import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Represents an alert parameter name. */
  AlertParameterName: { input: string; output: string; }
  /** Represents any value. */
  Any: { input: unknown; output: unknown; }
  /** Represents a Date and Time in RFC 3339 format. */
  DateTime: { input: string; output: string; }
  /** Represents a duration of time. */
  Duration: { input: string; output: string; }
  /** Represents an IP address, either IPv4 or IPv6. */
  IP: { input: string; output: string; }
  /**
   * Represents an IPv4 address pattern with a prefix length, e.g. `10.1-4.*.2/31`.
   * Each octet is a value, an inclusive range (`n-m`), or a wildcard (`*`).
   */
  IPAddressPattern: { input: string; output: string; }
  /** Represents an IP address prefix in CIDR notation. */
  IPPrefix: { input: string; output: string; }
  /** Represents an IPv4 address. */
  IPV4: { input: string; output: string; }
  /** Represents an IPv6 address. */
  IPV6: { input: string; output: string; }
  /** Represents a JSON string. */
  JSON: { input: string; output: string; }
  /** Represents a generic JSON object. */
  JSONObject: { input: Record<string, unknown>; output: Record<string, unknown>; }
  /** Represents a MAC Address. */
  MacAddress: { input: string; output: string; }
  /** Represents a Universally Unique Identifier (UUID). */
  UUID: { input: string; output: string; }
  /** Represents an unsigned 32-bit integer. */
  Uint32: { input: number; output: number; }
  /** Represents an unsigned 64-bit integer. */
  Uint64: { input: BigInt; output: BigInt; }
  /** Represents an unmasked IP address prefix in CIDR notation. */
  UnmaskedIPPrefix: { input: string; output: string; }
};

/** Represents a value of AP channel utilization metrics at a specific timestamp. */
export type ApChannelUtilizationMetricsValue = MetricsValue & {
  __typename?: 'APChannelUtilizationMetricsValue';
  /** The name of the Access Point (AP) that reported this measurement. */
  apName: Scalars['String']['output'];
  /** The time at which the measurement was recorded. */
  timestamp: Scalars['DateTime']['output'];
  /** The measured value of channel utilization at the given timestamp. */
  value: Scalars['Float']['output'];
};

/** Response type containing channel utilization metrics for an AP. */
export type ApChannelUtilizationResponse = MetricsResponse & {
  __typename?: 'APChannelUtilizationResponse';
  /** Metadata about the channel utilization metrics. */
  metadata?: Maybe<MetricsMetadata>;
  /** List of channel utilization metrics values. */
  values: Array<ApChannelUtilizationMetricsValue>;
};

/** Represents a value in the timeseries of AP channel utilization metrics. */
export type ApChannelUtilizationTimeseriesValue = {
  __typename?: 'APChannelUtilizationTimeseriesValue';
  /**
   * What channel the AP's radio was on at the time of the observation.
   * For single AP queries, this will be the most-seen channel during the bucket window.
   * This will be null for network / multiple-AP queries (because network-level is
   * an aggregation of all APs, which will likely be on a long list of channels).
   */
  channel?: Maybe<Scalars['Int']['output']>;
  /**
   * The channel width of the AP's radio at the time of the observation.
   * For single AP queries, this will be the most-seen channel width during the bucket window.
   * This will be null for network / multiple-AP queries (because network-level is
   * an aggregation of all APs, which will likely be on different channel widths).
   */
  channelWidth?: Maybe<Scalars['Int']['output']>;
  /** The maximum signal strength of interference sources detected on the channel. (in dBm) */
  interferenceSignalStrengthMaxdBm: Scalars['Int']['output'];
  /** The median signal strength of interference sources detected on the channel. (in dBm). This is a median of medians of observations within a bucket window, floored to the nearest integer. */
  interferenceSignalStrengthMediandBm: Scalars['Int']['output'];
  /** The number of sources of high interference detected on the channel. (An average of data observations, floored to the nearest integer). */
  interferenceSourceCountHigh: Scalars['Int']['output'];
  /** The number of sources of low interference detected on the channel. (An average of data observations, floored to the nearest integer). */
  interferenceSourceCountLow: Scalars['Int']['output'];
  /** The number of sources of medium interference detected on the channel. (An average of data observations, floored to the nearest integer). */
  interferenceSourceCountMedium: Scalars['Int']['output'];
  /** The amount of utilization contributed by non-802.11 interference in the environment, e.g., Bluetooth devices, cameras. (from 0 to 1) */
  non80211Utilization: Scalars['Float']['output'];
  /** The amount of utilization as a result of 802.11 interference by neighboring devices. (from 0 to 1) */
  obssUtilization: Scalars['Float']['output'];
  /** The percentage of time the channel was utilized due to transmissions from clients. (from 0 to 1) */
  rxUtilization: Scalars['Float']['output'];
  /** The percentage of time the channel was utilized by the AP itself. (from 0 to 1) */
  selfUtilization: Scalars['Float']['output'];
  /** The time at which the measurement was recorded. */
  timestamp: Scalars['DateTime']['output'];
  /** The percentage of time the channel was utilized. (from 0 to 1) */
  totalUtilization: Scalars['Float']['output'];
  /** The percentage of time the channel was utilized due to transmissions from the AP. (from 0 to 1) */
  txUtilization: Scalars['Float']['output'];
};

/** The access level an API key is minted with. */
export enum ApiKeyAccessLevel {
  /** The key may execute read-only query operations. */
  ReadOnly = 'READ_ONLY',
  /** The key may execute query and mutation operations. */
  ReadWrite = 'READ_WRITE'
}

/**
 * Deprecated. This is a config1 query.
 * Represents an uptime metric value for an AP at a specific timestamp.
 */
export type ApUptimeMetricsValue = MetricsValue & {
  __typename?: 'APUptimeMetricsValue';
  /** The name of the AP that reported this measurement. */
  apName: Scalars['String']['output'];
  /** The time at which the measurement was recorded. */
  timestamp: Scalars['DateTime']['output'];
  /** The uptime value of the AP at the given timestamp, in seconds. */
  value: Scalars['Float']['output'];
};

/**
 * Deprecated. This is a config1 query.
 * Response type containing AP uptime metrics.
 */
export type ApUptimeResponse = MetricsResponse & {
  __typename?: 'APUptimeResponse';
  /** Metadata about the AP uptime metrics. */
  metadata?: Maybe<MetricsMetadata>;
  /** List of AP uptime metrics values. */
  values: Array<ApUptimeMetricsValue>;
};

/** An entry in the device's ARP table. */
export type ArpTableEntry = {
  __typename?: 'ARPTableEntry';
  /** How long the entry has been in the table. */
  ageSeconds?: Maybe<Scalars['Int']['output']>;
  /** IEEE-registered vendor for the macAddress's OUI, if known. Sourced from the IEEE OUI database. */
  ieeeDeviceVendor?: Maybe<IeeeDeviceVendor>;
  /** The IP address of the entry. */
  ipAddress: Scalars['IPV4']['output'];
  /** Whether the entry is incomplete, i.e. the ARP request has not been answered yet. */
  isIncomplete: Scalars['Boolean']['output'];
  /** The MAC address the IP resolved to. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** A user-defined nickname for the MAC address, if specified. */
  macAddressAlias?: Maybe<MacAddressAlias>;
  /** The time the device last reported the table this entry came from. */
  updatedAt: Scalars['DateTime']['output'];
  /** The virtual device the entry was observed on. */
  virtualDevice: VirtualDevice;
  /** The UUID of the virtual device the entry was observed on. */
  virtualDeviceUUID: Scalars['UUID']['output'];
  /** The VLAN associated with the VLAN ID. */
  vlan?: Maybe<Vlan>;
  /** The VLAN ID associated with the MAC address. */
  vlanID: Scalars['Int']['output'];
};

/** Enum to indicate access availability. */
export enum AccessLevel {
  /**
   * Not complete on all parts of the stack but usable on a subset of networks for testing and validation.
   * Only Meter can view and configure it.
   */
  AccessLevelAlpha = 'ACCESS_LEVEL_ALPHA',
  /**
   * Not complete on all parts of the stack but usable on a subset of networks for testing and validation.
   * Customers who have it enabled can view and configure it.
   */
  AccessLevelBeta = 'ACCESS_LEVEL_BETA',
  /** Limited internally to operators only. Never intended for public consumption. */
  AccessLevelInternal = 'ACCESS_LEVEL_INTERNAL',
  /** Complete on all parts of the stack and usable by any network. */
  AccessLevelPublic = 'ACCESS_LEVEL_PUBLIC'
}

/** Information about an AP that failed to reset to its expected (configured) channel. */
export type AccessPointChannelInfo = {
  __typename?: 'AccessPointChannelInfo';
  /** The current 5GHz channel the AP is operating on. */
  current5GChannel: Scalars['Int']['output'];
  /** The expected (configured) 5GHz channel. */
  expected5GChannel: Scalars['Int']['output'];
  /** The virtual device associated with the AP. */
  virtualDevice?: Maybe<AccessPointVirtualDevice>;
};

/** Properties for access point connection events. */
export type AccessPointConnectionProperties = {
  __typename?: 'AccessPointConnectionProperties';
  /** The access point that the connection event occurred on. */
  accessPoint?: Maybe<AccessPointVirtualDevice>;
  /** The band on which the connection event occurred. */
  band: RadioBand;
  /** The mac address of the client corresponding to the connection event. */
  clientMac: Scalars['MacAddress']['output'];
  /** If the event type is `FAILED`, explains which step of the connection process failed. */
  connectionFailedStep?: Maybe<WirelessClientConnectionFailedStep>;
  /** The type of connection event. */
  connectionType: WirelessClientConnectionEventType;
  /** The time taken for this connection event in milliseconds. */
  durationMs?: Maybe<Scalars['Int']['output']>;
  /** The previous access point that the client was connected to, if the connection event is roam. */
  previousAccessPoint?: Maybe<AccessPointVirtualDevice>;
  /** The reason code, if the connection event is disassociated or failed. */
  reasonCode?: Maybe<Scalars['Int']['output']>;
  /** The ssid on which the connection event occurred. */
  ssid: Ssid;
};

/** An individual Access Point's raw connection and DHCP counts. */
export type AccessPointConnectivityStats = {
  __typename?: 'AccessPointConnectivityStats';
  /** The number of connection attempts on the 2G radio band of the device. */
  connectionAttempts2G: Scalars['Int']['output'];
  /** The number of connection attempts on the 5G radio band of the device. */
  connectionAttempts5G: Scalars['Int']['output'];
  /** The number of connection attempts on the 6G radio band of the device. */
  connectionAttempts6G: Scalars['Int']['output'];
  /** Connection failure reasons grouped by failed step and reason code, sorted by count descending. Only populated for aggregated stats. */
  connectionFailureReasons: Array<ConnectionFailureReason>;
  /** The number of successful connections on the 2G radio band of the device. */
  connectionSuccess2G: Scalars['Int']['output'];
  /** The number of successful connections on the 5G radio band of the device. */
  connectionSuccess5G: Scalars['Int']['output'];
  /** The number of successful connections on the 6G radio band of the device. */
  connectionSuccess6G: Scalars['Int']['output'];
  /** The number of DHCP attempts on the 2G radio band of the device. */
  dhcpAttempts2G: Scalars['Int']['output'];
  /** The number of DHCP attempts on the 5G radio band of the device. */
  dhcpAttempts5G: Scalars['Int']['output'];
  /** The number of DHCP attempts on the 6G radio band of the device. */
  dhcpAttempts6G: Scalars['Int']['output'];
  /** The number of successful DHCP completions on the 2G radio band of the device. */
  dhcpSuccess2G: Scalars['Int']['output'];
  /** The number of successful DHCP completions on the 5G radio band of the device. */
  dhcpSuccess5G: Scalars['Int']['output'];
  /** The number of successful DHCP completions on the 6G radio band of the device. */
  dhcpSuccess6G: Scalars['Int']['output'];
  /** The end of the aggregation window. */
  windowEnd: Scalars['DateTime']['output'];
  /** The start of the aggregation window. */
  windowStart: Scalars['DateTime']['output'];
};

/** Properties for access point dfs reset events. */
export type AccessPointDfsChannelResetProperties = {
  __typename?: 'AccessPointDfsChannelResetProperties';
  /** New fallback channel after the dfs channel reset. */
  fbChan: Scalars['Int']['output'];
  /** New operational channel after the dfs channel reset. */
  newOpChan: Scalars['Int']['output'];
  /** Operational channel before the dfs channel reset. */
  opChan: Scalars['Int']['output'];
  /** The virtual device that the dfs reset occurred on. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** An access point hardware device represents a physical access point. */
export type AccessPointHardwareDevice = HardwareDevice & {
  __typename?: 'AccessPointHardwareDevice';
  /** The list of BSSIDs (Basic Service Set Identifiers) that represent unique identifiers for the access point's SSID and radio band combinations. */
  BSSIDs: Array<Bssid>;
  /** The batch identifier of the hardware device, if any. */
  batch?: Maybe<Scalars['String']['output']>;
  /** Shows the most recent boot history of a device (buildName, bootCount). */
  bootHistory: Array<BootInfo>;
  /** The active config override for this device, if any. */
  configOverride?: Maybe<DeviceConfigOverride>;
  /** The timestamp when the hardware device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** The model name of the hardware device. */
  deviceModel: DeviceModel;
  /** The type of the hardware device. */
  deviceType: DeviceType;
  /** If the device is no longer connected to the backend, this is the time at which it was last connected. */
  disconnectedFromBackendAt?: Maybe<Scalars['DateTime']['output']>;
  /** The hardware generation of the device. */
  hardwareGeneration: HardwareGeneration;
  /** Metadata for the model of this device. */
  hardwareModelProperties: HardwareModelProperties;
  /** Internal operator-only notes about this hardware device. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /**
   * The IP address of the access point hardware device.
   * @deprecated Use `VirtualDevice.ipAddress` instead.
   */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /**
   * True if the device has an active websocket connection to the backend. Note that this only works if the device has registered via the /v2/register endpoint (i.e., is a Config 2 device) - otherwise is always false.
   * @deprecated Use `isSpare` instead.
   */
  isActive: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is connected to the backend. */
  isConnectedToBackend: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /**
   * Indicates whether the hardware device is marked as a development (dev) device, moving it into the dev (staging) realm for testing purposes.
   * @deprecated Use `realm` instead. isDev is equivalent to realm == DEV.
   */
  isDev: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is in factory mode. */
  isFactoryMode: Scalars['Boolean']['output'];
  /** True if the AP's MAC address exists in the most recent controller MAC table for the network. */
  isInCurrentControllerMACTable: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is an RMA (Return Merchandise Authorization) replacement device. */
  isRMA: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device has been retired. */
  isRetired: Scalars['Boolean']['output'];
  /** A spare hardware device belongs to a network but is not assigned to a virtual device. Spares are typically kept on site as replacements and are not in service. */
  isSpare: Scalars['Boolean']['output'];
  /** The latest device config metadata (ie. the config without the actual JSON payload) for the device. */
  latestDeviceConfigMetadata?: Maybe<DeviceConfigMetadata>;
  /** The MAC address of the hardware device. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** The UUID of the network that the hardware device belongs to. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** The physical interface (on a Meter Switch) that the access point is connected to, if applicable. */
  phyInterfaceConnectedTo?: Maybe<PhyInterface>;
  /**
   * If the access point is not currently connected to a physical interface on a Meter Switch (ie. `phyInterfaceConnectedTo` is null),
   * then this field will be populated with the physical interface that the access point was last connected to, if applicable and known.
   * Only returns a result if the AP was connected to a Switch in the last 30 days and the network is on a sufficient NOS version that reports LLDP stats.
   */
  phyInterfaceLastConnectedTo?: Maybe<PhyInterfaceConnectedAt>;
  /** The public key used to add the device to the jumphost's WireGuard interface. */
  publicKey?: Maybe<Scalars['String']['output']>;
  /** The realm that owns this hardware device. Used for cross-realm device management. */
  realm: HardwareDeviceRealm;
  /** The unique serial number of the hardware device. */
  serialNumber: Scalars['String']['output'];
  /** The network that the spare hardware device belongs to. Spare hardware devices that are not affiliated with a virtual device will have this field populated. */
  spareDeviceNetwork?: Maybe<Network>;
  /** IPv6 address on the jumphost subnet. Used to send requests to the device. */
  tunnelIPAddress?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the hardware device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The uptime metrics from the time series database for the device.
   * @deprecated Use `VirtualDevice.uptime` instead.
   */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** The virtual device associated with this hardware device, if any. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The UUID of the virtual device this hardware device is assigned to, if any. */
  virtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
};


/** An access point hardware device represents a physical access point. */
export type AccessPointHardwareDeviceBssiDsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An access point hardware device represents a physical access point. */
export type AccessPointHardwareDeviceBootHistoryArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

/** An individual Access Point's health scores. */
export type AccessPointHealthScores = {
  __typename?: 'AccessPointHealthScores';
  /** The beacon score on the 2G radio band of the device. */
  beaconScore2G: Scalars['Int']['output'];
  /** The beacon score on the 5G radio band of the device. */
  beaconScore5G: Scalars['Int']['output'];
  /** The beacon score on the 6G radio band of the device. */
  beaconScore6G: Scalars['Int']['output'];
  /** The number of connection attempts on the 2G radio band of the device. */
  connectionAttempts2G: Scalars['Int']['output'];
  /** The number of connection attempts on the 5G radio band of the device. */
  connectionAttempts5G: Scalars['Int']['output'];
  /** The number of connection attempts on the 6G radio band of the device. */
  connectionAttempts6G: Scalars['Int']['output'];
  /** This represents the quality and stability of connections between the device and its clients. */
  connectionScore: Scalars['Int']['output'];
  /** The connection score on the 2G radio band of the device. */
  connectionScore2G: Scalars['Int']['output'];
  /** The connection score on the 5G radio band of the device. */
  connectionScore5G: Scalars['Int']['output'];
  /** The connection score on the 6G radio band of the device. */
  connectionScore6G: Scalars['Int']['output'];
  /** The number of successful connections on the 2G radio band of the device. */
  connectionSuccess2G: Scalars['Int']['output'];
  /** The number of successful connections on the 5G radio band of the device. */
  connectionSuccess5G: Scalars['Int']['output'];
  /** The number of successful connections on the 6G radio band of the device. */
  connectionSuccess6G: Scalars['Int']['output'];
  /** The coverage score on the 2G radio band of the device. */
  coverageScore2G: Scalars['Int']['output'];
  /** The coverage score on the 5G radio band of the device. */
  coverageScore5G: Scalars['Int']['output'];
  /** The coverage score on the 6G radio band of the device. */
  coverageScore6G: Scalars['Int']['output'];
  /** The number of DHCP attempts on the 2G radio band of the device. */
  dhcpAttempts2G: Scalars['Int']['output'];
  /** The number of DHCP attempts on the 5G radio band of the device. */
  dhcpAttempts5G: Scalars['Int']['output'];
  /** The number of DHCP attempts on the 6G radio band of the device. */
  dhcpAttempts6G: Scalars['Int']['output'];
  /** The number of successful DHCP completions on the 2G radio band of the device. */
  dhcpSuccess2G: Scalars['Int']['output'];
  /** The number of successful DHCP completions on the 5G radio band of the device. */
  dhcpSuccess5G: Scalars['Int']['output'];
  /** The number of successful DHCP completions on the 6G radio band of the device. */
  dhcpSuccess6G: Scalars['Int']['output'];
  /** The percentage of CPU available on the device. */
  freeCPUPercentage: Scalars['Int']['output'];
  /** The percentage of memory available on the device. */
  freeMemoryPercentage: Scalars['Int']['output'];
  /** The MCS (Modulation and Coding Scheme) score on the 2G radio band of the device. */
  mcsScore2G: Scalars['Int']['output'];
  /** The MCS (Modulation and Coding Scheme) score on the 5G radio band of the device. */
  mcsScore5G: Scalars['Int']['output'];
  /** The MCS (Modulation and Coding Scheme) score on the 6G radio band of the device. */
  mcsScore6G: Scalars['Int']['output'];
  /** The number of clients on a 2G radio band. */
  numClients2G: Scalars['Int']['output'];
  /** The number of clients on a 5G radio band. */
  numClients5G: Scalars['Int']['output'];
  /** The number of clients on a 6G radio band. */
  numClients6G: Scalars['Int']['output'];
  /** The total score, which is an aggregate of the other scores. */
  overallScore: Scalars['Int']['output'];
  /** The overall score on the 2G radio band of the device. */
  overallScore2G: Scalars['Int']['output'];
  /** The overall score on the 5G radio band of the device. */
  overallScore5G: Scalars['Int']['output'];
  /** The overall score on the 6G radio band of the device. */
  overallScore6G: Scalars['Int']['output'];
  /** This represents the overall throughput, latency, etc. of the device. */
  performanceScore: Scalars['Int']['output'];
  /** The performance score on the 2G radio band of the device. */
  performanceScore2G: Scalars['Int']['output'];
  /** The performance score on the 5G radio band of the device. */
  performanceScore5G: Scalars['Int']['output'];
  /** The performance score on the 6G radio band of the device. */
  performanceScore6G: Scalars['Int']['output'];
  /** The retry score on the 2G radio band of the device. */
  retryScore2G: Scalars['Int']['output'];
  /** The retry score on the 5G radio band of the device. */
  retryScore5G: Scalars['Int']['output'];
  /** The retry score on the 6G radio band of the device. */
  retryScore6G: Scalars['Int']['output'];
  /** The score of the device's wireless environment (interference, noise, etc.). */
  rfScore: Scalars['Int']['output'];
  /** The RF score on the 2G radio band of the device. */
  rfScore2G: Scalars['Int']['output'];
  /** The RF score on the 5G radio band of the device. */
  rfScore5G: Scalars['Int']['output'];
  /** The RF score on the 6G radio band of the device. */
  rfScore6G: Scalars['Int']['output'];
  /** The score of the system (CPU, memory, etc) of the device. */
  systemScore: Scalars['Int']['output'];
  /** The timestamp when the health scores were last updated. */
  timestamp: Scalars['DateTime']['output'];
};

/** An AP involved in an interference entry, with its channel info and optional full device details. */
export type AccessPointInterferenceEntryDevice = {
  __typename?: 'AccessPointInterferenceEntryDevice';
  /** The full access point device object. */
  accessPoint: AccessPointVirtualDevice;
  /** The UUID of the access point. */
  accessPointUUID: Scalars['UUID']['output'];
  /** The channel the AP is operating on. */
  channel: Scalars['Int']['output'];
  /** The channel width (MHz) the AP is operating on. */
  channelWidth: Scalars['Int']['output'];
};

/** Properties for a connection on an invalid (unknown or disabled) VLAN. */
export type AccessPointInvalidVlanConnectionProperties = {
  __typename?: 'AccessPointInvalidVLANConnectionProperties';
  /** The access point that the connection event occurred on. */
  accessPoint: AccessPointVirtualDevice;
  /** The band on which the connection event occurred. */
  band: RadioBand;
  /** The mac address of the client corresponding to the connection event. */
  clientMACAddress: Scalars['MacAddress']['output'];
  /** The ssid on which the connection event occurred. */
  ssid: Ssid;
  /** The invalid VLAN. */
  vlanID: Scalars['Int']['output'];
};

/** Properties when an access point detects spoofing of one of its BSSIDs. */
export type AccessPointMacSpoofDetectedProperties = {
  __typename?: 'AccessPointMacSpoofDetectedProperties';
  /** Band where the spoof was observed. */
  band: RadioBand;
  /** RF channel index where the spoof was observed. */
  channel: Scalars['Int']['output'];
  /** RSSI at which the frame was observed. */
  rssi: Scalars['Int']['output'];
  /** The spoofed BSSID MAC address observed. */
  spoofedMac: Scalars['MacAddress']['output'];
  /** The access point that detected the spoofed frame. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** A port profile for access points, defining VLAN assignments for each wired LAN port. */
export type AccessPointPortProfile = HardwarePortProfile & {
  __typename?: 'AccessPointPortProfile';
  /** The unique identifier of the port profile. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the port profile was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A human readable description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The hardware model this port profile is for. */
  deviceModel: DeviceModel;
  /** The name of the port profile. */
  name: Scalars['String']['output'];
  /** The network to which this port profile belongs. */
  network: Network;
  /** The unique identifier of the network to which this port profile belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** The port bindings associated with this profile, defining VLAN assignments per port. */
  portBindings: Array<AccessPointPortProfilePortBinding>;
  /** The timestamp when the port profile was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The list of virtual devices (access points) assigned to this port profile. */
  virtualDevices: Array<VirtualDevice>;
};

/** A binding of a VLAN to a specific port on an access point port profile. */
export type AccessPointPortProfilePortBinding = {
  __typename?: 'AccessPointPortProfilePortBinding';
  /** The unique identifier of the port binding. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the port binding was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The port number on the access point. */
  portNumber: Scalars['Int']['output'];
  /** The timestamp when the port binding was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The VLAN assigned to this port, if any. */
  vlan?: Maybe<Vlan>;
  /** The UUID of the VLAN assigned to this port, if any. */
  vlanUUID?: Maybe<Scalars['UUID']['output']>;
};

/** Properties for access point radar hit detected events. */
export type AccessPointRadarHitDetectedProperties = {
  __typename?: 'AccessPointRadarHitDetectedProperties';
  /** Clients moved off the AP (probably) due to the radar hit */
  clientsMovedOff: Array<Scalars['String']['output']>;
  /** Operation channel before the radar hit. */
  dfsChannel: Scalars['Int']['output'];
  /** Operational channel after the radar hit */
  fallbackChannel: Scalars['Int']['output'];
  /** The virtual device that detected the radar hit. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** An access point virtual device is a logical representation of a physical access point. */
export type AccessPointVirtualDevice = Identifiable & TargetInterface & VirtualDevice & {
  __typename?: 'AccessPointVirtualDevice';
  /** The unique identifier (UUID) of the virtual device. */
  UUID: Scalars['UUID']['output'];
  /** The port profile associated with this access point. */
  accessPointPortProfile?: Maybe<AccessPointPortProfile>;
  /** The UUID of the port profile associated with this access point. */
  accessPointPortProfileUUID?: Maybe<Scalars['UUID']['output']>;
  /** The wireless clients that are currently connected to the access point. */
  connectedClients: Array<WirelessClient>;
  /** The wired clients that are currently connected to the access point. */
  connectedWiredClients: Array<AccessPointWiredClient>;
  /** Raw connection and DHCP counts for this access point over a time range, with optional client MAC address exclusion. */
  connectivityStats: Array<AccessPointConnectivityStats>;
  /** Connection and DHCP counts for this access point aggregated over a duration, with optional client MAC address exclusion. */
  connectivityStatsAggregated?: Maybe<AccessPointConnectivityStats>;
  /** The timestamp when the virtual device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** An optional description for the virtual device. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Metadata for the configurations rendered for this virtual device over time, newest
   * first. Includes configs written to hardware devices that have since been dissociated
   * from this virtual device. Omits the rendered config JSON for performance.
   */
  deviceConfigs: Array<DeviceConfigMetadata>;
  /** The model name of the virtual device. */
  deviceModel: DeviceModel;
  /** The type of the virtual device. */
  deviceType: VirtualDeviceType;
  /** The access point placement on a dynamic floor plan, if one exists. */
  dynamicFloorPlanPlacement?: Maybe<DynamicFloorPlanAccessPointPlacement>;
  /** The hardware device associated with this virtual device, if any. */
  hardwareDevice?: Maybe<HardwareDevice>;
  /** Metadata for the model of this device. */
  hardwareModelProperties: HardwareModelProperties;
  /** The management IP address of the device. */
  ipAddress?: Maybe<Scalars['IP']['output']>;
  /** Indicates whether the virtual device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether debug logging is enabled on the virtual device. */
  isDebugLogEnabled: Scalars['Boolean']['output'];
  /** Whether this virtual device is in a draft state for preconfiguration reasons. */
  isDraft: Scalars['Boolean']['output'];
  /** Indicates whether LED dark mode is enabled on the access point, which turns off all LED activity. */
  isLEDDarkModeEnabled: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is online, indicated by its heartbeat. */
  isOnline: Scalars['Boolean']['output'];
  /** A human-friendly name for the device. */
  label: Scalars['String']['output'];
  /** The health scores of an Access Point aggregated from the last N seconds (defaults to 300 seconds / 5 minutes). */
  latestHealthScores?: Maybe<AccessPointHealthScores>;
  /** The physical location of this virtual device, derived from its rack elevation placement. */
  location?: Maybe<VirtualDeviceLocation>;
  /** Distribution of active clients across MCS index buckets, based on their p50 TX and RX MCS values. */
  mcsDistribution: Array<McsBucketCount>;
  /** The most recent NOS upgrade for this virtual device that has started executing or was skipped (in progress, completed, failed, or skipped), if any. */
  mostRecentNOSUpgrade?: Maybe<ScheduledDeviceNosUpgrade>;
  /** The network that the virtual device belongs to. */
  network: Network;
  /** The unique identifier (UUID) of the network the virtual device belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The group that the device belongs to for firmware upgrade grouping purposes. */
  nosUpgradeGroup: NosUpgradeGroup;
  /** The current NOS firmware version that the virtual device is configured to run. */
  nosVersion?: Maybe<ConfiguredNosVersion>;
  /** The identifier of the NOS firmware version that the virtual device is configured to run. */
  nosVersionID: Scalars['Int']['output'];
  /** The access point's active or future notification snoozes */
  notificationSnoozes: Array<DeviceNotificationSnooze>;
  /** ObserverTests returns all observer tests configured to target this access point. */
  observerTests?: Maybe<Array<ObserverTest>>;
  /** The paired virtual device to this device, applicable to dual-chassis configurations. */
  pairedVirtualDevice?: Maybe<AccessPointVirtualDevice>;
  /** The NOS firmware version that the virtual device is scheduled to upgrade to. */
  pendingNosVersion?: Maybe<PendingNosVersion>;
  /** The radio profile associated with this access point. */
  radioProfile?: Maybe<RadioProfile>;
  /** The UUID of the radio profile associated with this access point. */
  radioProfileUUID?: Maybe<Scalars['UUID']['output']>;
  /** The radio settings (channel, power) specific to this access point. */
  radioSettings: RadioSettings;
  /** URL to the regulatory e-label for the device, if applicable. */
  regulatoryLabelURL?: Maybe<Scalars['String']['output']>;
  /** All of the enabled SSIDs (Service Set Identifiers) that the access point is broadcasting. */
  ssids: Array<Ssid>;
  /** The virtual device tags on this device. */
  tags: Array<VirtualDeviceTag>;
  /** Data about this virtual device's position in its network's topology. */
  topologyData?: Maybe<VirtualDeviceTopologyData>;
  /** The timestamp when the virtual device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /** How long the device has been continuously powered on and reporting. */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** The position of this virtual device within its device pair (left or right). Null if not part of a pair. */
  virtualDevicePairPosition?: Maybe<DevicePosition>;
};


/** An access point virtual device is a logical representation of a physical access point. */
export type AccessPointVirtualDeviceConnectedClientsArgs = {
  excludeObservers?: Scalars['Boolean']['input'];
};


/** An access point virtual device is a logical representation of a physical access point. */
export type AccessPointVirtualDeviceConnectivityStatsArgs = {
  duration?: Scalars['Duration']['input'];
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMACs?: InputMaybe<Array<Scalars['String']['input']>>;
  stepSeconds?: Scalars['Int']['input'];
};


/** An access point virtual device is a logical representation of a physical access point. */
export type AccessPointVirtualDeviceConnectivityStatsAggregatedArgs = {
  duration?: Scalars['Duration']['input'];
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMACs?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** An access point virtual device is a logical representation of a physical access point. */
export type AccessPointVirtualDeviceDeviceConfigsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


/** An access point virtual device is a logical representation of a physical access point. */
export type AccessPointVirtualDeviceLatestHealthScoresArgs = {
  duration?: Scalars['Duration']['input'];
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
};


/** An access point virtual device is a logical representation of a physical access point. */
export type AccessPointVirtualDeviceMcsDistributionArgs = {
  band?: InputMaybe<RadioBand>;
  duration?: Scalars['Duration']['input'];
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  maxMCS?: InputMaybe<Scalars['Int']['input']>;
  minMCS?: InputMaybe<Scalars['Int']['input']>;
  step?: InputMaybe<Scalars['Int']['input']>;
};

/** An access point wired client is a client connected to a port on an access point. */
export type AccessPointWiredClient = {
  __typename?: 'AccessPointWiredClient';
  /** The MAC address of the client. */
  macAddress: Scalars['MacAddress']['output'];
  /** The network client, if available. */
  networkClient?: Maybe<NetworkClient>;
  /** The UUID of the network that the client is on. */
  networkUUID: Scalars['UUID']['output'];
  /** The port number that the client is connected to. */
  portNumber: Scalars['Int']['output'];
  /** The UUID of the virtual device that the client is connected to. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** Input type for specifying options when querying active clients metrics. */
export type ActiveClientsInput = {
  /** Whether to include Meter hardware in the metrics calculation. */
  includeMeterHardware?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response type containing active clients metrics over a specified time range. */
export type ActiveClientsMetricsResponse = MetricsResponse & {
  __typename?: 'ActiveClientsMetricsResponse';
  /**
   * Aggregated metadata for active clients over the specified time range.
   * @deprecated Use `wired` and `wireless` instead.
   */
  metadata?: Maybe<MetricsMetadata>;
  /**
   * A list of active clients (both wired and wireless) metrics values.
   * @deprecated Use `wired` and `wireless` instead.
   */
  values: Array<ActiveClientsMetricsValue>;
  /** A list of wired active clients metrics values. */
  wired: Array<ActiveClientsMetricsValue>;
  /** A list of wireless active clients metrics values. */
  wireless: Array<ActiveClientsMetricsValue>;
};

/** Represents a single data point for the number of active clients at a given timestamp. */
export type ActiveClientsMetricsValue = MetricsValue & {
  __typename?: 'ActiveClientsMetricsValue';
  /** The timestamp of the metric data point. */
  timestamp: Scalars['DateTime']['output'];
  /** The number of active clients at the given timestamp. */
  value: Scalars['Float']['output'];
};

/** An active IPS rule identifier for a given virtual device. */
export type ActiveIpsRule = {
  __typename?: 'ActiveIPSRule';
  /** The unique identifier for the active IPS rule. */
  UUID: Scalars['UUID']['output'];
  /** When the active IPS rule was reported. */
  observedAt: Scalars['DateTime']['output'];
  /** The virtual device on which the IPS rule is active. */
  virtualDevice: VirtualDevice;
  /** The unique identifier for the virtual device on which the IPS rule is active. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** An active issue is a potentially disruptive issue to a network. */
export type ActiveIssue = {
  /** When the issue was first detected, if available */
  detectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The network that this issue is impacting */
  networkUUID: Scalars['UUID']['output'];
  /** When the issue was resolved, if available */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The severity of the issue */
  severity: ActiveIssueSeverity;
  /** The type of the issue */
  type: ActiveIssueType;
};

/** Enumerates the severity of an issue. */
export enum ActiveIssueSeverity {
  /** Critical severity */
  Critical = 'CRITICAL',
  /** High severity */
  High = 'HIGH',
  /** Low severity */
  Low = 'LOW',
  /** Medium severity */
  Medium = 'MEDIUM'
}

/** Enumerates all supported issue types. */
export enum ActiveIssueType {
  /** The default VLAN has no IPv4 gateway. */
  DefaultVlanMissingGatewayIp = 'DEFAULT_VLAN_MISSING_GATEWAY_IP',
  /** Device has not sent a heartbeat in the last 5 minutes. */
  DeviceOffline = 'DEVICE_OFFLINE',
  /** FLIP triggered on a port on a switch in last 5 minutes. */
  FlipTriggered = 'FLIP_TRIGGERED',
  /** Hardware device is marked as inactive. */
  InactiveHardwareDevice = 'INACTIVE_HARDWARE_DEVICE',
  /** The network has no default VLAN. */
  MissingDefaultVlan = 'MISSING_DEFAULT_VLAN',
  /** Virtual device is missing hardware device assignment. */
  MissingHardwareDevice = 'MISSING_HARDWARE_DEVICE',
  /** No WAN activity detected in last 5 minutes. */
  NoWanActivity = 'NO_WAN_ACTIVITY',
  /** PDU powers the switch providing its uplink. Networks with only one PDU are not checked. */
  PduSwitchCycle = 'PDU_SWITCH_CYCLE',
  /** Rogue AP detected on network. */
  RogueAp = 'ROGUE_AP'
}

export type ActiveIssuesFilter = {
  /** Specify the severity of issue you want */
  severities?: InputMaybe<Array<ActiveIssueSeverity>>;
  /** Specify the type of issue you want */
  types?: InputMaybe<Array<ActiveIssueType>>;
};

/** Input for adding a probe binding to a monitor group. */
export type AddMonitorGroupMemberInput = {
  /** Evaluation parameters for this probe binding. */
  evalParams?: InputMaybe<MonitorEvalParamsInput>;
};

/** Input type for adding a network to an AutoVPN group. */
export type AddNetworkToAutoVpnGroupInput = {
  /** IP address assigned to the member's uplink. Automatically assigned if not provided. */
  address?: InputMaybe<Scalars['IP']['input']>;
  /** Indicates if failover is enabled for the member's uplink. */
  isFailoverEnabled?: Scalars['Boolean']['input'];
  /** Port number the member listens on for VPN connections. */
  listenPort?: InputMaybe<Scalars['Int']['input']>;
  /** If set, configures the created member hubs. */
  memberHubs?: InputMaybe<Array<CreateAutoVpnMemberHubsInput>>;
  /** Unique identifier of the network to add as a member. */
  networkUUID: Scalars['UUID']['input'];
  /** List of permitted VLAN unique identifiers. The associated VLANs must have participatesInVPNs set to true. */
  permittedVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Unique identifier of the physical interface used by the member's uplink. */
  phyInterfaceUUID: Scalars['UUID']['input'];
};

/** Input for authorizing a support provider to support a target company. */
export type AddSupportProviderInput = {
  /** The UUID of the provider's public API key that will hold the grant. */
  publicAPIKeyUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents a network client that is affected by one or more CVEs by their MAC address and network UUID. */
export type AffectedClient = {
  __typename?: 'AffectedClient';
  /** CVE ID */
  cveID: Scalars['String']['output'];
  /** MAC address identifying the affected client. */
  macAddress: Scalars['MacAddress']['output'];
  /** Network UUID. */
  networkUUID: Scalars['UUID']['output'];
};

/** A Company's subscription to receive an alert. */
export type AlertCompanySubscription = Identifiable & {
  __typename?: 'AlertCompanySubscription';
  /** The unique identifier of the alert subscription. */
  UUID: Scalars['UUID']['output'];
  /**
   * The primary alert receiver.
   * @deprecated Use `alertReceivers` instead.
   */
  alertReceiver: AlertReceiver;
  /**
   * The UUID of the primary alert receiver.
   * @deprecated Use `alertReceiverUUIDs` instead.
   */
  alertReceiverUUID: Scalars['UUID']['output'];
  /** The UUIDs of all alert receivers that receive notifications stemming from an evaluation of this alert subscription. */
  alertReceiverUUIDs: Array<Scalars['UUID']['output']>;
  /** All alert receivers that receive notifications stemming from an evaluation of this alert subscription. */
  alertReceivers: Array<AlertReceiver>;
  /** The alert subscription threshold. */
  alertSubscriptionThreshold: AlertSubscriptionThreshold;
  /** The company that the alert subscription is associated with. */
  company: Company;
  /** The UUID of the company that the alert subscription is associated with. */
  companyUUID: Scalars['UUID']['output'];
  /** The support provider that created this alert subscription. */
  createdBySupportProvider?: Maybe<SupportProvider>;
  /** For every network that is subscribed to via this alert subscription, lists the most recent evaluation state of the alert evaluation. */
  currentEvaluationStates: Array<AlertSubscriptionEvaluationState>;
  /** The description of the alert subscription. */
  description?: Maybe<Scalars['String']['output']>;
  /** The networks that the alert subscription is explicitly excluded from, for company-wide subscriptions. For non-company-wide subscriptions, this will always be empty. */
  excludedNetworks?: Maybe<Array<Network>>;
  /** The networks that the alert subscription is associated with. For company-wide subscriptions, this is empty (all networks are included). For non-company-wide subscriptions, this is the list of opted-in networks. */
  includedNetworks?: Maybe<Array<Network>>;
  /** Whether the alert subscription is company-wide. Company-wide subscriptions are evaluated for all networks in the company, with optional exclusions. Non-company-wide subscriptions are opt-out by default. */
  isCompanyWide: Scalars['Boolean']['output'];
  /** Whether the alert subscription is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Whether the alert subscription is only visible internally. */
  isInternal: Scalars['Boolean']['output'];
  /** The label of the alert subscription. */
  label?: Maybe<Scalars['String']['output']>;
};

/** Input for filtering querying of alert fleetwide subscriptions. */
export type AlertCompanySubscriptionsFilterInput = {
  /** Filter the internal subscriptions like verification subscriptions. */
  includeInternal: Scalars['Boolean']['input'];
};

/** Optional per-network weekly schedule windows during which triggered alerts are sent at low priority. */
export type AlertDeprioritizationWindow = {
  __typename?: 'AlertDeprioritizationWindow';
  /** The UUID of the deprioritization window configuration. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The network this configuration applies to. */
  network: Network;
  /** The UUID of the network this configuration applies to. */
  networkUUID: Scalars['UUID']['output'];
  /** The reason alerts are deprioritized during the configured windows. */
  reason: Scalars['String']['output'];
  /** The timestamp when the configuration was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Weekly local-time intervals during which triggered alerts are deprioritized. */
  windows: Array<ScheduleInterval>;
};

/** The severity of an alert trigger. */
export enum AlertEvaluationTriggerState {
  /** The alert evaluation is triggered in critical state. */
  Critical = 'CRITICAL',
  /** The alert evaluation is triggered at low priority during a deprioritization window. */
  LowPriority = 'LOW_PRIORITY',
  /** The alert evaluation is not triggered. */
  NotTriggered = 'NOT_TRIGGERED',
  /** The alert evaluation is triggered. Used for point-in-time alerts that aren't sustained. */
  Triggered = 'TRIGGERED',
  /** The alert evaluation is triggered in warning (less-than-critical) state. */
  Warning = 'WARNING'
}

/** A fleetwide alert subscription is a subscription to receive an alert for all networks in the fleet. */
export type AlertFleetwideSubscription = {
  __typename?: 'AlertFleetwideSubscription';
  /** The unique identifier of the fleetwide alert subscription. */
  UUID: Scalars['UUID']['output'];
  /**
   * The primary alert receiver. Deprecated in favor of alertReceivers.
   * @deprecated Use `alertReceivers` instead.
   */
  alertReceiver: AlertReceiver;
  /**
   * The UUID of the primary alert receiver. Deprecated in favor of alertReceiverUUIDs.
   * @deprecated Use `alertReceiverUUIDs` instead.
   */
  alertReceiverUUID: Scalars['UUID']['output'];
  /** The UUIDs of all alert receivers that receive notifications stemming from an evaluation of this alert subscription. */
  alertReceiverUUIDs: Array<Scalars['UUID']['output']>;
  /** All alert receivers that receive notifications stemming from an evaluation of this alert subscription. */
  alertReceivers: Array<AlertReceiver>;
  /** The alert subscription threshold. */
  alertSubscriptionThreshold: AlertSubscriptionThreshold;
  /** For every network that is subscribed to this alert subscription, lists the most recent evaluation state of the alert evaluation. */
  currentEvaluationStates: Array<AlertSubscriptionEvaluationState>;
  /** The description of the alert subscription. */
  description?: Maybe<Scalars['String']['output']>;
  /** The company support tiers that the alert subscription is enabled for. If empty, the alert subscription is enabled for all company support tiers. */
  enabledCompanySupportTiers?: Maybe<Array<CompanySupportTier>>;
  /** The NOS upgrade channels that the alert subscription is enabled for. If empty, the alert subscription is enabled for all NOS upgrade channels. */
  enabledNOSUpgradeChannels?: Maybe<Array<NetworkNosUpgradeChannel>>;
  /** The companies that the alert subscription is explicitly excluded from. */
  excludedCompanies?: Maybe<Array<Company>>;
  /** The networks that the alert subscription is explicitly excluded from. */
  excludedNetworks?: Maybe<Array<Network>>;
  /** The companies that the alert subscription is limited to. If any inclusions (company or network) exist, the subscription only applies to matching networks. Exclusions take precedence over inclusions. */
  includedCompanies?: Maybe<Array<Company>>;
  /** The networks that the alert subscription is limited to. If any inclusions (company or network) exist, the subscription only applies to matching networks. Exclusions take precedence over inclusions. */
  includedNetworks?: Maybe<Array<Network>>;
  /** Whether the alert subscription is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** The label of the alert subscription. */
  label?: Maybe<Scalars['String']['output']>;
};

/** Input for filtering querying of alert fleetwide subscriptions. */
export type AlertFleetwideSubscriptionsFilterInput = {
  /** The alert types to filter by. If not specified, all alert types will be returned. */
  alertTypes?: InputMaybe<Array<AlertType>>;
};

/** An alert receiver is called when an alert is triggered. */
export type AlertReceiver = Identifiable & {
  __typename?: 'AlertReceiver';
  /** Unique identifier for the alert receiver. */
  UUID: Scalars['UUID']['output'];
  /** Unique identifier of the company that owns this alert receiver. */
  companyUUID: Scalars['UUID']['output'];
  /** Timestamp when the alert receiver was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Timestamp when the alert receiver was deleted (null if not deleted). */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Descriptive label for the alert receiver. */
  label: Scalars['String']['output'];
  /** Support provider that created the alert receiver. */
  supportProvider?: Maybe<SupportProvider>;
  /** List of alert targets associated with this alert receiver. */
  targets: Array<AlertTarget>;
  /** Timestamp when the alert receiver was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The state of an alert subscription's evaluation of a network. */
export type AlertSubscriptionEvaluationState = {
  __typename?: 'AlertSubscriptionEvaluationState';
  /** The alert type of the alert subscription being evaluated. */
  alertType: AlertType;
  /** The evaluation data of the alert subscription's evaluation of the network at the `stateChangedAt` time. */
  evaluationDataJSON: Scalars['JSON']['output'];
  /** The network being evaluated. */
  network: Network;
  /** The UUID of the network being evaluated. */
  networkUUID: Scalars['UUID']['output'];
  /** The UUID of the alert subscription being evaluated. */
  subscriptionUUID: Scalars['UUID']['output'];
  /** The threshold parameters of the alert subscription at the `stateChangedAt` time. */
  thresholdParams: AlertSubscriptionThreshold;
  /** The trigger state of the alert subscription's evaluation of the network. */
  triggerState: AlertEvaluationTriggerState;
  /** The time the trigger state of the alert subscription's evaluation of the network was last changed. */
  triggerStateChangedAt: Scalars['DateTime']['output'];
};

/** An alert subscription threshold is a set of threshold parameters for an alert. Each alert type implements this with its own threshold parameters. */
export type AlertSubscriptionThreshold = {
  /** The alert type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type ACCESS_POINT_CLIENT_COUNT. */
export type AlertSubscriptionThresholdAccessPointClientCount = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdAccessPointClientCount';
  /** The alert type. */
  alertType: AlertType;
  /** The threshold parameters for the alert subscription. */
  thresholdParams: AlertThresholdParamsAccessPointClientCount;
};

/** The threshold parameters for an alert subscription of type ACCESS_POINT_LINK_SPEED. */
export type AlertSubscriptionThresholdAccessPointLinkSpeed = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdAccessPointLinkSpeed';
  /** The alert type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type AP_RADAR_HIT. */
export type AlertSubscriptionThresholdApRadarHit = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdApRadarHit';
  /** The alert type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type AUDIT_LOG. */
export type AlertSubscriptionThresholdAuditLog = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdAuditLog';
  /** The alert type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type BOOT_LOOP. */
export type AlertSubscriptionThresholdBootLoop = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdBootLoop';
  /** The alert type. */
  alertType: AlertType;
  /** The threshold parameters for the alert subscription. */
  thresholdParams: AlertThresholdParamsBootLoop;
};

/** The threshold parameters for an alert subscription of type CAPTIVE_PORTAL_ACCESS. */
export type AlertSubscriptionThresholdCaptivePortalAccess = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdCaptivePortalAccess';
  /** The alert type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type CHANNEL_UTILIZATION_HIGH. */
export type AlertSubscriptionThresholdChannelUtilizationHigh = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdChannelUtilizationHigh';
  /** The alert type. */
  alertType: AlertType;
  /** The threshold parameters for the alert subscription. */
  thresholdParams: AlertThresholdParamsChannelUtilizationHigh;
};

/** The threshold parameters for an alert subscription of type CONFIG_FLAPS. */
export type AlertSubscriptionThresholdConfigFlaps = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdConfigFlaps';
  /** The alert type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type DHCP_POOL_EXHAUSTION. */
export type AlertSubscriptionThresholdDhcpPoolExhaustion = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdDHCPPoolExhaustion';
  /** The alert type. */
  alertType: AlertType;
  /** The threshold parameters for the alert subscription. */
  thresholdParams: AlertThresholdParamsDhcpPoolExhaustion;
};

/** The threshold parameters for an alert subscription of type DEVICE_BOOT. */
export type AlertSubscriptionThresholdDeviceBoot = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdDeviceBoot';
  /** The alert type. */
  alertType: AlertType;
  /** The threshold parameters for the alert subscription. */
  thresholdParams: AlertThresholdParamsDeviceBoot;
};

/** The threshold parameters for an alert subscription of type DEVICE_OFFLINE. */
export type AlertSubscriptionThresholdDeviceOffline = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdDeviceOffline';
  /** The alert type. */
  alertType: AlertType;
  /** The threshold parameters for the alert subscription. */
  thresholdParams: AlertThresholdParamsDeviceOffline;
};

/** The threshold parameters for an alert subscription of type FIRMWARE_UPGRADE_COMPLETED. */
export type AlertSubscriptionThresholdFirmwareUpgradeCompleted = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdFirmwareUpgradeCompleted';
  /** The alert type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type FIRMWARE_UPGRADE_FAILED. */
export type AlertSubscriptionThresholdFirmwareUpgradeFailed = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdFirmwareUpgradeFailed';
  /** The alert type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type FIRMWARE_UPGRADE_PENDING. */
export type AlertSubscriptionThresholdFirmwareUpgradePending = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdFirmwareUpgradePending';
  /** The alert type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type FIRMWARE_UPGRADE_SCHEDULED. */
export type AlertSubscriptionThresholdFirmwareUpgradeScheduled = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdFirmwareUpgradeScheduled';
  /** The alert type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type HIGH_AVAILABILITY_FAILOVER. */
export type AlertSubscriptionThresholdHighAvailabilityFailover = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdHighAvailabilityFailover';
  /** The alert type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type HIGH_CPU_USAGE. */
export type AlertSubscriptionThresholdHighCpuUsage = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdHighCPUUsage';
  /** The alert type. */
  alertType: AlertType;
  /** The threshold parameters for the alert subscription. */
  thresholdParams: AlertThresholdParamsHighCpuUsage;
};

/** The threshold parameters for an alert subscription of type HONEYPOT_AP. */
export type AlertSubscriptionThresholdHoneypotAp = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdHoneypotAp';
  /** The alert type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type IPSEC_TUNNEL_STATUS_CHANGE. */
export type AlertSubscriptionThresholdIpSecTunnelStatusChange = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdIPSecTunnelStatusChange';
  /** The alert type. */
  alertType: AlertType;
  /** The threshold parameters for the alert subscription. */
  thresholdParams: AlertThresholdParamsIpSecTunnelStatusChange;
};

/** The threshold parameters for an alert subscription of type ISP_DEGRADATION. */
export type AlertSubscriptionThresholdIspDegradation = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdISPDegradation';
  /** The alert type. */
  alertType: AlertType;
  /** The threshold parameters for the alert subscription. */
  thresholdParams: AlertThresholdParamsIspDegradation;
};

/** The threshold parameters for an alert subscription of type ISP_OUTAGE. */
export type AlertSubscriptionThresholdIspOutage = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdISPOutage';
  /** The alert type. */
  alertType: AlertType;
  /** The threshold parameters for the alert subscription. */
  thresholdParams: AlertThresholdParamsIspOutage;
};

/** The threshold parameters for an alert subscription of type IP_CONFLICT. */
export type AlertSubscriptionThresholdIpConflict = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdIpConflict';
  /** The alert type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type LOG_LINE_MATCH. */
export type AlertSubscriptionThresholdLogLineMatch = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdLogLineMatch';
  /** The alert type. */
  alertType: AlertType;
  /** The threshold parameters for the alert subscription. */
  thresholdParams: AlertThresholdParamsLogLineMatch;
};

/** The threshold parameters for an alert subscription of type MASS_DEVICE_BOOT. */
export type AlertSubscriptionThresholdMassDeviceBoot = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdMassDeviceBoot';
  /** The alert type. */
  alertType: AlertType;
  /** The threshold parameters for the alert subscription. */
  thresholdParams: AlertThresholdParamsMassDeviceBoot;
};

/** The threshold parameters for an alert subscription of type PORT_BLOCKED. */
export type AlertSubscriptionThresholdPortBlocked = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdPortBlocked';
  /** The alert type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type RADIUS_UNREACHABLE. */
export type AlertSubscriptionThresholdRadiusUnreachable = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdRadiusUnreachable';
  /** The alert type. */
  alertType: AlertType;
  /** The threshold parameters for the alert subscription. */
  thresholdParams: AlertThresholdParamsRadiusUnreachable;
};

/** The threshold parameters for an alert subscription of type ROGUE_AP. */
export type AlertSubscriptionThresholdRogueAp = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdRogueAp';
  /** The alert type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type ROGUE_DHCP_SERVER. */
export type AlertSubscriptionThresholdRogueDhcpServer = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdRogueDhcpServer';
  /** The alert type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type STP_ERROR. */
export type AlertSubscriptionThresholdStpError = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdSTPError';
  /** The alert type. */
  alertType: AlertType;
};

/** Support event webhook subscriptions have no threshold parameters. */
export type AlertSubscriptionThresholdSupportEvents = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdSupportEvents';
  /** The support event subscription type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type TEMPERATURE. */
export type AlertSubscriptionThresholdTemperature = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdTemperature';
  /** The alert type. */
  alertType: AlertType;
  /** The threshold parameters for the alert subscription. */
  thresholdParams: AlertThresholdParamsTemperature;
};

/** The threshold parameters for an alert subscription of type VERIFICATION. */
export type AlertSubscriptionThresholdVerification = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdVerification';
  /** The alert type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type WAN_DOWN. */
export type AlertSubscriptionThresholdWanDown = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdWANDown';
  /** The alert type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type WAN_FLAP. */
export type AlertSubscriptionThresholdWanFlap = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdWANFlap';
  /** The alert type. */
  alertType: AlertType;
  /** The threshold parameters for the alert subscription. */
  thresholdParams: AlertThresholdParamsWanFlap;
};

/** The threshold parameters for an alert subscription of type WAN_UP. */
export type AlertSubscriptionThresholdWanup = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdWANUP';
  /** The alert type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type WAN_FAILOVER. */
export type AlertSubscriptionThresholdWanFailover = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdWanFailover';
  /** The alert type. */
  alertType: AlertType;
};

/** The threshold parameters for an alert subscription of type WIRELESS_DHCP_FAILURE. */
export type AlertSubscriptionThresholdWirelessDhcpFailure = AlertSubscriptionThreshold & {
  __typename?: 'AlertSubscriptionThresholdWirelessDHCPFailure';
  /** The alert type. */
  alertType: AlertType;
  /** The threshold parameters for the alert subscription. */
  thresholdParams: AlertThresholdParamsWirelessDhcpFailure;
};

/** An interface representing a target to which alerts can be sent. This can be implemented by different types of alert targets, such as email or webhook. */
export type AlertTarget = {
  /** The unique identifier of the alert target. */
  UUID: Scalars['UUID']['output'];
  /** The unique identifier of the company that owns the alert target. */
  companyUUID: Scalars['UUID']['output'];
  /** The timestamp when the alert target was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The timestamp when the alert target was deleted, if applicable. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The type of the alert target. */
  type: AlertTargetType;
  /** The timestamp when the alert target was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** An email alert target that implements the AlertTarget interface. Used to send alerts to a specified email address. */
export type AlertTargetEmail = AlertTarget & {
  __typename?: 'AlertTargetEmail';
  /** The unique identifier of the email alert target. */
  UUID: Scalars['UUID']['output'];
  /** The unique identifier of the company that owns the email alert target. */
  companyUUID: Scalars['UUID']['output'];
  /** The timestamp when the email alert target was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The timestamp when the email alert target was deleted, if applicable. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The email address to which alerts will be sent. */
  emailAddress: Scalars['String']['output'];
  /** The type of the alert target, this should always be EMAIL. */
  type: AlertTargetType;
  /** The timestamp when the email alert target was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type AlertTargetInput = {
  /** Type of the alert target. */
  alertTargetType: AlertTargetType;
  /** Unique identifier of the alert target. Required for all alert target types except EMAIL. */
  alertTargetUUID?: InputMaybe<Scalars['String']['input']>;
  /** Email address for creating a new email alert target. Required if creating a new email target. */
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  /** Salesforce domain for creating a new salesforce alert target. Required if creating a new salesforce target. */
  salesforceDomain?: InputMaybe<Scalars['String']['input']>;
  /** Slack channel ID for creating a new slack alert target. Required if creating a new slack target. */
  slackChannelID?: InputMaybe<Scalars['String']['input']>;
  /** Slack channel label for creating a new slack alert target. Required if creating a new slack target. */
  slackChannelLabel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A read-only view of an internal, stateless no-op target. Its resource metadata
 * describes the receiver, since no separate target record exists.
 */
export type AlertTargetNoop = AlertTarget & {
  __typename?: 'AlertTargetNoop';
  /** The UUID of the receiver containing this no-op target. */
  UUID: Scalars['UUID']['output'];
  /** The company that owns the receiver; this does not restrict evaluation coverage. */
  companyUUID: Scalars['UUID']['output'];
  /** The timestamp when the receiver was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The timestamp when the receiver was deleted, if applicable. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The type of the alert target, always NOOP. */
  type: AlertTargetType;
  /** The timestamp when the receiver was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** An alert target that implements the AlertTarget interface. Used to send alerts to a specified Salesforce instance. */
export type AlertTargetSalesforce = AlertTarget & Identifiable & {
  __typename?: 'AlertTargetSalesforce';
  /** The unique identifier of the Salesforce alert target. */
  UUID: Scalars['UUID']['output'];
  /** The unique identifier of the company that owns the Salesforce alert target. */
  companyUUID: Scalars['UUID']['output'];
  /** The timestamp when the Salesforce alert target was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The timestamp when the Salesforce alert target was deleted, if applicable. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The domain of the Salesforce instance. */
  domain: Scalars['String']['output'];
  /** The type of the alert target, this should always be SALESFORCE. */
  type: AlertTargetType;
  /** The timestamp when the Salesforce alert target was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** An alert target that implements the AlertTarget interface. Used to send alerts to a specified Slack channel. */
export type AlertTargetSlack = AlertTarget & Identifiable & {
  __typename?: 'AlertTargetSlack';
  /** The unique identifier of the Slack alert target. */
  UUID: Scalars['UUID']['output'];
  /** The Slack channel ID to which alerts will be sent. */
  channelID: Scalars['String']['output'];
  /** The unique identifier of the company that owns the Slack alert target. */
  companyUUID: Scalars['UUID']['output'];
  /** The timestamp when the Slack alert target was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The timestamp when the Slack alert target was deleted, if applicable. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The label of the Slack alert target. */
  label?: Maybe<Scalars['String']['output']>;
  /** The type of the alert target, this should always be SLACK. */
  type: AlertTargetType;
  /** The timestamp when the Slack alert target was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration of possible alert target types. */
export enum AlertTargetType {
  /** Alert target type indicating an email address. */
  Email = 'EMAIL',
  /** Internal no-op target. It can only be configured through internal provisioning. */
  Noop = 'NOOP',
  /** Alert target type indicating a Salesforce instance. */
  Salesforce = 'SALESFORCE',
  /** Alert target type indicating a Slack channel. */
  Slack = 'SLACK',
  /** Alert target type indicating a webhook endpoint. */
  Webhook = 'WEBHOOK'
}

/** A webhook alert target that implements the AlertTarget interface. Used to send alerts to a specified webhook URL. */
export type AlertTargetWebhook = AlertTarget & Identifiable & {
  __typename?: 'AlertTargetWebhook';
  /** The unique identifier of the webhook alert target. */
  UUID: Scalars['UUID']['output'];
  /** The type of authentication to use for the webhook. */
  authType?: Maybe<WebhookAuthType>;
  /** The value of the authentication header to use for the webhook. */
  authValue?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the company that owns the webhook alert target. */
  companyUUID: Scalars['UUID']['output'];
  /** The timestamp when the webhook alert target was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The timestamp when the webhook alert target was deleted, if applicable. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** An optional label for the webhook alert target. */
  label?: Maybe<Scalars['String']['output']>;
  /** The OAuth client identifier. */
  oauthClientID?: Maybe<Scalars['String']['output']>;
  /** The HTTPS endpoint used to obtain an OAuth access token. */
  oauthTokenURL?: Maybe<Scalars['String']['output']>;
  /** The secret used to sign webhook requests for verification. */
  signingSecret?: Maybe<Scalars['String']['output']>;
  /** The type of the alert target, indicating that it is a webhook. */
  type: AlertTargetType;
  /** The timestamp when the webhook alert target was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The URL endpoint of the webhook where alerts will be sent. */
  url: Scalars['String']['output'];
};

/** A response type containing lists of alert targets for both emails and webhooks. */
export type AlertTargetsResponse = {
  __typename?: 'AlertTargetsResponse';
  /** A list of email alert targets. */
  emails: Array<AlertTargetEmail>;
  /** A list of Salesforce alert targets. */
  salesforceInstances: Array<AlertTargetSalesforce>;
  /** A list of Slack alert targets. */
  slacks: Array<AlertTargetSlack>;
  /** A list of webhook alert targets. */
  webhooks: Array<AlertTargetWebhook>;
};

/** The threshold parameters for an alert subscription of type ACCESS_POINT_CLIENT_COUNT. */
export type AlertThresholdParamsAccessPointClientCount = {
  __typename?: 'AlertThresholdParamsAccessPointClientCount';
  /** An alert is triggered if the number of connected clients to any AP in the network meets or exceeds this threshold. */
  clientCountThreshold: Scalars['Int']['output'];
};

/** Input for the threshold parameters for an alert subscription of type ACCESS_POINT_CLIENT_COUNT. */
export type AlertThresholdParamsAccessPointClientCountInput = {
  /** An alert is triggered if the number of connected clients to any AP in the network meets or exceeds this threshold. */
  clientCountThreshold: Scalars['Int']['input'];
};

/** The threshold parameters for an alert subscription of type BOOT_LOOP. */
export type AlertThresholdParamsBootLoop = {
  __typename?: 'AlertThresholdParamsBootLoop';
  /** Trigger the alert when a device reboots at least this many times within a rolling 60-minute window. */
  bootThreshold: Scalars['Int']['output'];
};

/** Input for the threshold parameters for an alert subscription of type BOOT_LOOP. */
export type AlertThresholdParamsBootLoopInput = {
  /** Trigger the alert when a device reboots at least this many times within a rolling 60-minute window. */
  bootThreshold?: Scalars['Int']['input'];
};

/** The threshold parameters for an alert subscription of type CHANNEL_UTILIZATION_HIGH. */
export type AlertThresholdParamsChannelUtilizationHigh = {
  __typename?: 'AlertThresholdParamsChannelUtilizationHigh';
  /** The band to evaluate the channel utilization for. */
  band: RadioBand;
  /** The percentage of access points on a network (from 0 to 100) that exceed the threshold for the given band. */
  percentageAccessPointsAboveThresholdInNetwork: Scalars['Float']['output'];
  /** Trigger the alert when the sum of the OBSS, non-802.11, and self (the access point's own client traffic) utilization crosses this threshold (from 0 to 100). */
  sumOBSSNon80211UtilizationThreshold: Scalars['Float']['output'];
};

/** Input for the threshold parameters for an alert subscription of type CHANNEL_UTILIZATION_HIGH. */
export type AlertThresholdParamsChannelUtilizationHighInput = {
  /** The band to evaluate the channel utilization for. */
  band: RadioBand;
  /** The percentage of access points on a network (from 0 to 100) that exceed the threshold for the given band. */
  percentageAccessPointsAboveThresholdInNetwork: Scalars['Float']['input'];
  /** Trigger the alert when the sum of the OBSS, non-802.11, and self (the access point's own client traffic) utilization crosses this threshold (from 0 to 100). */
  sumOBSSNon80211UtilizationThreshold: Scalars['Float']['input'];
};

/** The threshold parameters for an alert subscription of type DHCP_POOL_EXHAUSTION. */
export type AlertThresholdParamsDhcpPoolExhaustion = {
  __typename?: 'AlertThresholdParamsDHCPPoolExhaustion';
  /** Trigger the alert if the utilization of any VLAN's DHCP pool exceeds this threshold. */
  threshold: Scalars['Float']['output'];
};

/** Input for the threshold parameters for an alert subscription of type DHCP_POOL_EXHAUSTION. */
export type AlertThresholdParamsDhcpPoolExhaustionInput = {
  /** Trigger the alert if the utilization of any VLAN's DHCP pool exceeds this threshold. */
  threshold: Scalars['Float']['input'];
};

/** The threshold parameters for an alert subscription of type DEVICE_BOOT. */
export type AlertThresholdParamsDeviceBoot = {
  __typename?: 'AlertThresholdParamsDeviceBoot';
  /** Device types to alert on. Leave blank to alert on all device types. */
  deviceTypes?: Maybe<Array<DeviceType>>;
};

/** Input for the threshold parameters for an alert subscription of type DEVICE_BOOT. */
export type AlertThresholdParamsDeviceBootInput = {
  /** Device types to alert on. Leave blank to alert on all device types. */
  deviceTypes?: InputMaybe<Array<DeviceType>>;
};

/** The threshold parameters for an alert subscription of type DEVICE_OFFLINE. */
export type AlertThresholdParamsDeviceOffline = {
  __typename?: 'AlertThresholdParamsDeviceOffline';
  /** The device types to be alerted on. Leave blank to alert on all device types. */
  deviceTypes?: Maybe<Array<VirtualDeviceType>>;
};

/** Input for the threshold parameters for an alert subscription of type DEVICE_OFFLINE. */
export type AlertThresholdParamsDeviceOfflineInput = {
  /** The device types to be alerted on. Leave blank to alert on all device types. */
  deviceTypes?: InputMaybe<Array<VirtualDeviceType>>;
};

/** The threshold parameters for an alert subscription of type HIGH_CPU_USAGE. */
export type AlertThresholdParamsHighCpuUsage = {
  __typename?: 'AlertThresholdParamsHighCPUUsage';
  /** Trigger the alert when CPU usage on any device in the network exceeds this threshold. */
  threshold: Scalars['Float']['output'];
};

/** Input for the threshold parameters for an alert subscription of type HIGH_CPU_USAGE. */
export type AlertThresholdParamsHighCpuUsageInput = {
  /** Trigger the alert when CPU usage on any device in the network exceeds this threshold. */
  threshold: Scalars['Float']['input'];
};

/** The threshold parameters for an alert subscription of type IPSEC_TUNNEL_STATUS_CHANGE. */
export type AlertThresholdParamsIpSecTunnelStatusChange = {
  __typename?: 'AlertThresholdParamsIPSecTunnelStatusChange';
  /** The IPSec event types this alert subscribes to. */
  ipsecEventTypes?: Maybe<Array<IpSecEventType>>;
  /** The UUIDs of the IPSec tunnels to monitor for status changes. If empty, all tunnels will be monitored. */
  ipsecTunnelUUIDs?: Maybe<Array<Scalars['UUID']['output']>>;
};

/** Input for the threshold parameters for an alert subscription of type IPSEC_TUNNEL_STATUS_CHANGE. */
export type AlertThresholdParamsIpSecTunnelStatusChangeInput = {
  /** The IPSec event types this alert subscribes to. */
  ipsecEventTypes?: InputMaybe<Array<IpSecEventType>>;
  /** The UUIDs of the IPSec tunnels to monitor for status changes. If empty, all tunnels will be monitored. */
  ipsecTunnelUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** The threshold parameters for an alert subscription of type ISP_DEGRADATION. */
export type AlertThresholdParamsIspDegradation = {
  __typename?: 'AlertThresholdParamsISPDegradation';
  /** The minimum average WAN quality over a 1-minute period required to classify the connection as degraded. Quality is based on periodic ping success. */
  minimumPingSuccessRatio: Scalars['Float']['output'];
  /** The UUIDs of the ports on a firewall to detect degradation on. If none specified, all ports will be checked. */
  phyInterfaceUUIDs?: Maybe<Array<Scalars['UUID']['output']>>;
  /** The ports on a firewall to detect degradation on. If none specified, all ports will be checked. */
  phyInterfaces?: Maybe<Array<PhyInterface>>;
};

export type AlertThresholdParamsIspDegradationInput = {
  /** The minimum average WAN quality over a 1-minute period required to classify the connection as degraded. Quality is based on periodic ping success. */
  minimumPingSuccessRatio: Scalars['Float']['input'];
  /** The ports on a firewall to detect degradation on. If none specified, all ports will be checked. */
  phyInterfaceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** The threshold parameters for an alert subscription of type ISP_OUTAGE. */
export type AlertThresholdParamsIspOutage = {
  __typename?: 'AlertThresholdParamsISPOutage';
  /** The UUIDs of the ports on a firewall to detect outages on. If none specified, all ports will be checked. */
  phyInterfaceUUIDs?: Maybe<Array<Scalars['UUID']['output']>>;
  /** The ports on a firewall to detect outages on. If none specified, all ports will be checked. */
  phyInterfaces?: Maybe<Array<PhyInterface>>;
};

/** Input for the threshold parameters for an alert subscription of type ISP_OUTAGE. */
export type AlertThresholdParamsIspOutageInput = {
  /** The UUIDs of the ports on a firewall to detect outages on. If none specified, all ports will be checked. */
  phyInterfaceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type AlertThresholdParamsInput = {
  /** The alert type. */
  alertType: AlertType;
  /** Input for ACCESS_POINT_CLIENT_COUNT. */
  thresholdParamsAccessPointClientCount?: InputMaybe<AlertThresholdParamsAccessPointClientCountInput>;
  /** Input for BOOT_LOOP. */
  thresholdParamsBootLoopInput?: InputMaybe<AlertThresholdParamsBootLoopInput>;
  /** Input for CHANNEL_UTILIZATION_HIGH. */
  thresholdParamsChannelUtilizationHighInput?: InputMaybe<AlertThresholdParamsChannelUtilizationHighInput>;
  /** Input for DHCP_POOL_EXHAUSTION. */
  thresholdParamsDHCPPoolExhaustion?: InputMaybe<AlertThresholdParamsDhcpPoolExhaustionInput>;
  /** Input for DEVICE_BOOT. */
  thresholdParamsDeviceBootInput?: InputMaybe<AlertThresholdParamsDeviceBootInput>;
  /** Input for DEVICE_OFFLINE */
  thresholdParamsDeviceOfflineInput?: InputMaybe<AlertThresholdParamsDeviceOfflineInput>;
  /** Input for HIGH_CPU_USAGE. */
  thresholdParamsHighCPUUsageInput?: InputMaybe<AlertThresholdParamsHighCpuUsageInput>;
  /** Input for IPSEC_TUNNEL_STATUS_CHANGE. */
  thresholdParamsIPSecTunnelStatusChangeInput?: InputMaybe<AlertThresholdParamsIpSecTunnelStatusChangeInput>;
  /** Input for ISP_DEGRADATION. */
  thresholdParamsISPDegradationInput?: InputMaybe<AlertThresholdParamsIspDegradationInput>;
  /** Input for ISP_OUTAGE. */
  thresholdParamsISPOutageInput?: InputMaybe<AlertThresholdParamsIspOutageInput>;
  /** Input for LOG_LINE_MATCH. */
  thresholdParamsLogLineMatchInput?: InputMaybe<AlertThresholdParamsLogLineMatchInput>;
  /** Input for MASS_DEVICE_BOOT. */
  thresholdParamsMassDeviceBootInput?: InputMaybe<AlertThresholdParamsMassDeviceBootInput>;
  /** Input for RADIUS_UNREACHABLE. */
  thresholdParamsRadiusUnreachableInput?: InputMaybe<AlertThresholdParamsRadiusUnreachableInput>;
  /** Input for TEMPERATURE. */
  thresholdParamsTemperatureInput?: InputMaybe<AlertThresholdParamsTemperatureInput>;
  /** Input for WAN_FLAP. */
  thresholdParamsWANFlapInput?: InputMaybe<AlertThresholdParamsWanFlapInput>;
  /** Input for WIRELESS_DHCP_FAILURE. */
  thresholdParamsWirelessDHCPFailureInput?: InputMaybe<AlertThresholdParamsWirelessDhcpFailureInput>;
};

/** The threshold parameters for an alert subscription of type LOG_LINE_MATCH. */
export type AlertThresholdParamsLogLineMatch = {
  __typename?: 'AlertThresholdParamsLogLineMatch';
  /** Only match log lines from devices of these types. */
  deviceTypes?: Maybe<Array<DeviceType>>;
  /** Lucene query string matched against device logs. */
  query?: Maybe<Scalars['String']['output']>;
  /** Full-text search against the log body. */
  search?: Maybe<Scalars['String']['output']>;
  /** Only match log lines with these severity levels. */
  severities?: Maybe<Array<LogSeverity>>;
  /** The minimum number of matching log lines over the last five minutes required to trigger an alert. */
  threshold: Scalars['Int']['output'];
};

/** Input for the threshold parameters for an alert subscription of type LOG_LINE_MATCH. */
export type AlertThresholdParamsLogLineMatchInput = {
  /** Only match log lines from devices of these types. */
  deviceTypes?: InputMaybe<Array<DeviceType>>;
  /** Lucene query string matched against device logs. At least one of query, search, or severities must be provided. */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Full-text search against the log body. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Only match log lines with these severity levels. */
  severities?: InputMaybe<Array<LogSeverity>>;
  /** The minimum number of matching log lines over the last five minutes required to trigger an alert. */
  threshold?: Scalars['Int']['input'];
};

/** The threshold parameters for an alert subscription of type MASS_DEVICE_BOOT. */
export type AlertThresholdParamsMassDeviceBoot = {
  __typename?: 'AlertThresholdParamsMassDeviceBoot';
  /** Maximum spread, in minutes, for device reboots to count as a mass reboot. */
  bootSpanMinutes: Scalars['Int']['output'];
  /** Minimum percentage of non-PDU devices that must reboot within the boot span to trigger the alert. */
  devicePercent: Scalars['Float']['output'];
  /** Minimum number of non-PDU devices required in the network before this alert can trigger. */
  minDevices: Scalars['Int']['output'];
};

/** Input for the threshold parameters for an alert subscription of type MASS_DEVICE_BOOT. */
export type AlertThresholdParamsMassDeviceBootInput = {
  /** Maximum spread, in minutes, for device reboots to count as a mass reboot. */
  bootSpanMinutes?: Scalars['Int']['input'];
  /** Minimum percentage of non-PDU devices that must reboot within the boot span to trigger the alert. */
  devicePercent?: Scalars['Float']['input'];
  /** Minimum number of non-PDU devices required in the network before this alert can trigger. */
  minDevices?: Scalars['Int']['input'];
};

/** The threshold parameters for an alert subscription of type RADIUS_UNREACHABLE. */
export type AlertThresholdParamsRadiusUnreachable = {
  __typename?: 'AlertThresholdParamsRadiusUnreachable';
  /** An alert is triggered if the RADIUS authentication failure rate on the network exceeds this threshold. */
  threshold: Scalars['Float']['output'];
};

/** Input for the threshold parameters for an alert subscription of type RADIUS_UNREACHABLE. */
export type AlertThresholdParamsRadiusUnreachableInput = {
  /** Trigger the alert on a network where the failure rate is equal or higher than the threshold. */
  thresholdPercent: Scalars['Float']['input'];
};

/** The threshold parameters for an alert subscription of type TEMPERATURE. */
export type AlertThresholdParamsTemperature = {
  __typename?: 'AlertThresholdParamsTemperature';
  /** Only trigger the alert for devices with these device models. */
  deviceModels?: Maybe<Array<DeviceModel>>;
  /** Only trigger the alert for devices with these device types. */
  deviceTypes?: Maybe<Array<DeviceType>>;
  /** Trigger the alert when any device in the network drops below this temperature (C) threshold. */
  lowerThresholdCelsius?: Maybe<Scalars['Float']['output']>;
  /** Only trigger the alert for temperature measurements in these thermal zones. */
  thermalZones?: Maybe<Array<SystemThermalZone>>;
  /** Trigger the alert when any device in the network exceeds this temperature (C) threshold. */
  upperThresholdCelsius?: Maybe<Scalars['Float']['output']>;
  /** Trigger the alert when any device is outside its operating temperature range (C). */
  useOperatingTemperature: Scalars['Boolean']['output'];
  /** Only trigger the alert for devices with these device UUIDs. */
  virtualDeviceUUIDs?: Maybe<Array<Scalars['UUID']['output']>>;
};

/** Input for the threshold parameters for an alert subscription of type TEMPERATURE. */
export type AlertThresholdParamsTemperatureInput = {
  /** Only trigger the alert for devices with these device models. */
  deviceModels?: InputMaybe<Array<DeviceModel>>;
  /** Only trigger the alert for devices with these device types. */
  deviceTypes?: InputMaybe<Array<DeviceType>>;
  /** Trigger the alert when any device in the network drops below this temperature (C) threshold. */
  lowerThresholdCelsius?: InputMaybe<Scalars['Float']['input']>;
  /** Only trigger the alert for temperature measurements in these thermal zones. */
  thermalZones?: InputMaybe<Array<SystemThermalZone>>;
  /** Trigger the alert when any device in the network exceeds this temperature (C) threshold. */
  upperThresholdCelsius?: InputMaybe<Scalars['Float']['input']>;
  /** Trigger the alert when any device is outside its operating temperature range (C). */
  useOperatingTemperature: Scalars['Boolean']['input'];
  /** Only trigger the alert for devices with these device UUIDs. */
  virtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** The threshold parameters for an alert subscription of type WAN_FLAP. */
export type AlertThresholdParamsWanFlap = {
  __typename?: 'AlertThresholdParamsWANFlap';
  /** The minimum number of WAN status changes, within 15 minutes, to trigger the alert. */
  threshold: Scalars['Int']['output'];
};

/** Input for the threshold parameters for an alert subscription of type WAN_FLAP. */
export type AlertThresholdParamsWanFlapInput = {
  /** The minimum number of WAN status changes, within 15 minutes, to trigger the alert. */
  threshold?: Scalars['Int']['input'];
};

/** The threshold parameters for an alert subscription of type WIRELESS_DHCP_FAILURE. */
export type AlertThresholdParamsWirelessDhcpFailure = {
  __typename?: 'AlertThresholdParamsWirelessDHCPFailure';
  /** The minimum number of DHCP failures over the last five minutes required to trigger an alert. */
  threshold: Scalars['Int']['output'];
};

/** Input for the threshold parameters for an alert subscription of type WIRELESS_DHCP_FAILURE. */
export type AlertThresholdParamsWirelessDhcpFailureInput = {
  /** The minimum number of DHCP failures over the last five minutes required to trigger an alert. */
  threshold?: Scalars['Int']['input'];
};

/** Enumerates all supported alert types. */
export enum AlertType {
  /** Monitor when AP(s) in a network exceed a threshold of connected clients. */
  AccessPointClientCount = 'ACCESS_POINT_CLIENT_COUNT',
  /** Monitor when AP(s) in a network drop below their expected link speed. */
  AccessPointLinkSpeed = 'ACCESS_POINT_LINK_SPEED',
  /** Monitor when an AP radar event is detected. */
  ApRadarHit = 'AP_RADAR_HIT',
  /** Monitor when a mutation is performed on a network. */
  AuditLog = 'AUDIT_LOG',
  /** Monitor when a device reboots repeatedly within a short window. */
  BootLoop = 'BOOT_LOOP',
  /** Monitor when a client connects or requests access to a captive portal. */
  CaptivePortalAccess = 'CAPTIVE_PORTAL_ACCESS',
  /** Channel utilization crosses a threshold. */
  ChannelUtilizationHigh = 'CHANNEL_UTILIZATION_HIGH',
  /** Monitor when a network's devices' configs flap in short succession from version A to version B to version A to version B. */
  ConfigFlaps = 'CONFIG_FLAPS',
  /** Monitor when a device boots. */
  DeviceBoot = 'DEVICE_BOOT',
  /** Monitor when a device goes offline. */
  DeviceOffline = 'DEVICE_OFFLINE',
  /** Monitor when a DHCP pool is exhausted. */
  DhcpPoolExhaustion = 'DHCP_POOL_EXHAUSTION',
  /** Triggers when a firmware upgrade is completed. */
  FirmwareUpgradeCompleted = 'FIRMWARE_UPGRADE_COMPLETED',
  /** Triggers when a firmware upgrade fails. */
  FirmwareUpgradeFailed = 'FIRMWARE_UPGRADE_FAILED',
  /** Triggers when a firmware upgrade is pending. */
  FirmwareUpgradePending = 'FIRMWARE_UPGRADE_PENDING',
  /** Triggers when a firmware upgrade is scheduled. */
  FirmwareUpgradeScheduled = 'FIRMWARE_UPGRADE_SCHEDULED',
  /** Monitor when a failover event occurs on a high availability pair. */
  HighAvailabilityFailover = 'HIGH_AVAILABILITY_FAILOVER',
  /** High CPU usage on a device. */
  HighCpuUsage = 'HIGH_CPU_USAGE',
  /** Honeypot AP detected on a network. */
  HoneypotAp = 'HONEYPOT_AP',
  /** IPSec tunnel status changes. */
  IpsecTunnelStatusChange = 'IPSEC_TUNNEL_STATUS_CHANGE',
  /** Monitor when the same IP address is assigned to more than one MAC address. */
  IpConflict = 'IP_CONFLICT',
  /** Monitor when the WAN has experienced packet loss. */
  IspDegradation = 'ISP_DEGRADATION',
  /** Monitor when an ISP experiences an outage. */
  IspOutage = 'ISP_OUTAGE',
  /** Device log lines matching a filter are found. */
  LogLineMatch = 'LOG_LINE_MATCH',
  /** Monitor when many devices on a network reboot within a short window. */
  MassDeviceBoot = 'MASS_DEVICE_BOOT',
  /** Monitor when a port is blocked. */
  PortBlocked = 'PORT_BLOCKED',
  /** Monitor when RADIUS servers are unreachable. */
  RadiusUnreachable = 'RADIUS_UNREACHABLE',
  /** Rogue AP detected on a network. */
  RogueAp = 'ROGUE_AP',
  /** Rogue DHCP server detected on a network. */
  RogueDhcpServer = 'ROGUE_DHCP_SERVER',
  /** Spanning Tree Protocol error detected and port blocked. */
  StpError = 'STP_ERROR',
  /** Triggers when a support case or comment is created, updated, or deleted. */
  SupportEvents = 'SUPPORT_EVENTS',
  /** Monitor when temperature (C) is exceeded. */
  Temperature = 'TEMPERATURE',
  /** Verification of an alert being configured correctly. */
  Verification = 'VERIFICATION',
  /** WAN goes down on firewall. */
  WanDown = 'WAN_DOWN',
  /** WAN failover on firewall. */
  WanFailover = 'WAN_FAILOVER',
  /** WAN flaps on firewall. */
  WanFlap = 'WAN_FLAP',
  /** WAN goes up on firewall. */
  WanUp = 'WAN_UP',
  /** DHCP fails to resolve for a wireless client. */
  WirelessDhcpFailure = 'WIRELESS_DHCP_FAILURE'
}

/** Provides properties describing an AlertType. */
export type AlertTypeProperties = {
  __typename?: 'AlertTypeProperties';
  /** The alert type. */
  alertType: AlertType;
  /** Discrete event alerts are those that are triggered by a single event and are not evaluated on a recurring basis, nor are their trigger states sustained over time. */
  isDiscreteEvent: Scalars['Boolean']['output'];
  /** Whether this alert is only supported for fleetwide subscriptions. If true, one cannot create an AlertCompanySubscription for this alert type. */
  isFleetwideOnly: Scalars['Boolean']['output'];
  /** Whether this alert is snooze-able. If false, this alert will always trigger notifications even during a snooze. */
  snoozesSupported: Scalars['Boolean']['output'];
};

/** Input type for specifying filters when querying all client metrics timeseries data. */
export type AllClientMetricsTimeseriesFilterInput = {
  /** Specify the time range for the timeseries data. */
  timeFilter: MetricsFilterInput;
};

/** Response type containing client metrics timeseries data over a specified time range. */
export type AllClientMetricsTimeseriesResponse = {
  __typename?: 'AllClientMetricsTimeseriesResponse';
  /** Aggregated data for the total bytes received. */
  rxBytes: BaseMetricsResponse;
  /** Aggregated data for the total bytes transmitted. */
  txBytes: BaseMetricsResponse;
};

/** An enumeration of permitted folders where files can be uploaded to or downloaded from. */
export enum AllowedFolder {
  CompanyLogos = 'company_logos',
  ComplianceDocs = 'compliance_docs',
  DeploymentJobDocumentUploads = 'deployment_job_document_uploads',
  FloorPlanImages = 'floor_plan_images',
  InternalNotesAttachments = 'internal_notes_attachments',
  IspDocumentUploads = 'isp_document_uploads',
  MarketingChangelogEntries = 'marketing_changelog_entries',
  NetworkTopologyPhotos = 'network_topology_photos',
  OnboardingDocumentUploads = 'onboarding_document_uploads',
  ProviderLogos = 'provider_logos',
  SalesforceAttachments = 'salesforce_attachments'
}

/** More info about a kernel panic */
export type AnomalyKernelPanicInfo = {
  __typename?: 'AnomalyKernelPanicInfo';
  /** LR value in the panic log */
  lr: Scalars['String']['output'];
  /** PC value in the panic log */
  pc: Scalars['String']['output'];
};

export type AnomalyStatsFilterInput = {
  /** The lookback time to consider stats for, starting at `endTime`. Maximum allowed value is 7776000, 90 days. */
  durationSeconds: Scalars['Int']['input'];
  /** The latest observation time to consider stats for, inclusive. Defaults to the current time if not set. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The maximum number of results to return, between 1 and 1000. Defaults to 100 if not set. */
  limit?: Scalars['Int']['input'];
  /** The number of results to skip before returning results. Defaults to 0 if not set. */
  offset?: Scalars['Int']['input'];
  /** The unique identifiers of the virtual devices to fetch stats for. */
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']>;
};

/** Anomaly stats aggregate from multiple devices. */
export type AnomalyStatsGroup = {
  __typename?: 'AnomalyStatsGroup';
  /** The count of anomalies. */
  count: Scalars['Int']['output'];
  /** When the event is a kernel panic, more info about it (full stacktrace is in stackTrace). */
  kernelPanicInfo?: Maybe<AnomalyKernelPanicInfo>;
  /** The error message of the anomaly. */
  message: Scalars['String']['output'];
  /** The most recent observed time of the anomaly. */
  mostRecentObservedAt: Scalars['DateTime']['output'];
  /** The raw stats for the anomaly. */
  rawStats: Array<Stat>;
  /** Describes the source of the anomaly. */
  sourceFunction: Scalars['String']['output'];
  /** The line number description of the source function. */
  sourceLine: Scalars['String']['output'];
  /** The stack trace of the anomaly. */
  stackTrace: Scalars['String']['output'];
};

/**
 * A high-level category that an application belongs to (e.g. "Search Engines",
 * "Communication"). Distinct from ApplicationDNSFirewallRuleCategory, which is
 * specifically a category of DNS firewall rules.
 */
export type ApplicationCategory = {
  __typename?: 'ApplicationCategory';
  /** A description of the category. */
  description: Scalars['String']['output'];
  /** The unique identifier of the category. */
  id: Scalars['Int']['output'];
  /** The name of the category. */
  name: Scalars['String']['output'];
};

export type ApplicationClientUsageFilter = {
  /** The application ID to filter usage by. */
  applicationID: Scalars['Int']['input'];
  /** The lookback time to consider, starting at `endTime`. Maximum allowed value is 2592000, 30 days. */
  durationSeconds: Scalars['Int']['input'];
  /** The latest observation time to consider, inclusive. Defaults to the current time if not set. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** DNS firewall rules for a DHCP rule. These are powered by Netstar. */
export type ApplicationDnsFirewallRule = Identifiable & {
  __typename?: 'ApplicationDNSFirewallRule';
  /** The unique identifier of the DNS firewall rule. */
  UUID: Scalars['UUID']['output'];
  /** The action to take when the rule is matched. */
  action: FirewallRuleAction;
  /** The application associated with the DNS firewall rule as specified by Netstar. */
  application?: Maybe<ApplicationDnsFirewallRuleApplication>;
  /** List of DHCP rule bindings for the application DNS firewall rule. */
  boundDHCPRules?: Maybe<Array<DhcpRule>>;
  /** The category of the DNS firewall rule as specified by Netstar. */
  category?: Maybe<ApplicationDnsFirewallRuleCategory>;
  /** The timestamp when the rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The DHCP rule associated with this DNS firewall rule.
   * @deprecated Use `bindings` instead. This will be the first dhcpRule in bindings.
   */
  dhcpRule: DhcpRule;
  /** The domain or FQDN that is matched by the rule, allowing for wildcards denoted by '*'. */
  domain?: Maybe<Scalars['String']['output']>;
  /** The group of the DNS firewall rule as specified by Netstar. */
  group?: Maybe<ApplicationDnsFirewallRuleGroup>;
  /** Indicates whether the rule is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** The name of the DNS firewall rule. */
  name: Scalars['String']['output'];
  /** The network to which this rule is associated. */
  network: Network;
  /** The unique UUID for the network to which this rule is associated. */
  networkUUID: Scalars['UUID']['output'];
  /**
   * The priority of the rule; lower priority rules are applied first. When a rule is created with a
   * priority, any existing rule at that priority and the run of rules directly after it move down by
   * one. When a rule is created without a priority, it is added after the network's existing rules.
   * When creating several rules at once, two rules for the same network cannot ask for the same
   * priority, and the rules without one are added after all the others.
   */
  priority: Scalars['Int']['output'];
  /** The timestamp when the rule was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The application associated with a DNS firewall rule as specified by Netstar. */
export type ApplicationDnsFirewallRuleApplication = {
  __typename?: 'ApplicationDNSFirewallRuleApplication';
  /** The category this application belongs to, if any. */
  category?: Maybe<ApplicationCategory>;
  /** A human-readable description of the application, if any. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the application. */
  id: Scalars['Int']['output'];
  /** Indicates whether the application is visible to the customer. */
  isVisible: Scalars['Boolean']['output'];
  /** The name of the application. */
  name: Scalars['String']['output'];
  /** Security risk data for this application from the Netstar feed, if available. */
  riskData?: Maybe<ApplicationRiskData>;
};

/** Categories of DNS firewall rules as specified by Netstar. */
export type ApplicationDnsFirewallRuleCategory = {
  __typename?: 'ApplicationDNSFirewallRuleCategory';
  /** A description of the category. */
  description: Scalars['String']['output'];
  /** The group to which this category belongs. */
  group: ApplicationDnsFirewallRuleGroup;
  /** The unique identifier of the category. */
  id: Scalars['Int']['output'];
  /** The name of the category. */
  name: Scalars['String']['output'];
};

/** Groups multiple ApplicationDNSFirewallRuleApplications together, based on Netstar's categorizations. */
export type ApplicationDnsFirewallRuleGroup = {
  __typename?: 'ApplicationDNSFirewallRuleGroup';
  /** The unique identifier of the group. */
  id: Scalars['Int']['output'];
  /** The name of the group. */
  name: Scalars['String']['output'];
};

/** Security risk metadata for an application sourced from the Netstar WebAppCompass feed. */
export type ApplicationRiskData = {
  __typename?: 'ApplicationRiskData';
  /** Whether data stored at rest is encrypted. */
  dataAtRestEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the application has a data ownership policy. */
  dataOwnershipPolicy?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the application has a data retention policy. */
  dataRetentionPolicy?: Maybe<Scalars['Boolean']['output']>;
  /** TLS version in use. */
  encryptionProtocol?: Maybe<Scalars['String']['output']>;
  /** Whether the application reports GDPR data breaches. */
  gdprReportDataBreaches?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the application has had a known data breach. */
  latestBreach?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the application supports multi-factor authentication. */
  multifactorAuthentication?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the application enforces a password policy. */
  passwordPolicy?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the application has a privacy policy. */
  privacyPolicy?: Maybe<Scalars['Boolean']['output']>;
  /** The risk score level assigned by Netstar (e.g. Low Risk, High Risk). */
  riskScore: NetstarWebAppCompassRiskScore;
  /** Whether the application sends security HTTP headers. */
  securityHeaders?: Maybe<Scalars['String']['output']>;
  /** Whether the SSL certificate is from a trusted authority. */
  trustedCertificate?: Maybe<Scalars['String']['output']>;
  /** Whether the application requires user authentication. */
  userAuthentication?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the application uses a valid SSL certificate. */
  validCertificate?: Maybe<Scalars['String']['output']>;
};

/** The application usage. */
export type ApplicationUsage = {
  __typename?: 'ApplicationUsage';
  /** The application associated with this usage. The 'Unknown' application means we don't have the data to categorize the usage. */
  application: ApplicationDnsFirewallRuleApplication;
  /** The total rx bytes as specified by filter. */
  rxBytes: Scalars['Int']['output'];
  /** The total rx packets as specified by filter. */
  rxPackets: Scalars['Int']['output'];
  /** The total tx bytes as specified by filter. */
  txBytes: Scalars['Int']['output'];
  /** The total tx packets as specified by filter. */
  txPackets: Scalars['Int']['output'];
};

export type ApplicationUsageFilter = {
  /** If provided, filters usage to the specified MAC address. */
  clientMACAddress?: InputMaybe<Scalars['MacAddress']['input']>;
  /** The lookback time to consider, starting at `endTime`. Maximum allowed value is 2592000, 30 days. */
  durationSeconds: Scalars['Int']['input'];
  /** The latest observation time to consider, inclusive. Defaults to the current time if not set. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Response type containing application usage timeseries data over a specified time range. */
export type ApplicationUsageMetricsResponse = {
  __typename?: 'ApplicationUsageMetricsResponse';
  /** Aggregated data for the total bytes received (downloaded) by clients. */
  rxBytes: BaseMetricsResponse;
  /** Aggregated data for the total bytes transmitted (uploaded) by clients. */
  txBytes: BaseMetricsResponse;
};

/** Specifies the hardware device / virtual device pairing when assigning hardware to a virtual device. */
export type AssignHardwareDeviceToVirtualDeviceInput = {
  /** The serial number of the hardware device to assign. */
  serialNumber: Scalars['String']['input'];
  /** The UUID of the virtual device to assign the hardware device to. */
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** Input type for attaching a device to a rack elevation. */
export type AttachDeviceToRackElevationInput = {
  /** Whether the device is front-facing or rear-facing. */
  isFrontFacing?: InputMaybe<Scalars['Boolean']['input']>;
  /** A friendly name for display purposes. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Additional context or comments about the device. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The number of ports on the device. Only for switches and patch panels; cannot be specified if it's a Meter device. */
  portCount?: InputMaybe<Scalars['Int']['input']>;
  /** The indexes of the rack units that the device occupies. */
  rackMountUnitIndexes: Array<Scalars['Int']['input']>;
  /** A non-null value if the device shares or will share its rack mount unit with another device. 0-indexed; lower number is to the left when viewing the rack from the front. For simplicity this must be 0 or 1 (at-most 2 devices per rack mount unit). Paired devices require 0 for the primary and 1 for the secondary when placing or moving them. Omitted or null values use the required index. */
  sideBySideIndex?: InputMaybe<Scalars['Int']['input']>;
  /** The type of the device. Cannot be specified if it's a Meter device. */
  type?: InputMaybe<RackElevationDeviceType>;
  /** If it's a Meter device, the virtual device's UUID. If the device is paired, its partner is also placed on the same rack mount units and must not be attached to another rack elevation. */
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Per-device entry for attaching multiple devices to rack elevations. */
export type AttachDevicesToRackElevationsInput = {
  /** The details of the device to attach to the rack elevation. */
  input: AttachDeviceToRackElevationInput;
  /** The unique identifier of the rack elevation to which the device will be attached. */
  rackElevationUUID: Scalars['UUID']['input'];
};

/** How the mutation diff audit middleware obtains an entity snapshot for a mutation. */
export enum AuditLoadMode {
  /** Infer automatically: the before snapshot loads via the primary-scope UUID argument; the after snapshot is the resolver result. */
  Auto = 'AUTO',
  /** A hand-written loader on audithooks.MutationAuditLoader supplies the snapshot. The method is generated by src/graphql/auditgen; implementing it is tracked at code generation time. */
  Manual = 'MANUAL',
  /** No snapshot for this side of the diff. */
  None = 'NONE'
}

/** An authentication token entity, representing a token issued to a user or device. */
export type AuthenticationToken = {
  __typename?: 'AuthenticationToken';
  /** The unique identifier of the token. */
  UUID: Scalars['UUID']['output'];
  /** The serial number of the hardware device associated with the token, if any. */
  hardwareDeviceSerial?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the token was issued. */
  issuedAt: Scalars['DateTime']['output'];
  /** The timestamp when the token was revoked, if it has been revoked. */
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the user associated with the token, if any. */
  userID?: Maybe<Scalars['Int']['output']>;
};

/** An AP channel assignment changed by an auto channel selection job. */
export type AutoChannelSelectionAccessPointChannelAssignment = {
  __typename?: 'AutoChannelSelectionAccessPointChannelAssignment';
  /** The new 5GHz primary channel assigned to the AP. */
  newChannel5G?: Maybe<Scalars['Int']['output']>;
  /** The access point whose channel assignment was changed. */
  virtualDevice: VirtualDevice;
};

/** A network for which bulk dry-run auto channel selection did not complete, with a human-readable error. */
export type AutoChannelSelectionDryRunForNetworksFailure = {
  __typename?: 'AutoChannelSelectionDryRunForNetworksFailure';
  /** The error message describing the failure. */
  error: Scalars['String']['output'];
  /** The network that failed. */
  networkUUID: Scalars['UUID']['output'];
};

/** Result of running dry-run auto channel selection across multiple networks. */
export type AutoChannelSelectionDryRunForNetworksResult = {
  __typename?: 'AutoChannelSelectionDryRunForNetworksResult';
  /** A failure record for each network that failed. */
  failures: Array<AutoChannelSelectionDryRunForNetworksFailure>;
  /** A job record for each network that completed successfully. */
  successfulJobs: Array<AutoChannelSelectionJob>;
};

/** Auto Channel Selection Jobs automatically select the best channel for Access Points (APs) in a network. */
export type AutoChannelSelectionJob = AutoSelectionJob & NetworkJob & {
  __typename?: 'AutoChannelSelectionJob';
  /** The unique identifier of the job. */
  UUID: Scalars['UUID']['output'];
  /** The date and time when the job was completed. Null if not completed yet. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The network where the job is executed. */
  network: Network;
  /** The UUID of the network where the job is executed. */
  networkUUID: Scalars['UUID']['output'];
  /** The recurring auto channel selection schedule that triggered this job, if any. */
  recurringAutoChannelSelectionJob?: Maybe<RecurringAutoChannelSelectionJob>;
  /**
   * The results of the Auto Channel Selection job.
   * If the job is still running (completedAt is null), then no results will be returned.
   * One result will be returned for each virtual device (AP) that had its channel changed or encountered a warning.
   * If the device did not change channel and there was no warning, it will not appear in the results.
   */
  results?: Maybe<Array<AutoChannelSelectionResult>>;
  /** The date and time when the job is scheduled to start. */
  scheduledAt: Scalars['DateTime']['output'];
  /** The status of the job */
  status: NetworkJobStatus;
  /** The date and time when the job will time out if not completed. */
  timeoutAt: Scalars['DateTime']['output'];
  /** List of UUIDs of virtual devices (APs) involved in the job. */
  virtualDeviceUUIDs: Array<Scalars['UUID']['output']>;
};

/** Properties for auto channel selection job completed events. */
export type AutoChannelSelectionJobCompletedProperties = {
  __typename?: 'AutoChannelSelectionJobCompletedProperties';
  /** The auto channel selection job that completed. */
  autoChannelSelectionJob?: Maybe<AutoChannelSelectionJob>;
  /** The UUID of the auto channel selection job that completed. */
  autoChannelSelectionJobUUID?: Maybe<Scalars['UUID']['output']>;
  /** APs whose channel assignment was changed by the job. */
  modifiedAccessPoints: Array<AutoChannelSelectionAccessPointChannelAssignment>;
};

/** Input parameters for initializing an Auto Channel Selection Job. */
export type AutoChannelSelectionJobInput = {
  /**
   * Only applicable to the 5GHz band, ignored for other bands. Optional adjacent channel penalty
   * for ACS (0.0–1.0). 0 disables it. Defaults to 0.25.
   */
  band5GAdjacentChannelPenalty?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Only applicable to the 6GHz band, ignored for other bands. Optional adjacent channel penalty
   * for ACS (0.0–1.0). 0 disables it. Defaults to 0.25.
   */
  band6GAdjacentChannelPenalty?: InputMaybe<Scalars['Float']['input']>;
  /** The radio bands to run ACS for. Supported bands: 2.4GHz, 5GHz, 6GHz. */
  bands: Array<RadioBand>;
  /** Only for network-level runs: If true, only run ACS on APs that are experiencing high external interference. */
  excludeLowInterferenceAPs?: Scalars['Boolean']['input'];
  /** If true, compute proposed channels but do not update access point settings. */
  isDryRun?: Scalars['Boolean']['input'];
  /**
   * Only applicable to the 6GHz band, ignored for other bands. If true, ACS prefers Preferred
   * Scanning Channels (PSC) for faster client discovery. Defaults to true.
   */
  preferPSCChannels?: Scalars['Boolean']['input'];
  /** Schedule the job at a specific time in the future, up to a month in the future. If not provided, the job will run immediately. Must be null if scheduledAtNextMaintenanceWindow is true. */
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * If true, the ACS job will run during the network's next maintenance window.
   * Must be false if scheduledAt is provided.
   * Otherwise, it will run immediately.
   */
  scheduledAtNextMaintenanceWindow?: Scalars['Boolean']['input'];
  /** The scheduler to use for the job. */
  scheduler?: InputMaybe<SchedulerInput>;
  /**
   * Optional stickiness threshold for ACS (0.0–1.0). Controls how much better a new channel must
   * score before switching from the current channel. Defaults to 0.15.
   */
  stickinessThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** If provided, only run ACS on APs that have at least one of the specified tags. */
  virtualDeviceTagUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** The result of running Auto Channel Selection on a single virtual device (AP). */
export type AutoChannelSelectionResult = {
  __typename?: 'AutoChannelSelectionResult';
  /** The radio band this result applies to. */
  band?: Maybe<RadioBand>;
  /** Debug parameters from the ACS algorithm run for troubleshooting. */
  debugParams?: Maybe<Scalars['JSONObject']['output']>;
  /** The new 2.4GHz channel assigned to the AP after ACS ran. Null if no new channel was assigned. */
  new2_4GHzChannel?: Maybe<Scalars['Int']['output']>;
  /** The new 5GHz channel assigned to the AP after ACS ran. Null if no new channel was assigned. */
  new5GHzChannel?: Maybe<Scalars['Int']['output']>;
  /** The new 6GHz channel assigned to the AP after ACS ran. Null if no new channel was assigned. */
  new6GHzChannel?: Maybe<Scalars['Int']['output']>;
  /** The previous 2.4GHz channel assigned to the AP before ACS ran. Null if not applicable. */
  previous2_4GHzChannel?: Maybe<Scalars['Int']['output']>;
  /** The previous 5GHz channel assigned to the AP before ACS ran. Null if not applicable. */
  previous5GHzChannel?: Maybe<Scalars['Int']['output']>;
  /** The previous 6GHz channel assigned to the AP before ACS ran. Null if not applicable. */
  previous6GHzChannel?: Maybe<Scalars['Int']['output']>;
  /** The result type indicating the outcome of the Auto Channel Selection. */
  resultType: AutoChannelSelectionResultType;
  /** The date and time when the result was recorded. */
  timestamp: Scalars['DateTime']['output'];
  /** The UUID of the virtual device (AP) for which the result is reported. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** Enumeration of possible results for an Auto Channel Selection on an AP. */
export enum AutoChannelSelectionResultType {
  /** ACS ran and a channel was selected with the least number of BSSs, indicating minimal interference. */
  ChannelSelectedMinBss = 'CHANNEL_SELECTED_MIN_BSS',
  /** ACS ran but a random channel was selected, possibly due to insufficient data to make an informed choice. */
  ChannelSelectedRandom = 'CHANNEL_SELECTED_RANDOM',
  /** The Auto Channel Selection failed due to an unknown reason. */
  FailedUnknownReason = 'FAILED_UNKNOWN_REASON',
  /**
   * ACS skipped the AP because none of its allowed channels fit the configured channel width.
   * The AP keeps its current channel.
   */
  NoValidChannelForWidth = 'NO_VALID_CHANNEL_FOR_WIDTH',
  /** The Auto Channel Selection was successful. */
  Success = 'SUCCESS'
}

/** An interface representing a generic Auto Selection Job with common fields. */
export type AutoSelectionJob = {
  /** The unique identifier of the job. */
  UUID: Scalars['UUID']['output'];
  /** The date and time when the job was completed. Null if not completed yet. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The UUID of the network where the job is executed. */
  networkUUID: Scalars['UUID']['output'];
  /** The date and time when the job is scheduled to start. */
  scheduledAt: Scalars['DateTime']['output'];
  /** The status of the job */
  status: NetworkJobStatus;
  /** The date and time when the job will time out if not completed. */
  timeoutAt: Scalars['DateTime']['output'];
  /** A list of UUIDs of virtual devices involved in the job. */
  virtualDeviceUUIDs: Array<Scalars['UUID']['output']>;
};

/** A single time-bucketed BGP neighbor state observation. */
export type AutoVpnbgpNeighborStateMetricsValue = {
  __typename?: 'AutoVPNBGPNeighborStateMetricsValue';
  /** BFD state at this time.. */
  bfdState?: Maybe<BfdState>;
  /** BGP session state at this time. */
  bgpSessionState: BgpSessionState;
  /** Timestamp of this observation bucket. */
  timestamp: Scalars['DateTime']['output'];
};

/** An AutoVPNGroup defines a collection of networks connected via Auto VPN through a central hub. */
export type AutoVpnGroup = Identifiable & TargetInterface & {
  __typename?: 'AutoVPNGroup';
  /** Unique identifier for the AutoVPN group. */
  UUID: Scalars['UUID']['output'];
  /** BFD timing configuration for BGP sessions in this group. Only takes effect when `useBGP` is true. */
  bfd: BfdConfig;
  /** The company this AutoVPN group belongs to. */
  company: Company;
  /**
   * Slug of the company the AutoVPN group belongs to.
   * @deprecated Use `company.slug` instead.
   */
  companySlug: Scalars['String']['output'];
  /** Timestamp when the AutoVPN group was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The network that acts as the hub in the AutoVPN group.
   * @deprecated Use `hubs` instead.
   */
  hubNetwork?: Maybe<Network>;
  /**
   * Unique identifier of the network that acts as the hub in the AutoVPN group.
   * @deprecated Use `hubs` instead.
   */
  hubNetworkUUID?: Maybe<Scalars['UUID']['output']>;
  /**
   * Configuration of the hub's uplink interface.
   * @deprecated Use `hubs` instead.
   */
  hubUplink?: Maybe<AutoVpnHubUplink>;
  /** List of hubs in the AutoVPN group. */
  hubs: Array<AutoVpnHub>;
  /** The instance ASN used for the BGP session. Only takes effect when `useBGP` is true. */
  instanceASN: Scalars['Uint32']['output'];
  /** Indicates if the AutoVPN group is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /**
   * Indicates if hub failover is enabled.
   * @deprecated Use `hubs` instead.
   */
  isHubFailoverEnabled: Scalars['Boolean']['output'];
  /** List of members in the AutoVPN group. */
  members?: Maybe<Array<AutoVpnMember>>;
  /** Name of the AutoVPN group. */
  name: Scalars['String']['output'];
  /** Prefix length of the group overlay subnet. */
  overlayPrefixLength: Scalars['Int']['output'];
  /** Network address of the overlay subnet shared across all hubs and spokes in this group. */
  overlaySubnetGateway: Scalars['IP']['output'];
  /** If set, any new members will not automatically be assigned these addresses. */
  reservedMemberAddresses: Array<IpRange>;
  /** List of routes configured in the AutoVPN group. */
  routes?: Maybe<Array<AutoVpnRoute>>;
  /** Timestamp when the AutoVPN group was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The Auto VPN group uses a BGP backed version. This requires all associated networks support this implementation. */
  useBGP: Scalars['Boolean']['output'];
};

/** Represents a hub network within an AutoVPN group. */
export type AutoVpnHub = {
  __typename?: 'AutoVPNHub';
  /** Unique identifier for the AutoVPN Hub. */
  UUID: Scalars['UUID']['output'];
  /** The BGP neighbor state for this hub.. */
  bgpNeighborHubStates: Array<AutoVpnHubBgpNeighborState>;
  /** The Auto VPN group to which this hub belongs. */
  group: AutoVpnGroup;
  /** Unique identifier for the Auto VPN group to which this hub belongs. */
  groupUUID: Scalars['UUID']['output'];
  /** Indicates if failover is enabled for this hub. */
  isFailoverEnabled: Scalars['Boolean']['output'];
  /** Routes the hub's device most recently reported in this group's routing table. */
  learnedRoutes: Array<AutoVpnLearnedRoute>;
  /** The member hubs connected to this hub. */
  memberHubs: Array<AutoVpnMemberHub>;
  /** The network that acts as the hub. */
  network: Network;
  /** Unique identifier of the network that acts as the hub. */
  networkUUID: Scalars['UUID']['output'];
  /** Priority of this hub within its group. Lower value means higher priority. */
  priority: Scalars['Int']['output'];
  /** Configuration of the hub's uplink interface. */
  uplink?: Maybe<AutoVpnHubUplink>;
};

/** Hub and the BGP neighbor state to that hub. */
export type AutoVpnHubBgpNeighborState = {
  __typename?: 'AutoVPNHubBGPNeighborState';
  /** The other hub. */
  autoVPNHub: AutoVpnHub;
  /** The BGP neighbor state from this hubs perspective. */
  bgpNeighborState: BgpNeighborState;
};

/** Hub-to-hub BGP state timeseries. */
export type AutoVpnHubBgpNeighborStateMetricsResponse = {
  __typename?: 'AutoVPNHubBGPNeighborStateMetricsResponse';
  /** The hub whose BGP perspective is reported. */
  observingHub: AutoVpnHub;
  /** The peer hub being observed. */
  peerHub: AutoVpnHub;
  /** State observations over the requested time range */
  values: Array<AutoVpnbgpNeighborStateMetricsValue>;
};

/** Represents the configuration of the hub's uplink interface in an AutoVPN group. */
export type AutoVpnHubUplink = {
  __typename?: 'AutoVPNHubUplink';
  /** Unique identifier for the hub's uplink. */
  UUID: Scalars['UUID']['output'];
  /** IP address assigned to the hub's uplink. */
  address: Scalars['IP']['output'];
  /**
   * Prefix length of the uplink's IP address.
   * @deprecated Use `AutoVPNGroup.overlayPrefixLength` instead.
   */
  addressPrefixLength: Scalars['Int']['output'];
  /** Port number the hub listens on for VPN connections. */
  listenPort: Scalars['Int']['output'];
  /** Physical interface used by the hub's uplink. */
  phyInterface: PhyInterface;
  /** Unique identifier of the physical interface used by the hub's uplink. */
  phyInterfaceUUID: Scalars['UUID']['output'];
  /** Public key used for WireGuard VPN. */
  publicKey: Scalars['String']['output'];
};

/** A route reported in a device's routing table, learned over an Auto VPN BGP session. */
export type AutoVpnLearnedRoute = LearnedRoute & {
  __typename?: 'AutoVPNLearnedRoute';
  /** Whether the route is installed in the forwarding table. */
  installedToFIB: Scalars['Boolean']['output'];
  /** The next hop address for the route. */
  nextHop: Scalars['IP']['output'];
  /** When the routing table containing this route was reported. */
  observedAt: Scalars['DateTime']['output'];
  /** The destination prefix of the route. */
  prefix: Scalars['IPPrefix']['output'];
  /** The protocol that installed this route. Null if the device did not report one. */
  sourceProtocol?: Maybe<RouteSourceProtocol>;
};

/** Represents a member network within an AutoVPN group. */
export type AutoVpnMember = Identifiable & {
  __typename?: 'AutoVPNMember';
  /** Unique identifier for the AutoVPN member. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the AutoVPN member was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The group this member belongs to. */
  group: AutoVpnGroup;
  /** Unique identifier for the group this member belongs to. */
  groupUUID: Scalars['UUID']['output'];
  /** Indicates if failover is enabled for the member. */
  isFailoverEnabled: Scalars['Boolean']['output'];
  /** Hub connections for this member, one per hub in the group. */
  memberHubs: Array<AutoVpnMemberHub>;
  /** Network the member belongs to. */
  network: Network;
  /** Unique identifier of the network the member belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** VLANs permitted for the member. */
  permittedVLANs: Array<Vlan>;
  /** Timestamp when the AutoVPN member was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Configuration of the member's uplink interface.
   * @deprecated Use `memberHubs` instead.
   */
  uplink?: Maybe<AutoVpnMemberUplink>;
};

/** Hub-to-member BGP state timeseries. */
export type AutoVpnMemberBgpNeighborStateMetricsResponse = {
  __typename?: 'AutoVPNMemberBGPNeighborStateMetricsResponse';
  /** The hub whose BGP perspective is reported. */
  hub: AutoVpnHub;
  /** The member being observed. */
  member: AutoVpnMember;
  /** State observations over the requested time range */
  values: Array<AutoVpnbgpNeighborStateMetricsValue>;
};

/** Represents a connection between an AutoVPN member and one of the group's hubs. */
export type AutoVpnMemberHub = {
  __typename?: 'AutoVPNMemberHub';
  /** Unique identifier for the member-hub connection. */
  UUID: Scalars['UUID']['output'];
  /** The BGP neighbor state from perspective of hub. */
  bgpNeighborState?: Maybe<BgpNeighborState>;
  /** The hub this member is connected to. */
  hub: AutoVpnHub;
  /** Unique identifier of the hub. */
  hubUUID: Scalars['UUID']['output'];
  /** The hub uplink interface used for this connection. */
  hubUplink: AutoVpnHubUplink;
  /** Unique identifier of the hub uplink interface used for this connection. */
  hubUplinkUUID: Scalars['UUID']['output'];
  /**
   * Routes the member's device most recently reported whose next hop is this hub.
   * Routes in the group whose next hop is not a hub uplink address are not included.
   */
  learnedRoutes: Array<AutoVpnLearnedRoute>;
  /** The member this hub refers to. */
  member: AutoVpnMember;
  /** The unique identifier of the member this hub refers to. */
  memberUUID: Scalars['UUID']['output'];
  /** The member uplink interface used for this connection. */
  memberUplink: AutoVpnMemberUplink;
  /** Unique identifier of the member uplink interface used for this connection. */
  memberUplinkUUID: Scalars['UUID']['output'];
  /** Priority of this hub connection. If set, overrides the hub's priority in the group. */
  priority?: Maybe<Scalars['Int']['output']>;
  /** When metadata of this member hub connection was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Response type containing Client VPN server timeseries data over a specified time range. */
export type AutoVpnMemberMetricsResponse = {
  __typename?: 'AutoVPNMemberMetricsResponse';
  /** Auto VPN group. */
  autoVPNGroup: AutoVpnGroup;
  /** Client metrics for this Auto VPN group. */
  memberMetrics: Array<AutoVpnMemberUplinkMetricsResponse>;
};

/** Represents the configuration of a member's uplink interface in an AutoVPN group. */
export type AutoVpnMemberUplink = {
  __typename?: 'AutoVPNMemberUplink';
  /** Unique identifier for the member's uplink. */
  UUID: Scalars['UUID']['output'];
  /** IP address assigned to the member's uplink. */
  address: Scalars['IP']['output'];
  /**
   * Prefix length of the uplink's IP address.
   * @deprecated Use `AutoVPNGroup.overlayPrefixLength` instead.
   */
  addressPrefixLength: Scalars['Int']['output'];
  /** The latest connection info an AutoVPN hub reported about a member. */
  connectionInfo?: Maybe<AutoVpnMemberUplinkConnectionInfo>;
  /**
   * Unique identifier of the hub's uplink this member connects to.
   * @deprecated Use `AutoVPNMemberHub` instead.
   */
  hubUplinkUUID?: Maybe<Scalars['UUID']['output']>;
  /** Port number the member listens on for VPN connections. */
  listenPort: Scalars['Int']['output'];
  /** Physical interface used by the member's uplink. */
  phyInterface: PhyInterface;
  /** Unique identifier of the physical interface used by the member's uplink. */
  phyInterfaceUUID: Scalars['UUID']['output'];
  /** Public key used for WireGuard VPN. */
  publicKey: Scalars['String']['output'];
};

/** Provides connection statistics for a member's uplink in an AutoVPN group. */
export type AutoVpnMemberUplinkConnectionInfo = {
  __typename?: 'AutoVPNMemberUplinkConnectionInfo';
  /** The last time a handshake was received (from the hub's perspective). */
  lastHandshakeRx?: Maybe<Scalars['DateTime']['output']>;
  /** The last time a handshake was transmitted (from the hub's perspective). */
  lastHandshakeTx?: Maybe<Scalars['DateTime']['output']>;
  /** The last time a packet was received over the tunnel (from the hub's perspective). */
  lastPacketRx?: Maybe<Scalars['DateTime']['output']>;
  /** The last time a packet was transmitted over the tunnel (from the hub's perspective). */
  lastPacketTx?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when the connection info was observed. */
  observedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Response type containing Auto VPN member uplink client timeseries data. */
export type AutoVpnMemberUplinkMetricsResponse = {
  __typename?: 'AutoVPNMemberUplinkMetricsResponse';
  /** Auto VPN member uplink for this series */
  autoVPNMemberUplink: AutoVpnMemberUplink;
  /** Aggregated throughput for the total bytes received in bps. */
  rxBytes: BaseMetricsResponse;
  /** Aggregated throughput for the total packets received per second. */
  rxPackets: BaseMetricsResponse;
  /** Aggregated throughput for the total bytes transmitted in bps. */
  txBytes: BaseMetricsResponse;
  /** Aggregated throughput for the total packets transmitted per second. */
  txPackets: BaseMetricsResponse;
};

/** An Auto VPN route defines a network route members of an Auto VPN group route through the hub. */
export type AutoVpnRoute = Identifiable & {
  __typename?: 'AutoVPNRoute';
  /** Unique identifier for the AutoVPN route. */
  UUID: Scalars['UUID']['output'];
  /** The BGP router that created this route. */
  bgpRouter?: Maybe<BgpRouter>;
  /** Timestamp when the route was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Destination gateway IP address for the route. */
  dstGateway: Scalars['IPV4']['output'];
  /** Prefix length for the destination IP of the route. */
  dstPrefixLength: Scalars['Int']['output'];
  /** The group to which this route belongs. */
  group: AutoVpnGroup;
  /** The unique identifier to the group to which this route belongs. */
  groupUUID: Scalars['UUID']['output'];
  /** Indicates if the route is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Name of the route. */
  name: Scalars['String']['output'];
  /** The next hop address for the route. It is only set for routes with a BGP router. */
  nextHop?: Maybe<Scalars['IPV4']['output']>;
  /** Timestamp when the route was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Holds the binding of VLAN and Auto VPN Group. */
export type AutoVpnvlan = {
  __typename?: 'AutoVPNVLAN';
  /** The Auto VPN Group. */
  autoVPNGroup: AutoVpnGroup;
  /** The VLAN. */
  vlan: Vlan;
};

/** An autonomous system is used to control routing within networks. */
export type AutonomousSystem = {
  __typename?: 'AutonomousSystem';
  /** The unique Autonomous System Number (ASN) for this system. */
  asn: Scalars['Uint32']['output'];
  /** The IP ranges for the autonomous system. */
  ipRanges: Array<IpRange>;
  /** The name of the organization maintaining this autonomous system. */
  organizationName: Scalars['String']['output'];
};

/** BFD timing configuration for a BGP neighbor or a BGP-backed AutoVPN group. */
export type BfdConfig = {
  __typename?: 'BFDConfig';
  /** The number of missed packets before declaring peer down. */
  detectMultiplier: Scalars['Int']['output'];
  /** Interval at which BFD control packets are received. */
  receiveInterval: Scalars['Duration']['output'];
  /** Interval at which BFD control packets are transmitted. */
  transmitInterval: Scalars['Duration']['output'];
};

/** The state of the bidirectional forwarding detection (BFD). */
export enum BfdState {
  /** BFD session was manually brought down. */
  AdminDown = 'ADMIN_DOWN',
  /** BFD session is down. */
  Down = 'DOWN',
  /** BFD session is up and active. */
  Up = 'UP'
}

/** A neighbor for Border Gateway Protocol configuration. */
export type BgpNeighbor = Identifiable & {
  __typename?: 'BGPNeighbor';
  /** Unique identifier for this neighbor. */
  UUID: Scalars['UUID']['output'];
  /** The list of custom prefixes to advertise to this neighbor. */
  advertisementPrefixes: Array<Scalars['IPPrefix']['output']>;
  /** The list of VLAN subnets to advertise to this neighbor. */
  advertisementVLANs: Array<Vlan>;
  /**
   * The Auto VPN group associated with this neighbor.
   * @deprecated Use `targetInterface` instead.
   */
  autoVPNGroup?: Maybe<AutoVpnGroup>;
  /**
   * The unique identifier for the Auto VPN group associated with this neighbor.
   * @deprecated Use `targetInterface` instead.
   */
  autoVPNGroupUUID?: Maybe<Scalars['UUID']['output']>;
  /** The period between successive connect attempts, in seconds. */
  connectIntervalSeconds: Scalars['Int']['output'];
  /** When this neighbor was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A longer description for this neighbor. */
  description?: Maybe<Scalars['String']['output']>;
  /** The maximum number of hops between the router and neighbor. */
  ebgpNumMaxHops?: Maybe<Scalars['Int']['output']>;
  /** Whether this neighbor has a configured MD5 authentication password. This value can be updated but not retrieved after setting. */
  hasMD5AuthPassword: Scalars['Boolean']['output'];
  /** The period since the last received keep-alive before neighbor is dropped, in seconds. */
  holdIntervalSeconds: Scalars['Int']['output'];
  /** The IP address for this neighbor. */
  ipAddress: Scalars['IP']['output'];
  /** Whether the neighbor is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** The period at which BGP keep-alive is sent, in seconds. */
  keepaliveIntervalSeconds: Scalars['Int']['output'];
  /** A descriptive name for the neighbor. */
  name: Scalars['String']['output'];
  /**
   * The the physical interface used to reach this neighbor.
   * @deprecated Use `targetInterface` instead.
   */
  phyInterface?: Maybe<PhyInterface>;
  /**
   * The unique identifier for the physical interface used to reach this neighbor.
   * @deprecated Use `targetInterface` instead.
   */
  phyInterfaceUUID?: Maybe<Scalars['UUID']['output']>;
  /** The peer Autonomous System Number (ASN) for this neighbor. */
  remoteASN: Scalars['Uint32']['output'];
  /** The peer Autonomous System for this neighbor. */
  remoteAutonomousSystem?: Maybe<AutonomousSystem>;
  /** Unique identifier for this neighbor's router. */
  routerUUID: Scalars['UUID']['output'];
  /** The latest reported state for this neighbor. */
  state?: Maybe<BgpNeighborState>;
  /** Interface used to reach this neighbor. */
  targetInterface: TargetInterface;
  /** When this neighbor was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The the VLAN used to reach this neighbor.
   * @deprecated Use `targetInterface` instead.
   */
  vlan?: Maybe<Vlan>;
  /**
   * The unique identifier for the VLAN used to reach this neighbor.
   * @deprecated Use `targetInterface` instead.
   */
  vlanUUID?: Maybe<Scalars['UUID']['output']>;
};

/** Reported state of the BGP neighbor. */
export type BgpNeighborState = {
  __typename?: 'BGPNeighborState';
  /** The bidirectional forwarding detection (BFD) state. */
  bfdState?: Maybe<BfdState>;
  /** The time the current `bfdState` began. */
  bfdStateSince?: Maybe<Scalars['DateTime']['output']>;
  /** The time in seconds that have elapsed in the current `bfdState`. */
  bfdStateTimeSeconds?: Maybe<Scalars['Uint64']['output']>;
  /** The BGP session state. */
  bgpSessionState?: Maybe<BgpSessionState>;
  /** The time in seconds that the neighbor has been up. */
  bgpUpAt?: Maybe<Scalars['DateTime']['output']>;
  /** The time in seconds that the neighbor has been up. */
  bgpUptimeSeconds?: Maybe<Scalars['Uint64']['output']>;
  /** The time at which the last reset occured after a connection interruption. */
  lastResetAt?: Maybe<Scalars['DateTime']['output']>;
  /** The cause code when the last reset occured after a connection interruption. */
  lastResetCauseCode?: Maybe<Scalars['Uint64']['output']>;
  /** The total number of messages received by the neighbor since initialization (device configuration or reboot). */
  totalMessagesReceived?: Maybe<Scalars['Uint64']['output']>;
  /** The total number of messages sent by the neighbor since initialization (device configuration or reboot). */
  totalMessagesSent?: Maybe<Scalars['Uint64']['output']>;
};

/** A router for Border Gateway Protocol configuration. */
export type BgpRouter = Identifiable & {
  __typename?: 'BGPRouter';
  /** Unique identifier for this router. */
  UUID: Scalars['UUID']['output'];
  /** Auto VPN Groups associated with this router. */
  autoVPNGroups?: Maybe<Array<AutoVpnGroup>>;
  /** When this router was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A longer description for this router. */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether this router is is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** The local Autonomous System Number (ASN) for this router. */
  localASN: Scalars['Uint32']['output'];
  /** The local Autonomous System for this router. */
  localAutonomousSystem?: Maybe<AutonomousSystem>;
  /** The descriptive short name for this router. */
  name: Scalars['String']['output'];
  /** The list of neighbors to peer with. */
  neighbors: Array<BgpNeighbor>;
  /** This router's network. */
  network: Network;
  /** Unique identifier for this router's network. */
  networkUUID: Scalars['UUID']['output'];
  /** When this router was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Route for BGP router. */
export type BgpRouterDynamicRouteInput = {
  /** The next hop address for this route. */
  nextHop: Scalars['IPV4']['input'];
  /** The prefix for this route. */
  prefix: Scalars['UnmaskedIPPrefix']['input'];
};

/** A route reported in a device's routing table, learned over a BGP session belonging to a BGP router. */
export type BgpRouterLearnedRoute = LearnedRoute & {
  __typename?: 'BGPRouterLearnedRoute';
  /** Whether the route is installed in the forwarding table. */
  installedToFIB: Scalars['Boolean']['output'];
  /** The next hop address for the route. */
  nextHop: Scalars['IP']['output'];
  /** When the routing table containing this route was reported. */
  observedAt: Scalars['DateTime']['output'];
  /** The destination prefix of the route. */
  prefix: Scalars['IPPrefix']['output'];
  /** The protocol that installed this route. Null if the device did not report one. */
  sourceProtocol?: Maybe<RouteSourceProtocol>;
};

/** The state of the BGP session. */
export enum BgpSessionState {
  /** TCP 3-way handshake failed, retry active. */
  Active = 'ACTIVE',
  /** BGP session is being torn down. */
  Clearing = 'CLEARING',
  /** Waiting for TCP 3-way handshake. */
  Connect = 'CONNECT',
  /** Session is being removed from memory. */
  Deleted = 'DELETED',
  /** BGP session is up. */
  Established = 'ESTABLISHED',
  /** No incoming or outgoing connections. */
  Idle = 'IDLE',
  /** Received reply, and message is valid. */
  OpenConfirm = 'OPEN_CONFIRM',
  /** TCP connection established, BGP 'OPEN' message sent, waiting for reply. */
  OpenSent = 'OPEN_SENT'
}

/**
 * BSSID represents a unique identifier for a wireless network, in the form of a MAC address.
 * Every radio band / SSID pair for an AP has its own BSSID, derived from the hardware device's MAC address.
 */
export type Bssid = {
  __typename?: 'BSSID';
  /** The MAC address uniquely identifying this BSSID on the wireless network. */
  BSSID: Scalars['MacAddress']['output'];
  /** The SSID object associated with this BSSID. */
  SSID: Ssid;
  /** The UUID of the SSID associated with this BSSID. */
  SSIDUUID: Scalars['UUID']['output'];
  /** The hardware device representing the access point associated with this BSSID. */
  accessPointHardwareDevice: AccessPointHardwareDevice;
  /** The serial number of the access point associated with this BSSID. */
  accessPointSerialNumber: Scalars['String']['output'];
  /** A BSSID is inactive if it is associated with a disabled SSID, or the SSID is not broadcast for its AP, or the SSID is not allowed for its radio band, or the radio band is disabled on its AP's radio profile. */
  isActive: Scalars['Boolean']['output'];
  /** The radio frequency band on which this BSSID operates. */
  radioBand: RadioBand;
};

/** Base64 encoded image data. */
export type Base64Image = {
  __typename?: 'Base64Image';
  /** The base64 encoded image data. */
  data: Scalars['String']['output'];
  /** The type of the image. */
  imageType: ImageType;
};

/** A metrics response carrying plain timestamped values and no additional per-metric fields. */
export type BaseMetricsResponse = MetricsResponse & {
  __typename?: 'BaseMetricsResponse';
  /** Metadata providing additional information about the metrics data. */
  metadata?: Maybe<MetricsMetadata>;
  /** The list of metrics data points. */
  values: Array<BaseMetricsValue>;
};

/** A single timestamped metrics data point with no additional fields. */
export type BaseMetricsValue = MetricsValue & {
  __typename?: 'BaseMetricsValue';
  /** The timestamp for this metrics data point. */
  timestamp: Scalars['DateTime']['output'];
  /** The value of the metric at the given timestamp. */
  value: Scalars['Float']['output'];
};

/** A bearer session allows a token to be created for a CLI session using the credentials of the validator. */
export type BearerSession = {
  __typename?: 'BearerSession';
  /** The unique identifier for the bearer session. This UUID is used to reference and manage the session during its lifecycle. */
  UUID: Scalars['UUID']['output'];
  /** The authentication token associated with the bearer session. This token is used for authenticated CLI requests after the session has been validated. */
  token?: Maybe<Scalars['String']['output']>;
};

/** Input type for binding a firewall rule to a physical interface. */
export type BindFirewallRuleToPhyInterface = {
  /** UUID of the firewall rule to bind. */
  firewallRuleUUID: Scalars['UUID']['input'];
  /** Metric to assign to the binding (must be greater than or equal to 0). */
  metric?: InputMaybe<Scalars['Int']['input']>;
  /**
   * UUID of the physical interface to bind the firewall rule to.
   * The physical interface must be an uplink.
   */
  phyInterfaceUUID: Scalars['UUID']['input'];
};

/** Input type for binding a firewall rule to a VLAN. */
export type BindFirewallRuleToVlan = {
  /** UUID of the firewall rule to bind. */
  firewallRuleUUID: Scalars['UUID']['input'];
  /** Metric to assign to the binding (must be greater than or equal to 0). */
  metric?: InputMaybe<Scalars['Int']['input']>;
  /** UUID of the VLAN to bind the firewall rule to. */
  vlanUUID: Scalars['UUID']['input'];
};

export type BindPolicyRoutingRuleInput = {
  /** The binding information for the policy routing rule. */
  binding: PolicyRoutingRuleBindingInput;
  /** The metric (priority) assigned to the binding. If not provided, will be 1 greater than current greatest metric. */
  metric?: InputMaybe<Scalars['Int']['input']>;
};

export type BindPolicyRoutingRulesInput = {
  /** The binding information to be applied. */
  binding: PolicyRoutingRuleBindingInput;
};

export type BindVlanToPhyInterfaceInput = {
  /**
   * Indicates whether the VLAN should be tagged on the physical interface.
   * If true, the VLAN will be tagged; if false, it will be set as the native (untagged) VLAN.
   */
  isTagged: Scalars['Boolean']['input'];
  /** The UUID of the physical interface to which the VLAN will be bound. */
  phyInterfaceUUID: Scalars['UUID']['input'];
  /** The UUID of the VLAN to bind to the physical interface. */
  vlanUUID: Scalars['UUID']['input'];
};

export type BoolFilter = {
  /** The key for the filter. */
  key: Scalars['String']['input'];
  /** Boolean value for the filter. */
  value: Scalars['Boolean']['input'];
};

/** BootInfo captures logs every time a device boots up. */
export type BootInfo = {
  __typename?: 'BootInfo';
  /** The last reported boot counter which the device increments every time it boots. */
  bootCount: Scalars['Int']['output'];
  /** The last reported build the device was running. */
  buildName: Scalars['String']['output'];
  /** The human readable build version for the firmware, derived from the `buildName`. */
  buildVersion?: Maybe<Scalars['String']['output']>;
  /** The time at which the device first reported the information. */
  createdAt: Scalars['DateTime']['output'];
  /** Indicates whether the device is running a signed image. */
  isImageSigned?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the device has secure boot enabled. The hardware fuses have been set to enforce signed Meter images. */
  isSecureBoot?: Maybe<Scalars['Boolean']['output']>;
  /** If the device knows, this is the last reported reason that caused the device to reboot. */
  rebootReason: Scalars['String']['output'];
  /** The time at which the device reported the information. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The semantic version of a device image. */
export type BuildVersion = {
  __typename?: 'BuildVersion';
  /** Whether this is a debug build. */
  isDebug: Scalars['Boolean']['output'];
  /** Whether this is a release build. */
  isRelease: Scalars['Boolean']['output'];
  /** Whether this build requires secure boot. */
  isSecureBoot: Scalars['Boolean']['output'];
  /** The major version. */
  major: Scalars['Int']['output'];
  /** The minor version. */
  minor: Scalars['Int']['output'];
  /** The patch version. */
  patch: Scalars['Int']['output'];
};

/** Associates a device (mac + network) with a map of severity counts */
export type BulkCveSeverityCountResult = {
  __typename?: 'BulkCVESeverityCountResult';
  /** Array of severity and count per severity */
  counts: Array<CveSeverityCount>;
  /** MAC Address */
  macAddress: Scalars['MacAddress']['output'];
  /** Network UUID */
  networkUUID: Scalars['UUID']['output'];
};

export type BulkCreateNacCredentialInput = {
  /** Optional NAC user groups to assign the credential to. */
  groupUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The password for EAP-GTC authentication. */
  password: Scalars['String']['input'];
  /** The username for EAP-GTC authentication. */
  username: Scalars['String']['input'];
};

/** Represents a bulk NOS upgrade operation. */
export type BulkNosUpgrade = {
  __typename?: 'BulkNOSUpgrade';
  /** Unique identifier of the bulk NOS upgrade. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the bulk NOS upgrade was created. */
  createdAt: Scalars['DateTime']['output'];
  /** List of networks included in the bulk NOS upgrade. */
  networks: Array<Network>;
  /** The NOS version to upgrade to. */
  nosVersion: NosVersion;
  /**
   * Identifier of the NOS version to upgrade to.
   * @deprecated Use nosVersion instead.
   */
  nosVersionID: Scalars['Int']['output'];
  /** Timestamp when the bulk NOS upgrade will be scheduled at the earliest. The scheduler will schedule an upgrade at the next maintenance window for each network after this time. */
  scheduledAtEarliest: Scalars['DateTime']['output'];
  /** Timestamp when the bulk NOS upgrade was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Username or identifier of the user who last updated the bulk NOS upgrade. */
  updatedBy: Scalars['String']['output'];
};

export type BulkNosUpgradesFilterInput = {
  /** Maximum number of bulk NOS upgrades to return. */
  limit?: Scalars['Int']['input'];
  /** Filter to include bulk NOS upgrades created before or at this time. */
  maxCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter to include bulk NOS upgrades created at or after this time. */
  minCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Number of bulk NOS upgrades to skip before starting to collect the result set. */
  offset?: Scalars['Int']['input'];
};

/** A packet capture that was run on a Firewall. */
export type CosPacketCaptureJob = PacketCaptureJob & {
  __typename?: 'COSPacketCaptureJob';
  /** The unique identifier for the job. */
  UUID: Scalars['UUID']['output'];
  /** The time at which the job was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Whether the capture's file is currently available to download from storage. */
  downloadAvailable: Scalars['Boolean']['output'];
  /** The pcap-filter(7)/tcpdump filter applied to the capture; empty if all traffic was captured. */
  filter: Scalars['String']['output'];
  /** The unique identifier of the network associated with this job. */
  networkUUID: Scalars['UUID']['output'];
  /** The maximum size limit of the packet capture file in megabytes. */
  sizeLimitMb: Scalars['Int']['output'];
  /** Whether the job was stopped prematurely or not. */
  stopped: Scalars['Boolean']['output'];
  /** The maximum duration of the packet capture in seconds. */
  timeLimitSeconds: Scalars['Int']['output'];
  /**
   * The unique identifier for the job.
   * @deprecated Use `UUID` instead.
   */
  uuid: Scalars['UUID']['output'];
  /** The virtual device that the packet capture is run on. */
  virtualDevice: VirtualDevice;
  /** The UUID of the virtual device that the packet capture is run on. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/**
 * A Common Platform Enumeration (CPE) is a scheme for naming different systems / software versions.
 * Following CPE schema at https://csrc.nist.gov/schema/nvd/api/2.0/cpe_api_json_2.0.schema
 */
export type Cpe = {
  __typename?: 'CPE';
  /** Unique identifier for this CPE */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the CPE was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The unique identifier NIST uses for this CPE. */
  nameID: Scalars['UUID']['output'];
  /** The type of product, valid values are 'a' (application software), 'o' (operating system), and 'h' (hardware device). */
  part: Scalars['String']['output'];
  /** The product descriptor of the platform. */
  product: Scalars['String']['output'];
  /** Timestamp when the CPE was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The URI is defined by NIST is a combination of uri, part, vendor, and version. */
  uri: Scalars['String']['output'];
  /** The vendor of the platform. */
  vendor: Scalars['String']['output'];
  /** The version of the platform. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Filter the response to CPEs. Each provided filter will be used. At least 1 must be provided. */
export type CpEsFilterInput = {
  /** The maximum number of CPEs to return. */
  limit?: Scalars['Int']['input'];
  /** The number of CPEs to skip before starting to collect the result set. */
  offset?: Scalars['Int']['input'];
  /** Filter by prefix matching the part. */
  part?: InputMaybe<Scalars['String']['input']>;
  /** Filter by prefix matching the product. */
  product?: InputMaybe<Scalars['String']['input']>;
  /** Filter by prefix matching the vendor. */
  vendor?: InputMaybe<Scalars['String']['input']>;
  /** Filter by prefix matching the version. */
  version?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Shared shape for every entity CRUD event. An event carries only the action and the id of
 * the entity it happened to, so a client that just wants to invalidate a cache entry never
 * pays to resolve the entity. Select the entity field when you actually want the new values.
 */
export type CrudEvent = {
  /** The UUID of the entity the action was performed on. */
  entityUUID: Scalars['UUID']['output'];
  /** The action performed on the entity. */
  type: CrudEventType;
};

/** The action a CRUD event describes. */
export enum CrudEventType {
  /** The entity was created. */
  Created = 'CREATED',
  /** The entity was deleted. */
  Deleted = 'DELETED',
  /** The entity was updated. */
  Updated = 'UPDATED'
}

/** A Common Vulnerability and Exposure (CVE). */
export type Cve = {
  __typename?: 'CVE';
  /** The CVE identifier (e.g. 'CVE-2023-12345'). */
  ID: Scalars['String']['output'];
  /** Base severity label for the CVE. */
  baseSeverity?: Maybe<CveSeverity>;
  /** When our system first stored this CVE in the database. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Short description from the vulnerability feed. */
  description?: Maybe<Scalars['String']['output']>;
  /** When NVD last updated it. */
  externalLastModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When NVD published it. */
  externalPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Source of the CVE info (e.g. 'MITRE', 'NVD'). */
  source?: Maybe<Scalars['String']['output']>;
  /** Title of CVE */
  title?: Maybe<Scalars['String']['output']>;
  /** When our system last updated this CVE record. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Specifies the severity of a CVE. */
export enum CveSeverity {
  /** Critical severity */
  Critical = 'CRITICAL',
  /** High severity */
  High = 'HIGH',
  /** Low severity */
  Low = 'LOW',
  /** Medium severity */
  Medium = 'MEDIUM',
  /** Unknown severity */
  Unknown = 'UNKNOWN'
}

/** Number of CVEs for a specific severity. */
export type CveSeverityCount = {
  __typename?: 'CVESeverityCount';
  /** A label like 'HIGH', 'MEDIUM', etc. */
  baseSeverity: CveSeverity;
  /** Number of CVEs found for that severity. */
  count: Scalars['Int']['output'];
};

export type CvEsByNetworkMacAddressesInput = {
  /** Array of MAC addresses */
  macAddresses: Array<Scalars['MacAddress']['input']>;
  /** Network UUID. */
  networkUUID: Scalars['UUID']['input'];
};

/** Properties for calibration job channel reset failure events. */
export type CalibrationJobChannelResetFailedProperties = {
  __typename?: 'CalibrationJobChannelResetFailedProperties';
  /** The UUID of the calibration job that failed. */
  calibrationJobUuid: Scalars['UUID']['output'];
  /** The time the failure was detected. */
  detectedAt: Scalars['DateTime']['output'];
  /** List of APs that did not reset to their expected (configured) channel. */
  failedAccessPoints: Array<AccessPointChannelInfo>;
};

/** Properties for calibration job completed events. */
export type CalibrationJobCompletedProperties = {
  __typename?: 'CalibrationJobCompletedProperties';
  /** The UUID of the calibration job that completed. */
  calibrationJobUUID: Scalars['UUID']['output'];
  /** The time the calibration job completed. */
  completedAt: Scalars['DateTime']['output'];
  /** Whether the calibration job results were empty (no scan data). */
  emptyScanData: Scalars['Boolean']['output'];
};

/** Input parameters for cancelling a wireless calibration job. */
export type CancelWirelessCalibrationJobInput = {
  /** The UUID of the wireless calibration job to cancel. */
  UUID: Scalars['UUID']['input'];
};

/** A captive portal is a web page that is displayed to newly connected users before allowing them access to the network. */
export type CaptivePortal = Identifiable & {
  __typename?: 'CaptivePortal';
  /** The unique identifier of the captive portal. */
  UUID: Scalars['UUID']['output'];
  /** IPs/URLs that clients may reach before authenticating to the captive portal. */
  allowedHosts: Array<Scalars['String']['output']>;
  /** Authentication session duration in seconds. The amount of time a user remains authorized after accepting the terms and conditions. Defaults to 1 day (86400 seconds) if not set. */
  authLifetimeSec?: Maybe<Scalars['Int']['output']>;
  /** The heading to display on the captive portal page. */
  callToAction?: Maybe<Scalars['String']['output']>;
  /** Display settings for the captive portal page, including background and font colors and whether to hide the 'Powered by Meter' text. */
  displaySettings?: Maybe<CaptivePortalDisplaySettings>;
  /** Optional TTL for captive portal entry records. When set, entries are automatically hidden after this duration and deleted by a daily cleanup job. Minimum 30 days. */
  entriesTimeToLive?: Maybe<Scalars['Duration']['output']>;
  /** The URL to an external captive portal. If this is configured, it will override all configurations specific to internal captive portals. */
  externalPortalURL?: Maybe<Scalars['String']['output']>;
  /** HMAC secret used to sign and verify signatures. */
  hmacSecret?: Maybe<Scalars['String']['output']>;
  /** If true, the captive portal is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** A base64 encoded image of the logo, served inline so no additional domain needs to be reachable from the captive portal. */
  logoImageBase64?: Maybe<Base64Image>;
  /** The S3 key for where the logo image is stored. This is used for configuration and should not be used to display the image. */
  logoImageS3Key?: Maybe<Scalars['String']['output']>;
  /** A URL to a logo image that will be displayed on the captive portal page. */
  logoImageURL?: Maybe<Scalars['String']['output']>;
  /** A human-friendly name for the captive portal. */
  name?: Maybe<Scalars['String']['output']>;
  /** The network to which this captive portal belongs. */
  network: Network;
  /** The UUID of the network to which this captive portal belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** The URL to redirect to after a successful captive portal login. */
  redirectURL?: Maybe<Scalars['String']['output']>;
  /** If true, captive portal auth requests will need to be approved by an admin. */
  requiresApproval: Scalars['Boolean']['output'];
  /** If true, the captive portal will collect email addresses from users. */
  requiresEmail: Scalars['Boolean']['output'];
  /** If true, the captive portal will collect names from users. */
  requiresName: Scalars['Boolean']['output'];
  /** The terms and conditions text that a user must agree to before accessing the network. */
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  /** If true, an external captive portal receives this portal's webhook key on its URL and may post back to the per-company webhook endpoint. */
  useCompanyWebhook: Scalars['Boolean']['output'];
  /** The VLANs that this captive portal is associated with. */
  vlans?: Maybe<Array<Vlan>>;
  /** UUID used to generate a unique URL for a webhook corresponding to this captive portal. */
  webhookKey: Scalars['UUID']['output'];
};

/** Contains information about a client that interacted with a captive portal. */
export type CaptivePortalClient = {
  __typename?: 'CaptivePortalClient';
  /** The IP address of the client device. */
  ipAddress: Scalars['IP']['output'];
  /** If true, the client has accepted the terms and conditions and has been authorized. */
  isAuthorized: Scalars['Boolean']['output'];
  /** The MAC address of the client device. */
  macAddress: Scalars['MacAddress']['output'];
  /** The raw user-agent string of the client device. */
  rawUserAgent: Scalars['String']['output'];
  /** The timestamp when the client accessed or interacted with the captive portal. */
  timestamp: Scalars['DateTime']['output'];
};

/** Display settings for the captive portal page. */
export type CaptivePortalDisplaySettings = {
  __typename?: 'CaptivePortalDisplaySettings';
  /** The background color of the captive portal page, specified as a hex color code. */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The color used on the call to action, specified as a hex color code. */
  callToActionColor?: Maybe<Scalars['String']['output']>;
  /** The font color used on the captive portal page, specified as a hex color code. */
  fontColor?: Maybe<Scalars['String']['output']>;
  /** If true, the 'Powered by Meter' text will be hidden on the captive portal page. */
  hidePoweredByMeter?: Maybe<Scalars['Boolean']['output']>;
};

export type CaptivePortalDisplaySettingsInput = {
  /** The background color of the captive portal page, specified as a hex color code. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** The color used on the call to action, specified as a hex color code. */
  callToActionColor?: InputMaybe<Scalars['String']['input']>;
  /** The font color used on the captive portal page, specified as a hex color code. */
  fontColor?: InputMaybe<Scalars['String']['input']>;
  /** If true, the 'Powered by Meter' text will be hidden on the captive portal page. */
  hidePoweredByMeter?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A page of captive portal entries for the entries table. */
export type CaptivePortalEntriesTablePage = {
  __typename?: 'CaptivePortalEntriesTablePage';
  /** The page the cursor points to. */
  currentPage: Scalars['Int']['output'];
  /** The items in this page. */
  items: Array<CaptivePortalEntry>;
  /** The next pages cursor. */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /** The previous pages cursor. */
  previousCursor?: Maybe<Scalars['String']['output']>;
  /** The total number of entries. */
  totalCount: Scalars['Int']['output'];
  /** The total number of pages. */
  totalPages: Scalars['Int']['output'];
};

/** Recorded entry of an auth request for a captive portal. */
export type CaptivePortalEntry = Identifiable & {
  __typename?: 'CaptivePortalEntry';
  /** The UUID of the captive portal entry. */
  UUID: Scalars['UUID']['output'];
  /** User that performed the latest action on the captive portal entry. */
  actionedBy?: Maybe<User>;
  /** Timestamp when the captive portal request was approved. */
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The captive portal the entry belongs to. */
  captivePortal: CaptivePortal;
  /** Timestamp when the captive portal entry was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Timestamp when the captive portal entry data was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when the captive portal request was denied. */
  deniedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The email address collected from the client. */
  email?: Maybe<Scalars['String']['output']>;
  /** The IP address of the client. */
  ip?: Maybe<Scalars['IP']['output']>;
  /** The MAC address of the client. */
  mac?: Maybe<Scalars['MacAddress']['output']>;
  /** The name collected from the client. */
  name?: Maybe<Scalars['String']['output']>;
  /** The UUID of the network. */
  networkUUID: Scalars['UUID']['output'];
  /** Timestamp when the captive portal entry expires and will no longer be returned. */
  timeToLiveExpiresAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum CaptivePortalEntryAction {
  /** Approve the captive portal entry. */
  Approve = 'APPROVE',
  /** Delete the collected data of the captive portal entry */
  DeleteData = 'DELETE_DATA',
  /** Deny the captive portal entry. */
  Deny = 'DENY'
}

export type CaptivePortalEntryFilterInput = {
  /** Filter captive portal entries by IP address. */
  ipAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The maximum number of captive portal entries to return. */
  limit?: Scalars['Int']['input'];
  /** Filter captive portal entries by MAC address. */
  macAddress?: InputMaybe<Scalars['MacAddress']['input']>;
  /** Only include captive portal entries that were created before or at this date and time. */
  maxCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only include captive portal entries that were created at or after this date and time. */
  minCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The number of captive portal entries to skip before starting to collect the result set. */
  offset?: Scalars['Int']['input'];
};

/** A page of captive portal entries. */
export type CaptivePortalEntryPage = {
  __typename?: 'CaptivePortalEntryPage';
  /** The list of captive portal entries. */
  entries: Array<CaptivePortalEntry>;
  /** The total number of captive portal entries. */
  total: Scalars['Int']['output'];
};

export type CaptivePortalSettingsInput = {
  /** The IPs/URLs that are whitelisted by default. */
  allowedHosts?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Authentication session duration in seconds. The amount of time a user remains authorized after accepting the terms and conditions. Defaults to 1 day (86400 seconds) if not set. */
  authLifetimeSec?: InputMaybe<Scalars['Int']['input']>;
  /** The heading to display on the captive portal page. */
  callToAction?: InputMaybe<Scalars['String']['input']>;
  /** Display settings configuration for the captive portal page, including background and font colors and whether to hide the 'Powered by Meter' text. */
  displaySettings?: InputMaybe<CaptivePortalDisplaySettingsInput>;
  /** Optional TTL for captive portal entry records. When set, entries are automatically hidden after this duration and deleted by a daily cleanup job. Minimum 30 days. If set for an existing captive portal, the TTL will be applied to all existing entries. */
  entriesTimeToLive?: InputMaybe<Scalars['Duration']['input']>;
  /** Setting externalPortalURL will configure this captive portal to redirect users to an external portal and override any settings specific to internal captive portals. */
  externalPortalURL?: InputMaybe<Scalars['String']['input']>;
  /** If true, the captive portal is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Use the `createPreSignedUploadUrl` mutation to generate an S3 key and presigned URL for the logo image, and specify it here. */
  logoImageS3Key?: InputMaybe<Scalars['String']['input']>;
  /** A human-friendly name for the captive portal. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The URL to redirect to after a successful captive portal login. */
  redirectURL?: InputMaybe<Scalars['String']['input']>;
  /** If true, captive portal auth requests will need to be approved by an admin. */
  requiresApproval?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the captive portal will collect email addresses from users. */
  requiresEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the captive portal will collect names from users. */
  requiresName?: InputMaybe<Scalars['Boolean']['input']>;
  /** The terms and conditions text that a user must agree to before accessing the network. */
  termsAndConditions?: InputMaybe<Scalars['String']['input']>;
  /** If true, an external captive portal receives this portal's webhook key on its URL and may post back to the per-company webhook endpoint. */
  useCompanyWebhook?: InputMaybe<Scalars['Boolean']['input']>;
  /** Setting vlanUUIDs will assign this captive portal to the specified VLANs. */
  vlanUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** A carrier appliance. */
export type CarrierApplianceHardwareDevice = HardwareDevice & {
  __typename?: 'CarrierApplianceHardwareDevice';
  /** The batch identifier of the hardware device, if any. */
  batch?: Maybe<Scalars['String']['output']>;
  /** Shows the most recent boot history of a device. */
  bootHistory: Array<BootInfo>;
  /** The active config override for this device, if any. */
  configOverride?: Maybe<DeviceConfigOverride>;
  /** The timestamp when the hardware device was first created. */
  createdAt: Scalars['DateTime']['output'];
  /** The model name of the hardware device. */
  deviceModel: DeviceModel;
  /** The type of the hardware device. */
  deviceType: DeviceType;
  /** If the device is no longer connected to the backend, this is the time at which it was last connected. */
  disconnectedFromBackendAt?: Maybe<Scalars['DateTime']['output']>;
  /** The hardware generation of the device. */
  hardwareGeneration: HardwareGeneration;
  /** Metadata for the model of this device. */
  hardwareModelProperties: HardwareModelProperties;
  /** Internal operator-only notes about this hardware device. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /**
   * True if the device has an active websocket connection to the backend. Note that this only works if the device has registered via the /v2/register endpoint (i.e., is a Config 2 device) - otherwise is always false.
   * @deprecated Use `isSpare` instead.
   */
  isActive: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is connected to the backend. */
  isConnectedToBackend: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /**
   * Indicates whether the hardware device is marked as a development (dev) device, moving it into the dev (staging) realm for testing purposes.
   * @deprecated Use `realm` instead. isDev is equivalent to realm == DEV.
   */
  isDev: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is in factory mode. */
  isFactoryMode: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is an RMA (Return Merchandise Authorization) replacement device. */
  isRMA: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device has been retired. */
  isRetired: Scalars['Boolean']['output'];
  /** A spare hardware device belongs to a network but is not assigned to a virtual device. Spares are typically kept on site as replacements and are not in service. */
  isSpare: Scalars['Boolean']['output'];
  /** The latest device config metadata (ie. the config without the actual JSON payload) for the device. */
  latestDeviceConfigMetadata?: Maybe<DeviceConfigMetadata>;
  /** The MAC address of the hardware device. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** The UUID of the network that the hardware device belongs to. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** The public key used to add the device to the jumphost's WireGuard interface. */
  publicKey?: Maybe<Scalars['String']['output']>;
  /** The realm that owns this hardware device. Used for cross-realm device management. */
  realm: HardwareDeviceRealm;
  /** The unique serial number of the hardware device. */
  serialNumber: Scalars['String']['output'];
  /** The network that the spare hardware device belongs to. Spare hardware devices that are not affiliated with a virtual device will have this field populated. */
  spareDeviceNetwork?: Maybe<Network>;
  /** IPv6 address on the jumphost subnet. Used to send requests to the device. */
  tunnelIPAddress?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the hardware device was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The uptime of the hardware device, retrieved from the time series database.
   * @deprecated Use `VirtualDevice.uptime` instead.
   */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** The virtual device associated with this hardware device, if any. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The UUID of the virtual device this hardware device is assigned to, if any. */
  virtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
};


/** A carrier appliance. */
export type CarrierApplianceHardwareDeviceBootHistoryArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

/** A carrier appliance device is a logical representation of a physical carrier appliance device. */
export type CarrierApplianceVirtualDevice = TargetInterface & VirtualDevice & {
  __typename?: 'CarrierApplianceVirtualDevice';
  /** The unique identifier (UUID) of the virtual device. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the virtual device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** An optional description for the virtual device. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Metadata for the configurations rendered by this virtual device over time, newest
   * first. Includes configs written to hardware devices that have since been dissociated
   * from this virtual device. No history is available before June 2026.
   */
  deviceConfigs: Array<DeviceConfigMetadata>;
  /** The model name of the virtual device. */
  deviceModel: DeviceModel;
  /** The type of the virtual device. */
  deviceType: VirtualDeviceType;
  /** The hardware device associated with this virtual device, if any. */
  hardwareDevice?: Maybe<HardwareDevice>;
  /** Metadata for the model of this device. */
  hardwareModelProperties: HardwareModelProperties;
  /** Installer label for devices. Only supported on [CellularAccessPoint, CellularSwitches, CarrierAppliance] */
  installerLabel: Scalars['String']['output'];
  /** The management IP address of the device. Note this is not yet populated for carrier appliance devices. */
  ipAddress?: Maybe<Scalars['IP']['output']>;
  /** Indicates whether the virtual device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether debug logging is enabled on the virtual device. */
  isDebugLogEnabled: Scalars['Boolean']['output'];
  /** Whether this virtual device is in a draft state for preconfiguration reasons. */
  isDraft: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is online, indicated by its heartbeat. */
  isOnline: Scalars['Boolean']['output'];
  /** A human-friendly name for the device. */
  label: Scalars['String']['output'];
  /** The physical location of this virtual device, derived from its rack elevation placement. */
  location?: Maybe<VirtualDeviceLocation>;
  /** The most recent NOS upgrade for this virtual device that has started executing or was skipped (in progress, completed, failed, or skipped), if any. */
  mostRecentNOSUpgrade?: Maybe<ScheduledDeviceNosUpgrade>;
  /** The network that the virtual device belongs to. */
  network: Network;
  /** The unique identifier (UUID) of the network the virtual device belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /**
   * The group that the device belongs to for firmware upgrade grouping purposes.
   * Note: This is nullable in the schema but all devices now have a NOS upgrade group.
   */
  nosUpgradeGroup: NosUpgradeGroup;
  /** The current NOS firmware version that the virtual device is configured to run. */
  nosVersion?: Maybe<ConfiguredNosVersion>;
  /** The identifier of the NOS firmware version that the virtual device is configured to run. */
  nosVersionID: Scalars['Int']['output'];
  /** The carrier appliance's active or future notification snoozes */
  notificationSnoozes: Array<DeviceNotificationSnooze>;
  /** The paired virtual device to this device, applicable to dual-chassis configurations. */
  pairedVirtualDevice?: Maybe<VirtualDevice>;
  /** The NOS firmware version that the virtual device is scheduled to upgrade to. */
  pendingNosVersion?: Maybe<PendingNosVersion>;
  /** URL to the regulatory e-label for the device, if applicable. */
  regulatoryLabelURL?: Maybe<Scalars['String']['output']>;
  /** The virtual device tags on this device. */
  tags: Array<VirtualDeviceTag>;
  /** Data about this virtual device's position in its network's topology. */
  topologyData?: Maybe<VirtualDeviceTopologyData>;
  /** The timestamp when the virtual device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /** How long the device has been continuously powered on and reporting. */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** For dual-chassis devices, the "position" of this virtual device within its device pair (left or right). When hardware is assigned, this virtual device will receive hardware with a matching position. Null if not part of a pair. */
  virtualDevicePairPosition?: Maybe<DevicePosition>;
};


/** A carrier appliance device is a logical representation of a physical carrier appliance device. */
export type CarrierApplianceVirtualDeviceDeviceConfigsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};

/** A cellular access point. */
export type CellularAccessPointHardwareDevice = HardwareDevice & {
  __typename?: 'CellularAccessPointHardwareDevice';
  /** The batch identifier of the hardware device, if any. */
  batch?: Maybe<Scalars['String']['output']>;
  /** Shows the most recent boot history of a device. */
  bootHistory: Array<BootInfo>;
  /** The active config override for this device, if any. */
  configOverride?: Maybe<DeviceConfigOverride>;
  /** The timestamp when the hardware device was first created. */
  createdAt: Scalars['DateTime']['output'];
  /** The model name of the hardware device. */
  deviceModel: DeviceModel;
  /** The type of the hardware device. */
  deviceType: DeviceType;
  /** If the device is no longer connected to the backend, this is the time at which it was last connected. */
  disconnectedFromBackendAt?: Maybe<Scalars['DateTime']['output']>;
  /** The hardware generation of the device. */
  hardwareGeneration: HardwareGeneration;
  /** Metadata for the model of this device. */
  hardwareModelProperties: HardwareModelProperties;
  /** Internal operator-only notes about this hardware device. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /**
   * True if the device has an active websocket connection to the backend. Note that this only works if the device has registered via the /v2/register endpoint (i.e., is a Config 2 device) - otherwise is always false.
   * @deprecated Use `isSpare` instead.
   */
  isActive: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is connected to the backend. */
  isConnectedToBackend: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /**
   * Indicates whether the hardware device is marked as a development (dev) device, moving it into the dev (staging) realm for testing purposes.
   * @deprecated Use `realm` instead. isDev is equivalent to realm == DEV.
   */
  isDev: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is in factory mode. */
  isFactoryMode: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is an RMA (Return Merchandise Authorization) replacement device. */
  isRMA: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device has been retired. */
  isRetired: Scalars['Boolean']['output'];
  /** A spare hardware device belongs to a network but is not assigned to a virtual device. Spares are typically kept on site as replacements and are not in service. */
  isSpare: Scalars['Boolean']['output'];
  /** The latest device config metadata (ie. the config without the actual JSON payload) for the device. */
  latestDeviceConfigMetadata?: Maybe<DeviceConfigMetadata>;
  /** The MAC address of the hardware device. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** The UUID of the network that the hardware device belongs to. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** The public key used to add the device to the jumphost's WireGuard interface. */
  publicKey?: Maybe<Scalars['String']['output']>;
  /** The realm that owns this hardware device. Used for cross-realm device management. */
  realm: HardwareDeviceRealm;
  /** The unique serial number of the hardware device. */
  serialNumber: Scalars['String']['output'];
  /** The network that the spare hardware device belongs to. Spare hardware devices that are not affiliated with a virtual device will have this field populated. */
  spareDeviceNetwork?: Maybe<Network>;
  /** IPv6 address on the jumphost subnet. Used to send requests to the device. */
  tunnelIPAddress?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the hardware device was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The uptime of the hardware device, retrieved from the time series database.
   * @deprecated Use `VirtualDevice.uptime` instead.
   */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** The virtual device associated with this hardware device, if any. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The UUID of the virtual device this hardware device is assigned to, if any. */
  virtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
};


/** A cellular access point. */
export type CellularAccessPointHardwareDeviceBootHistoryArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

/** A cellular access point device is a logical representation of a physical cellular access point. */
export type CellularAccessPointVirtualDevice = TargetInterface & VirtualDevice & {
  __typename?: 'CellularAccessPointVirtualDevice';
  /** The unique identifier (UUID) of the virtual device. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the virtual device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** An optional description for the virtual device. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Metadata for the configurations rendered by this virtual device over time, newest
   * first. Includes configs written to hardware devices that have since been dissociated
   * from this virtual device. No history is available before June 2026.
   */
  deviceConfigs: Array<DeviceConfigMetadata>;
  /** The model name of the virtual device. */
  deviceModel: DeviceModel;
  /** The type of the virtual device. */
  deviceType: VirtualDeviceType;
  /** The hardware device associated with this virtual device, if any. */
  hardwareDevice?: Maybe<HardwareDevice>;
  /** Metadata for the model of this device. */
  hardwareModelProperties: HardwareModelProperties;
  /** Installer label for devices. Only supported on [CellularAccessPoint, CellularSwitches, CarrierAppliance] */
  installerLabel: Scalars['String']['output'];
  /** The management IP address of the device. Note that this is not yet populated for cellular devices. */
  ipAddress?: Maybe<Scalars['IP']['output']>;
  /** Indicates whether the virtual device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether debug logging is enabled on the virtual device. */
  isDebugLogEnabled: Scalars['Boolean']['output'];
  /** Whether this virtual device is in a draft state for preconfiguration reasons. */
  isDraft: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is online, indicated by its heartbeat. */
  isOnline: Scalars['Boolean']['output'];
  /** A human-friendly name for the device. */
  label: Scalars['String']['output'];
  /** The physical location of this virtual device, derived from its rack elevation placement. */
  location?: Maybe<VirtualDeviceLocation>;
  /** The most recent NOS upgrade for this virtual device that has started executing or was skipped (in progress, completed, failed, or skipped), if any. */
  mostRecentNOSUpgrade?: Maybe<ScheduledDeviceNosUpgrade>;
  /** The network that the virtual device belongs to. */
  network: Network;
  /** The unique identifier (UUID) of the network the virtual device belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /**
   * The group that the device belongs to for firmware upgrade grouping purposes.
   * Note: This is nullable in the schema but all devices now have a NOS upgrade group.
   */
  nosUpgradeGroup: NosUpgradeGroup;
  /** The current NOS firmware version that the virtual device is configured to run. */
  nosVersion?: Maybe<ConfiguredNosVersion>;
  /** The identifier of the NOS firmware version that the virtual device is configured to run. */
  nosVersionID: Scalars['Int']['output'];
  /** The carrier appliance's active or future notification snoozes */
  notificationSnoozes: Array<DeviceNotificationSnooze>;
  /** The paired virtual device to this device, applicable to dual-chassis configurations. */
  pairedVirtualDevice?: Maybe<VirtualDevice>;
  /** The NOS firmware version that the virtual device is scheduled to upgrade to. */
  pendingNosVersion?: Maybe<PendingNosVersion>;
  /** URL to the regulatory e-label for the device, if applicable. */
  regulatoryLabelURL?: Maybe<Scalars['String']['output']>;
  /** The virtual device tags on this device. */
  tags: Array<VirtualDeviceTag>;
  /** Data about this virtual device's position in its network's topology. */
  topologyData?: Maybe<VirtualDeviceTopologyData>;
  /** The timestamp when the virtual device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /** How long the device has been continuously powered on and reporting. */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** For dual-chassis devices, the "position" of this virtual device within its device pair (left or right). When hardware is assigned, this virtual device will receive hardware with a matching position. Null if not part of a pair. */
  virtualDevicePairPosition?: Maybe<DevicePosition>;
};


/** A cellular access point device is a logical representation of a physical cellular access point. */
export type CellularAccessPointVirtualDeviceDeviceConfigsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};

/** A cellular gateway. */
export type CellularGatewayHardwareDevice = HardwareDevice & {
  __typename?: 'CellularGatewayHardwareDevice';
  /** The batch identifier of the hardware device, if any. */
  batch?: Maybe<Scalars['String']['output']>;
  /** Shows the most recent boot history of a device (buildName, bootCount). */
  bootHistory: Array<BootInfo>;
  /** The active config override for this device, if any. */
  configOverride?: Maybe<DeviceConfigOverride>;
  /** The timestamp when the hardware device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** The model name of the hardware device. */
  deviceModel: DeviceModel;
  /** The type of the hardware device. */
  deviceType: DeviceType;
  /** If the device is no longer connected to the backend, this is the time at which it was last connected. */
  disconnectedFromBackendAt?: Maybe<Scalars['DateTime']['output']>;
  /** The hardware generation of the device. */
  hardwareGeneration: HardwareGeneration;
  /** Metadata for the model of this device. */
  hardwareModelProperties: HardwareModelProperties;
  /** Internal operator-only notes about this hardware device. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /**
   * True if the device has an active websocket connection to the backend. Note that this only works if the device has registered via the /v2/register endpoint (i.e., is a Config 2 device) - otherwise is always false.
   * @deprecated Use `isSpare` instead.
   */
  isActive: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is connected to the backend. */
  isConnectedToBackend: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /**
   * Indicates whether the hardware device is marked as a development (dev) device, moving it into the dev (staging) realm for testing purposes.
   * @deprecated Use `realm` instead. isDev is equivalent to realm == DEV.
   */
  isDev: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is in factory mode. */
  isFactoryMode: Scalars['Boolean']['output'];
  /** True if the PDU's MAC address exists in the most recent controller MAC table for the network. */
  isInCurrentControllerMACTable: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is an RMA (Return Merchandise Authorization) replacement device. */
  isRMA: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device has been retired. */
  isRetired: Scalars['Boolean']['output'];
  /** A spare hardware device belongs to a network but is not assigned to a virtual device. Spares are typically kept on site as replacements and are not in service. */
  isSpare: Scalars['Boolean']['output'];
  /** The latest device config metadata (ie. the config without the actual JSON payload) for the device. */
  latestDeviceConfigMetadata?: Maybe<DeviceConfigMetadata>;
  /** The MAC address of the hardware device. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** The UUID of the network that the hardware device belongs to. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** The physical interface (on a Meter Switch) that the power distribution unit is connected to, if applicable. */
  phyInterfaceConnectedTo?: Maybe<PhyInterface>;
  /** The public key used to add the device to the jumphost's WireGuard interface. */
  publicKey?: Maybe<Scalars['String']['output']>;
  /** The realm that owns this hardware device. Used for cross-realm device management. */
  realm: HardwareDeviceRealm;
  /** The unique serial number of the hardware device. */
  serialNumber: Scalars['String']['output'];
  /** The network that the hardware device belongs to. */
  spareDeviceNetwork?: Maybe<Network>;
  /** IPv6 address on the jumphost subnet. Used to send requests to the device. */
  tunnelIPAddress?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the hardware device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The uptime metrics from the time series database for the device.
   * @deprecated Use `VirtualDevice.uptime` instead.
   */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** The virtual device associated with this hardware device, if any. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The UUID of the virtual device this hardware device is assigned to, if any. */
  virtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
};


/** A cellular gateway. */
export type CellularGatewayHardwareDeviceBootHistoryArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

/** A cellular gateway virtual device is a logical representation of a physical cellular gateway. */
export type CellularGatewayVirtualDevice = Identifiable & TargetInterface & VirtualDevice & {
  __typename?: 'CellularGatewayVirtualDevice';
  /** The unique identifier (UUID) of the virtual device. */
  UUID: Scalars['UUID']['output'];
  /**
   * The state of the gateway's cellular modem from its most recent report within the last hour, or
   * null if it has not reported one in that time.
   */
  cellularInfo?: Maybe<GatewayCellularInfo>;
  /**
   * The devices currently connected to the gateway's downlink ports, from the
   * gateway's most recently reported connected-clients snapshot.
   */
  connectedClients: Array<GatewayConnectedClient>;
  /** The timestamp when the virtual device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Hologram's usage for the SIM's open 30-day billing period. Null if the gateway has not reported
   * its SIM in the last hour or Hologram has no record for it.
   */
  currentUsagePeriod?: Maybe<SimUsagePeriod>;
  /** An optional description for the virtual device. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Metadata for the configurations rendered for this virtual device over time, newest
   * first. Includes configs written to hardware devices that have since been dissociated
   * from this virtual device. Omits the rendered config JSON for performance.
   */
  deviceConfigs: Array<DeviceConfigMetadata>;
  /** The model name of the virtual device. */
  deviceModel: DeviceModel;
  /** The type of the virtual device. */
  deviceType: VirtualDeviceType;
  /**
   * The gateway profile associated with the gateway.
   * Null for gateway devices created before gateway profiles were introduced.
   */
  gatewayProfile?: Maybe<GatewayProfile>;
  /**
   * The unique identifier of the gateway profile associated with the gateway.
   * Null for gateway devices created before gateway profiles were introduced.
   */
  gatewayProfileUUID?: Maybe<Scalars['UUID']['output']>;
  /** The hardware device associated with this virtual device, if any. */
  hardwareDevice?: Maybe<HardwareDevice>;
  /** Metadata for the model of this device. */
  hardwareModelProperties: HardwareModelProperties;
  /** International mobile equipment identity (IMEI) of the device. */
  imei?: Maybe<Scalars['String']['output']>;
  /** The management IP address of the device. */
  ipAddress?: Maybe<Scalars['IP']['output']>;
  /** Indicates whether the virtual device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether debug logging is enabled on the virtual device. */
  isDebugLogEnabled: Scalars['Boolean']['output'];
  /** Whether this virtual device is in a draft state for preconfiguration reasons. */
  isDraft: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is online, indicated by its heartbeat. */
  isOnline: Scalars['Boolean']['output'];
  /** A human-friendly name for the device. */
  label: Scalars['String']['output'];
  /** The physical location of this virtual device, derived from its rack elevation placement. */
  location?: Maybe<VirtualDeviceLocation>;
  /** The most recent NOS upgrade for this virtual device that has started executing or was skipped (in progress, completed, failed, or skipped), if any. */
  mostRecentNOSUpgrade?: Maybe<ScheduledDeviceNosUpgrade>;
  /** The network that the virtual device belongs to. */
  network: Network;
  /** The unique identifier (UUID) of the network the virtual device belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The group that the device belongs to for firmware upgrade grouping purposes. */
  nosUpgradeGroup: NosUpgradeGroup;
  /** The current NOS firmware version that the virtual device is configured to run. */
  nosVersion?: Maybe<ConfiguredNosVersion>;
  /** The identifier of the NOS firmware version that the virtual device is configured to run. */
  nosVersionID: Scalars['Int']['output'];
  /** The cellular gateway's active or future notification snoozes */
  notificationSnoozes: Array<DeviceNotificationSnooze>;
  /** The paired virtual device to this device, applicable to dual-chassis configurations. */
  pairedVirtualDevice?: Maybe<CellularGatewayVirtualDevice>;
  /** The NOS firmware version that the virtual device is scheduled to upgrade to. */
  pendingNosVersion?: Maybe<PendingNosVersion>;
  /** DHCP rules configured on the physical interfaces of this gateway virtual device. */
  phyInterfaceDHCPRules: Array<PhyInterfaceDhcpRule>;
  /** The physical interfaces associated with the gateway. */
  phyInterfaces: Array<PhyInterface>;
  /** URL to the regulatory e-label for the device, if applicable. */
  regulatoryLabelURL?: Maybe<Scalars['String']['output']>;
  /** The virtual device tags on this device. */
  tags: Array<VirtualDeviceTag>;
  /** Data about this virtual device's position in its network's topology. */
  topologyData?: Maybe<VirtualDeviceTopologyData>;
  /** The timestamp when the virtual device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /** How long the device has been continuously powered on and reporting. */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /**
   * Hologram's billed usage for the SIM's closed 30-day billing periods, newest first. Empty if the
   * gateway has not reported its SIM in the last hour. A period with no usage has no entry.
   */
  usagePeriodHistory: Array<SimUsagePeriod>;
  /** The position of this virtual device within its device pair (left or right). Null if not part of a pair. */
  virtualDevicePairPosition?: Maybe<DevicePosition>;
};


/** A cellular gateway virtual device is a logical representation of a physical cellular gateway. */
export type CellularGatewayVirtualDeviceConnectedClientsArgs = {
  classifications?: InputMaybe<Array<GatewayConnectedClientClassification>>;
};


/** A cellular gateway virtual device is a logical representation of a physical cellular gateway. */
export type CellularGatewayVirtualDeviceDeviceConfigsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


/** A cellular gateway virtual device is a logical representation of a physical cellular gateway. */
export type CellularGatewayVirtualDeviceUsagePeriodHistoryArgs = {
  filter?: InputMaybe<DateTimeRangeInput>;
};

/** Enumeration of possible states for the cellular modem as managed by the device manager. */
export enum CellularManagerModemState {
  /** The modem is attached to the network. */
  Attached = 'ATTACHED',
  /** The modem is detached from the network. */
  Detached = 'DETACHED',
  /** The state of the modem is unspecified or unknown. */
  Unspecified = 'UNSPECIFIED'
}

/** Represents the current cellular status of a device, including the modem state and the time this status was observed. */
export type CellularStatus = {
  __typename?: 'CellularStatus';
  /** The state of the device's cellular modem as managed by the device manager. */
  managerModemState: CellularManagerModemState;
  /** The timestamp when this status was last observed. */
  observedAt: Scalars['DateTime']['output'];
};

/** A cellular switch. */
export type CellularSwitchHardwareDevice = HardwareDevice & {
  __typename?: 'CellularSwitchHardwareDevice';
  /** The batch identifier of the hardware device, if any. */
  batch?: Maybe<Scalars['String']['output']>;
  /** Shows the most recent boot history of a device. */
  bootHistory: Array<BootInfo>;
  /** The active config override for this device, if any. */
  configOverride?: Maybe<DeviceConfigOverride>;
  /** The timestamp when the hardware device was first created. */
  createdAt: Scalars['DateTime']['output'];
  /** The model name of the hardware device. */
  deviceModel: DeviceModel;
  /** The type of the hardware device. */
  deviceType: DeviceType;
  /** If the device is no longer connected to the backend, this is the time at which it was last connected. */
  disconnectedFromBackendAt?: Maybe<Scalars['DateTime']['output']>;
  /** The hardware generation of the device. */
  hardwareGeneration: HardwareGeneration;
  /** Metadata for the model of this device. */
  hardwareModelProperties: HardwareModelProperties;
  /** Internal operator-only notes about this hardware device. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /**
   * True if the device has an active websocket connection to the backend. Note that this only works if the device has registered via the /v2/register endpoint (i.e., is a Config 2 device) - otherwise is always false.
   * @deprecated Use `isSpare` instead.
   */
  isActive: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is connected to the backend. */
  isConnectedToBackend: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /**
   * Indicates whether the hardware device is marked as a development (dev) device, moving it into the dev (staging) realm for testing purposes.
   * @deprecated Use `realm` instead. isDev is equivalent to realm == DEV.
   */
  isDev: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is in factory mode. */
  isFactoryMode: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is an RMA (Return Merchandise Authorization) replacement device. */
  isRMA: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device has been retired. */
  isRetired: Scalars['Boolean']['output'];
  /** A spare hardware device belongs to a network but is not assigned to a virtual device. Spares are typically kept on site as replacements and are not in service. */
  isSpare: Scalars['Boolean']['output'];
  /** The latest device config metadata (ie. the config without the actual JSON payload) for the device. */
  latestDeviceConfigMetadata?: Maybe<DeviceConfigMetadata>;
  /** The MAC address of the hardware device. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** The UUID of the network that the hardware device belongs to. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** The public key used to add the device to the jumphost's WireGuard interface. */
  publicKey?: Maybe<Scalars['String']['output']>;
  /** The realm that owns this hardware device. Used for cross-realm device management. */
  realm: HardwareDeviceRealm;
  /** The unique serial number of the hardware device. */
  serialNumber: Scalars['String']['output'];
  /** The network that the spare hardware device belongs to. Spare hardware devices that are not affiliated with a virtual device will have this field populated. */
  spareDeviceNetwork?: Maybe<Network>;
  /** IPv6 address on the jumphost subnet. Used to send requests to the device. */
  tunnelIPAddress?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the hardware device was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The uptime of the hardware device, retrieved from the time series database.
   * @deprecated Use `VirtualDevice.uptime` instead.
   */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** The virtual device associated with this hardware device, if any. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The UUID of the virtual device this hardware device is assigned to, if any. */
  virtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
};


/** A cellular switch. */
export type CellularSwitchHardwareDeviceBootHistoryArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

/** A cellular switch virtual device is a logical representation of a physical cellular switch. */
export type CellularSwitchVirtualDevice = TargetInterface & VirtualDevice & {
  __typename?: 'CellularSwitchVirtualDevice';
  /** The unique identifier (UUID) of the virtual device. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the virtual device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** An optional description for the virtual device. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Metadata for the configurations rendered by this virtual device over time, newest
   * first. Includes configs written to hardware devices that have since been dissociated
   * from this virtual device. No history is available before June 2026.
   */
  deviceConfigs: Array<DeviceConfigMetadata>;
  /** The model name of the virtual device. */
  deviceModel: DeviceModel;
  /** The type of the virtual device. */
  deviceType: VirtualDeviceType;
  /** The hardware device associated with this virtual device, if any. */
  hardwareDevice?: Maybe<HardwareDevice>;
  /** Metadata for the model of this device. */
  hardwareModelProperties: HardwareModelProperties;
  /** Installer label for devices. Only supported on [CellularAccessPoint, CellularSwitches, CarrierAppliance] */
  installerLabel: Scalars['String']['output'];
  /** The management IP address of the device. Note that this is not yet populated for cellular switch devices. */
  ipAddress?: Maybe<Scalars['IP']['output']>;
  /** Indicates whether the virtual device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether debug logging is enabled on the virtual device. */
  isDebugLogEnabled: Scalars['Boolean']['output'];
  /** Whether this virtual device is in a draft state for preconfiguration reasons. */
  isDraft: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is online, indicated by its heartbeat. */
  isOnline: Scalars['Boolean']['output'];
  /** A human-friendly name for the device. */
  label: Scalars['String']['output'];
  /** The physical location of this virtual device, derived from its rack elevation placement. */
  location?: Maybe<VirtualDeviceLocation>;
  /** The most recent NOS upgrade for this virtual device that has started executing or was skipped (in progress, completed, failed, or skipped), if any. */
  mostRecentNOSUpgrade?: Maybe<ScheduledDeviceNosUpgrade>;
  /** The network that the virtual device belongs to. */
  network: Network;
  /** The unique identifier (UUID) of the network the virtual device belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /**
   * The group that the device belongs to for firmware upgrade grouping purposes.
   * Note: This is nullable in the schema but all devices now have a NOS upgrade group.
   */
  nosUpgradeGroup: NosUpgradeGroup;
  /** The current NOS firmware version that the virtual device is configured to run. */
  nosVersion?: Maybe<ConfiguredNosVersion>;
  /** The identifier of the NOS firmware version that the virtual device is configured to run. */
  nosVersionID: Scalars['Int']['output'];
  /** The carrier appliance's active or future notification snoozes */
  notificationSnoozes: Array<DeviceNotificationSnooze>;
  /** The paired virtual device to this device, applicable to dual-chassis configurations. */
  pairedVirtualDevice?: Maybe<VirtualDevice>;
  /** The NOS firmware version that the virtual device is scheduled to upgrade to. */
  pendingNosVersion?: Maybe<PendingNosVersion>;
  /** URL to the regulatory e-label for the device, if applicable. */
  regulatoryLabelURL?: Maybe<Scalars['String']['output']>;
  /** The virtual device tags on this device. */
  tags: Array<VirtualDeviceTag>;
  /** Data about this virtual device's position in its network's topology. */
  topologyData?: Maybe<VirtualDeviceTopologyData>;
  /** The timestamp when the virtual device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /** How long the device has been continuously powered on and reporting. */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** For dual-chassis devices, the "position" of this virtual device within its device pair (left or right). When hardware is assigned, this virtual device will receive hardware with a matching position. Null if not part of a pair. */
  virtualDevicePairPosition?: Maybe<DevicePosition>;
};


/** A cellular switch virtual device is a logical representation of a physical cellular switch. */
export type CellularSwitchVirtualDeviceDeviceConfigsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};

/** Represents the cellular data usage of a device, including uploaded and downloaded bytes. */
export type CellularUsage = {
  __typename?: 'CellularUsage';
  /** Number of bytes downloaded by the device over the cellular network. */
  downloadBytes?: Maybe<Scalars['Int']['output']>;
  /** Number of bytes uploaded by the device over the cellular network. */
  uploadBytes?: Maybe<Scalars['Int']['output']>;
};

/** Regulatory certification status for a device model in a country. */
export enum CertificationStatus {
  /** Meter has attained certification; the device may be deployed. */
  Certified = 'CERTIFIED',
  /** No certification and very low likelihood of attaining one in the foreseeable future. */
  Embargoed = 'EMBARGOED',
  /** The device may ship but requires customs support from the importer. */
  ImporterResponsibility = 'IMPORTER_RESPONSIBILITY',
  /** Meter has not attained certification. */
  NotCertified = 'NOT_CERTIFIED',
  /** Certification is pending. */
  OnHold = 'ON_HOLD'
}

/** Response type containing timeseries of channel utilization metrics. */
export type ChannelUtilizationResponseV2 = {
  __typename?: 'ChannelUtilizationResponseV2';
  /** The radio band (e.g., 2.4 GHz, 5 GHz) for which the data is provided. */
  band: RadioBand;
  /** List of timeseries values of channel utilization metrics. */
  values: Array<ApChannelUtilizationTimeseriesValue>;
  /** The unique identifier of the virtual device (AP) from which the data originates. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

export type ChannelUtilizationTimeseriesFilterInput = {
  /** Specify the time range for the timeseries data. */
  timeFilter: MetricsFilterInput;
};

/** An enumeration of channel widths. */
export enum ChannelWidth {
  /** Represents a 20 MHz channel width. */
  ChannelWidth_20MHz = 'CHANNEL_WIDTH_20MHz',
  /** Represents a 40 MHz channel width. */
  ChannelWidth_40MHz = 'CHANNEL_WIDTH_40MHz',
  /** Represents a 80 MHz channel width. */
  ChannelWidth_80MHz = 'CHANNEL_WIDTH_80MHz',
  /** Represents a 160 MHz channel width. */
  ChannelWidth_160MHz = 'CHANNEL_WIDTH_160MHz'
}

/** Input type for checking if the current user has a specific role in a given context. */
export type CheckRoleInput = {
  /**
   * The slug (unique identifier) of the company to check the role against.
   *
   * If the role is global or operator-level, this can be omitted.
   */
  companySlug?: InputMaybe<Scalars['String']['input']>;
  /**
   * The UUID of the network to check the role against.
   *
   * Provide this if checking for a network-specific role.
   */
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The name of the role to check for. */
  roleName: RoleName;
};

/**
 * Pair record data transferred during cross-realm claiming.
 * Uses scalar fields only to avoid resolver/dataloader issues after device deletion.
 */
export type ClaimHardwareDevicePairRecord = {
  __typename?: 'ClaimHardwareDevicePairRecord';
  /** When the pair record was originally created. */
  createdAt: Scalars['DateTime']['output'];
  /** The type of devices in the pair. */
  deviceType: DeviceType;
  /** Whether the left device has the lexicographically lower serial number. */
  isLeftDeviceLower: Scalars['Boolean']['output'];
  /** Serial number of the left device in the pair. */
  leftDeviceSerial: Scalars['String']['output'];
  /** Serial number of the right device in the pair. */
  rightDeviceSerial: Scalars['String']['output'];
};

/** Result of claiming a hardware device for a realm. */
export type ClaimHardwareDeviceResult = {
  __typename?: 'ClaimHardwareDeviceResult';
  /** If successful, the claimed hardware device. */
  device?: Maybe<HardwareDevice>;
  /** If the device is paired, the pair record data. */
  pairRecord?: Maybe<ClaimHardwareDevicePairRecord>;
  /** If the device is paired, the complement hardware device. */
  pairedDevice?: Maybe<HardwareDevice>;
  /** If the claim failed, the reason why. */
  reason?: Maybe<Scalars['String']['output']>;
  /** Whether the claim was successful. */
  success: Scalars['Boolean']['output'];
};

/** The usage of a single client for a given application. */
export type ClientApplicationUsage = {
  __typename?: 'ClientApplicationUsage';
  /** The MAC address of the client. */
  macAddress: Scalars['MacAddress']['output'];
  /** The connected network client, if this client is also in the regular clients list. */
  networkClient?: Maybe<NetworkClient>;
  /** The total rx bytes as specified by filter. */
  rxBytes: Scalars['Int']['output'];
  /** The total rx packets as specified by filter. */
  rxPackets: Scalars['Int']['output'];
  /** The total tx bytes as specified by filter. */
  txBytes: Scalars['Int']['output'];
  /** The total tx packets as specified by filter. */
  txPackets: Scalars['Int']['output'];
};

/** ClientAssignmentProtocol defines the method used to assign IP addresses to clients. */
export enum ClientAssignmentProtocol {
  /** DHCP protocol assigns IP addresses dynamically to clients. */
  Dhcp = 'DHCP',
  /** Static protocol assigns fixed IP addresses to clients. */
  Static = 'STATIC'
}

/** Represents a single data point of channel utilization metrics for a client. */
export type ClientChannelUtilizationTimeseriesValue = {
  __typename?: 'ClientChannelUtilizationTimeseriesValue';
  /** The amount of utilization contributed by non-802.11 interference in the environment, e.g., Bluetooth, cameras (from 0 to 1). */
  non80211Utilization: Scalars['Float']['output'];
  /** The amount of utilization due to 802.11 interference by neighboring networks (from 0 to 1). */
  obssUtilization: Scalars['Float']['output'];
  /** The percentage of time the channel was utilized due to receptions from clients (from 0 to 1). */
  rxUtilization: Scalars['Float']['output'];
  /** The percentage of time the channel was utilized by the AP itself (from 0 to 1). */
  selfUtilization: Scalars['Float']['output'];
  /** The timestamp of the metric data point. */
  timestamp: Scalars['DateTime']['output'];
  /** The percentage of time the channel was utilized (from 0 to 1). */
  totalUtilization: Scalars['Float']['output'];
  /** The percentage of time the channel was utilized due to transmissions from the AP (from 0 to 1). */
  txUtilization: Scalars['Float']['output'];
};

/** Aggregated values (like min/max) over the given time range for all of the client metrics requested. */
export type ClientMetricsMetadata = {
  __typename?: 'ClientMetricsMetadata';
  /** Aggregated metadata for the association time in seconds. */
  associationTimeSeconds?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the client count. */
  clientCount?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the hardware mode of the client device. */
  hwMode?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the noise level in dBm. */
  noise?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the number of receive spatial streams. */
  numSpatialStreamsRx?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the number of transmit spatial streams. */
  numSpatialStreamsTx?: Maybe<MetricsMetadata>;
  /**
   * Deprecated. Prefer `rxBytes` instead.
   * @deprecated Use `rxBytes` instead.
   */
  rx?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the total bytes received. */
  rxBytes?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the multicast bytes received. */
  rxMulticastBytes?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the receive rate in kilobits per second. */
  rxRate?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the unicast bytes received. */
  rxUnicastBytes?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the signal strength in dBm. */
  signal?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the signal-to-noise ratio in dB. */
  snr?: Maybe<MetricsMetadata>;
  /**
   * Deprecated. Prefer `txBytes` instead.
   * @deprecated Use `txBytes` instead.
   */
  tx?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the total bytes transmitted. */
  txBytes?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the multicast bytes transmitted. */
  txMulticastBytes?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the transmit rate in kilobits per second. */
  txRate?: Maybe<MetricsMetadata>;
  /** Aggregated metadata for the unicast bytes transmitted. */
  txUnicastBytes?: Maybe<MetricsMetadata>;
};

/** Deprecated in favor of `ClientMetricsTimeseriesResponse`. */
export type ClientMetricsResponse = {
  __typename?: 'ClientMetricsResponse';
  /** Aggregated metadata for the client metrics over the specified time range. */
  metadata?: Maybe<ClientMetricsMetadata>;
  /** A list of client metric values. */
  values: Array<ClientMetricsValue>;
};

/** Input type for specifying filters when querying client metrics timeseries data. */
export type ClientMetricsTimeseriesFilterInput = {
  /** Specifying this field returns only metrics observed for the given radio band(s). */
  bands?: InputMaybe<Array<RadioBand>>;
  /** Specifying this field returns only metrics observed for the given radio channel(s). */
  channels?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter events by client MAC address. */
  clientMacAddresses?: InputMaybe<Array<Scalars['MacAddress']['input']>>;
  /** Filter events by event type. */
  eventType?: InputMaybe<WirelessClientConnectionEventType>;
  /** Filter events by event type(s). */
  eventTypes?: InputMaybe<Array<WirelessClientConnectionEventType>>;
  /** Exclude events from the given client MAC addresses. */
  excludeClientMacAddresses?: InputMaybe<Array<Scalars['MacAddress']['input']>>;
  /** If true, exclude events from Observers. */
  excludeObservers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter events whose 802.1X identity contains the given string (case-insensitive). */
  identity8021X?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter events by whether they are NAC events. `true` returns only NAC
   * events, `false` returns only non-NAC events, and omitting the field returns
   * both.
   */
  isNACEvent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter events by partial client MAC address. */
  partialClientMacAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter events by 802.11 reason code(s). */
  reasonCodes?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter events by RSSI. */
  rssi?: InputMaybe<NumberRangeInput>;
  /** Specifying this field returns only metrics observed for the given SSID(s), by UUID. */
  ssidUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Specify the time range for the timeseries data. */
  timeFilter: MetricsFilterInput;
  /** Filter events by virtual device. */
  virtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Response type containing client metrics timeseries data over a specified time range. */
export type ClientMetricsTimeseriesResponse = {
  __typename?: 'ClientMetricsTimeseriesResponse';
  /** Aggregated metadata for the client metrics timeseries. */
  metadata?: Maybe<ClientMetricsMetadata>;
  /** A list of client metrics timeseries values. */
  values: Array<ClientMetricsTimeseriesValue>;
};

/**
 * Time-series data for client connectivity metrics.
 * If requested at a per-AP level, the results will be aggregated over all clients connected to the AP.
 */
export type ClientMetricsTimeseriesValue = {
  __typename?: 'ClientMetricsTimeseriesValue';
  /**
   * Number of seconds that the client has been associated with an AP for.
   * @deprecated This isn't really timeseries data and a timestamp is more useful; refer to WirelessClient.associatedAt instead.
   */
  associationTimeSeconds?: Maybe<Scalars['Float']['output']>;
  /** The count of distinct clients (by MAC address) that connected to the AP during the time period. */
  clientCount: Scalars['Int']['output'];
  /** The Wi-Fi capabilities of the client device. */
  hwMode?: Maybe<Scalars['String']['output']>;
  /** Noise level in dBm. */
  noise: Scalars['Float']['output'];
  /** The number of receive spatial streams. */
  numSpatialStreamsRx?: Maybe<Scalars['Int']['output']>;
  /** The number of transmit spatial streams. */
  numSpatialStreamsTx?: Maybe<Scalars['Int']['output']>;
  /** Total number of bytes received in the given time period. */
  rxBytes: Scalars['Float']['output'];
  /** Total number of multicast bytes received in the given time period; a subset of `rxBytes`. */
  rxMulticastBytes: Scalars['Float']['output'];
  /** The rate at which the client is receiving data in kilobits per second. */
  rxRate: Scalars['Float']['output'];
  /** The ratio of the number of times a packet was retried to the total number of successful packets. Null if no packets succeeded. */
  rxRetryRatio?: Maybe<Scalars['Float']['output']>;
  /**
   * Deprecated. It's unreliable to determine this client stat from the AP's perspective.
   * @deprecated It's unreliable to determine this client stat from the AP's perspective.
   */
  rxSuccessRatio?: Maybe<Scalars['Float']['output']>;
  /** Total number of unicast bytes received in the given time period; a subset of `rxBytes`. */
  rxUnicastBytes: Scalars['Float']['output'];
  /** Received signal strength in dBm. */
  signal: Scalars['Float']['output'];
  /** Signal-to-noise ratio in dB, calculated as `signal - noise`. A higher value is better. */
  snr: Scalars['Float']['output'];
  /** The timestamp of the metric data point. */
  timestamp: Scalars['DateTime']['output'];
  /** Total number of bytes transmitted in the given time period. */
  txBytes: Scalars['Float']['output'];
  /** Total number of multicast bytes transmitted in the given time period; a subset of `txBytes`. */
  txMulticastBytes: Scalars['Float']['output'];
  /** The rate at which the client is transmitting data in kilobits per second. */
  txRate: Scalars['Float']['output'];
  /** The ratio of the number of times the client retried a packet transmission to the number of packets successfully transmitted. Null if no packets were transmitted. */
  txRetryRatio?: Maybe<Scalars['Float']['output']>;
  /** The ratio of the number of times the client successfully received a packet to the number of packets transmitted. Null if no packets were transmitted. */
  txSuccessRatio?: Maybe<Scalars['Float']['output']>;
  /** Total number of unicast bytes transmitted in the given time period; a subset of `txBytes`. */
  txUnicastBytes: Scalars['Float']['output'];
  /** Number of ARPs sent by the client that received no response, summed over the time period. Elevated values suggest an upstream gateway or VLAN reachability problem. */
  unrespondedArpsFromClient: Scalars['Float']['output'];
  /** Number of ARPs sent to the client that received no response, summed over the time period. Elevated values suggest the client dropped off the network or became unreachable. */
  unrespondedArpsToClient: Scalars['Float']['output'];
};

/** Deprecated in favor of `ClientMetricsTimeseriesValue`. */
export type ClientMetricsValue = {
  __typename?: 'ClientMetricsValue';
  /** The MAC address of the client device. */
  macAddress: Scalars['MacAddress']['output'];
  /** Noise level in dBm. */
  noise: Scalars['Float']['output'];
  /** The receive rate from the client in kilobits per second. */
  rxRate: Scalars['Float']['output'];
  /** Received signal strength in dBm. */
  signal: Scalars['Float']['output'];
  /** Signal-to-noise ratio, in dB. Literally `signal - noise`. */
  signalToNoiseRatio: Scalars['Float']['output'];
  /** The timestamp of the metric data point. */
  timestamp: Scalars['DateTime']['output'];
  /** The transmit rate to the client in kilobits per second. */
  txRate: Scalars['Float']['output'];
};

/** Input type for filtering client observer tests when querying for tests associated with a specific network and client device. */
export type ClientObserverFilter = {
  /** The latest observation time to consider tests for, inclusive. Defaults to the current time if not set. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The maximum number of results to return, between 1 and 1000. Defaults to 100 if not set. */
  limit?: Scalars['Int']['input'];
  /** The lookback time to consider tests for, starting at `endTime`. Maximum allowed value is 7776000, 90 days. */
  lookbackSeconds: Scalars['Int']['input'];
  /** The MAC address of the client device to fetch tests for. If omitted, will include all client devices. */
  macAddress?: InputMaybe<Scalars['MacAddress']['input']>;
  /** The number of results to skip before returning results. Defaults to 0 if not set. */
  offset?: Scalars['Int']['input'];
  /** The list of test types to return. */
  types?: InputMaybe<Array<ClientObserverTestType>>;
};

/** Round trip timings measured by a ping test. */
export type ClientObserverPingData = {
  __typename?: 'ClientObserverPingData';
  /** The longest round trip time among all attempts. */
  maxDuration?: Maybe<Scalars['Duration']['output']>;
  /** The shortest round trip time among all attempts. */
  minDuration?: Maybe<Scalars['Duration']['output']>;
  /** 95% of attempts had a round trip time at or below this value. */
  p95Latency?: Maybe<Scalars['Duration']['output']>;
  /** 99% of attempts had a round trip time at or below this value. */
  p99Latency?: Maybe<Scalars['Duration']['output']>;
  /** The total round trip time across all attempts. */
  totalDuration?: Maybe<Scalars['Duration']['output']>;
};

/** Represents a target for client observer tests, identified by its SSID and BSSID. */
export type ClientObserverTarget = {
  __typename?: 'ClientObserverTarget';
  /** The target BSSID to connect to. */
  bssid: Scalars['String']['output'];
  /** The target SSID to connect to. */
  ssid: Scalars['String']['output'];
};

/** Represents a test performed by a client observer, including its type and results. */
export type ClientObserverTest = {
  __typename?: 'ClientObserverTest';
  /** UUID of the client device that ran the client observer test. */
  clientDeviceUUID: Scalars['UUID']['output'];
  /** Time when the test results were inserted into the database. */
  insertedAt: Scalars['DateTime']['output'];
  /** The network associated with the client observer test. */
  network: Network;
  /** The network client that ran the test, matched on MAC address. Null when the test carries no MAC address or the client is no longer on the network. */
  networkClient?: Maybe<NetworkClient>;
  /** UUID of the network associated with the client observer test. */
  networkUUID: Scalars['UUID']['output'];
  /** Time when the test was performed. */
  observedAt: Scalars['DateTime']['output'];
  /** Results of the client observer test. */
  testResult: ClientObserverTestResult;
  /** The type of test performed. */
  testType: ClientObserverTestType;
};

/**
 * Results that only make sense for one kind of client observer test. Each test
 * type contributes one member.
 */
export type ClientObserverTestData = ClientObserverPingData;

/** Represents the results of a client observer test, which may include various metrics depending on the test type. */
export type ClientObserverTestResult = {
  __typename?: 'ClientObserverTestResult';
  /** The accuracy in meters of the test location */
  accuracyMeters?: Maybe<Scalars['Float']['output']>;
  /** Results specific to the type of test that was run. */
  data?: Maybe<ClientObserverTestData>;
  /** The device model of the client device that ran the test. */
  deviceModel: Scalars['String']['output'];
  /** The IP address of the client device that ran the test. */
  ipAddress: Scalars['IP']['output'];
  /** The latitude coordinate of the test location */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The longitude coordinate of the test location */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The MAC address of the client device that ran the test. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /**
   * The maximum duration in milliseconds among all attempts during the client observer test.
   * @deprecated Use `data` on `ClientObserverPingData` instead.
   */
  maxDurationMsec?: Maybe<Scalars['Duration']['output']>;
  /**
   * The minimum duration in milliseconds among all attempts during the client observer test.
   * @deprecated Use `data` on `ClientObserverPingData` instead.
   */
  minDurationMsec?: Maybe<Scalars['Duration']['output']>;
  /** The number of attempts made during the client observer test. */
  numAttempts: Scalars['Int']['output'];
  /** The number of successful attempts during the client observer test. */
  numSuccess: Scalars['Int']['output'];
  /** The OS version of the client device that ran the test. */
  osVersion: Scalars['String']['output'];
  /**
   * P95 latency in milliseconds for the client observer test, meaning 95% of attempts had latency less than or equal to this value.
   * @deprecated Use `data` on `ClientObserverPingData` instead.
   */
  p95LatencyMsec?: Maybe<Scalars['Duration']['output']>;
  /**
   * P99 latency in milliseconds for the client observer test, meaning 99% of attempts had latency less than or equal to this value.
   * @deprecated Use `data` on `ClientObserverPingData` instead.
   */
  p99LatencyMsec?: Maybe<Scalars['Duration']['output']>;
  /** The rssi is the signal strength (in dBm) between the client and the AP. */
  rssi: Scalars['Int']['output'];
  /** The target of the client observer test, which may be an IP address, hostname, or other identifier depending on the test type. */
  testTarget: ClientObserverTestTarget;
  /** The type of test performed. */
  testType: ClientObserverTestType;
  /**
   * The total duration in milliseconds for all attempts during the client observer test.
   * @deprecated Use `data` on `ClientObserverPingData` instead.
   */
  totalDurationMsec?: Maybe<Scalars['Duration']['output']>;
};

/** Represents a target for client observer tests, which may be an IP address, hostname, or other identifier depending on the test type. */
export type ClientObserverTestTarget = {
  __typename?: 'ClientObserverTestTarget';
  /** The target value for the client observer test of the type specified by targetType. */
  target: Scalars['String']['output'];
  /** The type of target for the client observer test, such as an IP address or hostname. */
  targetType: ClientObserverTestTargetType;
};

/** Input type for specifying the target of a client observer test when uploading test results. */
export type ClientObserverTestTargetInput = {
  /** The target value for the client observer test of the type specified by targetType. */
  target: Scalars['String']['input'];
  /** The type of target for the client observer test, such as an IP address or hostname. */
  targetType: ClientObserverTestTargetType;
};

/** Types of targets that can be used for client observer tests. */
export enum ClientObserverTestTargetType {
  /** Target of the test is a hostname. */
  Hostname = 'HOSTNAME',
  /** Target of the test is an IPv4 address. */
  Ipv4 = 'IPV4',
  /** Target of the test is an IPv6 address. */
  Ipv6 = 'IPV6',
  /** Unspecified target type. */
  Unspecified = 'UNSPECIFIED'
}

/** Types of tests that can be performed by client observers. */
export enum ClientObserverTestType {
  /** Ping test to measure latency. */
  Ping = 'PING',
  /** Unspecified test type. */
  Unspecified = 'UNSPECIFIED'
}

/** Represents the result of pinging a single client during a client ping sweep job. */
export type ClientPingResult = {
  __typename?: 'ClientPingResult';
  /** The hostname the client gave DHCP, as recorded when the sweep ran, if present. */
  clientName?: Maybe<Scalars['String']['output']>;
  /** Error message, if the ping could not be performed for this client. */
  error?: Maybe<Scalars['String']['output']>;
  /** The IP address that was pinged. */
  ip: Scalars['IP']['output'];
  /** The MAC address of the client. */
  macAddress: Scalars['MacAddress']['output'];
  /** Average round-trip time in milliseconds, if there were any replies. */
  roundTripTimeMs?: Maybe<Scalars['Float']['output']>;
  /** Replies received divided by echoes sent (0.0 - 1.0); the client is reachable if > 0. */
  successRate: Scalars['Float']['output'];
  /** The access point the client was connected to. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The unique identifier of the virtual device of the access point the client was connected to. */
  virtualDeviceUUID: Scalars['UUID']['output'];
  /** The VLAN matching vlanID, if the network still has one configured with that number. */
  vlan?: Maybe<Vlan>;
  /** The VLAN the device pinged the client on, if it reported one. */
  vlanID?: Maybe<Scalars['Int']['output']>;
};

/** Represents one device the sweep ran on. */
export type ClientPingSweepDevice = {
  __typename?: 'ClientPingSweepDevice';
  /** Why the sweep could not run on this device. */
  error?: Maybe<Scalars['String']['output']>;
  /** The device that was asked to sweep. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The unique identifier of the device's virtual device. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/**
 * Represents a client ping sweep job for a network. Pings the clients selected by
 * the job's input and reports reachability for each one.
 */
export type ClientPingSweepJob = NetworkJob & {
  __typename?: 'ClientPingSweepJob';
  /** The unique identifier for the job. */
  UUID: Scalars['UUID']['output'];
  /** The time at which the job was completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The devices that ran this sweep. */
  devices: Array<ClientPingSweepDevice>;
  /** The unique identifier of the network associated with this job. */
  networkUUID: Scalars['UUID']['output'];
  /** Number of ICMP echoes each client was sent, as requested when the job started. */
  pingsPerClient: Scalars['Int']['output'];
  /** Per-client ping results. */
  results: Array<ClientPingResult>;
  /** The time at which the job was scheduled. */
  scheduledAt: Scalars['DateTime']['output'];
  /** The SSIDs the sweep targeted, named as they were when it started. */
  ssids: Array<ClientPingSweepSsid>;
  /** The current status of the sweep. */
  status: NetworkJobStatus;
  /** How long a device spent on one client, as requested when the job started. */
  timeoutSeconds: Scalars['Int']['output'];
};

/**
 * Represents a client ping sweep job without its per-client results. Fetch
 * clientPingSweepJob for one sweep's results and the devices that ran it.
 */
export type ClientPingSweepJobMetadata = NetworkJob & {
  __typename?: 'ClientPingSweepJobMetadata';
  /** The unique identifier for the job. */
  UUID: Scalars['UUID']['output'];
  /** The time at which the job was completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier of the network associated with this job. */
  networkUUID: Scalars['UUID']['output'];
  /** Number of ICMP echoes each client was sent, as requested when the job started. */
  pingsPerClient: Scalars['Int']['output'];
  /** The time at which the job was scheduled. */
  scheduledAt: Scalars['DateTime']['output'];
  /** The SSIDs the sweep targeted, named as they were when it started. */
  ssids: Array<ClientPingSweepSsid>;
  /** The current status of the sweep. */
  status: NetworkJobStatus;
  /** How long a device spent on one client, as requested when the job started. */
  timeoutSeconds: Scalars['Int']['output'];
};

/** Represents a page of a network's client ping sweep jobs. */
export type ClientPingSweepJobPage = {
  __typename?: 'ClientPingSweepJobPage';
  /** The page the items were taken from. */
  currentPage: Scalars['Int']['output'];
  /** The jobs in this page. */
  items: Array<ClientPingSweepJobMetadata>;
  /** The total number of jobs across all pages. */
  totalCount: Scalars['Int']['output'];
  /** The total number of pages. */
  totalPages: Scalars['Int']['output'];
};

/** Input for fetching a page of a network's client ping sweep jobs. */
export type ClientPingSweepJobsInput = {
  /** Filters to apply when fetching the page. */
  filters: Array<FilterInput>;
  /** Page of jobs to return. */
  page: PageInput;
};

/**
 * An SSID a client ping sweep targeted. The name is the one the SSID had when the
 * sweep started.
 */
export type ClientPingSweepSsid = {
  __typename?: 'ClientPingSweepSSID';
  /** The unique identifier of the SSID. */
  UUID: Scalars['UUID']['output'];
  /** The SSID's name when the sweep started. */
  name: Scalars['String']['output'];
};

/** A single device on the path from a network client up to the controller. */
export type ClientTopologyHop = {
  __typename?: 'ClientTopologyHop';
  /** The port on this device facing the next hop down, toward the client. */
  downstreamPhyInterface?: Maybe<PhyInterface>;
  /** Distance from the client where hop 0 is the first devices its connected to (AP for wireless, switch for wired) */
  hop: Scalars['Int']['output'];
  /** The port on this device facing the next hop up, toward the controller. */
  uplinkPhyInterface?: Maybe<PhyInterface>;
  /** The device at this hop. */
  virtualDevice: VirtualDevice;
  /** The UUID of the device at this hop. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** A Client VPN client is an end user configuration for connecting to a Client VPN server. */
export type ClientVpnClient = Identifiable & {
  __typename?: 'ClientVPNClient';
  /** Unique identifier for the Client VPN client. */
  UUID: Scalars['UUID']['output'];
  /** The latest connection info a device reported about this client. */
  connectionInfo?: Maybe<ClientVpnClientConnectionInfo>;
  /** Timestamp when the client configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifier of the user who created the client configuration. */
  createdBy: Scalars['String']['output'];
  /** IP address assigned to the client by the VPN server. */
  ipAddress: Scalars['IP']['output'];
  /** Whether this client is currently connected to the VPN server. Determined by if a handshake has taken place in the last 150 seconds or if sent or received packets increased during the last observation window. */
  isConnected: Scalars['Boolean']['output'];
  /** Whether the client is enabled. If false, users will not be able to connect using this client's key. */
  isEnabled: Scalars['Boolean']['output'];
  /** Name of the client device (e.g., 'paulmbp'). */
  name: Scalars['String']['output'];
  /** WireGuard public key of the client. */
  publicKey: Scalars['String']['output'];
  /** Email address of the client user. */
  userEmail: Scalars['String']['output'];
  /** Unique identifier of the user associated with the client. */
  userSID: Scalars['UUID']['output'];
  /** Unique identifier of the VPN server this client connects to. */
  vpnServerUUID: Scalars['UUID']['output'];
};

/** Connection information reported by the client VPN client. */
export type ClientVpnClientConnectionInfo = {
  __typename?: 'ClientVPNClientConnectionInfo';
  /** The last time a handshake was received (from the controller's perspective). */
  lastHandshakeRx?: Maybe<Scalars['DateTime']['output']>;
  /** The last time a handshake was transmitted (from the controller's perspective). */
  lastHandshakeTx?: Maybe<Scalars['DateTime']['output']>;
  /** The last time a packet was received over the tunnel (from the controller's perspective). */
  lastPacketRx?: Maybe<Scalars['DateTime']['output']>;
  /** The last time a packet was transmitted over the tunnel (from the controller's perspective). */
  lastPacketTx?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when this connection info was observed. */
  observedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Response type containing Client VPN client timeseries data. */
export type ClientVpnClientMetricsResponse = {
  __typename?: 'ClientVPNClientMetricsResponse';
  /** Client VPN client for this series */
  clientVPNClient: ClientVpnClient;
  /** Aggregated throughput for the total bytes received in bps. */
  rxBytes: BaseMetricsResponse;
  /** Aggregated throughput for the total packets received per second. */
  rxPackets: BaseMetricsResponse;
  /** Aggregated throughput for the total bytes transmitted in bps. */
  txBytes: BaseMetricsResponse;
  /** Aggregated throughput for the total packets transmitted per second. */
  txPackets: BaseMetricsResponse;
};

/** Properties for Client VPN client connected events. */
export type ClientVpnConnectedProperties = {
  __typename?: 'ClientVPNConnectedProperties';
  /** The client that connected. */
  clientVPNClient?: Maybe<ClientVpnClient>;
  /** The server that the client connected to. */
  clientVPNServer?: Maybe<ClientVpnServer>;
  /** The time the client was observed as connected. */
  connectedAt: Scalars['DateTime']['output'];
};

/** Properties for Client VPN client disconnected events. */
export type ClientVpnDisconnectedProperties = {
  __typename?: 'ClientVPNDisconnectedProperties';
  /** The client that disconnected. */
  clientVPNClient?: Maybe<ClientVpnClient>;
  /** The server that the client disconnected from. */
  clientVPNServer?: Maybe<ClientVpnServer>;
  /** The time the client was observed as disconnected. */
  disconnectedAt: Scalars['DateTime']['output'];
};

/** A Client VPN server is a WireGuard server used on a firewall for remote connection to the device. */
export type ClientVpnServer = TargetInterface & {
  __typename?: 'ClientVPNServer';
  /** Unique identifier for the Client VPN server. */
  UUID: Scalars['UUID']['output'];
  /** IP address assigned to the WireGuard interface. */
  address?: Maybe<Scalars['IP']['output']>;
  /** Subnet mask length (CIDR notation) for the WireGuard interface address. */
  addressMask?: Maybe<Scalars['Int']['output']>;
  /** The VLANs that are accessible via connections through this client VPN server. */
  boundVLANs?: Maybe<Array<Vlan>>;
  /** The Client VPN Clients for this server. */
  clients: Array<ClientVpnClient>;
  /** Sets the default value used for the WireGuard option `AllowedIPs` for generated client configs. */
  defaultClientAllowedIPs?: Maybe<Array<Scalars['IPPrefix']['output']>>;
  /** Sets the default value used for the WireGuard option `DNS` for generated client configs. Must be IP addresses or fully qualified domain names. If set, used instead of `address` or `dnsListenAddress`. */
  defaultClientDNS?: Maybe<Array<Scalars['String']['output']>>;
  /** An additional listen address other than `address` this server serves DNS traffic on. It must be a private IP. */
  dnsListenAddress?: Maybe<Scalars['IPV4']['output']>;
  /** The endpoint clients should connect to. */
  endpoint: Scalars['String']['output'];
  /** Whether the client VPN server is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** If failover between uplink phy interfaces (WANs) should be enabled. */
  isFailoverEnabled: Scalars['Boolean']['output'];
  /** The name of this VPN server. */
  name: Scalars['String']['output'];
  /** The network to which this VPN server belongs. */
  network: Network;
  /** The unique identifier to the network to which this VPN server belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** Allows the client VPN server to be accessible over Auto VPN. */
  participatesInAutoVPN: Scalars['Boolean']['output'];
  /** The WireGuard interface will listen on this interface. If null, the server is not active. */
  phyInterface?: Maybe<PhyInterface>;
  /** Port number on which the WireGuard server listens for incoming connections. */
  port: Scalars['Int']['output'];
  /** The WireGuard public key. */
  publicKey: Scalars['String']['output'];
};

/** Response type containing Client VPN server timeseries data over a specified time range. */
export type ClientVpnServerMetricsResponse = {
  __typename?: 'ClientVPNServerMetricsResponse';
  /** Client metrics for this VPN server. */
  clientMetrics: Array<ClientVpnClientMetricsResponse>;
  /** Client VPN server. */
  clientVPNServer: ClientVpnServer;
  /** Network UUID for this series. */
  networkUUID: Scalars['UUID']['output'];
};

/**
 * A time-bucketed wireless experience score for a client.
 * Scores are the median over all samples within the bucket.
 */
export type ClientWirelessScore = {
  __typename?: 'ClientWirelessScore';
  /** The radio band at the end of the bucket (most recent sample). */
  band?: Maybe<RadioBand>;
  /** Classification derived from the median composite score. */
  classification: ClientWirelessScoreClassification;
  /** Maximum negotiated MCS index (most recent sample). */
  maxNegotiatedMcs?: Maybe<Scalars['Int']['output']>;
  /** The median composite wireless experience score (0-100). 0 indicates idle. */
  overallScore: Scalars['Int']['output'];
  /** Median performance component score (0-100). Based on MCS utilization efficiency. */
  performanceScore?: Maybe<Scalars['Int']['output']>;
  /** Median reliability component score (0-100). Based on retry and failure ratios. */
  reliabilityScore?: Maybe<Scalars['Int']['output']>;
  /** Median RF quality component score (0-100). Based on uplink SNR. */
  rfScore?: Maybe<Scalars['Int']['output']>;
  /** Total bytes received during the bucket. */
  rxBytes: Scalars['Float']['output'];
  /** Median receive MCS index. */
  rxMcs?: Maybe<Scalars['Int']['output']>;
  /** Median receive retry ratio (retries / successful packets). Null if no packets. */
  rxRetryRatio?: Maybe<Scalars['Float']['output']>;
  /** Median signal-to-noise ratio in dB. */
  snr?: Maybe<Scalars['Float']['output']>;
  /** The start of the time bucket. */
  timestamp: Scalars['DateTime']['output'];
  /** Total bytes transmitted during the bucket. */
  txBytes: Scalars['Float']['output'];
  /** Median transmit failed packet ratio (failed / total attempted). Null if no packets. */
  txFailedRatio?: Maybe<Scalars['Float']['output']>;
  /** Median transmit MCS index. */
  txMcs?: Maybe<Scalars['Int']['output']>;
  /** Median transmit retry ratio (retries / successful packets). Null if no packets. */
  txRetryRatio?: Maybe<Scalars['Float']['output']>;
  /** The AP virtual device at the end of the bucket. */
  virtualDevice?: Maybe<AccessPointVirtualDevice>;
  /** The UUID of the AP virtual device at the end of the bucket. */
  virtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
};

/** Classification of a client's wireless experience based on composite score. */
export enum ClientWirelessScoreClassification {
  /** Composite score >= 40 and < 75. */
  Fair = 'FAIR',
  /** Composite score >= 75. */
  Good = 'GOOD',
  /** Client was idle (< 10 KB traffic) during this sample. */
  Idle = 'IDLE',
  /** Composite score < 40. */
  Poor = 'POOR'
}

/** Response type for client wireless experience scores over a time range. */
export type ClientWirelessScoreResponse = {
  __typename?: 'ClientWirelessScoreResponse';
  /** The scored samples, ordered by timestamp. */
  samples: Array<ClientWirelessScore>;
};

/**
 * Aggregated wireless experience scores for a single client over a time range.
 * Scores are the p50 (median) of all active samples in the window.
 */
export type ClientWirelessScoreSummary = {
  __typename?: 'ClientWirelessScoreSummary';
  /** The number of active (non-idle) samples in the time range. */
  activeSampleCount: Scalars['Int']['output'];
  /** Classification derived from the p50 composite score. */
  classification: ClientWirelessScoreClassification;
  /** The number of idle samples in the time range. */
  idleSampleCount: Scalars['Int']['output'];
  /** The MAC address of the client. */
  macAddress: Scalars['MacAddress']['output'];
  /** The p50 composite wireless experience score (0-100). 0 indicates idle. */
  overallScore: Scalars['Int']['output'];
  /** The p50 performance component score (0-100). */
  performanceScore?: Maybe<Scalars['Int']['output']>;
  /** The p50 reliability component score (0-100). */
  reliabilityScore?: Maybe<Scalars['Int']['output']>;
  /** The p50 RF quality component score (0-100). */
  rfScore?: Maybe<Scalars['Int']['output']>;
};

/** A company is a core Meter entity used to represent customers. Networks belong to companies. */
export type Company = Identifiable & {
  __typename?: 'Company';
  /** The unique UUID identifier for the company. */
  UUID: Scalars['UUID']['output'];
  /** The AutoVPN groups that belong to this company. */
  autoVPNGroups: Array<AutoVpnGroup>;
  /** Custom roles defined for this company. */
  customRoles: Array<CustomRole>;
  /** The default role for users with this company. */
  defaultRoleForUsers: RoleName;
  /** The document uploads that belong to this company. */
  documentUploads: Array<DocumentUpload>;
  /** The Salesforce Company ID corresponding to this company. */
  externalID?: Maybe<Scalars['String']['output']>;
  /** If true, the network holds template networks to apply to new networks. */
  holdsGlobalNetworkTemplates: Scalars['Boolean']['output'];
  /** The inbox messages on this company. */
  inbox: InboxMessagePage;
  /** The internal notes owned directly by this company. */
  internalNotes: Array<InternalNote>;
  /** Whether this company represents a Meter customer. */
  isCustomer: Scalars['Boolean']['output'];
  /** A prospective company is used for sales purposes. */
  isProspective: Scalars['Boolean']['output'];
  /** A pre-signed URL to download a company logo override specified by `logoS3Key`. */
  logoDownloadURL?: Maybe<Scalars['String']['output']>;
  /**
   * The S3 key (path) of the image file representing the company logo, stored in AWS S3.
   * This is not required; it overrides the default logo that we fetch from a 3rd party service.
   */
  logoS3Key?: Maybe<Scalars['String']['output']>;
  /** Returns all MAC address aliases for a company. */
  macAddressAliases: Array<MacAddressAlias>;
  /** The name of the company. */
  name: Scalars['String']['output'];
  /** The networks associated with this company. */
  networks: Array<Network>;
  /** Onboarding document form completed prior to network going live. Different from `onboarding`. */
  onboardingDocument?: Maybe<CompanyOnboardingDocument>;
  /** List of email domains permitted for authentication for this company. */
  permittedEmailDomains?: Maybe<Array<PermittedEmailDomain>>;
  /**
   * Requests made by this company's public API keys to gain access to other
   * companies. Each entry's requestedCompany is the company that key is
   * asking to reach.
   */
  publicAPIKeyGrantRequests: Array<PublicApiKeyGrantRequest>;
  /** The group-to-role mappings configured for this company. */
  roleMappings: Array<CompanyRoleMapping>;
  /** A unique, URL-friendly identifier for the company, used in APIs and URLs. */
  slug: Scalars['String']['output'];
  /** Indicates whether Single Sign-On (SSO) is enabled for the company. */
  ssoEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** All support case contacts (collaborators) that have participated on any support case for this company, deduplicated. */
  supportCaseContacts: Array<SupportCaseContact>;
  /** An integer representing the support group assigned to the company. */
  supportGroup?: Maybe<Scalars['Int']['output']>;
  /** The support provider owned by this company, if any. */
  supportProvider?: Maybe<SupportProvider>;
  /** The support providers for this company. */
  supportProviders: SupportProviderPage;
  /** The Customer Success team segments customers by their tier, which dictates their level of support / sensitivity. */
  supportTier?: Maybe<CompanySupportTier>;
  /** The number of unread messages on inbox. */
  unreadMessageCount: Scalars['Int']['output'];
  /**
   * The unique UUID identifier for the company.
   * @deprecated Use `UUID` instead.
   */
  uuid: Scalars['UUID']['output'];
  /** The company's website domain, if applicable. */
  websiteDomain?: Maybe<Scalars['String']['output']>;
};


/** A company is a core Meter entity used to represent customers. Networks belong to companies. */
export type CompanyInboxArgs = {
  input?: InputMaybe<GetInboxInput>;
};


/** A company is a core Meter entity used to represent customers. Networks belong to companies. */
export type CompanyNetworksArgs = {
  filter?: InputMaybe<CompanyNetworksFilterInput>;
};


/** A company is a core Meter entity used to represent customers. Networks belong to companies. */
export type CompanySupportProvidersArgs = {
  input?: InputMaybe<GetSupportProvidersInput>;
};

export type CompanyFilterInput = {
  /** Input for non-exact search against company fields. */
  search?: InputMaybe<CompanyFilterSearchInput>;
};

/** Filter Companies based on substring search. */
export type CompanyFilterSearchInput = {
  /** Search based on name. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a Location for a Company. */
export type CompanyLocation = Identifiable & {
  __typename?: 'CompanyLocation';
  /** UUID of the Company Location */
  UUID: Scalars['UUID']['output'];
  /** Address associated with the Company */
  address: ConnectAddress;
  /** Name of the location. */
  name?: Maybe<Scalars['String']['output']>;
};

/** Filters the list of networks for a single company */
export type CompanyNetworksFilterInput = {
  /** Filter networks using their UUIDs. */
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Represents the onboarding process for a company. */
export type CompanyOnboarding = {
  __typename?: 'CompanyOnboarding';
  /** Unique identifier for the company onboarding entry. */
  UUID: Scalars['UUID']['output'];
  /** Unique identifier of the associated company. */
  companyUUID: Scalars['UUID']['output'];
  /** Timestamp when the company onboarding was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Job data associated with the company onboarding. */
  jobData?: Maybe<NetworkOnboardingJobData>;
  /** Identifier of the associated job data. */
  jobDataID: Scalars['String']['output'];
  /** Timestamp when the company onboarding was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Document containing information required for company onboarding. */
export type CompanyOnboardingDocument = Identifiable & {
  __typename?: 'CompanyOnboardingDocument';
  /** Unique identifier for the company onboarding document. */
  UUID: Scalars['UUID']['output'];
  /** Unique identifier of the associated company. */
  companyUUID: Scalars['UUID']['output'];
  /** Timestamp when the document was created. */
  createdAt: Scalars['DateTime']['output'];
  /** List of fields that have been delegated to other users for completion. */
  delegations: Array<CompanyOnboardingFieldDelegation>;
  /** JSON object containing the onboarding document data. */
  document: Scalars['JSONObject']['output'];
  /** JSON object containing the onboarding document metadata data. */
  documentMetadata?: Maybe<Scalars['JSONObject']['output']>;
  /** Keys of document fields that are currently hidden. Fields not listed here are visible by default. */
  hiddenFields: Array<Scalars['String']['output']>;
  /** Timestamp when the document was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents the delegation of a specific field of the company onboarding document to a user. */
export type CompanyOnboardingFieldDelegation = Identifiable & {
  __typename?: 'CompanyOnboardingFieldDelegation';
  /** Unique identifier of the field delegation. */
  UUID: Scalars['UUID']['output'];
  /** Unique identifier of the associated company. */
  companyUUID: Scalars['UUID']['output'];
  /** Description of the delegation. */
  description?: Maybe<Scalars['String']['output']>;
  /** Email of the user to whom the field is delegated. */
  email: Scalars['String']['output'];
  /** Name of the field being delegated. */
  fieldName: Scalars['String']['output'];
};

/** Maps an IdP group name to a Meter role for directory-synced users. */
export type CompanyRoleMapping = {
  __typename?: 'CompanyRoleMapping';
  /** The unique identifier of the mapping. */
  UUID: Scalars['UUID']['output'];
  /** Company users who currently hold a role because of this mapping. */
  companyUsers: Array<CompanyUser>;
  /** When the mapping was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The IdP group name (case-insensitive) that triggers this role assignment. */
  groupName: Scalars['String']['output'];
  /**
   * The network scope for the role, if any. Returns the single network when exactly one network is configured.
   * @deprecated Use `networks` instead.
   */
  network?: Maybe<Network>;
  /** All network scopes for the role. Empty means the role applies company-wide. */
  networks: Array<Network>;
  /** The Meter role assigned to users in this group. */
  role: RoleName;
  /** For Meter cross-company mappings, the company this role is assigned at. */
  targetCompany?: Maybe<Company>;
};

/** Defines a SIEM integration for a company. All networks in that company will send data to the associated AWS Kinesis stream. */
export type CompanySiemIntegration = Identifiable & {
  __typename?: 'CompanySIEMIntegration';
  /** Unique identifier. */
  UUID: Scalars['UUID']['output'];
  /** The ARN of the AWS Kinesis stream data will be sent to. */
  awsKinesisARN: Scalars['String']['output'];
  /** Creation time. */
  createdAt: Scalars['DateTime']['output'];
  /** https://docs.aws.amazon.com/IAM/latest/UserGuide/id_roles_common-scenarios_third-party.html */
  externalID: Scalars['String']['output'];
  /** The role that is granted permission to write to awsKinesisARN that a Meter AWS user will assume. */
  roleARN: Scalars['String']['output'];
  /** The last status of the integration. */
  status?: Maybe<CompanySiemIntegrationStatus>;
  /** The time the status was set. */
  statusUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The last status of an integration. */
export enum CompanySiemIntegrationStatus {
  /** The integration is successfully running. */
  Success = 'SUCCESS',
  /** The status is unauthorized. The stream either does not exist or we don't have access to it. */
  Unauthorized = 'UNAUTHORIZED'
}

/** The support tier indicates the customer's level of support / sensitivity. */
export enum CompanySupportTier {
  /** The highest level of support; critical support for the most sensitive customers. */
  Critical = 'CRITICAL',
  /** The high level of support; elevated support for important customers. */
  High = 'HIGH',
  /** The lowest level of support; minimal support required. */
  Low = 'LOW',
  /** The medium level of support; standard support. */
  Medium = 'MEDIUM'
}

/** Type of company used in generating ISP contracts. */
export enum CompanyType {
  /** Company is designated as a Corporation. */
  Corp = 'CORP',
  /** Company is designated as an LLC. */
  Llc = 'LLC',
  /** Company is designated as a Partnership. */
  Partnership = 'PARTNERSHIP',
  /** Company type is unknown. */
  Unknown = 'UNKNOWN'
}

/** A company user provides access for a user to a company's networks. */
export type CompanyUser = {
  __typename?: 'CompanyUser';
  /** The unique identifier for the company user. */
  UUID: Scalars['UUID']['output'];
  /** The company the user is associated with. */
  company: Company;
  /** The date and time when the company user was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The date and time when the company user was deleted, if applicable. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user's most recent authenticated, dashboard activity */
  latestActivity?: Maybe<UserActivity>;
  /** The roles assigned to the company user. */
  roles: Array<RoleAssignment>;
  /** The user who is associated with the company. */
  user: User;
};

/** A compliance framework (e.g. PCI DSS, SOC 2) */
export type ComplianceFramework = {
  __typename?: 'ComplianceFramework';
  /** Unique identifier for the framework */
  UUID: Scalars['UUID']['output'];
  /** Framework description */
  description: Scalars['String']['output'];
  /** Human-readable name */
  name: Scalars['String']['output'];
  /** URL-friendly slug for the framework */
  slug: Scalars['String']['output'];
  /** Framework version */
  version: Scalars['String']['output'];
};

/** A compliance report for a specific network and compliance standard */
export type ComplianceReport = Identifiable & {
  __typename?: 'ComplianceReport';
  /** Unique identifier for the report */
  UUID: Scalars['UUID']['output'];
  /** When the report generation completed (if applicable) */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the report generation was requested */
  createdAt: Scalars['DateTime']['output'];
  /** End date of the compliance evaluation period (if applicable) */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The framework this report was generated for */
  frameworkUUID: Scalars['UUID']['output'];
  /** The network this report was generated for */
  networkUUID: Scalars['UUID']['output'];
  /** Results of individual requirement checks for this report */
  results: Array<ComplianceResult>;
  /** Start date of the compliance evaluation period (if applicable) */
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current status of the report generation */
  status: ComplianceReportStatus;
  /** When the report was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Status of a compliance report job */
export enum ComplianceReportStatus {
  /** Report generation completed successfully */
  Complete = 'COMPLETE',
  /** Report generation failed */
  Fail = 'FAIL',
  /** Report is currently being generated */
  InProgress = 'IN_PROGRESS',
  /** Report generation is pending */
  Pending = 'PENDING'
}

/** A compliance requirement definition */
export type ComplianceRequirement = {
  __typename?: 'ComplianceRequirement';
  /** Unique identifier for the requirement */
  UUID: Scalars['UUID']['output'];
  /** Detailed description of the requirement */
  description: Scalars['String']['output'];
  /** Requirement identifier (e.g., "1.2.3") */
  name: Scalars['String']['output'];
  /** Unique slug for the requirement */
  slug: Scalars['String']['output'];
  /** Short title of the requirement */
  title: Scalars['String']['output'];
};

/** Result of a specific requirement check for a given compliance report */
export type ComplianceResult = {
  __typename?: 'ComplianceResult';
  /** Unique identifier for the result */
  UUID: Scalars['UUID']['output'];
  /** Additional metadata for the result */
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  /** Human-readable notes about the result */
  notes?: Maybe<Scalars['String']['output']>;
  /** The requirement details */
  requirement: ComplianceRequirement;
  /** The result of the requirement check */
  result: RequirementResult;
};

/** Input for configuring SSO for a company. */
export type ConfigureSsoInput = {
  /** The slug (unique identifier) of the company. */
  companySlug: Scalars['String']['input'];
  /** The type of admin portal link to generate. */
  type: SsoAdminPortalType;
};

/** Result of configuring SSO for a company. */
export type ConfigureSsoResult = {
  __typename?: 'ConfigureSSOResult';
  /** The company for which SSO has been configured. */
  company: Company;
  /** The URL of the admin portal for SSO configuration. */
  portalURL: Scalars['String']['output'];
};

/** ConfiguredNOSVersion represents the NOS firmware version that a device is configured to run. */
export type ConfiguredNosVersion = {
  __typename?: 'ConfiguredNOSVersion';
  /** Stable UUID identifier for cross-realm sync. */
  UUID: Scalars['UUID']['output'];
  /** The build name specified in the NOS version (could be different from that reported by the device in bootinfo table). */
  buildName: Scalars['String']['output'];
  /** The human readable build version for the firmware, derived from the `buildName`. */
  buildVersion?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the NOS version configuration. */
  id: Scalars['Int']['output'];
  /** Major version number component of the NOS version. */
  major: Scalars['Int']['output'];
  /** Minor version number component of the NOS version. */
  minor: Scalars['Int']['output'];
  /** Patch version number component of the NOS version. */
  patch: Scalars['Int']['output'];
  /** The NOS firmware version string. */
  version: Scalars['String']['output'];
  /** Human readable version number (<major>.<minor>.<patch>). */
  versionNumber: Scalars['String']['output'];
};

/**
 * ConnectAddress represents a physical address, used with an ISP and Quote Request. It encompasses the Location and Sublocation.
 *
 * WARNING: These fields are currently different from the fields used in the MailingAddress type. There is a plan to
 * consolidate these types in the future.
 */
export type ConnectAddress = {
  __typename?: 'ConnectAddress';
  /** Unique identifier for the location. */
  UUID: Scalars['UUID']['output'];
  /** First line of the address. Typically includes street number and name. */
  address1: Scalars['String']['output'];
  /** Second line of the address. Typically includes apartment, suite, unit, building, floor, etc. */
  address2: Scalars['String']['output'];
  /** City where the address is located. */
  city: Scalars['String']['output'];
  /** Company associated with this address. */
  company?: Maybe<Company>;
  /** ISO 3166-1 alpha-2 country code for the address. */
  country: Scalars['String']['output'];
  /** Latitude of the address, when known. */
  latitude?: Maybe<Scalars['String']['output']>;
  /** Longitude of the address, when known. */
  longitude?: Maybe<Scalars['String']['output']>;
  /** Postal or ZIP code for the address. */
  postalCode: Scalars['String']['output'];
  /** State or province where the address is located. */
  state: Scalars['String']['output'];
  /** Unique identifier for the sublocation, such as a specific site or building. */
  sublocationUUID: Scalars['UUID']['output'];
};

/** Type of procurement channel, defining pricing model and contract terms for ISPs. */
export enum ConnectProcurementChannel {
  /** Retail pricing. */
  Retail = 'RETAIL',
  /** Wholesale quoting. Meter is the provider. */
  Wholesale = 'WHOLESALE'
}

/** Customer-facing product family a connection type belongs to. */
export enum ConnectProductGroup {
  /** Shared fiber and coax. */
  Broadband = 'BROADBAND',
  /** Dedicated internet access. */
  DedicatedInternetAccess = 'DEDICATED_INTERNET_ACCESS',
  /** Point to point wireless. */
  FixedWireless = 'FIXED_WIRELESS',
  /** Satellite. */
  Satellite = 'SATELLITE'
}

/** Connect Static Rate pricing for connection type, speed and term buckets */
export type ConnectStaticRate = {
  __typename?: 'ConnectStaticRate';
  /** Unique identifier for the static rate. */
  UUID: Scalars['UUID']['output'];
  /** Product type for the rate. */
  connectionType: InternetServicePlanConnectionType;
  /** Timestamp of when the Static Rate was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Download speed Kbps maximum for speed bucket (exclusive). */
  downloadKbpsMax: Scalars['Int']['output'];
  /** Download speed Kbps minimum for speed bucket (inclusive). */
  downloadKbpsMin: Scalars['Int']['output'];
  /** Install cost in cents. */
  installCostCents: Scalars['Int']['output'];
  /** Monthly recurring cost in cents. */
  monthlyCostCents: Scalars['Int']['output'];
  /** Term of contract in months. */
  termMonths: Scalars['Int']['output'];
  /** Timestamp of when the Static Rate was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A connection failure reason with total count and number of unique clients affected. */
export type ConnectionFailureReason = {
  __typename?: 'ConnectionFailureReason';
  /** The radio band on which the failure occurred. */
  band: RadioBand;
  /** The total number of failures with this step and reason code. */
  count: Scalars['Int']['output'];
  /** The step at which the connection failed. */
  failedStep: WirelessClientConnectionFailedStep;
  /** A numeric reason code providing additional detail for the failure, if available. The interpretation depends on the failedStep. */
  reasonCode?: Maybe<Scalars['Int']['output']>;
  /** The SSID on which the failure occurred, if available. */
  ssid?: Maybe<Scalars['String']['output']>;
  /** The number of unique clients that experienced this failure. */
  uniqueClients: Scalars['Int']['output'];
};

/** A console login record represents a user logging into a device via the console. */
export type ConsoleLogin = {
  __typename?: 'ConsoleLogin';
  /** Unique identifier for the console login record. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp of when the console login was recorded. */
  createdAt: Scalars['DateTime']['output'];
  /** Device that the user logged into. */
  hardwareDevice: HardwareDevice;
  /** Username of the user that logged into the device. */
  username: Scalars['String']['output'];
};

/** An enum of all the encodings for uploaded content */
export enum ContentEncoding {
  /** Base64 content encoding. */
  Base64 = 'Base64',
  /** Binary content encoding. */
  Binary = 'Binary'
}

/** Response containing an array of DNS request rate values. */
export type ControllerDnsRequestRatesResponse = {
  __typename?: 'ControllerDNSRequestRatesResponse';
  /** Array of DNS request rate values per timestamp and DNS server UUID. */
  values: Array<ControllerDnsRequestRatesValue>;
};

/** Metrics data point containing DNS request rates for a controller's DNS server. */
export type ControllerDnsRequestRatesValue = MetricsValue & {
  __typename?: 'ControllerDNSRequestRatesValue';
  /** Timestamp for the metrics data point. */
  timestamp: Scalars['DateTime']['output'];
  /** UUID of the DNS server. */
  uuid: Scalars['UUID']['output'];
  /** Requests per second. */
  value: Scalars['Float']['output'];
};

/** A controller hardware device represents a physical Meter firewall, also referred to as a security appliance or controller. */
export type ControllerHardwareDevice = HardwareDevice & {
  __typename?: 'ControllerHardwareDevice';
  /** The backup public key used to add the device to the jumphost's WireGuard interface. */
  backupPublicKey?: Maybe<Scalars['String']['output']>;
  /** Backup IPv6 address on the jumphost subnet. Used to send requests to the device. */
  backupTunnelIPAddress?: Maybe<Scalars['String']['output']>;
  /** The batch identifier of the hardware device, if any. */
  batch?: Maybe<Scalars['String']['output']>;
  /** Shows the most recent boot history of a device (buildName, bootCount). */
  bootHistory: Array<BootInfo>;
  /** The active config override for this device, if any. */
  configOverride?: Maybe<DeviceConfigOverride>;
  /** The timestamp when the hardware device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** The model name of the hardware device. */
  deviceModel: DeviceModel;
  /** The physical orientation or position of the hardware device in a device pair. */
  devicePosition?: Maybe<DevicePosition>;
  /** The type of the hardware device. */
  deviceType: DeviceType;
  /** If the device is no longer connected to the backend, this is the time at which it was last connected. */
  disconnectedFromBackendAt?: Maybe<Scalars['DateTime']['output']>;
  /** The hardware generation of the device. */
  hardwareGeneration: HardwareGeneration;
  /** Metadata for the model of this device. */
  hardwareModelProperties: HardwareModelProperties;
  /** Internal operator-only notes about this hardware device. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /**
   * True if the device has an active websocket connection to the backend. Note that this only works if the device has registered via the /v2/register endpoint (i.e., is a Config 2 device) - otherwise is always false.
   * @deprecated Use `isSpare` instead.
   */
  isActive: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is connected to the backend. */
  isConnectedToBackend: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /**
   * Indicates whether the hardware device is marked as a development (dev) device, moving it into the dev (staging) realm for testing purposes.
   * @deprecated Use `realm` instead. isDev is equivalent to realm == DEV.
   */
  isDev: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is in factory mode. */
  isFactoryMode: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is an RMA (Return Merchandise Authorization) replacement device. */
  isRMA: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device has been retired. */
  isRetired: Scalars['Boolean']['output'];
  /** A spare hardware device belongs to a network but is not assigned to a virtual device. Spares are typically kept on site as replacements and are not in service. */
  isSpare: Scalars['Boolean']['output'];
  /** The latest device config metadata (ie. the config without the actual JSON payload) for the device. */
  latestDeviceConfigMetadata?: Maybe<DeviceConfigMetadata>;
  /** The MAC address of the hardware device. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** The UUID of the network that the hardware device belongs to. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** The firewall device paired with this controller, if any. This is applicable to high-availability (HA) models. */
  pairedHardwareDevice?: Maybe<ControllerHardwareDevice>;
  /** The public key used to add the device to the jumphost's WireGuard interface. */
  publicKey?: Maybe<Scalars['String']['output']>;
  /** The realm that owns this hardware device. Used for cross-realm device management. */
  realm: HardwareDeviceRealm;
  /** The unique serial number of the hardware device. */
  serialNumber: Scalars['String']['output'];
  /** The network that the spare hardware device belongs to. Spare hardware devices that are not affiliated with a virtual device will have this field populated. */
  spareDeviceNetwork?: Maybe<Network>;
  /** IPv6 address on the jumphost subnet. Used to send requests to the device. */
  tunnelIPAddress?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the hardware device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The uptime metrics from the time series database for the device.
   * @deprecated Use `VirtualDevice.uptime` instead.
   */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** The virtual device associated with this hardware device, if any. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The UUID of the virtual device this hardware device is assigned to, if any. */
  virtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
};


/** A controller hardware device represents a physical Meter firewall, also referred to as a security appliance or controller. */
export type ControllerHardwareDeviceBootHistoryArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

/** Response object containing an array of controller port metrics rate values. */
export type ControllerPortMetricsRateResponse = {
  __typename?: 'ControllerPortMetricsRateResponse';
  /** Array of metrics rate values per timestamp and port. */
  values: Array<ControllerPortMetricsRateValue>;
};

/** Metrics data point containing rate statistics (per second) for a controller port over a specific time interval. */
export type ControllerPortMetricsRateValue = {
  __typename?: 'ControllerPortMetricsRateValue';
  /** Total number of broadcast packets per second received during the time interval; a subset of totalRxPackets. */
  broadcastRxPacketsPerSecond: Scalars['Float']['output'];
  /** Total number of broadcast packets per second transmitted during the time interval; a subset of totalTxPackets. */
  broadcastTxPacketsPerSecond: Scalars['Float']['output'];
  /** The number of packets per second that were dropped during the time interval. */
  dropsPerSecond: Scalars['Float']['output'];
  /** Total number of multicast packets per second received during the time interval; a subset of totalRxPackets. */
  multicastRxPacketsPerSecond: Scalars['Float']['output'];
  /** Total number of multicast packets per second transmitted during the time interval; a subset of totalTxPackets. */
  multicastTxPacketsPerSecond: Scalars['Float']['output'];
  /** The physical port number on the controller. */
  portNumber: Scalars['Int']['output'];
  /** The number of packets per second that encountered errors being received in the time interval. */
  rxErrPerSecond: Scalars['Float']['output'];
  /** Timestamp for the metrics data point. */
  timestamp: Scalars['DateTime']['output'];
  /** Total number of bytes per second received during the time interval. */
  totalRxBytesPerSecond: Scalars['Float']['output'];
  /** Total number of bytes per second transmitted during the time interval. */
  totalTxBytesPerSecond: Scalars['Float']['output'];
  /** The number of packets per second that encountered errors during transmission in the time interval. */
  txErrPerSecond: Scalars['Float']['output'];
};

/** Summed stats (unless otherwise specified) per controller port over a lookback period. */
export type ControllerPortStat = {
  __typename?: 'ControllerPortStat';
  /** Total number of broadcast bytes received in the given time period; a subset of totalRxBytes. */
  broadcastRxBytes: Scalars['Int']['output'];
  /** Total number of broadcast packets received in the given time period; a subset of totalRxPackets. */
  broadcastRxPackets: Scalars['Int']['output'];
  /** Total number of broadcast bytes transmitted in the given time period; a subset of totalTxBytes. */
  broadcastTxBytes: Scalars['Int']['output'];
  /** Total number of broadcast packets transmitted in the given time period; a subset of totalTxPackets. */
  broadcastTxPackets: Scalars['Int']['output'];
  /** The number of packets that were dropped in the time interval. */
  drops: Scalars['Int']['output'];
  /** Most recent hardware up state. Indicates that a physical connection is established, typically meaning a cable is properly connected and active. */
  hwUp: Scalars['Boolean']['output'];
  /** The number of IPv4 packets transmitted or received. */
  ipv4: Scalars['Int']['output'];
  /** The number of IPv6 packets transmitted or received. */
  ipv6: Scalars['Int']['output'];
  /** Total number of multicast bytes received in the given time period; a subset of totalRxBytes. */
  multicastRxBytes: Scalars['Int']['output'];
  /** Total number of multicast packets received in the given time period; a subset of totalRxPackets. */
  multicastRxPackets: Scalars['Int']['output'];
  /** Total number of multicast bytes transmitted in the given time period; a subset of totalTxBytes. */
  multicastTxBytes: Scalars['Int']['output'];
  /** Total number of multicast packets transmitted in the given time period; a subset of totalTxPackets. */
  multicastTxPackets: Scalars['Int']['output'];
  /** The physical port number on the controller. */
  portNumber: Scalars['Int']['output'];
  /** The number of packets punted to the CPU for processing (currently not reported by firmware). */
  punts: Scalars['Int']['output'];
  /** The number of packets that encountered errors being received. */
  rxErr: Scalars['Int']['output'];
  /** Total number of bytes received in the given time period. */
  totalRxBytes: Scalars['Int']['output'];
  /** Total number of packets received in the given time period. */
  totalRxPackets: Scalars['Int']['output'];
  /** Total number of bytes transmitted in the given time period. */
  totalTxBytes: Scalars['Int']['output'];
  /** Total number of packets transmitted in the given time period. */
  totalTxPackets: Scalars['Int']['output'];
  /** The number of packets that encountered errors during transmission. */
  txErr: Scalars['Int']['output'];
  /** Total number of unicast bytes received in the given time period; a subset of totalRxBytes. */
  unicastRxBytes: Scalars['Int']['output'];
  /** Total number of unicast packets received in the given time period; a subset of totalRxPackets. */
  unicastRxPackets: Scalars['Int']['output'];
  /** Total number of unicast bytes transmitted in the given time period; a subset of totalTxBytes. */
  unicastTxBytes: Scalars['Int']['output'];
  /** Total number of unicast packets transmitted in the given time period; a subset of totalTxPackets. */
  unicastTxPackets: Scalars['Int']['output'];
  /** The unique identifier of the device. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** A controller virtual device is a logical representation of a physical Meter firewall, also referred to as a security appliance or controller. */
export type ControllerVirtualDevice = Identifiable & TargetInterface & VirtualDevice & {
  __typename?: 'ControllerVirtualDevice';
  /** The unique identifier (UUID) of the virtual device. */
  UUID: Scalars['UUID']['output'];
  /** The most recent reported ARP table for this device, if it exists." */
  arpTable?: Maybe<Array<ArpTableEntry>>;
  /** The timestamp when the virtual device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** An optional description for the virtual device. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Metadata for the configurations rendered for this virtual device over time, newest
   * first. Includes configs written to hardware devices that have since been dissociated
   * from this virtual device. Omits the rendered config JSON for performance.
   */
  deviceConfigs: Array<DeviceConfigMetadata>;
  /** The model name of the virtual device. */
  deviceModel: DeviceModel;
  /** The type of the virtual device. */
  deviceType: VirtualDeviceType;
  /** The hardware device associated with this virtual device, if any. */
  hardwareDevice?: Maybe<HardwareDevice>;
  /** Metadata for the model of this device. */
  hardwareModelProperties: HardwareModelProperties;
  /** The high availability (HA) configuration information associated with this controller, if configured in HA mode. */
  highAvailability?: Maybe<HighAvailabilityControllerVirtualDeviceInfo>;
  /** The management IP address of the device. Note that this is not yet populated for controller devices. */
  ipAddress?: Maybe<Scalars['IP']['output']>;
  /** Indicates whether the virtual device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether debug logging is enabled on the virtual device. */
  isDebugLogEnabled: Scalars['Boolean']['output'];
  /** Whether this virtual device is in a draft state for preconfiguration reasons. */
  isDraft: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is online, indicated by its heartbeat. */
  isOnline: Scalars['Boolean']['output'];
  /** A human-friendly name for the device. */
  label: Scalars['String']['output'];
  /** The physical location of this virtual device, derived from its rack elevation placement. */
  location?: Maybe<VirtualDeviceLocation>;
  /** The management plane connection type for the controller. */
  managementConnection: ManagementConnection;
  /** The most recent NOS upgrade for this virtual device that has started executing or was skipped (in progress, completed, failed, or skipped), if any. */
  mostRecentNOSUpgrade?: Maybe<ScheduledDeviceNosUpgrade>;
  /** The network that the virtual device belongs to. */
  network: Network;
  /** The unique identifier (UUID) of the network the virtual device belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The group that the device belongs to for firmware upgrade grouping purposes. */
  nosUpgradeGroup: NosUpgradeGroup;
  /** The current NOS firmware version that the virtual device is configured to run. */
  nosVersion?: Maybe<ConfiguredNosVersion>;
  /** The identifier of the NOS firmware version that the virtual device is configured to run. */
  nosVersionID: Scalars['Int']['output'];
  /** The controller's active or future notification snoozes */
  notificationSnoozes: Array<DeviceNotificationSnooze>;
  /**
   * The outlet interface on a Meter Power Distribution Device that this device is connected to, if applicable.
   * This connection is a manually curated label and may not actually be the outlet that the device is connected to.
   */
  outletInterfaceConnectedTo?: Maybe<OutletInterface>;
  /** The paired virtual device to this device. This is applicable to high-availability (HA) models. */
  pairedVirtualDevice?: Maybe<ControllerVirtualDevice>;
  /** The NOS firmware version that the virtual device is scheduled to upgrade to. */
  pendingNosVersion?: Maybe<PendingNosVersion>;
  /** The physical interfaces associated with the controller. */
  phyInterfaces: Array<PhyInterface>;
  /** URL to the regulatory e-label for the device, if applicable. */
  regulatoryLabelURL?: Maybe<Scalars['String']['output']>;
  /** The firewall profile associated with the controller. */
  securityApplianceProfile: SecurityApplianceProfile;
  /** The unique identifier of the firewall profile associated with the controller. */
  securityApplianceProfileUUID: Scalars['UUID']['output'];
  /** The virtual device tags on this device. */
  tags: Array<VirtualDeviceTag>;
  /** Data about this virtual device's position in its network's topology. */
  topologyData?: Maybe<VirtualDeviceTopologyData>;
  /** The timestamp when the virtual device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /** How long the device has been continuously powered on and reporting. */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** The position of this virtual device within its device pair (left or right). Null if not part of a pair. */
  virtualDevicePairPosition?: Maybe<DevicePosition>;
};


/** A controller virtual device is a logical representation of a physical Meter firewall, also referred to as a security appliance or controller. */
export type ControllerVirtualDeviceDeviceConfigsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


/** A controller virtual device is a logical representation of a physical Meter firewall, also referred to as a security appliance or controller. */
export type ControllerVirtualDevicePhyInterfacesArgs = {
  isUplink?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents geographical coordinates with latitude and longitude. */
export type Coordinates = {
  __typename?: 'Coordinates';
  /** The latitude component of the coordinates. */
  latitude: Scalars['Float']['output'];
  /** The longitude component of the coordinates. */
  longitude: Scalars['Float']['output'];
};

/** Specifies a single virtual device to migrate as part of a bulk copyVirtualDevicesToNewModels call. */
export type CopyVirtualDeviceToNewModelInput = {
  /** Options for how to perform the device migration, if applicable. */
  deviceMigrationOptions?: InputMaybe<DeviceMigrationInput>;
  /** The new device model to migrate the virtual device to. */
  newDeviceModel: DeviceModel;
  /** The UUID of the virtual device to migrate. */
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** The certification status of a hardware device model in a country. */
export type CountryDeviceCertification = {
  __typename?: 'CountryDeviceCertification';
  /** The certification status of the device model in the country. */
  certificationStatus: CertificationStatus;
  /** ISO 3166-1 alpha-2 country code. */
  countryISO2: Scalars['String']['output'];
  /** The timestamp when the certification was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The hardware device model. */
  deviceModel: DeviceModel;
  /** Whether the certification status permits adding the device model to a network in the country. */
  isPermitted: Scalars['Boolean']['output'];
  /** The number of active, non-trial, non-template customer networks in this country with a virtual device of this model. */
  networkCount: Scalars['Int']['output'];
  /** Freeform notes about the certification. */
  notes?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the certification was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user who last changed the certification status. */
  updatedBy?: Maybe<User>;
};

/** The number of customer networks in a country. */
export type CountryDeviceCertificationNetworkCountByCountry = {
  __typename?: 'CountryDeviceCertificationNetworkCountByCountry';
  /** ISO 3166-1 alpha-2 country code. */
  countryISO2: Scalars['String']['output'];
  /** The number of active, non-trial, non-template customer networks in the country. */
  networkCount: Scalars['Int']['output'];
};

/** The number of customer networks with a virtual device of a model. */
export type CountryDeviceCertificationNetworkCountByDeviceModel = {
  __typename?: 'CountryDeviceCertificationNetworkCountByDeviceModel';
  /** The hardware device model. */
  deviceModel: DeviceModel;
  /** The number of active, non-trial, non-template customer networks with a virtual device of the model. */
  networkCount: Scalars['Int']['output'];
};

/** Country device certifications along with customer network counts. */
export type CountryDeviceCertificationsResponse = {
  __typename?: 'CountryDeviceCertificationsResponse';
  /** All country device certifications. */
  countryDeviceCertifications: Array<CountryDeviceCertification>;
  /** Customer network counts by country. */
  networkCountByCountry: Array<CountryDeviceCertificationNetworkCountByCountry>;
  /** Customer network counts by device model. */
  networkCountByDeviceModel: Array<CountryDeviceCertificationNetworkCountByDeviceModel>;
};

export type CreateAccessPointPortProfileInput = {
  /** A human readable description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The hardware model this port profile is for. */
  deviceModel: DeviceModel;
  /** The name of the port profile. */
  name: Scalars['String']['input'];
  /** Optional port bindings to set on creation. Keyed by port number; any ports not specified will use defaults (no VLAN). */
  portBindings?: InputMaybe<Array<CreateAccessPointPortProfilePortBindingInput>>;
  /** Optional virtual device UUIDs to assign this profile to on creation. Will overwrite previously assigned port profile for each device. */
  virtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type CreateAccessPointPortProfilePortBindingInput = {
  /** The port number on the access point. */
  portNumber: Scalars['Int']['input'];
  /** The UUID of the VLAN to assign to this port. */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input type for creating a new address. */
export type CreateAddressInput = {
  /** First line of the address. Typically includes street number and name. */
  address1: Scalars['String']['input'];
  /** Second line of the address. Typically includes apartment, suite, unit, building, floor, etc. */
  address2?: InputMaybe<Scalars['String']['input']>;
  /** City where the address is located. */
  city: Scalars['String']['input'];
  /** ISO 3166-1 alpha-2 country code for the address. */
  country: Scalars['String']['input'];
  /** Latitude of the address. */
  latitude?: InputMaybe<Scalars['String']['input']>;
  /** Logitude of the address */
  longitude?: InputMaybe<Scalars['String']['input']>;
  /** Postal or ZIP code for the address. */
  postalCode: Scalars['String']['input'];
  /** State or province where the address is located. */
  state: Scalars['String']['input'];
};

/** Input for creating a new Company alert subscription. */
export type CreateAlertCompanySubscriptionInput = {
  /** The input for the alert. */
  alertInput: AlertThresholdParamsInput;
  /** The UUID of the alert receiver that receives notifications stemming from an evaluation of this alert subscription. Deprecated in favor of alertReceiverUUIDs; if both are set, alertReceiverUUIDs wins. */
  alertReceiverUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The UUIDs of the alert receivers that receive notifications stemming from an evaluation of this alert subscription. If non-empty, takes precedence over alertReceiverUUID. */
  alertReceiverUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The UUID of the company to create the alert subscription for. */
  companyUUID: Scalars['UUID']['input'];
  /** The description of the alert subscription. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The UUIDs of the networks to exclude from the alert subscription. Only valid for company-wide subscriptions. */
  excludedNetworkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The UUIDs of the networks to include in the alert subscription. Only valid for non-company-wide subscriptions. */
  includedNetworkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Whether the alert subscription is company-wide. Company-wide subscriptions are evaluated for all networks in the company, with optional exclusions. Non-company-wide subscriptions are opt-out by default. */
  isCompanyWide: Scalars['Boolean']['input'];
  /** Whether the alert subscription is enabled. */
  isEnabled: Scalars['Boolean']['input'];
  /** The label of the alert subscription. */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new fleetwide alert subscription. */
export type CreateAlertFleetwideSubscriptionInput = {
  /** The input for the alert. */
  alertInput: AlertThresholdParamsInput;
  /** The UUID of the alert receiver that receives notifications stemming from an evaluation of this alert subscription. Deprecated in favor of alertReceiverUUIDs; if both are set, alertReceiverUUIDs wins. */
  alertReceiverUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The UUIDs of the alert receivers that receive notifications stemming from an evaluation of this alert subscription. If non-empty, takes precedence over alertReceiverUUID. */
  alertReceiverUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The description of the alert subscription. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The company support tiers that the alert subscription is enabled for. If empty, the alert subscription is enabled for all company support tiers. */
  enabledCompanySupportTiers?: InputMaybe<Array<CompanySupportTier>>;
  /** The NOS upgrade channels that the alert subscription is enabled for. If empty, the alert subscription is enabled for all NOS upgrade channels. */
  enabledNOSUpgradeChannels?: InputMaybe<Array<NetworkNosUpgradeChannel>>;
  /** The UUIDs of the companies to exclude from the alert subscription. */
  excludedCompanyUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The UUIDs of the networks to exclude from the alert subscription. */
  excludedNetworkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The UUIDs of the companies to limit the alert subscription to. If any inclusions (company or network) are provided, the subscription only applies to matching networks. Exclusions take precedence over inclusions: a company or network that is both included and excluded is excluded. */
  includedCompanyUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The UUIDs of the networks to limit the alert subscription to. If any inclusions (company or network) are provided, the subscription only applies to matching networks. Exclusions take precedence over inclusions: a company or network that is both included and excluded is excluded. */
  includedNetworkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Whether the alert subscription is enabled. */
  isEnabled: Scalars['Boolean']['input'];
  /** The label of the alert subscription. */
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAlertReceiverWithTargetsInput = {
  /** Label for the new alert receiver. */
  label: Scalars['String']['input'];
  /** List of alert targets to associate with the new alert receiver. */
  targets: Array<AlertTargetInput>;
};

/** Input for creating a new support provider alert subscription. */
export type CreateAlertSupportProviderSubscriptionInput = {
  /** The input for the alert. */
  alertInput: AlertThresholdParamsInput;
  /** The UUIDs of the alert receivers that receive notifications stemming from an evaluation of this alert subscription. If non-empty, takes precedence over alertReceiverUUID. */
  alertReceiverUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The UUID of the company to create the alert subscription for. */
  companyUUID: Scalars['UUID']['input'];
  /** The description of the alert subscription. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The UUIDs of the networks to exclude from the alert subscription. Only valid for company-wide subscriptions. */
  excludedNetworkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The UUIDs of the networks to include in the alert subscription. Only valid for non-company-wide subscriptions. */
  includedNetworkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Whether the alert subscription is company-wide. Company-wide subscriptions are evaluated for all networks in the company, with optional exclusions. Non-company-wide subscriptions are opt-out by default. */
  isCompanyWide: Scalars['Boolean']['input'];
  /** Whether the alert subscription is enabled. */
  isEnabled: Scalars['Boolean']['input'];
  /** The label of the alert subscription. */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for creating a new Salesforce alert target. */
export type CreateAlertTargetSalesforceInput = {
  /** The domain to which alerts will be sent. */
  domain: Scalars['String']['input'];
};

/** Input type for creating a new Slack alert target. */
export type CreateAlertTargetSlackInput = {
  /** The Slack channel ID to which alerts will be sent. */
  channelID: Scalars['String']['input'];
  /** An optional label for the Slack alert target. */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for creating a new webhook alert target. */
export type CreateAlertTargetWebhookInput = {
  /** The type of authentication to use for the webhook. */
  authType?: InputMaybe<WebhookAuthType>;
  /** The value of the authentication header to use for the webhook. */
  authValue?: InputMaybe<Scalars['String']['input']>;
  /** An optional label for the webhook alert target. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The client identifier. Required for OAUTH_CLIENT_CREDENTIALS. */
  oauthClientID?: InputMaybe<Scalars['String']['input']>;
  /** The client secret. Required for OAUTH_CLIENT_CREDENTIALS. */
  oauthClientSecret?: InputMaybe<Scalars['String']['input']>;
  /** The HTTPS token endpoint. Required for OAUTH_CLIENT_CREDENTIALS. */
  oauthTokenURL?: InputMaybe<Scalars['String']['input']>;
  /** An optional secret used to sign webhook requests for verification. */
  signingSecret?: InputMaybe<Scalars['String']['input']>;
  /** The URL endpoint of the webhook where alerts will be sent. */
  url: Scalars['String']['input'];
};

export type CreateApplicationDnsFirewallRuleInput = {
  /** The action to take when the rule is matched. */
  action: FirewallRuleAction;
  /** The ID of the Netstar application to associate with the rule. */
  applicationID?: InputMaybe<Scalars['Int']['input']>;
  /** List of UUIDs of DHCP rules to which the application DNS firewall rule is bound. */
  boundDHCPRuleUUIDs: Array<Scalars['UUID']['input']>;
  /** The ID of the Netstar category to associate with the rule. */
  categoryID?: InputMaybe<Scalars['Int']['input']>;
  /** The domain or FQDN that is matched by the rule, allowing for wildcards denoted by '*'. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Netstar group to associate with the rule. */
  groupID?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the rule is enabled; defaults to true. */
  isEnabled?: Scalars['Boolean']['input'];
  /** The name of the DNS firewall rule. */
  name: Scalars['String']['input'];
  /** The priority of the rule; if not provided, will default to 1 greater than the highest existing priority. */
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateApplicationDnsFirewallRulesInput = {
  /** The input data for the new rule. */
  input: CreateApplicationDnsFirewallRuleInput;
  /** The unique identifier of the network for the rule. */
  networkUUID: Scalars['UUID']['input'];
};

/** Input type for configuring the hub's uplink when creating an AutoVPN group. */
export type CreateAutoVpnGroupHubUplinkInput = {
  /** IP address assigned to the hub's uplink. */
  address: Scalars['IP']['input'];
  /** Prefix length of the uplink's IP address. */
  addressPrefixLength: Scalars['Int']['input'];
  /** Indicates if failover is enabled for the hub's uplink. */
  isFailoverEnabled?: Scalars['Boolean']['input'];
  /** Unique identifier of the physical interface used by the hub's uplink. */
  phyInterfaceUUID: Scalars['UUID']['input'];
};

/** Input type for creating a new AutoVPN group. */
export type CreateAutoVpnGroupInput = {
  /** BFD timing configuration for BGP-backed groups. If not provided, defaults to 1s, 1s, 6. */
  bfd?: InputMaybe<CreateBfdConfigInput>;
  /** Unique identifier of the hub network. */
  hubNetworkUUID: Scalars['UUID']['input'];
  /** The instance ASN used for the BGP session. Only takes effect when `useBGP` is true. */
  instanceASN?: Scalars['Uint32']['input'];
  /** Indicates if the AutoVPN group is enabled. Defaults to true. */
  isEnabled?: Scalars['Boolean']['input'];
  /** Indicates if hub failover is enabled. Defaults to true. */
  isHubFailoverEnabled?: Scalars['Boolean']['input'];
  /** Optionally adds specified members to the group. */
  members?: InputMaybe<Array<AddNetworkToAutoVpnGroupInput>>;
  /** Name of the AutoVPN group. */
  name: Scalars['String']['input'];
  /** If set, any new members will not automatically be assigned these addresses. */
  reservedMemberAddresses?: Array<IpRangeInput>;
  /** Configuration of the hub's uplink. */
  uplink: CreateAutoVpnGroupHubUplinkInput;
  /** The Auto VPN group uses a BGP backed version. This requires all associated networks support this implementation. */
  useBGP?: Scalars['Boolean']['input'];
};

/** Input type for adding a hub to an AutoVPN group. */
export type CreateAutoVpnHubInput = {
  /** Indicates if failover is enabled for the hub. Defaults to true. */
  isFailoverEnabled?: Scalars['Boolean']['input'];
  /** Unique identifier of the hub network. */
  networkUUID: Scalars['UUID']['input'];
  /** Priority of the hub within the group. Defaults to the next available value. */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Configuration of the hub's uplink. */
  uplink: CreateAutoVpnGroupHubUplinkInput;
};

/** Creates an AutoVPN member-hub relationship. */
export type CreateAutoVpnMemberHubInput = {
  /** If set, overrides the priority of hubs for this member only. If unset, `hub.priority` is used as priority. */
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateAutoVpnMemberHubsInput = {
  /** The unique identifier of the Auto VPN hub. */
  hubUUID: Scalars['UUID']['input'];
  /** Input for creating an auto VPN member hub. */
  input: CreateAutoVpnMemberHubInput;
};

/** Input type for creating a new AutoVPN route in an AutoVPN group. */
export type CreateAutoVpnRouteInput = {
  /** Destination gateway IP address for the route. */
  dstGateway: Scalars['IPV4']['input'];
  /** Prefix length for the destination IP of the route. Must be between 1 and 32. */
  dstPrefixLength: Scalars['Int']['input'];
  /** Indicates if the route is enabled. Defaults to true. */
  isEnabled?: Scalars['Boolean']['input'];
  /** Name of the route. */
  name: Scalars['String']['input'];
};

/** Input type for configuring BFD timing on a BGP neighbor or a BGP-backed AutoVPN group. */
export type CreateBfdConfigInput = {
  /** The number of missed packets before declaring peer down. */
  detectMultiplier?: Scalars['Int']['input'];
  /** Interval at which BFD control packets are received. */
  receiveInterval: Scalars['Duration']['input'];
  /** Interval at which BFD control packets are transmitted. */
  transmitInterval: Scalars['Duration']['input'];
};

/** Input values for creating a new BGP neighbor. */
export type CreateBgpNeighborInput = {
  /** The list of custom prefixes to advertise to this neighbor. */
  advertisementPrefixes: Array<Scalars['IPPrefix']['input']>;
  /** The list of VLAN subnets to advertise to this neighbor. */
  advertisementVLANUUIDs: Array<Scalars['UUID']['input']>;
  /** The unique identifier for the Auto VPN group associated with this neighbor. */
  autoVPNGroupUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The period between successive connect attempts, in seconds. */
  connectIntervalSeconds: Scalars['Int']['input'];
  /** A longer description for this neighbor. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The maximum number of hops between the router and neighbor. */
  ebgpNumMaxHops?: InputMaybe<Scalars['Int']['input']>;
  /** The period since the last received keep-alive before neighbor is dropped, in seconds. */
  holdIntervalSeconds: Scalars['Int']['input'];
  /** The IP address for this neighbor. */
  ipAddress: Scalars['IP']['input'];
  /** Whether the neighbor is enabled. */
  isEnabled?: Scalars['Boolean']['input'];
  /** The period at which BGP keep-alive is sent, in seconds. */
  keepaliveIntervalSeconds: Scalars['Int']['input'];
  /** The MD5 password used for authentication for this neighbor. */
  md5AuthPassword?: InputMaybe<Scalars['String']['input']>;
  /** A descriptive name for this neighbor. If omitted, will default to the IP address and remote ASN. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier for the physical interface used to reach this neighbor. */
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The peer Autonomous System Number (ASN) for this neighbor. */
  remoteASN: Scalars['Uint32']['input'];
  /** The interface used to reach this neighbor. */
  targetInterface?: InputMaybe<TargetInterfaceInput>;
  /** The unique identifier for the VLAN used to reach this neighbor. */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input values for creating a new BGP router. */
export type CreateBgpRouterInput = {
  /** The unique identifier for the Auto VPN group associated with this router. */
  autoVPNGroupUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A longer description for this router. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether this router is is enabled. */
  isEnabled: Scalars['Boolean']['input'];
  /** The local Autonomous System Number (ASN) for this router. */
  localASN: Scalars['Uint32']['input'];
  /** The descriptive short name for this router. */
  name: Scalars['String']['input'];
};

export type CreateBulkNosUpgradeInput = {
  /** Force the NOS upgrades to be scheduled immediately. Overrides the scheduledAtEarliest value. */
  force?: Scalars['Boolean']['input'];
  /** List of UUIDs of the networks to include in the bulk NOS upgrade. */
  networkUUIDs: Array<Scalars['UUID']['input']>;
  /** Identifier of the NOS version to upgrade to. */
  nosVersionID: Scalars['Int']['input'];
  /** If true, any networks provided in the request that already have a pending scheduled upgrade will have that upgrade cancelled and replaced with the upgrade from this request. */
  overwriteExistingScheduledUpgrades?: Scalars['Boolean']['input'];
  /** Timestamp when the bulk NOS upgrade will be scheduled at the earliest. The scheduler will schedule an upgrade at the next maintenance window for each network after this time. If not provided, this value will default to now. */
  scheduledAtEarliest?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input for creating multiple captive portals. */
export type CreateCaptivePortalsInput = {
  /** The input values for the captive portal. */
  input: CaptivePortalSettingsInput;
  /** The unique identifier for the network. */
  networkUUID: Scalars['UUID']['input'];
};

/** Used to create a cellular hardware device. */
export type CreateCellularHardwareDeviceInput = {
  /** The model of the hardware device. */
  deviceModel: DeviceModel;
  /** The MAC address of the hardware device. */
  macAddress?: InputMaybe<Scalars['MacAddress']['input']>;
  /** The serial number of the hardware device. */
  serialNumber: Scalars['String']['input'];
};

/** Input parameters for creating a Client VPN client. */
export type CreateClientVpnClientInput = {
  /** End user's company email associated with the VPN server's controller. */
  email: Scalars['String']['input'];
  /** Whether the client is enabled. If false, users will not be able to connect using this client's key. */
  isEnabled?: Scalars['Boolean']['input'];
  /** End user's device name, e.g., 'paulmbp'. */
  name: Scalars['String']['input'];
  /** A Curve25519 public key generated by the end user using WireGuard. */
  publicKey: Scalars['String']['input'];
};

/** Input parameters for creating a Client VPN server. */
export type CreateClientVpnServerInput = {
  /** IPv4 address to assign to the WireGuard interface. */
  address: Scalars['IPV4']['input'];
  /** Subnet mask length (CIDR notation) for the WireGuard interface address. */
  addressMask: Scalars['Int']['input'];
  /** The UUIDs for the VLANs that are accessible via connections through this client VPN server. */
  boundVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Default list of IP prefixes that clients are allowed to access. */
  defaultClientAllowedIPs?: Array<Scalars['IPPrefix']['input']>;
  /** Sets the default value used for the WireGuard option `DNS` for generated client configs. Must be IP addresses or fully qualified domain names. If set, used instead of `address` or `dnsListenAddress`. */
  defaultClientDNS?: InputMaybe<Array<Scalars['String']['input']>>;
  /** An additional listen address other than `address` this server serves DNS traffic on. It must be a private IP. */
  dnsListenAddress?: InputMaybe<Scalars['IPV4']['input']>;
  /** Whether the client VPN server is enabled. */
  isEnabled?: Scalars['Boolean']['input'];
  /** Set to true to enable failover between uplink physical interfaces (WANs). */
  isFailoverEnabled?: Scalars['Boolean']['input'];
  /** Port number on which the WireGuard server listens for incoming connections. */
  listenPort?: InputMaybe<Scalars['Int']['input']>;
  /** The name of this client VPN server. */
  name?: Scalars['String']['input'];
  /** Allows the client VPN server to be accessible over Auto VPN. */
  participatesInAutoVPN?: Scalars['Boolean']['input'];
  /** UUID of the uplink physical interface that the WireGuard server will listen on. */
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateCompanyInput = {
  /** A prospective company is used for sales purposes. */
  isProspective?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The S3 key (path) of the image file representing the company logo, stored in AWS S3.
   * This is not required; it overrides the default logo that we fetch from a 3rd party service.
   */
  logoS3Key?: InputMaybe<Scalars['String']['input']>;
  /** The name of the company. */
  name: Scalars['String']['input'];
  /** A unique, URL-friendly identifier for the company. */
  slug: Scalars['String']['input'];
};

/** Input for creating a new group-to-role mapping. */
export type CreateCompanyRoleMappingInput = {
  /** The slug of the company to create the mapping for. */
  companySlug: Scalars['String']['input'];
  /** The IdP group name to map. */
  groupName: Scalars['String']['input'];
  /** For network-scoped roles, the UUID of the network. Omit for company-wide roles. */
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** For network-scoped roles, the UUIDs of the networks. Takes precedence over networkUUID when both are provided. */
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The Meter role to assign to users in this group. */
  role: RoleName;
  /** For Meter mappings only: the slug of the company to assign the role at. */
  targetCompanySlug?: InputMaybe<Scalars['String']['input']>;
};

/** Input parameters for creating company SIEM integration. */
export type CreateCompanySiemIntegrationInput = {
  /** The ARN of the AWS Kinesis stream data will be sent to. */
  awsKinesisARN: Scalars['String']['input'];
  /** https://docs.aws.amazon.com/IAM/latest/UserGuide/id_roles_common-scenarios_third-party.html */
  externalID: Scalars['String']['input'];
  /** The role that is granted permission to write to awsKinesisARN that a Meter AWS user will assume. */
  roleARN: Scalars['String']['input'];
};

/** Create a new user for the specified company, with the provided attributes. */
export type CreateCompanyUserInput = {
  /** The email address of the new user. */
  email: Scalars['String']['input'];
  /** The first name of the new user. */
  firstName: Scalars['String']['input'];
  /** The last name of the new user. */
  lastName: Scalars['String']['input'];
  /** If specified, immediately creates the user's roles. */
  roleAssignments?: InputMaybe<Array<UserRoleInput>>;
};

/** Input for creating a new compliance framework */
export type CreateComplianceFrameworkInput = {
  /** Framework slug (e.g. "pci_dss_4_0") - must match JSON filename */
  frameworkSlug: Scalars['String']['input'];
};

/** Input for creating a new compliance report */
export type CreateComplianceReportInput = {
  /** End date of the compliance evaluation period (optional) */
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Framework slug to generate report for */
  frameworkSlug: Scalars['String']['input'];
  /** UUID of the network to generate the report for */
  networkUUID: Scalars['UUID']['input'];
  /** Start date of the compliance evaluation period (optional) */
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input type for creating a new Connect Static Rate. */
export type CreateConnectStaticRateInput = {
  /** UUID of Product type for the rate. */
  connectionTypeUUID: Scalars['UUID']['input'];
  /** Download speed Kbps maximum for speed bucket (exclusive). */
  downloadKbpsMax: Scalars['Int']['input'];
  /** Download speed Kbps minimum for speed bucket (inclusive). */
  downloadKbpsMin: Scalars['Int']['input'];
  /** Install cost in cents. */
  installCostCents: Scalars['Int']['input'];
  /** Monthly recurring cost in cents. */
  monthlyCostCents: Scalars['Int']['input'];
  /** Term of contract in months. */
  termMonths: Scalars['Int']['input'];
};

/** Input for creating a new custom role. */
export type CreateCustomRoleInput = {
  /** An optional built-in role to inherit permissions from. Effective permissions are the union of this role's permissions and the inherited role's permissions. */
  inheritsFromRole?: InputMaybe<RoleName>;
  /** The display name for the new custom role. */
  name: Scalars['String']['input'];
  /** The permissions to assign. The caller must hold every permission listed here. */
  permissions: Array<PermissionType>;
  /** Whether the role is scoped to the company or a specific network. */
  scope: CustomRoleScope;
};

/** Input values for creating a new DDNS record. */
export type CreateDdnsRecordInput = {
  /** Optional description for this DDNS record. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The main domain name, must be a supported domain name. */
  domain: Scalars['String']['input'];
  /** The unique subdomain for this DDNS record. */
  subdomain: Scalars['String']['input'];
};

/** Input for creating a new DHCP option. */
export type CreateDhcpOptionInput = {
  /**
   * The DHCP option code (also called tag). Refer to the IANA DHCP options list:
   * https://www.iana.org/assignments/bootp-dhcp-parameters/bootp-dhcp-parameters.xhtml
   */
  code: Scalars['Int']['input'];
  /** The data value for the DHCP option. */
  data: Scalars['String']['input'];
  /** If this is a custom (nonstandard) DHCP option, the type of the data. */
  dataType?: InputMaybe<DhcpOptionDataType>;
  /** An optional description for the DHCP option. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** If set, the option will only apply to devices with the given Vendor Class Identifier (VCI). */
  vendorClassID?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a DHCP proxy. */
export type CreateDhcpProxyInput = {
  /** The IP address of this DHCP proxy. */
  ipAddress: Scalars['IP']['input'];
  /** The UUID of the uplink physical interface (WAN) that should be used for egress with this proxy. */
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for creating a new DHCP reserved range. */
export type CreateDhcpReservedRangeInput = {
  /** A human-readable description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The last reserved IP address in the range. */
  endIPAddress: Scalars['IP']['input'];
  /** The first reserved IP address in the range. */
  startIPAddress: Scalars['IP']['input'];
};

/** Input for creating DHCP rule filter. */
export type CreateDhcpRuleFilterInput = {
  /** The MAC address this rule allows. */
  allowedMACAddress?: InputMaybe<Scalars['MacAddress']['input']>;
  /** The MAC address OUI this rule allows. This is in the format XX:XX:XX */
  allowedOUI?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new DHCP rule. */
export type CreateDhcpRuleInput = {
  /** A list of DHCP proxies to create alongside the rule. */
  dhcpProxies?: InputMaybe<Array<CreateDhcpProxyInput>>;
  /** Enables or disables DNS caching on the DHCP server. */
  dnsCacheIsEnabled?: Scalars['Boolean']['input'];
  /** Specifies the maximum Time-To-Live (TTL) in seconds for cached DNS entries. */
  dnsCacheMaxTTL?: Scalars['Int']['input'];
  /** Specifies the maximum number of DNS records to cache. */
  dnsCacheSize?: Scalars['Int']['input'];
  /** IP used as DNS proxy before forwarding requests to upstream DNS servers. Must be within the DHCP rule subnet and must be within a reserved range and not used by a static mapping. */
  dnsForwardingIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** A list of DNS search domains provided to DHCP clients. */
  dnsSearchDomains?: Array<Scalars['String']['input']>;
  /** List of upstream DNS servers to use.. */
  dnsUpstreamServers?: Array<Scalars['IP']['input']>;
  /** Determines if the gateway acts as a DNS proxy for clients. */
  dnsUseGatewayProxy?: Scalars['Boolean']['input'];
  /** The last available IP address in the DHCP range, ascending and inclusive. Omitted if DHCP is not being served. */
  endIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The gateway IP address provided to DHCP clients. */
  gatewayIPAddress: Scalars['IP']['input'];
  /** The prefix length of the gateway IP address. */
  gatewayPrefixLength: Scalars['Int']['input'];
  /** If set, the gateway IP address is allowed to be different from its VLAN's address. */
  hasGatewayOverride?: Scalars['Boolean']['input'];
  /** Indicates whether this DHCP rule is for IPv6 (`true`) or IPv4 (`false`). */
  isIPv6: Scalars['Boolean']['input'];
  /** The duration (in seconds) of the DHCP lease assigned to clients. Omitted if DHCP is not being served. */
  leaseDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The first available IP address in the DHCP range, ascending and inclusive. Omitted if DHCP is not being served. */
  startIPAddress?: InputMaybe<Scalars['IP']['input']>;
};

/** Input for creating a DHCP static mapping on a specific DHCP rule. */
export type CreateDhcpStaticMappingForRuleInput = {
  /** The UUID of the DHCP rule to add the static mapping to. */
  dhcpRuleUUID: Scalars['UUID']['input'];
  /** Input data for creating the DHCP static mapping. */
  input: CreateDhcpStaticMappingInput;
};

/** Input for creating a new DHCP static mapping. */
export type CreateDhcpStaticMappingInput = {
  /** The hostname to assign to the client device. */
  hostname?: InputMaybe<Scalars['String']['input']>;
  /** The fixed IP address to assign to the client device. */
  ipAddress: Scalars['IP']['input'];
  /** The MAC address of the client device. */
  macAddress: Scalars['MacAddress']['input'];
  /** A name or label for this static mapping. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new DNS host mapping. */
export type CreateDnsHostMappingInput = {
  /** The domain to which `overrideDomain` should resolve. Acts like a 'CNAME' record if specified. */
  destinationDomain?: InputMaybe<Scalars['String']['input']>;
  /**
   * The IP address to which `overrideDomain` should resolve. Acts like an 'A' record if specified.
   * Mutually exclusive with `destinationIPAddresses`.
   */
  destinationIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The IP addresses to which `overrideDomain` should resolve. Acts like one or more 'A' records if specified. */
  destinationIPAddresses?: InputMaybe<Array<Scalars['IP']['input']>>;
  /** Indicates whether this DNS host mapping is enabled. Defaults to `true`. */
  isEnabled?: Scalars['Boolean']['input'];
  /** The domain name to override. This can be a fully qualified domain name (FQDN) or a domain name. */
  overrideDomain: Scalars['String']['input'];
};

export type CreateDeploymentTaskBlockerInput = {
  /** The UUID of the task that is being blocked */
  blockedTaskUUID: Scalars['UUID']['input'];
  /** The UUID of the task that is doing the blocking */
  blockingTaskUUID: Scalars['UUID']['input'];
};

export type CreateDeploymentTaskExceptionInput = {
  /** The deployment task to raise an exception on. */
  deploymentTaskUUID: Scalars['UUID']['input'];
  /** If set, reopens this task (clears its completed state) and attaches the exception to it instead of deploymentTaskUUID. The task must belong to the same Deliverable as deploymentTaskUUID. Any tasks downstream of it (ie those with explicit DeploymentTaskBlockers) will also be reopened. */
  deploymentTaskUUIDToReopen?: InputMaybe<Scalars['UUID']['input']>;
  /** Freeform notes describing the issue. */
  description: Scalars['String']['input'];
  /** User IDs to tag for follow-up. If none provided, the creator of the task's Deliverable will be tagged. The user creating the exception will always be tagged upon creation. */
  taggedUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreateDeploymentTaskExceptionMessageInput = {
  /** The exception to post a message on. */
  deploymentTaskExceptionUUID: Scalars['UUID']['input'];
  /** Message content. */
  message: Scalars['String']['input'];
};

/**
 * Create a time window on a network. Job and installer links are optional.
 * A linked job must belong to the window's network. Installer links apply only
 * to this window and do not change the job's installer assignments.
 */
export type CreateDeploymentTimeWindowInput = {
  /** The optional job linked to this window. Must belong to the specified network. */
  deploymentJobUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** End of the window. Must be strictly after startAt. */
  endAt: Scalars['DateTime']['input'];
  /** Installation companies to link to this window. Omitted or empty means no companies. */
  installCompanyUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Technicians to link to this window. Omitted or empty means no technicians. */
  installTechnicianUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Whether the installer has confirmed this window. Omitted or null means not confirmed. */
  installerConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether Meter has confirmed this window. Omitted or null means not confirmed. */
  meterConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The network this window belongs to. */
  networkUUID: Scalars['UUID']['input'];
  /** Additional information about the window. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Start of the window. */
  startAt: Scalars['DateTime']['input'];
  /** The kind of availability or work. */
  type: DeploymentTimeWindowType;
};

/** Used to create a hardware device in the dev (staging) realm for testing purposes. */
export type CreateDevHardwareDeviceInput = {
  /** The model of the hardware device. */
  deviceModel: DeviceModel;
  /** The type of the hardware device. */
  deviceType: DeviceType;
  /** The MAC address of the hardware device. */
  macAddress?: InputMaybe<Scalars['MacAddress']['input']>;
  /** The serial number of the hardware device to mark as 'dev'. */
  serialNumber: Scalars['String']['input'];
};

export type CreateDeviceBatchInput = {
  /** The name of the device batch to create. */
  batchName: Scalars['String']['input'];
  /** The number of hardware devices to generate in this batch. */
  count: Scalars['Int']['input'];
  /** An optional custom prefix to use for the generated serial numbers. If not provided, a default prefix based on the device model will be used. */
  customSerialPrefix?: InputMaybe<Scalars['String']['input']>;
  /** The model of the hardware devices in this batch. */
  deviceModel: DeviceModel;
};

/** Input for creating a MAC allocation block for a device family. */
export type CreateDeviceMacAllocationInput = {
  /** The inclusive lower bound of the MAC address range for this block. */
  lowerMACBound: Scalars['MacAddress']['input'];
  /** The next MAC address to allocate from this block. If not provided, the next MAC will be set to the lower bound. */
  nextMAC?: InputMaybe<Scalars['MacAddress']['input']>;
  /** The inclusive upper bound of the MAC address range for this block. */
  upperMACBound: Scalars['MacAddress']['input'];
};

/** Input type for creating a device notification snooze. Specifying multiple device UUIDs creates one snooze per device. Every device UUID must belong to the supplied network. */
export type CreateDeviceNotificationSnoozeInput = {
  /** Alert types this snooze applies to. Omit or leave empty to snooze all alert types. */
  alertTypes?: InputMaybe<Array<AlertType>>;
  /** The network the snoozed devices belong to. */
  networkUUID: Scalars['UUID']['input'];
  /** The reason for the snooze. */
  snoozeReason?: InputMaybe<Scalars['String']['input']>;
  /** The virtual devices to snooze. Every UUID must belong to networkUUID. */
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']>;
  /** The time window for the snooze. */
  window: SnoozeNotificationSettingWindowInput;
};

export type CreateDocumentUploadInput = {
  /** The deployment-job document classification. Only set for uploads created from the deployment-job flows. */
  deploymentJobDocumentType?: InputMaybe<DocumentUploadDeploymentJobDocumentType>;
  /** The unique identifiers of the deployment jobs to scope the document upload to. */
  deploymentJobUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A description of the document upload. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** A human-readable name or label for the document upload. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifiers of the networks to scope the document upload to. */
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The S3 key (path) of the uploaded file. Exactly one of s3Key or url must be provided. */
  s3Key?: InputMaybe<Scalars['String']['input']>;
  /** The type of the externally hosted document. */
  type?: InputMaybe<DocumentUploadType>;
  /** The URL of the externally hosted document. Exactly one of s3Key or url must be provided. */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDynamicFloorPlanOpenIntentUploadInput = {
  /** Mappings from OpenIntent floor UUIDs to Meter floor numbers. */
  floorMappings: Array<DynamicFloorPlanOpenIntentFloorMappingInput>;
};

/** The result of creating an OpenIntent floor plan upload. */
export type CreateDynamicFloorPlanOpenIntentUploadPayload = {
  __typename?: 'CreateDynamicFloorPlanOpenIntentUploadPayload';
  /** The pre-signed URL for uploading the OpenIntent zip file to S3. */
  presignedUrl: Scalars['String']['output'];
  /** The S3 key where the OpenIntent zip file should be uploaded. */
  s3Key: Scalars['String']['output'];
  /** The unique identifier of the created OpenIntent upload record. */
  uploadUUID: Scalars['UUID']['output'];
};

/** Input type for creating a new 802.1X encryption configuration. */
export type CreateEncryption8021XInput = {
  /** The IP address of the accounting server. If provided, accountingServerPort and accountingServerSecret must also be provided. */
  accountingServerIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The port of the accounting server. Required if accountingServerIPAddress is provided. */
  accountingServerPort?: InputMaybe<Scalars['Int']['input']>;
  /** The shared secret used to authenticate with the accounting server. Required if accountingServerIPAddress is provided. */
  accountingServerSecret?: InputMaybe<Scalars['String']['input']>;
  /** The IP address of the authentication server. */
  authServerIPAddress: Scalars['IP']['input'];
  /** The port of the authentication server. */
  authServerPort: Scalars['Int']['input'];
  /** The shared secret used to authenticate with the authentication server. */
  authServerSecret: Scalars['String']['input'];
  /** A user-friendly label for the encryption configuration. */
  label: Scalars['String']['input'];
  /** The UUID of the network where the encryption configuration will be created. */
  networkUUID: Scalars['UUID']['input'];
};

/** The fields needed to retrieve an ids event from stats. */
export type CreateFirewallRuleIdsEventInput = {
  /** When the event was observed at. */
  observedAt: Scalars['DateTime']['input'];
  /** The UUID of the virtual device that created the event. */
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** Input type for creating a new firewall rule. */
export type CreateFirewallRuleInput = {
  /** The action to take when the firewall rule matches (e.g., DENY or PERMIT). */
  action: FirewallRuleAction;
  /**
   * List of UUIDs of physical interfaces to which the firewall rule is bound.
   * The physical interfaces must be uplinks.
   */
  boundPhyInterfaceUUIDs: Array<Scalars['UUID']['input']>;
  /** List of UUIDs of VLANs to which the firewall rule is bound. */
  boundVLANUUIDs: Array<Scalars['UUID']['input']>;
  /** A description of the firewall rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Destination IPv4 address patterns to match traffic to, e.g. `10.1-4.*.2/31`.
   * May be combined with `dstPrefixes`.
   */
  dstAddressPatterns?: InputMaybe<Array<Scalars['IPAddressPattern']['input']>>;
  /** UUID of the destination client VPN server to match traffic to. */
  dstClientVPNServerUUID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Destination FQDNs to match traffic to: an exact name, or `*.` followed by a name to match its subdomains only.
   * Matches the addresses the device has seen each name resolve to in the DNS answers it serves.
   * May be combined with `dstPrefixes` and `dstAddressPatterns`.
   */
  dstFQDNs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** UUID of the destination IPSec tunnel to match traffic to. */
  dstIPSecTunnelUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Deprecated. Use `dstPortRanges` instead. Single destination port range to match. */
  dstPortRange?: InputMaybe<PortRangeInput>;
  /** List of destination port ranges to match traffic to. */
  dstPortRanges?: InputMaybe<Array<PortRangeInput>>;
  /** Destination IP prefix to match traffic to. */
  dstPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
  /** Destination IP prefixes to match traffic to. */
  dstPrefixes?: InputMaybe<Array<Scalars['IPPrefix']['input']>>;
  /** UUID of the destination VLAN to match traffic to. */
  dstVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Creates a firewall rules based on an IDS event. If provided, ignores all fields other than name, isEnabled, and isInternal. */
  idsEvent?: InputMaybe<CreateFirewallRuleIdsEventInput>;
  /** Indicates if the firewall rule should be applied bidirectionally. */
  isBidirectional?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the firewall rule is currently enabled. */
  isEnabled: Scalars['Boolean']['input'];
  /** Indicates that the rule is managed by Meter and cannot be modified. */
  isMeterInternal?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the firewall rule. */
  name: Scalars['String']['input'];
  /**
   * Priority of the rule within the network, lower priority rules are applied first.
   * If there is an existing rule with the provided value, it and all subsequent occupied values will be incremented.
   * If omitted, next lowest priority in network will be used.
   */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Deprecated. Use `protocols` instead. Single IP protocol to match. */
  protocol?: InputMaybe<IpProtocol>;
  /** List of IP protocols to match. */
  protocols?: InputMaybe<Array<IpProtocol>>;
  /**
   * Source IPv4 address patterns to match traffic from, e.g. `10.1-4.*.2/31`.
   * May be combined with `srcPrefixes`.
   */
  srcAddressPatterns?: InputMaybe<Array<Scalars['IPAddressPattern']['input']>>;
  /** UUID of the source client VPN server to match traffic from. */
  srcClientVPNServerUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** UUID of the source IPSec tunnel to match traffic from. */
  srcIPSecTunnelUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Deprecated. Use `srcPortRanges` instead. Single source port range to match. */
  srcPortRange?: InputMaybe<PortRangeInput>;
  /** List of source port ranges to match traffic from. */
  srcPortRanges?: InputMaybe<Array<PortRangeInput>>;
  /** Source IP prefix to match traffic from. */
  srcPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
  /** Source IP prefixes to match traffic from. */
  srcPrefixes?: InputMaybe<Array<Scalars['IPPrefix']['input']>>;
  /** UUID of the source VLAN to match traffic from. */
  srcVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** List of tags associated with the firewall rule. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input type for creating multiple firewall rules. */
export type CreateFirewallRulesInput = {
  /** The input values to create the firewall rule. */
  input: CreateFirewallRuleInput;
  /** The unique identifier of the network in which to create the firewall rule. */
  networkUUID: Scalars['UUID']['input'];
};

export type CreateFloorPlanInput = {
  /** A description of the new floor plan. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The type of the document, will default to FLOOR_PLAN if not provided. */
  documentCategory?: InputMaybe<FloorPlanDocumentCategory>;
  /** The S3 key (path) of the image file representing the floor plan to be uploaded. */
  imageS3Key: Scalars['String']['input'];
  /** A human-readable name or label for the new floor plan. */
  label: Scalars['String']['input'];
};

/** Input type for creating a global notification snooze. */
export type CreateGlobalNotificationSnoozeInput = {
  /** The alert types to suppress. Must be non-empty. */
  alertTypes: Array<AlertType>;
  /** When the snooze expires. Omit for a snooze with no end; it stays active until deleted. */
  snoozeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** The reason for the snooze. */
  snoozeReason: Scalars['String']['input'];
  /** When the snooze becomes active. */
  snoozeStart: Scalars['DateTime']['input'];
};

/** Input type for creating a hardware device pair. */
export type CreateHardwareDevicePairInput = {
  /** The type of devices in the pair. */
  deviceType: DeviceType;
  /** The serial number of the left device in the pair. */
  leftDeviceSerial: Scalars['String']['input'];
  /** The serial number of the right device in the pair. */
  rightDeviceSerial: Scalars['String']['input'];
};

/** Input type for creating a high availability firewall pair. */
export type CreateHighAvailabilityPairInput = {
  /** Interval at which the firewall will advertise to one another, in milliseconds. Must be at least 300ms. */
  advertisementIntervalMs?: Scalars['Int']['input'];
  /**
   * VLAN ID to use for the advertisement VLAN.
   * One of `advertisementVLANUUID`, `advertisementVLANInput`, or `advertisementVLANID` must be provided.
   */
  advertisementVLANID?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Existing VLAN UUID to use for the advertisement VLAN.
   * One of `advertisementVLANUUID`, `advertisementVLANInput`, or `advertisementVLANID` must be provided.
   */
  advertisementVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Input parameters to use for the new advertisement VLAN.
   * One of `advertisementVLANUUID`, `advertisementVLANInput`, or `advertisementVLANID` must be provided.
   */
  createAdvertisementVLANInput?: InputMaybe<CreateVlanInput>;
  /** Enable or disable preemption for the HA firewall in VRRP. */
  preempt: Scalars['Boolean']['input'];
};

/** Input type for creating a new host monitoring target. */
export type CreateHostMonitoringTargetInput = {
  /** A descriptive text about the host monitoring target. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether the host monitoring target is enabled. */
  isEnabled?: Scalars['Boolean']['input'];
  /** Whether this target is used to compute whether a WAN should failover. Only available if `type` is `PING`. */
  isUsedForWANFailover?: Scalars['Boolean']['input'];
  /**
   * The target host to monitor.
   *
   * Currently, only IPv4 addresses are permitted.
   */
  targetHost: Scalars['IPV4']['input'];
  /** The type of monitoring to perform on the target host. */
  type: HostMonitoringType;
};

export type CreateHotspot20Input = {
  /** An optional value for the Hotspot 2.0 Access network type. */
  accessNetworkType?: InputMaybe<Scalars['Int']['input']>;
  /** A list of Hotspot 2.0 domain names. */
  domainNames: Array<Scalars['String']['input']>;
  /** Whether the Hotspot 2.0 is enabled */
  isEnabled: Scalars['Boolean']['input'];
  /** Optional label for the Hotspot 2.0 profile. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** A list of MCC/MNC pairs, formatted as "MCC,MNC". */
  mccMncPairs: Array<Scalars['String']['input']>;
  /** A list of Hotspot 2.0 NAI realms. */
  naiRealms: Array<Scalars['String']['input']>;
  /** A list of Operator names for Hotspot 2.0 (one per language). */
  operatorNames: Array<Scalars['String']['input']>;
  /** A list of Hotspot 2.0 Consortium OIs (Organization Identifiers). */
  roamingConsortiumOIs: Array<Scalars['String']['input']>;
  /** An optional value for the Hotspot 2.0 Venue group. */
  venueGroup?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A list of Venue names for Hotspot 2.0 (one per language); must be formatted with a two or three character language code separated by a colon from the venue name.
   * If at least one is set, hs20VenueGroup and hs20VenueType must be set.
   */
  venueNames: Array<Scalars['String']['input']>;
  /** An optional value for the Hotspot 2.0 Venue type. */
  venueType?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateIdsipsConfigInput = {
  /** VLANs to enable IDS/IPS for. */
  enabledVLANUUIDs: Array<Scalars['UUID']['input']>;
  /** How long rules generated by IPS stay valid. */
  ipsRuleDuration?: InputMaybe<Scalars['Duration']['input']>;
  /** If east-west protection is enabled. */
  isEastWestProtectionEnabled?: Scalars['Boolean']['input'];
  /** The IPS minimum severity to act on. */
  minIPSSeverity?: InputMaybe<Scalars['Int']['input']>;
  /** The IDS minimum severity to act on. */
  minSeverity?: Scalars['Int']['input'];
  /** The mode IDS/IPS should act in. */
  mode: IdsipsMode;
  /** List of subnets that should never be blocked. */
  safelist?: InputMaybe<Array<Scalars['IPPrefix']['input']>>;
};

/** A custom intrusion rule definition for IDS/IPS. These currently apply tls.sni rules. */
export type CreateIdsipsCustomRuleInput = {
  /** The action this rule applies. */
  action: FirewallRuleAction;
  /** The ID of the Netstar application to associate with the rule. */
  applicationID?: InputMaybe<Scalars['Int']['input']>;
  /** List of UUIDs of VLANs to which the rule is bound. */
  boundVLANUUIDs: Array<Scalars['UUID']['input']>;
  /** The FQDN this rule applies to. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** If this rule is enabled. */
  isEnabled: Scalars['Boolean']['input'];
  /** A name to identify this rule. */
  name: Scalars['String']['input'];
};

/** Input for creating IP forwarding rule. */
export type CreateIpForwardingRuleInput = {
  /** If rule is enabled. */
  isEnabled?: Scalars['Boolean']['input'];
  /** Name of this rule. */
  name: Scalars['String']['input'];
  /** The uplink interface associated with the rule. */
  uplinkPhyInterfaceUUID: Scalars['UUID']['input'];
  /** The UUID of VLAN associated with this rule. */
  vlanUUID: Scalars['UUID']['input'];
};

/** Input type for creating a new IPSec tunnel. */
export type CreateIpSecTunnelInput = {
  /** Sets if outbound traffic can be sent over this tunnel */
  allowOutboundTraffic?: Scalars['Boolean']['input'];
  /** The authentication algorithm to use for the IPSec connection. */
  authenticationAlgorithm?: InputMaybe<IpSecAuthenticationAlgorithm>;
  /** List of Auto VPN spoke VLANs to bind the IPSec tunnel to. */
  autoVPNVLANs?: InputMaybe<Array<IpSecTunnelAutoVpnvlanInput>>;
  /** Sets the close action for the tunnel. */
  closeAction?: InputMaybe<IpSecCloseAction>;
  /** Sets the DPD action for the tunnel. */
  dpdAction?: InputMaybe<IpSecDpdAction>;
  /** Sets the DPD delay for the tunnel. */
  dpdDelay?: InputMaybe<Scalars['Duration']['input']>;
  /** Sets the DPD timeout for the tunnel. */
  dpdTimeout?: InputMaybe<Scalars['Duration']['input']>;
  /** The encryption algorithm to use for the IPSec connection. */
  encryptionAlgorithm?: InputMaybe<IpSecEncryptionAlgorithm>;
  /** Sets the ikelifetime for the tunnel. */
  ikeLifetime?: InputMaybe<Scalars['Duration']['input']>;
  /** Whether BGP can be used for this tunnel. */
  isBGPEnabled?: Scalars['Boolean']['input'];
  /**
   * If true, adds Client VPN subnets to the local traffic selectors,
   * effectively allowing Client VPN clients to route traffic over the IPSec tunnel.
   */
  isClientVPNBound?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the IPSec tunnel should be enabled upon creation. */
  isEnabled: Scalars['Boolean']['input'];
  /** Indicates whether this tunnel should initiate the connection to the right participant; defaults to false. */
  isInitiator?: Scalars['Boolean']['input'];
  /** The Diffie-Hellman group to use for key exchange in the IPSec connection. */
  keyExchangeDHGroup?: InputMaybe<IpSecDhGroup>;
  /** Identifier for the left participant (this side) for authentication purposes. */
  leftID: Scalars['String']['input'];
  /** The MTU of the tunnel interface in bytes. When null, the device default is used. */
  mtu?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the IPSec tunnel. */
  name: Scalars['String']['input'];
  /** Allows for vendor specific configuration based on this peer type */
  peerType?: InputMaybe<IpSecPeerType>;
  /** The authentication algorithm used in Phase 2  for the IPSec connection. */
  phase2AuthenticationAlgorithm?: InputMaybe<IpSecAuthenticationAlgorithm>;
  /** The encryption algorithm used in Phase 2 for the IPSec connection. */
  phase2EncryptionAlgorithm?: InputMaybe<IpSecEncryptionAlgorithm>;
  /** The Diffie-Hellman group used in Phase 2 for key exchange in the IPSec connection. */
  phase2KeyExchangeDHGroup?: InputMaybe<IpSecDhGroup>;
  /** UUID of the physical interface to bind the IPSec tunnel to; must be an uplink interface. */
  phyInterfaceUUID: Scalars['UUID']['input'];
  /** The pre-shared key for authentication; can be base64 encoded or plaintext. */
  presharedKey: Scalars['String']['input'];
  /** Priority for the interface, lower priorities will be preferred. Only available for supporting implementations. */
  priority?: Scalars['Int']['input'];
  /** Sets the reauth for the tunnel, true = yes, false = no */
  reauth?: Scalars['Boolean']['input'];
  /** Sets the rekey for the tunnel, true = yes, false = no */
  rekey?: Scalars['Boolean']['input'];
  /** The public IP address or hostname of the right participant's gateway. */
  right?: InputMaybe<Scalars['String']['input']>;
  /** Identifier for the right participant (remote side) for authentication purposes. */
  rightID: Scalars['String']['input'];
  /** List of IP prefixes representing the private subnets behind the right participant. */
  rightPrefixes: Array<Scalars['IPPrefix']['input']>;
  /** Sets if outbound traffic can be sent over this tunnel */
  useAsDefaultRoute?: Scalars['Boolean']['input'];
  /** List of VLAN UUIDs to bind the IPSec tunnel to. */
  vlanUUIDs: Array<Scalars['UUID']['input']>;
  /** Virtual Tunnel Interfaces for the tunnel. */
  vti?: InputMaybe<IpSecTunnelVtiInput>;
  /** Weight for the interface, higher values will be given more weight when multiple tunnels are active. Only available for supporting implementations. */
  weight?: Scalars['Int']['input'];
};

export type CreateInternalNoteInput = {
  /** Indicates whether the note is marked as important. */
  isImportant?: Scalars['Boolean']['input'];
  /** Content of the internal note. */
  note: Scalars['String']['input'];
  /** Attach up to five photos. Use `createPreSignedUploadUrl` to generate the S3 keys and presigned upload URLs. */
  photoS3Keys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tags associated with the note. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input type for creating an ISP document. */
export type CreateInternetServicePlanDocumentInput = {
  /** UUID of isp to associate the job with. */
  ispUUID: Scalars['UUID']['input'];
  /** Name of the document. */
  name: Scalars['String']['input'];
  /** Notes regarding the document. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** S3 key of the document. */
  s3Key: Scalars['String']['input'];
  /** Type of document. */
  type: InternetServicePlanDocumentType;
};

/** Input type for creating a fulfillment job. */
export type CreateInternetServicePlanFulfillmentJobInput = {
  /** Estimated date of completion. */
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** UUID of isp to associate the job with. */
  ispUUID: Scalars['UUID']['input'];
  /** Notes regarding the job. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Job type. */
  type: InternetServicePlanFulfillmentJobType;
};

/** Input type for creatng a fulfillment task. */
export type CreateInternetServicePlanFulfillmentTaskInput = {
  /** Date completed. */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** UUID of job to associate the task with. */
  jobUUID: Scalars['UUID']['input'];
  /** Notes regarding the task. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Date scheduled to start. */
  scheduledFor?: InputMaybe<Scalars['DateTime']['input']>;
  /** Date started. */
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Task type. */
  type: InternetServicePlanFulfillmentTaskType;
};

/** Input type for creating a new Internet Service Plan. */
export type CreateInternetServicePlanInput = {
  /** Provider account number of the plan. */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Provider account number PIN. */
  accountPIN?: InputMaybe<Scalars['String']['input']>;
  /** Physical address associated with the Internet Service Plan. */
  address?: InputMaybe<CreateAddressInput>;
  /** Meter is to handle billing for this plan. */
  billingRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique identifier of the provider that brokered the ISP. */
  brokerProviderUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Connection details, including product and status. */
  connection: InternetServicePlanConnectionInput;
  /** Download speed of the plan. */
  downloadKbps?: InputMaybe<Scalars['Int']['input']>;
  /** Additional cost incurred to expedite the install, if any. */
  expeditedInstallCostCents?: InputMaybe<Scalars['Int']['input']>;
  /** Handoff type left by ISP. */
  handoffType?: InputMaybe<IspHandoffType>;
  /** Indicates whether the ISP connection has or is to have a static IP address or range. */
  hasStaticIP?: InputMaybe<Scalars['Boolean']['input']>;
  /** Install costs cost of the plan.  */
  installCostCents?: InputMaybe<Scalars['Int']['input']>;
  /** Wholesale install cost of the plan. */
  installCostWholesaleCents?: InputMaybe<Scalars['Int']['input']>;
  /** The install was escalated. */
  installEscalated?: InputMaybe<Scalars['Boolean']['input']>;
  /** The install was expedited. */
  installExpedited?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL from Provider for tracking install progress. */
  installationTrackingURL?: InputMaybe<Scalars['String']['input']>;
  /** IP configuration details provided by the ISP. */
  ipConfiguration: InternetServicePlanIpInput;
  /** Monthly recurring cost of the plan. */
  monthlyCostCents?: InputMaybe<Scalars['Int']['input']>;
  /** Monthly wholesale cost of the plan. */
  monthlyCostWholesaleCents?: InputMaybe<Scalars['Int']['input']>;
  /** Signals when the ISP data should be reviewed by Connect, typically for when data was provided by the customer. */
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Freeform notes associated with the plan. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Origin of the plan. */
  origin?: InputMaybe<InternetServicePlanOrigin>;
  /** The owner of the plan. */
  owner?: InputMaybe<InternetServicePlanOwner>;
  /** Procurement channel/pricing method for the circuit. */
  procurementChannel?: InputMaybe<ConnectProcurementChannel>;
  /** Label the provider tags the circuit with in the physical space after install completion. */
  providerCircuitID?: InputMaybe<Scalars['String']['input']>;
  /** External ID of associated order in Provider API. */
  providerOrderID?: InputMaybe<Scalars['String']['input']>;
  /** External ID of associated circuit/service in Provider API. */
  providerServiceID?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of the ISP provider. */
  providerUUID: Scalars['UUID']['input'];
  /** Cost of the riser work associated with fulfilling this plan. */
  riserCostCents?: InputMaybe<Scalars['Int']['input']>;
  /** Unique identifier of the underlying ISP provider. */
  subProviderUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Unique identifier of the sublocation to associate with the Internet Service Plan. */
  sublocationUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Internal users handling fulfillment/support for the plan. */
  supportUsers?: InputMaybe<Array<InternetServicePlanSupportUserInput>>;
  /** Length of the contract in months. */
  termMonths?: InputMaybe<Scalars['Int']['input']>;
  /** Actual contract term in months committed to with the underlying carrier, which may differ from the customer-facing termMonths. */
  termMonthsInternal?: InputMaybe<Scalars['Int']['input']>;
  /** Upload speed of the plan. */
  uploadKbps?: InputMaybe<Scalars['Int']['input']>;
  /** The far-end (Z-side) address for a point-to-point circuit product. Looked up or created as needed. */
  zSideAddress?: InputMaybe<CreateAddressInput>;
};

/** Input type for creating an ISP payment resource. */
export type CreateInternetServicePlanPaymentResourceInput = {
  /** Expected monthly spend on this resource, in cents. For Ramp, this also sets the card's initial monthly spend limit. */
  expectedSpendCents: Scalars['Int']['input'];
  /** UUID of the ISP to associate the payment resource with. */
  ispUUID: Scalars['UUID']['input'];
  /** Vendor to create the payment resource with. Determines the resulting payment type (Ramp creates a card, Increase creates a bank account). */
  paymentVendor: InternetServicePlanPaymentResourceVendor;
};

/** Input type for creating a new Internet Service Plan Provider. */
export type CreateInternetServicePlanProviderInput = {
  /** Alternative names for Internet Service Provider used in 3rd party APIs */
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contract terms this provider offers, per connection type. */
  connectionTypeTerms?: InputMaybe<Array<ProviderConnectionTypeTermInput>>;
  /** AWS S3 key of the square icon image. */
  iconS3Key?: InputMaybe<Scalars['String']['input']>;
  /** AWS S3 key of the landscape logo image. */
  logoS3Key?: InputMaybe<Scalars['String']['input']>;
  /** Name of the provider. */
  name: Scalars['String']['input'];
};

/** Input type for creating a new Internet Service Plan Provider Static Rate. */
export type CreateInternetServicePlanProviderStaticRateInput = {
  /** UUID of Product type for the rate. */
  connectionTypeUUID: Scalars['UUID']['input'];
  /** Data cap in GB. */
  dataCapGB?: InputMaybe<Scalars['Int']['input']>;
  /** Download speed Kbps. */
  downloadKbps: Scalars['Int']['input'];
  /** Enabled status of the rate. */
  enabled: Scalars['Boolean']['input'];
  /** Install cost in cents. */
  installCostCents: Scalars['Int']['input'];
  /** Install wholesale cost. */
  installCostWholesaleCents?: InputMaybe<Scalars['Int']['input']>;
  /** Describes dependency of the static rate on a location. */
  locationMode: InternetServicePlanProviderStaticRateLocationMode;
  /** Monthly recurring cost in cents. */
  monthlyCostCents: Scalars['Int']['input'];
  /** Monthly wholesale cost. */
  monthlyCostWholesaleCents?: InputMaybe<Scalars['Int']['input']>;
  /** Procurement channel/pricing method for the proposed circuit. */
  procurementChannel?: InputMaybe<ConnectProcurementChannel>;
  /** UUID of the Internet Service Plan Provider offering the product. */
  providerUUID: Scalars['UUID']['input'];
  /** Term of contract in months. */
  termMonths: Scalars['Int']['input'];
  /** Upload speed Kbps. */
  uploadKbps: Scalars['Int']['input'];
};

/** The input for creating a lab reservation. */
export type CreateLabReservationInput = {
  /** The end time of this reservation. */
  endTime: Scalars['DateTime']['input'];
  /** The resources to reserve. At least one is required. */
  labResourceUUIDs: Array<Scalars['UUID']['input']>;
  /** The note for this reservation. */
  note: Scalars['String']['input'];
  /** The start time of this reservation. */
  startTime: Scalars['DateTime']['input'];
};

/** Input for reserving a number of interchangeable resources of one kind. */
export type CreateLabReservationsByKindInput = {
  /** The end time of the reservations. */
  endTime: Scalars['DateTime']['input'];
  /** The kind of resource to reserve, matched exactly. */
  kind: Scalars['String']['input'];
  /**
   * Only consider resources whose metadata contains these keys and values, for example
   * {"region": "east-us-2"}. Values must match exactly; extra keys on the resource are fine.
   */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The note applied to every reservation created. */
  note: Scalars['String']['input'];
  /** How many resources of that kind to reserve. */
  quantity: Scalars['Int']['input'];
  /** The start time of the reservations. */
  startTime: Scalars['DateTime']['input'];
};

/** Input for creating a lab resource. */
export type CreateLabResourceInput = {
  /** The kind of lab resource. */
  kind: Scalars['String']['input'];
  /** The metadata for this lab resource. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The name of the lab resource. */
  name: Scalars['String']['input'];
  /** The parent lab resource if any. */
  parent?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input type for creating a mailing address. */
export type CreateMailingAddressInput = {
  /** The city of the mailing address. */
  city: Scalars['String']['input'];
  /** The two-letter ISO code of the country. */
  countryISO2: Scalars['String']['input'];
  /** The first line of the mailing address, usually the street address. */
  line1: Scalars['String']['input'];
  /** The second line of the mailing address, such as apartment or suite number. */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** The postal code or ZIP code of the mailing address. */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** The subdivision code, such as the state or province code. */
  subdivisionCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMarketingChangelogEntryInput = {
  /** Properties to display inside a badge alongside the changelog entry. */
  badge?: InputMaybe<DisplayBadgeInput>;
  /** Descriptive copy text for the marketing changelog entry. */
  copy?: InputMaybe<Scalars['String']['input']>;
  /** Informational heading text for the marketing changelog entry. */
  heading: Scalars['String']['input'];
  /** A pair of theme-dependent images to display alongside the changelog entry. */
  imageS3Keys?: InputMaybe<ThemedImageS3KeysInput>;
  /** A destination to link to that contains more information about the changelog entry. */
  linkURL?: InputMaybe<Scalars['String']['input']>;
  /** When the entry stops being visible to customers. */
  visibleEndAt: Scalars['DateTime']['input'];
  /** When the entry starts being visible to customers. */
  visibleStartAt: Scalars['DateTime']['input'];
};

/** Input values for creating a monitor group. */
export type CreateMonitorGroupInput = {
  /** Desired set of members. */
  members?: InputMaybe<Array<MonitorGroupMemberInput>>;
  /** Name of the group. */
  name: Scalars['String']['input'];
  /** Percentage of probes that must be healthy (0-100.00). */
  requiredHealthyPercent: Scalars['Float']['input'];
};

/** Input for creating a probe binding. */
export type CreateMonitorProbeBindingInput = {
  /** Target interface for this binding. */
  targetInterface: TargetInterfaceInput;
};

/** Input values for creating a monitor probe. */
export type CreateMonitorProbeInput = {
  /** Desired set of bindings. */
  bindings?: InputMaybe<Array<CreateMonitorProbeBindingInput>>;
  /** DNS probe parameters (required if type is DNS). */
  dnsParams?: InputMaybe<DnsProbeParamsInput>;
  /** ICMP probe parameters (required if type is ICMP). */
  icmpParams?: InputMaybe<IcmpProbeParamsInput>;
  /** Time between probe attempts. */
  probeInterval: Scalars['Duration']['input'];
  /** Random jitter added to probe interval. */
  probeJitter?: Scalars['Duration']['input'];
  /** Maximum time to wait for probe response. */
  probeTimeout?: Scalars['Duration']['input'];
  /** Type of probe. */
  probeType: MonitorProbeType;
  /** TCP probe parameters (required if type is TCP). */
  tcpParams?: InputMaybe<TcpProbeParamsInput>;
};

export type CreateNacCredentialInput = {
  /** The MAC for a device identity. */
  clientMAC?: InputMaybe<Scalars['MacAddress']['input']>;
  /** Optional NAC user groups to assign the credential to. Each must belong to the same company. */
  groupUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Optional display name. */
  label?: InputMaybe<Scalars['String']['input']>;
  /**
   * The password for EAP-GTC authentication. Provide this to set the password
   * immediately.
   */
  password?: InputMaybe<Scalars['String']['input']>;
  /**
   * If true, the credential is created without a password and the user sets it
   * themselves via a tokenized link sent to them. Mutually exclusive with
   * `password`.
   */
  userSetsPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** The login for a user identity. */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNacGroupInput = {
  /** Optional description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The group's display name. */
  name: Scalars['String']['input'];
};

export type CreateNacIdPConfigInput = {
  /** For Google Secure LDAP, the Secure LDAP client certificate, PEM-encoded. */
  clientCert?: InputMaybe<Scalars['String']['input']>;
  /** For Google Secure LDAP, the Secure LDAP client private key, PEM-encoded. */
  clientKey?: InputMaybe<Scalars['String']['input']>;
  /** The customer's primary domain (eg meter.com). Identities are routed to this configuration by the domain part of their username. */
  domain: Scalars['String']['input'];
  /** For Entra, the Application client ID of the Meter NAC app registration. */
  entraClientID?: InputMaybe<Scalars['String']['input']>;
  /** For Entra, a client secret on that app registration. */
  entraClientSecret?: InputMaybe<Scalars['String']['input']>;
  /** For Entra, the Secret ID of that client secret. */
  entraClientSecretID?: InputMaybe<Scalars['UUID']['input']>;
  /** For Entra, the Directory tenant ID. */
  entraTenantID?: InputMaybe<Scalars['String']['input']>;
  /** For Okta, the client ID of the native app. */
  oktaClientID?: InputMaybe<Scalars['String']['input']>;
  /** For Okta, a client secret on that native app. */
  oktaClientSecret?: InputMaybe<Scalars['String']['input']>;
  /** For Okta, the org URL. */
  oktaOrgURL?: InputMaybe<Scalars['String']['input']>;
  /** For Okta, the client ID of a separate API services app used for directory reads. */
  oktaServiceClientID?: InputMaybe<Scalars['String']['input']>;
  /** The identity provider to authenticate against. */
  provider: NacIdPProvider;
};

export type CreateNacIdPGroupMappingInput = {
  /** Human-readable name for the external group. */
  idpGroupDisplayName: Scalars['String']['input'];
  /** The external IdP group key */
  idpGroupName: Scalars['String']['input'];
  /** The NAC group to map the external group to. */
  nacGroupUUID: Scalars['UUID']['input'];
};

export type CreateNacPolicyEntryInput = {
  /** The UUID of the NAC credential for local_credential entries. Exactly one match field must be provided per entry. */
  nacCredentialUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The UUID of the NAC group, for entries whose identityType is NAC_GROUP. Exactly one match field must be provided per entry. */
  nacGroupUUID?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateNacPolicyInput = {
  /** An optional description of what this policy does. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether matching devices are accepted (true) or rejected (false). */
  isAccept: Scalars['Boolean']['input'];
  /** Whether this is a catch-all policy. Catch-all policies match all requests and must not have entries. */
  isCatchAll: Scalars['Boolean']['input'];
  /** Whether this policy is active. */
  isEnabled: Scalars['Boolean']['input'];
  /** A human-readable name for the policy. */
  label: Scalars['String']['input'];
  /** Maximum distinct devices a user may authenticate on within a rolling window. */
  maxDevicesPerUser?: InputMaybe<Scalars['Int']['input']>;
  /** Seconds before the device must re-authenticate */
  sessionTimeoutSec?: InputMaybe<Scalars['Int']['input']>;
  /** The UUID of the VLAN to assign to accepted devices. */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateNosUpgradeGroupInput = {
  /** A human-friendly description of the group. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** A human-friendly label for the group. */
  name: Scalars['String']['input'];
  /**
   * The priority of the NOS upgrade group; lower values are higher priority.
   * Groups of devices will be upgraded in order of priority.
   * If set, the group will be inserted at the given priority, bumping all equal or lesser groups to an inferior priority.
   * The priority must be equal to an existing group's priority or +1 of the last existing priority.
   * If not set, the group will be inserted at the most inferior priority.
   * Priority is 0-indexed.
   */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** How long to wait for all devices in the group to upgrade before timing out, in seconds. */
  timeoutDurationSeconds?: Scalars['Int']['input'];
  /** If specified, the given virtual devices will be moved from their current group to this group. */
  virtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type CreateNetworkClientCpeBindingInput = {
  /** The UUID of the CPE for the binding. */
  cpeUUID: Scalars['UUID']['input'];
  /** The MAC address to bind cpeUUID to. */
  macAddress: Scalars['MacAddress']['input'];
};

/** Input type for creating a network. */
export type CreateNetworkInput = {
  /** Explicit ARP tracker enablement for the network. */
  IsArpTrackerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If false, wifi steering will be fully disabled even if supported by NOS. */
  IsWifiSteeringEnabled?: Scalars['Boolean']['input'];
  /** The slug identifier of the company that this network belongs to. */
  companySlug?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether the network is currently active. Defaults to true. */
  isActive?: Scalars['Boolean']['input'];
  /** Enables controller to upgrade config-1 APs deployed to the network. */
  isConfig1WosUpgradesEnabled?: Scalars['Boolean']['input'];
  /** Indicates whether the network is a template for creating new networks. Defaults to false; must be true if creating the network underneath a 'global network template holding company'. */
  isTemplate?: Scalars['Boolean']['input'];
  /** Deprecated: Not a network property anymore. */
  isTest?: Scalars['Boolean']['input'];
  /** A label to quickly identify the network. */
  label: Scalars['String']['input'];
  /** Deprecated: Use `mailingAddressInput` instead. */
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
  /** The mailing address details for the network. */
  mailingAddressInput?: InputMaybe<CreateMailingAddressInput>;
  /** The UUID of the mailing address associated with the network. */
  mailingAddressUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The algorithm used for multi-WAN load balancing. */
  multiWANAlgorithm?: InputMaybe<MultiWanAlgorithm>;
  /** The URL of the patch panel diagram for the network. */
  patchPanelDiagramURL?: InputMaybe<Scalars['String']['input']>;
  /** A NOS version should be specified. If not, the default no-upgrades NOS version is assigned. */
  pinnedNOSVersionID?: InputMaybe<Scalars['Int']['input']>;
  /** If provided, will set Network's Routing Layer (L2 or L3), defaults to L2 if not specified. */
  routingLayer?: InputMaybe<NetworkRoutingLayer>;
  /** A human-readable identifier for the network. */
  slug: Scalars['String']['input'];
  /** Deprecated: Not a network property anymore. */
  squareFeet?: InputMaybe<Scalars['Int']['input']>;
  /** The interval in minutes used to stagger device upgrades within the network. */
  staggeredUpgradeIntervalMin?: InputMaybe<Scalars['Int']['input']>;
  /** The S3 key for the network topology image. */
  topologyImageS3Key?: InputMaybe<Scalars['String']['input']>;
};

/** Inputs to create a network reservation */
export type CreateNetworkReservationInput = {
  /** Description of the reservation */
  description?: InputMaybe<Scalars['String']['input']>;
  /** What time the reservation ends */
  endTime: Scalars['DateTime']['input'];
  /** What time the reservation starts */
  startTime: Scalars['DateTime']['input'];
};

export type CreateNetworkThreatAllowlistEntryInput = {
  /** A bssid to allow for honeypot AP detection. */
  BSSID?: InputMaybe<Scalars['String']['input']>;
  /** An explanation of the allowlisted device or the SSID to allow. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** An SSID to allow if a threat is broadcasting it. */
  ssidUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** A mac address to allow for rogue AP detection. */
  wiredMAC?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNosFeatureInput = {
  /** A detailed description of the NOS feature. */
  description: Scalars['String']['input'];
  /** If the feature is also behind a feature flag, this is the name of the feature flag. */
  featureFlag?: InputMaybe<Scalars['String']['input']>;
  /** A unique key that identifies the NOS feature. */
  key: Scalars['String']['input'];
  /** The display name of the NOS feature. */
  name: Scalars['String']['input'];
  /** The version ranges that define which NOS versions support this feature. */
  versionRanges: Array<NosFeatureVersionRangeInput>;
};

/** Input type for creating notification snooze. */
export type CreateNotificationSnoozeInput = {
  /** The reason for the snooze. */
  snoozeReason?: InputMaybe<Scalars['String']['input']>;
  /** The time window for the snooze. */
  window: SnoozeNotificationSettingWindowInput;
};

/** Input type for creating a new ObserverTest. */
export type CreateObserverTestInput = {
  /** The radio band on which the test should be run. Required for wireless tests. */
  band?: InputMaybe<RadioBand>;
  /** If not bound to all targets, this is the list of access points that the ObserverTest is bound to. */
  boundTargetVirtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** If true, requests broadcast responses for DHCP. */
  broadcastDHCP?: Scalars['Boolean']['input'];
  /** List of commands to run during the ObserverTest. */
  commands?: InputMaybe<Array<ObserverTestCommandInput>>;
  /** Duration of the test in milliseconds. */
  durationMs: Scalars['Int']['input'];
  /** If true, we will run every observer against every access point that it can reach. These bindings are kept up to date with an offline process. */
  isBoundToAllTargets: Scalars['Boolean']['input'];
  /** If the Observer is enabled. */
  isEnabled?: Scalars['Boolean']['input'];
  /** The human readable label for the test. */
  label: Scalars['String']['input'];
  /** Number of times an Observer will re-try when there is a connection failure. If unset, uses firmware default (1 retry). */
  numConnectionRetries?: InputMaybe<Scalars['Int']['input']>;
  /** Number of spatial streams to use for the test. If unset, uses max number of spatial streams. */
  numSpatialStreams?: InputMaybe<Scalars['Int']['input']>;
  /** 802.1X password for authentication. */
  password8021X?: InputMaybe<Scalars['String']['input']>;
  /** If true, each observer is bound to only its single highest-SNR target, and non-best bindings are pruned. */
  selectOnlyBestTarget?: Scalars['Boolean']['input'];
  /** The SNR threshold (in dB) used to select eligible target APs for observers. If unset, uses the default threshold. */
  snrThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** The UUID of the SSID to use for the ObserverTest. Required for wireless tests. */
  ssidUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Transmit power to user for the test. If unset, uses the transmit power of the access point. */
  transmitPowerdBm?: InputMaybe<Scalars['Int']['input']>;
  /** 802.1X username for authentication. */
  username8021X?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the VLAN for wired tests. Ignored if SSID is set. */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateOneToOneNatRuleInput = {
  /** Optional description of the 1:1 NAT rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The external IP address that is mapped by the NAT rule. This address must be present in the `externalPhyInterface`'s `ipv4ClientAddresses`, and will be added if it is not. */
  externalIPAddr: Scalars['IPV4']['input'];
  /** UUID of the physical interface associated with the external IP address. */
  externalPhyInterfaceUUID: Scalars['UUID']['input'];
  /** Internal IP address that the external IP address will be mapped to. */
  internalIPAddr: Scalars['IPV4']['input'];
  /** Automatically disables this 1:1 NAT rule when the associated physical interface is inactive. */
  isDisabledWhenUplinkInactive?: Scalars['Boolean']['input'];
  /** Indicates whether the NAT rule is enabled upon creation. */
  isEnabled: Scalars['Boolean']['input'];
  /** Name of the 1:1 NAT rule. */
  name: Scalars['String']['input'];
};

export type CreatePermittedEmailDomainInput = {
  /** The slug of the company to which the permitted email domain will be added. */
  companySlug: Scalars['String']['input'];
  /** The email domain to allow (e.g., "example.com"). */
  domain: Scalars['String']['input'];
};

/** Input for creating a new phy interface DHCP rule. */
export type CreatePhyInterfaceDhcpRuleInput = {
  /** The gateway address and subnet, as an unmasked prefix (e.g. `10.65.0.1/24`). */
  gateway: Scalars['UnmaskedIPPrefix']['input'];
  /** Indicates whether this DHCP rule is for IPv6 (`true`) or IPv4 (`false`). */
  isIPv6: Scalars['Boolean']['input'];
  /** The duration (in seconds) of the DHCP lease assigned to clients. */
  leaseDurationSeconds: Scalars['Int']['input'];
};

/** Input for creating a path on an existing policy. */
export type CreatePolicyEnginePathInput = {
  /** If set, clamps the TCP max segment size to the provided number of bytes. */
  clampMaxSegmentSizeBytes?: InputMaybe<Scalars['Int']['input']>;
  /** Optional extended description for the traffic matcher. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether this path should be initially active before monitor reports. */
  initialActive: Scalars['Boolean']['input'];
  /** Optional IP address used as virtual address for this path. */
  ipAddress?: InputMaybe<Scalars['IP']['input']>;
  /** Whether the traffic matcher is enabled. */
  isEnabled?: Scalars['Boolean']['input'];
  /** Monitor group UUID for health monitoring. */
  monitorGroupUUID: Scalars['UUID']['input'];
  /** Unique name for the traffic matcher. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** NAT configuration for the policy. If omitted, no translation happens before forwarding. */
  natConfiguration?: InputMaybe<PolicyEngineNatConfigurationInput>;
  /** Next hop configuration for the policy. If omitted, defaults to VRF route lookup with no specified ID. */
  nextHopConfiguration?: InputMaybe<PolicyEngineNextHopConfigurationInput>;
  /** Lower priority values are preferred for routing. */
  priority: Scalars['Int']['input'];
  /** Target interface for this path. */
  targetInterface: TargetInterfaceInput;
  /** Load balancing weight for distributing traffic across paths with equal priority. */
  weight: Scalars['Int']['input'];
};

/** Input values for creating a policy engine policy. */
export type CreatePolicyEnginePolicyInput = {
  /** Optional extended description for the traffic matcher. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether the traffic matcher is enabled. */
  isEnabled?: Scalars['Boolean']['input'];
  /** Name of the policy. */
  name: Scalars['String']['input'];
  /** Paths for this policy. */
  paths?: InputMaybe<Array<CreatePolicyEnginePathInput>>;
  /**
   * Priority of the policy within the network, lower priority policies are applied first.
   * If there is an existing policy with the provided value, it and all subsequent occupied values will be incremented.
   * If omitted, next lowest priority in network will be used.
   */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Traffic matchers for this policy. */
  trafficMatchers?: InputMaybe<Array<CreatePolicyEngineTrafficMatcherInput>>;
  /** The type of policy engine policy, affecting priority. */
  type?: PolicyEnginePolicyType;
};

/** Input for creating a traffic matcher on an existing policy. */
export type CreatePolicyEngineTrafficMatcherInput = {
  /** Optional extended description for the traffic matcher. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Destination address prefix to match. At most one of `destinationAddress`, `destinationAddressPattern`, and `destinationTargetInterface` can be set. */
  destinationAddress?: InputMaybe<Scalars['IPPrefix']['input']>;
  /** Destination IPv4 address pattern to match, e.g. `10.1-4.*.2/31`. At most one of `destinationAddress`, `destinationAddressPattern`, and `destinationTargetInterface` can be set. */
  destinationAddressPattern?: InputMaybe<Scalars['IPAddressPattern']['input']>;
  /** Destination target interface to match. At most one of `destinationAddress`, `destinationAddressPattern`, and `destinationTargetInterface` can be set. */
  destinationTargetInterface?: InputMaybe<TargetInterfaceInput>;
  /** Destination port ranges to match. */
  dstPortRanges: Array<PortRangeInput>;
  /** Whether the traffic matcher is enabled. */
  isEnabled?: Scalars['Boolean']['input'];
  /** Unique name for the traffic matcher. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** IANA protocol numbers to match. */
  protocols: Array<IpProtocol>;
  /** Source address prefix to match. At most one of `sourceAddress`, `sourceAddressPattern`, and `sourceTargetInterface` can be set. */
  sourceAddress?: InputMaybe<Scalars['IPPrefix']['input']>;
  /** Source IPv4 address pattern to match, e.g. `10.1-4.*.2/31`. At most one of `sourceAddress`, `sourceAddressPattern`, and `sourceTargetInterface` can be set. */
  sourceAddressPattern?: InputMaybe<Scalars['IPAddressPattern']['input']>;
  /** Source target interface to match. At most one of `sourceAddress`, `sourceAddressPattern`, and `sourceTargetInterface` can be set. */
  sourceTargetInterface?: InputMaybe<TargetInterfaceInput>;
  /** Source port ranges to match. */
  srcPortRanges: Array<PortRangeInput>;
};

export type CreatePolicyRoutingRuleInput = {
  /** The list of bindings to associate with this policy routing rule. */
  bindings: Array<PolicyRoutingRuleBindingInput>;
  /** The list of destination port ranges for the traffic matching this rule. */
  dstPortRanges: Array<PortRangeInput>;
  /** The destination IP prefix for the traffic matching this rule. */
  dstPrefix: Scalars['IPPrefix']['input'];
  /** Indicates whether the policy routing rule is enabled. */
  isEnabled: Scalars['Boolean']['input'];
  /** The name of the policy routing rule. */
  name: Scalars['String']['input'];
  /** The list of IP protocols (e.g., TCP, UDP) for the traffic matching this rule. */
  protocols: Array<IpProtocol>;
  /** The list of source port ranges for the traffic matching this rule. */
  srcPortRanges: Array<PortRangeInput>;
  /** The source IP prefix for the traffic matching this rule (optional). */
  srcPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
  /** The UUID of the source VLAN for the traffic matching this rule (optional). */
  srcVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreatePortForwardingRuleInput = {
  /** Restricts the port forwarding rule to only allow traffic to be forwarded if it originates from any of these IP addresses. */
  allowedRemoteIPAddresses?: InputMaybe<Array<Scalars['IP']['input']>>;
  /** Description of the port forwarding rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * The external IP address to which this rule applies.
   * One of `externalPhyInterfaceUUID` or `externalIPAddress` must be provided.
   */
  externalIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** UUID of the external uplink physical interface. */
  externalPhyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * The external port from which incoming traffic is forwarded.
   * Exactly one of `externalPort`/`localPort` or `externalPortRanges`/`localPortRanges` must be provided.
   */
  externalPort?: InputMaybe<Scalars['Int']['input']>;
  /**
   * External port ranges from which incoming traffic is forwarded.
   * `externalPortRanges[i]` forwards to `localPortRanges[i]`, so both lists must have the same number of
   * entries and each pair must span the same number of ports. Ranges within a rule must not overlap.
   * Exactly one of `externalPort`/`localPort` or `externalPortRanges`/`localPortRanges` must be provided.
   * A rule may specify at most 100 port ranges, and a network may forward at most 5000 ports in total
   * across all of its enabled port forwarding rules.
   */
  externalPortRanges?: InputMaybe<Array<PortRangeInput>>;
  /** Indicates whether the port forwarding rule is enabled. */
  isEnabled: Scalars['Boolean']['input'];
  /** The local IP address to which incoming traffic is forwarded. */
  localIPAddress: Scalars['IP']['input'];
  /** The local port to which the external port forwards traffic. */
  localPort?: InputMaybe<Scalars['Int']['input']>;
  /** Local port ranges to which the corresponding `externalPortRanges` entry forwards traffic. */
  localPortRanges?: InputMaybe<Array<PortRangeInput>>;
  /** Name of the port forwarding rule. */
  name: Scalars['String']['input'];
  /** The IP protocol to apply this rule on. */
  protocol?: InputMaybe<PortIpProtocol>;
  /** List of IP protocols to match. */
  protocols?: InputMaybe<Array<PortIpProtocol>>;
  /**
   * The incoming interface.
   * One of `targetInterface` or `externalIPAddress` must be provided.
   */
  targetInterface?: InputMaybe<TargetInterfaceInput>;
};

/** Input type for creating a pre-signed URL for file upload. */
export type CreatePreSignedUploadUrlInput = {
  /** The extension of the file being uploaded (e.g., 'jpg', 'png', 'pdf'). Do not include the leading dot. */
  fileExtension: Scalars['String']['input'];
  /** The folder where the file will be uploaded. */
  folder: AllowedFolder;
};

/** Input for creating the global proactive packet capture configuration for a network. */
export type CreateProactivePcapNetworkConfigInput = {
  /** Whether proactive packet capture is enabled globally for the network. */
  isEnabled?: Scalars['Boolean']['input'];
  /** For the same client and same type of event, minimum interval in seconds before exporting another pcap. 0 means use firmware default (30 minutes). */
  maxPcapFreqSec?: Scalars['Int']['input'];
};

/** Input for creating the per-SSID proactive packet capture configuration. */
export type CreateProactivePcapSsidConfigInput = {
  /**
   * List of 802.11 disassociation reason codes to capture.
   * If empty and isCaptureDisassocsEnabled is true, all disassociations are captured.
   */
  captureDisassocsReasonCodes?: Array<Scalars['Int']['input']>;
  /** List of client MAC addresses to follow for all pcap events. */
  followedClientMacs?: Array<Scalars['MacAddress']['input']>;
  /** Whether disassociation events are captured. */
  isCaptureDisassocsEnabled?: Scalars['Boolean']['input'];
  /** Whether to capture successful connection events. */
  isCaptureSuccessEnabled?: Scalars['Boolean']['input'];
  /** Whether proactive packet capture is enabled for this SSID. */
  isEnabled: Scalars['Boolean']['input'];
};

/** Input type for creating a new Provider Connection Type Term. */
export type CreateProviderConnectionTypeTermInput = {
  /** UUID of the connection type the term applies to. */
  connectionTypeUUID: Scalars['UUID']['input'];
  /** UUID of the Provider offering the product. */
  providerUUID: Scalars['UUID']['input'];
  /** Term of contract in months. */
  termMonths: Scalars['Int']['input'];
};

export type CreatePublicApiKeyInput = {
  /** The access level for the key. */
  accessLevel: ApiKeyAccessLevel;
  /** Optional expiration interval for the key. If not set, the key will not expire. */
  expirationInterval?: InputMaybe<PublicApiKeyExpirationInterval>;
  /** A human readable name for the key. */
  name: Scalars['String']['input'];
};

/** Response from creating a public API key. */
export type CreatePublicApiKeyResponse = {
  __typename?: 'CreatePublicAPIKeyResponse';
  /** The public API key metadata. */
  key: PublicApiKey;
  /** shortened token that can be used as a bearer auth token */
  shortToken: Scalars['String']['output'];
  /** The raw PASETO token. */
  token: Scalars['String']['output'];
};

/** Input for creating a new Quote. */
export type CreateQuoteInput = {
  /**
   * Indicates availability (OnNet/NearNet/OffNet) of the associated Provider and Connectiontype at the associated location.
   * Providing this information set the availability for the location, not just the quote.
   */
  availability?: InputMaybe<LocationProviderAvailability>;
  /** Connection type UUID. */
  connectionTypeUUID: Scalars['UUID']['input'];
  /** Length of the contract in months. */
  contractLengthMonths: Scalars['Int']['input'];
  /** Actual contract term in months committed to with the underlying carrier, which may differ from the customer-facing contractLengthMonths. */
  contractLengthMonthsInternal?: InputMaybe<Scalars['Int']['input']>;
  /** Download speed in Kbps. */
  downloadKbps: Scalars['Int']['input'];
  /** Installation fee in cents. Defaults to the Connect rate card price for the connection type, term and download speed. */
  installFeeCents?: InputMaybe<Scalars['Int']['input']>;
  /** Wholesale installation fee in cents. */
  installFeeWholesaleCents?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated number of days for installation. */
  installationEstimateDays?: InputMaybe<Scalars['Int']['input']>;
  /** UUID of the broker providing quote. */
  internetServicePlanBrokerProviderUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** UUID of the ISP Provider. */
  internetServicePlanProviderUUID: Scalars['UUID']['input'];
  /** UUID of the ISP underlying Provider. */
  internetServicePlanSubProviderUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Monthly fee in cents. Defaults to the Connect rate card price for the connection type, term and download speed. */
  monthlyFeeCents?: InputMaybe<Scalars['Int']['input']>;
  /** Monthly fee prior to any discounts applied. */
  monthlyFeePreDiscountCents?: InputMaybe<Scalars['Int']['input']>;
  /** Wholesale cost. */
  monthlyFeeWholesaleCents?: InputMaybe<Scalars['Int']['input']>;
  /** Internal notes about the quote. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the associated Quote Request. */
  quoteRequestUUID: Scalars['UUID']['input'];
  /** Whether this quote is recommended. */
  recommended: Scalars['Boolean']['input'];
  /** Responsibility for riser cabling work. */
  riserResponsibility: RiserResponsibility;
  /** Whether a router is included in the quote. */
  routerIncluded: Scalars['Boolean']['input'];
  /** Indicates selection status */
  selectedStatus?: InputMaybe<QuoteSelectionStatus>;
  /** Indicates a quote has been selected and its proposed priority. */
  selectionPriority?: InputMaybe<Scalars['Int']['input']>;
  /** Status of the Quote. */
  status: QuoteStatus;
  /** Upload speed in Kbps. */
  uploadKbps: Scalars['Int']['input'];
};

/**
 * Input type for creating a new Quote Request.
 * Providing companyUUID will associate the Quote Request with an existing company.
 * Address can be provided as input or looked up via networkUUID or mailingAddressUUID.
 */
export type CreateQuoteRequestInput = {
  /** Address for which the Quote Request is created. */
  address?: InputMaybe<CreateAddressInput>;
  /** Company UUID identifying existing company. */
  companyUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Email of customer initiating the Quote Request. */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Name of customer initiating the Quote Request. */
  contactName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of customer initiating the Quote Request. */
  contactTelephone?: InputMaybe<Scalars['String']['input']>;
  /** Requested maximum days to install. */
  contractMaximumInstallDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Requested minumum contract length in months. */
  contractMinimumMonths?: InputMaybe<Scalars['Int']['input']>;
  /** End date of the potential customer's existing ISP contract. */
  existingContractEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Monthly recurring cost of the customer */
  existingMonthlyFeeCents?: InputMaybe<Scalars['Int']['input']>;
  /** Customer's existing provider */
  existingProviderUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Is the user interested in the Meter Network product. */
  isInterestedInNetwork: Scalars['Boolean']['input'];
  /** Is there a pending manual quote that needs to be prepared. */
  isManualResponsePending: Scalars['Boolean']['input'];
  /** Unique identifier of existing mailing address. */
  mailingAddressUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Network UUID identifying existing network. */
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Note tracking details of quote creation. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Procurement channel/pricing method for the associated quotes. */
  procurementChannel?: InputMaybe<ConnectProcurementChannel>;
  /** Proposed name of the company to create or associate with quote request. */
  requestedCompanyName?: InputMaybe<Scalars['String']['input']>;
  /** Requested download speed. */
  requestedDownloadKbps?: InputMaybe<Scalars['Int']['input']>;
  /** Requested upload speed. */
  requestedUploadKbps?: InputMaybe<Scalars['Int']['input']>;
  /** Internal users handling fulfillment/support for the Quote Request. */
  supportUsers?: InputMaybe<Array<QuoteRequestSupportUserInput>>;
};

/** Input type for creating a new rack elevation. */
export type CreateRackElevationInput = {
  /** The building where this rack is physically located. */
  building?: InputMaybe<Scalars['String']['input']>;
  /** The name of the distribution frame associated with this rack. */
  distributionFrame?: InputMaybe<Scalars['String']['input']>;
  /** The floor within the building where this rack is physically located. */
  floor?: InputMaybe<Scalars['String']['input']>;
  /** The left-to-right position of the rack relative to others. */
  horizontalIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Human-readable name for the rack elevation. */
  label: Scalars['String']['input'];
  /** Notes associated with the rack elevation. */
  notes?: InputMaybe<Array<RackElevationNoteInput>>;
  /** The number of rack units (like slots) for the rack elevation. */
  rackMountUnitCount: Scalars['Int']['input'];
  /** The room where this rack is physically located. */
  room?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRadioProfileInput = {
  /**
   * Required if band2_4GAutoChannelIsEnabled is true.
   * The list of allowed channels for auto channel selection on the 2.4 GHz band.
   */
  band2_4GAllowedChannels?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Indicates whether auto channel selection is enabled for the 2.4 GHz band. */
  band2_4GAutoChannelIsEnabled: Scalars['Boolean']['input'];
  /** Indicates whether auto channel width selection is enabled for the 2.4 GHz band. */
  band2_4GAutoChannelWidthIsEnabled: Scalars['Boolean']['input'];
  /** Indicates whether automatic transmit power adjustment is enabled for the 2.4 GHz band. */
  band2_4GAutoTxPowerIsEnabled: Scalars['Boolean']['input'];
  /**
   * Required if band2_4GAutoTxPowerIsEnabled is true.
   * The maximum transmit power in dBm for the 2.4 GHz band when auto transmit power is enabled.
   */
  band2_4GAutoTxPowerMaxdBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band2_4GAutoTxPowerIsEnabled is true.
   * The minimum transmit power in dBm for the 2.4 GHz band when auto transmit power is enabled.
   */
  band2_4GAutoTxPowerMindBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band2_4GAutoChannelWidthIsEnabled is false.
   * The channel width in MHz for the 2.4 GHz band when auto channel width is disabled.
   */
  band2_4GChannelWidthMHz?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the 2.4 GHz band is enabled. */
  band2_4GIsEnabled: Scalars['Boolean']['input'];
  /**
   * Required if band5GAutoChannelIsEnabled is true.
   * The list of allowed channels for auto channel selection on the 5 GHz band.
   */
  band5GAllowedChannels?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Indicates whether auto channel selection is enabled for the 5 GHz band. */
  band5GAutoChannelIsEnabled: Scalars['Boolean']['input'];
  /** Indicates whether auto channel width selection is enabled for the 5 GHz band. */
  band5GAutoChannelWidthIsEnabled: Scalars['Boolean']['input'];
  /** Indicates whether automatic transmit power adjustment is enabled for the 5 GHz band. */
  band5GAutoTxPowerIsEnabled: Scalars['Boolean']['input'];
  /**
   * Required if band5GAutoTxPowerIsEnabled is true.
   * The maximum transmit power in dBm for the 5 GHz band when auto transmit power is enabled.
   */
  band5GAutoTxPowerMaxdBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band5GAutoTxPowerIsEnabled is true.
   * The minimum transmit power in dBm for the 5 GHz band when auto transmit power is enabled.
   */
  band5GAutoTxPowerMindBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band5GAutoChannelWidthIsEnabled is false.
   * The channel width in MHz for the 5 GHz band when auto channel width is disabled.
   */
  band5GChannelWidthMHz?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the 5 GHz band is enabled. */
  band5GIsEnabled: Scalars['Boolean']['input'];
  /** When true, the AP returns to a DFS channel after the NOP expires. */
  band5GZeroWaitDFSIsEnabled?: Scalars['Boolean']['input'];
  /**
   * Required if band6GAutoChannelIsEnabled is true.
   * The list of allowed channels for auto channel selection on the 6 GHz band.
   */
  band6GAllowedChannels?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Indicates whether auto channel selection is enabled for the 6 GHz band. */
  band6GAutoChannelIsEnabled?: Scalars['Boolean']['input'];
  /** Indicates whether auto channel width selection is enabled for the 6 GHz band. */
  band6GAutoChannelWidthIsEnabled?: Scalars['Boolean']['input'];
  /** Indicates whether automatic transmit power adjustment is enabled for the 6 GHz band. */
  band6GAutoTxPowerIsEnabled?: Scalars['Boolean']['input'];
  /**
   * Required if band6GAutoTxPowerIsEnabled is true.
   * The maximum transmit power in dBm for the 6 GHz band when auto transmit power is enabled.
   */
  band6GAutoTxPowerMaxdBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band6GAutoTxPowerIsEnabled is true.
   * The minimum transmit power in dBm for the 6 GHz band when auto transmit power is enabled.
   */
  band6GAutoTxPowerMindBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band6GAutoChannelWidthIsEnabled is false.
   * The channel width in MHz for the 6 GHz band when auto channel width is disabled.
   */
  band6GChannelWidthMHz?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the 6 GHz band is enabled. */
  band6GIsEnabled?: Scalars['Boolean']['input'];
  /** Clear channel assessment (CCA) threshold in dBm used to determine whether the channel is free. 0 means use driver default. */
  ccaThreshold?: Scalars['Int']['input'];
  /** A human-readable description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Setting this to true will set all other profiles to false.
   * Indicates whether this profile should be set as the default for the network.
   */
  isDefault: Scalars['Boolean']['input'];
  /** The name of the radio profile to create. */
  name: Scalars['String']['input'];
  /** Receive sensitivity level (RX-SOP) in dBm below which received frames are not considered. 0 means use driver default. */
  rxSensitivityLevel?: Scalars['Int']['input'];
};

/** Input for creating a radio profile in a specific network, used by createRadioProfiles. */
export type CreateRadioProfilesInput = {
  /** The input data for creating the radio profile. */
  input: CreateRadioProfileInput;
  /** Unique identifier of the network where the radio profile will be created. */
  networkUUID: Scalars['UUID']['input'];
};

/** The metadata required to create radio settings for an access point. */
export type CreateRadioSettingsInput = {
  /** The primary channel for the 2.4 GHz radio band. */
  band2_4GPrimaryChannel: Scalars['Int']['input'];
  /** The transmit power in dBm for the 2.4 GHz radio band. */
  band2_4GTransmitPowerdBm: Scalars['Int']['input'];
  /** The primary channel for the 5 GHz radio band. */
  band5GPrimaryChannel: Scalars['Int']['input'];
  /** The secondary channel for the 5 GHz radio band, if applicable. */
  band5GSecondaryChannel?: InputMaybe<Scalars['Int']['input']>;
  /** The transmit power in dBm for the 5 GHz radio band. */
  band5GTransmitPowerdBm: Scalars['Int']['input'];
  /** The primary channel for the 6 GHz radio band. */
  band6GPrimaryChannel?: InputMaybe<Scalars['Int']['input']>;
  /** The transmit power in dBm for the 6 GHz radio band. */
  band6GTransmitPowerdBm?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateRateLimitRuleInput = {
  /** A list of UUIDs of physical interfaces to which this rate limit rule is bound. */
  boundPhyInterfaceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A list of UUIDs of SSIDs to which this rate limit rule is bound. */
  boundSSIDUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A list of UUIDs of VLANs to which this rate limit rule is bound. */
  boundVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A description of the rate limit rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Destination MAC address to match. */
  dstMac?: InputMaybe<Scalars['MacAddress']['input']>;
  /** Destination port range to match. */
  dstPortRange?: InputMaybe<PortRangeInput>;
  /** Destination IP address prefix to match. */
  dstPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
  /** Indicates whether the rate limit rule is enabled. */
  isEnabled: Scalars['Boolean']['input'];
  /** Specifies if the rate limit is applied per source IP/MAC address. */
  isPerSource?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the rate limit rule. */
  name: Scalars['String']['input'];
  /** The order in which the rate limit rules are applied, lower priorities first. If omitted, will be appended to the end. */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** IANA protocol number to match. */
  protocol?: InputMaybe<IpProtocol>;
  /** Maximum download rate limit in kilobits per second. */
  rateLimitKbpsDownload?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum upload rate limit in kilobits per second. */
  rateLimitKbpsUpload?: InputMaybe<Scalars['Int']['input']>;
  /** Source MAC address to match. */
  srcMac?: InputMaybe<Scalars['MacAddress']['input']>;
  /** Source port range to match. */
  srcPortRange?: InputMaybe<PortRangeInput>;
  /** Source IP address prefix to match. */
  srcPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
};

export type CreateRateLimitRulesInput = {
  /** Input values to create a rate limit rule. */
  input: CreateRateLimitRuleInput;
  /** The unique identifier of the network. */
  networkUUID: Scalars['UUID']['input'];
};

export type CreateSpanMirrorSessionInput = {
  /** UUID of the destination physical interface where mirrored traffic will be sent. */
  destPhyInterfaceUUID: Scalars['UUID']['input'];
  /** Hardware session ID (1-4). If not provided, the next available ID will be assigned. */
  sessionID?: InputMaybe<Scalars['Int']['input']>;
  /** Source ports to mirror traffic from. At least one source port is required. */
  sourcePorts: Array<CreateSpanMirrorSessionSourcePortInput>;
};

export type CreateSpanMirrorSessionSourcePortInput = {
  /** If true, mirror outgoing (egress) traffic. At least one of ingressMirror or egressMirror must be true. */
  egressMirror?: Scalars['Boolean']['input'];
  /** If true, mirror incoming (ingress) traffic. At least one of ingressMirror or egressMirror must be true. */
  ingressMirror?: Scalars['Boolean']['input'];
  /** UUID of the physical interface to mirror traffic from. */
  phyInterfaceUUID: Scalars['UUID']['input'];
};

export type CreateSsidInput = {
  /**
   * The lowest rate at which a client can connect to the 2.4 GHz radio, in kilobits per second.
   * If not set, will be set to a default value.
   */
  band2GMinimumBasicRateKbps?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum RSSI (in dBm) for probe request suppression on the 2.4 GHz radio. */
  band2GMinimumProbeRssiDbm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The lowest rate at which a client can connect to the 5 GHz radio, in kilobits per second.
   * If not set, will be set to a default value.
   */
  band5GMinimumBasicRateKbps?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum RSSI (in dBm) for probe request suppression on the 5 GHz radio. */
  band5GMinimumProbeRssiDbm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The lowest rate at which a client can connect to the 6 GHz radio, in kilobits per second.
   * If not set, will be set to a default value.
   */
  band6GMinimumBasicRateKbps?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum RSSI (in dBm) for probe request suppression on the 6 GHz radio. */
  band6GMinimumProbeRssiDbm?: InputMaybe<Scalars['Int']['input']>;
  /** If true, all broadcast traffic is blocked before being transmitted to the wireless. Requires proxy ARP to be enabled. */
  blockWirelessTxBroadcast?: Scalars['Boolean']['input'];
  /** If true, all multicast traffic is blocked before being transmitted to the wireless. */
  blockWirelessTxMulticast?: Scalars['Boolean']['input'];
  /** Specifies the schedule intervals during which the SSID will be broadcasted. */
  broadcastSchedule?: InputMaybe<Array<ScheduleIntervalInput>>;
  /** A list of allowed client MACs, if isClientAllowlistEnabled is true. */
  clientAllowlist?: InputMaybe<Array<Scalars['MacAddress']['input']>>;
  /** Enable or disable client steering for association. */
  clientSteeringAssociationSteeringIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The minimum number of clients on an SSID before client steering is attempted. */
  clientSteeringLoadBalancingClientMinThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Enable or disable post-association client steering. */
  clientSteeringPostassociationSteeringIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The minimum RSSI signal strength (in dBm) before pre-association client steering is attempted. */
  clientSteeringPreassociationRSSIMinThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Description of the SSID. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** List of access point virtual device UUIDs on which the SSID is disabled. */
  disabledAccessPointVirtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The DTIM period for the SSID. */
  dtimPeriod?: InputMaybe<Scalars['Int']['input']>;
  /** Dynamic VLAN mode setting. */
  dynamicVLANMode?: InputMaybe<SsidDynamicVlanMode>;
  /** An optional period for requiring client reauthentication, for a 802.1X SSID. */
  eapReauthPeriod?: InputMaybe<Scalars['Duration']['input']>;
  /**
   * Required if isEnabledForAllAccessPoints is false.
   * List of access point virtual device UUIDs on which the SSID is enabled.
   */
  enabledAccessPointVirtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** 802.11w Protected Management Frames mode. */
  encryption80211wProtectedManagementFramesMode?: InputMaybe<SsidEncryption80211wProtectedManagementFramesMode>;
  /** Encryption protocol used by the SSID. */
  encryptionProtocol?: InputMaybe<SsidEncryptionProtocol>;
  /** Input values for Hotspot 2.0 (Passpoint) */
  hotspot20?: InputMaybe<CreateHotspot20Input>;
  /** Enable or disable 802.11ax (Wi-Fi 6) for the SSID. */
  is80211axEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable 802.11be (Wi-Fi 7) for the SSID. */
  is80211beEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable AP debug logging for APs broadcasting the SSID. */
  isAPDebugLogEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, all traffic sent on this SSID will be sent as voice access category, which means it will be prioritized compared to normal traffic of other SSIDs. */
  isAllTrafficVoicePriority?: Scalars['Boolean']['input'];
  /** Enable or disable broadcasting the SSID on the 2.4 GHz band. */
  isBand2GAllowed: Scalars['Boolean']['input'];
  /** Enable or disable broadcasting the SSID on the 5 GHz band. */
  isBand5GAllowed: Scalars['Boolean']['input'];
  /** Enable or disable broadcasting the SSID on the 6 GHz band. */
  isBand6GAllowed?: Scalars['Boolean']['input'];
  /** If true, only clients in the client allowlist will be allowed. */
  isClientAllowlistEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, clients in the blocklist will be blocked for this SSID. */
  isClientSSIDBlocklistEnabled?: Scalars['Boolean']['input'];
  /** Enable or disable the SSID. */
  isEnabled: Scalars['Boolean']['input'];
  /** Enable the SSID for all access points or only specified ones. */
  isEnabledForAllAccessPoints: Scalars['Boolean']['input'];
  /** Mark the SSID as a guest network. */
  isGuest?: Scalars['Boolean']['input'];
  /** Hide the SSID from being broadcasted. */
  isHidden: Scalars['Boolean']['input'];
  /** Enable client isolation on the SSID. */
  isIsolateClientsEnabled: Scalars['Boolean']['input'];
  /** Enable or disable multicast to unicast translation on the SSID. */
  isMulticastToUnicastEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether proxy ARP (AP responds to ARP requests coming from the uplink on behalf of the clients) is enabled */
  isProxyARPEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable 802.11k roaming. */
  isRoaming80211kEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable 802.11r fast roaming. */
  isRoaming80211rEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable 802.11v roaming. */
  isRoaming80211vEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Threshold above which multicast to unicast is disabled. If 0, no limit. */
  multicastToUnicastClientThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** A NAS (Network Access Server) identifier that can be used for Radius or 11r; if empty, defaults to the AP's hostname. */
  nasIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Pre-shared key (PSK) for the SSID. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Cadence for automatic password rotation. */
  passwordRotationCadence?: InputMaybe<SsidPasswordRotationCadence>;
  /** The day of the month for password rotation in the network's local time zone. */
  passwordRotationDayOfMonthLocal?: InputMaybe<Scalars['Int']['input']>;
  /** The day of the week for password rotation in the network's local time zone (0 = Sunday). */
  passwordRotationDayOfWeekLocal?: InputMaybe<Scalars['Int']['input']>;
  /** The hour of the day for password rotation in the network's local time zone. */
  passwordRotationHourOfDayLocal?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Set the primary 802.1X encryption configuration.
   * Required if encryptionProtocol is WPA2_ENTERPRISE.
   */
  primaryEncryption8021XUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Enable or disable RADIUS Change of Authorization (CoA). */
  radiusCoaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A port where RADIUS servers can send CoA requests. If unset, default port will be 3799 as per RFC 3576. */
  radiusCoaPort?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum wait in seconds between two RADIUS retries. */
  radiusMaxRetryWait?: InputMaybe<Scalars['Int']['input']>;
  /** Number of RADIUS server retries before a failover. */
  radiusServerRetries?: InputMaybe<Scalars['Int']['input']>;
  /** Input values for attaching and creating rate limit rules. */
  rateLimitRules?: InputMaybe<Array<UpsertRateLimitRuleInput>>;
  /** Value to configure RTS/CTS. */
  rtsCtsEnabledCode?: InputMaybe<Scalars['Int']['input']>;
  /** Size of the PPDU on which RTS would be sent out. */
  rtsThreshold?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Set the secondary 802.1X encryption configuration.
   * Required if encryptionProtocol is WPA2_ENTERPRISE.
   */
  secondaryEncryption8021XUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Name of the SSID. */
  ssid: Scalars['String']['input'];
  /** UUID of the VLAN to associate with the SSID. */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Input values for creating IPSKs. */
  wifiIPSKs?: InputMaybe<Array<CreateWifiIpskInput>>;
};

/** Input values for creating multiple SSIDs. */
export type CreateSsiDsInput = {
  /** Input fields for creating the SSID. */
  input: CreateSsidInput;
  /** UUID of the network where the SSID will be created. */
  networkUUID: Scalars['UUID']['input'];
};

/** Result of creating a SSO dashboard for a company. */
export type CreateSsoDashboardForCompanyResult = {
  __typename?: 'CreateSSODashboardForCompanyResult';
  /** The company for which the SSO dashboard was created. */
  company: Company;
  /** The URL of the SSO dashboard. */
  dashboardURL: Scalars['String']['output'];
};

/** Result of creating an SSO redirect URI. */
export type CreateSsoRedirectUriResult = {
  __typename?: 'CreateSSORedirectURIResult';
  /** The URI to redirect to for SSO login. */
  uri: Scalars['String']['output'];
};

/** Input for verifying an SSO authentication. */
export type CreateSsoVerifyInput = {
  /** The authorization code returned by the SSO provider. */
  code: Scalars['String']['input'];
  /** Deprecated. The source of the verification request. */
  source?: InputMaybe<SsoVerificationSource>;
  /** Optional state parameter for CSRF protection. */
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Result returned after verifying an SSO authentication. */
export type CreateSsoVerifyResult = {
  __typename?: 'CreateSSOVerifyResult';
  /** The email address of the authenticated user. */
  email: Scalars['String']['output'];
  /** The first name of the authenticated user. */
  firstName: Scalars['String']['output'];
  /** If the session was created via impersonation, this field will be set. */
  impersonator?: Maybe<Impersonator>;
  /** The last name of the authenticated user. */
  lastName: Scalars['String']['output'];
  /** The path to redirect the user to after successful authentication. */
  path?: Maybe<Scalars['String']['output']>;
  /** Indicates if the user is accessing a preview environment. */
  preview?: Maybe<Scalars['Boolean']['output']>;
  /** The method used to authenticate the user. */
  via?: Maybe<Scalars['String']['output']>;
};

/** Input type for creating a firewall device pair. This is deprecated, use `CreateHardwareDevicePairInput` instead. */
export type CreateSecurityApplianceDevicePairInput = {
  /** The serial number of the left device in the pair. */
  leftDeviceSerial: Scalars['String']['input'];
  /** The serial number of the right device in the pair. */
  rightDeviceSerial: Scalars['String']['input'];
};

/** Input for creating a service request. */
export type CreateServiceRequestInput = {
  /** The deployment job to create tasks within */
  deploymentJobUUID: Scalars['UUID']['input'];
  /** The field values for this service request */
  fields: Array<ServiceRequestFieldInput>;
  /** Optional parent task — generated root tasks will be children of this task */
  parentTaskUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Declares that this deployment does not need any task work to declare this deliverable copmlete. */
  skip?: InputMaybe<SkipServiceRequestInput>;
  /** SLA duration in seconds — tasks will be due at startAt + this value (startAt defaults to now). Defaults to the spec's defaultSLASeconds when omitted. */
  slaSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** When work begins. If omitted, defaults to now. */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The type of service request to create */
  type: ServiceRequestType;
};

export type CreateSpeedtestRuleInput = {
  /** Frequency to run the rule at */
  frequency: SpeedtestRuleFrequency;
  /** If the rule is enabled or disabled */
  isEnabled: Scalars['Boolean']['input'];
  /** Max number of bytes transfered by jobs started by this rule */
  maxTransferBytes: Scalars['Uint32']['input'];
  /** Network UUID if the rule targets one */
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Phy interface UUID if the rule targets one */
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Scheduled day of the week to run the rule on, starting at Sunday (0) */
  scheduledDayOfWeekLocal?: InputMaybe<Scalars['Int']['input']>;
  /** Scheduled hour of the day to run the rule at */
  scheduledHourLocal: Scalars['Int']['input'];
};

/** Result of creating SSO OAuth URIs for Google and Microsoft authentication. */
export type CreateSsoOAuthUriResult = {
  __typename?: 'CreateSsoOAuthURIResult';
  /** The OAuth URI for Google authentication. */
  googleUri: Scalars['String']['output'];
  /** The OAuth URI for Microsoft authentication. */
  microsoftUri: Scalars['String']['output'];
};

export type CreateStaticRouteInput = {
  /** Destination IP prefix for the static route. */
  dstPrefix: Scalars['IPPrefix']['input'];
  /**
   * UUIDs of VLANs to be excluded from the static route.
   * Only valid if this is a default route (0.0.0.0/0 destination prefix).
   * Only one of `explicitlyBoundVLANUUIDs` and `excludedVLANUUIDs` can be non-null and non-empty.
   */
  excludedVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /**
   * UUIDs of VLANs to be bound to the static route.
   * Only valid if this is a default route (0.0.0.0/0 destination prefix).
   * If empty, all non-excluded VLANs will be bound to the default route.
   * Only one of `explicitlyBoundVLANUUIDs` and `excludedVLANUUIDs` can be non-null and non-empty.
   */
  explicitlyBoundVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** UUID of the DHCP Static Mapping to be used as gateway. */
  gatewayDHCPStaticMappingUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Gateway IP address for the static route. */
  gatewayIP?: InputMaybe<Scalars['IPV4']['input']>;
  /** UUID of the VLAN to be used as the gateway. */
  gatewayVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Indicates whether the static route is enabled. */
  isEnabled?: Scalars['Boolean']['input'];
  /** Name of the static route. */
  name: Scalars['String']['input'];
};

/** Represents the input for creating a support case attachment */
export type CreateSupportCaseAttachmentsInput = {
  /** S3Key the files are uploaded to. */
  S3Keys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Content encoding of the attachment, defaults to Binary. */
  contentEncoding?: InputMaybe<ContentEncoding>;
  /** Name of the file. */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Size of the file. */
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  /** If the attachment is public. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents the input for creating a support case comment */
export type CreateSupportCaseCommentInput = {
  /** Keys of files (returned from `createSupportCaseAttachmentUploadUrl`) to attach to this comment. */
  attachmentKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Attachments input. */
  attachments?: InputMaybe<Array<CreateSupportCaseAttachmentsInput>>;
  /** The author of the comment. Defaults to the authenticated user or the Meter API key owner. */
  author?: InputMaybe<SupportCaseContactInput>;
  /** Comment body. */
  body: Scalars['String']['input'];
  /** Client-supplied external identifier for the comment. */
  externalID?: InputMaybe<Scalars['String']['input']>;
  /** If the feed entry is visible to external users. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** S3 keys of files uploaded alongside this comment. */
  s3Keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateSupportCaseInput = {
  /** Assignee contact for the case. */
  assignedTo?: InputMaybe<SupportCaseContactInput>;
  /** The close code for the support case. */
  closeCode?: InputMaybe<SupportCaseCloseCode>;
  /** The closing notes for the support case. */
  closeNotes?: InputMaybe<Scalars['String']['input']>;
  /** Email addresses of collaborators to be notified about the case. */
  collaborators?: InputMaybe<Array<Scalars['String']['input']>>;
  /** UUID of the company experiencing the issue. */
  companyUUID: Scalars['UUID']['input'];
  /** Contacts associated with the case. */
  contacts?: InputMaybe<Array<SupportCaseContactInput>>;
  /** Customer contact for the case. */
  customer?: InputMaybe<SupportCaseContactInput>;
  /** Description of the case. */
  description: Scalars['String']['input'];
  /** Email address of the person creating the case. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Client-supplied external identifier for the case. */
  externalID?: InputMaybe<Scalars['String']['input']>;
  /** Comments to leave on case creation, created in order. */
  initialComments?: InputMaybe<Array<CreateSupportCaseCommentInput>>;
  /** Location of the issue. */
  issueLocation?: InputMaybe<Scalars['String']['input']>;
  /** More refined type for the issue. */
  issueType: IssueType;
  /** MAC address of the device experiencing the issue. */
  macAddress?: InputMaybe<Scalars['String']['input']>;
  /** Name of the person creating the case. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** URL of the network experiencing the issue. */
  networkURL?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the network experiencing the issue. */
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Origin of the case. */
  origin: SupportCaseOrigin;
  /** Parent support case for the case. */
  parentSupportCaseUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Priority of the case. Low, Medium, or High. */
  priority: SupportCasePriority;
  /** Requester contact for the case. */
  requester?: InputMaybe<SupportCaseContactInput>;
  /** Person who resolved the case. */
  resolvedBy?: InputMaybe<SupportCaseContactInput>;
  /** Subject of the case. */
  subject: Scalars['String']['input'];
  /** Type of the technology affected, such as Wired, Wireless, Wired and Wireless, Dashboard, or Unsure. */
  type: TechnologyType;
};

/** The response from creating a case. */
export type CreateSupportCaseResponse = {
  __typename?: 'CreateSupportCaseResponse';
  /** The created support case. */
  case: SupportCase;
  /**
   * The ID of the created case in salesforce. now deprecated
   * @deprecated No longer supported
   */
  caseID: Scalars['String']['output'];
};

/** Input for creating a support provider alert receiver */
export type CreateSupportProviderAlertReceiverWithTargetsInput = {
  /** Label for the new alert receiver. */
  label: Scalars['String']['input'];
  /** List of alert targets to associate with the new alert receiver. */
  targets: Array<AlertTargetInput>;
};

/** Input for creating a support provider */
export type CreateSupportProviderInput = {
  /** The point of contact to associate with the support provider. */
  pointOfContactID?: InputMaybe<Scalars['Int']['input']>;
  /** Public api key uuid to associate with the support provider. */
  publicAPIKeyUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for creating a support user from a user. */
export type CreateSupportUserInput = {
  /** Department to filter user to. */
  department: SupportUserDepartment;
  /** Role to filter user to. */
  role: SupportUserRole;
  /** ID of user */
  userID: Scalars['ID']['input'];
};

export type CreateSwitchAutoConfigMacAddressVlanBindingInput = {
  /** The OUI (Organizationally Unique Identifier) to bind to a VLAN. Either OUI, macAddress, or vendor must be provided. */
  OUI?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the VLAN to assign to the specified MAC address or OUI. */
  VLANUUID: Scalars['UUID']['input'];
  /** The MAC address to bind to a VLAN. Either macAddress, OUI, or vendor must be provided. */
  macAddress?: InputMaybe<Scalars['MacAddress']['input']>;
  /** The vendor of devices as specified by the IEEE OUI database: https://standards-oui.ieee.org/. Either vendor, macAddress, or OUI must be provided. Use the OUI resolvers to get the correct string to input here. */
  vendor?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for creating a switch profile. */
export type CreateSwitchProfileInput = {
  /** For 802.1X encryption on a Switch's ports, if a client fails 802.1X authentication, clients are placed in the specified VLAN. The VLAN must be specified as `isGuest`. If set to null, then clients must authenticate before accessing the network. */
  encryption8021XGuestVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** For 802.1X encryption on a Switches, if a vlan is specified as a source vlan for radius, then the switch will use that vlan to send radius requests. If not set, then the switch will use the management vlan. */
  encryption8021XRadiusSourceVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The 802.1X encryption configurations associated with this switch profile. */
  encryption8021XUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** If true, flap link intervention protocol is enabled on the port. Both this flag and isFLIPEnabled in SwitchProfile must be true for FLIP to be enabled on a port. */
  isFLIPEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enables switch to periodically send IGMP queries to detect multicast clients. */
  isIGMPSnoopingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enables switch to periodically send MLD queries to detect multicast clients. */
  isMLDSnoopingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the switch's 802.1X ports authenticate against Meter's managed RADIUS, using the NAC policies defined for the network. Mutually exclusive with encryption8021XUUIDs. */
  isMeterNACEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Multicast filtering tells the switch what to do with unknown multicast packet i.e packets for which snooping doesn't have any learned ports. When enabled, unknown multicast packets are dropped. */
  isMulticastFilteringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, voice VLAN is enabled for this port. Both this flag and isVoiceVLANEnabled in SwitchProfile must be true for voice VLAN to be enabled on a port. */
  isVoiceVLANEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time in seconds after which a MAC entry will be aged out, default is 300 seconds (5 minutes) and 0 means no expiration. */
  macTableAgingSec?: Scalars['Int']['input'];
  /** The maximum transmission unit (MTU) size in bytes. */
  mtu?: Scalars['Int']['input'];
  /** The name of the switch profile. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier of the network where the switch profile will be created. */
  networkUUID: Scalars['UUID']['input'];
  /**
   * The STP bridge priority for the switch.
   *
   * The lower the value, the more likely the switch is to be elected as the root bridge.
   * The default is 32768.
   * The range is 0 to 61440. Valid values are multiples of 4096.
   */
  stpBridgePriority?: Scalars['Int']['input'];
  /** The tier of the switch device(s) associated with the switch profile, denoting the purpose of the devices in the network. */
  switchingTier: SwitchProfileSwitchingTier;
};

/** Used to create a synthetic hardware device in the dev (staging) realm for testing purposes. Unlike CreateDevHardwareDeviceInput, this does not attempt to claim the device from prod. */
export type CreateSyntheticHardwareDeviceInput = {
  /** The model of the hardware device. */
  deviceModel: DeviceModel;
  /** The type of the hardware device. */
  deviceType: DeviceType;
  /** The MAC address of the hardware device. */
  macAddress?: InputMaybe<Scalars['MacAddress']['input']>;
  /** The serial number of the hardware device. */
  serialNumber: Scalars['String']['input'];
};

export type CreateTopologyDesignLinkInput = {
  /** Physical cable medium. */
  cableType: TopologyDesignCableType;
  /** Intended link speed in Mbps. */
  intendedSpeedMbps: Scalars['Int']['input'];
  /** Link classification. */
  linkRole: TopologyDesignLinkRole;
  /** Interface type on side A. */
  sideAInterfaceType?: InputMaybe<TopologyDesignInterfaceType>;
  /** The UUID of the node on side A. Nullable only if the link is being constructed within the bulk upsert. */
  sideANodeUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Port label on the side A device (e.g. '1', 'LAN1', 'WAN1'). */
  sideAPort?: InputMaybe<Scalars['String']['input']>;
  /** Interface type on side B. */
  sideBInterfaceType?: InputMaybe<TopologyDesignInterfaceType>;
  /** The UUID of the node on side B. Nullable only if the link is being constructed within the bulk upsert. */
  sideBNodeUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Port label on the side B device (e.g. '1', 'LAN1', 'WAN1'). */
  sideBPort?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTopologyDesignNodeInput = {
  /** Building name or identifier. */
  building?: InputMaybe<Scalars['String']['input']>;
  /** Optional description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The intended device model identifier, e.g. S1, F3, G1, ISP_HANDOFF for design-only nodes, or a free-text model/kind for THIRD_PARTY nodes. */
  deviceModel: Scalars['String']['input'];
  /** The type of device. */
  deviceType: TopologyDesignDeviceType;
  /** Label of the distribution frame. */
  distributionFrameLabel?: InputMaybe<Scalars['String']['input']>;
  /** MDF or IDF. */
  distributionFrameType?: InputMaybe<TopologyDesignDistributionFrameType>;
  /** Floor name or number. */
  floor?: InputMaybe<Scalars['String']['input']>;
  /** Intended device label. */
  label: Scalars['String']['input'];
  /** Freeform notes about the installation location. */
  locationNotes?: InputMaybe<Scalars['String']['input']>;
  /** Label of the rack. */
  rackLabel?: InputMaybe<Scalars['String']['input']>;
  /** Room within the floor. */
  room?: InputMaybe<Scalars['String']['input']>;
  /** The switching layer. Only applicable to switches. */
  switchingTier?: InputMaybe<SwitchProfileSwitchingTier>;
};

export type CreateTopologyDesignVersionInput = {
  /** If set, deep-copies nodes, links, and the build record (buildSteps and generationInput) from this version into the new draft. */
  forkedFromVersionUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Human-readable name for the new version. */
  name: Scalars['String']['input'];
  /** Optional notes. */
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTopologyDesignVirtualDevicesInput = {
  /** The default VLAN ID for HA advertisements when that VLAN must be created. */
  advertisementVLANID?: Scalars['Int']['input'];
  /** Whether the virtual devices should be active. Inactive virtual devices are created as drafts. */
  isActive?: Scalars['Boolean']['input'];
  /** The default VLAN ID for the first ISP switch's circuit when that VLAN must be created. */
  isp01VLANID?: Scalars['Int']['input'];
  /** The default VLAN ID for the second ISP switch's circuit when that VLAN must be created. */
  isp02VLANID?: Scalars['Int']['input'];
};

/** Input type for creating or updating an underlay pool for a network. */
export type CreateUnderlayPoolInput = {
  /** The base IP address of the pool. */
  baseAddress: Scalars['IPV4']['input'];
  /** The CIDR prefix determining the size of the address pool. */
  prefixLength: Scalars['Int']['input'];
};

/** Feedback submitted by a dashboard user. */
export type CreateUserFeedbackInput = {
  /** The feedback text. */
  feedback: Scalars['String']['input'];
  /** The Datadog session replay associated with the feedback. */
  sessionReplayUrl?: InputMaybe<Scalars['String']['input']>;
  /** The dashboard page where the feedback was submitted. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Input type containing parameters required to create user access to a network. */
export type CreateUserNetworkAccessInput = {
  /** The date and time when the access should expire. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The unique identifier (UUID) of the network to which access is being granted. */
  networkUUID: Scalars['UUID']['input'];
};

export type CreateVlanInput = {
  /** A list of DHCP rules to create for this VLAN. */
  createDHCPRules?: InputMaybe<Array<CreateDhcpRuleInput>>;
  /** An optional description of the VLAN. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the protocol for assigning IPv4 addresses to clients on this VLAN. */
  ipV4ClientAssignmentProtocol?: InputMaybe<ClientAssignmentProtocol>;
  /** Specifies the IPv4 gateway address for this VLAN. */
  ipV4ClientGateway?: InputMaybe<Scalars['IPV4']['input']>;
  /** Specifies the IPv4 prefix length (subnet mask) for this VLAN. */
  ipV4ClientPrefixLength?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Specifies the IPv4 address of an externally-managed (non-Meter) gateway for this L2 VLAN;
   * used by features like client isolation. Mutually exclusive with ipV4ClientGateway.
   * If set, ipV4ExternalPrefixLength must be set as well.
   */
  ipV4ExternalGateway?: InputMaybe<Scalars['IPV4']['input']>;
  /** Specifies the IPv4 prefix length (subnet mask) that pairs with ipV4ExternalGateway. */
  ipV4ExternalPrefixLength?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies the protocol for assigning IPv6 addresses to clients on this VLAN. */
  ipV6ClientAssignmentProtocol?: InputMaybe<ClientAssignmentProtocol>;
  /** Specifies the IPv6 gateway address for this VLAN. */
  ipV6ClientGateway?: InputMaybe<Scalars['IPV6']['input']>;
  /** Specifies the IPv6 prefix length (subnet mask) for this VLAN. */
  ipV6ClientPrefixLength?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Override to indicate this VLAN is the native VLAN for access point management traffic.
   * This is a nonstandard configuration used for APs to reach external radius servers,
   * future firmware work will deprecate the need for ever setting this.
   */
  isAPNativeVLAN?: Scalars['Boolean']['input'];
  /** If true, the VLAN is enabled upon creation. */
  isEnabled?: Scalars['Boolean']['input'];
  /**
   * Override to indicate that this VLAN is an ISP VLAN and should be rendered only on
   * Meter ISP switches. This is a nonstandard configuration and should be used carefully.
   */
  isISPVLAN?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, this VLAN is for Meter internal use only and should not be displayed to or editable by the customer. */
  isInternal?: Scalars['Boolean']['input'];
  /** If true, the VLAN participates in multicast/mDNS reflection. */
  isMulticastReflectionEnabled?: Scalars['Boolean']['input'];
  /**
   * If true, this VLAN is suggested as the uncategorized client native VLAN in switch auto-configuration.
   * Setting this to true unsets the flag on any other VLAN in the network.
   */
  isUncategorizedClientFallback?: Scalars['Boolean']['input'];
  /** If true, prevents this VLAN from sending traffic through WANs (blocks internet access). */
  isWANDenied?: Scalars['Boolean']['input'];
  /** A human-friendly name to identify the VLAN. */
  name: Scalars['String']['input'];
  /**
   * If true, allows this VLAN to participate in cross-site VPN features and its IPv4Prefix cannot overlap with any other
   * IPv4Prefix for VLANs with a true participatesInVPN in the associated company for this network.
   */
  participatesInVPNs?: Scalars['Boolean']['input'];
  /**
   * VLANs explicitly allowed to inter-communicate with this VLAN.
   * Effectively equivalent to firewall rules allowing communication between this VLAN and all of these VLANs.
   */
  permittedInterVLANCommunicationVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The VLAN ID. Must be between 1 and 4094 and is unique per network. If not provided, the lowest available ID for the network will be selected. */
  vlanID?: InputMaybe<Scalars['Int']['input']>;
};

/** The metadata required to create a virtual device. */
export type CreateVirtualDeviceInput = {
  /**
   * Interval at which the firewalls will advertise to one another, in milliseconds.
   * Defaults to 300ms.
   */
  advertisementIntervalMs?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Existing VLAN UUID to use for a advertisement VLAN.
   * At most one of `advertisementVLANUUID` and `advertisementVLANInput` can be provided.
   * Valid only for controllers.
   */
  advertisementVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Input parameters to use for a new advertisement VLAN.
   * At most one of `advertisementVLANUUID` and `advertisementVLANInput` can be provided.
   * Valid only for controllers.
   */
  createAdvertisementVLANInput?: InputMaybe<CreateVlanInput>;
  /** An optional description for the virtual device. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The model of the virtual device. */
  deviceModel: DeviceModel;
  /** The type of the virtual device to create. */
  deviceType: VirtualDeviceType;
  /** Installer label for devices. Only supported on [CellularAccessPoint, CellularSwitches, CarrierAppliance] */
  installerLabel?: InputMaybe<Scalars['String']['input']>;
  /** Whether this virtual device is in a draft state for preconfiguration reasons. */
  isDraft?: Scalars['Boolean']['input'];
  /**
   * Mark the virtual device as read-only. As of now this is only supported for PDUs.
   * If the device is marked as read-only, updating any other fields will result in a Bad Request error.
   */
  isReadonly?: Scalars['Boolean']['input'];
  /** A human-friendly name for the virtual device. */
  label: Scalars['String']['input'];
  /** The UUID of the NOS upgrade group to associate with the virtual devices for grouped firmware upgrades. */
  nosUpgradeGroupUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** [Access Points only] The radio settings to apply to the access point. */
  radioSettings?: InputMaybe<CreateRadioSettingsInput>;
  /** [Switches only] Customize the switch profile for the device. A default hardcoded switch profile is created when the device is created; if not provided, the default will be used with no modifications. */
  switchProfile?: InputMaybe<UpdateSwitchProfileInput>;
  /** [Switches only] The UUID of the switch profile to associate with the switch. */
  switchProfileUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** [Switches only] The switching tier for the virtual device's switch profile. */
  switchingTier?: InputMaybe<SwitchProfileSwitchingTier>;
  /** Specify VirtualDeviceTags by name. If a tag with this name does not exist in the network, it will be created and attached to the device. If it already exists, it will be attached to the device. */
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateVirtualDeviceTagInput = {
  /** Name of the virtual device tag to create. */
  name: Scalars['String']['input'];
  /** Unique identifier of the network to create the tag in. */
  networkUUID: Scalars['UUID']['input'];
};

/** Create many virtual devices at once, with the same type and model. */
export type CreateVirtualDevicesInput = {
  /** How many virtual devices to create, up to 100. */
  count: Scalars['Int']['input'];
  /** The model of the virtual devices to create. */
  deviceModel: DeviceModel;
  /** The type of the virtual devices to create. */
  deviceType: VirtualDeviceType;
  /** Whether this virtual device is in a draft state for preconfiguration reasons. */
  isDraft?: Scalars['Boolean']['input'];
  /**
   * Mark the virtual device as read-only. As of now this is only supported for PDUs.
   * If the device is marked as read-only, updating any other fields will result in a Bad Request error.
   */
  isReadonly?: Scalars['Boolean']['input'];
  /** The labels of the devices will all start with the prefix, followed by an increasing suffix number (e.g., "AP" -> "AP01", "AP02", "AP03", ...). */
  labelPrefix: Scalars['String']['input'];
  /** The starting number to suffix the labels with, defaults to 1. The numbers will be zero-padded at the front. */
  labelSuffixIndex?: Scalars['Int']['input'];
  /** Optionally specify suffixes to skip when generating labels. */
  labelSuffixesToSkip?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The UUID of the NOS upgrade group to associate with the virtual devices for grouped firmware upgrades. */
  nosUpgradeGroupUUID: Scalars['UUID']['input'];
  /** [For Switches only] Customize the switch profile for the devices. A default hardcoded switch profile is created when the devices are created; if not provided, the default will be used with no modifications. */
  switchProfile?: InputMaybe<UpdateSwitchProfileInput>;
  /** [For Switches only] Set the device's switch profile's switching tier. */
  switchingTier?: InputMaybe<SwitchProfileSwitchingTier>;
  /** Specify VirtualDeviceTags by name. If a tag with this name does not exist in the network, it will be created and attached to the devices. If it already exists, it will be attached to the devices. */
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input type for creating a new Wifi IPSK. */
export type CreateWifiIpskInput = {
  /**
   * An optional array of MAC addresses to restrict a password to some clients (if null, no
   * MAC restriction)
   */
  clientMACs?: InputMaybe<Array<Scalars['MacAddress']['input']>>;
  /** A label for this IPSK */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Password for authentication. */
  password: Scalars['String']['input'];
  /** The UUID of the SSID for which we add an IPSK */
  ssidUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The VLAN UUID if dynamic VLAN is enabled. */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input values for creating multiple IPSKs. */
export type CreateWifiIpsKsInput = {
  /** Input values for the IPSK. */
  input: CreateWifiIpskInput;
  /** The unique identifier of the associated SSID. */
  ssidUUID: Scalars['UUID']['input'];
};

/** A company-defined role with a user-specified set of permissions. */
export type CustomRole = {
  __typename?: 'CustomRole';
  /** The unique identifier of the custom role. */
  UUID: Scalars['UUID']['output'];
  /** When the custom role was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Effective permissions: own permissions plus all permissions from the inherited built-in role. */
  effectivePermissions: Array<PermissionType>;
  /** A built-in role whose full permission set this custom role inherits. */
  inheritsFromRole?: Maybe<RoleName>;
  /** The display name of the custom role. */
  name: Scalars['String']['output'];
  /** Permissions assigned directly to this role, not counting inheritance. */
  ownPermissions: Array<PermissionType>;
  /** Whether the role applies at company scope or network scope. */
  scope: CustomRoleScope;
  /** When the custom role was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Scope for a custom role — either company-wide or network-specific. */
export enum CustomRoleScope {
  /** The role applies across the entire company. */
  Company = 'COMPANY',
  /** The role applies within a specific network. */
  Network = 'NETWORK'
}

/** A dynamic DNS record. */
export type DdnsRecord = {
  __typename?: 'DDNSRecord';
  /** The unique identifier of this record. */
  UUID: Scalars['UUID']['output'];
  /** The current IP address for this DDNS record. May be null if not yet set. */
  address?: Maybe<Scalars['IP']['output']>;
  /** When the `address` was most recently updated. */
  addressUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When this DDNS record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Optional description for this DDNS record. */
  description?: Maybe<Scalars['String']['output']>;
  /** The main domain name, must be a supported domain name. */
  domain: Scalars['String']['output'];
  /** The fully qualified domain name for this record. Concatenation of `subdomain` and `domain` with a `.` separator. */
  fqdn: Scalars['String']['output'];
  /** The network associated with this DDNS record. */
  network: Network;
  /** The unique identifier of the network associated with this DDNS record. */
  networkUUID: Scalars['UUID']['output'];
  /** The WAN uplink for this DDNS record's current IP address, if set. */
  phyInterface?: Maybe<PhyInterface>;
  /** The unique identifier for the WAN uplink for this DDNS record's current IP address, if set. */
  phyInterfaceUUID?: Maybe<Scalars['UUID']['output']>;
  /** The unique subdomain for this DDNS record. */
  subdomain: Scalars['String']['output'];
  /** When this DDNS record was last updated (excluding `address`-only updates). */
  updatedAt: Scalars['DateTime']['output'];
};

/** Arbitrary DHCP option values to pass to Kea configuration that we do not yet have dedicated fields for. */
export type DhcpOption = Identifiable & {
  __typename?: 'DHCPOption';
  /** The unique identifier of the DHCP option. */
  UUID: Scalars['UUID']['output'];
  /**
   * The DHCP option code (also called tag). Refer to the IANA DHCP options list:
   * https://www.iana.org/assignments/bootp-dhcp-parameters/bootp-dhcp-parameters.xhtml
   */
  code: Scalars['Int']['output'];
  /** The timestamp when this DHCP option was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The data value for the DHCP option. */
  data: Scalars['String']['output'];
  /** If this is a custom (nonstandard) DHCP option, the type of the data. */
  dataType?: Maybe<DhcpOptionDataType>;
  /** An optional description for the DHCP option. */
  description?: Maybe<Scalars['String']['output']>;
  /** The UUID of the DHCP rule this option belongs to. */
  dhcpRuleUUID: Scalars['UUID']['output'];
  /** The timestamp when this DHCP option was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** If set, the option will only apply to devices with the given Vendor Class Identifier (VCI). */
  vendorClassID?: Maybe<Scalars['String']['output']>;
};

/** Data type for custom (nonstandard) DHCP options. */
export enum DhcpOptionDataType {
  /** A hexadecimal-encoded binary value, without a 0x prefix. */
  Binary = 'BINARY',
  /** A plain text string. */
  String = 'STRING'
}

/** A proxied DHCP server that will be used instead of the VLAN's own internal one. */
export type DhcpProxy = Identifiable & {
  __typename?: 'DHCPProxy';
  /** The unique identifier of the DHCP proxy. */
  UUID: Scalars['UUID']['output'];
  /** The VLAN associated with this DHCP proxy. */
  dhcpRule: DhcpRule;
  /** The UUID of the DHCP rule associated with this DHCP proxy. */
  dhcpRuleUUID: Scalars['UUID']['output'];
  /** The IP address of this DHCP proxy. */
  ipAddress: Scalars['IP']['output'];
  /** The uplink physical interface (WAN) that should be used for egress with this proxy. */
  phyInterface?: Maybe<PhyInterface>;
  /** The UUID of the uplink physical interface (WAN) that should be used for egress with this proxy. */
  phyInterfaceUUID?: Maybe<Scalars['UUID']['output']>;
};

/** Sub-ranges within the `DHCPRule` range to reserve for static IP assignment and not issue DHCP leases within. */
export type DhcpReservedRange = Identifiable & {
  __typename?: 'DHCPReservedRange';
  /** The unique identifier of the DHCP reserved range. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when this DHCP reserved range was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A human-readable description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The UUID of the DHCP rule this reserved range belongs to. */
  dhcpRuleUUID: Scalars['UUID']['output'];
  /** The last reserved IP address in the range, ascending and inclusive. */
  endIPAddress: Scalars['IP']['output'];
  /** The first reserved IP address in the range, ascending and inclusive. */
  startIPAddress: Scalars['IP']['output'];
  /** The timestamp when this DHCP reserved range was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Stores specific information about a DHCP server for a specific interface, equivalent to a Kea 'subnet'. */
export type DhcpRule = Identifiable & {
  __typename?: 'DHCPRule';
  /** The unique identifier of the DHCP rule. */
  UUID: Scalars['UUID']['output'];
  /** A list of application-level DNS firewall rules applied to this DHCP rule. */
  applicationDNSFirewallRules: Array<ApplicationDnsFirewallRule>;
  /** The timestamp when this DHCP rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A list of DHCP proxies on this rule. Omitted if DHCP is being served. */
  dhcpProxies?: Maybe<Array<DhcpProxy>>;
  /** A list of DHCP rule filters on this DHCP rule. */
  dhcpRuleFilters: Array<DhcpRuleFilter>;
  /** Enables or disables DNS caching on the DHCP server. If `false`, DNS caching is disabled regardless of other settings. */
  dnsCacheIsEnabled: Scalars['Boolean']['output'];
  /** Specifies the maximum Time-To-Live (TTL) in seconds for cached DNS entries. */
  dnsCacheMaxTTL: Scalars['Int']['output'];
  /** Specifies the maximum number of DNS records to cache when DNS caching is enabled. */
  dnsCacheSize: Scalars['Int']['output'];
  /** IP used as DNS proxy before forwarding requests to upstream DNS servers. Must be within the DHCP rule subnet and must be within a reserved range and not used by a static mapping. */
  dnsForwardingIPAddress?: Maybe<Scalars['IP']['output']>;
  /** A list of DNS host mappings that override regular DNS lookups for specific domains. */
  dnsHostMappings: Array<DnsHostMapping>;
  /** A list of DNS search domains provided to DHCP clients (e.g., 'local.meter'). */
  dnsSearchDomains?: Maybe<Array<Scalars['String']['output']>>;
  /** List of upstream DNS servers to use when `dnsUseGatewayProxy` is `false`, or to forward queries to when enabled. */
  dnsUpstreamServers: Array<Scalars['IP']['output']>;
  /** Determines if the gateway acts as a DNS proxy for clients. If `true`, DNS queries are sent via the gateway. */
  dnsUseGatewayProxy: Scalars['Boolean']['output'];
  /** The last available IP address in the DHCP range, ascending and inclusive. Omitted if DHCP is not being served. */
  endIPAddress?: Maybe<Scalars['IP']['output']>;
  /** The gateway IP address provided to DHCP clients (commonly known as the router option or DHCP option 3). */
  gatewayIPAddress: Scalars['IP']['output'];
  /** The prefix length of the gateway IP address (e.g., 24 for a subnet mask of 255.255.255.0 in IPv4). */
  gatewayPrefixLength: Scalars['Int']['output'];
  /** If set, the gateway IP address is allowed to be different from its VLAN's address. */
  hasGatewayOverride: Scalars['Boolean']['output'];
  /** Indicates whether this DHCP rule is for IPv6 (`true`) or IPv4 (`false`). */
  isIPv6: Scalars['Boolean']['output'];
  /** The latest observed DHCP rule stats emitted by the active controller for this DHCP rule. */
  latestStats?: Maybe<LatestDhcpRuleStats>;
  /** The duration (in seconds) of the DHCP lease assigned to clients. Omitted if DHCP is not being served. */
  leaseDurationSeconds?: Maybe<Scalars['Int']['output']>;
  /** A list of additional DHCP options to pass to the DHCP server configuration. */
  options: Array<DhcpOption>;
  /** A list of IP ranges within the DHCP range that are reserved and not assigned to clients dynamically. */
  reservedRanges: Array<DhcpReservedRange>;
  /** The first available IP address in the DHCP range, ascending and inclusive. Omitted if DHCP is not being served. */
  startIPAddress?: Maybe<Scalars['IP']['output']>;
  /** A list of static mappings linking specific MAC addresses to fixed IP addresses. It's valid to provide a static mapping inside a reserved range - the static mapping will take precedence. */
  staticMappings: Array<DhcpStaticMapping>;
  /** The timestamp when this DHCP rule was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The VLAN associated with this DHCP rule. */
  vlan: Vlan;
  /** The UUID of the VLAN associated with this DHCP rule. */
  vlanUUID: Scalars['UUID']['output'];
};

/** A filter that allows specific devices to DHCP to a DHCP rule. Only one of allowedMACAddress and allowedOUI will be defined. */
export type DhcpRuleFilter = Identifiable & {
  __typename?: 'DHCPRuleFilter';
  /** The unique identifier of the DHCP rule filter. */
  UUID: Scalars['UUID']['output'];
  /** The MAC address this rule allows. */
  allowedMACAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** The MAC address OUI this rule allows. This is in the format XX:XX:XX */
  allowedOUI?: Maybe<Scalars['String']['output']>;
  /** The timestamp when this DHCP rule filter. */
  createdAt: Scalars['DateTime']['output'];
  /** The UUID of the DHCP rule this DNS rule filter. */
  dhcpRuleUUID: Scalars['UUID']['output'];
};

/** DHCP static mappings between MAC addresses and IP addresses to ensure clients receive predefined IP addresses. */
export type DhcpStaticMapping = Identifiable & {
  __typename?: 'DHCPStaticMapping';
  /** The unique identifier of the DHCP static mapping. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when this DHCP static mapping was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The UUID of the DHCP rule this static mapping belongs to. */
  dhcpRuleUUID: Scalars['UUID']['output'];
  /** The hostname to assign to the client device. */
  hostname?: Maybe<Scalars['String']['output']>;
  /** Assigned IP address for client device through static DHCP. Application logic will ensure this ip is within the associated `dhcp_rule.gateway_prefix`. */
  ipAddress?: Maybe<Scalars['IP']['output']>;
  /** The MAC address of the client device. */
  macAddress: Scalars['MacAddress']['output'];
  /** A name or label for this static mapping (for organizational purposes). */
  name?: Maybe<Scalars['String']['output']>;
  /** The timestamp when this DHCP static mapping was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The number of blocked queries from a client. */
export type DnsBlockedClientCount = {
  __typename?: 'DNSBlockedClientCount';
  /** The IP address of the client. */
  clientIP: Scalars['IP']['output'];
  /** The MAC address of the client, if it was resolved when its queries were blocked. */
  clientMACAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** The number of blocked queries from the client. */
  count: Scalars['Int']['output'];
};

/** The number of blocked queries for a domain. */
export type DnsBlockedDomainCount = {
  __typename?: 'DNSBlockedDomainCount';
  /** The number of blocked queries for the domain. */
  count: Scalars['Int']['output'];
  /** The DNS domain that was queried. */
  domain: Scalars['String']['output'];
};

/** A DNS query that was blocked by an application DNS firewall rule. */
export type DnsBlockedEvent = {
  __typename?: 'DNSBlockedEvent';
  /** When the query was blocked. */
  blockedAt: Scalars['DateTime']['output'];
  /** The IP address of the client that made the query. */
  clientIP: Scalars['IP']['output'];
  /**
   * The MAC address of the client that made the query, if it could be resolved from the client IP
   * when the query was blocked.
   */
  clientMACAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** The DNS domain that was queried. */
  domain: Scalars['String']['output'];
  /** The firewall rule that blocked the query. */
  rule?: Maybe<ApplicationDnsFirewallRule>;
  /** The virtual device that blocked the query. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** Filters for DNS blocked events. All set fields must match. */
export type DnsBlockedEventFilterInput = {
  /** Find events from this client IP address. */
  clientIP?: InputMaybe<Scalars['IP']['input']>;
  /** Find events from this client MAC address. */
  clientMACAddress?: InputMaybe<Scalars['MacAddress']['input']>;
  /** Find events whose domain contains this substring, ignoring case. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** Find events blocked by any of these rules. */
  ruleUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Find events blocked by any of these virtual devices. */
  virtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** A paged response for DNS blocked event queries. */
export type DnsBlockedEventsPage = {
  __typename?: 'DNSBlockedEventsPage';
  /** A subset of the events based on the limit and offset. */
  events: Array<DnsBlockedEvent>;
  /** The total number of events matching the query. */
  total: Scalars['Int']['output'];
};

/** Aggregates over DNS blocked events. Each field is only computed when requested. */
export type DnsBlockedEventsSummary = {
  __typename?: 'DNSBlockedEventsSummary';
  /** The number of blocked queries for each rule, most blocked first. */
  byRule: Array<DnsBlockedRuleCount>;
  /** The clients with the most blocked queries, most blocked first. */
  topClients: Array<DnsBlockedClientCount>;
  /** The most blocked domains, most blocked first. */
  topDomains: Array<DnsBlockedDomainCount>;
  /** The total number of blocked queries. */
  total: Scalars['Int']['output'];
};


/** Aggregates over DNS blocked events. Each field is only computed when requested. */
export type DnsBlockedEventsSummaryTopClientsArgs = {
  limit?: Scalars['Int']['input'];
};


/** Aggregates over DNS blocked events. Each field is only computed when requested. */
export type DnsBlockedEventsSummaryTopDomainsArgs = {
  limit?: Scalars['Int']['input'];
};

/**
 * Properties for a DNS Blocked event. Emitted when the Security Appliance blocks a
 * DNS query.
 */
export type DnsBlockedProperties = {
  __typename?: 'DNSBlockedProperties';
  /** The IP address of the client whose DNS query was blocked. */
  clientIP: Scalars['IP']['output'];
  /**
   * The MAC address of the client whose DNS query was blocked, if it could be
   * resolved from the client IP at the time the event was generated.
   */
  clientMACAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** The DNS domain that was blocked. */
  domain: Scalars['String']['output'];
  /** The firewall rule that caused the block. */
  rule?: Maybe<ApplicationDnsFirewallRule>;
  /** The virtual device that blocked the query. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** The number of queries blocked by a rule. */
export type DnsBlockedRuleCount = {
  __typename?: 'DNSBlockedRuleCount';
  /** The number of queries blocked by the rule. */
  count: Scalars['Int']['output'];
  /** The rule that blocked the queries. Null if the rule has since been deleted. */
  rule?: Maybe<ApplicationDnsFirewallRule>;
  /** The UUID of the rule that blocked the queries. */
  ruleUUID: Scalars['UUID']['output'];
};

/** Predefined mappings between a domain and IP address, overriding regular DNS lookups for the given domain. */
export type DnsHostMapping = Identifiable & {
  __typename?: 'DNSHostMapping';
  /** The unique identifier of the DNS host mapping. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when this DNS host mapping was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The domain to which `overrideDomain` should resolve. If specified, this mapping acts like a 'CNAME' record. */
  destinationDomain?: Maybe<Scalars['String']['output']>;
  /**
   * The first IP address to which `overrideDomain` should resolve. If specified, this mapping acts like an 'A' record.
   * @deprecated Use `destinationIPAddresses` instead.
   */
  destinationIPAddress?: Maybe<Scalars['IP']['output']>;
  /** The IP addresses to which `overrideDomain` should resolve. If specified, this mapping acts like one or more 'A' records. */
  destinationIPAddresses?: Maybe<Array<Scalars['IP']['output']>>;
  /** The UUID of the DHCP rule this DNS host mapping belongs to. */
  dhcpRuleUUID: Scalars['UUID']['output'];
  /** Indicates whether this DNS host mapping is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** The domain name to override. This can be a fully qualified domain name (FQDN) or a domain name (e.g., 'example.com'). */
  overrideDomain: Scalars['String']['output'];
  /** The timestamp when this DNS host mapping was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for DNS probe parameters. */
export type DnsProbeParamsInput = {
  /** Domain name to query. */
  domain: Scalars['String']['input'];
  /** DNS server port. */
  port?: InputMaybe<Scalars['Int']['input']>;
  /** DNS query class. */
  qclass?: InputMaybe<Scalars['Int']['input']>;
  /** DNS query type. */
  qtype?: InputMaybe<Scalars['Int']['input']>;
  /** DNS server IP address. */
  serverIP: Scalars['String']['input'];
};

/** Date range filter implementation. */
export type DateRangeFilter = {
  /** End of date range for the filter. */
  end?: InputMaybe<Scalars['DateTime']['input']>;
  /** The key for the filter. */
  key: Scalars['String']['input'];
  /** Start of date range for the filter. */
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

/** A range of DateTimes. Both bounds are optional and inclusive. */
export type DateTimeRangeInput = {
  /** The upper bound, inclusive. Null means unbounded above. */
  end?: InputMaybe<Scalars['DateTime']['input']>;
  /** The lower bound, inclusive. Null means unbounded below. */
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Result for CRUD ops for managing the default role for users in an organization */
export type DefaultRoleForUsersResponse = {
  __typename?: 'DefaultRoleForUsersResponse';
  /** The slug of the company where the default role is assigned */
  companySlug: Scalars['String']['output'];
  /** The name of the default role for users in the company (ie: company_admin_read_only), may be empty */
  defaultRoleForUsers: RoleName;
};

/** The default VLAN has no IPv4 gateway. */
export type DefaultVlanMissingGatewayIpActiveIssue = ActiveIssue & {
  __typename?: 'DefaultVLANMissingGatewayIPActiveIssue';
  /** When the issue was first detected, if available. */
  detectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The network that this issue is impacting. */
  networkUUID: Scalars['UUID']['output'];
  /** When the issue was resolved, if available. */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The severity of the issue. */
  severity: ActiveIssueSeverity;
  /** The type of the issue. */
  type: ActiveIssueType;
  /** The default VLAN missing its gateway IP. */
  vlan: Vlan;
};

/** Input for deleting a group-to-role mapping. */
export type DeleteCompanyRoleMappingInput = {
  /** The UUID of the mapping to delete. */
  UUID: Scalars['UUID']['input'];
  /** The slug of the company that owns the mapping. */
  companySlug: Scalars['String']['input'];
};

export type DeletePermittedEmailDomainInput = {
  /** The slug of the company from which the permitted email domain will be deleted. */
  companySlug: Scalars['String']['input'];
  /** The UUID of the permitted email domain to delete. */
  permittedEmailDomainSID: Scalars['UUID']['input'];
};

/** Result of deleting a permitted email domain, indicating the number of rows deleted. */
export type DeletePermittedEmailDomainResult = {
  __typename?: 'DeletePermittedEmailDomainResult';
  /** The number of permitted email domains that were deleted. */
  numRowsDeleted: Scalars['Int']['output'];
};

/** Input for deleting a support provider alert receiver. */
export type DeleteSupportProviderAlertReceiverWithTargetsInput = {
  /** Unique identifier of the alert receiver to delete. */
  alertReceiverUUID: Scalars['UUID']['input'];
  /** Unique identifier of the supported company. */
  companyUUID: Scalars['UUID']['input'];
};

/**
 * A deliverable is a discrete work product a deployment job needs produced.
 * Deliverables are 1:1 with service requests: a deliverable is created by
 * an associated service request, and the request's tasks produce the work product.
 */
export type Deliverable = Identifiable & {
  __typename?: 'Deliverable';
  /** UUID of the deliverable */
  UUID: Scalars['UUID']['output'];
  /** When this deliverable was cancelled. Cleared when the service request is requested again. */
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who initiated the service request that created this deliverable. */
  createdBy?: Maybe<User>;
  /** The service request definition backing this deliverable, for rendering (label, description, category, form fields). */
  definition: ServiceRequestDefinition;
  /** The deployment job this deliverable belongs to. */
  deploymentJob: DeploymentJob;
  /** Human-readable display name for the deliverable type, or null if no display name is defined. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The inputs to this deliverable's service request and their completion state. */
  inputs: Array<DeliverableInput>;
  /** The result of the owner's review of the deliverable's work product. */
  review: DeliverableReview;
  /** The owner's description of the review. Set only when review is APPROVED or REJECTED. */
  reviewDescription?: Maybe<Scalars['String']['output']>;
  /** The tasks created for this deliverable by its service request. */
  tasks: Array<DeploymentTask>;
  /** The service request type that produces this deliverable. Deliverables are 1:1 with service requests. */
  type: ServiceRequestType;
};

/**
 * An input a deliverable needs before it can be requested. An input is
 * either a service request form field (`field` is set) or a prerequisite
 * satisfied outside the form, e.g. a floor plan uploaded to the network
 * (`field` is null).
 */
export type DeliverableInput = {
  __typename?: 'DeliverableInput';
  /** Whether this input is already satisfied — a value exists for a form field, or the prerequisite's condition holds. */
  completed: Scalars['Boolean']['output'];
  /** Human-readable description of what this input requires. */
  description?: Maybe<Scalars['String']['output']>;
  /** The service request form field that collects this input, or null if the input is a prerequisite satisfied outside the service request form. */
  field?: Maybe<ServiceRequestFieldDefinition>;
  /** Stable identifier for this input. Matches `field.key` for form-field inputs; for prerequisitess. */
  key: Scalars['String']['output'];
  /** Whether this input must be completed before the deliverable can be requested. */
  required: Scalars['Boolean']['output'];
};

/**
 * The result of the deliverable owner's review of the work product.
 * APPROVED and REJECTED are stored; PENDING, BLOCKED, and RESUBMITTED are derived from tasks.
 */
export enum DeliverableReview {
  /** The owner has approved the work product. */
  Approved = 'APPROVED',
  /** The deliverable's tasks have not been completed so it is not reviewable yet */
  Blocked = 'BLOCKED',
  /** The work product has not been reviewed yet. */
  Pending = 'PENDING',
  /** The owner has rejected the work product. */
  Rejected = 'REJECTED',
  /** The owner rejected the work product and the reopened tasks have all been completed again, so it is ready for re-review. Cannot be set directly. */
  Resubmitted = 'RESUBMITTED'
}

/**
 * Represents a job for the deployment ops team. This is typically the intial
 * bringup of a network, but can also be service calls or other complex work
 * associated with a network.
 */
export type DeploymentJob = Identifiable & {
  __typename?: 'DeploymentJob';
  /** UUID of the deployment job */
  UUID: Scalars['UUID']['output'];
  /** Derived action-needed for the job's next unfinished deliverable, or null when no action is needed. */
  actionNeeded?: Maybe<DeploymentJobActionNeeded>;
  /** Airtable ID for the deployment job, legacy field for airtable jobs */
  airtableID?: Maybe<Scalars['String']['output']>;
  /** The date the deployment was closed out. */
  closeoutDate?: Maybe<Scalars['DateTime']['output']>;
  /** Link to the deployment's CompanyCam project, synced from Airtable. */
  companyCamProjectLink?: Maybe<Scalars['String']['output']>;
  /** Completed at date for the deployment job */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ordered deliverables that have been requested on this job. */
  deliverables: Array<Deliverable>;
  /** Time windows linked directly to this job. */
  deploymentTimeWindows: Array<DeploymentTimeWindow>;
  /** The document uploads visible on this deployment job: documents scoped to this job or its network plus company-wide documents. */
  documentUploads: Array<DocumentUpload>;
  /**
   * Deprecated
   * @deprecated Column temporarily removed, returns null for now.
   */
  equipmentOrderIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Anticipated first day of business for the network */
  firstDayOfBusiness?: Maybe<Scalars['DateTime']['output']>;
  /** Link to the Hamina wireless design for this deployment. */
  haminaLink?: Maybe<Scalars['String']['output']>;
  /** Customer high availability deployment requirement, synced from Salesforce. */
  highAvailabilityDeployment?: Maybe<Scalars['String']['output']>;
  /** Customer high availability expectations and context, synced from Salesforce. */
  highAvailabilityReasonNotes?: Maybe<Scalars['String']['output']>;
  /** Linked installation companies ordered by name, then UUID. Empty when no companies are linked. */
  installCompanies: Array<InstallCompany>;
  /**
   * One linked installation company. Null when no company is linked.
   * @deprecated Use installCompanies.
   */
  installCompany?: Maybe<InstallCompany>;
  /** The date the deployment is scheduled to install. */
  installDate?: Maybe<Scalars['DateTime']['output']>;
  /** Installation technicians assigned to this deployment job. */
  installTechnicians: Array<InstallTechnician>;
  /** Link to the installer scheduling ticket (Intercom) for this deployment, synced from Airtable. */
  intercomLink?: Maybe<Scalars['String']['output']>;
  /** User the deployment job is assigned to */
  jobOwner?: Maybe<User>;
  /** Network the deployment job is associated with */
  network: Network;
  /**
   * All service request definitions, each carrying the deliverable already
   * requested on this job (null `deliverable` means not requested yet).
   */
  serviceRequestDefinitions: Array<ServiceRequestDefinition>;
  /**
   * Existing values on the job and its network that can prepopulate service
   * request forms, grouped by service request type. One entry per type; the
   * inner `values` list may be empty if no fields can be prepopulated.
   */
  serviceRequestFieldValues: Array<ServiceRequestFieldValues>;
  /**
   * Prerequisite state for every service request type against this job. Each
   * state is a check that some data must exist somewhere (e.g. a floor plan
   * has been uploaded for the network) before the SR can be created. The
   * inner `states` list is empty for SR types with no declared prerequisites.
   */
  serviceRequestPrerequisiteStates: Array<ServiceRequestPrerequisiteStates>;
  /** Information learned from the pre-deployment site assessment. */
  siteAssessmentInterpretation?: Maybe<Scalars['String']['output']>;
  /** Free-text site-survey notes captured for this deployment. */
  siteSurveyData?: Maybe<Scalars['String']['output']>;
  /** Link to the deployment's Slack thread, synced from Airtable. */
  slackLink?: Maybe<Scalars['String']['output']>;
  /** When the deployment job is scheduled to start */
  startAt?: Maybe<Scalars['DateTime']['output']>;
  /** Derived job status, matching DeploymentJobsPaginatedFilter.statuses semantics. */
  status: DeploymentJobStatus;
  /** Target go live date for the network */
  targetGoLive?: Maybe<Scalars['DateTime']['output']>;
  /** Tasks associated with the deployment job */
  tasks: Array<DeploymentTask>;
  /**
   * The topology design version currently resulting from this deployment,
   * possibly a draft if engineering help is needed finalizing the design.
   */
  topologyVersion?: Maybe<TopologyDesignVersion>;
  /** Type of deployment job */
  type?: Maybe<DeploymentJobType>;
  /** The date the deployment was validated. */
  validationDate?: Maybe<Scalars['DateTime']['output']>;
};


/**
 * Represents a job for the deployment ops team. This is typically the intial
 * bringup of a network, but can also be service calls or other complex work
 * associated with a network.
 */
export type DeploymentJobDeliverablesArgs = {
  includeCancelled?: Scalars['Boolean']['input'];
};


/**
 * Represents a job for the deployment ops team. This is typically the intial
 * bringup of a network, but can also be service calls or other complex work
 * associated with a network.
 */
export type DeploymentJobTasksArgs = {
  includeCancelled?: Scalars['Boolean']['input'];
};

/** The kind of action that a deployment job's next unfinished deliverable needs. */
export enum DeploymentJobActionNeeded {
  /** The next service request definition has no deliverable yet and needs to be requested. */
  Request = 'REQUEST',
  /** The next deliverable is ready for review. */
  Review = 'REVIEW'
}

/** Input for creating or updating a deployment job. */
export type DeploymentJobInput = {
  /** The date the deployment was closed out. */
  closeoutDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The completed at date for the deployment job */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The anticipated first day of business for the deployment job */
  firstDayOfBusiness?: InputMaybe<Scalars['DateTime']['input']>;
  /** Link to the Hamina wireless design for this deployment. */
  haminaLink?: InputMaybe<Scalars['String']['input']>;
  /** The date the deployment is scheduled to install. */
  installDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The ID of the user who owns the deployment job */
  jobOwner?: InputMaybe<Scalars['Int']['input']>;
  /** The UUID of the network the deployment job belongs to. Required when creating. */
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Information learned from the pre-deployment site assessment. */
  siteAssessmentInterpretation?: InputMaybe<Scalars['String']['input']>;
  /** Free-text site-survey notes captured for this deployment. */
  siteSurveyData?: InputMaybe<Scalars['String']['input']>;
  /** The start at date for the deployment job */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The target go live date for the deployment job */
  targetGoLive?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The topology design version currently resulting from this deployment,
   * possibly a draft if engineering help is needed finalizing the design. Pass null to unbind it.
   */
  topologyVersionUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The type of deployment job */
  type?: InputMaybe<DeploymentJobType>;
  /** The date the deployment was validated. */
  validationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Field to order deployment job results by. */
export enum DeploymentJobOrderByField {
  /** Sort on the job's completed-at date. */
  CompletedAt = 'COMPLETED_AT',
  /** Sort on the job's creation date. */
  CreatedAt = 'CREATED_AT',
  /** Sort on the job's start-at date. */
  StartAt = 'START_AT',
  /** Sort on the job's target go-live date. */
  TargetGoLive = 'TARGET_GO_LIVE'
}

/** A page of deployment jobs. */
export type DeploymentJobPage = {
  __typename?: 'DeploymentJobPage';
  /** The deployment jobs in this page. */
  items: Array<DeploymentJob>;
  /**
   * Total number of jobs matching the filter, ignoring limit/offset.
   * Populated only for operator callers due to complexities with the permissions model.
   */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Derived status of a deployment job. */
export enum DeploymentJobStatus {
  /** The job is not on hold, the network is not live, and the job has at least one deliverable requested. */
  InProgress = 'IN_PROGRESS',
  /** The network is live: active, template, trial, or a customer network that has been deactivated. Takes precedence over ON_HOLD. */
  LiveNetwork = 'LIVE_NETWORK',
  /** The job is not on hold, the network is not live, and no deliverables have been requested. */
  NotStarted = 'NOT_STARTED',
  /** The network is not live and the job's start-at is in the future. */
  OnHold = 'ON_HOLD'
}

export enum DeploymentJobType {
  /** Cellular only */
  CellularOnly = 'CELLULAR_ONLY',
  /** Meter Connect only */
  ConnectOnly = 'CONNECT_ONLY',
  /** Turning off a meter network */
  Deactivation = 'DEACTIVATION',
  /** Growing an existing network */
  Expansion = 'EXPANSION',
  /** Bringing up a new network from scratch */
  NewBuild = 'NEW_BUILD',
  /** Not for resale */
  Nfr = 'NFR',
  /** Installing in an unoccupied space */
  PreInstall = 'PRE_INSTALL',
  /** Bringing a former Meter network back online */
  Reactivation = 'REACTIVATION',
  /** Renewing an existing customer contract */
  Renewal = 'RENEWAL',
  /** Servicing an existing network */
  ServiceCall = 'SERVICE_CALL',
  /** Standard installation */
  StandardInstall = 'STANDARD_INSTALL',
  /** Replacing an existing network with a Meter network */
  Swap = 'SWAP',
  /** Removing a meter network */
  Uninstall = 'UNINSTALL',
  /** Upgrading existing hardware */
  Upgrade = 'UPGRADE'
}

/** Filters for the deploymentJobs query. */
export type DeploymentJobsFilter = {
  /** Restrict results to deployment jobs with these UUIDs. */
  UUIDs: Array<Scalars['UUID']['input']>;
};

/** Filters for the deploymentJobsPaginated query. */
export type DeploymentJobsPaginatedFilter = {
  /** Restrict results to deployment jobs with these UUIDs. */
  UUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Restrict results to jobs whose computed action-needed is one of these kinds. */
  actionNeeded?: InputMaybe<Array<DeploymentJobActionNeeded>>;
  /** Restrict results to deployment jobs on networks owned by these companies. */
  companyUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Whether to include completed deployment jobs. */
  includeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict results to deployment jobs on these networks. */
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Restrict results to jobs whose derived status matches one of these values. */
  statuses?: InputMaybe<Array<DeploymentJobStatus>>;
  /** Restrict results to jobs whose target-go-live falls within this inclusive range. */
  targetGoLive?: InputMaybe<DateTimeRangeInput>;
  /** Restrict results to jobs with one of these types. Omitted or empty means all types. */
  types?: InputMaybe<Array<DeploymentJobType>>;
  /** When true, restrict to unassigned jobs (job_owner IS NULL). Ignores userId. */
  unassignedJobsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict results to deployment jobs owned by this user. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A deployment task is a single unit of work that is part of a deployment job.
 * Can be subsidiary to a larger task or top level within a job.
 */
export type DeploymentTask = Identifiable & {
  __typename?: 'DeploymentTask';
  /** UUID of the deployment task */
  UUID: Scalars['UUID']['output'];
  /** The department responsible for completing the task */
  assignedDepartment?: Maybe<SupportUserDepartment>;
  /** The person responsible for completing the task */
  assignedTo?: Maybe<User>;
  /**
   * Tasks that block this task from proceeding. By default only unresolved
   * blockers are returned; blockers whose blocking task was cancelled are always
   * omitted.
   */
  blockedBy: Array<DeploymentTaskBlocker>;
  /** Tasks that this task blocks */
  blocking: Array<DeploymentTaskBlocker>;
  /** Cancelled at date for the task */
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who cancelled the task */
  cancelledBy?: Maybe<User>;
  /** The child tasks for the task */
  childTasks: Array<DeploymentTask>;
  /** Completed at date for the task */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who completed the task */
  completedBy?: Maybe<User>;
  /**
   * Completion requirements for this, evaluated against current
   * system state. Empty for task types with no defined requirements.
   */
  completionRequirements?: Maybe<Array<DeploymentTaskCompletionRequirement>>;
  /** Number of days required to perform the work. */
  daysRequired?: Maybe<Scalars['Int']['output']>;
  /** The deliverable this task produces work for. */
  deliverable: Deliverable;
  /** The deployment job this task is part of. */
  deploymentJob?: Maybe<DeploymentJob>;
  /** Human-readable display name for the task type, or null if no display name is defined. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Deadline for the task */
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  /** Exceptions raised on this task. */
  exceptions: Array<DeploymentTaskException>;
  /** Whether this task's deliverable can be completed if this task is cancelled and not replaced. */
  isOptional: Scalars['Boolean']['output'];
  /** Whether the current user has read/acknowledged this task */
  isRead: Scalars['Boolean']['output'];
  /** The latest due date among all descendant tasks */
  lastChildDueAt?: Maybe<Scalars['DateTime']['output']>;
  /** The network this task is part of. */
  network?: Maybe<Network>;
  /** Notes left on the task by people working on it. */
  notes: Scalars['String']['output'];
  /**
   * Optional tasks whose skip decision belongs to this task's workspace. Empty
   * for tasks that have no optional tasks to skip.
   */
  optionalTasks: Array<OptionalTask>;
  /** The parent task of this task */
  parentTask?: Maybe<DeploymentTask>;
  /** The root task of this task — the topmost ancestor reached by climbing parent links, or this task itself if it has no parent. */
  rootTask: DeploymentTask;
  /** When the task can start, or when the work being monitored in the task is scheduled to start */
  startAt?: Maybe<Scalars['DateTime']['output']>;
  /** Description of the task */
  taskDescription: Scalars['String']['output'];
  /** Number of technicians required to perform the work. */
  techniciansRequired?: Maybe<Scalars['Int']['output']>;
  /** Type of deployment task */
  type: DeploymentTaskType;
};


/**
 * A deployment task is a single unit of work that is part of a deployment job.
 * Can be subsidiary to a larger task or top level within a job.
 */
export type DeploymentTaskBlockedByArgs = {
  includeCompleted?: Scalars['Boolean']['input'];
};


/**
 * A deployment task is a single unit of work that is part of a deployment job.
 * Can be subsidiary to a larger task or top level within a job.
 */
export type DeploymentTaskExceptionsArgs = {
  filter?: InputMaybe<DeploymentTaskExceptionsFilter>;
};

/** Represents a deployment task whose execution is blocked by another task. */
export type DeploymentTaskBlocker = {
  __typename?: 'DeploymentTaskBlocker';
  /** UUID of the blocker relationship */
  UUID: Scalars['UUID']['output'];
  /** The task that is being blocked */
  blockedTask: DeploymentTask;
  /** The task that is doing the blocking */
  blockingTask: DeploymentTask;
  /** Date created */
  createdAt: Scalars['DateTime']['output'];
  /** Date updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** The evaluated state of a single completion requirement for a deployment task. */
export type DeploymentTaskCompletionRequirement = {
  __typename?: 'DeploymentTaskCompletionRequirement';
  /** Human-readable description of what the requirement needs. */
  description: Scalars['String']['output'];
  /** Whether the requirement must be satisfied for the task to be completed, versus merely recommended. */
  required: Scalars['Boolean']['output'];
  /** Whether the requirement is currently met. */
  satisfied: Scalars['Boolean']['output'];
  /** Stable identifier for this requirement — the frontend can map it to a remediation flow. */
  type: DeploymentTaskCompletionRequirementType;
};

/**
 * Identifies a field elsewhere in the system that a task type requires before it
 * can be completed. Stable so the frontend can map each key to a remediation flow.
 */
export enum DeploymentTaskCompletionRequirementType {
  /** A committed topology design on the network. */
  CommittedTopologyDesign = 'COMMITTED_TOPOLOGY_DESIGN',
  /** A Hamina design link on the deployment job. */
  HaminaLink = 'HAMINA_LINK',
  /** An install schedule time window on the network for this deployment job. */
  InstallScheduleWindow = 'INSTALL_SCHEDULE_WINDOW',
  /** A site walk schedule time window on the network. */
  SiteWalkScheduleWindow = 'SITE_WALK_SCHEDULE_WINDOW',
  /** A verification signature on the network's committed topology design. */
  VerifiedTopologyDesign = 'VERIFIED_TOPOLOGY_DESIGN',
  /** A wireless design uploaded to the network's floor plans. */
  WirelessDesignFloorPlan = 'WIRELESS_DESIGN_FLOOR_PLAN'
}

/**
 * An exception raised on a deployment task when something goes wrong and another user
 * needs to review and take action.
 */
export type DeploymentTaskException = {
  __typename?: 'DeploymentTaskException';
  /** UUID of the exception. */
  UUID: Scalars['UUID']['output'];
  /** When the exception was cancelled. */
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who cancelled the exception. */
  cancelledBy?: Maybe<User>;
  /** When the exception was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The user who created the exception. */
  createdBy: User;
  /** The deployment task this exception belongs to. */
  deploymentTask: DeploymentTask;
  /** Freeform notes describing the issue. */
  description: Scalars['String']['output'];
  /** Discussion messages on this exception. */
  messages: Array<DeploymentTaskExceptionMessage>;
  /** When the exception was resolved. */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who resolved the exception. */
  resolvedBy?: Maybe<User>;
  /** Derived lifecycle status of the exception. */
  status: DeploymentTaskExceptionStatus;
  /** Users tagged on this exception for follow-up. */
  taggedUsers: Array<User>;
};

/** A message posted on a deployment task exception. */
export type DeploymentTaskExceptionMessage = {
  __typename?: 'DeploymentTaskExceptionMessage';
  /** UUID of the message. */
  UUID: Scalars['UUID']['output'];
  /** When the message was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Message content. */
  message: Scalars['String']['output'];
  /** When the message was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user who wrote the message. */
  user: User;
};

/** Lifecycle status of a deployment task exception. */
export enum DeploymentTaskExceptionStatus {
  /** The exception was cancelled. */
  Cancelled = 'CANCELLED',
  /** The exception is open and awaiting action. */
  Open = 'OPEN',
  /** The exception was resolved. */
  Resolved = 'RESOLVED'
}

/** Filter for listing deployment task exceptions where a user is tagged. */
export type DeploymentTaskExceptionsFilter = {
  /** If set, only return exceptions with this status. */
  status?: InputMaybe<DeploymentTaskExceptionStatus>;
  /** User whose tagged exceptions should be returned. Defaults to the calling user. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type DeploymentTaskInput = {
  /** The department to assign the deployment task to */
  assignedDepartment?: InputMaybe<SupportUserDepartment>;
  /** The ID of the user to assign the deployment task to */
  assignedTo?: InputMaybe<Scalars['Int']['input']>;
  /** Number of days required. Must be positive. Pass null to clear. */
  daysRequired?: InputMaybe<Scalars['Int']['input']>;
  /** The UUID of the deliverable this task produces work for. Required when creating a task. */
  deploymentDeliverableUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The due at date for the deployment task */
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Whether the task is cancelled. When set to true, the server sets cancelledAt and cancelledBy. When false, clears them. */
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the task is completed. When set to true, the server sets completedAt and completedBy. When false, clears them. */
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the task is read. When set to true, adds the current user to the set of users who has read the task. When false, clears them. */
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  /** The notes for the deployment task */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the parent task to create the deployment task for */
  parentTaskUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The start at date for the deployment task */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The description of the deployment task */
  taskDescription?: InputMaybe<Scalars['String']['input']>;
  /** Number of technicians required. Must be positive. Pass null to clear. */
  techniciansRequired?: InputMaybe<Scalars['Int']['input']>;
  /** The type of deployment task */
  type: DeploymentTaskType;
};

/**
 * A notification recording a state change on a deployment task that a user
 * should see (e.g. a task was assigned to them, or a task they own was completed).
 */
export type DeploymentTaskNotification = {
  __typename?: 'DeploymentTaskNotification';
  /** The unique identifier for the notification. */
  UUID: Scalars['UUID']['output'];
  /** Time the notification was archived by the recipient. Null if not archived. */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Time the notification was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The deployment job this notification is for. Null for task-scoped notifications. */
  deploymentJob?: Maybe<DeploymentJob>;
  /** The deployment task this notification is for. Null for job-scoped notifications. */
  deploymentTask?: Maybe<DeploymentTask>;
  /** Time the notification was marked read by the recipient. Null if unread. */
  readAt?: Maybe<Scalars['DateTime']['output']>;
  /** Human-readable title rendered for the notification. */
  title: Scalars['String']['output'];
  /** The type of notification. */
  type: DeploymentTaskNotificationType;
  /** Time the notification was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user this notification was delivered to. */
  userId: Scalars['Int']['output'];
};

/** The type of deployment task notification. */
export enum DeploymentTaskNotificationType {
  /** Notification created when a deployment task is assigned to the recipient. */
  Assigned = 'ASSIGNED',
  /** Notification created when a deployment task is completed. */
  Completed = 'COMPLETED',
  /** Notification created when a deliverable is approved, for its job owner and task completers. */
  DeliverableApproved = 'DELIVERABLE_APPROVED',
  /** Notification created when a deliverable is rejected, for its job owner and task completers. */
  DeliverableRejected = 'DELIVERABLE_REJECTED',
  /** Notification created when a deployment task exception is cancelled. */
  ExceptionCancelled = 'EXCEPTION_CANCELLED',
  /** Notification created when a deployment task exception message is added. */
  ExceptionMessagePosted = 'EXCEPTION_MESSAGE_POSTED',
  /** Notification created when a deployment task exception is resolved. */
  ExceptionResolved = 'EXCEPTION_RESOLVED',
  /** Notification created when a user is tagged on a deployment task exception. */
  ExceptionTagged = 'EXCEPTION_TAGGED',
  /** Notification created when a deployment task is reopened by raising an exception. */
  ExceptionTaskReopened = 'EXCEPTION_TASK_REOPENED',
  /** Notification created when a deployment job is assigned to the recipient. */
  JobAssigned = 'JOB_ASSIGNED',
  /** Notification created when a deployment task becomes fully unblocked. */
  Unblocked = 'UNBLOCKED'
}

/** Filter for listing deployment task notifications. */
export type DeploymentTaskNotificationsFilter = {
  /** If set, only return notifications with this archived state (true = archived, false = unarchived). */
  archivedFilter?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, only return notifications for this deployment task. */
  deploymentTaskUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** If set, only return notifications with this read state (true = read, false = unread). */
  readFilter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Recipient user id whose notifications should be returned. If omitted, the calling user is returned */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** Field to order deployment task results by. */
export enum DeploymentTaskOrderByField {
  /** Sort on the task's completed-at date. */
  CompletedAt = 'COMPLETED_AT',
  /** Sort on the task's due-at date. */
  DueAt = 'DUE_AT',
  /** Sort on the target go-live date of the task's deployment job. */
  JobTargetGoLive = 'JOB_TARGET_GO_LIVE',
  /** Sort on the task's start-at date. */
  StartAt = 'START_AT',
  /** Sort on the task's updated-at date. */
  UpdatedAt = 'UPDATED_AT'
}

/** A page of deployment tasks. */
export type DeploymentTaskPage = {
  __typename?: 'DeploymentTaskPage';
  /** The deployment tasks in this page. */
  items: Array<DeploymentTask>;
  /**
   * Total number of tasks matching the filter, ignoring limit/offset.
   * Populated only for operator callers due to complexities with the permissions model.
   */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum DeploymentTaskType {
  /** AP configuration confirmation */
  ApConfigurationConfirmation = 'AP_CONFIGURATION_CONFIRMATION',
  /** Assess the CompanyCam results of a completed site walk */
  AssessCompanycamResults = 'ASSESS_COMPANYCAM_RESULTS',
  /** Auto channel selection */
  AutoChannelSelection = 'AUTO_CHANNEL_SELECTION',
  /** A report communicating details of the jobs closeout */
  CloseoutReport = 'CLOSEOUT_REPORT',
  /** Configure a network */
  ConfigureFirewall = 'CONFIGURE_FIREWALL',
  /** Coordinate ISP circuit delivery and activation */
  CoordinateIsp = 'COORDINATE_ISP',
  /** Create a bid sheet */
  CreateBidSheet = 'CREATE_BID_SHEET',
  /** Create an equipment order */
  CreateEquipmentOrder = 'CREATE_EQUIPMENT_ORDER',
  /** Create a work order */
  CreateWorkOrder = 'CREATE_WORK_ORDER',
  /** Deactivating a network */
  DeactivateNetwork = 'DEACTIVATE_NETWORK',
  /** Provide device count details */
  DeviceCountDetail = 'DEVICE_COUNT_DETAIL',
  /** Equipment order confirmation */
  EquipmentOrderConfirmation = 'EQUIPMENT_ORDER_CONFIRMATION',
  /** Communicating with external parties, potentially blocked by waiting for a response */
  ExternalCommunication = 'EXTERNAL_COMMUNICATION',
  /** Generate a certificate of insurance */
  GenerateCoi = 'GENERATE_COI',
  /** HA failover test */
  HaFailoverTest = 'HA_FAILOVER_TEST',
  /** Determine whether high availability is required */
  HaRequirement = 'HA_REQUIREMENT',
  /** Initial network configuration */
  InitialNetworkConfiguration = 'INITIAL_NETWORK_CONFIGURATION',
  /** Schedule an installer for a deployment */
  InstallerScheduling = 'INSTALLER_SCHEDULING',
  /** Close out an installation */
  InstallCloseout = 'INSTALL_CLOSEOUT',
  /** ISP availability confirmation */
  IspAvailabilityConfirmation = 'ISP_AVAILABILITY_CONFIRMATION',
  /** Final work that needs to be taken once an install is complete and a job is ready to be validated and handed off */
  JobCloseout = 'JOB_CLOSEOUT',
  /** Validating that the job has been completed correctly and final network health validation */
  JobValidation = 'JOB_VALIDATION',
  /** Mark the network as live */
  MarkNetworkLive = 'MARK_NETWORK_LIVE',
  /** Validating that the network is correctly configured and operational */
  NetworkValidation = 'NETWORK_VALIDATION',
  /** Other */
  Other = 'OTHER',
  /** Ping test */
  PingTest = 'PING_TEST',
  /** Review the network's topology design and sign off on it */
  ReviewTopologyDesign = 'REVIEW_TOPOLOGY_DESIGN',
  /** Confirm the site assessment after the site walk */
  SiteAssessmentScheduleConfirmation = 'SITE_ASSESSMENT_SCHEDULE_CONFIRMATION',
  /** Schedule a site walk with the customer */
  SiteWalkScheduling = 'SITE_WALK_SCHEDULING',
  /** Speed test */
  SpeedTest = 'SPEED_TEST',
  /** Switching the autoconfig */
  SwitchAutoconfig = 'SWITCH_AUTOCONFIG',
  /** Technician feedback */
  TechnicianFeedback = 'TECHNICIAN_FEEDBACK',
  /** Update Job Status */
  UpdateJobStatus = 'UPDATE_JOB_STATUS',
  /** Upload DHCP scope requirements document */
  UploadDhcpScopeRequirements = 'UPLOAD_DHCP_SCOPE_REQUIREMENTS',
  /** Upload Document */
  UploadDocument = 'UPLOAD_DOCUMENT',
  /** Upload firewall rules document */
  UploadFirewallRules = 'UPLOAD_FIREWALL_RULES',
  /** Upload IPSec tunnel requirements document */
  UploadIpsecTunnelRequirements = 'UPLOAD_IPSEC_TUNNEL_REQUIREMENTS',
  /** Upload legacy vendor config export */
  UploadLegacyVendorConfigExport = 'UPLOAD_LEGACY_VENDOR_CONFIG_EXPORT',
  /** Upload RADIUS auth requirements document */
  UploadRadiusAuthRequirements = 'UPLOAD_RADIUS_AUTH_REQUIREMENTS',
  /** Upload SSID requirements document */
  UploadSsidRequirements = 'UPLOAD_SSID_REQUIREMENTS',
  /** Upload static IP requirements document */
  UploadStaticIpRequirements = 'UPLOAD_STATIC_IP_REQUIREMENTS',
  /** Upload VLAN requirements document */
  UploadVlanRequirements = 'UPLOAD_VLAN_REQUIREMENTS',
  /** Upload a wired design document */
  UploadWiredDesign = 'UPLOAD_WIRED_DESIGN',
  /** Upload a completed wireless design document */
  UploadWirelessDesign = 'UPLOAD_WIRELESS_DESIGN',
  /** Validating the quality of the ISP */
  ValidateIspQuality = 'VALIDATE_ISP_QUALITY',
  /** Validating the PDU labelling */
  ValidatePduLabelling = 'VALIDATE_PDU_LABELLING',
  /** Validating the switch patching */
  ValidateSwitchPatching = 'VALIDATE_SWITCH_PATCHING',
  /** Validating the wireless client health */
  ValidateWirelessClientHealth = 'VALIDATE_WIRELESS_CLIENT_HEALTH',
  /** Wired design result — parent task for wired design deliverables */
  WiredDesignResult = 'WIRED_DESIGN_RESULT',
  /** Peer review a completed wireless design */
  WirelessDesignPeerReview = 'WIRELESS_DESIGN_PEER_REVIEW',
  /** Wireless design result — parent task for wireless design deliverables */
  WirelessDesignResult = 'WIRELESS_DESIGN_RESULT',
  /** Wireless validation plan */
  WirelessValidationPlan = 'WIRELESS_VALIDATION_PLAN'
}

/** Filters for the deploymentTasks query. */
export type DeploymentTasksFilter = {
  /** Restrict results to deployment tasks with these UUIDs. */
  UUIDs: Array<Scalars['UUID']['input']>;
};

/** Filters for the deploymentTasksPaginated query. */
export type DeploymentTasksPaginatedFilter = {
  /** Restrict results to deployment tasks with these UUIDs. */
  UUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Restrict results to tasks assigned to this department. */
  assignedDepartment?: InputMaybe<SupportUserDepartment>;
  /** Restrict results to tasks assigned to this user. Cannot be combined with unassignedOnly. */
  assignedTo?: InputMaybe<Scalars['Int']['input']>;
  /**
   * When true, restrict to tasks with at least one blocking task that is neither completed nor
   * cancelled. When false, restrict to tasks with no such blocking task.
   */
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict results to deployment tasks on networks owned by these companies. */
  companyUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /**
   * When true, restrict to tasks with a completedAt. When false, restrict to tasks without one.
   * Takes precedence over includeCompleted when set.
   */
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict results to deployment tasks belonging to these deployment jobs. */
  deploymentJobUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Restrict results to tasks whose due-at falls within this inclusive range. */
  dueAt?: InputMaybe<DateTimeRangeInput>;
  /** When true, restrict to tasks with at least one OPEN exception. When false, restrict to tasks with none. */
  hasOpenException?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * When true, restrict to tasks whose deliverable review is REJECTED. When false, restrict to
   * tasks whose deliverable review is not REJECTED.
   */
  inRejectedDeliverable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include cancelled deployment tasks. */
  includeCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include completed deployment tasks. Ignored when completed is set. */
  includeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, restrict to tasks the calling user has read. When false, restrict to unread tasks. */
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict results to tasks whose job start-at falls within this inclusive range. */
  jobStartAt?: InputMaybe<DateTimeRangeInput>;
  /** Restrict results to tasks whose job has one of these statuses. NOT_STARTED jobs have no tasks. An empty list applies no filter. */
  jobStatuses?: InputMaybe<Array<DeploymentJobStatus>>;
  /** Restrict results to tasks whose job target go-live falls within this inclusive range. */
  jobTargetGoLive?: InputMaybe<DateTimeRangeInput>;
  /** Restrict results to deployment tasks on these networks. */
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Case-insensitive literal substring search across company name, network label, or mailing address. Blank values apply no filter. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Restrict results to tasks whose start-at falls within this inclusive range. */
  startAt?: InputMaybe<DateTimeRangeInput>;
  /** Restrict results to tasks of these types. */
  types?: InputMaybe<Array<DeploymentTaskType>>;
  /**
   * When true, restrict to tasks with no assigned user that belong to a department
   * the calling user is a member of. Cannot be combined with assignedTo.
   */
  unassignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A time window associated with a network — site availability reported by the
 * customer, or scheduled work windows (site walk, install, ISP circuit).
 */
export type DeploymentTimeWindow = {
  __typename?: 'DeploymentTimeWindow';
  /** UUID of the time window. */
  UUID: Scalars['UUID']['output'];
  /** Date created. */
  createdAt: Scalars['DateTime']['output'];
  /** The job linked to this window. Must belong to the window's network. Null for windows without a job. */
  deploymentJob?: Maybe<DeploymentJob>;
  /** End of the window. Always strictly greater than startAt. */
  endAt: Scalars['DateTime']['output'];
  /** Installation companies explicitly linked to this window. */
  installCompanies: Array<InstallCompany>;
  /** Technicians linked to this window. */
  installTechnicians: Array<InstallTechnician>;
  /** Whether the installer has confirmed this window. */
  installerConfirmed: Scalars['Boolean']['output'];
  /** Whether Meter has confirmed this window. */
  meterConfirmed: Scalars['Boolean']['output'];
  /** The network this window belongs to. */
  network: Network;
  /** Free-form notes about this window. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Start of the window. */
  startAt: Scalars['DateTime']['output'];
  /** Derived from technician assignment, installer confirmation, and Meter confirmation, in that order. */
  status: DeploymentTimeWindowStatus;
  /** What type of time window this is. */
  type: DeploymentTimeWindowType;
  /** Date updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export enum DeploymentTimeWindowStatus {
  /** The time window is confirmed. */
  Confirmed = 'CONFIRMED',
  /** No technicians are assigned to this window. */
  PendingInstallerAssignment = 'PENDING_INSTALLER_ASSIGNMENT',
  /** Awaiting installer confirmation. */
  PendingInstallerConfirmation = 'PENDING_INSTALLER_CONFIRMATION',
  /** Awaiting Meter confirmation. */
  PendingMeterConfirmation = 'PENDING_METER_CONFIRMATION'
}

/** Discriminator for time windows on a network. */
export enum DeploymentTimeWindowType {
  /** Desired installation windows for a deployment job, before dates are confirmed. */
  DesiredInstall = 'DESIRED_INSTALL',
  /** Install schedule windows. May be empty, single, or phased. */
  InstallSchedule = 'INSTALL_SCHEDULE',
  /** ISP circuit delivery / activation windows. */
  IspCircuitSchedule = 'ISP_CIRCUIT_SCHEDULE',
  /** Customer-reported windows of when the site is available for work. */
  SiteAvailability = 'SITE_AVAILABILITY',
  /** Scheduled site walk window(s). */
  SiteWalkSchedule = 'SITE_WALK_SCHEDULE'
}

/** Omitted or empty lists do not restrict results. */
export type DeploymentTimeWindowsFilter = {
  /** Restrict to these time window UUIDs. */
  UUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Windows linked directly to any of these jobs. */
  deploymentJobUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Only windows ending strictly after this time. Together with startsBefore, selects overlapping windows. */
  endsAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Windows linked directly to any of these installation companies. */
  installCompanyUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Windows linked directly to any of these technicians. */
  installTechnicianUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Windows belonging to any of these networks. */
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Only windows starting strictly before this time. */
  startsBefore?: InputMaybe<Scalars['DateTime']['input']>;
  /** Restrict to these derived statuses. */
  statuses?: InputMaybe<Array<DeploymentTimeWindowStatus>>;
  /** Restrict to these window types. */
  types?: InputMaybe<Array<DeploymentTimeWindowType>>;
};

/** The union of a hardware device and a virtual device. */
export type Device = {
  __typename?: 'Device';
  /** The hardware device component of the device. */
  hardwareDevice: HardwareDevice;
  /** The virtual device component of the device. */
  virtualDevice: VirtualDevice;
};

/** A batch of generated device pairings, consisting of a serial number and MACs. */
export type DeviceBatch = {
  __typename?: 'DeviceBatch';
  /** The unique identifier for the device batch. */
  batchName: Scalars['String']['output'];
  /** The model of the hardware devices in this batch. */
  deviceModel: DeviceModel;
  /** The generated pairings of hardware devices with their associated MAC addresses for this batch. */
  devicePairings: Array<DevicePairing>;
};

export type DeviceBatchFilterInput = {
  /** Only include device batches that were created before or at this date and time. */
  maxCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only include device batches that were created at or after this date and time. */
  minCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The device models of the device batches to filter by. */
  models?: InputMaybe<Array<DeviceModel>>;
};

/** Properties for device boot events. */
export type DeviceBootProperties = {
  __typename?: 'DeviceBootProperties';
  /** The number of times the device has booted. */
  bootCount: Scalars['Int']['output'];
  /** The name of the build that was booted. */
  buildName: Scalars['String']['output'];
  /** The reason for the reboot. */
  rebootReason: Scalars['String']['output'];
  /** The virtual device associated with the device boot event. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** Represents a rendered configuration for a device. */
export type DeviceConfig = {
  __typename?: 'DeviceConfig';
  /**
   * The timestamp when the device acknowledged this configuration.
   * If null, the device has not acknowledged this version of config.
   */
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The config data in JSON format. */
  configJSON: Scalars['JSONObject']['output'];
  /** Size of the device config in proto encoding, uncompressed. */
  contentSize: Scalars['Int']['output'];
  /** The timestamp when this configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  /** At-most one DeviceConfig for a device is 'current'. The current version is the most recent good version of the config that the device is currently using. This timestamp is the last time the device reported the config as current. */
  isCurrentAsOf?: Maybe<Scalars['DateTime']['output']>;
  /** The state of the validation process for the config version on the device. For performance reasons, we do not return data for this field if requesting data for configs over a > 90 day time window. */
  state?: Maybe<DeviceConfigState>;
  /** The version number of the configuration. */
  version: Scalars['Int']['output'];
};

/** Represents the metadata for rendered configuration for a device, omitting the rendered `configJSON` for performance reasons when fetching many at once. A subset of `DeviceConfig`. */
export type DeviceConfigMetadata = {
  __typename?: 'DeviceConfigMetadata';
  /**
   * The timestamp when the device acknowledged this configuration.
   * If null, the device has not acknowledged this version of config.
   */
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The timestamp when this configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The hardware device associated with the configuration */
  hardwareDevice: HardwareDevice;
  /** At-most one DeviceConfig for a device is 'current'. The current version is the most recent good version of the config that the device is currently using. This timestamp is the last time the device reported the config as current. */
  isCurrentAsOf?: Maybe<Scalars['DateTime']['output']>;
  /** The serial number of the device associated with the configuration. */
  serialNumber: Scalars['String']['output'];
  /** The state of the validation process for the config version on the device. For performance reasons, we do not return data for this field if requesting data for configs over a > 90 day time window. */
  state?: Maybe<DeviceConfigState>;
  /** The version number of the configuration. */
  version: Scalars['Int']['output'];
  /**
   * The virtual device that the hardware device was bound to when this config was rendered.
   * Null for configs rendered before this was June 2026.
   */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** Represents an override configuration for a device. */
export type DeviceConfigOverride = {
  __typename?: 'DeviceConfigOverride';
  /** The overridden configuration data in JSON format. */
  configJSON: Scalars['JSONObject']['output'];
  /** When the config was upserted. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user who upserted this version. */
  updatedBy?: Maybe<User>;
  /** The email address of the user who upserted this version. */
  updatedByEmail?: Maybe<Scalars['String']['output']>;
};

/** The state of the configuration for a DeviceConfig, as reported by the device. */
export type DeviceConfigState = {
  __typename?: 'DeviceConfigState';
  /** The state of the configuration for the device. */
  state: DeviceConfigStateType;
  /** The timestamp when the state was sent from the device. */
  timestamp: Scalars['DateTime']['output'];
};

export enum DeviceConfigStateType {
  /** The device has finished its connectivity evaluation and determined the configuration to be bad. The device will roll back to the most recent `GOOD` version of the config. */
  Failed = 'FAILED',
  /** The device has finished its connectivity evaluation and determined the configuration to be good. */
  Good = 'GOOD',
  /** The device has received the configuration, but has not yet finished a connectivity evaluation to know if it's good or failed. This validation process typically takes 15 minutes. If a new config version is received before the validation is complete, this version can be stuck in this state indefinitely. */
  Received = 'RECEIVED',
  /** Uncategorized state. */
  Unknown = 'UNKNOWN'
}

/** A firmware build for a Meter hardware device. */
export type DeviceImage = {
  __typename?: 'DeviceImage';
  /** The unique identifier of the device image. */
  UUID: Scalars['UUID']['output'];
  /** The hardware board this image is for. */
  board: Scalars['String']['output'];
  /** The semantic version of this device image, if set. */
  buildVersion?: Maybe<BuildVersion>;
  /** When this build was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Whether this build is locked. */
  isLocked: Scalars['Boolean']['output'];
  /** The build name of the device image. */
  name: Scalars['String']['output'];
  /** The OS family for this device image, if set. */
  osFamily?: Maybe<DeviceImageOsFamily>;
  /** When metadata for this build was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A device build OS family. */
export enum DeviceImageOsFamily {
  /** Controller (firewall) operating system. */
  Cos = 'COS',
  /** Gateway operating system. */
  Gos = 'GOS',
  /** PDU operating system. */
  Pos = 'POS',
  /** Switch operating system. */
  Sos = 'SOS',
  /** Wireless operating system. */
  Wos = 'WOS',
  /** Wireless operating system observer build. */
  WosObs = 'WOS_OBS'
}

/** Input for filtering device images. */
export type DeviceImagesFilterInput = {
  /** The device image board. */
  board?: InputMaybe<Scalars['String']['input']>;
  /** Whether this is a debug build. */
  isDebug?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this is a release build. */
  isRelease?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this build requires secure boot. */
  isSecureBoot?: InputMaybe<Scalars['Boolean']['input']>;
  /** The major version range. */
  majorVerison?: InputMaybe<VersionNumberRangeInput>;
  /** The minor version range. */
  minorVerison?: InputMaybe<VersionNumberRangeInput>;
  /** The build name for substring case insensitive match. */
  nameSearch?: InputMaybe<Scalars['String']['input']>;
  /** The operating system family. */
  osFamily?: InputMaybe<DeviceImageOsFamily>;
  /** The patch version range. */
  patchVerison?: InputMaybe<VersionNumberRangeInput>;
};

/** A page of device images, with the total count of images for the provided filters. */
export type DeviceImagesPage = {
  __typename?: 'DeviceImagesPage';
  /** The results available based on the current filters, limit, and offset. */
  items: Array<DeviceImage>;
  /** The total number of results available based on the provided filters. */
  total: Scalars['Int']['output'];
};

/** A single log entry from a device. */
export type DeviceLog = {
  __typename?: 'DeviceLog';
  /** The attributes of the log. */
  attributes: Array<DeviceLogAttribute>;
  /** The log message body. */
  body: Scalars['String']['output'];
  /** The hardware device that emitted the log. */
  hardwareDevice: HardwareDevice;
  /** Severity level of the log entry. */
  level?: Maybe<LogSeverity>;
  /** Serial number of the device that emitted the log. */
  serialNumber: Scalars['String']['output'];
  /** The service or unit that emitted the log. */
  service?: Maybe<Scalars['String']['output']>;
  /** When the log was emitted. */
  timestamp: Scalars['DateTime']['output'];
};

/** Attribute of a device log. */
export type DeviceLogAttribute = {
  __typename?: 'DeviceLogAttribute';
  /** Key of the attribute. */
  key: Scalars['String']['output'];
  /** Value of the attribute. */
  value: Scalars['String']['output'];
};

/** Filter input for querying device logs. */
export type DeviceLogsFilterInput = {
  /** Limit results to devices of specific types. */
  deviceTypes?: InputMaybe<Array<DeviceType>>;
  /** Latest timestamp to include. Defaults to now. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Maximum number of entries to return. */
  limit?: Scalars['Int']['input'];
  /** Number of entries to skip. */
  offset?: Scalars['Int']['input'];
  /** Lucene query string. */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Full-text search against the log body. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Limit results to specific severity levels. */
  severities?: InputMaybe<Array<LogSeverity>>;
  /** Earliest timestamp to include. Defaults to 15 minutes before endTime. */
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Limit results to specific virtual devices. Defaults to all devices on the networks. */
  virtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** A paginated collection of device log entries. */
export type DeviceLogsPage = {
  __typename?: 'DeviceLogsPage';
  /** The log entries for this page. */
  logs: Array<DeviceLog>;
  /** Total number of matching log entries. */
  total: Scalars['Int']['output'];
};

/**
 * A block of MAC addresses allocated to a device family. A family may own several
 * non-overlapping blocks.
 */
export type DeviceMacAllocation = {
  __typename?: 'DeviceMACAllocation';
  /** The unique identifier for this block. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when this block was added. */
  createdAt: Scalars['DateTime']['output'];
  /** The device family this block is allocated to. */
  deviceFamily: Scalars['String']['output'];
  /** The inclusive lower bound of the MAC address range for this block. */
  lowerMACBound: Scalars['MacAddress']['output'];
  /** The next MAC address to allocate from this block. Once the block is exhausted this is one past upperMACBound. */
  nextMAC: Scalars['MacAddress']['output'];
  /** Timestamp when this block was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The inclusive upper bound of the MAC address range for this block. */
  upperMACBound: Scalars['MacAddress']['output'];
};

/** Specifies the input for migrating a device to a new virtual device. */
export type DeviceMigrationInput = {
  /** The UUID of a paired virtual device to migrate, if applicable. */
  pairVirtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Optional mapping of source to destination port numbers, if not included, will default to same order as source device. */
  portMappings?: InputMaybe<Array<PortMappingEntryInput>>;
};

/** DeviceModel enumerates the different model names of devices that Meter deploys. */
export enum DeviceModel {
  A1 = 'A1',
  A2 = 'A2',
  A3 = 'A3',
  Att6355 = 'ATT6355',
  Cuttlefish = 'CUTTLEFISH',
  Dot2254 = 'DOT2254',
  Dot2274 = 'DOT2274',
  Dot4455 = 'DOT4455',
  F1 = 'F1',
  F2 = 'F2',
  F3 = 'F3',
  G1 = 'G1',
  Iru1648 = 'IRU1648',
  Iru1649 = 'IRU1649',
  Iru8850 = 'IRU8850',
  Jellyfish = 'JELLYFISH',
  Kiwi = 'KIWI',
  Mantaray = 'MANTARAY',
  Mc01 = 'MC01',
  Mc05 = 'MC05',
  Mc06 = 'MC06',
  Mc11 = 'MC11',
  Mp01 = 'MP01',
  Ms07 = 'MS07',
  Ms10 = 'MS10',
  Ms11 = 'MS11',
  Ms12 = 'MS12',
  Mw02 = 'MW02',
  Mw03 = 'MW03',
  Mw04 = 'MW04',
  Mw05 = 'MW05',
  Mw06 = 'MW06',
  Mw07 = 'MW07',
  Mw08 = 'MW08',
  Mw09 = 'MW09',
  Narwhal = 'NARWHAL',
  S1 = 'S1',
  S2 = 'S2',
  S3 = 'S3',
  S4 = 'S4',
  Skyfire = 'SKYFIRE',
  Tmobile6655 = 'TMOBILE6655',
  Verizon6672 = 'VERIZON6672',
  Whaleshark = 'WHALESHARK'
}

/** Information about migrating a device model, including the device model and compatible upgrade models. */
export type DeviceModelMigrationInfo = {
  __typename?: 'DeviceModelMigrationInfo';
  /** The virtual devices that a device model can be migrated to. */
  compatibleUpgradeModels: Array<DeviceModel>;
  /** The device model being migrated. */
  deviceModel: DeviceModel;
};

/**
 * A device notification snooze silences alert notifications for a single virtual device
 * for the given time window. When alertTypes is empty the snooze applies to all alert
 * types; otherwise it only snoozes alerts whose AlertType is in the list.
 */
export type DeviceNotificationSnooze = {
  __typename?: 'DeviceNotificationSnooze';
  /** The UUID of the snooze. */
  UUID: Scalars['UUID']['output'];
  /** The alert types this snooze applies to. Empty means all alert types. */
  alertTypes: Array<AlertType>;
  /** The associated company. */
  company: Company;
  /** The timestamp when the snooze was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The timestamp when the snooze was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The associated network */
  network: Network;
  /** The timestamp when the snooze ends. */
  snoozeEnd: Scalars['DateTime']['output'];
  /** The reason for the snooze. */
  snoozeReason?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the snooze begins. */
  snoozeStart: Scalars['DateTime']['output'];
  /** The timestamp when the snooze was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The associated virtual device. */
  virtualDevice: VirtualDevice;
  /** The associated virtual device UUID. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** A device offline active issue */
export type DeviceOfflineActiveIssue = ActiveIssue & {
  __typename?: 'DeviceOfflineActiveIssue';
  /** When the issue was first detected, if available */
  detectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The network that this issue is impacting */
  networkUUID: Scalars['UUID']['output'];
  /** When the issue was resolved, if available */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The severity of the issue */
  severity: ActiveIssueSeverity;
  /** The type of the issue */
  type: ActiveIssueType;
  /** The virtual device that this issue is impacting */
  virtualDevice: VirtualDevice;
};

/** Properties for device offline events. */
export type DeviceOfflineProperties = {
  __typename?: 'DeviceOfflineProperties';
  /** The time the device was last seen online. */
  lastSeen: Scalars['DateTime']['output'];
  /** The virtual device associated with the device offline event. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** Properties for device online events. */
export type DeviceOnlineProperties = {
  __typename?: 'DeviceOnlineProperties';
  /** The time the device was first seen online. */
  firstSeen: Scalars['DateTime']['output'];
  /** The virtual device associated with the device online event. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** A generated pairing of a hardware device serial number with its associated MAC addresses. */
export type DevicePairing = {
  __typename?: 'DevicePairing';
  /** List of MAC addresses associated with the hardware device. */
  macAddresses: Array<Scalars['MacAddress']['output']>;
  /** The serial number of the hardware device. */
  serialNumber: Scalars['String']['output'];
};

/** Represents the physical position of a hardware device. Applicable to models that are device pairs. Position are from the perspective of looking at the front of the device. */
export enum DevicePosition {
  /** The device is in the left position when viewing from the front of the device. */
  Left = 'LEFT',
  /** The device is in the right position when viewing from the front of the device. */
  Right = 'RIGHT',
  /** The device is in an unspecified position. */
  Unspecified = 'UNSPECIFIED'
}

/** An enumeration of radios on a device. */
export enum DeviceRadio {
  /** Represents the 2.4 GHz radio. */
  Radio_2_4G = 'RADIO_2_4G',
  /** Represents the 5 GHz radio. */
  Radio_5G = 'RADIO_5G',
  /** Represents the 6 GHz radio. */
  Radio_6G = 'RADIO_6G',
  /** Represents the scanning radio. */
  RadioScanning = 'RADIO_SCANNING'
}

/** A device's state over a time window. */
export type DeviceStateTimeline = {
  __typename?: 'DeviceStateTimeline';
  /** The end of the window. */
  endTime: Scalars['DateTime']['output'];
  /** Events. */
  events: Array<DeviceStateTimelineEvent>;
  /** The UUID of the network the virtual device belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The start of the window. */
  startTime: Scalars['DateTime']['output'];
  /** Interval tracks. */
  tracks: Array<DeviceStateTimelineTrack>;
  /** The virtual device. */
  virtualDevice: VirtualDevice;
  /** The UUID of the virtual device. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** A period during which a device was in one cloud connection state. */
export type DeviceStateTimelineCloudConnectionInterval = DeviceStateTimelineInterval & {
  __typename?: 'DeviceStateTimelineCloudConnectionInterval';
  /** When the interval ended. Null if the state is ongoing. */
  endTime?: Maybe<Scalars['DateTime']['output']>;
  /** When the interval started. */
  startTime: Scalars['DateTime']['output'];
  /** The state during the interval. */
  state: DeviceStateTimelineCloudConnectionState;
};

/** Whether a device held a connection to Meter's cloud. */
export enum DeviceStateTimelineCloudConnectionState {
  /** Connected to Meter's cloud. */
  Connected = 'CONNECTED',
  /** Disconnected from Meter's cloud. */
  Disconnected = 'DISCONNECTED',
  /** Not known, e.g. before the first recorded connection. */
  Unknown = 'UNKNOWN'
}

/** Whether the device held a connection to Meter's cloud. */
export type DeviceStateTimelineCloudConnectionTrack = DeviceStateTimelineTrack & {
  __typename?: 'DeviceStateTimelineCloudConnectionTrack';
  /** The track's intervals, in order. */
  intervals: Array<DeviceStateTimelineCloudConnectionInterval>;
};

/** The status of a config version on the device changed. */
export type DeviceStateTimelineConfigEvent = DeviceStateTimelineEvent & {
  __typename?: 'DeviceStateTimelineConfigEvent';
  /** The config version. */
  configVersion: Scalars['Int']['output'];
  /** When the device reported the status. */
  occurredAt: Scalars['DateTime']['output'];
  /** The config version's new status. */
  status: DeviceStateTimelineConfigStatus;
  /** The virtual device reporting this status. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The unique identifier of the virtual device reporting this status. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** A step in a device taking a config version into use. */
export enum DeviceStateTimelineConfigStatus {
  /** The device applied the config version and passed its connectivity checks. */
  Applied = 'APPLIED',
  /** The device reported running the config version. */
  Current = 'CURRENT',
  /** The device failed to apply the config version. */
  Failed = 'FAILED',
  /** The device received the config version. */
  Received = 'RECEIVED'
}

/** The access point reset its operating channel after moving off a DFS channel. */
export type DeviceStateTimelineDfsChannelResetEvent = DeviceStateTimelineEvent & {
  __typename?: 'DeviceStateTimelineDFSChannelResetEvent';
  /** The channel the access point operates on after the reset. */
  newChannel: Scalars['Int']['output'];
  /** When the channel was reset. */
  occurredAt: Scalars['DateTime']['output'];
  /** The channel the access point was operating on before the reset. */
  previousChannel: Scalars['Int']['output'];
};

/** A point in time on a device state timeline. */
export type DeviceStateTimelineEvent = {
  /** When the event occurred. */
  occurredAt: Scalars['DateTime']['output'];
};

export type DeviceStateTimelineFilterInput = {
  /** The end of the window, defaults to now. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** If true, includes upstream events. */
  includeUpstream?: Scalars['Boolean']['input'];
  /** The start of the window. */
  startTime: Scalars['DateTime']['input'];
};

/** The high availability pair the firewall belongs to changed state. */
export type DeviceStateTimelineHaEvent = DeviceStateTimelineEvent & {
  __typename?: 'DeviceStateTimelineHAEvent';
  /** The pair's backup virtual device. */
  backupVirtualDevice?: Maybe<VirtualDevice>;
  /** The UUID of the pair's backup virtual device. */
  backupVirtualDeviceUUID: Scalars['UUID']['output'];
  /** When the change occurred. */
  occurredAt: Scalars['DateTime']['output'];
  /** The pair's primary virtual device. */
  primaryVirtualDevice?: Maybe<VirtualDevice>;
  /** The UUID of the pair's primary virtual device. */
  primaryVirtualDeviceUUID: Scalars['UUID']['output'];
  /** What happened to the pair. */
  type: DeviceStateTimelineHaEventType;
};

/** A change in a high availability firewall pair. */
export enum DeviceStateTimelineHaEventType {
  /** The pair failed over to the other firewall. */
  Failover = 'FAILOVER',
  /** Both firewalls in the pair were active at once. */
  MultipleActive = 'MULTIPLE_ACTIVE',
  /** The pair recovered to a single active firewall. */
  Recovery = 'RECOVERY'
}

/** A period during which a device was in one heartbeat state. */
export type DeviceStateTimelineHeartbeatInterval = DeviceStateTimelineInterval & {
  __typename?: 'DeviceStateTimelineHeartbeatInterval';
  /** When the interval ended. Null if the state is ongoing. */
  endTime?: Maybe<Scalars['DateTime']['output']>;
  /** When the interval started. */
  startTime: Scalars['DateTime']['output'];
  /** The state during the interval. */
  state: DeviceStateTimelineHeartbeatState;
};

/** Whether a device was sending heartbeats. */
export enum DeviceStateTimelineHeartbeatState {
  /** Went more than 75 seconds without a heartbeat. */
  Offline = 'OFFLINE',
  /** Sending heartbeats. */
  Online = 'ONLINE'
}

/** Whether the device was sending heartbeats. */
export type DeviceStateTimelineHeartbeatTrack = DeviceStateTimelineTrack & {
  __typename?: 'DeviceStateTimelineHeartbeatTrack';
  /** The time of every heartbeat in the window. Only available for windows of at most 24 hours. */
  heartbeats: Array<Scalars['DateTime']['output']>;
  /** The track's intervals, in order. */
  intervals: Array<DeviceStateTimelineHeartbeatInterval>;
};

/** A period during which a device state timeline track was in one state. */
export type DeviceStateTimelineInterval = {
  /** When the interval ended, or the end of the timeline if it ended later. Null if the state is ongoing. */
  endTime?: Maybe<Scalars['DateTime']['output']>;
  /** When the interval started, or the start of the timeline if it started earlier. */
  startTime: Scalars['DateTime']['output'];
};

/** The access point detected radar on a DFS channel and moved off it. */
export type DeviceStateTimelineRadarHitEvent = DeviceStateTimelineEvent & {
  __typename?: 'DeviceStateTimelineRadarHitEvent';
  /** The DFS channel the access point was operating on. */
  dfsChannel: Scalars['Int']['output'];
  /** The channel the access point moved to. */
  fallbackChannel: Scalars['Int']['output'];
  /** When the radar was detected. */
  occurredAt: Scalars['DateTime']['output'];
};

/** The device rebooted. */
export type DeviceStateTimelineRebootEvent = DeviceStateTimelineEvent & {
  __typename?: 'DeviceStateTimelineRebootEvent';
  /** The firmware build the device booted into. */
  firmwareBuildName?: Maybe<Scalars['String']['output']>;
  /** When the device reported booting. */
  occurredAt: Scalars['DateTime']['output'];
  /** The reason the device reported for the reboot. */
  rebootReason?: Maybe<Scalars['String']['output']>;
  /** Whether the reboot was requested. */
  type: DeviceStateTimelineRebootType;
};

/** A reboot of the device was requested. */
export type DeviceStateTimelineRebootRequestedEvent = DeviceStateTimelineEvent & {
  __typename?: 'DeviceStateTimelineRebootRequestedEvent';
  /** When the reboot was requested. */
  occurredAt: Scalars['DateTime']['output'];
};

/** Whether a reboot was requested. */
export enum DeviceStateTimelineRebootType {
  /** The device rebooted shortly after a reboot was requested. */
  Planned = 'PLANNED',
  /** The device rebooted without a reboot request. */
  Unexpected = 'UNEXPECTED'
}

/** The switch blocked a port because of an STP error. */
export type DeviceStateTimelineStpPortBlockedEvent = DeviceStateTimelineEvent & {
  __typename?: 'DeviceStateTimelineSTPPortBlockedEvent';
  /** When the port was blocked. */
  occurredAt: Scalars['DateTime']['output'];
  /** The blocked port's physical interface. */
  phyInterface: PhyInterface;
  /** The blocked port number. */
  port: Scalars['Int']['output'];
  /** The STP error that caused the block. */
  portError: StpPortError;
};

/** The switch unblocked ports it had blocked because of STP errors. */
export type DeviceStateTimelineStpPortUnblockedEvent = DeviceStateTimelineEvent & {
  __typename?: 'DeviceStateTimelineSTPPortUnblockedEvent';
  /** When the ports were unblocked. */
  occurredAt: Scalars['DateTime']['output'];
  /** The physical interfaces of the unblocked ports, in the same order. */
  phyInterfaces: Array<PhyInterface>;
  /** The unblocked port numbers. */
  ports: Array<Scalars['Int']['output']>;
};

/** The switch saw a new STP root bridge. */
export type DeviceStateTimelineStpRootBridgeChangedEvent = DeviceStateTimelineEvent & {
  __typename?: 'DeviceStateTimelineSTPRootBridgeChangedEvent';
  /** The MAC address of the new root bridge. */
  newRootBridgeMACAddress: Scalars['MacAddress']['output'];
  /** When the root bridge changed. */
  occurredAt: Scalars['DateTime']['output'];
  /** The MAC address of the previous root bridge. */
  previousRootBridgeMACAddress: Scalars['MacAddress']['output'];
};

/** A band of contiguous intervals covering a device state timeline. */
export type DeviceStateTimelineTrack = {
  /** The track's intervals, in order. */
  intervals: Array<DeviceStateTimelineInterval>;
};

/**
 * A period during which a firewall was in one WAN state with one set of active WAN connections.
 * A new interval starts whenever the set of active WAN connections changes.
 */
export type DeviceStateTimelineWanInterval = DeviceStateTimelineInterval & {
  __typename?: 'DeviceStateTimelineWANInterval';
  /** The physical interfaces of the active ports, in the same order. */
  activePhyInterfaces: Array<PhyInterface>;
  /** The ports of the WAN connections active during the interval, in ascending order. */
  activePorts: Array<Scalars['Int']['output']>;
  /** When the interval ended. Null if the state is ongoing. */
  endTime?: Maybe<Scalars['DateTime']['output']>;
  /** When the interval started. */
  startTime: Scalars['DateTime']['output'];
  /** The state during the interval. */
  state: DeviceStateTimelineWanState;
};

/** Whether a firewall had an active WAN connection. */
export enum DeviceStateTimelineWanState {
  /** No WAN connection was active. */
  Down = 'DOWN',
  /** Not known, e.g. before the first recorded WAN status change. */
  Unknown = 'UNKNOWN',
  /** At least one WAN connection was active. */
  Up = 'UP'
}

/** The firewalls's set of active WAN connections changed. */
export type DeviceStateTimelineWanStatusChangeEvent = DeviceStateTimelineEvent & {
  __typename?: 'DeviceStateTimelineWANStatusChangeEvent';
  /** The physical interfaces of the active ports, in the same order. */
  activePhyInterfaces: Array<PhyInterface>;
  /** The ports of the WAN connections active after the change. */
  activePorts: Array<Scalars['Int']['output']>;
  /** When the change occurred. */
  occurredAt: Scalars['DateTime']['output'];
};

/** Whether the firewall had an active WAN connection. Only present for firewalls. */
export type DeviceStateTimelineWanTrack = DeviceStateTimelineTrack & {
  __typename?: 'DeviceStateTimelineWANTrack';
  /** The track's intervals, in order. */
  intervals: Array<DeviceStateTimelineWanInterval>;
};

export type DeviceStateTimelinesFilterInput = {
  /** Limit results to devices of specific types. */
  deviceTypes?: InputMaybe<Array<VirtualDeviceType>>;
  /** The end of the window, defaults to now. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** If true, includes upstream events. */
  includeUpstream?: Scalars['Boolean']['input'];
  /** The start of the window. */
  startTime: Scalars['DateTime']['input'];
  /** Limit results to specific virtual devices. Defaults to all devices on the networks. */
  virtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** DeviceType enumerates the different types of hardware devices that Meter deploys. */
export enum DeviceType {
  /** Represents an Access Point device type. */
  AccessPoint = 'ACCESS_POINT',
  /** Represents a Carrier Appliance device type. */
  CarrierAppliance = 'CARRIER_APPLIANCE',
  /** Represents a Cellular Access Point device type. */
  CellularAccessPoint = 'CELLULAR_ACCESS_POINT',
  /** Represents a Cellular Gateway device type. */
  CellularGateway = 'CELLULAR_GATEWAY',
  /** Represents a Cellular Switch device type. */
  CellularSwitch = 'CELLULAR_SWITCH',
  /** Represents a Controller device type. */
  Controller = 'CONTROLLER',
  /** Represents a Power Distribution Unit device type. */
  PowerDistributionUnit = 'POWER_DISTRIBUTION_UNIT',
  /** Represents a Switch device type. */
  Switch = 'SWITCH'
}

/** Filter criteria for devices in a network. */
export type DevicesForNetworkFilter = {
  /** Filter devices by virtual device type. */
  deviceType?: InputMaybe<VirtualDeviceType>;
  /** Filter devices by any of the given device types. */
  deviceTypes?: InputMaybe<Array<VirtualDeviceType>>;
  /** Filter devices by their draft state. */
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** If provided, only return virtual devices with these UUIDs. An empty list returns no devices. */
  virtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Represents a service that has been discovered on the network, advertising via mDNS (multicast DNS), such as printers, AirPlay devices, speakers, etc. */
export type DiscoveredService = {
  __typename?: 'DiscoveredService';
  /** IP address of the discovered service. */
  ipAddress: Scalars['IP']['output'];
  /** MAC address of the device hosting the service. */
  macAddress: Scalars['MacAddress']['output'];
  /** Name assigned to the discovered service, typically provided by the device itself. */
  name: Scalars['String']['output'];
  /** Unique identifier of the network where the service was discovered. */
  networkUUID: Scalars['UUID']['output'];
  /** Type of the discovered service, indicating its functionality (e.g., AIRPLAY, PRINTER, SPEAKER). */
  serviceType: ServiceType;
  /** Timestamp indicating when the service was last detected or reported. */
  timestamp: Scalars['DateTime']['output'];
};

/** Input parameters for querying discovered services. */
export type DiscoveredServicesInput = {
  /**
   * Number of minutes to look back when querying for available services.
   * Specifies how far back in time the query should search for services that were discovered.
   * Must be between 1 and 180 minutes.
   */
  numMinutesLookback: Scalars['Int']['input'];
  /** List of service types to filter for in the query. Only services of these types will be returned. */
  serviceTypes: Array<ServiceType>;
};

/** Properties for an informative badge to display. */
export type DisplayBadge = {
  __typename?: 'DisplayBadge';
  /** A slug for the icon to display inside the badge. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Text to display inside the badge. */
  text?: Maybe<Scalars['String']['output']>;
};

export type DisplayBadgeInput = {
  /** A slug for the icon to display inside the badge. */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Text to display inside the badge. */
  text?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A document upload is a company-scoped document backed by either a file stored in S3
 * or a URL linking out to an externally hosted document. A document upload can optionally
 * be scoped to specific networks and/or deployment jobs; a document with no network or
 * deployment job scoping is visible across the whole company.
 */
export type DocumentUpload = Identifiable & {
  __typename?: 'DocumentUpload';
  /** The unique identifier of the document upload. */
  UUID: Scalars['UUID']['output'];
  /** The unique identifier of the company that this document upload belongs to. */
  companyUUID: Scalars['UUID']['output'];
  /** The timestamp when the document upload was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The user who created the document upload. */
  createdBy?: Maybe<User>;
  /** The deployment-job document classification of this upload. Only meaningful for uploads created from the deployment-job flows; null on generic company-scoped uploads. */
  deploymentJobDocumentType?: Maybe<DocumentUploadDeploymentJobDocumentType>;
  /** The deployment jobs this document upload is scoped to. Null when the document is not scoped to any specific deployment job. */
  deploymentJobs?: Maybe<Array<DeploymentJob>>;
  /** A description of the document upload. */
  description?: Maybe<Scalars['String']['output']>;
  /** A pre-signed URL to download the document. Only available when the document is stored in S3. */
  downloadURL?: Maybe<Scalars['String']['output']>;
  /** A human-readable name or label for the document upload. */
  label?: Maybe<Scalars['String']['output']>;
  /** The networks this document upload is scoped to. Null when the document is not scoped to any specific network. */
  networks?: Maybe<Array<Network>>;
  /** The S3 key (path) of the uploaded file. Exactly one of s3Key or url is set. */
  s3Key?: Maybe<Scalars['String']['output']>;
  /** The type of the externally hosted document. */
  type?: Maybe<DocumentUploadType>;
  /** The timestamp when the document upload was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The URL of the externally hosted document. Exactly one of s3Key or url is set. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Deployment-job document classification for a DocumentUpload. */
export enum DocumentUploadDeploymentJobDocumentType {
  /** DHCP scope requirements document. */
  DhcpScopeRequirements = 'DHCP_SCOPE_REQUIREMENTS',
  /** Firewall rules document. */
  FirewallRules = 'FIREWALL_RULES',
  /** IPSec tunnel requirements document. */
  IpsecTunnelRequirements = 'IPSEC_TUNNEL_REQUIREMENTS',
  /** Legacy vendor config export document. */
  LegacyVendorConfigExport = 'LEGACY_VENDOR_CONFIG_EXPORT',
  /** Other document type. */
  Other = 'OTHER',
  /** RADIUS auth requirements document. */
  RadiusAuthRequirements = 'RADIUS_AUTH_REQUIREMENTS',
  /** Site survey link document. */
  SiteSurveyLink = 'SITE_SURVEY_LINK',
  /** SSID requirements document. */
  SsidRequirements = 'SSID_REQUIREMENTS',
  /** Static IP requirements document. */
  StaticIpRequirements = 'STATIC_IP_REQUIREMENTS',
  /** Topology design document. */
  TopologyDesign = 'TOPOLOGY_DESIGN',
  /** VLAN requirements document. */
  VlanRequirements = 'VLAN_REQUIREMENTS',
  /** Wired design document. */
  WiredDesign = 'WIRED_DESIGN',
  /** Wireless design document. */
  WirelessDesign = 'WIRELESS_DESIGN',
  /** Work order document. */
  WorkOrder = 'WORK_ORDER'
}

/** The type of an externally hosted document. */
export enum DocumentUploadType {
  /** A link to a document hosted in Google Drive. */
  GoogleDrive = 'GOOGLE_DRIVE'
}

/** Input type for generating a pre-signed URL for file download. */
export type DownloadUrlInput = {
  /**
   * The S3 key (path and filename) of the file to be downloaded.
   * Example: 'access_point_photos/20231010_abcd1234.jpg'
   */
  s3Key: Scalars['String']['input'];
};

/**
 * A dynamic floor plan stores the floor plan metadata for a single floor of a
 * network.
 */
export type DynamicFloorPlan = {
  __typename?: 'DynamicFloorPlan';
  /** The unique identifier of the dynamic floor plan. */
  UUID: Scalars['UUID']['output'];
  /** Access points placed on this dynamic floor plan. */
  accessPoints: Array<AccessPointVirtualDevice>;
  /** The building this dynamic floor plan belongs to. */
  building: DynamicFloorPlanBuilding;
  /** The UUID of the building this dynamic floor plan belongs to. */
  buildingUUID: Scalars['UUID']['output'];
  /** The timestamp when the dynamic floor plan was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A description of the dynamic floor plan. */
  description?: Maybe<Scalars['String']['output']>;
  /** The Meter floor number. */
  floor: Scalars['Int']['output'];
  /** The floor height in meters. */
  floorHeightMeters?: Maybe<Scalars['Float']['output']>;
  /** A pre-signed URL for downloading the floor plan image. */
  imageDownloadURL: DynamicFloorPlanImageDownloadUrl;
  /** The height of the floor plan image in pixels. */
  imageHeightPx: Scalars['Int']['output'];
  /** The width of the floor plan image in pixels. */
  imageWidthPx: Scalars['Int']['output'];
  /** A human-readable label for the dynamic floor plan. */
  label: Scalars['String']['output'];
  /** The real-world meters represented by one image pixel. */
  metersPerPixel?: Maybe<Scalars['Float']['output']>;
  /** The network this dynamic floor plan belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The S3 key for the floor plan image. */
  s3Key: Scalars['String']['output'];
  /** How this dynamic floor plan was created. */
  source: DynamicFloorPlanSource;
  /** The timestamp when the dynamic floor plan was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Wall segments on this dynamic floor plan. */
  wallSegments: Array<DynamicFloorPlanWallSegment>;
};

/** The placement of an access point on a dynamic floor plan. */
export type DynamicFloorPlanAccessPointPlacement = {
  __typename?: 'DynamicFloorPlanAccessPointPlacement';
  /** The access point coordinate in floor plan image space. */
  coordinate: DynamicFloorPlanPoint;
  /** The dynamic floor plan containing this placement. */
  dynamicFloorPlan: DynamicFloorPlan;
  /** The mounting height of the access point above the floor in meters, if known. */
  heightMeters?: Maybe<Scalars['Float']['output']>;
};

/**
 * A DynamicFloorPlanBuilding represents a physical building in the network. It can
 * have multiple floor plans, one for each floor of the building.
 * Each OpenIntent import targets a single building, and wall materials and
 * segments are scoped to a building.
 * There can be multiple buildings in a network.
 */
export type DynamicFloorPlanBuilding = {
  __typename?: 'DynamicFloorPlanBuilding';
  /** The unique identifier of the building. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the DynamicFloorPlanBuilding was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The dynamic floor plans in this building. */
  floorPlans: Array<DynamicFloorPlan>;
  /** The building name. Must be unique within the network. */
  name: Scalars['String']['output'];
  /** The network this building belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The timestamp when the DynamicFloorPlanBuilding was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The wall materials used by this building's floor plans. */
  wallMaterials: Array<DynamicFloorPlanWallMaterial>;
};

/** A pre-signed S3 URL for downloading a dynamic floor plan image from S3, with expiration. */
export type DynamicFloorPlanImageDownloadUrl = {
  __typename?: 'DynamicFloorPlanImageDownloadURL';
  /** The timestamp when the pre-signed URL expires. Currently uses the default presigned URL expiration of 15 minutes. */
  expiresAt: Scalars['DateTime']['output'];
  /** The pre-signed S3 URL for downloading the dynamic floor plan image. */
  url: Scalars['String']['output'];
};

/** A mapping from an OpenIntent floor UUID to a floor number. */
export type DynamicFloorPlanOpenIntentFloorMapping = {
  __typename?: 'DynamicFloorPlanOpenIntentFloorMapping';
  /** The building floor number this OpenIntent floor maps to. */
  floor: Scalars['Int']['output'];
  /** The floor UUID from the OpenIntent JSON. */
  openIntentFloorID: Scalars['String']['output'];
};

export type DynamicFloorPlanOpenIntentFloorMappingInput = {
  /** The building floor number to import this OpenIntent floor as. */
  floor: Scalars['Int']['input'];
  /** The floor UUID from the OpenIntent JSON. */
  openIntentFloorID: Scalars['String']['input'];
};

/** An OpenIntent .zip file upload for floor plans. */
export type DynamicFloorPlanOpenIntentUpload = {
  __typename?: 'DynamicFloorPlanOpenIntentUpload';
  /** The unique identifier of the OpenIntent upload record. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the upload record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The error message for a failed upload, if any. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Mappings from OpenIntent floor UUIDs to Meter floor numbers. */
  floorMappings: Array<DynamicFloorPlanOpenIntentFloorMapping>;
  /** The network this upload belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The timestamp when processing completed. */
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The timestamp when processing started. */
  processingStartedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The S3 key for the uploaded OpenIntent zip file. */
  s3Key: Scalars['String']['output'];
  /** The current processing status for this upload. */
  status: DynamicFloorPlanOpenIntentUploadStatus;
  /** The timestamp when the upload record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The timestamp when the zip file was uploaded. */
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DynamicFloorPlanOpenIntentUploadFilter = {
  /** Only return uploads whose status is in this list. */
  statuses?: InputMaybe<Array<DynamicFloorPlanOpenIntentUploadStatus>>;
};

export enum DynamicFloorPlanOpenIntentUploadStatus {
  /** The .zip file failed to process. */
  Failed = 'FAILED',
  /** The upload record exists, but the .zip file has not been uploaded yet. */
  PendingUpload = 'PENDING_UPLOAD',
  /** The .zip file was processed successfully. */
  Processed = 'PROCESSED',
  /** The .zip file is currently being processed. */
  Processing = 'PROCESSING',
  /** The .zip file has been uploaded and is waiting to be processed. */
  Uploaded = 'UPLOADED'
}

/**
 * A point on a dynamic floor plan is a coordinate in the 2D image space of the
 * floor plan, where origin is the bottom-left corner of the image.
 */
export type DynamicFloorPlanPoint = {
  __typename?: 'DynamicFloorPlanPoint';
  /** The x coordinate of the point. */
  x: Scalars['Float']['output'];
  /** The y coordinate of the point. */
  y: Scalars['Float']['output'];
};

export enum DynamicFloorPlanSource {
  /** Created manually. */
  Manual = 'MANUAL',
  /** Imported from a Hamina OpenIntent export. */
  OpenIntentHaminaImport = 'OPEN_INTENT_HAMINA_IMPORT',
  /** Created from a PDF upload. */
  PdfUpload = 'PDF_UPLOAD'
}

/**
 * A wall material specifies the physical material of a wall segment on a dynamic floor plan.
 * It is a subset of the OpenIntent wall material data.
 */
export type DynamicFloorPlanWallMaterial = {
  __typename?: 'DynamicFloorPlanWallMaterial';
  /** The unique identifier of the wall material. */
  UUID: Scalars['UUID']['output'];
  /** If the wall does not start at the floor, this specifies the height of the bottom of the wall in meters. */
  bottomHeightMeters?: Maybe<Scalars['Float']['output']>;
  /** The building this wall material belongs to. */
  buildingUUID: Scalars['UUID']['output'];
  /** The timestamp when the wall material was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The display color for the material, if one was provided. */
  displayColorHex?: Maybe<Scalars['String']['output']>;
  /** The ITU material type, if OpenIntent provided one. */
  ituMaterialType?: Maybe<Scalars['String']['output']>;
  /** The wall material name. */
  name: Scalars['String']['output'];
  /** The network this wall material belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** RF attenuation properties for this material, if OpenIntent provided them. */
  rfProperties?: Maybe<DynamicFloorPlanWallMaterialRfProperties>;
  /** The material thickness in meters, if known. */
  thicknessMeters?: Maybe<Scalars['Float']['output']>;
  /** The height of the top of the wall in meters, if known. */
  topHeightMeters?: Maybe<Scalars['Float']['output']>;
  /** The timestamp when the wall material was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** RF attenuation properties for a wall material. */
export type DynamicFloorPlanWallMaterialRfProperties = {
  __typename?: 'DynamicFloorPlanWallMaterialRFProperties';
  /** Flat attenuation value in dB, regardless of wall thickness. */
  attenuationFlatDb?: Maybe<Scalars['Float']['output']>;
  /** Attenuation in dB per meter of wall thickness. */
  attenuationPerMeterDb?: Maybe<Scalars['Float']['output']>;
};

/** A wall segment is a line segment on a dynamic floor plan that represents a wall. */
export type DynamicFloorPlanWallSegment = {
  __typename?: 'DynamicFloorPlanWallSegment';
  /** The unique identifier of the wall segment. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the wall segment was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The dynamic floor plan this wall segment belongs to. */
  dynamicFloorPlanUUID: Scalars['UUID']['output'];
  /** The wall segment geometry in floor plan image coordinates. */
  geometry: Array<DynamicFloorPlanPoint>;
  /** The network this wall segment belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The timestamp when the wall segment was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The material used for this segment. */
  wallMaterial: DynamicFloorPlanWallMaterial;
  /** The wall material used for this segment. */
  wallMaterialUUID: Scalars['UUID']['output'];
};

/** Represents the 802.1X encryption configuration for an SSID. */
export type Encryption8021X = Identifiable & {
  __typename?: 'Encryption8021X';
  /** The unique identifier of this 802.1X encryption configuration. */
  UUID: Scalars['UUID']['output'];
  /** The IP address of the accounting server. */
  accountingServerIPAddress?: Maybe<Scalars['IP']['output']>;
  /** The port of the accounting server. */
  accountingServerPort?: Maybe<Scalars['Int']['output']>;
  /** The shared secret used to authenticate with the accounting server. */
  accountingServerSecret?: Maybe<Scalars['String']['output']>;
  /** The IP address of the authentication server. */
  authServerIPAddress: Scalars['IP']['output'];
  /** The port of the authentication server. */
  authServerPort: Scalars['Int']['output'];
  /** The shared secret used to authenticate with the authentication server. */
  authServerSecret: Scalars['String']['output'];
  /** A user-friendly label for the encryption configuration. */
  label: Scalars['String']['output'];
  /** The network to which this encryption configuration belongs. */
  network: Network;
  /** The UUID of the network to which this encryption configuration belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** The configuration for the radius poller. */
  radiusPoller: RadiusPoller;
  /** The SSIDs associated with this 802.1X encryption configuration. */
  ssids?: Maybe<Array<Ssid>>;
  /** The switch profiles that use this 802.1X encryption configuration. */
  switchProfiles?: Maybe<Array<SwitchProfile>>;
};

/** An event in the event log. */
export type EventLogEvent = {
  __typename?: 'EventLogEvent';
  /** The type of event. */
  eventType: EventType;
  /** The API name representation of the event type. */
  eventTypeAPIName: Scalars['String']['output'];
  /** The timestamp when the event was generated. */
  generatedAt: Scalars['DateTime']['output'];
  /** The timestamp when the event was inserted into the database. */
  insertedAt: Scalars['DateTime']['output'];
  /** The network where the event occurred */
  network: Network;
  /**
   * The UUID of the network where the event occurred.
   * @deprecated Use `network` instead.
   */
  networkUUID: Scalars['UUID']['output'];
  /** How much attention this event deserves, derived from its event type. */
  priority: EventPriority;
  /** The properties associated with the event. */
  properties: EventLogProperties;
};

/** A paged response for event log queries. */
export type EventLogEventsPage = {
  __typename?: 'EventLogEventsPage';
  /** A subset of records based on the limit and offset fields. */
  events: Array<EventLogEvent>;
  /** The total number of records. */
  total: Scalars['Int']['output'];
};

/** Properties associated with an event log event. */
export type EventLogProperties = AccessPointConnectionProperties | AccessPointDfsChannelResetProperties | AccessPointInvalidVlanConnectionProperties | AccessPointMacSpoofDetectedProperties | AccessPointRadarHitDetectedProperties | AutoChannelSelectionJobCompletedProperties | CalibrationJobChannelResetFailedProperties | CalibrationJobCompletedProperties | ClientVpnConnectedProperties | ClientVpnDisconnectedProperties | DnsBlockedProperties | DeviceBootProperties | DeviceOfflineProperties | DeviceOnlineProperties | FirmwareUpgradeCancelledProperties | FirmwareUpgradeCompletedProperties | FirmwareUpgradePendingProperties | FirmwareUpgradeScheduledProperties | HighAvailabilityFailoverProperties | HighAvailabilityMultipleActiveProperties | HighAvailabilityRecoveryProperties | HoneypotAccessPointProperties | IpSecTunnelStatusChangeProperties | ManagementConnectionStatusChangeProperties | PduOutletProperties | PortBlockedProperties | RadiusFailoverProperties | RadiusPollerResultFailProperties | RadiusPollerResultOkProperties | RogueAccessPointProperties | RogueDhcpServerProperties | StpErrorPortBlockedProperties | StpErrorPortUnblockedProperties | StpRootBridgeChangedProperties | WanDownProperties | WanStatusChangeProperties | WanUpProperties;

/**
 * The priority of an event. It's a static property of the event type. All events
 * that share a type also share a priority.
 */
export enum EventPriority {
  /** An event that likely warrants investigation. */
  High = 'HIGH',
  /** Routine events, often high-volume. */
  Low = 'LOW',
  /** Notable event, which includes recoveries from high priority events. */
  Medium = 'MEDIUM'
}

/** Enumerate the known event types that exist in the event log. */
export enum EventType {
  /** Event indicating a wireless connection event on an access point. */
  AccessPointConnection = 'ACCESS_POINT_CONNECTION',
  /** Event indicating that a DFS channel reset occurred on an access point. */
  AccessPointDfsChannelReset = 'ACCESS_POINT_DFS_CHANNEL_RESET',
  /** Event indicating a connection on an invalid (unknown or disabled) VLAN. */
  AccessPointInvalidVlanConnection = 'ACCESS_POINT_INVALID_VLAN_CONNECTION',
  /** Event indicating that an access point detected spoofing of one of its BSSIDs. */
  AccessPointMacSpoofDetected = 'ACCESS_POINT_MAC_SPOOF_DETECTED',
  /** Event indicating that a DFS radar hit was detected by an access point. */
  AccessPointRadarHitDetected = 'ACCESS_POINT_RADAR_HIT_DETECTED',
  /** Event indicating that an auto channel selection job completed successfully. */
  AutoChannelSelectionJobCompleted = 'AUTO_CHANNEL_SELECTION_JOB_COMPLETED',
  /** Event indicating that APs failed to return to their configured channel after a wireless calibration job. */
  CalibrationJobChannelResetFailed = 'CALIBRATION_JOB_CHANNEL_RESET_FAILED',
  /** Event indicating that a wireless calibration job completed. */
  CalibrationJobCompleted = 'CALIBRATION_JOB_COMPLETED',
  /** Event indicating that a client connected to a Client VPN server. */
  ClientVpnConnected = 'CLIENT_VPN_CONNECTED',
  /** Event indicating that a client disconnected from a Client VPN server. */
  ClientVpnDisconnected = 'CLIENT_VPN_DISCONNECTED',
  /** Event indicating that a High Availability failover event occurred. */
  CosHaFailover = 'COS_HA_FAILOVER',
  /** Event indicating that multiple Security Appliances are active in a High Availability setup. */
  CosHaMultipleActive = 'COS_HA_MULTIPLE_ACTIVE',
  /** Event indicating that a High Availability recovery event occurred. */
  CosHaRecovery = 'COS_HA_RECOVERY',
  /** Event indicating that a device booted with a specific version of the firmware. */
  DeviceBoot = 'DEVICE_BOOT',
  /** Event indicating that a device has gone offline. */
  DeviceOffline = 'DEVICE_OFFLINE',
  /** Event indicating that a device has come online. */
  DeviceOnline = 'DEVICE_ONLINE',
  /** Event indicating that the Security Appliance blocked a DNS query. */
  DnsBlocked = 'DNS_BLOCKED',
  /** Event indicating that a firmware upgrade was cancelled on a network. */
  FirmwareUpgradeCancelled = 'FIRMWARE_UPGRADE_CANCELLED',
  /** Event indicating that a firmware upgrade is completed on a network. */
  FirmwareUpgradeCompleted = 'FIRMWARE_UPGRADE_COMPLETED',
  /**
   * Event indicating that a firmware upgrade is pending on a network.
   * An upgrade has been applied to the respective device configs and should immediately take effect, given
   * that these devices are online.
   */
  FirmwareUpgradePending = 'FIRMWARE_UPGRADE_PENDING',
  /**
   * Event indicating that a firmware upgrade is scheduled on a network.
   * The upgrade will be applied to the device configs at the scheduled time; no device
   * config change has been made yet.
   */
  FirmwareUpgradeScheduled = 'FIRMWARE_UPGRADE_SCHEDULED',
  /** Event indicating that a honeypot access point was detected. */
  HoneypotAccessPointDetected = 'HONEYPOT_ACCESS_POINT_DETECTED',
  /** Event indicating that a honeypot access point is no longer detected. */
  HoneypotAccessPointNoLongerDetected = 'HONEYPOT_ACCESS_POINT_NO_LONGER_DETECTED',
  /** Event indicating that an IPSec tunnel had a status change. */
  IpsecTunnelStatusChange = 'IPSEC_TUNNEL_STATUS_CHANGE',
  /** Event indicating that a management connection status changed. */
  ManagementConnectionStatusChanged = 'MANAGEMENT_CONNECTION_STATUS_CHANGED',
  /** Event indicating that a PDU outlet event occurred. */
  PduOutletStatusChanged = 'PDU_OUTLET_STATUS_CHANGED',
  /** Event indicating that a port was blocked due to flap link intervention protocol (FLIP). */
  PortBlocked = 'PORT_BLOCKED',
  /** Event indicating that a port was unblocked due to flap link intervention protocol (FLIP). */
  PortUnblocked = 'PORT_UNBLOCKED',
  /**
   * Event indicating that access points failed over from a primary RADIUS auth
   * server to a backup within a time window.
   */
  RadiusFailover = 'RADIUS_FAILOVER',
  /** Event indicating that RADIUS servers are reachable. */
  RadiusPollerOk = 'RADIUS_POLLER_OK',
  /** Event indicating that RADIUS servers are unreachable. */
  RadiusPollerUnreachable = 'RADIUS_POLLER_UNREACHABLE',
  /** Event indicating that a rogue access point was detected. */
  RogueAccessPointDetected = 'ROGUE_ACCESS_POINT_DETECTED',
  /** Event indicating that a rogue access point is no longer detected. */
  RogueAccessPointNoLongerDetected = 'ROGUE_ACCESS_POINT_NO_LONGER_DETECTED',
  /**
   * Event indicating a rogue (unexpected) DHCP server was detected — multiple
   * DHCP servers offered IPs for the same transaction on the same VLAN.
   */
  RogueDhcpServer = 'ROGUE_DHCP_SERVER',
  /** Event indicating that a Spanning Tree Protocol (STP) error caused a port to be blocked. */
  StpErrorPortBlocked = 'STP_ERROR_PORT_BLOCKED',
  /** Event indicating that a port blocked by a Spanning Tree Protocol (STP) error has been unblocked. */
  StpErrorPortUnblocked = 'STP_ERROR_PORT_UNBLOCKED',
  /** Event indicating that the Spanning Tree Protocol (STP) root bridge observed by a switch has changed. */
  StpRootBridgeChanged = 'STP_ROOT_BRIDGE_CHANGED',
  /** The event type is unspecified. */
  Unspecified = 'UNSPECIFIED',
  /** Event indicating that the WAN connection is down. */
  WanDown = 'WAN_DOWN',
  /** Event indicating a change in WAN status. */
  WanStatusChange = 'WAN_STATUS_CHANGE',
  /** Event indicating that the WAN connection is up. */
  WanUp = 'WAN_UP'
}

/** A FLIP triggered active issue */
export type FlipTriggeredActiveIssue = ActiveIssue & {
  __typename?: 'FLIPTriggeredActiveIssue';
  /** When the issue was first detected, if available */
  detectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The network that this issue is impacting */
  networkUUID: Scalars['UUID']['output'];
  /** The ports that have FLIP triggered */
  phyInterfaces: Array<PhyInterface>;
  /** When the issue was resolved, if available */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The severity of the issue */
  severity: ActiveIssueSeverity;
  /** The type of the issue */
  type: ActiveIssueType;
};

/** Payload containing the pre-signed URL for file download. */
export type FileDownloadPayload = {
  __typename?: 'FileDownloadPayload';
  /** The pre-signed URL for downloading the file from S3. */
  presignedUrl: Scalars['String']['output'];
};

/** Payload containing the pre-signed URL for file upload. */
export type FileUploadPayload = {
  __typename?: 'FileUploadPayload';
  /** The expiration date of the pre-signed URL. */
  expiresAt: Scalars['DateTime']['output'];
  /**
   * The key (path and filename) for the stored file.
   * Format: <folder>/<timestamp>_<uuid>.<extension>
   */
  key: Scalars['String']['output'];
  /** The pre-signed URL for uploading the file. */
  presignedUrl: Scalars['String']['output'];
};

/** An available filter for a given query. */
export type FilterDefinition = {
  __typename?: 'FilterDefinition';
  /** ID used to identify which filter is being targeted. */
  id: Scalars['String']['output'];
  /** Displayable label for the filter definition. */
  label: Scalars['String']['output'];
  /** If the filter has options they are available here. */
  options: Array<FilterOption>;
  /** The variant of filter. */
  variant: FilterVariant;
};

/** Filter type shared across all queries. */
export type FilterInput = {
  /** Bool filter. */
  bool?: InputMaybe<BoolFilter>;
  /** Date range filter. */
  dateRange?: InputMaybe<DateRangeFilter>;
  /** Multi select filter. */
  multiSelect?: InputMaybe<MultiSelectFilter>;
  /** Number filter. */
  number?: InputMaybe<NumberFilter>;
  /** Number range filter. */
  numberRange?: InputMaybe<NumberRangeFilter>;
  /** Select filter. */
  select?: InputMaybe<SelectFilter>;
  /** Text filter. */
  text?: InputMaybe<TextFilter>;
};

/** An available option for a filter definition. */
export type FilterOption = {
  __typename?: 'FilterOption';
  /** Whether this option is disabled for the filter. */
  disabled: Scalars['Boolean']['output'];
  /** Displayable label for the filter option. */
  label: Scalars['String']['output'];
  /** Value of the filter option. */
  value: Scalars['String']['output'];
};

/** The variant of a filter, which determines how it is rendered and how its values are interpreted. */
export enum FilterVariant {
  /** A boolean toggle. */
  Bool = 'BOOL',
  /** A date range defined by a start and end date. */
  DateRange = 'DATE_RANGE',
  /** A multi-choice selection from a predefined set of options. */
  MultiSelect = 'MULTI_SELECT',
  /** A single numeric value. */
  Number = 'NUMBER',
  /** A numeric range defined by a lower and upper bound. */
  NumberRange = 'NUMBER_RANGE',
  /** A single-choice selection from a predefined set of options. */
  Select = 'SELECT',
  /** A free-form text input. */
  Text = 'TEXT'
}

/** Represents a binding of a firewall rule to a physical interface with a metric. */
export type FirewallPhyInterfaceBinding = {
  __typename?: 'FirewallPhyInterfaceBinding';
  /**
   * The metric associated with the binding.
   * @deprecated Use `FirewallRule.priority` instead.
   */
  metric?: Maybe<Scalars['Int']['output']>;
  /** The physical interface to which the firewall rule is bound. */
  phyInterface: PhyInterface;
};

/** Represents a firewall rule in the network configuration. */
export type FirewallRule = Identifiable & {
  __typename?: 'FirewallRule';
  /** Unique identifier for the firewall rule. */
  UUID: Scalars['UUID']['output'];
  /** The action to take when the firewall rule matches (e.g., DENY or PERMIT). */
  action: FirewallRuleAction;
  /** List of physical interfaces bound to the firewall rule. */
  boundPhyInterfaces: Array<PhyInterface>;
  /** List of VLANs bound to the firewall rule. */
  boundVLANs: Array<Vlan>;
  /** The date and time when the firewall rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A description of the firewall rule. */
  description?: Maybe<Scalars['String']['output']>;
  /** Destination IPv4 address patterns to match traffic to, e.g. `10.1-4.*.2/31`. */
  dstAddressPatterns?: Maybe<Array<Scalars['IPAddressPattern']['output']>>;
  /** Destination client VPN server to match traffic to. */
  dstClientVPNServer?: Maybe<ClientVpnServer>;
  /**
   * Destination FQDNs to match traffic to: an exact name, or `*.` followed by a name to match its subdomains only.
   * Matches the addresses the device has seen each name resolve to in the DNS answers it serves.
   */
  dstFQDNs?: Maybe<Array<Scalars['String']['output']>>;
  /** Destination IPSec tunnel to match traffic to. */
  dstIPSecTunnel?: Maybe<IpSecTunnel>;
  /**
   * Deprecated. Use `dstPortRanges` instead. Single destination port range to match.
   * @deprecated Use `dstPortRanges` instead.
   */
  dstPortRange: PortRange;
  /** List of destination port ranges to match traffic to. */
  dstPortRanges: Array<PortRange>;
  /**
   * Destination IP prefix to match traffic to.
   * @deprecated Use `dstPrefixes` instead.
   */
  dstPrefix?: Maybe<Scalars['IPPrefix']['output']>;
  /** Destination IP prefixes to match traffic to. */
  dstPrefixes?: Maybe<Array<Scalars['IPPrefix']['output']>>;
  /** Destination VLAN to match traffic to. */
  dstVLAN?: Maybe<Vlan>;
  /** IDS event associated with this rule. */
  idsEvent?: Maybe<IdsEvent>;
  /**
   * If a firewall rule is bidirectional then the config renderer will generate an additional rule(s)
   * where the src and dst options are swapped.
   * @deprecated Bidirectional rules are now implicit, enabled if the rule is between two VLANs.
   */
  isBidirectional?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates that the firewall rule is generated automatically via other settings and cannot be modified directly. */
  isDefault: Scalars['Boolean']['output'];
  /** Indicates if the firewall rule is currently enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Indicates that the rule is managed by Meter and cannot be modified. */
  isMeterInternal: Scalars['Boolean']['output'];
  /** The name of the firewall rule. */
  name: Scalars['String']['output'];
  /** The network to which the firewall rule belongs. */
  network: Network;
  /** Unique identifier of the network to which the firewall rule belongs. */
  networkUUID: Scalars['UUID']['output'];
  /**
   * List of physical interface bindings for the firewall rule.
   * @deprecated Use `boundPhyInterfaces` instead.
   */
  phyInterfaceBindings?: Maybe<Array<FirewallPhyInterfaceBinding>>;
  /** Priority of the rule within the network, lower priority rules are applied first. */
  priority: Scalars['Int']['output'];
  /**
   * Deprecated. Use `protocols` instead. Single IP protocol to match.
   * @deprecated Use `protocols` instead.
   */
  protocol: IpProtocol;
  /** List of IP protocols to match. */
  protocols: Array<IpProtocol>;
  /** Source IPv4 address patterns to match traffic from, e.g. `10.1-4.*.2/31`. */
  srcAddressPatterns?: Maybe<Array<Scalars['IPAddressPattern']['output']>>;
  /** Source client VPN server to match traffic from. */
  srcClientVPNServer?: Maybe<ClientVpnServer>;
  /** Source IPSec tunnel to match traffic from. */
  srcIPSecTunnel?: Maybe<IpSecTunnel>;
  /**
   * Deprecated. Use `srcPortRanges` instead. Single source port range to match.
   * @deprecated Use `srcPortRanges` instead.
   */
  srcPortRange: PortRange;
  /** List of source port ranges to match traffic from. */
  srcPortRanges: Array<PortRange>;
  /**
   * Source IP prefix to match traffic from.
   * @deprecated Use `srcPrefixes` instead.
   */
  srcPrefix?: Maybe<Scalars['IPPrefix']['output']>;
  /** Source IP prefixes to match traffic from. */
  srcPrefixes?: Maybe<Array<Scalars['IPPrefix']['output']>>;
  /** Source VLAN to match traffic from. */
  srcVLAN?: Maybe<Vlan>;
  /** List of tags associated with the firewall rule. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  /** The date and time when the firewall rule was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * List of VLAN bindings for the firewall rule.
   * @deprecated Use `boundVLANS` instead.
   */
  vlanBindings?: Maybe<Array<FirewallVlanBinding>>;
};

/** Possible actions for a firewall rule. */
export enum FirewallRuleAction {
  /** Deny the traffic. */
  Deny = 'DENY',
  /** Permit the traffic. */
  Permit = 'PERMIT'
}

/** Response type containing firewall rule timeseries data over a specified time range. */
export type FirewallRuleMetricsTimeseriesResponse = {
  __typename?: 'FirewallRuleMetricsTimeseriesResponse';
  /** The firewall rule for this series, if associated with a non-default firewall rule entity. */
  firewallRule?: Maybe<FirewallRule>;
  /** The unique identifier for the firewall rule. If a default rule, will be dynamically generated. */
  firewallRuleUUID: Scalars['UUID']['output'];
  /** Packets blocked per bucket. */
  packets: BaseMetricsResponse;
  /** The total packets blocked in the lookback. */
  totalPackets: Scalars['Int']['output'];
  /** The virtual device that emitted the counters. */
  virtualDevice: VirtualDevice;
};

/** Represents a binding of a firewall rule to a VLAN with a metric. */
export type FirewallVlanBinding = {
  __typename?: 'FirewallVLANBinding';
  /**
   * The metric associated with the binding.
   * @deprecated Use `FirewallRule.priority` instead.
   */
  metric?: Maybe<Scalars['Int']['output']>;
  /** The VLAN to which the firewall rule is bound. */
  vlan: Vlan;
};

/** Properties for firmware upgrade cancelled events. */
export type FirmwareUpgradeCancelledProperties = {
  __typename?: 'FirmwareUpgradeCancelledProperties';
  /** The time the firmware upgrade was cancelled. */
  cancelledAt: Scalars['DateTime']['output'];
  /** The scheduled network NOS upgrade that was cancelled. Null if the referenced upgrade no longer exists. */
  cancelledNOSUpgrade?: Maybe<ScheduledNetworkNosUpgrade>;
  /** If this force cancelled upgrades in progress. */
  force: Scalars['Boolean']['output'];
};

/** Properties for firmware upgrade completed events. */
export type FirmwareUpgradeCompletedProperties = {
  __typename?: 'FirmwareUpgradeCompletedProperties';
  /** The time the upgrade completed. */
  completedAt: Scalars['DateTime']['output'];
  /** The virtual devices that unsuccessfully upgraded to nosVersion. */
  failedVirtualDevices?: Maybe<Array<Maybe<VirtualDevice>>>;
  /** The NOS version pending for the upgrade. Null if the referenced NOS version no longer exists. */
  nosVersion?: Maybe<NosVersion>;
  /** The virtual devices that were skipped because they were offline. */
  skippedVirtualDevices?: Maybe<Array<Maybe<VirtualDevice>>>;
  /** The status of the upgrade. */
  status: FirmwareUpgradeCompletedStatus;
  /** The virtual devices that successfully upgraded to nosVersion. */
  successfulVirtualDevices?: Maybe<Array<Maybe<VirtualDevice>>>;
};

/** Specifies the status of a firmware upgrade completed event. */
export enum FirmwareUpgradeCompletedStatus {
  /** The upgrade failed. */
  Failure = 'FAILURE',
  /** The upgrade was successful. */
  Success = 'SUCCESS',
  /** Status is unknown. */
  Unspecified = 'UNSPECIFIED'
}

/** Properties for firmware upgrade pending events. */
export type FirmwareUpgradePendingProperties = {
  __typename?: 'FirmwareUpgradePendingProperties';
  /** If this was a force upgrade. */
  force: Scalars['Boolean']['output'];
  /** The NOS version pending for the upgrade. Null if the referenced NOS version no longer exists. */
  nosVersion?: Maybe<NosVersion>;
  /** The virtual devices that have a pending upgrade. */
  virtualDevices?: Maybe<Array<Maybe<VirtualDevice>>>;
};

/** Properties for firmware upgrade scheduled events. */
export type FirmwareUpgradeScheduledProperties = {
  __typename?: 'FirmwareUpgradeScheduledProperties';
  /** The NOS version scheduled for the upgrade. Null if the referenced NOS version no longer exists. */
  nosVersion?: Maybe<NosVersion>;
  /** The time the firmware upgrade is scheduled. */
  scheduledAt: Scalars['DateTime']['output'];
  /** The virtual devices scheduled for an upgrade. */
  virtualDevices?: Maybe<Array<Maybe<VirtualDevice>>>;
};

/** A snooze silences alert notifications for the given network or company for the given time window. */
export type FleetwideNotificationSnooze = Identifiable & {
  __typename?: 'FleetwideNotificationSnooze';
  /** The UUID of the snooze. */
  UUID: Scalars['UUID']['output'];
  /** The associated company. */
  company?: Maybe<Company>;
  /** The timestamp when the snooze was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The timestamp when the snooze was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The associated network. */
  network?: Maybe<Network>;
  /** The timestamp when the snooze ends. */
  snoozeEnd: Scalars['DateTime']['output'];
  /** The reason for the snooze. */
  snoozeReason?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the snooze begins. */
  snoozeStart: Scalars['DateTime']['output'];
  /** The timestamp when the snooze was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * A floor plan is an overhead view of a physical space. A floor plan is one-to-many to floor plan locations,
 * which are x/y coordinates for Meter devices in the physical space.
 */
export type FloorPlan = Identifiable & {
  __typename?: 'FloorPlan';
  /** The unique identifier of the floor plan. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the floor plan was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A description of the floor plan. */
  description?: Maybe<Scalars['String']['output']>;
  /** The type of the document. */
  documentCategory: FloorPlanDocumentCategory;
  /** A pre-signed URL to download the floor plan image. */
  imageDownloadURL: Scalars['String']['output'];
  /** The S3 key (path) of the image file representing the floor plan, stored in Amazon S3. */
  imageS3Key: Scalars['String']['output'];
  /** A human-readable name or label for the floor plan. */
  label: Scalars['String']['output'];
  /** The network that this floor plan belongs to. */
  network: Network;
  /** The unique identifier of the network that this floor plan belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The timestamp when the floor plan was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export enum FloorPlanDocumentCategory {
  /** A floor plan */
  FloorPlan = 'FLOOR_PLAN',
  /** An annotated floor plan uploaded through the network onboarding form. */
  OnboardingAnnotatedFloorPlan = 'ONBOARDING_ANNOTATED_FLOOR_PLAN',
  /** A blank floor plan uploaded through the network onboarding form. */
  OnboardingBlankFloorPlan = 'ONBOARDING_BLANK_FLOOR_PLAN',
  /**
   * Any non-floor plan documentation relevant to the site.
   * @deprecated Site documentation is no longer stored as floor plans.
   */
  SiteDocumentation = 'SITE_DOCUMENTATION',
  /** A wireless design for the site. */
  WirelessDesigns = 'WIRELESS_DESIGNS'
}

/** The cellular generation and architecture of a gateway's current connection. */
export enum GatewayCellularAccessMode {
  /** 4G LTE. */
  Lte = 'LTE',
  /** The modem is up but has no service. */
  None = 'NONE',
  /** 5G non-standalone: an LTE anchor with a 5G secondary carrier. */
  Nr5GNsa = 'NR5G_NSA',
  /** 5G standalone. */
  Nr5GSa = 'NR5G_SA',
  /** The reporting firmware did not specify the access mode. */
  Unspecified = 'UNSPECIFIED',
  /** 3G, a legacy fallback. */
  Wcdma = 'WCDMA'
}

/** Whether a serving component carrier is carrying data or merely provisioned. */
export enum GatewayCellularCarrierState {
  /** The carrier is currently carrying data. */
  Active = 'ACTIVE',
  /** The carrier is provisioned but idle, such as a deactivated secondary carrier. */
  Configured = 'CONFIGURED',
  /** Not applicable: the cell is a neighbor, or the per-carrier readout was unavailable for this report. */
  Unspecified = 'UNSPECIFIED'
}

/** The state of the cellular data session on a gateway's modem. */
export enum GatewayCellularConnectionState {
  /** A data session is established. */
  Connected = 'CONNECTED',
  /** A data session is being established. */
  Connecting = 'CONNECTING',
  /** No data session is established. */
  Disconnected = 'DISCONNECTED',
  /** The reporting firmware did not specify the connection state. */
  Unspecified = 'UNSPECIFIED'
}

/**
 * What the carrier negotiated on the cellular data call, as opposed to what the gateway's kernel has
 * configured on the interface. A mismatch means the modem and host are out of sync.
 */
export type GatewayCellularDataCallInfo = {
  __typename?: 'GatewayCellularDataCallInfo';
  /** The negotiated DNS servers, typically two. */
  dnsServers: Array<Scalars['IP']['output']>;
  /** The negotiated IPv4 address; null if none was negotiated. */
  ipv4Address?: Maybe<Scalars['IPV4']['output']>;
  /** The negotiated IPv4 gateway; null if none was negotiated. */
  ipv4Gateway?: Maybe<Scalars['IPV4']['output']>;
};

/**
 * The state of a cellular gateway's modem as reported at a point in time: registration and data
 * session state, the serving component carriers and neighbor cells with per-carrier signal
 * measurements, per-slot SIM state, and the data connection as seen by both the kernel and the carrier.
 */
export type GatewayCellularInfo = {
  __typename?: 'GatewayCellularInfo';
  /** The cellular generation and architecture of the current connection. */
  accessMode: GatewayCellularAccessMode;
  /** The access point name of the data session, such as `hologram`. */
  accessPointName: Scalars['String']['output'];
  /** The physical slot number of the SIM the modem is using. */
  activeSlot: Scalars['Int']['output'];
  /** The state of the cellular data session. */
  connectionState: GatewayCellularConnectionState;
  /** What the carrier negotiated on the data call; null if it could not be read for this report. */
  dataCall?: Maybe<GatewayCellularDataCallInfo>;
  /** The kernel interface name of the cellular link, such as `cellular129`. */
  interfaceName: Scalars['String']['output'];
  /** The IPv4 address the kernel has configured on the cellular interface; null when not connected. */
  ipv4Address?: Maybe<Scalars['IPV4']['output']>;
  /** The IPv4 gateway the kernel has configured on the cellular interface; null when not connected. */
  ipv4Gateway?: Maybe<Scalars['IPV4']['output']>;
  /** Whether the modem is roaming. */
  isRoaming: Scalars['Boolean']['output'];
  /** Adjacent or overlapping neighbor cells monitored for potential handover. Currently LTE only. */
  neighborCells: Array<GatewayRadioCell>;
  /** When the gateway observed this state. */
  observedAt: Scalars['DateTime']['output'];
  /** The preferred public land mobile network list read from the SIM. */
  preferredPLMNs: Array<Scalars['String']['output']>;
  /** Whether the carrier's network has accepted the gateway. */
  registrationState: GatewayCellularRegistrationState;
  /** Bytes received on the cellular interface since boot. */
  rxBytes: Scalars['Uint64']['output'];
  /** The serving operator name, such as `T-Mobile`. */
  servingCarrier: Scalars['String']['output'];
  /** Radio cells that are handling active connection and data transmission. */
  servingCells: Array<GatewayRadioCell>;
  /** The serving public land mobile network as MCC followed by MNC, such as `310260`. */
  servingPLMN: Scalars['String']['output'];
  /** The state of each SIM slot. */
  simSlots: Array<GatewayCellularSimSlot>;
  /** Bytes transmitted on the cellular interface since boot. */
  txBytes: Scalars['Uint64']['output'];
  /** The virtual device associated with this gateway cellular info. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The UUID of the gateway virtual device that reported this state. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** The physical radio technology of a single cellular carrier, as opposed to the access mode of the overall connection. */
export enum GatewayCellularRadioAccessTechnology {
  /** 4G LTE. */
  Lte = 'LTE',
  /** 5G New Radio. */
  Nr5G = 'NR5G',
  /** The reporting firmware did not specify the radio access technology. */
  Unspecified = 'UNSPECIFIED',
  /** 3G WCDMA. */
  Wcdma = 'WCDMA'
}

/**
 * Whether the carrier's network has accepted the gateway, the cellular equivalent of being signed in.
 * Registration is a prerequisite for moving data but is not a data session by itself; a gateway can be
 * REGISTERED while its connection state is not CONNECTED, which points at an APN or configuration problem.
 */
export enum GatewayCellularRegistrationState {
  /** A network was found but rejected the gateway; a SIM, plan, or provisioning problem that needs operator action. */
  Denied = 'DENIED',
  /** The modem is idle and not currently trying to register. */
  NotRegistered = 'NOT_REGISTERED',
  /** The network has accepted the gateway. */
  Registered = 'REGISTERED',
  /** No usable network was found; a coverage or antenna problem. */
  Searching = 'SEARCHING',
  /** The reporting firmware did not specify the registration state. */
  Unspecified = 'UNSPECIFIED'
}

/** Whether a SIM card is present and readable in a slot. */
export enum GatewayCellularSimCardState {
  /** No card is present in the slot. */
  Absent = 'ABSENT',
  /** A card is present but could not be read. */
  Error = 'ERROR',
  /** A card is present and readable. */
  Present = 'PRESENT',
  /** The reporting firmware did not specify the card state. */
  Unspecified = 'UNSPECIFIED'
}

/** The state of one of the gateway's SIM slots. */
export type GatewayCellularSimSlot = {
  __typename?: 'GatewayCellularSIMSlot';
  /** Whether a card is present and readable in the slot. */
  cardState: GatewayCellularSimCardState;
  /** The eUICC identifier; populated for the embedded slot only. */
  eid: Scalars['String']['output'];
  /** The ICCID of the inserted SIM or enabled profile; empty if unknown. */
  iccid: Scalars['String']['output'];
  /** Whether the card is an embedded UICC (eSIM). */
  isEUICC: Scalars['Boolean']['output'];
  /** The physical slot number: 1 is the removable SIM, 2 is the embedded eUICC. */
  physicalSlot: Scalars['Int']['output'];
  /** Whether the slot is the one the modem is using. */
  state: GatewayCellularSimSlotState;
};

/** Whether a SIM slot is the one the modem is using. */
export enum GatewayCellularSimSlotState {
  /** The slot is the one the modem is using. */
  Active = 'ACTIVE',
  /** The slot is not in use. */
  Inactive = 'INACTIVE',
  /** The reporting firmware did not specify the slot state. */
  Unspecified = 'UNSPECIFIED'
}

/**
 * A device currently connected to a gateway virtual device's downlink ports,
 * from the gateway's most recently reported connected-clients snapshot.
 */
export type GatewayConnectedClient = {
  __typename?: 'GatewayConnectedClient';
  /** Whether the client uses this gateway or is merely present on a shared L2 segment. */
  classification: GatewayConnectedClientClassification;
  /** The client's DHCP lease from the gateway's DHCP server, if it holds an unexpired one. */
  dhcpLease?: Maybe<GatewayConnectedClientDhcpLease>;
  /** The freshest observation of the client across all of the gateway's signals. */
  lastSeen?: Maybe<Scalars['DateTime']['output']>;
  /** The client's MAC address. */
  macAddress: Scalars['MacAddress']['output'];
  /** When the gateway reported the snapshot containing this client. */
  observedAt: Scalars['DateTime']['output'];
  /** The downlink port number the client is connected to. */
  port: Scalars['Int']['output'];
  /** The UUID of the gateway virtual device that reported the client. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/**
 * Whether a device connected to a gateway's downlink actually uses the gateway
 * or is merely present on a shared L2 segment.
 */
export enum GatewayConnectedClientClassification {
  /** The device shows intent to use this gateway, such as a DHCP lease from the gateway's DHCP server or NATed uplink flows. */
  GatewayClient = 'GATEWAY_CLIENT',
  /** The device is live on the gateway's L2 segment with no gateway intent observed. */
  OnSegment = 'ON_SEGMENT',
  /** The reporting firmware did not classify the device. */
  Unspecified = 'UNSPECIFIED'
}

/** An unexpired DHCP lease held by a gateway-connected client. */
export type GatewayConnectedClientDhcpLease = {
  __typename?: 'GatewayConnectedClientDHCPLease';
  /** When the lease expires. */
  expiresAt: Scalars['DateTime']['output'];
  /** The hostname the client sent (DHCP option 12), if any. */
  hostname?: Maybe<Scalars['String']['output']>;
  /** The leased IP address. */
  ipAddress: Scalars['IP']['output'];
};

/** A gateway profile is a bundle of settings that applies to a cellular gateway device. */
export type GatewayProfile = {
  __typename?: 'GatewayProfile';
  /** Unique identifier of the gateway profile. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the profile was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Indicates whether the gateway device should send logs to the backend.
   * Off by default because shipped logs incur a cost per megabyte sent over the cellular connection.
   */
  isLogShippingEnabled: Scalars['Boolean']['output'];
  /** The unique identifier of the network the gateway profile belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** Timestamp when the profile was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Radio cell that can provide service for a specific radio frequency. Can either be a serving cell that is providing a
 * connection and data transmission or a neighbor cell that is nearby and available.
 */
export type GatewayRadioCell = {
  __typename?: 'GatewayRadioCell';
  /** The normalized band, such as `b66` or `n41`. */
  band: Scalars['String']['output'];
  /** The carrier bandwidth in MHz. */
  bandwidthMhz: Scalars['Uint32']['output'];
  /**
   * Serving cells only: the position of this carrier within its radio access technology's carrier
   * aggregation set. 0 is the anchor carrier (the LTE primary component carrier, or the NR primary
   * secondary cell in non-standalone 5G), 1 is the first secondary component carrier, and so on.
   */
  carrierIndex: Scalars['Uint32']['output'];
  /** Serving cells only: whether this carrier is carrying data or merely provisioned. */
  carrierState: GatewayCellularCarrierState;
  /** The channel number: EARFCN for LTE or NR-ARFCN for 5G. */
  channel: Scalars['Uint32']['output'];
  /** The globally unique cell tower identifier. Serving anchor carrier only; 0 otherwise. */
  globalCellID: Scalars['Uint64']['output'];
  /** Neighbor cells only: whether the cell was measured on the same channel as the serving cell. */
  intraFrequency: Scalars['Boolean']['output'];
  /** The physical cell identifier, unique only within the modem's current radio neighborhood. */
  physicalCellID: Scalars['Uint32']['output'];
  /** The physical radio technology of this cell. */
  radioAccessTechnology: GatewayCellularRadioAccessTechnology;
  /** Reference signal received power in dBm; 0 if not measured. */
  rsrpDbm: Scalars['Float']['output'];
  /** Reference signal received quality in dB; 0 if not measured. */
  rsrqDb: Scalars['Float']['output'];
  /** Received signal strength indicator in dBm; 0 if not measured. */
  rssiDbm: Scalars['Float']['output'];
  /** Signal to interference plus noise ratio in dB; 0 if not measured. Not reported for neighbor cells. */
  snrDb: Scalars['Float']['output'];
  /** The tracking area code. Serving anchor carrier only; 0 otherwise. */
  trackingAreaCode: Scalars['Uint32']['output'];
};

/** Settings related to gateway uplinks for a network's firewalls. */
export type GatewayUplinkSettings = {
  __typename?: 'GatewayUplinkSettings';
  /** Indicates whether gateway ports are allowed to be enabled as uplinks on the network's firewalls. */
  isEnabled: Scalars['Boolean']['output'];
};

export type GenerateTopologyDesignIdfInput = {
  /** Building where this IDF is located. Stamped onto every node generated for it. */
  building?: InputMaybe<Scalars['String']['input']>;
  /** Number of ports needed. Mutually exclusive with switchCounts. */
  endpointPortDemand?: InputMaybe<Scalars['Int']['input']>;
  /** Floor within the building where this IDF is located. Stamped onto every node generated for it. */
  floor?: InputMaybe<Scalars['String']['input']>;
  /** Insert a local aggregation tier that collects this IDF's distribution and its child IDFs' distribution before the core (hospitality aggregation). */
  hostAgg?: Scalars['Boolean']['input'];
  /** Number of indoor access points. */
  indoorAPCount: Scalars['Int']['input'];
  /** User-provided label for this IDF, used by other IDFs to reference it as a parent. */
  label: Scalars['String']['input'];
  /** Number of outdoor access points. */
  outdoorAPCount: Scalars['Int']['input'];
  /** Label of the parent MDF/IDF. */
  parentLabel: Scalars['String']['input'];
  /** Connection medium for uplinks from this IDF to its parent MDF/IDF. */
  parentUplinkConnectionType?: InputMaybe<TopologyDesignUplinkConnectionType>;
  /** Room where this IDF is located. Stamped onto every node generated for it. */
  room?: InputMaybe<Scalars['String']['input']>;
  /** Explicit switch counts. Mutually exclusive with endpointPortDemand. */
  switchCounts?: InputMaybe<GenerateTopologyDesignSwitchCountInput>;
};

export type GenerateTopologyDesignInput = {
  /** Force all access-layer switches to 24-port. */
  accessLayer24PortOnly?: Scalars['Boolean']['input'];
  /** Access point device model (MW08 or A1). */
  apModel: DeviceModel;
  /** HA firewall hardware variant. Only meaningful when isHA is true; defaults to F3 (shared chassis). */
  haFirewallVariant?: InputMaybe<TopologyDesignFirewallVariant>;
  /** IDF configurations. */
  idfs: Array<GenerateTopologyDesignIdfInput>;
  /** Whether to generate the G1 cellular gateway (OOB management on the firewall's dedicated OOB port). Defaults to true: every Gen-1 deployment carries a G1. */
  includeCellularGateway?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this is a high-availability design */
  isHA: Scalars['Boolean']['input'];
  /** MDF configuration. */
  mdf: GenerateTopologyDesignMdfInput;
  /** Human-readable name for the generated draft version. */
  name: Scalars['String']['input'];
  /** Optional notes for the generated draft version. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft topology design version to overwrite. When omitted, a new draft version is created. */
  topologyDesignVersionUUID?: InputMaybe<Scalars['UUID']['input']>;
};

export type GenerateTopologyDesignMdfInput = {
  /** Building where this MDF is located. Stamped onto every node generated for it. */
  building?: InputMaybe<Scalars['String']['input']>;
  /** Number of ports needed. Mutually exclusive with switchCounts. */
  endpointPortDemand?: InputMaybe<Scalars['Int']['input']>;
  /** Floor within the building where this MDF is located. Stamped onto every node generated for it. */
  floor?: InputMaybe<Scalars['String']['input']>;
  /** Number of indoor access points. */
  indoorAPCount: Scalars['Int']['input'];
  /** How the carrier terminates ISP circuit 1. Omit for no circuit. */
  isp1HandoffType?: InputMaybe<TopologyDesignIspHandoffType>;
  /** How the carrier terminates ISP circuit 2. Omit for no circuit. */
  isp2HandoffType?: InputMaybe<TopologyDesignIspHandoffType>;
  /** Label for the MDF. */
  label?: Scalars['String']['input'];
  /** Number of outdoor access points. */
  outdoorAPCount: Scalars['Int']['input'];
  /** Room where this MDF is located. Stamped onto every node generated for it. */
  room?: InputMaybe<Scalars['String']['input']>;
  /** Explicit switch counts. Mutually exclusive with endpointPortDemand. */
  switchCounts?: InputMaybe<GenerateTopologyDesignSwitchCountInput>;
};

/** Result of generating a topology design: the created or overwritten draft version. The build steps that produced it are on the version itself (version.buildSteps). */
export type GenerateTopologyDesignResult = {
  __typename?: 'GenerateTopologyDesignResult';
  /** The created or overwritten draft version. Its buildSteps field carries the generation steps. */
  version: TopologyDesignVersion;
};

export type GenerateTopologyDesignSwitchCountInput = {
  /** Number of 12-port SFP (S3) switches. Fiber-fed; cannot host access points or PDU management. */
  count12Port?: Scalars['Int']['input'];
  /** Number of 24-port switches. */
  count24Port: Scalars['Int']['input'];
  /** Number of 48-port switches. */
  count48Port: Scalars['Int']['input'];
};

/** Input for fetching a page of captive portal entries. */
export type GetCaptivePortalEntriesInput = {
  /** Filters to apply when fetching the page. */
  filters: Array<FilterInput>;
  /** Page location to load from. */
  page: PageInput;
};

export type GetCaptivePortalWithSignatureInput = {
  /** This field does not currently do anything; this is a placeholder for future use. */
  signature?: InputMaybe<Scalars['String']['input']>;
};

/** Additional options that can be used to customize the results of a query for company users. */
export type GetCompanyUserInput = {
  /** If true, include company users that have been deleted. */
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents the filters for retreiving an inbox. */
export type GetInboxInput = {
  /** Filters archived messages from the inbox */
  archivedFilter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters to apply when fetching the page. */
  filters: Array<FilterInput>;
  /** Page location to load from. */
  page: PageInput;
  /** Filters read messages from the inbox */
  readFilter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by order for the inbox. */
  sort?: InputMaybe<SortOrderInput>;
};

/** Input for fetching a page of lab reservations. */
export type GetLabReservationsInput = {
  /** Filters to apply when fetching the page. */
  filters?: InputMaybe<Array<FilterInput>>;
  /** Page location to load from. */
  page: PageInput;
  /** Sort order for the lab reservations. */
  sort?: InputMaybe<SortOrderInput>;
};

/** Get support cases input */
export type GetSupportCasesInput = {
  /** Company UUID to get support cases for, required for the API. */
  companyUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Filters to apply when fetching the page. */
  filters: Array<FilterInput>;
  /** Page location to load from. */
  page: PageInput;
  /** Sort by order for the support cases. */
  sort?: InputMaybe<SortOrderInput>;
};

/** Pagination and sort input for support provider listings. */
export type GetSupportProvidersInput = {
  /** Page location to load from. */
  page: PageInput;
  /** Sort by order. */
  sort?: InputMaybe<SortOrderInput>;
};

/** Input for fetching a page of switch MAC table entries. */
export type GetSwitchMacTablePageInput = {
  /** Filters to apply when fetching the page. */
  filters: Array<FilterInput>;
  /** Page location to load from. */
  page: PageInput;
  /** Sort order to apply when fetching the page. Defaults to MAC address ascending. */
  sort?: InputMaybe<SortOrderInput>;
};

/**
 * A global notification snooze suppresses alert notifications for the listed
 * alert types across all companies and networks for the given time window.
 */
export type GlobalNotificationSnooze = {
  __typename?: 'GlobalNotificationSnooze';
  /** The UUID of the snooze. */
  UUID: Scalars['UUID']['output'];
  /** The alert types suppressed by this snooze. */
  alertTypes: Array<AlertType>;
  /** The timestamp when the snooze was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The timestamp when the snooze was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The timestamp when the snooze ends. Null means the snooze never expires and stays active until deleted. */
  snoozeEnd?: Maybe<Scalars['DateTime']['output']>;
  /** The reason for the snooze. */
  snoozeReason: Scalars['String']['output'];
  /** The timestamp when the snooze begins. */
  snoozeStart: Scalars['DateTime']['output'];
  /** The timestamp when the snooze was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A hardware device represents a physical device. */
export type HardwareDevice = {
  /** The batch identifier of the hardware device, if any. */
  batch?: Maybe<Scalars['String']['output']>;
  /** Shows the most recent boot history of a device. */
  bootHistory: Array<BootInfo>;
  /** The active config override for this device, if any. */
  configOverride?: Maybe<DeviceConfigOverride>;
  /** The timestamp when the hardware device was first created. */
  createdAt: Scalars['DateTime']['output'];
  /** The model name of the hardware device. */
  deviceModel: DeviceModel;
  /** The type of the hardware device. */
  deviceType: DeviceType;
  /** If the device is no longer connected to the backend, this is the time at which it was last connected. */
  disconnectedFromBackendAt?: Maybe<Scalars['DateTime']['output']>;
  /** The hardware generation of the device. */
  hardwareGeneration: HardwareGeneration;
  /** Metadata for the model of this device. */
  hardwareModelProperties: HardwareModelProperties;
  /** Internal operator-only notes about this hardware device. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /**
   * True if the device has an active websocket connection to the backend. Note that this only works if the device has registered via the /v2/register endpoint (i.e., is a Config 2 device) - otherwise is always false.
   * @deprecated Use `isSpare` instead.
   */
  isActive: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is connected to the backend. */
  isConnectedToBackend: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /**
   * Indicates whether the hardware device is marked as a development (dev) device, moving it into the dev (staging) realm for testing purposes.
   * @deprecated Use `realm` instead. isDev is equivalent to realm == DEV.
   */
  isDev: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is in factory mode. */
  isFactoryMode: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is an RMA (Return Merchandise Authorization) replacement device. */
  isRMA: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device has been retired. */
  isRetired: Scalars['Boolean']['output'];
  /** A spare hardware device belongs to a network but is not assigned to a virtual device. Spares are typically kept on site as replacements and are not in service. */
  isSpare: Scalars['Boolean']['output'];
  /** The latest device config metadata (ie. the config without the actual JSON payload) for the device. */
  latestDeviceConfigMetadata?: Maybe<DeviceConfigMetadata>;
  /** The MAC address of the hardware device. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** The UUID of the network that the hardware device belongs to. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** The public key used to add the device to the jumphost's WireGuard interface. */
  publicKey?: Maybe<Scalars['String']['output']>;
  /** The realm that owns this hardware device. Used for cross-realm device management. */
  realm: HardwareDeviceRealm;
  /** The unique serial number of the hardware device. */
  serialNumber: Scalars['String']['output'];
  /** The network that the spare hardware device belongs to. Spare hardware devices that are not affiliated with a virtual device will have this field populated. */
  spareDeviceNetwork?: Maybe<Network>;
  /** IPv6 address on the jumphost subnet. Used to send requests to the device. */
  tunnelIPAddress?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the hardware device was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The uptime of the hardware device, retrieved from the time series database.
   * @deprecated Use `VirtualDevice.uptime` instead.
   */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** The virtual device associated with this hardware device, if any. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The UUID of the virtual device this hardware device is assigned to, if any. */
  virtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
};


/** A hardware device represents a physical device. */
export type HardwareDeviceBootHistoryArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

/** A pair of hardware devices that are physically attached. */
export type HardwareDevicePair = {
  __typename?: 'HardwareDevicePair';
  /** The unique identifier for the hardware pair. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the hardware device pair was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The type of devices in the pair. */
  deviceType: DeviceType;
  /** Hardware device on the left side of the box. */
  leftDevice: HardwareDevice;
  /** Hardware device on the right side of the box. */
  rightDevice: HardwareDevice;
};

/**
 * HardwareDeviceRealm indicates which backend realm owns a hardware device.
 * Prod is the authoritative ledger; other realms must claim devices from prod.
 */
export enum HardwareDeviceRealm {
  /** Development/staging realm */
  Dev = 'DEV',
  /** EU realm */
  Eu = 'EU',
  /** Production realm - the authoritative ledger for all hardware devices */
  Prod = 'PROD'
}

/** Filters the response when fetching multiple hardware devices. */
export type HardwareDevicesFilter = {
  /** Filter hardware devices by device model. */
  deviceModel?: InputMaybe<DeviceModel>;
  /** Filter hardware devices by device type. */
  deviceType?: InputMaybe<DeviceType>;
  /** The maximum number of hardware devices to return. Default is 200. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The offset from where to start returning hardware devices. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Filter criteria for devices in a network. */
export type HardwareDevicesForNetworkFilter = {
  /** Filter devices by virtual device type. */
  deviceType?: InputMaybe<DeviceType>;
};

/** HardwareGeneration classifies hardware devices by their design generation. */
export enum HardwareGeneration {
  /** Original generation Meter hardware (eg MC, MW, MS, MP, PSGS, etc) */
  Gen0 = 'GEN0',
  /** First generation Meter hardware (eg A1, S1, F1, P1, G1, etc) */
  Gen1 = 'GEN1'
}

/** HardwareModelLifecycle describes a model's visibility and support status. */
export enum HardwareModelLifecycle {
  /** Shipping to customers and supported. */
  Active = 'ACTIVE',
  /** No longer deployed. */
  Discontinued = 'DISCONTINUED',
  /**
   * Operator-only prototype or pre-release model. The server omits entries with
   * this lifecycle from responses to viewers that lack
   * PERM_HARDWARE___MODEL___PROPERTIES_READ_LIMITED.
   */
  InDevelopment = 'IN_DEVELOPMENT',
  /** Still shipping but being wound down; prefer newer models for new deployments. */
  PhasingOut = 'PHASING_OUT'
}

/** Metadata about a hardware model. */
export type HardwareModelProperties = {
  __typename?: 'HardwareModelProperties';
  /** Whether this switch is a dedicated ISP switch model. */
  IsISPSwitchModel: Scalars['Boolean']['output'];
  /** The device type this model belongs to. */
  deviceType: DeviceType;
  /**
   * The hardware generation of this model. Null for models that pre-date GEN0 or
   * whose generation is otherwise undefined.
   */
  generation?: Maybe<HardwareGeneration>;
  /** True if this model is deployed as a high-availability pair. */
  isPairedDevice: Scalars['Boolean']['output'];
  /** Lifecycle status for this model. */
  lifecycle: HardwareModelLifecycle;
  /** The device model this entry describes. Unique across the catalog. */
  model: DeviceModel;
  /**
   * Whether this access-point model has Wi-Fi radios on the 6GHz band. Null for
   * non-Wi-Fi hardware (switches, controllers, PDUs, gateways, and cellular
   * access points) where 6GHz Wi-Fi support is not a meaningful attribute.
   */
  supportsBand6GHz?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents the range of NOS firmware versions that are compatible with a specific hardware device model. */
export type HardwareNosVersionRange = {
  __typename?: 'HardwareNosVersionRange';
  /** Timestamp when the hardware NOS version range was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The maximum major version of NOS firmware for this range. If null, there is no upper major version limit. */
  maxMajorVersion?: Maybe<Scalars['Int']['output']>;
  /** The maximum minor version of NOS firmware for this range. If null, there is no upper minor version limit. */
  maxMinorVersion?: Maybe<Scalars['Int']['output']>;
  /** The maximum patch version of NOS firmware for this range. If null, there is no upper patch version limit. */
  maxPatchVersion?: Maybe<Scalars['Int']['output']>;
  /** The minimum major version of NOS firmware for this range. */
  minMajorVersion: Scalars['Int']['output'];
  /** The minimum minor version of NOS firmware for this range. */
  minMinorVersion: Scalars['Int']['output'];
  /** The minimum patch version of NOS firmware for this range. */
  minPatchVersion: Scalars['Int']['output'];
  /** Hardware model associated with this NOS version range. */
  model: DeviceModel;
  /** Timestamp when the hardware NOS version range was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input type for specifying a range of NOS firmware versions, including minimum and optional maximum major, minor, and patch versions. */
export type HardwareNosVersionRangeInput = {
  /** The maximum major version of NOS firmware for this range. If null, there is no upper major version limit. */
  maxMajorVersion?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum minor version of NOS firmware for this range. If null, there is no upper minor version limit. */
  maxMinorVersion?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum patch version of NOS firmware for this range. If null, there is no upper patch version limit. */
  maxPatchVersion?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum major version of NOS firmware for this range. */
  minMajorVersion: Scalars['Int']['input'];
  /** The minimum minor version of NOS firmware for this range. */
  minMinorVersion: Scalars['Int']['input'];
  /** The minimum patch version of NOS firmware for this range. */
  minPatchVersion: Scalars['Int']['input'];
};

/** A hardware port profile defines port-level VLAN assignments that can be applied to a hardware device. */
export type HardwarePortProfile = {
  /** The unique identifier of the port profile. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the port profile was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A human readable description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The hardware model this port profile is for. */
  deviceModel: DeviceModel;
  /** The name of the port profile. */
  name: Scalars['String']['output'];
  /** The unique identifier of the network to which this port profile belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** The timestamp when the port profile was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Specifies the role of the high availability firewall. */
export enum HighAvailabilityControllerRole {
  /** The firewall is configured as backup. */
  Backup = 'BACKUP',
  /** The firewall is configured as primary. */
  Primary = 'PRIMARY'
}

/** Information about a virtual device in a high availability firewall setup. */
export type HighAvailabilityControllerVirtualDeviceInfo = {
  __typename?: 'HighAvailabilityControllerVirtualDeviceInfo';
  /** Configuration associated with the HA configuration of this virtual device. */
  config: HighAvailabilityControllersConfig;
  /**
   * The role this device is configured to serve as.
   * This does not indicate whether the device is currently serving traffic.
   */
  role: HighAvailabilityControllerRole;
  /** The status of the HA device, reported by the device. */
  status: HighAvailabilityStatus;
};

/** Configuration of the high availability firewalls. */
export type HighAvailabilityControllersConfig = Identifiable & {
  __typename?: 'HighAvailabilityControllersConfig';
  /** Unique identifier of the high availability configuration. */
  UUID: Scalars['UUID']['output'];
  /** Interval at which the firewalls advertise to one another, in milliseconds. Must be at least 300ms. */
  advertisementIntervalMs: Scalars['Int']['output'];
  /**
   * Port the firewalls use to communicate over.
   * This is currently _required_ to be the same port on both firewalls.
   */
  advertisementPort: Scalars['Int']['output'];
  /** VLAN whose sole purpose is for the HA firewalls to communicate with each other. */
  advertisementVLAN: Vlan;
  /** PhyInterface for the firewall configured as backup in the HA setup. */
  backupPhyInterface: PhyInterface;
  /** The current status of the backup firewall in the HA pair. */
  backupStatus: HighAvailabilityStatus;
  /** The virtual device of the backup firewall in the HA setup. */
  backupVirtualDevice: ControllerVirtualDevice;
  /** Virtual device UUID of the backup firewall in the HA setup. */
  backupVirtualDeviceUUID: Scalars['UUID']['output'];
  /** Network that is configured with HA firewalls. */
  network: Network;
  /** Whether or not VRRP is configured for preemption between the firewalls in the HA pair. */
  preemption: Scalars['Boolean']['output'];
  /** PhyInterface for the firewall configured as primary in the HA setup. */
  primaryPhyInterface: PhyInterface;
  /** The current status of the primary firewall in the HA pair. */
  primaryStatus: HighAvailabilityStatus;
  /** The virtual device of the primary firewall in the HA setup. */
  primaryVirtualDevice: ControllerVirtualDevice;
  /** Virtual device UUID of the primary firewall in the HA setup. */
  primaryVirtualDeviceUUID: Scalars['UUID']['output'];
};

/** Properties for high availability failover events. */
export type HighAvailabilityFailoverProperties = {
  __typename?: 'HighAvailabilityFailoverProperties';
  /** The backup virtual device in the high availability pair. */
  backupVirtualDevice?: Maybe<VirtualDevice>;
  /** The primary virtual device in the high availability pair. */
  primaryVirtualDevice?: Maybe<VirtualDevice>;
  /**
   * The virtual device associated with the high availability failover event.
   * @deprecated Use `primaryVirtualDevice` and `backupVirtualDevice` instead.
   */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** Properties for high availability multiple active events. */
export type HighAvailabilityMultipleActiveProperties = {
  __typename?: 'HighAvailabilityMultipleActiveProperties';
  /** The backup virtual device in the high availability pair. */
  backupVirtualDevice?: Maybe<VirtualDevice>;
  /** The primary virtual device in the high availability pair. */
  primaryVirtualDevice?: Maybe<VirtualDevice>;
};

/** Properties for high availability recovery events. */
export type HighAvailabilityRecoveryProperties = {
  __typename?: 'HighAvailabilityRecoveryProperties';
  /** The backup virtual device in the high availability pair. */
  backupVirtualDevice?: Maybe<VirtualDevice>;
  /** The primary virtual device in the high availability pair. */
  primaryVirtualDevice?: Maybe<VirtualDevice>;
};

/** Possible status values for high availability firewalls. */
export enum HighAvailabilityStatus {
  /** The firewall is currently active and serving traffic. */
  Active = 'ACTIVE',
  /** The firewall is ready but not currently serving traffic. */
  Ready = 'READY',
  /** The status is unspecified. */
  Unspecified = 'UNSPECIFIED'
}

/** Properties for honeypot access point events. */
export type HoneypotAccessPointProperties = {
  __typename?: 'HoneypotAccessPointProperties';
  /** The honeypot access points detected. */
  honeypotAccessPoints: Array<HoneypotSsid>;
};

/** A honeypot broadcaster is the actual device that is observed broadcasting the SSID. */
export type HoneypotBroadcaster = {
  __typename?: 'HoneypotBroadcaster';
  /** The BSSID of the honeypot. */
  bssid: Scalars['MacAddress']['output'];
  /** The devices that were able to observe the honeypot. */
  observers: Array<NetworkThreatObserver>;
};

/** A honeypot is an SSID that is being broadcasted which matches the name of a known SSID. */
export type HoneypotSsid = {
  __typename?: 'HoneypotSSID';
  /** The devices that are broadcasting the SSID. */
  broadcasters: Array<HoneypotBroadcaster>;
  /** Conflicting Meter SSID */
  conflictingMeterSSID?: Maybe<Ssid>;
  /** The network that the honeypot was observed on. */
  network: Network;
  /** The unique identifier of the network that the honeypot was observed on. */
  networkUUID: Scalars['UUID']['output'];
  /** The SSID of the honeypot. */
  ssid: Scalars['String']['output'];
};

/** Represents the response containing metadata and host monitoring values. */
export type HostMonitoringResponse = MetricsResponse & {
  __typename?: 'HostMonitoringResponse';
  /** Metadata about the metrics, such as aggregation intervals. */
  metadata: MetricsMetadata;
  /** A list of host monitoring data points. */
  values: Array<HostMonitoringValue>;
};

/** Represents the status of host monitoring. */
export enum HostMonitoringStatus {
  /** The host monitoring failed. */
  Failed = 'FAILED',
  /** The host is reachable and responding. */
  Ok = 'OK',
  /** The host monitoring request timed out. */
  Timeout = 'TIMEOUT'
}

/** Host monitoring targets are used to specify hosts for which to monitor availability/reachability on a network. */
export type HostMonitoringTarget = Identifiable & {
  __typename?: 'HostMonitoringTarget';
  /** The unique identifier of the host monitoring target. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the host monitoring target was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A descriptive text about the host monitoring target. */
  description?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the host monitoring target is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Whether this target is used to compute whether a WAN should failover. Only available if `type` is `PING`. */
  isUsedForWANFailover: Scalars['Boolean']['output'];
  /** The UUID of the network to which this host monitoring target belongs. */
  networkUUID: Scalars['UUID']['output'];
  /**
   * The target host to monitor.
   *
   * Currently, only IPv4 addresses are permitted, but FQDNs (Fully Qualified Domain Names) will be supported in the future.
   */
  targetHost: Scalars['IPV4']['output'];
  /** The type of monitoring to perform on the target host. */
  type: HostMonitoringType;
  /** The timestamp when the host monitoring target was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Defines the types of host monitoring available. */
export enum HostMonitoringType {
  /** Perform ICMP ping monitoring. */
  Ping = 'PING',
  /** Perform traceroute monitoring. */
  Traceroute = 'TRACEROUTE'
}

/** Represents a single host monitoring data point. */
export type HostMonitoringValue = MetricsValue & {
  __typename?: 'HostMonitoringValue';
  /** Count of entries where status was FAILED. */
  countFailed: Scalars['Int']['output'];
  /** Count of entries where status was OK. */
  countOk: Scalars['Int']['output'];
  /** Count of entries where status was TIMEOUT. */
  countTimeout: Scalars['Int']['output'];
  /** The IP address of the monitored host. */
  hostIPAddr: Scalars['String']['output'];
  /**
   * The source Ethernet port number used for the monitoring.
   * @deprecated Use `srcPhyInterface` instead.
   */
  srcEthPortNum: Scalars['Int']['output'];
  /** The source physical interface port used for the monitoring. */
  srcPhyInterface: PhyInterface;
  /**
   * The status of the host monitoring.
   * @deprecated Use `statusValue` instead.
   */
  status: HostMonitoringStatus;
  /** Average value of quality where OK is 1.0 and everything else is 0.0. */
  statusValue: Scalars['Float']['output'];
  /** The time at which the measurement was taken. */
  timestamp: Scalars['DateTime']['output'];
  /** The average round-trip time (RTT) to the host in nanoseconds. */
  value: Scalars['Float']['output'];
  /** The virtual device where the measurement was taken. */
  virtualDevice: VirtualDevice;
  /** The UUID of the virtual device where the measurement was taken. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** The access network type as defined in Table 9-214 of 802.11-2016 IEEE Standard. */
export type Hs20AccessNetworkTypes = {
  __typename?: 'Hs20AccessNetworkTypes';
  /** Description of the access network type. */
  description: Scalars['String']['output'];
  /** Access network type as defined in Table 9-214 of 802.11-2016 IEEE Standard. */
  type: Scalars['Int']['output'];
};

/** The auth parameter for Hs20 */
export type Hs20AuthParam = {
  __typename?: 'Hs20AuthParam';
  /** Description of the authentication parameter. */
  description: Scalars['String']['output'];
  /** Authentication parameter. */
  param: Scalars['Int']['output'];
  /** Valid authentication values for this parameter. */
  validValues: Array<Hs20AuthValue>;
};

/** Hs20AuthValue and Hs20AuthParam are the authentication parameters and values as defined in Table 9-335 of 802.11-2020 IEEE Standard. */
export type Hs20AuthValue = {
  __typename?: 'Hs20AuthValue';
  /** Description of the authentication value. */
  description: Scalars['String']['output'];
  /** Authentication value. */
  value: Scalars['Int']['output'];
};

/** The EAP method as defined by IANA (http://www.iana.org/assignments/eap-numbers/eap-numbers.xhtml#eap-numbers-4). */
export type Hs20EapMethod = {
  __typename?: 'Hs20EapMethod';
  /** Description of the EAP method. */
  description: Scalars['String']['output'];
  /** An EAP method, as defined by IANA (http://www.iana.org/assignments/eap-numbers/eap-numbers.xhtml#eap-numbers-4) */
  method: Scalars['Int']['output'];
  /** Indicates if the method is commonly used. */
  mostUsed: Scalars['Boolean']['output'];
};

/** Response type containing valid Hotspot 2.0 venue types. */
export type Hs20ValidTypesResponse = {
  __typename?: 'Hs20ValidTypesResponse';
  /** List of valid Hotspot 2.0 access network types. */
  accessNetworkTypes: Array<Hs20AccessNetworkTypes>;
  /** List of valid authentication parameters. */
  authParams: Array<Hs20AuthParam>;
  /** List of valid EAP methods. */
  eapMethods: Array<Hs20EapMethod>;
  /** List of valid Hotspot 2.0 venue types. */
  venueTypes: Array<Hs20VenueTypes>;
};

/** Venue types as defined in Table 9-62 of 802.11-2016 IEEE Standard. */
export type Hs20VenueTypes = {
  __typename?: 'Hs20VenueTypes';
  /** Description of the venue. */
  description: Scalars['String']['output'];
  /** Venue group as defined in Table 9-62 of 802.11-2016 IEEE Standard. */
  group: Scalars['Int']['output'];
  /** Venue type as defined in Table 9-62 of 802.11-2016 IEEE Standard. */
  type: Scalars['Int']['output'];
};

/** Input for ICMP probe parameters. */
export type IcmpProbeParamsInput = {
  /** Target IP address or hostname. */
  address: Scalars['String']['input'];
  /** ICMP payload length in bytes. */
  payloadLen?: InputMaybe<Scalars['Int']['input']>;
};

/** An intrusion detection event observed on the network. Field semantics follow the Suricata EVE JSON format: https://docs.suricata.io/en/latest/output/eve/eve-json-format.html */
export type IdsEvent = {
  __typename?: 'IDSEvent';
  /** Alert for the event. */
  alert?: Maybe<IdsEventAlert>;
  /** The application layer protocol detected for this event, if any. */
  appProto?: Maybe<Scalars['String']['output']>;
  /** Direction for this event. */
  direction: IdsEventDirection;
  /** The destination IP of this event. */
  dstIP?: Maybe<Scalars['IP']['output']>;
  /** The destination location of this event, derived from dstIP. */
  dstLocation?: Maybe<IdsEventLocation>;
  /** The destination MAC address of this event. */
  dstMAC?: Maybe<Scalars['MacAddress']['output']>;
  /** The destination port of this event. */
  dstPort: Scalars['Int']['output'];
  /**
   * The log type.
   * @deprecated No longer used.
   */
  eventType: Scalars['String']['output'];
  /** Will be defined if a firewall rule exists for this event. */
  firewallRule?: Maybe<FirewallRule>;
  /** Flow info for the event. */
  flow?: Maybe<IdsEventFlowInfo>;
  /** Correlates the network protocol, flow logs EVE data and any evidence that Suricata has logged to an alert event and that alert's metadata, as well as to fileinfo/file transaction and anomaly logs, if available. */
  flowID: Scalars['Int']['output'];
  /** HTTP info for the event. */
  httpInfo?: Maybe<IdsEventHttpInfo>;
  /** IPS rule, only populated if IPS is enabled. */
  ipsRule?: Maybe<IdsEventIpsRule>;
  /** When this event was observed. */
  observedAt: Scalars['DateTime']['output'];
  /** Network protocol for this event. */
  protocol: IdsEventProtocol;
  /** The source IP of this event. */
  srcIP?: Maybe<Scalars['IP']['output']>;
  /** The source location of this event, derived from srcIP. */
  srcLocation?: Maybe<IdsEventLocation>;
  /** The source MAC address of this event. */
  srcMAC?: Maybe<Scalars['MacAddress']['output']>;
  /** The source port of this event. */
  srcPort: Scalars['Int']['output'];
  /** Timestamp of this event. If not reported by the device, defaults to the time the event was observed. */
  timestamp: Scalars['DateTime']['output'];
  /** TLS info for the event. */
  tlsInfo?: Maybe<IdsEventTlsInfo>;
  /** The log type. */
  type: IdsEventType;
  /** Virtual device that observed this event. */
  virtualDevice: VirtualDevice;
};

/** Alert details for an IDS event. See https://docs.suricata.io/en/latest/output/eve/eve-json-format.html#event-type-alert */
export type IdsEventAlert = {
  __typename?: 'IDSEventAlert';
  /** Action for the alert. */
  action: IdsEventAlertAction;
  /** Category of the alert. */
  category: Scalars['String']['output'];
  /** Group ID of the alert. */
  gid: Scalars['Int']['output'];
  /** The rule that triggered this event. */
  idsRule?: Maybe<IdsRule>;
  /** Revision of the alert. */
  rev: Scalars['Int']['output'];
  /**
   * Rule of the alert.
   * @deprecated Use `idsRule` instead.
   */
  rule?: Maybe<Scalars['String']['output']>;
  /** The severity of the alert. */
  severity: Scalars['Int']['output'];
  /** Signature ID of the alert. */
  sid: Scalars['Int']['output'];
  /** The signature of the alert. */
  signature: Scalars['String']['output'];
};

export enum IdsEventAlertAction {
  /** Action is allowed. */
  Allowed = 'ALLOWED',
  /** Action is blocked. */
  Blocked = 'BLOCKED',
  /** Action is unknown. */
  Unspecified = 'UNSPECIFIED'
}

export enum IdsEventDirection {
  /** Direction is to client. */
  ToClient = 'TO_CLIENT',
  /** Direction is to server. */
  ToServer = 'TO_SERVER',
  /** Direction is unknown. */
  Unspecified = 'UNSPECIFIED'
}

export type IdsEventFilterInput = {
  /** Find events by signature ID. */
  SID?: InputMaybe<Scalars['Int']['input']>;
  /** Find events based on action. */
  action?: InputMaybe<IdsEventAlertAction>;
  /** Find events based on application layer protocol. */
  appProtocol?: InputMaybe<Scalars['String']['input']>;
  /** Find events by rule class type shortname. */
  classType?: InputMaybe<Scalars['String']['input']>;
  /** Find events based on direction. */
  direction?: InputMaybe<IdsEventDirection>;
  /** Find events based on destination IP. */
  dstIP?: InputMaybe<Scalars['IP']['input']>;
  /** Find events based on destination MAC address. */
  dstMAC?: InputMaybe<Scalars['MacAddress']['input']>;
  /** Find events based on destination port. */
  dstPort?: InputMaybe<PortRangeInput>;
  /** Find events based on protocol. */
  protocol?: InputMaybe<IdsEventProtocol>;
  /** Input for non-exact search against rule fields. */
  search?: InputMaybe<IdsEventFilterSearchInput>;
  /** Find events based on source IP. */
  srcIP?: InputMaybe<Scalars['IP']['input']>;
  /** Find events based on source MAC address. */
  srcMAC?: InputMaybe<Scalars['MacAddress']['input']>;
  /** Find events based on source port. */
  srcPort?: InputMaybe<PortRangeInput>;
};

export type IdsEventFilterSearchInput = {
  /** Match events whose rule description contains this substring. */
  description?: InputMaybe<Scalars['String']['input']>;
};

/** Flow details for an IDS event. See https://docs.suricata.io/en/latest/output/eve/eve-json-format.html#event-type-flow */
export type IdsEventFlowInfo = {
  __typename?: 'IDSEventFlowInfo';
  /** Total bytes count to client. */
  bytesToClient: Scalars['Int']['output'];
  /** Total bytes count to server. */
  bytesToServer: Scalars['Int']['output'];
  /** Time the flow ended (last seen packet). */
  end?: Maybe<Scalars['DateTime']['output']>;
  /** Total number of packets to client. */
  packetsToClient: Scalars['Int']['output'];
  /** Total number of packets to server, including bypassed packets. */
  packetsToServer: Scalars['Int']['output'];
  /** Mechanism that triggered the end of the flow; one of "timeout", "forced" or "shutdown". */
  reason?: Maybe<Scalars['String']['output']>;
  /** Time the flow started. */
  start?: Maybe<Scalars['DateTime']['output']>;
};

/** HTTP details for an IDS event. See https://docs.suricata.io/en/latest/output/eve/eve-json-format.html#event-type-http */
export type IdsEventHttpInfo = {
  __typename?: 'IDSEventHTTPInfo';
  /** The type of data returned (ex: application/x-gzip). */
  contentType: Scalars['String']['output'];
  /** The hostname this HTTP event is attributed to. */
  hostname: Scalars['String']['output'];
  /** The content size of the HTTP body. */
  length: Scalars['Int']['output'];
  /** Protocol / Version of HTTP (ex: HTTP/1.1). */
  protocol: Scalars['String']['output'];
  /** HTTP status code. */
  status: Scalars['Int']['output'];
  /** URL at the hostname that was accessed. */
  url: Scalars['String']['output'];
  /** The user-agent of the software that was used. */
  userAgent: Scalars['String']['output'];
};

/** Details a firewall rule created by IPS. */
export type IdsEventIpsRule = {
  __typename?: 'IDSEventIPSRule';
  /** Unique identifier for the IPS rule. */
  UUID: Scalars['UUID']['output'];
  /** Destination port range to match traffic to. */
  dstPortRange: PortRange;
  /** Destination IP prefix to match traffic to. */
  dstPrefix: Scalars['IPPrefix']['output'];
  /** How long the rule stays valid, in seconds. 0 means the rule never expires. */
  durationSec: Scalars['Int']['output'];
  /** Uplink phy interface bound to this rule. */
  phyInterfaceBindings?: Maybe<Array<PhyInterface>>;
  /** IP protocols to match. */
  protocol: IdsEventProtocol;
  /** Source port range to match traffic from. */
  srcPortRange: PortRange;
  /** Source IP prefix to match traffic from. */
  srcPrefix: Scalars['IPPrefix']['output'];
  /** VLANs bound to this rule. */
  vlanBindings?: Maybe<Array<Vlan>>;
};

/** Location of an IDS event, derived from an IP address lookup. */
export type IdsEventLocation = {
  __typename?: 'IDSEventLocation';
  /** ISO-3166 alpha-2 country code. */
  countryCode: Scalars['String']['output'];
  /** Latitude of the location. */
  latitude: Scalars['Float']['output'];
  /** Longitude of the location. */
  longitude: Scalars['Float']['output'];
};

export enum IdsEventProtocol {
  /** Protocol is AH. */
  Ah = 'AH',
  /** Protocol is ANY. */
  Any = 'ANY',
  /** Protocol is ESP. */
  Esp = 'ESP',
  /** Protocol is ICMP. */
  Icmp = 'ICMP',
  /** Protocol is TCP. */
  Tcp = 'TCP',
  /** Protocol is UDP. */
  Udp = 'UDP',
  /** Protocol is unknown. */
  Unspecified = 'UNSPECIFIED'
}

/** TLS details for an IDS event. See https://docs.suricata.io/en/latest/output/eve/eve-json-format.html#event-type-tls */
export type IdsEventTlsInfo = {
  __typename?: 'IDSEventTLSInfo';
  /** The JA3 hash. */
  ja3Hash: Scalars['String']['output'];
  /** The JA3S hash. */
  ja3sHash: Scalars['String']['output'];
  /** The Server Name Indication (SNI) extension sent by the client. */
  sni: Scalars['String']['output'];
};

export enum IdsEventType {
  /** Detect */
  Detect = 'DETECT',
  /** Inline IPS. */
  IbProtect = 'IB_PROTECT',
  /** Out-of-band firewall rule. */
  OobProtect = 'OOB_PROTECT',
  /** Unknown */
  Unspecified = 'UNSPECIFIED'
}

/** A paged response for IDS event queries. */
export type IdsEventsPage = {
  __typename?: 'IDSEventsPage';
  /** A subset of records based on the limit and offset fields. */
  events?: Maybe<Array<IdsEvent>>;
  /** The total number of records. */
  total: Scalars['Int']['output'];
};

/** A category for IDS/IPS rules. */
export type IdsipsCategory = {
  __typename?: 'IDSIPSCategory';
  /** Unique identifier for this category. */
  UUID: Scalars['UUID']['output'];
  /** When this category was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The priority of this category. */
  priority: Scalars['Int']['output'];
  /** The number of rules associated with this category. */
  ruleCount: Scalars['Int']['output'];
  /** A short description of this category. */
  shortDescription: Scalars['String']['output'];
  /** The unique shortname code for this category. */
  shortname: Scalars['String']['output'];
  /** When this category was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Holds the IDS/IPS config for a network. */
export type IdsipsConfig = Identifiable & {
  __typename?: 'IDSIPSConfig';
  /** Unique identifier for this configuration. */
  UUID: Scalars['UUID']['output'];
  /** The configured categories for this config. */
  boundCategories: Array<IdsipsConfigCategoryBinding>;
  /** The explicitly configured rules for this config. */
  boundIDSRules: Array<IdsipsConfigRuleBinding>;
  /** When this configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The custom rules for this config. */
  customRules?: Maybe<Array<IdsipsCustomRule>>;
  /** The VLANs this is enabled for. */
  enabledVLANs: Array<Vlan>;
  /** How long rules generated by IPS stay valid. */
  ipsRuleDuration?: Maybe<Scalars['Duration']['output']>;
  /** If east-west protection is enabled. */
  isEastWestProtectionEnabled: Scalars['Boolean']['output'];
  /** The IPS minimum severity to act on. */
  minIPSSeverity?: Maybe<Scalars['Int']['output']>;
  /** The IDS minimum severity to act on. */
  minSeverity: Scalars['Int']['output'];
  /** The mode IDS/IPS should act in. */
  mode: IdsipsMode;
  /** The UUID of the network for this configuration. */
  networkUUID: Scalars['UUID']['output'];
  /** List of subnets that should never be blocked. */
  safelist?: Maybe<Array<Scalars['IPPrefix']['output']>>;
  /** The rule list source version. */
  sourceVersion: Scalars['Int']['output'];
  /** The categories suppressed for this config; matching traffic is not acted on. */
  suppressedCategories: Array<IdsipsConfigCategorySuppression>;
  /** The rules suppressed for this config; matching traffic is not acted on. */
  suppressedRules: Array<IdsipsConfigRuleSuppression>;
};

/** A binding between an IDS/IPS configuration and a category of rules it applies. */
export type IdsipsConfigCategoryBinding = {
  __typename?: 'IDSIPSConfigCategoryBinding';
  /** The bound IDS/IPS category. */
  category: IdsipsCategory;
  /** Unique identifier for the bound IDS/IPS category. */
  categoryUUID: Scalars['UUID']['output'];
  /** The bound IDS/IPS configuration. */
  config: IdsipsConfig;
  /** Unique identifier for the bound IDS/IPS configuration. */
  configUUID: Scalars['UUID']['output'];
  /** When this binding was created. Will be null if the binding is an implicit default. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The mode of this binding, whether it applies to IDS or IPS. */
  mode: IdsipsMode;
  /** When this binding was last updated. Will be null if the binding is an implicit default. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdsipsConfigCategoryBindingInput = {
  /** Unique identifier of the IDS/IPS category. */
  categoryUUID: Scalars['UUID']['input'];
  /** The mode of this binding, whether it applies to IDS or IPS. */
  mode: IdsipsMode;
};

/** A suppressed category for an IDS/IPS config. */
export type IdsipsConfigCategorySuppression = {
  __typename?: 'IDSIPSConfigCategorySuppression';
  /** Unique identifier of the IDS/IPS config suppressed category. */
  UUID: Scalars['UUID']['output'];
  /** The IDS category. */
  category: IdsipsCategory;
  /** Unique identifier of the category. */
  categoryUUID: Scalars['UUID']['output'];
  /** Unique identifier of the IDS/IPS configuration. */
  configUUID: Scalars['UUID']['output'];
  /** An optional informational description for the suppression. */
  description?: Maybe<Scalars['String']['output']>;
  /** The traffic direction to consider when determining IP prefix application. Required if `ipPrefixes` is set. */
  direction?: Maybe<IdsipsSuppressedRuleDirection>;
  /** The IP prefixes that this suppression should apply to. If set, `direction` is required. */
  ipPrefixes?: Maybe<Array<Scalars['IPPrefix']['output']>>;
  /** The mode of this suppression, whether it applies to IDS or IPS. */
  mode: IdsipsMode;
};

export type IdsipsConfigCategorySuppressionInput = {
  /** Unique identifier of the IDS category. */
  categoryUUID: Scalars['UUID']['input'];
  /** An optional informational description for the suppression. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The traffic direction to consider when determining IP prefix application. Required if `ipPrefixes` is set. */
  direction?: InputMaybe<IdsipsSuppressedRuleDirection>;
  /** The IP prefixes that this suppression should apply to. If set, `direction` is required. */
  ipPrefixes?: InputMaybe<Array<Scalars['IPPrefix']['input']>>;
  /** The mode of this suppression, whether it applies to IDS or IPS. */
  mode: IdsipsMode;
};

/** A configured IDS rule for an IDS/IPS config. */
export type IdsipsConfigRuleBinding = {
  __typename?: 'IDSIPSConfigRuleBinding';
  /** Unique identifier of the IDS/IPS configuration. */
  configUUID: Scalars['UUID']['output'];
  /** The mode of this binding, whether it applies to IDS or IPS. */
  mode: IdsipsMode;
  /** The IDS rule. */
  rule: IdsRule;
  /** Unique signature ID of the IDS rule. */
  ruleSID: Scalars['Int']['output'];
};

export type IdsipsConfigRuleBindingInput = {
  /** The mode of this binding, whether it applies to IDS or IPS. */
  mode: IdsipsMode;
  /** Unique signature ID of the IDS rule. */
  ruleSID: Scalars['Int']['input'];
};

/** A suppressed IDS rule for an IDS/IPS config. */
export type IdsipsConfigRuleSuppression = {
  __typename?: 'IDSIPSConfigRuleSuppression';
  /** Unique identifier of the IDS/IPS config suppressed rule. */
  UUID: Scalars['UUID']['output'];
  /** Unique identifier of the IDS/IPS configuration. */
  configUUID: Scalars['UUID']['output'];
  /** An optional informational description for the suppression. */
  description?: Maybe<Scalars['String']['output']>;
  /** The traffic direction to consider when determining IP prefix application. Required if `ipPrefixes` is set. */
  direction?: Maybe<IdsipsSuppressedRuleDirection>;
  /** The IP prefixes that this suppression should apply to. If set, `direction` is required. */
  ipPrefixes?: Maybe<Array<Scalars['IPPrefix']['output']>>;
  /** The mode of this suppression, whether it applies to IDS or IPS. */
  mode: IdsipsMode;
  /** The IDS rule. */
  rule: IdsRule;
  /** Unique signature ID of the IDS rule. */
  ruleSID: Scalars['Int']['output'];
};

export type IdsipsConfigRuleSuppressionInput = {
  /** An optional informational description for the suppression. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The traffic direction to consider when determining IP prefix application. Required if `ipPrefixes` is set. */
  direction?: InputMaybe<IdsipsSuppressedRuleDirection>;
  /** The IP prefixes that this suppression should apply to. If set, `direction` is required. */
  ipPrefixes?: InputMaybe<Array<Scalars['IPPrefix']['input']>>;
  /** The mode of this suppression, whether it applies to IDS or IPS. */
  mode: IdsipsMode;
  /** Unique signature ID of the IDS rule. */
  ruleSID: Scalars['Int']['input'];
};

/** A custom intrusion rule definition for IDS/IPS. These currently apply tls.sni rules. */
export type IdsipsCustomRule = Identifiable & {
  __typename?: 'IDSIPSCustomRule';
  /** Unique identifier. */
  UUID: Scalars['UUID']['output'];
  /** The action this rule applies. */
  action: FirewallRuleAction;
  /** The application this rule applies to. */
  application?: Maybe<ApplicationDnsFirewallRuleApplication>;
  /** List of VLAN bindings for the rule. */
  boundVLANs?: Maybe<Array<Vlan>>;
  /** Unique identifier of the IDS/IPS configuration. */
  configUUID: Scalars['UUID']['output'];
  /** When this rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** When this rule was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The FQDN this rule applies to. */
  domain?: Maybe<Scalars['String']['output']>;
  /** If this rule is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** A name to identify this rule. */
  name: Scalars['String']['output'];
  /** When this rule was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export enum IdsipsMode {
  /** Intrusion Detection System mode */
  Ids = 'IDS',
  /** Intrusion Prevention System mode */
  Ips = 'IPS'
}

/** Identical to `IDSIPSMode`, separate for technical reasons. */
export enum IdsipsModeFilterInput {
  /** Intrusion Detection System mode */
  Ids = 'IDS',
  /** Intrusion Prevention System mode */
  Ips = 'IPS'
}

export enum IdsipsSuppressedRuleDirection {
  /** Destination */
  Destination = 'DESTINATION',
  /** Either */
  Either = 'EITHER',
  /** Source */
  Source = 'SOURCE'
}

/** A single available intrusion rule definition for IDS/IPS. */
export type IdsRule = {
  __typename?: 'IDSRule';
  /** The unique signature ID for this rule. */
  SID: Scalars['Int']['output'];
  /** Unique identifier for this rule. */
  UUID: Scalars['UUID']['output'];
  /** The action for this rule. */
  action: Scalars['String']['output'];
  /** The associated category for this rule, if present. */
  category?: Maybe<IdsipsCategory>;
  /** The category class type (shortname) for this rule. */
  classType: Scalars['String']['output'];
  /** When this rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The description for this rule. */
  description?: Maybe<Scalars['String']['output']>;
  /** The group ID for this rule. */
  groupID?: Maybe<Scalars['Int']['output']>;
  /** The header for this rule. */
  header: Scalars['String']['output'];
  /** The list of metadata entries for this rule. */
  metadata: Array<Scalars['String']['output']>;
  /** The list of references for this rule. */
  references: Array<IdsRuleReference>;
  /** The revision version for this rule. */
  revision: Scalars['Int']['output'];
  /** When this rule was updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Filter IDS rules based on bindings on a given config. */
export type IdsRuleBindingFilterInput = {
  /** The mode of the bindings to filter for rules on. */
  modes?: InputMaybe<Array<InputMaybe<IdsipsModeFilterInput>>>;
};

export type IdsRuleFilterConfigInput = {
  /** Filter IDS rules based on bindings in the given config. */
  boundIDSRules?: InputMaybe<IdsRuleBindingFilterInput>;
  /** The IDS/IPS config's unique identifier to filter for rules on. */
  idsIPSConfigUUID: Scalars['UUID']['input'];
  /** Filter IDS rules based on suppressions in the given config. */
  suppressedRules?: InputMaybe<IdsRuleSuppressionFilterInput>;
};

export type IdsRuleFilterInput = {
  /** Find rules by signature ID. */
  SID?: InputMaybe<Scalars['Int']['input']>;
  /** Find based on action for this rule. */
  action?: InputMaybe<Scalars['String']['input']>;
  /** Find rules by class type shortname. */
  classType?: InputMaybe<Scalars['String']['input']>;
  /** Input for rules that are associated with a given configuration. */
  config?: InputMaybe<IdsRuleFilterConfigInput>;
  /** Find rules by group ID. */
  groupID?: InputMaybe<Scalars['Int']['input']>;
  /** Find rules by revision. */
  revision?: InputMaybe<Scalars['Int']['input']>;
  /** Input for non-exact search against rule fields. */
  search?: InputMaybe<IdsRuleFilterSearchInput>;
};

/** Filter IDS rules based on substring search. */
export type IdsRuleFilterSearchInput = {
  /** Search based on description for this rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Search based on header for this rule. */
  header?: InputMaybe<Scalars['String']['input']>;
};

/** A page of IDS rule results. */
export type IdsRulePage = {
  __typename?: 'IDSRulePage';
  /** The results for this page. */
  items: Array<IdsRule>;
  /** The total number of results available based on the provided filters. */
  total: Scalars['Int']['output'];
};

/** A key/value reference entry for an IDS rule. */
export type IdsRuleReference = {
  __typename?: 'IDSRuleReference';
  /** The value of the reference. */
  ref: Scalars['String']['output'];
  /** The type of the reference. */
  type: Scalars['String']['output'];
};

/** Filter IDS rules based on suppressions on a given config. */
export type IdsRuleSuppressionFilterInput = {
  /** The mode of the suppression to filter for rules on. */
  modes?: InputMaybe<Array<InputMaybe<IdsipsModeFilterInput>>>;
};

/** An IEEEDeviceVendor represents a vendor registered with the IEEE, which includes the vendor's name and mailing address. */
export type IeeeDeviceVendor = {
  __typename?: 'IEEEDeviceVendor';
  /** The name of the vendor registered with the IEEE. */
  vendor: Scalars['String']['output'];
  /** The mailing address of the vendor registered with the IEEE. */
  vendorAddress: Scalars['String']['output'];
};

/** An IP forwarding rule forwards the given prefix through a specific WAN */
export type IpForwardingRule = Identifiable & {
  __typename?: 'IPForwardingRule';
  /** Unique identifier of the IP forwarding rule. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** If rule is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Name of this rule. */
  name: Scalars['String']['output'];
  /** The network that this rule applies to. */
  network: Network;
  /** UUID of the network that this rule applies to. */
  networkUUID: Scalars['UUID']['output'];
  /** Timestamp when rule was Updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The uplink interface associated with the rule. */
  uplinkPhyInterface: PhyInterface;
  /** The VLAN associated with this rule. */
  vlan: Vlan;
};

/** Supported IP protocols for firewall rules. */
export enum IpProtocol {
  /** All protocols. */
  All = 'ALL',
  /** Internet Control Message Protocol. */
  Icmp = 'ICMP',
  /** Transmission Control Protocol. */
  Tcp = 'TCP',
  /** User Datagram Protocol. */
  Udp = 'UDP'
}

/** A range of IP addresses. */
export type IpRange = {
  __typename?: 'IPRange';
  /** The upper address in the IP range. */
  end: Scalars['IP']['output'];
  /** The lower address in the IP range. */
  start: Scalars['IP']['output'];
};

/** A range of IP addresses. */
export type IpRangeInput = {
  /** The upper address in the IP range. */
  end: Scalars['IP']['input'];
  /** The lower address in the IP range. */
  start: Scalars['IP']['input'];
};

/** Enumeration of possible IPSec authentication algorithms. */
export enum IpSecAuthenticationAlgorithm {
  /** AES-CMAC-96 authentication algorithm. */
  Cmac_96 = 'CMAC_96',
  /** MD5 HMAC with 96-bit truncation. */
  Md5_96 = 'MD5_96',
  /** SHA-1 HMAC with 96-bit truncation. */
  Sha1_96 = 'SHA1_96',
  /** SHA-256 HMAC with 128-bit truncation. */
  Sha2_256_128 = 'SHA2_256_128',
  /** SHA-384 HMAC with 192-bit truncation. */
  Sha2_384_192 = 'SHA2_384_192',
  /** SHA-512 HMAC with 256-bit truncation. */
  Sha2_512_256 = 'SHA2_512_256',
  /** AES-XCBC-MAC-96 authentication algorithm. */
  Xcbc_96 = 'XCBC_96'
}

/** Enumeration of possible states for the CHILD Security Association. */
export enum IpSecChildSaStatus {
  /** The CHILD Security Association is created but not yet installed. */
  Created = 'CREATED',
  /** The CHILD Security Association has been deleted. */
  Deleted = 'DELETED',
  /** The CHILD Security Association is being deleted. */
  Deleting = 'DELETING',
  /** The CHILD Security Association is being destroyed. */
  Destroying = 'DESTROYING',
  /** The CHILD Security Association is installed and operational. */
  Installed = 'INSTALLED',
  /** The CHILD Security Association is being installed. */
  Installing = 'INSTALLING',
  /** The CHILD Security Association has been rekeyed. */
  Rekeyed = 'REKEYED',
  /** The CHILD Security Association is rekeying. */
  Rekeying = 'REKEYING',
  /** The CHILD Security Association is retrying after failure. */
  Retrying = 'RETRYING',
  /** The CHILD Security Association is routed. */
  Routed = 'ROUTED',
  /** Unspecified status. */
  Unspecified = 'UNSPECIFIED',
  /** The CHILD Security Association is updating its configuration. */
  Updating = 'UPDATING'
}

/**
 * Enumeration of possible close actions
 * https://wiki.strongswan.org/projects/strongswan/wiki/connsection
 */
export enum IpSecCloseAction {
  /** CLEAR */
  Clear = 'CLEAR',
  /** HOLD */
  Hold = 'HOLD',
  /** NONE. Disables . */
  None = 'NONE',
  /** RESTART */
  Restart = 'RESTART'
}

/** Enumeration of possible Diffie-Hellman groups for key exchange. */
export enum IpSecDhGroup {
  /** Diffie-Hellman group 2 (MODP 1024). */
  Dh2 = 'DH2',
  /** Diffie-Hellman group 14 (MODP 2048). */
  Dh14 = 'DH14',
  /** Diffie-Hellman group 19 (ECP 256). */
  Dh19 = 'DH19',
  /** Diffie-Hellman group 20 (ECP 384). */
  Dh20 = 'DH20',
  /** Diffie-Hellman group 21 (ECP 521). */
  Dh21 = 'DH21'
}

/**
 * Enumeration of possible DPD actions
 * https://wiki.strongswan.org/projects/strongswan/wiki/connsection
 */
export enum IpSecDpdAction {
  /** CLEAR */
  Clear = 'CLEAR',
  /** HOLD */
  Hold = 'HOLD',
  /** NONE. Disables . */
  None = 'NONE',
  /** RESTART */
  Restart = 'RESTART'
}

/** Enumeration of possible IPSec encryption algorithms. */
export enum IpSecEncryptionAlgorithm {
  /** AES in CBC mode with a 128-bit key. */
  AesCbc_128 = 'AES_CBC_128',
  /** AES in CBC mode with a 192-bit key. */
  AesCbc_192 = 'AES_CBC_192',
  /** AES in CBC mode with a 256-bit key. */
  AesCbc_256 = 'AES_CBC_256',
  /** AES in CTR mode with a 128-bit key. */
  AesCtr_128 = 'AES_CTR_128',
  /** AES in CTR mode with a 192-bit key. */
  AesCtr_192 = 'AES_CTR_192',
  /** AES in CTR mode with a 256-bit key. */
  AesCtr_256 = 'AES_CTR_256',
  /** AES in Galois/Counter Mode (GCM) with a 128-bit key and 16-byte ICV. */
  AesGcm_16128 = 'AES_GCM_16128',
  /** AES in Galois/Counter Mode (GCM) with a 192-bit key and 16-byte ICV. */
  AesGcm_16192 = 'AES_GCM_16192',
  /** AES in Galois/Counter Mode (GCM) with a 256-bit key and 16-byte ICV. */
  AesGcm_16256 = 'AES_GCM_16256',
  /** Triple DES encryption with a 112-bit effective key length. */
  Algo_3Des_112 = 'ALGO_3DES_112',
  /** Triple DES encryption with a 168-bit key. */
  Algo_3Des_168 = 'ALGO_3DES_168',
  /** None. */
  None = 'NONE'
}

export enum IpSecEventType {
  /** All child SAs lost event type. */
  AllChildSasLost = 'ALL_CHILD_SAS_LOST',
  /** IKE failures event type. */
  IkeFailures = 'IKE_FAILURES',
  /** IKE SA renegotiated after tear down event type. */
  IkeSaRenegotiated = 'IKE_SA_RENEGOTIATED',
  /** Tunnel down event type. */
  TunnelDown = 'TUNNEL_DOWN',
  /** Tunnel failed to establish event type. */
  TunnelFailedEstablishment = 'TUNNEL_FAILED_ESTABLISHMENT',
  /** Tunnel flapping event type. */
  TunnelFlapping = 'TUNNEL_FLAPPING',
  /** Tunnel recovered event type. */
  TunnelRecovered = 'TUNNEL_RECOVERED',
  /** Unspecified event type. */
  Unspecified = 'UNSPECIFIED'
}

export enum IpSecPeerType {
  /** AWS peer type */
  Aws = 'AWS',
  /** Azure peer type */
  Azure = 'AZURE',
  /** Cisco ASA peer type */
  CiscoAsa = 'CISCO_ASA'
}

/** Enumeration of possible states for the IKE Security Association. */
export enum IpSecSaStatus {
  /** The IKE Security Association is in the process of connecting. */
  Connecting = 'CONNECTING',
  /** The IKE Security Association is created but not yet connected. */
  Created = 'CREATED',
  /** The IKE Security Association is being deleted. */
  Deleting = 'DELETING',
  /** The IKE Security Association is being destroyed. */
  Destroying = 'DESTROYING',
  /** The IKE Security Association is established and operational. */
  Established = 'ESTABLISHED',
  /** The IKE Security Association is in passive mode, waiting for incoming connections. */
  Passive = 'PASSIVE',
  /** The IKE Security Association has been rekeyed. */
  Rekeyed = 'REKEYED',
  /** The IKE Security Association is rekeying. */
  Rekeying = 'REKEYING',
  /** Unspecified status. */
  Unspecified = 'UNSPECIFIED'
}

/** Represents an IPSec tunnel configuration. */
export type IpSecTunnel = Identifiable & TargetInterface & {
  __typename?: 'IPSecTunnel';
  /** The unique identifier for the IPSec tunnel. */
  UUID: Scalars['UUID']['output'];
  /**
   * Sets if outbound traffic can be sent over this tunnel
   * @deprecated This field is misnamed and will be replaced with `useAsDefaultRoute`.
   */
  allowOutboundTraffic: Scalars['Boolean']['output'];
  /** The authentication algorithm used for the IPSec connection. */
  authenticationAlgorithm?: Maybe<IpSecAuthenticationAlgorithm>;
  /** The VLANs that are bound to this IPSec tunnel. */
  boundAutoVPNVLANs?: Maybe<Array<AutoVpnvlan>>;
  /** The physical interface that this IPSec tunnel is bound to. */
  boundPhyInterface: PhyInterface;
  /** The VLANs that are bound to this IPSec tunnel. */
  boundVLANs: Array<Vlan>;
  /** Sets the close action for the tunnel. */
  closeAction?: Maybe<IpSecCloseAction>;
  /** Timestamp when the IPSec tunnel was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Sets the DPD action for the tunnel. */
  dpdAction?: Maybe<IpSecDpdAction>;
  /** Sets the DPD delay for the tunnel. */
  dpdDelay?: Maybe<Scalars['Duration']['output']>;
  /** Sets the DPD timeout for the tunnel. */
  dpdTimeout?: Maybe<Scalars['Duration']['output']>;
  /** The encryption algorithm used for the IPSec connection. */
  encryptionAlgorithm?: Maybe<IpSecEncryptionAlgorithm>;
  /** Sets the ikelifetime for the tunnel. */
  ikeLifetime?: Maybe<Scalars['Duration']['output']>;
  /** The generated internal IP address of the tunnel, if enabled and active. */
  ipAddress?: Maybe<Scalars['IPV4']['output']>;
  /** Whether BGP can be used for this tunnel. */
  isBGPEnabled: Scalars['Boolean']['output'];
  /**
   * If true, adds Client VPN subnets to the local traffic selectors,
   * effectively allowing Client VPN clients to route traffic over the IPSec tunnel.
   */
  isClientVPNBound: Scalars['Boolean']['output'];
  /** Indicates whether the IPSec tunnel is currently enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Indicates whether this tunnel should initiate the connection to the right participant. */
  isInitiator: Scalars['Boolean']['output'];
  /** The Diffie-Hellman group used for key exchange in the IPSec connection. */
  keyExchangeDHGroup?: Maybe<IpSecDhGroup>;
  /** How the left participant should be identified for authentication. Can be an IP address, email, or FQDN which will be validated in application logic. If this is not set, defaults to `%defaultroute`. */
  leftID: Scalars['String']['output'];
  /** The MTU of the tunnel interface in bytes. When null, the device default is used. */
  mtu?: Maybe<Scalars['Int']['output']>;
  /** A user-defined name for the IPSec tunnel. */
  name: Scalars['String']['output'];
  /** The network to which this IPSec tunnel belongs. */
  network: Network;
  /** The unique identifier of the network to which this IPSec tunnel belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** Allows for vendor specific configuration based on this peer type. */
  peerType?: Maybe<IpSecPeerType>;
  /** The authentication algorithm used in Phase 2  for the IPSec connection. */
  phase2AuthenticationAlgorithm?: Maybe<IpSecAuthenticationAlgorithm>;
  /** The encryption algorithm used in Phase 2 for the IPSec connection. */
  phase2EncryptionAlgorithm?: Maybe<IpSecEncryptionAlgorithm>;
  /** The Diffie-Hellman group used in Phase 2 for key exchange in the IPSec connection. */
  phase2KeyExchangeDHGroup?: Maybe<IpSecDhGroup>;
  /** Priority for the interface, lower priorities will be preferred. Only available for supporting implementations. */
  priority: Scalars['Int']['output'];
  /** Sets the reauth for the tunnel, true = yes, false = no */
  reauth: Scalars['Boolean']['output'];
  /** Sets the rekey for the tunnel, true = yes, false = no */
  rekey: Scalars['Boolean']['output'];
  /** The public IP address or DNS hostname where the right participant can be reached. Can be an IP address, email, or FQDN which will be validated in application logic. */
  right?: Maybe<Scalars['String']['output']>;
  /** Identifier for the right participant (remote side) for authentication purposes. Can be an IP address, email, or FQDN which will be validated in application logic. */
  rightID: Scalars['String']['output'];
  /** The private subnets behind the right participant. This is usually 0.0.0.0/0 but in some cases may be different. */
  rightPrefixes: Array<Scalars['IPPrefix']['output']>;
  /** The last reported status of the IPSec tunnel. */
  status?: Maybe<IpSecTunnelStatus>;
  /** Timestamp when the IPSec tunnel was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Sets if outbound traffic can be sent over this tunnel */
  useAsDefaultRoute: Scalars['Boolean']['output'];
  /** Virtual Tunnel Interface for the tunnel. */
  vti?: Maybe<IpSecTunnelVti>;
  /** Weight for the interface, higher values will be given more weight when multiple tunnels are active. Only available for supporting implementations. */
  weight: Scalars['Int']['output'];
};

/** Input type for creating Auto VPN IPSec VLAN binding */
export type IpSecTunnelAutoVpnvlanInput = {
  /** The UUID of the Auto VPN Group. */
  autoVPNGroupUUID: Scalars['UUID']['input'];
  /** The UUID of the spoke VLAN. */
  vlanUUID: Scalars['UUID']['input'];
};

/** Status of a single CHILD Security Association negotiated under an IPSec tunnel's IKE_SA. */
export type IpSecTunnelChildSaStatus = {
  __typename?: 'IPSecTunnelChildSAStatus';
  /** Timestamp when the CHILD Security Association will expire. */
  lifetime: Scalars['DateTime']['output'];
  /** List of local traffic selectors that were agreed upon */
  localTrafficSelectorsAccepted?: Maybe<Array<Scalars['String']['output']>>;
  /** Timestamp when the CHILD Security Association will be rekeyed. */
  rekeyAt: Scalars['DateTime']['output'];
  /** List of remote traffic selectors that were agreed upon */
  remoteTrafficSelectorsAccepted?: Maybe<Array<Scalars['String']['output']>>;
  /** Number of bytes received. */
  rxBytes: Scalars['Int']['output'];
  /** Timestamp of the last inbound packet, if any. */
  rxLast: Scalars['DateTime']['output'];
  /** Number of packets received. */
  rxPackets: Scalars['Int']['output'];
  /** Status of the CHILD Security Association. */
  status: IpSecChildSaStatus;
  /** Number of bytes transmitted. */
  txBytes: Scalars['Int']['output'];
  /** Timestamp of the last outbound packet, if any. */
  txLast: Scalars['DateTime']['output'];
  /** Number of packets transmitted. */
  txPackets: Scalars['Int']['output'];
  /** CHILD Security Association unique identifier. */
  uniqueID: Scalars['String']['output'];
};

/** Response type containing IPSec tunnel timeseries data over a specified time range. */
export type IpSecTunnelMetricsTimeseriesResponse = {
  __typename?: 'IPSecTunnelMetricsTimeseriesResponse';
  /** IPSec tunnel for this series. */
  ipSecTunnel: IpSecTunnel;
  /** Aggregated latency to the remote IKE in milliseconds. */
  latencyMs: BaseMetricsResponse;
  /** Network UUID for this series. */
  networkUUID: Scalars['UUID']['output'];
  /** Aggregated throughput for the total bytes received in bps. */
  rxBytes: BaseMetricsResponse;
  /** Aggregated throughput for the total packets received per second. */
  rxPackets: BaseMetricsResponse;
  /** Aggregated throughput for the total bytes transmitted in bps. */
  txBytes: BaseMetricsResponse;
  /** Aggregated throughput for the total packets transmitted per second. */
  txPackets: BaseMetricsResponse;
};

/** Status information for an IPSec tunnel. */
export type IpSecTunnelStatus = {
  __typename?: 'IPSecTunnelStatus';
  /**
   * Timestamp when the CHILD Security Association will expire.
   * @deprecated Use childSAs instead. A single tunnel's IKE_SA can have more than one CHILD_SA; this reflects an aggregate/primary CHILD_SA only.
   */
  childLifetime: Scalars['DateTime']['output'];
  /**
   * Timestamp when the CHILD Security Association will be rekeyed.
   * @deprecated Use childSAs instead. A single tunnel's IKE_SA can have more than one CHILD_SA; this reflects an aggregate/primary CHILD_SA only.
   */
  childRekeyAt: Scalars['DateTime']['output'];
  /**
   * Status of the CHILD Security Association.
   * @deprecated Use childSAs instead. A single tunnel's IKE_SA can have more than one CHILD_SA; this reflects an aggregate/primary CHILD_SA only.
   */
  childSAStatus: IpSecChildSaStatus;
  /**
   * Every CHILD Security Association currently known for this tunnel's IKE_SA. A single IKE_SA
   * can have more than one CHILD_SA (multiple traffic selectors, rekey overlap, or peer-initiated
   * re-negotiation), which the backend cannot prevent.
   */
  childSAs: Array<IpSecTunnelChildSaStatus>;
  /** Timestamp when the IKE Security Association was established. */
  establishedAt: Scalars['DateTime']['output'];
  /** Latency to the remote IKE endpoint in milliseconds. */
  latencyMs: Scalars['Int']['output'];
  /**
   * List of local traffic selectors that were agreed upon
   * @deprecated Use childSAs instead. A single tunnel's IKE_SA can have more than one CHILD_SA; this reflects an aggregate/primary CHILD_SA only.
   */
  localTrafficSelectorsAccepted?: Maybe<Array<Scalars['String']['output']>>;
  /** The timestamp when the status was observed. */
  observedAt: Scalars['DateTime']['output'];
  /** Timestamp when the IKE Security Association will be re-authenticated. */
  reauthAt: Scalars['DateTime']['output'];
  /** Timestamp when the IKE Security Association will be rekeyed. */
  rekeyAt: Scalars['DateTime']['output'];
  /** IPv4 address of the remote IKE endpoint. */
  remoteHostIP4Address: Scalars['String']['output'];
  /**
   * List of remote traffic selectors that were agreed upon
   * @deprecated Use childSAs instead. A single tunnel's IKE_SA can have more than one CHILD_SA; this reflects an aggregate/primary CHILD_SA only.
   */
  remoteTrafficSelectorsAccepted?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Number of bytes received.
   * @deprecated Use childSAs instead. A single tunnel's IKE_SA can have more than one CHILD_SA; this reflects an aggregate/primary CHILD_SA only.
   */
  rxBytes: Scalars['Int']['output'];
  /**
   * Timestamp of the last inbound packet, if any.
   * @deprecated Use childSAs instead. A single tunnel's IKE_SA can have more than one CHILD_SA; this reflects an aggregate/primary CHILD_SA only.
   */
  rxLast: Scalars['DateTime']['output'];
  /**
   * Number of packets received.
   * @deprecated Use childSAs instead. A single tunnel's IKE_SA can have more than one CHILD_SA; this reflects an aggregate/primary CHILD_SA only.
   */
  rxPackets: Scalars['Int']['output'];
  /** The state of the IKE Security Association. */
  saStatus: IpSecSaStatus;
  /**
   * Number of bytes transmitted.
   * @deprecated Use childSAs instead. A single tunnel's IKE_SA can have more than one CHILD_SA; this reflects an aggregate/primary CHILD_SA only.
   */
  txBytes: Scalars['Int']['output'];
  /**
   * Timestamp of the last outbound packet, if any.
   * @deprecated Use childSAs instead. A single tunnel's IKE_SA can have more than one CHILD_SA; this reflects an aggregate/primary CHILD_SA only.
   */
  txLast: Scalars['DateTime']['output'];
  /** Unique identifier of the IKE Security Association. */
  uniqueID: Scalars['String']['output'];
};

/** Properties for an IPSec tunnel status change event. */
export type IpSecTunnelStatusChangeProperties = {
  __typename?: 'IPSecTunnelStatusChangeProperties';
  /** The new status of the CHILD Security Association if not null. */
  childSAStatus?: Maybe<IpSecChildSaStatus>;
  /** The IPSec tunnel associated with the event. */
  ipSecTunnel?: Maybe<IpSecTunnel>;
  /** The new state of the IKE Security Association if not null */
  saStatus?: Maybe<IpSecSaStatus>;
};

/** Virtual Tunnel Interface (VTI) configuration for an IPSec Tunnel. */
export type IpSecTunnelVti = {
  __typename?: 'IPSecTunnelVTI';
  /** Local address. */
  localAddr: Scalars['IP']['output'];
  /** Remote address. */
  remoteAddr: Scalars['IP']['output'];
};

/** Input type for creating IPSec Virtual Tunnel Interface (VTI). */
export type IpSecTunnelVtiInput = {
  /** Local address. */
  localAddr: Scalars['IP']['input'];
  /** Remote address. */
  remoteAddr: Scalars['IP']['input'];
};

/** Computed lifecycle status of an Internet Service Plan. */
export enum IspFulfillmentStatus {
  /** ISP has been canceled. */
  Canceled = 'CANCELED',
  /** ISP cancellation is in progress. */
  CancellationInProgress = 'CANCELLATION_IN_PROGRESS',
  /** ISP is associted with a WAN port. */
  Configured = 'CONFIGURED',
  /** ISP has been deactivated. */
  Deactivated = 'DEACTIVATED',
  /** ISP deactivation is in progress. */
  DeactivationInProgress = 'DEACTIVATION_IN_PROGRESS',
  /** ISP has been installed. */
  Installed = 'INSTALLED',
  /** Installation is in progress. */
  InProgress = 'IN_PROGRESS',
  /** ISP is installed and static IPs added to ISP record. */
  ReadyForPatchIn = 'READY_FOR_PATCH_IN'
}

/** Type of handoff left by the ISP */
export enum IspHandoffType {
  /** Ethernet handoff. */
  Ethernet = 'ETHERNET',
  /** Multi mode fiber (MMF) handoff. */
  MultiModeFiber = 'MULTI_MODE_FIBER',
  /** Single mode fiber (SMF) handoff. */
  SingleModeFiber = 'SINGLE_MODE_FIBER'
}

/** The category of service provided by the ISP. */
export enum IspProduct {
  /** Business cable connection */
  BusinessCable = 'BUSINESS_CABLE',
  /** Cellular connection */
  Cellular = 'CELLULAR',
  /** Dark (unlit) fiber circuit */
  DarkFiber = 'DARK_FIBER',
  /** Dedicated fiber optic connection */
  DedicatedFiber = 'DEDICATED_FIBER',
  /** DSL connection */
  Dsl = 'DSL',
  /** Point-to-point wireless connection */
  PointToPointWireless = 'POINT_TO_POINT_WIRELESS',
  /** Private Ethernet Line (Layer 2 point-to-point) circuit */
  PrivateEthernetLine = 'PRIVATE_ETHERNET_LINE',
  /** Residential cable connection */
  ResidentialCable = 'RESIDENTIAL_CABLE',
  /** Residential fiber optic connection */
  ResidentialFiber = 'RESIDENTIAL_FIBER',
  /** Satellite connection */
  Satellite = 'SATELLITE',
  /** Shared fiber optic connection */
  SharedFiber = 'SHARED_FIBER',
  /** Wavelength (DWDM) circuit */
  Wavelength = 'WAVELENGTH'
}

/** Whether the ISP is intended to function as the primary or backup connection. */
export enum IspStatus {
  /** The ISP is configured as the fallback ISP connection. */
  Backup = 'BACKUP',
  /** The ISP is configured as the preferred ISP connection. */
  Primary = 'PRIMARY'
}

/** Interface denoting that an entity is identifiable by its UUID. */
export type Identifiable = {
  /** The unique identifier of the entity. */
  UUID: Scalars['UUID']['output'];
};

/** An enumeration of supported image types. */
export enum ImageType {
  /** Graphics Interchange Format. */
  Gif = 'GIF',
  /** Joint Photographic Experts Group format. */
  Jpeg = 'JPEG',
  /** Portable Network Graphics format. */
  Png = 'PNG',
  /** Scalable Vector Graphics format. */
  Svg = 'SVG'
}

/** Information about the user who performed the impersonation. */
export type Impersonator = {
  __typename?: 'Impersonator';
  /** The email address of the impersonating user. */
  email: Scalars['String']['output'];
};

/**
 * An in-network interference entry where a reporting AP detects another AP in the same network
 * in its scan data above a given RSSI threshold.
 */
export type InNetworkApInterferenceEntry = {
  __typename?: 'InNetworkAPInterferenceEntry';
  /** The radio band on which this interference was detected. */
  band: RadioBand;
  /** The AP whose BSSID was detected by the reporting AP. */
  detectedAP: AccessPointInterferenceEntryDevice;
  /** The AP that reported detecting the other AP in its scan. */
  reportedAP: AccessPointInterferenceEntryDevice;
  /** The maximum RSSI (in dBm) at which the reporting AP detected the other AP. */
  rssiDBm: Scalars['Int']['output'];
};

/** A hardware device is marked as inactive active issue */
export type InactiveHardwareDeviceActiveIssue = ActiveIssue & {
  __typename?: 'InactiveHardwareDeviceActiveIssue';
  /** When the issue was first detected, if available */
  detectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The network that this issue is impacting */
  networkUUID: Scalars['UUID']['output'];
  /** When the issue was resolved, if available */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The severity of the issue */
  severity: ActiveIssueSeverity;
  /** The type of the issue */
  type: ActiveIssueType;
  /** The virtual device whose hardware device is marked as inactive */
  virtualDevice: VirtualDevice;
};

/** Represents the support ticket inbox message type. */
export type InboxMessage = {
  __typename?: 'InboxMessage';
  /** The unique identifier for the message. */
  UUID: Scalars['UUID']['output'];
  /** Date time the message was archived. */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The company this inbox message is on. */
  company: Company;
  /** The time at which the message was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Is the message archived. */
  isArchived: Scalars['Boolean']['output'];
  /** Is the message read. */
  isRead: Scalars['Boolean']['output'];
  /** The network that might be related to the given message */
  network?: Maybe<Network>;
  /** Date time the message was read. */
  readAt?: Maybe<Scalars['DateTime']['output']>;
  /** support case this message represents. */
  supportCase?: Maybe<SupportCase>;
  /** title of the message. */
  title: Scalars['String']['output'];
  /** Type of the inbox message. */
  type: InboxMessageType;
  /** The time at which the message was modified. */
  updatedAt: Scalars['DateTime']['output'];
  /** The unique identifier for the message. */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Represents a page of inbox messages. */
export type InboxMessagePage = {
  __typename?: 'InboxMessagePage';
  /** The page the cursor points to. */
  currentPage: Scalars['Int']['output'];
  /** The items in this page. */
  items: Array<InboxMessage>;
  /** The next pages cursor. */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /** The previous pages cursor. */
  previousCursor?: Maybe<Scalars['String']['output']>;
  /** The total number of pages. */
  totalCount: Scalars['Int']['output'];
  /** The total number of pages. */
  totalPages: Scalars['Int']['output'];
};

/** Represents the inbox message state */
export type InboxMessageState = {
  __typename?: 'InboxMessageState';
  /** Date time the message was archived. */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The time at which the message was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Is the message archived. */
  isArchived: Scalars['Boolean']['output'];
  /** Is the message read. */
  isRead: Scalars['Boolean']['output'];
  /** Date time the message was read. */
  readAt?: Maybe<Scalars['DateTime']['output']>;
  /** The time at which the message was modified. */
  updatedAt: Scalars['DateTime']['output'];
  /** The unique identifier for the message. */
  userId: Scalars['Int']['output'];
};

/** Represents the type of inbox message. */
export enum InboxMessageType {
  /** Support ticket inbox message type. */
  SupportTicket = 'SUPPORT_TICKET',
  /** Inbox message type is unknown. */
  Unknown = 'UNKNOWN'
}

/** Filters combine with AND. Omitted or empty lists do not restrict results. */
export type InstallCompaniesFilter = {
  /** Restrict to these installation company UUIDs. */
  UUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Companies linked to any of these deployment jobs. */
  deploymentJobUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Companies linked to any of these installation technician UUIDs. */
  installTechnicianUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/**
 * Third-party installation partner assigned to a deployment job.
 * Synced from Airtable.
 */
export type InstallCompany = {
  __typename?: 'InstallCompany';
  /** Unique identifier of the installation company. */
  UUID: Scalars['UUID']['output'];
  /** Creation time of the record. */
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deployment jobs linked to this company, including completed jobs. */
  deploymentJobs: Array<DeploymentJob>;
  /** Time windows linked directly to this company. */
  deploymentTimeWindows: Array<DeploymentTimeWindow>;
  /** Installation technicians linked to this company. */
  installTechnicians: Array<InstallTechnician>;
  /** Name of the install company. */
  name: Scalars['String']['output'];
};


/**
 * Third-party installation partner assigned to a deployment job.
 * Synced from Airtable.
 */
export type InstallCompanyDeploymentTimeWindowsArgs = {
  filter?: InputMaybe<DeploymentTimeWindowsFilter>;
};

/** An individual installation technician synced from Airtable. */
export type InstallTechnician = {
  __typename?: 'InstallTechnician';
  /** Unique identifier of the installation technician. */
  UUID: Scalars['UUID']['output'];
  /** Creation time of the record. */
  createdTime?: Maybe<Scalars['String']['output']>;
  /** Deployment jobs linked to this technician, including completed jobs. */
  deploymentJobs: Array<DeploymentJob>;
  /** Time windows linked directly to this technician. */
  deploymentTimeWindows: Array<DeploymentTimeWindow>;
  /** Email address of the installation technician. */
  email?: Maybe<Scalars['String']['output']>;
  /** Installation company linked to this technician. */
  installCompany?: Maybe<InstallCompany>;
  /** Name of the installation technician. */
  name?: Maybe<Scalars['String']['output']>;
  /** Phone number of the installation technician. */
  phone?: Maybe<Scalars['String']['output']>;
};


/** An individual installation technician synced from Airtable. */
export type InstallTechnicianDeploymentTimeWindowsArgs = {
  filter?: InputMaybe<DeploymentTimeWindowsFilter>;
};

/** Filters combine with AND. Omitted or empty lists do not restrict results. */
export type InstallTechniciansFilter = {
  /** Restrict to these contact UUIDs. */
  UUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Contacts linked to any of these deployment jobs. */
  deploymentJobUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Contacts linked to any of these installation company UUIDs. */
  installCompanyUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** A pair of VLANs that are permitted to communicate with each other. */
export type InterVlanCommunicationPermittedPair = {
  __typename?: 'InterVLANCommunicationPermittedPair';
  /** The unique identifier of the inter-VLAN communication pair. */
  UUID: Scalars['UUID']['output'];
  /** The other VLAN in the permitted communication pair. */
  higherVLAN: Vlan;
  /** One VLAN in the permitted communication pair. */
  lowerVLAN: Vlan;
  /** The UUID of the network to which the VLANs belong. */
  networkUUID: Scalars['UUID']['output'];
};

/** An internal note is a note for Meter teams to share information about a network or company. */
export type InternalNote = Identifiable & {
  __typename?: 'InternalNote';
  /** Unique identifier for the internal note. */
  UUID: Scalars['UUID']['output'];
  /** UUID of the company that directly owns this note, if any. A note has exactly one owner. */
  companyUUID?: Maybe<Scalars['UUID']['output']>;
  /** Timestamp indicating when the note was created */
  createdAt: Scalars['DateTime']['output'];
  /** The email address of the user who created the note. */
  createdBy: Scalars['String']['output'];
  /** The user who created the note. */
  createdByUser: User;
  /** Important notes can be highlighted in the UI. */
  isImportant: Scalars['Boolean']['output'];
  /** UUID of the network to which this internal note belongs */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** Content of the internal note. */
  note: Scalars['String']['output'];
  /** AWS S3 keys for photos attached to the note. */
  photoS3Keys?: Maybe<Array<Scalars['String']['output']>>;
  /** URLs for photos attached to the note. */
  photoURLs?: Maybe<Array<Scalars['String']['output']>>;
  /** Tags associated with the note. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Timestamp indicating when the note was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The email address of the user who updated the note most recently. */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** The user who updated the note most recently. */
  updatedByUser?: Maybe<User>;
};

/**
 * InternetServicePlan represents the configuration associated with an Internet Service Provider (ISP). This includes
 * information about the provider itself, as well as the IP address configurations for the network.
 */
export type InternetServicePlan = Identifiable & TargetInterface & {
  __typename?: 'InternetServicePlan';
  /** Unique identifier for the Internet Service Plan. */
  UUID: Scalars['UUID']['output'];
  /** Provider account number of the plan. */
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** Provider account number PIN. */
  accountPIN?: Maybe<Scalars['String']['output']>;
  /** The physical address associated with this Internet Service Plan. */
  address?: Maybe<ConnectAddress>;
  /** Activation date of the associated record in the Meter Circuits Airtable. */
  airtableActivationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Deactivation date of the associated record in the Meter Circuits Airtable. */
  airtableDeactivationDate?: Maybe<Scalars['DateTime']['output']>;
  /** RecordID of the associated record in the Meter Circuits Airtable. */
  airtableRecordID?: Maybe<Scalars['String']['output']>;
  /** Name of the associated circuit (MC-00000) in the Meter Circuits Airtable. */
  airtableRecordName?: Maybe<Scalars['String']['output']>;
  /** Status of the associated record in the Meter Circuits Airtable. */
  airtableStatus?: Maybe<Scalars['String']['output']>;
  /** Meter is to handle billing for this plan. */
  billingRequired: Scalars['Boolean']['output'];
  /** The provider that brokered the ISP. */
  brokerProvider?: Maybe<InternetServicePlanProvider>;
  /** The Company associated with the plan. */
  company?: Maybe<Company>;
  /** The UUID of the Company associated with the Internet Service Plan. */
  companyUUID?: Maybe<Scalars['UUID']['output']>;
  /** The category of service provided by the ISP (e.g., Dedicated Fiber, Shared Fiber). */
  connectionProduct: IspProduct;
  /** Indicates whether this ISP connection is the primary or backup connection. */
  connectionStatus: IspStatus;
  /**
   * ControllerIP is dynamically resolved from stats coming in to Clickhouse. These stats are reported
   * by the controller.
   */
  controllerIP?: Maybe<Scalars['IPV4']['output']>;
  /**
   * Name of the controller device associated with this Internet Service Plan.
   * @deprecated Use `networkUUID` instead.
   */
  controllerName?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the Internet Service Plan was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Documents associated with the plan including contracts and install photos. */
  documents?: Maybe<Array<InternetServicePlanDocument>>;
  /** Download speed of the plan. */
  downloadKbps?: Maybe<Scalars['Int']['output']>;
  /** Additional cost incurred to expedite the install, if any. */
  expeditedInstallCostCents?: Maybe<Scalars['Int']['output']>;
  /** SFDC id of Circuit object. */
  externalID?: Maybe<Scalars['String']['output']>;
  /** First usable IP address in the static IP range provided by the ISP. */
  firstUsableIP?: Maybe<Scalars['IPV4']['output']>;
  /** Jobs tracking the fulfillment phases of this ISP */
  fulfillmentJobs?: Maybe<Array<InternetServicePlanFulfillmentJob>>;
  /** Gateway IP address provided by the ISP for routing. */
  gatewayAddr?: Maybe<Scalars['IPV4']['output']>;
  /** Handoff type left by ISP. */
  handoffType?: Maybe<IspHandoffType>;
  /** Indicates whether the ISP connection has or is to have a static IP address or range. */
  hasStaticIP: Scalars['Boolean']['output'];
  /** Install costs cost of the plan. */
  installCostCents?: Maybe<Scalars['Int']['output']>;
  /** Wholesale install cost of the plan. */
  installCostWholesaleCents?: Maybe<Scalars['Int']['output']>;
  /** The install was escalated. */
  installEscalated?: Maybe<Scalars['Boolean']['output']>;
  /** The install was expedited. */
  installExpedited?: Maybe<Scalars['Boolean']['output']>;
  /** URL from Provider for tracking install progress. */
  installationTrackingURL?: Maybe<Scalars['String']['output']>;
  /** Last usable IP address in the static IP range provided by the ISP. */
  lastUsableIP?: Maybe<Scalars['IPV4']['output']>;
  /** The mailing address associated with this Internet Service Plan connecting it to a SFDC opportunity location. */
  mailingAddress?: Maybe<MailingAddress>;
  /** Monthly recurring cost of the plan. */
  monthlyCostCents?: Maybe<Scalars['Int']['output']>;
  /** Monthly wholesale cost of the plan. */
  monthlyCostWholesaleCents?: Maybe<Scalars['Int']['output']>;
  /** Signals when the ISP data should be reviewed by Connect, typically for when data was provided by the customer. */
  needsReview?: Maybe<Scalars['Boolean']['output']>;
  /** The network associated with the Plan. */
  network?: Maybe<Network>;
  /** Unique identifier of the network associated with this Internet Service Plan. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** Freeform notes associated with the plan. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Origin of the plan. */
  origin?: Maybe<InternetServicePlanOrigin>;
  /** The owner of the plan. */
  owner?: Maybe<InternetServicePlanOwner>;
  /** Payment resources (Ramp cards / Increase bank accounts) used to pay this ISP's circuit bill. */
  paymentResources?: Maybe<Array<InternetServicePlanPaymentResource>>;
  /** Firewall physical interfaces assumed to be the uplinks to this ISP. */
  phyInterfaces?: Maybe<Array<PhyInterface>>;
  /** Procurement channel/pricing method for the circuit. */
  procurementChannel?: Maybe<ConnectProcurementChannel>;
  /** The ISP provider associated with this Internet Service Plan. */
  provider?: Maybe<InternetServicePlanProvider>;
  /** Indicates whether the provider API linkage has been successfully verified. */
  providerAPIStatus?: Maybe<InternetServicePlanProviderApiStatus>;
  /** Billing Account Number (BAN) associated with customer in Provider API. */
  providerBillingID?: Maybe<Scalars['String']['output']>;
  /** Label the provider tags the circuit with in the physical space after install completion. */
  providerCircuitID?: Maybe<Scalars['String']['output']>;
  /** External ID of associated order in Provider API. */
  providerOrderID?: Maybe<Scalars['String']['output']>;
  /** External status of order according to Provider API. */
  providerOrderStatus?: Maybe<InternetServicePlanProviderOrderStatus>;
  /** External ID of associated circuit/service in Provider API. */
  providerServiceID?: Maybe<Scalars['String']['output']>;
  /** External status of service according to Provider API. */
  providerServiceStatus?: Maybe<InternetServicePlanProviderServiceStatus>;
  /** Flag signaling a request is made to run a provider service status update. */
  providerServiceStatusUpdatePending?: Maybe<Scalars['Boolean']['output']>;
  /** Provider service status checks retrieved from Provider API. */
  providerStatusItems?: Maybe<Array<InternetServicePlanProviderStatusItem>>;
  /** Provider installation phases and completion dates retrieved from Provider API. */
  providerTasks?: Maybe<Array<InternetServicePlanProviderTask>>;
  /** The UUID of the QuoteRequest associated with the plan. */
  quoteRequestUUID?: Maybe<Scalars['UUID']['output']>;
  /** The UUID of the Quote associated with the plan. */
  quoteUUID?: Maybe<Scalars['UUID']['output']>;
  /** Cost of the riser work associated with fulfilling this plan. */
  riserCostCents?: Maybe<Scalars['Int']['output']>;
  /** Link to slack thread where the fulfillment of this plan is discussed. */
  slackThreadLink?: Maybe<Scalars['String']['output']>;
  /** CIDR notation of the static IP address range provided by the ISP. */
  staticIPRange?: Maybe<Scalars['IPPrefix']['output']>;
  /** Lifecycle status of the ISP mostly based on fulfillment job completion. */
  status?: Maybe<IspFulfillmentStatus>;
  /** The underlying provider associated with this Internet Service Plan. */
  subProvider?: Maybe<InternetServicePlanProvider>;
  /** User handling fulfillment/support. */
  supportUsers?: Maybe<Array<InternetServicePlanSupportUser>>;
  /** Length of the contract in months. */
  termMonths?: Maybe<Scalars['Int']['output']>;
  /** Actual contract term in months committed to with the underlying carrier, which may differ from the customer-facing termMonths. */
  termMonthsInternal?: Maybe<Scalars['Int']['output']>;
  /** Timestamp when the Internet Service Plan was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Upload speed of the plan. */
  uploadKbps?: Maybe<Scalars['Int']['output']>;
  /**
   * The far-end (Z-side) location for point-to-point circuit products (dark fiber, wavelength, private Ethernet
   * line) that terminate at a second site rather than a routed internet handoff.
   */
  zSideLocation?: Maybe<ConnectAddress>;
};

/** Input type for connection details of an Internet Service Plan. */
export type InternetServicePlanConnectionInput = {
  /** The category of service provided by the ISP (e.g., Dedicated Fiber, Shared Fiber). */
  product: IspProduct;
  /** Indicates whether the ISP connection is the primary or backup connection. */
  status: IspStatus;
};

/** Category of service provided by the ISP connection. */
export type InternetServicePlanConnectionType = {
  __typename?: 'InternetServicePlanConnectionType';
  /** Unique identifier for the ISP connection type. */
  UUID: Scalars['UUID']['output'];
  /** Name of the ISP connection type. Examples: "Dedicated Fiber", "Shared Fiber", "Coax", "Point to Point Wireless", etc. */
  name: Scalars['String']['output'];
  /** Customer-facing product group of the connection type, when it has one. */
  productGroup?: Maybe<ConnectProductGroup>;
};

/** Media */
export type InternetServicePlanDocument = Identifiable & {
  __typename?: 'InternetServicePlanDocument';
  /** UUID of the document */
  UUID: Scalars['UUID']['output'];
  /** Date created. */
  createdAt: Scalars['DateTime']['output'];
  /** A pre-signed URL to download the document. */
  downloadURL: Scalars['String']['output'];
  /** UUID of the ISP the task is associated with. */
  ispUUID: Scalars['UUID']['output'];
  /** Name of the document. */
  name: Scalars['String']['output'];
  /** Notes regarding the document. */
  notes?: Maybe<Scalars['String']['output']>;
  /** S3 key of the document. */
  s3Key: Scalars['String']['output'];
  /** Type of document. */
  type: InternetServicePlanDocumentType;
  /** Date updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Type of ISP Document. */
export enum InternetServicePlanDocumentType {
  /** Contract between ISP and Meter/Customer. */
  Contract = 'CONTRACT',
  /** Photo of circuit install. */
  InstallImage = 'INSTALL_IMAGE',
  /** Riser quote detailing riser cost. */
  RiserQuote = 'RISER_QUOTE'
}

/** Filter input for ISP fields. */
export type InternetServicePlanFilterInput = {
  /** Having completed jobs of the provided types. */
  closedJobTypes?: InputMaybe<Array<InternetServicePlanFulfillmentJobType>>;
  /**
   * UUID of Company.  This field is required for non-operators in order to enforce
   * authenticating Company scope for those users.
   */
  companyUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Fulfillment statuses to filter on. */
  fulfillmentStatuses?: InputMaybe<Array<IspFulfillmentStatus>>;
  /** Filter on whether the ISP has an associated payment resource. */
  hasPaymentResource?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter on whether the install was escalated. */
  installEscalated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter on whether the install was expedited. */
  installExpedited?: InputMaybe<Scalars['Boolean']['input']>;
  /** UUID of plan to filter to. */
  internetServicePlanUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Signals when the ISP data should be reviewed by Connect, typically for when data was provided by the customer. */
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Having open jobs of the provided types. */
  openJobTypes?: InputMaybe<Array<InternetServicePlanFulfillmentJobType>>;
  /** The owner of the plan. */
  owners?: InputMaybe<Array<InternetServicePlanOwner>>;
  /** Procurement channels to filter on. */
  procurementChannels?: InputMaybe<Array<ConnectProcurementChannel>>;
  /** Input for non-exact search against ISP fields. */
  search?: InputMaybe<InternetServicePlanFilterSearchInput>;
  /** Users responsible for fulfilling or supporting the ISP. */
  supportUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Input for non-exact search against ISP fields. */
export type InternetServicePlanFilterSearchInput = {
  /** Provider account number of the plan. */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Address1 associated with the Internet Service Plan. */
  address1?: InputMaybe<Scalars['String']['input']>;
  /** Company name associated with the Internet Service Plan. */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Location associated with the Internet Service Plan. */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Label the provider tags the circuit with in the physical space after install completion. */
  providerCircuitID?: InputMaybe<Scalars['String']['input']>;
  /** Provider name associated with the Internet Service Plan. */
  providerName?: InputMaybe<Scalars['String']['input']>;
  /** External ID of associated order in Provider API. */
  providerOrderID?: InputMaybe<Scalars['String']['input']>;
};

/** Job representing a phase of fulfillment. */
export type InternetServicePlanFulfillmentJob = Identifiable & {
  __typename?: 'InternetServicePlanFulfillmentJob';
  /** UUID of the fulfullment job */
  UUID: Scalars['UUID']['output'];
  /** Estimated date of completion. */
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  /** UUID of associated ISP. */
  ispUUID: Scalars['UUID']['output'];
  /** Notes regarding the job. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Tasks associated with the job */
  tasks?: Maybe<Array<InternetServicePlanFulfillmentTask>>;
  /** Job type. */
  type: InternetServicePlanFulfillmentJobType;
};

/** Type of fullfillment job. */
export enum InternetServicePlanFulfillmentJobType {
  /** Cancellation phase. */
  Cancel = 'CANCEL',
  /** Configuration phase. */
  Configure = 'CONFIGURE',
  /** Contracting phase. */
  Contract = 'CONTRACT',
  /** Deactivation phase. */
  Deactivate = 'DEACTIVATE',
  /** ISP installs phase. */
  IspInstall = 'ISP_INSTALL',
  /** Quoting phhase. */
  Quote = 'QUOTE',
  /** Riser install phase. */
  RiserInstall = 'RISER_INSTALL',
  /** Setup billing phase. */
  SetupBilling = 'SETUP_BILLING'
}

/** Metadata for job type. */
export type InternetServicePlanFulfillmentJobTypeMetaData = {
  __typename?: 'InternetServicePlanFulfillmentJobTypeMetaData';
  /** Order the jobs should be displayed in. In reality some may overlap in time. */
  order: Scalars['Int']['output'];
  /** Data for task types */
  taskTypesMetaData?: Maybe<Array<InternetServicePlanFulfillmentTaskTypeMetaData>>;
  /** Type of job. */
  type: InternetServicePlanFulfillmentJobType;
};

/** Task representing a specific chore related to a Job. */
export type InternetServicePlanFulfillmentTask = Identifiable & {
  __typename?: 'InternetServicePlanFulfillmentTask';
  /** UUID of the fulfullment task. */
  UUID: Scalars['UUID']['output'];
  /** Date completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** UUID of the job the task is associated with. */
  jobUUID: Scalars['UUID']['output'];
  /** Notes regarding the task. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Date scheduled to start. */
  scheduledFor?: Maybe<Scalars['DateTime']['output']>;
  /** Date started. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Task type. */
  type: InternetServicePlanFulfillmentTaskType;
};

/** Type of fulfillment task related to a job. */
export enum InternetServicePlanFulfillmentTaskType {
  /** Circuit is actiated by provider. */
  CircuitActivation = 'CIRCUIT_ACTIVATION',
  /** Circuit is cancelled by the ISP. */
  CircuitCancellation = 'CIRCUIT_CANCELLATION',
  /** Circuit is deactivated by the ISP. */
  CircuitDeactivation = 'CIRCUIT_DEACTIVATION',
  /** ISP installs modem at install appointment. */
  CircuitInstallation = 'CIRCUIT_INSTALLATION',
  /** Configure autopay in ISP portal. */
  ConfigureAutopay = 'CONFIGURE_AUTOPAY',
  /** Configure invoicing for customer for ISP. */
  ConfigureInvoicing = 'CONFIGURE_INVOICING',
  /** Configure static IPs. */
  ConfigureStaticIps = 'CONFIGURE_STATIC_IPS',
  /** ISP performing contruction. */
  Construction = 'CONSTRUCTION',
  /** Create ISP contract. */
  Contract = 'CONTRACT',
  /** Riser company performing an extension. */
  Extension = 'EXTENSION',
  /** Fiber is being spliced by provider. */
  FiberSplicing = 'FIBER_SPLICING',
  /** Patching phase. */
  Patch = 'PATCH',
  /** Quote ISP pricing. */
  Quote = 'QUOTE',
  /** Site being surveyed by ISP or riser company. */
  SiteSurvey = 'SITE_SURVEY',
  /** Stop invoicing the customer. */
  StopInvoicing = 'STOP_INVOICING'
}

/** Metadata for task type. */
export type InternetServicePlanFulfillmentTaskTypeMetaData = {
  __typename?: 'InternetServicePlanFulfillmentTaskTypeMetaData';
  /** Order the jobs should be displayed in. In reality some may overlap in time. */
  order: Scalars['Int']['output'];
  /** Type of task. */
  type: InternetServicePlanFulfillmentTaskType;
};

/** Input type for IP configuration details of an Internet Service Plan. */
export type InternetServicePlanIpInput = {
  /** The IP address of the controller device. */
  controllerIP?: InputMaybe<Scalars['IPV4']['input']>;
  /** Name of the controller device. */
  controllerName?: InputMaybe<Scalars['String']['input']>;
  /** First usable IP address in the ISP-provided static IP range. */
  firstUsableIP?: InputMaybe<Scalars['IPV4']['input']>;
  /** Gateway IP address for routing provided by the ISP. */
  gatewayAddr?: InputMaybe<Scalars['IPV4']['input']>;
  /** Last usable IP address in the ISP-provided static IP range. */
  lastUsableIP?: InputMaybe<Scalars['IPV4']['input']>;
  /** CIDR notation of the static IP address range provided by the ISP. */
  staticIPRange?: InputMaybe<Scalars['IPPrefix']['input']>;
};

/** Name of ISP field to sort results on. */
export enum InternetServicePlanOrderByField {
  /** Sort on address1 of ISP location. */
  Address_1 = 'ADDRESS_1',
  /** Sort on ISP creation date. */
  CreatedAt = 'CREATED_AT'
}

/** Origin of the ISP */
export enum InternetServicePlanOrigin {
  /** The ISP originated from the associated company. */
  Company = 'COMPANY',
  /** The ISP originated from Connect. */
  Connect = 'CONNECT'
}

/** Owner of the ISP responsible for its management. */
export enum InternetServicePlanOwner {
  /** The ISP is managed by the associated Company. */
  Company = 'COMPANY',
  /** The ISP is managed by Connect. */
  Connect = 'CONNECT'
}

/** Page of ISPs. */
export type InternetServicePlanPage = {
  __typename?: 'InternetServicePlanPage';
  /** The results for this page. */
  items: Array<InternetServicePlan>;
  /** The total number of results available based on the provided filters. */
  total: Scalars['Int']['output'];
};

/** A payment resource (Ramp card or Increase bank account) used to pay an ISP's circuit bill. */
export type InternetServicePlanPaymentResource = {
  __typename?: 'InternetServicePlanPaymentResource';
  /** UUID of the payment resource. */
  UUID: Scalars['UUID']['output'];
  /** The currently active temporary spend limit override for this resource, if any. */
  activeTemporaryLimit?: Maybe<InternetServicePlanPaymentResourceTemporaryLimit>;
  /** Date created. */
  createdAt: Scalars['DateTime']['output'];
  /** Live details about the payment resource, fetched directly from the vendor. Null if the resource is still pending a vendor action, or if the vendor lookup fails. */
  details?: Maybe<InternetServicePlanPaymentResourceDetails>;
  /** Expected monthly spend on this resource, in cents. */
  expectedSpendCents?: Maybe<Scalars['Int']['output']>;
  /** UUID of the ISP the payment resource is associated with. */
  ispUUID: Scalars['UUID']['output'];
  /** Vendor-side identifier for the resource (a Ramp card/limit-task ID, or an Increase account number ID). */
  paymentResourceID: Scalars['String']['output'];
  /** Vendor-side identifier for the resource's parent (a Ramp spend limit ID, or an Increase account ID). */
  paymentResourceParentID?: Maybe<Scalars['String']['output']>;
  /** Lifecycle status of the payment resource. */
  paymentStatus: InternetServicePlanPaymentResourceStatus;
  /** Type of payment resource. */
  paymentType: InternetServicePlanPaymentResourceType;
  /** Vendor providing the payment resource. */
  paymentVendor: InternetServicePlanPaymentResourceVendor;
  /** Transactions charged against this payment resource, most recent first. */
  transactions: Array<InternetServicePlanPaymentResourceTransaction>;
  /** Date updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Live details about an Increase bank account, fetched directly from Increase. */
export type InternetServicePlanPaymentResourceBankAccountDetails = {
  __typename?: 'InternetServicePlanPaymentResourceBankAccountDetails';
  /** Address of the bank the account is held at. */
  bankAddress: Scalars['String']['output'];
  /** Name of the bank the account is held at. */
  bankName: Scalars['String']['output'];
  /** Last 4 digits of the account number. Null if the vendor lookup failed or the account number is unavailable. */
  last4?: Maybe<Scalars['String']['output']>;
  /** Link to the account in the Increase dashboard. */
  vendorURL?: Maybe<Scalars['String']['output']>;
};

/** Live details about a Ramp card, fetched directly from Ramp. */
export type InternetServicePlanPaymentResourceCardDetails = {
  __typename?: 'InternetServicePlanPaymentResourceCardDetails';
  /** Current balance on the card's spend limit, in cents. */
  balanceCents?: Maybe<Scalars['Int']['output']>;
  /** Billing address on file for the card. */
  billingAddress: Scalars['String']['output'];
  /** Card expiration, formatted MM/YY. */
  expiration: Scalars['String']['output'];
  /** Name on the card. */
  holderName: Scalars['String']['output'];
  /** Last 4 digits of the card number. Null if the vendor's card vault lookup failed or the card's number is unavailable. */
  last4?: Maybe<Scalars['String']['output']>;
  /** Current spend limit on the card, in cents. */
  limitCents?: Maybe<Scalars['Int']['output']>;
  /** Link to the card's spend limit in the Ramp dashboard. */
  vendorURL?: Maybe<Scalars['String']['output']>;
};

/** Live details about a payment resource fetched directly from the vendor. */
export type InternetServicePlanPaymentResourceDetails = InternetServicePlanPaymentResourceBankAccountDetails | InternetServicePlanPaymentResourceCardDetails;

/** Lifecycle status of a payment resource. */
export enum InternetServicePlanPaymentResourceStatus {
  /** Resource is active and in use. */
  Active = 'ACTIVE',
  /** Resource has been deactivated and is no longer in use. */
  Deactivated = 'DEACTIVATED',
  /** The async vendor-side step failed. */
  FailedVendorAction = 'FAILED_VENDOR_ACTION',
  /** Resource exists at the vendor and now needs a manual Meter-side action before it can be used. */
  PendingMeterAction = 'PENDING_METER_ACTION',
  /** Waiting on an async vendor-side step (e.g. Ramp's deferred limit task) to resolve. */
  PendingVendorAction = 'PENDING_VENDOR_ACTION'
}

/** A temporary override of a payment resource's spend limit, in effect until its expiration date. */
export type InternetServicePlanPaymentResourceTemporaryLimit = {
  __typename?: 'InternetServicePlanPaymentResourceTemporaryLimit';
  /** UUID of the temporary limit. */
  UUID: Scalars['UUID']['output'];
  /** The overriding spend limit, in cents. */
  amountCents: Scalars['Int']['output'];
  /** Date created. */
  createdAt: Scalars['DateTime']['output'];
  /** When this limit stops being in effect. */
  expirationDate: Scalars['DateTime']['output'];
  /** UUID of the payment resource this limit applies to. */
  paymentResourceUUID: Scalars['UUID']['output'];
  /** Lifecycle status of the temporary limit. */
  status: InternetServicePlanPaymentResourceTemporaryLimitStatus;
  /** Date updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Lifecycle status of a temporary spend limit override. */
export enum InternetServicePlanPaymentResourceTemporaryLimitStatus {
  /** The limit is currently in effect. */
  Active = 'ACTIVE',
  /** The limit was superseded by a newer one before it expired. */
  Deleted = 'DELETED',
  /** The limit's expiration date has passed. */
  Expired = 'EXPIRED'
}

/** A transaction charged against an ISP payment resource. */
export type InternetServicePlanPaymentResourceTransaction = {
  __typename?: 'InternetServicePlanPaymentResourceTransaction';
  /** UUID of the transaction. */
  UUID: Scalars['UUID']['output'];
  /** Amount of the transaction, in cents. */
  amountCents: Scalars['Int']['output'];
  /** Date created. */
  createdAt: Scalars['DateTime']['output'];
  /** Date the transaction occurred. */
  date: Scalars['DateTime']['output'];
  /** Vendor-provided description of the transaction, if available. */
  description?: Maybe<Scalars['String']['output']>;
  /** Error/decline reason, if the transaction errored or was declined. */
  error?: Maybe<Scalars['String']['output']>;
  /** Merchant/originator the transaction was with, if available. */
  merchant?: Maybe<Scalars['String']['output']>;
  /** UUID of the payment resource this transaction was charged against. */
  paymentResourceUUID: Scalars['UUID']['output'];
  /** Normalized status of the transaction. */
  status: InternetServicePlanPaymentResourceTransactionStatus;
  /** Date updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Vendor the transaction occurred at. */
  vendor: InternetServicePlanPaymentResourceVendor;
  /** Raw vendor-side status of the transaction, if available. */
  vendorStatus?: Maybe<Scalars['String']['output']>;
  /** Vendor-side identifier for the transaction. */
  vendorTransactionID: Scalars['String']['output'];
};

/** Status of a payment resource transaction, normalized across vendors. */
export enum InternetServicePlanPaymentResourceTransactionStatus {
  /** The transaction was accepted/cleared. */
  Accepted = 'ACCEPTED',
  /** The transaction was declined. */
  Declined = 'DECLINED',
  /** The transaction errored. */
  Error = 'ERROR',
  /** The transaction is pending. */
  Pending = 'PENDING',
  /** The transaction's status could not be determined. */
  Unknown = 'UNKNOWN'
}

/** Type of payment resource backing an ISP's circuit payment (a Ramp card or an Increase bank account). */
export enum InternetServicePlanPaymentResourceType {
  /** An Increase bank account. */
  BankAccount = 'BANK_ACCOUNT',
  /** A Ramp card. */
  Card = 'CARD'
}

/** Vendor providing the payment resource. */
export enum InternetServicePlanPaymentResourceVendor {
  /** Increase, a banking-as-a-service provider. */
  Increase = 'INCREASE',
  /** Ramp, a card issuer. */
  Ramp = 'RAMP'
}

/** Represents an Internet Service Plan Provider. */
export type InternetServicePlanProvider = {
  __typename?: 'InternetServicePlanProvider';
  /** Unique identifier for the Internet Service Plan Provider. */
  UUID: Scalars['UUID']['output'];
  /** Alternative names for this provider, used in 3rd-party APIs */
  aliases?: Maybe<Array<InternetServicePlanProviderAlias>>;
  /** Contract terms this provider offers, per connection type. */
  connectionTypeTerms: Array<ProviderConnectionTypeTerm>;
  /** AWS S3 key of the square icon image. */
  iconS3Key?: Maybe<Scalars['String']['output']>;
  /** Is a preferred provider, typically to have discounted pricing and expedited install. */
  isPreferred: Scalars['Boolean']['output'];
  /** AWS S3 key of the landscape logo image. */
  logoS3Key?: Maybe<Scalars['String']['output']>;
  /** Legacy Logo image. */
  logoURL?: Maybe<Scalars['String']['output']>;
  /** Name of the Internet Service Plan Provider. */
  name: Scalars['String']['output'];
  /** Static rates for this providers products */
  staticRates?: Maybe<Array<InternetServicePlanProviderStaticRate>>;
};

/** Status of the ISP API linkage. */
export enum InternetServicePlanProviderApiStatus {
  /** API linkage has been initiated but has not yet been verified. */
  Pending = 'PENDING',
  /** API linkage is marked unverified after a failed call, however it is possible that this call will succeed in the future. */
  Unverified = 'UNVERIFIED',
  /** API linkage has been verified by a successful call. */
  Verified = 'VERIFIED'
}

/** Represents an Internet Service Plan Provider Alias. */
export type InternetServicePlanProviderAlias = {
  __typename?: 'InternetServicePlanProviderAlias';
  /** Unique identifier for the Internet Service Plan Provider. */
  UUID: Scalars['UUID']['output'];
  /** Alternative name for Internet Service Provider used in 3rd party APIs */
  alias: Scalars['String']['output'];
};

/** Order status of the ISP according to the Provider. */
export enum InternetServicePlanProviderOrderStatus {
  /** Order has been fulfilled */
  Complete = 'COMPLETE',
  /** Order is in progress. */
  InProgress = 'IN_PROGRESS'
}

/** Service status of the ISP according to the Provider. */
export enum InternetServicePlanProviderServiceStatus {
  /** Service is severly degraded or down. */
  Critical = 'CRITICAL',
  /** Service appears healthy. */
  Ok = 'OK',
  /** Status is unknown. */
  Unknown = 'UNKNOWN',
  /** Service experiencing issues. */
  Warning = 'WARNING'
}

/** Static rates for a Provider's products. */
export type InternetServicePlanProviderStaticRate = {
  __typename?: 'InternetServicePlanProviderStaticRate';
  /** Unique identifier for the Provider Static Rate. */
  UUID: Scalars['UUID']['output'];
  /** Product type for the rate. */
  connectionType: InternetServicePlanConnectionType;
  /** Timestamp of when the Static Rate was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Data cap in GB. */
  dataCapGB?: Maybe<Scalars['Int']['output']>;
  /** Download speed Kbps. */
  downloadKbps: Scalars['Int']['output'];
  /** Enabled status of the rate. */
  enabled: Scalars['Boolean']['output'];
  /** Install cost in cents. */
  installCostCents: Scalars['Int']['output'];
  /**
   * Install wholesale cost.
   * @deprecated Rely on monthlyCostCents and procurementChannel instead.
   */
  installCostWholesaleCents?: Maybe<Scalars['Int']['output']>;
  /** Describes dependency of the static rate on a location. */
  locationMode: InternetServicePlanProviderStaticRateLocationMode;
  /** Monthly recurring cost in cents. */
  monthlyCostCents: Scalars['Int']['output'];
  /**
   * Monthly wholesale cost.
   * @deprecated Rely on monthlyCostCents and procurementChannel instead.
   */
  monthlyCostWholesaleCents?: Maybe<Scalars['Int']['output']>;
  /** Procurement channel/pricing method for the proposed circuit. */
  procurementChannel: ConnectProcurementChannel;
  /** Term of contract in months. */
  termMonths: Scalars['Int']['output'];
  /** Timestamp of when the Static Rate was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Upload speed Kbps. */
  uploadKbps: Scalars['Int']['output'];
};

/** Describes dependency of the static rate on a location. */
export enum InternetServicePlanProviderStaticRateLocationMode {
  /** Static rates do not depend on a location. */
  Agnostic = 'AGNOSTIC',
  /** Static rates depend on location being found in location availabilities sourced from 3rd parties or internal histories. */
  Dynamic = 'DYNAMIC'
}

/** Tracking status of service checks (service utilization, interface status, pings, etc) as reported in Provider API. */
export type InternetServicePlanProviderStatusItem = {
  __typename?: 'InternetServicePlanProviderStatusItem';
  /** Date the check was completed. */
  createdAt: Scalars['DateTime']['output'];
  /** Name of the status check, like 'Service Utilization', 'Ping', etc. */
  criteria: Scalars['String']['output'];
  /** Details behind the status of this check. */
  message: Scalars['String']['output'];
  /** Order that this task should be displayed in in relation to other service checks associated with the ISP. */
  sortOrder: Scalars['Int']['output'];
  /** Status of the check. */
  status: InternetServicePlanProviderServiceStatus;
};

/** Tracking stages of install (Tasks) as reported in Provider API. */
export type InternetServicePlanProviderTask = {
  __typename?: 'InternetServicePlanProviderTask';
  /** Task completed date. */
  completedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Last updated date of the task record. */
  lastUpdatedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Task name. */
  name: Scalars['String']['output'];
  /** Order that this task should be completed in in relation to other tasks associated with the ISP. */
  sortOrder: Scalars['Int']['output'];
  /** Task start date. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Task status. */
  status: InternetServicePlanProviderTaskStatus;
};

/** Status of an ISP Task according to the Provider. */
export enum InternetServicePlanProviderTaskStatus {
  /** Task has been completed */
  Complete = 'COMPLETE',
  /** Task is in progress. */
  InProgress = 'IN_PROGRESS',
  /** Task has not yet started. */
  Pending = 'PENDING'
}

/** Internal user responsible for fulfillment/support of an ISP. */
export type InternetServicePlanSupportUser = {
  __typename?: 'InternetServicePlanSupportUser';
  /** All support roles for this user. */
  supportRoles: Array<SupportUser>;
  /**
   * Deprecated: Use supportRoles instead. Returns only the first support role
   * for this user. If the user has multiple support roles, the others are not
   * included. May return null if the user has no support roles.
   * @deprecated Use `supportRoles` instead. Only returns the first support role.
   */
  supportUser?: Maybe<SupportUser>;
  /** Describes the type of role the user is fulfilling for the plan. */
  type: InternetServicePlanSupportUserType;
  /** Associated user. */
  user: User;
};

/** Input type for users associated with an Internet Service Plan. */
export type InternetServicePlanSupportUserInput = {
  /** Describes the type of role the user is fulfilling for the plan. */
  type: InternetServicePlanSupportUserType;
  /** ID of the user to associate. */
  userID: Scalars['ID']['input'];
};

/** Type of role the user is fulfilling for the plan. */
export enum InternetServicePlanSupportUserType {
  /** Primary support person, typically a program manager. */
  Primary = 'PRIMARY',
  /** Secondary support person, typically an ops associate. */
  Secondary = 'SECONDARY'
}

/** Input values for invalidating connected devices. */
export type InvalidatePhyInterfaceConnectedDevicesInput = {
  /** When the connected devices are invalidated at. Defaults to now if not set, can be set to null to clear. */
  invalidatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input parameters for inviting a Client VPN client. */
export type InviteClientVpnClientInput = {
  /** The email of the client to invite to the VPN server. If the user does not exist, a new dashboard user account will be created otherwise the existing user will simply receive an email with a link to the VPN server self-service page. */
  email: Scalars['String']['input'];
};

/** An ISP VLAN update for one ISP switch, sent with a firewall uplink VLAN change. */
export type IspVlanUpdateInput = {
  /**
   * The VLAN IDs to set. One of ispAVLANID or ispBVLANID must equal the uplink VLAN ID being set.
   * resetToDefaults is ignored.
   */
  input: SetIspVlaNsInput;
  /** The UUID of the ISP switch virtual device. */
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/**
 * The pair of ISP isolation VLAN IDs for an ISP switch. Each ISP switch splits its ports
 * between two ISP VLANs, one per ISP connection, so that traffic from one ISP is never
 * sent to the other. These are not network VLANs and are only ever configured on the ISP switch.
 */
export type IspVlaNs = {
  __typename?: 'IspVLANs';
  /** UUID of the VLAN. */
  UUID: Scalars['UUID']['output'];
  /** When the VLANs were created. */
  createdAt: Scalars['DateTime']['output'];
  /** The VLAN ID for the ISP A ports. */
  ispAVLANID: Scalars['Int']['output'];
  /** The VLAN ID for the ISP B ports. */
  ispBVLANID: Scalars['Int']['output'];
  /** When the VLANs were updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The UUID of the virtual device the VLAN pair belongs to. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** The type of issue the customer is experiencing. */
export enum IssueType {
  /** A feature is not working as expected. */
  BrokenFeature = 'BROKEN_FEATURE',
  /** Change config or add config. */
  ChangeConfig = 'CHANGE_CONFIG',
  /** Spotty connection to the network. */
  IntermittenConnectivity = 'INTERMITTEN_CONNECTIVITY',
  /** The network is slower than expected. */
  Slow = 'SLOW',
  /** Unable to connect to network. */
  UnableToConnect = 'UNABLE_TO_CONNECT',
  /** Unknown issue type. */
  Unknown = 'UNKNOWN'
}

/**
 * L3 configuration for a device profile, grouping the routing layer and the
 * underlay address. Additional L3-related settings should be added here.
 */
export type L3Configuration = {
  __typename?: 'L3Configuration';
  /** If true, the device runs OSPF on the underlay loopback interface's IP. Only enabled when L3 is enabled. */
  isOSPFEnabled: Scalars['Boolean']['output'];
  /** The routing layer of the device profile. L3_ROUTING indicates L3 is enabled. */
  routingLayer: NetworkRoutingLayer;
  /** The underlay address assigned to the device profile. Only set when L3 is enabled. */
  underlayAddress?: Maybe<Scalars['IPV4']['output']>;
};

/** Input for configuring L3 on a device profile. */
export type L3ConfigurationInput = {
  /** If true, the device will enable OSPF with the underlay loopback interface's IP address. OSPF can only be enabled on a device that has L3 enabled. */
  isOSPFEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The routing layer to set on the device profile. Set to L3_ROUTING to enable L3. The network must also have L3 enabled. */
  routingLayer?: InputMaybe<NetworkRoutingLayer>;
  /**
   * The underlay address to assign to the device profile. Must come from the network's underlay pool.
   * If omitted when enabling L3, an address is automatically assigned from the pool.
   * It cannot be set on a device that does not have L3 enabled, and cannot be removed while L3 is enabled.
   */
  underlayAddress?: InputMaybe<Scalars['IPV4']['input']>;
};

/** Represents an LLDP entry emitted from a device. */
export type LldpEntry = {
  __typename?: 'LLDPEntry';
  /** The chassis ID emitted by the device, refer to `chassisSubtype` for what this corresponds to. */
  chassisID?: Maybe<Scalars['String']['output']>;
  /** The type of data represented by `chassisID`. */
  chassisSubtype?: Maybe<LldpEntryChassisSubtype>;
  /** When this entry was last observed. */
  observedAt: Scalars['DateTime']['output'];
  /** The physical interface of the receiving Meter device. */
  phyInterface?: Maybe<PhyInterface>;
  /** The port number on the receiving Meter device. */
  portNumber: Scalars['Int']['output'];
  /** The type of data represented by `remoteID`. */
  portSubtype?: Maybe<LldpEntryPortSubtype>;
  /** The remote ID emitted by the device, refer to `portSubtype` for what this corresponds to. */
  remoteID?: Maybe<Scalars['String']['output']>;
  /** The IP address emitted by the device. */
  remoteIPAddress?: Maybe<Scalars['IP']['output']>;
  /** The system description emitted by the device. */
  systemDescription?: Maybe<Scalars['String']['output']>;
  /** The system name emitted by the device. */
  systemName?: Maybe<Scalars['String']['output']>;
};

/** An LLDP entry's reported chassis subtype. */
export enum LldpEntryChassisSubtype {
  /** Cassis component */
  ChassisComponent = 'CHASSIS_COMPONENT',
  /** Interface alias */
  InterfaceAlias = 'INTERFACE_ALIAS',
  /** Interface name */
  InterfaceName = 'INTERFACE_NAME',
  /** Local */
  Local = 'LOCAL',
  /** MAC address */
  MacAddress = 'MAC_ADDRESS',
  /** Network address */
  NetworkAddress = 'NETWORK_ADDRESS',
  /** Port component */
  PortComponent = 'PORT_COMPONENT',
  /** Unspecified */
  Unspecified = 'UNSPECIFIED'
}

/** An LLDP entry's reported port subtype. */
export enum LldpEntryPortSubtype {
  /** Agent circuit ID */
  AgentCircuitId = 'AGENT_CIRCUIT_ID',
  /** Interface alias */
  InterfaceAlias = 'INTERFACE_ALIAS',
  /** Interface name */
  InterfaceName = 'INTERFACE_NAME',
  /** Local */
  Local = 'LOCAL',
  /** MAC address */
  MacAddress = 'MAC_ADDRESS',
  /** Network address */
  NetworkAddress = 'NETWORK_ADDRESS',
  /** Port component */
  PortComponent = 'PORT_COMPONENT',
  /** Unspecified */
  Unspecified = 'UNSPECIFIED'
}

/** A lab reservation for a lab resource. */
export type LabReservation = {
  __typename?: 'LabReservation';
  /** The unique identifier for this reservation. */
  UUID: Scalars['UUID']['output'];
  /** The end time of this reservation. */
  endTime: Scalars['DateTime']['output'];
  /** The lab resources this reservation holds. Always at least one. */
  labResources: Array<LabResource>;
  /** The note for this reservation. */
  note: Scalars['String']['output'];
  /** The user who made this reservation (api identities are exclusded) */
  reservedBy?: Maybe<User>;
  /** The start time of this reservation. */
  startTime: Scalars['DateTime']['output'];
};

/** A page of lab reservations. */
export type LabReservationPage = {
  __typename?: 'LabReservationPage';
  /** The page the cursor points to. */
  currentPage: Scalars['Int']['output'];
  /** The items in this page. */
  items: Array<LabReservation>;
  /** The cursor for the next page. */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /** The cursor for the previous page. */
  previousCursor?: Maybe<Scalars['String']['output']>;
  /** The total number of lab reservations matching the filters. */
  totalCount: Scalars['Int']['output'];
  /** The total number of pages. */
  totalPages: Scalars['Int']['output'];
};

/** A lab resource that can be reserved (Like a phone, laptop, etc) */
export type LabResource = {
  __typename?: 'LabResource';
  /** The unique identifier for this resource. */
  UUID: Scalars['UUID']['output'];
  /** The children of this resource. */
  children: Array<LabResource>;
  /** Reservations affecting this resource now or within the next week ordered by start time. */
  currentAndUpcomingReservations: Array<LabReservation>;
  /** The kind of this resource. */
  kind: Scalars['String']['output'];
  /** The label of this resource. */
  label: Scalars['String']['output'];
  /** The metadata for this resource. */
  metadata: Scalars['JSONObject']['output'];
  /** The parent of this resource. */
  parent?: Maybe<LabResource>;
  /** Whether this resource is held right now */
  status: LabResourceStatus;
};

/**
 * Whether a lab resource can be reserved right now. A parent reports PARTIALLY_AVAILABLE when
 * some of what it contains is held
 */
export enum LabResourceStatus {
  /** Nothing in this resource or inside it is held. */
  Available = 'AVAILABLE',
  /** This resource is held, or sits inside a parent that is. */
  Held = 'HELD',
  /** Some of what this parent contains is held, but not all of it. */
  PartiallyAvailable = 'PARTIALLY_AVAILABLE'
}

/**
 * Contains the kea statistics for a specific subnet. Further documentation for these values can be found at
 * https://kea.readthedocs.io/en/kea-2.2.0/arm/dhcp4-srv.html#dhcp4-stats.
 */
export type LatestDhcpRuleStats = {
  __typename?: 'LatestDHCPRuleStats';
  /**
   * Number of assigned addresses in a given subnet. It increases every time a new lease is allocated (as a result of
   * receiving a DHCPREQUEST message) and decreases every time a lease is released (a DHCPRELEASE message is received)
   * or expires.
   */
  assignedAddresses: Scalars['Int']['output'];
  /**
   * Number of IPv4 addresses that are currently declined in a given subnet; a count of the number of leases currently
   * unavailable. Once a lease is recovered, this statistic is decreased; ideally, this statistic should be zero.
   * If this statistic is non-zero or increasing, a network administrator should investigate whether there is a
   * misbehaving device in the network.
   */
  declinedAddresses: Scalars['Int']['output'];
  /**
   * Number of times an IPv4 lease had its CLTT increased in memory and its expiration time left unchanged in persistent
   * storage as part of the lease caching feature. This is referred to as a lease reuse.
   */
  leaseReuses: Scalars['Int']['output'];
  /** The time these stats were observed. */
  observedAt: Scalars['DateTime']['output'];
  /**
   * Number of IPv4 addresses that were declined, but have now been recovered. Unlike declined-addresses, this statistic
   * never decreases. It can be used as a long-term indicator of how many actual valid declines were processed and
   * recovered from.
   */
  reclaimedDeclinedAddresses: Scalars['Int']['output'];
  /**
   * Number of expired leases associated with a given subnet (id is the subnet-id) that have been reclaimed since server
   * startup. It is incremented each time an expired lease is reclaimed.
   */
  reclaimedLeases: Scalars['Int']['output'];
  /**
   * Number of host reservation allocation conflicts which have occurred in a specific subnet. When a client sends a
   * DHCP Discover and is matched to a host reservation which is already leased to another client, this counter is
   * increased by 1.
   */
  reservationConflicts: Scalars['Int']['output'];
  /**
   * Total number of addresses available for DHCPv4 management; in other words, this is the sum of all addresses in all
   * configured pools. This statistic changes only during configuration updates. It does not take into account any
   * addresses that may be reserved due to host reservation.
   */
  totalAddresses: Scalars['Int']['output'];
};

/** A route reported in a device's routing table. */
export type LearnedRoute = {
  /** Whether the route is installed in the forwarding table. */
  installedToFIB: Scalars['Boolean']['output'];
  /** The next hop address for the route. */
  nextHop: Scalars['IP']['output'];
  /** When the routing table containing this route was reported. */
  observedAt: Scalars['DateTime']['output'];
  /** The destination prefix of the route. */
  prefix: Scalars['IPPrefix']['output'];
  /** The protocol that installed this route. Null if the device did not report one. */
  sourceProtocol?: Maybe<RouteSourceProtocol>;
};

/** Availability of an ISP product */
export enum LocationProviderAvailability {
  /** Location is near existing infrastructure. */
  NearNet = 'NEAR_NET',
  /** Location is not near any existing infrastructure. */
  OffNet = 'OFF_NET',
  /** Connection exists at location. */
  OnNet = 'ON_NET',
  /** Availability unknown */
  Unknown = 'UNKNOWN'
}

/** All sources of availability of an ISP product and the overall decision on availability. */
export type LocationProviderAvailabilityData = {
  __typename?: 'LocationProviderAvailabilityData';
  /** All sources of availability of an ISP product. */
  availabilities?: Maybe<Array<LocationProviderAvailabilitySource>>;
  /** Chosen availability. */
  availability?: Maybe<LocationProviderAvailability>;
};

/** Availability of an ISP product and the source of that data. */
export type LocationProviderAvailabilitySource = {
  __typename?: 'LocationProviderAvailabilitySource';
  /** UUID of the availability record. Null for availabilities derived from existing Internet Service Plans. */
  UUID?: Maybe<Scalars['UUID']['output']>;
  /** Availability of an ISP product. */
  availability?: Maybe<LocationProviderAvailability>;
  /** ISP product. */
  connectionType?: Maybe<InternetServicePlanConnectionType>;
  /** Provider the availability applies to. */
  provider?: Maybe<InternetServicePlanProvider>;
  /** Whether a NEAR_NET or OFF_NET availability makes the product recommendable. Null when not set. */
  recommendable?: Maybe<Scalars['Boolean']['output']>;
  /** Source of the data determining availabilty. */
  source?: Maybe<QuoteSource>;
};

/** An attribute key present on device logs, with its number of occurrences. */
export type LogAttributeKey = {
  __typename?: 'LogAttributeKey';
  /** Number of log entries carrying this attribute in the time window. */
  count: Scalars['Int']['output'];
  /** The attribute key. */
  key: Scalars['String']['output'];
};

/** A single attribute value with its occurrence count. */
export type LogAttributeValueCount = {
  __typename?: 'LogAttributeValueCount';
  /** Number of log entries with this value in the time window. */
  count: Scalars['Int']['output'];
  /** The attribute value. */
  value: Scalars['String']['output'];
};

/** Attribute values ranked by occurrence count for a single device log attribute key. */
export type LogAttributeValueCounts = {
  __typename?: 'LogAttributeValueCounts';
  /** The attribute key. */
  key: Scalars['String']['output'];
  /** Values ranked by occurrence count, descending. */
  values: Array<LogAttributeValueCount>;
};

/** Sampled distinct values for a single device log attribute key. */
export type LogAttributeValues = {
  __typename?: 'LogAttributeValues';
  /** The attribute key. */
  key: Scalars['String']['output'];
  /** Distinct sample values for the key. An arbitrary sample, not ranked by frequency. */
  values: Array<Scalars['String']['output']>;
};

/** A time-bucketed histogram of log counts grouped by a chosen field or attribute. */
export type LogHistogram = {
  __typename?: 'LogHistogram';
  /** The time buckets. */
  buckets: Array<LogHistogramBucket>;
};

/** Per-group log counts for a single time bucket. */
export type LogHistogramBucket = {
  __typename?: 'LogHistogramBucket';
  /** Start of the time bucket. */
  bucketStart: Scalars['DateTime']['output'];
  /** Per-group counts within this bucket. */
  counts: Array<LogHistogramCount>;
};

/** Count of log entries for a single group value. */
export type LogHistogramCount = {
  __typename?: 'LogHistogramCount';
  /** Number of log entries with this group value in the bucket. */
  count: Scalars['Int']['output'];
  /** The group value. Null means the rollup of all values outside the top maxGroups groups. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Fields of a device log that logHistogram can group by. */
export enum LogHistogramField {
  /** Group by the serial number of the device that emitted the log. */
  SerialNumber = 'SERIAL_NUMBER',
  /** Group by the service or unit that emitted the log. */
  Service = 'SERVICE',
  /** Group by severity. Values are the raw severity text (e.g. "error"). */
  Severity = 'SEVERITY'
}

/** What to group log counts by. Exactly one field must be provided. */
export type LogHistogramGroupByInput = {
  /** A log attribute key to group by. Logs without the attribute group under the empty string. */
  attributeKey?: InputMaybe<Scalars['String']['input']>;
  /** A predefined log field to group by. */
  field?: InputMaybe<LogHistogramField>;
};

/** A log message pattern mined from a random sample of device logs. */
export type LogPattern = {
  __typename?: 'LogPattern';
  /** Time-bucketed counts of sampled lines; empty buckets are omitted. */
  buckets: Array<LogPatternBucket>;
  /** Number of sampled log lines matching this pattern. */
  count: Scalars['Int']['output'];
  /** Percentage of sampled lines matching this pattern. */
  coverage: Scalars['Float']['output'];
  /** Estimated total matching lines, extrapolated from the sample. */
  estimatedTotal: Scalars['Int']['output'];
  /** Identifier of the pattern's cluster within this result. */
  id: Scalars['Int']['output'];
  /** The mined pattern: the log message with variables masked (e.g. <:IP:>) and wildcards where unmasked values vary. */
  pattern: Scalars['String']['output'];
  /** An example log line matching this pattern. */
  sample: Scalars['String']['output'];
};

/** A single time bucket of a log pattern's counts. */
export type LogPatternBucket = {
  __typename?: 'LogPatternBucket';
  /** Start of the time bucket. */
  bucketStart: Scalars['DateTime']['output'];
  /** Number of sampled log lines in this bucket. */
  count: Scalars['Int']['output'];
};

/** Log patterns mined from a random sample of device logs. */
export type LogPatternsResult = {
  __typename?: 'LogPatternsResult';
  /** The mined patterns, most frequent first. */
  patterns: Array<LogPattern>;
  /** Number of log lines that were sampled and mined. */
  sampledCount: Scalars['Int']['output'];
  /** Total number of log lines matching the filter. */
  totalCount: Scalars['Int']['output'];
};

/** Severity level of a device log entry. */
export enum LogSeverity {
  /** Debug log. */
  Debug = 'DEBUG',
  /** Error log. */
  Error = 'ERROR',
  /** Informational log. */
  Informational = 'INFORMATIONAL',
  /** Notice log. */
  Notice = 'NOTICE',
  /** Warning log. */
  Warning = 'WARNING'
}

/** Count of log entries for a single severity level. */
export type LogSeverityCount = {
  __typename?: 'LogSeverityCount';
  /** Number of log entries with this severity in the bucket. */
  count: Scalars['Int']['output'];
  /** Severity level. */
  level?: Maybe<LogSeverity>;
};

/** A time-bucketed histogram of log counts by severity. */
export type LogSeverityHistogram = {
  __typename?: 'LogSeverityHistogram';
  /** The time buckets. */
  buckets: Array<LogSeverityHistogramBucket>;
};

/** Per-severity log counts for a single time bucket. */
export type LogSeverityHistogramBucket = {
  __typename?: 'LogSeverityHistogramBucket';
  /** Start of the time bucket. */
  bucketStart: Scalars['DateTime']['output'];
  /** Per-severity counts within this bucket. */
  counts: Array<LogSeverityCount>;
};

/** Represents a mapping between a MAC address and its human-friendly alias within a specific company. */
export type MacAddressAlias = {
  __typename?: 'MACAddressAlias';
  /**
   * The MAC address of the device.
   * @deprecated Use `macAddress` instead.
   */
  MACAddress: Scalars['MacAddress']['output'];
  /** The human-friendly name assigned to the MAC address. */
  alias: Scalars['String']['output'];
  /** The unique slug identifier of the company that owns this MAC address alias. */
  companySlug: Scalars['String']['output'];
  /** The MAC address of the device. */
  macAddress: Scalars['MacAddress']['output'];
};

/** The Switch and PhyInterface that a client MAC address is associated with. */
export type MacAddressSwitchEntry = {
  __typename?: 'MACAddressSwitchEntry';
  /** The physical interface on the switch that the client MAC address is connected to. */
  phyInterface: PhyInterface;
  /** The switch virtual device that the client MAC address is associated with. */
  virtualDevice: VirtualDevice;
};

/** Client TX and RX counts for a single MCS index bucket. */
export type McsBucketCount = {
  __typename?: 'MCSBucketCount';
  /** The maximum MCS index of this bucket (inclusive). */
  max: Scalars['Int']['output'];
  /** The minimum MCS index of this bucket (inclusive). */
  min: Scalars['Int']['output'];
  /** Number of clients whose p50 RX MCS falls in this bucket. */
  rxClients: Scalars['Int']['output'];
  /** Number of clients whose p50 TX MCS falls in this bucket. */
  txClients: Scalars['Int']['output'];
};

/** Represents a mailing address with optional coordinates and timezone. */
export type MailingAddress = {
  __typename?: 'MailingAddress';
  /** The unique identifier of the mailing address. */
  UUID: Scalars['UUID']['output'];
  /** The city of the mailing address. */
  city?: Maybe<Scalars['String']['output']>;
  /** The geographical coordinates of the mailing address. */
  coordinates?: Maybe<Coordinates>;
  /** The two-letter ISO code of the country. */
  countryISO2?: Maybe<Scalars['String']['output']>;
  /** The Salesforce Opportunity Location ID corresponding to this mailing address. */
  externalID?: Maybe<Scalars['String']['output']>;
  /** The first line of the mailing address. */
  line1?: Maybe<Scalars['String']['output']>;
  /** The second line of the mailing address. */
  line2?: Maybe<Scalars['String']['output']>;
  /** Network associated with the location. */
  networks?: Maybe<Array<Network>>;
  /** The postal code or ZIP code of the mailing address. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The square footage of the location associated with the mailing address. */
  squareFeet?: Maybe<Scalars['Int']['output']>;
  /** The subdivision code, such as the state or province code. */
  subdivisionCode?: Maybe<Scalars['String']['output']>;
  /** The timezone associated with the mailing address. */
  timezone: Scalars['String']['output'];
};

/** Filter input for MailingAddress fields. */
export type MailingAddressFilterInput = {
  /** Substring to filter address parts on. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** UUID of company to filter on.  Filters MailingAddresses associated with other company networks. */
  companyUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Page of MailingAddresses */
export type MailingAddressPage = {
  __typename?: 'MailingAddressPage';
  /** The results for this page. */
  items: Array<MailingAddress>;
  /** The total number of results available based on the provided filters. */
  total: Scalars['Int']['output'];
};

/** Defines a periodic window of time during which customers prefer that maintenance be performed on a network. */
export type MaintenanceWindow = {
  __typename?: 'MaintenanceWindow';
  /** The unique identifier for the maintenance window. */
  UUID: Scalars['UUID']['output'];
  /** The ending day of the week for the maintenance window, in local time (0-6, where 0 is Sunday). */
  endDayOfWeekLocal?: Maybe<Scalars['Int']['output']>;
  /** The ending hour of the maintenance window, in local time (0-23). */
  endHourOfDayLocal?: Maybe<Scalars['Int']['output']>;
  /** For DAILY recurrence windows only. Specifies days of the week (0-6, where 0 is Sunday) to exclude from the maintenance window. */
  excludedDaysOfWeek?: Maybe<Array<Scalars['Int']['output']>>;
  /** Indicates whether the maintenance window is opted out (true) or not (false). If true, maintenance should not be performed during this window. */
  isOptedOut: Scalars['Boolean']['output'];
  /** The unique identifier of the network associated with this maintenance window. */
  networkUUID: Scalars['UUID']['output'];
  /** The recurrence pattern of the maintenance window (daily or weekly). */
  recurrence: MaintenanceWindowRecurrence;
  /** The starting day of the week for the maintenance window, in local time (0-6, where 0 is Sunday). */
  startDayOfWeekLocal?: Maybe<Scalars['Int']['output']>;
  /** The starting hour of the maintenance window, in local time (0-23). */
  startHourOfDayLocal?: Maybe<Scalars['Int']['output']>;
  /** The IANA timezone identifier (e.g., 'America/New_York') for the maintenance window. */
  timezone?: Maybe<Scalars['String']['output']>;
};

/** Defines the recurrence patterns for maintenance windows. */
export enum MaintenanceWindowRecurrence {
  /** Indicates a daily recurrence pattern. */
  Daily = 'DAILY',
  /** Indicates a weekly recurrence pattern. */
  Weekly = 'WEEKLY'
}

/** Represents the management connection result for a virtual device. */
export type ManagementConnection = {
  __typename?: 'ManagementConnection';
  /** The type of management connection (WAN, LTE, Disconnected). */
  connectionType: ManagementConnectionType;
  /** The timestamp when the connection was observed. */
  observedAt: Scalars['DateTime']['output'];
};

/** Properties for management connection status change events. */
export type ManagementConnectionStatusChangeProperties = {
  __typename?: 'ManagementConnectionStatusChangeProperties';
  /** The new management connection type. */
  connectionType: ManagementConnectionType;
  /** The virtual device associated with the management connection status change. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** Enumerates the connection types for management plane traffic to the controller */
export enum ManagementConnectionType {
  /** Indicates that the device is disconnected. */
  Disconnected = 'DISCONNECTED',
  /** Indicates that the device is connected via LTE. */
  Lte = 'LTE',
  /** Indicates that the device is connected via WAN. */
  Wan = 'WAN'
}

/** Marketing changelog entries are used to display informational alerts about product releases to customers. */
export type MarketingChangelogEntry = {
  __typename?: 'MarketingChangelogEntry';
  /** Unique identifier of the marketing changelog entry. */
  UUID: Scalars['UUID']['output'];
  /** Properties to display inside a badge alongside the changelog entry. */
  badge?: Maybe<DisplayBadge>;
  /** Descriptive copy text for the marketing changelog entry. */
  copy?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the entry was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Informational heading text for the marketing changelog entry. */
  heading: Scalars['String']['output'];
  /** S3 keys for an image to display alongside the entry. */
  imageS3Keys?: Maybe<ThemedImageS3Keys>;
  /** A destination to link to that contains more information about the changelog entry. */
  linkURL?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the entry was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** When the entry stops being visible to customers. */
  visibleEndAt: Scalars['DateTime']['output'];
  /** When the entry starts being visible to customers. */
  visibleStartAt: Scalars['DateTime']['output'];
};

export type MetricsFilterInput = {
  /** The total duration in seconds for which to retrieve metrics data. Maximum set to 1 year. */
  durationSeconds: Scalars['Int']['input'];
  /** If not provided, endTime defaults to now. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The interval in seconds between data points in the metrics response. */
  stepSeconds: Scalars['Int']['input'];
};

/** Metadata providing the minimum and maximum values among all metrics data points. */
export type MetricsMetadata = {
  __typename?: 'MetricsMetadata';
  /** The maximum value among all metrics data points. */
  maxValue: Scalars['Float']['output'];
  /** The minimum value among all metrics data points. */
  minValue: Scalars['Float']['output'];
};

/** Represents a response containing metrics data points and associated metadata. */
export type MetricsResponse = {
  /** Metadata providing additional information about the metrics data. */
  metadata?: Maybe<MetricsMetadata>;
  /** The list of metrics data points. */
  values: Array<MetricsValue>;
};

export type MetricsSerialNumberDirectionInput = {
  /** Specify which traffic directions are queried for. */
  directions: Array<TrafficDirection>;
  /** The serial number of the device for which the metrics are requested. */
  serialNumber: Scalars['String']['input'];
};

/** Summary statistics over a metrics series' window. Units are those of the series being summarized. */
export type MetricsSummary = {
  __typename?: 'MetricsSummary';
  /** The mean rate over every bucket in the window, including buckets with no data. */
  averagePerSecond: Scalars['Float']['output'];
  /** The highest bucket rate in the window. */
  maxPerSecond: Scalars['Float']['output'];
  /** The total quantity accumulated over the window. */
  total: Scalars['Float']['output'];
};

/** Represents a single data point in a metrics time series, including its timestamp and value. */
export type MetricsValue = {
  /** The timestamp for this metrics data point. */
  timestamp: Scalars['DateTime']['output'];
  /** The value of the metric at the given timestamp. */
  value: Scalars['Float']['output'];
};

export type MintTokenInput = {
  /** The permissions that this token should contain. */
  permissions?: InputMaybe<Array<Permission>>;
  /** The principal name for the token. For devices, the serial number; for machines, the machine name; for users, the user name. */
  principalName: Scalars['String']['input'];
  /** If the principal type is MACHINE, allows assigning a role to the principalName. */
  principalRole?: InputMaybe<RoleName>;
  /** The principal type for the token. */
  principalType: PrincipalType;
  /** How long from now the token is valid. If null, the token does not expire. */
  validityDuration?: InputMaybe<Scalars['Duration']['input']>;
};

/** Represents a newly minted (issued) token. */
export type MintedToken = {
  __typename?: 'MintedToken';
  /** The encoded string of the token. */
  encoded: Scalars['String']['output'];
  /** The epoch time when the token was issued. */
  epoch: Scalars['String']['output'];
  /** The list of permissions assigned to the token. */
  permissions: Array<Permission>;
  /** The principal (entity) for which the token is issued. */
  principal: TokenPrincipal;
  /** The realm associated with the token. */
  realm: Scalars['String']['output'];
  /** The unique identifier assigned to the token. */
  tokenId: Scalars['String']['output'];
  /** The type of the token. */
  tokenType: TokenType;
};

/** The network has no default VLAN. */
export type MissingDefaultVlanActiveIssue = ActiveIssue & {
  __typename?: 'MissingDefaultVLANActiveIssue';
  /** When the issue was first detected, if available. */
  detectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The network that this issue is impacting. */
  networkUUID: Scalars['UUID']['output'];
  /** When the issue was resolved, if available. */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The severity of the issue. */
  severity: ActiveIssueSeverity;
  /** The type of the issue. */
  type: ActiveIssueType;
};

/** A missing hardware device active issue */
export type MissingHardwareDeviceActiveIssue = ActiveIssue & {
  __typename?: 'MissingHardwareDeviceActiveIssue';
  /** When the issue was first detected, if available */
  detectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The network that this issue is impacting */
  networkUUID: Scalars['UUID']['output'];
  /** When the issue was resolved, if available */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The severity of the issue */
  severity: ActiveIssueSeverity;
  /** The type of the issue */
  type: ActiveIssueType;
  /** The virtual devices that are missing hardware device assignments */
  virtualDevices: Array<VirtualDevice>;
};

/** DNS query probe. */
export type MonitorDnsProbe = Identifiable & MonitorProbe & {
  __typename?: 'MonitorDNSProbe';
  /** Unique identifier for this probe. */
  UUID: Scalars['UUID']['output'];
  /** Bindings of this probe to interfaces. */
  bindings: Array<MonitorProbeBinding>;
  /** When this probe was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Domain name to query. */
  domain: Scalars['String']['output'];
  /** Monitor groups that include this probe (via bindings). */
  monitorGroups: Array<MonitorGroup>;
  /** This probe's network. */
  network: Network;
  /** Unique identifier for this probe's network. */
  networkUUID: Scalars['UUID']['output'];
  /** DNS server port. */
  port?: Maybe<Scalars['Int']['output']>;
  /** Time between probe attempts. */
  probeInterval: Scalars['Duration']['output'];
  /** Random jitter added to probe interval. */
  probeJitter: Scalars['Duration']['output'];
  /** Maximum time to wait for probe response. */
  probeTimeout: Scalars['Duration']['output'];
  /** Type of probe. */
  probeType: MonitorProbeType;
  /** DNS query class. */
  qclass?: Maybe<Scalars['Int']['output']>;
  /** DNS query type. */
  qtype?: Maybe<Scalars['Int']['output']>;
  /** DNS server IP address. */
  serverIP: Scalars['String']['output'];
  /** When this probe was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Evaluation parameters for probe health assessment. */
export type MonitorEvalParams = {
  __typename?: 'MonitorEvalParams';
  /** EWMA smoothing factor (0-1). */
  alpha?: Maybe<Scalars['Float']['output']>;
  /** Number of probe results to keep in history. */
  historySize?: Maybe<Scalars['Int']['output']>;
  /** Jitter threshold for degraded state. */
  jitterDegrade?: Maybe<Scalars['Duration']['output']>;
  /** Jitter threshold for recovery. */
  jitterRecover?: Maybe<Scalars['Duration']['output']>;
  /** RTT threshold for degraded state. */
  rttDegrade?: Maybe<Scalars['Duration']['output']>;
  /** RTT threshold for recovery. */
  rttRecover?: Maybe<Scalars['Duration']['output']>;
  /** Success rate threshold for degraded state (0-1). */
  successDegrade?: Maybe<Scalars['Float']['output']>;
  /** Success rate threshold for recovery (0-1). */
  successRecover?: Maybe<Scalars['Float']['output']>;
};

/** Input for evaluation parameters. */
export type MonitorEvalParamsInput = {
  /** EWMA smoothing factor (0-1). */
  alpha?: InputMaybe<Scalars['Float']['input']>;
  /** Number of probe results to keep in history. */
  historySize?: InputMaybe<Scalars['Int']['input']>;
  /** Jitter threshold for degraded state. */
  jitterDegrade?: InputMaybe<Scalars['Duration']['input']>;
  /** Jitter threshold for recovery. */
  jitterRecover?: InputMaybe<Scalars['Duration']['input']>;
  /** RTT threshold for degraded state. */
  rttDegrade?: InputMaybe<Scalars['Duration']['input']>;
  /** RTT threshold for recovery. */
  rttRecover?: InputMaybe<Scalars['Duration']['input']>;
  /** Success rate threshold for degraded state (0-1). */
  successDegrade?: InputMaybe<Scalars['Float']['input']>;
  /** Success rate threshold for recovery (0-1). */
  successRecover?: InputMaybe<Scalars['Float']['input']>;
};

/** A group of health monitoring probes for policy routing. */
export type MonitorGroup = Identifiable & {
  __typename?: 'MonitorGroup';
  /** Unique identifier for this group. */
  UUID: Scalars['UUID']['output'];
  /** When this group was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Probe bindings in this group. */
  members: Array<MonitorGroupMember>;
  /** Name of the group. */
  name: Scalars['String']['output'];
  /** This group's network. */
  network: Network;
  /** Unique identifier for this group's network. */
  networkUUID: Scalars['UUID']['output'];
  /** Percentage of probes that must be healthy (0-100.00). */
  requiredHealthyPercent: Scalars['Float']['output'];
  /** When this group was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The reported state of a monitor group. */
export type MonitorGroupEvent = {
  __typename?: 'MonitorGroupEvent';
  /** The monitor group. */
  group?: Maybe<MonitorGroup>;
  /** The unique identifier for the monitor group. */
  groupUUID: Scalars['UUID']['output'];
  /** The timeseries responses of the number of healthy members in the group over time. */
  healthyMembers: BaseMetricsResponse;
  /** The timeseries responses of the percentage of healthy members in the group over time. */
  healthyMembersPercentage: BaseMetricsResponse;
  /** The reported state of the group's members. */
  members: Array<MonitorGroupMemberEvent>;
  /** The current number of required healthy members. */
  requiredHealthyMembers: Scalars['Int']['output'];
  /** The virtual device reporting the state of the group. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The unique identifier of the virtual device reporting the state of the group. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** A probe binding member of a monitor group with evaluation parameters. */
export type MonitorGroupMember = {
  __typename?: 'MonitorGroupMember';
  /** The probe binding. */
  binding: MonitorProbeBinding;
  /** Evaluation parameters for this binding. */
  evalParams: MonitorEvalParams;
  /** The monitor group. */
  group: MonitorGroup;
};

/** The reported state of a monitor group member. */
export type MonitorGroupMemberEvent = {
  __typename?: 'MonitorGroupMemberEvent';
  /** The current state of the member. */
  currentState?: Maybe<MonitorGroupMemberEventState>;
  /** The timeseries responses of the member's exponentially weighted moving average of jitter in nanoseconds. */
  ewmaJitterNs: BaseMetricsResponse;
  /** The timeseries responses of the member's exponentially weighted moving average of round trip time in nanoseconds. */
  ewmaRttNs: BaseMetricsResponse;
  /** The unique identifier for the group that contains this member. */
  groupUUID: Scalars['UUID']['output'];
  /** The member. */
  member?: Maybe<MonitorGroupMember>;
  /** The unique identifier for the probe binding. */
  probeBindingUUID: Scalars['UUID']['output'];
  /** The current state of the member. */
  state: MonitorGroupMemberEventStateMetricsResponse;
  /** The timeseries responses of the member's success ratio. */
  successRatio: BaseMetricsResponse;
};

/** The state of a monitor group member. */
export enum MonitorGroupMemberEventState {
  /** The member is considered degraded. */
  Degraded = 'DEGRADED',
  /** The member is considered down. */
  Down = 'DOWN',
  /** The member is considered up. */
  Up = 'UP'
}

/** Response type containing monitor group member state metrics. */
export type MonitorGroupMemberEventStateMetricsResponse = {
  __typename?: 'MonitorGroupMemberEventStateMetricsResponse';
  /** List of member state metrics values. */
  values: Array<MonitorGroupMemberEventStateMetricsValue>;
};

/** Represents a monitor group member's state metric value for a specific timestamp. */
export type MonitorGroupMemberEventStateMetricsValue = {
  __typename?: 'MonitorGroupMemberEventStateMetricsValue';
  /** The time at which the measurement was recorded. */
  timestamp: Scalars['DateTime']['output'];
  /** The state of the member. */
  value?: Maybe<MonitorGroupMemberEventState>;
};

/** Input for specifying a monitor group member. */
export type MonitorGroupMemberInput = {
  /** Evaluation parameters for this probe binding. */
  evalParams?: InputMaybe<MonitorEvalParamsInput>;
  /** The monitor probe binding UUID. */
  monitorProbeBindingUUID: Scalars['UUID']['input'];
};

/** ICMP ping probe. */
export type MonitorIcmpProbe = Identifiable & MonitorProbe & {
  __typename?: 'MonitorICMPProbe';
  /** Unique identifier for this probe. */
  UUID: Scalars['UUID']['output'];
  /** Target IP address or hostname. */
  address: Scalars['String']['output'];
  /** Bindings of this probe to interfaces. */
  bindings: Array<MonitorProbeBinding>;
  /** When this probe was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Monitor groups that include this probe (via bindings). */
  monitorGroups: Array<MonitorGroup>;
  /** This probe's network. */
  network: Network;
  /** Unique identifier for this probe's network. */
  networkUUID: Scalars['UUID']['output'];
  /** ICMP payload length in bytes. */
  payloadLen?: Maybe<Scalars['Int']['output']>;
  /** Time between probe attempts. */
  probeInterval: Scalars['Duration']['output'];
  /** Random jitter added to probe interval. */
  probeJitter: Scalars['Duration']['output'];
  /** Maximum time to wait for probe response. */
  probeTimeout: Scalars['Duration']['output'];
  /** Type of probe. */
  probeType: MonitorProbeType;
  /** When this probe was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A health monitoring probe (base interface for all probe types). */
export type MonitorProbe = {
  /** Unique identifier for this probe. */
  UUID: Scalars['UUID']['output'];
  /** Bindings of this probe to interfaces. */
  bindings: Array<MonitorProbeBinding>;
  /** When this probe was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Monitor groups that include this probe (via bindings). */
  monitorGroups: Array<MonitorGroup>;
  /** This probe's network. */
  network: Network;
  /** Unique identifier for this probe's network. */
  networkUUID: Scalars['UUID']['output'];
  /** Time between probe attempts. */
  probeInterval: Scalars['Duration']['output'];
  /** Random jitter added to probe interval. */
  probeJitter: Scalars['Duration']['output'];
  /** Maximum time to wait for probe response. */
  probeTimeout: Scalars['Duration']['output'];
  /** Type of probe. */
  probeType: MonitorProbeType;
  /** When this probe was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents a binding between a monitor probe and a target interface. */
export type MonitorProbeBinding = Identifiable & {
  __typename?: 'MonitorProbeBinding';
  /** Unique identifier for this binding. */
  UUID: Scalars['UUID']['output'];
  /** When this binding was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Monitor groups that include this binding. */
  monitorGroups: Array<MonitorGroup>;
  /** The probe being bound. */
  monitorProbe: MonitorProbe;
  /** Target interface for this binding. */
  targetInterface: TargetInterface;
  /** When this binding was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Type of health monitoring probe. */
export enum MonitorProbeType {
  /** DNS query probe. */
  Dns = 'DNS',
  /** ICMP ping probe. */
  Icmp = 'ICMP',
  /** TCP connection probe. */
  Tcp = 'TCP'
}

/** TCP connection probe. */
export type MonitorTcpProbe = Identifiable & MonitorProbe & {
  __typename?: 'MonitorTCPProbe';
  /** Unique identifier for this probe. */
  UUID: Scalars['UUID']['output'];
  /** Bindings of this probe to interfaces. */
  bindings: Array<MonitorProbeBinding>;
  /** When this probe was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Monitor groups that include this probe (via bindings). */
  monitorGroups: Array<MonitorGroup>;
  /** This probe's network. */
  network: Network;
  /** Unique identifier for this probe's network. */
  networkUUID: Scalars['UUID']['output'];
  /** TCP payload length in bytes. */
  payloadLen?: Maybe<Scalars['Int']['output']>;
  /** TCP server port. */
  port: Scalars['Int']['output'];
  /** Time between probe attempts. */
  probeInterval: Scalars['Duration']['output'];
  /** Random jitter added to probe interval. */
  probeJitter: Scalars['Duration']['output'];
  /** Maximum time to wait for probe response. */
  probeTimeout: Scalars['Duration']['output'];
  /** Type of probe. */
  probeType: MonitorProbeType;
  /** TCP server IP address. */
  serverIP: Scalars['String']['output'];
  /** When this probe was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Per-device placement in a bulk move to a rack elevation. */
export type MoveRackElevationDeviceInput = {
  /** The unique identifier of the device to move. */
  UUID: Scalars['UUID']['input'];
  /** Whether the device is front-facing or rear-facing. */
  isFrontFacing?: InputMaybe<Scalars['Boolean']['input']>;
  /** The indexes of the rack units that the device will occupy in the new rack. */
  rackMountUnitIndexes: Array<Scalars['Int']['input']>;
  /** A non-null value if the device shares or will share its rack mount unit with another device. Paired devices require 0 for the primary and 1 for the secondary when placing or moving them. Omitted or null values use the required index. */
  sideBySideIndex?: InputMaybe<Scalars['Int']['input']>;
};

/** Input type for moving a device to a different rack elevation. */
export type MoveRackElevationDeviceToRackInput = {
  /** Whether the device is front-facing or rear-facing. */
  isFrontFacing?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique identifier of the destination rack elevation. */
  rackElevationUUID: Scalars['UUID']['input'];
  /** The indexes of the rack units that the device will occupy in the new rack. */
  rackMountUnitIndexes: Array<Scalars['Int']['input']>;
  /** A non-null value if the device shares or will share its rack mount unit with another device. Paired devices require 0 for the primary and 1 for the secondary when placing or moving them. Omitted or null values use the required index. */
  sideBySideIndex?: InputMaybe<Scalars['Int']['input']>;
};

/** Input type for moving multiple devices to the same rack elevation atomically. */
export type MoveRackElevationDevicesToRackInput = {
  /** The devices to move and their placements in the destination rack. */
  devices: Array<MoveRackElevationDeviceInput>;
};

/** Multiselect filter implementation. */
export type MultiSelectFilter = {
  /** The key for the filter. */
  key: Scalars['String']['input'];
  /** Selected values for the filter. */
  values: Array<Scalars['String']['input']>;
};

/** The algorithm used for multi-WAN load balancing. */
export enum MultiWanAlgorithm {
  /** Use the first active WAN interface. */
  FirstActive = 'FIRST_ACTIVE',
  /** Distribute traffic across WAN interfaces in a round-robin fashion. */
  RoundRobin = 'ROUND_ROBIN'
}

/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Performs an action on a captive portal entry. */
  actionCaptivePortalEntry: CaptivePortalEntry;
  /** Re-activates a previously deleted company user, allowing them to now log in and access the dashboard for that company as before. */
  activateCompanyUser: CompanyUser;
  /** Activates a Kore Cellular SIM card. */
  activateDeviceSIM?: Maybe<SuperSim>;
  /** Adds a hub to an Auto VPN group. */
  addHubToAutoVPNGroup: AutoVpnHub;
  /** Adds a probe binding to a monitor group. */
  addMonitorGroupMember: MonitorGroup;
  /** Adds a network to an Auto VPN group. */
  addNetworkToAutoVPNGroup: AutoVpnMember;
  /** Adds networks to an Auto VPN group. */
  addNetworksToAutoVPNGroup: Array<AutoVpnMember>;
  /** Authorizes a support provider to support a target company. */
  addSupportProvider: SupportProviderCompany;
  /**
   * Recommends Meter quotes for a Quote Request's selection priorities and selects them in one transaction.
   * Matching quotes are reused, the current Meter quote at a priority is updated in place, and otherwise a quote is created.
   */
  applyQuoteRecommendations: QuoteRecommendations;
  /**
   * Apply the results of a completed Switch Auto Configuration dry run without re-querying stats.
   * Returns a new SwitchAutoConfigurationJob (with IsDryRun=false) with the results of the applied configuration.
   */
  applySwitchAutoConfigurationDryRun: SwitchAutoConfigurationJob;
  /**
   * Applies all of the configuration of a source network to a destination network.
   * The behavior is a Copy + Replace operation (ie. the destination network will have the same configuration as the source network).
   * Some network-specific fields are not copied, and the hardware from the source network is not assigned to the destination network.
   * This can only be performed on a non-active destination network because it will overwrite the configuration.
   * This is a dangerous operation and should be used only by users who know what they are doing, to kick-start a new network with the same configuration as an existing network.
   */
  applyTemplateToNetwork: Network;
  /** Approve a pending request and grant the key access to the company. */
  approvePublicAPIKeyGrantRequest: PublicApiKeyGrantRequest;
  /** Approve a pending temporary access request. Only listed approvers may approve, and not their own requests. */
  approveTemporaryAccessGrant: TemporaryAccessGrant;
  /**
   * This assigns hardware to any virtual device in a network that matches the same type/model as the hardware.
   * Not to be confused with assignSpareHardwareDeviceToNetwork.
   * If the hardware was already associated to the network as a spare, then it will be removed from the spare list.
   */
  assignHardwareDeviceToNetwork: HardwareDevice;
  /**
   * This does not assign the hardware to a virtual device, but rather to the network as a spare device.
   * Need to call assignHardwareDeviceToVirtualDevice / assignHardwareDeviceToNetwork to actually put the hardware to use.
   */
  assignHardwareDeviceToNetworkAsSpare: HardwareDevice;
  /**
   * This assigns hardware to a specific virtual device.
   * Not to be confused with assignSpareHardwareDeviceToNetwork.
   * If the hardware was already associated to the network as a spare, then it will be removed from the spare list.
   */
  assignHardwareDeviceToVirtualDevice: HardwareDevice;
  /**
   * This assigns hardware to specific virtual devices, respectively.
   * If any hardware were already associated to the network as a spare, then they will be removed from the spare list.
   */
  assignHardwareDevicesToVirtualDevices: Array<HardwareDevice>;
  /**
   * Assigns the role of operator to the user represented by this company user.
   * If companySlug is provided, the operator role is scoped to that company only.
   * If companySlug is omitted, a global operator role is assigned.
   */
  assignOperatorRole: CompanyUser;
  /**
   * Assigns the role of super operator to the user represented by this company user.
   * If companySlug is provided, the super operator role is scoped to that company only.
   * If companySlug is omitted, a global super operator role is assigned.
   */
  assignSuperOperatorRole: CompanyUser;
  /** Assign a switch profile to a virtual device. */
  assignSwitchProfleToVirtualDevice: Scalars['Boolean']['output'];
  /** Add a device to a rack elevation. If the device is paired, its partner is also placed on the same rack mount units and must not be attached to another rack elevation. */
  attachDeviceToRackElevation: RackElevation;
  /** Attach multiple devices to one or more rack elevations atomically. If a device is paired, both devices are placed on the same rack mount units and neither may already be attached to another rack elevation. */
  attachDevicesToRackElevations: Array<RackElevation>;
  /** Attaches an AP to a radio profile so that the AP can inherit the radio settings. */
  attachVirtualDeviceToRadioProfile: VirtualDevice;
  /** Binds a firewall rule to a phy interface with a given metric. Subsequent calls act as an upsert. */
  bindFirewallRuleToPhyInterface: FirewallRule;
  /** Binds a firewall rule to a VLAN with a given metric. Subsequent calls act as an upsert. */
  bindFirewallRuleToVLAN: FirewallRule;
  /**
   * Binds firewall rules to a phy interface, assigning metrics based on the UUIDs' order in `orderedRuleUUIDs`.
   * Any existing bound rules not present in `orderedRuleUUIDs` will be unbound.
   * @deprecated Use `bindPhyInterfaceToFirewallRules` instead.
   */
  bindFirewallRulesToPhyInterface: Array<FirewallPhyInterfaceBinding>;
  /**
   * Binds firewall rules to a VLAN, assigning metrics based on the UUIDs' order in `orderedRuleUUIDs`.
   * Any existing bound rules not present in `orderedRuleUUIDs` will be unbound.
   * @deprecated Use `bindVLANToFirewallRules` instead.
   */
  bindFirewallRulesToVLAN: Array<FirewallVlanBinding>;
  /**
   * Binds firewall rules to a phy interface.
   * Any existing bound rules not present in `firewallRuleUUIDs` will be unbound.
   */
  bindPhyInterfaceToFirewallRules: Array<FirewallPhyInterfaceBinding>;
  /** Bind a policy routing rule to a physical interface. */
  bindPolicyRoutingRule: PolicyRoutingRule;
  /**
   * Binds `input` to `orderedRuleUUIDs`, assigning metrics based on the order in `orderedRuleUUIDs`.
   * Any existing bound rules to `input` not present in `orderedRuleUUIDs` will be unbound.
   */
  bindPolicyRoutingRules: Array<PolicyRoutingRuleBinding>;
  /** Attach a rate limit rule to a physical interface (port). */
  bindRateLimitRuleToPhyInterface: RateLimitRule;
  /** Attach a rate limit rule to an SSID. */
  bindRateLimitRuleToSSID: RateLimitRule;
  /** Attach a rate limit rule to a VLAN. */
  bindRateLimitRuleToVLAN: RateLimitRule;
  /** Add a virtual device tag to one or many virtual devices. For now this is only supported for APs. */
  bindTagToVirtualDevices: Array<VirtualDevice>;
  /**
   * Binds firewall rules to a VLAN.
   * Any existing bound rules not present in `firewallRuleUUIDs` will be unbound.
   */
  bindVLANToFirewallRules: Array<FirewallVlanBinding>;
  /** Bind a VLAN to a physical interface to permit traffic for the VLAN to flow through the port. */
  bindVLANtoPhyInterface: Scalars['Boolean']['output'];
  /**
   * Blocks one or more clients on the given network
   * Returns the newly created blocklist entries.
   */
  blockClientsInNetwork: Array<NetworkClientBlocklistEntry>;
  /**
   * Blocks one or more clients on a specific SSID.
   * Returns the newly created blocklist entries.
   */
  blockClientsInSSID: Array<NetworkClientBlocklistEntry>;
  /** Cancel a scheduled Auto Channel Selection job that hasn't run yet. */
  cancelAutoChannelSelectionJob: AutoChannelSelectionJob;
  /** Cancel a scheduled Auto Switch Configuration job that hasn't run yet. */
  cancelAutoSwitchConfigurationJob: SwitchAutoConfigurationJob;
  /** Cancel a pending request. */
  cancelPublicAPIKeyGrantRequest: PublicApiKeyGrantRequest;
  /** Cancel a scheduled NOS upgrade. Must be SCHEDULED or IN_PROGRESS (if forceInProgressCancel is true). */
  cancelScheduledNetworkNOSUpgrade: ScheduledNetworkNosUpgrade;
  /** Cancel a wireless calibration job. */
  cancelWirelessCalibrationJob: WirelessCalibrationJob;
  /**
   * Claims a hardware device for a target realm. Service-to-service only.
   *
   * When called on prod:
   * - Checks device is not assigned to a virtual device or spare
   * - Updates realm column to forRealm
   * - Returns device data (serial, mac, model, type, batch)
   *
   * When called on non-prod (dev/EU):
   * - Checks device is not assigned locally
   * - Deletes device from local database
   * - Returns success (no device data)
   */
  claimHardwareDevice: ClaimHardwareDeviceResult;
  /** User-facing mutation that performs the full flow of enabling SSO for a company, creating a permitted email domain, and generating an admin portal URI for SSO configuration. */
  configureSSO: ConfigureSsoResult;
  /**
   * Copy one topology design into several other networks at once, so a design that was
   * generated once can be reused across multiple company's sites without regenerating it per network.
   */
  copyTopologyDesignVersionToNetworks: Array<TopologyDesignVersion>;
  /** Copy a virtual device to a new device model along with related entities. */
  copyVirtualDeviceToNewModel: VirtualDevice;
  /** Copy a set of virtual devices to new device models along with related entities. */
  copyVirtualDevicesToNewModels: Array<VirtualDevice>;
  /** Create an access point port profile for a network. Empty port bindings are automatically created for all ports. */
  createAccessPointPortProfile: AccessPointPortProfile;
  /** Create a new alert company subscription. */
  createAlertCompanySubscription: AlertCompanySubscription;
  /** Create a new fleetwide alert subscription. */
  createAlertFleetwideSubscription: AlertFleetwideSubscription;
  /**
   * Creates an alert receiver and mappings between an alert receiver and one or more alert targets
   * Alert targets must be predefined unless the alert target type is EMAIL. In that case, the email address must be
   * provided and alertTargetUUID can be left empty. An email target will be created automatically.
   */
  createAlertReceiverWithTargets: AlertReceiver;
  /** Creates an alert subscription for a support provider on a supported company. */
  createAlertSupportProviderSubscription: AlertCompanySubscription;
  /** Create a new Salesforce alert target to notify users via salesforce cases of network events. */
  createAlertTargetSalesforce: AlertTargetSalesforce;
  /** Create a new Slack alert target to notify users via slack of network events. */
  createAlertTargetSlack: AlertTargetSlack;
  /** Create a new webhook alert target to notify users via webhook of network events. */
  createAlertTargetWebhook: AlertTargetWebhook;
  /** Creates a new application DNS firewall rule for a DHCP rule. */
  createApplicationDNSFirewallRule: ApplicationDnsFirewallRule;
  /** Creates new application DNS firewall rules. */
  createApplicationDNSFirewallRules: Array<ApplicationDnsFirewallRule>;
  /** Creates an Auto VPN group. */
  createAutoVPNGroup: AutoVpnGroup;
  /** Creates an Auto VPN route on an Auto VPN group. */
  createAutoVPNRoute: AutoVpnRoute;
  /** Creates a new BGP neighbor. */
  createBGPNeighbor: BgpNeighbor;
  /** Creates a new BGP router. */
  createBGPRouter: BgpRouter;
  /** Creates a new bearer session. This mutation initiates a CLI bearer session that can be verified to obtain an authentication token. */
  createBearerSession: BearerSession;
  /** Create a new bulk NOS upgrade for a group of networks. */
  createBulkNOSUpgrade: BulkNosUpgrade;
  /** Creates a captive portal. */
  createCaptivePortal: CaptivePortal;
  /** Creates captive portals in bulk. */
  createCaptivePortals: Array<CaptivePortal>;
  /**
   * Create many cellular hardware devices. This endpoint only supports creating cellular
   * devices, all other devices should go through hardware device batches. This is because
   * cellular devices are purchased from and do not belong to a manufacturing batch.
   */
  createCellularHardwareDevices: Array<HardwareDevice>;
  /** Creates a Client VPN client on a Client VPN server. */
  createClientVPNClient: ClientVpnClient;
  /** Batch creates Client VPN clients on a Client VPN server. */
  createClientVPNClients: Array<ClientVpnClient>;
  /** Creates a Client VPN server for a network. */
  createClientVPNServer: ClientVpnServer;
  /** Create a new internal-only company. Customer companies cannot be created; they are created by the Salesforce -> Backend data sync process. */
  createCompany: Company;
  /** Creates a new company onboarding document associated with the specified company. */
  createCompanyOnboarding: CompanyOnboarding;
  /** Creates a SIEM integration for a company. */
  createCompanySIEMIntegration: CompanySiemIntegration;
  /** Creates a company user with the specified fields. If a user with the specified email already exists, this will be a no-op. */
  createCompanyUser: CompanyUser;
  /** Create a new compliance framework from JSON configuration */
  createComplianceFramework: ComplianceFramework;
  /** Create a new compliance report for a network */
  createComplianceReport: ComplianceReport;
  /** Creates a new Connect Static Rate. */
  createConnectStaticRate: ConnectStaticRate;
  /** Creates a new custom role for a company. */
  createCustomRole: CustomRole;
  /** Creates a new DDNS record. */
  createDDNSRecord: DdnsRecord;
  /** Create a new DHCP option. */
  createDHCPOption: DhcpOption;
  /** Create a new DHCP proxy. */
  createDHCPProxy: DhcpProxy;
  /** Create a new DHCP reserved range. */
  createDHCPReservedRange: DhcpReservedRange;
  /** Create a new DHCP rule. */
  createDHCPRule: DhcpRule;
  /** Creates a new DHCP rule filter. */
  createDHCPRuleFilter: DhcpRuleFilter;
  /**
   * Create a new DHCP static mapping.
   * @deprecated Use `createDHCPStaticMappings` instead.
   */
  createDHCPStaticMapping: DhcpStaticMapping;
  /** Create many new DHCP static mappings. */
  createDHCPStaticMappings: Array<DhcpStaticMapping>;
  /** Create a new DNS host mapping. */
  createDNSHostMapping: DnsHostMapping;
  /** Create many new DNS host mapping. */
  createDNSHostMappings: Array<DnsHostMapping>;
  /** Create a new deployment job */
  createDeploymentJob: DeploymentJob;
  /** Create deployment task blocking relationships. */
  createDeploymentTaskBlockers: Array<DeploymentTaskBlocker>;
  /** Raise an exception on a deployment task. */
  createDeploymentTaskException: DeploymentTaskException;
  /** Post a message on a deployment task exception. */
  createDeploymentTaskExceptionMessage: DeploymentTaskExceptionMessage;
  /** Create a single time window for the given network. */
  createDeploymentTimeWindow: DeploymentTimeWindow;
  /** Invoke this method in dev to create a new device in the dev realm, or claim it from prod when cross-realm claiming is enabled. */
  createDevHardwareDevice: HardwareDevice;
  /** Create a batch of serial numbers and MAC addresses for a given hardware model. */
  createDeviceBatch: DeviceBatch;
  /**
   * Create a MAC allocation block for a device family. A family may own several
   * blocks, as long as the new range does not overlap any existing block of any
   * family.
   */
  createDeviceMACAllocation: DeviceMacAllocation;
  /** Create device notification snoozes. Returns one snooze per virtualDeviceUUID supplied. */
  createDeviceNotificationSnoozes: Array<DeviceNotificationSnooze>;
  /** Create one or more document uploads within a company. */
  createDocumentUploads: Array<DocumentUpload>;
  /** Create a pending OpenIntent upload and return a pre-signed S3 URL for the zip file. */
  createDynamicFloorPlanOpenIntentUpload: CreateDynamicFloorPlanOpenIntentUploadPayload;
  /** Creates a new 802.1X encryption configuration for a network. */
  createEncryption8021X: Encryption8021X;
  /** Creates new 802.1X encryption configuration for networks. */
  createEncryption8021Xes: Array<Encryption8021X>;
  /** Create a new firewall rule. */
  createFirewallRule: FirewallRule;
  /** Create a new firewall rule. */
  createFirewallRules?: Maybe<Array<FirewallRule>>;
  /** Create a fleetwide notification snooze. */
  createFleetwideNotificationSnooze: FleetwideNotificationSnooze;
  /** Create a new floor plan within a specific network. */
  createFloorPlan: FloorPlan;
  /** Create a global notification snooze. */
  createGlobalNotificationSnooze: GlobalNotificationSnooze;
  /** Create a new hardware device pair. */
  createHardwareDevicePair: HardwareDevicePair;
  /** Create multiple hardware device pairs. */
  createHardwareDevicePairs: Array<HardwareDevicePair>;
  /** Create a new hardware NOS version range for a specific hardware device model. */
  createHardwareNosVersionRange: HardwareNosVersionRange;
  /** Combine two firewalls on the same network into an HA pair using VRRP. */
  createHighAvailabilityControllersConfiguration: HighAvailabilityControllersConfig;
  /** Create a new host monitoring target. */
  createHostMonitoringTarget: HostMonitoringTarget;
  /** Creates an IDS/IPS config for a network. There can be a single config per network; this is a no-op if one already exists. */
  createIDSIPSConfig: IdsipsConfig;
  /** Create a custom rule for an IDS configuration. */
  createIDSIPSCustomRule: IdsipsCustomRule;
  /** Create an IP forwarding rule for a network. */
  createIPForwardingRule: IpForwardingRule;
  /** Create a new IPSec tunnel. */
  createIPSecTunnel: IpSecTunnel;
  /** Create a new internal note. */
  createInternalNote: InternalNote;
  /** Creates a new InternetServicePlan.  Must include networkUUID or mailingAddressUUID with companySlug. */
  createInternetServicePlan: InternetServicePlan;
  /** Creates an ISP Document with the provided fields. */
  createInternetServicePlanDocument: InternetServicePlanDocument;
  /** Creates a fullfillment job with the provided fields. */
  createInternetServicePlanFulfillmentJob: InternetServicePlanFulfillmentJob;
  /** Creates a fullfillment task with the provided fields. */
  createInternetServicePlanFulfillmentTask: InternetServicePlanFulfillmentTask;
  /**
   * Creates an ISP payment resource by provisioning a card (Ramp) or bank account (Increase) at
   * the given vendor, then recording it against the ISP. The vendor-facing display name is
   * computed from the ISP's company, location, provider, and product.
   */
  createInternetServicePlanPaymentResource: InternetServicePlanPaymentResource;
  /** Creates a new InternetServicePlanProvider. */
  createInternetServicePlanProvider: InternetServicePlanProvider;
  /** Creates a new Internet Service Plan Provider Static Rate. */
  createInternetServicePlanProviderStaticRate: InternetServicePlanProviderStaticRate;
  /**
   * Creates a new Knock token for the authenticated user and company. The token is valid for 24 hours and used to authenticate
   * Knock integrations.
   */
  createKnockToken: Scalars['String']['output'];
  /** Creates a new lab reservation. */
  createLabReservation: LabReservation;
  /**
   * Reserves a number of interchangeable resources of one kind, optionally narrowed by
   * metadata, as a single reservation holding all of them.
   */
  createLabReservationsByKind: LabReservation;
  /** Creates a new lab resource. */
  createLabResource: LabResource;
  /** Create a new marketing changelog entry. */
  createMarketingChangelogEntry: MarketingChangelogEntry;
  /** Creates a new monitor group. */
  createMonitorGroup: MonitorGroup;
  /** Creates a new monitor probe. */
  createMonitorProbe: MonitorProbe;
  /** Creates a binding between a probe and an interface. */
  createMonitorProbeBinding: MonitorProbeBinding;
  /** Create a static NAC credential. */
  createNACCredential: NacCredential;
  /** Bulk create multiple NAC credentials. */
  createNACCredentials: Array<NacCredential>;
  /** Create a NAC user group. */
  createNACGroup: NacGroup;
  /** Create a NAC IdP configuration for a company. */
  createNACIdPConfig: NacIdPConfig;
  /** Create a group mapping for a company's IdP configuration. */
  createNACIdPGroupMapping: NacIdPGroupMapping;
  /** Create a NAC policy for a network. */
  createNACPolicy: NacPolicy;
  /** Create an entry in a NAC policy. */
  createNACPolicyEntry: NacPolicyEntry;
  /** Create a new NOS upgrade group for a network. */
  createNOSUpgradeGroup: NosUpgradeGroup;
  /** Create an internal network for an internal company. Users cannot create customer networks under customer companies; they are created by the Salesforce -> Backend data sync process. */
  createNetwork: Network;
  /** Create network client CPE bindings on a network. */
  createNetworkClientCPEBindings: Array<NetworkClientCpeBinding>;
  /** Creates a new network onboarding document associated with the specified network. */
  createNetworkOnboarding: NetworkOnboarding;
  /** Mutation for creating a new network reservation */
  createNetworkReservation: NetworkReservation;
  /** Create a NetworkThreatAllowlistEntry for a network. */
  createNetworkThreatAllowlistEntry: NetworkThreatAllowlistEntry;
  /** Create a new NOS feature. */
  createNosFeature: NosFeature;
  /** Creates a new NOS (Network Operating System) version, including the build strings for various device types. */
  createNosVersion: NosVersion;
  /** Create a new ObserverTest for a network. */
  createObserverTest: ObserverTest;
  /** Create a new 1:1 NAT rule in the specified network. */
  createOneToOneNATRule: OneToOneNatRule;
  /** Create a new permitted email domain for a company. This feature is largely out-of-use in favor of SSO. */
  createPermittedEmailDomain: PermittedEmailDomain;
  /** Create a new DHCP rule on a cellular gateway phy interface. */
  createPhyInterfaceDHCPRule: PhyInterfaceDhcpRule;
  /** Creates a new path on an existing policy engine policy. */
  createPolicyEnginePath: PolicyEnginePath;
  /** Creates a new policy engine policy. */
  createPolicyEnginePolicy: PolicyEnginePolicy;
  /** Creates a new traffic matcher on an existing policy engine policy. */
  createPolicyEngineTrafficMatcher: PolicyEngineTrafficMatcher;
  /** Create a policy routing rule for a network. */
  createPolicyRoutingRule: PolicyRoutingRule;
  /** Create a port forwarding rule for a network. */
  createPortForwardingRule: PortForwardingRule;
  /** Generates a pre-signed URL for uploading a file to S3. */
  createPreSignedUploadUrl: FileUploadPayload;
  /** Create the global proactive packet capture configuration for a network. */
  createProactivePcapNetworkConfig: ProactivePcapNetworkConfig;
  /** Create the proactive packet capture configuration for an SSID. */
  createProactivePcapSSIDConfig: ProactivePcapSsidConfig;
  /** Creates a new Provider Connection Type Term. */
  createProviderConnectionTypeTerm: ProviderConnectionTypeTerm;
  /** Create a new public API key for a company. */
  createPublicAPIKey: CreatePublicApiKeyResponse;
  /** Creates a new Quote. */
  createQuote: Quote;
  /** Creates a new Quote Request. Input requires either companyName or companyUUID. */
  createQuoteRequest: QuoteRequest;
  /** Create a rack elevation for a network. */
  createRackElevation: RackElevation;
  /** Create a radio profile for a network. */
  createRadioProfile: RadioProfile;
  /** Create radio profiles for networks. */
  createRadioProfiles: Array<RadioProfile>;
  /** Create a rate limit rule for a network. */
  createRateLimitRule: RateLimitRule;
  /** Creates a group-to-role mapping for a company. */
  createRoleMapping: CompanyRoleMapping;
  /** Create a new SPAN mirror session on a virtual device. */
  createSPANMirrorSession: SpanMirrorSession;
  /** Create an SSID for a network. */
  createSSID: Ssid;
  /** Create an SSID for a network. */
  createSSIDs: Array<Ssid>;
  /** Creates a WorkOS admin portal link for the specified company and purpose. */
  createSSOAdminPortalLink: ConfigureSsoResult;
  /** Verifies the token provided via the WorkOS callback. */
  createSSOVerify: CreateSsoVerifyResult;
  /**
   * Create a new firewall device pair.
   * @deprecated Use `createHardwareDevicePair` instead.
   */
  createSecurityApplianceDevicePair: SecurityApplianceDevicePair;
  /**
   * Create multiple firewall device pairs.
   * @deprecated Use `createHardwareDevicePairs` instead.
   */
  createSecurityApplianceDevicePairs: Array<SecurityApplianceDevicePair>;
  /** Create a service request, which turns a set of defined inputs into a set of tasks to be completed. */
  createServiceRequest: Array<DeploymentTask>;
  /** Creates a new session token for the client. This mutation initiates a session that can be used to authenticate subsequent requests. */
  createSessionToken: SessionToken;
  /** Fetch and save a Slack access token for a company. */
  createSlackAccessToken: SlackAccessToken;
  /** Create speedtest rule for a company */
  createSpeedtestRule: SpeedtestRule;
  /** Creates SSO OAuth URIs for Google and Microsoft authentication. */
  createSsoOAuthURI: CreateSsoOAuthUriResult;
  /** Create a new static route. */
  createStaticRoute: StaticRoute;
  /**
   * Creates a support case that will be published to inbox.
   *
   * For machine principals adding collaborators is restricted to the domain that is configured for your account. If this is not set please contact our support team and we can configure your desired domain.
   */
  createSupportCase: CreateSupportCaseResponse;
  /** Creates an attachment on a support case. */
  createSupportCaseAttachments: Array<SupportCaseAttachment>;
  /** Creates a comment on a support case. */
  createSupportCaseComment: SupportCaseComment;
  /** Creates a support provider owned by a company. */
  createSupportProvider: SupportProvider;
  /**
   * Creates an alert receiver and mappings between an alert receiver and one or more alert targets
   * Alert targets must be predefined unless the alert target type is EMAIL. In that case, the email address must be
   * provided and alertTargetUUID can be left empty. An email target will be created automatically.
   */
  createSupportProviderAlertReceiverWithTargets: AlertReceiver;
  /** Assign a user a support department and role making them a support user. */
  createSupportUser: SupportUser;
  /** Bind MAC addresses or OUIs to VLANs before running Switch Auto Config. */
  createSwitchAutoConfigMACAddressVLANBindings: Array<SwitchAutoConfigMacAddressVlanBinding>;
  /** Create a new switch profile. */
  createSwitchProfile: SwitchProfile;
  /**
   * Create a synthetic hardware device locally in the dev realm for testing purposes.
   * Unlike createDevHardwareDevice, this does not attempt to claim the device from prod.
   */
  createSyntheticHardwareDevice: HardwareDevice;
  /** Create a template network from another network, which can subsequently be used to create new networks with the same configuration. */
  createTemplateFromNetwork: Network;
  /** Create a template network. */
  createTemplateNetwork: Network;
  /** Create a topology design link. */
  createTopologyDesignLink: TopologyDesignLink;
  /** Create a topology design node within a version. */
  createTopologyDesignNode: TopologyDesignNode;
  /** Create a new draft topology design version. Optionally fork from an existing version. */
  createTopologyDesignVersion: TopologyDesignVersion;
  /** Create virtual devices from the provisionable nodes in a committed topology design version. */
  createTopologyDesignVirtualDevices: Array<VirtualDevice>;
  /** Submit feedback from the authenticated user for a company. */
  createUserFeedback: Scalars['UUID']['output'];
  /** Provides an internal Operator user access to a network to provide elevated permissions like SSH access. */
  createUserNetworkAccess: Scalars['Boolean']['output'];
  /** Create a new VLAN. */
  createVLAN: Vlan;
  /** Create multiple new VLANs. */
  createVLANs: Array<Vlan>;
  /** Create a virtual device. */
  createVirtualDevice: VirtualDevice;
  /** Create a virtual device tag. */
  createVirtualDeviceTag: VirtualDeviceTag;
  /** Create many virtual devices of the same type and model. */
  createVirtualDevices: Array<VirtualDevice>;
  /** Create multiple virtual devices each with different parameters. */
  createVirtualDevicesIndependently: Array<VirtualDevice>;
  /** Create a new Wifi IPSK. */
  createWifiIPSK: WifiIpsk;
  /** Create multiple Wifi IPSKs. */
  createWifiIPSKs: Array<WifiIpsk>;
  /** Cutover mutable entities from one virtual device to another. This migrates entities that could not be copied during virtual device copy. */
  cutoverMutableEntitiesToNewVirtualDevice: VirtualDevice;
  /** Cycles the access point's currently configured primary channels to new allowed channels, scheduling a task to update the configuration back to its original channels after the configured timeout. */
  cycleAccessPointChannels: RadioSettings;
  /** Deactivates a Kore Cellular SIM card. */
  deactivateDeviceSIM?: Maybe<SuperSim>;
  /** Delete an access point port profile. */
  deleteAccessPointPortProfile: AccessPointPortProfile;
  /** Delete alert company subscriptions. */
  deleteAlertCompanySubscriptions: Array<AlertCompanySubscription>;
  /** Delete alert deprioritization window configurations for multiple networks. */
  deleteAlertDeprioritizationWindowsForNetworks: Array<AlertDeprioritizationWindow>;
  /** Delete fleetwide alert subscriptions. */
  deleteAlertFleetwideSubscriptions: Array<AlertFleetwideSubscription>;
  /** Deletes an alert receiver and all of its targets. */
  deleteAlertReceiverWithTargets: AlertReceiver;
  /** Delete alert company subscriptions. */
  deleteAlertSupportProviderSubscriptions: Array<AlertCompanySubscription>;
  /** Deletes a Salesforce alert target specified by its UUID. */
  deleteAlertTargetSalesforce: AlertTargetSalesforce;
  /** Deletes a Slack alert target specified by its UUID. */
  deleteAlertTargetSlack: AlertTargetSlack;
  /** Deletes a webhook alert target specified by its UUID. */
  deleteAlertTargetWebhook: AlertTargetWebhook;
  /** Delete all Wifi IPSKs for this SSID. */
  deleteAllWifiIPSKsForSSID: Array<WifiIpsk>;
  /** Deletes an application DNS firewall rule. */
  deleteApplicationDNSFirewallRule: ApplicationDnsFirewallRule;
  /** Delete many DNS firewall rules. */
  deleteApplicationDNSFirewallRules: Array<ApplicationDnsFirewallRule>;
  /** Deletes an Auto VPN group. Deleting an Auto VPN group deletes all group members. */
  deleteAutoVPNGroup: AutoVpnGroup;
  /** Removes a network from an Auto VPN group. */
  deleteAutoVPNMember: AutoVpnMember;
  /** Removes networks from an Auto VPN group. */
  deleteAutoVPNMembers: Array<AutoVpnMember>;
  /** Deletes an Auto VPN route on an Auto VPN group. */
  deleteAutoVPNRoute: AutoVpnRoute;
  /** Deletes a BGP neighbor. */
  deleteBGPNeighbor: BgpNeighbor;
  /** Deletes a BGP router. */
  deleteBGPRouter: BgpRouter;
  /** Delete a bulk NOS upgrade. Cannot delete a bulk upgrade that has non-PENDING scheduled NOS upgrades. */
  deleteBulkNOSUpgrade: BulkNosUpgrade;
  /** Deletes a captive portal. */
  deleteCaptivePortal: CaptivePortal;
  /** Deletes a Client VPN client. */
  deleteClientVPNClient: Scalars['Boolean']['output'];
  /** Deletes a Client VPN server. */
  deleteClientVPNServer: Scalars['Boolean']['output'];
  /** Deletes a company onboarding document. */
  deleteCompanyOnboardingDocument: CompanyOnboardingDocument;
  /** Deletes a field delegation. */
  deleteCompanyOnboardingFieldDelegation: CompanyOnboardingFieldDelegation;
  /** Deletes a SIEM integration. */
  deleteCompanySIEMIntegration: CompanySiemIntegration;
  /** Deletes the specified company user, preventing them from logging in and accessing the dashboard for that company. */
  deleteCompanyUser: CompanyUser;
  /** Deletes an existing Connect Static Rate. */
  deleteConnectStaticRate: ConnectStaticRate;
  /** Deletes a custom role. Cannot delete a role that users have assigned. */
  deleteCustomRole: CustomRole;
  /** Deletes a DDNS record. */
  deleteDDNSRecord: DdnsRecord;
  /** Delete a DHCP option by its UUID. */
  deleteDHCPOption: DhcpOption;
  /** Delete a DHCP proxy by its UUID. */
  deleteDHCPProxy: DhcpProxy;
  /** Delete a DHCP reserved range by its UUID. */
  deleteDHCPReservedRange: DhcpReservedRange;
  /** Delete a DHCP rule by its UUID. */
  deleteDHCPRule: DhcpRule;
  /** Deletes a DHCP rule filter by its UUID */
  deleteDHCPRuleFilter: DhcpRuleFilter;
  /**
   * Delete a DHCP static mapping by its UUID.
   * @deprecated Use `deleteDHCPStaticMappings` instead.
   */
  deleteDHCPStaticMapping: DhcpStaticMapping;
  /** Delete many DHCP static mappings by their UUIDs. */
  deleteDHCPStaticMappings: Array<DhcpStaticMapping>;
  /** Delete a DNS host mapping by its UUID. */
  deleteDNSHostMapping: DnsHostMapping;
  /** Delete a deployment job */
  deleteDeploymentJob: DeploymentJob;
  /** Delete a deployment task */
  deleteDeploymentTask: DeploymentTask;
  /** Delete a deployment task blocker by UUID. */
  deleteDeploymentTaskBlocker: DeploymentTaskBlocker;
  /** Delete a time window and its links, returning the deleted window. */
  deleteDeploymentTimeWindow: DeploymentTimeWindow;
  /** Delete one of a device family's MAC allocation blocks. */
  deleteDeviceMACAllocation: DeviceMacAllocation;
  /** Delete a device notification snooze. */
  deleteDeviceNotificationSnooze: DeviceNotificationSnooze;
  /** Delete one or more existing document uploads. */
  deleteDocumentUploads: Array<DocumentUpload>;
  /** Deletes an existing 802.1X encryption configuration. */
  deleteEncryption8021X: Encryption8021X;
  /** Delete a firewall rule. */
  deleteFirewallRule: FirewallRule;
  /** Delete multiple firewall rules at once. */
  deleteFirewallRules: Array<FirewallRule>;
  /** Delete a fleetwide notification snooze. */
  deleteFleetwideNotificationSnooze: FleetwideNotificationSnooze;
  /** Delete an existing floor plan. */
  deleteFloorPlan: FloorPlan;
  /** Delete a global notification snooze. */
  deleteGlobalNotificationSnooze: GlobalNotificationSnooze;
  /** Delete a hardware device pair by the UUID of the pair. */
  deleteHardwareDevicePair: HardwareDevicePair;
  /** Delete the HA configuration for the given network. */
  deleteHighAvailabilityControllersConfiguration: HighAvailabilityControllersConfig;
  /** Delete an existing host monitoring target. */
  deleteHostMonitoringTarget: HostMonitoringTarget;
  /** Deletes the IDS/IPS config for a network. */
  deleteIDSIPSConfig: IdsipsConfig;
  /** Delete a category configuration for an IDS/IPS configuration. */
  deleteIDSIPSConfigCategoryBinding: IdsipsConfigCategoryBinding;
  /** Delete a configured rule for an IDS/IPS configuration. */
  deleteIDSIPSConfigRuleBinding: IdsipsConfigRuleBinding;
  /** Delete a custom rule for an IDS configuration. */
  deleteIDSIPSCustomRule: IdsipsCustomRule;
  /** Delete an IP forwarding rule. */
  deleteIPForwardingRule: IpForwardingRule;
  /** Delete an IPSec tunnel. */
  deleteIPSecTunnel: IpSecTunnel;
  /** Delete an internal note. */
  deleteInternalNote: InternalNote;
  /** Deletes an existing InternetServicePlan. */
  deleteInternetServicePlan: Scalars['Boolean']['output'];
  /** Deletes an existing ISP Document. */
  deleteInternetServicePlanDocument: InternetServicePlanDocument;
  /** Deletes an existing job. */
  deleteInternetServicePlanFulfillmentJob: InternetServicePlanFulfillmentJob;
  /** Deletes an existing task. */
  deleteInternetServicePlanFulfillmentTask: InternetServicePlanFulfillmentTask;
  /** Deletes an existing Internet Service Plan Provider Static Rate. */
  deleteInternetServicePlanProviderStaticRate: Scalars['Boolean']['output'];
  /** Deletes a lab reservation. */
  deleteLabReservation: LabReservation;
  /** Deletes a lab resource. */
  deleteLabResource: LabResource;
  /** Deletes a manual availability record. Availability records from other sources can't be deleted. */
  deleteLocationProviderAvailability: LocationProviderAvailabilitySource;
  /** Delete an existing marketing changelog entry. */
  deleteMarketingChangelogEntry: MarketingChangelogEntry;
  /** Deletes a monitor group. */
  deleteMonitorGroup: MonitorGroup;
  /** Deletes a monitor probe. */
  deleteMonitorProbe: MonitorProbe;
  /** Deletes a probe binding. */
  deleteMonitorProbeBinding: MonitorProbeBinding;
  /** Delete the network-level NAC configuration and all associated policies and entries. */
  deleteNACConfig: NacConfig;
  /** Delete a static NAC credential. */
  deleteNACCredential: NacCredential;
  /** Delete a NAC user group. Also removes the group from all policy entries and credential memberships. */
  deleteNACGroup: NacGroup;
  /** Delete a NAC IdP configuration and its group mappings. */
  deleteNACIdPConfig: NacIdPConfig;
  /** Delete a group mapping. */
  deleteNACIdPGroupMapping: NacIdPGroupMapping;
  /** Delete a NAC policy. */
  deleteNACPolicy: NacPolicy;
  /** Delete an entry from a NAC policy. */
  deleteNACPolicyEntry: NacPolicyEntry;
  /** Delete a NOS upgrade group if no devices are assigned to it. */
  deleteNOSUpgradeGroup: NosUpgradeGroup;
  /** Mark a network as soft-deleted. Customer networks cannot be deleted. Careful, this is a very dangerous operation! */
  deleteNetwork: Network;
  /** Delete network client CPE bindings on a network. */
  deleteNetworkClientCPEBindings: Array<NetworkClientCpeBinding>;
  /** Deletes a network onboarding document. */
  deleteNetworkOnboardingDocument: NetworkOnboardingDocument;
  /** Deletes a field delegation. */
  deleteNetworkOnboardingFieldDelegation: NetworkOnboardingFieldDelegation;
  /** Mutation for deleting a new network reservation */
  deleteNetworkReservation: NetworkReservation;
  /** Delete a NetworkThreatAllowlistEntry for a network. */
  deleteNetworkThreatAllowlistEntry: NetworkThreatAllowlistEntry;
  /** Remove the active underlay pool for a network by deactivating it. */
  deleteNetworkUnderlayPool: UnderlayPool;
  /** Deletes a NOS version. Only NOS versions that are not associated with any networks can be deleted. */
  deleteNosVersion: NosVersion;
  /** Delete bindings for an observer test. */
  deleteObserverTestBindings: Array<ObserverTestBinding>;
  /** Delete existing ObserverTests at once. */
  deleteObserverTests: Array<ObserverTest>;
  /** Delete an existing 1:1 NAT rule by its UUID. */
  deleteOneToOneNATRule: OneToOneNatRule;
  /** Delete multiple 1:1 NAT rules by their UUIDs. */
  deleteOneToOneNATRules: Array<OneToOneNatRule>;
  /** Delete a permitted email domain for a company. */
  deletePermittedEmailDomain: DeletePermittedEmailDomainResult;
  /** Delete a phy interface DHCP rule by its UUID. */
  deletePhyInterfaceDHCPRule: PhyInterfaceDhcpRule;
  /** Deletes a path. */
  deletePolicyEnginePath: PolicyEnginePath;
  /** Deletes a policy engine policy. */
  deletePolicyEnginePolicy: PolicyEnginePolicy;
  /** Deletes a traffic matcher. */
  deletePolicyEngineTrafficMatcher: PolicyEngineTrafficMatcher;
  /** Delete a policy routing rule. */
  deletePolicyRoutingRule: PolicyRoutingRule;
  /**
   * Delete a port forwarding rule.
   * @deprecated Use `deletePortForwardingRules` instead.
   */
  deletePortForwardingRule: PortForwardingRule;
  /** Delete multiple port forwarding rules. */
  deletePortForwardingRules: Array<PortForwardingRule>;
  /** Delete the proactive packet capture configuration for an SSID. */
  deleteProactivePcapSSIDConfig: ProactivePcapSsidConfig;
  /** Deletes an existing Provider Connection Type Term. */
  deleteProviderConnectionTypeTerm: ProviderConnectionTypeTerm;
  /** Deletes an existing Quote. */
  deleteQuote: Scalars['Boolean']['output'];
  /** Deletes existing Quote Request. */
  deleteQuoteRequest: Scalars['Boolean']['output'];
  /** Delete a rack elevation. */
  deleteRackElevation: Scalars['Boolean']['output'];
  /** Delete a radio profile. */
  deleteRadioProfile: RadioProfile;
  /** Delete a rate limit rule. */
  deleteRateLimitRule: RateLimitRule;
  /** Delete recurring auto channel selection schedules for multiple networks. */
  deleteRecurringAutoChannelSelectionJobs: Array<Scalars['UUID']['output']>;
  /** Deletes a group-to-role mapping. */
  deleteRoleMapping: CompanyRoleMapping;
  /** Delete a SPAN mirror session. */
  deleteSPANMirrorSession: SpanMirrorSession;
  /** Delete an SSID. */
  deleteSSID: Ssid;
  /** Delete SSIDs. */
  deleteSSIDs: Array<Ssid>;
  /** Delete a Slack access token. */
  deleteSlackAccessToken: SlackAccessToken;
  /** Delete all Slack access tokens for a company. */
  deleteSlackAccessTokensForCompany: SlackAccessToken;
  /** Delete speedtest rules */
  deleteSpeedtestRules?: Maybe<Array<SpeedtestRule>>;
  /** Delete a static route. */
  deleteStaticRoute: StaticRoute;
  /** Bulk delete support cases and all associated collaborators, comments, attachments, and inbox data. */
  deleteSupportCases: Array<Scalars['UUID']['output']>;
  /** Deletes a support provider. */
  deleteSupportProvider: SupportProvider;
  /** Deletes an alert receiver and all of its targets. */
  deleteSupportProviderAlertReceiverWithTargets: AlertReceiver;
  /** Remove user from all support department roles. */
  deleteSupportUser: Scalars['Boolean']['output'];
  /** Un-bind a MAC address or OUI from a VLAN before running Switch Auto Config. */
  deleteSwitchAutoConfigMACAddressVLANBinding: SwitchAutoConfigMacAddressVlanBinding;
  /** Delete a topology design link. */
  deleteTopologyDesignLink: TopologyDesignLink;
  /** Delete a topology design node. */
  deleteTopologyDesignNode: TopologyDesignNode;
  /** Delete a draft topology design version and all its nodes and links. */
  deleteTopologyDesignVersion: TopologyDesignVersion;
  /** Delete a VLAN. */
  deleteVLAN: Scalars['Boolean']['output'];
  /** Delete multiple VLANs at once. */
  deleteVLANs: Array<Vlan>;
  /** Delete a virtual device and all associated entities. Be sure you know what you're doing, this is a hard deletion! Returns an error if the virtual device is assigned to hardware. */
  deleteVirtualDevice: VirtualDevice;
  /** Delete a virtual device tag. */
  deleteVirtualDeviceTag: VirtualDeviceTag;
  /** Delete multiple virtual devices and all associated entities. Be sure you know what you're doing! Returns an error if any of the virtual devices are assigned to hardware. */
  deleteVirtualDevices: Array<VirtualDevice>;
  /** Delete a Wifi IPSK. */
  deleteWifiIPSK: WifiIpsk;
  /** Deny a pending temporary access request. Only listed approvers may deny, and not their own requests. */
  denyTemporaryAccessGrant: TemporaryAccessGrant;
  /** Remove a device from a rack elevation. If the device is paired, its attached partner is removed too. */
  detachDeviceFromRackElevation: Scalars['Boolean']['output'];
  /** Remove multiple devices from rack elevations atomically. For each paired device, its attached partner is removed too. */
  detachDevicesFromRackElevation: Scalars['Boolean']['output'];
  /** Detaches an AP from a radio profile. The AP will inherit its network's default radio profile settings. */
  detachVirtualDeviceFromRadioProfile: VirtualDevice;
  /** Edit the reason specified for why a mutation was made in the audit log. */
  editMutationAuditLogEntryReason: Scalars['Boolean']['output'];
  /** Edits the reason specified for why a mutation was made in the diff audit log entry. */
  editMutationDiffAuditLogEntryReason: Scalars['Boolean']['output'];
  /** Enables SSO for a company. */
  enableSSOForCompany: Company;
  /** End a currently active global notification snooze. */
  endGlobalNotificationSnooze: GlobalNotificationSnooze;
  /**
   * Force a sync of the Salesforce -> Backend data sync process for all existing companies.
   * Used when backfilling a new synced field that needs to be populated for all companies.
   * Returns the River Job ID.
   * This should only be invoked by engineers who know what they are doing.
   */
  forceSalesforceSyncCompanies: Scalars['Int']['output'];
  /**
   * Force a sync of the Salesforce -> Backend data sync process for all existing networks and their mailing addresses.
   * Used when backfilling a new synced field that needs to be populated for all networks.
   * Returns the River Job ID.
   * This should only be invoked by engineers who know what they are doing.
   */
  forceSalesforceSyncNetworks: Scalars['Int']['output'];
  /** Forget a client device, freeing one of the identity's device limit slots. */
  forgetNACClientDevice: NacClientDevice;
  /** Generate a power plan given a calibration job uuid and other interference inputs. */
  generatePowerPlanForNetwork: PowerPlan;
  /** Generate a complete topology design as a new draft version, or overwrite the draft version specified in the input. */
  generateTopologyDesign: GenerateTopologyDesignResult;
  /** For each network, run backend-driven Auto Channel Selection in dry-run mode only. */
  initializeAutoChannelSelectionDryRunForNetworks: AutoChannelSelectionDryRunForNetworksResult;
  /**
   * Initialize and start a job to run Auto Channel Selection for a list of APs.
   * The process takes some time, so an AutoChannelSelectionJob is returned to track the progress.
   */
  initializeAutoChannelSelectionForAccessPoints: AutoChannelSelectionJob;
  /**
   * Initialize and start a job to run Auto Channel Selection for all APs in a network.
   * The process takes some time, so an AutoChannelSelectionJob is returned to track the progress.
   */
  initializeAutoChannelSelectionForNetwork: AutoChannelSelectionJob;
  /** Initialize and start a job to run Auto Switch Configuration for a network. */
  initializeAutoSwitchConfigurationForNetwork: SwitchAutoConfigurationJob;
  /** Add fake stats to a demo company for sales demonstration purposes. */
  insertStatsForDemo: Scalars['Boolean']['output'];
  /** Invalidates historical connected devices */
  invalidatePhyInterfaceConnectedDevices: Array<PhyInterface>;
  /** Invites a Client VPN client on a Client VPN server. */
  inviteClientVPNClient: ClientVpnServer;
  /** Batch invites Client VPN clients on a Client VPN server. */
  inviteClientVPNClients: ClientVpnServer;
  /** Mint a new authentication token. */
  mintAuthenticationToken: MintedToken;
  /** Moves an internet service plan to a given network. The network must belong to the company currently associated with the ISP. */
  moveInternetServicePlanToNetwork: InternetServicePlan;
  /** Move a device from one rack elevation to another. If the device is paired, its attached partner moves with it. */
  moveRackElevationDeviceToRack: RackElevation;
  /** Move multiple devices to the same rack elevation atomically. If a selected device is paired, its attached partner moves with it unless both devices in the pair are explicitly included, in which case each supplied placement is used. */
  moveRackElevationDevicesToRack: RackElevation;
  /** Always returns true and does nothing. */
  noop: Scalars['Boolean']['output'];
  /** Pauses one or more Salesforce job queues. Newly enqueued jobs accumulate but will not be worked until the queue is resumed. Restricted to super operators. */
  pauseSalesforceJobQueues: Array<SalesforceJobQueueState>;
  /** Pins the configurations for devices in a network to the versions at the given timestamp. Be very careful; use only in outage situations! */
  pinDeviceConfigsForNetwork: Network;
  /** Pins the configurations for devices in a network to the versions at the given timestamp. Be very careful; use only in outage situations! */
  pinDeviceConfigsForNetworks: Array<Network>;
  /**
   * Refreshes a Quote's wholesale cost. Quotes with a carrier pricing integration queue a carrier pricing request, which fills in the wholesale cost and provider quote ID when it completes. Other Quotes take their wholesale cost from the provider's static rate immediately.
   * Fails if the Quote has neither.
   */
  priceQuote: Quote;
  /** Reactivates a Kore Cellular SIM card. */
  reactivateDeviceSIM?: Maybe<SuperSim>;
  /**
   * Reassign hardware devices currently on the source network to the destination network. Each input serial is unassigned from any virtual device or spare pool on the source network, then either assigned to the specified destination virtual device or added as a spare on the destination network when no virtual device UUID is provided.
   * Paired hardware (e.g. stacked switches) may only be moved as spares — both pair members must be included in the input list and each must have a null virtualDeviceUUID.
   */
  reassignHardwareToOtherNetwork: Network;
  /**
   * Reassign a network from one company to another by applying the first network's configuration to the second network. Soft-deletes the destination network, replacing it with a new network with the same configuration as the source network.
   * The hardware from the source network is unassigned from the source network and assigned to the destination network.
   * The main use case for this is when a new customer moves into a space that was previously occupied by a different customer.
   * This is a very dangerous operation and will cause immediate disruption to both the source and destination networks. It should be used only by users who are very clear on what they are doing.
   */
  reassignNetwork: Network;
  /**
   * Refresh bindings for an observer test. It will force a refresh, which will
   * delete any bindings that are no longer valid.
   */
  refreshObserverTestBindings: ObserverTest;
  /** Reject a pending request. */
  rejectPublicAPIKeyGrantRequest: PublicApiKeyGrantRequest;
  /** Removes a hub from an Auto VPN group. The last hub cannot be removed. */
  removeHubFromAutoVPNGroup: AutoVpnHub;
  /** Removes a probe binding from a monitor group. */
  removeMonitorGroupMember: MonitorGroup;
  /**
   * Removes networks from an Auto VPN group.
   * @deprecated Use `deleteAutoVPNMembers` instead.
   */
  removeNetworksFromAutoVPNGroup: Scalars['Boolean']['output'];
  /** Remove networks that were previously added to a pending NOS upgrade. */
  removeNetworksFromBulkNOSUpgrade: BulkNosUpgrade;
  /**
   * Removes the role of operator from the user represented by this company user.
   * If companySlug is provided, removes only the company-scoped operator role for that company.
   * If companySlug is omitted, removes the global operator role.
   */
  removeOperatorRole: CompanyUser;
  /**
   * Removes the role of super operator from the user represented by this company user.
   * If companySlug is provided, removes only the company-scoped super operator role for that company.
   * If companySlug is omitted, removes the global super operator role.
   */
  removeSuperOperatorRole: CompanyUser;
  /** Removes a support provider's authorization for a target company. */
  removeSupportProvider: SupportProviderCompany;
  /**
   * Invoke a rendering of the latest configuration for a device.
   * Does the same thing as the device-facing `GET /v2/devices/:serial_number/config` endpoint.
   */
  renderDeviceConfig: DeviceConfig;
  /** Invoke a rendering of the latest configuration for a device, without overrides. */
  renderDeviceConfigWithoutOverrides: Scalars['JSONObject']['output'];
  /**
   * Replace the priority ordering of every NAC policy on a network. The input
   * must contain each policy UUID currently on the network exactly once
   * (validated in the resolver). Priorities are assigned in array order
   * (first item = highest priority, evaluated first).
   */
  reorderNACPolicies: Array<NacPolicy>;
  /**
   * Request that a public API key be granted access to an additional company.
   * Creates a pending request, nothing is granted until another operator
   * approves it.
   */
  requestCompanyAccessForPublicAPIKey: PublicApiKeyGrantRequest;
  /**
   * Request time-limited operator or read-only access to another company. The request is pending until another
   * user on the approver list approves it. The role is granted on approval and removed automatically when the
   * grant expires.
   */
  requestTemporaryAccess: TemporaryAccessGrant;
  /** Rerun quoting/serviceability vendor API requests. */
  rerunQuoteRequest: QuoteRequest;
  /** Resumes one or more previously paused Salesforce job queues. Restricted to super operators. */
  resumeSalesforceJobQueues: Array<SalesforceJobQueueState>;
  /** Return a hardware device by unassigning it from either a virtual device or spare assignment. */
  returnHardwareDevice: HardwareDevice;
  /** Revoke an existing authentication token. */
  revokeAuthenticationToken: AuthenticationToken;
  /** Revoke a public API key's access to a previously granted company. */
  revokeCompanyAccessFromPublicAPIKey: PublicApiKey;
  /** Revoke the API key making this request, along with all of its tokens. */
  revokeOwnAPIKey: PublicApiKey;
  /** Revoke a public API key and all associated tokens. */
  revokePublicAPIKey: PublicApiKey;
  /**
   * End a temporary access grant early. The requester may revoke their own grant,
   * revoking another user's grant requires elevated permission.
   */
  revokeTemporaryAccessGrant: TemporaryAccessGrant;
  /** Rotates the HMAC secret for a given captive portal. */
  rotateCaptivePortalSecret: CaptivePortal;
  /** Blink the LEDs on a device. */
  rpcBlinkLEDs: Scalars['Boolean']['output'];
  /** Instruct a device to clear its list of configs that were marked as bad. */
  rpcClearBlockedConfigs: Scalars['Boolean']['output'];
  /** Instruct a device to perform DNS lookups for specified hosts. Right now supported only on Access Point hardwares */
  rpcDNS: Array<RpcdnsResponse>;
  /** Instruct a device to run an EAPOL test to check RADIUS connectivity. */
  rpcEapolTestForSerial: RpcEapolTestForSerialResponse;
  /** Instruct multiple devices to run EAPOL tests to check RADIUS connectivity. */
  rpcEapolTestForSerials: Array<RpcEapolTestForSerialResponse>;
  /** Cycle an outlet on a Power Distribution Unit (PDU). */
  rpcPDUOutletCycle: Scalars['Boolean']['output'];
  /** Instruct multiple devices to start packet captures, grouped under a single packet capture group. */
  rpcPacketCapturesStart: PacketCaptureGroup;
  /** Instruct multiple packet captures to stop. */
  rpcPacketCapturesStop: Array<RpcPacketCaptureResponse>;
  /** Instruct a device to ping out to a host. */
  rpcPing: RpcPingResponse;
  /** Instruct a device to run a cable test on a port. */
  rpcPortCableTest: RpcCableTestResponse;
  /** Cycle a port on a device. */
  rpcPortCycle: Scalars['Boolean']['output'];
  /** Cycle a port on many devices in parallel. */
  rpcPortCycleDevices: Array<RpcPortCycleDeviceResponse>;
  /** Instruct a device to run an eye diagram test on an SFP port. */
  rpcPortEyeTest: RpcEyeTestResponse;
  /** On switches, force LEDs on specified ports to be on and the others off. */
  rpcPortSpotlight: Scalars['Boolean']['output'];
  /** On switches, cancel a previously issued spotlight RPC and return the ports LEDs to normal. */
  rpcPortSpotlightCancel: Scalars['Boolean']['output'];
  /** Instruct a device to reboot.. */
  rpcRebootDevice: Scalars['Boolean']['output'];
  /** Instruct many devices to reboot in parallel. */
  rpcRebootDevices: Array<RpcRebootDeviceResponse>;
  /** Instruct a device to pull its latest config from the backend. */
  rpcRefreshConfig: Scalars['Boolean']['output'];
  /** Instruct a device to recreate a specified IPSec tunnel. */
  rpcRestartIPSecTunnel: Scalars['Boolean']['output'];
  /** RPC for interacting with the rotating packet captures feature (currently supported on an AP hardware: Access Point or Observer). */
  rpcRotatingPacketCapture: RpcRotatingPacketCaptureResponse;
  /**
   * Cycle a port on a switch.
   * @deprecated Use `rpcPortCycle` instead.
   */
  rpcSwitchPortCycle: Scalars['Boolean']['output'];
  /** Clear one or more MAC addresses from a switch port which has dynamic or sticky port security enabled. */
  rpcSwitchPortSecurityClear: Scalars['Boolean']['output'];
  /** Instruct a device to start a network wide wireless calibration job. */
  rpcWirelessCalibrationStart: RpcWirelessCalibrationResponse;
  /** Disconnect a client from an AP. */
  rpcWosDisconnectClient: Scalars['Boolean']['output'];
  /** Instruct an Access Point, Observer, or Cellular Gateway to ping out to a host. */
  rpcWosPing: RpcWosPingResponse;
  /** Reset the radio for a specific band on a device. */
  rpcWosRadioReset: Scalars['Boolean']['output'];
  /** Reset Dynamic Frequency Selection (DFS) channels on an AP. */
  rpcWosResetDfs: Scalars['Boolean']['output'];
  /** Enqueue a single run of a River Job to run immediately by specifying the job kind and arguments. This should only be invoked by engineers who know what they are doing. Returns the River Job ID. */
  runRiverJob: Scalars['Int']['output'];
  /** Send a test event for a SIEM integration. */
  sendCompanySIEMIntegrationTestEvent: Scalars['Boolean']['output'];
  /** Invoke this method in prod to route a device to the dev realm. This clears the registration info and requires the device to re-register. */
  setHardwareDeviceIsDev: Scalars['Boolean']['output'];
  /**
   * Sets a payment resource's temporary spend limit, superseding any existing active one. Pushes
   * the new limit to the vendor (Ramp only; a no-op for Increase) before recording it.
   */
  setInternetServicePlanPaymentResourceTemporaryLimit: InternetServicePlanPaymentResourceTemporaryLimit;
  /** Sets the ISP VLAN IDs of an ISP switch. Any ID that is omitted or null is left unchanged. Use resetToDefaults to restore 4000/4001. */
  setIspVLANs: IspVlaNs;
  /** Set an arbitrary value, unique to the authenticated user. */
  setKeyValue?: Maybe<Scalars['JSON']['output']>;
  /** Set the password for a NAC credential using a setup token. */
  setNACCredentialPassword: Scalars['Boolean']['output'];
  /** Sets the NOS version for a network, resulting in a firmware upgrade or downgrade being applied to all devices within the network. */
  setNetworkNosVersion: Scalars['Boolean']['output'];
  /**
   * Binds a policy routing rule to `input`, assigning metrics based on the order in `input`.
   * Any existing bound rules not present in `input` will be unbound.
   */
  setPolicyRoutingRuleBindings: Array<PolicyRoutingRuleBinding>;
  /**
   * Use this to activate a manual role (overriding the IdP default) or to deactivate a synced role
   * so that the manual role is used instead.
   */
  setRoleAssignmentActive: RoleAssignment;
  /**
   * Replace all support roles for a user with the provided list.
   * Deletes any existing roles not in the list and creates new ones.
   * Passing an empty list removes all roles for the user.
   */
  setSupportUserRoles: Array<SupportUser>;
  /**
   * Shuffles hardware between the given virtual devices. The set of hardware serial numbers
   * provided (excluding nulls) must exactly equal the set of hardware currently assigned to
   * the input virtual devices — no new hardware may be introduced, and no currently-assigned
   * hardware may be dropped. Paired devices are not supported.
   */
  shuffleHardwareDeviceAssignments: Array<VirtualDevice>;
  /** Sign a console login challenge, allowing the user to log in to the device. */
  signConsoleLoginChallenge: SignedConsoleLoginChallenge;
  /** Sign a local config access challenge, allowing the user to access and modify the device's local configuration. */
  signLocalConfigAccessChallenge: SignedLocalConfigAccessChallenge;
  /** Begin a sweep that pings a selected set of the network's clients. */
  startClientPingSweepJob: ClientPingSweepJob;
  /** Begin a WAN speed test job with the given input parameters. */
  startWANSpeedtestJob: StartWanSpeedtestJobResponse;
  /** Begin a wireless calibration job with the given input parameters. */
  startWirelessCalibrationJob: WirelessCalibrationJob;
  /** Suppress applied IPS rules. */
  suppressIPSRules: Scalars['Boolean']['output'];
  /** Runs the test fire alert for an alert receiver which will always result in failure and then notification. */
  testFireAlert?: Maybe<TestFireAlertResult>;
  /** Unassign the given hardware from its virtual device, if any. */
  unassignHardwareDeviceFromVirtualDevice: HardwareDevice;
  /** Unassigns hardware from the list of virtual devices. Be sure you know what you're doing! */
  unassignHardwareFromVirtualDevices: Array<VirtualDevice>;
  /** Removes the association of an internet service plan from any network it was previously assigned to. */
  unassignInternetServicePlanFromNetwork: InternetServicePlan;
  /** Unassign the hardware from the network as a spare device. */
  unassignSpareHardwareDeviceFromNetwork: HardwareDevice;
  /** Unbinds a firewall rule from a physical interface. */
  unbindFirewallRuleFromPhyInterface: FirewallRule;
  /** Unbinds a firewall rule from a VLAN. */
  unbindFirewallRuleFromVLAN: FirewallRule;
  /** Unbind a policy routing rule from a physical interface. */
  unbindPolicyRoutingRule: PolicyRoutingRule;
  /** Detach a rate limit rule from a physical interface (port). */
  unbindRateLimitRuleFromPhyInterface: RateLimitRule;
  /** Detach a rate limit rule from a VLAN. */
  unbindRateLimitRuleFromSSID: RateLimitRule;
  /** Detach a rate limit rule from a VLAN. */
  unbindRateLimitRuleFromVLAN: RateLimitRule;
  /** Remove a virtual device tag from one or many virtual devices. For now this is only supported for APs. */
  unbindTagFromVirtualDevices: Array<VirtualDevice>;
  /** Unblocks one or more clients on the given network. */
  unblockClientsInNetwork: Array<NetworkClientBlocklistEntry>;
  /** Unblocks one or more clients from a specific SSID. */
  unblockClientsInSSID: Array<NetworkClientBlocklistEntry>;
  /** Un-soft-delete a network. Should only be used in special circumstances. */
  undeleteNetwork: Network;
  /**
   * Revert every switch port change made by a completed, non-dry-run Switch
   * Auto Configuration job. Fails atomically without writing anything if the
   * current state of ANY touched port has drifted from what the job left
   * behind (i.e. something else has modified the port since apply).
   */
  undoSwitchAutoConfigurationRun: SwitchAutoConfigurationJob;
  /** For trial networks only: undoes the expiry of a trial network. Un-deletes the trial network and un-deletes users / role assignments for the company. */
  unexpireTrialNetwork: Network;
  /** Unpins the configurations for devices in a network if they were previously pinned. Be very careful; use only in outage situations! */
  unpinDeviceConfigsForNetwork: Network;
  /** Unpins the configurations for devices in networks if they were previously pinned. Be very careful; use only in outage situations! */
  unpinDeviceConfigsForNetworks: Array<Network>;
  /**
   * Invoke this method in prod to route a dev device back to the prod realm. This clears the registration info and requires the device to re-register.
   * Note that the device will NOT come up immediately, it needs to be factory reset after running this mutation.
   */
  unsetHardwareDeviceIsDev: Scalars['Boolean']['output'];
  /**
   * Withdraw a topology design version's verification, clearing both the timestamp and the
   * accountable owner. Allowed on any verified version, including archived ones, so a sign-off
   * recorded in error can still be withdrawn after the version has been superseded.
   */
  unverifyTopologyDesignVersion: TopologyDesignVersion;
  /** Update an access point port profile. */
  updateAccessPointPortProfile: AccessPointPortProfile;
  /** Update an existing alert company subscription. */
  updateAlertCompanySubscription: AlertCompanySubscription;
  /** Update an existing fleetwide alert subscription. */
  updateAlertFleetwideSubscription: AlertFleetwideSubscription;
  /** Updates an alert receiver and its targets. */
  updateAlertReceiverWithTargets: AlertReceiver;
  /** Update an existing alert company subscription. */
  updateAlertSupportProviderSubscription: AlertCompanySubscription;
  /** Update an existing Salesforce alert target. */
  updateAlertTargetSalesforce: AlertTargetSalesforce;
  /** Update an existing Slack alert target. */
  updateAlertTargetSlack: AlertTargetSlack;
  /** Update an existing webhook alert target. */
  updateAlertTargetWebhook: AlertTargetWebhook;
  /** Updates an existing application DNS firewall rule. */
  updateApplicationDNSFirewallRule: ApplicationDnsFirewallRule;
  /** Updates the visibility of applications for DNS firewall rules. */
  updateApplicationDNSFirewallRuleApplicationVisibilities: Array<Maybe<ApplicationDnsFirewallRuleApplication>>;
  /** Updates a existing application DNS firewall rules. */
  updateApplicationDNSFirewallRules: Array<ApplicationDnsFirewallRule>;
  /** Updates an Auto VPN group, only allowing updates to the hub. */
  updateAutoVPNGroup: AutoVpnGroup;
  /** Updates an Auto VPN Hub. */
  updateAutoVPNHub: AutoVpnHub;
  /** Updates multiple Auto VPN Hubs in a group. */
  updateAutoVPNHubs: Array<AutoVpnHub>;
  /** Updates an Auto VPN Member. */
  updateAutoVPNMember: AutoVpnMember;
  /** Updates an Auto VPN Member. */
  updateAutoVPNMemberHub: AutoVpnMemberHub;
  /** Updates an Auto VPN route on an Auto VPN group. */
  updateAutoVPNRoute: AutoVpnRoute;
  /** Updates a BGP neighbor. */
  updateBGPNeighbor: BgpNeighbor;
  /** Updates a BGP router. */
  updateBGPRouter: BgpRouter;
  /** This mutation is intended to be called only by the Kafka consumer. */
  updateBGPRouterForEvent: Scalars['Boolean']['output'];
  /** Updates a captive portal. */
  updateCaptivePortal: CaptivePortal;
  /** Updates a Client VPN client. */
  updateClientVPNClient: ClientVpnClient;
  /** Updates a Client VPN server. */
  updateClientVPNServer: ClientVpnServer;
  /** Update a limited set of fields on a company. Many fields are owned by Salesforce and cannot be updated via this endpoint. */
  updateCompany: Company;
  /** Updates an existing Company Location with the provided fields. */
  updateCompanyLocation: CompanyLocation;
  /** Updates a SIEM integration. */
  updateCompanySIEMIntegration: CompanySiemIntegration;
  /** Updates the specified company user with the provided fields. Note that the email field cannot be updated. */
  updateCompanyUser: CompanyUser;
  /** Updates an existing Connet Static Rate with the provided fields. */
  updateConnectStaticRate: ConnectStaticRate;
  /** Create or overwrite the certification statuses of device models in countries. */
  updateCountryDeviceCertifications: Array<CountryDeviceCertification>;
  /** Updates an existing custom role. */
  updateCustomRole: CustomRole;
  /** Updates an existing DDNS record. */
  updateDDNSRecord: DdnsRecord;
  /** Update an existing DHCP option by its UUID. */
  updateDHCPOption: DhcpOption;
  /** Update an existing DHCP proxy by its UUID. */
  updateDHCPProxy: DhcpProxy;
  /** Update an existing DHCP reserved range by its UUID. */
  updateDHCPReservedRange: DhcpReservedRange;
  /** Update an existing DHCP rule by its UUID. */
  updateDHCPRule: DhcpRule;
  /** Update an existing DHCP static mapping by its UUID. */
  updateDHCPStaticMapping: DhcpStaticMapping;
  /** Update an existing DNS host mapping by its UUID. */
  updateDNSHostMapping: DnsHostMapping;
  /** Updates the default role for users in an organization */
  updateDefaultRoleForUsers: DefaultRoleForUsersResponse;
  /** Update a deliverable's review state or service request inputs, or cancel the deliverable. */
  updateDeliverable: Deliverable;
  /** Update a deployment job */
  updateDeploymentJob: DeploymentJob;
  /** Update a deployment task */
  updateDeploymentTask: DeploymentTask;
  /** Update a deployment task exception. */
  updateDeploymentTaskException: DeploymentTaskException;
  /** Update a message on a deployment task exception. Only the author may edit their message. */
  updateDeploymentTaskExceptionMessage: DeploymentTaskExceptionMessage;
  /**
   * Update the read/archived state of a deployment task notification. The
   * calling user must be the notification's recipient.
   */
  updateDeploymentTaskNotification: DeploymentTaskNotification;
  /** Update a time window and its links. */
  updateDeploymentTimeWindow: DeploymentTimeWindow;
  /**
   * Updates a hardware device in the dev (staging) realm only.
   * Device must not be associated with any virtual devices or this will fail.
   */
  updateDevHardwareDevice: HardwareDevice;
  /**
   * Move the next-MAC cursor of one of a device family's MAC allocation blocks.
   * The block is chosen by nextMAC: the block whose range contains it, or the
   * block it sits one past the end of.
   */
  updateDeviceMACAllocation: DeviceMacAllocation;
  /** Update a device notification snooze. */
  updateDeviceNotificationSnooze: DeviceNotificationSnooze;
  /** Update the details of an existing document upload. */
  updateDocumentUpload: DocumentUpload;
  /** Updates an existing 802.1X encryption configuration. */
  updateEncryption8021X: Encryption8021X;
  /** Update a firewall rule. */
  updateFirewallRule: FirewallRule;
  /** Updates multiple firewall rules at once. */
  updateFirewallRules: Array<FirewallRule>;
  /** Update a fleetwide notification snooze. */
  updateFleetwideNotificationSnooze: FleetwideNotificationSnooze;
  /** Update the details of an existing floor plan. */
  updateFloorPlan: FloorPlan;
  /**
   * Update the status for a high availability event.
   * This is intended to only be called by the stat-consumer.
   */
  updateForHighAvailabilityEvent: Scalars['Boolean']['output'];
  /** Updates a single gateway profile. */
  updateGatewayProfile: GatewayProfile;
  /** Update the gateway uplink settings for a network's firewalls. */
  updateGatewayUplinkSettings: GatewayUplinkSettings;
  /** Update the metadata of a hardware device. */
  updateHardwareDevice: HardwareDevice;
  /** Update the hardware NOS version range for a specific hardware device model. */
  updateHardwareNosVersionRange: HardwareNosVersionRange;
  /**
   * Updates the hidden state of one or more fields on the company onboarding document.
   * Returns the keys of fields that are currently hidden after the update.
   */
  updateHiddenCompanyOnboardingDocumentFields: Array<Scalars['String']['output']>;
  /**
   * Updates the hidden state of one or more fields on the network onboarding document.
   * Returns the names of fields that are currently hidden after the update.
   */
  updateHiddenNetworkOnboardingDocumentFields: Array<Scalars['String']['output']>;
  /** Update an existing high availability configuration between two firewalls. */
  updateHighAvailabilityControllersConfiguration: HighAvailabilityControllersConfig;
  /** Update an existing host monitoring target. */
  updateHostMonitoringTarget: HostMonitoringTarget;
  /** Updates the IDS/IPS config for a network. */
  updateIDSIPSConfig: IdsipsConfig;
  /** Update a custom rule for an IDS configuration. */
  updateIDSIPSCustomRule: IdsipsCustomRule;
  /** Update an IP forwarding rule. */
  updateIPForwardingRule: IpForwardingRule;
  /** Update an IPSec tunnel. */
  updateIPSecTunnel: IpSecTunnel;
  /** Sets the permitted pairs for this network to these pairs, discarding others. Equivalent to PUT semantics. */
  updateInterVLANCommunicationPermittedPairs: Array<InterVlanCommunicationPermittedPair>;
  /** Update an internal note. */
  updateInternalNote: InternalNote;
  /** Updates an existing InternetServicePlan with the provided fields. */
  updateInternetServicePlan: InternetServicePlan;
  /** Updates an existing ISP Document with the provided fields. */
  updateInternetServicePlanDocument: InternetServicePlanDocument;
  /** Updates an existing fullfillment job with the provided fields. */
  updateInternetServicePlanFulfillmentJob: InternetServicePlanFulfillmentJob;
  /** Updates an existing fullfillment task with the provided fields. */
  updateInternetServicePlanFulfillmentTask: InternetServicePlanFulfillmentTask;
  /** Updates an existing InternetServicePlanProvider with the provided fields. Replaces aliases. */
  updateInternetServicePlanProvider: InternetServicePlanProvider;
  /** Updates an existing Internet Service Plan Provider Static Rate with the provided fields. */
  updateInternetServicePlanProviderStaticRate: InternetServicePlanProviderStaticRate;
  /** Updates existing Internet Service Plan Provider Static Rates in bulk. */
  updateInternetServicePlanProviderStaticRates?: Maybe<Array<InternetServicePlanProviderStaticRate>>;
  /** Updates a lab reservation. */
  updateLabReservation: LabReservation;
  /** Updates a lab resource. */
  updateLabResource: LabResource;
  /** Updates an availability record, such as marking a NEAR_NET or OFF_NET availability recommendable. */
  updateLocationProviderAvailability: LocationProviderAvailabilitySource;
  /** Updates the maintenance window for a network. */
  updateMaintenanceWindowForNetwork: MaintenanceWindow;
  /** Update an existing marketing changelog entry. */
  updateMarketingChangelogEntry: MarketingChangelogEntry;
  /** Updates a monitor group. */
  updateMonitorGroup: MonitorGroup;
  /** Updates a probe binding's evaluation parameters in a group. */
  updateMonitorGroupMember: MonitorGroup;
  /** Updates a monitor probe. */
  updateMonitorProbe: MonitorProbe;
  /** Update the network-level NAC configuration. */
  updateNACConfig: NacConfig;
  /** Update a static NAC credential. */
  updateNACCredential: NacCredential;
  /** Update a NAC user group. */
  updateNACGroup: NacGroup;
  /** Update a NAC IdP configuration. */
  updateNACIdPConfig: NacIdPConfig;
  /** Update a group mapping. */
  updateNACIdPGroupMapping: NacIdPGroupMapping;
  /** Update a NAC policy. */
  updateNACPolicy: NacPolicy;
  /** Update the metadata of an existing NOS upgrade group (not the devices contained in the group). */
  updateNOSUpgradeGroup: NosUpgradeGroup;
  /** Update many NOS upgrade groups at once. */
  updateNOSUpgradeGroups: Array<NosUpgradeGroup>;
  /** Update a network. */
  updateNetwork: Network;
  /** Update site-scoped metadata for a network. Creates the row on first call. */
  updateNetworkMetadata: NetworkMetadata;
  /** Mutation for updating a network reservation */
  updateNetworkReservation: NetworkReservation;
  /** Update a NetworkThreatAllowlistEntry for a network. */
  updateNetworkThreatAllowlistEntry: NetworkThreatAllowlistEntry;
  /**
   * Update the underlay Pool for a network.
   * This deactivates any existing active underlay pool and creates a new one.
   */
  updateNetworkUnderlayPool: UnderlayPool;
  /** Update an existing NOS feature. */
  updateNosFeature: NosFeature;
  /** Updates an existing NOS version with new data. */
  updateNosVersion: NosVersion;
  /** Update out-of-band management phy interface. */
  updateOOBPhyInterface: PhyInterface;
  /** Update an existing ObserverTest. */
  updateObserverTest: ObserverTest;
  /** Update an existing 1:1 NAT rule by its UUID. */
  updateOneToOneNATRule: OneToOneNatRule;
  /** Updates an existing Opportunity with the provided fields. */
  updateOpportunity: Opportunity;
  /** Update an outlet interface. */
  updateOutletInterface: OutletInterface;
  /** Update multiple outlet interfaces. */
  updateOutletInterfaces: Array<OutletInterface>;
  /** Update multiple outlet interfaces independently and atomically. */
  updateOutletInterfacesIndependently: Array<OutletInterface>;
  /** Update multiple packet capture groups. */
  updatePacketCaptureGroups: Array<PacketCaptureGroup>;
  /** Update a physical interface. */
  updatePhyInterface: PhyInterface;
  /** Update an existing phy interface DHCP rule by its UUID. */
  updatePhyInterfaceDHCPRule: PhyInterfaceDhcpRule;
  /** This mutation is intended to be called only by the Kafka consumer. It updates the physical interface for a Multi-WAN event. */
  updatePhyInterfaceForMultiWANEvent: Scalars['Boolean']['output'];
  /** Update multiple physical interfaces to the same values. */
  updatePhyInterfaces: Array<PhyInterface>;
  /** Update multiple phy interfaces simultaneously and atomically, each with independent parameters. Only a subset of parameters are supported. */
  updatePhyInterfacesIndependently: Array<PhyInterface>;
  /** Updates an existing path. */
  updatePolicyEnginePath: PolicyEnginePath;
  /** Updates multiple policy engine policies. */
  updatePolicyEnginePolicies: Array<PolicyEnginePolicy>;
  /** Updates a policy engine policy. */
  updatePolicyEnginePolicy: PolicyEnginePolicy;
  /** Updates an existing traffic matcher. */
  updatePolicyEngineTrafficMatcher: PolicyEngineTrafficMatcher;
  /** Update a policy routing rule. */
  updatePolicyRoutingRule: PolicyRoutingRule;
  /** Update a port forwarding rule. */
  updatePortForwardingRule: PortForwardingRule;
  /** Update the global proactive packet capture configuration for a network. */
  updateProactivePcapNetworkConfig: ProactivePcapNetworkConfig;
  /** Update the proactive packet capture configuration for an SSID. */
  updateProactivePcapSSIDConfig: ProactivePcapSsidConfig;
  /** Updates an existing Provider Connection Type Term with the provided fields. */
  updateProviderConnectionTypeTerm: ProviderConnectionTypeTerm;
  /**
   * Override the rate limits for a single public API key. A null value clears
   * that override and returns the key to the default for all keys.
   */
  updatePublicAPIKeyRateLimits: PublicApiKey;
  /** Updates an existing Quote. */
  updateQuote: Quote;
  /** Updates an existing Quote Request with the provided fields. */
  updateQuoteRequest: QuoteRequest;
  /** Update a rack elevation. */
  updateRackElevation: RackElevation;
  /** Update a device in a rack elevation. If the device is paired, placement changes also apply to its attached partner in the same rack; partners in other racks are unchanged. Labels and notes affect only the selected device. */
  updateRackElevationDevice: RackElevation;
  /** Update a radio profile. */
  updateRadioProfile: RadioProfile;
  /** Update a rate limit rule. */
  updateRateLimitRule: RateLimitRule;
  /** Update multiple rate limit rules with independent values. */
  updateRateLimitRulesIndependently: Array<RateLimitRule>;
  /** Updates an existing group-to-role mapping. */
  updateRoleMapping: CompanyRoleMapping;
  /** Update an existing SPAN mirror session. */
  updateSPANMirrorSession: SpanMirrorSession;
  /** Update an SSID. */
  updateSSID: Ssid;
  /** Update multiple SSIDs. */
  updateSSIDs: Array<Ssid>;
  /** Update multiple SSIDs with independent values. */
  updateSSIDsIndependently: Array<Ssid>;
  /** Updates a single security appliance profile. */
  updateSecurityApplianceProfile: SecurityApplianceProfile;
  /** Update all security appliance profiles belonging to a given network. */
  updateSecurityApplianceProfilesForNetwork: Array<SecurityApplianceProfile>;
  /** Fetch and update a Slack access token. */
  updateSlackAccessToken: SlackAccessToken;
  /** Update speedtest rules */
  updateSpeedtestRules: Array<SpeedtestRule>;
  /** Update a static route. */
  updateStaticRoute: StaticRoute;
  /** Update support cases. */
  updateSupportCases: Array<SupportCase>;
  /** Updates a support provider owned by a company. */
  updateSupportProvider: SupportProvider;
  /** Updates an alert receiver and its targets. */
  updateSupportProviderAlertReceiverWithTargets: AlertReceiver;
  /** Update an existing switch profile. */
  updateSwitchProfile: SwitchProfile;
  /** Update multiple switch profiles. */
  updateSwitchProfiles: Array<SwitchProfile>;
  /** Update a topology design link. */
  updateTopologyDesignLink: TopologyDesignLink;
  /** Update a topology design node. */
  updateTopologyDesignNode: TopologyDesignNode;
  /** Update a topology design version. Can rename, update notes, or commit a draft. */
  updateTopologyDesignVersion: TopologyDesignVersion;
  /** This mutation is intended to be called only by the Kafka consumer. It updates the external addresses of an uplink physical interface. */
  updateUplinkPhyInterfaceExternalAddresses: Scalars['Boolean']['output'];
  /**
   * Updates a user's roles to be only those specified by the input.
   *
   * Any existing roles not included in the input will be removed.
   */
  updateUserRoles: CompanyUser;
  /** Update an existing VLAN. */
  updateVLAN: Vlan;
  /** Sets the permitted pairs for this VLAN to these other VLANs, discarding others. Equivalent to PUT semantics. */
  updateVLANInterVLANCommunicationPermittedVLANs: Vlan;
  /** Update many VLANs at once, applying the same settings to each. */
  updateVLANs: Array<Vlan>;
  /** Update many VLANs at once, applying different settings to each. */
  updateVLANsIndependently: Array<Vlan>;
  /** Update the metadata of a virtual device. */
  updateVirtualDevice: VirtualDevice;
  /** Update a virtual device tag. */
  updateVirtualDeviceTag: VirtualDeviceTag;
  /** Update the metadata of multiple virtual devices at once, to the same values for all devices. */
  updateVirtualDevices: Array<VirtualDevice>;
  /** Update the metadata of multiple virtual devices at once, to different values for each device. */
  updateVirtualDevicesIndependently: Array<VirtualDevice>;
  /** Update a Wifi IPSK's client MACs */
  updateWifiIPSK: WifiIpsk;
  /** Upload the results of a client observer test performed by a client device. */
  uploadClientObserverTest: ClientObserverTest;
  /** Create or update alert deprioritization window configurations for multiple networks. */
  upsertAlertDeprioritizationWindowsForNetworks: Array<AlertDeprioritizationWindow>;
  /** Upserts the read/archived state for every inbox message visible to the current user in the given company. */
  upsertAllInboxMessageStates: Array<InboxMessage>;
  /**
   * Creates or updates the company onboarding document using PUT semantics.
   * The document is keyed by `companyUUID` for convenience.
   */
  upsertCompanyOnboardingDocument: CompanyOnboardingDocument;
  /**
   * Creates or updates the company onboarding document metadata using PUT semantics.
   * The document metadata is keyed by `companyUUID` for convenience.
   */
  upsertCompanyOnboardingDocumentMetadata: CompanyOnboardingDocument;
  /** Delegates specific fields of the company onboarding document to a user. */
  upsertCompanyOnboardingFieldDelegation: CompanyOnboardingFieldDelegation;
  /** Only use this in development or extreme outage situations! Overrides the rendered configuration for a device with the given JSON. */
  upsertDeviceConfigOverride: Scalars['Boolean']['output'];
  /** Configure a category for an IDS/IPS configuration. */
  upsertIDSIPSConfigCategoryBinding: IdsipsConfigCategoryBinding;
  /** Configure a rule for an IDS configuration. */
  upsertIDSIPSConfigRuleBinding: IdsipsConfigRuleBinding;
  /** Upserts the state of the message in an inbox */
  upsertInboxMessageState: InboxMessage;
  /** Upserts the read/archived state for a set of inbox messages visible to the current user. */
  upsertInboxMessageStates: Array<InboxMessage>;
  /**
   * Creates or replaces the manual availability (ON_NET, NEAR_NET or OFF_NET) of a provider and connection type at a location, independent of any Quote.
   * If the location already has a manual availability for the provider and connection type, its availability is replaced.
   */
  upsertLocationProviderAvailability: LocationProviderAvailabilitySource;
  /** Creates a new alias for a MAC address or updates an existing one within a specified company. */
  upsertMACAddressAlias: MacAddressAlias;
  /** Creates a new alias for a MAC address or updates an existing one within a specified company. */
  upsertMACAddressAliases: Array<MacAddressAlias>;
  /**
   * Replace the set of NOS versions the network's primary firewall caches
   * for internal use. Only permitted on non-customer networks, and limited
   * to at most 5 NOS versions per network.
   */
  upsertNetworkCachedNOSVersions: Network;
  /**
   * Creates or updates the network onboarding document using PUT semantics.
   * The document is keyed by `networkUUID` for convenience.
   */
  upsertNetworkOnboardingDocument: NetworkOnboardingDocument;
  /**
   * Creates or updates the network onboarding document metadata using PUT semantics.
   * The document metadata is keyed by `networkUUID` for convenience.
   */
  upsertNetworkOnboardingDocumentMetadata: NetworkOnboardingDocument;
  /** Delegates specific fields of the network onboarding document to a user. */
  upsertNetworkOnboardingFieldDelegation: NetworkOnboardingFieldDelegation;
  /** Upsert recurring auto channel selection schedules for multiple networks. */
  upsertRecurringAutoChannelSelectionJobs: Array<RecurringAutoChannelSelectionJob>;
  /** Bind MAC addresses or OUIs to VLANs before running Switch Auto Config. The mappings provided here will replace any existing mappings for the specified network, deleting any pre-existing mappings not included in the input. */
  upsertSwitchAutoConfigMACAddressVLANBindingsForNetwork: Array<SwitchAutoConfigMacAddressVlanBinding>;
  /** Replace the entire topology design for a version. Nodes with a UUID are updated; nodes without are created; existing nodes not in the list are deleted. */
  upsertTopologyDesign: TopologyDesign;
  /** Validates a bearer session using its UUID. Should only be called a single time. Once validated, the bearer session can be used to authenticate. */
  validateBearerSession: BearerSession;
  /**
   * Sign off a committed topology design version: record the calling user as the deployment
   * engineer accountable for the verification, along with the moment of sign-off.
   *
   * Only committed versions can be verified, since a committed design is the one to deploy and
   * is immutable, so a signature cannot be invalidated by later edits. Rejects a version that is
   * already verified: withdraw the existing signature first rather than silently reassigning
   * accountability.
   */
  verifyTopologyDesignVersion: TopologyDesignVersion;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationActionCaptivePortalEntryArgs = {
  action: CaptivePortalEntryAction;
  entryUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationActivateCompanyUserArgs = {
  companyUserUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationActivateDeviceSimArgs = {
  input: SimActivationInput;
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAddHubToAutoVpnGroupArgs = {
  groupUUID: Scalars['UUID']['input'];
  input: CreateAutoVpnHubInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAddMonitorGroupMemberArgs = {
  input: AddMonitorGroupMemberInput;
  monitorGroupUUID: Scalars['UUID']['input'];
  monitorProbeBindingUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAddNetworkToAutoVpnGroupArgs = {
  groupUUID: Scalars['UUID']['input'];
  input: AddNetworkToAutoVpnGroupInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAddNetworksToAutoVpnGroupArgs = {
  groupUUID: Scalars['UUID']['input'];
  inputs: Array<AddNetworkToAutoVpnGroupInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAddSupportProviderArgs = {
  input?: InputMaybe<AddSupportProviderInput>;
  providerUUID: Scalars['UUID']['input'];
  targetCompanyUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationApplyQuoteRecommendationsArgs = {
  input: QuoteRecommendationInput;
  quoteRequestUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationApplySwitchAutoConfigurationDryRunArgs = {
  jobUUID: Scalars['UUID']['input'];
  onlyChangeFromVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  onlyChangeToVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledAtNextMaintenanceWindow?: Scalars['Boolean']['input'];
  skipFromVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  skipPhyInterfaceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  skipToVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  skipVirtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationApplyTemplateToNetworkArgs = {
  destinationNetworkUUID: Scalars['UUID']['input'];
  shouldKeepSSIDNames?: Scalars['Boolean']['input'];
  sourceNetworkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationApprovePublicApiKeyGrantRequestArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationApproveTemporaryAccessGrantArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAssignHardwareDeviceToNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAssignHardwareDeviceToNetworkAsSpareArgs = {
  networkUUID: Scalars['UUID']['input'];
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAssignHardwareDeviceToVirtualDeviceArgs = {
  serialNumber: Scalars['String']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAssignHardwareDevicesToVirtualDevicesArgs = {
  inputs: Array<AssignHardwareDeviceToVirtualDeviceInput>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAssignOperatorRoleArgs = {
  companySlug?: InputMaybe<Scalars['String']['input']>;
  companyUserUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAssignSuperOperatorRoleArgs = {
  companySlug?: InputMaybe<Scalars['String']['input']>;
  companyUserUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAssignSwitchProfleToVirtualDeviceArgs = {
  UUID: Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAttachDeviceToRackElevationArgs = {
  input: AttachDeviceToRackElevationInput;
  rackElevationUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAttachDevicesToRackElevationsArgs = {
  devices: Array<AttachDevicesToRackElevationsInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationAttachVirtualDeviceToRadioProfileArgs = {
  radioProfileUUID: Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindFirewallRuleToPhyInterfaceArgs = {
  input: BindFirewallRuleToPhyInterface;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindFirewallRuleToVlanArgs = {
  input: BindFirewallRuleToVlan;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindFirewallRulesToPhyInterfaceArgs = {
  orderedRuleUUIDs: Array<Scalars['UUID']['input']>;
  phyInterfaceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindFirewallRulesToVlanArgs = {
  orderedRuleUUIDs: Array<Scalars['UUID']['input']>;
  vlanUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindPhyInterfaceToFirewallRulesArgs = {
  firewallRuleUUIDs: Array<Scalars['UUID']['input']>;
  phyInterfaceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindPolicyRoutingRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: BindPolicyRoutingRuleInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindPolicyRoutingRulesArgs = {
  input: BindPolicyRoutingRulesInput;
  orderedRuleUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindRateLimitRuleToPhyInterfaceArgs = {
  input: RateLimitPhyInterfaceBindingInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindRateLimitRuleToSsidArgs = {
  input: RateLimitSsidBindingInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindRateLimitRuleToVlanArgs = {
  input: RateLimitVlanBindingInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindTagToVirtualDevicesArgs = {
  tagUUID: Scalars['UUID']['input'];
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindVlanToFirewallRulesArgs = {
  firewallRuleUUIDs: Array<Scalars['UUID']['input']>;
  vlanUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBindVlaNtoPhyInterfaceArgs = {
  input: BindVlanToPhyInterfaceInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBlockClientsInNetworkArgs = {
  macAddresses?: InputMaybe<Array<Scalars['MacAddress']['input']>>;
  networkUUID: Scalars['UUID']['input'];
  ouis?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationBlockClientsInSsidArgs = {
  macAddresses?: InputMaybe<Array<Scalars['MacAddress']['input']>>;
  ouis?: InputMaybe<Array<Scalars['String']['input']>>;
  ssidUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCancelAutoChannelSelectionJobArgs = {
  jobUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCancelAutoSwitchConfigurationJobArgs = {
  jobUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCancelPublicApiKeyGrantRequestArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCancelScheduledNetworkNosUpgradeArgs = {
  forceInProgressCancel?: Scalars['Boolean']['input'];
  scheduledNetworkNOSUpgradeUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCancelWirelessCalibrationJobArgs = {
  input: CancelWirelessCalibrationJobInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationClaimHardwareDeviceArgs = {
  forRealm: HardwareDeviceRealm;
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationConfigureSsoArgs = {
  input: ConfigureSsoInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCopyTopologyDesignVersionToNetworksArgs = {
  targetNetworkUUIDs: Array<Scalars['UUID']['input']>;
  topologyDesignVersionUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCopyVirtualDeviceToNewModelArgs = {
  deviceMigrationOptions?: InputMaybe<DeviceMigrationInput>;
  newDeviceModel: DeviceModel;
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCopyVirtualDevicesToNewModelsArgs = {
  inputs: Array<CopyVirtualDeviceToNewModelInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateAccessPointPortProfileArgs = {
  input: CreateAccessPointPortProfileInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateAlertCompanySubscriptionArgs = {
  input: CreateAlertCompanySubscriptionInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateAlertFleetwideSubscriptionArgs = {
  input: CreateAlertFleetwideSubscriptionInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateAlertReceiverWithTargetsArgs = {
  companyUUID: Scalars['UUID']['input'];
  input: CreateAlertReceiverWithTargetsInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateAlertSupportProviderSubscriptionArgs = {
  input?: InputMaybe<CreateAlertSupportProviderSubscriptionInput>;
  supportProviderUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateAlertTargetSalesforceArgs = {
  companyUUID: Scalars['UUID']['input'];
  input: CreateAlertTargetSalesforceInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateAlertTargetSlackArgs = {
  companyUUID: Scalars['UUID']['input'];
  input: CreateAlertTargetSlackInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateAlertTargetWebhookArgs = {
  companyUUID: Scalars['UUID']['input'];
  input: CreateAlertTargetWebhookInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateApplicationDnsFirewallRuleArgs = {
  dhcpRuleUUID?: InputMaybe<Scalars['UUID']['input']>;
  input: CreateApplicationDnsFirewallRuleInput;
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateApplicationDnsFirewallRulesArgs = {
  inputs: Array<CreateApplicationDnsFirewallRulesInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateAutoVpnGroupArgs = {
  companySlug: Scalars['String']['input'];
  input: CreateAutoVpnGroupInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateAutoVpnRouteArgs = {
  groupUUID: Scalars['UUID']['input'];
  input: CreateAutoVpnRouteInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateBgpNeighborArgs = {
  input: CreateBgpNeighborInput;
  routerUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateBgpRouterArgs = {
  input: CreateBgpRouterInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateBulkNosUpgradeArgs = {
  input: CreateBulkNosUpgradeInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateCaptivePortalArgs = {
  input: CaptivePortalSettingsInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateCaptivePortalsArgs = {
  inputs: Array<CreateCaptivePortalsInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateCellularHardwareDevicesArgs = {
  inputs: Array<CreateCellularHardwareDeviceInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateClientVpnClientArgs = {
  input: CreateClientVpnClientInput;
  serverUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateClientVpnClientsArgs = {
  inputs: Array<CreateClientVpnClientInput>;
  serverUUID: Scalars['UUID']['input'];
  skipEmails?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateClientVpnServerArgs = {
  input: CreateClientVpnServerInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateCompanyOnboardingArgs = {
  companyUUID: Scalars['UUID']['input'];
  jobTrackerID: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateCompanySiemIntegrationArgs = {
  companyUUID: Scalars['UUID']['input'];
  input: CreateCompanySiemIntegrationInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateCompanyUserArgs = {
  companySlug: Scalars['String']['input'];
  input: CreateCompanyUserInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateComplianceFrameworkArgs = {
  input: CreateComplianceFrameworkInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateComplianceReportArgs = {
  input: CreateComplianceReportInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateConnectStaticRateArgs = {
  input: CreateConnectStaticRateInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateCustomRoleArgs = {
  companySlug: Scalars['String']['input'];
  input: CreateCustomRoleInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDdnsRecordArgs = {
  input: CreateDdnsRecordInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDhcpOptionArgs = {
  dhcpRuleUUID: Scalars['UUID']['input'];
  input: CreateDhcpOptionInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDhcpProxyArgs = {
  dhcpRuleUUID: Scalars['UUID']['input'];
  input: CreateDhcpProxyInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDhcpReservedRangeArgs = {
  dhcpRuleUUID: Scalars['UUID']['input'];
  input: CreateDhcpReservedRangeInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDhcpRuleArgs = {
  input: CreateDhcpRuleInput;
  vlanUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDhcpRuleFilterArgs = {
  dhcpRuleUUID: Scalars['UUID']['input'];
  input: CreateDhcpRuleFilterInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDhcpStaticMappingArgs = {
  dhcpRuleUUID: Scalars['UUID']['input'];
  input: CreateDhcpStaticMappingInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDhcpStaticMappingsArgs = {
  inputs: Array<CreateDhcpStaticMappingForRuleInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDnsHostMappingArgs = {
  dhcpRuleUUID: Scalars['UUID']['input'];
  input: CreateDnsHostMappingInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDnsHostMappingsArgs = {
  dhcpRuleUUID: Scalars['UUID']['input'];
  inputs: Array<CreateDnsHostMappingInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDeploymentJobArgs = {
  input: DeploymentJobInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDeploymentTaskBlockersArgs = {
  input: Array<CreateDeploymentTaskBlockerInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDeploymentTaskExceptionArgs = {
  input: CreateDeploymentTaskExceptionInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDeploymentTaskExceptionMessageArgs = {
  input: CreateDeploymentTaskExceptionMessageInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDeploymentTimeWindowArgs = {
  input?: InputMaybe<CreateDeploymentTimeWindowInput>;
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<DeploymentTimeWindowType>;
  window?: InputMaybe<TimeWindowInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDevHardwareDeviceArgs = {
  input: CreateDevHardwareDeviceInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDeviceBatchArgs = {
  input: CreateDeviceBatchInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDeviceMacAllocationArgs = {
  deviceFamily: Scalars['String']['input'];
  input: CreateDeviceMacAllocationInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDeviceNotificationSnoozesArgs = {
  input: CreateDeviceNotificationSnoozeInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDocumentUploadsArgs = {
  companyUUID: Scalars['UUID']['input'];
  inputs: Array<CreateDocumentUploadInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateDynamicFloorPlanOpenIntentUploadArgs = {
  input: CreateDynamicFloorPlanOpenIntentUploadInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateEncryption8021XArgs = {
  input: CreateEncryption8021XInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateEncryption8021XesArgs = {
  inputs: Array<CreateEncryption8021XInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateFirewallRuleArgs = {
  input: CreateFirewallRuleInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateFirewallRulesArgs = {
  inputs: Array<CreateFirewallRulesInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateFleetwideNotificationSnoozeArgs = {
  companyUUID?: InputMaybe<Scalars['UUID']['input']>;
  fleetwideNotificationSettingUUID?: InputMaybe<Scalars['UUID']['input']>;
  input: CreateNotificationSnoozeInput;
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateFloorPlanArgs = {
  input: CreateFloorPlanInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateGlobalNotificationSnoozeArgs = {
  input: CreateGlobalNotificationSnoozeInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateHardwareDevicePairArgs = {
  input: CreateHardwareDevicePairInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateHardwareDevicePairsArgs = {
  inputs: Array<CreateHardwareDevicePairInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateHardwareNosVersionRangeArgs = {
  deviceModel: DeviceModel;
  versionRange: HardwareNosVersionRangeInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateHighAvailabilityControllersConfigurationArgs = {
  backupPhyInterfaceUUID: Scalars['UUID']['input'];
  input: CreateHighAvailabilityPairInput;
  networkUUID: Scalars['UUID']['input'];
  primaryPhyInterfaceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateHostMonitoringTargetArgs = {
  input: CreateHostMonitoringTargetInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateIdsipsConfigArgs = {
  input: CreateIdsipsConfigInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateIdsipsCustomRuleArgs = {
  idsIPSConfigUUID: Scalars['UUID']['input'];
  input: CreateIdsipsCustomRuleInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateIpForwardingRuleArgs = {
  input: CreateIpForwardingRuleInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateIpSecTunnelArgs = {
  input: CreateIpSecTunnelInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateInternalNoteArgs = {
  companyUUID?: InputMaybe<Scalars['UUID']['input']>;
  input: CreateInternalNoteInput;
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateInternetServicePlanArgs = {
  companySlug?: InputMaybe<Scalars['String']['input']>;
  input: CreateInternetServicePlanInput;
  mailingAddressUUID?: InputMaybe<Scalars['UUID']['input']>;
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateInternetServicePlanDocumentArgs = {
  input: CreateInternetServicePlanDocumentInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateInternetServicePlanFulfillmentJobArgs = {
  input: CreateInternetServicePlanFulfillmentJobInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateInternetServicePlanFulfillmentTaskArgs = {
  input: CreateInternetServicePlanFulfillmentTaskInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateInternetServicePlanPaymentResourceArgs = {
  input: CreateInternetServicePlanPaymentResourceInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateInternetServicePlanProviderArgs = {
  input: CreateInternetServicePlanProviderInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateInternetServicePlanProviderStaticRateArgs = {
  input: CreateInternetServicePlanProviderStaticRateInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateKnockTokenArgs = {
  companyUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateLabReservationArgs = {
  input: CreateLabReservationInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateLabReservationsByKindArgs = {
  input: CreateLabReservationsByKindInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateLabResourceArgs = {
  input: CreateLabResourceInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateMarketingChangelogEntryArgs = {
  input: CreateMarketingChangelogEntryInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateMonitorGroupArgs = {
  input: CreateMonitorGroupInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateMonitorProbeArgs = {
  input: CreateMonitorProbeInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateMonitorProbeBindingArgs = {
  input: CreateMonitorProbeBindingInput;
  monitorProbeUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNacCredentialArgs = {
  companyUUID: Scalars['UUID']['input'];
  input: CreateNacCredentialInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNacCredentialsArgs = {
  companyUUID: Scalars['UUID']['input'];
  inputs: Array<BulkCreateNacCredentialInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNacGroupArgs = {
  companyUUID: Scalars['UUID']['input'];
  input: CreateNacGroupInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNacIdPConfigArgs = {
  companyUUID: Scalars['UUID']['input'];
  input: CreateNacIdPConfigInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNacIdPGroupMappingArgs = {
  input: CreateNacIdPGroupMappingInput;
  nacIdPConfigUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNacPolicyArgs = {
  input: CreateNacPolicyInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNacPolicyEntryArgs = {
  input: CreateNacPolicyEntryInput;
  nacPolicyUUID: Scalars['UUID']['input'];
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNosUpgradeGroupArgs = {
  input: CreateNosUpgradeGroupInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNetworkArgs = {
  input: CreateNetworkInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNetworkClientCpeBindingsArgs = {
  inputs: Array<CreateNetworkClientCpeBindingInput>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNetworkOnboardingArgs = {
  jobTrackerID: Scalars['String']['input'];
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNetworkReservationArgs = {
  input: CreateNetworkReservationInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNetworkThreatAllowlistEntryArgs = {
  input: CreateNetworkThreatAllowlistEntryInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNosFeatureArgs = {
  input: CreateNosFeatureInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateNosVersionArgs = {
  input: NosVersionInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateObserverTestArgs = {
  input: CreateObserverTestInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateOneToOneNatRuleArgs = {
  input: CreateOneToOneNatRuleInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreatePermittedEmailDomainArgs = {
  input: CreatePermittedEmailDomainInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreatePhyInterfaceDhcpRuleArgs = {
  input: CreatePhyInterfaceDhcpRuleInput;
  phyInterfaceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreatePolicyEnginePathArgs = {
  input: CreatePolicyEnginePathInput;
  policyEnginePolicyUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreatePolicyEnginePolicyArgs = {
  input: CreatePolicyEnginePolicyInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreatePolicyEngineTrafficMatcherArgs = {
  input: CreatePolicyEngineTrafficMatcherInput;
  policyEnginePolicyUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreatePolicyRoutingRuleArgs = {
  input: CreatePolicyRoutingRuleInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreatePortForwardingRuleArgs = {
  input: CreatePortForwardingRuleInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreatePreSignedUploadUrlArgs = {
  input: CreatePreSignedUploadUrlInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateProactivePcapNetworkConfigArgs = {
  input: CreateProactivePcapNetworkConfigInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateProactivePcapSsidConfigArgs = {
  input: CreateProactivePcapSsidConfigInput;
  ssidUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateProviderConnectionTypeTermArgs = {
  input: CreateProviderConnectionTypeTermInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreatePublicApiKeyArgs = {
  companyUUID: Scalars['UUID']['input'];
  input: CreatePublicApiKeyInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateQuoteArgs = {
  input: CreateQuoteInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateQuoteRequestArgs = {
  input: CreateQuoteRequestInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateRackElevationArgs = {
  input: CreateRackElevationInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateRadioProfileArgs = {
  input: CreateRadioProfileInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateRadioProfilesArgs = {
  inputs: Array<CreateRadioProfilesInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateRateLimitRuleArgs = {
  input: CreateRateLimitRuleInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateRoleMappingArgs = {
  input: CreateCompanyRoleMappingInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSpanMirrorSessionArgs = {
  input: CreateSpanMirrorSessionInput;
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSsidArgs = {
  input: CreateSsidInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSsiDsArgs = {
  inputs: Array<CreateSsiDsInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSsoAdminPortalLinkArgs = {
  input?: InputMaybe<ConfigureSsoInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSsoVerifyArgs = {
  input: CreateSsoVerifyInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSecurityApplianceDevicePairArgs = {
  input: CreateSecurityApplianceDevicePairInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSecurityApplianceDevicePairsArgs = {
  inputs: Array<CreateSecurityApplianceDevicePairInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateServiceRequestArgs = {
  input: CreateServiceRequestInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSessionTokenArgs = {
  retrievalToken: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSlackAccessTokenArgs = {
  companyUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSpeedtestRuleArgs = {
  companyUUID: Scalars['UUID']['input'];
  input: CreateSpeedtestRuleInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSsoOAuthUriArgs = {
  targetApp: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateStaticRouteArgs = {
  input: CreateStaticRouteInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSupportCaseArgs = {
  input: CreateSupportCaseInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSupportCaseAttachmentsArgs = {
  input: CreateSupportCaseAttachmentsInput;
  supportCaseUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSupportCaseCommentArgs = {
  input: CreateSupportCaseCommentInput;
  supportCaseUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSupportProviderArgs = {
  companyUUID: Scalars['UUID']['input'];
  input?: InputMaybe<CreateSupportProviderInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSupportProviderAlertReceiverWithTargetsArgs = {
  input: CreateSupportProviderAlertReceiverWithTargetsInput;
  supportProvider: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSupportUserArgs = {
  input: CreateSupportUserInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSwitchAutoConfigMacAddressVlanBindingsArgs = {
  input: Array<CreateSwitchAutoConfigMacAddressVlanBindingInput>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSwitchProfileArgs = {
  input: CreateSwitchProfileInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateSyntheticHardwareDeviceArgs = {
  input: CreateSyntheticHardwareDeviceInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateTemplateFromNetworkArgs = {
  destinationCompanyUUID: Scalars['UUID']['input'];
  label: Scalars['String']['input'];
  sourceNetworkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateTemplateNetworkArgs = {
  input: CreateNetworkInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateTopologyDesignLinkArgs = {
  input: CreateTopologyDesignLinkInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateTopologyDesignNodeArgs = {
  input: CreateTopologyDesignNodeInput;
  topologyDesignVersionUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateTopologyDesignVersionArgs = {
  input: CreateTopologyDesignVersionInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateTopologyDesignVirtualDevicesArgs = {
  input: CreateTopologyDesignVirtualDevicesInput;
  topologyDesignVersionUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateUserFeedbackArgs = {
  companySlug: Scalars['String']['input'];
  input: CreateUserFeedbackInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateUserNetworkAccessArgs = {
  input: CreateUserNetworkAccessInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateVlanArgs = {
  input: CreateVlanInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateVlaNsArgs = {
  inputs: Array<CreateVlanInput>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateVirtualDeviceArgs = {
  input: CreateVirtualDeviceInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateVirtualDeviceTagArgs = {
  input: CreateVirtualDeviceTagInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateVirtualDevicesArgs = {
  input: CreateVirtualDevicesInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateVirtualDevicesIndependentlyArgs = {
  input: Array<CreateVirtualDeviceInput>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateWifiIpskArgs = {
  input: CreateWifiIpskInput;
  ssidUUID?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCreateWifiIpsKsArgs = {
  input?: InputMaybe<Array<CreateWifiIpskInput>>;
  inputs?: InputMaybe<Array<CreateWifiIpsKsInput>>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCutoverMutableEntitiesToNewVirtualDeviceArgs = {
  destinationVirtualDeviceUUID: Scalars['UUID']['input'];
  sourceVirtualDeviceUUID: Scalars['UUID']['input'];
  undoCutover?: Scalars['Boolean']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationCycleAccessPointChannelsArgs = {
  connectedClientLookback?: InputMaybe<Scalars['Duration']['input']>;
  radioBands: Array<RadioBand>;
  timeout?: Scalars['Duration']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeactivateDeviceSimArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteAccessPointPortProfileArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteAlertCompanySubscriptionsArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteAlertDeprioritizationWindowsForNetworksArgs = {
  networkUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteAlertFleetwideSubscriptionsArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteAlertReceiverWithTargetsArgs = {
  alertReceiverUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteAlertSupportProviderSubscriptionsArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
  supportProviderUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteAlertTargetSalesforceArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteAlertTargetSlackArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteAlertTargetWebhookArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteAllWifiIpsKsForSsidArgs = {
  ssidUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteApplicationDnsFirewallRuleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteApplicationDnsFirewallRulesArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteAutoVpnGroupArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteAutoVpnMemberArgs = {
  memberUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteAutoVpnMembersArgs = {
  memberUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteAutoVpnRouteArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteBgpNeighborArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteBgpRouterArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteBulkNosUpgradeArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteCaptivePortalArgs = {
  uuid: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteClientVpnClientArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteClientVpnServerArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteCompanyOnboardingDocumentArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteCompanyOnboardingFieldDelegationArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteCompanySiemIntegrationArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteCompanyUserArgs = {
  companyUserUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteConnectStaticRateArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteCustomRoleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDdnsRecordArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDhcpOptionArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDhcpProxyArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDhcpReservedRangeArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDhcpRuleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDhcpRuleFilterArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDhcpStaticMappingArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDhcpStaticMappingsArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDnsHostMappingArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDeploymentJobArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDeploymentTaskArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDeploymentTaskBlockerArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDeploymentTimeWindowArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDeviceMacAllocationArgs = {
  UUID?: InputMaybe<Scalars['UUID']['input']>;
  deviceFamily: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDeviceNotificationSnoozeArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteDocumentUploadsArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteEncryption8021XArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteFirewallRuleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteFirewallRulesArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteFleetwideNotificationSnoozeArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteFloorPlanArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteGlobalNotificationSnoozeArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteHardwareDevicePairArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteHighAvailabilityControllersConfigurationArgs = {
  UUID?: InputMaybe<Scalars['UUID']['input']>;
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteHostMonitoringTargetArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteIdsipsConfigArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteIdsipsConfigCategoryBindingArgs = {
  idsIPSCategoryUUID: Scalars['UUID']['input'];
  idsIPSConfigUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteIdsipsConfigRuleBindingArgs = {
  idsIPSConfigUUID: Scalars['UUID']['input'];
  ruleSID: Scalars['Int']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteIdsipsCustomRuleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteIpForwardingRuleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteIpSecTunnelArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteInternalNoteArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteInternetServicePlanArgs = {
  internetServicePlanUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteInternetServicePlanDocumentArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteInternetServicePlanFulfillmentJobArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteInternetServicePlanFulfillmentTaskArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteInternetServicePlanProviderStaticRateArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteLabReservationArgs = {
  reservationUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteLabResourceArgs = {
  resourceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteLocationProviderAvailabilityArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteMarketingChangelogEntryArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteMonitorGroupArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteMonitorProbeArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteMonitorProbeBindingArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNacConfigArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNacCredentialArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNacGroupArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNacIdPConfigArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNacIdPGroupMappingArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNacPolicyArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNacPolicyEntryArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNosUpgradeGroupArgs = {
  nosUpgradeGroupUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNetworkArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNetworkClientCpeBindingsArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNetworkOnboardingDocumentArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNetworkOnboardingFieldDelegationArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNetworkReservationArgs = {
  reservationUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNetworkThreatAllowlistEntryArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNetworkUnderlayPoolArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteNosVersionArgs = {
  id: Scalars['Int']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteObserverTestBindingsArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteObserverTestsArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteOneToOneNatRuleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteOneToOneNatRulesArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeletePermittedEmailDomainArgs = {
  input: DeletePermittedEmailDomainInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeletePhyInterfaceDhcpRuleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeletePolicyEnginePathArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeletePolicyEnginePolicyArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeletePolicyEngineTrafficMatcherArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeletePolicyRoutingRuleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeletePortForwardingRuleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeletePortForwardingRulesArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteProactivePcapSsidConfigArgs = {
  ssidUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteProviderConnectionTypeTermArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteQuoteArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteQuoteRequestArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteRackElevationArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteRadioProfileArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteRateLimitRuleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteRecurringAutoChannelSelectionJobsArgs = {
  networkUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteRoleMappingArgs = {
  input: DeleteCompanyRoleMappingInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteSpanMirrorSessionArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteSsidArgs = {
  uuid: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteSsiDsArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteSlackAccessTokenArgs = {
  uuid: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteSlackAccessTokensForCompanyArgs = {
  companyUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteSpeedtestRulesArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteStaticRouteArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteSupportCasesArgs = {
  uuids: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteSupportProviderArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteSupportProviderAlertReceiverWithTargetsArgs = {
  input: DeleteSupportProviderAlertReceiverWithTargetsInput;
  supportProvider: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteSupportUserArgs = {
  userID: Scalars['ID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteSwitchAutoConfigMacAddressVlanBindingArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteTopologyDesignLinkArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteTopologyDesignNodeArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteTopologyDesignVersionArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteVlanArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteVlaNsArgs = {
  vlanUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteVirtualDeviceArgs = {
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteVirtualDeviceTagArgs = {
  tagUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteVirtualDevicesArgs = {
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDeleteWifiIpskArgs = {
  uuid: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDenyTemporaryAccessGrantArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDetachDeviceFromRackElevationArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDetachDevicesFromRackElevationArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationDetachVirtualDeviceFromRadioProfileArgs = {
  radioProfileUUID: Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationEditMutationAuditLogEntryReasonArgs = {
  UUID: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationEditMutationDiffAuditLogEntryReasonArgs = {
  UUID: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationEnableSsoForCompanyArgs = {
  companySlug: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationEndGlobalNotificationSnoozeArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationForgetNacClientDeviceArgs = {
  callingStationID: Scalars['MacAddress']['input'];
  identity: Scalars['String']['input'];
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationGeneratePowerPlanForNetworkArgs = {
  calibrationJobUUID: Scalars['UUID']['input'];
  commit?: Scalars['Boolean']['input'];
  input: PowerPlanInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationGenerateTopologyDesignArgs = {
  input: GenerateTopologyDesignInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationInitializeAutoChannelSelectionDryRunForNetworksArgs = {
  networkUUIDs: Array<Scalars['UUID']['input']>;
  stickinessThreshold?: InputMaybe<Scalars['Float']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationInitializeAutoChannelSelectionForAccessPointsArgs = {
  input: AutoChannelSelectionJobInput;
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationInitializeAutoChannelSelectionForNetworkArgs = {
  input: AutoChannelSelectionJobInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationInitializeAutoSwitchConfigurationForNetworkArgs = {
  input: SwitchAutoConfigurationJobInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationInsertStatsForDemoArgs = {
  companySlug: Scalars['String']['input'];
  duration?: InputMaybe<StatInjectionDuration>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationInvalidatePhyInterfaceConnectedDevicesArgs = {
  input?: InputMaybe<InvalidatePhyInterfaceConnectedDevicesInput>;
  phyInterfaceUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationInviteClientVpnClientArgs = {
  input: InviteClientVpnClientInput;
  serverUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationInviteClientVpnClientsArgs = {
  inputs: Array<InviteClientVpnClientInput>;
  serverUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationMintAuthenticationTokenArgs = {
  input?: InputMaybe<MintTokenInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationMoveInternetServicePlanToNetworkArgs = {
  internetServicePlanUUID: Scalars['UUID']['input'];
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationMoveRackElevationDeviceToRackArgs = {
  UUID: Scalars['UUID']['input'];
  input: MoveRackElevationDeviceToRackInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationMoveRackElevationDevicesToRackArgs = {
  input: MoveRackElevationDevicesToRackInput;
  rackElevationUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationPauseSalesforceJobQueuesArgs = {
  queues: Array<SalesforceJobQueue>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationPinDeviceConfigsForNetworkArgs = {
  maxDeviceConfigCreatedAt: Scalars['DateTime']['input'];
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationPinDeviceConfigsForNetworksArgs = {
  maxDeviceConfigCreatedAt: Scalars['DateTime']['input'];
  networkUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationPriceQuoteArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationReactivateDeviceSimArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationReassignHardwareToOtherNetworkArgs = {
  destinationNetworkUUID: Scalars['UUID']['input'];
  inputs: Array<ReassignHardwareToOtherNetworkInput>;
  sourceNetworkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationReassignNetworkArgs = {
  destinationNetworkUUID: Scalars['UUID']['input'];
  sourceNetworkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRefreshObserverTestBindingsArgs = {
  snr?: InputMaybe<Scalars['Int']['input']>;
  uuid: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRejectPublicApiKeyGrantRequestArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRemoveHubFromAutoVpnGroupArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRemoveMonitorGroupMemberArgs = {
  monitorGroupUUID: Scalars['UUID']['input'];
  monitorProbeBindingUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRemoveNetworksFromAutoVpnGroupArgs = {
  groupUUID: Scalars['UUID']['input'];
  networkUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRemoveNetworksFromBulkNosUpgradeArgs = {
  UUID: Scalars['UUID']['input'];
  networkUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRemoveOperatorRoleArgs = {
  companySlug?: InputMaybe<Scalars['String']['input']>;
  companyUserUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRemoveSuperOperatorRoleArgs = {
  companySlug?: InputMaybe<Scalars['String']['input']>;
  companyUserUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRemoveSupportProviderArgs = {
  providerUUID: Scalars['UUID']['input'];
  targetCompanyUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRenderDeviceConfigArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRenderDeviceConfigWithoutOverridesArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationReorderNacPoliciesArgs = {
  networkUUID: Scalars['UUID']['input'];
  policyUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRequestCompanyAccessForPublicApiKeyArgs = {
  input: RequestCompanyAccessForPublicApiKeyInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRequestTemporaryAccessArgs = {
  input: RequestTemporaryAccessInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRerunQuoteRequestArgs = {
  UUID: Scalars['UUID']['input'];
  input: RerunQuoteRequestInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationResumeSalesforceJobQueuesArgs = {
  queues: Array<SalesforceJobQueue>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationReturnHardwareDeviceArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRevokeAuthenticationTokenArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRevokeCompanyAccessFromPublicApiKeyArgs = {
  companyUUID: Scalars['UUID']['input'];
  keyUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRevokeOwnApiKeyArgs = {
  companyUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRevokePublicApiKeyArgs = {
  UUID: Scalars['UUID']['input'];
  companyUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRevokeTemporaryAccessGrantArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRotateCaptivePortalSecretArgs = {
  uuid: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcBlinkLeDsArgs = {
  durationSec?: Scalars['Int']['input'];
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcClearBlockedConfigsArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcDnsArgs = {
  input: RpcdnsInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcEapolTestForSerialArgs = {
  input: RpcEapolTestForSerialInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcEapolTestForSerialsArgs = {
  input: RpcEapolTestForSerialsInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcPduOutletCycleArgs = {
  input: RpcpduOutletCycleInput;
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcPacketCapturesStartArgs = {
  input: RpcPacketCapturesStartInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcPacketCapturesStopArgs = {
  jobIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcPingArgs = {
  input: RpcPingInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcPortCableTestArgs = {
  portNumber: Scalars['Int']['input'];
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcPortCycleArgs = {
  input: RpcPortCycleInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcPortCycleDevicesArgs = {
  inputs: Array<RpcPortCycleInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcPortEyeTestArgs = {
  portNumber: Scalars['Int']['input'];
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcPortSpotlightArgs = {
  input: PortsSpotlightInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcPortSpotlightCancelArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcRebootDeviceArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcRebootDevicesArgs = {
  serialNumbers: Array<Scalars['String']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcRefreshConfigArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcRestartIpSecTunnelArgs = {
  ipSecTunnelUUID: Scalars['UUID']['input'];
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcRotatingPacketCaptureArgs = {
  input: RpcRotatingPacketCaptureInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcSwitchPortCycleArgs = {
  input: RpcSwitchPortCycleInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcSwitchPortSecurityClearArgs = {
  input: RpcSwitchPortSecurityClearInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcWirelessCalibrationStartArgs = {
  input: RpcWirelessCalibrationInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcWosDisconnectClientArgs = {
  mac: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
  ssid: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcWosPingArgs = {
  input: RpcWosPingInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcWosRadioResetArgs = {
  band: RadioBand;
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRpcWosResetDfsArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationRunRiverJobArgs = {
  jobArgs: Scalars['JSON']['input'];
  jobKind: Scalars['String']['input'];
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationSendCompanySiemIntegrationTestEventArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationSetHardwareDeviceIsDevArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationSetInternetServicePlanPaymentResourceTemporaryLimitArgs = {
  input: SetInternetServicePlanPaymentResourceTemporaryLimitInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationSetIspVlaNsArgs = {
  input: SetIspVlaNsInput;
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationSetKeyValueArgs = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationSetNacCredentialPasswordArgs = {
  UUID: Scalars['UUID']['input'];
  input: SetNacCredentialPasswordInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationSetNetworkNosVersionArgs = {
  input: SetNetworkNosVersionInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationSetPolicyRoutingRuleBindingsArgs = {
  UUID: Scalars['UUID']['input'];
  input: SetPolicyRoutingRuleBindingsInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationSetRoleAssignmentActiveArgs = {
  companyUserUUID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  roleAssignmentUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationSetSupportUserRolesArgs = {
  roles: Array<SupportUserRoleInput>;
  userID: Scalars['ID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationShuffleHardwareDeviceAssignmentsArgs = {
  inputs: Array<ShuffleHardwareDeviceAssignmentInput>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationSignConsoleLoginChallengeArgs = {
  challenge: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationSignLocalConfigAccessChallengeArgs = {
  challenge: Scalars['String']['input'];
  networkUUID: Scalars['UUID']['input'];
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationStartClientPingSweepJobArgs = {
  input: StartClientPingSweepJobInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationStartWanSpeedtestJobArgs = {
  input: StartWanSpeedtestJobInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationStartWirelessCalibrationJobArgs = {
  input: StartWirelessCalibrationJobInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationSuppressIpsRulesArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationTestFireAlertArgs = {
  alertReceiverUUID: Scalars['UUID']['input'];
  alertTargetType: AlertTargetType;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnassignHardwareDeviceFromVirtualDeviceArgs = {
  assignAsSpare?: Scalars['Boolean']['input'];
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnassignHardwareFromVirtualDevicesArgs = {
  assignAsSpare?: Scalars['Boolean']['input'];
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnassignInternetServicePlanFromNetworkArgs = {
  internetServicePlanUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnassignSpareHardwareDeviceFromNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnbindFirewallRuleFromPhyInterfaceArgs = {
  input: UnbindFirewallRuleFromPhyInterface;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnbindFirewallRuleFromVlanArgs = {
  input: UnbindFirewallRuleFromVlan;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnbindPolicyRoutingRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: UnbindPolicyRoutingRuleInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnbindRateLimitRuleFromPhyInterfaceArgs = {
  input: RateLimitPhyInterfaceBindingInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnbindRateLimitRuleFromSsidArgs = {
  input: RateLimitSsidBindingInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnbindRateLimitRuleFromVlanArgs = {
  input: RateLimitVlanBindingInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnbindTagFromVirtualDevicesArgs = {
  tagUUID: Scalars['UUID']['input'];
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnblockClientsInNetworkArgs = {
  macAddresses?: InputMaybe<Array<Scalars['MacAddress']['input']>>;
  networkUUID: Scalars['UUID']['input'];
  ouis?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnblockClientsInSsidArgs = {
  macAddresses?: InputMaybe<Array<Scalars['MacAddress']['input']>>;
  ouis?: InputMaybe<Array<Scalars['String']['input']>>;
  ssidUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUndeleteNetworkArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUndoSwitchAutoConfigurationRunArgs = {
  jobUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnexpireTrialNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnpinDeviceConfigsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnpinDeviceConfigsForNetworksArgs = {
  networkUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnsetHardwareDeviceIsDevArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUnverifyTopologyDesignVersionArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateAccessPointPortProfileArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateAccessPointPortProfileInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateAlertCompanySubscriptionArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateAlertCompanySubscriptionInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateAlertFleetwideSubscriptionArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateAlertFleetwideSubscriptionInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateAlertReceiverWithTargetsArgs = {
  alertReceiverUUID: Scalars['UUID']['input'];
  input: UpdateAlertReceiverWithTargetsInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateAlertSupportProviderSubscriptionArgs = {
  input: UpdateAlertSupportProviderSubscriptionInput;
  supportProviderUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateAlertTargetSalesforceArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateAlertTargetSalesforceInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateAlertTargetSlackArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateAlertTargetSlackInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateAlertTargetWebhookArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateAlertTargetWebhookInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateApplicationDnsFirewallRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateApplicationDnsFirewallRuleInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateApplicationDnsFirewallRuleApplicationVisibilitiesArgs = {
  input: Array<UpdateApplicationDnsFirewallRuleApplicationVisibilities>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateApplicationDnsFirewallRulesArgs = {
  inputs: Array<UpdateApplicationDnsFirewallRulesInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateAutoVpnGroupArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateAutoVpnGroupInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateAutoVpnHubArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateAutoVpnHubInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateAutoVpnHubsArgs = {
  groupUUID: Scalars['UUID']['input'];
  inputs: Array<UpdateAutoVpnHubsInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateAutoVpnMemberArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateAutoVpnMemberInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateAutoVpnMemberHubArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateAutoVpnMemberHubInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateAutoVpnRouteArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateAutoVpnRouteInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateBgpNeighborArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateBgpNeighborInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateBgpRouterArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateBgpRouterInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateBgpRouterForEventArgs = {
  input: Array<UpdateBgpRouterForEventInput>;
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateCaptivePortalArgs = {
  input: CaptivePortalSettingsInput;
  uuid: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateClientVpnClientArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateClientVpnClientInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateClientVpnServerArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateClientVpnServerInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateCompanyArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateCompanyInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateCompanyLocationArgs = {
  companyLocationUUID: Scalars['UUID']['input'];
  input: UpdateCompanyLocationInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateCompanySiemIntegrationArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateCompanySiemIntegrationInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateCompanyUserArgs = {
  companyUserUUID: Scalars['UUID']['input'];
  input: UpdateCompanyUserInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateConnectStaticRateArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateConnectStaticRateInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateCountryDeviceCertificationsArgs = {
  inputs: Array<UpdateCountryDeviceCertificationInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateCustomRoleArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateCustomRoleInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDdnsRecordArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateDdnsRecordInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDhcpOptionArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateDhcpOptionInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDhcpProxyArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateDhcpProxyInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDhcpReservedRangeArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateDhcpReservedRangeInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDhcpRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateDhcpRuleInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDhcpStaticMappingArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateDhcpStaticMappingInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDnsHostMappingArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateDnsHostMappingInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDefaultRoleForUsersArgs = {
  companySlug: Scalars['String']['input'];
  input: UpdateDefaultRoleForUsersInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDeliverableArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateDeliverableInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDeploymentJobArgs = {
  UUID: Scalars['UUID']['input'];
  input: DeploymentJobInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDeploymentTaskArgs = {
  UUID: Scalars['UUID']['input'];
  input: DeploymentTaskInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDeploymentTaskExceptionArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateDeploymentTaskExceptionInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDeploymentTaskExceptionMessageArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateDeploymentTaskExceptionMessageInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDeploymentTaskNotificationArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateDeploymentTaskNotificationInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDeploymentTimeWindowArgs = {
  UUID: Scalars['UUID']['input'];
  window: UpdateTimeWindowInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDevHardwareDeviceArgs = {
  input: UpdateDevHardwareDeviceInput;
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDeviceMacAllocationArgs = {
  deviceFamily: Scalars['String']['input'];
  nextMAC: Scalars['MacAddress']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDeviceNotificationSnoozeArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateDeviceNotificationSnoozeInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateDocumentUploadArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateDocumentUploadInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateEncryption8021XArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateEncryption8021XInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateFirewallRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateFirewallRuleInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateFirewallRulesArgs = {
  inputs: Array<UpdateFirewallRulesInput>;
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateFleetwideNotificationSnoozeArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateNotificationSnoozeInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateFloorPlanArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateFloorPlanInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateForHighAvailabilityEventArgs = {
  input: UpdateForHighAvailabilityEventInput;
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateGatewayProfileArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateGatewayProfileInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateGatewayUplinkSettingsArgs = {
  input: UpdateGatewayUplinkSettingsInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateHardwareDeviceArgs = {
  input: UpdateHardwareDeviceInput;
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateHardwareNosVersionRangeArgs = {
  deviceModel: DeviceModel;
  versionRange: HardwareNosVersionRangeInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateHiddenCompanyOnboardingDocumentFieldsArgs = {
  companyUUID: Scalars['UUID']['input'];
  fields: Array<OnboardingDocumentHiddenFieldUpdateInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateHiddenNetworkOnboardingDocumentFieldsArgs = {
  fields: Array<OnboardingDocumentHiddenFieldUpdateInput>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateHighAvailabilityControllersConfigurationArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateHighAvailabilityPairInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateHostMonitoringTargetArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateHostMonitoringTargetInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateIdsipsConfigArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateIdsipsConfigInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateIdsipsCustomRuleArgs = {
  input: UpdateIdsipsCustomRuleInput;
  ruleUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateIpForwardingRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateIpForwardingRuleInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateIpSecTunnelArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateIpSecTunnelInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateInterVlanCommunicationPermittedPairsArgs = {
  networkUUID: Scalars['UUID']['input'];
  vlanPairs: Array<VlanPairInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateInternalNoteArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateInternalNoteInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateInternetServicePlanArgs = {
  input: UpdateInternetServicePlanInput;
  internetServicePlanUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateInternetServicePlanDocumentArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateInternetServicePlanDocumentInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateInternetServicePlanFulfillmentJobArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateInternetServicePlanFulfillmentJobInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateInternetServicePlanFulfillmentTaskArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateInternetServicePlanFulfillmentTaskInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateInternetServicePlanProviderArgs = {
  input: UpdateInternetServicePlanProviderInput;
  uuid: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateInternetServicePlanProviderStaticRateArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateInternetServicePlanProviderStaticRateInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateInternetServicePlanProviderStaticRatesArgs = {
  UUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  enabled: Scalars['Boolean']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateLabReservationArgs = {
  input: UpdateLabReservationInput;
  reservationUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateLabResourceArgs = {
  input: UpdateLabResourceInput;
  resourceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateLocationProviderAvailabilityArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateLocationProviderAvailabilityInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateMaintenanceWindowForNetworkArgs = {
  input: UpdateMaintenanceWindowInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateMarketingChangelogEntryArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateMarketingChangelogEntryInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateMonitorGroupArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateMonitorGroupInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateMonitorGroupMemberArgs = {
  input: UpdateMonitorGroupMemberInput;
  monitorGroupUUID: Scalars['UUID']['input'];
  monitorProbeBindingUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateMonitorProbeArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateMonitorProbeInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNacConfigArgs = {
  input: UpdateNacConfigInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNacCredentialArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateNacCredentialInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNacGroupArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateNacGroupInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNacIdPConfigArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateNacIdPConfigInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNacIdPGroupMappingArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateNacIdPGroupMappingInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNacPolicyArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateNacPolicyInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNosUpgradeGroupArgs = {
  input: UpdateNosUpgradeGroupInput;
  nosUpgradeGroupUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNosUpgradeGroupsArgs = {
  inputs: Array<UpdateNosUpgradeGroupsInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNetworkArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateNetworkInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNetworkMetadataArgs = {
  input: UpdateNetworkMetadataInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNetworkReservationArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateNetworkReservationInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNetworkThreatAllowlistEntryArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateNetworkThreatAllowlistEntryInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNetworkUnderlayPoolArgs = {
  input: CreateUnderlayPoolInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNosFeatureArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateNosFeatureInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateNosVersionArgs = {
  id: Scalars['Int']['input'];
  input: NosVersionInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateOobPhyInterfaceArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateOobPhyInterfaceInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateObserverTestArgs = {
  input: UpdateObserverTestInput;
  uuid: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateOneToOneNatRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateOneToOneNatRuleInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateOpportunityArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateOpportunityInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateOutletInterfaceArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateOutletInterfaceInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateOutletInterfacesArgs = {
  input: UpdateOutletInterfaceInput;
  outletInterfaceUUIDs: Array<Scalars['UUID']['input']>;
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateOutletInterfacesIndependentlyArgs = {
  inputs: Array<UpdateOutletInterfacesIndependentlyInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdatePacketCaptureGroupsArgs = {
  inputs: Array<UpdatePacketCaptureGroupsInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdatePhyInterfaceArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdatePhyInterfaceInput;
  ispVLANUpdates?: InputMaybe<Array<IspVlanUpdateInput>>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdatePhyInterfaceDhcpRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdatePhyInterfaceDhcpRuleInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdatePhyInterfaceForMultiWanEventArgs = {
  input: Array<UpdatePhyInterfaceForMultiWanEventInput>;
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdatePhyInterfacesArgs = {
  input: UpdatePhyInterfaceInput;
  ispVLANUpdates?: InputMaybe<Array<IspVlanUpdateInput>>;
  phyInterfaceUUIDs: Array<Scalars['UUID']['input']>;
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdatePhyInterfacesIndependentlyArgs = {
  inputs: Array<UpdatePhyInterfacesIndependentlyInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdatePolicyEnginePathArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdatePolicyEnginePathInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdatePolicyEnginePoliciesArgs = {
  inputs: Array<UpdatePolicyEnginePoliciesInput>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdatePolicyEnginePolicyArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdatePolicyEnginePolicyInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdatePolicyEngineTrafficMatcherArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdatePolicyEngineTrafficMatcherInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdatePolicyRoutingRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdatePolicyRoutingRuleInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdatePortForwardingRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdatePortForwardingRuleInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateProactivePcapNetworkConfigArgs = {
  input: UpdateProactivePcapNetworkConfigInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateProactivePcapSsidConfigArgs = {
  input: UpdateProactivePcapSsidConfigInput;
  ssidUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateProviderConnectionTypeTermArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateProviderConnectionTypeTermInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdatePublicApiKeyRateLimitsArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdatePublicApiKeyRateLimitsInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateQuoteArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateQuoteInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateQuoteRequestArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateQuoteRequestInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateRackElevationArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateRackElevationInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateRackElevationDeviceArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateRackElevationDeviceInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateRadioProfileArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateRadioProfileInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateRateLimitRuleArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateRateLimitRuleInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateRateLimitRulesIndependentlyArgs = {
  inputs: Array<UpdateRateLimitRulesInput>;
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateRoleMappingArgs = {
  input: UpdateCompanyRoleMappingInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateSpanMirrorSessionArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateSpanMirrorSessionInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateSsidArgs = {
  input: UpdateSsidInput;
  uuid: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateSsiDsArgs = {
  input: UpdateSsiDsInput;
  uuids: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateSsiDsIndependentlyArgs = {
  inputs: Array<UpdateSsiDsIndependentlyInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateSecurityApplianceProfileArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateSecurityApplianceProfileInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateSecurityApplianceProfilesForNetworkArgs = {
  input: UpdateSecurityApplianceProfileInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateSlackAccessTokenArgs = {
  companyUUID: Scalars['UUID']['input'];
  uuid: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateSpeedtestRulesArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
  input: UpdateSpeedtestRuleInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateStaticRouteArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateStaticRouteInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateSupportCasesArgs = {
  input: UpdateSupportCasesInput;
  uuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateSupportProviderArgs = {
  input: UpdateSupportProviderInput;
  uuid: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateSupportProviderAlertReceiverWithTargetsArgs = {
  input: UpdateSupportProviderAlertReceiverWithTargetsInput;
  supportProvider: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateSwitchProfileArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateSwitchProfileInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateSwitchProfilesArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
  input: UpdateSwitchProfilesInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateTopologyDesignLinkArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateTopologyDesignLinkInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateTopologyDesignNodeArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateTopologyDesignNodeInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateTopologyDesignVersionArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateTopologyDesignVersionInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateUplinkPhyInterfaceExternalAddressesArgs = {
  input: UpdateUplinkPhyInterfaceExternalAddressesInput;
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateUserRolesArgs = {
  companyUserUUID: Scalars['UUID']['input'];
  input: Array<UserRoleInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateVlanArgs = {
  UUID: Scalars['UUID']['input'];
  input: UpdateVlanInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateVlanInterVlanCommunicationPermittedVlaNsArgs = {
  otherVLANUUIDs: Array<Scalars['UUID']['input']>;
  vlanUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateVlaNsArgs = {
  input: UpdateVlanInput;
  vlanUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateVlaNsIndependentlyArgs = {
  inputs: Array<UpdateVlaNsIndependentlyInput>;
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateVirtualDeviceArgs = {
  input: UpdateVirtualDeviceInput;
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateVirtualDeviceTagArgs = {
  input: UpdateVirtualDeviceTagInput;
  tagUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateVirtualDevicesArgs = {
  input: UpdateVirtualDeviceInput;
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateVirtualDevicesIndependentlyArgs = {
  inputs: Array<UpdateVirtualDeviceIndependentlyInput>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpdateWifiIpskArgs = {
  input: UpdateWifiIpskInput;
  uuid: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUploadClientObserverTestArgs = {
  input: UploadClientObserverTestInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertAlertDeprioritizationWindowsForNetworksArgs = {
  inputs: Array<UpsertAlertDeprioritizationWindowForNetworkInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertAllInboxMessageStatesArgs = {
  companyUUID: Scalars['UUID']['input'];
  input: UpsertAllInboxMessageStatesInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertCompanyOnboardingDocumentArgs = {
  companyUUID: Scalars['UUID']['input'];
  document: Scalars['JSONObject']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertCompanyOnboardingDocumentMetadataArgs = {
  companyUUID: Scalars['UUID']['input'];
  documentMetadata: Scalars['JSONObject']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertCompanyOnboardingFieldDelegationArgs = {
  companyUUID: Scalars['UUID']['input'];
  fieldName: Scalars['String']['input'];
  input: UpsertCompanyOnboardingFieldDelegationInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertDeviceConfigOverrideArgs = {
  configJSON: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertIdsipsConfigCategoryBindingArgs = {
  idsIPSCategoryUUID: Scalars['UUID']['input'];
  idsIPSConfigUUID: Scalars['UUID']['input'];
  mode: IdsipsMode;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertIdsipsConfigRuleBindingArgs = {
  idsIPSConfigUUID: Scalars['UUID']['input'];
  mode: IdsipsMode;
  ruleSID: Scalars['Int']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertInboxMessageStateArgs = {
  input: UpsertInboxMessageStateInput;
  messageUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertInboxMessageStatesArgs = {
  input: UpsertInboxMessageStatesInput;
  messageUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertLocationProviderAvailabilityArgs = {
  input: UpsertLocationProviderAvailabilityInput;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertMacAddressAliasArgs = {
  alias: Scalars['String']['input'];
  companySlug: Scalars['String']['input'];
  macAddress: Scalars['MacAddress']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertMacAddressAliasesArgs = {
  companySlug: Scalars['String']['input'];
  inputs: Array<UpsertMacAddressAliasInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertNetworkCachedNosVersionsArgs = {
  networkUUID: Scalars['UUID']['input'];
  nosVersionIDs: Array<Scalars['Int']['input']>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertNetworkOnboardingDocumentArgs = {
  document?: InputMaybe<Scalars['JSONObject']['input']>;
  documentData?: InputMaybe<NetworkOnboardingDocumentDataInput>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertNetworkOnboardingDocumentMetadataArgs = {
  documentMetadata: Scalars['JSONObject']['input'];
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertNetworkOnboardingFieldDelegationArgs = {
  fieldName: Scalars['String']['input'];
  input: UpsertNetworkOnboardingFieldDelegationInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertRecurringAutoChannelSelectionJobsArgs = {
  inputs: Array<UpsertRecurringAutoChannelSelectionJobInput>;
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertSwitchAutoConfigMacAddressVlanBindingsForNetworkArgs = {
  input: Array<CreateSwitchAutoConfigMacAddressVlanBindingInput>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationUpsertTopologyDesignArgs = {
  input: WriteTopologyDesignInput;
  topologyDesignVersionUUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationValidateBearerSessionArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root mutation type of the GraphQL schema. Contains all operations that modify data. */
export type MutationVerifyTopologyDesignVersionArgs = {
  UUID: Scalars['UUID']['input'];
};

/** The action made by this mutation. */
export enum MutationAuditLogAction {
  /** Indicates that this mutation creates a new entity. */
  Create = 'CREATE',
  /** Indicates that this mutation deletes an existing entity. */
  Delete = 'DELETE',
  /** Indicates that this mutation modifies an existing entity. */
  Update = 'UPDATE'
}

/** Tracks the mutations that have been made to the network's configuration over time. */
export type MutationAuditLogEntry = {
  __typename?: 'MutationAuditLogEntry';
  /** The unique identifier for this audit log entry. */
  UUID: Scalars['UUID']['output'];
  /** The action or mutation that was performed, typically the name of the mutation function invoked. */
  action: Scalars['String']['output'];
  /** The arguments provided to the mutation, represented as a JSON object. */
  args: Scalars['JSONObject']['output'];
  /** The company user who performed the mutation, if they belong to the network's company. */
  companyUser?: Maybe<CompanyUser>;
  /** The date and time when the mutation was performed, in ISO 8601 format */
  createdAt: Scalars['DateTime']['output'];
  /** The type of identity that performed the mutation. */
  identityType: Scalars['String']['output'];
  /** The unique identifier of the network where the mutation occurred */
  networkUUID: Scalars['UUID']['output'];
  /** An optional reason specified for why the mutation was made. */
  reason?: Maybe<Scalars['String']['output']>;
  /** The user who performed the mutation, if it was a user. */
  user?: Maybe<User>;
  /** The username or identifier of the entity (user or machine) that performed the mutation. */
  username: Scalars['String']['output'];
};

export type MutationAuditLogFilter = {
  /** Whether to include audit log entries where the identityType is 'MACHINE'. */
  includeMachine?: Scalars['Boolean']['input'];
  /** The maximum number of audit log entries to return. */
  limit?: Scalars['Int']['input'];
  /** Only include audit log entries that were created before or at this date and time. */
  maxCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only include audit log entries that were created at or after this date and time. */
  minCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The number of audit log entries to skip before starting to collect the result set. */
  offset?: Scalars['Int']['input'];
};

/** The log level for a mutation. */
export enum MutationAuditLogLevel {
  /** Indicates that this mutation should not be logged at all. */
  Disabled = 'DISABLED',
  /** Indicates that this mutation should be logged only for Meter operators. */
  InternalOnly = 'INTERNAL_ONLY',
  /** Indicates that this mutation should be logged normally, for operators and users with the necessary access. */
  Log = 'LOG'
}

/** Tracks the mutations that have been made to the network's configuration and what was changed over time. */
export type MutationDiffAuditLogEntry = {
  __typename?: 'MutationDiffAuditLogEntry';
  /** The unique identifier for this audit log entry. */
  UUID: Scalars['UUID']['output'];
  /** The action or mutation that was performed, typically the name of the mutation function invoked. */
  action: Scalars['String']['output'];
  /** The JSON model after the mutation, represented as a JSON string. */
  afterJSON: Scalars['JSON']['output'];
  /** The JSON model before the mutation, represented as a JSON string. */
  beforeJSON: Scalars['JSON']['output'];
  /** The unique identifier of the company where the mutation occurred */
  companyUUID?: Maybe<Scalars['UUID']['output']>;
  /** The date and time when the mutation was performed, in ISO 8601 format */
  createdAt: Scalars['DateTime']['output'];
  /** Errors, if any, encountered during execution. */
  errors?: Maybe<Scalars['JSON']['output']>;
  /** The unique identifier of the network where the mutation occurred */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** An optional reason specified for why the mutation was made. */
  reason?: Maybe<Scalars['String']['output']>;
  /** The user who performed the mutation, if it was a user. */
  user?: Maybe<User>;
  /** The username or identifier of the entity (user or machine) that performed the mutation. */
  username: Scalars['String']['output'];
};

export type MutationDiffAuditLogFilterInput = {
  /** Filter audit log entries by method. */
  actions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Include audit log entries marked as failed. */
  includeFailed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include audit log entries marked as internal only. */
  includeInternal?: InputMaybe<Scalars['Boolean']['input']>;
  /** The maximum number of audit log entries to return. */
  limit?: Scalars['Int']['input'];
  /** Only include audit log entries that were created before or at this date and time. */
  maxCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only include audit log entries that were created at or after this date and time. */
  minCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The number of audit log entries to skip before starting to collect the result set. */
  offset?: Scalars['Int']['input'];
};

/** A page of a subset of mutation diff audit log entries. */
export type MutationDiffAuditLogPage = {
  __typename?: 'MutationDiffAuditLogPage';
  /** A subset of records based on the limit and offset fields */
  entries: Array<MutationDiffAuditLogEntry>;
  /** The total number of records */
  total: Scalars['Int']['output'];
};

/** A NAC auth event. */
export type NacAuthEvent = {
  __typename?: 'NACAuthEvent';
  /** The unique identifier for the event. */
  UUID: Scalars['UUID']['output'];
  /** The MAC and SSID (MAC:SSID). */
  calledStationID: Scalars['String']['output'];
  /** The client device MAC. */
  callingStationID: Scalars['String']['output'];
  /** The identity that attempted auth. */
  identity: Scalars['String']['output'];
  /** Where the credential for this identity is expected to live. */
  identitySource?: Maybe<NacIdentitySource>;
  /** The authentication method used. */
  method: NacAuthMethod;
  /** The NAC groups the identity belonged to at the time of the attempt. */
  nacGroupUUIDs: Array<Scalars['UUID']['output']>;
  /** The IdP config that handled the identity, if it still exists. */
  nacIdPConfig?: Maybe<NacIdPConfig>;
  /** The UUID of the IdP config that handled the identity, if any. */
  nacIdPConfigUUID?: Maybe<Scalars['UUID']['output']>;
  /** The policy that matched, if it still exists. Null if no policy matched or the policy was since deleted. */
  nacPolicy?: Maybe<NacPolicy>;
  /** The network the auth attempt belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The timestamp when the auth attempt was observed. */
  observedAt: Scalars['DateTime']['output'];
  /** The label of the policy that matched. */
  policyLabel: Scalars['String']['output'];
  /** The UUID of the policy that matched, if any. */
  policyUUID?: Maybe<Scalars['UUID']['output']>;
  /** The reason code for the decision. */
  reason: NacAuthReason;
  /** The outcome of the attempt. */
  result: NacAuthResult;
  /** The virtual device the attempt came from. Null if the device no longer exists. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The virtual device UUID the attempt came from. */
  virtualDeviceUUID: Scalars['UUID']['output'];
  /** The VLAN number assigned, if any. */
  vlanID?: Maybe<Scalars['Int']['output']>;
  /** The UUID of the VLAN assigned, if any. */
  vlanUUID?: Maybe<Scalars['UUID']['output']>;
};

/** Filters for the nacAuthEvents query. */
export type NacAuthEventsFilter = {
  /** Only return events observed at or before this time. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only return events for this identity. */
  identity?: InputMaybe<Scalars['String']['input']>;
  /** Only return events whose identity is owned by one of these sources. */
  identitySources?: InputMaybe<Array<NacIdentitySource>>;
  /** Only return events whose identity belonged to any of these NAC groups. */
  nacGroupUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Only return events with this reason code. */
  reason?: InputMaybe<NacAuthReason>;
  /** Only return events with this result. */
  result?: InputMaybe<NacAuthResult>;
  /** Only return events observed at or after this time. */
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only return events for this device. */
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** A response for NAC auth event queries. */
export type NacAuthEventsPage = {
  __typename?: 'NACAuthEventsPage';
  /** A subset of records based on the limit and offset fields. */
  events: Array<NacAuthEvent>;
  /** The total number of records matching the query. */
  total: Scalars['Int']['output'];
};

/** The authentication method used for a NAC auth attempt. */
export enum NacAuthMethod {
  /** EAP-GTC. */
  EapGtc = 'EAP_GTC',
  /** EAP-MSCHAPv2. */
  EapMschapv2 = 'EAP_MSCHAPV2',
  /** EAP-TTLS. */
  EapTtls = 'EAP_TTLS',
  /** MAB. */
  Mab = 'MAB',
  /** Recorded when the request's method was missing or unsupported. */
  Unknown = 'UNKNOWN'
}

/** The reason code for a NAC auth decision. */
export enum NacAuthReason {
  /** Policy matched, VLAN assigned. */
  Accepted = 'ACCEPTED',
  /**
   * The identity provider locked the account after too many failed sign-ins so
   * even the correct password is refused
   */
  IdpAccountLockedOut = 'IDP_ACCOUNT_LOCKED_OUT',
  /** The identity provider refused our directory client rather than the user */
  IdpConfigError = 'IDP_CONFIG_ERROR',
  /** The identity provider refused to check the password because of tenant policy */
  IdpPasswordAuthBlocked = 'IDP_PASSWORD_AUTH_BLOCKED',
  /** The identity provider is rate-limiting the requests. */
  IdpQuotaExceeded = 'IDP_QUOTA_EXCEEDED',
  /** The identity provider knows the identity but refuses to authenticate it */
  IdpUserNotAuthorized = 'IDP_USER_NOT_AUTHORIZED',
  /** Internal error. */
  InternalError = 'INTERNAL_ERROR',
  /** The matched policy denies access. */
  RejectedByPolicy = 'REJECTED_BY_POLICY',
  /** Over the policy's max distinct devices per user. */
  RejectedDeviceLimitExceeded = 'REJECTED_DEVICE_LIMIT_EXCEEDED',
  /** Neither the identity provider nor static credentials know this identity */
  RejectedIdentityNotFound = 'REJECTED_IDENTITY_NOT_FOUND',
  /** IdP or static credential mismatch. */
  RejectedInvalidCredentials = 'REJECTED_INVALID_CREDENTIALS',
  /** Unsupported method or missing/invalid fields. */
  RejectedInvalidRequest = 'REJECTED_INVALID_REQUEST',
  /** NAC is disabled for the network. */
  RejectedNacDisabled = 'REJECTED_NAC_DISABLED',
  /** No policy matched. */
  RejectedNoMatchingPolicy = 'REJECTED_NO_MATCHING_POLICY',
  /** Unknown device. */
  RejectedUnknownDevice = 'REJECTED_UNKNOWN_DEVICE',
  /** Authentication timed out before a decision was reached. */
  TimedOut = 'TIMED_OUT'
}

/** The outcome of a NAC auth attempt. */
export enum NacAuthResult {
  /** The attempt was accepted and a VLAN assigned. */
  Accept = 'ACCEPT',
  /** The attempt was rejected. */
  Reject = 'REJECT'
}

/** A user device seen authenticating as a NAC identity. */
export type NacClientDevice = {
  __typename?: 'NACClientDevice';
  /** The unique identifier for the device record. */
  UUID: Scalars['UUID']['output'];
  /** The client device MAC. */
  callingStationID: Scalars['String']['output'];
  /** When this device was first seen for this identity. */
  firstSeenAt: Scalars['DateTime']['output'];
  /** When an admin forgot this device, freeing its device limit slot. */
  forgottenAt?: Maybe<Scalars['DateTime']['output']>;
  /** The identity the device authenticated as. */
  identity: Scalars['String']['output'];
  /** The most recent accepted auth from this device. */
  lastSeenAt: Scalars['DateTime']['output'];
  /** The Meter-managed credential this identity authenticated against. */
  nacCredential?: Maybe<NacCredential>;
  /** The network the device authenticated on. */
  networkUUID: Scalars['UUID']['output'];
  /** The device's registration state. */
  status: NacClientDeviceStatus;
};

/** The lifecycle state of a client device's registration. */
export enum NacClientDeviceStatus {
  /** An admin forgot this device, freeing its slot. */
  Forgotten = 'FORGOTTEN',
  /** Has not authenticated recently enough to hold a slot. */
  Inactive = 'INACTIVE',
  /** Holds one of the identity's device limit slots. */
  Registered = 'REGISTERED'
}

/** A response for NAC client device queries. */
export type NacClientDevicesPage = {
  __typename?: 'NACClientDevicesPage';
  /** A subset of records based on the limit and offset fields. */
  devices: Array<NacClientDevice>;
  /** The total number of records matching the query. */
  total: Scalars['Int']['output'];
};

/** Network-level NAC configuration */
export type NacConfig = {
  __typename?: 'NACConfig';
  /** The unique identifier for the NAC config. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the NAC config was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Whether this config, or any of its enabled accept policies, sets a device limit. */
  hasDeviceLimit: Scalars['Boolean']['output'];
  /** Whether any enabled policy exists on this network. */
  hasEnabledPolicies: Scalars['Boolean']['output'];
  /** Whether NAC is enabled for this network. When disabled, all RADIUS auth requests are rejected. */
  isEnabled: Scalars['Boolean']['output'];
  /** Network-wide default for the maximum distinct devices a user may authenticate on within a rolling window. */
  maxDevicesPerUser?: Maybe<Scalars['Int']['output']>;
  /** The network this config belongs to. */
  network: Network;
  /** The unique identifier of the network this config belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** Network-wide default for the seconds before a device must re-authenticate. */
  sessionTimeoutSec?: Maybe<Scalars['Int']['output']>;
  /** The timestamp when the NAC config was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A NAC identity scoped to a company: either a username/password user or a MAB device. */
export type NacCredential = {
  __typename?: 'NACCredential';
  /** The unique identifier for the credential. */
  UUID: Scalars['UUID']['output'];
  /** The MAC for a MAC identity. */
  clientMAC?: Maybe<Scalars['MacAddress']['output']>;
  /** The unique identifier of the company this credential belongs to. */
  companyUUID: Scalars['UUID']['output'];
  /** The timestamp when the credential was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The NAC user groups this credential belongs to. */
  groups: Array<NacGroup>;
  /** Optional display name. */
  label?: Maybe<Scalars['String']['output']>;
  /** The number of NAC policy entries currently referencing this credential. Deleting the credential will also delete these entries. */
  policyEntryCount: Scalars['Int']['output'];
  /** Whether this identity is a password user or a MAB device. */
  type: NacCredentialType;
  /** The timestamp when the credential was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The login for a user identity. */
  username?: Maybe<Scalars['String']['output']>;
};

/**
 * Minimal, non-sensitive credential info for the public password-setup page. Only
 * fields safe to expose to an unauthenticated caller holding a valid setup token.
 */
export type NacCredentialPasswordSetupInfo = {
  __typename?: 'NACCredentialPasswordSetupInfo';
  /** The username (email) the password is being set for. */
  username: Scalars['String']['output'];
};

/** The kind of identity a NACCredential holds. */
export enum NacCredentialType {
  /** A device authenticating by MAB, username is its MAC */
  Mac = 'MAC',
  /** A person authenticating by password, username is their login. */
  User = 'USER'
}

/** A user group used by NAC policies. A policy entry can target a group instead of enumerating members individually so the same network access rules apply to everyone in the group. */
export type NacGroup = {
  __typename?: 'NACGroup';
  /** The unique identifier for the group. */
  UUID: Scalars['UUID']['output'];
  /** The unique identifier of the company this group belongs to. */
  companyUUID: Scalars['UUID']['output'];
  /** The timestamp when the group was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The credentials currently in this group. */
  credentials: Array<NacCredential>;
  /** Optional description of the group's purpose. */
  description?: Maybe<Scalars['String']['output']>;
  /** The external IdP groups mapped into this group. */
  idpGroupMappings: Array<NacIdPGroupMapping>;
  /** The group's display name. */
  name: Scalars['String']['output'];
  /** The timestamp when the group was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Per-company IdP configuration for NAC. */
export type NacIdPConfig = {
  __typename?: 'NACIdPConfig';
  /** The unique identifier for the configuration. */
  UUID: Scalars['UUID']['output'];
  /** The unique identifier of the company this configuration belongs to. */
  companyUUID: Scalars['UUID']['output'];
  /** The timestamp when the configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  /** When the credential this configuration authenticates with expires. */
  credentialExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The customer's primary domain. Identities are routed to this configuration by the domain part of their username. */
  domain: Scalars['String']['output'];
  /** For Entra configurations, the Application client ID of the Meter NAC app registration. */
  entraClientID?: Maybe<Scalars['String']['output']>;
  /** For Entra configurations, the Secret ID of the client secret in use. */
  entraClientSecretID?: Maybe<Scalars['UUID']['output']>;
  /** For Entra configurations, the Entra Directory tenant ID. */
  entraTenantID?: Maybe<Scalars['String']['output']>;
  /** For Okta configurations, the client ID of the native app that performs the password grant. */
  oktaClientID?: Maybe<Scalars['String']['output']>;
  /** For Okta configurations, the customer's Okta org URL. */
  oktaOrgURL?: Maybe<Scalars['String']['output']>;
  /** For Okta configurations, the client ID of the API services app used for directory reads. */
  oktaServiceClientID?: Maybe<Scalars['String']['output']>;
  /**
   * For Okta configurations, the public JWK the customer must paste into their API
   * services app. Okta requires private_key_jwt for directory reads, Meter holds
   * the private half and the customer registers this public half.
   */
  oktaServicePublicJWK?: Maybe<Scalars['String']['output']>;
  /** The identity provider this configuration talks to. */
  provider: NacIdPProvider;
  /** The timestamp when the configuration was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The result of testing a NAC IdP configuration. */
export type NacIdPConfigValidationResult = {
  __typename?: 'NACIdPConfigValidationResult';
  /** Whether the IdP connection and directory query succeeded. */
  ok: Scalars['Boolean']['output'];
  /** If the test failed, the reason why. */
  reason?: Maybe<Scalars['String']['output']>;
};

/** A group from a NAC IdP directory. */
export type NacIdPDirectoryGroup = {
  __typename?: 'NACIdPDirectoryGroup';
  /** The human-readable group name, for display alongside the mapping. */
  displayName: Scalars['String']['output'];
  /** The group's raw LDAP distinguished name. */
  distinguishedName: Scalars['String']['output'];
  /** The external group key to store in a NAC IdP group mapping. */
  idpGroupName: Scalars['String']['output'];
};

/** A mapping from an external IdP group name to a NAC group, scoped to a company's IdP. */
export type NacIdPGroupMapping = {
  __typename?: 'NACIdPGroupMapping';
  /** The unique identifier for the mapping. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the mapping was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Human-readable name for the external group. */
  idpGroupDisplayName: Scalars['String']['output'];
  /** The external IdP group key. */
  idpGroupName: Scalars['String']['output'];
  /** The NAC group this external group maps to. */
  nacGroupUUID: Scalars['UUID']['output'];
  /** The IdP configuration this mapping belongs to. */
  nacIdPConfigUUID: Scalars['UUID']['output'];
  /** The identity provider of the configuration this mapping belongs to. */
  provider: NacIdPProvider;
  /** The timestamp when the mapping was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** An identity provider that NAC can authenticate users against. */
export enum NacIdPProvider {
  /** Microsoft Entra ID. */
  Entra = 'ENTRA',
  /** Google Workspace Secure LDAP. */
  GoogleSecureLdap = 'GOOGLE_SECURE_LDAP',
  /** Okta. */
  Okta = 'OKTA'
}

/** A directory group an identity belongs to, paired with the NAC group it maps to. */
export type NacIdPUserGroup = {
  __typename?: 'NACIdPUserGroup';
  /**
   * The human-readable group name. Falls back to idpGroupName when the provider
   * cannot supply a name.
   */
  displayName: Scalars['String']['output'];
  /** The external group key, matching a group mapping's idpGroupName. */
  idpGroupName: Scalars['String']['output'];
  /** The NAC group this directory group is mapped to, null when unmapped. */
  nacGroup?: Maybe<NacGroup>;
};

/**
 * The directory groups an identity belongs to, read live from the IdP, and the NAC
 * groups they resolve to.
 */
export type NacIdPUserLookupResult = {
  __typename?: 'NACIdPUserLookupResult';
  /** Every directory group the identity belongs to. */
  groups: Array<NacIdPUserGroup>;
};

/** Where the credential for an identity is expected to live. */
export enum NacIdentitySource {
  /** Microsoft Entra ID. */
  Entra = 'ENTRA',
  /** Google Workspace over Secure LDAP. */
  GoogleSecureLdap = 'GOOGLE_SECURE_LDAP',
  /** Meter-managed. */
  MeterManaged = 'METER_MANAGED',
  /** Okta. */
  Okta = 'OKTA'
}

/** A NAC (Network Access Control) policy defines rules for authenticating devices on the network via RADIUS. */
export type NacPolicy = {
  __typename?: 'NACPolicy';
  /** The unique identifier for the NAC policy. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the NAC policy was created. */
  createdAt: Scalars['DateTime']['output'];
  /** An optional description of what this policy does. */
  description?: Maybe<Scalars['String']['output']>;
  /** The entries (match criteria) associated with this policy. */
  entries: Array<NacPolicyEntry>;
  /** Whether matching devices are accepted (true) or rejected (false). */
  isAccept: Scalars['Boolean']['output'];
  /** Whether this is a catch-all policy. Catch-all policies match all requests and must not have entries. */
  isCatchAll: Scalars['Boolean']['output'];
  /** Whether this policy is active. Disabled policies are skipped during evaluation. */
  isEnabled: Scalars['Boolean']['output'];
  /** A human-readable name for the policy. */
  label: Scalars['String']['output'];
  /** Maximum distinct devices a user may authenticate on within a rolling window. */
  maxDevicesPerUser?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier of the network this policy belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** Evaluation order. Lower values are evaluated first, the first matching rule wins. */
  priority: Scalars['Int']['output'];
  /** Seconds before the device must re-authenticate. */
  sessionTimeoutSec?: Maybe<Scalars['Int']['output']>;
  /** The timestamp when the NAC policy was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The VLAN to assign to accepted devices. */
  vlan?: Maybe<Vlan>;
};

/** An entry in a NAC policy that defines a match criterion, such as a client MAC address for MAB. */
export type NacPolicyEntry = {
  __typename?: 'NACPolicyEntry';
  /** The unique identifier for the policy entry. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the entry was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The NAC group, for entries whose identityType is NAC_GROUP. */
  group?: Maybe<NacGroup>;
  /** The type of identity this entry matches against. */
  identityType: NacPolicyEntryIdentityType;
  /** The UUID of the NAC credential for local_credential entries. */
  nacCredentialUUID?: Maybe<Scalars['UUID']['output']>;
  /** The UUID of the NAC group, for entries whose identityType is NAC_GROUP. */
  nacGroupUUID?: Maybe<Scalars['UUID']['output']>;
  /** The UUID of the NAC policy this entry belongs to. */
  nacPolicyUUID: Scalars['UUID']['output'];
  /** The timestamp when the entry was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The kind of identity a NAC policy entry matches against. */
export enum NacPolicyEntryIdentityType {
  /** Match an identity by its stored credential: a user for the password methods, a device for MAB. */
  LocalCredential = 'LOCAL_CREDENTIAL',
  /** Match any user in a NAC group (used for EAP-GTC). */
  NacGroup = 'NAC_GROUP'
}

/** Groups devices in a network together for the purpose of cohorting them for NOS upgrades. */
export type NosUpgradeGroup = Identifiable & {
  __typename?: 'NOSUpgradeGroup';
  /** Unique identifier of the NOS upgrade group. */
  UUID: Scalars['UUID']['output'];
  /** The number of batches in the group; based on the number of devices in the group (excluding devices with no hardware attached) and a hard-coded maximum batch size based on the default device type. */
  batchCount: Scalars['Int']['output'];
  /** Timestamp when the NOS upgrade group was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Further distinguishes a device type by its role in the network; not all device types have subtypes. This is only applicable to default groups that are auto-created for a network. */
  defaultDeviceSubtype?: Maybe<NosUpgradeGroupDeviceSubtype>;
  /** The default device type for this group (unique per network). If set, devices of the given type will be assigned by default to this group. */
  defaultDeviceType?: Maybe<VirtualDeviceType>;
  /** A human-friendly description of the group. */
  description?: Maybe<Scalars['String']['output']>;
  /** The maximum number of devices that can be upgraded in a single batch within a group. If there is no default device type and/or the devices in the group have different types, a default maximum batch size is used. */
  maximumDeviceBatchSize: Scalars['Int']['output'];
  /** A human-friendly label for the group. */
  name: Scalars['String']['output'];
  /** The network that the NOS upgrade group is associated with. */
  networkUUID: Scalars['UUID']['output'];
  /** How long to wait for all batches of the group to upgrade before timing out, in seconds. Equal to the batch timeout duration multiplied by the number of batches; the number of batches is hard-coded based on the defaultDeviceType. Devices with no hardware attached are excluded. */
  overallUpgradeDurationSeconds: Scalars['Int']['output'];
  /** The priority of the NOS upgrade group; lower values are higher priority (0-indexed). Groups of devices will be upgraded in order of priority. Unique per network. */
  priority: Scalars['Int']['output'];
  /** How long to wait for all devices in each batch of the group to upgrade before timing out, in seconds. */
  timeoutDurationSeconds: Scalars['Int']['output'];
  /** Timestamp when the NOS upgrade group was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The virtual devices assigned to the NOS upgrade group. */
  virtualDevices: Array<VirtualDevice>;
};

/** Further distinguishes a device type by its role in the network. */
export enum NosUpgradeGroupDeviceSubtype {
  /** A controller backup device in a high-availability network. */
  ControllerBackup = 'CONTROLLER_BACKUP',
  /** A controller primary device in a high-availability network. */
  ControllerPrimary = 'CONTROLLER_PRIMARY',
  /** A switch access device. */
  SwitchAccess = 'SWITCH_ACCESS',
  /** A switch core device. */
  SwitchCore = 'SWITCH_CORE',
  /** A switch distribution device. */
  SwitchDistribution = 'SWITCH_DISTRIBUTION',
  /** An ISP switch device. */
  SwitchIsp = 'SWITCH_ISP'
}

/** The reason and notes for a NOS version change. */
export type NosVersionChangeReason = {
  __typename?: 'NOSVersionChangeReason';
  /** Optional notes providing additional context. */
  notes?: Maybe<Scalars['String']['output']>;
  /** The categorical reason for the version change */
  reason: NosVersionChangeReasonType;
};

/** Input for specifying the reason of the NOS version change. */
export type NosVersionChangeReasonInput = {
  /** Optional notes providing additional context. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The categorical reason for the version change */
  reason: NosVersionChangeReasonType;
};

/** Represents the reason for performing a NOS version change (eg a downgrade). */
export enum NosVersionChangeReasonType {
  /** The reason is the customer requested it. */
  CustomerRequest = 'CUSTOMER_REQUEST',
  /** The reason is an upgrade failed or is incomplete. */
  Failed = 'FAILED',
  /** The reason is other. */
  Other = 'OTHER',
  /** The reason is a performance or stability issue. */
  PerformanceStability = 'PERFORMANCE_STABILITY',
  /** The reason is a feature regression or functional bug. */
  Regression = 'REGRESSION'
}

/** A risk level from the Netstar WebAppCompass feed (e.g. Low Risk, High Risk). */
export type NetstarWebAppCompassRiskScore = {
  __typename?: 'NetstarWebAppCompassRiskScore';
  /** A description of what this risk level means. */
  description: Scalars['String']['output'];
  /** The unique identifier of the risk level. */
  id: Scalars['Int']['output'];
  /** The name of the risk level (e.g. Low Risk, High Risk). */
  name: Scalars['String']['output'];
};

/** A network is a grouping of devices in a single location belonging to a company. A core Meter entity. */
export type Network = Identifiable & {
  __typename?: 'Network';
  /**
   * Explicit ARP tracker enablement for the network. When null,
   * enablement falls back to the NOS feature and the LaunchDarkly flag.
   */
  IsArpTrackerEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** If false, wifi steering will be fully disabled even if supported by NOS. */
  IsWifiSteeringEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier of the network. */
  UUID: Scalars['UUID']['output'];
  /** Get the access point port profiles for the network. */
  accessPointPortProfiles: Array<AccessPointPortProfile>;
  /** Get the list of active issues for the network */
  activeIssues: Array<ActiveIssue>;
  /** The active underlay subnet for this network, if one exists. */
  activeUnderlayPool?: Maybe<UnderlayPool>;
  /** Optional weekly windows during which triggered alerts for this network are sent at low priority. */
  alertDeprioritizationWindow?: Maybe<AlertDeprioritizationWindow>;
  /** The list of valid DDNS domains available for this network. */
  allowedDDNSDomains: Array<Scalars['String']['output']>;
  /** The application DNS firewall rules associated with the network. */
  applicationDNSFirewallRules: Array<ApplicationDnsFirewallRule>;
  /** List Auto Channel Selection Jobs for the network, most recently scheduled first. */
  autoChannelSelectionJobs: Array<AutoChannelSelectionJob>;
  /** The Auto VPN groups associated with the network. */
  autoVPNGroups: Array<AutoVpnGroup>;
  /** BGP routers configured for this network. */
  bgpRouters: Array<BgpRouter>;
  /** Currently blocked clients on the network. */
  blockedClients: Array<NetworkClientBlocklistEntry>;
  /** The dynamic floor plan buildings associated with the network. */
  buildings: Array<DynamicFloorPlanBuilding>;
  /**
   * The NOS versions whose firmware images the network's primary firewall
   * should pre-download and cache for internal use.
   */
  cachedNOSVersions: Array<NosVersion>;
  /** The captive portals associated with the network. */
  captivePortals: Array<CaptivePortal>;
  /** Get client observer tests for this network. */
  clientObserverTests: Array<ClientObserverTest>;
  /** The client VPN servers associated with the network. */
  clientVPNServers: Array<ClientVpnServer>;
  /** The company that this network belongs to. */
  company: Company;
  /** The slug identifier of the company that this network belongs to. */
  companySlug: Scalars['String']['output'];
  /**
   * The device models that may be added to this network based on its country's
   * device certifications, in alphabetical order. Models without a certification
   * entry are included.
   */
  compliantDeviceModels: Array<DeviceModel>;
  /** If this network was created by copying another network, this is the UUID of the network that was copied. Only valid for networks created after ~October 7, 2025. */
  copiedFromNetworkUUID?: Maybe<Scalars['UUID']['output']>;
  /** CPE bindings for the network. */
  cpeBindings: Array<NetworkClientCpeBinding>;
  /** The date and time when the network was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The DDNS records associated with this network. */
  ddnsRecords: Array<DdnsRecord>;
  /** The time when the network was deactivated, if applicable. Allows differentiation between pre-live and post-live networks. */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The date and time when the network was deleted, if applicable. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Get the list of deployment jobs for the network */
  deploymentJobs: Array<DeploymentJob>;
  /** Get the list of deployment tasks for the network */
  deploymentTasks: Array<DeploymentTask>;
  /** All deployment time windows for the network. */
  deploymentTimeWindows: Array<DeploymentTimeWindow>;
  /** The document uploads visible on this network: documents scoped to this network plus company-wide documents. */
  documentUploads: Array<DocumentUpload>;
  /** An OpenIntent upload given the network UUID and upload UUID. */
  dynamicFloorPlanOpenIntentUpload?: Maybe<DynamicFloorPlanOpenIntentUpload>;
  /** The OpenIntent uploads associated with the network. */
  dynamicFloorPlanOpenIntentUploads: Array<DynamicFloorPlanOpenIntentUpload>;
  /** The dynamic floor plans associated with the network. */
  dynamicFloorPlans: Array<DynamicFloorPlan>;
  /** The service types enabled for service discovery in this network. */
  enabledServiceDiscoveryTypes: Array<ServiceType>;
  /** The 802.1X encryption configurations associated with the network. */
  encryption8021Xs: Array<Encryption8021X>;
  /** The Salesforce Meter Network ID corresponding to this network. */
  externalID?: Maybe<Scalars['String']['output']>;
  /** The firewall rules associated with the network. */
  firewallRules: Array<FirewallRule>;
  /** The floor plans associated with the network. */
  floorPlans: Array<FloorPlan>;
  /** Settings related to gateway uplinks for this network's firewalls. */
  gatewayUplinkSettings: GatewayUplinkSettings;
  /** The date the network first started serving traffic. */
  goLiveAt?: Maybe<Scalars['DateTime']['output']>;
  /** Configuration of the HA controllers for this network. */
  highAvailabilityConfig?: Maybe<HighAvailabilityControllersConfig>;
  /** IDS IPS config associated with the network. */
  idsIPSConfig?: Maybe<IdsipsConfig>;
  /** The internal notes associated with the network. */
  internalNotes: Array<InternalNote>;
  /** Internet service plans associated with the network. */
  internetServicePlans: Array<InternetServicePlan>;
  /** The IP forwarding rules for the network. */
  ipForwardingRules: Array<IpForwardingRule>;
  /** The IPSec tunnels associated with the network. */
  ipSecTunnels: Array<IpSecTunnel>;
  /** Whether or not the network is currently serving traffic. */
  isActive: Scalars['Boolean']['output'];
  /** Indicates whether the controller can upgrade config-1 APs deployed to the network. */
  isConfig1WosUpgradesEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not the network services a customer (as opposed to being an internal / test network). */
  isCustomer: Scalars['Boolean']['output'];
  /**
   * A "template" network is one that does not represent a real physical network, but rather a template for creating new networks.
   * It is not associated with any physical devices, and is not intended to be used for any real-world operations.
   */
  isTemplate: Scalars['Boolean']['output'];
  /** Whether the network is participating in the Meter Trial Program. */
  isTrial: Scalars['Boolean']['output'];
  /**
   * Indicates whether a network is sensitive to firmware updates.
   * @deprecated Not a network property anymore.
   */
  isUpgradeSensitive: Scalars['Boolean']['output'];
  /** A short code to quickly identify the network. Useful for customers with many networks and a need to quickly identify them. */
  label: Scalars['String']['output'];
  /** The last time this network was upgraded. It is the time when pending NOS was copied into pinned NOS by the NOS scheduler. */
  lastUpgradedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The mailing address associated with the network. */
  mailingAddress?: Maybe<MailingAddress>;
  /** The unique identifier of the network's mailing address. */
  mailingAddressUUID?: Maybe<Scalars['UUID']['output']>;
  /** Maintenance window associated with the network. */
  maintenanceWindow: MaintenanceWindow;
  /** The site-scoped metadata fact sheet for this network. Null if no metadata has been written yet. */
  metadata?: Maybe<NetworkMetadata>;
  /** Monitor groups for this network. */
  monitorGroups: Array<MonitorGroup>;
  /** Monitor probes for this network. */
  monitorProbes: Array<MonitorProbe>;
  /** The most recent NOS upgrade for this network that has started executing (in progress, completed, or failed), if any. */
  mostRecentNetworkNOSUpgrade?: Maybe<ScheduledNetworkNosUpgrade>;
  /** The algorithm used for multi-WAN load balancing. */
  multiWANAlgorithm?: Maybe<MultiWanAlgorithm>;
  /** The network-level NAC configuration. */
  nacConfig?: Maybe<NacConfig>;
  /** The NAC policies associated with the network. */
  nacPolicies: Array<NacPolicy>;
  /** Configuration properties for this network. */
  networkConfigProperties: NetworkConfigProperties;
  /** The network threat allowlist entries for this network. */
  networkThreatAllowlistEntries: Array<NetworkThreatAllowlistEntry>;
  /** The NOS feature flags enabled for this network. */
  nosFeatures: Array<NosFeature>;
  /** A NOS upgrade channel is a property to group networks by their sensitivity to cutting-edge NOS releases. */
  nosUpgradeChannel: NetworkNosUpgradeChannel;
  /** A note about the network's NOS upgrade channel, explaining why it was set to its current value. */
  nosUpgradeChannelNote?: Maybe<Scalars['String']['output']>;
  /** All NOS upgrade groups for this network. */
  nosUpgradeGroups: Array<NosUpgradeGroup>;
  /** The maximum duration in minutes that a NOS upgrade can take, by summing the durations of all NOS upgrade groups containing at least one device. */
  nosUpgradeMaxDurationMinutes: Scalars['Int']['output'];
  /** Preview a hypothetical NOS upgrade of this network to the given target NOS version. */
  nosUpgradePreview: NetworkNosUpgradePreview;
  /**
   * If there is a scheduled upcoming NOS upgrade for this network, this will contain all NOS versions between the current pinned version and the pending version.
   * For upgrades: includes pending, excludes pinned. Semantically, returns what you're getting.
   * For downgrades: includes pinned, excludes target. Semantically, returns what you're losing.
   */
  nosVersionsBetween?: Maybe<Array<NosVersion>>;
  /** Get all ObserverTests for this network. */
  observerTests: Array<ObserverTest>;
  /** Installation and onboarding tracking information for the network. Different from `onboardingDocument`. */
  onboarding?: Maybe<NetworkOnboarding>;
  /** Onboarding document form completed prior to network going live. Different from `onboarding`. */
  onboardingDocument?: Maybe<NetworkOnboardingDocument>;
  /** The one-to-one NAT rules associated with the network. */
  oneToOneNATRules: Array<OneToOneNatRule>;
  /** The URL of the patch panel diagram for the network. */
  patchPanelDiagramURL?: Maybe<Scalars['String']['output']>;
  /** If there is a scheduled upcoming NOS upgrade for this network, this will be the NOS version that will be applied. */
  pendingNOSVersion?: Maybe<NosVersion>;
  /**
   * If there is a scheduled upcoming NOS upgrade for this network, this will be the NOS version that will be applied.
   * @deprecated Use `pendingNOSVersion` instead.
   */
  pendingNOSVersionID?: Maybe<Scalars['Int']['output']>;
  /** The DHCP rules associated with the network's physical interfaces. */
  phyInterfaceDHCPRules: Array<PhyInterfaceDhcpRule>;
  /** A way to pin a network's devices to a known version of config by the config's max created at time. */
  pinnedDeviceConfigMaxCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The current NOS version for all devices in the network. */
  pinnedNOSVersion: NosVersion;
  /**
   * The current NOS version for all devices in the network.
   * @deprecated Use `pinnedNOSVersion` instead.
   */
  pinnedNOSVersionID: Scalars['Int']['output'];
  /** Policy engine policies for this network. */
  policyEnginePolicies: Array<PolicyEnginePolicy>;
  /** The policy routing rules associated with the network. */
  policyRoutingRules: Array<PolicyRoutingRule>;
  /** The port forwarding rules associated with the network. */
  portForwardingRules: Array<PortForwardingRule>;
  /** The network that was soft-deleted and replaced by this network, if any. */
  previousNetworkUUID?: Maybe<Scalars['UUID']['output']>;
  /** The global proactive packet capture configuration for this network. */
  proactivePcapConfig?: Maybe<ProactivePcapNetworkConfig>;
  /** Problematic clients on the network. */
  problematicClients: Array<ProblematicClientEntry>;
  /** Client totals for the same filter as `problematicClients`, including idle clients and active clients with no problems. `reasons` is ignored. */
  problematicClientsSummary: ProblematicClientsSummary;
  /** The rack elevations associated with the network. */
  rackElevations: Array<RackElevation>;
  /** The radio profiles associated with the network. */
  radioProfiles: Array<RadioProfile>;
  /** The rate limit rules associated with the network. */
  rateLimitRules: Array<RateLimitRule>;
  /** The recurring auto channel selection schedule for this network, if configured. */
  recurringAutoChannelSelectionJob?: Maybe<RecurringAutoChannelSelectionJob>;
  /**
   * When true and the network is deactivated (deactivatedAt is set and in the past), all devices in the
   * network render the standard inactive config regardless of their virtual device assignment.
   */
  rendersInactiveConfigs: Scalars['Boolean']['output'];
  /** The network reservations that this network has */
  reservations: Array<NetworkReservation>;
  /** Whether the Network participates in L2 or L3 Routing. */
  routingLayer?: Maybe<NetworkRoutingLayer>;
  /**
   * List all available service requests and their input fields that are  available
   * to be requested through the project management tool.
   * @deprecated Use `DeploymentJob.serviceRequestDefinitions` instead, which carries each definition's `deliverable`.
   */
  serviceRequestDefinitions: Array<ServiceRequestDefinition>;
  /** A human-readable identifier for the network. Used in URLs to identify the network. */
  slug: Scalars['String']['output'];
  /**
   * Deprecated: Not a network property anymore.
   * @deprecated Not a network property anymore.
   */
  spaceCategory?: Maybe<Scalars['String']['output']>;
  /** The spare hardware devices associated with the network, optionally filtered. */
  spareHardwareDevices: Array<HardwareDevice>;
  /** The SSIDs associated with the network. */
  ssids: Array<Ssid>;
  /**
   * The interval in minutes used to stagger device upgrades within the network.
   * @deprecated No longer relevant.
   */
  staggeredUpgradeIntervalMin: Scalars['Int']['output'];
  /** The policy routing rules associated with the network. */
  staticRoutes: Array<StaticRoute>;
  /** The URL of the network topology image. */
  topologyImageURL?: Maybe<Scalars['String']['output']>;
  /** For trial networks, the date when the trial is set to expire. Expiry blocks customer access to the network and disables its functionality. */
  trialExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The upcoming NOS upgrade for this network, if one is scheduled. */
  upcomingScheduledNetworkNOSUpgrade?: Maybe<ScheduledNetworkNosUpgrade>;
  /** The date and time when the network was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The virtual device tags associated with the network. */
  virtualDeviceTags: Array<VirtualDeviceTag>;
  /** The virtual devices associated with the network, optionally filtered. */
  virtualDevices: Array<VirtualDevice>;
  /** The VLANs associated with the network. */
  vlans: Array<Vlan>;
  /**
   * The maximum transmit power in dBm for this network's wireless devices, based on the network's mailing address.
   * @deprecated Use `wirelessValidTransmitPowers` instead.
   */
  wirelessMaxTxPowerdBm: Scalars['Int']['output'];
  /** The channels that are valid for this network's wireless devices, based on the network's mailing address. */
  wirelessValidChannels: Array<ValidChannelsResponse>;
  /** The valid maximum transmit power for this network's wireless devices, based on the network's mailing address. */
  wirelessValidTransmitPowers: Array<ValidTransmitPowerResponse>;
};


/** A network is a grouping of devices in a single location belonging to a company. A core Meter entity. */
export type NetworkActiveIssuesArgs = {
  filters?: InputMaybe<ActiveIssuesFilter>;
};


/** A network is a grouping of devices in a single location belonging to a company. A core Meter entity. */
export type NetworkAutoChannelSelectionJobsArgs = {
  statuses?: InputMaybe<Array<NetworkJobStatus>>;
};


/** A network is a grouping of devices in a single location belonging to a company. A core Meter entity. */
export type NetworkClientObserverTestsArgs = {
  filter?: InputMaybe<ClientObserverFilter>;
};


/** A network is a grouping of devices in a single location belonging to a company. A core Meter entity. */
export type NetworkDeploymentTimeWindowsArgs = {
  types?: InputMaybe<Array<DeploymentTimeWindowType>>;
};


/** A network is a grouping of devices in a single location belonging to a company. A core Meter entity. */
export type NetworkDynamicFloorPlanOpenIntentUploadArgs = {
  uploadUUID: Scalars['UUID']['input'];
};


/** A network is a grouping of devices in a single location belonging to a company. A core Meter entity. */
export type NetworkDynamicFloorPlanOpenIntentUploadsArgs = {
  filter?: InputMaybe<DynamicFloorPlanOpenIntentUploadFilter>;
};


/** A network is a grouping of devices in a single location belonging to a company. A core Meter entity. */
export type NetworkFirewallRulesArgs = {
  includeDefault?: Scalars['Boolean']['input'];
};


/** A network is a grouping of devices in a single location belonging to a company. A core Meter entity. */
export type NetworkNosUpgradePreviewArgs = {
  nosVersionID: Scalars['Int']['input'];
};


/** A network is a grouping of devices in a single location belonging to a company. A core Meter entity. */
export type NetworkPolicyEnginePoliciesArgs = {
  filter?: InputMaybe<PolicyEnginePoliciesFilterInput>;
};


/** A network is a grouping of devices in a single location belonging to a company. A core Meter entity. */
export type NetworkProblematicClientsArgs = {
  filter: ProblematicClientsFilter;
};


/** A network is a grouping of devices in a single location belonging to a company. A core Meter entity. */
export type NetworkProblematicClientsSummaryArgs = {
  filter: ProblematicClientsFilter;
};


/** A network is a grouping of devices in a single location belonging to a company. A core Meter entity. */
export type NetworkSpareHardwareDevicesArgs = {
  filter?: InputMaybe<HardwareDevicesForNetworkFilter>;
};


/** A network is a grouping of devices in a single location belonging to a company. A core Meter entity. */
export type NetworkVirtualDevicesArgs = {
  filter?: InputMaybe<DevicesForNetworkFilter>;
};

/** A network client is a large container for all of the data that constitutes a client connected to a network. */
export type NetworkClient = {
  __typename?: 'NetworkClient';
  /** The access point to which the client is connected, if applicable. */
  accessPoint?: Maybe<AccessPointVirtualDevice>;
  /** The UUID of the access point to which the client is connected, if applicable. */
  accessPointVirtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
  /** A user-defined alias for the client's MAC address, if one is defined for the company. */
  alias?: Maybe<Scalars['String']['output']>;
  /**
   * The location of the access point (AP) to which the client is connected, if applicable.
   * @deprecated Use `accessPoint.label` instead.
   */
  apLocation?: Maybe<Scalars['String']['output']>;
  /**
   * The serial number of the access point (AP) to which the client is connected, if applicable.
   * @deprecated Use `accessPoint.hardwareDevice.serialNumber` instead.
   */
  apSerialNumber?: Maybe<Scalars['String']['output']>;
  /**
   * The AP as a virtual device to which the client is connected, if applicable.
   * @deprecated Use `accessPoint` instead.
   */
  apVirtualDevice?: Maybe<AccessPointVirtualDevice>;
  /** When the client associated with the AP, if applicable. */
  associatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The channel number used by the client's wireless connection. */
  channel?: Maybe<Scalars['Int']['output']>;
  /** The channel width used by the client's wireless connection. */
  channelWidth?: Maybe<Scalars['Int']['output']>;
  /** The friendly name of the client device, if available from DHCP. */
  clientName?: Maybe<Scalars['String']['output']>;
  /** Get client observer tests run by this client, matched on its MAC address. */
  clientObserverTests: Array<ClientObserverTest>;
  /** The path from this client up to the controller, nearest device first. Empty when the client cannot be placed in the topology. */
  clientTopology: Array<ClientTopologyHop>;
  /** The SSID to which the client is connected, if wireless. */
  connectedSSID?: Maybe<Ssid>;
  /** The VLAN to which the client is connected. */
  connectedVLAN?: Maybe<Vlan>;
  /** The vendor of the client device (often its manufacturer), if known. Derived from the IEEE OUI database. */
  deviceVendor?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the DHCP lease assigned to the client expires. */
  dhcpLeaseExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The Wi-Fi generation the client is connected with. */
  hwMode?: Maybe<NetworkClientHwMode>;
  /** The 802.1X identity of the client, if any. This would only be applicable for enterprise authentication using RADIUS. */
  identity8021x: Scalars['String']['output'];
  /** The IP address assigned to the client. */
  ip: Scalars['String']['output'];
  /** Whether this client is blocked network-wide by either MAC address or OUI. */
  isBlocked: Scalars['Boolean']['output'];
  /** Whether this client has run at least one client observer test */
  isClientObserver: Scalars['Boolean']['output'];
  /** Whether the client's MAC address has the locally administered bit set, which could indicate MAC address randomization or that it's virtually assigned. */
  isLocallyAdministeredMACAddress: Scalars['Boolean']['output'];
  /** Whether the client is connected over Wi-Fi. If false, the client is wired. */
  isWireless: Scalars['Boolean']['output'];
  /** The timestamp when the client was last seen on the network. */
  lastSeen: Scalars['DateTime']['output'];
  /**
   * The latency between the controller and the client, measured in milliseconds. Deprecated in favor of 'latencyNs'.
   * @deprecated Use `latencyNs` instead.
   */
  latencyMs?: Maybe<Scalars['Int']['output']>;
  /** The latency between the controller and the client, measured in nanoseconds. */
  latencyNs?: Maybe<Scalars['Int']['output']>;
  /** The MAC address of the client. */
  macAddress: Scalars['MacAddress']['output'];
  /** The network to which this client is connected. */
  network: Network;
  /** The UUID of the network to which this client is connected. */
  networkUUID: Scalars['UUID']['output'];
  /** The noise level of the client's connection, measured in dBm. */
  noise?: Maybe<Scalars['Int']['output']>;
  /** The total number of spatial streams a client device can support, determined as the minimum of its transmit (TX) and receive (RX) spatial streams. */
  numSpatialStreams?: Maybe<Scalars['Int']['output']>;
  /** The Observer virtual device, if the client is an observer */
  observerVirtualDevice?: Maybe<ObserverVirtualDevice>;
  /**
   * Deprecated - favor `phyInterfacesConnectedToRecently` instead.
   * @deprecated Use `phyInterfacesConnectedToRecently` instead.
   */
  phyInterfaceConnectedTo?: Maybe<PhyInterface>;
  /** The physical switch port(s) this wired client has recently been connected to. May return multiple results if the client changed ports recently. */
  phyInterfacesConnectedToRecently: Array<PhyInterface>;
  /** If the client is wireless, the radio band it is connected on. */
  radioBand?: Maybe<RadioBand>;
  /** The recent LLDP entries for this client's MAC address. */
  recentLLDPEntries: Array<LldpEntry>;
  /** The receive rate of the client connection, in bits per second. */
  rxRate?: Maybe<Scalars['Int']['output']>;
  /** List of mdns service types that this client offers (e.g. printer, airplay, etc). */
  serviceTypes?: Maybe<Array<ServiceType>>;
  /** The signal strength of the client's connection, measured in dBm. */
  signal?: Maybe<Scalars['Int']['output']>;
  /** The signal-to-noise ratio of the client's connection, measured in dB, calculated as `signal - noise`. Null if either `signal` or `noise` is null. */
  signalToNoiseRatio?: Maybe<Scalars['Int']['output']>;
  /** The SSID of the wireless network to which the client is connected. */
  ssid?: Maybe<Scalars['String']['output']>;
  /** If the client's IP address is reserved, the DHCP static mapping associated with it. */
  staticMapping?: Maybe<DhcpStaticMapping>;
  /** The average network throughput of the client during the lookback period. */
  throughput?: Maybe<NetworkClientThroughput>;
  /** The total number of bytes received by the client over the requested lookback period. */
  totalRxBytes?: Maybe<Scalars['Int']['output']>;
  /** The total number of bytes transmitted by the client over the requested lookback period. */
  totalTxBytes?: Maybe<Scalars['Int']['output']>;
  /** The transmit rate of the client connection, in bits per second. */
  txRate?: Maybe<Scalars['Int']['output']>;
  /**
   * The VLAN the client is connected to.
   * @deprecated Use `connectedVLAN` instead.
   */
  vlan?: Maybe<Scalars['String']['output']>;
  /** The UUID of the VLAN to which the client is connected. */
  vlanUUID?: Maybe<Scalars['UUID']['output']>;
  /** Performance component of the wireless score (0-100). Based on MCS utilization efficiency. */
  wirelessPerformanceScore?: Maybe<Scalars['Float']['output']>;
  /** Reliability component of the wireless score (0-100). Based on retry and failure ratios. */
  wirelessReliabilityScore?: Maybe<Scalars['Float']['output']>;
  /** RF quality component of the wireless score (0-100). Based on uplink SNR. */
  wirelessRfScore?: Maybe<Scalars['Float']['output']>;
  /** Wireless score computed based on the current health of the client. */
  wirelessScore?: Maybe<Scalars['Float']['output']>;
};


/** A network client is a large container for all of the data that constitutes a client connected to a network. */
export type NetworkClientClientObserverTestsArgs = {
  filter?: InputMaybe<ClientObserverFilter>;
};

/** Entries representing MAC addresses blocked on a given network. */
export type NetworkClientBlocklistEntry = Identifiable & {
  __typename?: 'NetworkClientBlocklistEntry';
  /** Unique identifier for the blocklist entry. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp this entry was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The MAC address being blocked. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** The network that the MAC address is blocked on. */
  network: Network;
  /** Unique identifier for the network that the MAC address is blocked on. */
  networkUUID: Scalars['UUID']['output'];
  /** The OUI being blocked. Only one of either MAC Address or OUI is set. */
  oui?: Maybe<Scalars['String']['output']>;
  /** The SSID this blocklist entry is scoped to, if any. */
  ssid?: Maybe<Ssid>;
  /** If set, the SSID this blocklist entry is scoped to. If null, the entry is network-wide. */
  ssidUUID?: Maybe<Scalars['UUID']['output']>;
  /**
   * Unique identifier for the blocklist entry.
   * @deprecated Use `UUID` instead.
   */
  uuid: Scalars['UUID']['output'];
};

/** A NetworkClientCPEBinding marks a certain CPE as running on a network client, keyed by its MAC address. */
export type NetworkClientCpeBinding = Identifiable & {
  __typename?: 'NetworkClientCPEBinding';
  /** Unique identifier for this NetworkClientCPEBinding */
  UUID: Scalars['UUID']['output'];
  /** The CPE associated with this binding. */
  cpe: Cpe;
  /** Timestamp when the NetworkClientCPEBinding was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The unique identifier of client associated with this binding. */
  macAddress: Scalars['MacAddress']['output'];
  /** The network associated with this binding. */
  network: Network;
};

/** Represents the hardware mode of a device the client is connected to. */
export enum NetworkClientHwMode {
  /** Represents no HW mode. */
  Na = 'NA',
  /** Represents Wi-Fi 2. */
  Wifi_2 = 'WIFI_2',
  /** Represents Wi-Fi 3. */
  Wifi_3 = 'WIFI_3',
  /** Represents Wi-Fi 4. */
  Wifi_4 = 'WIFI_4',
  /** Represents Wi-Fi 5. */
  Wifi_5 = 'WIFI_5',
  /** Represents Wi-Fi 6. */
  Wifi_6 = 'WIFI_6',
  /** Represents Wi-Fi 7. */
  Wifi_7 = 'WIFI_7'
}

/**
 * A MAC address of a network client, scoped to the network on which it was observed.
 * Returned by `networksClientsMACAddresses` as a lightweight alternative to
 * `networksClients` when only the set of known client MAC addresses is needed.
 */
export type NetworkClientMacAddress = {
  __typename?: 'NetworkClientMACAddress';
  /** The MAC address of the client. */
  macAddress: Scalars['MacAddress']['output'];
  /** The UUID of the network on which the client was observed. */
  networkUUID: Scalars['UUID']['output'];
};

/** Represents the throughput of a client device. */
export type NetworkClientThroughput = {
  __typename?: 'NetworkClientThroughput';
  /** The average receive rate of the client, in bits per second. */
  rxRate?: Maybe<Scalars['Float']['output']>;
  /** The average transmit rate of the client, in bits per second. */
  txRate?: Maybe<Scalars['Float']['output']>;
};

/** Represents the throughput of a client device, grouped by day. */
export type NetworkClientTxRxPerDay = {
  __typename?: 'NetworkClientTxRxPerDay';
  /** The date to which the data is grouped by. */
  dateString: Scalars['String']['output'];
  /** The IP address of the client. */
  ip: Scalars['String']['output'];
  /** The MAC address of the client. */
  macAddress: Scalars['MacAddress']['output'];
  /** The total number of bytes received by the client on this date. */
  rxBytes: Scalars['Int']['output'];
  /** The total number of bytes transmitted by the client on this date. */
  txBytes: Scalars['Int']['output'];
};

export type NetworkClientsFilter = {
  /**
   * If provided, the latest connected clients for a network are returned
   * that were reported to be connected to the given AP serial number.
   * At most one of `macAddress`, `apSerialNumber`, `vlanID`, or `ssid` can be provided.
   */
  apSerialNumber?: InputMaybe<Scalars['String']['input']>;
  /** If true, clients identified as Meter hardware devices will be excluded from the results. */
  excludeMeterHardware?: Scalars['Boolean']['input'];
  /**
   * If provided, then the ping latency from controller to client is included
   * in the response.
   */
  includeLatency?: Scalars['Boolean']['input'];
  /**
   * If provided, the average usage for all returned clients in the last
   * 30 minutes will be included in the response. If macAddress is provided this field has no effect.
   */
  includeThroughput?: Scalars['Boolean']['input'];
  /** If provided, returns clients with IP addresses within the provided range. */
  ipRange?: InputMaybe<IpRangeInput>;
  /**
   * When no macAddress and apSerialNumber are provided, filters resulting clients' lastSeen
   * to this many minutes before now.
   */
  lookbackMinutes?: Scalars['Int']['input'];
  /**
   * If a MAC address is provided, this will get the history of clients with this MAC address.
   * At most one of `macAddress`, `apSerialNumber`, `vlanID`, or `ssid` can be provided.
   */
  macAddress?: InputMaybe<Scalars['MacAddress']['input']>;
  /**
   * If provided, the latest connected clients for a network are returned
   * that were reported to be connected to the given SSID.
   * Only supported on networks running a firewall.
   * At most one of `macAddress`, `apSerialNumber`, `vlanID`, or `ssid` can be provided.
   */
  ssid?: InputMaybe<Scalars['String']['input']>;
  /** If provided, then returns the results that were observed at the given timestamp. If null, defaults to now. */
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * If provided, the latest connected clients for a network are returned
   * that were reported to be connected to the given VLAN.
   * Only supported on networks running a firewall.
   * At most one of `macAddress`, `apSerialNumber`, `vlanID`, or `ssid` can be provided.
   */
  vlanID?: InputMaybe<Scalars['Int']['input']>;
};

export type NetworkClientsMacAddressesFilter = {
  /** If true, clients identified as Meter hardware devices will be excluded from the results. */
  excludeMeterHardware?: Scalars['Boolean']['input'];
  /** Filters resulting clients' lastSeen to this many minutes before now. */
  lookbackMinutes?: Scalars['Int']['input'];
};

/** Per-network configuration properties. */
export type NetworkConfigProperties = {
  __typename?: 'NetworkConfigProperties';
  /**
   * If true, trunk ports on switches where all access ports are STP edge ports may be configured as STP edge ports
   * via `isSTPEdgePortEnabled`. Otherwise, those trunk ports are never edge ports.
   */
  isTrunkEdgeOverrideEnabled: Scalars['Boolean']['output'];
};

/** A network was created, updated, or deleted. */
export type NetworkEvent = CrudEvent & {
  __typename?: 'NetworkEvent';
  /** The UUID of the network the action was performed on. */
  entityUUID: Scalars['UUID']['output'];
  /** The network itself. */
  network?: Maybe<Network>;
  /** The action performed on the network. */
  type: CrudEventType;
};

/** An interface representing a network job. */
export type NetworkJob = {
  /** The unique identifier for the job. */
  UUID: Scalars['UUID']['output'];
  /** The time at which the job was completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier of the network associated with this job. */
  networkUUID: Scalars['UUID']['output'];
  /** The time at which the job was scheduled. */
  scheduledAt: Scalars['DateTime']['output'];
};

/** Represents the status of a network job. */
export enum NetworkJobStatus {
  /** Status is canceled. */
  Canceled = 'CANCELED',
  /** Status is failed. */
  Failed = 'FAILED',
  /** Status is pending. */
  Pending = 'PENDING',
  /** Status is running. */
  Running = 'RUNNING',
  /** Status is succeeded. */
  Succeeded = 'SUCCEEDED',
  /** Status is timed out. */
  TimedOut = 'TIMED_OUT',
  /** Status is unknown. */
  Unknown = 'UNKNOWN'
}

/**
 * Additional data about a network like square feet, floor count, device counts, etc.
 * These are 1:1 with networks. Each field has its own updatedAt which is reset any
 * time that field is set in a mutation, even if it doesn't change.
 */
export type NetworkMetadata = {
  __typename?: 'NetworkMetadata';
  /** Estimated number of access points the site requires. */
  accessPointCount?: Maybe<Scalars['Int']['output']>;
  /** When accessPointCount was last set. */
  accessPointCountUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Free-text instructions describing how the network should be configured. */
  configurationInstructions?: Maybe<Scalars['String']['output']>;
  /** When configurationInstructions was last set. */
  configurationInstructionsUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When this metadata row was first created. */
  createdAt: Scalars['DateTime']['output'];
  /** Number of distribution frames (IDFs/MDFs) at the site. */
  distributionFrameCount?: Maybe<Scalars['Int']['output']>;
  /** When distributionFrameCount was last set. */
  distributionFrameCountUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the design must use cabling that is already in place. */
  existingCabling?: Maybe<Scalars['Boolean']['output']>;
  /** Free-text context describing the existing cabling. */
  existingCablingContext?: Maybe<Scalars['String']['output']>;
  /** When existingCablingContext was last set. */
  existingCablingContextUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When existingCabling was last set. */
  existingCablingUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Expected number of concurrent users. */
  expectedUserCount?: Maybe<Scalars['Int']['output']>;
  /** When expectedUserCount was last set. */
  expectedUserCountUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Number of fiber runs needed at the site. */
  fiberRunsNeeded?: Maybe<Scalars['Int']['output']>;
  /** When fiberRunsNeeded was last set. */
  fiberRunsNeededUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Number of floors at the site. */
  floorCount?: Maybe<Scalars['Int']['output']>;
  /** When floorCount was last set. */
  floorCountUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The UUID of the network this metadata is for. */
  networkUUID: Scalars['UUID']['output'];
  /** Whether outdoor wireless coverage is needed. */
  outdoorCoverageNeeded?: Maybe<Scalars['Boolean']['output']>;
  /** Free-text context describing outdoor-coverage needs. */
  outdoorCoverageNeededContext?: Maybe<Scalars['String']['output']>;
  /** When outdoorCoverageNeededContext was last set. */
  outdoorCoverageNeededContextUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When outdoorCoverageNeeded was last set. */
  outdoorCoverageNeededUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Type of space (office, warehouse, etc.). */
  spaceType?: Maybe<Scalars['String']['output']>;
  /** When spaceType was last set. */
  spaceTypeUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Square footage of the site. */
  squareFeet?: Maybe<Scalars['Int']['output']>;
  /** When squareFeet was last set. */
  squareFeetUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Preferred switch port count for the site. */
  switchPortCountPreference?: Maybe<Scalars['Int']['output']>;
  /** When switchPortCountPreference was last set. */
  switchPortCountPreferenceUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Free-text instructions describing the needs for this network's topology. */
  topologyInstructions?: Maybe<Scalars['String']['output']>;
  /** When topologyInstructions was last set. */
  topologyInstructionsUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When this metadata row was last touched (any column). */
  updatedAt: Scalars['DateTime']['output'];
  /** Estimated number of wired clients the site supports. */
  wiredClientCount?: Maybe<Scalars['Int']['output']>;
  /** When wiredClientCount was last set. */
  wiredClientCountUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A NOS upgrade channel describes the network's minimum readiness to receive a given stage of NOS upgrade as it proceeds through the QA process. */
export enum NetworkNosUpgradeChannel {
  /** Non-production customer networks. Provides customers with cutting-edge bug fixes and features; may include unknown issues. */
  CustomerLab = 'CUSTOMER_LAB',
  /** For high-touch or special case customer networks that require manual NOS upgrade scheduling by Meter Support. May also be applied to critical accounts or any customer with active Support involvement. Effectively slows upgrades until the end of a NOS upgrade cycle and may slow the delivery of non-critical bug fixes and features. */
  DeferredUpgrades = 'DEFERRED_UPGRADES',
  /** Internal networks that receive NOS versions which have completed regression testing; additional QA is in progress. */
  Dogfood = 'DOGFOOD',
  /** Internal networks that are used by Meter employees in real-world environments, for example, office and warehouse networks. NOS versions are nearing full QA completion and is prepared for broader internal testing. */
  InternalProduction = 'INTERNAL_PRODUCTION',
  /** Internal networks that receive early-stage NOS versions that have passed preliminary QA; additional QA is in progress. */
  Kittyfood = 'KITTYFOOD',
  /** Simple customer networks with low complexity and low risk of issues. */
  Phase_1 = 'PHASE_1',
  /** Moderate complexity customer networks with moderate risk of issues. */
  Phase_2 = 'PHASE_2',
  /** Complex customer networks with sophisticated topology and high risk of issues. */
  Phase_3 = 'PHASE_3',
  /** Complex, mission-critical customer networks with sophisticated topology and high risk of issues. */
  Phase_4 = 'PHASE_4',
  /** Internal networks that do not receive automated upgrades. The network owner is fully responsible for managing their NOS version. */
  Sandbox = 'SANDBOX'
}

/** Preview of a hypothetical NOS upgrade for a network to a given target NOS version. */
export type NetworkNosUpgradePreview = {
  __typename?: 'NetworkNOSUpgradePreview';
  /** The expected total upgrade duration in minutes, summing the batch timings of groups that still have at least one device to upgrade after excluding no-ops. */
  durationMinutes: Scalars['Int']['output'];
  /** Virtual devices that will be skipped by the upgrade: those with no hardware attached, and those whose current build string for the network's existing NOS version is identical to the build string of the target NOS version. */
  noOpVirtualDevices: Array<VirtualDevice>;
};

/** Represents the onboarding process for a network. */
export type NetworkOnboarding = {
  __typename?: 'NetworkOnboarding';
  /** Unique identifier for the network onboarding entry. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the network onboarding was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Job data associated with the network onboarding. */
  jobData?: Maybe<NetworkOnboardingJobData>;
  /** Identifier of the associated job data. */
  jobDataID: Scalars['String']['output'];
  /** Unique identifier of the associated network. */
  networkUUID: Scalars['UUID']['output'];
  /** Timestamp when the network onboarding was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Certificate of insurance (COI) requirements for the network site. */
export type NetworkOnboardingCoiData = {
  __typename?: 'NetworkOnboardingCOIData';
  /** The uploaded certificate of insurance. Set only when is_required is YES. */
  file?: Maybe<NetworkOnboardingDocumentFileData>;
  /** Whether a certificate of insurance is required for the site. */
  is_required: YesNoUnsure;
};

/** Input for the certificate of insurance (COI) requirements. */
export type NetworkOnboardingCoiInput = {
  /** The uploaded certificate of insurance. Required when is_required is YES, and must be omitted otherwise. */
  file?: InputMaybe<NetworkOnboardingDocumentFileInput>;
  /** Whether a certificate of insurance is required for the site. */
  is_required: YesNoUnsure;
};

/** A conditional yes/no/unsure answer with supporting details and file uploads. */
export type NetworkOnboardingConditionalDetailsUploadData = {
  __typename?: 'NetworkOnboardingConditionalDetailsUploadData';
  /** Free-form details supporting the answer. Empty when selection is NO. */
  details?: Maybe<Scalars['String']['output']>;
  /** Files uploaded to support the answer. Empty when selection is NO. */
  files: Array<NetworkOnboardingDocumentFileData>;
  /** The yes/no/unsure answer. */
  selection: YesNoUnsure;
};

/** Input for a conditional yes/no/unsure answer with supporting details and file uploads. */
export type NetworkOnboardingConditionalDetailsUploadInput = {
  /** Free-form details supporting the answer. Must be omitted when selection is NO. */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Files uploaded to support the answer. Must be empty when selection is NO. */
  files: Array<NetworkOnboardingDocumentFileInput>;
  /** The yes/no/unsure answer. */
  selection: YesNoUnsure;
};

/** A conditional yes/no/unsure answer with supporting file uploads. */
export type NetworkOnboardingConditionalUploadData = {
  __typename?: 'NetworkOnboardingConditionalUploadData';
  /** Files uploaded to support the answer. */
  files: Array<NetworkOnboardingDocumentFileData>;
  /** The yes/no/unsure answer, if one has been given. */
  selection?: Maybe<YesNoUnsure>;
};

/** Input for a conditional yes/no/unsure answer with supporting file uploads. */
export type NetworkOnboardingConditionalUploadInput = {
  /** Files uploaded to support the answer. */
  files: Array<NetworkOnboardingDocumentFileInput>;
  /** The yes/no/unsure answer, if one has been given. */
  selection?: InputMaybe<YesNoUnsure>;
};

/** Document containing information required for network onboarding. */
export type NetworkOnboardingDocument = Identifiable & {
  __typename?: 'NetworkOnboardingDocument';
  /** Unique identifier for the network onboarding document. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the document was created. */
  createdAt: Scalars['DateTime']['output'];
  /** List of fields that have been delegated to other users for completion. */
  delegations: Array<NetworkOnboardingFieldDelegation>;
  /** JSON object containing the onboarding document data. */
  document: Scalars['JSONObject']['output'];
  /** Data for the onboarding document in a normalized format. */
  documentData: NetworkOnboardingDocumentData;
  /** List of editors for each field in the document. */
  documentEditors: Array<NetworkOnboardingDocumentFieldEditor>;
  /** JSON object containing the onboarding document metadata data. */
  documentMetadata?: Maybe<Scalars['JSONObject']['output']>;
  /** List of editors for each field in the document metadata. */
  documentMetadataEditors: Array<NetworkOnboardingDocumentFieldEditor>;
  /** Keys of document fields that are currently hidden. Fields not listed here are visible by default. */
  hiddenFields: Array<Scalars['String']['output']>;
  /** Unique identifier of the associated network. */
  networkUUID: Scalars['UUID']['output'];
  /** Timestamp when the document was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Normalized data for the onboarding document. */
export type NetworkOnboardingDocumentData = {
  __typename?: 'NetworkOnboardingDocumentData';
  /** Whether union contractors are required at the site. */
  AreUnionContractorsRequired?: Maybe<YesNoUnsure>;
  /** Certificate of insurance requirements for the site. */
  COI?: Maybe<NetworkOnboardingCoiData>;
  /** Floor plans for the site. */
  FloorPlans: NetworkOnboardingFloorPlansData;
  /** The people representing the customer who Meter can contact when needing to discuss the network. */
  OnsitePointsOfContact?: Maybe<Array<PointOfContactData>>;
  /** Whether there are servers on-site, with supporting details and uploads. */
  ServersOnsite?: Maybe<NetworkOnboardingConditionalDetailsUploadData>;
  /** Preferred dates and times for the site survey. */
  SiteSurveyWindows?: Maybe<Array<NetworkOnboardingTimeWindowData>>;
  /** The technical points of contact for the network. */
  TechnicalPointsOfContact?: Maybe<Array<PointOfContactData>>;
  /** Current and expected future wireless user counts for the site. */
  WirelessUserCount?: Maybe<NetworkOnboardingWirelessUserCountData>;
};

/** Normalized input data for mutating the onboarding document. */
export type NetworkOnboardingDocumentDataInput = {
  /** Whether union contractors are required at the site. */
  AreUnionContractorsRequired?: InputMaybe<YesNoUnsure>;
  /** Certificate of insurance requirements for the site. */
  COI?: InputMaybe<NetworkOnboardingCoiInput>;
  /** Floor plans for the site. Fields left unset are not modified; setting the whole input to null is a no-op. */
  FloorPlans?: InputMaybe<NetworkOnboardingFloorPlansInput>;
  /** The people representing the customer who Meter can contact when needing to discuss the network. */
  OnsitePointsOfContact?: InputMaybe<Array<PointOfContactInput>>;
  /** Whether there are servers on-site, with supporting details and uploads. */
  ServersOnsite?: InputMaybe<NetworkOnboardingConditionalDetailsUploadInput>;
  /** Preferred dates and times for the site survey. */
  SiteSurveyWindows?: InputMaybe<Array<TimeWindowInput>>;
  /** The technical points of contact for the network. */
  TechnicalPointsOfContact?: InputMaybe<Array<PointOfContactInput>>;
  /** Current and expected future wireless user counts for the site. */
  WirelessUserCount?: InputMaybe<NetworkOnboardingWirelessUserCountInput>;
};

/** Information about the edit history for a specific field of the network onboarding document. */
export type NetworkOnboardingDocumentFieldEditor = {
  __typename?: 'NetworkOnboardingDocumentFieldEditor';
  /** Name of the field that was edited. */
  fieldName: Scalars['String']['output'];
  /** History of edits for this field, ordered from oldest to newest. */
  history: Array<NetworkOnboardingDocumentFieldEditorHistoryEntry>;
};

/** A single edit entry in the history of a field. */
export type NetworkOnboardingDocumentFieldEditorHistoryEntry = {
  __typename?: 'NetworkOnboardingDocumentFieldEditorHistoryEntry';
  /** Timestamp when the field was edited. */
  updatedAt: Scalars['DateTime']['output'];
  /** Name of the user who edited the field. */
  username: Scalars['String']['output'];
};

/** A file uploaded as part of the network onboarding document. */
export type NetworkOnboardingDocumentFileData = {
  __typename?: 'NetworkOnboardingDocumentFileData';
  /** Extension of the uploaded file, including the leading dot. */
  extension?: Maybe<Scalars['String']['output']>;
  /** Original name of the uploaded file. */
  file_name?: Maybe<Scalars['String']['output']>;
  /** S3 key of the uploaded file. */
  s3_key: Scalars['String']['output'];
};

/** Input for a file uploaded as part of the network onboarding document. */
export type NetworkOnboardingDocumentFileInput = {
  /** Extension of the uploaded file, including the leading dot. */
  extension?: InputMaybe<Scalars['String']['input']>;
  /** Original name of the uploaded file. */
  file_name?: InputMaybe<Scalars['String']['input']>;
  /** S3 key of the uploaded file. */
  s3_key: Scalars['String']['input'];
};

/** Represents the delegation of a specific field of the network onboarding document to a user. */
export type NetworkOnboardingFieldDelegation = Identifiable & {
  __typename?: 'NetworkOnboardingFieldDelegation';
  /** Unique identifier of the field delegation. */
  UUID: Scalars['UUID']['output'];
  /** Description of the delegation. */
  description?: Maybe<Scalars['String']['output']>;
  /** Email of the user to whom the field is delegated. */
  email: Scalars['String']['output'];
  /** Name of the field being delegated. */
  fieldName: Scalars['String']['output'];
  /** Unique identifier of the associated network. */
  networkUUID: Scalars['UUID']['output'];
};

/** The floor plans of the network site. */
export type NetworkOnboardingFloorPlansData = {
  __typename?: 'NetworkOnboardingFloorPlansData';
  /** Blank floor plans for the site, together with a yes/no/unsure answer for whether they can be provided. */
  BlankFloorPlanWithConditional?: Maybe<NetworkOnboardingConditionalUploadData>;
  /** Blank floor plans for the site. */
  BlankFloorPlans?: Maybe<Array<NetworkOnboardingDocumentFileData>>;
  /** Marked up floor plans for the site. */
  MarkedUpFloorPlans?: Maybe<Array<NetworkOnboardingDocumentFileData>>;
};

/** Input for the floor plans of the network site. */
export type NetworkOnboardingFloorPlansInput = {
  /** Blank floor plans for the site, together with a yes/no/unsure answer for whether they can be provided. */
  BlankFloorPlanWithConditional?: InputMaybe<NetworkOnboardingConditionalUploadInput>;
  /** Blank floor plans for the site. */
  BlankFloorPlans?: InputMaybe<Array<NetworkOnboardingDocumentFileInput>>;
  /** Marked up floor plans for the site. */
  MarkedUpFloorPlans?: InputMaybe<Array<NetworkOnboardingDocumentFileInput>>;
};

/** Stores logistical data for tracking the installation and onboarding of a network. */
export type NetworkOnboardingJobData = {
  __typename?: 'NetworkOnboardingJobData';
  /** Full address of the network location, possibly including address lines, city, state, and ZIP code. */
  fullAddress?: Maybe<Array<Scalars['String']['output']>>;
  /** Unique identifier of the job data. */
  id: Scalars['String']['output'];
  /**
   * End date of the installation.
   * @deprecated No longer supported.
   */
  installationEndDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Start date of the installation.
   * @deprecated No longer supported.
   */
  installationStartDate?: Maybe<Scalars['DateTime']['output']>;
  /** Identifier of the job. */
  jobID?: Maybe<Scalars['String']['output']>;
  /** User who owns the job. */
  jobOwnerUser?: Maybe<Scalars['String']['output']>;
  /**
   * Current stage of the job.
   * @deprecated No longer supported.
   */
  jobStage?: Maybe<Scalars['String']['output']>;
  /** Current status of the job. */
  jobStatus?: Maybe<Scalars['String']['output']>;
  /**
   * Names of the technicians assigned to the job.
   * @deprecated No longer supported.
   */
  jobTechnicianName?: Maybe<Array<Scalars['String']['output']>>;
  /** Phone numbers of the technicians assigned to the job. */
  jobTechnicianPhone?: Maybe<Array<Scalars['String']['output']>>;
  /** Code identifying the location. */
  locationCode?: Maybe<Scalars['String']['output']>;
  /**
   * Information about the onsite contact person.
   * @deprecated No longer supported.
   */
  onsiteContactInformation?: Maybe<Scalars['String']['output']>;
  /**
   * Links for scheduling a site survey.
   * @deprecated No longer supported.
   */
  scheduleSiteSurveyLink?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Dates of the site survey..
   * @deprecated No longer supported.
   */
  siteSurveyDate?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Status updates of the site survey.
   * @deprecated No longer supported.
   */
  siteSurveyStatus?: Maybe<Array<Scalars['String']['output']>>;
  /** Target date for the network to go live. */
  targetGoLiveDate?: Maybe<Scalars['DateTime']['output']>;
  /** Total square footage of the network location. */
  totalSqFt?: Maybe<Array<Scalars['String']['output']>>;
};

/** A time window for potential work to be done. */
export type NetworkOnboardingTimeWindowData = {
  __typename?: 'NetworkOnboardingTimeWindowData';
  /** End time of the time window. */
  end_time: Scalars['DateTime']['output'];
  /** Notes about the time window. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Start time of the time window. */
  start_time: Scalars['DateTime']['output'];
};

/** Current and expected future wireless user counts from onboarding. */
export type NetworkOnboardingWirelessUserCountData = {
  __typename?: 'NetworkOnboardingWirelessUserCountData';
  /** Current daily average number of wireless users. */
  currentUsers: Scalars['Int']['output'];
  /** Expected future daily average number of wireless users. Null means growth is unknown; equal to currentUsers means no growth. */
  futureUsers?: Maybe<Scalars['Int']['output']>;
};

/** Input for the current and expected future wireless user counts. */
export type NetworkOnboardingWirelessUserCountInput = {
  /** Positive current daily average number of wireless users. */
  currentUsers: Scalars['Int']['input'];
  /** Positive expected future daily average number of wireless users. Omitted or null means growth is unknown; equal to currentUsers means no growth. */
  futureUsers?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Network Reservations are used to represent a QA hold on a network. These
 * reservations can only be created on non-customer facing networks and can be modified
 * by any operator
 */
export type NetworkReservation = Identifiable & {
  __typename?: 'NetworkReservation';
  /** Reservation id */
  UUID: Scalars['UUID']['output'];
  /** Description of the reservation */
  description?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the reservation ends */
  endTime: Scalars['DateTime']['output'];
  /** Who made the reservation */
  reservedBy: Scalars['String']['output'];
  /** The timestamp when the reservation begins */
  startTime: Scalars['DateTime']['output'];
};

/** A network route defines a route within the networking stack on a device. It can refer to either a physical interface, VLAN interface, or another Linux interface. */
export type NetworkRoute = {
  __typename?: 'NetworkRoute';
  /** The network attachment for the route; one of the attachment fields will be non-null. */
  attachment: NetworkRouteAttachment;
  /** The destination IP prefix of the network route. */
  destination: Scalars['IPPrefix']['output'];
  /** The gateway IP address for the network route. */
  gateway?: Maybe<Scalars['IPV4']['output']>;
  /** The route as the device reported it, only for learned routes. */
  learnedRoute?: Maybe<LearnedRoute>;
};

/** At least one field of NetworkRouteAttachment will be non-null. Static routes report both staticRoute and their gateway vlan. */
export type NetworkRouteAttachment = {
  __typename?: 'NetworkRouteAttachment';
  /** Attachment to an Auto VPN group. */
  autoVPNGroup?: Maybe<AutoVpnGroup>;
  /** Attachment to a BGP router. */
  bgpRouter?: Maybe<BgpRouter>;
  /** Attachment to a Client VPN server. */
  clientVPNServer?: Maybe<ClientVpnServer>;
  /** Attachment to an IPSec tunnel. */
  ipSecTunnel?: Maybe<IpSecTunnel>;
  /** Attachment to a physical network interface. */
  phyInterface?: Maybe<PhyInterface>;
  /** Attachment to a static route. */
  staticRoute?: Maybe<StaticRoute>;
  /** Attachment to a VLAN interface. */
  vlan?: Maybe<Vlan>;
};

/** The Network Routing Layer defines whether L3 Routing is enabled on the network. */
export enum NetworkRoutingLayer {
  /** Network has L3 Segmentation disabled. */
  L2Routing = 'L2_ROUTING',
  /** Network has L3 Segmentation enabled. */
  L3Routing = 'L3_ROUTING'
}

export type NetworkStatsFilter = {
  /** The lookback time to consider stats for, starting at `endTime`. Maximum allowed value is 7776000, 90 days. */
  durationSeconds: Scalars['Int']['input'];
  /** The latest observation time to consider stats for, inclusive. Defaults to the current time if not set. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The maximum number of results to return, between 1 and 1000. Defaults to 100 if not set. */
  limit?: Scalars['Int']['input'];
  /** The number of results to skip before returning results. Defaults to 0 if not set. */
  offset?: Scalars['Int']['input'];
  /** The list of stat types to return. */
  types: Array<StatType>;
  /** The unique identifiers of the virtual devices to fetch stats for. If omitted, will include all virtual devices in the network. */
  virtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Represents an allowed device for threat detection. */
export type NetworkThreatAllowlistEntry = Identifiable & {
  __typename?: 'NetworkThreatAllowlistEntry';
  /** A BSSID to allow for honeypot AP detection. */
  BSSID?: Maybe<Scalars['String']['output']>;
  /** The SSID object associated with this BSSID. */
  SSID?: Maybe<Ssid>;
  /** The unique identifier for the allowed device. */
  UUID: Scalars['UUID']['output'];
  /** The time at which the entry was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The network. */
  network: Network;
  /** The unique identifier for the network. */
  networkUUID: Scalars['UUID']['output'];
  /** An explanation of the allowlisted device or the SSID to allow. */
  reason?: Maybe<Scalars['String']['output']>;
  /** An SSID to allow if a threat is broadcasting it. */
  ssidUUID?: Maybe<Scalars['UUID']['output']>;
  /** The time at which the entry was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** A mac address to allow for rogue AP detection. */
  wiredMAC?: Maybe<Scalars['String']['output']>;
};

/** Represents an observer of a network threat. Will usually be an access point. */
export type NetworkThreatObserver = {
  __typename?: 'NetworkThreatObserver';
  /** The noise floor represents the background signal interference by the observer, which can affect the clarity and accuracy of the signal measurement from the network threat. */
  noiseFloor: Scalars['Int']['output'];
  /** The time that the observation occurred. */
  observedAt: Scalars['DateTime']['output'];
  /** The RSSI represents the signal strength measured by the observer from the network threat. */
  rssi: Scalars['Int']['output'];
  /** The SSID that this observer saw the threat broadcasting. */
  ssid: Scalars['String']['output'];
  /** The virtual device that observed the network threat. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The UUID of the virtual device that observed the network threat. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

export type NetworkThreatsFilterInput = {
  /** Specify the time range for data. */
  timeFilter: MetricsFilterInput;
};

/** The response containing quality metrics for a network uplink. */
export type NetworkUplinkQualityResponse = MetricsResponse & {
  __typename?: 'NetworkUplinkQualityResponse';
  /** Metadata about the metrics. */
  metadata?: Maybe<MetricsMetadata>;
  /** A list of quality metric values. */
  values: Array<NetworkUplinkQualityValue>;
};

/** Represents the quality metrics value for a network uplink. */
export type NetworkUplinkQualityValue = MetricsValue & {
  __typename?: 'NetworkUplinkQualityValue';
  /**
   * The UUID of the network associated with this quality metric.
   * Entities are referenced by UUID rather than embedded, because a response can contain many data points.
   */
  networkUUID: Scalars['UUID']['output'];
  /**
   * The UUID of the physical interface associated with this quality metric.
   * Entities are referenced by UUID rather than embedded, because a response can contain many data points.
   */
  phyInterfaceUUID: Scalars['UUID']['output'];
  /** The timestamp when the metric was recorded. */
  timestamp: Scalars['DateTime']['output'];
  /** The quality value measured at the given timestamp, typically represented as a percentage of successful pings. */
  value: Scalars['Float']['output'];
};

/** The response containing throughput metrics for a network uplink. */
export type NetworkUplinkThroughputMetricsResponse = MetricsResponse & {
  __typename?: 'NetworkUplinkThroughputMetricsResponse';
  /** Metadata about the metrics, such as time range and aggregation interval. */
  metadata?: Maybe<MetricsMetadata>;
  /** A list of throughput metric values. */
  values: Array<NetworkUplinkThroughputMetricsValue>;
};

/** Represents the throughput metrics value for a network uplink. */
export type NetworkUplinkThroughputMetricsValue = MetricsValue & {
  __typename?: 'NetworkUplinkThroughputMetricsValue';
  /** Indicates the direction of the traffic. */
  direction: TrafficDirection;
  /**
   * The UUID of the network associated with this throughput metric.
   * Entities are referenced by UUID rather than embedded, because a response can contain many data points.
   */
  networkUUID: Scalars['UUID']['output'];
  /**
   * The UUID of the physical interface associated with this throughput metric.
   * Entities are referenced by UUID rather than embedded, because a response can contain many data points.
   */
  phyInterfaceUUID: Scalars['UUID']['output'];
  /** The timestamp when the metric was recorded. */
  timestamp: Scalars['DateTime']['output'];
  /** The throughput value measured at the given timestamp, in bits per second. */
  value: Scalars['Float']['output'];
};

/**
 * A wireless client that attempted to connect to the network (from wireless connection events),
 * including clients that failed to connect and are not in the regular clients list.
 */
export type NetworkWirelessClient = {
  __typename?: 'NetworkWirelessClient';
  /** The UUID of the access point the client last attempted to connect to. */
  accessPointVirtualDeviceUUID: Scalars['UUID']['output'];
  /** The timestamp when the client was last seen attempting to connect. */
  lastSeen: Scalars['DateTime']['output'];
  /** The MAC address of the client. */
  macAddress: Scalars['MacAddress']['output'];
  /** The connected network client, if this client is also in the regular clients list. */
  networkClient?: Maybe<NetworkClient>;
  /** The UUID of the network. */
  networkUUID: Scalars['UUID']['output'];
  /** The radio band the client last attempted to connect on. */
  radioBand: RadioBand;
  /** The signal strength of the client's last connection attempt, measured in dBm. */
  signal: Scalars['Int']['output'];
  /** The SSID the client last attempted to connect to. */
  ssid: Scalars['String']['output'];
};

export type NetworkWirelessClientsFilter = {
  /** If true, clients identified as Meter hardware devices will be excluded from the results. */
  excludeMeterHardware?: Scalars['Boolean']['input'];
  /** Filters resulting clients' lastSeen to this many minutes before now. */
  lookbackMinutes?: Scalars['Int']['input'];
  /** If provided, filters to clients that attempted to connect to this SSID. */
  ssid?: InputMaybe<Scalars['String']['input']>;
};

/** Filter for boolean fields in networks. */
export type NetworksBooleanFilter = {
  /** Equals comparison for boolean fields. */
  eq: Scalars['Boolean']['input'];
};

/** Filter networks by company support tiers. */
export type NetworksCompanySupportTierFilter = {
  /** Company support tiers to include. */
  in: Array<CompanySupportTier>;
  /** Invert the filter. */
  not?: Scalars['Boolean']['input'];
};

/** Filter networks by date-time fields. */
export type NetworksDateTimeFilter = {
  /** Greater than comparison. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Less than comparison. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input type for filtering networks based on various criteria. */
export type NetworksFilter = {
  /** Filter networks by whether they are active. */
  active?: InputMaybe<NetworksBooleanFilter>;
  /** Filter networks by company support tier. */
  companySupportTier?: InputMaybe<NetworksCompanySupportTierFilter>;
  /** Filter networks by company UUID. */
  companyUUIDs?: InputMaybe<NetworksUuiDsFilter>;
  /** Filter networks by hardware generation. */
  hardwareGeneration?: InputMaybe<NetworksHardwareGenerationFilter>;
  /** Filter networks by hardware model. */
  hardwareModel?: InputMaybe<NetworksHardwareModelFilter>;
  /** Filter networks by whether or not they are a Trial. */
  isTrial?: InputMaybe<NetworksBooleanFilter>;
  /** Filter networks by last upgrade date. */
  lastUpgradedAt?: InputMaybe<NetworksDateTimeFilter>;
  /** Filter networks by the square footage of their mailing address. */
  mailingAddressSquareFeet?: InputMaybe<NetworksIntFilter>;
  /** Filter networks by NOS upgrade channel. */
  nosUpgradeChannel?: InputMaybe<NetworksNosUpgradeChannelFilter>;
  /** Filter networks by NOS version ID. */
  nosVersionID?: InputMaybe<NetworksNosVersionIdFilter>;
  /** Filter networks by whether they have a pending upgrade. */
  pendingUpgrade?: InputMaybe<NetworksBooleanFilter>;
  /** Filter networks by the network that was soft-deleted and replaced by this network. */
  previousNetworkUUID?: InputMaybe<NetworksUuidFilter>;
  /** Filter networks by upgrade sensitivity. */
  upgradeSensitivity?: InputMaybe<NetworksBooleanFilter>;
};

/** Filter networks by hardware generation. */
export type NetworksHardwareGenerationFilter = {
  /** Hardware generations to include. */
  in: Array<HardwareGeneration>;
  /** Invert the filter */
  not?: Scalars['Boolean']['input'];
};

/** Filter networks by hardware models. */
export type NetworksHardwareModelFilter = {
  /** Hardware models to include. */
  in: Array<DeviceModel>;
  /** Invert the filter */
  not?: Scalars['Boolean']['input'];
};

/** Filter networks by integer fields. */
export type NetworksIntFilter = {
  /** Greater than comparison. */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** Less than comparison. */
  lt?: InputMaybe<Scalars['Int']['input']>;
};

/** Filter networks by NOS upgrade channel. */
export type NetworksNosUpgradeChannelFilter = {
  /** NOS upgrade channels to include. */
  in: Array<NetworkNosUpgradeChannel>;
  /** Invert the filter. */
  not?: Scalars['Boolean']['input'];
};

/** Filter networks by NOS version IDs. */
export type NetworksNosVersionIdFilter = {
  /** NOS version IDs to include. */
  in: Array<Scalars['Int']['input']>;
  /** Invert the filter. */
  not?: Scalars['Boolean']['input'];
};

/** Filter networks by UUID fields. */
export type NetworksUuidFilter = {
  /** Equals comparison for UUID fields. */
  eq: Scalars['UUID']['input'];
};

/** Filter networks by a list of UUIDs. */
export type NetworksUuiDsFilter = {
  /** UUIDs to include. */
  in: Array<Scalars['UUID']['input']>;
  /** Invert the filter. */
  not?: Scalars['Boolean']['input'];
};

/** A no wan activity active issue */
export type NoWanActivityActiveIssue = ActiveIssue & {
  __typename?: 'NoWANActivityActiveIssue';
  /** When the issue was first detected, if available */
  detectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The network that this issue is impacting */
  networkUUID: Scalars['UUID']['output'];
  /** When the issue was resolved, if available */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The severity of the issue */
  severity: ActiveIssueSeverity;
  /** The type of the issue */
  type: ActiveIssueType;
};

/** A NOS feature is a feature flag that tells us which NOS firmware versions support a given feature. */
export type NosFeature = Identifiable & {
  __typename?: 'NosFeature';
  /** Unique identifier of the NOS feature. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the NOS feature was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A detailed description of the NOS feature. */
  description: Scalars['String']['output'];
  /** If the feature is also behind a feature flag, this is the name of the feature flag. */
  featureFlag?: Maybe<Scalars['String']['output']>;
  /** A unique key that identifies the NOS feature. */
  key: Scalars['String']['output'];
  /** The display name of the NOS feature. */
  name: Scalars['String']['output'];
  /** The NOS versions which have this feature enabled. */
  nosVersions: Array<NosVersion>;
  /** Timestamp when the NOS feature was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Unique identifier of the NOS feature.
   * @deprecated Use `UUID` instead.
   */
  uuid: Scalars['UUID']['output'];
  /** The version ranges that define which NOS versions support this feature. */
  versionRanges: Array<NosFeatureVersionRange>;
};

/** Represents whether a NOS feature is enabled or disabled. */
export type NosFeatureEnabled = {
  __typename?: 'NosFeatureEnabled';
  /** Indicates whether the feature is enabled or disabled. */
  enabled: Scalars['Boolean']['output'];
  /** A unique key that identifies the NOS feature. */
  key: Scalars['String']['output'];
  /** A unique key that identifies the network. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
};

/** A version range that defines a minimum and optional maximum NOS version for a feature. */
export type NosFeatureVersionRange = Identifiable & {
  __typename?: 'NosFeatureVersionRange';
  /** Unique identifier of the version range. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the version range was created. */
  createdAt: Scalars['DateTime']['output'];
  /** If set, requires the device to be one of the listed generations. */
  deviceGenerations?: Maybe<Array<HardwareGeneration>>;
  /** If set, requires the device to be one of the listed models. */
  deviceModels?: Maybe<Array<DeviceModel>>;
  /** The maximum major version of NOS firmware for this range. If null, there is no upper major version limit. */
  maxMajorVersion?: Maybe<Scalars['Int']['output']>;
  /** The maximum minor version of NOS firmware for this range. If null, there is no upper minor version limit. */
  maxMinorVersion?: Maybe<Scalars['Int']['output']>;
  /** The maximum patch version of NOS firmware for this range. If null, there is no upper patch version limit. */
  maxPatchVersion?: Maybe<Scalars['Int']['output']>;
  /** The minimum major version of NOS firmware for this range. */
  minMajorVersion: Scalars['Int']['output'];
  /** The minimum minor version of NOS firmware for this range. */
  minMinorVersion: Scalars['Int']['output'];
  /** The minimum patch version of NOS firmware for this range. */
  minPatchVersion: Scalars['Int']['output'];
  /** Timestamp when the version range was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Unique identifier of the version range.
   * @deprecated Use `UUID` instead.
   */
  uuid: Scalars['UUID']['output'];
};

export type NosFeatureVersionRangeInput = {
  /** If set, requires the device to be one of the listed generations. */
  deviceGenerations?: InputMaybe<Array<HardwareGeneration>>;
  /** If set, requires the device to be one of the listed models. */
  deviceModels?: InputMaybe<Array<DeviceModel>>;
  /** The maximum major version of NOS firmware for this range. If null, there is no upper major version limit. */
  maxMajorVersion?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum minor version of NOS firmware for this range. If null, there is no upper minor version limit. */
  maxMinorVersion?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum patch version of NOS firmware for this range. If null, there is no upper patch version limit. */
  maxPatchVersion?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum major version of NOS firmware for this range. */
  minMajorVersion: Scalars['Int']['input'];
  /** The minimum minor version of NOS firmware for this range. */
  minMinorVersion: Scalars['Int']['input'];
  /** The minimum patch version of NOS firmware for this range. */
  minPatchVersion: Scalars['Int']['input'];
};

/**
 * Filters NOS features by case-insensitive substring match. Each field is matched
 * against its own column, and fields provided together are combined with AND.
 */
export type NosFeaturesFilterInput = {
  /** Match features whose description contains this substring. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Match features whose key contains this substring. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Match features whose name contains this substring. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A NOS (Network Operating System) version is a grouping of build strings for various device types. Together they constitute a network-wide firmware release. */
export type NosVersion = {
  __typename?: 'NosVersion';
  /** Stable UUID identifier for cross-realm sync. */
  UUID: Scalars['UUID']['output'];
  /** Build string for the 'a1' wireless device type. */
  a1Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'a2' wireless device type. */
  a2Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'a3' wireless device type. */
  a3Build?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the NOS version was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Build string for the 'f1' controller device type. */
  f1Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'f2' controller device type. */
  f2Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'f3' controller device type. */
  f3Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'g1' cellular gateway device type. */
  g1Build?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the NOS version. */
  id: Scalars['Int']['output'];
  /** Indicates if this NOS version is the default version for new networks. */
  isDefault: Scalars['Boolean']['output'];
  /** Indicates whether the NOS version is deprecated and should no longer be used. */
  isDeprecated: Scalars['Boolean']['output'];
  /** Indicates whether the NOS version is Generally Available (GA) for all users. */
  isGA: Scalars['Boolean']['output'];
  /** Indicates whether the NOS version is locked and cannot be modified or deleted. */
  isLocked: Scalars['Boolean']['output'];
  /** Public NOS versions have a subset of their metadata visible to all users. */
  isPublic: Scalars['Boolean']['output'];
  /** If false, checks for `isLocked` and other validation checks that underlying networks associated with the build are non-customer networks will be disabled. */
  isValidationEnabled: Scalars['Boolean']['output'];
  /** Major version number component of the NOS version. */
  major: Scalars['Int']['output'];
  /** Build string for the 'mc01' controller device type. */
  mc01Build?: Maybe<Scalars['String']['output']>;
  /** Minor version number component of the NOS version. */
  minor: Scalars['Int']['output'];
  /** Build string for the 'mp01' power distribution unit device type. */
  mp01Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'ms10' switch device type. */
  ms10Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'ms11' switch device type. */
  ms11Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'ms12' switch device type. */
  ms12Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'mw03' wireless device type. */
  mw03Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'mw04' wireless device type. */
  mw04Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'mw06' wireless device type. */
  mw06Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'mw07' wireless device type. */
  mw07Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'mw08' wireless device type. */
  mw08Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 'mw09' wireless device type. */
  mw09Build?: Maybe<Scalars['String']['output']>;
  /** Optional name for the NOS version, used for display purposes. */
  name?: Maybe<Scalars['String']['output']>;
  /** The networks which are pinned to this NOS version. */
  networks: Array<Network>;
  /** Build string for the 'observer' device type. */
  observerBuild?: Maybe<Scalars['String']['output']>;
  /** Patch version number component of the NOS version. */
  patch: Scalars['Int']['output'];
  /** Release notes or description associated with the NOS version. */
  releaseNotes?: Maybe<Scalars['String']['output']>;
  /** Build string for the 's1' switch device type. */
  s1Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 's2' switch device type. */
  s2Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 's3' switch device type. */
  s3Build?: Maybe<Scalars['String']['output']>;
  /** Build string for the 's4' switch device type. */
  s4Build?: Maybe<Scalars['String']['output']>;
  /** The status of the NOS version. */
  status?: Maybe<NosVersionStatus>;
  /** Timestamp when the NOS version was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** String representing the overall version of the NOS, typically in 'major.minor.patch' format. */
  version: Scalars['String']['output'];
  /** Human readable version number (<major>.<minor>.<patch>). */
  versionNumber: Scalars['String']['output'];
};

/** Input data for creating or updating a NOS version. */
export type NosVersionInput = {
  /** Build string for the 'a1' wireless device type. */
  a1Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'a2' wireless device type. */
  a2Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'a3' wireless device type. */
  a3Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'f1' controller device type. */
  f1Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'f2' controller device type. */
  f2Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'f3' controller device type. */
  f3Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'g1' cellular gateway device type. */
  g1Build?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if this NOS version should be set as the default version for new networks. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the NOS version is deprecated and should no longer be used. */
  isDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the NOS version is Generally Available (GA) for all users. */
  isGA?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the NOS version is locked and cannot be modified or deleted. */
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Public NOS versions have a subset of their metadata visible to all users. */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** If false, checks for `isLocked` and other validation checks that underlying networks associated with the build are non-customer networks will be disabled. This should only be disabled in exceptional cases. */
  isValidationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Major version number component of the NOS version. */
  major?: InputMaybe<Scalars['Int']['input']>;
  /** Build string for the 'mc01' controller device type. */
  mc01Build?: InputMaybe<Scalars['String']['input']>;
  /** Minor version number component of the NOS version. */
  minor?: InputMaybe<Scalars['Int']['input']>;
  /** Build string for the 'mp01' power distribution unit device type. */
  mp01Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'ms10' switch device type. */
  ms10Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'ms11' switch device type. */
  ms11Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'ms12' switch device type. */
  ms12Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'mw03' wireless device type. */
  mw03Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'mw04' wireless device type. */
  mw04Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'mw06' wireless device type. */
  mw06Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'mw07' wireless device type. */
  mw07Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'mw08' wireless device type. */
  mw08Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'mw09' wireless device type. */
  mw09Build?: InputMaybe<Scalars['String']['input']>;
  /** Optional name for the NOS version, used for display purposes. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 'observer' device type. */
  observerBuild?: InputMaybe<Scalars['String']['input']>;
  /** Patch version number component of the NOS version. */
  patch?: InputMaybe<Scalars['Int']['input']>;
  /** Release notes or description associated with the NOS version. */
  releaseNotes?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 's1' switch device type. */
  s1Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 's2' switch device type. */
  s2Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 's3' switch device type. */
  s3Build?: InputMaybe<Scalars['String']['input']>;
  /** Build string for the 's4' switch device type. */
  s4Build?: InputMaybe<Scalars['String']['input']>;
  /** The status of the NOS version. */
  status?: InputMaybe<NosVersionStatus>;
  /** String representing the overall version of the NOS, typically in 'major.minor.patch' format. */
  version: Scalars['String']['input'];
};

/** Represents the status of a NOS version. */
export enum NosVersionStatus {
  /** Status is alpha. */
  Alpha = 'ALPHA',
  /** Status is early production. */
  EarlyProduction = 'EARLY_PRODUCTION',
  /** Status is general availability. */
  GeneralAvailability = 'GENERAL_AVAILABILITY',
  /** Status is release candidate. */
  ReleaseCandidate = 'RELEASE_CANDIDATE'
}

/** Number filter implementation. */
export type NumberFilter = {
  /** The key for the filter. */
  key: Scalars['String']['input'];
  /** Number value for the filter. */
  value: Scalars['Float']['input'];
};

/** Number range filter implementation. */
export type NumberRangeFilter = {
  /** End of number range for the filter. */
  end?: InputMaybe<Scalars['Float']['input']>;
  /** The key for the filter. */
  key: Scalars['String']['input'];
  /** Start of number range for the filter. */
  start?: InputMaybe<Scalars['Float']['input']>;
};

/** A number range input type. */
export type NumberRangeInput = {
  /** The maximum value */
  max?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum value */
  min?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * An OUI (Organizationally Unique Identifier) is the first 3 bytes of a MAC address.
 * Each OUI belongs to a vendor registered with the IEEE.
 * The data is populated from the IEEE OUI database: https://standards-oui.ieee.org/
 */
export type OuIsForVendorResult = {
  __typename?: 'OUIsForVendorResult';
  /** The OUIs belonging to the vendor. */
  OUIs: Array<Scalars['String']['output']>;
  /** The vendor registered with the IEEE. */
  vendor: IeeeDeviceVendor;
};

/** Enumeration of possible connection status for the Observer. */
export enum ObserverConnectionStatus {
  /** Failed during 802.11 association. */
  FailAssoc = 'FAIL_ASSOC',
  /** Failed during authentication. */
  FailAuth = 'FAIL_AUTH',
  /** Failed because no matching BSSID was found during scan. */
  FailBssidNotFound = 'FAIL_BSSID_NOT_FOUND',
  /** Failed during DHCP. */
  FailDhcp = 'FAIL_DHCP',
  /** Failed for another reason (see failureReason field). */
  FailOther = 'FAIL_OTHER',
  /** Successful connection. */
  Success = 'SUCCESS',
  /** Unknown status. */
  Unspecified = 'UNSPECIFIED'
}

/** An ObserverTest is a configuration for an observer to run tests on a specific SSID. */
export type ObserverTest = {
  __typename?: 'ObserverTest';
  /** The unique identifier for the ObserverTest. */
  UUID: Scalars['UUID']['output'];
  /** The radio band on which the test will run. Null for VLAN-only (wired) tests. */
  band?: Maybe<RadioBand>;
  /** If not bound to all targets, this is the list of access points that the ObserverTest is bound to. */
  boundTargetVirtualDevices?: Maybe<Array<VirtualDevice>>;
  /** If true, requests broadcast responses for DHCP. */
  broadcastDHCP: Scalars['Boolean']['output'];
  /** List of commands to run during the test. These are sorted by commandType, then target, then uuid. */
  commands?: Maybe<Array<ObserverTestCommand>>;
  /** When the ObserverTest was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Duration of the test in milliseconds. */
  durationMs: Scalars['Int']['output'];
  /** If true, we will run every observer against every access point that it can reach. These bindings are kept up to date with an offline process. */
  isBoundToAllTargets: Scalars['Boolean']['output'];
  /** If the Observer is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** The human readable label for the test. */
  label: Scalars['String']['output'];
  /** The network for this test. */
  network: Network;
  /** The UUID of the network for this test. */
  networkUUID: Scalars['UUID']['output'];
  /** Number of times an Observer will re-try when there is a connection failure. If unset, uses firmware default (1 retry). */
  numConnectionRetries?: Maybe<Scalars['Int']['output']>;
  /** Number of spatial streams to use for the test. If unset, uses max number of spatial streams. */
  numSpatialStreams?: Maybe<Scalars['Int']['output']>;
  /** For enterprise SSIDs, this password is authed against the RADIUS server. */
  password8021X?: Maybe<Scalars['String']['output']>;
  /** The results of the ObserverTest, if it has been run. It is nil if the test has not been run yet. */
  results?: Maybe<ObserverTestResults>;
  /** If true, each observer is bound to only its single highest-SNR target, and non-best bindings are pruned. */
  selectOnlyBestTarget: Scalars['Boolean']['output'];
  /** The SNR threshold (in dB) used to select eligible target APs for observers. If unset, uses the default threshold. */
  snrThreshold?: Maybe<Scalars['Int']['output']>;
  /** The SSID for this test. Null for VLAN-only (wired) tests. */
  ssid?: Maybe<Ssid>;
  /** The targets that exist for this observer test. */
  targets: Array<ObserverTestTarget>;
  /** Transmit power to user for the test. If unset, uses the transmit power of the access point. */
  transmitPowerdBm?: Maybe<Scalars['Int']['output']>;
  /** When the ObserverTest was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** For enterprise SSIDs, this username is authed against the RADIUS server. */
  username8021X?: Maybe<Scalars['String']['output']>;
  /** The VLAN for this test. Null for wireless (SSID-based) tests. */
  vlan?: Maybe<Vlan>;
};


/** An ObserverTest is a configuration for an observer to run tests on a specific SSID. */
export type ObserverTestResultsArgs = {
  filters?: InputMaybe<ObserverTestResultsFilter>;
};

/** An ObserverTestBinding is a binding for an ObserverTest. It maintains the relationship between an ObserverTest, an ObserverVirtualDevice, and a TargetVirtualDevice. */
export type ObserverTestBinding = Identifiable & {
  __typename?: 'ObserverTestBinding';
  /** The unique identifier for the ObserverTestBinding. */
  UUID: Scalars['UUID']['output'];
  /** The observer that this binding is for. */
  observerVirtualDevice: VirtualDevice;
  /** The results of the ObserverTest, aggregated by this target / observer pair. It is nil if the test has not been run yet. */
  results?: Maybe<ObserverTestResults>;
  /** The target that this binding is for. */
  targetVirtualDevice: VirtualDevice;
};


/** An ObserverTestBinding is a binding for an ObserverTest. It maintains the relationship between an ObserverTest, an ObserverVirtualDevice, and a TargetVirtualDevice. */
export type ObserverTestBindingResultsArgs = {
  filters?: InputMaybe<ObserverTestResultsFilter>;
};

/** A command to be executed by the Observer during the test. */
export type ObserverTestCommand = {
  __typename?: 'ObserverTestCommand';
  /** The unique identifier for the ObserverTestCommand. */
  UUID: Scalars['UUID']['output'];
  /** The type of command to run (e.g., PING, DOWNLOAD). */
  commandType: ObserverTestCommandType;
  /** Interval between command executions in milliseconds. */
  intervalMs: Scalars['Int']['output'];
  /** An optional label for the test command endpoint. */
  label: Scalars['String']['output'];
  /** The target of the command, such as an IP address or hostname. */
  target: Scalars['String']['output'];
  /** The type of target (IPv4, IPv6, or hostname). */
  targetType: ObserverTestCommandTargetType;
  /** Timeout for the command execution in milliseconds. */
  timeoutMs: Scalars['Int']['output'];
};

/** Input type for defining an Observer command. */
export type ObserverTestCommandInput = {
  /** The unique identifier for the ObserverTestCommand. If set, this command will update the existing command with this UUID. If not set, a new command will be created. */
  UUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The type of command to run. */
  commandType: ObserverTestCommandType;
  /** Interval between command executions in milliseconds. */
  intervalMs: Scalars['Int']['input'];
  /** An optional label for the test command endpoint. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The target of the command. */
  target: Scalars['String']['input'];
  /** The type of target for the command. */
  targetType: ObserverTestCommandTargetType;
  /** Timeout for the command execution in milliseconds. */
  timeoutMs: Scalars['Int']['input'];
};

/** An ObserverTestCommandSummary gives you the aggregate results for a specific command within an ObserverTest. */
export type ObserverTestCommandSummary = {
  __typename?: 'ObserverTestCommandSummary';
  /** The command that this summary is for. */
  command: ObserverTestCommand;
  /** The aggregate number of commands run for the ObserverTest. */
  numAttempts: Scalars['Int']['output'];
  /** For DNS commands, the aggregate number of DNS responses that returned no IP address across all runs. */
  numResponsesNoIP: Scalars['Int']['output'];
  /** The aggregate number of successful commands for the ObserverTest. */
  numSuccess: Scalars['Int']['output'];
  /** The computed success rate of commands for the ObserverTest, as a percentage. */
  successRate: Scalars['Float']['output'];
  /** The total latency of the command across all successful runs, in milliseconds. */
  totalLatencyMs: Scalars['Int']['output'];
};

/** Enumeration of possible target types for the Observer command. */
export enum ObserverTestCommandTargetType {
  /** Hostname target type. */
  Hostname = 'HOSTNAME',
  /** IPv4 address target type. */
  Ipv4 = 'IPV4',
  /** IPv6 address target type. */
  Ipv6 = 'IPV6'
}

/** Enumeration of possible command types for the Observer. */
export enum ObserverTestCommandType {
  /** DNS command type. */
  Dns = 'DNS',
  /** Download command type. */
  Download = 'DOWNLOAD',
  /** Iperf command type. */
  Iperf = 'IPERF',
  /** Ping command type. */
  Ping = 'PING',
  /** Speedtest command type. */
  Speedtest = 'SPEEDTEST',
  /** Traceroute command type. */
  Traceroute = 'TRACEROUTE'
}

/** An ObserverTestResult contains the history (log) and summary (aggregates) of an ObserverTest. */
export type ObserverTestResults = {
  __typename?: 'ObserverTestResults';
  /** The historical summaries of the ObserverTest; needs `stepSeconds` to be set in ObserverTestResultsFilter. */
  historicalSummaries?: Maybe<Array<ObserverTestRunSummary>>;
  /** The log of runs for the ObserverTest. */
  history: Array<ObserverTestRun>;
  /** The summary of the ObserverTest, including aggregates of runs and commands. */
  summary: ObserverTestRunSummary;
};

/** The ObserverTestResultsFilter allows you to optionally filter results/summaries for an ObserverTest. */
export type ObserverTestResultsFilter = {
  /** The lookback time to consider results for, starting at `endTime`. Maximum allowed value is 7776000, 90 days. */
  durationSeconds: Scalars['Int']['input'];
  /** The latest observation time to consider results for, inclusive. Defaults to the current time if not set. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The observer to get results for. If unset, results for all observers will be returned. */
  observerVirtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * By default, `history` returns only the runs from the best observer (highest connection success rate)
   * for each target, matching the observer the summary is computed from. Set to true to return the runs
   * from all observers instead.
   */
  showAllObservers?: InputMaybe<Scalars['Boolean']['input']>;
  /** A time step to populate historical summaries, in seconds */
  stepSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The target virtual device to get results for. If unset, results for all targets will be returned. */
  targetVirtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** An ObserverTestRun represents a single execution of an ObserverTest, including the commands that were executed and their results. */
export type ObserverTestRun = {
  __typename?: 'ObserverTestRun';
  /** The commands that were executed during this test run. */
  commandResults: Array<ObserverTestCommandSummary>;
  /** The connection status (with failure reason in case of failure) */
  connectionStatus: ObserverConnectionStatus;
  /**
   * Whether the observer successfully connected to the target for the test run.
   * TODO deprecate when connectionStatus is used
   */
  connectionSuccess: Scalars['Boolean']['output'];
  /** A more detailed failure reason. */
  detailedFailureReason: Scalars['String']['output'];
  /** The observer virtual device that ran this test. */
  observerVirtualDevice: VirtualDevice;
  /** The target virtual device that this test was run against. */
  targetVirtualDevice: VirtualDevice;
  /** The timestamp of when the test was run. */
  timestamp: Scalars['DateTime']['output'];
};

/** An ObserverTestRunSummary object contains the aggregates of runs and commands for an ObserverTest. */
export type ObserverTestRunSummary = {
  __typename?: 'ObserverTestRunSummary';
  /** The aggregate results for each command. */
  commandSummaries: Array<ObserverTestCommandSummary>;
  /** The computed success rate of connections for the ObserverTest, as a percentage. */
  connectionSuccessRate: Scalars['Float']['output'];
  /** The duration for which this summary was computed, in seconds */
  durationSeconds: Scalars['Int']['output'];
  /** The end time of the summary */
  endTime: Scalars['DateTime']['output'];
  /** The aggregate number of attempted connections for the ObserverTest. */
  numConnectionAttempts: Scalars['Int']['output'];
  /** The aggregate number of successful connections for the ObserverTest. */
  numConnectionSuccess: Scalars['Int']['output'];
};

/** An ObserverTestTarget is an access point that is targeted by atleast one observer for this ObserverTest. */
export type ObserverTestTarget = {
  __typename?: 'ObserverTestTarget';
  /** A stable identifier for this target, derived from its ObserverTest and target device. */
  UUID: Scalars['UUID']['output'];
  /** The bindings that exist for this test and target. */
  bindings: Array<ObserverTestBinding>;
  /** The results of the ObserverTest, aggregated by this target. It is nil if the test has not been run yet. */
  results?: Maybe<ObserverTestResults>;
  /** The access point that this target represents. */
  virtualDevice: VirtualDevice;
};


/** An ObserverTestTarget is an access point that is targeted by atleast one observer for this ObserverTest. */
export type ObserverTestTargetResultsArgs = {
  filters?: InputMaybe<ObserverTestResultsFilter>;
};

/** An observer virtual device is a logical representation of a physical observer. */
export type ObserverVirtualDevice = Identifiable & TargetInterface & VirtualDevice & {
  __typename?: 'ObserverVirtualDevice';
  /** The unique identifier (UUID) of the virtual device. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the virtual device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** An optional description for the virtual device. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Metadata for the configurations rendered for this virtual device over time, newest
   * first. Includes configs written to hardware devices that have since been dissociated
   * from this virtual device. Omits the rendered config JSON for performance.
   */
  deviceConfigs: Array<DeviceConfigMetadata>;
  /** The model name of the virtual device. */
  deviceModel: DeviceModel;
  /** The type of the virtual device. */
  deviceType: VirtualDeviceType;
  /** The hardware device associated with this virtual device, if any. */
  hardwareDevice?: Maybe<HardwareDevice>;
  /** Metadata for the model of this device. */
  hardwareModelProperties: HardwareModelProperties;
  /** The management IP address of the device. */
  ipAddress?: Maybe<Scalars['IP']['output']>;
  /** Indicates whether the virtual device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether debug logging is enabled on the virtual device. */
  isDebugLogEnabled: Scalars['Boolean']['output'];
  /** Whether this virtual device is in a draft state for preconfiguration reasons. */
  isDraft: Scalars['Boolean']['output'];
  /** Indicates whether LED dark mode is enabled on the observer, which turns off all LED activity. */
  isLEDDarkModeEnabled: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is online, indicated by its heartbeat. */
  isOnline: Scalars['Boolean']['output'];
  /** A human-friendly name for the device. */
  label: Scalars['String']['output'];
  /** The physical location of this virtual device, derived from its rack elevation placement. */
  location?: Maybe<VirtualDeviceLocation>;
  /** The most recent NOS upgrade for this virtual device that has started executing or was skipped (in progress, completed, failed, or skipped), if any. */
  mostRecentNOSUpgrade?: Maybe<ScheduledDeviceNosUpgrade>;
  /** The network that the virtual device belongs to. */
  network: Network;
  /** The unique identifier (UUID) of the network the virtual device belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The group that the device belongs to for firmware upgrade grouping purposes. */
  nosUpgradeGroup: NosUpgradeGroup;
  /** The current NOS firmware version that the virtual device is configured to run. */
  nosVersion?: Maybe<ConfiguredNosVersion>;
  /** The identifier of the NOS firmware version that the virtual device is configured to run. */
  nosVersionID: Scalars['Int']['output'];
  /** The observer's active or future notification snoozes */
  notificationSnoozes: Array<DeviceNotificationSnooze>;
  /** ObserverTests returns all observer tests configured for this observer. */
  observerTests?: Maybe<Array<ObserverTest>>;
  /** The paired virtual device to this device, applicable to dual-chassis configurations. */
  pairedVirtualDevice?: Maybe<ObserverVirtualDevice>;
  /** The NOS firmware version that the virtual device is scheduled to upgrade to. */
  pendingNosVersion?: Maybe<PendingNosVersion>;
  /** URL to the regulatory e-label for the device, if applicable. */
  regulatoryLabelURL?: Maybe<Scalars['String']['output']>;
  /** The virtual device tags on this device. */
  tags: Array<VirtualDeviceTag>;
  /** Data about this virtual device's position in its network's topology. */
  topologyData?: Maybe<VirtualDeviceTopologyData>;
  /** The timestamp when the virtual device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /** How long the device has been continuously powered on and reporting. */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** The position of this virtual device within its device pair (left or right). Null if not part of a pair. */
  virtualDevicePairPosition?: Maybe<DevicePosition>;
};


/** An observer virtual device is a logical representation of a physical observer. */
export type ObserverVirtualDeviceDeviceConfigsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};

/** Input for updating the hidden state of a single onboarding-document hidden field. */
export type OnboardingDocumentHiddenFieldUpdateInput = {
  /** Name of the field whose hidden state is being set. */
  fieldName: Scalars['String']['input'];
  /** Whether the field should be hidden (true) or visible (false). */
  isHidden: Scalars['Boolean']['input'];
};

/** 1:1 NAT Rules are used to map a single external IP address to a single internal IP address. */
export type OneToOneNatRule = Identifiable & {
  __typename?: 'OneToOneNATRule';
  /** Unique identifier of the 1:1 NAT rule. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the NAT rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Optional description of the 1:1 NAT rule. */
  description?: Maybe<Scalars['String']['output']>;
  /** The external IP address that is mapped by the NAT rule. */
  externalIPAddr: Scalars['IPV4']['output'];
  /** Physical interface associated with the external IP address. */
  externalPhyInterface: PhyInterface;
  /** UUID of the physical interface associated with the external IP address. */
  externalPhyInterfaceUUID: Scalars['UUID']['output'];
  /** The internal IP address that the external IP address is mapped to. */
  internalIPAddr: Scalars['IPV4']['output'];
  /** Automatically disables this 1:1 NAT rule when the associated physical interface is inactive. */
  isDisabledWhenUplinkInactive: Scalars['Boolean']['output'];
  /** Indicates whether the NAT rule is currently enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Name of the 1:1 NAT rule. */
  name: Scalars['String']['output'];
  /** The network this NAT rule applies to. */
  network: Network;
  /** UUID of the network that this NAT rule applies to. */
  networkUUID: Scalars['UUID']['output'];
  /** Timestamp when the NAT rule was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Filter input for Opportunity fields. */
export type OpportunitiesFilterInput = {
  /** Whether Connect is included on the Opportunity. */
  connectIncluded?: InputMaybe<Array<OpportunityConnectIncluded>>;
  /** Has QuoteRequests with accepted quotes or has non-complete QuoteRequests with selections missing acceptance. */
  hasAcceptedQuoteRequests?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has QuoteRequests with a completed order or has non-complete QuoteRequests with orders needing to be completed. */
  hasOrderedQuoteRequests?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has QuoteRequests with selected quotes or has non-complete QuoteRequests missing selections. */
  hasSelectedQuoteRequests?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is not closed and has non-complete, non-canceled QuoteRequests with selected quotes missing upload speed, or missing monthly wholesale cost on wholesale QuoteRequests. */
  needsQuoteData?: InputMaybe<Scalars['Boolean']['input']>;
  /** Opportunities with these states. */
  opportunityStatuses?: InputMaybe<Array<OpportunityState>>;
  /** Having QuoteRequests with these states. */
  quoteRequestStatuses?: InputMaybe<Array<QuoteRequestState>>;
  /** Input for non-exact search against ISP fields. */
  search?: InputMaybe<OpportunitySearchInput>;
  /** Stages of the Opportunity. */
  stages?: InputMaybe<Array<OpportunityStage>>;
  /** Users responsible for serviceability checking locations of the Opportunity. */
  supportUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Page of Opportunities. */
export type OpportunitiesPage = {
  __typename?: 'OpportunitiesPage';
  /** The results for this page. */
  items: Array<Opportunity>;
  /** The total number of results available based on the provided filters. */
  total: Scalars['Int']['output'];
};

/** A sales Opportunity. */
export type Opportunity = {
  __typename?: 'Opportunity';
  /** Unique identifier for the Opportunity. */
  UUID: Scalars['UUID']['output'];
  /** Close date of the Opportunity. */
  closeDate?: Maybe<Scalars['DateTime']['output']>;
  /** Company associated with the Opportunity. */
  company?: Maybe<Company>;
  /** UUID of the company associated with the Opportunity. */
  companyUUID?: Maybe<Scalars['UUID']['output']>;
  /** Whether Connect is included on the Opportunity. */
  connectIncluded?: Maybe<OpportunityConnectIncluded>;
  /** Created date of the Opportunity. */
  createdDate: Scalars['DateTime']['output'];
  /** Current state of the Opportunity. */
  currentState: OpportunityStateLogEntry;
  /** Description of the Opportunity. */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether or not the locations of an Opportunity have existing ISPs.  Signals the customer won't likely be needing circuits. */
  existingISP?: Maybe<Scalars['Boolean']['output']>;
  /** SFDC id of Opportunity object. */
  externalID: Scalars['String']['output'];
  /** Freeform notes that may contain information from customer regarding bandwidth requirements or ISP preferences for related locations. */
  ispDetails?: Maybe<Scalars['String']['output']>;
  /** Name of the Opportunity. */
  name: Scalars['String']['output'];
  /** Email of the owner of the Opportunity. */
  ownerEmail?: Maybe<Scalars['String']['output']>;
  /** Name of the owner of the Opportunity. */
  ownerName?: Maybe<Scalars['String']['output']>;
  /** Prospective company name. Company may not yet be created for Opportunity. */
  prospectiveCompanyName?: Maybe<Scalars['String']['output']>;
  /**
   * QuoteRequests associated with the locations on the Opportunity.
   * @deprecated Use `quoteRequestsPage` for a filtered/paginated list, or `quoteRequestsSummary` for aggregate progress counts.
   */
  quoteRequests?: Maybe<Array<QuoteRequest>>;
  /** Paginated, filterable QuoteRequests associated with the locations on the Opportunity. */
  quoteRequestsPage: QuoteRequestPage;
  /** Aggregate progress counts across all QuoteRequests on the Opportunity. */
  quoteRequestsSummary: OpportunityQuoteRequestSummary;
  /** Slack channel ID associated with the Opportunity. */
  slackChannelID?: Maybe<Scalars['String']['output']>;
  /** Slack message timestamp associated with the Opportunity. */
  slackMessageTS?: Maybe<Scalars['String']['output']>;
  /** Link to slack thread where this Opportunity is discussed. */
  slackThreadLink?: Maybe<Scalars['String']['output']>;
  /** Current stage of the Opportunity. */
  stage: OpportunityStage;
  /** User handling fulfillment/support. */
  supportUsers?: Maybe<Array<OpportunitySupportUser>>;
  /** Type of the Opportunity. */
  type?: Maybe<OpportunityType>;
};


/** A sales Opportunity. */
export type OpportunityQuoteRequestsPageArgs = {
  filter?: InputMaybe<QuoteRequestFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  options?: InputMaybe<QuoteRequestOptionsInput>;
};

/** Whether Connect is included on the Opportunity. */
export enum OpportunityConnectIncluded {
  /** Connect is not included. */
  No = 'NO',
  /** Not yet determined whether Connect is included. */
  Tbd = 'TBD',
  /** Connect is included. */
  Yes = 'YES'
}

/** Progress counts for the QuoteRequests on an Opportunity. */
export type OpportunityQuoteRequestSummary = {
  __typename?: 'OpportunityQuoteRequestSummary';
  /** Quotes that have been sales-accepted or further along (contract requested/available/complete). */
  acceptedQuotesCount: Scalars['Int']['output'];
  /** QuoteRequests whose most recent serviceability-check-complete state was set automatically rather than by a human. */
  autoServiceabilityCompleteQuoteRequests: Scalars['Int']['output'];
  /** Quotes that are complete. */
  completeQuotesCount: Scalars['Int']['output'];
  /** Quotes that are contracted: contract available or complete. */
  contractedQuotesTotal: Scalars['Int']['output'];
  /** Selected quotes on non-complete, non-canceled QuoteRequests missing upload speed, or missing monthly wholesale cost on wholesale QuoteRequests. */
  needsQuoteDataCount: Scalars['Int']['output'];
  /** Quotes that are ordering: contract requested, contract available, or complete. */
  orderingQuotesTotal: Scalars['Int']['output'];
  /** Total quotes with a selection made. */
  selectedQuotesTotal: Scalars['Int']['output'];
  /** QuoteRequests that have a selection made, or are closed (complete/canceled). */
  selectionsCount: Scalars['Int']['output'];
  /** QuoteRequests that have completed serviceability checking. */
  serviceabilityCompleteQuoteRequests: Scalars['Int']['output'];
  /** QuoteRequests with full serviceability coverage: a recommendable DIA provider and a recommendable Broadband provider that is a different carrier. */
  serviceabilityCoverageFullCount: Scalars['Int']['output'];
  /** QuoteRequests with partial serviceability coverage: at least one recommendable DIA or Broadband provider, but not full coverage. Mutually exclusive with serviceabilityCoverageFullCount. */
  serviceabilityCoveragePartialCount: Scalars['Int']['output'];
  /** Total number of QuoteRequests on the Opportunity. */
  totalQuoteRequests: Scalars['Int']['output'];
};

/** Input for non-exact search against Opportunity fields. Filters are AND'd together. */
export type OpportunitySearchInput = {
  /** Company name associated with Opportunity. */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Location associated with the Opportunity. */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Name of the Opportunity. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Opportunity owner email. */
  ownerEmail?: InputMaybe<Scalars['String']['input']>;
  /** Opportunity owner name. */
  ownerName?: InputMaybe<Scalars['String']['input']>;
};

/** Stage of the Opportunity. */
export enum OpportunityStage {
  /** Prospect has churned. */
  Churn = 'CHURN',
  /** Opportunity is closed + lost */
  ClosedLost = 'CLOSED_LOST',
  /** Opportunity is closed and won. */
  ClosedWon = 'CLOSED_WON',
  /** Opportunity is in final review phase. */
  ClosingReview = 'CLOSING_REVIEW',
  /** Opportunity is contracting phase. */
  Contracting = 'CONTRACTING',
  /** Opportunity has a contract requested. */
  ContractRequested = 'CONTRACT_REQUESTED',
  /** Opportunity is in discovery phase. */
  Discovery = 'DISCOVERY',
  /** Opportunity is in disqualified. */
  Disqualified = 'DISQUALIFIED',
  /** Opportunity is in contract negotiations. */
  NegotiatingContract = 'NEGOTIATING_CONTRACT',
  /** Opportunity is in negotiating quotes phase. */
  NegotiatingQuotes = 'NEGOTIATING_QUOTES',
  /** Opportunity is in terms negotiations. */
  NegotiatingTerms = 'NEGOTIATING_TERMS',
  /** Opportunity has been qualified. */
  QualifiedOpportunity = 'QUALIFIED_OPPORTUNITY',
  /** Opportunity has quotes requested. */
  QuotesRequested = 'QUOTES_REQUESTED',
  /** Opportunity is undergoing technical validation. */
  TechnicalValidation = 'TECHNICAL_VALIDATION'
}

/** State of the Opportunity. */
export enum OpportunityState {
  /** Opportunity is closed. */
  Closed = 'CLOSED',
  /** Opportunity is in progress. */
  InProgress = 'IN_PROGRESS',
  /** A new Opportunity has been started. */
  New = 'NEW',
  /** Serviceability checking has completed for the Opportunity. */
  ServiceabilityCheckComplete = 'SERVICEABILITY_CHECK_COMPLETE'
}

/** Opportunity state and meta data. */
export type OpportunityStateLogEntry = {
  __typename?: 'OpportunityStateLogEntry';
  /** Time of when the state was entered. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** UUID of associated Opportunity. */
  opportunityUUID: Scalars['UUID']['output'];
  /** State of the Opportunity. */
  state: OpportunityState;
};

/** Internal user responsible for fulfillment/support of an Opportunity. */
export type OpportunitySupportUser = {
  __typename?: 'OpportunitySupportUser';
  /** All support roles for this user. */
  supportRoles: Array<SupportUser>;
  /** Describes the type of role the user is fulfilling for Opportunity. */
  type: OpportunitySupportUserType;
  /** Associated user. */
  user: User;
};

/** Input type for users associated with a Opportunity. */
export type OpportunitySupportUserInput = {
  /** Describes the type of role the user is fulfilling for the Opportunity. */
  type: OpportunitySupportUserType;
  /** ID of the user to associate. */
  userID: Scalars['ID']['input'];
};

/** Type of role the user is fulfilling for the Opportunity. */
export enum OpportunitySupportUserType {
  /** Primary support person, typically a program manager. */
  Primary = 'PRIMARY',
  /** Secondary support person, typically an ops associate. */
  Secondary = 'SECONDARY'
}

/** Type of the Opportunity. */
export enum OpportunityType {
  /** Existing business opportunity. */
  ExistingBusiness = 'EXISTING_BUSINESS',
  /** New business opportunity. */
  NewBusiness = 'NEW_BUSINESS',
  /** Pre-install opportunity. */
  PreInstall = 'PRE_INSTALL'
}

/** An optional task that can be cancelled without preventing its deliverable from being completed. */
export type OptionalTask = {
  __typename?: 'OptionalTask';
  /** Suggested initial state of the skip input field. */
  defaultSkipped: Scalars['Boolean']['output'];
  /** Prompt to show alongside the skip toggle, e.g. "Skip peer review?". */
  prompt: Scalars['String']['output'];
  /** The optional task being offered for skipping. */
  task: DeploymentTask;
};

/** Direction to sort results in. */
export enum OrderByDirection {
  /** Sort in ascending order. */
  Asc = 'ASC',
  /** Sort in descending order. */
  Desc = 'DESC'
}

/** Specifies settings for a power outlet on a Power Distribution Unit (PDU). */
export type OutletInterface = Identifiable & {
  __typename?: 'OutletInterface';
  /** Globally unique identifier for the outlet interface. */
  UUID: Scalars['UUID']['output'];
  /** The virtual device connected to the power outlet. */
  connectedVirtualDevice?: Maybe<VirtualDevice>;
  /** UUID of the virtual device connected to the power outlet. */
  connectedVirtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
  /** Timestamp when the outlet interface was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The current being drawn from the outlet in Amperes. Null when the reading failed. */
  currentAmps?: Maybe<Scalars['Float']['output']>;
  /** Description of the outlet interface. */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether or not the interface is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** User-defined label for the outlet interface. */
  label?: Maybe<Scalars['String']['output']>;
  /** Number identifying the outlet on the PDU. */
  outletNumber: Scalars['Int']['output'];
  /** Whether over-current protection is armed for the outlet. Null when unknown. */
  overcurrentProtectionEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Number of seconds to wait when performing a power cycle.
   * The outlet turns off, waits for this duration, and then turns back on.
   */
  powerCycleDelaySec: Scalars['Int']['output'];
  /**
   * A schedule for the power outlet. The intervals cover when the outlet
   * is turned on.
   */
  powerSchedule?: Maybe<Array<ScheduleInterval>>;
  /** The power being drawn from the outlet in Watts. Null when that reading failed. */
  powerWatts?: Maybe<Scalars['Float']['output']>;
  /**
   * Current condition of the outlet, read back from the PDU's meter rather
   * than taken from configuration. Null when the PDU has not reported it.
   */
  state?: Maybe<PduOutletState>;
  /** Timestamp when the outlet interface was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Timestamp when the outlet interface was validated to ensure that the connectedVirtualDevice is correctly assigned. */
  validatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who validated the outlet interface. */
  validatedBy?: Maybe<User>;
  /** The virtual device associated with this outlet interface. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** UUID of the virtual device associated with this outlet interface. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** Response type containing PDU timeseries data over a specified time range. */
export type PduMetricsTimeseriesResponse = {
  __typename?: 'PDUMetricsTimeseriesResponse';
  /** Outlets metrics data from the PDU. */
  outlets: Array<PduOutletMetricsTimeseriesResponse>;
  /** Temperature readings from the PDU in Celsius. */
  temperatureCelsius: BaseMetricsResponse;
  /** The PDU virtual device. */
  virtualDevice: PowerDistributionUnitVirtualDevice;
  /** The unique identifier for the PDU virtual device. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** Response type containing PDU outlet timeseries data over a specified time range. */
export type PduOutletMetricsTimeseriesResponse = {
  __typename?: 'PDUOutletMetricsTimeseriesResponse';
  /** Average current in amps. */
  currentAmps: BaseMetricsResponse;
  /** Average frequency in hertz. */
  frequencyHz: BaseMetricsResponse;
  /** The outlet interface for this series. */
  outlet: OutletInterface;
  /** Average power consumption in watts. */
  powerWatts: BaseMetricsResponse;
  /** Average voltage in volts. */
  voltageVolts: BaseMetricsResponse;
};

/** Properties for PDU outlet events. */
export type PduOutletProperties = {
  __typename?: 'PDUOutletProperties';
  /** Whether the outlet is enabled. */
  outletEnabled: Scalars['Boolean']['output'];
  /** The outlet number of the PDU outlet. */
  outletNum: Scalars['Int']['output'];
  /** The virtual device associated with the PDU outlet. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** Condition of a PDU outlet, read back from the PDU's meter. */
export enum PduOutletState {
  /** The outlet is off by configuration or command. */
  Off = 'OFF',
  /** The outlet is on. */
  On = 'ON',
  /** A protection tripped for a cause the PDU does not report. */
  TrippedOther = 'TRIPPED_OTHER',
  /** Over-current protection tripped: current stayed above the outlet's limit for longer than its trip delay. */
  TrippedOvercurrent = 'TRIPPED_OVERCURRENT',
  /** Short-circuit protection tripped: current went above the instantaneous limit. */
  TrippedShortCircuit = 'TRIPPED_SHORT_CIRCUIT',
  /** Voltage protection tripped: the supply voltage left the PDU's configured range. */
  TrippedVoltageOutOfRange = 'TRIPPED_VOLTAGE_OUT_OF_RANGE',
  /** The PDU could not read the outlet's state. */
  Unknown = 'UNKNOWN'
}

/** A PDU switch cycle active issue. Networks with only one PDU are not checked. */
export type PduSwitchCycleActiveIssue = ActiveIssue & {
  __typename?: 'PDUSwitchCycleActiveIssue';
  /** When the issue was first detected, if available */
  detectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The network that this issue is impacting */
  networkUUID: Scalars['UUID']['output'];
  /** When the issue was resolved, if available */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The severity of the issue */
  severity: ActiveIssueSeverity;
  /** The type of the issue */
  type: ActiveIssueType;
  /** The virtual device that this issue is impacting */
  virtualDevice: PowerDistributionUnitVirtualDevice;
};

/**
 * An envelope grouping a set of packet captures that were started together.
 * It holds the shared configuration (size and time limits) that applies to every
 * capture in the group.
 */
export type PacketCaptureGroup = {
  __typename?: 'PacketCaptureGroup';
  /** The unique identifier for the group. */
  UUID: Scalars['UUID']['output'];
  /** The time at which the group was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The serial numbers of devices that were asked to capture but failed to start. Empty when every capture started. */
  failedSerialNumbers: Array<Scalars['String']['output']>;
  /** The shared pcap-filter(7)/tcpdump filter applied to every capture in the group, if any. Switch captures do not support filtering. */
  filter?: Maybe<Scalars['String']['output']>;
  /** An optional label for the packet capture group. */
  label?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the network associated with this group. */
  networkUUID: Scalars['UUID']['output'];
  /** Whether the requesting user is emailed once every capture in the group is ready to download. */
  notifyOnCompletion: Scalars['Boolean']['output'];
  /** The packet captures started under this group. */
  packetCaptures: Array<PacketCaptureJob>;
  /** The maximum size limit applied to every capture in the group, in megabytes. */
  sizeLimitMb: Scalars['Int']['output'];
  /** The maximum duration applied to every capture in the group, in seconds. */
  timeLimitSeconds: Scalars['Int']['output'];
};

/** Represents a packet capture job. */
export type PacketCaptureJob = {
  /** The unique identifier for the job. */
  UUID: Scalars['UUID']['output'];
  /** The time at which the job was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Whether the capture's file is currently available to download from storage. */
  downloadAvailable: Scalars['Boolean']['output'];
  /** The unique identifier of the network associated with this job. */
  networkUUID: Scalars['UUID']['output'];
  /** The maximum size limit of the packet capture file in megabytes. */
  sizeLimitMb: Scalars['Int']['output'];
  /** Whether the job was stopped prematurely or not. */
  stopped: Scalars['Boolean']['output'];
  /** The maximum duration of the packet capture in seconds. */
  timeLimitSeconds: Scalars['Int']['output'];
  /**
   * The unique identifier for the job.
   * @deprecated Use `UUID` instead.
   */
  uuid: Scalars['UUID']['output'];
  /** The virtual device that the packet capture is run on. */
  virtualDevice: VirtualDevice;
  /** The UUID of the virtual device that the packet capture is run on. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** Pagination input shared across all paginated queries. */
export type PageInput = {
  /** Time pagination began */
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  /** Max items to return (server may cap). */
  limit: Scalars['Int']['input'];
  /** Page to jump to. */
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Specifies the NOS firmware version that a device is scheduled to upgrade to. */
export type PendingNosVersion = {
  __typename?: 'PendingNosVersion';
  /** Unique identifier for this scheduled NOS upgrade. */
  UUID: Scalars['UUID']['output'];
  /** The NOS firmware version that the device is scheduled to upgrade to. */
  nosVersion: NosVersion;
  /** The timestamp when the device is scheduled to upgrade to the specified NOS version. */
  scheduledAt: Scalars['DateTime']['output'];
};

/** An enumeration of v1 permissions (not RBAC) that can be assigned to tokens. */
export enum Permission {
  Admin = 'ADMIN',
  Api = 'API',
  Ci = 'CI',
  Cmd = 'CMD',
  Connect = 'CONNECT',
  ConnectAdmin = 'CONNECT_ADMIN',
  Controller = 'CONTROLLER',
  Crossrealm = 'CROSSREALM',
  Dashboard = 'DASHBOARD',
  InventoryApp = 'INVENTORY_APP',
  Jumphost = 'JUMPHOST',
  Logs = 'LOGS',
  Noc = 'NOC',
  Ops = 'OPS',
  Portal = 'PORTAL',
  ProvisionController = 'PROVISION_CONTROLLER',
  Radius = 'RADIUS',
  Rpcbroker = 'RPCBROKER',
  Stats = 'STATS',
  StatConsumer = 'STAT_CONSUMER',
  StatUpload = 'STAT_UPLOAD',
  SupportTooling = 'SUPPORT_TOOLING',
  Worker = 'WORKER'
}

/**
 * A PermissionAssignment denotes the permissions of a user in the context of a company or company & network.
 *
 * In the case of an Operator role, the networkUUID field will be null.
 */
export type PermissionAssignment = {
  __typename?: 'PermissionAssignment';
  /**
   * The UUID of the network associated with these permissions.
   *
   * Null if the permissions are not network-specific or are company-wide.
   */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /**
   * The list of permissions assigned to the user in this context.
   *
   * PermissionType represents the specific permissions granted.
   */
  permissions: Array<PermissionType>;
};

/** Result type indicating whether the user has the specified permission. */
export type PermissionCheckResult = {
  __typename?: 'PermissionCheckResult';
  /** True if the user has the specified permission, false otherwise. */
  hasPermission: Scalars['Boolean']['output'];
};

/** A named grouping of related permissions for display and organization purposes. */
export type PermissionGroup = {
  __typename?: 'PermissionGroup';
  /** A description of what permissions in this group control. */
  description: Scalars['String']['output'];
  /** The display name of this permission group. */
  name: Scalars['String']['output'];
  /** The permissions belonging to this group. */
  permissions: Array<PermissionType>;
};

/** A PermissionGroupAssignment denotes the permissions of a user in the context of a company or company & network. */
export type PermissionGroupAssignment = {
  __typename?: 'PermissionGroupAssignment';
  /** The UUID of the network associated with these permissions. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /**
   * The list of permissions assigned to the user in this context.
   *
   * PermissionType represents the specific permissions granted.
   */
  permissionGroup: Array<PermissionGroup>;
};

/**
 * Code generated by src/cmd/utils/permissions. DO NOT EDIT.
 * permissions are generated from src/auth/permissions/permissions.go
 */
export enum PermissionType {
  /** Allows reading the active issues for a network. */
  PermActiveIssuesRead = 'PERM_ACTIVE___ISSUES_READ',
  PermAlertDeviceNotificationSnoozeRead = 'PERM_ALERT___DEVICE___NOTIFICATION___SNOOZE_READ',
  PermAlertDeviceNotificationSnoozeWrite = 'PERM_ALERT___DEVICE___NOTIFICATION___SNOOZE_WRITE',
  PermAlertReceiverProviderRead = 'PERM_ALERT___RECEIVER_PROVIDER_READ',
  PermAlertReceiverProviderWrite = 'PERM_ALERT___RECEIVER_PROVIDER_WRITE',
  PermAlertReceiverRead = 'PERM_ALERT___RECEIVER_READ',
  PermAlertReceiverTest = 'PERM_ALERT___RECEIVER_TEST',
  PermAlertReceiverWrite = 'PERM_ALERT___RECEIVER_WRITE',
  PermAlertSubscriptionCompanyRead = 'PERM_ALERT___SUBSCRIPTION_COMPANY_READ',
  PermAlertSubscriptionCompanyWrite = 'PERM_ALERT___SUBSCRIPTION_COMPANY_WRITE',
  PermAlertSubscriptionFleetwideRead = 'PERM_ALERT___SUBSCRIPTION_FLEETWIDE_READ',
  PermAlertSubscriptionFleetwideWrite = 'PERM_ALERT___SUBSCRIPTION_FLEETWIDE_WRITE',
  PermAlertSubscriptionSupportProviderRead = 'PERM_ALERT___SUBSCRIPTION_SUPPORT___PROVIDER_READ',
  PermAlertSubscriptionSupportProviderWrite = 'PERM_ALERT___SUBSCRIPTION_SUPPORT___PROVIDER_WRITE',
  PermApplicationMaintenance = 'PERM_APPLICATION_MAINTENANCE',
  PermApplicationUsageRead = 'PERM_APPLICATION___USAGE_READ',
  PermAuditLogRead = 'PERM_AUDIT___LOG_READ',
  PermAuditLogReadRestricted = 'PERM_AUDIT___LOG_READ_RESTRICTED',
  PermAuditLogWrite = 'PERM_AUDIT___LOG_WRITE',
  PermAuditLogWriteRestricted = 'PERM_AUDIT___LOG_WRITE_RESTRICTED',
  PermAuthenticationTokenRead = 'PERM_AUTHENTICATION___TOKEN_READ',
  PermAuthenticationTokenWrite = 'PERM_AUTHENTICATION___TOKEN_WRITE',
  PermAutoSelectionJobRead = 'PERM_AUTO___SELECTION___JOB_READ',
  PermAutoSelectionJobReadRestricted = 'PERM_AUTO___SELECTION___JOB_READ_RESTRICTED',
  PermAutoSelectionJobWrite = 'PERM_AUTO___SELECTION___JOB_WRITE',
  PermAutoSelectionJobWriteRestricted = 'PERM_AUTO___SELECTION___JOB_WRITE_RESTRICTED',
  PermAutoVpnRead = 'PERM_AUTO___VPN_READ',
  PermAutoVpnWrite = 'PERM_AUTO___VPN_WRITE',
  PermBearerSessionWrite = 'PERM_BEARER___SESSION_WRITE',
  PermBgpRouterRead = 'PERM_BGP___ROUTER_READ',
  PermBgpRouterWrite = 'PERM_BGP___ROUTER_WRITE',
  PermBulkNosUpgradeRead = 'PERM_BULK___NOS___UPGRADE_READ',
  PermBulkNosUpgradeWrite = 'PERM_BULK___NOS___UPGRADE_WRITE',
  /** Allows user to create, update, and perform actions (approve/deny) on captive portal entries. */
  PermCaptivePortalEntryWrite = 'PERM_CAPTIVE___PORTAL_ENTRY_WRITE',
  /** Allows user to view captive portals and entries. */
  PermCaptivePortalRead = 'PERM_CAPTIVE___PORTAL_READ',
  /** Allows user to create and update network-scoped captive portals and entries. */
  PermCaptivePortalWrite = 'PERM_CAPTIVE___PORTAL_WRITE',
  PermCellularWrite = 'PERM_CELLULAR_WRITE',
  PermClientBlocklistRead = 'PERM_CLIENT___BLOCKLIST_READ',
  PermClientBlocklistWrite = 'PERM_CLIENT___BLOCKLIST_WRITE',
  PermClientObserverTestsRead = 'PERM_CLIENT___OBSERVER___TESTS_READ',
  PermClientObserverTestsWrite = 'PERM_CLIENT___OBSERVER___TESTS_WRITE',
  PermClientVpnClientRead = 'PERM_CLIENT___VPN_CLIENT_READ',
  PermClientVpnClientWrite = 'PERM_CLIENT___VPN_CLIENT_WRITE',
  PermClientVpnRead = 'PERM_CLIENT___VPN_READ',
  PermClientVpnWrite = 'PERM_CLIENT___VPN_WRITE',
  PermCompanyAdminAssign = 'PERM_COMPANY_ADMIN_ASSIGN',
  /** Company Admin Read Only gives users read-only access to all networks in a company. */
  PermCompanyAdminReadOnlyAssign = 'PERM_COMPANY_ADMIN___READ___ONLY_ASSIGN',
  PermCompanyGet = 'PERM_COMPANY_GET',
  PermCompanyGlobalTemplatesRead = 'PERM_COMPANY_GLOBAL___TEMPLATES_READ',
  PermCompanyGuestAssign = 'PERM_COMPANY_GUEST_ASSIGN',
  PermCompanyInternalNoteRead = 'PERM_COMPANY_INTERNAL___NOTE_READ',
  PermCompanyInternalNoteWrite = 'PERM_COMPANY_INTERNAL___NOTE_WRITE',
  PermCompanyList = 'PERM_COMPANY_LIST',
  PermCompanyLocationWrite = 'PERM_COMPANY_LOCATION_WRITE',
  PermCompanyNetworkAdminAssign = 'PERM_COMPANY_NETWORK___ADMIN_ASSIGN',
  PermCompanyNetworkAdminReadOnlyAssign = 'PERM_COMPANY_NETWORK___ADMIN___READ___ONLY_ASSIGN',
  /** Allows user to assign captive portal entry manager role. This role allows users to mutate captive portal entries with read-only access to the rest of the network. */
  PermCompanyNetworkCaptivePortalManagerAssign = 'PERM_COMPANY_NETWORK___CAPTIVE___PORTAL___MANAGER_ASSIGN',
  PermCompanyNetworkOnboardingAssign = 'PERM_COMPANY_NETWORK___ONBOARDING_ASSIGN',
  PermCompanyOnboardingAssign = 'PERM_COMPANY_ONBOARDING_ASSIGN',
  PermCompanyOnboardingRead = 'PERM_COMPANY_ONBOARDING_READ',
  PermCompanyOnboardingWrite = 'PERM_COMPANY_ONBOARDING_WRITE',
  PermCompanyOnboardingWriteRestricted = 'PERM_COMPANY_ONBOARDING_WRITE_RESTRICTED',
  PermCompanySiemIntegrationRead = 'PERM_COMPANY_SIEM___INTEGRATION_READ',
  PermCompanySiemIntegrationWrite = 'PERM_COMPANY_SIEM___INTEGRATION_WRITE',
  PermCompanySsoRead = 'PERM_COMPANY_SSO_READ',
  PermCompanySsoWrite = 'PERM_COMPANY_SSO_WRITE',
  PermCompanySupportTierReadRestricted = 'PERM_COMPANY_SUPPORT___TIER_READ_RESTRICTED',
  PermCompanyUpdate = 'PERM_COMPANY_UPDATE',
  PermCompanyUsersViewMeterEmployees = 'PERM_COMPANY_USERS_VIEW__METER__EMPLOYEES',
  PermCompanyUserAssign = 'PERM_COMPANY_USER_ASSIGN',
  PermCompanyWriteRestricted = 'PERM_COMPANY_WRITE_RESTRICTED',
  PermConnectStaticRateRead = 'PERM_CONNECT___STATIC___RATE_READ',
  PermConnectStaticRateWrite = 'PERM_CONNECT___STATIC___RATE_WRITE',
  PermCountryDeviceCertificationRead = 'PERM_COUNTRY___DEVICE___CERTIFICATION_READ',
  PermCountryDeviceCertificationWrite = 'PERM_COUNTRY___DEVICE___CERTIFICATION_WRITE',
  PermCpeRead = 'PERM_CPE_READ',
  PermCustomRoleRead = 'PERM_CUSTOM___ROLE_READ',
  PermCustomRoleWrite = 'PERM_CUSTOM___ROLE_WRITE',
  /** Allows a user to access the dashboard. */
  PermDashboardAccess = 'PERM_DASHBOARD_ACCESS',
  PermDdnsRecordRead = 'PERM_DDNS___RECORD_READ',
  PermDdnsRecordWrite = 'PERM_DDNS___RECORD_WRITE',
  PermDeploymentScheduleRead = 'PERM_DEPLOYMENT___SCHEDULE_READ',
  /** Allows reading the uptime of devices on a network. */
  PermDeviceUptimeRead = 'PERM_DEVICE_UPTIME_READ',
  /** Allows reading and rendering device configurations. */
  PermDeviceConfigReadRestricted = 'PERM_DEVICE___CONFIG_READ_RESTRICTED',
  PermDhcpDnsRead = 'PERM_DHCP___DNS_READ',
  PermDhcpDnsWrite = 'PERM_DHCP___DNS_WRITE',
  PermDhcpDnsWriteRestricted = 'PERM_DHCP___DNS_WRITE_RESTRICTED',
  PermDocumentUploadRead = 'PERM_DOCUMENT___UPLOAD_READ',
  PermDocumentUploadWrite = 'PERM_DOCUMENT___UPLOAD_WRITE',
  PermEntityLookup = 'PERM_ENTITY___LOOKUP',
  PermEventLogRead = 'PERM_EVENT___LOG_READ',
  PermFirewallRead = 'PERM_FIREWALL_READ',
  PermFirewallWrite = 'PERM_FIREWALL_WRITE',
  PermFirewallWriteRestricted = 'PERM_FIREWALL_WRITE_RESTRICTED',
  PermFloorPlanRead = 'PERM_FLOOR___PLAN_READ',
  PermFloorPlanWrite = 'PERM_FLOOR___PLAN_WRITE',
  PermGatewayProfileRead = 'PERM_GATEWAY___PROFILE_READ',
  PermGatewayProfileWrite = 'PERM_GATEWAY___PROFILE_WRITE',
  PermHardwareDeviceAssign = 'PERM_HARDWARE___DEVICE_ASSIGN',
  PermHardwareDeviceDevWrite = 'PERM_HARDWARE___DEVICE_DEV_WRITE',
  PermHardwareDeviceInventoryReturn = 'PERM_HARDWARE___DEVICE_INVENTORY_RETURN',
  PermHardwareDeviceLocalConfigAccess = 'PERM_HARDWARE___DEVICE_LOCAL___CONFIG_ACCESS',
  PermHardwareDeviceLogin = 'PERM_HARDWARE___DEVICE_LOGIN',
  PermHardwareDeviceRead = 'PERM_HARDWARE___DEVICE_READ',
  PermHardwareDeviceReadLimited = 'PERM_HARDWARE___DEVICE_READ_LIMITED',
  PermHardwareDeviceRealmClaim = 'PERM_HARDWARE___DEVICE_REALM_CLAIM',
  PermHardwareDeviceRpcBlinkLeds = 'PERM_HARDWARE___DEVICE_RPC_BLINK___LEDS',
  PermHardwareDeviceRpcCableTest = 'PERM_HARDWARE___DEVICE_RPC_CABLE___TEST',
  PermHardwareDeviceRpcEapolTest = 'PERM_HARDWARE___DEVICE_RPC_EAPOL___TEST',
  PermHardwareDeviceRpcEyeTest = 'PERM_HARDWARE___DEVICE_RPC_EYE___TEST',
  PermHardwareDeviceRpcPing = 'PERM_HARDWARE___DEVICE_RPC_PING',
  PermHardwareDeviceRpcPortCycle = 'PERM_HARDWARE___DEVICE_RPC_PORT___CYCLE',
  PermHardwareDeviceRpcPortSecurityWrite = 'PERM_HARDWARE___DEVICE_RPC_PORT___SECURITY_WRITE',
  PermHardwareDeviceRpcReboot = 'PERM_HARDWARE___DEVICE_RPC_REBOOT',
  PermHardwareDeviceRpcRefreshConfig = 'PERM_HARDWARE___DEVICE_RPC_REFRESH___CONFIG',
  PermHardwareDeviceRpcSpotlightLeds = 'PERM_HARDWARE___DEVICE_RPC_SPOTLIGHT___LEDS',
  PermHardwareDeviceRpcWanSpeedtest = 'PERM_HARDWARE___DEVICE_RPC_WAN___SPEEDTEST',
  PermHardwareDeviceRpcWirelessCalibration = 'PERM_HARDWARE___DEVICE_RPC_WIRELESS___CALIBRATION',
  PermHardwareDeviceWrite = 'PERM_HARDWARE___DEVICE_WRITE',
  PermHardwareDeviceWriteRestricted = 'PERM_HARDWARE___DEVICE_WRITE_RESTRICTED',
  PermHardwareDevicePairReadRestricted = 'PERM_HARDWARE___DEVICE___PAIR_READ_RESTRICTED',
  PermHardwareDevicePairWriteRestricted = 'PERM_HARDWARE___DEVICE___PAIR_WRITE_RESTRICTED',
  PermHardwareModelPropertiesRead = 'PERM_HARDWARE___MODEL___PROPERTIES_READ',
  PermHardwareModelPropertiesReadLimited = 'PERM_HARDWARE___MODEL___PROPERTIES_READ_LIMITED',
  PermHardwarePortProfileRead = 'PERM_HARDWARE___PORT___PROFILE_READ',
  PermHardwarePortProfileWrite = 'PERM_HARDWARE___PORT___PROFILE_WRITE',
  PermHighAvailabilityRead = 'PERM_HIGH___AVAILABILITY_READ',
  PermHighAvailabilityWrite = 'PERM_HIGH___AVAILABILITY_WRITE',
  PermHostMonitoringRead = 'PERM_HOST___MONITORING_READ',
  PermHostMonitoringWrite = 'PERM_HOST___MONITORING_WRITE',
  PermIdsIpsRead = 'PERM_IDS___IPS_READ',
  PermIdsIpsWrite = 'PERM_IDS___IPS_WRITE',
  PermInboxMessageCollaboratorRead = 'PERM_INBOX___MESSAGE_COLLABORATOR_READ',
  PermInboxMessageCompanyRead = 'PERM_INBOX___MESSAGE_COMPANY_READ',
  PermInboxMessageNetworkRead = 'PERM_INBOX___MESSAGE_NETWORK_READ',
  PermInboxMessageRead = 'PERM_INBOX___MESSAGE_READ',
  PermInstallerAssign = 'PERM_INSTALLER_ASSIGN',
  PermInternalRoleMappingsWrite = 'PERM_INTERNAL___ROLE___MAPPINGS_WRITE',
  PermIpsecTunnelRead = 'PERM_IPSEC___TUNNEL_READ',
  PermIpsecTunnelWrite = 'PERM_IPSEC___TUNNEL_WRITE',
  PermIpForwardingRead = 'PERM_IP___FORWARDING_READ',
  PermIpForwardingWrite = 'PERM_IP___FORWARDING_WRITE',
  PermIspRead = 'PERM_ISP_READ',
  PermIspReadRestricted = 'PERM_ISP_READ_RESTRICTED',
  PermIspWrite = 'PERM_ISP_WRITE',
  PermIspWriteRestricted = 'PERM_ISP_WRITE_RESTRICTED',
  PermIspConnectionTypeRead = 'PERM_ISP___CONNECTION___TYPE_READ',
  PermIspConnectionTypeWrite = 'PERM_ISP___CONNECTION___TYPE_WRITE',
  PermIspDocumentRead = 'PERM_ISP___DOCUMENT_READ',
  PermIspDocumentWrite = 'PERM_ISP___DOCUMENT_WRITE',
  PermIspFulfillmentJobRead = 'PERM_ISP___FULFILLMENT___JOB_READ',
  PermIspFulfillmentJobWrite = 'PERM_ISP___FULFILLMENT___JOB_WRITE',
  PermIspFulfillmentTaskRead = 'PERM_ISP___FULFILLMENT___TASK_READ',
  PermIspFulfillmentTaskWrite = 'PERM_ISP___FULFILLMENT___TASK_WRITE',
  PermIspPaymentResourceReadRestricted = 'PERM_ISP___PAYMENT___RESOURCE_READ_RESTRICTED',
  PermIspPaymentResourceWriteRestricted = 'PERM_ISP___PAYMENT___RESOURCE_WRITE_RESTRICTED',
  PermIspProviderRead = 'PERM_ISP___PROVIDER_READ',
  PermIspProviderWrite = 'PERM_ISP___PROVIDER_WRITE',
  PermIspProviderStaticRateRead = 'PERM_ISP___PROVIDER___STATIC___RATE_READ',
  PermIspProviderStaticRateWrite = 'PERM_ISP___PROVIDER___STATIC___RATE_WRITE',
  /** Allows an operator to read lab resources and their reservations. */
  PermLabResourceRead = 'PERM_LAB___RESOURCE_READ',
  /** Allows an operator to create, update, and delete lab resources and their reservations. */
  PermLabResourceWrite = 'PERM_LAB___RESOURCE_WRITE',
  PermMacAddressAliasRead = 'PERM_MAC___ADDRESS___ALIAS_READ',
  PermMacAddressAliasWrite = 'PERM_MAC___ADDRESS___ALIAS_WRITE',
  PermMailingAddressesRead = 'PERM_MAILING___ADDRESSES_READ',
  PermMaintenanceWindowRead = 'PERM_MAINTENANCE___WINDOW_READ',
  PermMaintenanceWindowWrite = 'PERM_MAINTENANCE___WINDOW_WRITE',
  PermMarketingChangelogEntriesRead = 'PERM_MARKETING___CHANGELOG___ENTRIES_READ',
  PermMarketingChangelogEntriesReadRestricted = 'PERM_MARKETING___CHANGELOG___ENTRIES_READ_RESTRICTED',
  PermMarketingChangelogEntriesWrite = 'PERM_MARKETING___CHANGELOG___ENTRIES_WRITE',
  /** Allows an operator to grant a Meter contracted annotator read-only access to a company, including device stats. */
  PermMeterAnnotatorAssign = 'PERM_METER___ANNOTATOR_ASSIGN',
  PermMonitorProbeRead = 'PERM_MONITOR___PROBE_READ',
  PermMonitorProbeWrite = 'PERM_MONITOR___PROBE_WRITE',
  PermNacRead = 'PERM_NAC_READ',
  PermNacWrite = 'PERM_NAC_WRITE',
  PermNetworkCpeRead = 'PERM_NETWORK_CPE_READ',
  PermNetworkCpeWrite = 'PERM_NETWORK_CPE_WRITE',
  /** Allows the create network mutation. */
  PermNetworkCreate = 'PERM_NETWORK_CREATE',
  /** Allows the delete network mutation. */
  PermNetworkDelete = 'PERM_NETWORK_DELETE',
  PermNetworkDeleteRestricted = 'PERM_NETWORK_DELETE_RESTRICTED',
  PermNetworkInternalNoteRead = 'PERM_NETWORK_INTERNAL___NOTE_READ',
  PermNetworkInternalNoteWrite = 'PERM_NETWORK_INTERNAL___NOTE_WRITE',
  PermNetworkMetricsRead = 'PERM_NETWORK_METRICS_READ',
  PermNetworkNosRead = 'PERM_NETWORK_NOS_READ',
  PermNetworkNosWrite = 'PERM_NETWORK_NOS_WRITE',
  PermNetworkOnboardingRead = 'PERM_NETWORK_ONBOARDING_READ',
  PermNetworkOnboardingWrite = 'PERM_NETWORK_ONBOARDING_WRITE',
  PermNetworkOnboardingWriteRestricted = 'PERM_NETWORK_ONBOARDING_WRITE_RESTRICTED',
  PermNetworkRead = 'PERM_NETWORK_READ',
  PermNetworkReadLimited = 'PERM_NETWORK_READ_LIMITED',
  PermNetworkReadRestricted = 'PERM_NETWORK_READ_RESTRICTED',
  PermNetworkSettingsRead = 'PERM_NETWORK_SETTINGS_READ',
  PermNetworkSettingsUpdate = 'PERM_NETWORK_SETTINGS_UPDATE',
  PermNetworkSettingsWrite = 'PERM_NETWORK_SETTINGS_WRITE',
  PermNetworkSshRead = 'PERM_NETWORK_SSH_READ',
  PermNetworkSshWrite = 'PERM_NETWORK_SSH_WRITE',
  PermNetworkTemplateApply = 'PERM_NETWORK_TEMPLATE_APPLY',
  PermNetworkTemplateCreate = 'PERM_NETWORK_TEMPLATE_CREATE',
  PermNetworkWriteLimited = 'PERM_NETWORK_WRITE_LIMITED',
  PermNetworkWriteRestricted = 'PERM_NETWORK_WRITE_RESTRICTED',
  PermNetworkClientsRead = 'PERM_NETWORK___CLIENTS_READ',
  PermNetworkClientsWriteDisconnect = 'PERM_NETWORK___CLIENTS_WRITE_DISCONNECT',
  PermNetworkDevicesRead = 'PERM_NETWORK___DEVICES_READ',
  PermNetworkDevicesReadRestricted = 'PERM_NETWORK___DEVICES_READ_RESTRICTED',
  PermNetworkDevicesWrite = 'PERM_NETWORK___DEVICES_WRITE',
  PermNetworkDevicesWriteRestricted = 'PERM_NETWORK___DEVICES_WRITE_RESTRICTED',
  PermNetworkJobRead = 'PERM_NETWORK___JOB_READ',
  PermNetworkRouteRead = 'PERM_NETWORK___ROUTE_READ',
  PermNetworkRouteWrite = 'PERM_NETWORK___ROUTE_WRITE',
  PermNetworkThreatsRead = 'PERM_NETWORK___THREATS_READ',
  PermNetworkThreatAllowlistRead = 'PERM_NETWORK___THREAT___ALLOWLIST_READ',
  PermNetworkThreatAllowlistWrite = 'PERM_NETWORK___THREAT___ALLOWLIST_WRITE',
  PermNosRead = 'PERM_NOS_READ',
  PermNosReadRestricted = 'PERM_NOS_READ_RESTRICTED',
  PermNosWrite = 'PERM_NOS_WRITE',
  PermNosFeatureRead = 'PERM_NOS___FEATURE_READ',
  PermNosFeatureWrite = 'PERM_NOS___FEATURE_WRITE',
  PermNotificationSnoozeRead = 'PERM_NOTIFICATION___SNOOZE_READ',
  PermNotificationSnoozeWrite = 'PERM_NOTIFICATION___SNOOZE_WRITE',
  PermObserverTestsRead = 'PERM_OBSERVER___TESTS_READ',
  PermObserverTestsWrite = 'PERM_OBSERVER___TESTS_WRITE',
  PermOneToOneNatRead = 'PERM_ONE___TO___ONE___NAT_READ',
  PermOneToOneNatWrite = 'PERM_ONE___TO___ONE___NAT_WRITE',
  PermOperatorAssign = 'PERM_OPERATOR_ASSIGN',
  PermOpportunityReadRestricted = 'PERM_OPPORTUNITY_READ_RESTRICTED',
  PermOpportunityWriteRestricted = 'PERM_OPPORTUNITY_WRITE_RESTRICTED',
  PermOuiRead = 'PERM_OUI_READ',
  PermOutletWrite = 'PERM_OUTLET_WRITE',
  PermPacketCaptureJobRead = 'PERM_PACKET___CAPTURE___JOB_READ',
  PermPacketCaptureJobWrite = 'PERM_PACKET___CAPTURE___JOB_WRITE',
  /** Allows a user to assign the role of Partner to another user. A Partner is a special type of Meter customer who has elevated permissions to fully manage a Meter network. */
  PermPartnerAssign = 'PERM_PARTNER_ASSIGN',
  PermPermittedEmailDomainRead = 'PERM_PERMITTED___EMAIL___DOMAIN_READ',
  PermPermittedEmailDomainWrite = 'PERM_PERMITTED___EMAIL___DOMAIN_WRITE',
  PermPhyInterfaceRead = 'PERM_PHY___INTERFACE_READ',
  PermPhyInterfaceReadLimited = 'PERM_PHY___INTERFACE_READ_LIMITED',
  PermPhyInterfaceWrite = 'PERM_PHY___INTERFACE_WRITE',
  PermPhyInterfaceWriteRestricted = 'PERM_PHY___INTERFACE_WRITE_RESTRICTED',
  PermPolicyEngineRead = 'PERM_POLICY___ENGINE_READ',
  PermPolicyEngineReadRestricted = 'PERM_POLICY___ENGINE_READ_RESTRICTED',
  PermPolicyEngineWrite = 'PERM_POLICY___ENGINE_WRITE',
  PermPolicyEngineWriteRestricted = 'PERM_POLICY___ENGINE_WRITE_RESTRICTED',
  PermPolicyRoutingRead = 'PERM_POLICY___ROUTING_READ',
  PermPolicyRoutingWrite = 'PERM_POLICY___ROUTING_WRITE',
  PermPortForwardRead = 'PERM_PORT___FORWARD_READ',
  PermPortForwardWrite = 'PERM_PORT___FORWARD_WRITE',
  PermProjectManagementRead = 'PERM_PROJECT___MANAGEMENT_READ',
  PermProjectManagementReadRestricted = 'PERM_PROJECT___MANAGEMENT_READ_RESTRICTED',
  PermProjectManagementWrite = 'PERM_PROJECT___MANAGEMENT_WRITE',
  PermPublicApiKeyGrantRestricted = 'PERM_PUBLIC___API___KEY_GRANT_RESTRICTED',
  PermPublicApiKeyRead = 'PERM_PUBLIC___API___KEY_READ',
  PermPublicApiKeyWrite = 'PERM_PUBLIC___API___KEY_WRITE',
  PermPublicApiKeyWriteRestricted = 'PERM_PUBLIC___API___KEY_WRITE_RESTRICTED',
  PermPublicApiKeyGrantRequestReadRestricted = 'PERM_PUBLIC___API___KEY___GRANT___REQUEST_READ_RESTRICTED',
  PermPublicApiKeyGrantRequestWriteRestricted = 'PERM_PUBLIC___API___KEY___GRANT___REQUEST_WRITE_RESTRICTED',
  PermQuoteRead = 'PERM_QUOTE_READ',
  PermQuoteReadRestricted = 'PERM_QUOTE_READ_RESTRICTED',
  PermQuoteWrite = 'PERM_QUOTE_WRITE',
  PermQuoteWriteRestricted = 'PERM_QUOTE_WRITE_RESTRICTED',
  PermQuoteRequestRead = 'PERM_QUOTE___REQUEST_READ',
  PermQuoteRequestReadRestricted = 'PERM_QUOTE___REQUEST_READ_RESTRICTED',
  PermQuoteRequestWrite = 'PERM_QUOTE___REQUEST_WRITE',
  PermQuoteRequestWriteRestricted = 'PERM_QUOTE___REQUEST_WRITE_RESTRICTED',
  PermRackElevationRead = 'PERM_RACK___ELEVATION_READ',
  PermRackElevationWrite = 'PERM_RACK___ELEVATION_WRITE',
  PermRadioProfileRead = 'PERM_RADIO___PROFILE_READ',
  PermRadioProfileWrite = 'PERM_RADIO___PROFILE_WRITE',
  PermRateLimitRead = 'PERM_RATE___LIMIT_READ',
  PermRateLimitWrite = 'PERM_RATE___LIMIT_WRITE',
  PermSchemaIntrospection = 'PERM_SCHEMA___INTROSPECTION',
  PermSecurityApplianceDevicePairReadRestricted = 'PERM_SECURITY___APPLIANCE___DEVICE___PAIR_READ_RESTRICTED',
  PermSecurityApplianceDevicePairWriteRestricted = 'PERM_SECURITY___APPLIANCE___DEVICE___PAIR_WRITE_RESTRICTED',
  PermSecurityApplianceProfileRead = 'PERM_SECURITY___APPLIANCE___PROFILE_READ',
  PermSecurityApplianceProfileReadRestricted = 'PERM_SECURITY___APPLIANCE___PROFILE_READ_RESTRICTED',
  PermSecurityApplianceProfileWrite = 'PERM_SECURITY___APPLIANCE___PROFILE_WRITE',
  PermSecurityApplianceProfileWriteRestricted = 'PERM_SECURITY___APPLIANCE___PROFILE_WRITE_RESTRICTED',
  PermSpanMirrorSessionRead = 'PERM_SPAN___MIRROR___SESSION_READ',
  PermSpanMirrorSessionWrite = 'PERM_SPAN___MIRROR___SESSION_WRITE',
  PermSpeedtestRead = 'PERM_SPEEDTEST_READ',
  PermSpeedtestWrite = 'PERM_SPEEDTEST_WRITE',
  PermSsidsRead = 'PERM_SSIDS_READ',
  PermSsidsWrite = 'PERM_SSIDS_WRITE',
  PermStatEventWrite = 'PERM_STAT___EVENT_WRITE',
  PermSuperOperatorAssign = 'PERM_SUPER___OPERATOR_ASSIGN',
  PermSupportCaseCollaboratorRead = 'PERM_SUPPORT___CASE_COLLABORATOR_READ',
  PermSupportCaseCompanyRead = 'PERM_SUPPORT___CASE_COMPANY_READ',
  PermSupportCaseCreate = 'PERM_SUPPORT___CASE_CREATE',
  PermSupportCaseNetworkRead = 'PERM_SUPPORT___CASE_NETWORK_READ',
  PermSupportCaseRead = 'PERM_SUPPORT___CASE_READ',
  PermSupportCaseWrite = 'PERM_SUPPORT___CASE_WRITE',
  PermSupportProviderRead = 'PERM_SUPPORT___PROVIDER_READ',
  PermSupportProviderWrite = 'PERM_SUPPORT___PROVIDER_WRITE',
  PermSupportUserRead = 'PERM_SUPPORT___USER_READ',
  PermSupportUserWrite = 'PERM_SUPPORT___USER_WRITE',
  PermSwitchProfileRead = 'PERM_SWITCH___PROFILE_READ',
  PermSwitchProfileWrite = 'PERM_SWITCH___PROFILE_WRITE',
  PermTechnicalEnablementLabManagementAssign = 'PERM_TECHNICAL___ENABLEMENT___LAB___MANAGEMENT_ASSIGN',
  PermTechnicalPartnerSalesEngineerAssign = 'PERM_TECHNICAL___PARTNER___SALES___ENGINEER_ASSIGN',
  PermTemporaryAccessReadRestricted = 'PERM_TEMPORARY___ACCESS_READ_RESTRICTED',
  PermTemporaryAccessRequest = 'PERM_TEMPORARY___ACCESS_REQUEST',
  PermTemporaryAccessWriteRestricted = 'PERM_TEMPORARY___ACCESS_WRITE_RESTRICTED',
  PermTopologyDesignRead = 'PERM_TOPOLOGY___DESIGN_READ',
  PermTopologyDesignWrite = 'PERM_TOPOLOGY___DESIGN_WRITE',
  PermUserCreate = 'PERM_USER_CREATE',
  PermUserRead = 'PERM_USER_READ',
  PermUserUpdate = 'PERM_USER_UPDATE',
  PermUserActivityReadRestricted = 'PERM_USER___ACTIVITY_READ_RESTRICTED',
  PermVirtualDeviceCreate = 'PERM_VIRTUAL___DEVICE_CREATE',
  PermVirtualDeviceReadLimited = 'PERM_VIRTUAL___DEVICE_READ_LIMITED',
  PermVlanRead = 'PERM_VLAN_READ',
  PermVlanWrite = 'PERM_VLAN_WRITE',
  PermVlanWriteRestricted = 'PERM_VLAN_WRITE_RESTRICTED'
}

/** Input type specifying the context for fetching a user's permissions. */
export type PermissionsInput = {
  /**
   * The slug of the company to fetch permissions for.
   *
   * Required if permissions are company-specific.
   */
  companySlug?: InputMaybe<Scalars['String']['input']>;
  /**
   * The UUID of the network to fetch permissions for.
   *
   * Provide this if fetching network-specific permissions.
   */
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents an email domain that is permitted for authentication for a company. */
export type PermittedEmailDomain = {
  __typename?: 'PermittedEmailDomain';
  /** The timestamp when the permitted email domain was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The email domain that is permitted (e.g., "example.com"). */
  domain: Scalars['String']['output'];
  /** The unique UUID identifier for the permitted email domain. */
  sid?: Maybe<Scalars['UUID']['output']>;
};

/** A PhyInterface is a physical interface on a device. It's a software representation of a physical port. */
export type PhyInterface = Identifiable & TargetInterface & {
  __typename?: 'PhyInterface';
  /** The maximum transmission unit (MTU) - max size in bytes of frames that the port can transmit/receive. */
  MTU?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for the physical interface. */
  UUID: Scalars['UUID']['output'];
  /** The allowed (tagged) VLANs that are permitted to have traffic on this interface. */
  allowedVLANs?: Maybe<Array<Vlan>>;
  /** Devices connected to this physical interface. If `isConnected` is true, this will only return devices that are actively connected, else it returns the most recent devices that were connected to the port in a longer lookback period. */
  connectedDevices?: Maybe<Array<PhyInterfaceConnectedDevice>>;
  /** When the historical connected device information was invalidated, if set devices connected prior to this will not be returned. */
  connectedDevicesInvalidatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The date and time when the physical interface was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A description of the physical interface. */
  description?: Maybe<Scalars['String']['output']>;
  /** If 802.1X authentication is enabled for a Switch, this field contains the settings to configure 802.1X authentication. 802.1X must be enabled on the phy interface's switch's switch profile by having a RADIUS server configured in order for 802.1X to be enabled on the phy interface. */
  encryption8021XSettings?: Maybe<PhyInterface8021XSettings>;
  /** The reason this port is excluded from Switch Auto Configuration. Null when the port is not excluded. */
  excludedFromSwitchAutoConfigReason?: Maybe<Scalars['String']['output']>;
  /** The maximum amount of data that can be transmitted through the interface, in Mbps. */
  forcedPortSpeedMbps?: Maybe<Scalars['Int']['output']>;
  /** Whether the phy interface allows setting a forced speed */
  forcedSpeedAllowed: Scalars['Boolean']['output'];
  /** An optional filter to only accept certain frame types on this port. If null, all frame types are accepted. */
  frameAcceptTypeFilter?: Maybe<PhyInterfaceFrameAcceptTypeFilter>;
  /** Static hardware port label, if present. */
  hardwareLabel?: Maybe<Scalars['String']['output']>;
  /** If this interface represents a WAN port, indicates if there is any recent activity representing a connection to an ISP. */
  hasWANActivity?: Maybe<Scalars['Boolean']['output']>;
  /** Configuration for high availability associated with this interface, if on a controller configured in HA mode for this port. */
  highAvailability?: Maybe<HighAvailabilityControllerVirtualDeviceInfo>;
  /** If this interface represents a WAN port, attempts to match the most recently reported IP for the port against the IP address information from the provider. */
  internetServicePlan?: Maybe<InternetServicePlan>;
  /** If assigning this interface as a client, this field indicates the IPv4 addresses to assign to the interface without netmasks. */
  ipv4ClientAddresses?: Maybe<Array<Scalars['IPV4']['output']>>;
  /** If assigning this interface as a client, this field indicates the protocol to use for IPv4 addresses. */
  ipv4ClientAssignmentProtocol?: Maybe<ClientAssignmentProtocol>;
  /** If assigning this interface as a client, this field indicates the gateway IPv4 address without a netmask. */
  ipv4ClientGateway?: Maybe<Scalars['IPV4']['output']>;
  /** If assigning this interface as a client, this field indicates the subnet prefix length for the IPv4 addresses. */
  ipv4ClientPrefixLength?: Maybe<Scalars['Int']['output']>;
  /** If assigning this interface as a client, this field indicates the IPv6 addresses to assign to the interface without netmasks. */
  ipv6ClientAddresses?: Maybe<Array<Scalars['IPV6']['output']>>;
  /** If assigning this interface as a client, this field indicates the protocol to use for IPv6 addresses. */
  ipv6ClientAssignmentProtocol?: Maybe<ClientAssignmentProtocol>;
  /** If assigning this interface as a client, this field indicates the gateway IPv6 address without a netmask. */
  ipv6ClientGateway?: Maybe<Scalars['IPV6']['output']>;
  /** If assigning this interface as a client, this field indicates the subnet prefix length for the IPv6 addresses. */
  ipv6ClientPrefixLength?: Maybe<Scalars['Int']['output']>;
  /** Indicates if the port has been blocked by FLIP (Flap Link Intervention Protocol) due to too many port flaps. */
  isBlockedByFLIP: Scalars['Boolean']['output'];
  /**
   * Indicates if the port is blocked due to too many port flaps (link down/up).
   * @deprecated Use `isBlockedByFLIP` instead.
   */
  isBlockedDueToFlaps: Scalars['Boolean']['output'];
  /** Whether or not the interface is implicitly bound to all VLANs, including any future VLANs that are created. If set to true, all VLAN bindings (excluding the native VLAN) will be tagged on this interface. */
  isBoundToAllVLANs: Scalars['Boolean']['output'];
  /** True if something is connected to the port. */
  isConnected: Scalars['Boolean']['output'];
  /** Whether or not the interface is enabled. Interfaces that are not enabled are still visible to the user. */
  isEnabled: Scalars['Boolean']['output'];
  /** Indicates if the port is an Ethernet port. */
  isEthernet: Scalars['Boolean']['output'];
  /** If true, this port is excluded from Switch Auto Configuration. True when `excludedFromSwitchAutoConfigReason` is set. */
  isExcludedFromSwitchAutoConfig: Scalars['Boolean']['output'];
  /** If true, flap link intervention protocol is enabled on the port. Both this flag and isFLIPEnabled in SwitchProfile must be true for FLIP to be enabled on a port. */
  isFLIPEnabled: Scalars['Boolean']['output'];
  /** If true, Fast Leave is enabled on this interface. When enabled, the port is removed from the multicast group as soon as the switch sees an IGMP/MLD leave message from the client on the port. */
  isFastLeaveEnabled: Scalars['Boolean']['output'];
  /** This represents whether flow control is enabled. This feature is enabled by default. */
  isFlowControlEnabled: Scalars['Boolean']['output'];
  /** Indicates if this interface is a dedicated port connecting to a gateway device. */
  isGatewayPort: Scalars['Boolean']['output'];
  /** Indicates if this interface is a dedicated port connecting to another firewall in a high availability (HA) setup. */
  isHAPort: Scalars['Boolean']['output'];
  /**
   * If true, tagged frames are discarded when the VLAN ID of the frame does not match the VLAN ID of the port.
   * @deprecated This field is not respected for modern devices.
   */
  isIngressFilteringEnabled: Scalars['Boolean']['output'];
  /** If true, clients on isolated ports cannot communicate with other isolated ports; they can only communicate with non-isolated ports. */
  isIsolationEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** If true, this phy interface is configured as an L3 port. L3 ports have an IP address assigned directly and do not participate in VLANs or STP. */
  isL3Port: Scalars['Boolean']['output'];
  /** Indicates if the port is blocked due to loopback detection. */
  isLoopbackDetected?: Maybe<Scalars['Boolean']['output']>;
  /** If true, this L3 port participates in OSPF routing. Only valid on L3 ports whose device has L3 routing and OSPF enabled. */
  isOspfEnabled: Scalars['Boolean']['output'];
  /** Indicates if this interface is a dedicated port for out-of-band management. */
  isOutOfBandPort: Scalars['Boolean']['output'];
  /** Whether or not the interface is enabled to deliver Power over Ethernet. */
  isPOEEnabled: Scalars['Boolean']['output'];
  /** If true, this phy interface cannot be configured. */
  isReadOnly: Scalars['Boolean']['output'];
  /** Indicates if the port is an SFP port. */
  isSFP: Scalars['Boolean']['output'];
  /**
   * If true, this interface will be configured as an edge port in STP (Spanning Tree Protocol).
   *
   * For modern NOS versions, access ports are always edge ports. Trunk ports are never edge ports unless
   * the network's `isTrunkEdgeOverrideEnabled` STP override is enabled.
   */
  isSTPEdgePortEnabled: Scalars['Boolean']['output'];
  /** Whether or not the interface is enabled to participate in Spanning Tree Protocol. */
  isSTPEnabled: Scalars['Boolean']['output'];
  /** Indicates if the port is forwarding (true) or blocking (false) due to STP. */
  isSTPForwarding?: Maybe<Scalars['Boolean']['output']>;
  /** This should only be used with trunk ports. If enabled, the port cannot become STP root. It helps prevent a customer or rogue switch from sending a low bridge priority and becoming root. If a switch has root guard enabled and it receives a low bpdu (that would normally make it a root port), then the switch ill disable that port */
  isSTPRootGuardEnabled: Scalars['Boolean']['output'];
  /** If true, this phy interface is configured as a sink. */
  isSink: Scalars['Boolean']['output'];
  /** Whether or not storm control is enabled on the port. */
  isStormControlEnabled: Scalars['Boolean']['output'];
  /** A trunk port is a port that is assigned to carry traffic for multiple VLANs. */
  isTrunkPort: Scalars['Boolean']['output'];
  /** An uplink interface connects the device to other networks or network devices. */
  isUplink: Scalars['Boolean']['output'];
  /** Only populated if `isUplink` is true. Indicates if this uplink physical interface is currently active. */
  isUplinkActive?: Maybe<Scalars['Boolean']['output']>;
  /** Can only be populated if `isUplink` is true. If enabled, incoming ICMP requests to this uplink interface will be blocked by default. Only applies to controllers. */
  isUplinkIncomingICMPDenied?: Maybe<Scalars['Boolean']['output']>;
  /** If true, voice VLAN is enabled for this port. Both this flag and isVoiceVLANEnabled in SwitchProfile must be true for voice VLAN to be enabled on a port. */
  isVoiceVLANEnabled: Scalars['Boolean']['output'];
  /** An optional IPv4 address served in this interface's config in place of the device's underlay address. Only valid on interfaces where L3 is enabled. Null means the interface uses the device's underlay address. */
  l3IpAddress?: Maybe<Scalars['IPV4']['output']>;
  /** The prefix length (1-32) of the port CIDR, paired with L3IpAddress. Only valid on interfaces where L3 is enabled. */
  l3IpPrefixLength?: Maybe<Scalars['Int']['output']>;
  /** A custom label for the physical interface. */
  label?: Maybe<Scalars['String']['output']>;
  /** For switch port security, the maximum number of MAC addresses allowed on the port. */
  maxMACAddressesAllowed?: Maybe<Scalars['Int']['output']>;
  /** Maximum speed capability of the port from hardware specifications, in Mbps. */
  maxSpeedMbps?: Maybe<Scalars['Int']['output']>;
  /** The native (untagged) VLAN that is assigned to this interface. */
  nativeVLAN?: Maybe<Vlan>;
  /** The native (untagged) VLAN that is assigned to this interface. If no native VLAN is assigned, this returns the default VLAN for the network. */
  nativeVLANOrDefaultVLAN: Vlan;
  /** The 1:1 NAT rules associated with this physical interface. */
  oneToOneNATRules?: Maybe<Array<OneToOneNatRule>>;
  /**
   * The port's live PoE state, as last reported by the device. Null when the device has not reported
   * one recently, including on firmware that predates PoE port state.
   */
  poeStatus?: Maybe<PoEPortStatus>;
  /** PoE type for this port. It can be 802.3af, 802.3at or 802.3bt. A nil value indicates that the port cannot deliver PoE. */
  poeType?: Maybe<PoEType>;
  /** Information about the authenticated host on a port (reported by stats). */
  port8021XAuthenticatedHost?: Maybe<PhyInterface8021XAuthenticatedHost>;
  /** Indicates the status of 802.1X authentication on a port. */
  port8021XStatus?: Maybe<PhyInterface8021XPortStatus>;
  /** The physical port number on the device where the interface is located. */
  portNumber: Scalars['Int']['output'];
  /** A schedule for the port. The intervals cover when the port is enabled */
  portSchedule?: Maybe<Array<ScheduleInterval>>;
  /** For switch port security, this is a list of MAC addresses that have been learned on the port. Only populated if port security mode is dynamic or sticky. */
  portSecurityLearnedMACs?: Maybe<Array<Scalars['MacAddress']['output']>>;
  /** For switch port security, this is an allow list of MAC addresses that are allowed to be connected to the port. */
  portSecurityMACAllowList?: Maybe<Array<Scalars['MacAddress']['output']>>;
  /** For switch port security, this specifies the type of security - dynamic, static or sticky. */
  portSecurityMode?: Maybe<PhyInterfacePortSecurityMode>;
  /** The link speed on the port, as most recently reported by the device. */
  portSpeedMbps?: Maybe<Scalars['Int']['output']>;
  /**
   * The type of port (Ethernet, SFP, or Unknown).
   * @deprecated Use `isEthernet` or `isSFP` instead.
   */
  portType: PortType;
  /** The power draw on the port, populated from our time series database for PoE. */
  powerDraw?: Maybe<Scalars['Float']['output']>;
  /** The latest public IP address reported for the specific uplink port. (For physical interfaces on Firewalls) */
  reportedPublicIP?: Maybe<ReportedPublicIpInfo>;
  /** Receive rate limit for the port, in Kbps. May be rounded down to a nearest supported value depending on hardware support. */
  rxRateLimitKbps?: Maybe<Scalars['Int']['output']>;
  /**
   * Indicates if module speed exceeds the current port speed capability.
   * @deprecated Use `sfpModuleError` instead.
   */
  sfpExceedsPortSpeed: Scalars['Boolean']['output'];
  /**
   * Why the SFP module in this port cannot be used, if it cannot. Null when no module is present or no
   * problem is detected.
   */
  sfpModuleError?: Maybe<SfpModuleError>;
  /** SFP module information (if an SFP module is plugged into the port). */
  sfpModuleInfo?: Maybe<SfpModuleInfo>;
  /** SPAN (Switched Port Analyzer) mirror session information for this port on a switch, if applicable. */
  spanMirrorInfo?: Maybe<PhyInterfaceSpanMirrorInfo>;
  /** The percent of broadcast traffic to drop if storm control is enabled. */
  stormControlBroadcastTrafficPercent: Scalars['Int']['output'];
  /** The percent of unknown multicast traffic to drop if storm control is enabled. */
  stormControlUnknownMulticastTrafficPercent: Scalars['Int']['output'];
  /** The percent of unknown unicast traffic to drop if storm control is enabled. */
  stormControlUnknownUnicastTrafficPercent: Scalars['Int']['output'];
  /** STP Path cost for the port (1-200000000). */
  stpPathCost?: Maybe<Scalars['Int']['output']>;
  /** The Spanning Tree Protocol (STP) role of the port. */
  stpPortRole?: Maybe<StpPortRole>;
  /** STP Priority for the port (0-240 in multiples of 16, default 128). */
  stpPriority: Scalars['Int']['output'];
  /** For phy interfaces belonging to a switch, aggregated statistics over a specified lookback period. */
  switchPortStats?: Maybe<Array<SwitchPortStat>>;
  /**
   * The throughput (RX/TX) for the last 24 hours on the port, populated from our time series database.
   * @deprecated Use `Query.switchPortMetricsRate` instead.
   */
  throughputLastDay?: Maybe<Array<ThroughputValueWithDirection>>;
  /** Transmit rate limit for the port, in Kbps. May be rounded down to a nearest supported value depending on hardware support. */
  txRateLimitKbps?: Maybe<Scalars['Int']['output']>;
  /** The date and time when the physical interface was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Only populated if `isUplink` is true. Holds the statically reported addresses of the physical interface. */
  uplinkExternalAddresses?: Maybe<Array<Scalars['UnmaskedIPPrefix']['output']>>;
  /** the IEEE device vendor data for the uplink gateway. */
  uplinkGatewayIEEEDeviceVendor?: Maybe<IeeeDeviceVendor>;
  /** Can only be populated if `isUplink` is true. The MAC Address of the upstream device this physical interface is connected to. */
  uplinkGatewayMACAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** Can only be populated if `isUplink` is true. The priority order in which the uplink should be used. */
  uplinkPriority?: Maybe<Scalars['Int']['output']>;
  /** Can only be populated if `isUplink` is true. The VLAN ID used for the uplink. */
  uplinkVLANID?: Maybe<Scalars['Int']['output']>;
  /** The virtual device associated with this physical interface. */
  virtualDevice: VirtualDevice;
  /** The UUID of the virtual device that this physical interface belongs to. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};


/** A PhyInterface is a physical interface on a device. It's a software representation of a physical port. */
export type PhyInterfaceSwitchPortStatsArgs = {
  lookbackHours?: InputMaybe<Scalars['Int']['input']>;
};

/** The authentication method used for 802.1X authentication. */
export enum PhyInterface8021XAuthType {
  /** Client authenticated using EAP (e.g., certificate-based or username/password). */
  Eap = 'EAP',
  /** Switch authenticated the client based on its MAC address. */
  Mac = 'MAC',
  /** The authentication type is unspecified. */
  Unspecified = 'UNSPECIFIED'
}

/** Information about an authenticated host on a port (reported by stats). */
export type PhyInterface8021XAuthenticatedHost = {
  __typename?: 'PhyInterface8021XAuthenticatedHost';
  /** The authentication method used (EAP or MAC-based). */
  authType?: Maybe<PhyInterface8021XAuthType>;
  /** The VLAN ID assigned to the client if it was dynamically provisioned by RADIUS (0 for static or fallback VLANs). Used for MS switches */
  dynamicVlanId?: Maybe<Scalars['Int']['output']>;
  /** The MAC address of the authenticated host. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** Whether no RADIUS server answered the client's latest authentication. */
  serverUnreachable?: Maybe<Scalars['Boolean']['output']>;
  /** How long the client has been authenticated, or for a client on a fallback VLAN, how long it has been on it (in seconds). */
  sessionDurationSeconds?: Maybe<Scalars['Int']['output']>;
  /** The username of the authenticated host. */
  username?: Maybe<Scalars['String']['output']>;
  /** The VLAN ID assigned to the client. Used for S* series switches. */
  vlanId?: Maybe<Scalars['Int']['output']>;
  /** The source of the VLAN assignment for the client. */
  vlanType?: Maybe<PhyInterface8021XVlanType>;
};

/** Specifies how many hosts are allowed to authenticate on the port. */
export enum PhyInterface8021XHostMode {
  /** All clients on the port must authenticate using 802.1X. All must belong to the same VLAN. Guest VLAN cannot be used. */
  MultiAuth = 'MULTI_AUTH',
  /** Allows multiple clients access to the port. After the first client is authenticated, all subsequent clients can tailgate and do not have to authenticate. */
  MultiHost = 'MULTI_HOST',
  /** Allows only a single client to authenticate and use the port. No other clients can access the port. */
  SingleHost = 'SINGLE_HOST'
}

/** When a phy interface has this mode enabled, the switch will use the MAC address of the client to authenticate with the RADIUS server, often used for printer ports. */
export enum PhyInterface8021XmacAuthenticationBypassMode {
  /** The port will not use MAC authentication bypass; the client must authenticate with 802.1X. */
  Disabled = 'DISABLED',
  /** Allows a client to specify credentials and falls back to MAC auth if the client fails. */
  Hybrid = 'HYBRID',
  /** Forces only MAC-based auth; the client cannot specify user credentials. */
  MacAuthOnly = 'MAC_AUTH_ONLY'
}

/** Specifies the variant of 802.1X authentication to use. */
export enum PhyInterface8021XPortMode {
  /** Allows only EAPOL frames to be sent and received through the port until the client is authenticated by the RADIUS server. */
  Auto = 'AUTO',
  /** Configures the port as authenticated, essentially skipping 802.1X auth. The port receives and sends normal traffic without 802.1X-based authentication of the client. */
  ForceAuthorized = 'FORCE_AUTHORIZED'
}

/** Indicates the status of 802.1X authentication on a port. */
export enum PhyInterface8021XPortStatus {
  /** The port is currently attempting to authenticate the connected client via 802.1X. */
  Authenticating = 'AUTHENTICATING',
  /** The client has successfully authenticated. The port is authorized to pass normal traffic. */
  Authorized = 'AUTHORIZED',
  /** The port is initialized and preparing to begin 802.1X authentication. */
  Initialized = 'INITIALIZED',
  /** The client is not authorized. The port is blocked from forwarding normal traffic. */
  Unauthorized = 'UNAUTHORIZED',
  /** Status unknown or unavailable. May indicate 802.1X is disabled or port is not reporting. */
  Unspecified = 'UNSPECIFIED'
}

/** Specifies the settings for 802.1X authentication on a port. */
export type PhyInterface8021XSettings = {
  __typename?: 'PhyInterface8021XSettings';
  /** Specifies how many hosts are allowed to authenticate on the port. Null when 802.1X is not configured on the port. */
  hostMode?: Maybe<PhyInterface8021XHostMode>;
  /** If enabled, the switch will dynamically assign VLANs to the port based on the RADIUS server response. */
  isAssignVLANsFromRADIUSEnabled: Scalars['Boolean']['output'];
  /** 'If enabled, unauthenticated clients will be assigned to the guest VLAN specified in the switch profile (`RADIUSGuestVLAN`). If disabled, unauthenticated clients are blocked. */
  isGuestVLANEnabled: Scalars['Boolean']['output'];
  /** The MAC authentication bypass mode for the port to accept MAC-based auth. The switch will use the MAC address of the client to authenticate with the RADIUS server, often used for printer ports. */
  macAuthenticationBypassMode: PhyInterface8021XmacAuthenticationBypassMode;
  /** Specifies the variant of 802.1X authentication to use. */
  portMode: PhyInterface8021XPortMode;
  /** The duration that the port will wait after a client fails authentication; after this period it will allow re-attempt. */
  quietPeriodSeconds: Scalars['Int']['output'];
  /** If set, authorized clients are forced to re-authenticate after this period. If not set, clients are not forced to re-authenticate. */
  reauthenticationPeriodSeconds?: Maybe<Scalars['Int']['output']>;
  /** When a client is connected to a port, the switch sends out an EAP auth request to the client; the request times out and retransmits according to this value. */
  supplicantPeriodSeconds: Scalars['Int']['output'];
};

/** The source of the VLAN assignment for the client. */
export enum PhyInterface8021XVlanType {
  /** VLAN was assigned dynamically from RADIUS response. */
  Dynamic = 'DYNAMIC',
  /** Authentication failed; the switch placed the client in the preconfigured guest VLAN. */
  Guest = 'GUEST',
  /** No RADIUS server answered for the client; the switch placed it in the server fail VLAN. */
  ServerFail = 'SERVER_FAIL',
  /** The RADIUS server rejected the client; the switch placed it in the server reject VLAN. */
  ServerReject = 'SERVER_REJECT',
  /** VLAN was assigned based on the port’s static configuration (e.g., the port's default/native access VLAN). */
  Static = 'STATIC',
  /** The VLAN type is unspecified. */
  Unspecified = 'UNSPECIFIED'
}

/** An object to tell when a device was connected to a physical interface on a Meter Switch. */
export type PhyInterfaceConnectedAt = {
  __typename?: 'PhyInterfaceConnectedAt';
  /** The timestamp when the device was connected to the physical interface on a Meter Switch. */
  connectedAt: Scalars['DateTime']['output'];
  /** The physical interface on the Meter Switch that the device is connected to. */
  phyInterface: PhyInterface;
};

/** Represents a device connected to a physical interface. */
export type PhyInterfaceConnectedDevice = {
  __typename?: 'PhyInterfaceConnectedDevice';
  /** Network client for the connected device, if available. */
  client?: Maybe<NetworkClient>;
  /**
   * If the macAddress belongs to a Meter device, this field will load it from the database. Deprecated: Use `hardwareDevice` instead.
   * @deprecated Use `hardwareDevice` instead.
   */
  device?: Maybe<Device>;
  /** The Meter hardware device with this MAC address, if the connected device is one. */
  hardwareDevice?: Maybe<HardwareDevice>;
  /** IEEE-registered vendor for the macAddress's OUI, if known. Sourced from the IEEE OUI database. */
  ieeeDeviceVendor?: Maybe<IeeeDeviceVendor>;
  /** When the device was last observed to be connected. */
  lastUpdatedAt: Scalars['DateTime']['output'];
  /** The raw entry returned by the LLDP protocol. */
  lldpEntry?: Maybe<LldpEntry>;
  /** For non-Meter devices, this field contains the raw 'remoteID' returned by the LLDP protocol. */
  lldpRemoteID?: Maybe<Scalars['String']['output']>;
  /** MAC Address of the device that is plugged into the port. Populated via LLDP. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** A user-defined nickname for the device, if specified. */
  macAddressAlias?: Maybe<MacAddressAlias>;
  /** The network UUID. */
  networkUUID: Scalars['UUID']['output'];
  /** The other phy interface that is plugged into the calling phy interface, if the other device is a Meter device. */
  phyInterface?: Maybe<PhyInterface>;
  /** The port number of the other phy interface that is plugged into the calling phy interface, if the other device is a Meter device. */
  portNumber?: Maybe<Scalars['Int']['output']>;
};

/**
 * A simplified DHCP rule served on a routed LAN port of a gateway device.
 * Unlike a DHCPRule, it is not attached to a VLAN.
 */
export type PhyInterfaceDhcpRule = {
  __typename?: 'PhyInterfaceDHCPRule';
  /** The unique identifier of the DHCP rule. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when this DHCP rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The gateway address and served subnet, as an unmasked prefix (e.g. `10.65.0.1/24`).
   * The address is handed to DHCP clients as the router (DHCP option 3) and is
   * also the port's own address; the masked prefix is the served subnet.
   */
  gateway: Scalars['UnmaskedIPPrefix']['output'];
  /** The IP address of the gateway that serves DHCP on this phy interface. */
  gatewayIPAddress: Scalars['IP']['output'];
  /** Indicates whether this DHCP rule is for IPv6 (`true`) or IPv4 (`false`). */
  isIPv6: Scalars['Boolean']['output'];
  /** The duration (in seconds) of the DHCP lease assigned to clients. */
  leaseDurationSeconds: Scalars['Int']['output'];
  /** The phy interface this rule serves DHCP on. */
  phyInterface: PhyInterface;
  /** The timestamp when this DHCP rule was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A physical interface was created, updated, or deleted. */
export type PhyInterfaceEvent = CrudEvent & {
  __typename?: 'PhyInterfaceEvent';
  /** The UUID of the physical interface the action was performed on. */
  entityUUID: Scalars['UUID']['output'];
  /** The physical interface itself. */
  phyInterface?: Maybe<PhyInterface>;
  /** The action performed on the physical interface. */
  type: CrudEventType;
};

/** Specifies the frame types to accept on a port. */
export enum PhyInterfaceFrameAcceptTypeFilter {
  /** Accept only tagged frames. */
  TaggedOnly = 'TAGGED_ONLY',
  /** Accept only untagged frames. */
  UntaggedOnly = 'UNTAGGED_ONLY'
}

/** Specifies how a switch port allows hosts to connect to a port when port security is enabled. */
export enum PhyInterfacePortSecurityMode {
  /** Allows the switch port to dynamically learn and allow hosts on the port up to the max configured limit. */
  Dynamic = 'DYNAMIC',
  /** Allows the switch port to only permit the configured MACs to access the port. */
  Static = 'STATIC',
  /** Allows the switch port to dynamically learn and allow hosts on the port up to the max configured limit and the host's MACs are retained by the switch across reboots. */
  Sticky = 'STICKY'
}

/** Information about how a phy interface participates in SPAN (Switched Port Analyzer) port mirroring on a switch. */
export type PhyInterfaceSpanMirrorInfo = {
  __typename?: 'PhyInterfaceSPANMirrorInfo';
  /** The SPAN mirror session where this port is the destination (monitor) port, if any. */
  destinationSession?: Maybe<SpanMirrorSession>;
  /** Roles this port plays in SPAN mirroring on its switch. */
  roles: Array<PhyInterfaceSpanMirrorRole>;
  /** Source port configurations for SPAN mirror sessions where this port mirrors traffic. */
  sourcePorts: Array<SpanMirrorSessionSourcePort>;
};

/**
 * Information about how a physical interface participates in SPAN (Switched Port Analyzer)
 * port mirroring on its switch.
 */
export enum PhyInterfaceSpanMirrorRole {
  /** The port is the destination (monitor) port for a SPAN mirror session. */
  Destination = 'DESTINATION',
  /** The port is a source port for a SPAN mirror session. */
  Source = 'SOURCE'
}

/** Contains info about the PoE (Power over Ethernet) usage of a hardware device. */
export type PoEInfo = {
  __typename?: 'PoEInfo';
  /** The maximum PoE power the device can supply (in Watts). */
  max?: Maybe<Scalars['Float']['output']>;
  /**
   * Timestamp of the stat that max was extracted from.
   * @deprecated The same value as usedCreatedAt.
   */
  maxCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The current PoE power usage value (in Watts). */
  used?: Maybe<Scalars['Float']['output']>;
  /** The timestamp when the current PoE power usage was recorded. */
  usedCreatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The cause of a port's current PoE state. */
export enum PoEPortReason {
  /** The device's classification was invalid. */
  ClassificationFailed = 'CLASSIFICATION_FAILED',
  /** No valid PoE signature was detected, or the connection check failed. */
  DetectionFailed = 'DETECTION_FAILED',
  /** The PoE controller's hardware disable pin is active. */
  DisablePin = 'DISABLE_PIN',
  /** Voltage from an external source was found on the port. */
  ExternalVoltage = 'EXTERNAL_VOLTAGE',
  /** The device stopped drawing power, usually because it was unplugged. */
  MpsAbsent = 'MPS_ABSENT',
  /** The device drew more current than allowed. */
  Overload = 'OVERLOAD',
  /** The port or PoE controller is too hot. */
  OverTemperature = 'OVER_TEMPERATURE',
  /** The device requires more power than the port's configured or hardware limit. */
  PortPowerLimit = 'PORT_POWER_LIMIT',
  /** Powering the device would exceed the PoE power budget. */
  PowerBudgetExceeded = 'POWER_BUDGET_EXCEEDED',
  /** An internal PoE hardware fault, or the port is missing from the PoE controller's port map. */
  PseFault = 'PSE_FAULT',
  /** A short circuit was detected. */
  Short = 'SHORT',
  /** The port failed to power up the device. */
  StartupFailed = 'STARTUP_FAILED',
  /** The PoE supply voltage is too high or too low. */
  VmainOutOfRange = 'VMAIN_OUT_OF_RANGE'
}

/** A port's current PoE operating condition. */
export enum PoEPortState {
  /** Powering a device. */
  Delivering = 'DELIVERING',
  /** Disabled by configuration or a hardware disable pin. */
  Disabled = 'DISABLED',
  /** Nothing is connected. */
  Open = 'OPEN',
  /** Looking for a device, including after a disconnect or a configuration change. */
  Searching = 'SEARCHING',
  /** The PoE controller cannot power this port. `PoEPortStatus.reason` gives the cause, when known. */
  UnableToPower = 'UNABLE_TO_POWER'
}

/** The live PoE state of a port, as reported by the device's PoE controller. */
export type PoEPortStatus = {
  __typename?: 'PoEPortStatus';
  /**
   * The IEEE class the PoE controller assigned. Class 0 is valid. Null when no class was reported. For a
   * dual-signature device this is the primary pair set's class.
   */
  assignedClass?: Maybe<Scalars['Int']['output']>;
  /** The secondary pair set's assigned class for a dual-signature device. Null when not reported. */
  assignedClassSecondary?: Maybe<Scalars['Int']['output']>;
  /** The power allocated to the port, in watts. Null when not reported. */
  assignedPowerWatts?: Maybe<Scalars['Float']['output']>;
  /** Why the port is in its state. Null when it is delivering power normally or the device gave no cause. */
  reason?: Maybe<PoEPortReason>;
  /** The port's current PoE operating condition. */
  state: PoEPortState;
};

/** Indicates max PoE power delivered by the port */
export enum PoEType {
  /** 802.3af max 15 Watts */
  PoE8023Af = 'PoE8023AF',
  /** 802.3at max 30 Watts */
  PoE8023At = 'PoE8023AT',
  /** 802.3bt max 90 Watts */
  PoE8023Bt = 'PoE8023BT'
}

/** A person representing the customer who Meter can contact when needing to discuss the network. */
export type PointOfContactData = {
  __typename?: 'PointOfContactData';
  /** Email of the onsite point of contact. */
  email?: Maybe<Scalars['String']['output']>;
  /** Name of the onsite point of contact. */
  name?: Maybe<Scalars['String']['output']>;
  /** Phone number of the onsite point of contact. */
  phone_number?: Maybe<Scalars['String']['output']>;
};

/** Input for a person representing the customer who Meter can contact when needing to discuss the network. */
export type PointOfContactInput = {
  /** Email of the onsite point of contact. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Name of the onsite point of contact. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the onsite point of contact. */
  phone_number?: InputMaybe<Scalars['String']['input']>;
};

/** Security appliance profile configuration seettings for policy engine. */
export type PolicyEngineConfiguration = {
  __typename?: 'PolicyEngineConfiguration';
  /**
   * The maximum number of sessions supported by policy engine.
   * Affects the initial capacity of the session table (set to this value), and the maximum capacity
   * and the main heap size for the firmware (based on memory profiles in the firmware, depending on this value).
   */
  initialSessions?: Maybe<Scalars['Int']['output']>;
};

/** Security appliance profile configuration seettings for policy engine. */
export type PolicyEngineConfigurationInput = {
  /**
   * The maximum number of sessions supported by policy engine.
   * Affects the initial capacity of the session table (set to this value), and the maximum capacity
   * and the main heap size for the firmware (based on memory profiles in the firmware, depending on this value).
   */
  initialSessions?: InputMaybe<Scalars['Int']['input']>;
};

/** Configuration for destination NAT. */
export type PolicyEngineDestinationNatConfiguration = {
  __typename?: 'PolicyEngineDestinationNATConfiguration';
  /** The destination address configuration. */
  destinationAddress: PolicyEngineNatConfigurationAddress;
  /** The destination static port. */
  destinationStaticPort?: Maybe<Scalars['Int']['output']>;
};

/** Configuration for destination NAT. */
export type PolicyEngineDestinationNatConfigurationInput = {
  /** The destination address configuration. */
  destinationAddress: PolicyEngineNatConfigurationAddressInput;
  /** The destination static port. */
  destinationStaticPort?: InputMaybe<Scalars['Int']['input']>;
};

/** Configuration for NAPT NAT. */
export type PolicyEngineNaptConfiguration = {
  __typename?: 'PolicyEngineNAPTConfiguration';
  /** The source address configuration. */
  sourceAddress: PolicyEngineNatConfigurationAddress;
};

/** Configuration for NAPT NAT. */
export type PolicyEngineNaptConfigurationInput = {
  /** The source address configuration. */
  sourceAddress: PolicyEngineNatConfigurationAddressInput;
};

/** NAT configuration for a policy engine path. */
export type PolicyEngineNatConfiguration = PolicyEngineDestinationNatConfiguration | PolicyEngineNaptConfiguration | PolicyEngineSourceNatConfiguration | PolicyEngineTwiceNatConfiguration;

/** An address and static port for a policy engine NAT configuration address. */
export type PolicyEngineNatConfigurationAddress = {
  __typename?: 'PolicyEngineNATConfigurationAddress';
  /** The IP address, if the type is either `STATIC` or `VIRTUAL`. */
  ipAddress?: Maybe<Scalars['IP']['output']>;
  /** The source type of the address translation. */
  sourceType: PolicyEngineNatConfigurationAddressSourceType;
  /** The interface, if the type is either `DHCP` or `VIRTUAL`. */
  targetInterface?: Maybe<TargetInterface>;
  /** The unique identifier for the interface, if the type is either `DHCP` or `VIRTUAL`. */
  targetInterfaceUUID?: Maybe<Scalars['UUID']['output']>;
};

/** An address and static port for a policy engine NAT configuration address. */
export type PolicyEngineNatConfigurationAddressInput = {
  /** The IP address, if the type is either `STATIC` or `VIRTUAL`. */
  ipAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The source type of the address translation. */
  sourceType: PolicyEngineNatConfigurationAddressSourceType;
  /** The interface, if the type is either `DHCP` or `VIRTUAL`. */
  targetInterface?: InputMaybe<TargetInterfaceInput>;
};

/** An address source type for a policy engine NAT configuration. */
export enum PolicyEngineNatConfigurationAddressSourceType {
  /** A DHCP interface. */
  Dhcp = 'DHCP',
  /** A static IP address. */
  Static = 'STATIC',
  /** A virtual address, containing both an IP address and an interface. */
  Virtual = 'VIRTUAL'
}

/** NAT configuration for a policy engine path. */
export type PolicyEngineNatConfigurationInput = {
  /** Configuration for destination NAT. */
  destinationNAT?: InputMaybe<PolicyEngineDestinationNatConfigurationInput>;
  /** Configuration for NAPT NAT. */
  napt?: InputMaybe<PolicyEngineNaptConfigurationInput>;
  /** Configuration for source NAT. */
  sourceNAT?: InputMaybe<PolicyEngineSourceNatConfigurationInput>;
  /** Configuration for twice NAT. */
  twiceNAT?: InputMaybe<PolicyEngineTwiceNatConfigurationInput>;
};

/** The next hop configuration for a policy engine policy. */
export type PolicyEngineNextHopConfiguration = PolicyEngineNextHopL3Configuration | PolicyEngineNextHopVrfRouteLookupConfiguration;

/** The next hop configuration for a policy engine policy. */
export type PolicyEngineNextHopConfigurationInput = {
  /** Layer 3 next hop configuration. */
  l3NextHop?: InputMaybe<PolicyEngineNextHopL3ConfigurationInput>;
  /** VRF route lookup next hop configuration. */
  vrfRouteLookup?: InputMaybe<PolicyEngineNextHopVrfRouteLookupConfigurationInput>;
};

/** Next hop via layer 3 routing. */
export type PolicyEngineNextHopL3Configuration = {
  __typename?: 'PolicyEngineNextHopL3Configuration';
  /** The next hop IP address. If omitted, the destination must be on-link to the `nextHopInterface`. */
  nextHopIPAddress?: Maybe<Scalars['IP']['output']>;
  /** The next hop interface. */
  nextHopInterface: TargetInterface;
  /** The unique identifier of the next hop interface. */
  nextHopInterfaceUUID: Scalars['UUID']['output'];
};

/** Next hop via layer 3 routing. */
export type PolicyEngineNextHopL3ConfigurationInput = {
  /** The next hop IP address. If omitted, the destination must be on-link to the `nextHopInterface`. */
  nextHopIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The next hop interface. */
  nextHopInterface: TargetInterfaceInput;
};

/** Next hop via VRF route lookup. */
export type PolicyEngineNextHopVrfRouteLookupConfiguration = {
  __typename?: 'PolicyEngineNextHopVRFRouteLookupConfiguration';
  /** The VRF ID. If omitted, VRF is derived from the packet's receiving interface. */
  vrfID?: Maybe<Scalars['Int']['output']>;
};

/** Next hop via VRF route lookup. */
export type PolicyEngineNextHopVrfRouteLookupConfigurationInput = {
  /** The VRF ID. If omitted, VRF is derived from the packet's receiving interface. Currently only `0` is supported. */
  vrfID?: InputMaybe<Scalars['Int']['input']>;
};

/** A path in a policy engine policy that defines how matched traffic should be routed. */
export type PolicyEnginePath = Identifiable & {
  __typename?: 'PolicyEnginePath';
  /** Unique identifier for this path. */
  UUID: Scalars['UUID']['output'];
  /** If set, clamps the TCP max segment size to the provided number of bytes. */
  clampMaxSegmentSizeBytes?: Maybe<Scalars['Int']['output']>;
  /** Optional extended description for the path. */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether this path should be initially active before monitor reports. */
  initialActive: Scalars['Boolean']['output'];
  /** Optional IP address used as virtual address for this path. */
  ipAddress?: Maybe<Scalars['IP']['output']>;
  /** Whether the path is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Monitor group for health monitoring. */
  monitorGroup: MonitorGroup;
  /** Unique name for the path. */
  name: Scalars['String']['output'];
  /** NAT configuration for the policy. */
  natConfiguration?: Maybe<PolicyEngineNatConfiguration>;
  /** Next hop configuration for the policy. */
  nextHopConfiguration?: Maybe<PolicyEngineNextHopConfiguration>;
  /** This path's policy. */
  policy: PolicyEnginePolicy;
  /** Unique identifier for this path's policy. */
  policyUUID: Scalars['UUID']['output'];
  /** Lower priority values are preferred for routing. */
  priority: Scalars['Int']['output'];
  /** Target interface for this path. */
  targetInterface: TargetInterface;
  /** Load balancing weight for distributing traffic across paths with equal priority. */
  weight: Scalars['Int']['output'];
};

/** Filter type for retrieving policy engine policies. */
export type PolicyEnginePoliciesFilterInput = {
  /** If set, only returns policies with the given type */
  type?: InputMaybe<PolicyEnginePolicyType>;
};

/** A policy engine policy that matches traffic and routes it through configured paths. */
export type PolicyEnginePolicy = Identifiable & {
  __typename?: 'PolicyEnginePolicy';
  /** Unique identifier for this policy. */
  UUID: Scalars['UUID']['output'];
  /** When this policy was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Optional extended description for the policy. */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the policy is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Name of the policy. */
  name: Scalars['String']['output'];
  /** This policy's network. */
  network: Network;
  /** Unique identifier for this policy's network. */
  networkUUID: Scalars['UUID']['output'];
  /** Paths for this policy. */
  paths: Array<PolicyEnginePath>;
  /** Priority of the policy within the network, lower priority policies are applied first. */
  priority: Scalars['Int']['output'];
  /** Traffic matchers for this policy. */
  trafficMatchers: Array<PolicyEngineTrafficMatcher>;
  /** The type of policy engine policy, affecting priority. */
  type: PolicyEnginePolicyType;
  /** When this policy was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The type of policy. Affects ordering of policies, policy priorities are ordered amongst their types. */
export enum PolicyEnginePolicyType {
  /** Default path selection. */
  DefaultPathSelection = 'DEFAULT_PATH_SELECTION',
  /** Routing override */
  PreRoutingPolicy = 'PRE_ROUTING_POLICY'
}

/** Configuration for source NAT. */
export type PolicyEngineSourceNatConfiguration = {
  __typename?: 'PolicyEngineSourceNATConfiguration';
  /** The source address configuration. */
  sourceAddress: PolicyEngineNatConfigurationAddress;
  /** The source static port. */
  sourceStaticPort?: Maybe<Scalars['Int']['output']>;
};

/** Configuration for source NAT. */
export type PolicyEngineSourceNatConfigurationInput = {
  /** The source address configuration. */
  sourceAddress: PolicyEngineNatConfigurationAddressInput;
  /** The source static port. */
  sourceStaticPort?: InputMaybe<Scalars['Int']['input']>;
};

/** A traffic matcher that defines what traffic a policy engine policy applies to. */
export type PolicyEngineTrafficMatcher = Identifiable & {
  __typename?: 'PolicyEngineTrafficMatcher';
  /** Unique identifier for this traffic matcher. */
  UUID: Scalars['UUID']['output'];
  /** Optional extended description for the traffic matcher. */
  description?: Maybe<Scalars['String']['output']>;
  /** Destination address prefix to match. At most one of `destinationAddress`, `destinationAddressPattern`, and `destinationTargetInterface` can be set. */
  destinationAddress?: Maybe<Scalars['IPPrefix']['output']>;
  /** Destination IPv4 address pattern to match, e.g. `10.1-4.*.2/31`. At most one of `destinationAddress`, `destinationAddressPattern`, and `destinationTargetInterface` can be set. */
  destinationAddressPattern?: Maybe<Scalars['IPAddressPattern']['output']>;
  /** Destination target interface to match. At most one of `destinationAddress`, `destinationAddressPattern`, and `destinationTargetInterface` can be set. */
  destinationTargetInterface?: Maybe<TargetInterface>;
  /** Destination port ranges to match. */
  dstPortRanges: Array<PortRange>;
  /** Whether the traffic matcher is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Unique name for the traffic matcher. */
  name: Scalars['String']['output'];
  /** This traffic matcher's policy. */
  policy: PolicyEnginePolicy;
  /** Unique identifier for this traffic matcher's policy. */
  policyUUID: Scalars['UUID']['output'];
  /** IANA protocol numbers to match. */
  protocols: Array<IpProtocol>;
  /** Source address prefix to match. At most one of `sourceAddress`, `sourceAddressPattern`, and `sourceTargetInterface` can be set. */
  sourceAddress?: Maybe<Scalars['IPPrefix']['output']>;
  /** Source IPv4 address pattern to match, e.g. `10.1-4.*.2/31`. At most one of `sourceAddress`, `sourceAddressPattern`, and `sourceTargetInterface` can be set. */
  sourceAddressPattern?: Maybe<Scalars['IPAddressPattern']['output']>;
  /** Source target interface to match. At most one of `sourceAddress`, `sourceAddressPattern`, and `sourceTargetInterface` can be set. */
  sourceTargetInterface?: Maybe<TargetInterface>;
  /** Source port ranges to match. */
  srcPortRanges: Array<PortRange>;
};

/** Configuration for twice NAT. */
export type PolicyEngineTwiceNatConfiguration = {
  __typename?: 'PolicyEngineTwiceNATConfiguration';
  /** The destination address configuration. */
  destinationAddress: PolicyEngineNatConfigurationAddress;
  /** The destination static port. */
  destinationStaticPort: Scalars['Int']['output'];
  /** The destination address configuration. */
  sourceAddress: PolicyEngineNatConfigurationAddress;
  /**
   * The destination static port.
   * @deprecated This field is no longer used.
   */
  sourceStaticPort?: Maybe<Scalars['Int']['output']>;
};

/** Configuration for twice NAT. */
export type PolicyEngineTwiceNatConfigurationInput = {
  /** The destination address configuration. */
  destinationAddress: PolicyEngineNatConfigurationAddressInput;
  /** The destination static port. */
  destinationStaticPort: Scalars['Int']['input'];
  /** The source address configuration. */
  sourceAddress: PolicyEngineNatConfigurationAddressInput;
  /** The source static port. */
  sourceStaticPort?: InputMaybe<Scalars['Int']['input']>;
};

/** A policy routing rule sets a policy for some source traffic to some destination traffic over a specific physical interface binding. */
export type PolicyRoutingRule = Identifiable & {
  __typename?: 'PolicyRoutingRule';
  /** The unique identifier for the policy routing rule. */
  UUID: Scalars['UUID']['output'];
  /** The physical interfaces and metrics this rule is bound to. A lower metric takes higher priority. */
  bindings?: Maybe<Array<PolicyRoutingRuleBinding>>;
  /** The timestamp when the policy routing rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The list of destination port ranges for the traffic matching this rule. */
  dstPortRanges: Array<PortRange>;
  /** The destination IP prefix for the traffic matching this rule. */
  dstPrefix: Scalars['IPPrefix']['output'];
  /** Indicates whether the policy routing rule is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** The name of the policy routing rule. */
  name: Scalars['String']['output'];
  /** The network to which this policy routing rule belongs. */
  network: Network;
  /** The unique identifier of the network to which this policy routing rule belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** The list of IP protocols (e.g., TCP, UDP) for the traffic matching this rule. */
  protocols: Array<IpProtocol>;
  /** The list of source port ranges for the traffic matching this rule. */
  srcPortRanges: Array<PortRange>;
  /** The source IP prefix for the traffic matching this rule (optional). */
  srcPrefix?: Maybe<Scalars['IPPrefix']['output']>;
  /** The source VLAN for the traffic matching this rule (optional). */
  srcVLAN?: Maybe<Vlan>;
  /** The timestamp when the policy routing rule was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents a binding between a policy routing rule and a physical interface, including the metric. */
export type PolicyRoutingRuleBinding = {
  __typename?: 'PolicyRoutingRuleBinding';
  /** The unique identifier for the policy routing rule binding. */
  UUID: Scalars['UUID']['output'];
  /** The metric (priority) assigned to the binding. Lower metrics have higher priority. */
  metric: Scalars['Int']['output'];
  /** The physical interface to which the policy routing rule is bound. */
  phyInterface: PhyInterface;
  /** The policy routing rule. */
  rule: PolicyRoutingRule;
};

export type PolicyRoutingRuleBindingInput = {
  /** The UUID of the physical interface to bind the policy routing rule to. The physical interface must be an uplink. */
  phyInterfaceUUID: Scalars['UUID']['input'];
};

/** Properties for port block events. */
export type PortBlockedProperties = {
  __typename?: 'PortBlockedProperties';
  /** The ports associated with the block. */
  phyInterfaces: Array<Maybe<PhyInterface>>;
  /** The virtual device the blocks refer to. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** Aggregates over the whole window for one port error direction. */
export type PortErrorCountSummary = {
  __typename?: 'PortErrorCountSummary';
  /** Number of buckets with at least one error. */
  bucketsWithErrors: Scalars['Int']['output'];
  /** Highest error count in a single bucket. */
  maxPerBucket: Scalars['Int']['output'];
  /** Total errors over the window. */
  total: Scalars['Int']['output'];
};

/** Error counts for one port error direction. */
export type PortErrorCounts = {
  __typename?: 'PortErrorCounts';
  /**
   * Number of errors in each bucket. counts[i] contains the count for the bucket
   * starting at startTime + i * stepSeconds.
   */
  counts: Array<Scalars['Int']['output']>;
  /** Aggregates over the whole window. */
  summary: PortErrorCountSummary;
};

/** A port error direction. */
export enum PortErrorDirection {
  /** Receive errors. */
  Rx = 'RX',
  /** Transmit errors. */
  Tx = 'TX'
}

/** Port error filters that are not part of MetricsFilterInput. */
export type PortErrorFiltersInput = {
  /** Which error directions to return. Must not be empty. */
  directions: Array<PortErrorDirection>;
};

/** Error counts for one port on a device. */
export type PortErrorSeries = {
  __typename?: 'PortErrorSeries';
  /** The type of the virtual device the port belongs to. */
  deviceType: VirtualDeviceType;
  /** The interface name, such as eth0. Set for access point ports. */
  interfaceName?: Maybe<Scalars['String']['output']>;
  /** The UUID of the network the port belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The UUID of the physical interface. Null when the port has no physical interface (access points). */
  phyInterfaceUUID?: Maybe<Scalars['UUID']['output']>;
  /** The physical port number. Set for switch and controller ports. */
  portNumber?: Maybe<Scalars['Int']['output']>;
  /** Receive errors. Null unless RX was requested. */
  rxErr?: Maybe<PortErrorCounts>;
  /** Transmit errors. Null unless TX was requested. */
  txErr?: Maybe<PortErrorCounts>;
  /** The UUID of the virtual device the port belongs to. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** The response containing port error series. Every series shares the one time set up (startTime + stepSeconds). */
export type PortErrorSeriesResponse = {
  __typename?: 'PortErrorSeriesResponse';
  /** The UUID of the company that owns the networks. */
  companyUUID: Scalars['UUID']['output'];
  /** One entry per port with at least one error in the requested directions, ordered by total errors descending. */
  series: Array<PortErrorSeries>;
  /** The start of the first bucket. */
  startTime: Scalars['DateTime']['output'];
  /** The interval in seconds between consecutive entries in every `counts` array. */
  stepSeconds: Scalars['Int']['output'];
};

/** Port forwarding rules for a network define how incoming traffic is forwarded to a local destination. */
export type PortForwardingRule = Identifiable & {
  __typename?: 'PortForwardingRule';
  /** Unique identifier for the port forwarding rule. */
  UUID: Scalars['UUID']['output'];
  /** Restricts the port forwarding rule to only allow traffic to be forwarded if it originates from any of these IP addresses. */
  allowedRemoteIPAddresses?: Maybe<Array<Scalars['IP']['output']>>;
  /** Timestamp when the port forwarding rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Description of the port forwarding rule. */
  description?: Maybe<Scalars['String']['output']>;
  /** The external IP address to which this rule applies. */
  externalIPAddress?: Maybe<Scalars['IP']['output']>;
  /**
   * The external physical interface associated with this rule.
   * @deprecated Use `targetInterface` instead.
   */
  externalPhyInterface?: Maybe<PhyInterface>;
  /**
   * One of `externalPhyInterfaceUUID` or `externalIPAddress` must be set.
   * If `externalPhyInterfaceUUID` is provided, the port forwarding rule only applies to this external physical interface.
   * If `externalIPAddress` is provided, the rule applies to the specified external IP address.
   * Otherwise, the rule will apply to all external interfaces on a device.
   * Application logic will ensure that this interface is an uplink interface.
   * @deprecated Use `targetInterfaceUUID` instead.
   */
  externalPhyInterfaceUUID?: Maybe<Scalars['UUID']['output']>;
  /** The external port from which incoming traffic is forwarded. Null when the rule uses `externalPortRanges`. */
  externalPort?: Maybe<Scalars['Int']['output']>;
  /**
   * External port ranges from which incoming traffic is forwarded, sorted by lower bound.
   * `externalPortRanges[i]` forwards to `localPortRanges[i]`.
   * Empty when the rule uses `externalPort`/`localPort`.
   */
  externalPortRanges: Array<PortRange>;
  /** Indicates whether the port forwarding rule is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** The local IP address to which incoming traffic is forwarded. This must be a single IP. */
  localIPAddress: Scalars['IP']['output'];
  /** The local port to which the external port forwards traffic. Null when the rule uses `localPortRanges`. */
  localPort?: Maybe<Scalars['Int']['output']>;
  /**
   * Local port ranges to which the corresponding `externalPortRanges` entry forwards traffic.
   * Empty when the rule uses `externalPort`/`localPort`.
   */
  localPortRanges: Array<PortRange>;
  /** Name of the port forwarding rule. */
  name: Scalars['String']['output'];
  /** The network to which this port forwarding rule belongs. */
  network: Network;
  /** Unique identifier of the network to which this port forwarding rule belongs. */
  networkUUID: Scalars['UUID']['output'];
  /**
   * The IP protocol to apply this rule on. These are the IANA-defined protocol numbers. 6 = TCP, 17 = UDP. A value of 256 is reserved by IANA and will be used to denote all protocols.
   * @deprecated Use `protocols` instead.
   */
  protocol: PortIpProtocol;
  /** List of IP protocols to match. */
  protocols: Array<PortIpProtocol>;
  /** The interface associated with this rule. */
  targetInterface?: Maybe<TargetInterface>;
  /**
   * One of `targetInterfaceUUID` or `externalIPAddress` must be set.
   * If `targetInterfaceUUID` is provided, the port forwarding rule only applies to the selected interface.
   * If `externalIPAddress` is provided, the rule applies to the specified external IP address.
   * Otherwise, the rule will apply to all external interfaces on a device.
   */
  targetInterfaceUUID?: Maybe<Scalars['UUID']['output']>;
  /** Timestamp when the port forwarding rule was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Supported IP protocols for specifying port ranges. */
export enum PortIpProtocol {
  /** Transmission Control Protocol. */
  Tcp = 'TCP',
  /** User Datagram Protocol. */
  Udp = 'UDP'
}

/** The color of a port's LED */
export enum PortLedColor {
  /** Green colored LED */
  Green = 'GREEN',
  /** White colored LED */
  White = 'WHITE'
}

/** Specifies a mapping of source to destination port numbers, used for device migration. */
export type PortMappingEntryInput = {
  /** The port number on the destination device that the source port should be mapped to. */
  destinationPortNumber: Scalars['Int']['input'];
  /** The port number on the source device. */
  sourcePortNumber: Scalars['Int']['input'];
};

/** Represents a range of ports. */
export type PortRange = {
  __typename?: 'PortRange';
  /** Lower bound of the port range. */
  lower: Scalars['Int']['output'];
  /** Upper bound of the port range. */
  upper: Scalars['Int']['output'];
};

/** Input type for specifying a port range. */
export type PortRangeInput = {
  /** Lower bound of the port range (1-65535). */
  lower: Scalars['Int']['input'];
  /** Upper bound of the port range (1-65535). */
  upper: Scalars['Int']['input'];
};

/** Indicates the type of port. */
export enum PortType {
  /** An Ethernet port. */
  Ethernet = 'ETHERNET',
  /** An SFP port. */
  Sfp = 'SFP',
  /** Unknown port type. */
  Unknown = 'UNKNOWN'
}

/** A request to set the color of the ports LEDs for a specified duration. */
export type PortsSpotlightInput = {
  /** The color of the LED to use. Defaults to white LED. */
  color?: PortLedColor;
  /** The duration to spotlight the LEDs for, in seconds. Defaults to 30 seconds and a max limit of 1hr */
  durationSec?: Scalars['Int']['input'];
  /** The ports whose LEDs need to be turned on. */
  portNumbers: Array<Scalars['Int']['input']>;
  /** The serial number of the device to spotlight LEDs on. */
  serialNumber: Scalars['String']['input'];
  /** Should the LED blink. Defaults to false. */
  shouldBlink?: Scalars['Boolean']['input'];
};

/** A power distribution unit hardware device represents a physical power distribution unit. */
export type PowerDistributionUnitHardwareDevice = HardwareDevice & {
  __typename?: 'PowerDistributionUnitHardwareDevice';
  /** The batch identifier of the hardware device, if any. */
  batch?: Maybe<Scalars['String']['output']>;
  /** Shows the most recent boot history of a device (buildName, bootCount). */
  bootHistory: Array<BootInfo>;
  /** The active config override for this device, if any. */
  configOverride?: Maybe<DeviceConfigOverride>;
  /** The timestamp when the hardware device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** The model name of the hardware device. */
  deviceModel: DeviceModel;
  /** The type of the hardware device. */
  deviceType: DeviceType;
  /** If the device is no longer connected to the backend, this is the time at which it was last connected. */
  disconnectedFromBackendAt?: Maybe<Scalars['DateTime']['output']>;
  /** The hardware generation of the device. */
  hardwareGeneration: HardwareGeneration;
  /** Metadata for the model of this device. */
  hardwareModelProperties: HardwareModelProperties;
  /** Internal operator-only notes about this hardware device. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /**
   * True if the device has an active websocket connection to the backend. Note that this only works if the device has registered via the /v2/register endpoint (i.e., is a Config 2 device) - otherwise is always false.
   * @deprecated Use `isSpare` instead.
   */
  isActive: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is connected to the backend. */
  isConnectedToBackend: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /**
   * Indicates whether the hardware device is marked as a development (dev) device, moving it into the dev (staging) realm for testing purposes.
   * @deprecated Use `realm` instead. isDev is equivalent to realm == DEV.
   */
  isDev: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is in factory mode. */
  isFactoryMode: Scalars['Boolean']['output'];
  /** True if the PDU's MAC address exists in the most recent controller MAC table for the network. */
  isInCurrentControllerMACTable: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is an RMA (Return Merchandise Authorization) replacement device. */
  isRMA: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device has been retired. */
  isRetired: Scalars['Boolean']['output'];
  /** A spare hardware device belongs to a network but is not assigned to a virtual device. Spares are typically kept on site as replacements and are not in service. */
  isSpare: Scalars['Boolean']['output'];
  /** The latest device config metadata (ie. the config without the actual JSON payload) for the device. */
  latestDeviceConfigMetadata?: Maybe<DeviceConfigMetadata>;
  /** The MAC address of the hardware device. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** The UUID of the network that the hardware device belongs to. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** The physical interface (on a Meter Switch) that the power distribution unit is connected to, if applicable. */
  phyInterfaceConnectedTo?: Maybe<PhyInterface>;
  /**
   * If the power distribution unit is not currently connected to a physical interface on a Meter Switch (ie. `phyInterfaceConnectedTo` is null),
   * then this field will be populated with the physical interface that the power distribution unit was last connected to, if applicable and known.
   * Only returns a result if the PDU was connected to a Switch in the last 30 days and the network is on a sufficient NOS version that reports LLDP stats.
   */
  phyInterfaceLastConnectedTo?: Maybe<PhyInterfaceConnectedAt>;
  /** The public key used to add the device to the jumphost's WireGuard interface. */
  publicKey?: Maybe<Scalars['String']['output']>;
  /** The realm that owns this hardware device. Used for cross-realm device management. */
  realm: HardwareDeviceRealm;
  /** The unique serial number of the hardware device. */
  serialNumber: Scalars['String']['output'];
  /** The network that the spare hardware device belongs to. Spare hardware devices that are not affiliated with a virtual device will have this field populated. */
  spareDeviceNetwork?: Maybe<Network>;
  /** IPv6 address on the jumphost subnet. Used to send requests to the device. */
  tunnelIPAddress?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the hardware device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The uptime metrics from the time series database for the device.
   * @deprecated Use `VirtualDevice.uptime` instead.
   */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** The virtual device associated with this hardware device, if any. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The UUID of the virtual device this hardware device is assigned to, if any. */
  virtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
};


/** A power distribution unit hardware device represents a physical power distribution unit. */
export type PowerDistributionUnitHardwareDeviceBootHistoryArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

/** A power distribution unit virtual device is a logical representation of a physical power distribution unit. */
export type PowerDistributionUnitVirtualDevice = Identifiable & TargetInterface & VirtualDevice & {
  __typename?: 'PowerDistributionUnitVirtualDevice';
  /** The unique identifier (UUID) of the virtual device. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the virtual device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** An optional description for the virtual device. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Metadata for the configurations rendered for this virtual device over time, newest
   * first. Includes configs written to hardware devices that have since been dissociated
   * from this virtual device. Omits the rendered config JSON for performance.
   */
  deviceConfigs: Array<DeviceConfigMetadata>;
  /** The model name of the virtual device. */
  deviceModel: DeviceModel;
  /** The device temperature of the PDU in degrees Celsius. */
  deviceTemperatureCelsius?: Maybe<Scalars['Float']['output']>;
  /** The type of the virtual device. */
  deviceType: VirtualDeviceType;
  /** The Ethernet interface speed of the PDU in Mbps. */
  ethernetSpeedMbps?: Maybe<Scalars['Int']['output']>;
  /** The hardware device associated with this virtual device, if any. */
  hardwareDevice?: Maybe<HardwareDevice>;
  /** Metadata for the model of this device. */
  hardwareModelProperties: HardwareModelProperties;
  /** The management IP address of the device. */
  ipAddress?: Maybe<Scalars['IP']['output']>;
  /** Indicates whether the PDU's circuit breaker is functioning properly. */
  isCircuitBreakerGood?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the virtual device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether debug logging is enabled on the virtual device. */
  isDebugLogEnabled: Scalars['Boolean']['output'];
  /** Whether this virtual device is in a draft state for preconfiguration reasons. */
  isDraft: Scalars['Boolean']['output'];
  /** Indicates whether the PDU is properly grounded. */
  isGrounded?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the hardware device is online, indicated by its heartbeat. */
  isOnline: Scalars['Boolean']['output'];
  /**
   * Read-only devices cannot be modified until this is set to false.
   * This also prevents sub-entities from being modified.
   */
  isReadonly: Scalars['Boolean']['output'];
  /** Indicates whether the PDU's surge protection is functioning properly. */
  isSurgeProtectionGood?: Maybe<Scalars['Boolean']['output']>;
  /** A human-friendly name for the device. */
  label: Scalars['String']['output'];
  /** The physical location of this virtual device, derived from its rack elevation placement. */
  location?: Maybe<VirtualDeviceLocation>;
  /** The maximum allowed power for the PDU in watts. */
  maxPowerAllowedWatts?: Maybe<Scalars['Float']['output']>;
  /** The most recent NOS upgrade for this virtual device that has started executing or was skipped (in progress, completed, failed, or skipped), if any. */
  mostRecentNOSUpgrade?: Maybe<ScheduledDeviceNosUpgrade>;
  /** The network that the virtual device belongs to. */
  network: Network;
  /** The unique identifier (UUID) of the network the virtual device belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The group that the device belongs to for firmware upgrade grouping purposes. */
  nosUpgradeGroup: NosUpgradeGroup;
  /** The current NOS firmware version that the virtual device is configured to run. */
  nosVersion?: Maybe<ConfiguredNosVersion>;
  /** The identifier of the NOS firmware version that the virtual device is configured to run. */
  nosVersionID: Scalars['Int']['output'];
  /** The power distribution unit's active or future notification snoozes */
  notificationSnoozes: Array<DeviceNotificationSnooze>;
  /** The outlet interfaces of the PDU. */
  outletInterfaces: Array<OutletInterface>;
  /** The paired virtual device to this device, applicable to dual-chassis configurations. */
  pairedVirtualDevice?: Maybe<PowerDistributionUnitVirtualDevice>;
  /** The NOS firmware version that the virtual device is scheduled to upgrade to. */
  pendingNosVersion?: Maybe<PendingNosVersion>;
  /** URL to the regulatory e-label for the device, if applicable. */
  regulatoryLabelURL?: Maybe<Scalars['String']['output']>;
  /** The virtual device tags on this device. */
  tags: Array<VirtualDeviceTag>;
  /** Data about this virtual device's position in its network's topology. */
  topologyData?: Maybe<VirtualDeviceTopologyData>;
  /** The total power usage of the PDU in watts. */
  totalPowerUsedWatts?: Maybe<Scalars['Float']['output']>;
  /** The timestamp when the virtual device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /** How long the device has been continuously powered on and reporting. */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** The position of this virtual device within its device pair (left or right). Null if not part of a pair. */
  virtualDevicePairPosition?: Maybe<DevicePosition>;
};


/** A power distribution unit virtual device is a logical representation of a physical power distribution unit. */
export type PowerDistributionUnitVirtualDeviceDeviceConfigsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};

/** Represents a calculated power plan for a network. */
export type PowerPlan = {
  __typename?: 'PowerPlan';
  /** The unique identifier of the calibration job associated with this power plan. */
  calibrationJobUUID: Scalars['UUID']['output'];
  /** The SNR interference threshold with which the ATX algorithm was run with (dBm). */
  interferenceThreshold: Scalars['Int']['output'];
  /** The interferers that we expect each AP to have on this power plan. */
  interferers: Array<PowerPlanInterferer>;
  /** The maximum tx power (dBm) for the power plan. */
  maxTxPower: Scalars['Int']['output'];
  /** The minimum power an AP should see at least one other AP at (dBm). */
  minPowerToAnotherAP: Scalars['Int']['output'];
  /** The minimum tx power (dBm) for the power plan. */
  minTxPower: Scalars['Int']['output'];
  /** The unique identifier of the network the power plan is for. */
  networkUUID: Scalars['UUID']['output'];
  /** The number of interferers the ATX algorithm was calculated with. */
  numberOfInterferers: Scalars['Int']['output'];
  /** The associated power settings for this power plan. */
  powerSetting: Array<PowerSetting>;
};

/** The input for generating a power plan. */
export type PowerPlanInput = {
  /** The SNR interference threshold to run the ATX algorithm with (dBm). */
  interferenceThreshold: Scalars['Int']['input'];
  /** The maximum tx power (dBm) to run the ATX algorithm with. */
  maxTxPower: Scalars['Int']['input'];
  /** The minimum power an AP should see at least one other AP at (dBm). */
  minPowerToAnotherAP: Scalars['Int']['input'];
  /** The minimum tx power (dBm) to run the ATX algorithm with. */
  minTxPower: Scalars['Int']['input'];
  /** The number of interferers to run the ATX algorithm with. */
  numberOfInterferers: Scalars['Int']['input'];
};

/** Represents the interferer list for a single AP for the given power plan. */
export type PowerPlanInterferer = {
  __typename?: 'PowerPlanInterferer';
  /** The access point virtual device that has interfering APs. */
  accessPoint: AccessPointVirtualDevice;
  /** The access point virtual devices that are interferers. */
  interfererAccessPoints: Array<AccessPointVirtualDevice>;
};

/** Represents a power setting for a single AP for the given power plan. */
export type PowerSetting = {
  __typename?: 'PowerSetting';
  /** The access point virtual device for which to suggest a power setting. */
  accessPoint: AccessPointVirtualDevice;
  /** The calculated power setting (dBm) for the 5G radio of the access point. */
  txPower: Scalars['Int']['output'];
};

/** An enumeration of possible principal types for authentication tokens. */
export enum PrincipalType {
  /** A device principal, representing a hardware device. */
  Device = 'DEVICE',
  /** A machine principal, a virtual or physical machine. */
  Machine = 'MACHINE',
  /** A user principal, representing a human user. */
  User = 'USER'
}

/** Global proactive packet capture configuration for a network. */
export type ProactivePcapNetworkConfig = {
  __typename?: 'ProactivePcapNetworkConfig';
  /** The unique identifier for this configuration. */
  UUID: Scalars['UUID']['output'];
  /** When the configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Whether proactive packet capture is enabled globally for the network.
   * @deprecated Proactive pcap enablement is now derived from per-SSID configs. This returns whether any SSID in the network has proactive pcap enabled.
   */
  isEnabled: Scalars['Boolean']['output'];
  /** For the same client and same type of event, minimum interval in seconds before exporting another pcap. 0 means use firmware default (30 minutes). */
  maxPcapFreqSec: Scalars['Int']['output'];
  /** The network this configuration belongs to. */
  network: Network;
  /** The UUID of the network. */
  networkUUID: Scalars['UUID']['output'];
  /** When the configuration was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Per-SSID proactive packet capture configuration. */
export type ProactivePcapSsidConfig = {
  __typename?: 'ProactivePcapSSIDConfig';
  /** The unique identifier for this configuration. */
  UUID: Scalars['UUID']['output'];
  /**
   * List of 802.11 disassociation reason codes to capture.
   * If empty and isCaptureDisassocsEnabled is true, all disassociations are captured.
   */
  captureDisassocsReasonCodes: Array<Scalars['Int']['output']>;
  /** When the configuration was created. */
  createdAt: Scalars['DateTime']['output'];
  /** List of client MAC addresses to follow for all pcap events. */
  followedClientMacs: Array<Scalars['MacAddress']['output']>;
  /** Whether disassociation events are captured. */
  isCaptureDisassocsEnabled: Scalars['Boolean']['output'];
  /** Whether to capture successful connection events. */
  isCaptureSuccessEnabled: Scalars['Boolean']['output'];
  /** Whether proactive packet capture is enabled for this SSID. */
  isEnabled: Scalars['Boolean']['output'];
  /** The network this configuration belongs to. */
  network: Network;
  /** The UUID of the network. */
  networkUUID: Scalars['UUID']['output'];
  /** The SSID this configuration applies to. */
  ssid: Ssid;
  /** The UUID of the SSID this configuration applies to. */
  ssidUUID: Scalars['UUID']['output'];
  /** When the configuration was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Problematic client entry. */
export type ProblematicClientEntry = {
  __typename?: 'ProblematicClientEntry';
  /** The radio band of the client's latest sample. */
  band: RadioBand;
  /** The network client, if available. */
  client?: Maybe<NetworkClient>;
  /** Whether the client's latest sample is on a legacy HW mode (WiFi 1/2/3/4). */
  isLegacy: Scalars['Boolean']['output'];
  /** The MAC address of the client. */
  macAddress: Scalars['MacAddress']['output'];
  /**
   * The median across samples in the window of TX MCS as a percentage of the client's max MCS for its mode at the time (0-100).
   * Null when the max MCS is unknown, in which case the client is never flagged LOW_MCS.
   */
  mcsPercent?: Maybe<Scalars['Float']['output']>;
  /** The UUID of the network this client belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /**
   * The primary reason the client might be problematic.
   * @deprecated Use reasons instead
   */
  reason: ProblematicClientReason;
  /** All reasons the client might be problematic. */
  reasons: Array<ProblematicClientReason>;
  /** TX retries as a percentage of TX attempts (successful packets plus retries) in the window (0-100). */
  retryPercent: Scalars['Float']['output'];
  /** The median signal-to-noise ratio across samples in the window, in dB. */
  snr: Scalars['Float']['output'];
  /** The virtual device of the client's latest sample. */
  virtualDevice: VirtualDevice;
  /** The UUID of the virtual device of the client's latest sample. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** A problematic client reason. */
export enum ProblematicClientReason {
  /** Client has a high retry rate */
  HighRetryRate = 'HIGH_RETRY_RATE',
  /** Client is on a legacy HW mode */
  LegacyClient = 'LEGACY_CLIENT',
  /** Client has a suboptimal MCS */
  LowMcs = 'LOW_MCS',
  /** Client has a poor coverage */
  PoorCoverage = 'POOR_COVERAGE'
}

/** Filter for problematic clients. */
export type ProblematicClientsFilter = {
  /** The radio band to filter the clients by. */
  band?: InputMaybe<RadioBand>;
  /** The lookback duration. */
  duration?: Scalars['Duration']['input'];
  /** The end time for the lookback. If omitted defaults to the current time. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Flag HIGH_RETRY_RATE if retries exceed this percentage of TX packets. Default 15. */
  highRetryRateThresholdPercent?: Scalars['Int']['input'];
  /** Flag LOW_MCS if p50 TX MCS is below this percentage of max negotiated MCS. Default 60. */
  lowMcsThresholdPercent?: Scalars['Int']['input'];
  /** Flag POOR_COVERAGE if p50 SNR is below this value in dB. Default 20. */
  poorCoverageSnrThreshold?: Scalars['Int']['input'];
  /** Only return clients with these reasons. If not provided, all reasons are returned. */
  reasons?: InputMaybe<Array<ProblematicClientReason>>;
  /** The virtual device to filter the clients by. */
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Connected, active and idle client totals. */
export type ProblematicClientsSummary = {
  __typename?: 'ProblematicClientsSummary';
  /** Clients with TX MCS data, enough association time and enough airtime in the window. These are the clients evaluated for problems. */
  activeClients: Scalars['Int']['output'];
  /** Clients in totalClients that are not active: too little association time, airtime or TX MCS data. */
  idleClients: Scalars['Int']['output'];
  /** Unique wireless clients on the access point and band in the window, however little they did, counted like the network's active clients: a row in the window with a wireless sample under an hour old. Equals activeClients plus idleClients. */
  totalClients: Scalars['Int']['output'];
};

/** Contract terms a Provider offers for a given connection type. */
export type ProviderConnectionTypeTerm = {
  __typename?: 'ProviderConnectionTypeTerm';
  /** Unique identifier for the Provider Connection Type Term. */
  UUID: Scalars['UUID']['output'];
  /** Product type the term applies to. */
  connectionType: InternetServicePlanConnectionType;
  /** Timestamp of when the Provider Connection Type Term was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Term of contract in months. */
  termMonths: Scalars['Int']['output'];
  /** Timestamp of when the Provider Connection Type Term was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A contract term a provider offers for a connection type. */
export type ProviderConnectionTypeTermInput = {
  /** UUID of the connection type the term applies to. */
  connectionTypeUUID: Scalars['UUID']['input'];
  /** Term of contract in months. */
  termMonths: Scalars['Int']['input'];
};

/** Serviceability of one provider and connection type, resolved from all availability sources. */
export type ProviderServiceability = {
  __typename?: 'ProviderServiceability';
  /** Availability resolved across all sources by source priority. */
  availability: LocationProviderAvailability;
  /** Connection type the serviceability applies to. */
  connectionType: InternetServicePlanConnectionType;
  /** Estimated days to install, from the product and availability. Speeds of 2 Gbps or more can take longer. Null when the product has no install timeline. */
  installationEstimateDays?: Maybe<Scalars['Int']['output']>;
  /** Customer-facing product group of the connection type, when it has one. */
  productGroup?: Maybe<ConnectProductGroup>;
  /** Provider the serviceability applies to. */
  provider: InternetServicePlanProvider;
  /** Whether the product is eligible for recommendations: it has a product group and a contract term, and either an ON_NET source or a NEAR_NET/OFF_NET source marked recommendable. */
  recommendable: Scalars['Boolean']['output'];
  /** Availability records this serviceability was resolved from. */
  sources: Array<LocationProviderAvailabilitySource>;
};

/** An API key used to authenticate requests to the Meter API. */
export type PublicApiKey = {
  __typename?: 'PublicAPIKey';
  /** The unique UUID identifier for the key. */
  UUID: Scalars['UUID']['output'];
  /** The access level the key was minted with. */
  accessLevel: ApiKeyAccessLevel;
  /** The UUID of the company this key belongs to. */
  companyUUID: Scalars['UUID']['output'];
  /** The timestamp when the key was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The email of the user who created the key. */
  createdBy: Scalars['String']['output'];
  /** The user who created the key. */
  createdByUser: User;
  /** The timestamp when the key expires, if applicable. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The timestamp when the key was last used, if ever. */
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The human readable name for the key. */
  name: Scalars['String']['output'];
  /** The overrides set on this key, if any. */
  rateLimitOverrides: PublicApiKeyRateLimitOverrides;
  /** The rate limits currently in effect for this key. */
  rateLimits: PublicApiKeyRateLimits;
  /** The timestamp when the key was revoked, if applicable. */
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Expiration intervals for public API keys. If not specified, the key will not expire. */
export enum PublicApiKeyExpirationInterval {
  /** Key expires after 30 days. */
  Days_30 = 'DAYS_30',
  /** Key expires after 180 days. */
  Days_180 = 'DAYS_180',
  /** Key expires after 365 days. */
  Days_365 = 'DAYS_365',
  /** Key expires after 1 day. */
  Day_1 = 'DAY_1'
}

/** A request to grant a public API key access to an additional company. */
export type PublicApiKeyGrantRequest = {
  __typename?: 'PublicAPIKeyGrantRequest';
  /** The unique UUID identifier for the request. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the request was filed. */
  createdAt: Scalars['DateTime']['output'];
  /** The timestamp after which the request can no longer be approved. */
  expiresAt: Scalars['DateTime']['output'];
  /** The public API key that would receive access. */
  key: PublicApiKey;
  /** The UUID of the public API key that would receive access. */
  keyUUID: Scalars['UUID']['output'];
  /** The user who filed the request. */
  requestedByUser: User;
  /** The company the key is asking to reach. Never the key's owning company. */
  requestedCompany: Company;
  /** The UUID of the company the key is asking to reach. */
  requestedCompanyUUID: Scalars['UUID']['output'];
  /** The timestamp when the request was resolved, if it has been. */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who approved, rejected, or cancelled the request. */
  resolvedByUser?: Maybe<User>;
  /** The timestamp when the grant this request created was revoked. */
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who revoked the grant this request created, if it has been revoked. */
  revokedByUser?: Maybe<User>;
  /** The current state. */
  status: PublicApiKeyGrantRequestStatus;
};

/** The state of a request to grant a public API key access to a company. */
export enum PublicApiKeyGrantRequestStatus {
  /** Approved, the grant has been applied. */
  Approved = 'APPROVED',
  /** Withdrawn by the requester. */
  Cancelled = 'CANCELLED',
  /** Went unapproved past its expiry window and can no longer be approved. */
  Expired = 'EXPIRED',
  /** Awaiting approval. */
  Pending = 'PENDING',
  /** Rejected by an approver. */
  Rejected = 'REJECTED',
  /** The grant has been revoked and the key no longer reaches the company. */
  Revoked = 'REVOKED'
}

/**
 * The rate limit overrides stored on a single key. A null field means the key
 * carries no override for that limit and inherits the default for all keys.
 */
export type PublicApiKeyRateLimitOverrides = {
  __typename?: 'PublicAPIKeyRateLimitOverrides';
  /**
   * Complexity points the key may accumulate, or null when the key inherits
   * the default.
   */
  complexityBucketCapacity?: Maybe<Scalars['Int']['output']>;
  /** Requests per minute, or null when the key inherits the default. */
  requestRateLimit?: Maybe<Scalars['Int']['output']>;
  /** Mutations per minute, or null when the key inherits the default. */
  writeRateLimit?: Maybe<Scalars['Int']['output']>;
};

/** A set of public API rate limit values. */
export type PublicApiKeyRateLimits = {
  __typename?: 'PublicAPIKeyRateLimits';
  /** Complexity points the key may accumulate. */
  complexityBucketCapacity: Scalars['Int']['output'];
  /** Requests per minute. */
  requestRateLimit: Scalars['Int']['output'];
  /** Mutations per minute. */
  writeRateLimit: Scalars['Int']['output'];
};

/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type Query = {
  __typename?: 'Query';
  /**
   * Retrieve the OUIs belonging to the given vendor. Accepts a substring of the vendor name and
   * returns all OUIs belonging to vendors whose names contain the substring.
   */
  OUIsForVendor: Array<OuIsForVendorResult>;
  /** Get the access point port profiles for a network. */
  accessPointPortProfilesForNetwork: Array<AccessPointPortProfile>;
  /** Active clients are clients that currently appear both in the MAC and ARP tables of one or more networks, as a single series. */
  activeClients: ActiveClientsMetricsResponse;
  /** The IPS rules that are active for a given network. */
  activeIPSRules: Array<ActiveIpsRule>;
  /** Get the active underlay pool for a network. */
  activeUnderlayPoolForNetwork?: Maybe<UnderlayPool>;
  /** Given one CVE ID (e.g. 'CVE-2023-12345'), list all affected clients. */
  affectedClientsByCVE: Array<AffectedClient>;
  /** Given multiple CVE IDs, list all affected clients. */
  affectedClientsByCVEIDs: Array<AffectedClient>;
  /** Get a list of alert company subscriptions. */
  alertCompanySubscriptionsForCompany: Array<AlertCompanySubscription>;
  /** Get all alert deprioritization window configurations. */
  alertDeprioritizationWindows: Array<AlertDeprioritizationWindow>;
  /** Get the history of alert subscription evaluation states for a network. Only returns state changes. */
  alertEvaluationStateHistoryForNetwork: Array<AlertSubscriptionEvaluationState>;
  /** Get the history of alert subscription evaluation states for a fleetwide subscription. */
  alertEvaluationStateHistoryForNetworkFleetwideSubscription: Array<AlertSubscriptionEvaluationState>;
  /** Get a list of alert fleetwide subscriptions. */
  alertFleetwideSubscriptions: Array<AlertFleetwideSubscription>;
  /** Get an alert receiver and its targets. */
  alertReceiver: AlertReceiver;
  /** Get all alert receivers and their targets for a company. */
  alertReceiversForCompany: Array<AlertReceiver>;
  /** Get a specific Salesforce alert target by its UUID. */
  alertTargetSalesforce: AlertTargetSalesforce;
  /** Get a specific Slack alert target by its UUID. */
  alertTargetSlack: AlertTargetSlack;
  /** Get a specific webhook alert target by its UUID. */
  alertTargetWebhook: AlertTargetWebhook;
  /** Get all alert targets for a specified company UUID. */
  alertTargets: AlertTargetsResponse;
  /** Get all Salesforce alert targets for a company. */
  alertTargetsSalesforce: Array<AlertTargetSalesforce>;
  /** Get all Slack alert targets for a company. */
  alertTargetsSlack: Array<AlertTargetSlack>;
  /** Get all webhook alert targets for a company. */
  alertTargetsWebhook: Array<AlertTargetWebhook>;
  /** List all supported alert types and their properties. */
  alertTypeProperties: Array<AlertTypeProperties>;
  /** Return all CVEs for every client in a network. */
  allCVEsForNetwork: Array<Cve>;
  /** Timeseries data of data usage metrics for a single client. */
  allClientMetricsByClient: AllClientMetricsTimeseriesResponse;
  /** Timeseries data of data usage metrics for clients on a VLAN. */
  allClientMetricsByVLAN: AllClientMetricsTimeseriesResponse;
  /** All Internet service plans (not scoped to networks) for use by operators. */
  allInternetServicePlans: InternetServicePlanPage;
  /** Get all marketing changelog entries. */
  allMarketingChangelogEntries: Array<MarketingChangelogEntry>;
  /** Lists Quote Requests. */
  allQuoteRequests: QuoteRequestPage;
  /** Metadata for built in roles the current user has access to. */
  allRoles: Array<RoleMetadata>;
  /** Fetch aggregated anomaly stats for multiple virtual devices. */
  anomalyStatsGroupsForVirtualDevices: Array<AnomalyStatsGroup>;
  /** Retrieves health scores for a specified access point over the requested time range. */
  apHealthScores: Array<AccessPointHealthScores>;
  /** List all API keys for a company. */
  apiKeysForCompany: Array<PublicApiKey>;
  /** Get an application DNS firewall rule. */
  applicationDNSFirewallRule: ApplicationDnsFirewallRule;
  /** Given a hostname, returns the application that would be applied to it. */
  applicationDNSFirewallRuleApplicationForHostname: ApplicationDnsFirewallRuleApplication;
  /**
   * Fetch all applications that DNS firewall rules can be associated with.
   * This currently returns all applications – in the future this will only return visible applications for customers.
   */
  applicationDNSFirewallRuleApplications: Array<ApplicationDnsFirewallRuleApplication>;
  /** Fetch all available Categories of DNS firewall rules. */
  applicationDNSFirewallRuleCategories: Array<ApplicationDnsFirewallRuleCategory>;
  /** Given a hostname, returns the category of DNS firewall rule that would be applied to it. */
  applicationDNSFirewallRuleCategoryForHostname: ApplicationDnsFirewallRuleCategory;
  /** Fetch all groups of DNS firewall rules. */
  applicationDNSFirewallRuleGroups: Array<ApplicationDnsFirewallRuleGroup>;
  /** Fetch all application DNS firewall rules for a network. */
  applicationDNSFirewallRulesForNetwork: Array<ApplicationDnsFirewallRule>;
  /**
   * Check if multiple NOS features are enabled for any network in a company.
   * In development environments, this always returns true for a key if it is not recognized on the backend.
   * This checks if *any* network for the specified company supports the NOS features.
   */
  areNosFeaturesEnabledForCompany: Array<NosFeatureEnabled>;
  /**
   * Check if multiple NOS features are enabled for a network.
   * In development environments, this always returns true for a key if it is not recognized on the backend.
   */
  areNosFeaturesEnabledForNetwork: Array<NosFeatureEnabled>;
  /** Fetch an authentication token by its unique identifier (UUID). */
  authenticationToken: AuthenticationToken;
  /** Get an Auto Channel Selection Job by its UUID. */
  autoChannelSelectionJob: AutoChannelSelectionJob;
  /** List Auto Channel Selection Jobs for a network, most recently scheduled first. */
  autoChannelSelectionJobsForNetwork: Array<AutoChannelSelectionJob>;
  /** Fetch a Switch Auto Configuration Job by its UUID. */
  autoSwitchConfigurationJob: SwitchAutoConfigurationJob;
  /** Fetch all Switch Auto Configuration Jobs for a network. */
  autoSwitchConfigurationJobsForNetwork: Array<SwitchAutoConfigurationJob>;
  /** Timeseries of BGP session state between hubs in an Auto VPN group, one series per hub pair. */
  autoVPNBGPNeighborHubStateMetrics: Array<AutoVpnHubBgpNeighborStateMetricsResponse>;
  /** Timeseries of BGP session state between hubs and members in an Auto VPN group, one series per hub-member pair. */
  autoVPNBGPNeighborMemberStateMetrics: Array<AutoVpnMemberBgpNeighborStateMetricsResponse>;
  /** Get an Auto VPN group by its UUID. */
  autoVPNGroup: AutoVpnGroup;
  /** Lists Auto VPN Groups for a company. */
  autoVPNGroupsForCompany: Array<AutoVpnGroup>;
  /** Lists Auto VPN Groups for a network. */
  autoVPNGroupsForNetwork: Array<AutoVpnGroup>;
  /** Gets an Auto VPN Member by its UUID. */
  autoVPNMember: AutoVpnMember;
  /** Timeseries data of data usage metrics for members of an Auto VPN group. */
  autoVPNMemberMetricsForCompany: Array<AutoVpnMemberMetricsResponse>;
  /** Retrieves an autonomous system by its Autonomous System Number (ASN). */
  autonomousSystem: AutonomousSystem;
  /**
   * Retrieves an existing bearer session by its UUID. A CLI session creates a one-time-use bearer session that must be
   * verified before issuing a token. Once it is verified, the session can no longer be used.
   */
  bearerSession: BearerSession;
  /** Retrieves a BGP neighbor by its unique identifier. */
  bgpNeighbor: BgpNeighbor;
  /** Retrieves a BGP router by its unique identifier. */
  bgpRouter: BgpRouter;
  /** Returns all currently blocked clients for the given network. */
  blockedClientsForNetwork: Array<NetworkClientBlocklistEntry>;
  /** Returns blocked clients scoped to the given SSID. */
  blockedClientsForSSID: Array<NetworkClientBlocklistEntry>;
  /** Return all of the BSSIDs associated with hardware devices linked to virtual devices in a given network. */
  bssidsForNetwork: Array<Bssid>;
  /** Get a Bulk NOS upgrade by UUID. */
  bulkNOSUpgrade: BulkNosUpgrade;
  /** List Bulk NOS upgrades with the given filter. */
  bulkNOSUpgrades: Array<BulkNosUpgrade>;
  /** Gets a captive portal. */
  captivePortal: CaptivePortal;
  /** Returns all clients that have seen or interacted with the captive portal in the last specified amount of hours. May contain duplicate clients. */
  captivePortalAllClients: Array<CaptivePortalClient>;
  /** Returns authorized clients to the captive portal in the last specified amount of hours. */
  captivePortalAuthorizedClients: Array<CaptivePortalClient>;
  /** Returns a page of captive portal entries for a captive portal. */
  captivePortalEntries: CaptivePortalEntriesTablePage;
  /** Returns a page of captive portal entries for a captive portal along with total count of entries for the given filter. */
  captivePortalEntriesForPortal: CaptivePortalEntryPage;
  /** Returns a captive portal entry. */
  captivePortalEntry: CaptivePortalEntry;
  /** Get the filters available for captive portal entries. */
  captivePortalEntryFilters: Array<FilterDefinition>;
  /**
   * Gets the enabled captive portal for a network, if any.
   * @deprecated Use `captivePortalsForNetwork` instead.
   */
  captivePortalForNetwork?: Maybe<CaptivePortal>;
  /** Gets the captive portal attached to a VLAN. */
  captivePortalForVLAN?: Maybe<CaptivePortal>;
  /** Gets a captive portal by its webhook key. */
  captivePortalForWebhook?: Maybe<CaptivePortal>;
  /** Gets a captive portal. */
  captivePortalWithSignature: CaptivePortal;
  /** Lists network-level captive portals for a network. */
  captivePortalsForNetwork: Array<CaptivePortal>;
  /** Returns one timeseries per radio band for all of the radio bands broadcasted by the AP. */
  channelUtilizationByAP: Array<ChannelUtilizationResponseV2>;
  /** Returns a timeseries for channel utilization for the client, aggregated over the APs that the client has been connected to. */
  channelUtilizationByClient: Array<ClientChannelUtilizationTimeseriesValue>;
  /** Returns a time series for each radio band for the APs in the network. */
  channelUtilizationByNetwork: Array<ChannelUtilizationResponseV2>;
  /** Get client observer tests for a specific network and client device. */
  clientObserverTests: Array<ClientObserverTest>;
  /** Whether the network's access points can ping their clients. */
  clientPingSweepIsSupportedForNetwork: Scalars['Boolean']['output'];
  /** Retrieve the results or check the status of a specific client ping sweep job. */
  clientPingSweepJob: ClientPingSweepJob;
  /** Get the filters available for a network's client ping sweep history. */
  clientPingSweepJobFilters: Array<FilterDefinition>;
  /**
   * List a network's client ping sweep jobs, newest first. Per-client results are
   * not included, fetch clientPingSweepJob for a single sweep's results.
   */
  clientPingSweepJobsForNetwork: ClientPingSweepJobPage;
  /** Get a Client VPN client. */
  clientVPNClient: ClientVpnClient;
  /** Timeseries data of data usage metrics for Client VPN client. */
  clientVPNClientMetrics: Array<ClientVpnServerMetricsResponse>;
  /** Lists Client VPN clients for a Client VPN server. */
  clientVPNClients: Array<ClientVpnClient>;
  /** Get a Client VPN server. */
  clientVPNServer: ClientVpnServer;
  /** Lists Client VPN servers for a Network. */
  clientVPNServers: Array<ClientVpnServer>;
  /**
   * Per-sample wireless experience scores for a single client over a time range.
   * Returns one scored sample per aggregation interval, with component scores,
   * raw measurements, and band/AP context for the insights view.
   */
  clientWirelessScores: ClientWirelessScoreResponse;
  /**
   * Aggregated wireless experience scores for all clients on a network over a time range.
   * Returns one summary per client with p50 scores across all active samples.
   * Filterable by band, AP, and SSID.
   */
  clientWirelessScoresByNetwork: Array<ClientWirelessScoreSummary>;
  /** Get all the companies that the current API key has access to. */
  companiesForAPIKey: Array<Company>;
  /**
   * Get all the companies that contain global network templates.
   * Partners must be added to the Global Templates company to have access.
   */
  companiesHoldingGlobalNetworkTemplates: Array<Company>;
  /** Get a company by its UUID. */
  company: Company;
  /** Get a company by its slug. */
  companyBySlug: Company;
  /** Get all the companies that the user is a member of. */
  companyMemberships: Array<Company>;
  /** Get a company user by UUID. */
  companyUser: CompanyUser;
  /** List all company users for the specified company. */
  companyUsers: Array<CompanyUser>;
  /** List all available compliance frameworks */
  complianceFrameworks: Array<ComplianceFramework>;
  /** Get a specific compliance report by ID */
  complianceReport: ComplianceReport;
  /** Get all compliance reports for a network */
  complianceReportsForNetwork: Array<ComplianceReport>;
  /** Gets an Connect Static Rate. */
  connectStaticRate: ConnectStaticRate;
  /** Lists all Connect Static Rates. */
  connectStaticRates: Array<ConnectStaticRate>;
  /** Get recent console login challenges for a device. */
  consoleLogins: Array<ConsoleLogin>;
  /** Timeseries data of requests/sec per DNS server for a single controller. */
  controllerDNSRequestRates: ControllerDnsRequestRatesResponse;
  /** Per port timeseries metrics data as a rate per second for a single controller. */
  controllerPortMetricsRate: ControllerPortMetricsRateResponse;
  /** Per port stats for a specified controller over a lookback period. Encompasses receive/transmission data counters and hardware operational status. */
  controllerPortStats: Array<ControllerPortStat>;
  /**
   * Count how many CVEs exist for each severity, for a given MAC + Network.
   * Used for the 'high/medium/low' columns in the client UI.
   */
  countCVEsBySeverityForMACAddressesBulk: Array<BulkCveSeverityCountResult>;
  /**
   * Get the active, non-trial, non-template customer networks that are in the given
   * country and have a virtual device of the given model.
   */
  countryDeviceCertificationNetworks: Array<Network>;
  /** Get all country device certifications and customer network counts by country and device model. */
  countryDeviceCertifications: CountryDeviceCertificationsResponse;
  /** Get a CPE by its unique identifier. */
  cpe: Cpe;
  /** Get CPEs according to provided filter. */
  cpes: Array<Cpe>;
  /** Fetch the 'Current' configuration for a device, which is the most recent Good configuration that the device is using. Do not confuse this with the 'latest' configuration, which is just the most recent configuration that was rendered. This will differ from the latest if there is a brand new (Received) config that is still being validated, or if the latest config has been marked as Failed, and a rollback has occurred to this Current config. */
  currentDeviceConfig: DeviceConfigMetadata;
  /** Retrieve a CVE by its ID */
  cve: Cve;
  /**
   * Return CVEs for a specific client (networkUUID + macAddress).
   * Optionally filter by severity if provided.
   */
  cvesForMACAddress: Array<Cve>;
  /** Retrieves a DDNS record by its unique identifier. */
  ddnsRecord: DdnsRecord;
  /** List deployment task exceptions where the given user is tagged. */
  deploymentExceptionsForUser: Array<DeploymentTaskException>;
  /**
   * Query deployment jobs by filter. Currently the only filter is a list of UUIDs.
   * @deprecated Use deploymentJobsPaginated.
   */
  deploymentJobs: Array<DeploymentJob>;
  /** List all deployment jobs for a network */
  deploymentJobsForNetwork: Array<DeploymentJob>;
  /** List all deployment jobs for a user */
  deploymentJobsForUser: Array<DeploymentJob>;
  /**
   * Paginated list of deployment jobs. Supports filtering by UUIDs, by owning
   * user, and by completion status, with basic limit/offset pagination.
   */
  deploymentJobsPaginated: DeploymentJobPage;
  /** List deployment task notifications matching the given filter. */
  deploymentTaskNotifications: Array<DeploymentTaskNotification>;
  /**
   * Query deployment tasks by filter. Currently the only filter is a list of UUIDs.
   * @deprecated Use deploymentJobsPaginated.
   */
  deploymentTasks: Array<DeploymentTask>;
  /** List all deployment tasks for a network. */
  deploymentTasksForNetwork: Array<DeploymentTask>;
  /** List all deployment tasks for a user, ordered by most recently updated first. */
  deploymentTasksForUser: Array<DeploymentTask>;
  /** Paginated list of deployment tasks. */
  deploymentTasksPaginated: DeploymentTaskPage;
  /** Get a deployment time window by UUID. */
  deploymentTimeWindow?: Maybe<DeploymentTimeWindow>;
  /** Time windows matching the filters that the caller can read. */
  deploymentTimeWindows: Array<DeploymentTimeWindow>;
  /**
   * Get a device by its serial number.
   * @deprecated Use `hardwareDevice` query instead, accessing `virtualDevice` within the hardware device if necessary.
   */
  device: Device;
  /** Get a device batch by its batch name. */
  deviceBatchByName?: Maybe<DeviceBatch>;
  /** Retrieve a list of device batches based on filter criteria. */
  deviceBatches: Array<DeviceBatch>;
  /** Gets the cellular status last reported by a device. */
  deviceCellularStatus?: Maybe<CellularStatus>;
  /** Fetch a specific configuration for a device by its version number. */
  deviceConfigByVersion: DeviceConfig;
  /** Fetch the configuration override for a device; should rarely be used, if ever, in production. */
  deviceConfigOverride: DeviceConfigOverride;
  /** Fetch metadata for all configurations for devices over time ordered by version. */
  deviceConfigs: Array<DeviceConfigMetadata>;
  /** Fetch a single device image by its UUID. */
  deviceImage: DeviceImage;
  /** Fetches a page of device images for an optional filter. */
  deviceImages: DeviceImagesPage;
  /**
   * Retrieves the cellular usage of a controller aggregated over the last day.
   *
   * This is its own resolver so that it can be used for both config 1 and config 2.
   */
  deviceLastDayCellularUsage?: Maybe<CellularUsage>;
  /**
   * Get the MAC allocation block that new device batches for a device family are
   * currently drawing from. Use deviceMACAllocations to see every block, including
   * exhausted ones.
   */
  deviceMACAllocation?: Maybe<DeviceMacAllocation>;
  /** List every MAC allocation block for a device family, oldest first. */
  deviceMACAllocations: Array<DeviceMacAllocation>;
  /** List of valid device migrations for supported models. */
  deviceMigrationInfo: Array<DeviceModelMigrationInfo>;
  /** Get a device notification snooze by UUID. */
  deviceNotificationSnooze: DeviceNotificationSnooze;
  /** Retrieves the SIM information for this device. */
  deviceSIM: SuperSim;
  /** Returns a timeline of a device's state. */
  deviceStateTimeline: DeviceStateTimeline;
  /** Returns timelines of the state of devices on the networks, ordered by virtual device UUID. */
  deviceStateTimelines: Array<DeviceStateTimeline>;
  /**
   * List devices for a network.
   * @deprecated Use `virtualDevicesForNetwork` instead, accessing `hardwareDevice` within the virtual devices if necessary.
   */
  devicesForNetwork: Array<Device>;
  /** Get a list of 5GHz DFS channels. */
  dfsChannels: Array<Scalars['Int']['output']>;
  /** Get a DHCP option by its UUID. */
  dhcpOption: DhcpOption;
  /** Get a DHCP proxy by its UUID. */
  dhcpProxy: DhcpProxy;
  /** Get a DHCP reserved range by its UUID. */
  dhcpReservedRange: DhcpReservedRange;
  /** Get a DHCP rule by its UUID. */
  dhcpRule: DhcpRule;
  /** Get a DHCP rule filter by its UUID. */
  dhcpRuleFilter: DhcpRuleFilter;
  /** Get all DHCP rules for a specific network. */
  dhcpRulesForNetwork: Array<DhcpRule>;
  /** Get a DHCP static mapping by its UUID. */
  dhcpStaticMapping: DhcpStaticMapping;
  /** Returns a list of services discovered on the specified network within the last given number of minutes, filtered by the provided service types. */
  discoveredServicesForNetwork: Array<DiscoveredService>;
  /** A page of DNS queries blocked by application DNS firewall rules, most recent first. */
  dnsBlockedEvents: DnsBlockedEventsPage;
  /** Aggregates over DNS queries blocked by application DNS firewall rules. */
  dnsBlockedEventsSummary: DnsBlockedEventsSummary;
  /** Get a DNS host mapping by its UUID. */
  dnsHostMapping: DnsHostMapping;
  /** Generates a pre-signed URL for downloading a file from S3. */
  downloadUrl: FileDownloadPayload;
  /** Lists the 802.1X encryption configurations for a specific network. */
  encryption8021XsForNetwork: Array<Encryption8021X>;
  /** Queries for any Identifiable entity by its UUID. */
  entity: Identifiable;
  /**
   * Deprecated.
   * @deprecated Use `NetworkClient.phyInterfacesConnectedToRecently` instead.
   */
  findSwitchLLDPEntryForMAC?: Maybe<MacAddressSwitchEntry>;
  /** Get a firewall rule by UUID. */
  firewallRule: FirewallRule;
  /** Timeseries data of firewall rule usage. */
  firewallRuleMetrics: Array<FirewallRuleMetricsTimeseriesResponse>;
  /** Timeseries data of firewall rule usage. */
  firewallRuleMetricsForNetworks: Array<FirewallRuleMetricsTimeseriesResponse>;
  /** Get all firewall rules for a network. */
  firewallRulesForNetwork: Array<FirewallRule>;
  /** Get a notification snooze by UUID. */
  fleetwideNotificationSnooze: FleetwideNotificationSnooze;
  /** Get a floor plan by its unique identifier. */
  floorPlan: FloorPlan;
  /** List all floor plans associated with a specific network. */
  floorPlansForNetwork: Array<FloorPlan>;
  /** Gets all fleetwide notification snoozes that end in the future. */
  futureFleetwideNotificationSnoozes?: Maybe<Array<FleetwideNotificationSnooze>>;
  /** Get the gateway uplink settings for a network's firewalls. */
  gatewayUplinkSettings: GatewayUplinkSettings;
  /**
   * Get a company by its slug.
   * @deprecated Use `companyBySlug` instead.
   */
  getCompany?: Maybe<Company>;
  /**
   * Get a company by its UUID.
   * @deprecated Use `company` instead.
   */
  getCompanyByUUID?: Maybe<Company>;
  /**
   * Returns pairs of in-network APs that are interfering with each other,
   * based on scan data from the last 5 minutes. Each entry represents one AP
   * detecting another AP's BSSID at or above the specified RSSI threshold.
   */
  getInNetworkAPInterference: Array<InNetworkApInterferenceEntry>;
  /** Get an arbitrary previously stored value, unique to the authenticated user. */
  getKeyValue?: Maybe<Scalars['JSON']['output']>;
  /** List all global notification snoozes that have not been deleted. */
  globalNotificationSnoozes: Array<GlobalNotificationSnooze>;
  /** Return a hardware device by its serial number. */
  hardwareDevice: HardwareDevice;
  /** Return a hardware device by its MAC address. */
  hardwareDeviceByMACAddress: HardwareDevice;
  /** Retrieve a hardware device pair by the serial number of one of its devices. */
  hardwareDevicePairBySerial?: Maybe<HardwareDevicePair>;
  /** Retrieve hardware device pairs by the serial numbers of their devices. */
  hardwareDevicePairsBySerials: Array<HardwareDevicePair>;
  /** Return a list of hardware devices that match the filter. */
  hardwareDevices: Array<HardwareDevice>;
  /**
   * Static properties for every DeviceModel known to the backend. Viewers that
   * hold PERM_HARDWARE___MODEL___PROPERTIES_READ_LIMITED receive every entry;
   * viewers that hold only PERM_HARDWARE___MODEL___PROPERTIES_READ do not see
   * entries whose lifecycle is IN_DEVELOPMENT.
   */
  hardwareModelProperties: Array<HardwareModelProperties>;
  /** Fetch the hardware NOS version range associated with a specific hardware device model. */
  hardwareNosVersionRange?: Maybe<HardwareNosVersionRange>;
  /** Fetch hardware NOS version ranges for all hardware device models. */
  hardwareNosVersionRanges: Array<HardwareNosVersionRange>;
  /** Get high availability firewall configuration for a network. */
  highAvailabilityControllersConfig?: Maybe<HighAvailabilityControllersConfig>;
  /** List the honeypot SSIDs observed on one or more networks. */
  honeypotSSIDsObservedOnNetwork?: Maybe<Array<HoneypotSsid>>;
  /** View host monitoring metrics for a network. */
  hostMonitoringForNetwork: Array<HostMonitoringResponse>;
  /** Get a host monitoring target by its UUID. */
  hostMonitoringTarget: HostMonitoringTarget;
  /** List all host monitoring targets for a specific network. */
  hostMonitoringTargetsForNetwork: Array<HostMonitoringTarget>;
  /** Get the valid types for Hotspot 2.0 (Passpoint) configuration. */
  hs20ValidTypes: Hs20ValidTypesResponse;
  /** Retrieve a single IDSEvent. */
  idsEvent: IdsEvent;
  /** A page of IDS events that includes the total number of records. */
  idsEvents: IdsEventsPage;
  /** All of the global IDS/IPS categories that can be configured. */
  idsIPSCategories: Array<IdsipsCategory>;
  /** A single global IDS/IPS category that can be configured. */
  idsIPSCategory: IdsipsCategory;
  /** Gets the IDS/IPS config for a network. */
  idsIPSConfig?: Maybe<IdsipsConfig>;
  /** The IDS/IPS categories configured for an IDS/IPS configuration. */
  idsIPSConfigCategoryBindings: Array<IdsipsConfigCategoryBinding>;
  /** Get an IDS IPS custom rule. */
  idsIPSCustomRule: IdsipsCustomRule;
  /** A single globally available IDS rule. */
  idsRule: IdsRule;
  /** Configured rules for IDS/IPS configuration. */
  idsRulesForConfig: Array<IdsipsConfigRuleBinding>;
  /** The global list of available rules for a given source version. */
  idsRulesForSourceVersion: IdsRulePage;
  /** Get the filters available for a users inbox. */
  inboxFilters: Array<FilterDefinition>;
  /** Get the inbox message for a given UUID. */
  inboxMessage: InboxMessage;
  /** Get the sort orderings available for the inbox. */
  inboxSortOrderDefinitions: Array<SortOrderDefinition>;
  /** Installation companies ordered by name, then UUID. */
  installCompanies: Array<InstallCompany>;
  /** Installation technicians ordered by name, then UUID. */
  installTechnicians: Array<InstallTechnician>;
  /** List all links between VLANs that are allowed to communicate with each other. */
  interVLANCommunicationPermittedPairs: Array<InterVlanCommunicationPermittedPair>;
  /** Get an internal note by UUID. */
  internalNote: InternalNote;
  /**
   * List all internal notes for a network.
   * @deprecated Use `Network.internalNotes` instead.
   */
  internalNotesForNetwork: Array<InternalNote>;
  /** Internet service plan for a given UUID. */
  internetServicePlan?: Maybe<InternetServicePlan>;
  /** Lists all existing ISPConnectionTypes. */
  internetServicePlanConnectionTypes: Array<InternetServicePlanConnectionType>;
  /** ISP Document a given UUID. */
  internetServicePlanDocument?: Maybe<InternetServicePlanDocument>;
  /** Fulfillment job for a given UUID. */
  internetServicePlanFulfillmentJob?: Maybe<InternetServicePlanFulfillmentJob>;
  /** List of all fulfilment job types and their meta data. */
  internetServicePlanFulfillmentJobTypeMetaData?: Maybe<Array<InternetServicePlanFulfillmentJobTypeMetaData>>;
  /** Gets an InternetServicePlanProvider. */
  internetServicePlanProvider: InternetServicePlanProvider;
  /** Gets an Internet Service Plan Provider Static Rate. */
  internetServicePlanProviderStaticRate: InternetServicePlanProviderStaticRate;
  /** Lists an existing Internet Service Plan Provider Static Rates. */
  internetServicePlanProviderStaticRates: Array<InternetServicePlanProviderStaticRate>;
  /** Lists an existing InternetServicePlanProviders. */
  internetServicePlanProviders: Array<InternetServicePlanProvider>;
  /** Internet service plans for a given company, and optionally scoped by a network. */
  internetServicePlans: Array<InternetServicePlan>;
  /** Get IP forwarding rule. */
  ipForwardingRule: IpForwardingRule;
  /** List all IP forwarding rules for a specific network. */
  ipForwardingRulesForNetwork: Array<IpForwardingRule>;
  /** Get an IPSec tunnel by UUID. */
  ipSecTunnel: IpSecTunnel;
  /** Timeseries data of data usage metrics for IPSec tunnels. */
  ipSecTunnelMetrics: Array<IpSecTunnelMetricsTimeseriesResponse>;
  /** List all IPSec tunnels for a network. */
  ipSecTunnelsForNetwork: Array<IpSecTunnel>;
  /** A page of IPS events that includes the total number of records. */
  ipsEvents: IdsEventsPage;
  /**
   * Check if a specific NOS feature is enabled for any network in a company.
   * In development environments, this always returns true if the key is not recognized on the backend.
   * This checks if *any* network for the specified company supports the NOS feature.
   */
  isNosFeatureEnabledForCompany: Scalars['Boolean']['output'];
  /**
   * Check if a specific NOS feature is enabled for a network.
   * In development environments, this always returns true if the key is not recognized on the backend.
   */
  isNosFeatureEnabledForNetwork: Scalars['Boolean']['output'];
  /**
   * Check if a specific NOS feature is enabled for multiple networks.
   * In development environments, this always returns true if the key is not recognized on the backend.
   */
  isNosFeatureEnabledForNetworks?: Maybe<Array<NosFeatureEnabled>>;
  /** Lists network onboarding job trackers retrieved from Airtable. */
  jobTrackers: Array<NetworkOnboardingJobData>;
  /** Retrieves a lab reservation by its UUID. */
  labReservation: LabReservation;
  /** The filters available for lab reservations. */
  labReservationFilters: Array<FilterDefinition>;
  /** The sort orderings available for lab reservations. */
  labReservationSortOrderDefinitions: Array<SortOrderDefinition>;
  /** Retrieves a page of lab reservations. */
  labReservations: LabReservationPage;
  /** All lab resources */
  labResources: Array<LabResource>;
  /**
   * Fetch the latest configuration that a device has acknowledged.
   * @deprecated Use `currentDeviceConfig` instead because it incorporates connectivity and rollback checking.
   */
  latestAcknowledgedDeviceConfig: DeviceConfig;
  /**
   * Fetches the latest configuration rendered for a device. Does not re-render the configuration;
   * use the `renderDeviceConfig` mutation for that.
   */
  latestDeviceConfig: DeviceConfig;
  /** Returns all of the companies, excluding companies that only have Connect quotes. */
  listCompanies: Array<Company>;
  /** Fetch device log attribute keys ranked by occurrence count. */
  logAttributeKeys: Array<LogAttributeKey>;
  /** Fetch device log attribute values ranked by occurrence count. */
  logAttributeValueCounts: Array<LogAttributeValueCounts>;
  /** Fetch sampled distinct values for device log attribute keys. */
  logAttributeValues: Array<LogAttributeValues>;
  /** Fetch a time-bucketed histogram of device log counts grouped by a chosen field or attribute. */
  logHistogram: LogHistogram;
  /** Mine log message patterns from a random sample of device logs. */
  logPatternsForNetwork: LogPatternsResult;
  /** Fetch a time-bucketed histogram of device log counts by severity. */
  logSeverityHistogram: LogSeverityHistogram;
  /** Fetch a page of device logs for a network. */
  logsForNetwork: DeviceLogsPage;
  /** Mailing addresses */
  mailingAddresses: MailingAddressPage;
  /** Retrieves the maintenance window for the specified network. */
  maintenanceWindowForNetwork: MaintenanceWindow;
  /** Get a single marketing changelog entry by its UUID. */
  marketingChangelogEntry: MarketingChangelogEntry;
  /** Retrieves a monitor group. */
  monitorGroup: MonitorGroup;
  /** Retrieves timeseries metrics for monitor groups for the network. */
  monitorGroupMetricsForNetwork: Array<MonitorGroupEvent>;
  /** Retrieves a monitor probe. */
  monitorProbe: MonitorProbe;
  /** Retrieve the list of mutations that a network has undergone. */
  mutationAuditLogEntriesForNetwork: Array<MutationAuditLogEntry>;
  /** Retrieves the list of mutations that a company has undergone, showing the JSON models before and after the mutation. */
  mutationDiffAuditLogEntriesForCompany: Array<MutationDiffAuditLogEntry>;
  /** Retrieve a single mutation audit log entry. */
  mutationDiffAuditLogEntry: MutationDiffAuditLogEntry;
  /** Retrieves the list of mutations that a network has undergone, showing the JSON models before and after the mutation. Includes a count of the total number of entries for pagination. */
  mutationDiffAuditLogPageForNetwork: MutationDiffAuditLogPage;
  /** The NAC auth events across one or more networks, most recent first. */
  nacAuthEvents: NacAuthEventsPage;
  /** Client devices seen across one or more networks, most recently seen first. */
  nacClientDevices: NacClientDevicesPage;
  /** Fetch a single NAC credential by UUID. */
  nacCredential: NacCredential;
  /** Fetch display info for the public password setup page. */
  nacCredentialPasswordSetup: NacCredentialPasswordSetupInfo;
  /** List NAC identities for a company. */
  nacCredentialsForCompany: Array<NacCredential>;
  /** List all NAC user groups for a company. */
  nacGroupsForCompany: Array<NacGroup>;
  /** List the NAC IdP configurations for a company. */
  nacIdPConfigsForCompany: Array<NacIdPConfig>;
  /** Groups from a NAC IdP directory matching a group name search term. */
  nacIdPDirectoryGroups: Array<NacIdPDirectoryGroup>;
  /** List the group mappings for a company's IdP configuration. */
  nacIdPGroupMappingsForIdPConfig: Array<NacIdPGroupMapping>;
  /** Resolves one identity's directory groups and the NAC groups they map to. */
  nacIdPUserLookup: NacIdPUserLookupResult;
  /** Fetch a single NAC policy by UUID. */
  nacPolicy: NacPolicy;
  /** Get a network. */
  network: Network;
  /** Gets a usage metrics timeseries for a given application category on a network. */
  networkApplicationCategoryUsageMetrics: ApplicationUsageMetricsResponse;
  /** Gets the per-client usage for a given application. */
  networkApplicationUsageByClient: Array<ClientApplicationUsage>;
  /** Gets a usage metrics timeseries for a given application on a network. */
  networkApplicationUsageMetrics: ApplicationUsageMetricsResponse;
  /** Get a network by its slug. */
  networkBySlug: Network;
  /** Get a network client CPE binding by its unique identifier. */
  networkClientCPEBinding: NetworkClientCpeBinding;
  /** Get all network client CPE bindings for a network. */
  networkClientCPEBindingsForNetwork: Array<NetworkClientCpeBinding>;
  /**
   * Get the latest connected clients for a network.
   * The values in filter can alter this behavior.
   */
  networkClients: Array<NetworkClient>;
  /** Gets the application usage of network client(s). */
  networkClientsApplicationUsage: Array<ApplicationUsage>;
  /** Get a report of the total number of bytes transmitted and received by each client connected to a network, on a per day basis. */
  networkClientsTxRxPerDay: Array<NetworkClientTxRxPerDay>;
  /** Retrieves all jobs associated with a company that the calling user has permission on the associated network. */
  networkJobsForCompany: Array<NetworkJob>;
  /**
   * Get port error counts as time series for every switch, controller, and access point port in one or more
   * networks. Only ports with at least one error in the requested directions are returned.
   */
  networkPortErrorSeries: PortErrorSeriesResponse;
  /**
   * Returns the network routes a virtual device is currently configured with, followed by
   * the BGP routes it most recently reported learning.
   * Configured routes are rendered from the network's current configuration, so they include
   * all implied routes from other features (Client VPN, IPSec, Auto VPN) alongside static
   * routes. They reflect the intended configuration.
   * Learned routes come from the device's last reported routing table and are attached to the
   * Auto VPN group or BGP router that learned them.
   */
  networkRoutesForVirtualDevice: Array<NetworkRoute>;
  /** List the NetworkThreatAllowlistEntries for a network. */
  networkThreatAllowlistForNetwork?: Maybe<Array<NetworkThreatAllowlistEntry>>;
  /**
   * Get metrics about uplink quality (i.e., the ISP quality) for one or more networks.
   * Quality is the percentage of successful pings to common web servers over the ISP connection.
   */
  networkUplinkQuality: NetworkUplinkQualityResponse;
  /**
   * Get metrics about uplink throughput (i.e., the ISP throughput) for one or more networks.
   * Throughput is the amount of data transferred over the ISP connection, measured in bits per second.
   */
  networkUplinkThroughput: NetworkUplinkThroughputMetricsResponse;
  /** Get uplink throughput for one or more networks as time series. */
  networkUplinkThroughputSeries: UplinkThroughputSeriesResponse;
  /** Get wireless clients that attempted (success or failure) to connect to the network (from wireless connection events). */
  networkWirelessClients: Array<NetworkWirelessClient>;
  /** Get all networks that match the given filter. */
  networks: Array<Network>;
  /**
   * Get the latest connected clients for multiple networks.
   * The values in filter can alter this behavior.
   */
  networksClients: Array<NetworkClient>;
  /**
   * Get the MAC addresses of the connected clients for the given networks.
   * Lightweight alternative to `networksClients` that skips per-client aggregation,
   * suitable for callers that only need the set of known client MAC addresses.
   */
  networksClientsMACAddresses: Array<NetworkClientMacAddress>;
  /** Get all of a company's networks. */
  networksForCompany: Array<Network>;
  /** Get uplink quality metrics for multiple networks. */
  networksUplinkQualities: Array<NetworkUplinkQualityResponse>;
  /** Always returns true and does nothing. */
  noop: Scalars['Boolean']['output'];
  /** Get a NOS feature by its UUID. */
  nosFeature: NosFeature;
  /** List all NOS features. */
  nosFeatures: Array<NosFeature>;
  /** Retrieves all NOS versions that were scheduled for a virtual device. */
  nosHistoryForVirtualDevice?: Maybe<Array<VirtualDeviceNosHistory>>;
  /** Fetch all NOS upgrade groups for a network. */
  nosUpgradeGroupsForNetwork: Array<NosUpgradeGroup>;
  /** List all NOS versions with optional filters. */
  nosVersions: Array<NosVersion>;
  /** Get a single ObserverTest by UUID. */
  observerTest: ObserverTest;
  /** Get all ObserverTests for a network. */
  observerTestsForNetwork: Array<ObserverTest>;
  /** Get a 1:1 NAT rule by its UUID. */
  oneToOneNATRule: OneToOneNatRule;
  /** List all 1:1 NAT rules for a specific network. */
  oneToOneNATRulesForNetwork: Array<OneToOneNatRule>;
  /** Lists Opportunities. */
  opportunities: OpportunitiesPage;
  /** Get a single Opportunity by UUID. */
  opportunity: Opportunity;
  /** Get all outlet interfaces for a Power Distribution Unit (PDU) virtual device. */
  outletInterfacesForVirtualDevice: Array<OutletInterface>;
  /** Temporary access grants requested by the current user. */
  ownTemporaryAccessGrants: Array<TemporaryAccessGrant>;
  /** Get a single packet capture. */
  packetCapture: PacketCaptureJob;
  /** Get a single packet capture group. */
  packetCaptureGroup: PacketCaptureGroup;
  /** List all packet capture groups for a network, most recent first. */
  packetCaptureGroups: Array<PacketCaptureGroup>;
  /** List all packet captures for a network. */
  packetCaptures: Array<PacketCaptureJob>;
  /** Timeseries data of PDU device. */
  pduMetrics: PduMetricsTimeseriesResponse;
  /** Timeseries data of PDU devices. */
  pdusMetrics: Array<PduMetricsTimeseriesResponse>;
  /** Pending temporary access requests the current user may approve. */
  pendingTemporaryAccessGrantsToApprove: Array<TemporaryAccessGrant>;
  /** Returns all permission groups with their associated permissions. */
  permissionGroups: Array<PermissionGroupAssignment>;
  /** Retrieves the permissions that are assigned to the current user, in context of the provided parameters. */
  permissions: Array<PermissionAssignment>;
  /** Get a phy interface DHCP rule by its UUID. */
  phyInterfaceDHCPRule: PhyInterfaceDhcpRule;
  /** Get the physical interfaces associated with a virtual device. */
  phyInterfacesForVirtualDevice: Array<PhyInterface>;
  /** Retrieves a policy engine policy. */
  policyEnginePolicy: PolicyEnginePolicy;
  /** Get a policy routing rule. */
  policyRoutingRule: PolicyRoutingRule;
  /** List policy routing rules for a network. */
  policyRoutingRulesForNetwork: Array<PolicyRoutingRule>;
  /** Get a port forwarding rule by UUID. */
  portForwardingRule: PortForwardingRule;
  /** Get all port forwarding rules for a network. */
  portForwardingRulesForNetwork: Array<PortForwardingRule>;
  /** Gets a Provider Connection Type Term. */
  providerConnectionTypeTerm: ProviderConnectionTypeTerm;
  /** Lists the Provider Connection Type Terms for a Provider. */
  providerConnectionTypeTerms: Array<ProviderConnectionTypeTerm>;
  /**
   * The rate limits applied to every public API key that has no override of
   * its own.
   */
  publicAPIKeyRateLimitDefaults: PublicApiKeyRateLimits;
  /** Lists all `isPublic=true` NOS versions for a network in reverse semver order, starting with versions <= the network's NOS version. */
  publicNOSVersionsForNetwork: Array<NosVersion>;
  /** Get a single Quote by UUID. */
  quote: Quote;
  /** Recommends Meter quotes for a Quote Request's selection priorities without changing anything. */
  quoteRecommendations: QuoteRecommendations;
  /** Gets an Quote Request. */
  quoteRequest: QuoteRequest;
  /**
   * Lists Quote Requests.
   * @deprecated Use `allQuoteRequests` instead.
   */
  quoteRequests: Array<QuoteRequest>;
  /** Get all quotes associated with a specific Quote Request. */
  quotesForQuoteRequest: Array<Quote>;
  /** Get a rack elevation by UUID. */
  rackElevation: RackElevation;
  /** Get all rack elevations for a network. */
  rackElevations: Array<RackElevation>;
  /** Get the radio profiles for a network. */
  radioProfilesForNetwork: Array<RadioProfile>;
  /** RADIUS poller monitoring data for all poller-enabled profiles in a network. */
  radiusPollerMonitoringForNetwork: RadiusPollerMonitoringNetworkData;
  /** Get a rate limit rule by UUID. */
  rateLimitRule: RateLimitRule;
  /** Get all rate limit rules for a network. */
  rateLimitRulesForNetwork: Array<RateLimitRule>;
  /**
   * Events in the event log represent notable state changes in the state of the network.
   * @deprecated Use `recentEventLogEventsPage` instead, includes total count of records for pagination.
   */
  recentEventLogEvents?: Maybe<Array<EventLogEvent>>;
  /** A page of events in the event log that includes the total number of records. */
  recentEventLogEventsPage: EventLogEventsPage;
  /** List the rogue access points observed on one or more networks. */
  rogueAccessPointsObservedOnNetwork?: Maybe<Array<RogueAccessPoint>>;
  /** The email domain restrictions for roles that limit assignment by email domain. */
  rolePermittedEmailDomains: Array<RolePermittedEmailDomains>;
  /** Retrieves the roles that are assigned to the current user, in context of the provided parameters. */
  roles: Array<RoleAssignment>;
  /** Get the current pause state of one or more Salesforce job queues. Restricted to super operators. */
  salesforceJobQueueStates: Array<SalesforceJobQueueState>;
  /** Return all of the scan data associated with a network. */
  scanDataForNetwork: Array<ScanData>;
  /** Fetch all scheduled NOS upgrades for a network in reverse chronological order to see the history of a network's firmware upgrades. Note that only grouped NOS upgrades are returned. */
  scheduledNetworkNOSUpgradesForNetwork: Array<ScheduledNetworkNosUpgrade>;
  /**
   * List all available service request definitions.
   * @deprecated Use `DeploymentJob.serviceRequestDefinitions` instead, which is scoped for non-operators and carries each definition's `deliverable`.
   */
  serviceRequestDefinitions: Array<ServiceRequestDefinition>;
  /** Retrieves all SIEM integrations for a company. */
  siemIntegrationsForCompany?: Maybe<Array<CompanySiemIntegration>>;
  /** Return the hardware devices that are not associated with a virtual device; they're not in use but affiliated with the network for potential future use. */
  spareHardwareDevicesForNetwork: Array<HardwareDevice>;
  /** Get a specific speedtest rule */
  speedtestByUUID: SpeedtestRule;
  /** List all rules for a company */
  speedtestRulesByCompany: Array<SpeedtestRule>;
  /** Get all speedtest servers for a network. */
  speedtestServersForNetwork: Array<SpeedtestServer>;
  /** Get an SSID. */
  ssid: Ssid;
  /** List all SSIDs for a network. */
  ssidsForNetwork: Array<Ssid>;
  /** Retrieves the SSO options that can be configured for a company. */
  ssoOptions: SsoOptions;
  /** Get a static route by UUID. */
  staticRoute: StaticRoute;
  /** List all static routes for a network. */
  staticRoutesForNetwork: Array<StaticRoute>;
  /**
   * Fetch stats (device-generated metrics) for a virtual device.
   * @deprecated Use `statsForVirtualDevices` instead.
   */
  statsForVirtualDevice: Array<Stat>;
  /**
   * Fetch stats (device-generated metrics) for multiple virtual devices.
   * @deprecated Use `statsPageForVirtualDevice` instead.
   */
  statsForVirtualDevices: Array<Stat>;
  /** Fetch paginated stats (device-generated metrics) for multiple virtual devices. */
  statsPageForVirtualDevices: StatsPage;
  /**
   * Selecting a NOS upgrade group is mandatory for all devices in a network. Based on the device's label,
   * type, and other attributes, this query will suggest a NOS upgrade group to assign to the device.
   * We take in the parameters rather than the device itself because the device has not been created yet.
   * It's possible the parameters will not match any existing NOS upgrade groups, in which case the query will return null.
   */
  suggestedNOSUpgradeGroupForDevice?: Maybe<NosUpgradeGroup>;
  /** Fetch a support case by UUID */
  supportCase: SupportCase;
  /** Fetch support case attachments by UUIDs */
  supportCaseAttachments: Array<SupportCaseAttachment>;
  /** Get the filters available for case management. */
  supportCaseFilters: Array<FilterDefinition>;
  /** Get the sort orderings available for case management. */
  supportCaseSortOrderDefinitions: Array<SortOrderDefinition>;
  /** Fetch all support cases */
  supportCases: SupportCasePage;
  /** List support providers visible to the caller. */
  supportProviders: SupportProvidersListPage;
  /** List all support users. */
  supportUsers: Array<SupportUser>;
  /** Fetch all MAC address or OUI to VLAN bindings for a network. */
  switchAutoConfigMACAddressVLANBindingsForNetwork: Array<SwitchAutoConfigMacAddressVlanBinding>;
  /**
   * Retrieve the MAC address table for a specified switch.
   * The MAC table contains all MAC addresses observed on the switch's ports.
   */
  switchMACTable: Array<SwitchMacTableEntry>;
  /** Make the filters available for the paginated switch MAC table. */
  switchMACTableFilters: Array<FilterDefinition>;
  /** Retrieve a page of the combined MAC address tables for the networks' switches. */
  switchMACTablePage: SwitchMacTableEntriesPage;
  /** Make the sort orders available for the paginated switch MAC table. */
  switchMACTableSortOrderDefinitions: Array<SortOrderDefinition>;
  /** Retrieve per-port timeseries metrics data expressed as rates (per second) for a specified switch. */
  switchPortMetricsRate: SwitchPortMetricsRateResponse;
  /** Retrieve aggregated per-port statistics for a specified switch over a given lookback period. */
  switchPortStats: Array<SwitchPortStat>;
  /** Fetch system performance stats for a virtual device (as opposed to network-related data plan stats). */
  systemInfoStatForVirtualDevice: Array<SystemInfoStat>;
  /**
   * Fetch system performance metrics for multiple virtual devices (as opposed to network-related data plan metrics).
   * @deprecated Use `systemInfoStatForVirtualDevice` instead.
   */
  systemMetricsForVirtualDevices: Array<VirtualDeviceSystemInfoMetricsResponse>;
  /** Search companies by name or slug before requesting access. */
  temporaryAccessCompanies: Array<TemporaryAccessCompany>;
  /** Resolve a dashboard slug before requesting access. */
  temporaryAccessCompanyBySlug: TemporaryAccessCompany;
  /** Get a temporary access grant. */
  temporaryAccessGrant: TemporaryAccessGrant;
  /** Temporary access grants across all companies. Intended for auditing. */
  temporaryAccessGrants: Array<TemporaryAccessGrant>;
  /** Get the ticket inbox message for a given support case UUID. */
  ticketInboxMessage: InboxMessage;
  /** Get a topology design version by UUID. */
  topologyDesignVersion: TopologyDesignVersion;
  /** Get all topology design versions for a network. */
  topologyDesignVersions: Array<TopologyDesignVersion>;
  /** A list of hardware devices that are detected as connected to virtual devices in the network without an associated virtual device of their own. */
  unassignedHardwareDevicesForNetwork: Array<UnassignedHardwareDeviceForNetworkResponse>;
  /** List all underlay pools (active and deactivated) for a network. */
  underlayPoolsForNetwork: Array<UnderlayPool>;
  /** Returns network uplink (WAN) physical interfaces for the network (controller interfaces only). */
  uplinkPhyInterfacesForNetwork: Array<PhyInterface>;
  /** Checks if the calling user has access to a network. Responds with the expiration of the access if found. */
  userNetworkAccessExpiry?: Maybe<Scalars['DateTime']['output']>;
  /** Test a NAC IdP configuration by connecting to the IdP and querying its directory. */
  validateNACIdPConfig: NacIdPConfigValidationResult;
  /** Retrieve the vendor for the given OUI, if it exists in the IEEE database. */
  vendorForOUI?: Maybe<IeeeDeviceVendor>;
  /** Return a virtual device by its UUID. */
  virtualDevice: VirtualDevice;
  /** Get all virtual device tags for a network. */
  virtualDeviceTagsByNetwork?: Maybe<Array<VirtualDeviceTag>>;
  /** Get all virtual devices with a specific tag. */
  virtualDevicesByTag?: Maybe<Array<VirtualDevice>>;
  /** Return a list of virtual devices for a network that match the given filter. */
  virtualDevicesForNetwork: Array<VirtualDevice>;
  /** Get visible marketing changelog entries. */
  visibleMarketingChangelogEntries: Array<MarketingChangelogEntry>;
  /** Get a VLAN by UUID. */
  vlan: Vlan;
  /** Timeseries data of data usage metrics for clients on a VLAN. */
  vlanMetrics: Array<VlanMetricsTimeseriesResponse>;
  /** Get all VLANs for a network. */
  vlans: Array<Vlan>;
  /** Retrieve the results or check the status of a specific WAN speed test job. */
  wanSpeedtestJob: WanSpeedtestJob;
  /** Retrieve the results for all WAN speed test jobs on a particular network. */
  wanSpeedtestJobsForNetwork: Array<WanSpeedtestJob>;
  /** Get all Wifi IPSKs for an SSID. */
  wifiIPSKs: Array<WifiIpsk>;
  /** Retrieve the results or check the status of a specific wireless calibration job. */
  wirelessCalibrationJob: WirelessCalibrationJob;
  /** Retrieve the results for all wireless calibration jobs on a particular network. */
  wirelessCalibrationJobsForNetwork: Array<WirelessCalibrationJob>;
  /** Retrieve a single connection event. */
  wirelessClientConnectionEvent: WirelessClientConnectionEvent;
  /** Aggregate data for wireless client connections on a network. */
  wirelessClientConnectionEventsAggregates: WirelessClientConnectionEventsAggregates;
  /**
   * A list of events that indicate when clients connected to an AP, disassociated from an AP, or failed to connect to an AP, for all clients interacting with an AP.
   * @deprecated Use `wirelessClientConnectionEventsEnhanced` instead.
   */
  wirelessClientConnectionEventsByAP: Array<WirelessClientConnectionEvent>;
  /**
   * A list of events that indicate when a client connected to an AP, disassociated from an AP, or failed to connect to an AP, for a single client.
   * @deprecated Use `wirelessClientConnectionEventsEnhanced` instead.
   */
  wirelessClientConnectionEventsByClient: Array<WirelessClientConnectionEvent>;
  /** A list of events that indicate when clients connected to an AP, disassociated from an AP, or failed to connect to an AP, for all clients on a network. */
  wirelessClientConnectionEventsEnhanced: WirelessClientConnectionEventsPage;
  /**
   * Timeseries data of wireless connectivity metrics for all clients on a network.
   * Returns an aggregated timeseries for each client.
   */
  wirelessClientMetrics: Array<WirelessClientMetricsResponse>;
  /**
   * Timeseries data of wireless connectivity metrics for all clients connected to an AP.
   * Returns a single aggregated timeseries, rather than one per client.
   */
  wirelessClientMetricsByAP: ClientMetricsTimeseriesResponse;
  /** Timeseries data of wireless connectivity metrics for a single client. */
  wirelessClientMetricsByClient: ClientMetricsTimeseriesResponse;
  /**
   * Timeseries data of wireless connectivity metrics aggregated per AP for all clients on a network.
   * Returns a single aggregated timeseries per AP. Optionally filtered to a subset of APs.
   */
  wirelessClientMetricsByNetwork: Array<WirelessClientMetricsByApResponse>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryOuIsForVendorArgs = {
  vendorSubstring: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAccessPointPortProfilesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryActiveClientsArgs = {
  filter: MetricsFilterInput;
  input?: InputMaybe<ActiveClientsInput>;
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryActiveIpsRulesArgs = {
  networkUUID: Scalars['UUID']['input'];
  unknownOnly?: Scalars['Boolean']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryActiveUnderlayPoolForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAffectedClientsByCveArgs = {
  cveID: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAffectedClientsByCveiDsArgs = {
  cveIDs: Array<Scalars['String']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertCompanySubscriptionsForCompanyArgs = {
  companyUUID: Scalars['UUID']['input'];
  filters?: InputMaybe<AlertCompanySubscriptionsFilterInput>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertEvaluationStateHistoryForNetworkArgs = {
  alertCompanySubscriptionUUID?: InputMaybe<Scalars['UUID']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  networkUUID: Scalars['UUID']['input'];
  windowDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertEvaluationStateHistoryForNetworkFleetwideSubscriptionArgs = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  fleetwideSubscriptionUUID: Scalars['UUID']['input'];
  networkUUID: Scalars['UUID']['input'];
  windowDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertFleetwideSubscriptionsArgs = {
  filter?: InputMaybe<AlertFleetwideSubscriptionsFilterInput>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertReceiverArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertReceiversForCompanyArgs = {
  companyUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertTargetSalesforceArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertTargetSlackArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertTargetWebhookArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertTargetsArgs = {
  companyUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertTargetsSalesforceArgs = {
  companyUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertTargetsSlackArgs = {
  companyUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAlertTargetsWebhookArgs = {
  companyUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAllCvEsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAllClientMetricsByClientArgs = {
  filter: AllClientMetricsTimeseriesFilterInput;
  macAddress: Scalars['MacAddress']['input'];
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAllClientMetricsByVlanArgs = {
  filter: AllClientMetricsTimeseriesFilterInput;
  networkUUID: Scalars['UUID']['input'];
  vlanUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAllInternetServicePlansArgs = {
  filter?: InputMaybe<InternetServicePlanFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  orderBy?: InputMaybe<InternetServicePlanOrderByField>;
  orderByDir?: InputMaybe<OrderByDirection>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAllQuoteRequestsArgs = {
  filter?: InputMaybe<QuoteRequestFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  options?: InputMaybe<QuoteRequestOptionsInput>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAllRolesArgs = {
  input?: InputMaybe<RolesInput>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAnomalyStatsGroupsForVirtualDevicesArgs = {
  filter: AnomalyStatsFilterInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryApHealthScoresArgs = {
  filter: MetricsFilterInput;
  serialNumber: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryApiKeysForCompanyArgs = {
  companyUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryApplicationDnsFirewallRuleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryApplicationDnsFirewallRuleApplicationForHostnameArgs = {
  hostname: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryApplicationDnsFirewallRuleCategoryForHostnameArgs = {
  hostname: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryApplicationDnsFirewallRulesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAreNosFeaturesEnabledForCompanyArgs = {
  companySlug: Scalars['String']['input'];
  nosFeatureKeys: Array<Scalars['String']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAreNosFeaturesEnabledForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
  nosFeatureKeys: Array<Scalars['String']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAuthenticationTokenArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutoChannelSelectionJobArgs = {
  jobUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutoChannelSelectionJobsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
  statuses?: InputMaybe<Array<NetworkJobStatus>>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutoSwitchConfigurationJobArgs = {
  jobUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutoSwitchConfigurationJobsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutoVpnbgpNeighborHubStateMetricsArgs = {
  filter: MetricsFilterInput;
  groupUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutoVpnbgpNeighborMemberStateMetricsArgs = {
  filter: MetricsFilterInput;
  groupUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutoVpnGroupArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutoVpnGroupsForCompanyArgs = {
  companySlug: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutoVpnGroupsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutoVpnMemberArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutoVpnMemberMetricsForCompanyArgs = {
  autoVPNGroupUUID?: InputMaybe<Scalars['UUID']['input']>;
  companyUUID: Scalars['UUID']['input'];
  filter: MetricsFilterInput;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryAutonomousSystemArgs = {
  asn: Scalars['Uint32']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryBearerSessionArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryBgpNeighborArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryBgpRouterArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryBlockedClientsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryBlockedClientsForSsidArgs = {
  ssidUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryBssidsForNetworkArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryBulkNosUpgradeArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryBulkNosUpgradesArgs = {
  filter: BulkNosUpgradesFilterInput;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalArgs = {
  uuid: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalAllClientsArgs = {
  networkUUID: Scalars['UUID']['input'];
  numHoursLookback: Scalars['Int']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalAuthorizedClientsArgs = {
  networkUUID: Scalars['UUID']['input'];
  numHoursLookback: Scalars['Int']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalEntriesArgs = {
  captivePortalUUID?: InputMaybe<Scalars['UUID']['input']>;
  captivePortalUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  input: GetCaptivePortalEntriesInput;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalEntriesForPortalArgs = {
  captivePortalUUID?: InputMaybe<Scalars['UUID']['input']>;
  captivePortalUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  filter?: InputMaybe<CaptivePortalEntryFilterInput>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalEntryArgs = {
  uuid: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalEntryFiltersArgs = {
  captivePortalUUID?: InputMaybe<Scalars['UUID']['input']>;
  captivePortalUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalForVlanArgs = {
  vlanUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalForWebhookArgs = {
  webhookKey: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalWithSignatureArgs = {
  UUID: Scalars['UUID']['input'];
  input?: InputMaybe<GetCaptivePortalWithSignatureInput>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCaptivePortalsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryChannelUtilizationByApArgs = {
  apVirtualDeviceUUID: Scalars['UUID']['input'];
  band?: InputMaybe<RadioBand>;
  filter: ChannelUtilizationTimeseriesFilterInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryChannelUtilizationByClientArgs = {
  filter: ChannelUtilizationTimeseriesFilterInput;
  macAddress: Scalars['MacAddress']['input'];
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryChannelUtilizationByNetworkArgs = {
  band?: InputMaybe<RadioBand>;
  filter: ChannelUtilizationTimeseriesFilterInput;
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryClientObserverTestsArgs = {
  filter?: InputMaybe<ClientObserverFilter>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryClientPingSweepIsSupportedForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryClientPingSweepJobArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryClientPingSweepJobFiltersArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryClientPingSweepJobsForNetworkArgs = {
  input: ClientPingSweepJobsInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryClientVpnClientArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryClientVpnClientMetricsArgs = {
  clientVPNServerUUID?: InputMaybe<Scalars['UUID']['input']>;
  filter: MetricsFilterInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryClientVpnClientsArgs = {
  serverUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryClientVpnServerArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryClientVpnServersArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryClientWirelessScoresArgs = {
  filter: ClientMetricsTimeseriesFilterInput;
  macAddress: Scalars['MacAddress']['input'];
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryClientWirelessScoresByNetworkArgs = {
  filter: ClientMetricsTimeseriesFilterInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCompaniesForApiKeyArgs = {
  companyUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCompanyArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCompanyBySlugArgs = {
  slug: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCompanyUserArgs = {
  companyUserUUID: Scalars['UUID']['input'];
  input?: InputMaybe<GetCompanyUserInput>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCompanyUsersArgs = {
  companySlug: Scalars['String']['input'];
  input?: InputMaybe<GetCompanyUserInput>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryComplianceReportArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryComplianceReportsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryConnectStaticRateArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryConsoleLoginsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  serialNumber: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryControllerDnsRequestRatesArgs = {
  filter: MetricsFilterInput;
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryControllerPortMetricsRateArgs = {
  filter: MetricsFilterInput;
  portNumber?: InputMaybe<Scalars['Int']['input']>;
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryControllerPortStatsArgs = {
  lookbackHours?: Scalars['Int']['input'];
  portNumber?: InputMaybe<Scalars['Int']['input']>;
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
  virtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCountCvEsBySeverityForMacAddressesBulkArgs = {
  input: Array<CvEsByNetworkMacAddressesInput>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCountryDeviceCertificationNetworksArgs = {
  countryISO2s?: InputMaybe<Array<Scalars['String']['input']>>;
  deviceModels?: InputMaybe<Array<DeviceModel>>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCpeArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCpesArgs = {
  filter: CpEsFilterInput;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCurrentDeviceConfigArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCveArgs = {
  cveID: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryCvesForMacAddressArgs = {
  macAddress: Scalars['MacAddress']['input'];
  networkUUID: Scalars['UUID']['input'];
  severity?: InputMaybe<CveSeverity>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDdnsRecordArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeploymentExceptionsForUserArgs = {
  filter: DeploymentTaskExceptionsFilter;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeploymentJobsArgs = {
  filter: DeploymentJobsFilter;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeploymentJobsForNetworkArgs = {
  includeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeploymentJobsForUserArgs = {
  includeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  unassignedJobsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['Int']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeploymentJobsPaginatedArgs = {
  filter: DeploymentJobsPaginatedFilter;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  orderBy?: InputMaybe<DeploymentJobOrderByField>;
  orderByDir?: InputMaybe<OrderByDirection>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeploymentTaskNotificationsArgs = {
  filter: DeploymentTaskNotificationsFilter;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeploymentTasksArgs = {
  filter: DeploymentTasksFilter;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeploymentTasksForNetworkArgs = {
  includeCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  includeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeploymentTasksForUserArgs = {
  includeCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  includeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  unassignedTeamTasksOnly?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['Int']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeploymentTasksPaginatedArgs = {
  filter: DeploymentTasksPaginatedFilter;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  orderBy?: InputMaybe<DeploymentTaskOrderByField>;
  orderByDir?: InputMaybe<OrderByDirection>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeploymentTimeWindowArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeploymentTimeWindowsArgs = {
  filter?: InputMaybe<DeploymentTimeWindowsFilter>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceBatchByNameArgs = {
  batchName: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceBatchesArgs = {
  filter: DeviceBatchFilterInput;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceCellularStatusArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceConfigByVersionArgs = {
  serialNumber: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceConfigOverrideArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceConfigsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  serialNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceImageArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceImagesArgs = {
  filter?: InputMaybe<DeviceImagesFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceLastDayCellularUsageArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceMacAllocationArgs = {
  deviceFamily: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceMacAllocationsArgs = {
  deviceFamily: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceNotificationSnoozeArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceSimArgs = {
  ICCID?: InputMaybe<Scalars['String']['input']>;
  SID?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceStateTimelineArgs = {
  filter: DeviceStateTimelineFilterInput;
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDeviceStateTimelinesArgs = {
  filter: DeviceStateTimelinesFilterInput;
  networkUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDevicesForNetworkArgs = {
  filter?: InputMaybe<DevicesForNetworkFilter>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDhcpOptionArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDhcpProxyArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDhcpReservedRangeArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDhcpRuleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDhcpRuleFilterArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDhcpRulesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDhcpStaticMappingArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDiscoveredServicesForNetworkArgs = {
  input: DiscoveredServicesInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDnsBlockedEventsArgs = {
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<DnsBlockedEventFilterInput>;
  limit?: Scalars['Int']['input'];
  networkUUID: Scalars['UUID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDnsBlockedEventsSummaryArgs = {
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<DnsBlockedEventFilterInput>;
  networkUUID: Scalars['UUID']['input'];
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDnsHostMappingArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryDownloadUrlArgs = {
  input: DownloadUrlInput;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryEncryption8021XsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryEntityArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryFindSwitchLldpEntryForMacArgs = {
  macAddress: Scalars['MacAddress']['input'];
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryFirewallRuleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryFirewallRuleMetricsArgs = {
  filter: MetricsFilterInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryFirewallRuleMetricsForNetworksArgs = {
  filter: MetricsFilterInput;
  networkUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryFirewallRulesForNetworkArgs = {
  includeDefault?: Scalars['Boolean']['input'];
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryFleetwideNotificationSnoozeArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryFloorPlanArgs = {
  UUID: Scalars['UUID']['input'];
  documentCategories?: InputMaybe<Array<FloorPlanDocumentCategory>>;
  documentCategory?: InputMaybe<FloorPlanDocumentCategory>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryFloorPlansForNetworkArgs = {
  documentCategories?: InputMaybe<Array<FloorPlanDocumentCategory>>;
  documentCategory?: InputMaybe<FloorPlanDocumentCategory>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryGatewayUplinkSettingsArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryGetCompanyArgs = {
  slug: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryGetCompanyByUuidArgs = {
  uuid: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryGetInNetworkApInterferenceArgs = {
  band?: InputMaybe<RadioBand>;
  networkUUID: Scalars['UUID']['input'];
  rssiThresholdDBm?: InputMaybe<Scalars['Int']['input']>;
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryGetKeyValueArgs = {
  key: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryHardwareDeviceArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryHardwareDeviceByMacAddressArgs = {
  macAddress: Scalars['MacAddress']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryHardwareDevicePairBySerialArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryHardwareDevicePairsBySerialsArgs = {
  serialNumbers: Array<Scalars['String']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryHardwareDevicesArgs = {
  filter?: InputMaybe<HardwareDevicesFilter>;
  serialNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryHardwareNosVersionRangeArgs = {
  deviceModel: DeviceModel;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryHighAvailabilityControllersConfigArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryHoneypotSsiDsObservedOnNetworkArgs = {
  filter: NetworkThreatsFilterInput;
  limit?: Scalars['Int']['input'];
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  offset?: Scalars['Int']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryHostMonitoringForNetworkArgs = {
  filter: MetricsFilterInput;
  hostIPs?: InputMaybe<Array<Scalars['String']['input']>>;
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryHostMonitoringTargetArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryHostMonitoringTargetsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIdsEventArgs = {
  observedAt: Scalars['DateTime']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIdsEventsArgs = {
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<IdsEventFilterInput>;
  limit?: Scalars['Int']['input'];
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIdsIpsCategoryArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIdsIpsConfigArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIdsIpsConfigCategoryBindingsArgs = {
  idsIPSConfigUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIdsIpsCustomRuleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIdsRuleArgs = {
  ruleSID: Scalars['Int']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIdsRulesForConfigArgs = {
  idsIPSConfigUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIdsRulesForSourceVersionArgs = {
  filter?: InputMaybe<IdsRuleFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sourceVersion?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInboxFiltersArgs = {
  companyUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInboxMessageArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInboxSortOrderDefinitionsArgs = {
  companyUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInstallCompaniesArgs = {
  filter?: InputMaybe<InstallCompaniesFilter>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInstallTechniciansArgs = {
  filter?: InputMaybe<InstallTechniciansFilter>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInterVlanCommunicationPermittedPairsArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInternalNoteArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInternalNotesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInternetServicePlanArgs = {
  uuid: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInternetServicePlanDocumentArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInternetServicePlanFulfillmentJobArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInternetServicePlanProviderArgs = {
  uuid: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInternetServicePlanProviderStaticRateArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInternetServicePlanProviderStaticRatesArgs = {
  providerUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInternetServicePlanProvidersArgs = {
  companySlug?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryInternetServicePlansArgs = {
  companySlug: Scalars['String']['input'];
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIpForwardingRuleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIpForwardingRulesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIpSecTunnelArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIpSecTunnelMetricsArgs = {
  filter: MetricsFilterInput;
  ipSecTunnelUUID?: InputMaybe<Scalars['UUID']['input']>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIpSecTunnelsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIpsEventsArgs = {
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  idsFilter?: InputMaybe<IdsEventFilterInput>;
  limit?: Scalars['Int']['input'];
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIsNosFeatureEnabledForCompanyArgs = {
  companySlug: Scalars['String']['input'];
  nosFeatureKey: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIsNosFeatureEnabledForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
  nosFeatureKey: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryIsNosFeatureEnabledForNetworksArgs = {
  networkUUIDs: Array<Scalars['UUID']['input']>;
  nosFeatureKey: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryLabReservationArgs = {
  reservationUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryLabReservationsArgs = {
  input: GetLabReservationsInput;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryLatestAcknowledgedDeviceConfigArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryLatestDeviceConfigArgs = {
  serialNumber: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryListCompaniesArgs = {
  filter?: InputMaybe<CompanyFilterInput>;
  includeEmpty?: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryLogAttributeKeysArgs = {
  filter?: InputMaybe<DeviceLogsFilterInput>;
  limit?: Scalars['Int']['input'];
  networkUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryLogAttributeValueCountsArgs = {
  filter?: InputMaybe<DeviceLogsFilterInput>;
  keys: Array<Scalars['String']['input']>;
  maxValuesPerKey?: Scalars['Int']['input'];
  networkUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryLogAttributeValuesArgs = {
  filter?: InputMaybe<DeviceLogsFilterInput>;
  keys: Array<Scalars['String']['input']>;
  maxValuesPerKey?: Scalars['Int']['input'];
  networkUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryLogHistogramArgs = {
  filter?: InputMaybe<DeviceLogsFilterInput>;
  groupBy: LogHistogramGroupByInput;
  maxGroups?: Scalars['Int']['input'];
  networkUUIDs: Array<Scalars['UUID']['input']>;
  stepSeconds?: Scalars['Int']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryLogPatternsForNetworkArgs = {
  filter?: InputMaybe<DeviceLogsFilterInput>;
  networkUUIDs: Array<Scalars['UUID']['input']>;
  sampleSize?: Scalars['Int']['input'];
  stepSeconds?: Scalars['Int']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryLogSeverityHistogramArgs = {
  filter?: InputMaybe<DeviceLogsFilterInput>;
  networkUUIDs: Array<Scalars['UUID']['input']>;
  stepSeconds?: Scalars['Int']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryLogsForNetworkArgs = {
  filter?: InputMaybe<DeviceLogsFilterInput>;
  networkUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryMailingAddressesArgs = {
  filter?: InputMaybe<MailingAddressFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryMaintenanceWindowForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryMarketingChangelogEntryArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryMonitorGroupArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryMonitorGroupMetricsForNetworkArgs = {
  groupUUID?: InputMaybe<Scalars['UUID']['input']>;
  networkUUID: Scalars['UUID']['input'];
  timeFilter: MetricsFilterInput;
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryMonitorProbeArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryMutationAuditLogEntriesForNetworkArgs = {
  filter?: InputMaybe<MutationAuditLogFilter>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryMutationDiffAuditLogEntriesForCompanyArgs = {
  companyUUID: Scalars['UUID']['input'];
  filter?: InputMaybe<MutationDiffAuditLogFilterInput>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryMutationDiffAuditLogEntryArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryMutationDiffAuditLogPageForNetworkArgs = {
  filter?: InputMaybe<MutationDiffAuditLogFilterInput>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNacAuthEventsArgs = {
  filter?: InputMaybe<NacAuthEventsFilter>;
  limit?: Scalars['Int']['input'];
  networkUUIDs: Array<Scalars['UUID']['input']>;
  offset?: Scalars['Int']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNacClientDevicesArgs = {
  identity?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  networkUUIDs: Array<Scalars['UUID']['input']>;
  offset?: Scalars['Int']['input'];
  status?: InputMaybe<NacClientDeviceStatus>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNacCredentialArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNacCredentialPasswordSetupArgs = {
  UUID: Scalars['UUID']['input'];
  token: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNacCredentialsForCompanyArgs = {
  companyUUID: Scalars['UUID']['input'];
  credentialType?: InputMaybe<NacCredentialType>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNacGroupsForCompanyArgs = {
  companyUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNacIdPConfigsForCompanyArgs = {
  companyUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNacIdPDirectoryGroupsArgs = {
  nacIdPConfigUUID: Scalars['UUID']['input'];
  search: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNacIdPGroupMappingsForIdPConfigArgs = {
  nacIdPConfigUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNacIdPUserLookupArgs = {
  identity: Scalars['String']['input'];
  nacIdPConfigUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNacPolicyArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkApplicationCategoryUsageMetricsArgs = {
  categoryID: Scalars['Int']['input'];
  filter: MetricsFilterInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkApplicationUsageByClientArgs = {
  filter: ApplicationClientUsageFilter;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkApplicationUsageMetricsArgs = {
  applicationID: Scalars['Int']['input'];
  filter: MetricsFilterInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkBySlugArgs = {
  companySlug: Scalars['String']['input'];
  networkSlug: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkClientCpeBindingArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkClientCpeBindingsForNetworkArgs = {
  macAddress?: InputMaybe<Scalars['MacAddress']['input']>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkClientsArgs = {
  filter?: InputMaybe<NetworkClientsFilter>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkClientsApplicationUsageArgs = {
  filter: ApplicationUsageFilter;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkClientsTxRxPerDayArgs = {
  networkUUID: Scalars['UUID']['input'];
  numDaysLookback: Scalars['Int']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkJobsForCompanyArgs = {
  companyUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkPortErrorSeriesArgs = {
  filter: MetricsFilterInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  networkUUIDs: Array<Scalars['UUID']['input']>;
  portErrorFilter: PortErrorFiltersInput;
  virtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkRoutesForVirtualDeviceArgs = {
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkThreatAllowlistForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkUplinkQualityArgs = {
  filter: MetricsFilterInput;
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkUplinkThroughputArgs = {
  filter: MetricsFilterInput;
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkUplinkThroughputSeriesArgs = {
  filter: MetricsFilterInput;
  groupBy?: InputMaybe<Array<UplinkThroughputGrouping>>;
  networkUUIDs: Array<Scalars['UUID']['input']>;
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworkWirelessClientsArgs = {
  filter: NetworkWirelessClientsFilter;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworksArgs = {
  filter: NetworksFilter;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworksClientsArgs = {
  companyUUID: Scalars['UUID']['input'];
  filter?: InputMaybe<NetworkClientsFilter>;
  networkUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworksClientsMacAddressesArgs = {
  filter?: InputMaybe<NetworkClientsMacAddressesFilter>;
  networkUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworksForCompanyArgs = {
  companySlug: Scalars['String']['input'];
  filter?: InputMaybe<CompanyNetworksFilterInput>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNetworksUplinkQualitiesArgs = {
  filter: MetricsFilterInput;
  networkUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNosFeatureArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNosFeaturesArgs = {
  filter?: InputMaybe<NosFeaturesFilterInput>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNosHistoryForVirtualDeviceArgs = {
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNosUpgradeGroupsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryNosVersionsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isGA?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryObserverTestArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryObserverTestsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryOneToOneNatRuleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryOneToOneNatRulesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryOpportunitiesArgs = {
  filter?: InputMaybe<OpportunitiesFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryOpportunityArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryOutletInterfacesForVirtualDeviceArgs = {
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryOwnTemporaryAccessGrantsArgs = {
  includeEnded?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPacketCaptureArgs = {
  uuid: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPacketCaptureGroupArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPacketCaptureGroupsArgs = {
  limit?: Scalars['Int']['input'];
  networkUUID: Scalars['UUID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPacketCapturesArgs = {
  limit?: Scalars['Int']['input'];
  networkUUID: Scalars['UUID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPduMetricsArgs = {
  filter: MetricsFilterInput;
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPdusMetricsArgs = {
  filter: MetricsFilterInput;
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPermissionGroupsArgs = {
  input: PermissionsInput;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPermissionsArgs = {
  input: PermissionsInput;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPhyInterfaceDhcpRuleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPhyInterfacesForVirtualDeviceArgs = {
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPolicyEnginePolicyArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPolicyRoutingRuleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPolicyRoutingRulesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPortForwardingRuleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPortForwardingRulesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryProviderConnectionTypeTermArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryProviderConnectionTypeTermsArgs = {
  providerUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryPublicNosVersionsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryQuoteArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryQuoteRecommendationsArgs = {
  input: QuoteRecommendationInput;
  quoteRequestUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryQuoteRequestArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryQuoteRequestsArgs = {
  companyUUID?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryQuotesForQuoteRequestArgs = {
  quoteRequestUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryRackElevationArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryRackElevationsArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryRadioProfilesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryRadiusPollerMonitoringForNetworkArgs = {
  filter: MetricsFilterInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryRateLimitRuleArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryRateLimitRulesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryRecentEventLogEventsArgs = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: Scalars['Int']['input'];
  networkUUID: Scalars['UUID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryRecentEventLogEventsPageArgs = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  excludedTypeFilter?: InputMaybe<Array<EventType>>;
  limit?: Scalars['Int']['input'];
  networkUUID: Scalars['UUID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  priorityFilter?: InputMaybe<Array<EventPriority>>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  typeFilter?: InputMaybe<Array<EventType>>;
  virtualDeviceUUIDFilter?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryRogueAccessPointsObservedOnNetworkArgs = {
  filter: NetworkThreatsFilterInput;
  limit?: Scalars['Int']['input'];
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  offset?: Scalars['Int']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryRolesArgs = {
  input?: InputMaybe<RolesInput>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySalesforceJobQueueStatesArgs = {
  queues: Array<SalesforceJobQueue>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryScanDataForNetworkArgs = {
  filter: TimeFilter;
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryScheduledNetworkNosUpgradesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySiemIntegrationsForCompanyArgs = {
  companyUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySpareHardwareDevicesForNetworkArgs = {
  filter?: InputMaybe<HardwareDevicesFilter>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySpeedtestByUuidArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySpeedtestRulesByCompanyArgs = {
  companyUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySpeedtestServersForNetworkArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySsidArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySsidsForNetworkArgs = {
  filter?: InputMaybe<SsidFilterInput>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySsoOptionsArgs = {
  input: SsoOptionsInput;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryStaticRouteArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryStaticRoutesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryStatsForVirtualDeviceArgs = {
  filter: StatsFilter;
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryStatsForVirtualDevicesArgs = {
  filter: NetworkStatsFilter;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryStatsPageForVirtualDevicesArgs = {
  filter: StatsFilter;
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySuggestedNosUpgradeGroupForDeviceArgs = {
  controllerRole?: InputMaybe<HighAvailabilityControllerRole>;
  deviceLabel: Scalars['String']['input'];
  deviceType: VirtualDeviceType;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySupportCaseArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySupportCaseAttachmentsArgs = {
  UUIDs: Array<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySupportCasesArgs = {
  input?: InputMaybe<GetSupportCasesInput>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySupportProvidersArgs = {
  input?: InputMaybe<GetSupportProvidersInput>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySupportUsersArgs = {
  input?: InputMaybe<SupportUserFilterInput>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySwitchAutoConfigMacAddressVlanBindingsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySwitchMacTableArgs = {
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySwitchMacTableFiltersArgs = {
  networkUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySwitchMacTablePageArgs = {
  input: GetSwitchMacTablePageInput;
  networkUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySwitchMacTableSortOrderDefinitionsArgs = {
  networkUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySwitchPortMetricsRateArgs = {
  filter: MetricsFilterInput;
  portNumber?: InputMaybe<Scalars['Int']['input']>;
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySwitchPortStatsArgs = {
  lookbackHours?: InputMaybe<Scalars['Int']['input']>;
  portNumber?: InputMaybe<Scalars['Int']['input']>;
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySystemInfoStatForVirtualDeviceArgs = {
  filter: SystemInfoStatsFilter;
  virtualDeviceUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QuerySystemMetricsForVirtualDevicesArgs = {
  filter: MetricsFilterInput;
  virtualDeviceUUIDs: Array<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryTemporaryAccessCompaniesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryTemporaryAccessCompanyBySlugArgs = {
  slug: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryTemporaryAccessGrantArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryTemporaryAccessGrantsArgs = {
  filter?: InputMaybe<TemporaryAccessGrantsFilter>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryTicketInboxMessageArgs = {
  supportCaseUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryTopologyDesignVersionArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryTopologyDesignVersionsArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryUnassignedHardwareDevicesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryUnderlayPoolsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryUplinkPhyInterfacesForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryUserNetworkAccessExpiryArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryValidateNacIdPConfigArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryVendorForOuiArgs = {
  OUI: Scalars['String']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryVirtualDeviceArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryVirtualDeviceTagsByNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryVirtualDevicesByTagArgs = {
  tagUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryVirtualDevicesForNetworkArgs = {
  filter?: InputMaybe<DevicesForNetworkFilter>;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryVlanArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryVlanMetricsArgs = {
  filter: MetricsFilterInput;
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUID: Scalars['UUID']['input'];
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryVlansArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWanSpeedtestJobArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWanSpeedtestJobsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWifiIpsKsArgs = {
  ssidUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWirelessCalibrationJobArgs = {
  UUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWirelessCalibrationJobsForNetworkArgs = {
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWirelessClientConnectionEventArgs = {
  eventType: WirelessClientConnectionEventType;
  networkUUID: Scalars['UUID']['input'];
  timestamp: Scalars['DateTime']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWirelessClientConnectionEventsAggregatesArgs = {
  count?: Scalars['Int']['input'];
  filter: ClientMetricsTimeseriesFilterInput;
  groupBy?: WirelessConnectionEventsAggregateDimension;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWirelessClientConnectionEventsByApArgs = {
  apVirtualDeviceUUID: Scalars['UUID']['input'];
  filter: ClientMetricsTimeseriesFilterInput;
  limit?: Scalars['Int']['input'];
  networkUUID: Scalars['UUID']['input'];
  offset?: Scalars['Int']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWirelessClientConnectionEventsByClientArgs = {
  filter: ClientMetricsTimeseriesFilterInput;
  limit?: Scalars['Int']['input'];
  macAddress: Scalars['MacAddress']['input'];
  networkUUID: Scalars['UUID']['input'];
  offset?: Scalars['Int']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWirelessClientConnectionEventsEnhancedArgs = {
  filter: ClientMetricsTimeseriesFilterInput;
  limit?: Scalars['Int']['input'];
  networkUUID: Scalars['UUID']['input'];
  offset?: Scalars['Int']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWirelessClientMetricsArgs = {
  filter: ClientMetricsTimeseriesFilterInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWirelessClientMetricsByApArgs = {
  apVirtualDeviceUUID: Scalars['UUID']['input'];
  filter: ClientMetricsTimeseriesFilterInput;
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWirelessClientMetricsByClientArgs = {
  filter: ClientMetricsTimeseriesFilterInput;
  macAddress: Scalars['MacAddress']['input'];
  networkUUID: Scalars['UUID']['input'];
};


/** The root query type of the GraphQL schema. Contains all read-only fetch operations. */
export type QueryWirelessClientMetricsByNetworkArgs = {
  filter: ClientMetricsTimeseriesFilterInput;
  networkUUID: Scalars['UUID']['input'];
  virtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Represents an individual ISP Quote for a Quote Request. */
export type Quote = {
  __typename?: 'Quote';
  /** Unique identifier for the Quote. */
  UUID: Scalars['UUID']['output'];
  /** OnNet/NearNet/OffNet distinction for provider product quoted. */
  availabilities?: Maybe<LocationProviderAvailabilityData>;
  /**
   * OnNet/NearNet/OffNet distinction for provider product quoted.
   * @deprecated Use `availabilities.availability` instead.
   */
  availability?: Maybe<LocationProviderAvailabilitySource>;
  /** Product type of the quote. */
  connectionType?: Maybe<InternetServicePlanConnectionType>;
  /** Length of the contract in months. */
  contractLengthMonths?: Maybe<Scalars['Int']['output']>;
  /** Actual contract term in months committed to with the underlying carrier, which may differ from the customer-facing contractLengthMonths. */
  contractLengthMonthsInternal?: Maybe<Scalars['Int']['output']>;
  /** Creation date of the quote. */
  createdAt: Scalars['DateTime']['output'];
  /** Origin of the quote (manual or integration). */
  createdBy: QuoteCreatedBy;
  /** State of the Quote. */
  currentState: QuoteStateLogEntry;
  /** Monthly usage cap. */
  dataCapGB?: Maybe<Scalars['Int']['output']>;
  /** Download speed in Kbps. */
  downloadKbps?: Maybe<Scalars['Int']['output']>;
  /** SFDC id of Quote object. */
  externalID?: Maybe<Scalars['String']['output']>;
  /** Installation fee in cents. */
  installFeeCents?: Maybe<Scalars['Int']['output']>;
  /** Wholesale installation fee in cents. */
  installFeeWholesaleCents?: Maybe<Scalars['Int']['output']>;
  /** SFDC OpportunityLineItem id for the install. */
  installLineItemExternalID?: Maybe<Scalars['String']['output']>;
  /** Estimated number of days for installation. */
  installationEstimateDays?: Maybe<Scalars['Int']['output']>;
  /** Internet Service Plan associated with this quote */
  internetServicePlan?: Maybe<InternetServicePlan>;
  /** The broker responsible for quote and its fulfillment. */
  internetServicePlanBrokerProvider?: Maybe<InternetServicePlanProvider>;
  /** ISP Provider associated with the Quote. */
  internetServicePlanProvider: InternetServicePlanProvider;
  /** Underlying ISP Provider associated with Quote when request is Wholesale (and Meter is the Provider) */
  internetServicePlanSubProvider?: Maybe<InternetServicePlanProvider>;
  /** Minimum estimated number of days for installation, based on product type. */
  minInstallationEstimateDays?: Maybe<Scalars['Int']['output']>;
  /** Monthly fee in cents. */
  monthlyFeeCents?: Maybe<Scalars['Int']['output']>;
  /** Monthly fee prior to any discounts applied. */
  monthlyFeePreDiscountCents?: Maybe<Scalars['Int']['output']>;
  /** Wholesale cost. */
  monthlyFeeWholesaleCents?: Maybe<Scalars['Int']['output']>;
  /** SFDC OpportunityLineItem id for the monthly recurring cost. */
  monthlyLineItemExternalID?: Maybe<Scalars['String']['output']>;
  /** Whether the Quote is selected and missing an upload speed, or missing a monthly wholesale cost on a wholesale QuoteRequest. */
  needsData: Scalars['Boolean']['output'];
  /** Internal notes about the quote. */
  notes: Scalars['String']['output'];
  /** ID of the quote in the provider API. */
  providerQuoteID?: Maybe<Scalars['String']['output']>;
  /** Unique indentifier of the Quote Request containing the quote. */
  quoteRequestUUID: Scalars['UUID']['output'];
  /** Whether this quote is recommended. */
  recommended: Scalars['Boolean']['output'];
  /** Responsibility for riser cabling work. */
  riserResponsibility: RiserResponsibility;
  /** Whether a router is included in the quote. */
  routerIncluded: Scalars['Boolean']['output'];
  /**
   * Indicates selection status.
   * @deprecated Use `selectionPriority` instead.
   */
  selectedStatus: QuoteSelectionStatus;
  /** Indicates a quote has been selected and its proposed priority. */
  selectionPriority?: Maybe<Scalars['Int']['output']>;
  /** Indicates the source of the quote. */
  source: QuoteSource;
  /** Status of the Quote. */
  status: QuoteStatus;
  /** Upload speed in Kbps. */
  uploadKbps?: Maybe<Scalars['Int']['output']>;
  /** Raw request results from carrier pricing APIs for this Quote, newest first. */
  vendorData: Array<QuoteRequestVendorData>;
};

/** Indicates who created the quote. */
export enum QuoteCreatedBy {
  /** Quote was manually entered. */
  Manual = 'MANUAL',
  /** Quote was created by a third-party integration. */
  ThirdParty = 'THIRD_PARTY'
}

/** Preferences for recommending a Quote Request's quotes. */
export type QuoteRecommendationInput = {
  /** Never recommended. */
  exclusions?: InputMaybe<Array<QuoteRecommendationProviderInput>>;
  /** Recommended ahead of the default ranking, in order, when serviceable and allowed by the slot's product group. */
  preferred?: InputMaybe<Array<QuoteRecommendationProviderInput>>;
  /** Priorities to fill. Locked selections are always kept; other selections at unlisted priorities are cleared when applied. */
  slots: Array<QuoteRecommendationSlotInput>;
};

/** A provider's product, identified by provider and connection type. */
export type QuoteRecommendationProviderInput = {
  /** UUID of the connection type. */
  connectionTypeUUID: Scalars['UUID']['input'];
  /** UUID of the provider. */
  providerUUID: Scalars['UUID']['input'];
};

/** The quote selected at a priority and the quote recommended for it. */
export type QuoteRecommendationSlot = {
  __typename?: 'QuoteRecommendationSlot';
  /** Download speeds offered for the recommended provider. */
  downloadKbpsOptions: Array<Scalars['Int']['output']>;
  /** Whether the selected quote is contracting or ordered. Locked slots are kept and get no recommendation. */
  locked: Scalars['Boolean']['output'];
  /** Product group of the recommendation, or of the selected quote when locked. */
  productGroup?: Maybe<ConnectProductGroup>;
  /** Product groups with an available provider at the location. */
  productGroupOptions: Array<ConnectProductGroup>;
  /** Providers and connection types that can be recommended at the slot's contract length, in recommendation order. Includes excluded ones. */
  recommendableProviderConnectionTypes: Array<RecommendableProviderConnectionType>;
  /** Whether the selected quote already matches the recommendation. */
  recommendationIsSelected: Scalars['Boolean']['output'];
  /** Recommended quote, which is not saved: its UUID identifies the recommended terms and matches no stored quote, and selecting it means applying the recommendations. Null when locked or when no provider is available. */
  recommendedQuote?: Maybe<Quote>;
  /** Quote currently selected at this priority. */
  selectedQuote?: Maybe<Quote>;
  /** Selection priority: 1 = primary, 2 = backup, 3 = tertiary. */
  selectionPriority: Scalars['Int']['output'];
  /** Why there is no recommendation for an unlocked slot. */
  unavailableReason?: Maybe<Scalars['String']['output']>;
};

/** What to recommend at one selection priority. */
export type QuoteRecommendationSlotInput = {
  /** Customer term in months: 12, 24, 36 or 60. Only providers offering a term at or below it are recommended, priced at the longest rate card term not exceeding it. Defaults to 36. */
  contractLengthMonths?: InputMaybe<Scalars['Int']['input']>;
  /** Needed download speed. The slowest offered speed at or above it is recommended, else the fastest. Defaults to the Quote Request's requestedDownloadKbps, then to 1 Gbps for DIA and Broadband. */
  downloadKbps?: InputMaybe<Scalars['Int']['input']>;
  /** Customer installation fee in cents. Defaults to 0 for retail. Ignored for wholesale. */
  installFeeCents?: InputMaybe<Scalars['Int']['input']>;
  /** Customer monthly fee in cents. Retail is not on the rate card, so this is required to apply a retail selection. Ignored for wholesale. */
  monthlyFeeCents?: InputMaybe<Scalars['Int']['input']>;
  /** Product group to recommend. Defaults to DIA for the primary and Broadband for later priorities, falling back to the next group with an available provider. */
  productGroup?: InputMaybe<ConnectProductGroup>;
  /** Priority to fill: 1 = primary, 2 = backup, 3 = tertiary. */
  selectionPriority: Scalars['Int']['input'];
};

/** Recommended quotes for a Quote Request. */
export type QuoteRecommendations = {
  __typename?: 'QuoteRecommendations';
  /** Accepted customer contract terms. */
  contractLengthMonthsOptions: Array<Scalars['Int']['output']>;
  /** One slot per requested or locked priority, in priority order. */
  slots: Array<QuoteRecommendationSlot>;
};

/** Represents an ISP Quote Request. */
export type QuoteRequest = Identifiable & {
  __typename?: 'QuoteRequest';
  /** Unique identifier for the Quote Request. */
  UUID: Scalars['UUID']['output'];
  /** Address for which the Quote Request is created. */
  address?: Maybe<ConnectAddress>;
  /** Company associated with this Quote Request. */
  company?: Maybe<Company>;
  /** Email of customer initiating the Quote Request. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** Name of customer initiating the Quote Request. */
  contactName?: Maybe<Scalars['String']['output']>;
  /** Phone number of customer initiating the Quote Request. */
  contactTelephone?: Maybe<Scalars['String']['output']>;
  /** Requested maximum days to install. */
  contractMaximumInstallDate?: Maybe<Scalars['DateTime']['output']>;
  /** Requested minumum contract length in months. */
  contractMinimumMonths?: Maybe<Scalars['Int']['output']>;
  /** DateTime when the quote request was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Curent state of the Quote Request. */
  currentState: QuoteRequestStateLogEntry;
  /** End date of the potential customer's existing ISP contract. */
  existingContractEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** Monthly recurring cost of the customer. */
  existingMonthlyFeeCents?: Maybe<Scalars['Int']['output']>;
  /** SFDC id of QuoteRequest object. */
  externalID?: Maybe<Scalars['String']['output']>;
  /** Is the user interested in the Meter Network product. */
  isInterestedInNetwork: Scalars['Boolean']['output'];
  /** Is there a pending manual quote that needs to be prepared. */
  isManualResponsePending: Scalars['Boolean']['output'];
  /** The mailing address associated with this Internet Service Plan connecting it to a SFDC opportunity location. */
  mailingAddress?: Maybe<MailingAddress>;
  /** The network associated with the Quote Request. */
  network?: Maybe<Network>;
  /** UUID of Network associated with this Quote Request. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** Note tracking details of quote creation. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Contact and business information collected in order to generate an ISP contract. */
  onboarding?: Maybe<QuoteRequestOnboarding>;
  /** Sales Opportunity associated with the Quote Request. */
  opportunity?: Maybe<Opportunity>;
  /**
   * SFDC id of associated Opportunity object.
   * @deprecated Use `opportunity.externalID` instead.
   */
  opportunityExternalID?: Maybe<Scalars['String']['output']>;
  /** UUID of primary selected quote. */
  primarySelectedQuoteUUID?: Maybe<Scalars['UUID']['output']>;
  /** Procurement channel/pricing method for the associated quotes. */
  procurementChannel: ConnectProcurementChannel;
  /** Quotes associated with this Quote Request */
  quotes?: Maybe<Array<Quote>>;
  /** Proposed name of the company to create or associate with quote request. */
  requestedCompanyName?: Maybe<Scalars['String']['output']>;
  /** Requested download speed. */
  requestedDownloadKbps?: Maybe<Scalars['Int']['output']>;
  /** Requested upload speed. */
  requestedUploadKbps?: Maybe<Scalars['Int']['output']>;
  /** UUID of backup selected quote. */
  secondarySelectedQuoteUUID?: Maybe<Scalars['UUID']['output']>;
  /** Serviceability at the Quote Request's location, one per provider and connection type. */
  serviceability: Array<ProviderServiceability>;
  /** Link to slack thread where this Quote Request is discussed. */
  slackThreadLink?: Maybe<Scalars['String']['output']>;
  /** Full history of state changes for this Quote Request, ordered oldest to newest. */
  stateLogEntries: Array<QuoteRequestStateLogEntry>;
  /** Status of the Quote Request. DEPRECATED. */
  status: QuoteRequestStatus;
  /** User handling fulfillment/support. */
  supportUsers?: Maybe<Array<QuoteRequestSupportUser>>;
  /** Raw responses from vendor APIs. */
  vendorData?: Maybe<Array<QuoteRequestVendorData>>;
};

/** Filter input for Quote Request fields. */
export type QuoteRequestFilterInput = {
  /** UUID of Company. */
  companyUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Has accepted quotes. */
  hasAcceptedQuotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has selected quotes. */
  hasSelectedQuotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is not complete or canceled and has selected quotes missing upload speed, or missing monthly wholesale cost on wholesale requests. */
  needsQuoteData?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether Connect is included on the associated Opportunity. */
  opportunityConnectIncluded?: InputMaybe<Array<OpportunityConnectIncluded>>;
  /** UUID of Opportunity. */
  opportunityUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Procurement channels to filter on. */
  procurementChannels?: InputMaybe<Array<ConnectProcurementChannel>>;
  /** UUID of QuoteRequest. */
  quoteRequestUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Having quotes of a certain state. */
  quoteStates?: InputMaybe<Array<QuoteState>>;
  /** Input for non-exact search against ISP fields. */
  search?: InputMaybe<QuoteRequestSearchInput>;
  /** State of the request. */
  states?: InputMaybe<Array<QuoteRequestState>>;
  /** Users responsible for handling the request. */
  supportUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Contact and business information collected for a quote request in order to generate an ISP contract. */
export type QuoteRequestOnboarding = {
  __typename?: 'QuoteRequestOnboarding';
  /** Unique identifier for the quote request onboarding. */
  UUID: Scalars['UUID']['output'];
  /** Date the associated company was incorporated. */
  companyIncorporatedDate: Scalars['DateTime']['output'];
  /** Legal name of associated company. */
  companyLegalName: Scalars['String']['output'];
  /** US State of the associated company. */
  companyState: Scalars['String']['output'];
  /** TaxID of associated company. */
  companyTaxid: Scalars['String']['output'];
  /** Type of the associated company. */
  companyType: CompanyType;
  /** Email of contact intending to be onsite during install. */
  onsiteContactEmail: Scalars['String']['output'];
  /** Name of contact intending to be onsite during install. */
  onsiteContactName: Scalars['String']['output'];
  /** Phone number of contact intending to be onsite during install. */
  onsiteContactPhone: Scalars['String']['output'];
  /** Unique identifier of the quote request for which the onboarding data was collected. */
  quoteRequestUUID: Scalars['UUID']['output'];
  /** Email of contact intending to sign the contract. */
  signorContactEmail: Scalars['String']['output'];
  /** Name of contact intending to sign the contract. */
  signorContactName: Scalars['String']['output'];
  /** Phone number of contact intending to sign the contract. */
  signorContactPhone: Scalars['String']['output'];
};

/** Options input for Quote Request fields. */
export type QuoteRequestOptionsInput = {
  /** Ensure locations in result are disinct, prioritizing most recent result. */
  distinctOnLocation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Page of Quote Requests. */
export type QuoteRequestPage = {
  __typename?: 'QuoteRequestPage';
  /** The results for this page. */
  items: Array<QuoteRequest>;
  /** The total number of results available based on the provided filters. */
  total: Scalars['Int']['output'];
};

/** Input for non-exact search against Quote Request fields. Filters are AND'd together. */
export type QuoteRequestSearchInput = {
  /** Company name associated with request. */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Contact email for the request. */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Contact name for the request. */
  contactName?: InputMaybe<Scalars['String']['input']>;
  /** Location associated with the request. */
  location?: InputMaybe<Scalars['String']['input']>;
};

/** State of ISP Quote Request. */
export enum QuoteRequestState {
  /** Attempting to contact requester. */
  AttemptingContact = 'ATTEMPTING_CONTACT',
  /** Requester needs to change the address on the Quote Request. */
  AwaitingAddressChange = 'AWAITING_ADDRESS_CHANGE',
  /** Quote Request has been canceled. */
  Canceled = 'CANCELED',
  /** Quote Request process is complete. */
  Complete = 'COMPLETE',
  /** A new Quote Request has been started and quotes are being generated. */
  GeneratingQuotes = 'GENERATING_QUOTES',
  /** Actively working on getting quotes from providers. */
  InProgress = 'IN_PROGRESS',
  /** Flagged for the Connect product team. */
  NeedingInternalReview = 'NEEDING_INTERNAL_REVIEW',
  /** A new Quote Request has been created. */
  New = 'NEW',
  /** Ongoing relationship-building with requester. */
  Nurturing = 'NURTURING',
  /** User is in process of ordering service. */
  OrderingService = 'ORDERING_SERVICE',
  /** Request has been qualified. */
  Qualified = 'QUALIFIED',
  /** Quotes have been generated for the Quote Request. */
  ReadyForReview = 'READY_FOR_REVIEW',
  /** Indicates all quote selections has occurred. */
  ServiceabilityCheckComplete = 'SERVICEABILITY_CHECK_COMPLETE',
  /** Quote Request state is unknown. */
  Unknown = 'UNKNOWN',
  /** Requester has been deemed unqualified. */
  Unqualified = 'UNQUALIFIED'
}

/** Quote Request state and meta data. */
export type QuoteRequestStateLogEntry = {
  __typename?: 'QuoteRequestStateLogEntry';
  /** Whether this state was set automatically rather than by a human. */
  automated: Scalars['Boolean']['output'];
  /** Time of when the state was entered. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** UUID of associated Quote Request. */
  quoteRequestUUID: Scalars['UUID']['output'];
  /** State of ISP Quote Request. */
  state: QuoteRequestState;
};

/** Status of ISP Quote Request. DEPRECATED. */
export enum QuoteRequestStatus {
  /** Quote Request has been archived. */
  Archived = 'ARCHIVED',
  /** Contract details have been collected for the Quote Request. */
  ContractRequested = 'CONTRACT_REQUESTED',
  /** Quote Request has been started. */
  Created = 'CREATED',
  /** Quotes have been selected from the Quote Request. Contract details can be collected. */
  ReadyForContract = 'READY_FOR_CONTRACT',
  /** Quotes have been generated for the Quote Request. */
  ReadyForReview = 'READY_FOR_REVIEW'
}

/** Internal user responsible for fulfillment/support of a Quote Request. */
export type QuoteRequestSupportUser = {
  __typename?: 'QuoteRequestSupportUser';
  /** All support roles for this user. */
  supportRoles: Array<SupportUser>;
  /**
   * Deprecated: Use supportRoles instead. Returns only the first support role
   * for this user. If the user has multiple support roles, the others are not
   * included. May return null if the user has no support roles.
   * @deprecated Use `supportRoles` instead. Only returns the first support role.
   */
  supportUser?: Maybe<SupportUser>;
  /** Describes the type of role the user is fulfilling for the plan. */
  type: QuoteRequestSupportUserType;
  /** Associated user. */
  user: User;
};

/** Input type for users associated with a Quote Request. */
export type QuoteRequestSupportUserInput = {
  /** Describes the type of role the user is fulfilling for the Quote Request. */
  type: QuoteRequestSupportUserType;
  /** ID of the user to associate. */
  userID: Scalars['ID']['input'];
};

/** Type of role the user is fulfilling for the Quote Request. */
export enum QuoteRequestSupportUserType {
  /** Primary support person, typically a program manager. */
  Primary = 'PRIMARY',
  /** Secondary support person, typically an ops associate. */
  Secondary = 'SECONDARY'
}

/** Quote request quoting and serviceability vendors. */
export enum QuoteRequestVendor {
  /** ATT Broadband. */
  AttBroadband = 'ATT_BROADBAND',
  /** ATT DIA. */
  AttDia = 'ATT_DIA',
  /** Comcast. */
  Comcast = 'COMCAST',
  /** Connectbase. */
  Connectbase = 'CONNECTBASE',
  /** EasyQuote. */
  Easyquote = 'EASYQUOTE',
  /** Lumen. */
  Lumen = 'LUMEN',
  /** Monkeybrains. */
  Monkeybrains = 'MONKEYBRAINS',
  /** Zayo. */
  Zayo = 'ZAYO'
}

/** Raw response and error data from vendor APIs used in generating the quote request. */
export type QuoteRequestVendorData = {
  __typename?: 'QuoteRequestVendorData';
  /** Unique identifier for the vendor data. */
  UUID: Scalars['UUID']['output'];
  /** When the request was completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the request was started. */
  createdAt: Scalars['DateTime']['output'];
  /** Raw errors from the vendor API. */
  error?: Maybe<Scalars['String']['output']>;
  /** UUID of the Quote this pricing request was made for. Null for serviceability requests. */
  quoteUUID?: Maybe<Scalars['UUID']['output']>;
  /** Raw response from the vendor API. */
  rawResponse?: Maybe<Scalars['String']['output']>;
  /** Status of the request(s) to the vendor API. */
  status: QuoteRequestVendorDataStatus;
  /** Name given to the vendor API. */
  vendor: QuoteRequestVendor;
};

/** Status of the quote request vendor API request. */
export enum QuoteRequestVendorDataStatus {
  /** Vendor API request has errored. */
  Error = 'ERROR',
  /** Vendor API request is running. */
  Running = 'RUNNING',
  /** Vendor API request has succeeded. */
  Success = 'SUCCESS'
}

/** Indicates the selected status of a quote. */
export enum QuoteSelectionStatus {
  /** Quote has been selected as a backup. */
  Backup = 'BACKUP',
  /** Quote not selected. */
  None = 'NONE',
  /** Quote has been selected as primary. */
  Primary = 'PRIMARY'
}

/** Indicates the source from which the quote availability was generated. */
export enum QuoteSource {
  /** Quote was provided directly by the carrier. */
  Carrier = 'CARRIER',
  /** Quote was retrieved via Connectbase. */
  Connectbase = 'CONNECTBASE',
  /** Quote was imported from EasyQuote integration. */
  Easyquote = 'EASYQUOTE',
  /** Quote came from existing InternetServicePlan. */
  InternetServicePlans = 'INTERNET_SERVICE_PLANS',
  /** Quote was manually entered. */
  Manual = 'MANUAL',
  /** Quote was derived from a static rate card. */
  StaticRate = 'STATIC_RATE',
  /** Quote source unknown. */
  Unknown = 'UNKNOWN'
}

/** State of an individual ISP Quote. */
export enum QuoteState {
  /** Awaiting cost approval. */
  AwaitingCostApproval = 'AWAITING_COST_APPROVAL',
  /** Awaiting communication from the ISP. */
  AwaitingIspCommunication = 'AWAITING_ISP_COMMUNICATION',
  /** The quote has been canceled. */
  Canceled = 'CANCELED',
  /** Verifying the carrier can serve this address. */
  CheckingServiceability = 'CHECKING_SERVICEABILITY',
  /** Contract has been signed by the customer. */
  Complete = 'COMPLETE',
  /** Contract has been produced by the provider and is ready for a signature. */
  ContractAvailable = 'CONTRACT_AVAILABLE',
  /** Contract has been requested from the provider. */
  ContractRequested = 'CONTRACT_REQUESTED',
  /** A new quote has been created. */
  New = 'NEW',
  /** Pricing has returned by the provider. */
  PricingAvailable = 'PRICING_AVAILABLE',
  /** Pricing request has been made by the user. */
  PricingRequested = 'PRICING_REQUESTED',
  /** Quote has been accepted by the Sales team. */
  SalesAccepted = 'SALES_ACCEPTED',
  /** A site survey is being conducted. */
  SiteSurvey = 'SITE_SURVEY',
  /** Quote state is unknown. */
  Unknown = 'UNKNOWN'
}

/** Quote state and meta data. */
export type QuoteStateLogEntry = {
  __typename?: 'QuoteStateLogEntry';
  /** Time of when the state was entered. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** UUID of associated quote. */
  quoteUUID: Scalars['UUID']['output'];
  /** State of ISP Quote Request. */
  state: QuoteState;
};

/** Status of the ISP Quote. */
export enum QuoteStatus {
  /** Quote is currently disabled and not visible to users. */
  Disabled = 'DISABLED',
  /** Quote is enabled and visible to users. */
  Enabled = 'ENABLED',
  /** Quote is in a proposed state and awaiting confirmation. */
  Proposed = 'PROPOSED',
  /** Quote has been requested by a customer. */
  Requested = 'REQUESTED'
}

/** Properties for a RADIUS auth-server failover event. */
export type RadiusFailoverProperties = {
  __typename?: 'RADIUSFailoverProperties';
  /** Per server-pair breakdown: each entry is how many times one auth server failed over to another. */
  failovers?: Maybe<Array<RadiusServerFailover>>;
  /** The total number of auth-server failovers observed in the window. */
  totalFailoverCount: Scalars['Int']['output'];
};

/**
 * A single directed RADIUS auth-server failover (from one server to another) and
 * how many times it occurred in the window.
 */
export type RadiusServerFailover = {
  __typename?: 'RADIUSServerFailover';
  /** The number of times traffic failed over from this server to the other in the window. */
  failoverCount: Scalars['Int']['output'];
  /** The RADIUS auth server that failed. */
  fromIP: Scalars['IP']['output'];
  /** The port of the RADIUS auth server that failed. */
  fromPort: Scalars['Int']['output'];
  /** The RADIUS auth server that traffic failed over to. */
  toIP: Scalars['IP']['output'];
  /** The port of the RADIUS auth server that traffic failed over to. */
  toPort: Scalars['Int']['output'];
};

/** A single interface to capture on. */
export type RpccosPacketCaptureInterfaceInput = {
  /** Capture on an IPsec tunnel */
  ipsecUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Capture on a link aggregation group */
  lagInterfaceNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Capture on a loopback interface */
  loopbackId?: InputMaybe<Scalars['Int']['input']>;
  /** Capture on a physical port */
  port?: InputMaybe<Scalars['Int']['input']>;
  /** Capture on a PPPoE session interface */
  pppoeId?: InputMaybe<Scalars['Int']['input']>;
  /** Capture on a VLAN */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Capture on a WireGuard tunnel */
  wireguardUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input to run a packet capture on a firewall. */
export type RpccosPacketCaptureStartInput = {
  /** An optional pcap-filter(7) expression (tcpdump/libpcap syntax) applied to the whole capture across all targets; if empty, all traffic is captured. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** Whether to email the requesting user once the capture completes and its file is ready to download. */
  notifyOnCompletion?: Scalars['Boolean']['input'];
  /** The maximum size limit of the packet capture file in bytes. */
  sizeLimitBytes: Scalars['Int']['input'];
  /** The interfaces to capture on. At least one target is required. */
  targets: Array<RpccosPacketCaptureTargetInput>;
  /** The maximum duration of the packet capture in milliseconds. */
  timeLimitMS: Scalars['Int']['input'];
};

/** A single packet capture target, which is the interface and an optional filter. */
export type RpccosPacketCaptureTargetInput = {
  /** An optional per-interface pcap-filter(7) expression that overrides the capture-level filter for this interface. Not persisted; the capture-level filter is what's stored and shown. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** The interface to capture on. */
  interface: RpccosPacketCaptureInterfaceInput;
};

/** A response containing the results of a cable test. */
export type RpcCableTestResponse = {
  __typename?: 'RPCCableTestResponse';
  /** The result for twisted pair A. */
  pairA: RpcCableTestTwistedPairResult;
  /** The result for twisted pair B. */
  pairB: RpcCableTestTwistedPairResult;
  /** The result for twisted pair C. */
  pairC: RpcCableTestTwistedPairResult;
  /** The result for twisted pair D. */
  pairD: RpcCableTestTwistedPairResult;
};

/** Result of the cable test for a single twisted pair. */
export type RpcCableTestTwistedPairResult = {
  __typename?: 'RPCCableTestTwistedPairResult';
  /** The estimated length of the twisted pair in meters. */
  estimatedLengthInMeters: Scalars['Int']['output'];
  /** The status of the twisted pair in the cable test. */
  status: RpcCableTestTwistedPairStatus;
};

/**
 * Cable test checks each pair of wires (Ethernet cables have 4 pairs) to find if they are crimped correctly.
 * The wires can be good, open (not connected), short, or have crosstalk (bad cabling).
 * Emplus's implementation can also estimate the length of the Ethernet cable (in meters).
 * Cable test can only be run on RJ45 Ethernet ports and not on SFP ports.
 */
export enum RpcCableTestTwistedPairStatus {
  /** The twisted pair has crosstalk (bad cabling causing interference between pairs). */
  Crosstalk = 'CROSSTALK',
  /** The twisted pair is functioning correctly. */
  Good = 'GOOD',
  /** The twisted pair is open (not connected at one end). */
  Open = 'OPEN',
  /** The twisted pair has both an open and a short circuit. */
  OpenShort = 'OPEN_SHORT',
  /** The twisted pair has a short circuit. */
  Short = 'SHORT',
  /** The status of the twisted pair is unknown. */
  Unknown = 'UNKNOWN'
}

/** A request to perform DNS lookups from a device. */
export type RpcdnsInput = {
  /** An optional DNS server to use. If not provided, the device's default DNS server is used. */
  dnsServer?: InputMaybe<Scalars['IP']['input']>;
  /** The list of hosts to resolve. */
  hosts: Array<Scalars['String']['input']>;
  /** The serial number of the device. */
  serialNumber: Scalars['String']['input'];
};

/** The result of a DNS lookup for one host. */
export type RpcdnsResponse = {
  __typename?: 'RPCDNSResponse';
  /** The host that was queried. */
  host: Scalars['String']['output'];
  /** The resolved IP addresses for this host. */
  ips: Array<Scalars['IP']['output']>;
  /** The status of the DNS lookup. */
  status: RpcdnsStatus;
};

/** The status of a DNS lookup for a single host. */
export enum RpcdnsStatus {
  /** The DNS lookup failed. */
  Error = 'ERROR',
  /** The DNS lookup was successful. */
  Ok = 'OK'
}

/** A request to run an EAPOL test on a WOS access point. */
export type RpcEapolTestForSerialInput = {
  /** The UUID of the RADIUS server profile (either primary or secondary encryption 802.1X) to use for the EAPOL test. */
  Encryption8021XUUID: Scalars['UUID']['input'];
  /** The password to use for the EAPOL test. */
  password: Scalars['String']['input'];
  /** The serial number of the device to run the EAPOL test on. */
  serialNumber: Scalars['String']['input'];
  /** The UUID of the SSID to use for the EAPOL test. An EAPOL test without `ssidUuid` will omit sending this field to the authentication server. */
  ssidUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** The username to use for the EAPOL test. */
  user: Scalars['String']['input'];
};

/** A response containing the results of an EAPOL test. */
export type RpcEapolTestForSerialResponse = {
  __typename?: 'RPCEapolTestForSerialResponse';
  /** A human-readable error message if the EAPOL test failed with an unknown error. */
  error_reason?: Maybe<Scalars['String']['output']>;
  /** The serial number of the device this test was run on. */
  serialNumber: Scalars['String']['output'];
  /** The status of the EAPOL server response. */
  status: RpcEapolTestForSerialStatus;
};

/**
 * EAPOL (Extensible Authentication Protocol over LAN) is a network authentication protocol used in IEEE 802.1X to
 * authenticate users and computers in a network through a RADIUS server. It is used in wireless networks (WPA-Enterprise)
 * to secure access. The EAPOL test RPC runs directly on a WOS access point and simulates a client connecting wirelessly to
 * an AP performing RADIUS authentication. A successful EAPOL test means that the AP can authenticate a client with the
 * RADIUS server using the provided credentials and validates that a client can connect to the network.
 */
export enum RpcEapolTestForSerialStatus {
  /** The EAPOL test failed due to bad user/password credentials. */
  FailureBadCredentials = 'FAILURE_BAD_CREDENTIALS',
  /** The EAPOL test failed due to an incorrect RADIUS secret. */
  FailureIncorrectRadiusSecret = 'FAILURE_INCORRECT_RADIUS_SECRET',
  /** The EAPOL test failed due to the server not responding in time. */
  FailureRadiusServerTimeout = 'FAILURE_RADIUS_SERVER_TIMEOUT',
  /** The EAPOL test failed due to an unknown error. See `error_reason` for more details. */
  FailureUnknown = 'FAILURE_UNKNOWN',
  /** The EAPOL test was successful. */
  Success = 'SUCCESS'
}

/** A request to run EAPOL tests on multiple WOS access points. */
export type RpcEapolTestForSerialsInput = {
  /** The UUID of the RADIUS server profile (either primary or secondary encryption 802.1X) to use for the EAPOL tests. */
  Encryption8021XUUID: Scalars['UUID']['input'];
  /** The password to use for the EAPOL tests. */
  password: Scalars['String']['input'];
  /** The serial numbers of the devices to run the EAPOL tests on. */
  serialNumbers: Array<Scalars['String']['input']>;
  /** The UUID of the SSID to use for the EAPOL tests, if applicable. An EAPOL test without `ssidUuid` will omit sending this field to the authentication server. */
  ssidUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** The username to use for the EAPOL tests. */
  user: Scalars['String']['input'];
};

/** The line encoding used by the SERDES on the port. */
export enum RpcEyeTestEncoding {
  /** Non-return-to-zero: one bit per symbol. */
  Nrz = 'NRZ',
  /** Four-level pulse amplitude modulation: two bits per symbol. */
  Pam4 = 'PAM4',
  /** The encoding is unknown. */
  Unknown = 'UNKNOWN'
}

/** Eye measurements for a single SERDES lane. */
export type RpcEyeTestLaneResult = {
  __typename?: 'RPCEyeTestLaneResult';
  /** The height of the open eye below the eye center, in millivolts. */
  downMV: Scalars['Int']['output'];
  /** SERDES lane number in the port. */
  lane: Scalars['Int']['output'];
  /**
   * Portion of the bit to the left of the eye center that makes up the open eye, in milli-unit-intervals(mUI).
   * A Uint Interval is the width of 1 bit based on lane bitrate. Some of the bit width is lost to jitter,
   * so at best is 500mUI. Larger is better.
   */
  leftMUI: Scalars['Int']['output'];
  /** The right of the eye center, in mUI. */
  rightMUI: Scalars['Int']['output'];
  /** The height of the open eye above the eye center, in millivolts. Larger is better. */
  upMV: Scalars['Int']['output'];
};

/** The results of an eye diagram test. */
export type RpcEyeTestResponse = {
  __typename?: 'RPCEyeTestResponse';
  /** The line encoding in use on the port aka eye type. */
  encoding: RpcEyeTestEncoding;
  /** The per-lane eye measurements. Empty when the status is NO_EYE. */
  lanes: Array<RpcEyeTestLaneResult>;
  /** Whether an eye could be measured on the port. */
  status: RpcEyeTestStatus;
  /** Number of active SERDES lanes measured. SFP is always 1, SFP-DD is up to 2, QSFP up to 4, QSFP-DD and OSFP up to 8. */
  totalLanes: Scalars['Int']['output'];
};

/**
 * An eye diagram test measures the quality of the electrical signal on an SFP port. The eye itself
 * is effectively a heatmap of where the square wave is, aligned on the middle of the square part of
 * the wave. The "eye" is the open region in the middle of the overlaid signal waveform; a wider and
 * taller eye means less jitter and noise. Each SERDES lane of the port is measured separately.
 * The eye test is only available on gen1 ports with link speed >=10G.
 */
export enum RpcEyeTestStatus {
  /** No eye could be measured on the port, because there is no link or the signal is unusable. */
  NoEye = 'NO_EYE',
  /** The eye was measured successfully and per-lane results are available. */
  Ok = 'OK',
  /** The status of the eye test is unknown. */
  Unknown = 'UNKNOWN'
}

/** A request to power-cycle an outlet on a Power Distribution Unit (PDU). */
export type RpcpduOutletCycleInput = {
  /** A list of UUIDs identifying the outlets to cycle. */
  outletUUIDs: Array<Scalars['UUID']['input']>;
};

/** A response containing the status of a packet capture request. */
export type RpcPacketCaptureResponse = {
  __typename?: 'RPCPacketCaptureResponse';
  /** Status of the packet capture request. */
  status: RpcPacketCaptureResponseStatus;
  /** The UUID of the packet capture. */
  uuid: Scalars['UUID']['output'];
};

/** Status of the packet capture response. */
export enum RpcPacketCaptureResponseStatus {
  /** The packet capture request failed. */
  Fail = 'FAIL',
  /** The tcpdump filter provided is not valid and did not compile correctly. */
  FailFilterCompilation = 'FAIL_FILTER_COMPILATION',
  /** The requested interface is not yet implemented for packet captures. */
  FailInterfaceNotImplemented = 'FAIL_INTERFACE_NOT_IMPLEMENTED',
  /** Packet capture failed due to blank job ID. */
  FailNoJobId = 'FAIL_NO_JOB_ID',
  /** Packet capture failed due to blank size limit. */
  FailNoSizeLimit = 'FAIL_NO_SIZE_LIMIT',
  /** Packet capture failed due to blank time limit. */
  FailNoTimeLimit = 'FAIL_NO_TIME_LIMIT',
  /** The packet capture request was successful. */
  Ok = 'OK',
  /** Unspecified status. */
  Unspecified = 'UNSPECIFIED'
}

/**
 * A single device target within a grouped packet capture request. The size and
 * time limits come from the enclosing group, so they are not specified per target.
 */
export type RpcPacketCaptureTargetInput = {
  /** The input parameters for starting the packet capture, if the device is a firewall. */
  cosInput?: InputMaybe<RpccosPacketCaptureStartInput>;
  /** The serial number of the device to start the packet capture on. */
  serialNumber: Scalars['String']['input'];
  /** The input parameters for starting the packet capture, if the device is a switch. */
  sosInput?: InputMaybe<RpcsosPacketCaptureStartInput>;
  /** The input parameters for starting the packet capture, if the device is an access point, observer, or cellular gateway. */
  wosInput?: InputMaybe<RpcwosPacketCaptureStartInput>;
};

/**
 * Input to start a group of packet captures. The shared size and time limits are
 * applied to every capture in the group; any per-target size/time limits are
 * ignored in favor of these.
 */
export type RpcPacketCapturesStartInput = {
  /** The devices to start packet captures on. */
  captures: Array<RpcPacketCaptureTargetInput>;
  /** An optional shared pcap-filter(7)/tcpdump filter applied to every capture in the group, overriding any per-target filter. Ignored by switch (SOS) captures, which don't support filtering. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** An optional label for the packet capture group. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The network the group and its captures belong to. */
  networkUUID: Scalars['UUID']['input'];
  /** Whether to email the requesting user once every capture in the group finishes and its file is ready to download. A single email is sent for the whole group. */
  notifyOnCompletion?: Scalars['Boolean']['input'];
  /** The maximum size limit applied to every capture in the group, in bytes. */
  sizeLimitBytes: Scalars['Int']['input'];
  /** The maximum duration applied to every capture in the group, in milliseconds. */
  timeLimitMS: Scalars['Int']['input'];
};

/** A request to ping from a device to a specified host. */
export type RpcPingInput = {
  /** The number of ping packets the device sends at once. Defaults to 1. */
  burstSize?: Scalars['Int']['input'];
  /** The host IP address or domain name to ping. */
  host: Scalars['String']['input'];
  /** The interval between bursts of pings, in milliseconds. Must not be combined with `intervalSeconds`. */
  intervalMs?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The interval between bursts of pings, in seconds. Must not be combined with `intervalMs`.
   * Defaults to 200 ms if neither `intervalSeconds` nor `intervalMs` is specified.
   */
  intervalSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The number of bursts to send. Defaults to 1. */
  numberOfBursts?: Scalars['Int']['input'];
  /** The UUID of the physical interface if the user selects to ping out of a specific WAN port. */
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The serial number of the device issuing the ping. */
  serialNumber: Scalars['String']['input'];
  /** Maximum number of seconds before the ping command exits, regardless of how many packets have been sent or received. Defaults to 5 seconds. */
  timeoutSeconds?: Scalars['Int']['input'];
  /** The UUID of the VLAN if the user selects to ping out of a VLAN interface (for both client ping and WAN ping). */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The WAN interface to use for the ping (`wan0` or `wan1`). Defaults to `wan0`. Config-1 only. */
  wanInterface?: InputMaybe<Scalars['String']['input']>;
};

/** A response containing the results of a ping operation. */
export type RpcPingResponse = {
  __typename?: 'RPCPingResponse';
  /** The mean round-trip time in milliseconds, if any pings were successful. */
  roundTripTimeMs?: Maybe<Scalars['Int']['output']>;
  /** The number of successful pings divided by the total number of pings, expressed as a float between 0 and 1. */
  successRate: Scalars['Float']['output'];
};

/** A response containing the status of a port-cycle request for a single device. */
export type RpcPortCycleDeviceResponse = {
  __typename?: 'RPCPortCycleDeviceResponse';
  /** The error message from the port cycle, if any. */
  error?: Maybe<Scalars['String']['output']>;
  /** The port number that was attempted to be cycled. */
  portNumber: Scalars['Int']['output'];
  /** The serial number of the device that was attempted to be port-cycled. */
  serialNumber: Scalars['String']['output'];
  /** Whether the port cycle was successful. */
  success: Scalars['Boolean']['output'];
};

/** A request to power-cycle a port on a Meter device. */
export type RpcPortCycleInput = {
  /** The number of seconds between disabling and re-enabling the port (range 1-30 seconds). Defaults to 3 seconds. */
  cycleDownSec?: InputMaybe<Scalars['Int']['input']>;
  /** If true, cycle the Power over Ethernet (PoE) on the port by disabling and re-enabling it. */
  poeCycle?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, cycle the port by disabling and re-enabling it. */
  portCycle?: InputMaybe<Scalars['Boolean']['input']>;
  /** The port number to cycle. */
  portNumber: Scalars['Int']['input'];
  /** The serial number of the device whose port needs cycling. */
  serialNumber: Scalars['String']['input'];
};

/** A response containing the status of a reboot request. */
export type RpcRebootDeviceResponse = {
  __typename?: 'RPCRebootDeviceResponse';
  /** The error message from the reboot, if any. */
  error?: Maybe<Scalars['String']['output']>;
  /** The serial number of the device that was attempted to be rebooted. */
  serialNumber: Scalars['String']['output'];
  /** Whether the reboot was successful. */
  success: Scalars['Boolean']['output'];
};

/** A request for rotating packet captures. */
export type RpcRotatingPacketCaptureInput = {
  /** The per-interface configurations for rotating packet captures. */
  interfaceRequests: Array<RpcRotatingPacketCaptureInterfaceInput>;
  /** The serial number of the Access Point. */
  serialNumber: Scalars['String']['input'];
};

/** The interface for rotating packet captures. */
export enum RpcRotatingPacketCaptureInterface {
  /** LAN interface (for APs with LAN ports). */
  Lan = 'LAN',
  /** 2.4 GHz wireless interface. */
  Radio_2G = 'RADIO_2G',
  /** 5 GHz wireless interface. */
  Radio_5G = 'RADIO_5G',
  /** 6 GHz wireless interface. */
  Radio_6G = 'RADIO_6G',
  /** Unspecified interface. */
  Unspecified = 'UNSPECIFIED',
  /** Uplink interface. */
  Uplink = 'UPLINK'
}

/** Request for a single interface for rotating packet capture. */
export type RpcRotatingPacketCaptureInterfaceInput = {
  /** Whether to clean/remove old packet captures. */
  cleanPacketCaptures: Scalars['Boolean']['input'];
  /** Whether to export the captured packet captures. */
  exportPacketCaptures: Scalars['Boolean']['input'];
  /** The interface to configure. */
  interface: RpcRotatingPacketCaptureInterface;
};

/** The result for a single interface in a rotating packet capture response. */
export type RpcRotatingPacketCaptureInterfaceResponse = {
  __typename?: 'RPCRotatingPacketCaptureInterfaceResponse';
  /** The interface that was configured. */
  interface: RpcRotatingPacketCaptureInterface;
  /** The size of the packet capture in bytes. */
  packetCaptureSizeBytes: Scalars['Int']['output'];
  /** The status of the operation for this interface. */
  status: RpcRotatingPacketCaptureStatus;
  /** The UUID for the generated rotating packet capture. */
  uuid: Scalars['String']['output'];
};

/** A response containing the results of a rotating packet capture request. */
export type RpcRotatingPacketCaptureResponse = {
  __typename?: 'RPCRotatingPacketCaptureResponse';
  /** The per-interface results. */
  interfaceResponses: Array<RpcRotatingPacketCaptureInterfaceResponse>;
};

/** The status of a rotating packet capture request. */
export enum RpcRotatingPacketCaptureStatus {
  /** No packets were captured on this interface. */
  NoPacket = 'NO_PACKET',
  /** The operation was successful. */
  Ok = 'OK',
  /** Unspecified status. */
  Unspecified = 'UNSPECIFIED'
}

/** Input to run a packet capture on a switch. */
export type RpcsosPacketCaptureStartInput = {
  /** The mode of packet capture to run. */
  captureMode?: InputMaybe<SosPacketCaptureMode>;
  /** Whether to email the requesting user once the capture completes and its file is ready to download. */
  notifyOnCompletion?: Scalars['Boolean']['input'];
  /** The port to run the packet capture on. */
  portNumber: Scalars['Int']['input'];
  /** The maximum size limit of the packet capture file in bytes. */
  sizeLimitBytes: Scalars['Int']['input'];
  /** The maximum duration of the packet capture in milliseconds. */
  timeLimitMS: Scalars['Int']['input'];
};

/** A request to power-cycle a port on a Meter switch. */
export type RpcSwitchPortCycleInput = {
  /** The number of seconds between disabling and re-enabling the port (range 1-30 seconds). Defaults to 3 seconds. */
  cycleDownSec?: InputMaybe<Scalars['Int']['input']>;
  /** If true, cycle the Power over Ethernet (PoE) on the port by disabling and re-enabling it. */
  poeCycle?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, cycle the port by disabling and re-enabling it. */
  portCycle?: InputMaybe<Scalars['Boolean']['input']>;
  /** The port number to cycle. */
  portNumber: Scalars['Int']['input'];
  /** The serial number of the switch whose port needs cycling. */
  serialNumber: Scalars['String']['input'];
};

/** A request to clear one or more learned MACs on a switch port with dynamic or sticky port security. */
export type RpcSwitchPortSecurityClearInput = {
  /** The list of MAC addresses to clear from the port. A nil value clears all dynamic or sticky MACs from the port. */
  macAddresses?: InputMaybe<Array<Scalars['MacAddress']['input']>>;
  /** The port number of the switch this RPC is for. */
  portNumber: Scalars['Int']['input'];
  /** The serial number of the device to run the RPC on. */
  serialNumber: Scalars['String']['input'];
};

/** Channel input for a packet capture on an Observer. */
export type RpcwosPacketCaptureRadioParametersInput = {
  /** The band */
  band: RadioBand;
  /** The channel to capture on for this band */
  channel: Scalars['Int']['input'];
  /** The channel width to capture on */
  channelWidth: ChannelWidth;
};

/** Input to run a packet capture on an access point, observer, or cellular gateway (cellular gateways only support wired captures). */
export type RpcwosPacketCaptureStartInput = {
  /** Channels to listen on (for Observers). */
  channels?: InputMaybe<Array<RpcwosPacketCaptureRadioParametersInput>>;
  /** The interface(s) to listen on (wireless radio(s), or wired). At most one wireless interface. */
  interfaces?: InputMaybe<Array<WosPacketCaptureCommandMonitor>>;
  /** Whether to email the requesting user once the capture completes and its file is ready to download. */
  notifyOnCompletion?: Scalars['Boolean']['input'];
  /** Whether or not the packet capture should be stored in /tmp on the device. */
  onDevice?: InputMaybe<Scalars['Boolean']['input']>;
  /** Maximum size of a packet in the capture (truncate if larger); if unset, no maximum. */
  packetSizeLimitBytes?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum size limit of the packet capture file in megabytes. */
  sizeLimitMb: Scalars['Int']['input'];
  /** The tcpdump filter to be applied to the packet capture. */
  tcpdumpFilter?: InputMaybe<Scalars['String']['input']>;
  /** The maximum duration of the packet capture in seconds. */
  timeLimitSec: Scalars['Int']['input'];
  /** The tcpdump filter to be applied to the packet capture, for the wired capture if wired+wireless. */
  wiredTcpdumpFilter?: InputMaybe<Scalars['String']['input']>;
};

/** A request to run a wireless calibration job on all devices on a meter network with a given AP. */
export type RpcWirelessCalibrationInput = {
  /** The channel to set the APs to. */
  channel?: InputMaybe<Scalars['Int']['input']>;
  /** Unique identifier of the calibration job. */
  jobUUID: Scalars['UUID']['input'];
  /** The power to set the APs to. */
  power?: InputMaybe<Scalars['Int']['input']>;
  /** The serial number of the device to start the wireless calirbation on. */
  serialNumber: Scalars['String']['input'];
};

/** A response containing the status of the wireless calibration job including some extra information. */
export type RpcWirelessCalibrationResponse = {
  __typename?: 'RPCWirelessCalibrationResponse';
  /** Errors from running the wireless calibration job, if any. */
  error?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the calibration job */
  jobUUID: Scalars['UUID']['output'];
  /** The serial number of the device that was the leader AP of the calibration job. */
  serialNumber: Scalars['String']['output'];
  /** Status of the wireless calibration job. */
  status: Scalars['Boolean']['output'];
};

/** A request to send one ping to a specific target from an Access Point, Observer, or Cellular Gateway */
export type RpcWosPingInput = {
  /** An optional size; if 0, uses ping default */
  packetSize?: Scalars['Int']['input'];
  /** The serial number of the device issuing the ping. */
  serialNumber: Scalars['String']['input'];
  /** The host to target (IPv4 or hostname) */
  target: Scalars['String']['input'];
};

/** The response we get from an rpcWosPing */
export type RpcWosPingResponse = {
  __typename?: 'RPCWosPingResponse';
  /** If successful, the latency in microseconds (0 if unsuccessful) */
  latencyUsec: Scalars['Int']['output'];
  /** Whether the ping was successful or not */
  success: Scalars['Boolean']['output'];
};

/** A rack elevation is a 2D representation of racks of hardware in a datacenter or supply closet. */
export type RackElevation = Identifiable & {
  __typename?: 'RackElevation';
  /** The unique identifier for the rack elevation. */
  UUID: Scalars['UUID']['output'];
  /** The building where this rack is physically located. */
  building?: Maybe<Scalars['String']['output']>;
  /** The list of devices that are attached to this rack elevation. */
  devices: Array<RackElevationDevice>;
  /** The name of the distribution frame associated with this rack. */
  distributionFrame?: Maybe<Scalars['String']['output']>;
  /** The floor within the building where this rack is physically located. */
  floor?: Maybe<Scalars['String']['output']>;
  /** The left-to-right position of the rack relative to others. */
  horizontalIndex?: Maybe<Scalars['Int']['output']>;
  /** Human-readable name for the rack elevation. */
  label: Scalars['String']['output'];
  /** The unique identifier of the network to which this rack elevation belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** Notes associated with this rack elevation. */
  notes?: Maybe<Array<RackElevationNote>>;
  /** The number of rack units (like slots) for the rack elevation. */
  rackMountUnitCount: Scalars['Int']['output'];
  /** The room where this rack is physically located. */
  room?: Maybe<Scalars['String']['output']>;
};

/** A device attached to a rack elevation. */
export type RackElevationDevice = {
  __typename?: 'RackElevationDevice';
  /** The unique identifier for the rack elevation device. */
  UUID: Scalars['UUID']['output'];
  /** Whether the device is front-facing or rear-facing. */
  isFrontFacing: Scalars['Boolean']['output'];
  /** If the device is a switch, whether it supports PoE. */
  isPoESupported?: Maybe<Scalars['Boolean']['output']>;
  /** A friendly name for display purposes. */
  label?: Maybe<Scalars['String']['output']>;
  /** The hardware device's model. */
  model?: Maybe<Scalars['String']['output']>;
  /** Additional context or comments about the device. */
  notes?: Maybe<Scalars['String']['output']>;
  /** The number of ports on the device. */
  portCount?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier of the rack elevation to which this device is attached. */
  rackElevationUUID: Scalars['UUID']['output'];
  /** The indexes of the rack units that the device occupies. */
  rackMountUnitIndexes: Array<Scalars['Int']['output']>;
  /** A non-null value if the device shares or will share its rack mount unit with another device. 0-indexed; lower number is to the left when viewing the rack from the front. For simplicity this is currently limited to 0 or 1 (at-most 2 devices per rack mount unit). */
  sideBySideIndex?: Maybe<Scalars['Int']['output']>;
  /** The type of the device (e.g., switch, patch panel, etc.). */
  type: RackElevationDeviceType;
  /** The virtual device associated with this rack elevation device. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** If the device is associated with a virtual device, this is the UUID of that virtual device. */
  virtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
};

/** An enumeration of possible device types that can be attached to a rack elevation. */
export enum RackElevationDeviceType {
  /** A cable management device. */
  CableManagement = 'CABLE_MANAGEMENT',
  /** A device to support a Cellular deployment (other than a Meter Cellular Gateway). */
  Cellular = 'CELLULAR',
  /** A fiber optic device. */
  Fiber = 'FIBER',
  /** An Internet Service Provider (ISP) device. */
  Isp = 'ISP',
  /** A Meter access point device. */
  MeterAccessPoint = 'METER_ACCESS_POINT',
  /** A Meter controller device. */
  MeterController = 'METER_CONTROLLER',
  /** A Meter PDU device. */
  MeterPdu = 'METER_PDU',
  /** A Meter switch device. */
  MeterSwitch = 'METER_SWITCH',
  /** A non-Meter switch device. */
  NonMeterSwitch = 'NON_METER_SWITCH',
  /** Other type of device. */
  Other = 'OTHER',
  /** A patch panel. */
  PatchPanel = 'PATCH_PANEL',
  /** A universal power supply (UPS) device. */
  UniversalPowerSupply = 'UNIVERSAL_POWER_SUPPLY'
}

/** A note associated with a rack elevation, applicable to a range of rack units. */
export type RackElevationNote = {
  __typename?: 'RackElevationNote';
  /** The content of the note. */
  note: Scalars['String']['output'];
  /** The ending rack mount unit index where the note applies. */
  rackMountUnitIndexEnd: Scalars['Int']['output'];
  /** The starting rack mount unit index where the note applies. */
  rackMountUnitIndexStart: Scalars['Int']['output'];
};

/** Input type for creating or updating a rack elevation note. */
export type RackElevationNoteInput = {
  /** The content of the note. */
  note: Scalars['String']['input'];
  /** The ending rack mount unit index for the note. */
  rackMountUnitIndexEnd: Scalars['Int']['input'];
  /** The starting rack mount unit index for the note. */
  rackMountUnitIndexStart: Scalars['Int']['input'];
};

/** An enumeration of radio bands. */
export enum RadioBand {
  /** Represents the 2.4 GHz radio band. */
  Band_2_4G = 'BAND_2_4G',
  /** Represents the 5 GHz radio band. */
  Band_5G = 'BAND_5G',
  /** Represents the 6 GHz radio band. */
  Band_6G = 'BAND_6G'
}

/** Contains configuration for wireless radios. A profile is a way to apply the same configuration to multiple APs. */
export type RadioProfile = Identifiable & {
  __typename?: 'RadioProfile';
  /** The unique identifier for the radio profile. */
  UUID: Scalars['UUID']['output'];
  /**
   * Only set if band2_4GAutoChannelIsEnabled is true.
   * This is the list of channels that are permitted for ACS (auto channel selection) to
   * select from and is user-configurable.
   */
  band2_4GAllowedChannels?: Maybe<Array<Scalars['Int']['output']>>;
  /** Indicates whether auto channel selection is enabled for the 2.4 GHz band. */
  band2_4GAutoChannelIsEnabled: Scalars['Boolean']['output'];
  /** Indicates whether auto channel width selection is enabled for the 2.4 GHz band. */
  band2_4GAutoChannelWidthIsEnabled: Scalars['Boolean']['output'];
  /** Indicates whether automatic transmit power adjustment is enabled for the 2.4 GHz band. */
  band2_4GAutoTxPowerIsEnabled: Scalars['Boolean']['output'];
  /**
   * Only set if band2_4GAutoTxPowerIsEnabled is true.
   * The maximum transmit power in dBm for the 2.4 GHz band when auto transmit power is enabled.
   */
  band2_4GAutoTxPowerMaxdBm?: Maybe<Scalars['Int']['output']>;
  /**
   * Only set if band2_4GAutoTxPowerIsEnabled is true.
   * The minimum transmit power in dBm for the 2.4 GHz band when auto transmit power is enabled.
   */
  band2_4GAutoTxPowerMindBm?: Maybe<Scalars['Int']['output']>;
  /**
   * Only set if band2_4GAutoChannelWidthIsEnabled is false.
   * The channel width in MHz for the 2.4 GHz band when auto channel width is disabled.
   */
  band2_4GChannelWidthMHz?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the 2.4 GHz band is enabled. */
  band2_4GIsEnabled: Scalars['Boolean']['output'];
  /**
   * Only set if band5GAutoChannelIsEnabled is true.
   * This is the list of channels that are permitted for ACS (auto channel selection) to
   * select from and is user-configurable.
   */
  band5GAllowedChannels?: Maybe<Array<Scalars['Int']['output']>>;
  /** Indicates whether auto channel selection is enabled for the 5 GHz band. */
  band5GAutoChannelIsEnabled: Scalars['Boolean']['output'];
  /** Indicates whether auto channel width selection is enabled for the 5 GHz band. */
  band5GAutoChannelWidthIsEnabled: Scalars['Boolean']['output'];
  /** Indicates whether automatic transmit power adjustment is enabled for the 5 GHz band. */
  band5GAutoTxPowerIsEnabled: Scalars['Boolean']['output'];
  /**
   * Only set if band5GAutoTxPowerIsEnabled is true.
   * The maximum transmit power in dBm for the 5 GHz band when auto transmit power is enabled.
   */
  band5GAutoTxPowerMaxdBm?: Maybe<Scalars['Int']['output']>;
  /**
   * Only set if band5GAutoTxPowerIsEnabled is true.
   * The minimum transmit power in dBm for the 5 GHz band when auto transmit power is enabled.
   */
  band5GAutoTxPowerMindBm?: Maybe<Scalars['Int']['output']>;
  /**
   * Only set if band5GAutoChannelWidthIsEnabled is false.
   * The channel width in MHz for the 5 GHz band when auto channel width is disabled.
   */
  band5GChannelWidthMHz?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the 5 GHz band is enabled. */
  band5GIsEnabled: Scalars['Boolean']['output'];
  /** When true, the AP returns to a DFS channel after the NOP (No Operation Period) expires. */
  band5GZeroWaitDFSIsEnabled: Scalars['Boolean']['output'];
  /**
   * Only set if band6GAutoChannelIsEnabled is true.
   * This is the list of channels that are permitted for ACS (auto channel selection) to
   * select from and is user-configurable.
   */
  band6GAllowedChannels?: Maybe<Array<Scalars['Int']['output']>>;
  /** Indicates whether auto channel selection is enabled for the 6 GHz band. */
  band6GAutoChannelIsEnabled: Scalars['Boolean']['output'];
  /** Indicates whether auto channel width selection is enabled for the 6 GHz band. */
  band6GAutoChannelWidthIsEnabled: Scalars['Boolean']['output'];
  /** Indicates whether automatic transmit power adjustment is enabled for the 6 GHz band. */
  band6GAutoTxPowerIsEnabled: Scalars['Boolean']['output'];
  /**
   * Only set if band6GAutoTxPowerIsEnabled is true.
   * The maximum transmit power in dBm for the 6 GHz band when auto transmit power is enabled.
   */
  band6GAutoTxPowerMaxdBm?: Maybe<Scalars['Int']['output']>;
  /**
   * Only set if band6GAutoTxPowerIsEnabled is true.
   * The minimum transmit power in dBm for the 6 GHz band when auto transmit power is enabled.
   */
  band6GAutoTxPowerMindBm?: Maybe<Scalars['Int']['output']>;
  /**
   * Only set if band6GAutoChannelWidthIsEnabled is false.
   * The channel width in MHz for the 6 GHz band when auto channel width is disabled.
   */
  band6GChannelWidthMHz?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the 6 GHz band is enabled. */
  band6GIsEnabled: Scalars['Boolean']['output'];
  /** Clear channel assessment (CCA) threshold in dBm used to determine whether the channel is free. 0 means use driver default. */
  ccaThreshold: Scalars['Int']['output'];
  /** The timestamp when the radio profile was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A human-readable description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Indicates whether this profile is the default profile for the network. */
  isDefault: Scalars['Boolean']['output'];
  /** The name of the radio profile. */
  name: Scalars['String']['output'];
  /** The network to which this radio profile belongs. */
  network: Network;
  /** The unique identifier of the network to which this radio profile belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** The ISO2 country code where the device is located. */
  regulatoryDomain: Scalars['String']['output'];
  /** Receive sensitivity level (RX-SOP) in dBm below which received frames are not considered. 0 means use driver default. */
  rxSensitivityLevel: Scalars['Int']['output'];
  /** The timestamp when the radio profile was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The list of virtual devices (access points) attached to this radio profile. */
  virtualDevices: Array<VirtualDevice>;
};

/** An individual Access Point's radio settings (channel, power). Other radio settings are configured in the radio profile and shared across multiple APs. */
export type RadioSettings = {
  __typename?: 'RadioSettings';
  /** The active channel for the 2.4 GHz radio band. It can be used to determine if the AP is broadcasting on the primary, secondary, or other (DFS, etc). It is reported by the access point and is not configurable. */
  band2_4GActiveChannel?: Maybe<Scalars['Int']['output']>;
  /** The primary channel for the 2.4 GHz radio band. */
  band2_4GPrimaryChannel: Scalars['Int']['output'];
  /** The transmit power in dBm for the 2.4 GHz radio band. */
  band2_4GTransmitPowerdBm: Scalars['Int']['output'];
  /** The active channel for the 5 GHz radio band. It can be used to determine if the AP is broadcasting on the primary, secondary, or other (DFS, etc). It is reported by the access point and is not configurable. */
  band5GActiveChannel?: Maybe<Scalars['Int']['output']>;
  /** The primary channel for the 5 GHz radio band. */
  band5GPrimaryChannel: Scalars['Int']['output'];
  /** The secondary channel for the 5 GHz radio band, if applicable. */
  band5GSecondaryChannel?: Maybe<Scalars['Int']['output']>;
  /** The transmit power in dBm for the 5 GHz radio band. */
  band5GTransmitPowerdBm: Scalars['Int']['output'];
  /** The active channel for the 6 GHz radio band. It can be used to determine if the AP is broadcasting on the primary, secondary, or other (DFS, etc). It is reported by the access point and is not configurable. */
  band6GActiveChannel?: Maybe<Scalars['Int']['output']>;
  /** The primary channel for the 6 GHz radio band. */
  band6GPrimaryChannel: Scalars['Int']['output'];
  /** The transmit power in dBm for the 6 GHz radio band. */
  band6GTransmitPowerdBm: Scalars['Int']['output'];
  /** The virtual device. */
  virtualDevice: VirtualDevice;
  /** The UUID of the virtual device. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** Represents the radius poller configuration. */
export type RadiusPoller = {
  __typename?: 'RadiusPoller';
  /** The UUIDs of the access point virtual devices selected to poll the radius server. When null, all access points configured with the profile poll. When empty, no access points poll. */
  accessPointVirtualDeviceUUIDs?: Maybe<Array<Scalars['UUID']['output']>>;
  /** Whether radius poller is enabled. */
  enabled: Scalars['Boolean']['output'];
  /** The interval in seconds between each poll to the radius server. When null, the firmware-imposed interval is used. */
  intervalSeconds?: Maybe<Scalars['Int']['output']>;
};

/** The polling status of an access point for a RADIUS profile. Whether the RADIUS server was reachable is a separate signal (successPercent). */
export enum RadiusPollerAccessPointStatus {
  /** The access point reported results in the last 30 days but none in the selected time window. */
  Inactive = 'INACTIVE',
  /** The access point is selected to poll this profile but has not reported any results in the last 30 days. */
  NeverSeen = 'NEVER_SEEN',
  /** The access point reported at least one poll result in the selected time window. */
  Polling = 'POLLING'
}

/** Represents the RADIUS reachability tests running against a particular Encryption8021X profile. */
export type RadiusPollerDeviceTallies = {
  __typename?: 'RadiusPollerDeviceTallies';
  /** The fail count. */
  failCount: Scalars['Int']['output'];
  /** The label of the device. */
  label: Scalars['String']['output'];
  /** The success count. */
  successCount: Scalars['Int']['output'];
  /** The total number of requests. */
  totalCount: Scalars['Int']['output'];
};

/** Aggregate poll stats for an access point polling a RADIUS profile within the selected time window. */
export type RadiusPollerMonitoringAccessPointStats = {
  __typename?: 'RadiusPollerMonitoringAccessPointStats';
  /** The virtual device UUID of the polling access point. */
  accessPointVirtualDeviceUUID: Scalars['UUID']['output'];
  /** Round-trip latency in ms of the most recent successful poll. Null when the access point had no successful polls in the window. */
  lastLatencyMs?: Maybe<Scalars['Int']['output']>;
  /** 90th-percentile round-trip latency in ms across successful polls, weighted across time buckets in the window. Null when the access point had no successful polls in the window. */
  p90LatencyMs?: Maybe<Scalars['Float']['output']>;
  /** Current polling status of this access point for this profile. */
  status: RadiusPollerAccessPointStatus;
  /** Percent of polls that reached the RADIUS server in the time window. Null when the access point reported no results in the window. */
  successPercent?: Maybe<Scalars['Int']['output']>;
  /** The polling access point. */
  virtualDevice: VirtualDevice;
};

/** Trend data for one access point polling a RADIUS profile. */
export type RadiusPollerMonitoringAccessPointTrendData = {
  __typename?: 'RadiusPollerMonitoringAccessPointTrendData';
  /** The virtual device UUID of the polling access point. */
  accessPointVirtualDeviceUUID: Scalars['UUID']['output'];
  /** Bucketed trend points for this access point. Buckets in which the access point reported no results are omitted. */
  trendPoints: Array<RadiusPollerMonitoringTrendPoint>;
};

/** RADIUS poller monitoring data for a network. */
export type RadiusPollerMonitoringNetworkData = {
  __typename?: 'RadiusPollerMonitoringNetworkData';
  /** The width in seconds of every trend bucket in this response (the filter's step). */
  bucketSeconds: Scalars['Int']['output'];
  /** Monitoring data for each RADIUS profile in the network with the poller enabled. */
  profiles: Array<RadiusPollerMonitoringProfileData>;
};

/** Monitoring data for one RADIUS profile over the selected time window. */
export type RadiusPollerMonitoringProfileData = {
  __typename?: 'RadiusPollerMonitoringProfileData';
  /** Aggregate trend time series across all access points polling this profile, bucketed by the filter step. */
  aggregateTrend: Array<RadiusPollerMonitoringTrendPoint>;
  /** The auth server IP address of the profile. */
  authServerIPAddress: Scalars['String']['output'];
  /** The auth server port of the profile. */
  authServerPort: Scalars['Int']['output'];
  /** The virtual device UUIDs of the access points expected to poll this profile: the stored manual selection. Empty when the selection is empty (polling paused). */
  configuredAccessPointVirtualDeviceUUIDs: Array<Scalars['UUID']['output']>;
  /** The access points expected to poll this profile, resolved from configuredAccessPointVirtualDeviceUUIDs. */
  configuredAccessPoints: Array<VirtualDevice>;
  /** The UUID of the RADIUSprofile. */
  encryption8021XUUID: Scalars['UUID']['output'];
  /** Count of access points with status INACTIVE. */
  inactiveAccessPointCount: Scalars['Int']['output'];
  /** Count of access points with status NEVER_SEEN. */
  neverSeenAccessPointCount: Scalars['Int']['output'];
  /** 90th-percentile round-trip latency in ms across successful polls, weighted across access points and time buckets in the window. Null when no access point had a successful poll. */
  p90LatencyMs?: Maybe<Scalars['Float']['output']>;
  /** Count of access points with status POLLING. */
  pollingAccessPointCount: Scalars['Int']['output'];
  /** Per access point poll stats for every access point expected to poll this profile or that reported results in the window. */
  pollingAccessPointStats: Array<RadiusPollerMonitoringAccessPointStats>;
  /** Trend time series per access point that reported results in the window, bucketed by the filter step. */
  pollingAccessPointTrends: Array<RadiusPollerMonitoringAccessPointTrendData>;
  /** The configured polling interval in seconds. Falls back to the default interval (60 seconds) when the profile does not set one. */
  pollingIntervalSeconds: Scalars['Int']['output'];
  /** Percent of polls across all access points that reached the RADIUS server in the time window. Null when no access point reported results. */
  successPercent?: Maybe<Scalars['Int']['output']>;
};

/** A bucketed aggregate data point for poll latency and success percent across all access points polling a profile. */
export type RadiusPollerMonitoringTrendPoint = {
  __typename?: 'RadiusPollerMonitoringTrendPoint';
  /** Average round-trip latency in ms across successful polls in this bucket. Null when the bucket has no successful polls. */
  avgLatencyMs?: Maybe<Scalars['Int']['output']>;
  /** 90th-percentile round-trip latency in ms across successful polls in this bucket. Null when the bucket has no successful polls. */
  p90LatencyMs?: Maybe<Scalars['Float']['output']>;
  /** Percent of polls that reached the RADIUS server. */
  successPercent: Scalars['Int']['output'];
  /** The start of this time bucket. */
  timestamp: Scalars['DateTime']['output'];
};

/** Properties Radius Poller fail results. */
export type RadiusPollerResultFailProperties = {
  __typename?: 'RadiusPollerResultFailProperties';
  /** The RADIUS profiles that are having issues. */
  failingProfiles?: Maybe<Array<Maybe<RadiusPollerUnreachableProfile>>>;
};

/** Properties Radius Poller ok/success results. */
export type RadiusPollerResultOkProperties = {
  __typename?: 'RadiusPollerResultOkProperties';
  /** The RADIUS profiles that may have issues. */
  degradedProfiles?: Maybe<Array<Maybe<RadiusPollerUnreachableProfile>>>;
};

/** Represents the profiles of the unreachable RADIUS servers */
export type RadiusPollerUnreachableProfile = {
  __typename?: 'RadiusPollerUnreachableProfile';
  /** The RADIUS profile Acct IP. */
  accountingServerIP: Scalars['String']['output'];
  /** The RADIUS profile Accounting Port. */
  accountingServerPort?: Maybe<Scalars['Int']['output']>;
  /** The RADIUS profile Auth IP. */
  authServerIP: Scalars['String']['output'];
  /** The RADIUS profile Auth Port. */
  authServerPort?: Maybe<Scalars['Int']['output']>;
  /** A list of devices with the success and fail counts. */
  deviceTallies: Array<Maybe<RadiusPollerDeviceTallies>>;
  /** The Encryption8021X profile UUID. */
  encryption8021XUUID?: Maybe<Scalars['UUID']['output']>;
};

export type RateLimitPhyInterfaceBindingInput = {
  /** The UUID of the physical interface to bind or unbind the rate limit rule to/from. */
  phyInterfaceUUID: Scalars['UUID']['input'];
  /** The UUID of the rate limit rule. */
  rateLimitRuleUUID: Scalars['UUID']['input'];
};

/** Defines L2 and L3 rate limit rules for a network. A rate limit rule can be applied to multiple interfaces. */
export type RateLimitRule = Identifiable & {
  __typename?: 'RateLimitRule';
  /** Unique identifier for the rate limit rule. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the rate limit rule was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A description of the rate limit rule. */
  description?: Maybe<Scalars['String']['output']>;
  /** Destination MAC address to match for the rate limit rule. */
  dstMac?: Maybe<Scalars['MacAddress']['output']>;
  /** Destination port range to match for the rate limit rule. */
  dstPortRange?: Maybe<PortRange>;
  /** Destination IP address prefix to match for the rate limit rule. */
  dstPrefix?: Maybe<Scalars['IPPrefix']['output']>;
  /** Indicates whether the rate limit rule is currently enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Specifies if the rate limit is applied per source IP/MAC address. */
  isPerSource: Scalars['Boolean']['output'];
  /** The name of the rate limit rule. */
  name: Scalars['String']['output'];
  /** The network this rate limit rule belongs to. */
  network: Network;
  /** The UUID of the network this rate limit rule belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The physical interfaces that this rate limit rule is applied on. The same rate limit rule can be applied to multiple physical interfaces. */
  phyInterfaceBindings?: Maybe<Array<PhyInterface>>;
  /** The order in which the rate limit rules are applied, lower priorities first. */
  priority: Scalars['Int']['output'];
  /** The IANA IP protocol to apply this rule on. */
  protocol?: Maybe<IpProtocol>;
  /** The maximum download rate limit in kilobits per second. */
  rateLimitKbpsDownload?: Maybe<Scalars['Int']['output']>;
  /** The maximum upload rate limit in kilobits per second. */
  rateLimitKbpsUpload?: Maybe<Scalars['Int']['output']>;
  /** Source MAC address to match for the rate limit rule. */
  srcMac?: Maybe<Scalars['MacAddress']['output']>;
  /** Source port range to match for the rate limit rule. */
  srcPortRange?: Maybe<PortRange>;
  /** Source IP address prefix to match for the rate limit rule. */
  srcPrefix?: Maybe<Scalars['IPPrefix']['output']>;
  /** The SSIDs that this rate limit rule is applied on. The same rate limit rule can be applied to multiple SSIDs. */
  ssidBindings?: Maybe<Array<Ssid>>;
  /** The timestamp when the rate limit rule was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The VLAN interfaces that this rate limit rule is applied on. The same rate limit rule can be applied to multiple VLANs. */
  vlanBindings?: Maybe<Array<Vlan>>;
};

export type RateLimitSsidBindingInput = {
  /** The UUID of the rate limit rule. */
  rateLimitRuleUUID: Scalars['UUID']['input'];
  /** The UUID of the SSID to bind or unbind the rate limit rule to/from. */
  ssidUUID: Scalars['UUID']['input'];
};

export type RateLimitVlanBindingInput = {
  /** The UUID of the rate limit rule. */
  rateLimitRuleUUID: Scalars['UUID']['input'];
  /** The UUID of the VLAN to bind or unbind the rate limit rule to/from. */
  vlanUUID: Scalars['UUID']['input'];
};

/** Specifies a hardware device to move from one network to another, optionally to a specific virtual device on the destination network. */
export type ReassignHardwareToOtherNetworkInput = {
  /** The serial number of the hardware device to reassign. */
  serialNumber: Scalars['String']['input'];
  /** The UUID of the virtual device on the destination network to assign this hardware to. If null, the hardware is added as a spare to the destination network. */
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** A provider and connection type the recommender can use at a slot's contract length. */
export type RecommendableProviderConnectionType = {
  __typename?: 'RecommendableProviderConnectionType';
  /** Product type of the service. */
  connectionType: InternetServicePlanConnectionType;
  /** Carrier contract term in months: the provider's longest term not exceeding the customer term. */
  contractLengthMonthsInternal: Scalars['Int']['output'];
  /** Download speeds with a rate card price at the customer term. */
  downloadKbpsOptions: Array<Scalars['Int']['output']>;
  /** Product group of the connection type. */
  productGroup: ConnectProductGroup;
  /** Provider of the service. */
  provider: InternetServicePlanProvider;
};

/** Recurring auto channel selection schedule for a network. */
export type RecurringAutoChannelSelectionJob = {
  __typename?: 'RecurringAutoChannelSelectionJob';
  /** The unique identifier of the recurring job. */
  UUID: Scalars['UUID']['output'];
  /** The radio bands to run ACS for when this schedule triggers a job. */
  bands: Array<RadioBand>;
  /** The period upon which scheduled 5 GHz auto channel selection runs. */
  cadence: RecurringAutoChannelSelectionScheduleCadence;
  /** When this recurring job was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The day of the month, in the network's local time zone, when scheduled 5 GHz auto channel selection may run. */
  dayOfMonthLocal?: Maybe<Scalars['Int']['output']>;
  /** The day of the week, in the network's local time zone, when scheduled 5 GHz auto channel selection may run (0 = Sunday, 1 = Monday, etc.) */
  dayOfWeekLocal?: Maybe<Scalars['Int']['output']>;
  /** The hour of the day, in the network's local time zone, when scheduled 5 GHz auto channel selection may run. */
  hourOfDayLocal?: Maybe<Scalars['Int']['output']>;
  /** If true, compute proposed channels but do not update access point settings. */
  isDryRun: Scalars['Boolean']['output'];
  /** The last time scheduled 5 GHz auto channel selection ran for this network. */
  lastScheduledRunAt?: Maybe<Scalars['DateTime']['output']>;
  /** The UUID of the network. */
  networkUUID: Scalars['UUID']['output'];
  /**
   * Optional stickiness threshold for ACS (0.0–1.0). Controls how much better a new channel must
   * score before switching from the current channel. Defaults to 0.15.
   */
  stickinessThreshold?: Maybe<Scalars['Float']['output']>;
  /** The local timezone used for schedule evaluation. */
  timezone: Scalars['String']['output'];
  /** The type of auto selection job this schedule runs. */
  type: RecurringAutoSelectionJobType;
  /** When this recurring job was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export enum RecurringAutoChannelSelectionScheduleCadence {
  /** Run scheduled 5 GHz auto channel selection daily. */
  Daily = 'DAILY',
  /** Run scheduled 5 GHz auto channel selection monthly. */
  Monthly = 'MONTHLY',
  /** Run scheduled 5 GHz auto channel selection quarterly. */
  Quarterly = 'QUARTERLY',
  /** Run scheduled 5 GHz auto channel selection weekly. */
  Weekly = 'WEEKLY'
}

/** The type of auto selection job a recurring schedule runs. */
export enum RecurringAutoSelectionJobType {
  /** Scheduled auto channel selection. */
  AutoChannelSelection = 'AUTO_CHANNEL_SELECTION'
}

/** The latest reported public IP information for an uplink port. */
export type ReportedPublicIpInfo = {
  __typename?: 'ReportedPublicIPInfo';
  /** The ISO 2-letter country code derived from geolocation of the public IP address. */
  geolocatedCountryISO2?: Maybe<Scalars['String']['output']>;
  /** The latest public IP address reported for the uplink port. */
  publicIP?: Maybe<Scalars['IP']['output']>;
  /** When the latest public IP address was reported. */
  reportedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Input for requesting that a public API key be granted access to a company. */
export type RequestCompanyAccessForPublicApiKeyInput = {
  /** The UUID of the public API key. */
  keyUUID: Scalars['UUID']['input'];
  /** The UUID of the company the key is asking to reach. */
  requestedCompanyUUID: Scalars['UUID']['input'];
};

/** Input for requesting temporary access to a company. */
export type RequestTemporaryAccessInput = {
  /** The level of access to grant. Defaults to OPERATOR. */
  accessLevel?: InputMaybe<TemporaryAccessLevel>;
  /** The UUID of the company to gain access to. */
  companyUUID: Scalars['UUID']['input'];
  /** How long access lasts once approved. Defaults to 4 hours, at most 24 hours. */
  duration?: Scalars['Duration']['input'];
  /** Why access is needed. Recorded for audit. */
  reason: Scalars['String']['input'];
};

/** Result of a compliance requirement check */
export enum RequirementResult {
  /** Requirement check errored */
  Error = 'ERROR',
  /** Requirement check failed */
  Fail = 'FAIL',
  /** Requirement check passed */
  Pass = 'PASS'
}

/** Input type for re-running an existing quote request */
export type RerunQuoteRequestInput = {
  /** Vendors to re-run. */
  vendors?: InputMaybe<Array<QuoteRequestVendor>>;
};

/** Responsibility for riser cabling. */
export enum RiserResponsibility {
  /** Customer is responsible for riser work. */
  Customer = 'CUSTOMER',
  /** Provider is responsible for riser work. */
  Provider = 'PROVIDER',
  /** Riser responsibility is currently unknown. */
  Unknown = 'UNKNOWN'
}

/** A rogue AP active issue */
export type RogueApActiveIssue = ActiveIssue & {
  __typename?: 'RogueAPActiveIssue';
  /** When the issue was first detected, if available */
  detectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The network that this issue is impacting */
  networkUUID: Scalars['UUID']['output'];
  /** When the issue was resolved, if available */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The rogue access points */
  rogues: Array<RogueAccessPoint>;
  /** The severity of the issue */
  severity: ActiveIssueSeverity;
  /** The type of the issue */
  type: ActiveIssueType;
};

/** A rogue access point is an unrecognized access point detected on the network, such as one plugged into a Meter switch. */
export type RogueAccessPoint = {
  __typename?: 'RogueAccessPoint';
  /** The MAC address of the rogue AP. */
  macAddress: Scalars['MacAddress']['output'];
  /** The network that the rogue AP was observed on. */
  network: Network;
  /** The unique identifier for the network that the rogue AP was observed on. */
  networkUUID: Scalars['UUID']['output'];
  /** The devices that were able to observe the rogue AP. */
  observers: Array<NetworkThreatObserver>;
  /** The physical interface that the rogue access point is plugged into. */
  phyInterface: PhyInterface;
  /** The vendor that made the rogue AP. */
  vendor?: Maybe<Scalars['String']['output']>;
};

/** Properties for rogue access point events. */
export type RogueAccessPointProperties = {
  __typename?: 'RogueAccessPointProperties';
  /** The rogue access points detected. */
  rogueAccessPoints: Array<RogueAccessPoint>;
};

/**
 * Properties for a Rogue DHCP Server event. Emitted when multiple DHCP servers
 * offer an IP for the same DHCP transaction on the same VLAN.
 */
export type RogueDhcpServerProperties = {
  __typename?: 'RogueDHCPServerProperties';
  /** The MAC of the client who received multiple offers. */
  clientMACAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** IPs of the DHCP servers observed on this VLAN. */
  dhcpServerIPs?: Maybe<Array<Scalars['IP']['output']>>;
  /** MACs of the DHCP servers observed on this VLAN. */
  dhcpServerMACs?: Maybe<Array<Scalars['MacAddress']['output']>>;
  /** Distinct IP addresses offered to the client. */
  offeredIPs?: Maybe<Array<Scalars['IP']['output']>>;
  /** The relay IP if the offer was relayed. */
  relayIP?: Maybe<Scalars['IP']['output']>;
  /** The DHCP transaction id (xid) shared by the offers. */
  transactionID?: Maybe<Scalars['Int']['output']>;
  /** VLAN that the offer was observed on. */
  vlan?: Maybe<Vlan>;
};

/** Enumeration of user roles. */
export enum Role {
  /** Operator role with elevated permissions. */
  Operator = 'OPERATOR'
}

/**
 * A RoleAssignment denotes the role of a user in the context of a company or company & network.
 *
 * In the case of an Operator role, the companySlug and networkUUID fields will be null.
 */
export type RoleAssignment = {
  __typename?: 'RoleAssignment';
  /** The unique identifier for this role assignment. */
  UUID: Scalars['UUID']['output'];
  /** The UUID of the company role mapping that produced this assignment, if directory-synced. */
  companyRoleMappingUUID?: Maybe<Scalars['UUID']['output']>;
  /**
   * The slug of the company associated with the role assignment.
   *
   * Omitted if the role is global or operator-level.
   */
  companySlug?: Maybe<Scalars['String']['output']>;
  /** The custom role assigned to the user. */
  customRole?: Maybe<CustomRole>;
  /** When this assignment stops being effective. Set only for temporary access grants. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Whether this assignment is currently in effect for auth checks.
   * When both a manual and a synced role exist at the same scope, only the active one is used.
   */
  isActive: Scalars['Boolean']['output'];
  /** The name of the role assigned to the user. */
  name?: Maybe<RoleName>;
  /**
   * The UUID of the network associated with the role assignment.
   *
   * Omitted if the role is not network-specific.
   */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** The directory-sync mapping that produced this assignment, if any. */
  roleMapping?: Maybe<CompanyRoleMapping>;
  /** The temporary access grant that created this assignment. */
  temporaryAccessGrantUUID?: Maybe<Scalars['UUID']['output']>;
};

/** Result type indicating whether the user has the specified role. */
export type RoleCheckResult = {
  __typename?: 'RoleCheckResult';
  /** True if the user has the specified role, false otherwise. */
  hasRole: Scalars['Boolean']['output'];
};

/** Metadata about a role. */
export type RoleMetadata = {
  __typename?: 'RoleMetadata';
  /** The permission a caller must hold in order to assign this role to a user. */
  assignPermission: PermissionType;
  /** A human readable summary of what the role is. */
  description: Scalars['String']['output'];
  /** Whether the user has assignPermission in the requested company. */
  isAssignable: Scalars['Boolean']['output'];
  /** Whether the role must be assigned in the context of a company. */
  isCompanyScoped: Scalars['Boolean']['output'];
  /** Whether the role can be mapped to a group from a company's identity provider. */
  isMappableByIdP: Scalars['Boolean']['output'];
  /** Whether the role must be assigned in the context of a network. */
  isNetworkScoped: Scalars['Boolean']['output'];
  /** The human readable name of the role. */
  label: Scalars['String']['output'];
  /** The name of the role. */
  name: RoleName;
  /** The permissions the role gives. */
  permissions: Array<PermissionType>;
};

/** RoleName represents the various roles that can be assigned to users within the system. */
export enum RoleName {
  /** Build CI machine role, heavily locked down intended for Vercel/GitHub CI workflows. */
  BuildCi = 'BUILD_CI',
  /** Machine intended to be used in internal Continuous Integration workflows. */
  Ci = 'CI',
  /** Placeholder role so user can use Client VPN, limited access. */
  ClientVpnUser = 'CLIENT_VPN_USER',
  /** Command application specific role. */
  Command = 'COMMAND',
  /** Commandv2 application specific role. */
  CommandV2 = 'COMMAND_V2',
  /** Company Global Admin role, grants administrative privileges across the entire company. */
  CompanyGlobalAdmin = 'COMPANY_GLOBAL_ADMIN',
  /** Company Admin Read Only role, grants read only administrative privileges across the entire company. */
  CompanyGlobalAdminReadOnly = 'COMPANY_GLOBAL_ADMIN_READ_ONLY',
  /** Company Guest role, limited access. */
  CompanyGuest = 'COMPANY_GUEST',
  /** Company Network Admin role, grants administrative privileges within a specific network. */
  CompanyNetworkAdmin = 'COMPANY_NETWORK_ADMIN',
  /** Company Network Admin Read Only role, grants read only administrative privileges within a specific network. */
  CompanyNetworkAdminReadOnly = 'COMPANY_NETWORK_ADMIN_READ_ONLY',
  /** Company Network Captive Portal Entry Manager role, grants the ability to manage captive portal entries and read only administrative privileges within a specific network. */
  CompanyNetworkCaptivePortalEntryManager = 'COMPANY_NETWORK_CAPTIVE_PORTAL_ENTRY_MANAGER',
  /** Company Network Onboarding role, grants administrative privileges for onboarding a network. */
  CompanyNetworkOnboarding = 'COMPANY_NETWORK_ONBOARDING',
  /** Company Onboarding role, allows editing the company onboarding pages and gives read only access to the rest of the dashboard. */
  CompanyOnboardingOnly = 'COMPANY_ONBOARDING_ONLY',
  /** Company Standard User role, typical user role with standard access rights. */
  CompanyStandardUser = 'COMPANY_STANDARD_USER',
  /** Cross-realm machine role for device claiming between prod and dev realms. */
  CrossRealmMachine = 'CROSS_REALM_MACHINE',
  /** Installer role, has access to information that is straightforward to understand and necessary to monitor installs. */
  Installer = 'INSTALLER',
  /** Inventory management machine. */
  InventoryApp = 'INVENTORY_APP',
  /** Meter annotator role, grants read-only access to a company including device stats. Intended for Meter contracted annotators and manually assigned per company. */
  MeterAnnotator = 'METER_ANNOTATOR',
  /** Operator role, has almost every permission. */
  Operator = 'OPERATOR',
  /** Partner admin role, grants elevated permissions for network configuration. */
  Partner = 'PARTNER',
  /** Machine role for Salesforce Flow-driven webhooks (case create/update). */
  SalesforceWebhook = 'SALESFORCE_WEBHOOK',
  /** Super operator role, has every permission. */
  SuperOperator = 'SUPER_OPERATOR',
  /** A role to allow access for Support tooling integrations. */
  SupportTooling = 'SUPPORT_TOOLING',
  /** Technical partner enablement lab management role, extends the technical partner sales engineering training role with the ability to manage networks and users for automated setup and teardown of training networks. */
  TechnicalPartnerEnablementLabManagement = 'TECHNICAL_PARTNER_ENABLEMENT_LAB_MANAGEMENT',
  /** Technical partner sales engineer training role, grants elevated permissions for network configuration and device management for training purposes. */
  TechnicalPartnerSalesEngineerTraining = 'TECHNICAL_PARTNER_SALES_ENGINEER_TRAINING',
  /** Technical partner sales engineer training role, grants elevated permissions for visibility on network configuration and device management for training purposes. */
  TechnicalPartnerSalesEngineerTrainingReadOnly = 'TECHNICAL_PARTNER_SALES_ENGINEER_TRAINING_READ_ONLY'
}

/**
 * The email domains permitted for users assigned a role, for roles that restrict
 * assignment by email domain.
 */
export type RolePermittedEmailDomains = {
  __typename?: 'RolePermittedEmailDomains';
  /** The email domains permitted for the role. */
  domains: Array<Scalars['String']['output']>;
  /** Whether the restriction applies to the role assigned in the context of a company. */
  isCompanyScoped: Scalars['Boolean']['output'];
  /** The name of the role. */
  roleName: RoleName;
};

/** Input type specifying the context for which to fetch the roles for a given user. */
export type RolesInput = {
  /**
   * The slug of the company to fetch roles for.
   *
   * If omitted, roles without a company context are retrieved.
   */
  companySlug?: InputMaybe<Scalars['String']['input']>;
};

/** The routing protocol that installed a route into the routing table. */
export enum RouteSourceProtocol {
  /** BGP. */
  Bgp = 'BGP',
  /** Connected. */
  Connected = 'CONNECTED',
  /** Kernel. */
  Kernel = 'KERNEL',
  /** Local. */
  Local = 'LOCAL',
  /** OSPF. */
  Ospf = 'OSPF',
  /** Static. */
  Static = 'STATIC'
}

/** Information about an SFP module's monitored digital diagnostics. */
export type SfpDigitalDiagnosticsMonitoringInfo = {
  __typename?: 'SFPDigitalDiagnosticsMonitoringInfo';
  /** Alarms raised by the diagnostics monitor. */
  alarms: Array<SfpDigitalDiagnosticsMonitoringInfoAlarmType>;
  /** The bias current of the laser in milliamps. */
  laserBiasCurrentMilliAmp: Scalars['Float']['output'];
  /** Receiving loss of signal. */
  rxLossOfSignal: Scalars['Boolean']['output'];
  /** Receiving power in dBm. */
  rxPowerDbm: Scalars['Float']['output'];
  /** The volts of power supplied. */
  supplyVolts: Scalars['Float']['output'];
  /** Temperature of the module in celsius. */
  temperatureCelsius: Scalars['Float']['output'];
  /** Transmission fault. */
  txFault: Scalars['Boolean']['output'];
  /** Transmission power in dBm. */
  txPowerDbm: Scalars['Float']['output'];
};

/** Alarm issued by the SFP module's digital diagnostics monitor. */
export enum SfpDigitalDiagnosticsMonitoringInfoAlarmType {
  /** The current bias is high. */
  CurrentBiasHigh = 'CURRENT_BIAS_HIGH',
  /** The current bias is low. */
  CurrentBiasLow = 'CURRENT_BIAS_LOW',
  /** No alarm. */
  NoAlarm = 'NO_ALARM',
  /** The receiving power is high. */
  RxPowerHigh = 'RX_POWER_HIGH',
  /** The receiving power is low. */
  RxPowerLow = 'RX_POWER_LOW',
  /** The supply voltage collector is high. */
  SupplyVoltageVccHigh = 'SUPPLY_VOLTAGE_VCC_HIGH',
  /** The supply voltage collector is low. */
  SupplyVoltageVccLow = 'SUPPLY_VOLTAGE_VCC_LOW',
  /** The temperature is high. */
  TemperatureHigh = 'TEMPERATURE_HIGH',
  /** The temperature is low. */
  TemperatureLow = 'TEMPERATURE_LOW',
  /** The transmission power is high. */
  TxPowerHigh = 'TX_POWER_HIGH',
  /** The transmission power is low. */
  TxPowerLow = 'TX_POWER_LOW',
  /** The alarm type is unspecified. */
  Unspecified = 'UNSPECIFIED'
}

/** Reasons an SFP module cannot be used in the port it is plugged into. */
export enum SfpModuleError {
  /** The module is faster than the port supports. */
  SpeedFasterThanPort = 'SPEED_FASTER_THAN_PORT',
  /**
   * The module is slower than the port and the port does not negotiate down to the module's speed, so the
   * link will not come up. Controller SFP ports behave this way; switch ports link at the module's speed.
   */
  SpeedSlowerThanPort = 'SPEED_SLOWER_THAN_PORT'
}

/** Information about an SFP module plugged into a port. */
export type SfpModuleInfo = {
  __typename?: 'SFPModuleInfo';
  /** the digital diagnostics monitored information. */
  digitalDiagnosticsMonitoringInfo?: Maybe<SfpDigitalDiagnosticsMonitoringInfo>;
  /** The speed capability of the SFP module. */
  moduleSpeed: Scalars['String']['output'];
  /** The speed capability of the SFP module, in Kbps, if determinable. */
  moduleSpeedKbps?: Maybe<Scalars['Float']['output']>;
  /** The type of the SFP module. */
  moduleType: Scalars['String']['output'];
  /** The part name of the SFP module. */
  partName: Scalars['String']['output'];
  /** The serial number of the SFP module. */
  serialNumber: Scalars['String']['output'];
  /** The vendor of the SFP module. */
  vendor: Scalars['String']['output'];
};

/** Input type for activating a Kore cellular SIM card. */
export type SimActivationInput = {
  /** The country where the SIM card will be used. */
  country: SimCountry;
  /** The ICCID (Integrated Circuit Card Identifier) of the SIM card to activate. */
  iccid: Scalars['String']['input'];
};

/**
 * Enumeration of possible activation statuses for a SIM card.
 * Actually for Kore, not Twilio.
 */
export enum SimActivationStatus {
  /** The SIM is active and can be used for cellular connectivity. */
  Active = 'ACTIVE',
  /** The SIM is inactive. */
  Inactive = 'INACTIVE',
  /** The SIM is newly created and not yet ready for use. */
  New = 'NEW',
  /** The SIM is ready for activation. */
  Ready = 'READY',
  /** The SIM activation has been scheduled. */
  Scheduled = 'SCHEDULED'
}

/** Enumeration of supported countries for activating Kore cellular SIM cards. */
export enum SimCountry {
  /** Canada */
  Ca = 'CA',
  /** Used for all other countries. */
  Other = 'OTHER',
  /** United States of America */
  Us = 'US'
}

/** Information about a Kore SuperSIM fleet. */
export type SimFleet = {
  __typename?: 'SIMFleet';
  /** The unique name of the fleet. */
  name?: Maybe<Scalars['String']['output']>;
  /** The URL for the fleet. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Hologram's data usage for one SIM profile in one 30-day period. */
export type SimUsagePeriod = {
  __typename?: 'SIMUsagePeriod';
  /** The eUICC identifier of the SIM card; null for SIMs without an embedded UICC. */
  eid?: Maybe<Scalars['String']['output']>;
  /** The ICCID of the SIM profile. */
  iccid: Scalars['String']['output'];
  /** When the usage period ends. */
  periodEnd: Scalars['DateTime']['output'];
  /** When the usage period starts. */
  periodStart: Scalars['DateTime']['output'];
  /** When the figure was last synced from Hologram. */
  syncedAt: Scalars['DateTime']['output'];
  /**
   * Bytes used in the period. For a closed period this is what Hologram billed. For the open period
   * it is the running total as of `syncedAt`.
   */
  usageBytes: Scalars['Int']['output'];
};

/** A packet capture that was run on a Switch. */
export type SosPacketCaptureJob = PacketCaptureJob & {
  __typename?: 'SOSPacketCaptureJob';
  /** The unique identifier for the job. */
  UUID: Scalars['UUID']['output'];
  /** The mode of packet capture. */
  captureMode: SosPacketCaptureMode;
  /** The time at which the job was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Whether the capture's file is currently available to download from storage. */
  downloadAvailable: Scalars['Boolean']['output'];
  /** The unique identifier of the network associated with this job. */
  networkUUID: Scalars['UUID']['output'];
  /** The port number that the packet capture runs on. */
  portNumber: Scalars['Int']['output'];
  /** The maximum size limit of the packet capture file in megabytes. */
  sizeLimitMb: Scalars['Int']['output'];
  /** Whether the job was stopped prematurely or not. */
  stopped: Scalars['Boolean']['output'];
  /** The maximum duration of the packet capture in seconds. */
  timeLimitSeconds: Scalars['Int']['output'];
  /**
   * The unique identifier for the job.
   * @deprecated Use `UUID` instead.
   */
  uuid: Scalars['UUID']['output'];
  /** The virtual device that the packet capture is run on. */
  virtualDevice: VirtualDevice;
  /** The UUID of the virtual device that the packet capture is run on. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** Mode of packet capture to run on a switch. */
export enum SosPacketCaptureMode {
  /** Host capture mode. */
  CaptureModeHost = 'CAPTURE_MODE_HOST',
  /** Hardware capture mode. */
  CaptureModeHw = 'CAPTURE_MODE_HW',
  /** Hardware/host capture mode. */
  CaptureModeHwHost = 'CAPTURE_MODE_HW_HOST'
}

/**
 * SPAN (Switched Port Analyzer) mirror sessions allow monitoring of network traffic by copying packets
 * from source ports to a destination port for analysis. Each switch supports a limited number of
 * concurrent SPAN sessions (up to 4 for S-series, up to 3 for MS-series).
 */
export type SpanMirrorSession = Identifiable & {
  __typename?: 'SPANMirrorSession';
  /** Unique identifier for the SPAN mirror session. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the session was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The destination physical interface where mirrored traffic is sent. */
  destPhyInterface: PhyInterface;
  /** UUID of the destination physical interface where mirrored traffic is sent. */
  destPhyInterfaceUUID: Scalars['UUID']['output'];
  /** Hardware session ID (1-4 for S-series, 1-3 for MS-series). Unique per device. */
  sessionID: Scalars['Int']['output'];
  /** Source ports configured for this SPAN session. */
  sourcePorts: Array<SpanMirrorSessionSourcePort>;
  /** Timestamp when the session was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The virtual device this session belongs to. Only switches for now, but controllers will be enabled soon as well */
  virtualDevice: VirtualDevice;
  /** The UUID of the virtual device this session belongs to. Only switches are supported for now, but controllers will be enabled soon as well */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/**
 * A source port in a SPAN mirror session. Defines which port to mirror traffic from
 * and in which direction(s) to capture packets.
 */
export type SpanMirrorSessionSourcePort = {
  __typename?: 'SPANMirrorSessionSourcePort';
  /** Unique identifier for the source port configuration. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when this source port was added. */
  createdAt: Scalars['DateTime']['output'];
  /** If true, mirror outgoing (egress) traffic on this port. */
  egressMirror: Scalars['Boolean']['output'];
  /** If true, mirror incoming (ingress) traffic on this port. */
  ingressMirror: Scalars['Boolean']['output'];
  /** The physical interface to mirror traffic from. */
  phyInterface: PhyInterface;
  /** UUID of the physical interface to mirror traffic from. */
  phyInterfaceUUID: Scalars['UUID']['output'];
  /** The parent SPAN mirror session. */
  session: SpanMirrorSession;
  /** UUID of the parent SPAN mirror session. */
  spanMirrorSessionUUID: Scalars['UUID']['output'];
  /** Timestamp when this source port was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type SpanMirrorSessionSourcePortInput = {
  /** If true, mirror outgoing (egress) traffic. At least one of ingressMirror or egressMirror must be true. */
  egressMirror?: Scalars['Boolean']['input'];
  /** If true, mirror incoming (ingress) traffic. At least one of ingressMirror or egressMirror must be true. */
  ingressMirror?: Scalars['Boolean']['input'];
  /** UUID of the physical interface to mirror traffic from. */
  phyInterfaceUUID: Scalars['UUID']['input'];
};

/** Service set identifiers (SSIDs) for a network. */
export type Ssid = Identifiable & {
  __typename?: 'SSID';
  /** BSSIDs are MAC addresses that identify a radio band / SSID pair for an access point. */
  BSSIDs: Array<Bssid>;
  /** Unique identifier for the SSID. */
  UUID: Scalars['UUID']['output'];
  /** The lowest rate at which a client can connect to the 2.4 GHz radio, in kilobits per second. */
  band2GMinimumBasicRateKbps?: Maybe<Scalars['Int']['output']>;
  /** The minimum RSSI (in dBm) for probe request suppression on the 2.4 GHz radio. 0 means use driver default. */
  band2GMinimumProbeRssiDbm: Scalars['Int']['output'];
  /** The lowest rate at which a client can connect to the 5 GHz radio, in kilobits per second. */
  band5GMinimumBasicRateKbps?: Maybe<Scalars['Int']['output']>;
  /** The minimum RSSI (in dBm) for probe request suppression on the 5 GHz radio. 0 means use driver default. */
  band5GMinimumProbeRssiDbm: Scalars['Int']['output'];
  /** The lowest rate at which a client can connect to the 6 GHz radio, in kilobits per second. */
  band6GMinimumBasicRateKbps?: Maybe<Scalars['Int']['output']>;
  /** The minimum RSSI (in dBm) for probe request suppression on the 6 GHz radio. 0 means use driver default. */
  band6GMinimumProbeRssiDbm: Scalars['Int']['output'];
  /** If true, all broadcast traffic is blocked before being transmitted to the wireless. Requires proxy ARP to be enabled. */
  blockWirelessTxBroadcast: Scalars['Boolean']['output'];
  /** If true, all multicast traffic is blocked before being transmitted to the wireless. */
  blockWirelessTxMulticast: Scalars['Boolean']['output'];
  /** Blocklist entries scoped to this SSID. */
  blockedClients: Array<NetworkClientBlocklistEntry>;
  /** If an SSID is scheduled (only enabled during certain timeframes), this is the schedule that we follow. */
  broadcastSchedule?: Maybe<Array<ScheduleInterval>>;
  /** A list of allowed client MACs, if isClientAllowlistEnabled is true. */
  clientAllowlist?: Maybe<Array<Scalars['MacAddress']['output']>>;
  /** Client steering allows devices to select an optimal access point for better connectivity and performance. */
  clientSteeringAssociationSteeringIsEnabled: Scalars['Boolean']['output'];
  /** The minimum number of clients on an SSID before client steering is attempted. */
  clientSteeringLoadBalancingClientMinThreshold?: Maybe<Scalars['Int']['output']>;
  /** Post association steering allows devices to move to a better access point after they have already connected. */
  clientSteeringPostassociationSteeringIsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The minimum RSSI signal strength a client must have before pre-association client steering is attempted. */
  clientSteeringPreassociationRSSIMinThreshold?: Maybe<Scalars['Int']['output']>;
  /** The clients currently connected to this SSID. Excludes Meter hardware. */
  clients: Array<NetworkClient>;
  /** Timestamp when the SSID was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Description of the SSID. */
  description?: Maybe<Scalars['String']['output']>;
  /** The access points that will not broadcast this SSID, if isEnabledForAllAccessPoints is true. */
  disabledAccessPointVirtualDevices?: Maybe<Array<AccessPointVirtualDevice>>;
  /** The DTIM (Delivery Traffic Indication Message) period is a value in beacon frames that indicates how often clients should wake up to receive multicast and broadcast traffic. */
  dtimPeriod?: Maybe<Scalars['Int']['output']>;
  /** Dynamic VLAN is a setting to use the VLAN specified by an external RADIUS server's response after authentication. If null, then the VLAN specified by `vlan` is used. */
  dynamicVLANMode?: Maybe<SsidDynamicVlanMode>;
  /** An optional period for requiring client reauthentication, for a 802.1X SSID. */
  eapReauthPeriod?: Maybe<Scalars['Duration']['output']>;
  /** The access points that will broadcast this SSID, if isEnabledForAllAccessPoints is false. */
  enabledAccessPointVirtualDevices?: Maybe<Array<AccessPointVirtualDevice>>;
  /**
   * 802.11w is a security standard that protects management frames from being forged by an attacker.
   * For WPA3 PSK, this field is required and must be REQUIRED.
   * For WPA3 Transition, this field is required but can be REQUIRED or OPTIONAL.
   * For WPA2, this field is optional.
   * For open networks, this field is not supported.
   */
  encryption80211wProtectedManagementFramesMode?: Maybe<SsidEncryption80211wProtectedManagementFramesMode>;
  /** Encryption protocol used by the SSID. If null, this is an open network. */
  encryptionProtocol?: Maybe<SsidEncryptionProtocol>;
  /** An optional value for the Hotspot 2.0 Access network type, as defined in Table 9-214 of 802.11-2016. */
  hs20AccessNetworkType?: Maybe<Scalars['Int']['output']>;
  /** A list of Hotspot 2.0 domain names. */
  hs20DomainNames?: Maybe<Array<Scalars['String']['output']>>;
  /** An option to enable/disable Hotspot 2.0, aka Passpoint. */
  hs20Enabled: Scalars['Boolean']['output'];
  /** A boolean to represent whether a Hotspot 2.0 profile is attached to the SSID (has any fields set). */
  hs20HasProfile: Scalars['Boolean']['output'];
  /** Optional label for the Hotspot 2.0 profile. */
  hs20Label?: Maybe<Scalars['String']['output']>;
  /** A list of MCC/MNC (Mobile Country Codes and Mobile Network Codes) pairs, formatted as "MCC,MNC". */
  hs20MccMncPairs?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of Hotspot 2.0 NAI (Network Access Identifier) realms; format follows hostapd format for nai_realm option (see hostapd documentation). */
  hs20NaiRealms?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of Operator names for Hotspot 2.0 (one per language). */
  hs20OperatorNames?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of Hotspot 2.0 Consortium OIs (Organization Identifiers). */
  hs20RoamingConsortiumOIs?: Maybe<Array<Scalars['String']['output']>>;
  /** An optional value for the Hotspot 2.0 Venue group, as defined in Table 9-62 of 802.11-2016. */
  hs20VenueGroup?: Maybe<Scalars['Int']['output']>;
  /**
   * A list of Venue names for Hotspot 2.0 (one per language); must be formatted with a two or three character language code separated by a colon from the venue name.
   * If at least one is set, hs20VenueGroup and hs20VenueType must be set.
   */
  hs20VenueNames?: Maybe<Array<Scalars['String']['output']>>;
  /** An optional value for the Hotspot 2.0 Venue type, as defined in Table 9-62 of 802.11-2016. */
  hs20VenueType?: Maybe<Scalars['Int']['output']>;
  /** Whether or not the SSID is enabled for 802.11ax (Wi-Fi 6) clients. */
  is80211axEnabled: Scalars['Boolean']['output'];
  /** Whether or not the SSID is enabled for 802.11be (Wi-Fi 7) clients. */
  is80211beEnabled: Scalars['Boolean']['output'];
  /** Whether or not AP debug logging is enabled for APs broadcasting the SSID. */
  isAPDebugLogEnabled: Scalars['Boolean']['output'];
  /** If true, all traffic sent on this SSID will be sent as voice access category, which means it will be prioritized compared to normal traffic of other SSIDs. */
  isAllTrafficVoicePriority: Scalars['Boolean']['output'];
  /** Whether or not the SSID is allowed to be broadcasted on the 2.4 GHz radio. */
  isBand2GAllowed: Scalars['Boolean']['output'];
  /** Whether or not the SSID is allowed to be broadcasted on the 5 GHz radio. */
  isBand5GAllowed: Scalars['Boolean']['output'];
  /** Whether or not the SSID is allowed to be broadcasted on the 6 GHz radio. */
  isBand6GAllowed: Scalars['Boolean']['output'];
  /**
   * Whether the SSID is enabled and, if it is scheduled, currently inside its
   * broadcastSchedule. Evaluated in the network's local time, as of the moment
   * the field is resolved.
   */
  isBroadcasting: Scalars['Boolean']['output'];
  /** If true, only clients in the client allowlist will be allowed. */
  isClientAllowlistEnabled: Scalars['Boolean']['output'];
  /** If true, clients in the blocklist will be blocked for this SSID. */
  isClientSSIDBlocklistEnabled: Scalars['Boolean']['output'];
  /** Indicates whether the SSID is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** If true, the SSID is enabled for all access points in the network, except for any access points specified in the disabledAccessPointsVirtualDevices field. If false, the SSID is enabled for only the access points specified in the enabledAccessPointVirtualDevices field. */
  isEnabledForAllAccessPoints: Scalars['Boolean']['output'];
  /** If true, the SSID is considered as guest and can be displayed on site for guest access, for example on a kiosk. */
  isGuest: Scalars['Boolean']['output'];
  /** If true, the SSID is not broadcast and clients must enter its name manually to join. */
  isHidden: Scalars['Boolean']['output'];
  /** If true, clients on the same SSID cannot communicate with each other. */
  isIsolateClientsEnabled: Scalars['Boolean']['output'];
  /** True if multicast to unicast translation is enabled on the SSID. */
  isMulticastToUnicastEnabled: Scalars['Boolean']['output'];
  /**
   * Whether proxy ARP (AP responds to ARP requests coming from the uplink on behalf of the clients) is enabled.
   * Null means the SSID defers to the network default.
   */
  isProxyARPEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Threshold (number of clients in the multicast group) above which multicast to unicast is disabled (multicast frame is sent). If 0, no limit. */
  multicastToUnicastClientThreshold?: Maybe<Scalars['Int']['output']>;
  /** A NAS (Network Access Server) identifier that can be used for Radius or 11r; if empty, defaults to the AP's hostname. */
  nasIdentifier?: Maybe<Scalars['String']['output']>;
  /** The network the SSID belongs to. */
  network: Network;
  /** UUID of the network this SSID belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The PSK for the SSID. If null, it is an open passwordless network or the encryption protocol does not use a PSK. */
  password?: Maybe<Scalars['String']['output']>;
  /** The last time the password was rotated, if password rotation is enabled. */
  passwordLastRotatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The next time the password will be rotated, if password rotation is enabled. */
  passwordNextRotationAt?: Maybe<Scalars['DateTime']['output']>;
  /** The period upon which the password is automatically rotated; a non-null value indicates that password rotation is enabled. */
  passwordRotationCadence?: Maybe<SsidPasswordRotationCadence>;
  /** The day of the month, in the network's local time zone, at which the password is automatically rotated. */
  passwordRotationDayOfMonthLocal?: Maybe<Scalars['Int']['output']>;
  /** The day of the week, in the network's local time zone, at which the password is automatically rotated (0 = Sunday, 1 = Monday, etc.). */
  passwordRotationDayOfWeekLocal?: Maybe<Scalars['Int']['output']>;
  /** The hour of the day, in the network's local time zone, at which the password is automatically rotated. */
  passwordRotationHourOfDayLocal?: Maybe<Scalars['Int']['output']>;
  /** Primary 802.1X encryption configuration for Enterprise authentication. */
  primaryEncryption8021X?: Maybe<Encryption8021X>;
  /** The proactive packet capture configuration for this SSID. */
  proactivePcapConfig?: Maybe<ProactivePcapSsidConfig>;
  /** True if SSID supports RADIUS Change of Authorization (CoA). */
  radiusCoaEnabled: Scalars['Boolean']['output'];
  /** A port where RADIUS servers can send CoA requests. */
  radiusCoaPort?: Maybe<Scalars['Int']['output']>;
  /** Maximum wait in seconds between two RADIUS retries. */
  radiusMaxRetryWait?: Maybe<Scalars['Int']['output']>;
  /** Number of RADIUS server retries before a failover. */
  radiusServerRetries?: Maybe<Scalars['Int']['output']>;
  /** The rate limit rules, if they exist, that are applied to this SSID. */
  rateLimitRules: Array<RateLimitRule>;
  /** 802.11k is a standard that helps wireless devices quickly find and switch to the best available access point. */
  roaming80211kIsEnabled: Scalars['Boolean']['output'];
  /** 802.11r is a standard that allows clients to roam more effectively between access points. */
  roaming80211rIsEnabled: Scalars['Boolean']['output'];
  /**
   * Used to indicate a group of APs sharing the same SSID between which a client can use 802.11r to roam. A 2 byte hex string.
   * Currently we do not allow callers to set this field.
   */
  roaming80211rMobilityDomain?: Maybe<Scalars['String']['output']>;
  /**
   * A 32 byte hex string key used for encryption in 802.11r for r0 and r1 key holders.
   * Currently we do not allow callers to set this field.
   */
  roaming80211rR0khR1khKey?: Maybe<Scalars['String']['output']>;
  /** 802.11v is a standard that allows devices to communicate with the network for better connection performance, such as optimizing roaming and power efficiency. */
  roaming80211vIsEnabled: Scalars['Boolean']['output'];
  /** A value to configure RTS/CTS (see QCA doc "Wireless LAN Access Point Command Reference" for more details). */
  rtsCtsEnabledCode?: Maybe<Scalars['Int']['output']>;
  /** Size of the PPDU on which RTS would be sent out. */
  rtsThreshold?: Maybe<Scalars['Int']['output']>;
  /** Secondary 802.1X encryption configuration for Enterprise authentication. */
  secondaryEncryption8021X?: Maybe<Encryption8021X>;
  /** Name of the SSID (network name). */
  ssid: Scalars['String']['output'];
  /** A number to uniquely identify the SSID within the network. Starts from zero. */
  ssidIndex: Scalars['Int']['output'];
  /** Timestamp when the SSID was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** VLAN associated with the SSID. This field must be non-null if the SSID is enabled. */
  vlan?: Maybe<Vlan>;
  /** A list of all iPSKs for the SSID, if applicable. */
  wifiIPSKs?: Maybe<Array<WifiIpsk>>;
};


/** Service set identifiers (SSIDs) for a network. */
export type SsidBssiDsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SsidDynamicVlanMode {
  /**
   * The VLAN specified by an external RADIUS server's response after authentication is used.
   * The VLAN specified by `vlan` is used as a fallback if the RADIUS server does not specify a VLAN.
   */
  Enabled = 'ENABLED',
  /**
   * The VLAN specified by an external RADIUS server's response after authentication is used.
   * The VLAN specified by `vlan` is ignored.
   */
  Required = 'REQUIRED'
}

export enum SsidEncryption80211wProtectedManagementFramesMode {
  /** Can only be set as optional for WPA2 / WPA2 Enterprise / WPA3 Transition. */
  Optional = 'OPTIONAL',
  /** Must be set to this for WPA3; for other encryption protocols, it is also permitted. */
  Required = 'REQUIRED'
}

export enum SsidEncryptionProtocol {
  /** SSID with Meter NAC (Network Access Control, Meter RADIUS solution), Open MAC authentication. */
  MeterNacOpenMacAuth = 'METER_NAC_OPEN_MAC_AUTH',
  /** SSID with Meter NAC (Network Access Control, Meter RADIUS solution), WPA2-Enterprise. */
  MeterNacWpa2 = 'METER_NAC_WPA2',
  /** SSID with Meter NAC (Network Access Control, Meter RADIUS solution), WPA3-Enterprise. */
  MeterNacWpa3 = 'METER_NAC_WPA3',
  /** Open network with MAC address authentication via RADIUS. */
  OpenMacAuthRadius = 'OPEN_MAC_AUTH_RADIUS',
  /** Wi-Fi Protected Access II (WPA2) Personal. */
  Wpa2 = 'WPA2',
  /** WPA2 Enterprise with 802.1X authentication. */
  Wpa2Enterprise = 'WPA2_ENTERPRISE',
  /** SSID with multiple WPA2 passwords (iPSKs). */
  Wpa2Ipsk = 'WPA2_IPSK',
  /** SSID with MPSK (Radius-based iPSK solution in partnership with RoamingIQ) */
  Wpa2Mpsk = 'WPA2_MPSK',
  /** WPA3 Personal. */
  Wpa3 = 'WPA3',
  /** WPA3 Enterprise with 802.1X authentication. */
  Wpa3Enterprise = 'WPA3_ENTERPRISE',
  /** Supports clients that use WPA2 Enterprise or WPA3 Enterprise (802.1X). WPA3 Enterprise only on 6 GHz. */
  Wpa3EnterpriseTransition = 'WPA3_ENTERPRISE_TRANSITION',
  /** WPA3 OWE (Open). */
  Wpa3Owe = 'WPA3_OWE',
  /** Supports clients that use WPA2 or WPA3. */
  Wpa3Transition = 'WPA3_TRANSITION'
}

export type SsidFilterInput = {
  /** The guest status to filter by. */
  isGuest?: InputMaybe<Scalars['Boolean']['input']>;
  /** The hidden status to filter by. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** The SSID to filter by. */
  ssid?: InputMaybe<Scalars['String']['input']>;
};

export enum SsidPasswordRotationCadence {
  /** Rotate the password daily. */
  Daily = 'DAILY',
  /** Rotate the password monthly. */
  Monthly = 'MONTHLY',
  /** Rotate the password quarterly. */
  Quarterly = 'QUARTERLY',
  /** Rotate the password weekly. */
  Weekly = 'WEEKLY'
}

/** Specifies the type of admin portal link to generate for SSO configuration. */
export enum SsoAdminPortalType {
  /** WorkOS admin dashboard for viewing WorkOS Audit Logs. */
  AuditLogs = 'AUDIT_LOGS',
  /** WorkOS admin dashboard for verifying the company's email domains. */
  DomainVerification = 'DOMAIN_VERIFICATION',
  /** WorkOS admin dashboard for configuring Directory Sync. */
  Dsync = 'DSYNC',
  /** WorkOS admin dashboard for configuring Log Streams. */
  LogStreams = 'LOG_STREAMS',
  /** WorkOS admin dashboard for configuring an SSO Provider. */
  SsoProvider = 'SSO_PROVIDER'
}

/** Represents a directory that is connected to the company via WorkOS. */
export type SsoConnectedDirectory = {
  __typename?: 'SSOConnectedDirectory';
  /** The date and time when the directory was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The groups of the connected directory. */
  groups: Array<SsoDirectoryGroup>;
  /** The state of the connected directory. */
  state: SsoState;
  /** The type of the connected directory. */
  type: SsoDirectoryTypes;
};

/** Represents an SSO connection for a company. */
export type SsoConnection = {
  __typename?: 'SSOConnection';
  /** The date and time when the SSO connection was created. */
  connectedAt: Scalars['DateTime']['output'];
  /** The current state of the SSO connection. */
  state: SsoConnectionState;
  /** The type of the SSO connection. */
  type: SsoConnectionType;
};

/** Represents the state of an SSO connection. */
export enum SsoConnectionState {
  /** The SSO connection is active. */
  Active = 'Active',
  /** The SSO connection is in draft state and not yet active. */
  Draft = 'Draft',
  /** The SSO connection is inactive. */
  Inactive = 'Inactive',
  /** No SSO connection exists. */
  None = 'None',
  /** The SSO connection is validating credentials or configuration. */
  Validating = 'Validating'
}

/** Represents the type of an SSO connection. */
export enum SsoConnectionType {
  Adfssaml = 'ADFSSAML',
  AdpOidc = 'AdpOidc',
  Auth0Saml = 'Auth0SAML',
  AzureSaml = 'AzureSAML',
  CasSaml = 'CasSAML',
  ClassLinkSaml = 'ClassLinkSAML',
  CloudflareSaml = 'CloudflareSAML',
  CyberArkSaml = 'CyberArkSAML',
  DuoSaml = 'DuoSAML',
  GenericOidc = 'GenericOIDC',
  GenericSaml = 'GenericSAML',
  GoogleOAuth = 'GoogleOAuth',
  GoogleSaml = 'GoogleSAML',
  JumpCloudSaml = 'JumpCloudSAML',
  KeycloakSaml = 'KeycloakSAML',
  LastPassSaml = 'LastPassSAML',
  LoginGovOidc = 'LoginGovOidc',
  MagicLink = 'MagicLink',
  MicrosoftOAuth = 'MicrosoftOAuth',
  MiniOrangeSaml = 'MiniOrangeSAML',
  NetIqSaml = 'NetIqSAML',
  None = 'None',
  OktaSaml = 'OktaSAML',
  OneLoginSaml = 'OneLoginSAML',
  OracleSaml = 'OracleSAML',
  PingFederateSaml = 'PingFederateSAML',
  PingOneSaml = 'PingOneSAML',
  RipplingSaml = 'RipplingSAML',
  SalesforceSaml = 'SalesforceSAML',
  ShibbolethGenericSaml = 'ShibbolethGenericSAML',
  ShibbolethSaml = 'ShibbolethSAML',
  SimpleSamlPhpSaml = 'SimpleSamlPhpSAML',
  VMwareSaml = 'VMwareSAML'
}

/** Represents a directory available via WorkOS for SSO. */
export type SsoDirectory = {
  __typename?: 'SSODirectory';
  /** The domain associated with the directory. */
  domain: Scalars['String']['output'];
  /** The name of the directory. */
  name: Scalars['String']['output'];
  /** The state of the directory connection. */
  state: SsoState;
  /** The type of the directory. */
  type: SsoDirectoryTypes;
};

/** Represents groups within a directory. */
export type SsoDirectoryGroup = {
  __typename?: 'SSODirectoryGroup';
  /** The name of the group. */
  name: Scalars['String']['output'];
};

/** The type of directory that is available via WorkOS. 'None' doesn't exist in WorkOS, but is used internally to represent no connection. */
export enum SsoDirectoryTypes {
  AzureScimv2_0 = 'AzureSCIMV2_0',
  BambooHr = 'BambooHr',
  BreatheHr = 'BreatheHr',
  CezanneHr = 'CezanneHr',
  CyberArk = 'CyberArk',
  FourthHr = 'FourthHr',
  GSuiteDirectory = 'GSuiteDirectory',
  GenericScimv2_0 = 'GenericSCIMV2_0',
  Hibob = 'Hibob',
  JumpCloud = 'JumpCloud',
  None = 'None',
  OktaScimv2_0 = 'OktaSCIMV2_0',
  OneLogin = 'OneLogin',
  PeopleHr = 'PeopleHr',
  Personio = 'Personio',
  PingFederate = 'PingFederate',
  Rippling = 'Rippling',
  Sftp = 'SFTP',
  SftpWorkday = 'SFTPWorkday',
  Workday = 'Workday'
}

/** Represents the SSO options that can be configured for a company. */
export type SsoOptions = {
  __typename?: 'SSOOptions';
  /** The directory currently connected to the company. */
  connectedDirectory?: Maybe<SsoConnectedDirectory>;
  /** A list of SSO connections for the company. */
  connections: Array<SsoConnection>;
  /** A list of directories available via WorkOS. */
  directories: Array<SsoDirectory>;
};

/** Input for retrieving SSO options for a company. */
export type SsoOptionsInput = {
  /** The slug (unique identifier) of the company. */
  companySlug: Scalars['String']['input'];
};

/** Represents the state of the directory connection for SSO. */
export enum SsoState {
  /** The directory is active. */
  Active = 'Active',
  /** The directory is deleting. */
  Deleting = 'Deleting',
  /** The directory is connected, but the credentials are invalid. */
  InvalidCredentials = 'InvalidCredentials',
  /** The directory is connected and ready to use. */
  Linked = 'Linked',
  /** The directory is not connected and cannot be used. */
  Unlinked = 'Unlinked'
}

/** The source from which the SSO verification request originated. */
export enum SsoVerificationSource {
  /** The verification request originated from Auth Kit. */
  AuthKit = 'AUTH_KIT',
  /** The verification request originated from an SSO provider. */
  Sso = 'SSO'
}

/** Properties for STP error port blocked events. */
export type StpErrorPortBlockedProperties = {
  __typename?: 'STPErrorPortBlockedProperties';
  /** The physical interface associated with the STP port error. */
  phyInterface?: Maybe<PhyInterface>;
  /** The specific STP port error that occurred. */
  portError: StpPortError;
  /** The virtual device associated with the STP port error. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** Properties for STP error port unblocked events. */
export type StpErrorPortUnblockedProperties = {
  __typename?: 'STPErrorPortUnblockedProperties';
  /** The physical interface associated with the STP port error unblockage. */
  phyInterfaces: Array<Maybe<PhyInterface>>;
  /** The virtual device associated with the STP port error unblockage. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** STP (Spanning Tree Protocol) configuration information for switches to ensure loop-free topologies. */
export type StpInfo = {
  __typename?: 'STPInfo';
  /** The root bridge is the switch in a network from which all paths are derived to prevent loops. */
  isRootBridge: Scalars['Boolean']['output'];
  /** The MAC address of the root bridge. */
  rootBridgeMACAddress: Scalars['MacAddress']['output'];
  /** The port number on which the root bridge is connected. */
  rootBridgePortNumber: Scalars['Int']['output'];
};

/** Represents an error that occurred on a port in Spanning Tree Protocol (STP). */
export enum StpPortError {
  /** The port is blocked due to a BPDU (Bridge Protocol Data Unit) guard violation. */
  BpduGuard = 'BPDU_GUARD',
  /** The port is blocked due to receiving an invalid BPDU (Bridge Protocol Data Unit). */
  BpduInvalid = 'BPDU_INVALID',
  /** The port is blocked due to a loop condition detected by BPDU (Bridge Protocol Data Unit). */
  BpduLoopback = 'BPDU_LOOPBACK',
  /** The port is blocked due to a root guard violation, which occurs when a port receives a BPDU that would make it the root bridge. */
  RootGuard = 'ROOT_GUARD',
  /** Error is unspecified or unknown. */
  Unspecified = 'UNSPECIFIED'
}

/** Possible roles of a port in Spanning Tree Protocol (STP). */
export enum StpPortRole {
  /** An alternate port provides an alternate path to the root bridge in case the designated port fails. */
  Alternate = 'ALTERNATE',
  /** A backup port provides a backup path to a segment where another port already connects. */
  Backup = 'BACKUP',
  /** A designated port is a port that is designated for forwarding on a LAN segment. */
  Designated = 'DESIGNATED',
  /** A disabled port is not participating in STP. */
  Disabled = 'DISABLED',
  /** A root port is the port with the lowest cost path to the root bridge. */
  Root = 'ROOT'
}

/**
 * Properties for Spanning Tree Protocol (STP) root bridge change events. Emitted
 * when the root bridge observed by a switch changes (MAC, port connecting to the
 * root, or priority).
 */
export type StpRootBridgeChangedProperties = {
  __typename?: 'STPRootBridgeChangedProperties';
  /** The MAC address of the new root bridge. */
  newRootBridgeMacAddress: Scalars['MacAddress']['output'];
  /** The physical interface now connected to the root bridge, if known. */
  newRootBridgePhyInterface?: Maybe<PhyInterface>;
  /** The port number that is now the root port. */
  newRootBridgePortNumber: Scalars['Int']['output'];
  /** The STP priority of the new root bridge. */
  newRootBridgePriority: Scalars['Int']['output'];
  /** The MAC address of the previous root bridge. */
  oldRootBridgeMacAddress: Scalars['MacAddress']['output'];
  /** The physical interface that was previously connected to the root bridge, if known. */
  oldRootBridgePhyInterface?: Maybe<PhyInterface>;
  /** The port number that was previously the root port. */
  oldRootBridgePortNumber: Scalars['Int']['output'];
  /** The STP priority of the previous root bridge. */
  oldRootBridgePriority: Scalars['Int']['output'];
  /** The switch observing the root bridge change. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** Identifies a Salesforce-related river job queue that can be paused and resumed by super operators. */
export enum SalesforceJobQueue {
  /** The queue that processes batches of cases to upsert */
  BatchUpsert = 'BATCH_UPSERT',
  /** The queue that periodically syncs cases, comments, and attachments from Snowflake. */
  CaseSync = 'CASE_SYNC',
  /** The queue that ingests attachment file contents from Salesforce into Meter's S3. */
  Ingest = 'INGEST',
  /** The queue that publishes cases, comments, and attachments from Meter to Salesforce. */
  Publish = 'PUBLISH'
}

/** Represents the current pause state of a Salesforce job queue. */
export type SalesforceJobQueueState = {
  __typename?: 'SalesforceJobQueueState';
  /** Whether the queue is currently paused. */
  isPaused: Scalars['Boolean']['output'];
  /** When the queue was paused, if it is currently paused. */
  pausedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The queue this state describes. */
  queue: SalesforceJobQueue;
};

/**
 * ScanData represents the data collected from our access points about the
 * wireless networks they observe.
 */
export type ScanData = {
  __typename?: 'ScanData';
  /** The BSSID of the SSID that was observed. */
  BSSID: Scalars['MacAddress']['output'];
  /** The RSSI of the SSID that was observed, in dBm. */
  RSSI: Scalars['Int']['output'];
  /** The signal-to-noise ratio (SNR), in dB. */
  SNR: Scalars['Int']['output'];
  /** The SSID that was observed. */
  SSID: Scalars['String']['output'];
  /** The Band that the SSID was observed broadcasting on. */
  band: RadioBand;
  /** The channel on which the SSID was observed. */
  channel: Scalars['Int']['output'];
  /** The channel width of the SSID that was observed. */
  channelWidth: Scalars['Int']['output'];
  /** The noise floor measured by the scanning radio, in dBm. */
  noiseFloor: Scalars['Int']['output'];
  /** When the SSID was observed. */
  observedAt: Scalars['DateTime']['output'];
  /** The observed virtual device, if the BSSID is that of a Meter device. */
  observedVirtualDevice?: Maybe<VirtualDevice>;
  /** The radio that observed the SSID. */
  radio: DeviceRadio;
  /** The virtual device that observed the SSID. */
  virtualDevice: VirtualDevice;
  /** The UUID of the virtual device that observed the SSID. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/**
 * ScheduleInterval represents a time interval during a week, specified by start and end times
 * with day of week, hour, and minute precision. Used for scheduling SSID broadcasts and other
 * time-based operations.
 */
export type ScheduleInterval = {
  __typename?: 'ScheduleInterval';
  /** The day of the week for the end of the interval (0 = Sunday, 1 = Monday, etc.). */
  endDayOfWeek: Scalars['Int']['output'];
  /** The hour of the day for the end of the interval (0-23). */
  endHour: Scalars['Int']['output'];
  /** The minute of the hour for the end of the interval(0-59). */
  endMinute: Scalars['Int']['output'];
  /** The day of the week for the start of the interval (0 = Sunday, 1 = Monday, etc.). */
  startDayOfWeek: Scalars['Int']['output'];
  /** The hour of the day for the start of the interval (0-23). */
  startHour: Scalars['Int']['output'];
  /** The minute of the hour for the start of the interval(0-59). */
  startMinute: Scalars['Int']['output'];
};

/**
 * ScheduleIntervalInput is used to create or update a ScheduleInterval. It defines a time interval
 * during a week with start and end times specified by day of week, hour, and minute.
 */
export type ScheduleIntervalInput = {
  /** The day of the week for the end of the interval (0 = Sunday, 1 = Monday, etc.). */
  endDayOfWeek: Scalars['Int']['input'];
  /** The hour of the day for the end of the interval (0-23). */
  endHour: Scalars['Int']['input'];
  /** The minute of the hour for the end of the interval(0-59). */
  endMinute: Scalars['Int']['input'];
  /** The day of the week for the start of the interval (0 = Sunday, 1 = Monday, etc.). */
  startDayOfWeek: Scalars['Int']['input'];
  /** The hour of the day for the start of the interval (0-23). */
  startHour: Scalars['Int']['input'];
  /** The minute of the hour for the start of the interval(0-59). */
  startMinute: Scalars['Int']['input'];
};

/** Tracks the progress of a scheduled NOS upgrade at a device-level. */
export type ScheduledDeviceNosUpgrade = {
  __typename?: 'ScheduledDeviceNOSUpgrade';
  /** The UUID of the device NOS upgrade. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the device NOS upgrade was applied successfully, if applicable. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The reason the device NOS upgrade failed, if applicable. */
  failureReason?: Maybe<ScheduledDeviceNosUpgradeFailureReason>;
  /** The NOS version that the device was upgraded to. */
  nosVersion: NosVersion;
  /** The timestamp when the device NOS upgrade is scheduled to begin. */
  scheduledAt: Scalars['DateTime']['output'];
  /** The status of the device NOS upgrade. */
  status: ScheduledNosUpgradeStatus;
  /** The virtual device that the device NOS upgrade is associated with. */
  virtualDevice: VirtualDevice;
};

export enum ScheduledDeviceNosUpgradeFailureReason {
  /** Something went wrong talking to the backend API during the upgrade. */
  ApiError = 'API_ERROR',
  /** The upgrade file could not be downloaded after all retry attempts were exhausted. */
  FailedDownload = 'FAILED_DOWNLOAD',
  /** The upgrade install script failed when the device tried to run it. */
  FailedExecutingInstall = 'FAILED_EXECUTING_INSTALL',
  /** The downloaded file's checksum did not match the expected hash. */
  HashMismatch = 'HASH_MISMATCH',
  /** The target firmware build is not compatible with the device's board. */
  IncompatibleVersion = 'INCOMPATIBLE_VERSION',
  /** The device failed to boot with the expected build post-upgrade. */
  PostUpgradeBootMismatch = 'POST_UPGRADE_BOOT_MISMATCH'
}

/** Tracks the progress of a scheduled NOS upgrade at a group-level. */
export type ScheduledGroupNosUpgrade = {
  __typename?: 'ScheduledGroupNOSUpgrade';
  /** The UUID of the group NOS upgrade. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when all of the devices in the group have successfully upgraded, if applicable. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The timestamp when the group NOS upgrade was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The underlying device upgrades that the group NOS upgrade is associated with. */
  deviceUpgrades: Array<ScheduledDeviceNosUpgrade>;
  /** The NOS upgrade group that the group NOS upgrade is associated with. */
  nosUpgradeGroup: NosUpgradeGroup;
  /** The timestamp when the group NOS upgrade is scheduled to begin. */
  scheduledAt: Scalars['DateTime']['output'];
  /** The status of the scheduled NOS upgrade. */
  status: ScheduledNosUpgradeStatus;
  /** The timestamp when the group NOS upgrade was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The reason for a NOS upgrade failure. */
export enum ScheduledNosUpgradeFailureReason {
  /** The network has a config override on a device's build string. */
  DeviceConfigOverrides = 'DEVICE_CONFIG_OVERRIDES',
  /** Post-upgrade boot verification noted that some devices did not upgrade successfully. */
  PostUpgradeVerificationFailed = 'POST_UPGRADE_VERIFICATION_FAILED',
  /** The upgrade did not complete within the allowed time window. */
  UpgradeTimeout = 'UPGRADE_TIMEOUT'
}

/** The status of a scheduled NOS upgrade, indicating the progress of the upgrade. */
export enum ScheduledNosUpgradeStatus {
  /** The scheduled NOS upgrade was scheduled and then cancelled. */
  Cancelled = 'CANCELLED',
  /** The scheduled NOS upgrade was successfully completed. */
  Completed = 'COMPLETED',
  /** The scheduled NOS upgrade was not successful. */
  Failed = 'FAILED',
  /** The scheduled NOS upgrade is underway. */
  InProgress = 'IN_PROGRESS',
  /** The scheduled NOS upgrade has been scheduled but not yet started. */
  Scheduled = 'SCHEDULED',
  /** The scheduled NOS upgrade for a specific device was skipped. */
  Skipped = 'SKIPPED'
}

/** Tracks the progress of a scheduled NOS upgrade at a network-level. */
export type ScheduledNetworkNosUpgrade = Identifiable & {
  __typename?: 'ScheduledNetworkNOSUpgrade';
  /** The UUID of the scheduled NOS upgrade. */
  UUID: Scalars['UUID']['output'];
  /** The reason for this version change, if one was provided. */
  changeReason?: Maybe<NosVersionChangeReason>;
  /** The timestamp when the scheduled NOS upgrade was completed successfully, if applicable. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The timestamp when the scheduled NOS upgrade was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The reason for the NOS upgrade failure, if applicable. */
  failureReason?: Maybe<ScheduledNosUpgradeFailureReason>;
  /** The underlying NOS upgrade groups that the scheduled NOS upgrade is associated with, ordered by priority. */
  groupUpgrades: Array<ScheduledGroupNosUpgrade>;
  /** The network that the scheduled NOS upgrade is associated with. */
  networkUUID: Scalars['UUID']['output'];
  /** The NOS version to be applied to the network. */
  nosVersion: NosVersion;
  /** Any NOS upgrade groups that are associated with the network but not yet included in the `groupUpgrades` because they haven't been scheduled yet. */
  pendingNOSUpgradeGroups?: Maybe<Array<NosUpgradeGroup>>;
  /** The timestamp when the scheduled NOS upgrade is/was scheduled to begin. */
  scheduledAt: Scalars['DateTime']['output'];
  /** The status of the scheduled NOS upgrade. */
  status: ScheduledNosUpgradeStatus;
  /** The timestamp when the scheduled NOS upgrade was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Input representing the scheduling time of a
 * network job.
 */
export type SchedulerInput = {
  /** If true the network job will run immediately. */
  immediate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Schedule the job at a specific time in the future, up to a month in the future. If not provided, the job will run immediately. Must be null if scheduledAtNextMaintenanceWindow is true. */
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** If true, the network job will run during the network's next maintenance window. */
  scheduledAtNextMaintenanceWindow?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ScopeKind {
  AccessPointPortProfileUuid = 'ACCESS_POINT_PORT_PROFILE_UUID',
  AlertCompanySubscriptionUuid = 'ALERT_COMPANY_SUBSCRIPTION_UUID',
  AlertDeviceNotificationSnoozeUuid = 'ALERT_DEVICE_NOTIFICATION_SNOOZE_UUID',
  AlertReceiverUuid = 'ALERT_RECEIVER_UUID',
  AlertTargetSalesforceUuid = 'ALERT_TARGET_SALESFORCE_UUID',
  AlertTargetSlackUuid = 'ALERT_TARGET_SLACK_UUID',
  AlertTargetWebhookUuid = 'ALERT_TARGET_WEBHOOK_UUID',
  ApplicationDnsFirewallRuleUuid = 'APPLICATION_DNS_FIREWALL_RULE_UUID',
  AutoSelectionJobUuid = 'AUTO_SELECTION_JOB_UUID',
  AutoVpnGroupUuid = 'AUTO_VPN_GROUP_UUID',
  AutoVpnHubUplinkUuid = 'AUTO_VPN_HUB_UPLINK_UUID',
  AutoVpnHubUuid = 'AUTO_VPN_HUB_UUID',
  AutoVpnMemberHubUuid = 'AUTO_VPN_MEMBER_HUB_UUID',
  AutoVpnMemberUuid = 'AUTO_VPN_MEMBER_UUID',
  AutoVpnRouteUuid = 'AUTO_VPN_ROUTE_UUID',
  BgpNeighborUuid = 'BGP_NEIGHBOR_UUID',
  BgpRouterUuid = 'BGP_ROUTER_UUID',
  CaptivePortalEntryUuid = 'CAPTIVE_PORTAL_ENTRY_UUID',
  CaptivePortalUuid = 'CAPTIVE_PORTAL_UUID',
  ClientVpnClientUuid = 'CLIENT_VPN_CLIENT_UUID',
  ClientVpnServerUuid = 'CLIENT_VPN_SERVER_UUID',
  CompanyLocationUuid = 'COMPANY_LOCATION_UUID',
  CompanyOnboardingDocumentUuid = 'COMPANY_ONBOARDING_DOCUMENT_UUID',
  CompanyOnboardingFieldDelegationUuid = 'COMPANY_ONBOARDING_FIELD_DELEGATION_UUID',
  CompanySiemIntegrationUuid = 'COMPANY_SIEM_INTEGRATION_UUID',
  CompanySlug = 'COMPANY_SLUG',
  CompanyUserUuid = 'COMPANY_USER_UUID',
  CompanyUuid = 'COMPANY_UUID',
  ComplianceReportUuid = 'COMPLIANCE_REPORT_UUID',
  CustomRoleUuid = 'CUSTOM_ROLE_UUID',
  DdnsRecordUuid = 'DDNS_RECORD_UUID',
  DeploymentDeliverableUuid = 'DEPLOYMENT_DELIVERABLE_UUID',
  DeploymentJobUuid = 'DEPLOYMENT_JOB_UUID',
  DeploymentTaskBlockerUuid = 'DEPLOYMENT_TASK_BLOCKER_UUID',
  DeploymentTaskExceptionMessageUuid = 'DEPLOYMENT_TASK_EXCEPTION_MESSAGE_UUID',
  DeploymentTaskExceptionUuid = 'DEPLOYMENT_TASK_EXCEPTION_UUID',
  DeploymentTaskUuid = 'DEPLOYMENT_TASK_UUID',
  DeploymentTimeWindowUuid = 'DEPLOYMENT_TIME_WINDOW_UUID',
  DhcpOptionUuid = 'DHCP_OPTION_UUID',
  DhcpProxyUuid = 'DHCP_PROXY_UUID',
  DhcpReservedRangeUuid = 'DHCP_RESERVED_RANGE_UUID',
  DhcpRuleFilterUuid = 'DHCP_RULE_FILTER_UUID',
  DhcpRuleUuid = 'DHCP_RULE_UUID',
  DhcpStaticMappingUuid = 'DHCP_STATIC_MAPPING_UUID',
  DnsHostMappingsUuid = 'DNS_HOST_MAPPINGS_UUID',
  DocumentUploadUuid = 'DOCUMENT_UPLOAD_UUID',
  Encryption_8021XUuid = 'ENCRYPTION_8021X_UUID',
  FirewallRuleUuid = 'FIREWALL_RULE_UUID',
  FleetwideNotificationSnoozeUuid = 'FLEETWIDE_NOTIFICATION_SNOOZE_UUID',
  FloorPlanUuid = 'FLOOR_PLAN_UUID',
  GatewayProfileUuid = 'GATEWAY_PROFILE_UUID',
  HighAvailabilityConfigUuid = 'HIGH_AVAILABILITY_CONFIG_UUID',
  HostMonitoringTargetUuid = 'HOST_MONITORING_TARGET_UUID',
  IdsIpsConfigUuid = 'IDS_IPS_CONFIG_UUID',
  IdsIpsCustomRuleUuid = 'IDS_IPS_CUSTOM_RULE_UUID',
  InboxMessageUuid = 'INBOX_MESSAGE_UUID',
  InternalNoteUuid = 'INTERNAL_NOTE_UUID',
  InternetServicePlanDocumentUuid = 'INTERNET_SERVICE_PLAN_DOCUMENT_UUID',
  InternetServicePlanFulfillmentJobUuid = 'INTERNET_SERVICE_PLAN_FULFILLMENT_JOB_UUID',
  InternetServicePlanFulfillmentTaskUuid = 'INTERNET_SERVICE_PLAN_FULFILLMENT_TASK_UUID',
  InternetServicePlanPaymentResourceUuid = 'INTERNET_SERVICE_PLAN_PAYMENT_RESOURCE_UUID',
  InternetServicePlanUuid = 'INTERNET_SERVICE_PLAN_UUID',
  IpsecTunnelUuid = 'IPSEC_TUNNEL_UUID',
  IpForwardingRuleUuid = 'IP_FORWARDING_RULE_UUID',
  LabReservationUuid = 'LAB_RESERVATION_UUID',
  LabResourceUuid = 'LAB_RESOURCE_UUID',
  MonitorGroupUuid = 'MONITOR_GROUP_UUID',
  MonitorProbeBindingUuid = 'MONITOR_PROBE_BINDING_UUID',
  MonitorProbeUuid = 'MONITOR_PROBE_UUID',
  MutationDiffAuditLogEntryUuid = 'MUTATION_DIFF_AUDIT_LOG_ENTRY_UUID',
  NacCredentialUuid = 'NAC_CREDENTIAL_UUID',
  NacGroupUuid = 'NAC_GROUP_UUID',
  NacIdpConfigUuid = 'NAC_IDP_CONFIG_UUID',
  NacIdpGroupMappingUuid = 'NAC_IDP_GROUP_MAPPING_UUID',
  NacPolicyEntryUuid = 'NAC_POLICY_ENTRY_UUID',
  NacPolicyUuid = 'NAC_POLICY_UUID',
  NetworkClientBlocklistEntryUuid = 'NETWORK_CLIENT_BLOCKLIST_ENTRY_UUID',
  NetworkClientCpeBindingUuid = 'NETWORK_CLIENT_CPE_BINDING_UUID',
  NetworkJobUuid = 'NETWORK_JOB_UUID',
  NetworkOnboardingDocumentUuid = 'NETWORK_ONBOARDING_DOCUMENT_UUID',
  NetworkOnboardingFieldDelegationUuid = 'NETWORK_ONBOARDING_FIELD_DELEGATION_UUID',
  NetworkReservationUuid = 'NETWORK_RESERVATION_UUID',
  NetworkThreatAllowlistUuid = 'NETWORK_THREAT_ALLOWLIST_UUID',
  NetworkUuid = 'NETWORK_UUID',
  NosFeatureUuid = 'NOS_FEATURE_UUID',
  NosFeatureVersionRangeUuid = 'NOS_FEATURE_VERSION_RANGE_UUID',
  NosUpgradeGroupUuid = 'NOS_UPGRADE_GROUP_UUID',
  NotNetworkScoped = 'NOT_NETWORK_SCOPED',
  ObserverTestBindingUuid = 'OBSERVER_TEST_BINDING_UUID',
  ObserverTestUuid = 'OBSERVER_TEST_UUID',
  OneToOneNatRuleUuid = 'ONE_TO_ONE_NAT_RULE_UUID',
  OutletInterfaceUuid = 'OUTLET_INTERFACE_UUID',
  PacketCaptureGroupUuid = 'PACKET_CAPTURE_GROUP_UUID',
  PacketCaptureJobId = 'PACKET_CAPTURE_JOB_ID',
  PhyInterfaceDhcpRuleUuid = 'PHY_INTERFACE_DHCP_RULE_UUID',
  PhyInterfaceUuid = 'PHY_INTERFACE_UUID',
  PolicyEnginePathUuid = 'POLICY_ENGINE_PATH_UUID',
  PolicyEnginePolicyUuid = 'POLICY_ENGINE_POLICY_UUID',
  PolicyEngineTrafficMatcherUuid = 'POLICY_ENGINE_TRAFFIC_MATCHER_UUID',
  PolicyRoutingRuleUuid = 'POLICY_ROUTING_RULE_UUID',
  PortForwardingRuleUuid = 'PORT_FORWARDING_RULE_UUID',
  PublicApiKeyGrantRequestUuid = 'PUBLIC_API_KEY_GRANT_REQUEST_UUID',
  PublicApiKeyUuid = 'PUBLIC_API_KEY_UUID',
  QuoteRequestUuid = 'QUOTE_REQUEST_UUID',
  QuoteUuid = 'QUOTE_UUID',
  RackElevationDeviceUuid = 'RACK_ELEVATION_DEVICE_UUID',
  RackElevationUuid = 'RACK_ELEVATION_UUID',
  RadioProfileUuid = 'RADIO_PROFILE_UUID',
  RateLimitRuleUuid = 'RATE_LIMIT_RULE_UUID',
  ScheduledNetworkNosUpgradeUuid = 'SCHEDULED_NETWORK_NOS_UPGRADE_UUID',
  SecurityApplianceProfileUuid = 'SECURITY_APPLIANCE_PROFILE_UUID',
  SerialNumber = 'SERIAL_NUMBER',
  SlackAccessTokenUuid = 'SLACK_ACCESS_TOKEN_UUID',
  SpanMirrorSessionUuid = 'SPAN_MIRROR_SESSION_UUID',
  SpeedtestRuleUuid = 'SPEEDTEST_RULE_UUID',
  SsidUuid = 'SSID_UUID',
  StaticRouteUuid = 'STATIC_ROUTE_UUID',
  SupportCaseAttachmentUuid = 'SUPPORT_CASE_ATTACHMENT_UUID',
  SupportCaseUuid = 'SUPPORT_CASE_UUID',
  SupportProviderUuid = 'SUPPORT_PROVIDER_UUID',
  SwitchAutoConfigMacAddressVlanBindingUuid = 'SWITCH_AUTO_CONFIG_MAC_ADDRESS_VLAN_BINDING_UUID',
  SwitchProfileUuid = 'SWITCH_PROFILE_UUID',
  TopologyDesignLinkUuid = 'TOPOLOGY_DESIGN_LINK_UUID',
  TopologyDesignNodeUuid = 'TOPOLOGY_DESIGN_NODE_UUID',
  TopologyDesignVersionUuid = 'TOPOLOGY_DESIGN_VERSION_UUID',
  Unknown = 'UNKNOWN',
  VirtualDeviceTagUuid = 'VIRTUAL_DEVICE_TAG_UUID',
  VirtualDeviceUuid = 'VIRTUAL_DEVICE_UUID',
  VlanUuid = 'VLAN_UUID',
  WifiIpskUuid = 'WIFI_IPSK_UUID'
}

/** A pair of firewall devices that are physically attached. This is deprecated, use `HardwareDevicePair` instead. */
export type SecurityApplianceDevicePair = {
  __typename?: 'SecurityApplianceDevicePair';
  /** The unique identifier for the firewall pair. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the firewall device pair was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Firewall device on the left side of the box. */
  leftDevice: HardwareDevice;
  /** Firewall device on the right side of the box. */
  rightDevice: HardwareDevice;
};

/** A security appliance profile is a bundle of settings that applies to a firewall device. */
export type SecurityApplianceProfile = Identifiable & {
  __typename?: 'SecurityApplianceProfile';
  /** Unique identifier of the security appliance profile. */
  UUID: Scalars['UUID']['output'];
  /** Timestamp when the profile was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Disables client stat hostname collection. */
  disableClientStatsHostnames: Scalars['Boolean']['output'];
  /** The number of seconds between host monitoring pings. */
  hostMonitoringIntervalSec: Scalars['Int']['output'];
  /** The number of seconds to wait before timing out a host monitoring ping. */
  hostMonitoringTimeoutSec: Scalars['Int']['output'];
  /** The L3 configuration for this security appliance profile, including routing layer and underlay address. */
  l3Configuration: L3Configuration;
  /** The algorithm used to manage multiple WAN connections, such as load balancing or failover strategies. */
  multiWANAlgorithm: MultiWanAlgorithm;
  /** The number of seconds to wait before another failover can occur after a recent one. */
  multiWANUpdateCooldownSec?: Maybe<Scalars['Int']['output']>;
  /** Number of previous ping results to consider for the failover calculation. */
  multiWANUpdateLookback: Scalars['Int']['output'];
  /**
   * The minimum success ratio to consider a WAN link as good.
   * If it drops below the threshold, a failover occurs.
   * Stored as an integer representing the percentage.
   * For example, a value of 65 represents 65%, or a success ratio of 0.65.
   */
  multiWANUpdateThreshold: Scalars['Int']['output'];
  /**
   * If set, all network egress traffic will use this IP address for Network Address Translation.
   *
   * Conditions for usage:
   * - BGP-over-WAN must be enabled and configured
   * - This IP must belong to a prefix we advertise over WAN
   * - There must be at least one WAN interface with a static IP (ideally all are static)
   */
  natPublicIP?: Maybe<Scalars['IP']['output']>;
  /** Configuration settings for policy engine on this device. */
  policyEngineConfiguration: PolicyEngineConfiguration;
  /** Timestamp when the profile was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Select filter implementation. */
export type SelectFilter = {
  /** The key for the filter. */
  key: Scalars['String']['input'];
  /** Selected value for the filter. */
  value: Scalars['String']['input'];
};

/** The team which will complete the service request. */
export enum ServiceRequestCategory {
  /** Deployment engineering */
  DeploymentEngineering = 'DEPLOYMENT_ENGINEERING',
  /** Partner operations */
  PartnerOperations = 'PARTNER_OPERATIONS',
  /** Technician operations */
  TechnicianOperations = 'TECHNICIAN_OPERATIONS'
}

/** Describes an available service request type, including its required input fields in order to generate a dynamic form. */
export type ServiceRequestDefinition = {
  __typename?: 'ServiceRequestDefinition';
  /** The department responsible for this service request's tasks */
  assignedDepartment?: Maybe<SupportUserDepartment>;
  /** Category for grouping in the UI */
  category: ServiceRequestCategory;
  /** Default SLA in seconds, used when the caller omits slaSeconds on createServiceRequest. */
  defaultSLASeconds: Scalars['Int']['output'];
  /**
   * The deliverable created for this service request on the queried deployment
   * job, or null if it has not been requested there.
   */
  deliverable?: Maybe<Deliverable>;
  /** Description of what this service request does */
  description: Scalars['String']['output'];
  /** The input fields required for this service request */
  fields: Array<ServiceRequestFieldDefinition>;
  /** Whether this service request is currently actionable */
  isActive: Scalars['Boolean']['output'];
  /** Whether a deployment can declare this deliverable unnecessary instead of requesting the work. Skippable deliverables accept `skip` on createServiceRequest. */
  isSkippable: Scalars['Boolean']['output'];
  /** Human-readable label */
  label: Scalars['String']['output'];
  /** The task types of the root tasks that this service request creates. */
  rootTaskTypes: Array<DeploymentTaskType>;
  /** Distinct task types created by this service request, including child and optional tasks. */
  taskTypes: Array<DeploymentTaskType>;
  /** The type identifier for this service request */
  type: ServiceRequestType;
};


/** Describes an available service request type, including its required input fields in order to generate a dynamic form. */
export type ServiceRequestDefinitionDeliverableArgs = {
  includeCancelled?: Scalars['Boolean']['input'];
};

/** Describes a single input field for a service request. */
export type ServiceRequestFieldDefinition = {
  __typename?: 'ServiceRequestFieldDefinition';
  /** Whether this is a secondary field not relevant to most networks. Advanced fields are never required. */
  advanced: Scalars['Boolean']['output'];
  /** Optional description or help text */
  description?: Maybe<Scalars['String']['output']>;
  /** For DOCUMENT_UPLOAD fields, the expected document type */
  documentType?: Maybe<DocumentUploadDeploymentJobDocumentType>;
  /** The data type of this field */
  fieldType: ServiceRequestFieldType;
  /** Unique key for this field, used in field inputs */
  key: Scalars['String']['output'];
  /** Options for SELECT type fields */
  options?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether this field is required */
  required: Scalars['Boolean']['output'];
  /** The key of a BOOLEAN field in the same service request. This field is required when that field is true, and should be hidden when it is false. */
  requiredIfFieldKey?: Maybe<Scalars['String']['output']>;
};

/**
 * A single field value provided when creating a service request.
 * Exactly one of the value fields should be set, matching the field's type.
 */
export type ServiceRequestFieldInput = {
  /** Value for BOOLEAN fields */
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Value for DATE or DATETIME fields */
  dateValue?: InputMaybe<Scalars['DateTime']['input']>;
  /** Value for USER fields (user ID) */
  intValue?: InputMaybe<Scalars['Int']['input']>;
  /** The key of the field (must match a key from the definition) */
  key: Scalars['String']['input'];
  /** Value for STRING, TEXT, URL, FILE, or SELECT fields */
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

/** The data type of a field in a service request definition. */
export enum ServiceRequestFieldType {
  /** Boolean toggle */
  Boolean = 'BOOLEAN',
  /** Date picker (date only) */
  Date = 'DATE',
  /** Date and time picker */
  Datetime = 'DATETIME',
  /** Reference to an existing DocumentUpload by UUID. The upload's deploymentJobDocumentType must match the field definition's documentType. */
  DocumentUpload = 'DOCUMENT_UPLOAD',
  /** Numeric input */
  Number = 'NUMBER',
  /** Dropdown select */
  Select = 'SELECT',
  /** Text input */
  String = 'STRING',
  /** Reference to an existing TopologyDesignVersion by UUID */
  TopologyDesignVersion = 'TOPOLOGY_DESIGN_VERSION',
  /** User picker */
  User = 'USER'
}

/**
 * An existing field value for a service request form, sourced from the network's
 * metadata or the deployment job. The value fields mirror `ServiceRequestFieldInput`
 * — exactly one will be set, matching the field's type.
 */
export type ServiceRequestFieldValue = {
  __typename?: 'ServiceRequestFieldValue';
  /** Value for BOOLEAN fields. */
  boolValue?: Maybe<Scalars['Boolean']['output']>;
  /** Value for DATE/DATETIME fields. */
  dateValue?: Maybe<Scalars['DateTime']['output']>;
  /** Value for USER/NUMBER fields. */
  intValue?: Maybe<Scalars['Int']['output']>;
  /** The field key this value applies to (matches a key from the definition). */
  key: Scalars['String']['output'];
  /** When the underlying value was last written. */
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Value for STRING/SELECT fields. */
  stringValue?: Maybe<Scalars['String']['output']>;
};

/**
 * Existing field values for a single service request type, used to prepopulate
 * that type's form. One entry exists per service request type; `values` may be
 * empty if no fields can be prepopulated for the type.
 */
export type ServiceRequestFieldValues = {
  __typename?: 'ServiceRequestFieldValues';
  /** The service request type these values apply to. */
  type: ServiceRequestType;
  /** Existing values keyed by the field definition's key. */
  values: Array<ServiceRequestFieldValue>;
};

/**
 * The evaluated state of a single prerequisite for a service request. This is a
 * fact outside of the service request itself, for example the presence of a floor
 * plan, that must be true for the service request to be submittable.
 */
export type ServiceRequestPrerequisiteState = {
  __typename?: 'ServiceRequestPrerequisiteState';
  /** Human-readable description of what the prerequisite requires. */
  description: Scalars['String']['output'];
  /** Stable identifier for this prerequisite — the frontend can map it to a remediation flow. */
  key: Scalars['String']['output'];
  /** Whether the prerequisite is currently met. */
  satisfied: Scalars['Boolean']['output'];
};

/**
 * Whether the service request prerequisites, other things in the job that must be true, are satisfied.
 * Used to gate service request submission on actions outside the service request.
 */
export type ServiceRequestPrerequisiteStates = {
  __typename?: 'ServiceRequestPrerequisiteStates';
  /** Prerequisite states for this service request type. */
  states: Array<ServiceRequestPrerequisiteState>;
  /** The service request type these prerequisites apply to. */
  type: ServiceRequestType;
};

/** The list of service requests types available for requesting. */
export enum ServiceRequestType {
  /** Generate a certificate of insurance */
  CoiGeneration = 'COI_GENERATION',
  /** Request a network configuration */
  FirewallConfiguration = 'FIREWALL_CONFIGURATION',
  /** Schedule an installer for a deployment */
  InstallerScheduling = 'INSTALLER_SCHEDULING',
  /** Close out an installation */
  InstallCloseout = 'INSTALL_CLOSEOUT',
  /** Prepare for an installation */
  InstallPrep = 'INSTALL_PREP',
  /** Coordinate ISP circuit delivery and activation */
  IspCircuitCoordination = 'ISP_CIRCUIT_COORDINATION',
  /** Provide live support during an installation */
  LiveInstallSupport = 'LIVE_INSTALL_SUPPORT',
  /** Validate the network after installation */
  NetworkValidation = 'NETWORK_VALIDATION',
  /** Schedule a site walk with the customer */
  SiteWalkSchedule = 'SITE_WALK_SCHEDULE',
  /** Request a wired design for a network */
  WiredDesign = 'WIRED_DESIGN',
  /** Request a wireless design for a network */
  WirelessDesign = 'WIRELESS_DESIGN'
}

/** Enumeration of service types that can be discovered on the network. */
export enum ServiceType {
  /** AirPlay service (e.g., Apple devices that support media streaming). */
  Airplay = 'AIRPLAY',
  /** Printer service that is discoverable on the network. */
  Printer = 'PRINTER',
  /** Speaker service (e.g., network-connected audio devices). */
  Speaker = 'SPEAKER',
  /** Service type is unknown or not specified. */
  Unknown = 'UNKNOWN'
}

/** Session token represents an authentication token that can be used to authenticate client requests. */
export type SessionToken = {
  __typename?: 'SessionToken';
  /** The authentication token associated with the session. */
  token: Scalars['String']['output'];
};

/** Input type for setting a payment resource's temporary spend limit. */
export type SetInternetServicePlanPaymentResourceTemporaryLimitInput = {
  /** The overriding spend limit, in cents. */
  amountCents: Scalars['Int']['input'];
  /** When the limit should stop being in effect. Defaults to the end of the current month. */
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** UUID of the payment resource to set a temporary limit on. */
  paymentResourceUUID: Scalars['UUID']['input'];
};

export type SetIspVlaNsInput = {
  /**
   * The VLAN ID for the ISP A ports. Left unchanged if omitted or null.
   * This is the VLAN ID of the downstream uplink VLAN for the first ISP connection.
   */
  ispAVLANID?: InputMaybe<Scalars['Int']['input']>;
  /** The VLAN ID for the ISP B ports. Left unchanged if omitted or null. */
  ispBVLANID?: InputMaybe<Scalars['Int']['input']>;
  /**
   * If true, resets both VLAN IDs to their defaults (4000 for A, 4001 for B). Ignored if omitted, null or false.
   * Cannot be combined with ispAVLANID or ispBVLANID.
   */
  resetToDefaults?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetNacCredentialPasswordInput = {
  /** The password the user is setting. */
  password: Scalars['String']['input'];
  /** The password token that was emailed to the user. */
  token: Scalars['String']['input'];
};

/** Input for setting the NOS version for a network, which will apply the specified NOS version to all devices in the network. */
export type SetNetworkNosVersionInput = {
  /** Required when downgrading an external/customer network. Captures the reason for the version change. */
  changeReason?: InputMaybe<NosVersionChangeReasonInput>;
  /** If true, forces the NOS version change to happen immediately. Equivalent to setting `scheduledAt` to the current time. */
  force?: Scalars['Boolean']['input'];
  /** The unique identifier of the NOS version to apply to the network. */
  nosId: Scalars['Int']['input'];
  /** The NOS version change will be scheduled at the given timestamp if specified; if not specified, it will be scheduled at the next maintenance window. */
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The scheduler to use for the setting the scheduled time */
  scheduler?: InputMaybe<SchedulerInput>;
  /** The interval in minutes to stagger the upgrades across devices within the network to prevent simultaneous upgrades. */
  staggeredUpgradeIntervalMin?: Scalars['Int']['input'];
};

export type SetPolicyRoutingRuleBindingsInput = {
  /** The list of bindings to associate with the policy routing rule. */
  bindings: Array<PolicyRoutingRuleBindingInput>;
};

/** Specifies a virtual device's target hardware assignment when shuffling hardware between virtual devices. */
export type ShuffleHardwareDeviceAssignmentInput = {
  /**
   * The serial number of the hardware device to assign to this virtual device.
   * If null, the virtual device will end up unassigned. The hardware referenced by any
   * non-null serial number must currently be assigned to one of the virtual devices
   * included in the same mutation input.
   */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the virtual device whose hardware assignment should be updated. */
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** A signed response to a console login challenge, including the signature, algorithm, and key ID used for verification. */
export type SignedConsoleLoginChallenge = {
  __typename?: 'SignedConsoleLoginChallenge';
  /** Algorithm used to encode the payload. */
  algorithm: Scalars['String']['output'];
  /**
   * Key ID of the KMS key used to sign the challenge. This can be used to ensure
   * that the challenge was signed by the correct key.
   */
  keyID: Scalars['String']['output'];
  /**
   * The signature over the plain text response.
   * This is a base64 encoded string with the following JSON Object:
   * - a PSS SHA 256 signed JSON payload.
   * - A JSON encoded string with the following keys:
   *     - challenge: the original challenge
   *     - serialNumber: the serial number of the device to sign the challenge for
   *     - user: the user that signed the challenge
   * - To decode and verify the signature, use the following algorithms:
   *     - Base64 decode the response
   *     - Decode the JSON payload
   *     - Verify the PSS SHA 256 signature over the decoded JSON payload
   */
  response: Scalars['String']['output'];
};

/** A signed response to a local config access challenge, including the signature, algorithm, and key ID used for verification. */
export type SignedLocalConfigAccessChallenge = {
  __typename?: 'SignedLocalConfigAccessChallenge';
  /** Algorithm used to encode the payload. */
  algorithm: Scalars['String']['output'];
  /**
   * Key ID of the KMS key used to sign the challenge. This can be used to ensure
   * that the challenge was signed by the correct key.
   */
  keyID: Scalars['String']['output'];
  /**
   * The signature over the plain text response.
   * This is a base64 encoded string with the following JSON Object:
   * - a PSS SHA 256 signed JSON payload.
   * - A JSON encoded string with the following keys:
   * - challenge: the original challenge
   * - serialNumber: the serial number of the device to sign the challenge for
   * - user: the user that signed the challenge
   * - To decode and verify the signature, use the following algorithms:
   * - Base64 decode the response
   * - Decode the JSON payload
   * - Verify the PSS SHA 256 signature over the decoded JSON payload
   */
  response: Scalars['String']['output'];
};

/** Input for skipping a service request rather than requesting the work. */
export type SkipServiceRequestInput = {
  /** Why this deployment doesn't need the deliverable. Recorded on the deliverable. */
  reason: Scalars['String']['input'];
};

/** Slack access tokens for sending alerts to Slack. We do NOT expose the actual access token, only the metadata. */
export type SlackAccessToken = Identifiable & {
  __typename?: 'SlackAccessToken';
  /** The unique identifier of the Slack access token. */
  UUID: Scalars['UUID']['output'];
  /** The UUID of the company that owns the Slack access token. */
  companyUUID: Scalars['UUID']['output'];
  /** The timestamp when the Slack access token was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The timestamp when the Slack access token was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The unique identifier of the Slack access token.
   * @deprecated Use `UUID` instead.
   */
  uuid: Scalars['UUID']['output'];
};

/** Input type snooze time window. */
export type SnoozeNotificationSettingWindowInput = {
  /** When the snooze expires. */
  end: Scalars['DateTime']['input'];
  /** When the snooze becomes active. */
  start: Scalars['DateTime']['input'];
};

export enum SortOrder {
  /** Ascending sort order. */
  Ascending = 'ASCENDING',
  /** Descending sort order. */
  Descending = 'DESCENDING'
}

/** A field that results can be sorted by. */
export type SortOrderDefinition = {
  __typename?: 'SortOrderDefinition';
  /** Displayable name of the sort field. */
  name: Scalars['String']['output'];
  /** Value to pass as `fieldName` to sort by this field. */
  value: Scalars['String']['output'];
};

/** Sort order to apply to a list of results. */
export type SortOrderInput = {
  /** Field to sort by. */
  fieldName: Scalars['String']['input'];
  /** Order of the sort. */
  order: SortOrder;
};

/**
 * Represents a speedtest rule which is used to determine if a
 * job should be run by the river periodic job that executes
 * recurring speedtests
 */
export type SpeedtestRule = Identifiable & {
  __typename?: 'SpeedtestRule';
  /** UUID of the rule */
  UUID: Scalars['UUID']['output'];
  /** UUID of the company the rule is targeting */
  companyUUID: Scalars['UUID']['output'];
  /** Frequency to run the test */
  frequency: SpeedtestRuleFrequency;
  /** If the rule is enabled */
  isEnabled: Scalars['Boolean']['output'];
  /** Max number of bytes transfered by jobs started by this rule */
  maxTransferBytes: Scalars['Uint32']['output'];
  /** Network rule is targeting, if set */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** Phy Interface rule is targeting, if set */
  phyInterfaceUUID?: Maybe<Scalars['UUID']['output']>;
  /** Scheduled day of the week to run the rule on */
  scheduledDayOfWeekLocal?: Maybe<Scalars['Int']['output']>;
  /** Scheduled hour of the day to run the rule at */
  scheduledHourLocal: Scalars['Int']['output'];
  /** Type of speedtest rule being created */
  type: SpeedtestRuleType;
};

export enum SpeedtestRuleFrequency {
  /** Daily frequency for running speedtest */
  Daily = 'DAILY',
  /** Weekly frequency for running speedtest */
  Weekly = 'WEEKLY'
}

export enum SpeedtestRuleType {
  /** The value for a company speedtest rule */
  CompanyRule = 'COMPANY_RULE',
  /** The value for a network speedtest rule */
  NetworkRule = 'NETWORK_RULE',
  /** The value for a phy interface speedtest rule */
  PhyInterfaceRule = 'PHY_INTERFACE_RULE'
}

/** Represents a speedtest server. */
export type SpeedtestServer = {
  __typename?: 'SpeedtestServer';
  /** The distance to the server from the client. */
  distance: Scalars['Int']['output'];
  /** The hostname of the server. */
  host: Scalars['String']['output'];
  /** The identifier of the server. */
  id: Scalars['String']['output'];
  /** The latitude of the server location. */
  lat: Scalars['String']['output'];
  /** The longitude of the server location. */
  lon: Scalars['String']['output'];
  /** The name of the server. */
  name: Scalars['String']['output'];
};

/** Input parameters for starting a client ping sweep job. */
export type StartClientPingSweepJobInput = {
  /** Number of ICMP echoes to send to each client (reachable if any reply). */
  pingsPerClient?: Scalars['Int']['input'];
  /** Sweeps the clients connected to these SSIDs. At least one is required. */
  ssidUUIDs: Array<Scalars['UUID']['input']>;
  /**
   * How long a device spends on one client, covering all of its echoes rather
   * than each one. The echoes are spaced out so this has to be long enough to
   * send them all
   */
  timeoutSeconds?: Scalars['Int']['input'];
};

/** Input parameters for starting a WAN speed test job. */
export type StartWanSpeedtestJobInput = {
  /** The base URL used for downloading/uploading during the speed test. Defaults to 'https://speed.cloudflare.com'. */
  baseURL?: Scalars['String']['input'];
  /** The maximum number of bytes to transfer during the speed test. Must be greater than or equal to 100,000. */
  maxTransferBytes?: InputMaybe<Scalars['Int']['input']>;
  /** The UUID of the physical interface on which to perform the speed test. Either phyInterfaceUUID or virtualDeviceUUID must be provided. */
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The UUID of the virtual device on which to perform the speed test. Either phyInterfaceUUID or virtualDeviceUUID must be provided. */
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents the result of starting a WAN speedtest. */
export type StartWanSpeedtestJobResponse = {
  __typename?: 'StartWANSpeedtestJobResponse';
  /** Job that started or should be joined depending on status */
  job: WanSpeedtestJob;
  /** Indicates whether the test failed. */
  status: StartWanSpeedtestStatus;
};

/** Represents the status of starting a WAN speedtest */
export enum StartWanSpeedtestStatus {
  /** Joined an ongoing test. */
  Join = 'JOIN',
  /** Started a new test. */
  Start = 'START'
}

/** Input parameters for starting a wireless calibration job. */
export type StartWirelessCalibrationJobInput = {
  /** The band to calibrate on. */
  band?: InputMaybe<RadioBand>;
  /** The channel information to set all the APs on for a calibration job. */
  channel: Scalars['Int']['input'];
  /** Ignored. The default wait is used unless configAckBroadcastWaitMinutes is set. For backend-driven wireless calibration only. */
  configAckBroadcastWait?: InputMaybe<Scalars['Duration']['input']>;
  /** The amount of time to wait in minutes for the APs to acknowledge the config changes. For backend-driven wireless calibration only. */
  configAckBroadcastWaitMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** The power level to set all the APs at for a calibration job. */
  power: Scalars['Int']['input'];
  /** Ignored. The default wait is used unless scanStatsWaitMinutes is set. For backend-driven wireless calibration only. */
  scanStatsWait?: InputMaybe<Scalars['Duration']['input']>;
  /** The amount of time to wait in minutes for the APs to send scan stats. For backend-driven wireless calibration only. */
  scanStatsWaitMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** The scheduler to use for the setting the scheduled time. */
  scheduler?: InputMaybe<SchedulerInput>;
  /** If provided, only calibrate APs that have at least one of the specified tags. Only applies to backend-driven wireless calibration. */
  virtualDeviceTagUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Represents a statistical measurement of a device. */
export type Stat = {
  __typename?: 'Stat';
  /** The timestamp when the stat was inserted into the database. */
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier of the network the device belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The timestamp when the stat was observed by the device. */
  observedAt: Scalars['DateTime']['output'];
  /** The raw JSON data of the stat, contents depend on the type. */
  rawData: Scalars['JSONObject']['output'];
  /** The type of the stat, indicating what data is contained in rawData. */
  type: StatType;
  /** The virtual device that reported the stat. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The unique identifier of the virtual device that reported the stat. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

export type StatInjectionDuration = {
  /** The end time for fake stats injection. */
  endTime: Scalars['DateTime']['input'];
  /** The start time for fake stats injection. */
  startTime: Scalars['DateTime']['input'];
};

export enum StatType {
  Anomaly = 'ANOMALY',
  ArpTable = 'ARP_TABLE',
  BgpRouteStats = 'BGP_ROUTE_STATS',
  CellularBootInfo = 'CELLULAR_BOOT_INFO',
  CellularStatus = 'CELLULAR_STATUS',
  ClientLatency = 'CLIENT_LATENCY',
  ConfigMismatchInfo = 'CONFIG_MISMATCH_INFO',
  ConfigVersionInfo = 'CONFIG_VERSION_INFO',
  ConnectedClients = 'CONNECTED_CLIENTS',
  CoredumpEvent = 'COREDUMP_EVENT',
  CosCapoAuthEvent = 'COS_CAPO_AUTH_EVENT',
  CosCapoRedirectEvent = 'COS_CAPO_REDIRECT_EVENT',
  CosCapoRevokeEvent = 'COS_CAPO_REVOKE_EVENT',
  CosClients = 'COS_CLIENTS',
  CosDataplaneBuffers = 'COS_DATAPLANE_BUFFERS',
  CosDataplaneMemory = 'COS_DATAPLANE_MEMORY',
  CosDhcpServerInfo = 'COS_DHCP_SERVER_INFO',
  CosDnsBlockedEvent = 'COS_DNS_BLOCKED_EVENT',
  CosDnsInfo = 'COS_DNS_INFO',
  CosFirewallCounters = 'COS_FIREWALL_COUNTERS',
  CosFqdnResolution = 'COS_FQDN_RESOLUTION',
  CosGatewayPortInfo = 'COS_GATEWAY_PORT_INFO',
  CosHaEvent = 'COS_HA_EVENT',
  CosHostMonitoringEvent = 'COS_HOST_MONITORING_EVENT',
  CosIpsecTunnels = 'COS_IPSEC_TUNNELS',
  CosIpsActiveAcls = 'COS_IPS_ACTIVE_ACLS',
  CosIpsControlStatus = 'COS_IPS_CONTROL_STATUS',
  CosIpsEvent = 'COS_IPS_EVENT',
  CosLteFailoverEvent = 'COS_LTE_FAILOVER_EVENT',
  CosMacTableEvent = 'COS_MAC_TABLE_EVENT',
  CosMultiwanEvent = 'COS_MULTIWAN_EVENT',
  CosNetworks = 'COS_NETWORKS',
  CosPengCounters = 'COS_PENG_COUNTERS',
  CosPolicyStateEvent = 'COS_POLICY_STATE_EVENT',
  CosUsbPortEvent = 'COS_USB_PORT_EVENT',
  CosWanSpeedTestResult = 'COS_WAN_SPEED_TEST_RESULT',
  DhcpPacket = 'DHCP_PACKET',
  DhcpSnoopInfo = 'DHCP_SNOOP_INFO',
  DynamicRoutingState = 'DYNAMIC_ROUTING_STATE',
  DynamicRoutingTable = 'DYNAMIC_ROUTING_TABLE',
  DynamicRoutingTableV6 = 'DYNAMIC_ROUTING_TABLE_V6',
  FlowRecords = 'FLOW_RECORDS',
  GosCellularBootInfo = 'GOS_CELLULAR_BOOT_INFO',
  GosCellularInfo = 'GOS_CELLULAR_INFO',
  Heartbeat = 'HEARTBEAT',
  HostPing = 'HOST_PING',
  HostResults = 'HOST_RESULTS',
  HostTraceroute = 'HOST_TRACEROUTE',
  Ipv6WanEvent = 'IPV6_WAN_EVENT',
  LagEvent = 'LAG_EVENT',
  LagStatus = 'LAG_STATUS',
  LldpTable = 'LLDP_TABLE',
  LogshipperInfo = 'LOGSHIPPER_INFO',
  MacTable = 'MAC_TABLE',
  MacTableFlushEvent = 'MAC_TABLE_FLUSH_EVENT',
  MdnsServiceDiscoveryEvent = 'MDNS_SERVICE_DISCOVERY_EVENT',
  MulticastDnsInfo = 'MULTICAST_DNS_INFO',
  PacketCapture = 'PACKET_CAPTURE',
  PacketCaptureStatus = 'PACKET_CAPTURE_STATUS',
  PduMeterBootInfo = 'PDU_METER_BOOT_INFO',
  PduMeterInfo = 'PDU_METER_INFO',
  PduOutletAutoCycleEvent = 'PDU_OUTLET_AUTO_CYCLE_EVENT',
  PduOutletEvent = 'PDU_OUTLET_EVENT',
  PduStatusInfo = 'PDU_STATUS_INFO',
  PoeInfo = 'POE_INFO',
  PortEvent = 'PORT_EVENT',
  PortInfo = 'PORT_INFO',
  PowerInfo = 'POWER_INFO',
  PseBootInfo = 'PSE_BOOT_INFO',
  PseInfo = 'PSE_INFO',
  RadiusPollerResult = 'RADIUS_POLLER_RESULT',
  SecureAddressingAndMessagingSystemInfo = 'SECURE_ADDRESSING_AND_MESSAGING_SYSTEM_INFO',
  SfpPortsInfo = 'SFP_PORTS_INFO',
  SfpPortLoopbackInfo = 'SFP_PORT_LOOPBACK_INFO',
  Sos_8021XAuthenticatedHosts = 'SOS_8021X_AUTHENTICATED_HOSTS',
  Sos_8021XPortStatus = 'SOS_8021X_PORT_STATUS',
  SosAvailableResources = 'SOS_AVAILABLE_RESOURCES',
  SosFlapLinkStatus = 'SOS_FLAP_LINK_STATUS',
  SosIgmpSnoopingStatus = 'SOS_IGMP_SNOOPING_STATUS',
  SosMacMoveEvent = 'SOS_MAC_MOVE_EVENT',
  /** @deprecated Use `MAC_TABLE` instead. */
  SosMacTable = 'SOS_MAC_TABLE',
  SosMldSnoopingStatus = 'SOS_MLD_SNOOPING_STATUS',
  SosPoeInfo = 'SOS_POE_INFO',
  SosPortCounters = 'SOS_PORT_COUNTERS',
  SosPortEvent = 'SOS_PORT_EVENT',
  SosPortLoopbackInfo = 'SOS_PORT_LOOPBACK_INFO',
  SosPortSecurityMacTable = 'SOS_PORT_SECURITY_MAC_TABLE',
  SosPortSecurityPortStatus = 'SOS_PORT_SECURITY_PORT_STATUS',
  SosPortSecurityViolationEvent = 'SOS_PORT_SECURITY_VIOLATION_EVENT',
  SosStpInfo = 'SOS_STP_INFO',
  StatForwarderInfo = 'STAT_FORWARDER_INFO',
  StpLagEvent = 'STP_LAG_EVENT',
  StpPortEvent = 'STP_PORT_EVENT',
  SystemInfo = 'SYSTEM_INFO',
  Unspecified = 'UNSPECIFIED',
  UpgradeCacheState = 'UPGRADE_CACHE_STATE',
  UpgradeStatus = 'UPGRADE_STATUS',
  UplinkInfo = 'UPLINK_INFO',
  UplinkObservedExternalAddress = 'UPLINK_OBSERVED_EXTERNAL_ADDRESS',
  VrrpInfo = 'VRRP_INFO',
  WireguardPeerEvent = 'WIREGUARD_PEER_EVENT',
  WireguardTunnelInfo = 'WIREGUARD_TUNNEL_INFO',
  WosAcsResult = 'WOS_ACS_RESULT',
  WosApRadiusPollerResult = 'WOS_AP_RADIUS_POLLER_RESULT',
  WosAutoTransmitPowerSelectionJobChannelResetFailureInfo = 'WOS_AUTO_TRANSMIT_POWER_SELECTION_JOB_CHANNEL_RESET_FAILURE_INFO',
  WosAutoTransmitPowerSelectJobResults = 'WOS_AUTO_TRANSMIT_POWER_SELECT_JOB_RESULTS',
  WosCalibrationStatusInfo = 'WOS_CALIBRATION_STATUS_INFO',
  WosCfrObservations = 'WOS_CFR_OBSERVATIONS',
  WosClientMoved = 'WOS_CLIENT_MOVED',
  WosClientTable = 'WOS_CLIENT_TABLE',
  WosConnectionEvent = 'WOS_CONNECTION_EVENT',
  WosEthStats = 'WOS_ETH_STATS',
  WosEvent = 'WOS_EVENT',
  WosObserverResult = 'WOS_OBSERVER_RESULT',
  WosObssStats = 'WOS_OBSS_STATS',
  WosPingTable = 'WOS_PING_TABLE',
  WosProbeMonitor = 'WOS_PROBE_MONITOR',
  WosRfStats = 'WOS_RF_STATS',
  WosScanRadioUtilInfo = 'WOS_SCAN_RADIO_UTIL_INFO',
  WosScanTable = 'WOS_SCAN_TABLE'
}

/** A manually defined static route. */
export type StaticRoute = Identifiable & {
  __typename?: 'StaticRoute';
  /** Unique identifier of the static route. */
  UUID: Scalars['UUID']['output'];
  /**
   * VLANs bound (implicitly or explicitly) to this static route.
   * Currently only populated if this is a default route (0.0.0.0/0 destination prefix).
   */
  boundVLANs?: Maybe<Array<Vlan>>;
  /** Timestamp when the static route was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Destination IP prefix for the static route. */
  dstPrefix: Scalars['IPPrefix']['output'];
  /**
   * VLANs excluded from this static route.
   * Currently only populated if this is a default route (0.0.0.0/0 destination prefix).
   * Only one of `explicitlyBoundVLANs` and `excludedVLANs` can be non-null and non-empty.
   */
  excludedVLANs?: Maybe<Array<Vlan>>;
  /**
   * VLANs explicitly bound to this static route.
   * Currently only populated if this is a default route (0.0.0.0/0 destination prefix).
   * Only one of `explicitlyBoundVLANs` and `excludedVLANs` can be non-null and non-empty.
   */
  explicitlyBoundVLANs?: Maybe<Array<Vlan>>;
  /** DHCP Static Mapping used as gateway for the static route. */
  gatewayDHCPStaticMapping?: Maybe<DhcpStaticMapping>;
  /** Gateway IP address for the static route. */
  gatewayIP?: Maybe<Scalars['IPV4']['output']>;
  /** VLAN used as gateway for the static route. */
  gatewayVLAN?: Maybe<Vlan>;
  /** Indicates whether the static route is enabled. */
  isEnabled: Scalars['Boolean']['output'];
  /** Name of the static route. */
  name: Scalars['String']['output'];
  /** The network to which the static route belongs. */
  network: Network;
  /** UUID of the network to which the static route belongs. */
  networkUUID: Scalars['UUID']['output'];
  /** Timestamp when the static route was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type StatsFilter = {
  /** The lookback time to consider stats for, starting at `endTime`. Maximum allowed value is 86400, one day. */
  durationSeconds: Scalars['Int']['input'];
  /** The latest observation time to consider stats for, inclusive. Defaults to the current time if not set. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The maximum number of results to return, between 1 and 1000. Defaults to 100 if not set. */
  limit?: Scalars['Int']['input'];
  /** The number of results to skip before returning results. Defaults to 0 if not set. */
  offset?: Scalars['Int']['input'];
  /** The list of stat types to return. */
  types: Array<StatType>;
};

/** A paged response for stats. */
export type StatsPage = {
  __typename?: 'StatsPage';
  /** A subset of total stats based on the limit and offset of the query. */
  stats: Array<Stat>;
  /** The total number of stats. */
  total: Scalars['Int']['output'];
};

/** The root subscription type of the GraphQL schema */
export type Subscription = {
  __typename?: 'Subscription';
  /** Fires when a network in the company has a CRUD event. */
  networkEvent: NetworkEvent;
  /** Fires when a physical interface in the company has a CRUD event. */
  phyInterfaceEvent: PhyInterfaceEvent;
  /** Fires when a virtual device in the company has a CRUD event. */
  virtualDeviceEvent: VirtualDeviceEvent;
};


/** The root subscription type of the GraphQL schema */
export type SubscriptionNetworkEventArgs = {
  companySlug: Scalars['String']['input'];
};


/** The root subscription type of the GraphQL schema */
export type SubscriptionPhyInterfaceEventArgs = {
  companySlug: Scalars['String']['input'];
};


/** The root subscription type of the GraphQL schema */
export type SubscriptionVirtualDeviceEventArgs = {
  companySlug: Scalars['String']['input'];
};

/** Represents the status of a SIM from Kore. */
export type SuperSim = {
  __typename?: 'SuperSIM';
  /** The account SID associated with the Super SIM. */
  accountSID?: Maybe<Scalars['String']['output']>;
  /** The date and time when the SIM was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Information about the fleet resource. */
  fleet?: Maybe<SimFleet>;
  /**
   * The name of the fleet to which the SIM belongs.
   * @deprecated Use `fleet.name` instead, this will always be null.
   */
  fleetName?: Maybe<Scalars['String']['output']>;
  /**
   * The URL of the fleet resource in Kore.
   * @deprecated Use `fleet.url` instead, this will always be null.
   */
  fleetURL?: Maybe<Scalars['String']['output']>;
  /** The Integrated Circuit Card Identifier (ICCID) of the SIM. */
  iccid?: Maybe<Scalars['String']['output']>;
  /** The unique SID (identifier) for the Super SIM resource. */
  sid?: Maybe<Scalars['String']['output']>;
  /** The current activation status of the SIM. */
  status?: Maybe<SimActivationStatus>;
  /** A unique name assigned to the Super SIM. */
  uniqueName?: Maybe<Scalars['String']['output']>;
  /** The date and time when the SIM was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The URL of the SIM resource in Kore. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Represents the support case. */
export type SupportCase = {
  __typename?: 'SupportCase';
  /** The unique identifier for the support case. */
  UUID: Scalars['UUID']['output'];
  /** The contact the case is assigned to. */
  assignedTo?: Maybe<SupportCaseContact>;
  /**
   * The person the case is assigned to.
   * @deprecated Use `assignedTo` instead.
   */
  assignee?: Maybe<Scalars['String']['output']>;
  /**
   * The person the case is assigned email to.
   * @deprecated Use `assignedTo` instead.
   */
  assigneeEmail?: Maybe<Scalars['String']['output']>;
  /** The close code for the support case. */
  closeCode?: Maybe<SupportCaseCloseCode>;
  /** The closing notes for the support case. */
  closeNotes?: Maybe<Scalars['String']['output']>;
  /**
   * The collaborators on the case.
   * @deprecated Use `contacts` instead.
   */
  collaborators?: Maybe<Array<Scalars['String']['output']>>;
  /** The comment feed of the support case. */
  commentFeed: Array<SupportCaseCommentFeedEntry>;
  /**
   * The comments on the support case.
   * @deprecated Use `commentFeed` instead.
   */
  comments: Array<SupportCaseComment>;
  /** The company for the support case. */
  company: Company;
  /** The contacts for a case. */
  contacts: Array<SupportCaseContact>;
  /** The timestamp when the case was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The customer that submitted the case (e.g., the user that created the case). */
  customer?: Maybe<SupportCaseContact>;
  /**
   * The email address of the customer that submitted the case.
   * @deprecated Use `creator` instead.
   */
  customerEmail?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the customer that submitted the case.
   * @deprecated Use `creator` instead.
   */
  customerName?: Maybe<Scalars['String']['output']>;
  /** The description of the support case. */
  description: Scalars['String']['output'];
  /**
   * The email of the person that opened the ticket.
   * @deprecated Use `requester` instead.
   */
  email?: Maybe<Scalars['String']['output']>;
  /** The external ID of the support case. */
  externalID?: Maybe<Scalars['String']['output']>;
  /** The inbox message the support case belongs to. */
  inboxMessage: InboxMessage;
  /** If the case was originally submitted by the customer. */
  isCustomerSourced: Scalars['Boolean']['output'];
  /** True when every collaborator on the case has an @meter.com email (or there are none). */
  isInternal: Scalars['Boolean']['output'];
  /** The issue location of the case. */
  issueLocation?: Maybe<Scalars['String']['output']>;
  /** The issue type of the case. */
  issueType: IssueType;
  /** The MAC address of the device in the case. */
  macAddress?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the person who the ticket.
   * @deprecated Use `requester` instead.
   */
  name?: Maybe<Scalars['String']['output']>;
  /** The network for the support case. */
  network?: Maybe<Network>;
  /** The origin of the support case. */
  origin: SupportCaseOrigin;
  /** The parent case if the case was merged. */
  parentSupportCaseUUID?: Maybe<Scalars['UUID']['output']>;
  /** The priority of the support case. */
  priority: SupportCasePriority;
  /** The person the case was opened on behalf of. */
  requester?: Maybe<SupportCaseContact>;
  /** When the case was marked as resolved. */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The person who marked the case as resolved. */
  resolvedBy?: Maybe<SupportCaseContact>;
  /** The Salesforce case ID of the support case. */
  salesforceCaseID?: Maybe<Scalars['String']['output']>;
  /** The Salesforce case number of the support case. */
  salesforceCaseNumber?: Maybe<Scalars['String']['output']>;
  /** The status of the support case. */
  status: SupportCaseStatus;
  /** The subject of the support case. */
  subject: Scalars['String']['output'];
  /** The technology type of the case. */
  technologyType: TechnologyType;
  /** The timestamp when the case was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents a support case attachment. */
export type SupportCaseAttachment = SupportCaseCommentFeedEntry & {
  __typename?: 'SupportCaseAttachment';
  /**
   * URL of the attachment.
   * @deprecated use `contentURL` instead.
   */
  URL: Scalars['String']['output'];
  /** UUID of the attachment. */
  UUID: Scalars['UUID']['output'];
  /** Author of the attachment. */
  author?: Maybe<SupportCaseContact>;
  /**
   * Email of the author that owns the attachment.
   * @deprecated use `author` instead.
   */
  authorEmail?: Maybe<Scalars['String']['output']>;
  /**
   * Name of the author that owns the attachment.
   * @deprecated use `author` instead.
   */
  authorFullName?: Maybe<Scalars['String']['output']>;
  /** Length of the attachment in bytes. */
  bodyLength: Scalars['Int']['output'];
  /**
   * Default content encoding
   * @deprecated Attachments are always stored as binary; this field will always return BINARY.
   */
  contentEncoding: ContentEncoding;
  /** Content type of the attachment. */
  contentType: Scalars['String']['output'];
  /** The content url of the attachment in requested encoding form. */
  contentURL?: Maybe<Scalars['String']['output']>;
  /** Date the attachment was created at. */
  createdAt: Scalars['DateTime']['output'];
  /** External id of the comment. */
  externalID?: Maybe<Scalars['String']['output']>;
  /** File name of the attachment. */
  fileName: Scalars['String']['output'];
  /** If the feed entry is visible to external users. */
  isPublic: Scalars['Boolean']['output'];
  /** External salesforce ID of the attachment. */
  salesforceId?: Maybe<Scalars['String']['output']>;
  /** Support case that the attachment belongs to. */
  supportCase: SupportCase;
  /** Date the attachment was updated at. */
  updatedAt: Scalars['DateTime']['output'];
  /** The url to upload the attachment in the set encoding. Only populated on attachment creation */
  uploadURL?: Maybe<Scalars['String']['output']>;
};


/** Represents a support case attachment. */
export type SupportCaseAttachmentContentUrlArgs = {
  encoding?: InputMaybe<ContentEncoding>;
};


/** Represents a support case attachment. */
export type SupportCaseAttachmentUploadUrlArgs = {
  encoding?: InputMaybe<ContentEncoding>;
};

/** The close code for a support case. */
export enum SupportCaseCloseCode {
  /** The case was resolved. */
  Resolved = 'RESOLVED'
}

/** Represents the support case comment. */
export type SupportCaseComment = SupportCaseCommentFeedEntry & {
  __typename?: 'SupportCaseComment';
  /** UUID of the comment. */
  UUID: Scalars['UUID']['output'];
  /** Attachments belonging to this comment. */
  attachments: Array<SupportCaseAttachment>;
  /** Author of the comment. */
  author?: Maybe<SupportCaseContact>;
  /**
   * Address of comment author.
   * @deprecated use author instead.
   */
  authorAddress?: Maybe<Scalars['String']['output']>;
  /**
   * Address of comment author.
   * @deprecated use author instead.
   */
  authorEmail?: Maybe<Scalars['String']['output']>;
  /**
   * Full name of comment author.
   * @deprecated use author instead.
   */
  authorFullName?: Maybe<Scalars['String']['output']>;
  /**
   * Name of comment author.
   * @deprecated use author instead.
   */
  authorName: Scalars['String']['output'];
  /** Comment body. */
  body: Scalars['String']['output'];
  /** Comment type. */
  commentType: SupportCaseCommentType;
  /** Date time the comment was created. */
  createdAt: Scalars['DateTime']['output'];
  /** External id of the comment. */
  externalID?: Maybe<Scalars['String']['output']>;
  /** Whether the comment has been deleted. */
  isDeleted: Scalars['Boolean']['output'];
  /** If the comment was left by a meter employee or customer. */
  isInternal: Scalars['Boolean']['output'];
  /** If the feed entry is visible to external users. */
  isPublic: Scalars['Boolean']['output'];
  /** Salesforce ID of the comment. */
  salesforceId?: Maybe<Scalars['String']['output']>;
  /** Support case that the comment belongs to. */
  supportCase: SupportCase;
  /** Date time the comment was modified. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents an entry in the SupportCaseCommentFeed. */
export type SupportCaseCommentFeedEntry = {
  /** UUID of the feed entry. */
  UUID: Scalars['UUID']['output'];
  /** Author of the comment. */
  author?: Maybe<SupportCaseContact>;
  /**
   * Email of the author that owns the attachment.
   * @deprecated use `author` instead.
   */
  authorEmail?: Maybe<Scalars['String']['output']>;
  /**
   * Name of the author that owns the attachment.
   * @deprecated use `author` instead.
   */
  authorFullName?: Maybe<Scalars['String']['output']>;
  /** Date the feed entry was created at. */
  createdAt: Scalars['DateTime']['output'];
  /** If the feed entry is visible to external users. */
  isPublic: Scalars['Boolean']['output'];
  /** Salesforce ID of the feed entry. */
  salesforceId?: Maybe<Scalars['String']['output']>;
  /** Date the feed entry was updated at. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents the type of support case comment. */
export enum SupportCaseCommentType {
  /** Case comment sourced from email. */
  Email = 'EMAIL',
  /** Case comment sourced from Salesforce. */
  Salesforce = 'SALESFORCE'
}

/** A person associated with a support case, identified by email address. */
export type SupportCaseContact = {
  __typename?: 'SupportCaseContact';
  /** The UUID of the contact. */
  UUID: Scalars['UUID']['output'];
  /** The email of the contact. */
  email: Scalars['String']['output'];
  /** The salesforce id of the contact. */
  externalID?: Maybe<Scalars['String']['output']>;
  /** The name of the contact. */
  name?: Maybe<Scalars['String']['output']>;
  /** The phone number of the contact. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The title of the contact. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Input for getting or creating a support case contact by email. */
export type SupportCaseContactInput = {
  /** Email of the contact. The contact is created if none with this email exists. */
  email: Scalars['String']['input'];
  /** Name of the contact. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the contact. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Title of the contact. */
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum SupportCaseOrigin {
  /** Case originating from an alert. */
  Alert = 'ALERT',
  /** Case originating from an email. */
  Email = 'EMAIL',
  /** Lineage now integration sourced case. */
  LineageNow = 'LINEAGE_NOW',
  /** Case originating from a phone call. */
  Phone = 'PHONE',
  /** Case originating from a Slack message. */
  Slack = 'SLACK',
  /** Unknown case origin. */
  Unknown = 'UNKNOWN',
  /** Case originating from the Dashboard form. */
  Web = 'WEB'
}

/** Represents a page of support cases. */
export type SupportCasePage = {
  __typename?: 'SupportCasePage';
  /** The page the cursor points to. */
  currentPage: Scalars['Int']['output'];
  /** The items in this page. */
  items: Array<SupportCase>;
  /** The cursor for the next page. */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /** The cursor for the previous page. */
  previousCursor?: Maybe<Scalars['String']['output']>;
  /** The total number of support cases matching the filters. */
  totalCount: Scalars['Int']['output'];
  /** The total number of pages. */
  totalPages: Scalars['Int']['output'];
};

/** Priority associated with the case. */
export enum SupportCasePriority {
  /** Critical: network is down. */
  Sev_1 = 'SEV_1',
  /** Major: major functionality impacted. */
  Sev_2 = 'SEV_2',
  /** Medium: partial, non-critical functionality impacted. */
  Sev_3 = 'SEV_3',
  /** Low: no impact on network operation. */
  Sev_4 = 'SEV_4'
}

/** Status of the support case. */
export enum SupportCaseStatus {
  /** Case has been cancelled. */
  Cancelled = 'CANCELLED',
  /** Case is in progress. */
  InProgress = 'IN_PROGRESS',
  /** Case has been merged. */
  Merged = 'MERGED',
  /** Case is new. */
  New = 'NEW',
  /** Case has been put on hold. */
  OnHold = 'ON_HOLD',
  /** Case is pending a customer update. */
  PendingCustomerUpdate = 'PENDING_CUSTOMER_UPDATE',
  /** Case is pending a Meter update. */
  PendingMeterUpdate = 'PENDING_METER_UPDATE',
  /** Case is pending third party update. */
  PendingThirdPartyUpdate = 'PENDING_THIRD_PARTY_UPDATE',
  /** Case has been resolved. */
  Resolved = 'RESOLVED',
  /** Case has been marked as spam. */
  Spam = 'SPAM',
  /** Status is unknown. */
  Unknown = 'UNKNOWN'
}

/** A company that operates on support cases for one or more other companies. */
export type SupportProvider = {
  __typename?: 'SupportProvider';
  /** The UUID of the support provider. */
  UUID: Scalars['UUID']['output'];
  /** The company that owns this support provider. */
  company: Company;
  /** The timestamp when the support provider was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The companies this provider is authorized to support, paginated. */
  supportedCompanies: SupportProviderPage;
  /** The timestamp when the support provider was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** A company that operates on support cases for one or more other companies. */
export type SupportProviderSupportedCompaniesArgs = {
  input?: InputMaybe<GetSupportProvidersInput>;
};

/**
 * Maps a support provider to a company it is authorized to support. Backed by
 * a public API key grant request; the mapping's status is derived from that
 * grant.
 */
export type SupportProviderCompany = {
  __typename?: 'SupportProviderCompany';
  /** The UUID of the mapping. */
  UUID: Scalars['UUID']['output'];
  /** The underlying public API key grant request that authorizes the mapping. */
  apiKeyGrantRequest: PublicApiKeyGrantRequest;
  /** The timestamp when the mapping was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Derived from the underlying grant request's state. */
  status: SupportProviderCompanyStatus;
  /** The provider supporting the target company. */
  supportProvider: SupportProvider;
  /** The company being supported. */
  targetCompany: Company;
  /** The timestamp when the mapping was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Status of a support provider's relationship to a company. Derived from the
 * underlying public API key grant request that authorized the provider.
 */
export enum SupportProviderCompanyStatus {
  /** Provider is actively supporting the company. */
  Active = 'ACTIVE',
  /** Provider is awaiting grant approval before it can support the company. */
  Pending = 'PENDING',
  /** Provider is no longer supporting the company. */
  Revoked = 'REVOKED'
}

/** Represents a page of support-provider-to-company mappings. */
export type SupportProviderPage = {
  __typename?: 'SupportProviderPage';
  /** The page the cursor points to. */
  currentPage: Scalars['Int']['output'];
  /** The items in this page. */
  items: Array<SupportProviderCompany>;
  /** The cursor for the next page. */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /** The cursor for the previous page. */
  previousCursor?: Maybe<Scalars['String']['output']>;
  /** The total number of mappings matching the filters. */
  totalCount: Scalars['Int']['output'];
  /** The total number of pages. */
  totalPages: Scalars['Int']['output'];
};

/** Represents a page of support providers. */
export type SupportProvidersListPage = {
  __typename?: 'SupportProvidersListPage';
  /** The page the cursor points to. */
  currentPage: Scalars['Int']['output'];
  /** The items in this page. */
  items: Array<SupportProvider>;
  /** The cursor for the next page. */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /** The cursor for the previous page. */
  previousCursor?: Maybe<Scalars['String']['output']>;
  /** The total number of providers matching the filters. */
  totalCount: Scalars['Int']['output'];
  /** The total number of pages. */
  totalPages: Scalars['Int']['output'];
};

/** A user's membership in a support department with a specific role. */
export type SupportUser = {
  __typename?: 'SupportUser';
  /** Unique identifier for this support user role assignment. */
  UUID: Scalars['UUID']['output'];
  /** Department to filter user to. */
  department: SupportUserDepartment;
  /** Role to filter user to. */
  role: SupportUserRole;
  /** User attached to this support user. */
  user: User;
  /**
   * Unique identifier for this support user role assignment.
   * @deprecated Use `UUID` instead.
   */
  uuid: Scalars['UUID']['output'];
};

/** Deparment of the support user. */
export enum SupportUserDepartment {
  /** Admin Operations. */
  AdminOperations = 'ADMIN_OPERATIONS',
  /** Cellular Operations. */
  CellularOperations = 'CELLULAR_OPERATIONS',
  /** Fufillment department. */
  ConnectFulfillment = 'CONNECT_FULFILLMENT',
  /** Serviceability department. */
  ConnectServiceability = 'CONNECT_SERVICEABILITY',
  /** Deployment Engineering - Wired. */
  DeploymentEngineeringWired = 'DEPLOYMENT_ENGINEERING_WIRED',
  /** Deployment Engineering - Wireless. */
  DeploymentEngineeringWireless = 'DEPLOYMENT_ENGINEERING_WIRELESS',
  /** Deployment operations. */
  DeploymentOperations = 'DEPLOYMENT_OPERATIONS',
  /** Partner Operations. */
  PartnerOperations = 'PARTNER_OPERATIONS',
  /** Technician Operations. */
  TechnicianOperations = 'TECHNICIAN_OPERATIONS'
}

/** Filter input for support user fields. */
export type SupportUserFilterInput = {
  /** Department to filter user to. */
  department?: InputMaybe<SupportUserDepartment>;
  /** Role to filter user to. */
  role?: InputMaybe<SupportUserRole>;
};

/** Role of the support user. */
export enum SupportUserRole {
  /** Ops Associate role. */
  OpsAssociate = 'OPS_ASSOCIATE',
  /** Program manager role. */
  ProgramManager = 'PROGRAM_MANAGER',
  /** Team manager role. */
  TeamManager = 'TEAM_MANAGER'
}

/** A department and role pair for use in setSupportUserRoles. */
export type SupportUserRoleInput = {
  /** Department to assign. */
  department: SupportUserDepartment;
  /** Role to assign. */
  role: SupportUserRole;
};

/** Allows users to specify which native VLAN to assign to the physical interface where a given MAC address or OUI is detected during a Switch Auto Config job. */
export type SwitchAutoConfigMacAddressVlanBinding = Identifiable & {
  __typename?: 'SwitchAutoConfigMACAddressVLANBinding';
  /** The Organizationally Unique Identifier (OUI) to bind to a VLAN. Optional if macAddress or vendor is specified. */
  OUI?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this MAC address to VLAN binding. */
  UUID: Scalars['UUID']['output'];
  /** The VLAN assigned to the specified MAC address or OUI. */
  VLAN: Vlan;
  /** The specific MAC address to bind to a VLAN. Optional if OUI or vendor is specified. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** Unique identifier of the network where this binding applies. */
  networkUUID: Scalars['UUID']['output'];
  /** A vendor of devices as specified by the IEEE OUI database: https://standards-oui.ieee.org/. Optional if macAddress or OUI is specified. If specified, all OUIs for the vendor will be bound to the specified VLAN. */
  vendor?: Maybe<OuIsForVendorResult>;
};

/** Whether a dry-run Switch Auto Configuration job's recorded prior port state still matches the current state of the network. */
export enum SwitchAutoConfigurationDryRunStaleness {
  /** For legacy jobs, we cannot determine if the dry run is stale or not. */
  MaybeStale = 'MAYBE_STALE',
  /** Every result that recorded pre-apply port state still matches the current network state. */
  NotStale = 'NOT_STALE',
  /** At least one touched port has drifted from the state recorded when the dry run was computed. */
  Stale = 'STALE'
}

/** Switch Auto Configuration Jobs automatically configure switch ports based on the connected clients and Meter devices. */
export type SwitchAutoConfigurationJob = AutoSelectionJob & NetworkJob & {
  __typename?: 'SwitchAutoConfigurationJob';
  /** The unique identifier of the job. */
  UUID: Scalars['UUID']['output'];
  /** If this job is a dry-run and was applied to create a new job, the list of jobs that were created from this job. (ie. the inverse of sourceJob.) */
  childAppliedJobs?: Maybe<Array<SwitchAutoConfigurationJob>>;
  /** The date and time when the job was completed. Null if not completed yet. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether or not the job is a dry run. If true, no configuration changes are made. */
  isDryRun: Scalars['Boolean']['output'];
  /**
   * Whether the network state a dry-run job was computed against still
   * matches reality. Returns nil for non-dry-run jobs.
   */
  isStaleDryRun?: Maybe<SwitchAutoConfigurationDryRunStaleness>;
  /** The UUID of the network where the job is executed. */
  networkUUID: Scalars['UUID']['output'];
  /**
   * The results of the Switch Auto Configuration job.
   * Only ports that had their configuration changed or encountered warnings will appear in the results.
   */
  results?: Maybe<Array<SwitchAutoConfigurationResult>>;
  /** True if the job is completed and none of the switch ports that were changed by the job have drifted from the relevant state they were in when the job completed. */
  resultsMatchNetwork: Scalars['Boolean']['output'];
  /** The date and time when the job is scheduled to start. */
  scheduledAt: Scalars['DateTime']['output'];
  /**
   * The source dry-run job whose results were applied to produce this job.
   * Only set for jobs created via applySwitchAutoConfigurationDryRun.
   */
  sourceJob?: Maybe<SwitchAutoConfigurationJob>;
  /**
   * The UUID of the source dry-run job whose results were applied to produce this job.
   * Only set for jobs created via applySwitchAutoConfigurationDryRun.
   */
  sourceJobUUID?: Maybe<Scalars['UUID']['output']>;
  /** The status of the job */
  status: NetworkJobStatus;
  /** The date and time when the job will time out if not completed. */
  timeoutAt: Scalars['DateTime']['output'];
  /**
   * The Native VLAN assigned to switch ports whose clients are not classified in the client MAC to VLAN mappings for the network.
   * Null only if the VLAN no longer exists.
   */
  uncategorizedClientNativeVLAN?: Maybe<Vlan>;
  /**
   * The UUID of the applied (non-dry-run) job that this job reverts. Only set
   * for jobs created via undoSwitchAutoConfigurationRun.
   */
  undoOfJobUUID?: Maybe<Scalars['UUID']['output']>;
  /** List of UUIDs of virtual devices (switches) involved in the job. */
  virtualDeviceUUIDs: Array<Scalars['UUID']['output']>;
};

/** Input parameters for initializing a Switch Auto Configuration Job. */
export type SwitchAutoConfigurationJobInput = {
  /**
   * If true, the job will not make any configuration changes.
   * It will only return the changes it would have made (dry run).
   */
  isDryRun?: Scalars['Boolean']['input'];
  /**
   * If true, the job will run immediately.
   * The default is false; to guarantee correctness, we need to wait several minutes for stats to be reported by the switches before configuring things.
   * However, if we know that there have been no physical cable changes in the last, say, 10 minutes, then we can run the job immediately.
   * This should be used with caution; the caller is responsible for assessing if any patching changes have been made recently.
   */
  runNow?: Scalars['Boolean']['input'];
  /**
   * The list of Switch virtual device UUIDs to run Auto Configuration on.
   * If null, all switches in the network will be auto-configured.
   */
  switchVirtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The Native VLAN UUID to assign to the switch port if the clients on the port are not classified in the client MAC to VLAN mappings for the network. */
  uncategorizedClientNativeVLANUUID: Scalars['UUID']['input'];
};

/** The result of auto-configuring a single switch port. */
export type SwitchAutoConfigurationResult = {
  __typename?: 'SwitchAutoConfigurationResult';
  /** The MAC addresses that drove this result */
  decisiveMACAddresses: Array<Scalars['MacAddress']['output']>;
  /** The new Native VLAN assigned to the port. Null if the VLAN has since been deleted. */
  newNativeVLAN?: Maybe<Vlan>;
  /** The physical interface (port) that was configured. */
  phyInterface: PhyInterface;
  /** The previous Native VLAN assigned to the port. Null if the VLAN has since been deleted. */
  previousNativeVLAN?: Maybe<Vlan>;
  /** The direction of the toggle between access and trunk modes (or no change). */
  toggleDirection: SwitchAutoConfigurationResultToggleDirection;
  /** The switch virtual device that was configured. */
  virtualDevice: SwitchVirtualDevice;
  /** Any warnings that occurred during the port configuration. */
  warnings?: Maybe<Array<SwitchAutoConfigurationResultWarning>>;
};

/** Enumeration of possible toggles between trunk and access modes for switch ports during auto configuration. */
export enum SwitchAutoConfigurationResultToggleDirection {
  /** The port's mode was changed from access to trunk. */
  AccessToTrunk = 'ACCESS_TO_TRUNK',
  /** No change was made to the port's mode. */
  NoChange = 'NO_CHANGE',
  /** The port's mode was changed from trunk to access. */
  TrunkToAccess = 'TRUNK_TO_ACCESS'
}

/** Enumeration of possible warnings encountered during Switch Auto Configuration. */
export enum SwitchAutoConfigurationResultWarning {
  /**
   * Clients on the port had multiple mapped native VLANs based on their MAC addresses or OUIs.
   * The `uncategorizedClientNativeVLANUUID` was selected as the native VLAN.
   */
  MultipleClientMacVlanMappings = 'MULTIPLE_CLIENT_MAC_VLAN_MAPPINGS',
  /**
   * Client MAC addresses were seen on the port, but none were mapped to a native VLAN.
   * The `uncategorizedClientNativeVLANUUID` was selected as the native VLAN.
   */
  NoMappedDevices = 'NO_MAPPED_DEVICES',
  /** The switch did not report any statistics, so no configuration could take place. */
  NoStatsReported = 'NO_STATS_REPORTED'
}

/** A switch hardware device represents a physical switch. */
export type SwitchHardwareDevice = HardwareDevice & {
  __typename?: 'SwitchHardwareDevice';
  /** The batch identifier of the hardware device, if any. */
  batch?: Maybe<Scalars['String']['output']>;
  /** Shows the most recent boot history of a device (buildName, bootCount). */
  bootHistory: Array<BootInfo>;
  /** The active config override for this device, if any. */
  configOverride?: Maybe<DeviceConfigOverride>;
  /** The timestamp when the hardware device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** The model name of the hardware device. */
  deviceModel: DeviceModel;
  /** The type of the hardware device. */
  deviceType: DeviceType;
  /** If the device is no longer connected to the backend, this is the time at which it was last connected. */
  disconnectedFromBackendAt?: Maybe<Scalars['DateTime']['output']>;
  /** The hardware generation of the device. */
  hardwareGeneration: HardwareGeneration;
  /** Metadata for the model of this device. */
  hardwareModelProperties: HardwareModelProperties;
  /** Internal operator-only notes about this hardware device. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /**
   * The IP address of the switch hardware device.
   * @deprecated Use `VirtualDevice.ipAddress` instead.
   */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /**
   * True if the device has an active websocket connection to the backend. Note that this only works if the device has registered via the /v2/register endpoint (i.e., is a Config 2 device) - otherwise is always false.
   * @deprecated Use `isSpare` instead.
   */
  isActive: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is connected to the backend. */
  isConnectedToBackend: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /**
   * Indicates whether the hardware device is marked as a development (dev) device, moving it into the dev (staging) realm for testing purposes.
   * @deprecated Use `realm` instead. isDev is equivalent to realm == DEV.
   */
  isDev: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is in factory mode. */
  isFactoryMode: Scalars['Boolean']['output'];
  /** True if the Switch's MAC address exists in the most recent controller MAC table for the network. */
  isInCurrentControllerMACTable: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is an RMA (Return Merchandise Authorization) replacement device. */
  isRMA: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device has been retired. */
  isRetired: Scalars['Boolean']['output'];
  /** A spare hardware device belongs to a network but is not assigned to a virtual device. Spares are typically kept on site as replacements and are not in service. */
  isSpare: Scalars['Boolean']['output'];
  /** The latest device config metadata (ie. the config without the actual JSON payload) for the device. */
  latestDeviceConfigMetadata?: Maybe<DeviceConfigMetadata>;
  /** The MAC address of the hardware device. */
  macAddress?: Maybe<Scalars['MacAddress']['output']>;
  /** The UUID of the network that the hardware device belongs to. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** Information about the switch's Power over Ethernet (PoE) usage. */
  poeInfo?: Maybe<PoEInfo>;
  /** The public key used to add the device to the jumphost's WireGuard interface. */
  publicKey?: Maybe<Scalars['String']['output']>;
  /** The realm that owns this hardware device. Used for cross-realm device management. */
  realm: HardwareDeviceRealm;
  /** The unique serial number of the hardware device. */
  serialNumber: Scalars['String']['output'];
  /** The network that the spare hardware device belongs to. Spare hardware devices that are not affiliated with a virtual device will have this field populated. */
  spareDeviceNetwork?: Maybe<Network>;
  /** The Spanning Tree Protocol (STP) information for the switch, providing data to ensure a loop-free topology. */
  stpInfo?: Maybe<StpInfo>;
  /** IPv6 address on the jumphost subnet. Used to send requests to the device. */
  tunnelIPAddress?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the hardware device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * How long the device has been continuously powered on and reporting.
   * @deprecated Use `VirtualDevice.uptime` instead.
   */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** The virtual device associated with this hardware device, if any. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** The UUID of the virtual device this hardware device is assigned to, if any. */
  virtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
};


/** A switch hardware device represents a physical switch. */
export type SwitchHardwareDeviceBootHistoryArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

/** A page of MAC table entries for a switch. */
export type SwitchMacTableEntriesPage = {
  __typename?: 'SwitchMACTableEntriesPage';
  /** The page the cursor points to. */
  currentPage: Scalars['Int']['output'];
  /** The items in this page. */
  items: Array<SwitchMacTableEntry>;
  /** The next pages cursor. */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /** The previous pages cursor. */
  previousCursor?: Maybe<Scalars['String']['output']>;
  /** The total number of MAC table entries. */
  totalCount: Scalars['Int']['output'];
  /** The total number of pages. */
  totalPages: Scalars['Int']['output'];
};

/** Represents an entry in the switch's MAC address table, mapping MAC addresses to ports and VLANs. */
export type SwitchMacTableEntry = {
  __typename?: 'SwitchMACTableEntry';
  /** IEEE-registered vendor for the macAddress's OUI, if known. Sourced from the IEEE OUI database. */
  ieeeDeviceVendor?: Maybe<IeeeDeviceVendor>;
  /** The MAC address observed on the switch. */
  macAddress: Scalars['MacAddress']['output'];
  /** A user-defined nickname for the MAC address, if specified. */
  macAddressAlias?: Maybe<MacAddressAlias>;
  /** The physical interface where the MAC address was observed. Sometimes can be null for loopback ports */
  phyInterface?: Maybe<PhyInterface>;
  /**
   * The port number where the MAC address was observed.
   * @deprecated Can get this info from `phyInterface`.
   */
  port: Scalars['Int']['output'];
  /** The timestamp when the entry was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The switch virtual device the MAC address was observed on. */
  virtualDevice: SwitchVirtualDevice;
  /** The UUID of the switch virtual device. */
  virtualDeviceUUID: Scalars['UUID']['output'];
  /** The VLAN the MAC address was observed on. */
  vlan?: Maybe<Vlan>;
  /** The VLAN ID associated with the MAC address. */
  vlanID: Scalars['Int']['output'];
};

/** Response type containing an array of per-port rate metrics at specific timestamps. */
export type SwitchPortMetricsRateResponse = {
  __typename?: 'SwitchPortMetricsRateResponse';
  /** An array of per-port metrics expressed as rates at specific timestamps. */
  values: Array<SwitchPortMetricsRateValue>;
};

/** Per-port metrics data expressed as rates (per second) at specific timestamps. */
export type SwitchPortMetricsRateValue = {
  __typename?: 'SwitchPortMetricsRateValue';
  /** Total number of broadcast packets per second received in the given time period; a subset of totalRxPackets. */
  broadcastRxPacketsPerSecond: Scalars['Float']['output'];
  /** Total number of broadcast packets per second transmitted in the given time period; a subset of totalTxPackets. */
  broadcastTxPacketsPerSecond: Scalars['Float']['output'];
  /** The rate of packets per second dropped during reception on this port. */
  discardRxPacketsPerSecond: Scalars['Float']['output'];
  /** The rate of packets per second dropped during transmission on this port. */
  discardTxPacketsPerSecond: Scalars['Float']['output'];
  /**
   * The rate of packets per second that were dropped during transmission or reception on this port.
   * @deprecated Use `discardRxPacketsPerSecond` and `discardTxPacketsPerSecond` instead.
   */
  dropsPerSecond: Scalars['Float']['output'];
  /** Total number of multicast packets per second received in the given time period; a subset of totalRxPackets. */
  multicastRxPacketsPerSecond: Scalars['Float']['output'];
  /** Total number of multicast packets per second transmitted in the given time period; a subset of totalTxPackets. */
  multicastTxPacketsPerSecond: Scalars['Float']['output'];
  /** The physical port number on the switch. */
  portNumber: Scalars['Int']['output'];
  /** The rate of reception errors per second on this port. */
  rxErrPerSecond: Scalars['Float']['output'];
  /** The timestamp for when the rate values were calculated. */
  timestamp: Scalars['DateTime']['output'];
  /** The rate of bytes per second received on this port. */
  totalRxBytesPerSecond: Scalars['Float']['output'];
  /** The rate of bytes per second transmitted from this port. */
  totalTxBytesPerSecond: Scalars['Float']['output'];
  /** The rate of transmission errors per second on this port. */
  txErrPerSecond: Scalars['Float']['output'];
};

/** Aggregated statistics per switch port over a specified lookback period. */
export type SwitchPortStat = {
  __typename?: 'SwitchPortStat';
  /** Total number of broadcast packets received on this port during the lookback period; a subset of totalRxPackets. */
  broadcastRxPackets: Scalars['Int']['output'];
  /** Total number of broadcast packets transmitted from this port during the lookback period; a subset of totalTxPackets. */
  broadcastTxPackets: Scalars['Int']['output'];
  /** Total number of packets received on this port but discarded due to errors or resource limitations during the lookback period; a subset of totalRxPackets. */
  discardRxPackets: Scalars['Int']['output'];
  /** Total number of packets attempted to be transmitted from this port but discarded due to errors or resource limitations during the lookback period; a subset of totalTxPackets. */
  discardTxPackets: Scalars['Int']['output'];
  /** Total number of packets received on this port that contained errors (e.g., CRC errors) during the lookback period; a subset of totalRxPackets. */
  errorRxPackets: Scalars['Int']['output'];
  /** Total number of packets transmitted from this port that encountered errors during the lookback period; a subset of totalTxPackets. */
  errorTxPackets: Scalars['Int']['output'];
  /** Total number of multicast packets received on this port during the lookback period; a subset of totalRxPackets. */
  multicastRxPackets: Scalars['Int']['output'];
  /** Total number of multicast packets transmitted from this port during the lookback period; a subset of totalTxPackets. */
  multicastTxPackets: Scalars['Int']['output'];
  /** Total number of non-unicast (i.e., multicast and broadcast) packets received on this port during the lookback period; a subset of totalRxPackets. */
  nonUnicastRxPackets: Scalars['Int']['output'];
  /** Total number of non-unicast (i.e., multicast and broadcast) packets transmitted from this port during the lookback period; a subset of totalTxPackets. */
  nonUnicastTxPackets: Scalars['Int']['output'];
  /** The physical number of the port on the switch. */
  portNumber: Scalars['Int']['output'];
  /** Total number of bytes received on this port during the lookback period. */
  totalRxBytes: Scalars['Int']['output'];
  /** Total number of packets received on this port during the lookback period. */
  totalRxPackets: Scalars['Int']['output'];
  /** Total number of bytes transmitted from this port during the lookback period. */
  totalTxBytes: Scalars['Int']['output'];
  /** Total number of packets transmitted from this port during the lookback period. */
  totalTxPackets: Scalars['Int']['output'];
  /** Total number of unicast packets received on this port during the lookback period; a subset of totalRxPackets. */
  unicastRxPackets: Scalars['Int']['output'];
  /** Total number of unicast packets transmitted from this port during the lookback period; a subset of totalTxPackets. */
  unicastTxPackets: Scalars['Int']['output'];
};

/** A switch profile is a bundle of settings that applies to a switch device. */
export type SwitchProfile = Identifiable & {
  __typename?: 'SwitchProfile';
  /** The unique identifier of the switch profile. */
  UUID: Scalars['UUID']['output'];
  /** Time in minutes after the last voice device leaves and the port is removed from voice VLAN. */
  VoiceVLANAgingTimeMin?: Maybe<Scalars['Int']['output']>;
  /** OUIs that should be detected as IP phones. */
  VoiceVLANOUIs?: Maybe<Array<Scalars['String']['output']>>;
  /** The date and time when the switch profile was created. */
  createdAt: Scalars['DateTime']['output'];
  /** For 802.1X encryption on a Switch's ports, if a client fails 802.1X authentication, clients are placed in the specified VLAN. The VLAN must be specified as `isGuest`. If set to null, then clients must authenticate before accessing the network. */
  encryption8021XGuestVLAN?: Maybe<Vlan>;
  /** The 802.1X encryption configurations associated with this switch profile. Setting this field enables 802.1X encryption on the switch's ports, which can individually be enabled/disabled and configured on a per-port basis. The order matters; the first index is the primary and subsequent ones are backup(s). */
  encryption8021Xs?: Maybe<Array<Encryption8021X>>;
  /** The time in seconds after which all flap state for a port is cleared. */
  flipClearFlapStateAfterSec?: Maybe<Scalars['Int']['output']>;
  /** The maximum number of times to toggle the port before requiring manual toggle of port in dashboard. */
  flipMaxRetryCount?: Maybe<Scalars['Int']['output']>;
  /** The number of seconds to wait before re-enabling the port. */
  flipRetryPeriodSec?: Maybe<Scalars['Int']['output']>;
  /** Time window in seconds to count the number of flaps. */
  flipWindowSec?: Maybe<Scalars['Int']['output']>;
  /** The number of flaps per time window that will result in a port being shut down. */
  flipWindowThreshold?: Maybe<Scalars['Int']['output']>;
  /** If true, flap link intervention protocol is enabled for this switch profile. Both this flag and isFLIPEnabled in PhyInterface must be true for FLIP to be enabled on a port. */
  isFLIPEnabled: Scalars['Boolean']['output'];
  /** Enables switch to periodically send IGMP queries to detect multicast clients. Both this flag and isIgmpSnoopingEnabled in VLAN must be true for IGMP snooping to be enabled on this switch. */
  isIGMPSnoopingEnabled: Scalars['Boolean']['output'];
  /** Enables switch to periodically send MLD queries to detect multicast clients. Both this flag and isMldSnoopingEnabled in VLAN must be true for MLD snooping to be enabled on this switch. */
  isMLDSnoopingEnabled: Scalars['Boolean']['output'];
  /** If true, the switch's 802.1X ports authenticate against Meter's managed RADIUS, using the NAC policies defined for the network. Mutually exclusive with encryption8021Xs. */
  isMeterNACEnabled: Scalars['Boolean']['output'];
  /** Multicast filtering tells the switch what to do with unknown multicast packet i.e packets for which snooping doesn't have any learned ports. When enabled, unknown multicast packets are dropped. */
  isMulticastFilteringEnabled: Scalars['Boolean']['output'];
  /** If true, voice VLAN is enabled for this switch profile. Both this flag and isVoiceVLANEnabled in PhyInterface must be true for voice VLAN to be enabled on a port. */
  isVoiceVLANEnabled: Scalars['Boolean']['output'];
  /** The L3 configuration for this switch profile, including routing layer and underlay address. */
  l3Configuration: L3Configuration;
  /** Time in seconds after which a MAC entry will be aged out, default is 300 seconds (5 minutes) and 0 means no expiration. */
  macTableAgingSec: Scalars['Int']['output'];
  /** The maximum transmission unit (MTU) size in bytes. The default is 1522. */
  mtu: Scalars['Int']['output'];
  /** The name of the switch profile. */
  name: Scalars['String']['output'];
  /** The unique identifier of the network the switch profile belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /**
   * The STP (Spanning Tree Protocol) bridge priority for the switch.
   *
   * The lower the value, the more likely the switch is to be elected as the root bridge.
   * The range is 0 to 61440. Valid values are multiples of 4096.
   */
  stpBridgePriority: Scalars['Int']['output'];
  /**
   * STP forwarding delay in seconds.
   *
   * The time that the switch will wait before transitioning a port from the listening to the learning state, and from the learning to the forwarding state.
   * Valid values are between 4 and 30 seconds.
   */
  stpForwardingDelaySeconds: Scalars['Int']['output'];
  /**
   * STP Hello interval in seconds.
   *
   * The time between configuration messages sent by the root bridge to maintain the spanning tree topology.
   * Valid values are between 1 and 10 seconds.
   */
  stpHelloIntervalSeconds: Scalars['Int']['output'];
  /**
   * STP Max BPDU (Bridge Protocol Data Unit) age in seconds.
   *
   * The maximum age of received BPDU information before it is discarded.
   * Valid values are between 6 and 40 seconds.
   */
  stpMaxAgeSeconds: Scalars['Int']['output'];
  /**
   * STP BPDU transmit hold count per second.
   *
   * The maximum number of BPDUs that can be sent per second.
   * Valid values are between 1 and 10.
   */
  stpTransmitHoldCount: Scalars['Int']['output'];
  /** The tier of the switch device(s) associated with the switch profile, denoting the purpose of the devices in the network. */
  switchingTier: SwitchProfileSwitchingTier;
  /** The date and time when the switch profile was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Voice VLAN CoS (Class Of Service) that operates on Layer-2 level. Valid values are 0-7. */
  voiceCosValue?: Maybe<Scalars['Int']['output']>;
  /** Voice VLAN DSCP (Differentiated Services Code Point) that operates on Layer-4 level. Valid values are 0-63. */
  voiceDscpValue?: Maybe<Scalars['Int']['output']>;
  /** The UUID of the VLAN designated for voice traffic. */
  voiceVLANUUID?: Maybe<Scalars['UUID']['output']>;
};

/** A categorization for the switch device(s) associated with a SwitchProfile, denoting the purpose of the devices in the network. */
export enum SwitchProfileSwitchingTier {
  /** Switches that directly connect end devices, usually with a mix of Ethernet and SFP uplinks to distribution switches. */
  Access = 'ACCESS',
  /** MDF-based aggregation layer, typically SFP-only, serving as the central switching hub for the network. These switches connect to downstream distribution/access switches and uplinks to firewalls. */
  Core = 'CORE',
  /** MDF/IDF-based switches that aggregate multiple access switches and uplink to core switches. Can be SFP-only or a mix of Ethernet and SFP uplinks. */
  Distribution = 'DISTRIBUTION',
  /** The switches distribute an ISP connection between High Availability (HA) firewalls. */
  Isp = 'ISP'
}

/** A switch virtual device is a logical representation of a physical switch. */
export type SwitchVirtualDevice = Identifiable & TargetInterface & VirtualDevice & {
  __typename?: 'SwitchVirtualDevice';
  /** The unique identifier (UUID) of the virtual device. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the virtual device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** An optional description for the virtual device. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Metadata for the configurations rendered for this virtual device over time, newest
   * first. Includes configs written to hardware devices that have since been dissociated
   * from this virtual device. Omits the rendered config JSON for performance.
   */
  deviceConfigs: Array<DeviceConfigMetadata>;
  /** The model name of the virtual device. */
  deviceModel: DeviceModel;
  /** The type of the virtual device. */
  deviceType: VirtualDeviceType;
  /** The hardware device associated with this virtual device, if any. */
  hardwareDevice?: Maybe<HardwareDevice>;
  /** Metadata for the model of this device. */
  hardwareModelProperties: HardwareModelProperties;
  /** The management IP address of the device. */
  ipAddress?: Maybe<Scalars['IP']['output']>;
  /** Indicates whether the virtual device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether debug logging is enabled on the virtual device. */
  isDebugLogEnabled: Scalars['Boolean']['output'];
  /** Whether this virtual device is in a draft state for preconfiguration reasons. */
  isDraft: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is online, indicated by its heartbeat. */
  isOnline: Scalars['Boolean']['output'];
  /** The ISP VLAN IDs. Every ISP switch starts with 4000/4001. Null if the switch is not an ISP switch. */
  ispVLANs?: Maybe<IspVlaNs>;
  /** A human-friendly name for the device. */
  label: Scalars['String']['output'];
  /** The physical location of this virtual device, derived from its rack elevation placement. */
  location?: Maybe<VirtualDeviceLocation>;
  /** The MAC table of the switch (ie. the ports and the MAC addresses of the devices connected to them). */
  macTable?: Maybe<Array<SwitchMacTableEntry>>;
  /** The most recent NOS upgrade for this virtual device that has started executing or was skipped (in progress, completed, failed, or skipped), if any. */
  mostRecentNOSUpgrade?: Maybe<ScheduledDeviceNosUpgrade>;
  /** The network that the virtual device belongs to. */
  network: Network;
  /** The unique identifier (UUID) of the network the virtual device belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The group that the device belongs to for firmware upgrade grouping purposes. */
  nosUpgradeGroup: NosUpgradeGroup;
  /** The current NOS firmware version that the virtual device is configured to run. */
  nosVersion?: Maybe<ConfiguredNosVersion>;
  /** The identifier of the NOS firmware version that the virtual device is configured to run. */
  nosVersionID: Scalars['Int']['output'];
  /** The switch's active or future notification snoozes */
  notificationSnoozes: Array<DeviceNotificationSnooze>;
  /**
   * The outlet interface on a Meter Power Distribution Device that this device is connected to, if applicable.
   * This connection is a manually curated label and may not actually be the outlet that the device is connected to.
   */
  outletInterfaceConnectedTo?: Maybe<OutletInterface>;
  /** The paired virtual device to this device, applicable to dual-chassis configurations. */
  pairedVirtualDevice?: Maybe<SwitchVirtualDevice>;
  /** The NOS firmware version that the virtual device is scheduled to upgrade to. */
  pendingNosVersion?: Maybe<PendingNosVersion>;
  /** The physical interfaces associated with the switch. */
  phyInterfaces: Array<PhyInterface>;
  /** Information about the switch's Power over Ethernet (PoE) usage. */
  poeInfo?: Maybe<PoEInfo>;
  /** URL to the regulatory e-label for the device, if applicable. */
  regulatoryLabelURL?: Maybe<Scalars['String']['output']>;
  /** The SPAN mirror sessions configured on this switch. */
  spanMirrorSessions: Array<SpanMirrorSession>;
  /** The switch profile associated with this switch that defines port configurations and other settings. */
  switchProfile: SwitchProfile;
  /** The UUID of the switch profile associated with this switch. */
  switchProfileUUID: Scalars['UUID']['output'];
  /** The virtual device tags on this device. */
  tags: Array<VirtualDeviceTag>;
  /** Data about this virtual device's position in its network's topology. */
  topologyData?: Maybe<VirtualDeviceTopologyData>;
  /** The timestamp when the virtual device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /** How long the device has been continuously powered on and reporting. */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** The position of this virtual device within its device pair (left or right). Null if not part of a pair. */
  virtualDevicePairPosition?: Maybe<DevicePosition>;
};


/** A switch virtual device is a logical representation of a physical switch. */
export type SwitchVirtualDeviceDeviceConfigsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};

/** System information about a device's central processing unit (CPU) core. */
export type SystemCpuInfo = {
  __typename?: 'SystemCPUInfo';
  /** The percentage of time the core is idle. */
  idlePercent: Scalars['Float']['output'];
  /** The percentage of time the core is waiting for input or output (IO). */
  ioWaitPercent: Scalars['Float']['output'];
  /** The percentage of time the core is processing an interrupt request. */
  irqPercent: Scalars['Float']['output'];
  /** The percentage of time the core is processing a software interrupt request. */
  softIRQPercent: Scalars['Float']['output'];
  /** The percentage of time the core is used by system applications. */
  systemPercent: Scalars['Float']['output'];
  /** The percentage of time the core is used by userspace applications. */
  userPercent: Scalars['Float']['output'];
};

/** System information about a device's storage disk. */
export type SystemDiskInfo = {
  __typename?: 'SystemDiskInfo';
  /** The number of free bytes on the disk. */
  bytesFree: Scalars['Uint64']['output'];
  /** The number of total available bytes on the disk. */
  bytesTotal: Scalars['Uint64']['output'];
  /** The number of used bytes on the disk. */
  bytesUsed: Scalars['Uint64']['output'];
  /** The number of free inodes on the disk. */
  inodesFree: Scalars['Uint64']['output'];
  /** The number of total inodes on the disk. */
  inodesTotal: Scalars['Uint64']['output'];
  /** The number of used inodes on the disk. */
  inodesUsed: Scalars['Uint64']['output'];
  /** The root path of the disk. */
  path: Scalars['String']['output'];
};

/** System information about a device's cooling fan. */
export type SystemFanInfo = {
  __typename?: 'SystemFanInfo';
  /** The speed of the fan in rotations per minute (RPM) */
  speedRpm: Scalars['Uint32']['output'];
};

/** System information about a device's humidity sensor. */
export type SystemHumidityInfo = {
  __typename?: 'SystemHumidityInfo';
  /** The relative humidity percentage measured by this sensor. */
  percent: Scalars['Float']['output'];
  /** The location of this sensor on the board. */
  zone: SystemHumidityZone;
};

export enum SystemHumidityZone {
  /** A humidity sensor near the CPU. */
  Cpu = 'CPU',
  /** A humidity sensor near the outside of the enclosure. */
  Outside = 'OUTSIDE',
  /** An unspecified humidity sensor location. */
  Unspecified = 'UNSPECIFIED'
}

/** Response type for system performance metrics for a virtual device. */
export type SystemInfoMetricsResponse = {
  __typename?: 'SystemInfoMetricsResponse';
  /** The CPU used percentage over time. */
  cpuUsedPercentage: Array<BaseMetricsValue>;
  /** The memory available percentage over time. */
  memAvailablePercentage: Array<BaseMetricsValue>;
  /** The memory used percentage over time. */
  memUsedPercentage: Array<BaseMetricsValue>;
};

/** System information about a device. */
export type SystemInfoStat = {
  __typename?: 'SystemInfoStat';
  /** The used CPU percentage represented as a value [0, 1]. */
  cpuUsedPercentage: Scalars['Float']['output'];
  /** Information about the device's central processing unit (CPU) cores. */
  cpus?: Maybe<Array<SystemCpuInfo>>;
  /** Information about the device's storage disks. */
  disks?: Maybe<Array<SystemDiskInfo>>;
  /** Information about the device's cooling fans. */
  fans?: Maybe<Array<SystemFanInfo>>;
  /** Information about the device's humidity sensors. */
  humidities?: Maybe<Array<SystemHumidityInfo>>;
  /** Amount of available memory in bytes. */
  memoryBytesAvailable: Scalars['Int']['output'];
  /** Total memory in bytes. */
  memoryBytesTotal: Scalars['Int']['output'];
  /** Amount of used memory in bytes. */
  memoryBytesUsed: Scalars['Int']['output'];
  /** When the system information was recorded. */
  observedAt: Scalars['DateTime']['output'];
  /** Information about the device's thermal sensors. */
  thermals?: Maybe<Array<SystemThermalInfo>>;
  /** The uptime of the device since last reboot, in seconds. */
  uptime: Scalars['Duration']['output'];
};

export type SystemInfoStatsFilter = {
  /** The lookback time to consider stats for, starting at `endTime`. Maximum allowed value is 86400, one day. */
  durationSeconds: Scalars['Int']['input'];
  /** The latest observation time to consider stats for, inclusive. Defaults to the current time if not set. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The maximum number of results to return, between 1 and 1000. Defaults to 100 if not set. */
  limit?: Scalars['Int']['input'];
};

/** System information about a device's thermal sensor. */
export type SystemThermalInfo = {
  __typename?: 'SystemThermalInfo';
  /** The temperature in degrees Celsius measured by this sensor. */
  celsius: Scalars['Float']['output'];
  /**
   * The unique idenfifier of this sensor.
   * @deprecated Use `sensorID` instead, using this may introduce graph cache ambiguity.
   */
  id: Scalars['Int']['output'];
  /** The unique identifier of this sensor */
  sensorID: Scalars['Int']['output'];
  /** The type of zone monitored by this sensor. */
  zone: SystemThermalZone;
};

export enum SystemThermalZone {
  /** A CPU thermal zone. */
  Cpu = 'CPU',
  /** A humidity sensor thermal zone. */
  Humidity = 'HUMIDITY',
  /** A power sensor thermal zone. */
  Power = 'POWER',
  /** A radio thermal zone. */
  Radio = 'RADIO',
  /** An unspecified/other thermal zone. */
  Unspecified = 'UNSPECIFIED'
}

/** Input for TCP probe parameters. */
export type TcpProbeParamsInput = {
  /** TCP payload length in bytes. */
  payloadLen?: InputMaybe<Scalars['Int']['input']>;
  /** TCP server port. */
  port: Scalars['Int']['input'];
  /** TCP server IP address. */
  serverIP: Scalars['String']['input'];
};

/** Target interface. */
export type TargetInterface = {
  /** Unique identifier for this target interface. */
  UUID: Scalars['UUID']['output'];
};

/** Input for specifying the target interface. Uses POST semantics as only one can be provided. */
export type TargetInterfaceInput = {
  /** Auto VPN group UUID. */
  autoVPNGroupUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** IPSec tunnel UUID. */
  ipsecTunnelUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Internet service plan UUID. */
  ispUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Physical interface UUID. */
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Virtual device UUID. */
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** VLAN UUID. */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** VPN server UUID. */
  vpnServerUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Technology customer is experiencing issue with. */
export enum TechnologyType {
  /** Both wired and wireless technology. */
  Both = 'BOTH',
  /** Dashboard issue. */
  Dashboard = 'DASHBOARD',
  /** Unspecified issue type. */
  Unspecified = 'UNSPECIFIED',
  /** Wired technology. */
  Wired = 'WIRED',
  /** Wireless technology. */
  Wireless = 'WIRELESS'
}

/** Company identity available when requesting temporary access. */
export type TemporaryAccessCompany = {
  __typename?: 'TemporaryAccessCompany';
  /** The company UUID. */
  UUID: Scalars['UUID']['output'];
  /** The company name. */
  name: Scalars['String']['output'];
  /** The company dashboard slug. */
  slug: Scalars['String']['output'];
};

/** A temporary grant of a role on a company to an internal user. */
export type TemporaryAccessGrant = {
  __typename?: 'TemporaryAccessGrant';
  /** The unique UUID identifier for the grant. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the request was approved. */
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who approved the request. */
  approvedByUser?: Maybe<User>;
  /** The company access was granted on. */
  company: Company;
  /** The UUID of the company access was granted on. */
  companyUUID: Scalars['UUID']['output'];
  /** The timestamp when access was requested. */
  createdAt: Scalars['DateTime']['output'];
  /** The timestamp when the request was denied. */
  deniedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who denied the request. */
  deniedByUser?: Maybe<User>;
  /** The timestamp when the role was actually removed. */
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  /** While pending, the deadline for approval. Once approved, the timestamp when access expires or expired. */
  expiresAt: Scalars['DateTime']['output'];
  /** The reason given when requesting access. */
  reason: Scalars['String']['output'];
  /** How long access lasts once approved. */
  requestedDuration: Scalars['Duration']['output'];
  /** The timestamp when the grant was revoked. */
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who revoked the grant. */
  revokedByUser?: Maybe<User>;
  /** The role granted on the company. */
  roleName: RoleName;
  /** The current state. */
  status: TemporaryAccessGrantStatus;
  /** The user who requested and holds the access. */
  user: User;
};

/** The state of a temporary access grant. */
export enum TemporaryAccessGrantStatus {
  /** The grant is in effect. */
  Active = 'ACTIVE',
  /** The request was denied by an approver. */
  Denied = 'DENIED',
  /** The grant reached its expiry, or the request was not approved in time. */
  Expired = 'EXPIRED',
  /** The request is awaiting approval. */
  Pending = 'PENDING',
  /** The grant was ended early by a user. */
  Revoked = 'REVOKED'
}

/** Filter for listing temporary access grants. */
export type TemporaryAccessGrantsFilter = {
  /** Only grants for this company. */
  companyUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Include grants that have expired or been revoked. */
  includeEnded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only grants requested by the user with this email address. */
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

/** The level of access a temporary access grant provides. */
export enum TemporaryAccessLevel {
  /** Grants the operator role on the company. */
  Operator = 'OPERATOR',
  /** Grants the read-only company admin role on the company. */
  ReadOnly = 'READ_ONLY'
}

/** Represents the result of a test fire alert. */
export type TestFireAlertResult = {
  __typename?: 'TestFireAlertResult';
  /** Unique identifier of the alert receiver that was tested. */
  alertReceiverUUID: Scalars['UUID']['output'];
  /** Outcome of the test fire alert. */
  ok: Scalars['Boolean']['output'];
};

/** Text filter implementation. */
export type TextFilter = {
  /** The key for the filter. */
  key: Scalars['String']['input'];
  /** Text value for the filter. */
  value: Scalars['String']['input'];
};

/** A pair of S3 keys for a theme-dependent image. */
export type ThemedImageS3Keys = {
  __typename?: 'ThemedImageS3Keys';
  /** S3 key for an image intended to display on a dark theme. */
  darkS3Key: Scalars['String']['output'];
  /** S3 key for an image intended to display on a light theme. */
  lightS3Key: Scalars['String']['output'];
};

export type ThemedImageS3KeysInput = {
  /** S3 key for an image intended to display on a dark theme. */
  darkS3Key: Scalars['String']['input'];
  /** S3 key for an image intended to display on a light theme. */
  lightS3Key: Scalars['String']['input'];
};

/** Represents a throughput data point with its value and traffic direction. */
export type ThroughputValueWithDirection = {
  __typename?: 'ThroughputValueWithDirection';
  /** The direction of traffic for the throughput value. */
  direction: TrafficDirection;
  /** The throughput value in bits per second. */
  value: Scalars['Int']['output'];
};

export type TimeFilter = {
  /** The lookback time to consider, starting at `endTime`. Maximum allowed value is 86400, one day. */
  durationSeconds: Scalars['Int']['input'];
  /** The latest observation time to consider, inclusive. Defaults to the current time if not set. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input shape for a single time window. */
export type TimeWindowInput = {
  /** End of the window. Must be strictly greater than startAt. */
  endAt: Scalars['DateTime']['input'];
  /** Optional free-form notes. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Start of the window. */
  startAt: Scalars['DateTime']['input'];
};

/** Represents the principal (entity) associated with a token. */
export type TokenPrincipal = {
  __typename?: 'TokenPrincipal';
  /** The name of the principal. For devices, the serial number; for machines, the machine name; for users, the user name. */
  name: Scalars['String']['output'];
  /** The type of the principal (e.g., DEVICE, MACHINE, USER). */
  type: PrincipalType;
};

/** An enumeration of possible token types. */
export enum TokenType {
  /** A bearer token used for authentication. */
  Bearer = 'BEARER'
}

/** A complete topology design for a network, including nodes, links, and validation findings. */
export type TopologyDesign = {
  __typename?: 'TopologyDesign';
  /** All design links in this network. */
  links: Array<TopologyDesignLink>;
  /** All design nodes in this network. */
  nodes: Array<TopologyDesignNode>;
  /** Validation findings for the current design state. */
  validations: Array<TopologyDesignValidationFinding>;
};

/** One tick of the generator: a single atomic mutation to the design graph plus context for incremental rendering. Replaying the steps in order reconstructs the design. */
export type TopologyDesignBuildStep = {
  __typename?: 'TopologyDesignBuildStep';
  /** Set only on DECISION steps: a machine-readable branch name (collapsed-core, core-direct, dist-tier, home-run, aggregation, demotion, dual-role, multi-group, host_agg) for filtering/highlighting. */
  kind?: Maybe<Scalars['String']['output']>;
  /** Set on ADD_LINK / MODIFY_LINK. */
  link?: Maybe<TopologyDesignBuildStepLink>;
  /** The location this mutation belongs to. */
  location: Scalars['String']['output'];
  /** Set on ADD_NODE. */
  node?: Maybe<TopologyDesignBuildStepNode>;
  /** The mutation kind. */
  op: TopologyDesignBuildStepOp;
  /** Build phase: construct or host_agg. */
  phase: Scalars['String']['output'];
  /** Set on MODIFY_LINK: the link's endpoint before the move, for animating the re-route. */
  prevLink?: Maybe<TopologyDesignBuildStepLink>;
  /** Human-readable description for tooltips/logs. On DECISION steps this states the metrics behind the branch. */
  summary: Scalars['String']['output'];
  /** 0-based sequence index. */
  tick: Scalars['Int']['output'];
};

/** A cable's endpoints at a build step. id is stable across a relocation, so a cable can be tracked as its destination moves. */
export type TopologyDesignBuildStepLink = {
  __typename?: 'TopologyDesignBuildStepLink';
  /** Cable medium descriptor. */
  cable: Scalars['String']['output'];
  /** Destination device label. */
  dstDev: Scalars['String']['output'];
  /** Destination port. */
  dstPort: Scalars['String']['output'];
  /** Stable link identifier within this build. */
  id: Scalars['Int']['output'];
  /** Optional uplink media (fiber type). */
  media?: Maybe<Scalars['String']['output']>;
  /** Source device label. */
  srcDev: Scalars['String']['output'];
  /** Source port label (e.g. '1', 'LAN', or 'pwr1'), matching the persisted design. */
  srcPort: Scalars['String']['output'];
};

/** A device created at a build step. */
export type TopologyDesignBuildStepNode = {
  __typename?: 'TopologyDesignBuildStepNode';
  /** Device model, e.g. S1, S3, F3. */
  deviceModel: Scalars['String']['output'];
  /** Device label, e.g. MDF-C01. */
  label: Scalars['String']['output'];
  /** Location the device belongs to, e.g. MDF or IDF1. */
  location: Scalars['String']['output'];
  /** Internal role: Core, Dist, Access, Dist+Access, Agg, ISP, Firewall, PDU, AP. */
  role: Scalars['String']['output'];
};

/** The kind of graph mutation a build step performs. */
export enum TopologyDesignBuildStepOp {
  /** A cable was added. */
  AddLink = 'ADD_LINK',
  /** A device was added. */
  AddNode = 'ADD_NODE',
  /** An algorithm branch was taken (collapsed core, aggregation, demotion, dual-role, multi-group, host_agg, ...); no graph change. */
  Decision = 'DECISION',
  /** An existing cable's endpoint was relocated (the host_agg re-route). */
  ModifyLink = 'MODIFY_LINK',
  /** A phase marker; no graph change. */
  Phase = 'PHASE'
}

/** Physical cable medium for a topology design link. */
export enum TopologyDesignCableType {
  /** 1G Direct Attach Copper cable. */
  Dac_1G = 'DAC_1G',
  /** 10G Direct Attach Copper cable. */
  Dac_10G = 'DAC_10G',
  /** 25G Direct Attach Copper cable. */
  Dac_25G = 'DAC_25G',
  /** Standard Ethernet (RJ45) cable. */
  Ethernet = 'ETHERNET',
  /** Multi-mode fiber. */
  Mmf = 'MMF',
  /** Power cable. */
  Power = 'POWER',
  /** Single-mode fiber. */
  Smf = 'SMF'
}

/**
 * TopologyDesignDeviceType is the type of device a design node represents.
 *
 * Deliberately distinct from the hardware DeviceType enum: this is a design-domain
 * enum that also covers design-only nodes (ISP_HANDOFF, THIRD_PARTY) which have no
 * hardware spec and never provision into a virtual device.
 */
export enum TopologyDesignDeviceType {
  /** An access point. */
  AccessPoint = 'ACCESS_POINT',
  /** A cellular gateway. */
  CellularGateway = 'CELLULAR_GATEWAY',
  /** A controller / firewall. */
  Controller = 'CONTROLLER',
  /** A design-only ISP handoff / demarcation node. Has no hardware spec and never provisions a virtual device. */
  IspHandoff = 'ISP_HANDOFF',
  /** A power distribution unit. */
  PowerDistributionUnit = 'POWER_DISTRIBUTION_UNIT',
  /** A switch. */
  Switch = 'SWITCH',
  /** A design-only generic third-party (non-Meter) device. Its kind and model are free text (carried in deviceModel), it has no hardware spec, and it never provisions a virtual device. */
  ThirdParty = 'THIRD_PARTY'
}

/** Whether a device is in a Main Distribution Frame or Intermediate Distribution Frame. */
export enum TopologyDesignDistributionFrameType {
  /** Intermediate Distribution Frame. */
  Idf = 'IDF',
  /** Main Distribution Frame. */
  Mdf = 'MDF'
}

/** HA firewall hardware variant. */
export enum TopologyDesignFirewallVariant {
  /** Discrete HA pair with a dedicated firewall-to-firewall heartbeat link. */
  F1 = 'F1',
  /** Shared-chassis HA pair (no firewall-to-firewall heartbeat link). */
  F3 = 'F3'
}

/** How a carrier terminates an ISP circuit at the demarcation point. */
export enum TopologyDesignIspHandoffType {
  /** Copper Ethernet on an RJ45 port. */
  Copper = 'COPPER',
  /** 1G direct attach copper in a 1G SFP cage. */
  Dac_1G = 'DAC_1G',
  /** 10G direct attach copper in a 10G SFP+ cage. */
  Dac_10G = 'DAC_10G',
  /** 25G direct attach copper in a 25G-capable SFP cage. */
  Dac_25G = 'DAC_25G',
  /** 1G multi-mode fiber in a 1G SFP cage. */
  Sfp_1GMm = 'SFP_1G_MM',
  /** 1G single-mode fiber in a 1G SFP cage. */
  Sfp_1GSm = 'SFP_1G_SM',
  /** 10G multi-mode fiber in a 10G SFP+ cage. */
  Sfp_10GMm = 'SFP_10G_MM',
  /** 10G single-mode fiber in a 10G SFP+ cage. */
  Sfp_10GSm = 'SFP_10G_SM'
}

/** Interface/connector type on a topology design link endpoint. */
export enum TopologyDesignInterfaceType {
  /** Direct Attach Copper connector. */
  Dac = 'DAC',
  /** Power connector. */
  Power = 'POWER',
  /** RJ45 copper connector. */
  Rj45 = 'RJ45',
  /** SFP module for multi-mode fiber. */
  SfpMm = 'SFP_MM',
  /** SFP module with RJ45 copper. */
  SfpRj45 = 'SFP_RJ45',
  /** SFP module for single-mode fiber. */
  SfpSm = 'SFP_SM'
}

/** A design-time cable connection between two topology design nodes. */
export type TopologyDesignLink = {
  __typename?: 'TopologyDesignLink';
  /** The unique identifier for this topology design link. */
  UUID: Scalars['UUID']['output'];
  /** Physical cable medium. */
  cableType: TopologyDesignCableType;
  /** Client-provided identifier, echoed back in upsert responses for reconciliation. */
  clientID?: Maybe<Scalars['String']['output']>;
  /** Intended link speed in Mbps (e.g. 1000, 10000, 25000). */
  intendedSpeedMbps: Scalars['Int']['output'];
  /** Link classification. */
  linkRole: TopologyDesignLinkRole;
  /** The node on side A. */
  nodeA: TopologyDesignNode;
  /** The node on side B. */
  nodeB: TopologyDesignNode;
  /** Interface type on side A. */
  sideAInterfaceType?: Maybe<TopologyDesignInterfaceType>;
  /** The UUID of the node on side A. */
  sideANodeUUID: Scalars['UUID']['output'];
  /** Port label on the side A device (e.g. '1', 'LAN1', 'WAN1'). Nullable for devices without ports, e.g. APs. */
  sideAPort?: Maybe<Scalars['String']['output']>;
  /** Interface type on side B. */
  sideBInterfaceType?: Maybe<TopologyDesignInterfaceType>;
  /** The UUID of the node on side B. */
  sideBNodeUUID: Scalars['UUID']['output'];
  /** Port label on the side B device (e.g. '1', 'LAN1', 'WAN1'). Nullable for devices without ports, e.g. APs. */
  sideBPort?: Maybe<Scalars['String']['output']>;
};

/** Classification of a topology design link's purpose. */
export enum TopologyDesignLinkRole {
  /** Client-facing link. */
  Client = 'CLIENT',
  /** HA cross-connect between paired controllers. */
  CrossConnect = 'CROSS_CONNECT',
  /** LAN downlink toward access layer. */
  LanDownlink = 'LAN_DOWNLINK',
  /** LAN uplink toward aggregation/core. */
  LanUplink = 'LAN_UPLINK',
  /** Out-of-band management link. */
  Oobm = 'OOBM',
  /** Power connection from PDU. */
  Power = 'POWER',
  /** Wide Area Network uplink. */
  Wan = 'WAN'
}

/** A design-time representation of a device in the intended network topology. */
export type TopologyDesignNode = {
  __typename?: 'TopologyDesignNode';
  /** The unique identifier for this topology design node. */
  UUID: Scalars['UUID']['output'];
  /** Building name or identifier where this device will be installed. */
  building?: Maybe<Scalars['String']['output']>;
  /** Client-provided identifier, echoed back in upsert responses for reconciliation. */
  clientID?: Maybe<Scalars['String']['output']>;
  /** Optional description of this node. */
  description?: Maybe<Scalars['String']['output']>;
  /** The intended device model identifier, e.g. S1, F3, G1, ISP_HANDOFF for design-only nodes, or a free-text model/kind for THIRD_PARTY nodes. */
  deviceModel: Scalars['String']['output'];
  /** The type of device. */
  deviceType: TopologyDesignDeviceType;
  /** Label of the distribution frame, e.g. MDF, IDF1, IDF2. */
  distributionFrameLabel?: Maybe<Scalars['String']['output']>;
  /** Whether this device lives in an MDF or IDF. */
  distributionFrameType?: Maybe<TopologyDesignDistributionFrameType>;
  /** Floor name or number within the building. */
  floor?: Maybe<Scalars['String']['output']>;
  /** Intended device label, e.g. MDF-C01, IDF1-A03. */
  label: Scalars['String']['output'];
  /** The links connected to this node. */
  links: Array<TopologyDesignLink>;
  /** Freeform notes about the installation location, e.g. kitchen, supply closet, above drop ceiling. */
  locationNotes?: Maybe<Scalars['String']['output']>;
  /** Label of the rack within the distribution frame. */
  rackLabel?: Maybe<Scalars['String']['output']>;
  /** Room within the floor where this device will be installed. */
  room?: Maybe<Scalars['String']['output']>;
  /** The switching layer this device operates at. Only applicable to switches. */
  switchingTier?: Maybe<SwitchProfileSwitchingTier>;
  /** The topology design version this node belongs to. */
  topologyDesignVersionUUID: Scalars['UUID']['output'];
  /** The provisioned virtual device, if this node has been linked to one. */
  virtualDevice?: Maybe<VirtualDevice>;
  /** Set once this design node has been provisioned into a real virtual device. */
  virtualDeviceUUID?: Maybe<Scalars['UUID']['output']>;
};

/** Physical medium for uplinks between an IDF and its parent MDF/IDF. */
export enum TopologyDesignUplinkConnectionType {
  /** Copper Ethernet. */
  Copper = 'COPPER',
  /** Multi-mode fiber. */
  FiberMm = 'FIBER_MM',
  /** Single-mode fiber. */
  FiberSm = 'FIBER_SM'
}

/** A single validation finding for a topology design. */
export type TopologyDesignValidationFinding = {
  __typename?: 'TopologyDesignValidationFinding';
  /** UUIDs of links involved in this finding. */
  linkUUIDs: Array<Scalars['UUID']['output']>;
  /** Human-readable description of the issue. */
  message: Scalars['String']['output'];
  /** UUIDs of nodes involved in this finding. */
  nodeUUIDs: Array<Scalars['UUID']['output']>;
  /** The rule that produced this finding. */
  ruleID: Scalars['String']['output'];
  /** How critical this finding is. */
  severity: TopologyDesignValidationSeverity;
};

/** Severity of a topology design validation finding. */
export enum TopologyDesignValidationSeverity {
  /** A critical issue that must be resolved. */
  Error = 'ERROR',
  /** A potential issue that should be reviewed. */
  Warning = 'WARNING'
}

/** A versioned topology design for a network. */
export type TopologyDesignVersion = {
  __typename?: 'TopologyDesignVersion';
  /** The unique identifier for this version. */
  UUID: Scalars['UUID']['output'];
  /** When this version was archived. */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who archived this version. */
  archivedByUser?: Maybe<User>;
  /** The generator's tick-by-tick build steps, persisted at generation. Empty for non-generated versions. */
  buildSteps: Array<TopologyDesignBuildStep>;
  /** When this version was committed. */
  committedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who committed this version. */
  committedByUser?: Maybe<User>;
  /** When this version was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The user who created this version. */
  createdByUser?: Maybe<User>;
  /** The exact generateTopologyDesign input that produced this version, persisted at generation. Null for non-generated versions and for versions generated before the input was captured. */
  generationInput?: Maybe<Scalars['JSONObject']['output']>;
  /** All design links in this version. */
  links: Array<TopologyDesignLink>;
  /** Human-readable name for this version. */
  name: Scalars['String']['output'];
  /** The network this version belongs to. */
  network: Network;
  /** The network this version belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** All design nodes in this version. */
  nodes: Array<TopologyDesignNode>;
  /** User-provided notes about this version. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Current lifecycle status. */
  status: TopologyDesignVersionStatus;
  /** When this version was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user who last updated this version. */
  updatedByUser?: Maybe<User>;
  /** Validation findings for this version's current node/link set, recomputed on read. */
  validations: Array<TopologyDesignValidationFinding>;
  /** When a deployment engineer signed off that this committed design matches the deployed network. Null until verified. */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The deployment engineer accountable for the verification. Set together with verifiedAt, so a verified design always names its owner. */
  verifiedByUser?: Maybe<User>;
};

/** Lifecycle status of a topology design version. */
export enum TopologyDesignVersionStatus {
  /** Historical snapshots of past committed versions. */
  Archived = 'ARCHIVED',
  /** The single source of truth for a network's topology design. */
  Committed = 'COMMITTED',
  /** Draft topologies. */
  Draft = 'DRAFT'
}

/** Represents the direction of network traffic. */
export enum TrafficDirection {
  /** Incoming traffic direction (Received traffic). */
  Rx = 'RX',
  /** Outgoing traffic direction (Transmitted traffic). */
  Tx = 'TX'
}

/** Enumeration of supported countries for activating Twilio cellular SIM cards. Deprecated. */
export enum TwilioCellularCountry {
  /** Canada */
  Ca = 'CA',
  /** Used for all other countries. */
  Other = 'OTHER',
  /** United States of America */
  Us = 'US'
}

/** A pair of hardware devices that are not associated with any virtual device in a network. */
export type UnassignedHardwareAndConnectedPhyInterface = {
  __typename?: 'UnassignedHardwareAndConnectedPhyInterface';
  /** The physical interface of the switch that the unassigned hardware device is connected to. */
  phyInterface: PhyInterface;
  /** The physically connected hardware device that is not associated with any virtual device in this network. */
  unassignedHardwareDevice: AccessPointHardwareDevice;
};

/** Represents a response containing unassigned hardware devices for a network. */
export type UnassignedHardwareDeviceForNetworkResponse = {
  __typename?: 'UnassignedHardwareDeviceForNetworkResponse';
  /** Tuples of unassigned hardware devices and the physical interfaces they are connected to. */
  unassignedHardwareConnections: Array<UnassignedHardwareAndConnectedPhyInterface>;
  /** The switch virtual device that the unassigned hardware device is connected to. */
  virtualDevice: SwitchVirtualDevice;
};

/** Specifies the referer types allowed for unauthenticated access. */
export enum UnauthenticatedReferer {
  /** Access from any referer. */
  Any = 'ANY',
  /** Access from a captive portal. */
  Captive = 'CAPTIVE',
  /** Access during installation. */
  Install = 'INSTALL'
}

/** Input type for unbinding a firewall rule from a physical interface. */
export type UnbindFirewallRuleFromPhyInterface = {
  /** UUID of the firewall rule to unbind. */
  firewallRuleUUID: Scalars['UUID']['input'];
  /** UUID of the physical interface to unbind the firewall rule from. */
  phyInterfaceUUID: Scalars['UUID']['input'];
};

/** Input type for unbinding a firewall rule from a VLAN. */
export type UnbindFirewallRuleFromVlan = {
  /** UUID of the firewall rule to unbind. */
  firewallRuleUUID: Scalars['UUID']['input'];
  /** UUID of the VLAN to unbind the firewall rule from. */
  vlanUUID: Scalars['UUID']['input'];
};

export type UnbindPolicyRoutingRuleInput = {
  /** The binding information to unbind from the policy routing rule. */
  binding: PolicyRoutingRuleBindingInput;
};

/** An underlay pool defines the IP pool used for the underlay network of a given network. */
export type UnderlayPool = {
  __typename?: 'UnderlayPool';
  /** The unique identifier of the underlay pool. */
  UUID: Scalars['UUID']['output'];
  /** The base IP address of the pool. */
  baseAddress: Scalars['IPV4']['output'];
  /** The date and time when the underlay pool was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The date and time when the underlay pool was deactivated, if applicable. */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The UUID of the network this underlay pool belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /** The CIDR prefix determining the size of the address pool. */
  prefixLength: Scalars['Int']['output'];
};

export type UpdateAccessPointPortProfileInput = {
  /** A human readable description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The new name for the port profile. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional port binding updates, keyed by binding UUID. Only specified bindings are updated. */
  portBindings?: InputMaybe<Array<UpdateAccessPointPortProfilePortBindingInput>>;
  /** Optional virtual device UUIDs to assign this profile to. Will overwrite previously assigned port profile for each device. */
  virtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type UpdateAccessPointPortProfilePortBindingInput = {
  /** The UUID of the port binding to update. */
  uuid: Scalars['UUID']['input'];
  /** The UUID of the VLAN to assign to this port. */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for updating a Company alert subscription. */
export type UpdateAlertCompanySubscriptionInput = {
  /** The input for the alert. Note that an error will be returned if the alert type differs from the existing alert subscription. */
  alertInput?: InputMaybe<AlertThresholdParamsInput>;
  /** The UUID of the alert receiver that receives notifications stemming from an evaluation of this alert subscription. Deprecated in favor of alertReceiverUUIDs. */
  alertReceiverUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The UUIDs of the alert receivers that receive notifications stemming from an evaluation of this alert subscription. If set, replaces the existing receivers entirely. */
  alertReceiverUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The description of the alert subscription. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The UUIDs of the networks to exclude from the alert subscription. Only valid for company-wide subscriptions. If set, the value provided here will overwrite any existing exclusions. */
  excludedNetworkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The UUIDs of the networks to include in the alert subscription. Only valid for non-company-wide subscriptions. If set, the value provided here will overwrite any existing inclusions. */
  includedNetworkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** If set to a different value, removes all network inclusions or exclusions that previously existed, in favor of whatever new values are provided in the input. */
  isCompanyWide?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the alert subscription is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The label of the alert subscription. */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a fleetwide alert subscription. */
export type UpdateAlertFleetwideSubscriptionInput = {
  /** The input for the alert. Note that an error will be returned if the alert type differs from the existing alert subscription. */
  alertInput?: InputMaybe<AlertThresholdParamsInput>;
  /** The UUID of the alert receiver that receives notifications stemming from an evaluation of this alert subscription. Deprecated in favor of alertReceiverUUIDs. */
  alertReceiverUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The UUIDs of the alert receivers that receive notifications stemming from an evaluation of this alert subscription. If set, replaces the existing receivers entirely. */
  alertReceiverUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The description of the alert subscription. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The company support tiers that the alert subscription is enabled for. If empty, the alert subscription is enabled for all company support tiers. */
  enabledCompanySupportTiers?: InputMaybe<Array<CompanySupportTier>>;
  /** The NOS upgrade channels that the alert subscription is enabled for. If empty, the alert subscription is enabled for all NOS upgrade channels. */
  enabledNOSUpgradeChannels?: InputMaybe<Array<NetworkNosUpgradeChannel>>;
  /** The UUIDs of the companies to exclude from the alert subscription. If set, the value provided here will overwrite any existing exclusions. */
  excludedCompanyUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The UUIDs of the networks to exclude from the alert subscription. If set, the value provided here will overwrite any existing exclusions. */
  excludedNetworkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The UUIDs of the companies to limit the alert subscription to. If set, the value provided here will overwrite any existing company inclusions. Exclusions take precedence over inclusions: a company or network that is both included and excluded is excluded. */
  includedCompanyUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The UUIDs of the networks to limit the alert subscription to. If set, the value provided here will overwrite any existing network inclusions. Exclusions take precedence over inclusions: a company or network that is both included and excluded is excluded. */
  includedNetworkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Whether the alert subscription is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The label of the alert subscription. */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** The provided list of targets replaces the existing targets entirely. Any targets not included in this list will be removed. */
export type UpdateAlertReceiverWithTargetsInput = {
  /** Updated label for the alert receiver. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** List of alert targets to associate with the alert receiver. This list will replace any existing targets. */
  targets?: InputMaybe<Array<AlertTargetInput>>;
};

/** Input for updating a Support Provider alert subscription. */
export type UpdateAlertSupportProviderSubscriptionInput = {
  /** The UUID of the alert subscription to update. */
  UUID: Scalars['UUID']['input'];
  /** The input for the alert. Note that an error will be returned if the alert type differs from the existing alert subscription. */
  alertInput?: InputMaybe<AlertThresholdParamsInput>;
  /** The UUIDs of the alert receivers that receive notifications stemming from an evaluation of this alert subscription. If set, replaces the existing receivers entirely. */
  alertReceiverUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The description of the alert subscription. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The UUIDs of the networks to exclude from the alert subscription. Only valid for company-wide subscriptions. If set, the value provided here will overwrite any existing exclusions. */
  excludedNetworkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The UUIDs of the networks to include in the alert subscription. Only valid for non-company-wide subscriptions. If set, the value provided here will overwrite any existing inclusions. */
  includedNetworkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** If set to a different value, removes all network inclusions or exclusions that previously existed, in favor of whatever new values are provided in the input. */
  isCompanyWide?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the alert subscription is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The label of the alert subscription. */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating an existing Salesforce alert target. */
export type UpdateAlertTargetSalesforceInput = {
  /** An updated domain to which alerts will be sent. */
  domain?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating an existing Slack alert target. */
export type UpdateAlertTargetSlackInput = {
  /** An updated Slack channel ID to which alerts will be sent. */
  channelID?: InputMaybe<Scalars['String']['input']>;
  /** An updated label for the Slack alert target. */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating an existing webhook alert target. */
export type UpdateAlertTargetWebhookInput = {
  /** An updated type of authentication to use for the webhook. */
  authType?: InputMaybe<WebhookAuthType>;
  /** An updated value of the authentication header to use for the webhook. */
  authValue?: InputMaybe<Scalars['String']['input']>;
  /** An updated label for the webhook alert target. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The OAuth client identifier. */
  oauthClientID?: InputMaybe<Scalars['String']['input']>;
  /** The OAuth client secret; not returned in responses. */
  oauthClientSecret?: InputMaybe<Scalars['String']['input']>;
  /** The HTTPS token endpoint. */
  oauthTokenURL?: InputMaybe<Scalars['String']['input']>;
  /** An updated secret used to sign webhook requests for verification. */
  signingSecret?: InputMaybe<Scalars['String']['input']>;
  /** An updated URL endpoint for the webhook. */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateApplicationDnsFirewallRuleApplicationVisibilities = {
  /** The ID of the application to update visibility for. */
  id: Scalars['Int']['input'];
  /** Indicates whether the application is visible to the customer. */
  isVisible: Scalars['Boolean']['input'];
};

export type UpdateApplicationDnsFirewallRuleInput = {
  /** The action to take when the rule is matched. */
  action?: InputMaybe<FirewallRuleAction>;
  /** The ID of the Netstar application to associate with the rule. */
  applicationID?: InputMaybe<Scalars['Int']['input']>;
  /** List of UUIDs of DHCP rules to which the application DNS firewall rule is bound. */
  boundDHCPRuleUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The ID of the Netstar category to associate with the rule. */
  categoryID?: InputMaybe<Scalars['Int']['input']>;
  /** Updates the DHCP rule the DNS firewall rule is associated with. If priority is not specified, will default to 1 greater than the highest existing priority. */
  dhcpRuleUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The domain or FQDN that is matched by the rule, allowing for wildcards denoted by '*'. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Netstar group to associate with the rule. */
  groupID?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the rule is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the DNS firewall rule. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The priority of the rule; if not specified, will default to 1 greater than the highest existing priority. */
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateApplicationDnsFirewallRulesInput = {
  /** The UUID of the DNS firewall rule to update. */
  applicationDNSFirewallRuleUUID: Scalars['UUID']['input'];
  /** The input data for updating the DNS firewall rule. */
  input: UpdateApplicationDnsFirewallRuleInput;
};

/** Input type for updating an existing AutoVPN group. */
export type UpdateAutoVpnGroupInput = {
  /** Updated BFD timing configuration. */
  bfd?: InputMaybe<UpdateBfdConfigInput>;
  /** The instance ASN used for the BGP session. Only takes effect when `useBGP` is true. */
  instanceASN?: InputMaybe<Scalars['Uint32']['input']>;
  /** Indicates if the AutoVPN group is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if hub failover is enabled. */
  isHubFailoverEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, updates all provided members. */
  members?: InputMaybe<Array<UpdateAutoVpnMembersInput>>;
  /** New name for the AutoVPN group. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** If set, any new members will not automatically be assigned these addresses. */
  reservedMemberAddresses?: InputMaybe<Array<IpRangeInput>>;
  /** Updated configuration of the hub's uplink. */
  uplink?: InputMaybe<CreateAutoVpnGroupHubUplinkInput>;
  /** The Auto VPN group uses a BGP backed version. This requires all associated networks support this implementation. */
  useBGP?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input type for updating an existing AutoVPN Hub. */
export type UpdateAutoVpnHubInput = {
  /** Indicates if failover is enabled for the hub. */
  isFailoverEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** New priority for the hub within the group. */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Updated configuration of the hub's uplink. */
  uplink?: InputMaybe<CreateAutoVpnGroupHubUplinkInput>;
};

/** Input type for batch-updating AutoVPN hubs. */
export type UpdateAutoVpnHubsInput = {
  /** Unique identifier of the hub to update. */
  UUID: Scalars['UUID']['input'];
  /** Update input parameters. */
  input: UpdateAutoVpnHubInput;
};

/** Updates an existing AutoVPN member-hub relationship. */
export type UpdateAutoVpnMemberHubInput = {
  /** If set, overrides the priority of hubs for this member only. If unset, `hub.priority` is used as priority. */
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAutoVpnMemberHubsInput = {
  /** The unique identifier of the Auto VPN member hub. */
  UUID: Scalars['UUID']['input'];
  /** Input for updating an auto VPN member hub. */
  input: UpdateAutoVpnMemberHubInput;
};

/** Updates an existing AutoVPN member. */
export type UpdateAutoVpnMemberInput = {
  /** IP address assigned to the member's uplink. */
  address?: InputMaybe<Scalars['IP']['input']>;
  /** Indicates if failover is enabled for the member's uplink. */
  isFailoverEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Port number the member listens on for VPN connections. */
  listenPort?: InputMaybe<Scalars['Int']['input']>;
  /** If set, updates multiple member hub inputs. */
  memberHubs?: InputMaybe<Array<UpdateAutoVpnMemberHubsInput>>;
  /** List of permitted VLAN unique identifiers. The associated VLANs must have participatesInVPNs set to true. */
  permittedVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Unique identifier of the physical interface used by the member's uplink. */
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateAutoVpnMembersInput = {
  /** The UUID of the member. */
  UUID: Scalars['UUID']['input'];
  /** The input values to apply to the member. */
  input: UpdateAutoVpnMemberInput;
};

/** Input type for updating an existing AutoVPN route in an AutoVPN group. */
export type UpdateAutoVpnRouteInput = {
  /** Destination gateway IP address for the route. */
  dstGateway?: InputMaybe<Scalars['IPV4']['input']>;
  /** Prefix length for the destination IP of the route. */
  dstPrefixLength?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates if the route is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** New name for the route. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for configuring BFD timing on a BGP neighbor or a BGP-backed AutoVPN group. */
export type UpdateBfdConfigInput = {
  /** The number of missed packets before declaring peer down. */
  detectMultiplier?: InputMaybe<Scalars['Int']['input']>;
  /** Interval at which BFD control packets are received. */
  receiveInterval?: InputMaybe<Scalars['Duration']['input']>;
  /** Interval at which BFD control packets are transmitted. */
  transmitInterval?: InputMaybe<Scalars['Duration']['input']>;
};

/** Input values for updating an existing BGP neighbor. */
export type UpdateBgpNeighborInput = {
  /** The list of custom prefixes to advertise to this neighbor. */
  advertisementPrefixes?: InputMaybe<Array<Scalars['IPPrefix']['input']>>;
  /** The list of VLAN subnets to advertise to this neighbor. */
  advertisementVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The unique identifier for the Auto VPN group associated with this neighbor. */
  autoVPNGroupUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The period between successive connect attempts, in seconds. */
  connectIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** A longer description for this neighbor. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The maximum number of hops between the router and neighbor. */
  ebgpNumMaxHops?: InputMaybe<Scalars['Int']['input']>;
  /** The period since the last received keep-alive before neighbor is dropped, in seconds. */
  holdIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The IP address for this neighbor. */
  ipAddress?: InputMaybe<Scalars['IP']['input']>;
  /** Whether the neighbor is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The period at which BGP keep-alive is sent, in seconds. */
  keepaliveIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The MD5 password used for authentication for this neighbor. */
  md5AuthPassword?: InputMaybe<Scalars['String']['input']>;
  /** A descriptive name for this neighbor. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier for the physical interface used to reach this neighbor. */
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The peer Autonomous System Number (ASN) for this neighbor. */
  remoteASN?: InputMaybe<Scalars['Uint32']['input']>;
  /** The interface used to reach this neighbor. */
  targetInterface?: InputMaybe<TargetInterfaceInput>;
  /** The unique identifier for the VLAN used to reach this neighbor. */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input type for updateBGPRouterForEvent. */
export type UpdateBgpRouterForEventInput = {
  /** BGP router associated with these routes. */
  bgpRouterUUID: Scalars['UUID']['input'];
  /** The routes to set for the BGP router. */
  routes?: InputMaybe<Array<InputMaybe<BgpRouterDynamicRouteInput>>>;
};

/** Input values for updating a BGP router. */
export type UpdateBgpRouterInput = {
  /** The unique identifier for the Auto VPN groups associated with this router. */
  autoVPNGroupUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A longer description for this router. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether this router is is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The local Autonomous System Number (ASN) for this router. */
  localASN?: InputMaybe<Scalars['Uint32']['input']>;
  /** The descriptive short name for this router. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input parameters for updating a Client VPN client. */
export type UpdateClientVpnClientInput = {
  /** Whether the client is enabled. If false, users will not be able to connect using this client's key. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the client. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The public key of the client. WARNING: THIS WILL INVALIDATE THE CLIENT'S PREVIOUS CONNECTION. */
  publicKey?: InputMaybe<Scalars['String']['input']>;
};

/** Input parameters for updating a Client VPN server. */
export type UpdateClientVpnServerInput = {
  /** IPv4 address to assign to the WireGuard interface. */
  address?: InputMaybe<Scalars['IPV4']['input']>;
  /** Subnet mask length (CIDR notation) for the WireGuard interface address. */
  addressMask?: InputMaybe<Scalars['Int']['input']>;
  /** The UUIDs for the VLANs that are accessible via connections through this client VPN server. */
  boundVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Default list of IP prefixes that clients are allowed to access. */
  defaultClientAllowedIPs?: InputMaybe<Array<Scalars['IPPrefix']['input']>>;
  /** Sets the default value used for the WireGuard option `DNS` for generated client configs. Must be IP addresses or fully qualified domain names. If set, used instead of `address` or `dnsListenAddress`. */
  defaultClientDNS?: InputMaybe<Array<Scalars['String']['input']>>;
  /** An additional listen address other than `address` this server serves DNS traffic on. It must be a private IP. */
  dnsListenAddress?: InputMaybe<Scalars['IPV4']['input']>;
  /** Whether the client VPN server is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set to true to enable failover between uplink physical interfaces (WANs). */
  isFailoverEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Port number on which the WireGuard server listens for incoming connections. */
  listenPort?: InputMaybe<Scalars['Int']['input']>;
  /** The name of this client VPN server. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Allows the client VPN server to be accessible over Auto VPN. */
  participatesInAutoVPN?: InputMaybe<Scalars['Boolean']['input']>;
  /** UUID of the uplink physical interface that the WireGuard server will listen on. */
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateCompanyInput = {
  /** Indicates if the company is prospective (used for sales purposes). */
  isProspective?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The S3 key (path) of the image file representing the company logo, stored in AWS S3.
   * This is not required; it overrides the default logo that we fetch from a 3rd party service.
   */
  logoS3Key?: InputMaybe<Scalars['String']['input']>;
  /** New name for the company. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** New slug for the company. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a Company Location. */
export type UpdateCompanyLocationInput = {
  /** Name of the location. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an existing group-to-role mapping. */
export type UpdateCompanyRoleMappingInput = {
  /** The UUID of the mapping to update. */
  UUID: Scalars['UUID']['input'];
  /** The slug of the company that owns the mapping. */
  companySlug: Scalars['String']['input'];
  /** The new IdP group name. */
  groupName: Scalars['String']['input'];
  /** For network-scoped roles, the UUID of the network. Omit for company-wide roles. */
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** For network-scoped roles, the UUIDs of the networks. Takes precedence over networkUUID when both are provided. */
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The new Meter role. */
  role: RoleName;
  /** For Meter mappings only: the slug of the company to assign the role at. */
  targetCompanySlug?: InputMaybe<Scalars['String']['input']>;
};

/** Input parameters for updating company SIEM integration. */
export type UpdateCompanySiemIntegrationInput = {
  /** Status of the integration. */
  status: CompanySiemIntegrationStatus;
};

/** Fields that can be updated for a company user. */
export type UpdateCompanyUserInput = {
  /** The new first name for the company user. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The new last name for the company user. */
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating a Connect Static Rate . */
export type UpdateConnectStaticRateInput = {
  /** UUID of Product type for the rate. */
  connectionTypeUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Download speed Kbps maximum for speed bucket (exclusive). */
  downloadKbpsMax?: InputMaybe<Scalars['Int']['input']>;
  /** Download speed Kbps minimum for speed bucket (inclusive). */
  downloadKbpsMin?: InputMaybe<Scalars['Int']['input']>;
  /** Install cost in cents. */
  installCostCents?: InputMaybe<Scalars['Int']['input']>;
  /** Monthly recurring cost in cents. */
  monthlyCostCents?: InputMaybe<Scalars['Int']['input']>;
  /** Term of contract in months. */
  termMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCountryDeviceCertificationInput = {
  /** The certification status of the device model in the country. */
  certificationStatus: CertificationStatus;
  /** ISO 3166-1 alpha-2 country code. */
  countryISO2: Scalars['String']['input'];
  /** The hardware device model. */
  deviceModel: DeviceModel;
  /** Freeform notes about the certification. */
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an existing custom role. */
export type UpdateCustomRoleInput = {
  /** The new built-in role to inherit from, if any. */
  inheritsFromRole?: InputMaybe<RoleName>;
  /** The new display name. */
  name: Scalars['String']['input'];
  /** The new set of own permissions. The caller must hold every permission listed. */
  permissions: Array<PermissionType>;
  /** The new scope. */
  scope: CustomRoleScope;
};

/** Input values for updating an existing DDNS record. */
export type UpdateDdnsRecordInput = {
  /** Optional description for this DDNS record. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The main domain name, must be a supported domain name. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** The unique subdomain for this DDNS record. */
  subdomain?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an existing DHCP option. */
export type UpdateDhcpOptionInput = {
  /**
   * The DHCP option code (also called tag). Refer to the IANA DHCP options list:
   * https://www.iana.org/assignments/bootp-dhcp-parameters/bootp-dhcp-parameters.xhtml
   */
  code?: InputMaybe<Scalars['Int']['input']>;
  /** The data value for the DHCP option. */
  data?: InputMaybe<Scalars['String']['input']>;
  /** If this is a custom (nonstandard) DHCP option, the type of the data. */
  dataType?: InputMaybe<DhcpOptionDataType>;
  /** An optional description for the DHCP option. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** If set, the option will only apply to devices with the given Vendor Class Identifier (VCI). */
  vendorClassID?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a DHCP proxy. */
export type UpdateDhcpProxyInput = {
  /** The IP address of this DHCP proxy. */
  ipAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The UUID of the uplink physical interface (WAN) that should be used for egress with this proxy. */
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for updating an existing DHCP reserved range. */
export type UpdateDhcpReservedRangeInput = {
  /** A human-readable description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The last reserved IP address in the range. */
  endIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The first reserved IP address in the range. */
  startIPAddress?: InputMaybe<Scalars['IP']['input']>;
};

/** Input for updating a specific DHCP reserved range identified by UUID. */
export type UpdateDhcpReservedRangeUuidInput = {
  /** The unique identifier of the DHCP reserved range to update. */
  UUID: Scalars['UUID']['input'];
  /** The input data for updating the DHCP reserved range. */
  input: UpdateDhcpReservedRangeInput;
};

/** Input for updating an existing DHCP rule. */
export type UpdateDhcpRuleInput = {
  /** List of DHCP proxies to create or update. */
  dhcpProxies?: InputMaybe<Array<UpsertDhcpProxyInput>>;
  /** Enables or disables DNS caching on the DHCP server. */
  dnsCacheIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specifies the maximum Time-To-Live (TTL) in seconds for cached DNS entries. */
  dnsCacheMaxTTL?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies the maximum number of DNS records to cache. */
  dnsCacheSize?: InputMaybe<Scalars['Int']['input']>;
  /** IP used as DNS proxy before forwarding requests to upstream DNS servers. Must be within the DHCP rule subnet and must be within a reserved range and not used by a static mapping. */
  dnsForwardingIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** List of DNS host mappings to create */
  dnsHostMappings?: InputMaybe<Array<UpdateDnsHostMappingInput>>;
  /** A list of DNS search domains provided to DHCP clients. */
  dnsSearchDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of upstream DNS servers to use. */
  dnsUpstreamServers?: InputMaybe<Array<Scalars['IP']['input']>>;
  /** Determines if the gateway acts as a DNS proxy for clients. */
  dnsUseGatewayProxy?: InputMaybe<Scalars['Boolean']['input']>;
  /** The last available IP address in the DHCP range, ascending and inclusive. */
  endIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The gateway IP address provided to DHCP clients. */
  gatewayIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The prefix length of the gateway IP address. */
  gatewayPrefixLength?: InputMaybe<Scalars['Int']['input']>;
  /** If set, the gateway IP address is allowed to be different from its VLAN's address. */
  hasGatewayOverride?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether this DHCP rule is for IPv6 (`true`) or IPv4 (`false`). */
  isIPv6?: InputMaybe<Scalars['Boolean']['input']>;
  /** The duration (in seconds) of the DHCP lease assigned to clients. */
  leaseDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** List of reserved IP ranges within the DHCP range to update. */
  reservedRanges?: InputMaybe<Array<UpdateDhcpReservedRangeUuidInput>>;
  /** The first available IP address in the DHCP range, ascending and inclusive. */
  startIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** List of static mappings between MAC addresses and IP addresses to update. It's valid to provide a static mapping inside a reserved range - the static mapping will take precedence. */
  staticMappings?: InputMaybe<Array<UpdateDhcpStaticMappingUuidInput>>;
};

/** Input for updating an existing DHCP static mapping. */
export type UpdateDhcpStaticMappingInput = {
  /** The hostname to assign to the client device. */
  hostname?: InputMaybe<Scalars['String']['input']>;
  /** The fixed IP address to assign to the client device. */
  ipAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The MAC address of the client device. */
  macAddress?: InputMaybe<Scalars['MacAddress']['input']>;
  /** A name or label for this static mapping. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a specific DHCP static mapping identified by UUID. */
export type UpdateDhcpStaticMappingUuidInput = {
  /** The unique identifier of the DHCP static mapping to update. */
  UUID: Scalars['UUID']['input'];
  /** The input data for updating the DHCP static mapping. */
  input: UpdateDhcpStaticMappingInput;
};

/** Input for updating an existing DNS host mapping. */
export type UpdateDnsHostMappingInput = {
  /** The domain to which `overrideDomain` should resolve. */
  destinationDomain?: InputMaybe<Scalars['String']['input']>;
  /** The IP address to which `overrideDomain` should resolve. Mutually exclusive with `destinationIPAddresses`. */
  destinationIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The IP addresses to which `overrideDomain` should resolve. Replaces any existing destination IP addresses. */
  destinationIPAddresses?: InputMaybe<Array<Scalars['IP']['input']>>;
  /** The UUID of dns host mapping rule to update. */
  dnsHostMappingUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Indicates whether this DNS host mapping is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The domain name to override. This can be a fully qualified domain name (FQDN) or a domain name. */
  overrideDomain?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDefaultRoleForUsersInput = {
  /** The name of the default role for users in the company (ie: company_admin_read_only) */
  defaultRoleForUsers: RoleName;
};

export type UpdateDeliverableInput = {
  /** Cancel this deliverable and its remaining tasks. Completed tasks prevent cancellation. Cannot be combined with other updates. False or null has no effect and does not restore a cancelled deliverable. */
  cancel?: InputMaybe<Scalars['Boolean']['input']>;
  /** If rejecting a review, specifying tasks here will reopen them (clear completed and cancelled state). Any tasks downstream of these tasks (ie those with explicit DeploymentTaskBlockers) will also be reopened. */
  deploymentTasksUUIDsToReopen?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Replaces the values submitted on the service request form. Validated like createServiceRequest, but no tasks are created. Document fields cannot be changed. */
  fields?: InputMaybe<Array<ServiceRequestFieldInput>>;
  /** The owner's verdict on the work product. */
  review?: InputMaybe<DeliverableReview>;
  /** The owner's description of the review. Only applicable when review is APPROVED or REJECTED. */
  reviewDescription?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDeploymentTaskExceptionInput = {
  /** Updated freeform notes describing the issue. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** When true, marks the exception cancelled by the current user. When false, clears cancellation. */
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, marks the exception resolved by the current user. When false, clears resolution. */
  isResolved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updated list of tagged user IDs. */
  taggedUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateDeploymentTaskExceptionMessageInput = {
  /** Updated message content. */
  message: Scalars['String']['input'];
};

/** Input for updating the read/archived state of a deployment task notification. */
export type UpdateDeploymentTaskNotificationInput = {
  /** If set, true sets archivedAt to now; false clears archivedAt; omit to leave unchanged. */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, true sets readAt to now; false clears readAt; omit to leave unchanged. */
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Used to update a hardware device in the dev (staging) realm for testing purposes. */
export type UpdateDevHardwareDeviceInput = {
  /** The model of the hardware device. */
  deviceModel?: InputMaybe<DeviceModel>;
  /** The type of the hardware device. */
  deviceType?: InputMaybe<DeviceType>;
  /** The MAC address of the hardware device. */
  macAddress?: InputMaybe<Scalars['MacAddress']['input']>;
};

/** Input type for updating a device notification snooze. */
export type UpdateDeviceNotificationSnoozeInput = {
  /** Alert types this snooze applies to. Set to an empty list to apply to all alert types. */
  alertTypes?: InputMaybe<Array<AlertType>>;
  /** The reason for the snooze. */
  snoozeReason?: InputMaybe<Scalars['String']['input']>;
  /** The time window for the snooze. */
  window?: InputMaybe<SnoozeNotificationSettingWindowInput>;
};

export type UpdateDocumentUploadInput = {
  /** An updated deployment-job document classification. */
  deploymentJobDocumentType?: InputMaybe<DocumentUploadDeploymentJobDocumentType>;
  /** Replaces the set of deployment jobs the document upload is scoped to, if provided. */
  deploymentJobUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** An updated description of the document upload. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** An updated human-readable name or label for the document upload. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Replaces the set of networks the document upload is scoped to, if provided. */
  networkUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** An updated S3 key (path) of the uploaded file. */
  s3Key?: InputMaybe<Scalars['String']['input']>;
  /** An updated type of the externally hosted document. */
  type?: InputMaybe<DocumentUploadType>;
  /** An updated URL of the externally hosted document. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating an existing 802.1X encryption configuration. All fields are optional; only provided fields will be updated. */
export type UpdateEncryption8021XInput = {
  /** The new IP address of the accounting server. If provided, accountingServerPort and accountingServerSecret must also be provided. */
  accountingServerIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The new port of the accounting server (1-65535). */
  accountingServerPort?: InputMaybe<Scalars['Int']['input']>;
  /** The new shared secret used to authenticate with the accounting server. */
  accountingServerSecret?: InputMaybe<Scalars['String']['input']>;
  /** The new IP address of the authentication server.. */
  authServerIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The new port of the authentication server. */
  authServerPort?: InputMaybe<Scalars['Int']['input']>;
  /** The new shared secret used to authenticate with the authentication server. */
  authServerSecret?: InputMaybe<Scalars['String']['input']>;
  /** The new status of the RadiusPoller service */
  isRadiusPollerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A new label for the encryption configuration. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The interval in seconds between each poll to the radius server. When null, the firmware-imposed interval is used. */
  radiusPollerIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The UUIDs of the access point virtual devices that poll the radius server. Selected access points must broadcast an enabled SSID configured with this profile. Pass null to have all access points configured with the profile poll, or an empty list to have none poll. */
  radiusPollerVirtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Input type for updating an existing firewall rule. */
export type UpdateFirewallRuleInput = {
  /** The action to take when the firewall rule matches (e.g., DENY or PERMIT). */
  action?: InputMaybe<FirewallRuleAction>;
  /**
   * List of UUIDs of physical interfaces to which the firewall rule is bound.
   * The physical interfaces must be uplinks.
   */
  boundPhyInterfaceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** List of UUIDs of VLANs to which the firewall rule is bound. */
  boundVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A description of the firewall rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Destination IPv4 address patterns to match traffic to, e.g. `10.1-4.*.2/31`.
   * May be combined with `dstPrefixes`.
   */
  dstAddressPatterns?: InputMaybe<Array<Scalars['IPAddressPattern']['input']>>;
  /** UUID of the destination client VPN server to match traffic to. */
  dstClientVPNServerUUID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Destination FQDNs to match traffic to: an exact name, or `*.` followed by a name to match its subdomains only.
   * Matches the addresses the device has seen each name resolve to in the DNS answers it serves.
   * May be combined with `dstPrefixes` and `dstAddressPatterns`.
   */
  dstFQDNs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** UUID of the destination IPSec tunnel to match traffic to. */
  dstIPSecTunnelUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Deprecated. Use `dstPortRanges` instead. Single destination port range to match. */
  dstPortRange?: InputMaybe<PortRangeInput>;
  /** List of destination port ranges to match traffic to. */
  dstPortRanges?: InputMaybe<Array<PortRangeInput>>;
  /** Destination IP prefix to match traffic to. */
  dstPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
  /** Destination IP prefixes to match traffic to. */
  dstPrefixes?: InputMaybe<Array<Scalars['IPPrefix']['input']>>;
  /** UUID of the destination VLAN to match traffic to. */
  dstVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Indicates if the firewall rule should be applied bidirectionally. */
  isBidirectional?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the firewall rule is currently enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates that the rule is managed by Meter and cannot be modified. */
  isMeterInternal?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the firewall rule. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Priority of the rule within the network, lower priority rules are applied first.
   * If there is an existing rule with the provided value, it and all subsequent occupied values will be incremented.
   */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Deprecated. Use `protocols` instead. Single IP protocol to match. */
  protocol?: InputMaybe<IpProtocol>;
  /** List of IP protocols to match. */
  protocols?: InputMaybe<Array<IpProtocol>>;
  /**
   * Source IPv4 address patterns to match traffic from, e.g. `10.1-4.*.2/31`.
   * May be combined with `srcPrefixes`.
   */
  srcAddressPatterns?: InputMaybe<Array<Scalars['IPAddressPattern']['input']>>;
  /** UUID of the source client VPN server to match traffic from. */
  srcClientVPNServerUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** UUID of the source IPSec tunnel to match traffic from. */
  srcIPSecTunnelUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Deprecated. Use `srcPortRanges` instead. Single source port range to match. */
  srcPortRange?: InputMaybe<PortRangeInput>;
  /** List of source port ranges to match traffic from. */
  srcPortRanges?: InputMaybe<Array<PortRangeInput>>;
  /** Source IP prefix to match traffic from. */
  srcPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
  /** Source IP prefixes to match traffic from. */
  srcPrefixes?: InputMaybe<Array<Scalars['IPPrefix']['input']>>;
  /** UUID of the source VLAN to match traffic from. */
  srcVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** List of tags associated with the firewall rule. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input type for updating multiple existing firewall rules. */
export type UpdateFirewallRulesInput = {
  /** UUID of an existing firewall rule. */
  firewallRuleUUID: Scalars['UUID']['input'];
  /** Input data to apply to the firewall rule referred to by `firewallRuleUUID`. */
  input: UpdateFirewallRuleInput;
};

export type UpdateFloorPlanInput = {
  /** An updated description of the floor plan. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The type of the document. */
  documentCategory?: InputMaybe<FloorPlanDocumentCategory>;
  /** An updated S3 key (path) of the image file representing the floor plan. */
  imageS3Key?: InputMaybe<Scalars['String']['input']>;
  /** An updated human-readable name or label for the floor plan. */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating high availability event status. */
export type UpdateForHighAvailabilityEventInput = {
  /** The new status of the high availability event. */
  status: HighAvailabilityStatus;
};

/** Input type for updating a gateway profile. */
export type UpdateGatewayProfileInput = {
  /**
   * Indicates whether the gateway device should send logs to the backend.
   * Off by default because shipped logs incur a cost per megabyte sent over the cellular connection.
   */
  isLogShippingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input type for updating the gateway uplink settings for a network's firewalls. */
export type UpdateGatewayUplinkSettingsInput = {
  /** Whether to allow gateway ports to be enabled as uplinks on the network's firewalls. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Specifies the metadata that can be updated for a hardware device. */
export type UpdateHardwareDeviceInput = {
  /** [Deprecated] Use 'isSpare' instead. Indicates whether the hardware device is active. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable the hardware device's console port. */
  consoleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set the hardware device's factory mode status. */
  factoryMode?: InputMaybe<Scalars['Boolean']['input']>;
  /** Internal operator-only notes about this hardware device. */
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Change the hardware device's MAC address because of erroneous bookkeeping. Caution: This should only be done in exceptional cases. */
  macAddress?: InputMaybe<Scalars['MacAddress']['input']>;
  /** Mark the hardware device as retired. */
  retired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mark the hardware device as an RMA (Return Merchandise Authorization) replacement device. */
  rma?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input type for updating a high availability firewall pair. */
export type UpdateHighAvailabilityPairInput = {
  /** Interval at which the firewalls will advertise to one another, in milliseconds. Must be at least 300ms. */
  advertisementIntervalMs?: InputMaybe<Scalars['Int']['input']>;
  /** Existing VLAN UUID to use for the advertisement VLAN. */
  advertisementVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** UUID of the PhyInterface for the firewall to be configured as backup in the HA setup. */
  backupPhyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Enable or disable preemption for the HA firewalls in VRRP. */
  preempt?: InputMaybe<Scalars['Boolean']['input']>;
  /** UUID of the PhyInterface for the firewall to be configured as primary in the HA setup. */
  primaryPhyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input type for updating an existing host monitoring target. */
export type UpdateHostMonitoringTargetInput = {
  /** A new description for the host monitoring target. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether the host monitoring target is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this target is used to compute whether a WAN should failover. Only available if `type` is `PING`. */
  isUsedForWANFailover?: InputMaybe<Scalars['Boolean']['input']>;
  /** The type of monitoring to perform on the target host. */
  type?: InputMaybe<HostMonitoringType>;
};

export type UpdateHotspot20Input = {
  /** An optional value for the Hotspot 2.0 Access network type. */
  accessNetworkType?: InputMaybe<Scalars['Int']['input']>;
  /** A list of Hotspot 2.0 domain names. */
  domainNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether the Hotspot 2.0 is enabled */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional label for the Hotspot 2.0 profile. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** A list of MCC/MNC pairs, formatted as "MCC,MNC". */
  mccMncPairs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of Hotspot 2.0 NAI realms. */
  naiRealms?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of Operator names for Hotspot 2.0 (one per language). */
  operatorNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of Hotspot 2.0 Consortium OIs (Organization Identifiers). */
  roamingConsortiumOIs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** An optional value for the Hotspot 2.0 Venue group. */
  venueGroup?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A list of Venue names for Hotspot 2.0 (one per language); must be formatted with a two or three character language code separated by a colon from the venue name.
   * If at least one is set, hs20VenueGroup and hs20VenueType must be set.
   */
  venueNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** An optional value for the Hotspot 2.0 Venue type. */
  venueType?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateIdsipsConfigInput = {
  /** If set, replaces the list of bound categories. */
  boundCategories?: InputMaybe<Array<IdsipsConfigCategoryBindingInput>>;
  /** If set, replaces the list of bound rules. */
  boundRules?: InputMaybe<Array<IdsipsConfigRuleBindingInput>>;
  /** VLANs to enable IDS/IPS for. The enabled VLANs will be set to this value if provided. */
  enabledVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** How long rules generated by IPS stay valid. */
  ipsRuleDuration?: InputMaybe<Scalars['Duration']['input']>;
  /** If east-west protection is enabled. */
  isEastWestProtectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The IPS minimum severity to act on. */
  minIPSSeverity?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum severity to act on. */
  minSeverity?: InputMaybe<Scalars['Int']['input']>;
  /** The mode IDS/IPS should act in. */
  mode?: InputMaybe<IdsipsMode>;
  /** List of subnets that should never be blocked. */
  safelist?: InputMaybe<Array<Scalars['IPPrefix']['input']>>;
  /** If set, replaces the list of category suppressions. */
  suppressedCategories?: InputMaybe<Array<IdsipsConfigCategorySuppressionInput>>;
  /** If set, replaces the list of rule suppressions. */
  suppressedRules?: InputMaybe<Array<IdsipsConfigRuleSuppressionInput>>;
};

/** A custom intrusion rule definition for IDS/IPS. These currently apply tls.sni rules. */
export type UpdateIdsipsCustomRuleInput = {
  /** The action this rule applies. */
  action?: InputMaybe<FirewallRuleAction>;
  /** The ID of the Netstar application to associate with the rule. */
  applicationID?: InputMaybe<Scalars['Int']['input']>;
  /** List of UUIDs of VLANs to which the rule is bound. */
  boundVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The FQDN this rule applies to. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** If this rule is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A name to identify this rule. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating IP forwarding rule. */
export type UpdateIpForwardingRuleInput = {
  /** If rule is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of this rule. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The uplink interface associated with the rule. */
  uplinkPhyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The UUID of VLAN associated with this rule. */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input type for updating an existing IPSec tunnel. */
export type UpdateIpSecTunnelInput = {
  /** Sets if outbound traffic can be sent over this tunnel */
  allowOutboundTraffic?: InputMaybe<Scalars['Boolean']['input']>;
  /** The authentication algorithm to use for the IPSec connection. */
  authenticationAlgorithm?: InputMaybe<IpSecAuthenticationAlgorithm>;
  /** List of Auto VPN spoke VLANs to bind the IPSec tunnel to. */
  autoVPNVLANs?: InputMaybe<Array<IpSecTunnelAutoVpnvlanInput>>;
  /** Sets the close action for the tunnel. */
  closeAction?: InputMaybe<IpSecCloseAction>;
  /** Sets the DPD action for the tunnel. */
  dpdAction?: InputMaybe<IpSecDpdAction>;
  /** Sets the DPD delay for the tunnel. */
  dpdDelay?: InputMaybe<Scalars['Duration']['input']>;
  /** Sets the DPD timeout for the tunnel. */
  dpdTimeout?: InputMaybe<Scalars['Duration']['input']>;
  /** The encryption algorithm to use for the IPSec connection. */
  encryptionAlgorithm?: InputMaybe<IpSecEncryptionAlgorithm>;
  /** Sets the ikelifetime for the tunnel. */
  ikeLifetime?: InputMaybe<Scalars['Duration']['input']>;
  /** Whether BGP can be used for this tunnel. */
  isBGPEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If true, adds Client VPN subnets to the local traffic selectors,
   * effectively allowing Client VPN clients to route traffic over the IPSec tunnel.
   */
  isClientVPNBound?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the IPSec tunnel should be enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether this tunnel should initiate the connection to the right participant. */
  isInitiator?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Diffie-Hellman group to use for key exchange in the IPSec connection. */
  keyExchangeDHGroup?: InputMaybe<IpSecDhGroup>;
  /** Identifier for the left participant (this side) for authentication purposes. Must be a FQDN, email, or IPv4 address. */
  leftID?: InputMaybe<Scalars['String']['input']>;
  /** The MTU of the tunnel interface in bytes. When null, the device default is used. */
  mtu?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the IPSec tunnel. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Allows for vendor specific configuration based on this peer type */
  peerType?: InputMaybe<IpSecPeerType>;
  /** The authentication algorithm used in Phase 2  for the IPSec connection. */
  phase2AuthenticationAlgorithm?: InputMaybe<IpSecAuthenticationAlgorithm>;
  /** The encryption algorithm used in Phase 2 for the IPSec connection. */
  phase2EncryptionAlgorithm?: InputMaybe<IpSecEncryptionAlgorithm>;
  /** The Diffie-Hellman group used in Phase 2 for key exchange in the IPSec connection. */
  phase2KeyExchangeDHGroup?: InputMaybe<IpSecDhGroup>;
  /** UUID of the physical interface to bind the IPSec tunnel to; must be an uplink interface. */
  phyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The pre-shared key for authentication; can be base64 encoded or plaintext. */
  presharedKey?: InputMaybe<Scalars['String']['input']>;
  /** Priority for the interface, lower priorities will be preferred. Only available for supporting implementations. */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Sets the reauth for the tunnel, true = yes, false = no */
  reauth?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sets the rekey for the tunnel, true = yes, false = no */
  rekey?: InputMaybe<Scalars['Boolean']['input']>;
  /** The public IP address or hostname of the right participant's gateway. */
  right?: InputMaybe<Scalars['String']['input']>;
  /** Identifier for the right participant (remote side) for authentication purposes. Must be a FQDN, email, or IPv4 address. */
  rightID?: InputMaybe<Scalars['String']['input']>;
  /** List of IP prefixes representing the private subnets behind the right participant. */
  rightPrefixes?: InputMaybe<Array<Scalars['IPPrefix']['input']>>;
  /** Sets if outbound traffic can be sent over this tunnel */
  useAsDefaultRoute?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of VLAN UUIDs to bind the IPSec tunnel to. */
  vlanUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Virtual Tunnel Interface for the tunnel. */
  vti?: InputMaybe<IpSecTunnelVtiInput>;
  /** Weight for the interface, higher values will be given more weight when multiple tunnels are active. Only available for supporting implementations. */
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateInternalNoteInput = {
  /** Indicates whether the note is marked as important. */
  isImportant?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updated content of the internal note. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Attach up to five photos. Use `createPreSignedUploadUrl` to generate the S3 keys and presigned upload URLs. */
  photoS3Keys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tags associated with the note. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input type for updating an existing ISP document. */
export type UpdateInternetServicePlanDocumentInput = {
  /** Name of the document. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Notes regarding the document. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Type of document. */
  type?: InputMaybe<InternetServicePlanDocumentType>;
};

/** Input type for updating an existing fulfillment job. */
export type UpdateInternetServicePlanFulfillmentJobInput = {
  /** Estimated date of completion. */
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Notes regarding the job. */
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating an existing fulfillment task. */
export type UpdateInternetServicePlanFulfillmentTaskInput = {
  /** Date completed. */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Notes regarding the task. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Date scheduled to start. */
  scheduledFor?: InputMaybe<Scalars['DateTime']['input']>;
  /** Date started. */
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input type for updating an existing Internet Service Plan. */
export type UpdateInternetServicePlanInput = {
  /** Provider account number of the plan. */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Provider account number PIN. */
  accountPIN?: InputMaybe<Scalars['String']['input']>;
  /** Meter is to handle billing for this plan. */
  billingRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique identifier of the provider that brokered the ISP. */
  brokerProviderUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Slug identifier for the company. */
  companySlug?: InputMaybe<Scalars['String']['input']>;
  /** Connection details to update, including product and status. */
  connection?: InputMaybe<InternetServicePlanConnectionInput>;
  /** Download speed of the plan. */
  downloadKbps?: InputMaybe<Scalars['Int']['input']>;
  /** Additional cost incurred to expedite the install, if any. */
  expeditedInstallCostCents?: InputMaybe<Scalars['Int']['input']>;
  /** SFDC id of Circuit object. */
  externalID?: InputMaybe<Scalars['String']['input']>;
  /** Handoff type left by ISP. */
  handoffType?: InputMaybe<IspHandoffType>;
  /** Indicates whether the ISP connection has or is to have a static IP address or range. */
  hasStaticIP?: InputMaybe<Scalars['Boolean']['input']>;
  /** Install costs cost of the plan.  */
  installCostCents?: InputMaybe<Scalars['Int']['input']>;
  /** Wholesale install cost of the plan. */
  installCostWholesaleCents?: InputMaybe<Scalars['Int']['input']>;
  /** The install was escalated. */
  installEscalated?: InputMaybe<Scalars['Boolean']['input']>;
  /** The install was expedited. */
  installExpedited?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL from Provider for tracking install progress. */
  installationTrackingURL?: InputMaybe<Scalars['String']['input']>;
  /** IP configuration details to update. */
  ipConfiguration?: InputMaybe<InternetServicePlanIpInput>;
  /** Unique identifier of the mailing address where the Internet Service Plan will be created. */
  mailingAddressUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Monthly recurring cost of the plan. */
  monthlyCostCents?: InputMaybe<Scalars['Int']['input']>;
  /** Monthly wholesale cost of the plan. */
  monthlyCostWholesaleCents?: InputMaybe<Scalars['Int']['input']>;
  /** Signals when the ISP data should be reviewed by Connect, typically for when data was provided by the customer. */
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique identifier of the network where the Internet Service Plan will be created. */
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Freeform notes associated with the plan. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Origin of the plan. */
  origin?: InputMaybe<InternetServicePlanOrigin>;
  /** The owner of the plan. */
  owner?: InputMaybe<InternetServicePlanOwner>;
  /** Procurement channel/pricing method for the circuit. */
  procurementChannel?: InputMaybe<ConnectProcurementChannel>;
  /** Label the provider tags the circuit with in the physical space after install completion. */
  providerCircuitID?: InputMaybe<Scalars['String']['input']>;
  /** External ID of associated order in Provider API. */
  providerOrderID?: InputMaybe<Scalars['String']['input']>;
  /** External ID of associated circuit/service in Provider API. */
  providerServiceID?: InputMaybe<Scalars['String']['input']>;
  /** Flag signaling a request is made to run a provider service status update. */
  providerServiceStatusUpdatePending?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique identifier of the ISP provider to update. */
  providerUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Cost of the riser work associated with fulfilling this plan. */
  riserCostCents?: InputMaybe<Scalars['Int']['input']>;
  /** Unique identifier of the ISP sub provider to update. */
  subProviderUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Unique identifier of the sublocation to associate with the Internet Service Plan. */
  sublocationUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Internal users handling fulfillment/support for the plan. */
  supportUsers?: InputMaybe<Array<InternetServicePlanSupportUserInput>>;
  /** Length of the contract in months. */
  termMonths?: InputMaybe<Scalars['Int']['input']>;
  /** Actual contract term in months committed to with the underlying carrier, which may differ from the customer-facing termMonths. */
  termMonthsInternal?: InputMaybe<Scalars['Int']['input']>;
  /** Updates for associated PhyInterfaces. */
  updatePhyInterfaces?: InputMaybe<Array<UpdateInternetServicePlanPhyInterfaceInput>>;
  /** Upload speed of the plan. */
  uploadKbps?: InputMaybe<Scalars['Int']['input']>;
  /** The far-end (Z-side) address for a point-to-point circuit product. Looked up or created as needed. */
  zSideAddress?: InputMaybe<CreateAddressInput>;
};

/** Input type updating associated PhyInterfaces */
export type UpdateInternetServicePlanPhyInterfaceInput = {
  /** UUID of associated PhyInterface. */
  UUID: Scalars['UUID']['input'];
  /** Update input for PhyInterface. */
  input: UpdatePhyInterfaceInput;
};

/** Input type for updating an existing Internet Service Plan Provider. */
export type UpdateInternetServicePlanProviderInput = {
  /** Alternative names for Internet Service Provider used in 3rd party APIs.  Replaces all existing. */
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contract terms this provider offers, per connection type. Replaces all existing. */
  connectionTypeTerms?: InputMaybe<Array<ProviderConnectionTypeTermInput>>;
  /** AWS S3 key of the square icon image. */
  iconS3Key?: InputMaybe<Scalars['String']['input']>;
  /** Is a preferred provider, typically to have discounted pricing and expedited install. */
  isPreferred?: InputMaybe<Scalars['Boolean']['input']>;
  /** AWS S3 key of the landscape logo image. */
  logoS3Key?: InputMaybe<Scalars['String']['input']>;
  /** Name of the provider. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating a Internet Service Plan Provider Static Rate. */
export type UpdateInternetServicePlanProviderStaticRateInput = {
  /** UUID of Product type for the rate. */
  connectionTypeUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Data cap in GB. */
  dataCapGB?: InputMaybe<Scalars['Int']['input']>;
  /** Download speed Kbps. */
  downloadKbps?: InputMaybe<Scalars['Int']['input']>;
  /** Enabled status of the rate. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Install cost in cents. */
  installCostCents?: InputMaybe<Scalars['Int']['input']>;
  /** Install wholesale cost. */
  installCostWholesaleCents?: InputMaybe<Scalars['Int']['input']>;
  /** Describes dependency of the static rate on a location. */
  locationMode?: InputMaybe<InternetServicePlanProviderStaticRateLocationMode>;
  /** Monthly recurring cost in cents. */
  monthlyCostCents?: InputMaybe<Scalars['Int']['input']>;
  /** Monthly wholesale cost. */
  monthlyCostWholesaleCents?: InputMaybe<Scalars['Int']['input']>;
  /** Procurement channel/pricing method for the proposed circuit. */
  procurementChannel?: InputMaybe<ConnectProcurementChannel>;
  /** Term of contract in months. */
  termMonths?: InputMaybe<Scalars['Int']['input']>;
  /** Upload speed Kbps. */
  uploadKbps?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for updating a lab reservation. */
export type UpdateLabReservationInput = {
  /** The end time of this reservation. */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Replaces the whole set of reserved resources when provided. */
  labResourceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The note for this reservation. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The start time of this reservation. */
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input for updating a lab resource. */
export type UpdateLabResourceInput = {
  /** The kind of lab resource. */
  kind?: InputMaybe<Scalars['String']['input']>;
  /** The metadata for this lab resource. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The name of the lab resource. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The parent lab resource if any. */
  parent?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for updating an availability record. Omitted fields are left unchanged. */
export type UpdateLocationProviderAvailabilityInput = {
  /** Whether a NEAR_NET or OFF_NET availability makes the product recommendable. ON_NET availabilities are always recommendable. */
  recommendable?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input object for updating a maintenance window. */
export type UpdateMaintenanceWindowInput = {
  /** The ending day of the week for the maintenance window, in local time (0-6, where 0 is Sunday). */
  endDayOfWeekLocal?: InputMaybe<Scalars['Int']['input']>;
  /** The ending hour of the maintenance window, in local time (0-23). */
  endHourOfDayLocal?: InputMaybe<Scalars['Int']['input']>;
  /** For DAILY recurrence windows only. Specifies days of the week (0-6, where 0 is Sunday) to exclude from the maintenance window. */
  excludedDaysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Indicates whether the maintenance window is opted out (true) or not (false). */
  isOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  /** The recurrence pattern of the maintenance window (daily or weekly). */
  recurrence?: InputMaybe<MaintenanceWindowRecurrence>;
  /** The starting day of the week for the maintenance window, in local time (0-6, where 0 is Sunday). */
  startDayOfWeekLocal?: InputMaybe<Scalars['Int']['input']>;
  /** The starting hour of the maintenance window, in local time (0-23). */
  startHourOfDayLocal?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMarketingChangelogEntryInput = {
  /** Properties to display inside a badge alongside the changelog entry. */
  badge?: InputMaybe<DisplayBadgeInput>;
  /** Descriptive copy text for the marketing changelog entry. */
  copy?: InputMaybe<Scalars['String']['input']>;
  /** Informational heading text for the marketing changelog entry. */
  heading?: InputMaybe<Scalars['String']['input']>;
  /** A pair of theme-dependent images to display alongside the changelog entry. */
  imageS3Keys?: InputMaybe<ThemedImageS3KeysInput>;
  /** A destination to link to that contains more information about the changelog entry. */
  linkURL?: InputMaybe<Scalars['String']['input']>;
  /** When the entry stops being visible to customers. */
  visibleEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** When the entry starts being visible to customers. */
  visibleStartAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input values for updating a monitor group. */
export type UpdateMonitorGroupInput = {
  /** Desired set of members. Replaces all existing members when provided. */
  members?: InputMaybe<Array<MonitorGroupMemberInput>>;
  /** Name of the group. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Percentage of probes that must be healthy (0-100.00). */
  requiredHealthyPercent?: InputMaybe<Scalars['Float']['input']>;
};

/** Input for updating a probe binding's evaluation parameters in a group. */
export type UpdateMonitorGroupMemberInput = {
  /** Evaluation parameters for this probe binding. */
  evalParams: MonitorEvalParamsInput;
};

/** Input values for updating a monitor probe. */
export type UpdateMonitorProbeInput = {
  /** Desired set of bindings. Replaces all existing bindings when provided. */
  bindings?: InputMaybe<Array<CreateMonitorProbeBindingInput>>;
  /** DNS probe parameters. */
  dnsParams?: InputMaybe<DnsProbeParamsInput>;
  /** ICMP probe parameters. */
  icmpParams?: InputMaybe<IcmpProbeParamsInput>;
  /** Time between probe attempts. */
  probeInterval?: InputMaybe<Scalars['Duration']['input']>;
  /** Random jitter added to probe interval. */
  probeJitter?: InputMaybe<Scalars['Duration']['input']>;
  /** Maximum time to wait for probe response. */
  probeTimeout?: InputMaybe<Scalars['Duration']['input']>;
  /** Type of probe. */
  probeType?: InputMaybe<MonitorProbeType>;
  /** TCP probe parameters. */
  tcpParams?: InputMaybe<TcpProbeParamsInput>;
};

export type UpdateNacConfigInput = {
  /** Whether NAC is enabled for this network. When disabled, all RADIUS auth requests are rejected. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Network-wide device limit. */
  maxDevicesPerUser?: InputMaybe<Scalars['Int']['input']>;
  /** Network-wide session timeout in seconds. */
  sessionTimeoutSec?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateNacCredentialInput = {
  /** New full membership list. Empty list clears memberships, null or omitted leaves them unchanged. */
  groupUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** New display name. Null clears it, omit to leave it unchanged. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** New password. Null or omitted leaves it unchanged. User identities only. */
  password?: InputMaybe<Scalars['String']['input']>;
  /**
   * If true, clears the password and issues a fresh setup token, emailing the user
   * a link to set their own password. Mutually exclusive with `password`. User
   * identities only.
   */
  userSetsPassword?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateNacGroupInput = {
  /** New full membership list. Empty list clears membership, null or omitted leaves it unchanged. */
  credentialUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** New description. Null clears the existing description, omit to leave it unchanged. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** New name. Null or omitted leaves it unchanged. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNacIdPConfigInput = {
  /** For Google Secure LDAP, a new Secure LDAP client certificate, PEM-encoded. */
  clientCert?: InputMaybe<Scalars['String']['input']>;
  /** For Google Secure LDAP, a new Secure LDAP client private key, PEM-encoded. */
  clientKey?: InputMaybe<Scalars['String']['input']>;
  /** The customer's primary domain (eg meter.com). */
  domain: Scalars['String']['input'];
  /** For Entra, a new Application (client) ID. */
  entraClientID?: InputMaybe<Scalars['String']['input']>;
  /** For Entra, a new client secret. */
  entraClientSecret?: InputMaybe<Scalars['String']['input']>;
  /** For Entra, the Secret ID of the new client secret. */
  entraClientSecretID?: InputMaybe<Scalars['UUID']['input']>;
  /** For Entra, a new Directory (tenant) ID. */
  entraTenantID?: InputMaybe<Scalars['String']['input']>;
  /** For Okta, a new native app client ID. */
  oktaClientID?: InputMaybe<Scalars['String']['input']>;
  /** For Okta, a new native app client secret. */
  oktaClientSecret?: InputMaybe<Scalars['String']['input']>;
  /** For Okta, a new org URL. */
  oktaOrgURL?: InputMaybe<Scalars['String']['input']>;
  /** For Okta, a new API services app client ID. */
  oktaServiceClientID?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNacIdPGroupMappingInput = {
  /** Human-readable name for the external group. */
  idpGroupDisplayName: Scalars['String']['input'];
  /** The external IdP group key. */
  idpGroupName: Scalars['String']['input'];
  /** The NAC group to map the external group to. */
  nacGroupUUID: Scalars['UUID']['input'];
};

export type UpdateNacPolicyInput = {
  /** New description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** New accept/reject behavior. Accept policies require a VLAN, reject policies must not have one. */
  isAccept?: InputMaybe<Scalars['Boolean']['input']>;
  /** New enabled state. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** New label. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** New device limit: max distinct devices per user within a rolling window. */
  maxDevicesPerUser?: InputMaybe<Scalars['Int']['input']>;
  /** New session timeout. */
  sessionTimeoutSec?: InputMaybe<Scalars['Int']['input']>;
  /** New VLAN. */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateNosUpgradeGroupInput = {
  /** A human-friendly description of the group. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** A human-friendly label for the group. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * The priority of the NOS upgrade group; lower values are higher priority. Groups of devices will be upgraded in order of priority.
   *
   * If set, for an update of a single NOS upgrade group, the group will be inserted at the given priority, bumping all equal or lesser groups to an inferior priority. Different from the create input - if not set, no changes will be made to the priority.
   *
   * When specifying this value for a bulk-update of many groups, the auto-ordering logic above is not applied. If the priority provided collides with another group's priority (or to-be-updated priority), then an error is returned.
   */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** How long to wait for all devices in the group to upgrade before timing out, in seconds. */
  timeoutDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** If specified, the given virtual devices will be moved to this group. If a device already exists in this group and is not specified in this list, it will remain in the group. */
  virtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type UpdateNosUpgradeGroupsInput = {
  /** The input parameters for updating the NOS upgrade group. */
  input: UpdateNosUpgradeGroupInput;
  /** The UUID of the NOS upgrade group to update. */
  nosUpgradeGroupUUID: Scalars['UUID']['input'];
};

/** The input type for updating a network's configuration properties. */
export type UpdateNetworkConfigPropertiesInput = {
  /** Whether trunk ports may be configured as STP edge ports. Requires a NOS version where all access ports are STP edge ports. */
  isTrunkEdgeOverrideEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input type for updating a network. */
export type UpdateNetworkInput = {
  /**
   * Explicit ARP tracker enablement for the network. When set it takes precedence
   * over the NOS feature and LaunchDarkly flag; set to null to fall back to them.
   */
  IsArpTrackerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If false, wifi steering will be fully disabled even if supported by NOS. */
  IsWifiSteeringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of service types to enable for service discovery. */
  enabledServiceDiscoveryTypes?: InputMaybe<Array<ServiceType>>;
  /** If provided, will update the external id of the network. */
  externalID?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether the network is currently active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enables controller to upgrade config-1 APs deployed to the network. */
  isConfig1WosUpgradesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the network is a template for creating new networks. */
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deprecated: Not a network property anymore. */
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the network is sensitive to firmware updates. */
  isUpgradeSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  /** A label to quickly identify the network. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The mailing address details to update. */
  mailingAddressInput?: InputMaybe<CreateMailingAddressInput>;
  /** The UUID of the mailing address associated with the network. */
  mailingAddressUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** If provided, will update the maintenance window associated with the network accordingly. */
  maintenanceWindow?: InputMaybe<UpdateMaintenanceWindowInput>;
  /** The algorithm used for multi-WAN load balancing. */
  multiWANAlgorithm?: InputMaybe<MultiWanAlgorithm>;
  /** If provided, will update the network's configuration properties. */
  networkConfigProperties?: InputMaybe<UpdateNetworkConfigPropertiesInput>;
  /** The NOS upgrade channel for the network. */
  nosUpgradeChannel?: InputMaybe<NetworkNosUpgradeChannel>;
  /** A note about the network's NOS upgrade channel, explaining why it was set to its current value. */
  nosUpgradeChannelNote?: InputMaybe<Scalars['String']['input']>;
  /** The URL of the patch panel diagram for the network. */
  patchPanelDiagramURL?: InputMaybe<Scalars['String']['input']>;
  /**
   * When true, deactivated networks (deactivatedAt set and in the past) render the standard inactive
   * config for all devices. Can only be set to true when the network is already deactivated.
   */
  rendersInactiveConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  /** If provided, will set Network's Routing Layer (L2 or L3). */
  routingLayer?: InputMaybe<NetworkRoutingLayer>;
  /** A human-readable identifier for the network. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: Not a network property anymore. */
  squareFeet?: InputMaybe<Scalars['Int']['input']>;
  /** The S3 key for the network topology image. */
  topologyImageS3Key?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Patch input for updateNetworkMetadata. Every field is optional — only fields actually
 * provided are written, and each provided field refreshes its `UpdatedAt` timestamp.
 */
export type UpdateNetworkMetadataInput = {
  /** Estimated number of access points the site requires. */
  accessPointCount?: InputMaybe<Scalars['Int']['input']>;
  /** Free-text instructions describing how the network should be configured. */
  configurationInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Number of distribution frames at the site. */
  distributionFrameCount?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the design must use cabling that is already in place. */
  existingCabling?: InputMaybe<Scalars['Boolean']['input']>;
  /** Free-text context describing the existing cabling. */
  existingCablingContext?: InputMaybe<Scalars['String']['input']>;
  /** Expected number of concurrent users. */
  expectedUserCount?: InputMaybe<Scalars['Int']['input']>;
  /** Number of fiber runs needed at the site. */
  fiberRunsNeeded?: InputMaybe<Scalars['Int']['input']>;
  /** Number of floors at the site. */
  floorCount?: InputMaybe<Scalars['Int']['input']>;
  /** Whether outdoor wireless coverage is needed. */
  outdoorCoverageNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Free-text context describing outdoor-coverage needs. */
  outdoorCoverageNeededContext?: InputMaybe<Scalars['String']['input']>;
  /** Type of space (office, warehouse, etc.). */
  spaceType?: InputMaybe<Scalars['String']['input']>;
  /** Square footage of the site. */
  squareFeet?: InputMaybe<Scalars['Int']['input']>;
  /** Preferred switch port count for the site. */
  switchPortCountPreference?: InputMaybe<Scalars['Int']['input']>;
  /** Free-text instructions describing what the site's topology needs to do. */
  topologyInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Estimated number of wired clients the site supports. */
  wiredClientCount?: InputMaybe<Scalars['Int']['input']>;
};

/** Inputs to update a network reservation */
export type UpdateNetworkReservationInput = {
  /** Description of the reservation */
  description?: InputMaybe<Scalars['String']['input']>;
  /** New end time, nil if unchanged */
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** New start time, nil if unchanged */
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateNetworkThreatAllowlistEntryInput = {
  /** A bssid to allow for honeypot AP detection. */
  BSSID?: InputMaybe<Scalars['String']['input']>;
  /** An explanation of the allowlisted device or the SSID to allow. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** An SSID to allow if a threat is broadcasting it. */
  ssidUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** A mac address to allow for rogue AP detection. */
  wiredMAC?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNosFeatureInput = {
  /** A detailed description of the NOS feature. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** If the feature is also behind a feature flag, this is the name of the feature flag. */
  featureFlag?: InputMaybe<Scalars['String']['input']>;
  /** The display name of the NOS feature. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The version ranges that define which NOS versions support this feature. */
  versionRanges: Array<NosFeatureVersionRangeInput>;
};

/** Input type for creating notification snooze. */
export type UpdateNotificationSnoozeInput = {
  /** The reason for the snooze. */
  snoozeReason?: InputMaybe<Scalars['String']['input']>;
  /** The time window for the snooze. */
  window?: InputMaybe<SnoozeNotificationSettingWindowInput>;
};

/** Update out-of-band management phy interface. */
export type UpdateOobPhyInterfaceInput = {
  /** A description of the physical interface. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not the interface is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A custom label for the physical interface. */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating an ObserverTest. */
export type UpdateObserverTestInput = {
  /** The radio band on which the test should be run. */
  band?: InputMaybe<RadioBand>;
  /** If not bound to all targets, this is the list of access points that the ObserverTest is bound to. */
  boundTargetVirtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** If true, requests broadcast responses for DHCP. */
  broadcastDHCP?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of commands to run during the ObserverTest. */
  commands?: InputMaybe<Array<ObserverTestCommandInput>>;
  /** Duration of the test in milliseconds. */
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  /** If true, we will run every observer against every access point that it can reach. These bindings are kept up to date with an offline process. */
  isBoundToAllTargets?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the Observer is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The human readable label for the test. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Number of times an Observer will re-try when there is a connection failure. If unset, uses firmware default (1 retry). */
  numConnectionRetries?: InputMaybe<Scalars['Int']['input']>;
  /** Number of spatial streams to use for the test. If unset, uses max number of spatial streams. */
  numSpatialStreams?: InputMaybe<Scalars['Int']['input']>;
  /** 802.1X password for authentication. */
  password8021X?: InputMaybe<Scalars['String']['input']>;
  /** If true, each observer is bound to only its single highest-SNR target, and non-best bindings are pruned. */
  selectOnlyBestTarget?: InputMaybe<Scalars['Boolean']['input']>;
  /** The SNR threshold (in dB) used to select eligible target APs for observers. If unset, uses the default threshold. */
  snrThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** The UUID of the SSID to use for the ObserverTest. */
  ssidUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Transmit power to use for the test. If unset, uses the transmit power of the access point. */
  transmitPowerdBm?: InputMaybe<Scalars['Int']['input']>;
  /** 802.1X username for authentication. */
  username8021X?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the VLAN for wired tests. Ignored if SSID is set. */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateOneToOneNatRuleInput = {
  /** New description for the 1:1 NAT rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The external IP address that is mapped by the NAT rule. This address must be present in the `externalPhyInterface`'s `ipv4ClientAddresses`, and will be added if it is not. */
  externalIPAddr?: InputMaybe<Scalars['IPV4']['input']>;
  /** UUID of the new physical interface associated with the external IP address. */
  externalPhyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** New internal IP address for the NAT rule. */
  internalIPAddr?: InputMaybe<Scalars['IPV4']['input']>;
  /** Automatically disables this 1:1 NAT rule when the associated physical interface is inactive. */
  isDisabledWhenUplinkInactive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Toggle to enable or disable the NAT rule. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** New name for the 1:1 NAT rule. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating an existing Opportunity. */
export type UpdateOpportunityInput = {
  /** State of the Opportunity. */
  state?: InputMaybe<OpportunityState>;
  /** Internal users handling fulfillment/support for the Opportunity. */
  supportUsers?: InputMaybe<Array<OpportunitySupportUserInput>>;
};

/** Input type for updating an outlet interface. */
export type UpdateOutletInterfaceInput = {
  /** UUID of the virtual device to connect to the power outlet. */
  connectedVirtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Description of the outlet interface. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not the outlet interface is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the outlet interface is validated to ensure that the connectedVirtualDevice is correctly assigned. When set to true, the caller
   * is recorded as the validator. Validation requires a connected virtual
   * device. Changing connectedVirtualDeviceUUID invalidates any previous
   * validation.
   */
  isValidated?: InputMaybe<Scalars['Boolean']['input']>;
  /** User-defined label for the outlet interface. */
  label?: InputMaybe<Scalars['String']['input']>;
  /**
   * Number of seconds to wait when performing a power cycle.
   * The outlet turns off, waits for this duration, and then turns back on.
   */
  powerCycleDelaySec?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A schedule for the power outlet. The intervals cover when the outlet
   * is turned on.
   */
  powerSchedule?: InputMaybe<Array<ScheduleIntervalInput>>;
};

export type UpdateOutletInterfacesIndependentlyInput = {
  /** UUID of the outlet interface to update. */
  UUID: Scalars['UUID']['input'];
  /** Fields to update on the outlet interface. */
  input: UpdateOutletInterfaceInput;
};

/** Fields to update on a packet capture group. */
export type UpdatePacketCaptureGroupsInput = {
  /** The UUID of the group to update. */
  UUID: Scalars['UUID']['input'];
  /** An updated label for the packet capture group. Null or an empty string clears the label. */
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePhyInterface8021XSettingsInput = {
  /** Specifies how many clients can authenticate on the port. */
  hostMode?: InputMaybe<PhyInterface8021XHostMode>;
  /** If enabled, the switch will dynamiclaly assign VLANs to the port based on the RADIUS server response. */
  isAssignVLANsFromRADIUSEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, unauthenticated clients will be assigned to the guest VLAN specified in the switch profile (`RADIUSGuestVLAN`). If disabled, unauthenticated clients are blocked. */
  isGuestVLANEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The MAC authentication bypass mode for the port to accept MAC-based auth. The switch will use the MAC address of the client to authenticate with the RADIUS server, often used for printer ports. */
  macAuthenticationBypassMode?: InputMaybe<PhyInterface8021XmacAuthenticationBypassMode>;
  /** Specifies the variant of 802.1X authentication to use. */
  portMode?: InputMaybe<PhyInterface8021XPortMode>;
  /** The duration that the port will wait after a client fails authentication; after this period it will allow re-attempt. */
  quietPeriodSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** If set, authorized clients are forced to re-authenticate after this period. If not set, clients are not forced to re-authenticate. */
  reauthenticationPeriodSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** When a client is connected to a port, the switch sends out an EAP auth request to the client; the request times out and retransmits according to this value. */
  supplicantPeriodSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for updating an existing phy interface DHCP rule. */
export type UpdatePhyInterfaceDhcpRuleInput = {
  /**
   * The gateway address and subnet, as an unmasked prefix (e.g. `10.65.0.1/24`).
   * Both the address and the prefix length are replaced together.
   */
  gateway?: InputMaybe<Scalars['UnmaskedIPPrefix']['input']>;
  /** The duration (in seconds) of the DHCP lease assigned to clients. */
  leaseDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePhyInterfaceForMultiWanEventInput = {
  /** The port number of the active uplink interface following a Multi-WAN event. */
  activePortNumber: Scalars['Int']['input'];
  /** The timestamp when the active port number was updated due to the Multi-WAN event. */
  activePortNumberUpdatedAt: Scalars['DateTime']['input'];
  /** The external IP addresses assigned to the uplink interface after the Multi-WAN event. */
  uplinkExternalAddresses: Array<Scalars['UnmaskedIPPrefix']['input']>;
};

export type UpdatePhyInterfaceInput = {
  /** The maximum transmission unit (MTU) - max size in bytes for frames on the port. */
  MTU?: InputMaybe<Scalars['Int']['input']>;
  /** The UUIDs of the allowed (tagged) VLANs permitted on this interface. */
  allowedVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A description of the physical interface. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** If 802.1X authentication is enabled, this field contains the settings to configure 802.1X authentication. */
  encryption8021XSettings?: InputMaybe<UpdatePhyInterface8021XSettingsInput>;
  /** The reason this port is excluded from Switch Auto Configuration. Setting a non-empty string excludes the port. */
  excludedFromSwitchAutoConfigReason?: InputMaybe<Scalars['String']['input']>;
  /** The maximum amount of data that can be transmitted through the interface, in Mbps. */
  forcedPortSpeedMbps?: InputMaybe<Scalars['Int']['input']>;
  /** An optional filter to only accept certain frame types on this port. */
  frameAcceptTypeFilter?: InputMaybe<PhyInterfaceFrameAcceptTypeFilter>;
  /** The UUID of the InternetServicePlan associated with the uplink (if `isUplink` is true). */
  internetServicePlanUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** IPv4 addresses to assign to the interface without netmasks when assigning as a client. */
  ipv4ClientAddresses?: InputMaybe<Array<Scalars['IPV4']['input']>>;
  /** Protocol to use for IPv4 addresses when assigning this interface as a client. */
  ipv4ClientAssignmentProtocol?: InputMaybe<ClientAssignmentProtocol>;
  /** Gateway IPv4 address without netmask when assigning as a client. */
  ipv4ClientGateway?: InputMaybe<Scalars['IPV4']['input']>;
  /** Subnet prefix length for the IPv4 addresses when assigning as a client. */
  ipv4ClientPrefixLength?: InputMaybe<Scalars['Int']['input']>;
  /** IPv6 addresses to assign to the interface without netmasks when assigning as a client. */
  ipv6ClientAddresses?: InputMaybe<Array<Scalars['IPV6']['input']>>;
  /** Protocol to use for IPv6 addresses when assigning this interface as a client. */
  ipv6ClientAssignmentProtocol?: InputMaybe<ClientAssignmentProtocol>;
  /** Gateway IPv6 address without netmask when assigning as a client. */
  ipv6ClientGateway?: InputMaybe<Scalars['IPV6']['input']>;
  /** Subnet prefix length for the IPv6 addresses when assigning as a client. */
  ipv6ClientPrefixLength?: InputMaybe<Scalars['Int']['input']>;
  /** Whether or not the interface is implicitly bound to all VLANs. */
  isBoundToAllVLANs?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not the interface is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, flap link intervention protocol is enabled on the port. Both this flag and isFLIPEnabled in SwitchProfile must be true for FLIP to be enabled on a port. */
  isFLIPEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, Fast Leave is enabled on this interface. When enabled, the port is removed from the multicast group as soon as the switch sees an IGMP/MLD leave message from the client on the port. */
  isFastLeaveEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** This represents whether flow control is enabled. This feature is enabled by default. */
  isFlowControlEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, tagged frames are discarded when the VLAN ID does not match. */
  isIngressFilteringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, other ports are prevented from communicating with this port. */
  isIsolationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, configures this phy interface as an L3 port. */
  isL3Port?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, enables OSPF on this L3 port. Only valid on L3 ports whose device has L3 routing and OSPF enabled. When a port is set to L3, OSPF is automatically enabled if and only if the device has OSPF enabled. */
  isOspfEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not the interface is enabled to deliver Power over Ethernet. */
  isPOEEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If true, this interface will be configured as an edge port in STP (Spanning Tree Protocol).
   *
   * For modern NOS versions, access ports are always edge ports. Trunk ports are never edge ports unless
   * the network's `isTrunkEdgeOverrideEnabled` STP override is enabled.
   */
  isSTPEdgePortEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not the interface is enabled to participate in Spanning Tree Protocol. */
  isSTPEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** This should only be used with trunk ports. If enabled, the port cannot become STP root. It helps prevent a customer or rogue switch from sending a low bridge priority and becoming root. If a switch has root guard enabled and it receives a low bpdu (that would normally make it a root port), then the switch ill disable that port */
  isSTPRootGuardEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, this phy interface is configured as a sink. */
  isSink?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not storm control is enabled on the port. */
  isStormControlEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the port is a trunk port that carries multiple VLANs. */
  isTrunkPort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the interface is an uplink to other networks or devices. */
  isUplink?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, incoming ICMP requests to this uplink interface will be blocked by default. Only valid if `isUplink` is true. Only applies to controllers. */
  isUplinkIncomingICMPDenied?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, voice VLAN is enabled for this port. Both this flag and isVoiceVLANEnabled in SwitchProfile must be true for voice VLAN to be enabled on a port. */
  isVoiceVLANEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** An optional IPv4 address to serve in this interface's config in place of the device's underlay address. Can only be set on an interface where L3 is enabled. Pass null to clear it and fall back to the device's underlay address. */
  l3IpAddress?: InputMaybe<Scalars['IPV4']['input']>;
  /** An optional prefix length (1-32) of the L3 CIDR, paired with L3IpAddress. Can only be set on an interface where L3 is enabled. Pass null to clear it. */
  l3IpPrefixLength?: InputMaybe<Scalars['Int']['input']>;
  /** A custom label for the physical interface. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of MAC addresses allowed on the port for security. */
  maxMACAddressesAllowed?: InputMaybe<Scalars['Int']['input']>;
  /** The UUID of the native (untagged) VLAN assigned to this interface. */
  nativeVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** A schedule for the port. The intervals cover when the port is enabled */
  portSchedule?: InputMaybe<Array<ScheduleIntervalInput>>;
  /** For switch port security, this is a allow list of MAC addresses that are allowed to be connected to the port. */
  portSecurityMACAllowList?: InputMaybe<Array<InputMaybe<Scalars['MacAddress']['input']>>>;
  /** For switch port security, this specifies the type of security - dynamic, static or sticky. */
  portSecurityMode?: InputMaybe<PhyInterfacePortSecurityMode>;
  /** Receive rate limit for the port, in Kbps. */
  rxRateLimitKbps?: InputMaybe<Scalars['Int']['input']>;
  /** Percent of broadcast traffic to drop if storm control is enabled. */
  stormControlBroadcastTrafficPercent?: InputMaybe<Scalars['Int']['input']>;
  /** Percent of unknown multicast traffic to drop if storm control is enabled. */
  stormControlUnknownMulticastTrafficPercent?: InputMaybe<Scalars['Int']['input']>;
  /** Percent of unknown unicast traffic to drop if storm control is enabled. */
  stormControlUnknownUnicastTrafficPercent?: InputMaybe<Scalars['Int']['input']>;
  /** STP Path cost for the port (1-200000000). */
  stpPathCost?: InputMaybe<Scalars['Int']['input']>;
  /** STP Priority for the port (0-240 in multiples of 16, default 128). */
  stpPriority?: InputMaybe<Scalars['Int']['input']>;
  /** Transmit rate limit for the port, in Kbps. */
  txRateLimitKbps?: InputMaybe<Scalars['Int']['input']>;
  /** Priority order for using the uplink; lower values take precedence (if `isUplink` is true). */
  uplinkPriority?: InputMaybe<Scalars['Int']['input']>;
  /** VLAN ID used for the uplink (if `isUplink` is true). */
  uplinkVLANID?: InputMaybe<Scalars['Int']['input']>;
};

/** Update multiple phy interfaces simultaneously and atomically, each with independent parameters. Only a subset of parameters are supported. */
export type UpdatePhyInterfacesIndependentlyInput = {
  /** The UUID of the physical interface to update. */
  UUID: Scalars['UUID']['input'];
  /** The description of the physical interface. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The label of the physical interface. */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a path. */
export type UpdatePolicyEnginePathInput = {
  /** If set, clamps the TCP max segment size to the provided number of bytes. */
  clampMaxSegmentSizeBytes?: InputMaybe<Scalars['Int']['input']>;
  /** Optional extended description for the traffic matcher. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether this path should be initially active before monitor reports. */
  initialActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional IP address used as virtual address for this path. */
  ipAddress?: InputMaybe<Scalars['IP']['input']>;
  /** Whether the traffic matcher is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Monitor group UUID for health monitoring. */
  monitorGroupUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Unique name for the traffic matcher. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** NAT configuration for the policy. If omitted, no translation happens before forwarding. */
  natConfiguration?: InputMaybe<PolicyEngineNatConfigurationInput>;
  /** Next hop configuration for the policy. If omitted, defaults to VRF route lookup with no specified ID. */
  nextHopConfiguration?: InputMaybe<PolicyEngineNextHopConfigurationInput>;
  /** Lower priority values are preferred for routing. */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Target interface for this path. */
  targetInterface?: InputMaybe<TargetInterfaceInput>;
  /** Load balancing weight for distributing traffic across paths with equal priority. */
  weight?: InputMaybe<Scalars['Int']['input']>;
};

/** Input type for updating multiple existing policies. */
export type UpdatePolicyEnginePoliciesInput = {
  /** Input data to apply to the policy referred to by `policyEnginePolicyUUID`. */
  input: UpdatePolicyEnginePolicyInput;
  /** The UUID of the existing policy. */
  policyEnginePolicyUUID: Scalars['UUID']['input'];
};

/** Input values for updating a policy engine policy. */
export type UpdatePolicyEnginePolicyInput = {
  /** Optional extended description for the traffic matcher. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether the traffic matcher is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the policy. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Paths for this policy. When provided, replaces all existing paths. */
  paths?: InputMaybe<Array<CreatePolicyEnginePathInput>>;
  /**
   * Priority of the policy within the network, lower priority policies are applied first.
   * If there is an existing policy with the provided value, it and all subsequent occupied values will be incremented.
   */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Traffic matchers for this policy. When provided, replaces all existing matchers. */
  trafficMatchers?: InputMaybe<Array<CreatePolicyEngineTrafficMatcherInput>>;
  /** The type of policy engine policy, affecting priority. */
  type?: InputMaybe<PolicyEnginePolicyType>;
};

/** Input for updating a traffic matcher. */
export type UpdatePolicyEngineTrafficMatcherInput = {
  /** Optional extended description for the traffic matcher. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Destination address prefix to match. At most one of `destinationAddress`, `destinationAddressPattern`, and `destinationTargetInterface` can be set. */
  destinationAddress?: InputMaybe<Scalars['IPPrefix']['input']>;
  /** Destination IPv4 address pattern to match, e.g. `10.1-4.*.2/31`. At most one of `destinationAddress`, `destinationAddressPattern`, and `destinationTargetInterface` can be set. */
  destinationAddressPattern?: InputMaybe<Scalars['IPAddressPattern']['input']>;
  /** Destination target interface to match. At most one of `destinationAddress`, `destinationAddressPattern`, and `destinationTargetInterface` can be set. */
  destinationTargetInterface?: InputMaybe<TargetInterfaceInput>;
  /** Destination port ranges to match. */
  dstPortRanges?: InputMaybe<Array<PortRangeInput>>;
  /** Whether the traffic matcher is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique name for the traffic matcher. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** IANA protocol numbers to match. */
  protocols?: InputMaybe<Array<IpProtocol>>;
  /** Source address prefix to match. At most one of `sourceAddress`, `sourceAddressPattern`, and `sourceTargetInterface` can be set. */
  sourceAddress?: InputMaybe<Scalars['IPPrefix']['input']>;
  /** Source IPv4 address pattern to match, e.g. `10.1-4.*.2/31`. At most one of `sourceAddress`, `sourceAddressPattern`, and `sourceTargetInterface` can be set. */
  sourceAddressPattern?: InputMaybe<Scalars['IPAddressPattern']['input']>;
  /** Source target interface to match. At most one of `sourceAddress`, `sourceAddressPattern`, and `sourceTargetInterface` can be set. */
  sourceTargetInterface?: InputMaybe<TargetInterfaceInput>;
  /** Source port ranges to match. */
  srcPortRanges?: InputMaybe<Array<PortRangeInput>>;
};

export type UpdatePolicyRoutingRuleInput = {
  /** The list of bindings to update for this policy routing rule (optional). */
  bindings?: InputMaybe<Array<PolicyRoutingRuleBindingInput>>;
  /** A description for the policy routing rule (optional). */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The list of destination port ranges to update for the traffic matching this rule (optional). */
  dstPortRanges?: InputMaybe<Array<PortRangeInput>>;
  /** The destination IP prefix to update for the traffic matching this rule (optional). */
  dstPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
  /** Indicates whether the policy routing rule is enabled (optional). */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The new name of the policy routing rule (optional). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The list of IP protocols to update for the traffic matching this rule (optional). */
  protocols?: InputMaybe<Array<IpProtocol>>;
  /** The list of source port ranges to update for the traffic matching this rule (optional). */
  srcPortRanges?: InputMaybe<Array<PortRangeInput>>;
  /** The source IP prefix to update for the traffic matching this rule (optional). */
  srcPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
  /** The UUID of the source VLAN to update for the traffic matching this rule (optional). */
  srcVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdatePortForwardingRuleInput = {
  /** Restricts the port forwarding rule to only allow traffic to be forwarded if it originates from any of these IP addresses. */
  allowedRemoteIPAddresses?: InputMaybe<Array<Scalars['IP']['input']>>;
  /** Description of the port forwarding rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * The external IP address to which this rule applies.
   * One of `externalPhyInterfaceUUID` or `externalIPAddress` must be provided.
   */
  externalIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** UUID of the external uplink physical interface. */
  externalPhyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * The external port from which incoming traffic is forwarded.
   * Cannot be combined with `externalPortRanges`/`localPortRanges`.
   */
  externalPort?: InputMaybe<Scalars['Int']['input']>;
  /**
   * External port ranges from which incoming traffic is forwarded. Replaces the rule's existing ports or
   * ranges; cannot be combined with `externalPort`/`localPort`.
   * `externalPortRanges[i]` forwards to `localPortRanges[i]`, so both lists must have the same number of
   * entries and each pair must span the same number of ports. Ranges within a rule must not overlap.
   * A rule may specify at most 100 port ranges, and a network may forward at most 5000 ports in total
   * across all of its enabled port forwarding rules.
   */
  externalPortRanges?: InputMaybe<Array<PortRangeInput>>;
  /** Indicates whether the port forwarding rule is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The local IP address to which incoming traffic is forwarded. */
  localIPAddress?: InputMaybe<Scalars['IP']['input']>;
  /** The local port to which the external port forwards traffic. */
  localPort?: InputMaybe<Scalars['Int']['input']>;
  /** Local port ranges to which the corresponding `externalPortRanges` entry forwards traffic. */
  localPortRanges?: InputMaybe<Array<PortRangeInput>>;
  /** Name of the port forwarding rule. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The IP protocol to apply this rule on. */
  protocol?: InputMaybe<PortIpProtocol>;
  /** List of IP protocols to match. */
  protocols?: InputMaybe<Array<PortIpProtocol>>;
  /**
   * The incoming interface.
   * One of `targetInterface` or `externalIPAddress` must be provided.
   */
  targetInterface?: InputMaybe<TargetInterfaceInput>;
};

/** Input for updating the global proactive packet capture configuration for a network. */
export type UpdateProactivePcapNetworkConfigInput = {
  /** Whether proactive packet capture is enabled globally for the network. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** For the same client and same type of event, minimum interval in seconds before exporting another pcap. 0 means use firmware default (30 minutes). */
  maxPcapFreqSec?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for updating the per-SSID proactive packet capture configuration. */
export type UpdateProactivePcapSsidConfigInput = {
  /**
   * List of 802.11 disassociation reason codes to capture.
   * If empty and isCaptureDisassocsEnabled is true, all disassociations are captured.
   */
  captureDisassocsReasonCodes?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of client MAC addresses to follow for all pcap events. */
  followedClientMacs?: InputMaybe<Array<Scalars['MacAddress']['input']>>;
  /** Whether disassociation events are captured. */
  isCaptureDisassocsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to capture successful connection events. */
  isCaptureSuccessEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether proactive packet capture is enabled for this SSID. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input type for updating a Provider Connection Type Term. */
export type UpdateProviderConnectionTypeTermInput = {
  /** UUID of the connection type the term applies to. */
  connectionTypeUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Term of contract in months. */
  termMonths?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Rate limit overrides for a public API key. Omitting a field leaves that
 * override untouched, passing null explicitly clears it.
 */
export type UpdatePublicApiKeyRateLimitsInput = {
  /**
   * Complexity points the key may accumulate. May not be below the maximum
   * complexity of a single query, or queries above the budget could never be
   * paid for. Null restores the default.
   */
  complexityBucketCapacity?: InputMaybe<Scalars['Int']['input']>;
  /** Requests per minute. Null restores the default. */
  requestRateLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Mutations per minute. Null restores the default. */
  writeRateLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for updating an existing Quote. */
export type UpdateQuoteInput = {
  /**
   * Indicates availability (OnNet/NearNet/OffNet) of the associated Provider and Connectiontype at the associated location.
   * Providing this information set the availability for the location, not just the quote.
   */
  availability?: InputMaybe<LocationProviderAvailability>;
  /** Connection type UUID (optional). */
  connectionTypeUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Length of the contract in months. */
  contractLengthMonths?: InputMaybe<Scalars['Int']['input']>;
  /** Actual contract term in months committed to with the underlying carrier, which may differ from the customer-facing contractLengthMonths. */
  contractLengthMonthsInternal?: InputMaybe<Scalars['Int']['input']>;
  /** Creation date of the quote. */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Download speed in Kbps. */
  downloadKbps?: InputMaybe<Scalars['Int']['input']>;
  /** SFDC id of Quote object. */
  externalID?: InputMaybe<Scalars['String']['input']>;
  /** Installation fee in cents. */
  installFeeCents?: InputMaybe<Scalars['Int']['input']>;
  /** Wholesale installation fee in cents. */
  installFeeWholesaleCents?: InputMaybe<Scalars['Int']['input']>;
  /** SFDC OpportunityLineItem id for the install. */
  installLineItemExternalID?: InputMaybe<Scalars['String']['input']>;
  /** Estimated number of days for installation. */
  installationEstimateDays?: InputMaybe<Scalars['Int']['input']>;
  /** UUID of the broker providing quote. */
  internetServicePlanBrokerProviderUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** UUID of the ISP Provider. */
  internetServicePlanProviderUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** UUID of the ISP underlying Provider. */
  internetServicePlanSubProviderUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Monthly fee in cents. */
  monthlyFeeCents?: InputMaybe<Scalars['Int']['input']>;
  /** Monthly fee prior to any discounts applied. */
  monthlyFeePreDiscountCents?: InputMaybe<Scalars['Int']['input']>;
  /** Wholesale cost. */
  monthlyFeeWholesaleCents?: InputMaybe<Scalars['Int']['input']>;
  /** SFDC OpportunityLineItem id for the monthly recurring cost. */
  monthlyLineItemExternalID?: InputMaybe<Scalars['String']['input']>;
  /** Internal notes about the quote. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the associated Quote Request. */
  quoteRequestUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Whether this quote is recommended. */
  recommended?: InputMaybe<Scalars['Boolean']['input']>;
  /** Responsibility for riser cabling work. */
  riserResponsibility?: InputMaybe<RiserResponsibility>;
  /** Whether a router is included in the quote. */
  routerIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates selection status */
  selectedStatus?: InputMaybe<QuoteSelectionStatus>;
  /** Indicates a quote has been selected and its proposed priority. */
  selectionPriority?: InputMaybe<Scalars['Int']['input']>;
  /** State of the Quote. */
  state?: InputMaybe<QuoteState>;
  /** Status of the Quote. */
  status?: InputMaybe<QuoteStatus>;
  /** Upload speed in Kbps. */
  uploadKbps?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Input type for updating an existing Internet Service Plan Provider.
 * Providing companyUUID will associate the Quote Request with an existing company.
 */
export type UpdateQuoteRequestInput = {
  /** Address for which the Quote Request is created. */
  address?: InputMaybe<CreateAddressInput>;
  /** Company UUID identifying existing company. */
  companyUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Email of potential customerthe Quote Request. */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Name of potential customer initiating the Quote Request. */
  contactName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of potential customer initiating the Quote Request. */
  contactTelephone?: InputMaybe<Scalars['String']['input']>;
  /** Requested maximum days to install. */
  contractMaximumInstallDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Requested minumum contract length in months. */
  contractMinimumMonths?: InputMaybe<Scalars['Int']['input']>;
  /** End date of the potential customer's existing ISP contract. */
  existingContractEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Monthly recurring cost of the customer. */
  existingMonthlyFeeCents?: InputMaybe<Scalars['Int']['input']>;
  /** Customer's existing provider */
  existingProviderUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** SFDC id of QuoteRequest object. */
  externalID?: InputMaybe<Scalars['String']['input']>;
  /** Is the user interested in the Meter Network product. */
  isInterestedInNetwork?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is there a pending manual quote that needs to be prepared. */
  isManualResponsePending?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique identifier of existing mailing address. */
  mailingAddressUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Network UUID identifying existing network. */
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Note tracking details of quote creation. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** SFDC id of associated Opportunity object. */
  opportunityExternalID?: InputMaybe<Scalars['String']['input']>;
  /** Proposed name of the company to create or associate with quote request. */
  requestedCompanyName?: InputMaybe<Scalars['String']['input']>;
  /** Requested download speed. */
  requestedDownloadKbps?: InputMaybe<Scalars['Int']['input']>;
  /** Requested upload speed. */
  requestedUploadKbps?: InputMaybe<Scalars['Int']['input']>;
  /** State of the Quote Request. */
  state?: InputMaybe<QuoteRequestState>;
  /** Internal users handling fulfillment/support for the Quote Request. */
  supportUsers?: InputMaybe<Array<QuoteRequestSupportUserInput>>;
};

/** Input type for updating a device in a rack elevation. */
export type UpdateRackElevationDeviceInput = {
  /** Whether the device is front-facing or rear-facing. */
  isFrontFacing?: InputMaybe<Scalars['Boolean']['input']>;
  /** A friendly name for display purposes. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Additional context or comments about the device. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The number of ports on the device. Only for switches and patch panels; cannot be specified if it's a Meter device. */
  portCount?: InputMaybe<Scalars['Int']['input']>;
  /** The indexes of the rack units that the device occupies. */
  rackMountUnitIndexes?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The index of the rack mount unit that the device is side by side with. 0-indexed; lower number is to the left when viewing the rack from the front. For simplicity this must be 0 or 1 (at-most 2 devices per rack mount unit). For paired devices, placement changes enforce 0 for the primary and 1 for the secondary. A null value selects the required index; label and note edits leave an omitted index unchanged. */
  sideBySideIndex?: InputMaybe<Scalars['Int']['input']>;
  /** The type of the device. Cannot be specified if it's a Meter device. */
  type?: InputMaybe<RackElevationDeviceType>;
  /** If it's a Meter device, the virtual device's UUID. */
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input type for updating an existing rack elevation. */
export type UpdateRackElevationInput = {
  /** The building where this rack is physically located. */
  building?: InputMaybe<Scalars['String']['input']>;
  /** If true and rackMountUnitCount is decreasing, attempt to collapse devices downward into empty rack units so they fit within the new size. Devices are moved starting from the highest RMU first, each sliding down through empty space until blocked. */
  collapseDevicesWhenResizing?: Scalars['Boolean']['input'];
  /** The name of the distribution frame associated with this rack. */
  distributionFrame?: InputMaybe<Scalars['String']['input']>;
  /** The floor within the building where this rack is physically located. */
  floor?: InputMaybe<Scalars['String']['input']>;
  /** The left-to-right position of the rack relative to others. */
  horizontalIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Human-readable name for the rack elevation. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Notes associated with the rack elevation. */
  notes?: InputMaybe<Array<RackElevationNoteInput>>;
  /** The number of rack units (like slots) for the rack elevation. */
  rackMountUnitCount?: InputMaybe<Scalars['Int']['input']>;
  /** The room where this rack is physically located. */
  room?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRadioProfileInput = {
  /**
   * Required if band2_4GAutoChannelIsEnabled is true.
   * The list of allowed channels for auto channel selection on the 2.4 GHz band.
   */
  band2_4GAllowedChannels?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Indicates whether auto channel selection is enabled for the 2.4 GHz band. */
  band2_4GAutoChannelIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether auto channel width selection is enabled for the 2.4 GHz band. */
  band2_4GAutoChannelWidthIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether automatic transmit power adjustment is enabled for the 2.4 GHz band. */
  band2_4GAutoTxPowerIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Required if band2_4GAutoTxPowerIsEnabled is true.
   * The maximum transmit power in dBm for the 2.4 GHz band when auto transmit power is enabled.
   */
  band2_4GAutoTxPowerMaxdBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band2_4GAutoTxPowerIsEnabled is true.
   * The minimum transmit power in dBm for the 2.4 GHz band when auto transmit power is enabled.
   */
  band2_4GAutoTxPowerMindBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band2_4GAutoChannelWidthIsEnabled is false.
   * The channel width in MHz for the 2.4 GHz band when auto channel width is disabled.
   */
  band2_4GChannelWidthMHz?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the 2.4 GHz band is enabled. */
  band2_4GIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Required if band5GAutoChannelIsEnabled is true.
   * The list of allowed channels for auto channel selection on the 5 GHz band.
   */
  band5GAllowedChannels?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Indicates whether auto channel selection is enabled for the 5 GHz band. */
  band5GAutoChannelIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether auto channel width selection is enabled for the 5 GHz band. */
  band5GAutoChannelWidthIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether automatic transmit power adjustment is enabled for the 5 GHz band. */
  band5GAutoTxPowerIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Required if band5GAutoTxPowerIsEnabled is true.
   * The maximum transmit power in dBm for the 5 GHz band when auto transmit power is enabled.
   */
  band5GAutoTxPowerMaxdBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band5GAutoTxPowerIsEnabled is true.
   * The minimum transmit power in dBm for the 5 GHz band when auto transmit power is enabled.
   */
  band5GAutoTxPowerMindBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band5GAutoChannelWidthIsEnabled is false.
   * The channel width in MHz for the 5 GHz band when auto channel width is disabled.
   */
  band5GChannelWidthMHz?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the 5 GHz band is enabled. */
  band5GIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, the AP returns to a DFS channel after the NOP expires. */
  band5GZeroWaitDFSIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Required if band6GAutoChannelIsEnabled is true.
   * The list of allowed channels for auto channel selection on the 6 GHz band.
   */
  band6GAllowedChannels?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Indicates whether auto channel selection is enabled for the 6 GHz band. */
  band6GAutoChannelIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether auto channel width selection is enabled for the 6 GHz band. */
  band6GAutoChannelWidthIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether automatic transmit power adjustment is enabled for the 6 GHz band. */
  band6GAutoTxPowerIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Required if band6GAutoTxPowerIsEnabled is true.
   * The maximum transmit power in dBm for the 6 GHz band when auto transmit power is enabled.
   */
  band6GAutoTxPowerMaxdBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band6GAutoTxPowerIsEnabled is true.
   * The minimum transmit power in dBm for the 6 GHz band when auto transmit power is enabled.
   */
  band6GAutoTxPowerMindBm?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if band6GAutoChannelWidthIsEnabled is false.
   * The channel width in MHz for the 6 GHz band when auto channel width is disabled.
   */
  band6GChannelWidthMHz?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the 6 GHz band is enabled. */
  band6GIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Clear channel assessment (CCA) threshold in dBm used to determine whether the channel is free. 0 means use driver default. */
  ccaThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** A human-readable description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Setting this to true will set all other profiles to false.
   * Indicates whether this profile should be set as the default for the network.
   */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** The new name for the radio profile. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Receive sensitivity level (RX-SOP) in dBm below which received frames are not considered. 0 means use driver default. */
  rxSensitivityLevel?: InputMaybe<Scalars['Int']['input']>;
};

/** Specifies the metadata that can be updated for radio settings for an Access Point. */
export type UpdateRadioSettingsInput = {
  /** The primary channel for the 2.4 GHz radio band. */
  band2_4GPrimaryChannel?: InputMaybe<Scalars['Int']['input']>;
  /** The transmit power in dBm for the 2.4 GHz radio band. */
  band2_4GTransmitPowerdBm?: InputMaybe<Scalars['Int']['input']>;
  /** The primary channel for the 5 GHz radio band. */
  band5GPrimaryChannel?: InputMaybe<Scalars['Int']['input']>;
  /** The secondary channel for the 5 GHz radio band, if applicable. */
  band5GSecondaryChannel?: InputMaybe<Scalars['Int']['input']>;
  /** The transmit power in dBm for the 5 GHz radio band. */
  band5GTransmitPowerdBm?: InputMaybe<Scalars['Int']['input']>;
  /** The primary channel for the 6 GHz radio band. */
  band6GPrimaryChannel?: InputMaybe<Scalars['Int']['input']>;
  /** The transmit power in dBm for the 6 GHz radio band. */
  band6GTransmitPowerdBm?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRateLimitRuleInput = {
  /** A list of UUIDs of physical interfaces to which this rate limit rule is bound. */
  boundPhyInterfaceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A list of UUIDs of SSIDs to which this rate limit rule is bound. */
  boundSSIDUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A list of UUIDs of VLANs to which this rate limit rule is bound. */
  boundVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A description of the rate limit rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Destination MAC address to match. */
  dstMac?: InputMaybe<Scalars['MacAddress']['input']>;
  /** Destination port range to match. */
  dstPortRange?: InputMaybe<PortRangeInput>;
  /** Destination IP address prefix to match. */
  dstPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
  /** Indicates whether the rate limit rule is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specifies if the rate limit is applied per source IP/MAC address. */
  isPerSource?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the rate limit rule. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The order in which the rate limit rules are applied, lower priorities first. */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** IANA protocol number to match (e.g., 1 = ICMP, 6 = TCP, 17 = UDP). A value of 256 denotes all protocols. */
  protocol?: InputMaybe<IpProtocol>;
  /** Maximum download rate limit in kilobits per second. */
  rateLimitKbpsDownload?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum upload rate limit in kilobits per second. */
  rateLimitKbpsUpload?: InputMaybe<Scalars['Int']['input']>;
  /** Source MAC address to match. */
  srcMac?: InputMaybe<Scalars['MacAddress']['input']>;
  /** Source port range to match. */
  srcPortRange?: InputMaybe<PortRangeInput>;
  /** Source IP address prefix to match. */
  srcPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
};

export type UpdateRateLimitRulesInput = {
  /** The UUID of the rate limit rule to update. */
  UUID: Scalars['UUID']['input'];
  /** The updates to apply to the rate limit rule. */
  input: UpdateRateLimitRuleInput;
};

export type UpdateSpanMirrorSessionInput = {
  /** UUID of the destination physical interface where mirrored traffic will be sent. */
  destPhyInterfaceUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Source ports for this session. Update is declarative - completely replaces all existing source ports. Existing ports matching the phyInterfaceUUID are updated; new ones are created; absent ones are deleted. */
  sourcePorts?: InputMaybe<Array<SpanMirrorSessionSourcePortInput>>;
};

export type UpdateSsidInput = {
  /** The lowest rate at which a client can connect to the 2.4 GHz radio, in kilobits per second. */
  band2GMinimumBasicRateKbps?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum RSSI (in dBm) for probe request suppression on the 2.4 GHz radio. */
  band2GMinimumProbeRssiDbm?: InputMaybe<Scalars['Int']['input']>;
  /** The lowest rate at which a client can connect to the 5 GHz radio, in kilobits per second. */
  band5GMinimumBasicRateKbps?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum RSSI (in dBm) for probe request suppression on the 5 GHz radio. */
  band5GMinimumProbeRssiDbm?: InputMaybe<Scalars['Int']['input']>;
  /** The lowest rate at which a client can connect to the 6 GHz radio, in kilobits per second. */
  band6GMinimumBasicRateKbps?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum RSSI (in dBm) for probe request suppression on the 6 GHz radio. */
  band6GMinimumProbeRssiDbm?: InputMaybe<Scalars['Int']['input']>;
  /** If true, all broadcast traffic is blocked before being transmitted to the wireless. Requires proxy ARP to be enabled. */
  blockWirelessTxBroadcast?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, all multicast traffic is blocked before being transmitted to the wireless. */
  blockWirelessTxMulticast?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specifies the schedule intervals during which the SSID will be broadcasted. */
  broadcastSchedule?: InputMaybe<Array<ScheduleIntervalInput>>;
  /** A list of allowed client MACs, if isClientAllowlistEnabled is true. */
  clientAllowlist?: InputMaybe<Array<Scalars['MacAddress']['input']>>;
  /** Enable or disable client steering for association. */
  clientSteeringAssociationSteeringIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The minimum number of clients on an SSID before client steering is attempted. */
  clientSteeringLoadBalancingClientMinThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Enable or disable post-association client steering. */
  clientSteeringPostassociationSteeringIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The minimum RSSI signal strength (in dBm) before pre-association client steering is attempted. */
  clientSteeringPreassociationRSSIMinThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Description of the SSID. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** List of access point virtual device UUIDs on which the SSID is disabled. */
  disabledAccessPointVirtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The DTIM period for the SSID. */
  dtimPeriod?: InputMaybe<Scalars['Int']['input']>;
  /** Dynamic VLAN mode setting. */
  dynamicVLANMode?: InputMaybe<SsidDynamicVlanMode>;
  /** An optional period for requiring client reauthentication, for a 802.1X SSID. */
  eapReauthPeriod?: InputMaybe<Scalars['Duration']['input']>;
  /**
   * Required if isEnabledForAllAccessPoints is false.
   * List of access point virtual device UUIDs on which the SSID is enabled.
   */
  enabledAccessPointVirtualDeviceUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** 802.11w Protected Management Frames mode. */
  encryption80211wProtectedManagementFramesMode?: InputMaybe<SsidEncryption80211wProtectedManagementFramesMode>;
  /** Encryption protocol used by the SSID. */
  encryptionProtocol?: InputMaybe<SsidEncryptionProtocol>;
  /** Input values for updating Hotspot 2.0 (Passpoint). */
  hotspot20?: InputMaybe<UpdateHotspot20Input>;
  /** An optional value for the Hotspot 2.0 Access network type. */
  hs20AccessNetworkType?: InputMaybe<Scalars['Int']['input']>;
  /** When set to true, clears all Hotspot 2.0 data. */
  hs20ClearAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of Hotspot 2.0 domain names. */
  hs20DomainNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Enable or disable Hotspot 2.0 (Passpoint). */
  hs20Enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional label for the Hotspot 2.0 profile. */
  hs20Label?: InputMaybe<Scalars['String']['input']>;
  /** A list of MCC/MNC pairs, formatted as "MCC,MNC". */
  hs20MccMncPairs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of Hotspot 2.0 NAI realms. */
  hs20NaiRealms?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of Operator names for Hotspot 2.0 (one per language). */
  hs20OperatorNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of Hotspot 2.0 Consortium OIs (Organization Identifiers). */
  hs20RoamingConsortiumOIs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** An optional value for the Hotspot 2.0 Venue group. */
  hs20VenueGroup?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A list of Venue names for Hotspot 2.0 (one per language); must be formatted with a two or three character language code separated by a colon from the venue name.
   * If at least one is set, hs20VenueGroup and hs20VenueType must be set.
   */
  hs20VenueNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** An optional value for the Hotspot 2.0 Venue type. */
  hs20VenueType?: InputMaybe<Scalars['Int']['input']>;
  /** Enable or disable 802.11ax (Wi-Fi 6) for the SSID. */
  is80211axEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable 802.11be (Wi-Fi 7) for the SSID. */
  is80211beEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable AP debug logging for APs broadcasting the SSID. */
  isAPDebugLogEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, all traffic sent on this SSID will be sent as voice access category, which means it will be prioritized compared to normal traffic of other SSIDs. */
  isAllTrafficVoicePriority?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable broadcasting the SSID on the 2.4 GHz band. */
  isBand2GAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable broadcasting the SSID on the 5 GHz band. */
  isBand5GAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable broadcasting the SSID on the 6 GHz band. */
  isBand6GAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, only clients in the client allowlist will be allowed. */
  isClientAllowlistEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, clients in the blocklist will be blocked for this SSID. */
  isClientSSIDBlocklistEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable the SSID. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable the SSID for all access points or only specified ones. */
  isEnabledForAllAccessPoints?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mark the SSID as a guest network. */
  isGuest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hide the SSID from being broadcasted. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable client isolation on the SSID. */
  isIsolateClientsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable multicast to unicast translation on the SSID. */
  isMulticastToUnicastEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether proxy ARP (AP responds to ARP requests coming from the uplink on behalf of the clients) is enabled */
  isProxyARPEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable 802.11k roaming. */
  isRoaming80211kEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable 802.11r fast roaming. */
  isRoaming80211rEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable 802.11v roaming. */
  isRoaming80211vEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Threshold above which multicast to unicast is disabled. If 0, no limit. */
  multicastToUnicastClientThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** A NAS (Network Access Server) identifier that can be used for Radius or 11r; if empty, defaults to the AP's hostname. */
  nasIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Pre-shared key (PSK) for the SSID. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Cadence for automatic password rotation. */
  passwordRotationCadence?: InputMaybe<SsidPasswordRotationCadence>;
  /** The day of the month for password rotation in the network's local time zone. */
  passwordRotationDayOfMonthLocal?: InputMaybe<Scalars['Int']['input']>;
  /** The day of the week for password rotation in the network's local time zone (0 = Sunday). */
  passwordRotationDayOfWeekLocal?: InputMaybe<Scalars['Int']['input']>;
  /** The hour of the day for password rotation in the network's local time zone. */
  passwordRotationHourOfDayLocal?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Set the primary 802.1X encryption configuration.
   * Required if encryptionProtocol is WPA2_ENTERPRISE.
   */
  primaryEncryption8021XUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Enable or disable RADIUS Change of Authorization (CoA). */
  radiusCoaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A port where RADIUS servers can send CoA requests. */
  radiusCoaPort?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum wait in seconds between two RADIUS retries. */
  radiusMaxRetryWait?: InputMaybe<Scalars['Int']['input']>;
  /** Number of RADIUS server retries before a failover. */
  radiusServerRetries?: InputMaybe<Scalars['Int']['input']>;
  /** Value to configure RTS/CTS. */
  rtsCtsEnabledCode?: InputMaybe<Scalars['Int']['input']>;
  /** Size of the PPDU on which RTS would be sent out. */
  rtsThreshold?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Set the secondary 802.1X encryption configuration.
   * Required if encryptionProtocol is WPA2_ENTERPRISE.
   */
  secondaryEncryption8021XUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Name of the SSID. */
  ssid?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the VLAN to associate with the SSID. */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateSsiDsIndependentlyInput = {
  /** The unique identifier of the SSID. */
  UUID: Scalars['UUID']['input'];
  /** The input values for the SSID. */
  input: UpdateSsidInput;
};

export type UpdateSsiDsInput = {
  /** The lowest rate at which a client can connect to the 2.4 GHz radio, in kilobits per second. */
  band2GMinimumBasicRateKbps?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum RSSI (in dBm) for probe request suppression on the 2.4 GHz radio. */
  band2GMinimumProbeRssiDbm?: InputMaybe<Scalars['Int']['input']>;
  /** The lowest rate at which a client can connect to the 5 GHz radio, in kilobits per second. */
  band5GMinimumBasicRateKbps?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum RSSI (in dBm) for probe request suppression on the 5 GHz radio. */
  band5GMinimumProbeRssiDbm?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum RSSI (in dBm) for probe request suppression on the 6 GHz radio. */
  band6GMinimumProbeRssiDbm?: InputMaybe<Scalars['Int']['input']>;
  /** If true, all broadcast traffic is blocked before being transmitted to the wireless. Requires proxy ARP to be enabled. */
  blockWirelessTxBroadcast?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, all multicast traffic is blocked before being transmitted to the wireless. */
  blockWirelessTxMulticast?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable client steering for association. */
  clientSteeringAssociationSteeringIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The minimum number of clients on an SSID before client steering is attempted. */
  clientSteeringLoadBalancingClientMinThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Enable or disable post-association client steering. */
  clientSteeringPostassociationSteeringIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The minimum RSSI signal strength (in dBm) before pre-association client steering is attempted. */
  clientSteeringPreassociationRSSIMinThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Description of the SSID. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The DTIM period for the SSID. */
  dtimPeriod?: InputMaybe<Scalars['Int']['input']>;
  /** Dynamic VLAN mode setting. */
  dynamicVLANMode?: InputMaybe<SsidDynamicVlanMode>;
  /** An optional period for requiring client reauthentication, for a 802.1X SSID. */
  eapReauthPeriod?: InputMaybe<Scalars['Duration']['input']>;
  /** 802.11w Protected Management Frames mode. */
  encryption80211wProtectedManagementFramesMode?: InputMaybe<SsidEncryption80211wProtectedManagementFramesMode>;
  /** Encryption protocol used by the SSID. */
  encryptionProtocol?: InputMaybe<SsidEncryptionProtocol>;
  /** Enable or disable 802.11ax (Wi-Fi 6) for the SSID. */
  is80211axEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable 802.11be (Wi-Fi 7) for the SSID. */
  is80211beEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable AP debug logging for APs broadcasting the SSID. */
  isAPDebugLogEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable broadcasting the SSID on the 2.4 GHz band. */
  isBand2GAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable broadcasting the SSID on the 5 GHz band. */
  isBand5GAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable the SSID. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mark the SSID as a guest network. */
  isGuest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hide the SSID from being broadcasted. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable client isolation on the SSID. */
  isIsolateClientsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable multicast to unicast translation on the SSID. */
  isMulticastToUnicastEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether proxy ARP (AP responds to ARP requests coming from the uplink on behalf of the clients) is enabled */
  isProxyARPEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Threshold above which multicast to unicast is disabled. If 0, no limit. */
  multicastToUnicastClientThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** A NAS (Network Access Server) identifier that can be used for Radius or 11r; if empty, defaults to the AP's hostname. */
  nasIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Pre-shared key (PSK) for the SSID. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Cadence for automatic password rotation. */
  passwordRotationCadence?: InputMaybe<SsidPasswordRotationCadence>;
  /** The day of the month for password rotation in the network's local time zone. */
  passwordRotationDayOfMonthLocal?: InputMaybe<Scalars['Int']['input']>;
  /** The day of the week for password rotation in the network's local time zone (0 = Sunday). */
  passwordRotationDayOfWeekLocal?: InputMaybe<Scalars['Int']['input']>;
  /** The hour of the day for password rotation in the network's local time zone. */
  passwordRotationHourOfDayLocal?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Set the primary 802.1X encryption configuration.
   * Required if encryptionProtocol is WPA2_ENTERPRISE.
   */
  primaryEncryption8021XUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Enable or disable RADIUS Change of Authorization (CoA). */
  radiusCoaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A port where RADIUS servers can send CoA requests. */
  radiusCoaPort?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum wait in seconds between two RADIUS retries. */
  radiusMaxRetryWait?: InputMaybe<Scalars['Int']['input']>;
  /** Number of RADIUS server retries before a failover. */
  radiusServerRetries?: InputMaybe<Scalars['Int']['input']>;
  /** Value to configure RTS/CTS. */
  rtsCtsEnabledCode?: InputMaybe<Scalars['Int']['input']>;
  /** Size of the PPDU on which RTS would be sent out. */
  rtsThreshold?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Set the secondary 802.1X encryption configuration.
   * Required if encryptionProtocol is WPA2_ENTERPRISE.
   */
  secondaryEncryption8021XUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Name of the SSID. */
  ssid?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating a security appliance profile. */
export type UpdateSecurityApplianceProfileInput = {
  /** Disables client stat hostname collection. */
  disableClientStatsHostnames?: InputMaybe<Scalars['Boolean']['input']>;
  /** The number of seconds between host monitoring pings. */
  hostMonitoringIntervalSec?: InputMaybe<Scalars['Int']['input']>;
  /** The number of seconds to wait before timing out a host monitoring ping. */
  hostMonitoringTimeoutSec?: InputMaybe<Scalars['Int']['input']>;
  /** The L3 configuration to apply to the security appliance profile, including routing layer and underlay address. Only honored by updateSecurityApplianceProfile, not the network-wide mutation. */
  l3Configuration?: InputMaybe<L3ConfigurationInput>;
  /** The algorithm used to manage multiple WAN connections, such as load balancing or failover strategies. */
  multiWANAlgorithm?: InputMaybe<MultiWanAlgorithm>;
  /** The number of seconds to wait before another failover can occur after a recent one */
  multiWANUpdateCooldownSec?: InputMaybe<Scalars['Int']['input']>;
  /** Number of previous ping results to consider for the failover calculation. */
  multiWANUpdateLookback?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The minimum success ratio to consider a WAN link as good.
   * If it drops below the threshold, a failover occurs.
   * Stored as an integer representing the percentage.
   * For example, a value of 65 represents 65%, or a success ratio of 0.65.
   */
  multiWANUpdateThreshold?: InputMaybe<Scalars['Int']['input']>;
  /**
   * If set, all network egress traffic will use this IP address for Network Address Translation.
   *
   * Conditions for usage:
   * - BGP-over-WAN must be enabled and configured
   * - This IP must belong to a prefix we advertise over WAN
   * - There must be at least one WAN interface with a static IP (ideally all are static)
   */
  natPublicIP?: InputMaybe<Scalars['IP']['input']>;
  /** Configuration settings for policy engine on this device. */
  policyEngineConfiguration?: InputMaybe<PolicyEngineConfigurationInput>;
};

export type UpdateSpeedtestRuleInput = {
  /** Frequency to run the rule at */
  frequency?: InputMaybe<SpeedtestRuleFrequency>;
  /** If the rule is enabled or disabled */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Max number of bytes transfered by jobs started by this rule */
  maxTransferBytes?: InputMaybe<Scalars['Uint32']['input']>;
  /** Scheduled day of the week to run the rule on */
  scheduledDayOfWeekLocal?: InputMaybe<Scalars['Int']['input']>;
  /** Scheduled hour of the day to run the rule at */
  scheduledHourLocal?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateStaticRouteInput = {
  /** Destination IP prefix for the static route. */
  dstPrefix?: InputMaybe<Scalars['IPPrefix']['input']>;
  /**
   * UUIDs of VLANs to be excluded from the static route.
   * Only valid if this is a default route (0.0.0.0/0 destination prefix).
   * Only one of `explicitlyBoundVLANUUIDs` and `excludedVLANUUIDs` can be non-null and non-empty.
   */
  excludedVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /**
   * UUIDs of VLANs to be bound to the static route.
   * Only valid if this is a default route (0.0.0.0/0 destination prefix).
   * If empty, all non-excluded VLANs will be bound to the default route.
   * Only one of `explicitlyBoundVLANUUIDs` and `excludedVLANUUIDs` can be non-null and non-empty.
   */
  explicitlyBoundVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** UUID of the DHCP Static Mapping to be used as gateway. */
  gatewayDHCPStaticMappingUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Gateway IP address for the static route. */
  gatewayIP?: InputMaybe<Scalars['IPV4']['input']>;
  /** UUID of the VLAN to be used as the gateway. */
  gatewayVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** New enabled state for the static route. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** New name for the static route. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the input for updating support cases */
export type UpdateSupportCasesInput = {
  /** Assignee contact for the case. */
  assignedTo?: InputMaybe<SupportCaseContactInput>;
  /** Assignee for the case. */
  assignee?: InputMaybe<Scalars['String']['input']>;
  /** Assignee email for the case. */
  assigneeEmail?: InputMaybe<Scalars['String']['input']>;
  /** Close code to set on each case. */
  closeCode?: InputMaybe<SupportCaseCloseCode>;
  /** Closing notes to set on each case. */
  closeNotes?: InputMaybe<Scalars['String']['input']>;
  /** The complete list of collaborator emails to set on each case. Emails not in this list will be removed. */
  collaborators?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The complete list of contacts to set on each case. Contacts not in this list will be removed. */
  contacts?: InputMaybe<Array<SupportCaseContactInput>>;
  /** Customer contact for the case. (e.g., the creator of the case) */
  customer?: InputMaybe<SupportCaseContactInput>;
  /** Email of the customer that submitted the case. */
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  /** Name of the customer that submitted the case. */
  customerName?: InputMaybe<Scalars['String']['input']>;
  /** Description to set on each case. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Email of the person that opened the case. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Client-supplied external identifier for the case. */
  externalID?: InputMaybe<Scalars['String']['input']>;
  /** Issue location of the case. */
  issueLocation?: InputMaybe<Scalars['String']['input']>;
  /** Issue type of the case. */
  issueType?: InputMaybe<IssueType>;
  /** MAC address of the device in the case. */
  macAddress?: InputMaybe<Scalars['String']['input']>;
  /** Name of the person that opened the case. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Network to associate with each case. */
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Origin to set on each case. */
  origin?: InputMaybe<SupportCaseOrigin>;
  /** Parent support case for the case. */
  parentSupportCaseUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Priority to set on each case. */
  priority?: InputMaybe<SupportCasePriority>;
  /** Requester contact for the case. */
  requester?: InputMaybe<SupportCaseContactInput>;
  /** Person who resolved the case. */
  resolvedBy?: InputMaybe<SupportCaseContactInput>;
  /** Status to set all cases to. */
  status?: InputMaybe<SupportCaseStatus>;
  /** Subject to set on each case. */
  subject?: InputMaybe<Scalars['String']['input']>;
  /** Technology type of the case. */
  technologyType?: InputMaybe<TechnologyType>;
};

/**
 * Input for updating a support provider alert receiver
 * The provided list of targets replaces the existing targets entirely. Any targets not included in this list will be removed.
 */
export type UpdateSupportProviderAlertReceiverWithTargetsInput = {
  /** Unique identifier of the alert receiver to update. */
  alertReceiverUUID: Scalars['UUID']['input'];
  /** Unique identifier of the supported company. */
  companyUUID: Scalars['UUID']['input'];
  /** Updated label for the alert receiver. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** List of alert targets to associate with the alert receiver. This list will replace any existing targets. */
  targets?: InputMaybe<Array<AlertTargetInput>>;
};

/** Input to update a support provider */
export type UpdateSupportProviderInput = {
  /** The point of contact that api key requests will be created under. */
  pointOfContactID?: InputMaybe<Scalars['Int']['input']>;
  /** The public api key that will be associated with the support provider. */
  publicAPIKeyUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input type for updating a switch profile. */
export type UpdateSwitchProfileInput = {
  /** For 802.1X encryption on a Switch's ports, if a client fails 802.1X authentication, clients are placed in the specified VLAN. The VLAN must be specified as `isGuest`. If set to null, then clients must authenticate before accessing the network. */
  encryption8021XGuestVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** For 802.1X encryption on a Switches, if a vlan is specified as a source vlan for radius, then the switch will use that vlan to send radius requests. If not set, then the switch will use the management vlan. */
  encryption8021XRadiusSourceVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The 802.1X encryption configurations associated with this switch profile. Setting this field will replace the existing list of 802.1X encryption configurations. */
  encryption8021XUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The time in seconds after which all flap state for a port is cleared. */
  flipClearFlapStateAfterSec?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum number of times to toggle the port before requiring manual toggle of port in dashboard. */
  flipMaxRetryCount?: InputMaybe<Scalars['Int']['input']>;
  /** The number of seconds to wait before re-enabling the port. */
  flipRetryPeriodSec?: InputMaybe<Scalars['Int']['input']>;
  /** Time window in seconds to count the number of flaps. */
  flipWindowSec?: InputMaybe<Scalars['Int']['input']>;
  /** The number of flaps per time window that will result in a port being shut down. */
  flipWindowThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Flap link intervention protocol (FLIP) is a protocol that detects link failures and automatically disables the port. */
  isFLIPEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enables switch to periodically send IGMP queries to detect multicast clients. Both this flag and isIgmpSnoopingEnabled in VLAN must be true for IGMP snooping to be enabled on this switch. */
  isIGMPSnoopingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enables switch to periodically send MLD queries to detect multicast clients. Both this flag and isMldSnoopingEnabled in VLAN must be true for MLD snooping to be enabled on this switch. */
  isMLDSnoopingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the switch's 802.1X ports authenticate against Meter's managed RADIUS, using the NAC policies defined for the network. Mutually exclusive with encryption8021XUUIDs. */
  isMeterNACEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Multicast filtering tells the switch what to do with unknown multicast packet i.e packets for which snooping doesn't have any learned ports. When enabled, unknown multicast packets are dropped. */
  isMulticastFilteringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enables dedicated voice VLAN for voice traffic. */
  isVoiceVLANEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The L3 configuration to apply to the switch profile, including routing layer and underlay address. */
  l3Configuration?: InputMaybe<L3ConfigurationInput>;
  /** Time in seconds after which a MAC entry will be aged out. 0 means no expiration. */
  macTableAgingSec?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum transmission unit (MTU) size in bytes. */
  mtu?: InputMaybe<Scalars['Int']['input']>;
  /** The new name of the switch profile. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * The STP bridge priority for the switch.
   *
   * The lower the value, the more likely the switch is to be elected as the root bridge.
   * The range is 0 to 61440. Valid values are multiples of 4096.
   */
  stpBridgePriority?: InputMaybe<Scalars['Int']['input']>;
  /**
   * STP forwarding delay in seconds (4-30).
   *
   * The delay between port state changes in the spanning tree.
   */
  stpForwardingDelaySeconds?: InputMaybe<Scalars['Int']['input']>;
  /**
   * STP Hello interval in seconds (1-10).
   *
   * The time between configuration messages sent by the root bridge.
   */
  stpHelloIntervalSeconds?: InputMaybe<Scalars['Int']['input']>;
  /**
   * STP Max BPDU age in seconds (6-40).
   *
   * The maximum age of received BPDU information before discarding.
   */
  stpMaxAgeSeconds?: InputMaybe<Scalars['Int']['input']>;
  /**
   * STP BPDU transmit hold count per second (1-10).
   *
   * The maximum number of BPDUs that can be sent per second.
   */
  stpTransmitHoldCount?: InputMaybe<Scalars['Int']['input']>;
  /** The tier of the switch device(s) associated with the switch profile, denoting the purpose of the devices in the network. */
  switchingTier?: InputMaybe<SwitchProfileSwitchingTier>;
  /** Voice VLAN CoS (Class Of Service) that operates on Layer-2 level. Valid values are 0-7. */
  voiceCosValue?: InputMaybe<Scalars['Int']['input']>;
  /** Voice VLAN DSCP (Differentiated Services Code Point) that operates on Layer-4 level. Valid values are 0-63. */
  voiceDscpValue?: InputMaybe<Scalars['Int']['input']>;
  /** The UUID of the VLAN designated for voice traffic. */
  voiceVLANUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input type for updating a switch profiles. */
export type UpdateSwitchProfilesInput = {
  /** The time in seconds after which all flap state for a port is cleared. */
  flipClearFlapStateAfterSec?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum number of times to toggle the port before requiring manual toggle of port in dashboard. */
  flipMaxRetryCount?: InputMaybe<Scalars['Int']['input']>;
  /** The number of flaps per time window that will result in a port being shut down. */
  flipWindowThreshold?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Update a time window. Omitted fields remain unchanged. The resulting window must
 * have endAt after startAt. Any linked job must belong to the window's network.
 */
export type UpdateTimeWindowInput = {
  /** New job link. Must belong to the window's network. Pass null to clear. */
  deploymentJobUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** New end of the window. Omit or pass null to leave unchanged. */
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Replace the linked installation companies. Pass an empty list or null to clear all company links. */
  installCompanyUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Replace the linked technicians. Pass an empty list or null to clear all technician links. */
  installTechnicianUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Set installer confirmation. Omit or pass null to leave unchanged. */
  installerConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set Meter confirmation. Omit or pass null to leave unchanged. */
  meterConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** New network. Omit or pass null to leave unchanged. */
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** New notes; pass null to clear. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** New start of the window. Omit or pass null to leave unchanged. */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** New window type. Omit or pass null to leave unchanged. */
  type?: InputMaybe<DeploymentTimeWindowType>;
};

export type UpdateTopologyDesignLinkInput = {
  /** Physical cable medium. */
  cableType?: InputMaybe<TopologyDesignCableType>;
  /** Intended link speed in Mbps. */
  intendedSpeedMbps?: InputMaybe<Scalars['Int']['input']>;
  /** Link classification. */
  linkRole?: InputMaybe<TopologyDesignLinkRole>;
  /** Interface type on side A. */
  sideAInterfaceType?: InputMaybe<TopologyDesignInterfaceType>;
  /** Port label on the side A device (e.g. '1', 'LAN1', 'WAN1'). */
  sideAPort?: InputMaybe<Scalars['String']['input']>;
  /** Interface type on side B. */
  sideBInterfaceType?: InputMaybe<TopologyDesignInterfaceType>;
  /** Port label on the side B device (e.g. '1', 'LAN1', 'WAN1'). */
  sideBPort?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTopologyDesignNodeInput = {
  /** Building name or identifier. */
  building?: InputMaybe<Scalars['String']['input']>;
  /** Optional description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The intended device model identifier, e.g. S1, F3, or ISP_HANDOFF for design-only nodes. */
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  /** The type of device. */
  deviceType?: InputMaybe<TopologyDesignDeviceType>;
  /** Label of the distribution frame. */
  distributionFrameLabel?: InputMaybe<Scalars['String']['input']>;
  /** MDF or IDF. */
  distributionFrameType?: InputMaybe<TopologyDesignDistributionFrameType>;
  /** Floor name or number. */
  floor?: InputMaybe<Scalars['String']['input']>;
  /** Intended device label. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Freeform notes about the installation location. */
  locationNotes?: InputMaybe<Scalars['String']['input']>;
  /** Label of the rack. */
  rackLabel?: InputMaybe<Scalars['String']['input']>;
  /** Room within the floor. */
  room?: InputMaybe<Scalars['String']['input']>;
  /** The switching layer. Only applicable to switches. */
  switchingTier?: InputMaybe<SwitchProfileSwitchingTier>;
  /** Link to provisioned virtual device. */
  virtualDeviceUUID?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateTopologyDesignVersionInput = {
  /** Rename the version. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Update the notes. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Draft, committed, or archived. Can only transition to committed from draft. */
  status?: InputMaybe<TopologyDesignVersionStatus>;
};

export type UpdateUplinkPhyInterfaceExternalAddressesInput = {
  /** Physical port number of the uplink interface whose external addresses are being updated. */
  portNumber: Scalars['Int']['input'];
  /** The external IP addresses assigned to the uplink interface. */
  uplinkExternalAddresses: Array<Scalars['UnmaskedIPPrefix']['input']>;
  /** The timestamp when the uplink external addresses were updated. */
  uplinkExternalAddressesUpdatedAt: Scalars['DateTime']['input'];
};

export type UpdateVlandhcpRuleInput = {
  /** The UUID of the DHCP rule to update. If omitted, the input is applied to every DHCP rule on the target VLAN. */
  dhcpRuleUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The input containing updated values for the DHCP rule. */
  input: UpdateDhcpRuleInput;
};

export type UpdateVlanInput = {
  /** A list of DHCP rules to create for this VLAN. */
  createDHCPRules?: InputMaybe<Array<CreateDhcpRuleInput>>;
  /** A list of UUIDs of DHCP rules to delete from this VLAN. */
  deleteDHCPRules?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A new description for the VLAN. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Number of IGMP queries to send when the switch first starts up using the startup query interval. */
  igmpQueryCount?: InputMaybe<Scalars['Int']['input']>;
  /** Interval in seconds between IGMP queries. Must be between 60 and 500. */
  igmpQueryIntervalSec?: InputMaybe<Scalars['Int']['input']>;
  /** Interval in seconds to wait for responses to IGMP queries. */
  igmpResponseIntervalSec?: InputMaybe<Scalars['Int']['input']>;
  /** Interval in seconds between IGMP queries when the switch first starts up.. */
  igmpStartupQueryIntervalSec?: InputMaybe<Scalars['Int']['input']>;
  /** IGMP version to use. Must be 1, 2, or 3. */
  igmpVersion?: InputMaybe<Scalars['Int']['input']>;
  /** Updates the protocol for assigning IPv4 addresses to clients on this VLAN. */
  ipV4ClientAssignmentProtocol?: InputMaybe<ClientAssignmentProtocol>;
  /** Updates the IPv4 gateway address for this VLAN. */
  ipV4ClientGateway?: InputMaybe<Scalars['IPV4']['input']>;
  /** Updates the IPv4 prefix length (subnet mask) for this VLAN. */
  ipV4ClientPrefixLength?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Specifies the IPv4 address of an externally-managed (non-Meter) gateway for this L2 VLAN;
   * used by features like client isolation. Mutually exclusive with ipV4ClientGateway.
   * If set, ipV4ExternalPrefixLength must be set as well.
   */
  ipV4ExternalGateway?: InputMaybe<Scalars['IPV4']['input']>;
  /** Updates the IPv4 prefix length (subnet mask) that pairs with ipV4ExternalGateway. */
  ipV4ExternalPrefixLength?: InputMaybe<Scalars['Int']['input']>;
  /** Updates the protocol for assigning IPv6 addresses to clients on this VLAN. */
  ipV6ClientAssignmentProtocol?: InputMaybe<ClientAssignmentProtocol>;
  /** Updates the IPv6 gateway address for this VLAN. */
  ipV6ClientGateway?: InputMaybe<Scalars['IPV6']['input']>;
  /** Updates the IPv6 prefix length (subnet mask) for this VLAN. */
  ipV6ClientPrefixLength?: InputMaybe<Scalars['Int']['input']>;
  /**
   * If true, this VLAN is the native VLAN for access point management traffic.
   * Setting this to true unsets the flag on any other VLAN in the network.
   */
  isAPNativeVLAN?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable the VLAN. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enables periodically sending IGMP queries to detect multicast clients. Both this flag and isIgmpSnoopingEnabled in SwitchProfile must be true for IGMP snooping to be enabled on this VLAN. */
  isIGMPSnoopingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Override to indicate that this VLAN is an ISP VLAN and should be rendered only on
   * Meter ISP switches. This is a nonstandard configuration and should be used carefully.
   */
  isISPVLAN?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, marks the VLAN as internal to the network. */
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, MLD snooping is enabled for this VLAN. Both this flag and isMLDSnoopingEnabled in SwitchProfile must be true for MLD snooping to be enabled on this VLAN. */
  isMLDSnoopingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, enables or disables multicast/mDNS reflection for the VLAN. */
  isMulticastReflectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If true, this VLAN is suggested as the uncategorized client native VLAN in switch auto-configuration.
   * Setting this to true unsets the flag on any other VLAN in the network.
   */
  isUncategorizedClientFallback?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, prevents this VLAN from sending traffic through WANs (blocks internet access). */
  isWANDenied?: InputMaybe<Scalars['Boolean']['input']>;
  /** Interval in seconds between MLD queries. Must be between 60 and 500. */
  mldQueryIntervalSec?: InputMaybe<Scalars['Int']['input']>;
  /** MLD version to use. Must be 1 or 2. */
  mldVersion?: InputMaybe<Scalars['Int']['input']>;
  /** A new name for the VLAN. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** If true, allows this VLAN to participate in VPN features. */
  participatesInVPNs?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * VLANs explicitly allowed to inter-communicate with this VLAN.
   * Effectively equivalent to firewall rules allowing communication between this VLAN and all of these VLANs.
   * Equivalent to PUT semantics, VLANs previously paired with this VLAN that are not present in this list will be no longer permitted.
   */
  permittedInterVLANCommunicationVLANUUIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** A list of DHCP rules to update for this VLAN. */
  updateDHCPRules?: InputMaybe<Array<UpdateVlandhcpRuleInput>>;
  /** The new VLAN ID. Must be between 1 and 4094 and unique per network. */
  vlanID?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateVlaNsIndependentlyInput = {
  /** The UUID of the VLAN to update. */
  UUID: Scalars['UUID']['input'];
  /** The input containing the settings to update for the VLAN. */
  input: UpdateVlaNsInput;
};

/** Settings to update for multiple VLANs. */
export type UpdateVlaNsInput = {
  /** Enable or disable the VLAN. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the VLAN participates in multicast/mDNS reflection. */
  isMulticastReflectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Specifies the metadata that can be updated for a virtual device, used to update many virtual devices at once with different values. */
export type UpdateVirtualDeviceIndependentlyInput = {
  /** The update input containing the fields to update for the virtual device. */
  input: UpdateVirtualDeviceInput;
  /** The UUID of the virtual device to update. */
  virtualDeviceUUID: Scalars['UUID']['input'];
};

/** Specifies the metadata that can be updated for a virtual device. */
export type UpdateVirtualDeviceInput = {
  /** [Access Points only] The UUID of the port profile to associate with the access point. */
  accessPointPortProfileUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** An optional description for the virtual device. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * For some devices, we will allow the user to set the device model.
   * This will be useful for hardware swaps where we want to retain the same configuration for the virtual device.
   * There will be application validation, since sometimes changing the model is not valid (e.g., if the number of ports on the device differs,
   * or if the new model doesn't support features that the old model did).
   */
  deviceModel?: InputMaybe<DeviceModel>;
  /** Enable or disable the console port on the virtual device. */
  enableConsolePort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable or disable LED dark mode on the access point. */
  enableLEDDarkMode?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Gateways only] The UUID of the gateway profile to associate with the gateway. */
  gatewayProfileUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Enables coredumps upon system failure. Will result in extended downtime while the dump is being collected. Currently only supported on controllers. */
  isCoredumpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Currently we only support enabling debug logs on APs. */
  isDebugLogEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this virtual device is in a draft state for preconfiguration reasons. */
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Mark the virtual device as read-only. As of now this is only supported for PDUs.
   * If the device is marked as read-only, updating any other fields will result in a Bad Request error.
   */
  isReadonly?: InputMaybe<Scalars['Boolean']['input']>;
  /** A human-friendly name for the virtual device. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the NOS upgrade group to associate with the virtual device for grouped firmware upgrades. */
  nosUpgradeGroupUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** [Access Points only] The UUID of the radio profile to associate with the access point. */
  radioProfileUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** [Access Points only] The radio settings to update on the access point. */
  radioSettings?: InputMaybe<UpdateRadioSettingsInput>;
  /** [Switches only] Customize the switch profile for the device. */
  switchProfile?: InputMaybe<UpdateSwitchProfileInput>;
  /** [Switches only] The UUID of the switch profile to associate with the switch. */
  switchProfileUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** [Switches only] The switching tier for the virtual device's switch profile. */
  switchingTier?: InputMaybe<SwitchProfileSwitchingTier>;
  /** Overwrite the VirtualDeviceTags for this device by name. If a tag with this name does not exist in the network, it will be created and attached to the device. If it already exists, it will be attached to the device. This will delete any existing tags not specified in the list. */
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateVirtualDeviceTagInput = {
  /** New name for the virtual device tag. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating an existing Wifi IPSK. */
export type UpdateWifiIpskInput = {
  /**
   * An optional array of MAC addresses to restrict a password to some clients (if null, no
   * MAC restriction)
   */
  clientMACs?: InputMaybe<Array<Scalars['MacAddress']['input']>>;
  /** A label for this IPSK */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Password for authentication. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** The VLAN UUID if dynamic VLAN is enabled. */
  vlanUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Throughput for one traffic direction. */
export type UplinkThroughputDirectionSeries = {
  __typename?: 'UplinkThroughputDirectionSeries';
  /** Aggregates precomputed over the whole window. Rates are bits per second; total is bits. */
  summary: MetricsSummary;
  /**
   * Throughput in bits per second for each bucket. values[i] contains the value for the bucket
   * starting at startTime + i * stepSeconds.
   */
  values: Array<Scalars['Float']['output']>;
};

/** Selects how uplink throughput series are grouped. */
export enum UplinkThroughputGrouping {
  /** One series per network, summed across that network's uplinks. */
  Network = 'NETWORK',
  /** One series per uplink physical interface. */
  PhyInterface = 'PHY_INTERFACE'
}

/** Uplink throughput for one grouping. */
export type UplinkThroughputSeries = {
  __typename?: 'UplinkThroughputSeries';
  /** The UUID of the network. Null unless NETWORK grouping was requested. */
  networkUUID?: Maybe<Scalars['UUID']['output']>;
  /** The UUID of the physical interface. Null unless PHY_INTERFACE grouping was requested. */
  phyInterfaceUUID?: Maybe<Scalars['UUID']['output']>;
  /** Received traffic. */
  rx: UplinkThroughputDirectionSeries;
  /** Transmitted traffic. */
  tx: UplinkThroughputDirectionSeries;
};

/** The response containing uplink throughput series. Every series shares the one time set up (startTime + stepSeconds). */
export type UplinkThroughputSeriesResponse = {
  __typename?: 'UplinkThroughputSeriesResponse';
  /** One entry per group, or a single entry when no grouping was requested. */
  series: Array<UplinkThroughputSeries>;
  /** The start of the first bucket. */
  startTime: Scalars['DateTime']['output'];
  /** The interval in seconds between consecutive entries in every `values` array. */
  stepSeconds: Scalars['Int']['output'];
};

/** Input type for uploading the results of a client observer test performed by a client device. */
export type UploadClientObserverTestInput = {
  /** The accuracy in meters of the test location */
  accuracyMeters?: InputMaybe<Scalars['Float']['input']>;
  /** The UUID of the client device that ran the client observer test. */
  clientDeviceUUID: Scalars['UUID']['input'];
  /** The device model of the client device that ran the test. */
  deviceModel: Scalars['String']['input'];
  /** The IP address of the client device that ran the test. */
  ipAddress: Scalars['IP']['input'];
  /** The latitude coordinate of the test location */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** The longitude coordinate of the test location */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** The MAC address of the client device that ran the test. */
  macAddress?: InputMaybe<Scalars['MacAddress']['input']>;
  /** The maximum duration in milliseconds among all attempts during the client observer test. */
  maxDurationMsec?: InputMaybe<Scalars['Duration']['input']>;
  /** The minimum duration in milliseconds among all attempts during the client observer test. */
  minDurationMsec?: InputMaybe<Scalars['Duration']['input']>;
  /** The UUID of the network associated with the client observer test. */
  networkUUID: Scalars['UUID']['input'];
  /** The number of attempts made during the client observer test. */
  numAttempts: Scalars['Int']['input'];
  /** The number of successful attempts during the client observer test. */
  numSuccess: Scalars['Int']['input'];
  /** The OS version of the client device that ran the test. */
  osVersion: Scalars['String']['input'];
  /** P95 latency in milliseconds for the client observer test, meaning 95% of attempts had latency less than or equal to this value. */
  p95LatencyMsec?: InputMaybe<Scalars['Duration']['input']>;
  /** P99 latency in milliseconds for the client observer test, meaning 99% of attempts had latency less than or equal to this value. */
  p99LatencyMsec?: InputMaybe<Scalars['Duration']['input']>;
  /** The rssi is the signal strength (in dBm) between the client and the AP. */
  rssi: Scalars['Int']['input'];
  /** The target of the client observer test, which may be an IP address, hostname, or other identifier depending on the test type. */
  testTarget: ClientObserverTestTargetInput;
  /** The type of test performed. */
  testType: ClientObserverTestType;
  /** The total duration in milliseconds for all attempts during the client observer test. */
  totalDurationMsec?: InputMaybe<Scalars['Duration']['input']>;
};

export type UpsertAlertDeprioritizationWindowForNetworkInput = {
  /** The UUID of the network. */
  networkUUID: Scalars['UUID']['input'];
  /** The reason alerts are deprioritized during the configured windows. */
  reason: Scalars['String']['input'];
  /** Weekly local-time intervals during which triggered alerts are deprioritized. */
  windows: Array<ScheduleIntervalInput>;
};

/** Represents the state to upsert for every visible message in a company inbox. */
export type UpsertAllInboxMessageStatesInput = {
  /** Is the message archived. */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the message read. */
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input type for creating or updating a company onboarding field delegation. */
export type UpsertCompanyOnboardingFieldDelegationInput = {
  /** Description of the delegation. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Email of the user to whom the field is delegated. */
  email: Scalars['String']['input'];
};

/** Input for upserting a DHCP proxy. */
export type UpsertDhcpProxyInput = {
  /** The UUID of an existing DHCP proxy to update. If unset, will create a new DHCP proxy. */
  UUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Input for upserting the DHCP proxy. */
  input: CreateDhcpProxyInput;
};

/** Represents the inbox message upsert state arguments. */
export type UpsertInboxMessageStateInput = {
  /** Is the message archived. */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the message read. */
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique identifier for the message. */
  messageUUID?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents the state to upsert for a set of inbox messages. */
export type UpsertInboxMessageStatesInput = {
  /** Is the message archived. */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the message read. */
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for upserting the manual availability of a provider and connection type at a location. */
export type UpsertLocationProviderAvailabilityInput = {
  /** Availability to set: ON_NET, NEAR_NET or OFF_NET. */
  availability: LocationProviderAvailability;
  /** UUID of the connection type. */
  connectionTypeUUID: Scalars['UUID']['input'];
  /** UUID of the location, as returned by `ConnectAddress.UUID`. */
  locationUUID: Scalars['UUID']['input'];
  /** UUID of the ISP Provider. */
  providerUUID: Scalars['UUID']['input'];
};

export type UpsertMacAddressAliasInput = {
  /** The human-friendly name to assign to the MAC address. */
  alias: Scalars['String']['input'];
  /** The MAC address for which the alias is being created or updated. */
  macAddress: Scalars['MacAddress']['input'];
};

/** Input type for creating or updating a network onboarding field delegation. */
export type UpsertNetworkOnboardingFieldDelegationInput = {
  /** Description of the delegation. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Email of the user to whom the field is delegated. */
  email: Scalars['String']['input'];
};

export type UpsertRateLimitRuleInput = {
  /** Input values for creating a rate limit rule. */
  create?: InputMaybe<CreateRateLimitRulesInput>;
  /** Input values for updating an existing rate limit rule. */
  update?: InputMaybe<UpdateRateLimitRulesInput>;
};

export type UpsertRecurringAutoChannelSelectionJobInput = {
  /** The radio bands to run ACS for. Supported bands: 2.4GHz, 5GHz, 6GHz. */
  bands: Array<RadioBand>;
  /** The period upon which scheduled 5 GHz auto channel selection runs. */
  cadence: RecurringAutoChannelSelectionScheduleCadence;
  /** The day of the month, in the network's local time zone, when scheduled 5 GHz auto channel selection may run. */
  dayOfMonthLocal?: InputMaybe<Scalars['Int']['input']>;
  /** The day of the week, in the network's local time zone, when scheduled 5 GHz auto channel selection may run (0 = Sunday, 1 = Monday, etc.) */
  dayOfWeekLocal?: InputMaybe<Scalars['Int']['input']>;
  /** The hour of the day, in the network's local time zone, when scheduled 5 GHz auto channel selection may run. */
  hourOfDayLocal?: InputMaybe<Scalars['Int']['input']>;
  /** If true, compute proposed channels but do not update access point settings. */
  isDryRun?: Scalars['Boolean']['input'];
  /** The UUID of the network. */
  networkUUID: Scalars['UUID']['input'];
  /**
   * Optional stickiness threshold for ACS (0.0–1.0). Controls how much better a new channel must
   * score before switching from the current channel. Defaults to 0.15.
   */
  stickinessThreshold?: InputMaybe<Scalars['Float']['input']>;
};

/** A user is a person or machine that has access to Meter. */
export type User = {
  __typename?: 'User';
  /** The email address of the user. */
  email: Scalars['String']['output'];
  /** The first name of the user. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the user. */
  id: Scalars['ID']['output'];
  /** The last name of the user. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** URL of user profile picture. */
  profilePictureUrl?: Maybe<Scalars['String']['output']>;
};

/** Activity recorded from a user's authenticated dashboard requests. */
export type UserActivity = {
  __typename?: 'UserActivity';
  /** The public IP address the request came from. */
  ip?: Maybe<Scalars['IP']['output']>;
  /** When the activity occurred. */
  occurredAt: Scalars['DateTime']['output'];
};

/**
 * Input type for specifying a user's role assignment.
 *
 * One of roleName or customRoleUUID must be provided.
 */
export type UserRoleInput = {
  /** The UUID of a custom role to assign. */
  customRoleUUID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * The UUID of the network for network-specific roles.
   *
   * Omit for company-wide or global roles.
   */
  networkUUID?: InputMaybe<Scalars['UUID']['input']>;
  /** The name of the role to assign or remove. */
  roleName?: InputMaybe<RoleName>;
};

/** A VLAN (virtual LAN) is a logical network segment that allows network devices to communicate as if they were physically connected to the same network. */
export type Vlan = Identifiable & TargetInterface & {
  __typename?: 'VLAN';
  /** The unique identifier for the VLAN. */
  UUID: Scalars['UUID']['output'];
  /** The captive portal associated with this VLAN. */
  captivePortal?: Maybe<CaptivePortal>;
  /** The clients currently connected to this VLAN. Excludes Meter hardware. */
  clients: Array<NetworkClient>;
  /** The timestamp indicating when the VLAN was created. */
  createdAt: Scalars['DateTime']['output'];
  /** An optional description of the VLAN. */
  description?: Maybe<Scalars['String']['output']>;
  /** The DHCP rule associated with this VLAN. */
  dhcpRule?: Maybe<DhcpRule>;
  /** Number of IGMP queries to send when the switch first starts up using the startup query interval. */
  igmpQueryCount: Scalars['Int']['output'];
  /** Interval in seconds between IGMP queries. Must be between 60 and 500. */
  igmpQueryIntervalSec: Scalars['Int']['output'];
  /** Interval in seconds to wait for responses to IGMP queries. */
  igmpResponseIntervalSec: Scalars['Int']['output'];
  /** Interval in seconds between IGMP queries when the switch first starts up.. */
  igmpStartupQueryIntervalSec: Scalars['Int']['output'];
  /** IGMP version to use. Must be 1, 2, or 3. */
  igmpVersion: Scalars['Int']['output'];
  /** Specifies the protocol for assigning IPv4 addresses to clients on this VLAN. */
  ipV4ClientAssignmentProtocol?: Maybe<ClientAssignmentProtocol>;
  /** Specifies the IPv4 gateway address for this VLAN. This value should not include a netmask. */
  ipV4ClientGateway?: Maybe<Scalars['IPV4']['output']>;
  /** Specifies the IPv4 prefix length (subnet mask) for this VLAN. */
  ipV4ClientPrefixLength?: Maybe<Scalars['Int']['output']>;
  /**
   * Specifies the IPv4 address of an externally-managed (non-Meter) gateway for this L2 VLAN;
   * used by features like client isolation. Mutually exclusive with ipV4ClientGateway.
   * If set, ipV4ExternalPrefixLength must be set as well.
   */
  ipV4ExternalGateway?: Maybe<Scalars['IPV4']['output']>;
  /** Specifies the IPv4 prefix length (subnet mask) that pairs with ipV4ExternalGateway. */
  ipV4ExternalPrefixLength?: Maybe<Scalars['Int']['output']>;
  /** Specifies the protocol for assigning IPv6 addresses to clients on this VLAN. */
  ipV6ClientAssignmentProtocol?: Maybe<ClientAssignmentProtocol>;
  /** Specifies the IPv6 gateway address for this VLAN. This value should not include a netmask. */
  ipV6ClientGateway?: Maybe<Scalars['IPV6']['output']>;
  /** Specifies the IPv6 prefix length (subnet mask) for this VLAN. */
  ipV6ClientPrefixLength?: Maybe<Scalars['Int']['output']>;
  /**
   * If true, this VLAN is the native VLAN for access point management traffic.
   * Only one VLAN per network can have this set.
   */
  isAPNativeVLAN: Scalars['Boolean']['output'];
  /** Only one VLAN per network can be the default VLAN. Untagged packets that don't belong to any configured VLANs are assigned to the default one. */
  isDefault: Scalars['Boolean']['output'];
  /** If true, the VLAN is enabled and can be used in the network. */
  isEnabled: Scalars['Boolean']['output'];
  /** Enables periodically sending IGMP queries to detect multicast clients. Both this flag and isIgmpSnoopingEnabled in SwitchProfile must be true for IGMP snooping to be enabled on this VLAN. */
  isIGMPSnoopingEnabled: Scalars['Boolean']['output'];
  /** If true, this VLAN is rendered only on ISP switches to isolate each ISP connection's ports. */
  isISPVLAN: Scalars['Boolean']['output'];
  /** If true, this VLAN is for Meter internal use only and should not be displayed to or editable by the customer. */
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  /** If true, MLD snooping is enabled for this VLAN. Both this flag and isMLDSnoopingEnabled in SwitchProfile must be true for MLD snooping to be enabled on this VLAN. */
  isMLDSnoopingEnabled: Scalars['Boolean']['output'];
  /** If true, this VLAN participates in multicast/mDNS reflection. */
  isMulticastReflectionEnabled: Scalars['Boolean']['output'];
  /**
   * If true, this VLAN is suggested as the uncategorized client native VLAN in switch auto-configuration.
   * Only one VLAN per network can have this set.
   */
  isUncategorizedClientFallback: Scalars['Boolean']['output'];
  /** If true, prevents this VLAN from sending traffic through WANs (blocks internet access). */
  isWANDenied: Scalars['Boolean']['output'];
  /** Interval in seconds between MLD queries. Must be between 60 and 500. */
  mldQueryIntervalSec: Scalars['Int']['output'];
  /** MLD version to use. Must be 1 or 2. */
  mldVersion: Scalars['Int']['output'];
  /** A human-friendly name to identify the VLAN, like "guest". Unique per network. */
  name: Scalars['String']['output'];
  /** The network to which the VLAN belongs. */
  network: Network;
  /** The UUID of the network to which the VLAN belongs. */
  networkUUID: Scalars['UUID']['output'];
  /**
   * If true, allows this VLAN to participate in cross-site VPN features and its IPv4Prefix cannot overlap with any other
   * IPv4Prefix for VLANs with a true participatesInVPN in the associated company for this network.
   */
  participatesInVPNs: Scalars['Boolean']['output'];
  /** VLANs explicitly allowed to inter-communicate with this VLAN. Effectively equivalent to firewall rules allowing communication between this VLAN and all of these VLANs. */
  permittedInterVLANCommunicationVLANs: Array<Vlan>;
  /** The timestamp indicating the last time the VLAN was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The VLAN ID. Must be between 1 and 4094 and is unique per network. */
  vlanID: Scalars['Int']['output'];
};

/** Response type containing client metrics timeseries data over a specified time range. */
export type VlanMetricsTimeseriesResponse = {
  __typename?: 'VLANMetricsTimeseriesResponse';
  /** Aggregated throughput for the total drops per second. */
  drops: BaseMetricsResponse;
  /** Network UUID for this series. */
  networkUUID: Scalars['UUID']['output'];
  /** Aggregated throughput for the punts in packets per second. */
  punts: BaseMetricsResponse;
  /** Aggregated throughput for the total bytes received in bps. */
  rxBytes: BaseMetricsResponse;
  /** Aggregated throughput for the rx errors in packets per second. */
  rxError: BaseMetricsResponse;
  /** Aggregated throughput for the total packets received per second. */
  rxPackets: BaseMetricsResponse;
  /** Aggregated throughput for the total bytes transmitted in bps. */
  txBytes: BaseMetricsResponse;
  /** Aggregated throughput for the tx errors in packets per second. */
  txError: BaseMetricsResponse;
  /** Aggregated throughput for the total packets transmitted per second. */
  txPackets: BaseMetricsResponse;
  /** VLAN for this series. */
  vlan: Vlan;
  /** VLAN ID for this series. */
  vlanID: Scalars['Int']['output'];
};

/** Input to specify a pair of VLANs for permitted inter-VLAN communication. */
export type VlanPairInput = {
  /** The UUID of the first VLAN in the pair. */
  vlan1UUID: Scalars['UUID']['input'];
  /** The UUID of the second VLAN in the pair. */
  vlan2UUID: Scalars['UUID']['input'];
};

/** Response type containing valid channels for a radio band. */
export type ValidChannelsResponse = {
  __typename?: 'ValidChannelsResponse';
  /** The radio band for which the valid channels are provided. */
  band: RadioBand;
  /** A list of valid channels for the specified radio band. */
  channels: Array<Scalars['Int']['output']>;
};

/** Response type containing valid max transmit power (dBm) for a radio band / channel width (MHz). */
export type ValidTransmitPowerResponse = {
  __typename?: 'ValidTransmitPowerResponse';
  /** The radio band for which the valid max transmit power is provided. */
  band: RadioBand;
  /** The channel width for which the valid max transmit power is provided. */
  channelWidthMHz: Scalars['Int']['output'];
  /** The max transmit power for the band / channel width. */
  maxTransmitPowerdBm: Scalars['Int']['output'];
};

/** Input for specifying a version number range. */
export type VersionNumberRangeInput = {
  /** The version to return. */
  equal?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum version to return. */
  max?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum version to return. */
  min?: InputMaybe<Scalars['Int']['input']>;
};

/** A virtual device is a logical representation of a physical device; configuration is associated with the virtual device. */
export type VirtualDevice = {
  /** The unique identifier (UUID) of the virtual device. */
  UUID: Scalars['UUID']['output'];
  /** The timestamp when the virtual device was first created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** An optional description for the virtual device. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Metadata for the configurations rendered by this virtual device over time, newest
   * first. Includes configs written to hardware devices that have since been dissociated
   * from this virtual device. No history is available before June 2026.
   */
  deviceConfigs: Array<DeviceConfigMetadata>;
  /** The model name of the virtual device. */
  deviceModel: DeviceModel;
  /** The type of the virtual device. */
  deviceType: VirtualDeviceType;
  /** The hardware device associated with this virtual device, if any. */
  hardwareDevice?: Maybe<HardwareDevice>;
  /** Metadata for the model of this device. */
  hardwareModelProperties: HardwareModelProperties;
  /** The management IP address of the device. Note that this is not yet populated for some devices. */
  ipAddress?: Maybe<Scalars['IP']['output']>;
  /** Indicates whether the virtual device's console port is enabled. */
  isConsoleEnabled: Scalars['Boolean']['output'];
  /** Indicates whether debug logging is enabled on the virtual device. */
  isDebugLogEnabled: Scalars['Boolean']['output'];
  /** Whether this virtual device is in a draft state for preconfiguration reasons. */
  isDraft: Scalars['Boolean']['output'];
  /** Indicates whether the hardware device is online, indicated by its heartbeat. */
  isOnline: Scalars['Boolean']['output'];
  /** A human-friendly name for the device. */
  label: Scalars['String']['output'];
  /** The physical location of this virtual device, derived from its rack elevation placement. */
  location?: Maybe<VirtualDeviceLocation>;
  /** The most recent NOS upgrade for this virtual device that has started executing or was skipped (in progress, completed, failed, or skipped), if any. */
  mostRecentNOSUpgrade?: Maybe<ScheduledDeviceNosUpgrade>;
  /** The network that the virtual device belongs to. */
  network: Network;
  /** The unique identifier (UUID) of the network the virtual device belongs to. */
  networkUUID: Scalars['UUID']['output'];
  /**
   * The group that the device belongs to for firmware upgrade grouping purposes.
   * Note: This is nullable in the schema but all devices now have a NOS upgrade group.
   */
  nosUpgradeGroup: NosUpgradeGroup;
  /** The current NOS firmware version that the virtual device is configured to run. */
  nosVersion?: Maybe<ConfiguredNosVersion>;
  /** The identifier of the NOS firmware version that the virtual device is configured to run. */
  nosVersionID: Scalars['Int']['output'];
  /** Active and future device notification snoozes for this virtual device. */
  notificationSnoozes: Array<DeviceNotificationSnooze>;
  /** The paired virtual device to this device, applicable to dual-chassis configurations. */
  pairedVirtualDevice?: Maybe<VirtualDevice>;
  /** The NOS firmware version that the virtual device is scheduled to upgrade to. */
  pendingNosVersion?: Maybe<PendingNosVersion>;
  /** URL to the regulatory e-label for the device, if applicable. */
  regulatoryLabelURL?: Maybe<Scalars['String']['output']>;
  /** The virtual device tags on this device. */
  tags: Array<VirtualDeviceTag>;
  /** Data about this virtual device's position in its network's topology. */
  topologyData?: Maybe<VirtualDeviceTopologyData>;
  /** The timestamp when the virtual device was last updated in the system. */
  updatedAt: Scalars['DateTime']['output'];
  /** How long the device has been continuously powered on and reporting. */
  uptime?: Maybe<Scalars['Duration']['output']>;
  /** For dual-chassis devices, the "position" of this virtual device within its device pair (left or right). When hardware is assigned, this virtual device will receive hardware with a matching position. Null if not part of a pair. */
  virtualDevicePairPosition?: Maybe<DevicePosition>;
};


/** A virtual device is a logical representation of a physical device; configuration is associated with the virtual device. */
export type VirtualDeviceDeviceConfigsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};

/** A virtual device was created, updated, or deleted. */
export type VirtualDeviceEvent = CrudEvent & {
  __typename?: 'VirtualDeviceEvent';
  /** The UUID of the virtual device the action was performed on. */
  entityUUID: Scalars['UUID']['output'];
  /** The action performed on the virtual device. */
  type: CrudEventType;
  /** The virtual device itself. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** The physical location of a virtual device, derived from its rack elevation. */
export type VirtualDeviceLocation = {
  __typename?: 'VirtualDeviceLocation';
  /** The building where the device's rack is physically located. */
  building?: Maybe<Scalars['String']['output']>;
  /** The name of the distribution frame associated with the device's rack. */
  distributionFrame?: Maybe<Scalars['String']['output']>;
  /** The floor within the building where the device's rack is physically located. */
  floor?: Maybe<Scalars['String']['output']>;
  /** The room where the device's rack is physically located. */
  room?: Maybe<Scalars['String']['output']>;
};

/** Represents the history of NOS versions scheduled and applied to a virtual device. */
export type VirtualDeviceNosHistory = {
  __typename?: 'VirtualDeviceNosHistory';
  /** Timestamp when the NOS version was actually applied to the virtual device. */
  appliedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The NOS version scheduled or applied to the virtual device. */
  nosVersion: NosVersion;
  /** Timestamp when the NOS version was scheduled to be applied to the virtual device. */
  scheduledAt: Scalars['DateTime']['output'];
  /** Current status of the NOS version application on the virtual device (e.g., 'scheduled', 'in progress', 'completed', 'failed'). */
  status: Scalars['String']['output'];
};

/** A mapping of virtual device to its system info metrics. */
export type VirtualDeviceSystemInfoMetricsResponse = {
  __typename?: 'VirtualDeviceSystemInfoMetricsResponse';
  /** The system info metrics for the virtual device. */
  response: SystemInfoMetricsResponse;
  /** The virtual device. */
  virtualDevice: VirtualDevice;
  /** The unique identifier for the virtual device. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** A virtual device tag is an attribute that can be applied to many virtual devices to group them together for bulk-actions and UI filtering. */
export type VirtualDeviceTag = Identifiable & {
  __typename?: 'VirtualDeviceTag';
  /** Unique identifier of the virtual device tag. */
  UUID: Scalars['UUID']['output'];
  /** Name of the virtual device tag. */
  name: Scalars['String']['output'];
  /** Unique identifier of the network this tag belongs to. */
  networkUUID: Scalars['UUID']['output'];
};

/** Data about a virtual device's position in its network's topology. */
export type VirtualDeviceTopologyData = {
  __typename?: 'VirtualDeviceTopologyData';
  /** The phy interface on this device that is connected to another uplink virtual device / phy interface. */
  thisPhyInterface?: Maybe<PhyInterface>;
  /** The height of this virtual device in the topology; 0 is the root device. */
  topologyHeight: Scalars['Int']['output'];
  /** The phy interface on the uplink virtual device that is connected to this virtual device. */
  uplinkPhyInterface?: Maybe<PhyInterface>;
  /** The virtual device that is an uplink to this virtual device. */
  uplinkVirtualDevice?: Maybe<VirtualDevice>;
};

/** VirtualDeviceType enumerates the different types of virtual devices that Meter deploys. */
export enum VirtualDeviceType {
  /** Represents an Access Point virtual device type. */
  AccessPoint = 'ACCESS_POINT',
  /** Represents a Carrier Appliance virtual device type. */
  CarrierAppliance = 'CARRIER_APPLIANCE',
  /** Represents a Cellular Access Point virtual device type. */
  CellularAccessPoint = 'CELLULAR_ACCESS_POINT',
  /** Represents a Cellular Gateway virtual device type. */
  CellularGateway = 'CELLULAR_GATEWAY',
  /** Represents a Cellular Switch virtual device type. */
  CellularSwitch = 'CELLULAR_SWITCH',
  /** Represents a Controller virtual device type. */
  Controller = 'CONTROLLER',
  /** Represents an Observer virtual device type. */
  Observer = 'OBSERVER',
  /** Represents a Power Distribution Unit virtual device type. */
  PowerDistributionUnit = 'POWER_DISTRIBUTION_UNIT',
  /** Represents a Switch virtual device type. */
  Switch = 'SWITCH'
}

/** Enumeration of Wide Area Network (WAN) interfaces. */
export enum Wan {
  /** WAN interface 0. */
  Wan0 = 'wan0',
  /** WAN interface 1. */
  Wan1 = 'wan1'
}

/** Details about a WAN connection. */
export type WanConnection = {
  __typename?: 'WANConnection';
  /** The list of external IP addresses associated with this WAN connection. */
  externalAddresses: Array<Scalars['String']['output']>;
  /** The internet service plan provider for this WAN connection. */
  internetServicePlanProvider?: Maybe<InternetServicePlanProvider>;
  /** The port number of the WAN connection. */
  port: Scalars['Int']['output'];
};

/** Properties for WAN down events. */
export type WanDownProperties = {
  __typename?: 'WANDownProperties';
  /** The virtual device associated with the WAN down event. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** Represents the direction of the WAN speed test. */
export enum WanSpeedtestDirection {
  /** Download direction. */
  Down = 'DOWN',
  /** For simplicity in schema, latency is unintuitively considered a direction. */
  Latency = 'LATENCY',
  /** Unspecified direction. */
  Unspecified = 'UNSPECIFIED',
  /** Upload direction. */
  Up = 'UP'
}

/** Represents a WAN (Wide Area Network) speed test job. */
export type WanSpeedtestJob = NetworkJob & {
  __typename?: 'WANSpeedtestJob';
  /** The unique identifier for the job. */
  UUID: Scalars['UUID']['output'];
  /** The base URL used for the speed test. */
  baseURL: Scalars['String']['output'];
  /** The time at which the job was completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The maximum number of bytes to transfer during the speed test. */
  maxTransferBytes?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier of the network associated with this job. */
  networkUUID: Scalars['UUID']['output'];
  /** The physical interface on which the speed test is run. */
  phyInterface?: Maybe<PhyInterface>;
  /** The results of the speed test job. */
  results?: Maybe<Array<WanSpeedtestJobResult>>;
  /** The time at which the job was scheduled. */
  scheduledAt: Scalars['DateTime']['output'];
  /** The current status of the speed test. */
  status: NetworkJobStatus;
  /** The virtual device on which the speed test is run. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** Represents the result of a single WAN speed test measurement. */
export type WanSpeedtestJobResult = {
  __typename?: 'WANSpeedtestJobResult';
  /** The speed test direction (e.g., UP, DOWN, LATENCY). */
  direction: WanSpeedtestDirection;
  /** The duration in nanoseconds that this result took. Null for LATENCY results. */
  durationNs?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the test failed. */
  failed: Scalars['Boolean']['output'];
  /** The round-trip times (RTTs) in nanoseconds for each HTTP request in this result. */
  httpRTTsNs: Array<Scalars['Int']['output']>;
  /** The measured speed in megabits per second (Mbps). Null for LATENCY results. */
  mbps?: Maybe<Scalars['Float']['output']>;
  /** The number of bytes transferred in this result. Null for LATENCY results. */
  transferBytes?: Maybe<Scalars['Int']['output']>;
};

/** Properties for WAN status change events. */
export type WanStatusChangeProperties = {
  __typename?: 'WANStatusChangeProperties';
  /** The list of active WAN connections. */
  activeWANConnections: Array<Maybe<WanConnection>>;
  /** The virtual device associated with the WAN status change. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** Properties for WAN up events. */
export type WanUpProperties = {
  __typename?: 'WANUpProperties';
  /** The virtual device associated with the WAN up event. */
  virtualDevice?: Maybe<VirtualDevice>;
};

/** Radio interfaces available for packet capture. */
export enum WosPacketCaptureCommandMonitor {
  /** 2.4 GHz radio interface. */
  Radio_2G = 'RADIO_2G',
  /** 5 GHz radio interface. */
  Radio_5G = 'RADIO_5G',
  /** 6 GHz radio interface. */
  Radio_6G = 'RADIO_6G',
  /** Scanning radio interface. */
  RadioScan = 'RADIO_SCAN',
  /** Unspecified radio interface (means all wireless interfaces). */
  RadioUnspecified = 'RADIO_UNSPECIFIED',
  /** Wired interface (either eth0 or eth1) */
  Wired = 'WIRED'
}

/** A packet capture that was run on an Access Point, Observer, or Cellular Gateway. */
export type WosPacketCaptureJob = PacketCaptureJob & {
  __typename?: 'WOSPacketCaptureJob';
  /** The unique identifier for the job. */
  UUID: Scalars['UUID']['output'];
  /** The time at which the job was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Whether the capture's file is currently available to download from storage. */
  downloadAvailable: Scalars['Boolean']['output'];
  /** The interface the packet capture is running on (a wireless radio, or wired). */
  interface: WosPacketCaptureCommandMonitor;
  /** The unique identifier of the network associated with this job. */
  networkUUID: Scalars['UUID']['output'];
  /**
   * The interface the packet capture is running on (a wireless radio, or wired).
   * @deprecated Use `interface` instead.
   */
  radio: WosPacketCaptureCommandMonitor;
  /** The maximum size limit of the packet capture file in megabytes. */
  sizeLimitMb: Scalars['Int']['output'];
  /** Whether the job was stopped prematurely or not. */
  stopped: Scalars['Boolean']['output'];
  /** The filter ID to be applied to the packet capture. Not yet implemented in firmware. */
  tcpDumpFilter: Scalars['String']['output'];
  /** The maximum duration of the packet capture in seconds. */
  timeLimitSeconds: Scalars['Int']['output'];
  /**
   * The unique identifier for the job.
   * @deprecated Use `UUID` instead.
   */
  uuid: Scalars['UUID']['output'];
  /** The virtual device that the packet capture is run on. */
  virtualDevice: VirtualDevice;
  /** The UUID of the virtual device that the packet capture is run on. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** An enumeration of possible authentication types for a webhook alert target. */
export enum WebhookAuthType {
  /** Basic authentication is used. */
  Basic = 'BASIC',
  /** Bearer authentication is used. */
  Bearer = 'BEARER',
  /** No authentication is used. */
  None = 'NONE',
  /** An OAuth client credentials grant supplies the Bearer token. */
  OauthClientCredentials = 'OAUTH_CLIENT_CREDENTIALS'
}

/** Wifi IPSK: password for an IPSK SSID */
export type WifiIpsk = Identifiable & {
  __typename?: 'WifiIPSK';
  /** Unique identifier for the Wifi iPSK. */
  UUID: Scalars['UUID']['output'];
  /**
   * An optional array of MAC addresses to restrict a password to some clients (if null, no
   * MAC restriction)
   */
  clientMACs?: Maybe<Array<Scalars['MacAddress']['output']>>;
  /** A label for this IPSK */
  label?: Maybe<Scalars['String']['output']>;
  /** The network for the IPSK SSID. */
  network: Network;
  /** The UUID of the network for the IPSK SSID. */
  networkUUID: Scalars['UUID']['output'];
  /** One IPSK password for authentication. */
  password: Scalars['String']['output'];
  /** The SSID with IPSK. */
  ssid: Ssid;
  /** The UUID of the SSID with IPSK. */
  ssidUUID: Scalars['UUID']['output'];
  /**
   * The VLAN for this password; used when dynamic VLAN is set.
   * If dynamic VLAN is disabled or the VLAN is null, default VLAN is used.
   * If dynamic VLAN mode is required, it needs to be set.
   */
  vlan?: Maybe<Vlan>;
  /**
   * The unique identifier for the VLAN for this password; used when dynamic VLAN is set.
   * If dynamic VLAN is disabled or the VLAN is null, default VLAN is used.
   * If dynamic VLAN mode is required, it needs to be set.
   */
  vlanUUID?: Maybe<Scalars['UUID']['output']>;
};

/** Represents a wireless calibration job. */
export type WirelessCalibrationJob = NetworkJob & {
  __typename?: 'WirelessCalibrationJob';
  /** The unique identifier for the job. */
  UUID: Scalars['UUID']['output'];
  /** The band to calibrate on. */
  band?: Maybe<RadioBand>;
  /** The channel to set all the APs to for wireless calibration. */
  channel: Scalars['Int']['output'];
  /** The time at which the job was completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Event logs associated with this calibration job. */
  eventLogs: Array<EventLogEvent>;
  /** The unique identifier for the leader AP for this calibration job. */
  leaderAccessPoint?: Maybe<AccessPointVirtualDevice>;
  /** The unique identifier of the network associated with this job. */
  networkUUID: Scalars['UUID']['output'];
  /** The power to set all the APs to for wireless calibration. */
  power: Scalars['Int']['output'];
  /** The results of the speed test job. */
  results?: Maybe<Array<Maybe<WirelessCalibrationResult>>>;
  /** The time at which the job was scheduled. */
  scheduledAt: Scalars['DateTime']['output'];
  /** The current status of the wireless calibration. */
  status: NetworkJobStatus;
  /** If set, only APs that have at least one of these tags are calibrated. Only applies to backend-driven wireless calibration. */
  virtualDeviceTags?: Maybe<Array<VirtualDeviceTag>>;
};

/** Represents the result of a wireless calibration job. */
export type WirelessCalibrationResult = {
  __typename?: 'WirelessCalibrationResult';
  /** Error message, if any. */
  reason?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the test failed. */
  status: Scalars['Boolean']['output'];
};

/**
 * A single snapshot of client connectivity metrics for a single client.
 * Not an average over a time period or across multiple clients.
 */
export type WirelessClient = {
  __typename?: 'WirelessClient';
  /** When the client associated with the AP. */
  associatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The radio band the client is connected to. */
  band: RadioBand;
  /** The channel number the client is using. */
  channel: Scalars['Int']['output'];
  /** The channel width the client is using. */
  channelWidth?: Maybe<Scalars['Int']['output']>;
  /** The MAC address of the client device. */
  macAddress: Scalars['MacAddress']['output'];
  /** The latest connectivity metrics of the client. */
  metrics: ClientMetricsTimeseriesValue;
  /** The UUID of the network the client is connected to. */
  networkUUID: Scalars['UUID']['output'];
  /** The Observer virtual device, if the client is an observer */
  observerVirtualDevice?: Maybe<ObserverVirtualDevice>;
  /** List of mDNS service types that this client offers (e.g., printer, AirPlay, etc.). */
  serviceTypes?: Maybe<Array<ServiceType>>;
  /** The SSID that the client interacted with. */
  ssid: Ssid;
  /** The name of the SSID that the client interacted with. */
  ssidName: Scalars['String']['output'];
  /** The AP virtual device that the client interacted with. */
  virtualDevice: AccessPointVirtualDevice;
  /** The UUID of the AP virtual device the client is connected to. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

export enum WirelessClientConnectionDhcpState {
  /** The access point has seen the DHCP ACK from the DHCP server. */
  DhcpAck = 'DHCP_ACK',
  /** The access point has seen the DHCP DECLINE from the client. */
  DhcpDecline = 'DHCP_DECLINE',
  /** The access point has seen the DHCP DISCOVER from the client. */
  DhcpDiscover = 'DHCP_DISCOVER',
  /** The access point has seen the DHCP NAK from the DHCP server. */
  DhcpNak = 'DHCP_NAK',
  /** The access point has seen the DHCP OFFER from the DHCP server. */
  DhcpOffer = 'DHCP_OFFER',
  /** The access point has seen the DHCP REQUEST from the client. */
  DhcpRequest = 'DHCP_REQUEST',
  /** The client has not started the DHCP process. */
  DhcpUnspecified = 'DHCP_UNSPECIFIED'
}

/** A statistic that indicates when a client connected to an AP, disassociated from an AP, or failed to connect to an AP. */
export type WirelessClientConnectionEvent = {
  __typename?: 'WirelessClientConnectionEvent';
  /** The radio band that the client interacted with. */
  band: RadioBand;
  /** The DHCP assigned IP to the client, if DHCP completed successfully. */
  dhcpAssignedIp: Scalars['String']['output'];
  /** The IP Address of the default gateway. */
  dhcpGatewayIp: Scalars['String']['output'];
  /** The MAC address of the default gateway. */
  dhcpGatewayMac: Scalars['MacAddress']['output'];
  /** Explains the current DHCP state, especially useful when failed step is `FAILED_DHCP_TIMEOUT`. */
  dhcpState: WirelessClientConnectionDhcpState;
  /** If the event type is `DISASSOCIATED`, how long the client was associated with the AP before disassociating. */
  dwellTime?: Maybe<Scalars['Duration']['output']>;
  /** The type of connection event. */
  eventType: WirelessClientConnectionEventType;
  /** If the event type is `FAILED`, explains which step of the connection process failed. */
  failedStep?: Maybe<WirelessClientConnectionFailedStep>;
  /** The 802.1X identity of the client, if applicable (e.g. for WPA2/3-Enterprise). */
  identity8021X?: Maybe<Scalars['String']['output']>;
  /** The instigator, either client or access point, of the disassociation. */
  instigator?: Maybe<WirelessClientConnectionEventInstigator>;
  /** Whether the connection event was part of a fast transition (802.11r) roam. */
  is80211rRoam: Scalars['Boolean']['output'];
  /**
   * A bit of technical debt but there is a small class of events that we need to filter out on the backend
   * that isn't efficiently / cleanly done at the query level. To avoid breaking pagination, we still need to return those filtered events; this flag will be set as true and the frontend can simply look at this flag to determine if the event should be displayed.
   */
  isFilteredOutForDisplay: Scalars['Boolean']['output'];
  /** If true, came from an Observer. */
  isObserver: Scalars['Boolean']['output'];
  /** If this is a rejection event, whether it was caused by client steering. */
  isSteeringRejection: Scalars['Boolean']['output'];
  /** The MAC address of the client. */
  macAddress: Scalars['MacAddress']['output'];
  /** If the event type is `CONNECTED`, the radio band the client was previously connected on. */
  previousBand?: Maybe<RadioBand>;
  /** If the event type is `CONNECTED`, the AP virtual device that the client was previously connected to. */
  previousVirtualDeviceConnectedTo?: Maybe<AccessPointVirtualDevice>;
  /** If the event type is `CONNECTED`, the UUID of the AP virtual device the client was previously connected to. */
  previousVirtualDeviceUUIDConnectedTo?: Maybe<Scalars['UUID']['output']>;
  /** If the event type is `DISASSOCIATED` or `FAILED`, the 802.11 reason code for the event. */
  reasonCode?: Maybe<Scalars['Int']['output']>;
  /** The roaming rssi is the signal strength (in dBm) between the client and the previous virtual device. */
  roamRssi: Scalars['Int']['output'];
  /** The rssi is the signal strength (in dBm) between the client and the virtual device. */
  rssi: Scalars['Int']['output'];
  /**
   * If the event type is `DISASSOCIATED`, how long the client was associated with the AP before disassociating.
   * @deprecated Use `dwellTime` instead.
   */
  sessionDuration?: Maybe<Scalars['Duration']['output']>;
  /** The SSID that the client interacted with. */
  ssid?: Maybe<Ssid>;
  /** The UUID of the SSID that the client interacted with. */
  ssidUUID?: Maybe<Scalars['UUID']['output']>;
  /** If the event type is `CONNECTED`, how long it took for the client to connect to the AP. */
  timeToConnect?: Maybe<Scalars['Duration']['output']>;
  /** If the event type is `DHCP_OK`, how long it took for the client to receive an IP address from the DHCP server after connecting. */
  timeToDHCP?: Maybe<Scalars['Duration']['output']>;
  /** The timestamp of the event. */
  timestamp: Scalars['DateTime']['output'];
  /** The AP virtual device that the client interacted with. */
  virtualDevice?: Maybe<AccessPointVirtualDevice>;
  /** The UUID of the AP virtual device that the client interacted with. */
  virtualDeviceUUID: Scalars['UUID']['output'];
  /** The VLAN associated with this connection event, if available. */
  vlan?: Maybe<Vlan>;
  /** The UUID of the VLAN associated with this connection event, if available. */
  vlanUUID?: Maybe<Scalars['UUID']['output']>;
  /** The UUID of the wired proactive pcap, if any. */
  wiredProactivePcapUUID?: Maybe<Scalars['UUID']['output']>;
  /** The UUID of the wireless proactive pcap, if any. */
  wirelessProactivePcapUUID?: Maybe<Scalars['UUID']['output']>;
};

export enum WirelessClientConnectionEventInstigator {
  /** The access point initiated the disassociation. */
  InstigatorAp = 'INSTIGATOR_AP',
  /** The client initiated the disassociation. */
  InstigatorClient = 'INSTIGATOR_CLIENT',
  /** Unknown what initiated the disassociation. */
  InstigatorUnspecified = 'INSTIGATOR_UNSPECIFIED'
}

export enum WirelessClientConnectionEventType {
  /** The client failed to connect to the AP due to an ARP failure. */
  ArpFailed = 'ARP_FAILED',
  /** The client failed to connect to the AP due to ARP taking too long. */
  ArpLate = 'ARP_LATE',
  /** The client successfully connected to the AP. */
  Connected = 'CONNECTED',
  /** The client failed to receive an IP address from the DHCP server. */
  DhcpFailed = 'DHCP_FAILED',
  /** The client successfully received an IP address from the DHCP server. */
  DhcpOk = 'DHCP_OK',
  /** The client disassociated from the AP. */
  Disassociated = 'DISASSOCIATED',
  /** The client attempted to connect to the AP but failed. */
  Failed = 'FAILED'
}

/** A simplified counter for connection events aggregates. */
export type WirelessClientConnectionEventsAggregateCounter = {
  __typename?: 'WirelessClientConnectionEventsAggregateCounter';
  /** The counter. */
  count: Scalars['Int']['output'];
  /** The most common failed step for this aggregation (e.g. DHCP failure reason). */
  failedStep?: Maybe<WirelessClientConnectionFailedStep>;
  /** The IEEEDeviceVendor for this aggregation if applicable (if the value is a MAC address). */
  ieeeDeviceVendor?: Maybe<IeeeDeviceVendor>;
  /** The most common 802.11 reason code for this aggregation. */
  reasonCode?: Maybe<Scalars['Int']['output']>;
  /** The most common SSID for this aggregation. */
  ssid?: Maybe<Scalars['String']['output']>;
  /** The value (mac address, virtual device UUID, disassociation reason, etc). */
  value: Scalars['String']['output'];
};

/** Aggregate data for connection events. */
export type WirelessClientConnectionEventsAggregates = {
  __typename?: 'WirelessClientConnectionEventsAggregates';
  /** The total number of connection attempts. */
  connectionAttempts: Scalars['Int']['output'];
  /** The total number of successful connection attempts. */
  connectionSuccess: Scalars['Int']['output'];
  /** The total number of DHCP attempts. */
  dhcpAttempts: Scalars['Int']['output'];
  /** The total number of DHCP successes. */
  dhcpSuccess: Scalars['Int']['output'];
  /** The total number of roam attempts. */
  roamAttempts: Scalars['Int']['output'];
  /** The total number of roam success. */
  roamSuccess: Scalars['Int']['output'];
  /** The p50 of the time to connect, in milliseconds. */
  timeToConnectp50: Scalars['Int']['output'];
  /** The p90 of the time to connect, in milliseconds. */
  timeToConnectp90: Scalars['Int']['output'];
  /** The p50 of the time to roam, in milliseconds. */
  timeToRoamp50: Scalars['Int']['output'];
  /** The p90 of the time to roam, in milliseconds. */
  timeToRoamp90: Scalars['Int']['output'];
  /** The top N most common disassociation reasons. */
  topDisassociationReasons: Array<WirelessClientConnectionEventsAggregateCounter>;
  /** The top N (clients or access points, per groupBy) with the most failed connections. */
  topFailedConnections: Array<WirelessClientConnectionEventsAggregateCounter>;
  /** The top N clients with the most failed DHCP attempts. */
  topFailedDhcp: Array<WirelessClientConnectionEventsAggregateCounter>;
  /** The top N (clients or access points, per groupBy) with the most failed roams. */
  topFailedRoams: Array<WirelessClientConnectionEventsAggregateCounter>;
  /** The top failure reasons grouped by failed step and reason code, sorted by count descending. */
  topFailureReasons: Array<ConnectionFailureReason>;
  /** The top N (clients or access points, per groupBy) with the most successful connections. */
  topSuccessfulConnections: Array<WirelessClientConnectionEventsAggregateCounter>;
  /** The top N (clients or access points, per groupBy) with the most successful roams. */
  topSuccessfulRoams: Array<WirelessClientConnectionEventsAggregateCounter>;
};

/** A paged response for connection events. */
export type WirelessClientConnectionEventsPage = {
  __typename?: 'WirelessClientConnectionEventsPage';
  /** A subset of records based on the limit and offset fields. */
  events: Array<WirelessClientConnectionEvent>;
  /** The total number of records. */
  total: Scalars['Int']['output'];
};

export enum WirelessClientConnectionFailedStep {
  /** The association packet exchange in the 802.11 handshake protocol failed. */
  Failed_80211Association = 'FAILED_80211_ASSOCIATION',
  /** The authentication packet exchange in the 802.11 handshake protocol failed. */
  Failed_80211Authentication = 'FAILED_80211_AUTHENTICATION',
  /** The 4-way EAPOL handshake failed. */
  FailedAuthentication = 'FAILED_AUTHENTICATION',
  /** The client declined the IP address from the DHCP server. */
  FailedDhcpDecline = 'FAILED_DHCP_DECLINE',
  /** The DHCP server denied the client's request for an IP address. */
  FailedDhcpNak = 'FAILED_DHCP_NAK',
  /** The DHCP server did not respond to the client's request for an IP address. */
  FailedDhcpTimeout = 'FAILED_DHCP_TIMEOUT',
  /** The connection failed due to other reasons. */
  FailedOther = 'FAILED_OTHER'
}

/** Response type that contains ClientMetricsTimeseriesResponse for a single AP. */
export type WirelessClientMetricsByApResponse = {
  __typename?: 'WirelessClientMetricsByAPResponse';
  /** The aggregated client metrics for this AP. */
  response: ClientMetricsTimeseriesResponse;
  /** The AP virtual device. */
  virtualDevice: VirtualDevice;
  /** The UUID of the AP virtual device. */
  virtualDeviceUUID: Scalars['UUID']['output'];
};

/** Response type that contains ClientMetricsTimeseriesResponse for a single MAC address. */
export type WirelessClientMetricsResponse = {
  __typename?: 'WirelessClientMetricsResponse';
  /** The MAC address for this response. */
  macAddress: Scalars['MacAddress']['output'];
  /** The metrics for this MAC Address. */
  response: ClientMetricsTimeseriesResponse;
};

/** Which side of a connection event the top-N aggregates rank. */
export enum WirelessConnectionEventsAggregateDimension {
  /** Rank the access points involved in the matching events. */
  AccessPoint = 'ACCESS_POINT',
  /** Rank the clients involved in the matching events. */
  Client = 'CLIENT'
}

export type WriteTopologyDesignInput = {
  /** All links in the design. Links with a UUID are updated; links without are created; existing links not in the list are deleted. References nodes by clientID. */
  links: Array<WriteTopologyDesignLinkInput>;
  /** All nodes in the design. Nodes with a UUID are updated; nodes without are created; existing nodes not in the list are deleted. */
  nodes: Array<WriteTopologyDesignNodeInput>;
};

export type WriteTopologyDesignLinkInput = {
  /** The unique identifier of an existing link to update. If omitted, one will be created. */
  UUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Client-provided identifier for this link, echoed back in the response for reconciliation. */
  clientID: Scalars['String']['input'];
  /** The link data to create or update. */
  input: CreateTopologyDesignLinkInput;
  /** clientID of the node on side A. */
  sideAClientID: Scalars['String']['input'];
  /** clientID of the node on side B. */
  sideBClientID: Scalars['String']['input'];
};

export type WriteTopologyDesignNodeInput = {
  /** If provided, the existing node with this UUID will be updated. If omitted, a new node is created. */
  UUID?: InputMaybe<Scalars['UUID']['input']>;
  /** Client-provided identifier used by links to reference this node within the batch. */
  clientID: Scalars['String']['input'];
  /** The node data to create or update. */
  input: CreateTopologyDesignNodeInput;
};

/** Answer to a question that can be yes, no, or unsure. */
export enum YesNoUnsure {
  /** No. */
  No = 'NO',
  /** Unsure. */
  Unsure = 'UNSURE',
  /** Yes. */
  Yes = 'YES'
}

export type GetCaptivePortalQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;


export type GetCaptivePortalQuery = { __typename?: 'Query', captivePortalWithSignature: { __typename?: 'CaptivePortal', UUID: string, callToAction?: string | null, termsAndConditions?: string | null, requiresApproval: boolean, requiresEmail: boolean, requiresName: boolean, useCompanyWebhook: boolean, displaySettings?: { __typename?: 'CaptivePortalDisplaySettings', backgroundColor?: string | null, fontColor?: string | null, callToActionColor?: string | null, hidePoweredByMeter?: boolean | null } | null, logoImageBase64?: { __typename?: 'Base64Image', data: string, imageType: ImageType } | null } };


export const GetCaptivePortalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCaptivePortal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"captivePortalWithSignature"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"UUID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UUID"}},{"kind":"Field","name":{"kind":"Name","value":"callToAction"}},{"kind":"Field","name":{"kind":"Name","value":"displaySettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backgroundColor"}},{"kind":"Field","name":{"kind":"Name","value":"fontColor"}},{"kind":"Field","name":{"kind":"Name","value":"callToActionColor"}},{"kind":"Field","name":{"kind":"Name","value":"hidePoweredByMeter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logoImageBase64"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"imageType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"}},{"kind":"Field","name":{"kind":"Name","value":"requiresApproval"}},{"kind":"Field","name":{"kind":"Name","value":"requiresEmail"}},{"kind":"Field","name":{"kind":"Name","value":"requiresName"}},{"kind":"Field","name":{"kind":"Name","value":"useCompanyWebhook"}}]}}]}}]} as unknown as DocumentNode<GetCaptivePortalQuery, GetCaptivePortalQueryVariables>;

export const rootObjectDefinitions = {
  "Query": [
    "OUIsForVendor",
    "accessPointPortProfilesForNetwork",
    "activeClients",
    "activeIPSRules",
    "activeUnderlayPoolForNetwork",
    "affectedClientsByCVE",
    "affectedClientsByCVEIDs",
    "alertCompanySubscriptionsForCompany",
    "alertDeprioritizationWindows",
    "alertEvaluationStateHistoryForNetwork",
    "alertEvaluationStateHistoryForNetworkFleetwideSubscription",
    "alertFleetwideSubscriptions",
    "alertReceiver",
    "alertReceiversForCompany",
    "alertTargetSalesforce",
    "alertTargetSlack",
    "alertTargetWebhook",
    "alertTargets",
    "alertTargetsSalesforce",
    "alertTargetsSlack",
    "alertTargetsWebhook",
    "alertTypeProperties",
    "allCVEsForNetwork",
    "allClientMetricsByClient",
    "allClientMetricsByVLAN",
    "allInternetServicePlans",
    "allMarketingChangelogEntries",
    "allQuoteRequests",
    "allRoles",
    "anomalyStatsGroupsForVirtualDevices",
    "apHealthScores",
    "apiKeysForCompany",
    "applicationDNSFirewallRule",
    "applicationDNSFirewallRuleApplicationForHostname",
    "applicationDNSFirewallRuleApplications",
    "applicationDNSFirewallRuleCategories",
    "applicationDNSFirewallRuleCategoryForHostname",
    "applicationDNSFirewallRuleGroups",
    "applicationDNSFirewallRulesForNetwork",
    "areNosFeaturesEnabledForCompany",
    "areNosFeaturesEnabledForNetwork",
    "authenticationToken",
    "autoChannelSelectionJob",
    "autoChannelSelectionJobsForNetwork",
    "autoSwitchConfigurationJob",
    "autoSwitchConfigurationJobsForNetwork",
    "autoVPNBGPNeighborHubStateMetrics",
    "autoVPNBGPNeighborMemberStateMetrics",
    "autoVPNGroup",
    "autoVPNGroupsForCompany",
    "autoVPNGroupsForNetwork",
    "autoVPNMember",
    "autoVPNMemberMetricsForCompany",
    "autonomousSystem",
    "bearerSession",
    "bgpNeighbor",
    "bgpRouter",
    "blockedClientsForNetwork",
    "blockedClientsForSSID",
    "bssidsForNetwork",
    "bulkNOSUpgrade",
    "bulkNOSUpgrades",
    "captivePortal",
    "captivePortalAllClients",
    "captivePortalAuthorizedClients",
    "captivePortalEntries",
    "captivePortalEntriesForPortal",
    "captivePortalEntry",
    "captivePortalEntryFilters",
    "captivePortalForNetwork",
    "captivePortalForVLAN",
    "captivePortalForWebhook",
    "captivePortalWithSignature",
    "captivePortalsForNetwork",
    "channelUtilizationByAP",
    "channelUtilizationByClient",
    "channelUtilizationByNetwork",
    "clientObserverTests",
    "clientPingSweepIsSupportedForNetwork",
    "clientPingSweepJob",
    "clientPingSweepJobFilters",
    "clientPingSweepJobsForNetwork",
    "clientVPNClient",
    "clientVPNClientMetrics",
    "clientVPNClients",
    "clientVPNServer",
    "clientVPNServers",
    "clientWirelessScores",
    "clientWirelessScoresByNetwork",
    "companiesForAPIKey",
    "companiesHoldingGlobalNetworkTemplates",
    "company",
    "companyBySlug",
    "companyMemberships",
    "companyUser",
    "companyUsers",
    "complianceFrameworks",
    "complianceReport",
    "complianceReportsForNetwork",
    "connectStaticRate",
    "connectStaticRates",
    "consoleLogins",
    "controllerDNSRequestRates",
    "controllerPortMetricsRate",
    "controllerPortStats",
    "countCVEsBySeverityForMACAddressesBulk",
    "countryDeviceCertificationNetworks",
    "countryDeviceCertifications",
    "cpe",
    "cpes",
    "currentDeviceConfig",
    "cve",
    "cvesForMACAddress",
    "ddnsRecord",
    "deploymentExceptionsForUser",
    "deploymentJobs",
    "deploymentJobsForNetwork",
    "deploymentJobsForUser",
    "deploymentJobsPaginated",
    "deploymentTaskNotifications",
    "deploymentTasks",
    "deploymentTasksForNetwork",
    "deploymentTasksForUser",
    "deploymentTasksPaginated",
    "deploymentTimeWindow",
    "deploymentTimeWindows",
    "device",
    "deviceBatchByName",
    "deviceBatches",
    "deviceCellularStatus",
    "deviceConfigByVersion",
    "deviceConfigOverride",
    "deviceConfigs",
    "deviceImage",
    "deviceImages",
    "deviceLastDayCellularUsage",
    "deviceMACAllocation",
    "deviceMACAllocations",
    "deviceMigrationInfo",
    "deviceNotificationSnooze",
    "deviceSIM",
    "deviceStateTimeline",
    "deviceStateTimelines",
    "devicesForNetwork",
    "dfsChannels",
    "dhcpOption",
    "dhcpProxy",
    "dhcpReservedRange",
    "dhcpRule",
    "dhcpRuleFilter",
    "dhcpRulesForNetwork",
    "dhcpStaticMapping",
    "discoveredServicesForNetwork",
    "dnsBlockedEvents",
    "dnsBlockedEventsSummary",
    "dnsHostMapping",
    "downloadUrl",
    "encryption8021XsForNetwork",
    "entity",
    "findSwitchLLDPEntryForMAC",
    "firewallRule",
    "firewallRuleMetrics",
    "firewallRuleMetricsForNetworks",
    "firewallRulesForNetwork",
    "fleetwideNotificationSnooze",
    "floorPlan",
    "floorPlansForNetwork",
    "futureFleetwideNotificationSnoozes",
    "gatewayUplinkSettings",
    "getCompany",
    "getCompanyByUUID",
    "getInNetworkAPInterference",
    "getKeyValue",
    "globalNotificationSnoozes",
    "hardwareDevice",
    "hardwareDeviceByMACAddress",
    "hardwareDevicePairBySerial",
    "hardwareDevicePairsBySerials",
    "hardwareDevices",
    "hardwareModelProperties",
    "hardwareNosVersionRange",
    "hardwareNosVersionRanges",
    "highAvailabilityControllersConfig",
    "honeypotSSIDsObservedOnNetwork",
    "hostMonitoringForNetwork",
    "hostMonitoringTarget",
    "hostMonitoringTargetsForNetwork",
    "hs20ValidTypes",
    "idsEvent",
    "idsEvents",
    "idsIPSCategories",
    "idsIPSCategory",
    "idsIPSConfig",
    "idsIPSConfigCategoryBindings",
    "idsIPSCustomRule",
    "idsRule",
    "idsRulesForConfig",
    "idsRulesForSourceVersion",
    "inboxFilters",
    "inboxMessage",
    "inboxSortOrderDefinitions",
    "installCompanies",
    "installTechnicians",
    "interVLANCommunicationPermittedPairs",
    "internalNote",
    "internalNotesForNetwork",
    "internetServicePlan",
    "internetServicePlanConnectionTypes",
    "internetServicePlanDocument",
    "internetServicePlanFulfillmentJob",
    "internetServicePlanFulfillmentJobTypeMetaData",
    "internetServicePlanProvider",
    "internetServicePlanProviderStaticRate",
    "internetServicePlanProviderStaticRates",
    "internetServicePlanProviders",
    "internetServicePlans",
    "ipForwardingRule",
    "ipForwardingRulesForNetwork",
    "ipSecTunnel",
    "ipSecTunnelMetrics",
    "ipSecTunnelsForNetwork",
    "ipsEvents",
    "isNosFeatureEnabledForCompany",
    "isNosFeatureEnabledForNetwork",
    "isNosFeatureEnabledForNetworks",
    "jobTrackers",
    "labReservation",
    "labReservationFilters",
    "labReservationSortOrderDefinitions",
    "labReservations",
    "labResources",
    "latestAcknowledgedDeviceConfig",
    "latestDeviceConfig",
    "listCompanies",
    "logAttributeKeys",
    "logAttributeValueCounts",
    "logAttributeValues",
    "logHistogram",
    "logPatternsForNetwork",
    "logSeverityHistogram",
    "logsForNetwork",
    "mailingAddresses",
    "maintenanceWindowForNetwork",
    "marketingChangelogEntry",
    "monitorGroup",
    "monitorGroupMetricsForNetwork",
    "monitorProbe",
    "mutationAuditLogEntriesForNetwork",
    "mutationDiffAuditLogEntriesForCompany",
    "mutationDiffAuditLogEntry",
    "mutationDiffAuditLogPageForNetwork",
    "nacAuthEvents",
    "nacClientDevices",
    "nacCredential",
    "nacCredentialPasswordSetup",
    "nacCredentialsForCompany",
    "nacGroupsForCompany",
    "nacIdPConfigsForCompany",
    "nacIdPDirectoryGroups",
    "nacIdPGroupMappingsForIdPConfig",
    "nacIdPUserLookup",
    "nacPolicy",
    "network",
    "networkApplicationCategoryUsageMetrics",
    "networkApplicationUsageByClient",
    "networkApplicationUsageMetrics",
    "networkBySlug",
    "networkClientCPEBinding",
    "networkClientCPEBindingsForNetwork",
    "networkClients",
    "networkClientsApplicationUsage",
    "networkClientsTxRxPerDay",
    "networkJobsForCompany",
    "networkPortErrorSeries",
    "networkRoutesForVirtualDevice",
    "networkThreatAllowlistForNetwork",
    "networkUplinkQuality",
    "networkUplinkThroughput",
    "networkUplinkThroughputSeries",
    "networkWirelessClients",
    "networks",
    "networksClients",
    "networksClientsMACAddresses",
    "networksForCompany",
    "networksUplinkQualities",
    "noop",
    "nosFeature",
    "nosFeatures",
    "nosHistoryForVirtualDevice",
    "nosUpgradeGroupsForNetwork",
    "nosVersions",
    "observerTest",
    "observerTestsForNetwork",
    "oneToOneNATRule",
    "oneToOneNATRulesForNetwork",
    "opportunities",
    "opportunity",
    "outletInterfacesForVirtualDevice",
    "ownTemporaryAccessGrants",
    "packetCapture",
    "packetCaptureGroup",
    "packetCaptureGroups",
    "packetCaptures",
    "pduMetrics",
    "pdusMetrics",
    "pendingTemporaryAccessGrantsToApprove",
    "permissionGroups",
    "permissions",
    "phyInterfaceDHCPRule",
    "phyInterfacesForVirtualDevice",
    "policyEnginePolicy",
    "policyRoutingRule",
    "policyRoutingRulesForNetwork",
    "portForwardingRule",
    "portForwardingRulesForNetwork",
    "providerConnectionTypeTerm",
    "providerConnectionTypeTerms",
    "publicAPIKeyRateLimitDefaults",
    "publicNOSVersionsForNetwork",
    "quote",
    "quoteRecommendations",
    "quoteRequest",
    "quoteRequests",
    "quotesForQuoteRequest",
    "rackElevation",
    "rackElevations",
    "radioProfilesForNetwork",
    "radiusPollerMonitoringForNetwork",
    "rateLimitRule",
    "rateLimitRulesForNetwork",
    "recentEventLogEvents",
    "recentEventLogEventsPage",
    "rogueAccessPointsObservedOnNetwork",
    "rolePermittedEmailDomains",
    "roles",
    "salesforceJobQueueStates",
    "scanDataForNetwork",
    "scheduledNetworkNOSUpgradesForNetwork",
    "serviceRequestDefinitions",
    "siemIntegrationsForCompany",
    "spareHardwareDevicesForNetwork",
    "speedtestByUUID",
    "speedtestRulesByCompany",
    "speedtestServersForNetwork",
    "ssid",
    "ssidsForNetwork",
    "ssoOptions",
    "staticRoute",
    "staticRoutesForNetwork",
    "statsForVirtualDevice",
    "statsForVirtualDevices",
    "statsPageForVirtualDevices",
    "suggestedNOSUpgradeGroupForDevice",
    "supportCase",
    "supportCaseAttachments",
    "supportCaseFilters",
    "supportCaseSortOrderDefinitions",
    "supportCases",
    "supportProviders",
    "supportUsers",
    "switchAutoConfigMACAddressVLANBindingsForNetwork",
    "switchMACTable",
    "switchMACTableFilters",
    "switchMACTablePage",
    "switchMACTableSortOrderDefinitions",
    "switchPortMetricsRate",
    "switchPortStats",
    "systemInfoStatForVirtualDevice",
    "systemMetricsForVirtualDevices",
    "temporaryAccessCompanies",
    "temporaryAccessCompanyBySlug",
    "temporaryAccessGrant",
    "temporaryAccessGrants",
    "ticketInboxMessage",
    "topologyDesignVersion",
    "topologyDesignVersions",
    "unassignedHardwareDevicesForNetwork",
    "underlayPoolsForNetwork",
    "uplinkPhyInterfacesForNetwork",
    "userNetworkAccessExpiry",
    "validateNACIdPConfig",
    "vendorForOUI",
    "virtualDevice",
    "virtualDeviceTagsByNetwork",
    "virtualDevicesByTag",
    "virtualDevicesForNetwork",
    "visibleMarketingChangelogEntries",
    "vlan",
    "vlanMetrics",
    "vlans",
    "wanSpeedtestJob",
    "wanSpeedtestJobsForNetwork",
    "wifiIPSKs",
    "wirelessCalibrationJob",
    "wirelessCalibrationJobsForNetwork",
    "wirelessClientConnectionEvent",
    "wirelessClientConnectionEventsAggregates",
    "wirelessClientConnectionEventsByAP",
    "wirelessClientConnectionEventsByClient",
    "wirelessClientConnectionEventsEnhanced",
    "wirelessClientMetrics",
    "wirelessClientMetricsByAP",
    "wirelessClientMetricsByClient",
    "wirelessClientMetricsByNetwork"
  ],
  "Mutation": [
    "actionCaptivePortalEntry",
    "activateCompanyUser",
    "activateDeviceSIM",
    "addHubToAutoVPNGroup",
    "addMonitorGroupMember",
    "addNetworkToAutoVPNGroup",
    "addNetworksToAutoVPNGroup",
    "addSupportProvider",
    "applyQuoteRecommendations",
    "applySwitchAutoConfigurationDryRun",
    "applyTemplateToNetwork",
    "approvePublicAPIKeyGrantRequest",
    "approveTemporaryAccessGrant",
    "assignHardwareDeviceToNetwork",
    "assignHardwareDeviceToNetworkAsSpare",
    "assignHardwareDeviceToVirtualDevice",
    "assignHardwareDevicesToVirtualDevices",
    "assignOperatorRole",
    "assignSuperOperatorRole",
    "assignSwitchProfleToVirtualDevice",
    "attachDeviceToRackElevation",
    "attachDevicesToRackElevations",
    "attachVirtualDeviceToRadioProfile",
    "bindFirewallRuleToPhyInterface",
    "bindFirewallRuleToVLAN",
    "bindFirewallRulesToPhyInterface",
    "bindFirewallRulesToVLAN",
    "bindPhyInterfaceToFirewallRules",
    "bindPolicyRoutingRule",
    "bindPolicyRoutingRules",
    "bindRateLimitRuleToPhyInterface",
    "bindRateLimitRuleToSSID",
    "bindRateLimitRuleToVLAN",
    "bindTagToVirtualDevices",
    "bindVLANToFirewallRules",
    "bindVLANtoPhyInterface",
    "blockClientsInNetwork",
    "blockClientsInSSID",
    "cancelAutoChannelSelectionJob",
    "cancelAutoSwitchConfigurationJob",
    "cancelPublicAPIKeyGrantRequest",
    "cancelScheduledNetworkNOSUpgrade",
    "cancelWirelessCalibrationJob",
    "claimHardwareDevice",
    "configureSSO",
    "copyTopologyDesignVersionToNetworks",
    "copyVirtualDeviceToNewModel",
    "copyVirtualDevicesToNewModels",
    "createAccessPointPortProfile",
    "createAlertCompanySubscription",
    "createAlertFleetwideSubscription",
    "createAlertReceiverWithTargets",
    "createAlertSupportProviderSubscription",
    "createAlertTargetSalesforce",
    "createAlertTargetSlack",
    "createAlertTargetWebhook",
    "createApplicationDNSFirewallRule",
    "createApplicationDNSFirewallRules",
    "createAutoVPNGroup",
    "createAutoVPNRoute",
    "createBGPNeighbor",
    "createBGPRouter",
    "createBearerSession",
    "createBulkNOSUpgrade",
    "createCaptivePortal",
    "createCaptivePortals",
    "createCellularHardwareDevices",
    "createClientVPNClient",
    "createClientVPNClients",
    "createClientVPNServer",
    "createCompany",
    "createCompanyOnboarding",
    "createCompanySIEMIntegration",
    "createCompanyUser",
    "createComplianceFramework",
    "createComplianceReport",
    "createConnectStaticRate",
    "createCustomRole",
    "createDDNSRecord",
    "createDHCPOption",
    "createDHCPProxy",
    "createDHCPReservedRange",
    "createDHCPRule",
    "createDHCPRuleFilter",
    "createDHCPStaticMapping",
    "createDHCPStaticMappings",
    "createDNSHostMapping",
    "createDNSHostMappings",
    "createDeploymentJob",
    "createDeploymentTaskBlockers",
    "createDeploymentTaskException",
    "createDeploymentTaskExceptionMessage",
    "createDeploymentTimeWindow",
    "createDevHardwareDevice",
    "createDeviceBatch",
    "createDeviceMACAllocation",
    "createDeviceNotificationSnoozes",
    "createDocumentUploads",
    "createDynamicFloorPlanOpenIntentUpload",
    "createEncryption8021X",
    "createEncryption8021Xes",
    "createFirewallRule",
    "createFirewallRules",
    "createFleetwideNotificationSnooze",
    "createFloorPlan",
    "createGlobalNotificationSnooze",
    "createHardwareDevicePair",
    "createHardwareDevicePairs",
    "createHardwareNosVersionRange",
    "createHighAvailabilityControllersConfiguration",
    "createHostMonitoringTarget",
    "createIDSIPSConfig",
    "createIDSIPSCustomRule",
    "createIPForwardingRule",
    "createIPSecTunnel",
    "createInternalNote",
    "createInternetServicePlan",
    "createInternetServicePlanDocument",
    "createInternetServicePlanFulfillmentJob",
    "createInternetServicePlanFulfillmentTask",
    "createInternetServicePlanPaymentResource",
    "createInternetServicePlanProvider",
    "createInternetServicePlanProviderStaticRate",
    "createKnockToken",
    "createLabReservation",
    "createLabReservationsByKind",
    "createLabResource",
    "createMarketingChangelogEntry",
    "createMonitorGroup",
    "createMonitorProbe",
    "createMonitorProbeBinding",
    "createNACCredential",
    "createNACCredentials",
    "createNACGroup",
    "createNACIdPConfig",
    "createNACIdPGroupMapping",
    "createNACPolicy",
    "createNACPolicyEntry",
    "createNOSUpgradeGroup",
    "createNetwork",
    "createNetworkClientCPEBindings",
    "createNetworkOnboarding",
    "createNetworkReservation",
    "createNetworkThreatAllowlistEntry",
    "createNosFeature",
    "createNosVersion",
    "createObserverTest",
    "createOneToOneNATRule",
    "createPermittedEmailDomain",
    "createPhyInterfaceDHCPRule",
    "createPolicyEnginePath",
    "createPolicyEnginePolicy",
    "createPolicyEngineTrafficMatcher",
    "createPolicyRoutingRule",
    "createPortForwardingRule",
    "createPreSignedUploadUrl",
    "createProactivePcapNetworkConfig",
    "createProactivePcapSSIDConfig",
    "createProviderConnectionTypeTerm",
    "createPublicAPIKey",
    "createQuote",
    "createQuoteRequest",
    "createRackElevation",
    "createRadioProfile",
    "createRadioProfiles",
    "createRateLimitRule",
    "createRoleMapping",
    "createSPANMirrorSession",
    "createSSID",
    "createSSIDs",
    "createSSOAdminPortalLink",
    "createSSOVerify",
    "createSecurityApplianceDevicePair",
    "createSecurityApplianceDevicePairs",
    "createServiceRequest",
    "createSessionToken",
    "createSlackAccessToken",
    "createSpeedtestRule",
    "createSsoOAuthURI",
    "createStaticRoute",
    "createSupportCase",
    "createSupportCaseAttachments",
    "createSupportCaseComment",
    "createSupportProvider",
    "createSupportProviderAlertReceiverWithTargets",
    "createSupportUser",
    "createSwitchAutoConfigMACAddressVLANBindings",
    "createSwitchProfile",
    "createSyntheticHardwareDevice",
    "createTemplateFromNetwork",
    "createTemplateNetwork",
    "createTopologyDesignLink",
    "createTopologyDesignNode",
    "createTopologyDesignVersion",
    "createTopologyDesignVirtualDevices",
    "createUserFeedback",
    "createUserNetworkAccess",
    "createVLAN",
    "createVLANs",
    "createVirtualDevice",
    "createVirtualDeviceTag",
    "createVirtualDevices",
    "createVirtualDevicesIndependently",
    "createWifiIPSK",
    "createWifiIPSKs",
    "cutoverMutableEntitiesToNewVirtualDevice",
    "cycleAccessPointChannels",
    "deactivateDeviceSIM",
    "deleteAccessPointPortProfile",
    "deleteAlertCompanySubscriptions",
    "deleteAlertDeprioritizationWindowsForNetworks",
    "deleteAlertFleetwideSubscriptions",
    "deleteAlertReceiverWithTargets",
    "deleteAlertSupportProviderSubscriptions",
    "deleteAlertTargetSalesforce",
    "deleteAlertTargetSlack",
    "deleteAlertTargetWebhook",
    "deleteAllWifiIPSKsForSSID",
    "deleteApplicationDNSFirewallRule",
    "deleteApplicationDNSFirewallRules",
    "deleteAutoVPNGroup",
    "deleteAutoVPNMember",
    "deleteAutoVPNMembers",
    "deleteAutoVPNRoute",
    "deleteBGPNeighbor",
    "deleteBGPRouter",
    "deleteBulkNOSUpgrade",
    "deleteCaptivePortal",
    "deleteClientVPNClient",
    "deleteClientVPNServer",
    "deleteCompanyOnboardingDocument",
    "deleteCompanyOnboardingFieldDelegation",
    "deleteCompanySIEMIntegration",
    "deleteCompanyUser",
    "deleteConnectStaticRate",
    "deleteCustomRole",
    "deleteDDNSRecord",
    "deleteDHCPOption",
    "deleteDHCPProxy",
    "deleteDHCPReservedRange",
    "deleteDHCPRule",
    "deleteDHCPRuleFilter",
    "deleteDHCPStaticMapping",
    "deleteDHCPStaticMappings",
    "deleteDNSHostMapping",
    "deleteDeploymentJob",
    "deleteDeploymentTask",
    "deleteDeploymentTaskBlocker",
    "deleteDeploymentTimeWindow",
    "deleteDeviceMACAllocation",
    "deleteDeviceNotificationSnooze",
    "deleteDocumentUploads",
    "deleteEncryption8021X",
    "deleteFirewallRule",
    "deleteFirewallRules",
    "deleteFleetwideNotificationSnooze",
    "deleteFloorPlan",
    "deleteGlobalNotificationSnooze",
    "deleteHardwareDevicePair",
    "deleteHighAvailabilityControllersConfiguration",
    "deleteHostMonitoringTarget",
    "deleteIDSIPSConfig",
    "deleteIDSIPSConfigCategoryBinding",
    "deleteIDSIPSConfigRuleBinding",
    "deleteIDSIPSCustomRule",
    "deleteIPForwardingRule",
    "deleteIPSecTunnel",
    "deleteInternalNote",
    "deleteInternetServicePlan",
    "deleteInternetServicePlanDocument",
    "deleteInternetServicePlanFulfillmentJob",
    "deleteInternetServicePlanFulfillmentTask",
    "deleteInternetServicePlanProviderStaticRate",
    "deleteLabReservation",
    "deleteLabResource",
    "deleteLocationProviderAvailability",
    "deleteMarketingChangelogEntry",
    "deleteMonitorGroup",
    "deleteMonitorProbe",
    "deleteMonitorProbeBinding",
    "deleteNACConfig",
    "deleteNACCredential",
    "deleteNACGroup",
    "deleteNACIdPConfig",
    "deleteNACIdPGroupMapping",
    "deleteNACPolicy",
    "deleteNACPolicyEntry",
    "deleteNOSUpgradeGroup",
    "deleteNetwork",
    "deleteNetworkClientCPEBindings",
    "deleteNetworkOnboardingDocument",
    "deleteNetworkOnboardingFieldDelegation",
    "deleteNetworkReservation",
    "deleteNetworkThreatAllowlistEntry",
    "deleteNetworkUnderlayPool",
    "deleteNosVersion",
    "deleteObserverTestBindings",
    "deleteObserverTests",
    "deleteOneToOneNATRule",
    "deleteOneToOneNATRules",
    "deletePermittedEmailDomain",
    "deletePhyInterfaceDHCPRule",
    "deletePolicyEnginePath",
    "deletePolicyEnginePolicy",
    "deletePolicyEngineTrafficMatcher",
    "deletePolicyRoutingRule",
    "deletePortForwardingRule",
    "deletePortForwardingRules",
    "deleteProactivePcapSSIDConfig",
    "deleteProviderConnectionTypeTerm",
    "deleteQuote",
    "deleteQuoteRequest",
    "deleteRackElevation",
    "deleteRadioProfile",
    "deleteRateLimitRule",
    "deleteRecurringAutoChannelSelectionJobs",
    "deleteRoleMapping",
    "deleteSPANMirrorSession",
    "deleteSSID",
    "deleteSSIDs",
    "deleteSlackAccessToken",
    "deleteSlackAccessTokensForCompany",
    "deleteSpeedtestRules",
    "deleteStaticRoute",
    "deleteSupportCases",
    "deleteSupportProvider",
    "deleteSupportProviderAlertReceiverWithTargets",
    "deleteSupportUser",
    "deleteSwitchAutoConfigMACAddressVLANBinding",
    "deleteTopologyDesignLink",
    "deleteTopologyDesignNode",
    "deleteTopologyDesignVersion",
    "deleteVLAN",
    "deleteVLANs",
    "deleteVirtualDevice",
    "deleteVirtualDeviceTag",
    "deleteVirtualDevices",
    "deleteWifiIPSK",
    "denyTemporaryAccessGrant",
    "detachDeviceFromRackElevation",
    "detachDevicesFromRackElevation",
    "detachVirtualDeviceFromRadioProfile",
    "editMutationAuditLogEntryReason",
    "editMutationDiffAuditLogEntryReason",
    "enableSSOForCompany",
    "endGlobalNotificationSnooze",
    "forceSalesforceSyncCompanies",
    "forceSalesforceSyncNetworks",
    "forgetNACClientDevice",
    "generatePowerPlanForNetwork",
    "generateTopologyDesign",
    "initializeAutoChannelSelectionDryRunForNetworks",
    "initializeAutoChannelSelectionForAccessPoints",
    "initializeAutoChannelSelectionForNetwork",
    "initializeAutoSwitchConfigurationForNetwork",
    "insertStatsForDemo",
    "invalidatePhyInterfaceConnectedDevices",
    "inviteClientVPNClient",
    "inviteClientVPNClients",
    "mintAuthenticationToken",
    "moveInternetServicePlanToNetwork",
    "moveRackElevationDeviceToRack",
    "moveRackElevationDevicesToRack",
    "noop",
    "pauseSalesforceJobQueues",
    "pinDeviceConfigsForNetwork",
    "pinDeviceConfigsForNetworks",
    "priceQuote",
    "reactivateDeviceSIM",
    "reassignHardwareToOtherNetwork",
    "reassignNetwork",
    "refreshObserverTestBindings",
    "rejectPublicAPIKeyGrantRequest",
    "removeHubFromAutoVPNGroup",
    "removeMonitorGroupMember",
    "removeNetworksFromAutoVPNGroup",
    "removeNetworksFromBulkNOSUpgrade",
    "removeOperatorRole",
    "removeSuperOperatorRole",
    "removeSupportProvider",
    "renderDeviceConfig",
    "renderDeviceConfigWithoutOverrides",
    "reorderNACPolicies",
    "requestCompanyAccessForPublicAPIKey",
    "requestTemporaryAccess",
    "rerunQuoteRequest",
    "resumeSalesforceJobQueues",
    "returnHardwareDevice",
    "revokeAuthenticationToken",
    "revokeCompanyAccessFromPublicAPIKey",
    "revokeOwnAPIKey",
    "revokePublicAPIKey",
    "revokeTemporaryAccessGrant",
    "rotateCaptivePortalSecret",
    "rpcBlinkLEDs",
    "rpcClearBlockedConfigs",
    "rpcDNS",
    "rpcEapolTestForSerial",
    "rpcEapolTestForSerials",
    "rpcPDUOutletCycle",
    "rpcPacketCapturesStart",
    "rpcPacketCapturesStop",
    "rpcPing",
    "rpcPortCableTest",
    "rpcPortCycle",
    "rpcPortCycleDevices",
    "rpcPortEyeTest",
    "rpcPortSpotlight",
    "rpcPortSpotlightCancel",
    "rpcRebootDevice",
    "rpcRebootDevices",
    "rpcRefreshConfig",
    "rpcRestartIPSecTunnel",
    "rpcRotatingPacketCapture",
    "rpcSwitchPortCycle",
    "rpcSwitchPortSecurityClear",
    "rpcWirelessCalibrationStart",
    "rpcWosDisconnectClient",
    "rpcWosPing",
    "rpcWosRadioReset",
    "rpcWosResetDfs",
    "runRiverJob",
    "sendCompanySIEMIntegrationTestEvent",
    "setHardwareDeviceIsDev",
    "setInternetServicePlanPaymentResourceTemporaryLimit",
    "setIspVLANs",
    "setKeyValue",
    "setNACCredentialPassword",
    "setNetworkNosVersion",
    "setPolicyRoutingRuleBindings",
    "setRoleAssignmentActive",
    "setSupportUserRoles",
    "shuffleHardwareDeviceAssignments",
    "signConsoleLoginChallenge",
    "signLocalConfigAccessChallenge",
    "startClientPingSweepJob",
    "startWANSpeedtestJob",
    "startWirelessCalibrationJob",
    "suppressIPSRules",
    "testFireAlert",
    "unassignHardwareDeviceFromVirtualDevice",
    "unassignHardwareFromVirtualDevices",
    "unassignInternetServicePlanFromNetwork",
    "unassignSpareHardwareDeviceFromNetwork",
    "unbindFirewallRuleFromPhyInterface",
    "unbindFirewallRuleFromVLAN",
    "unbindPolicyRoutingRule",
    "unbindRateLimitRuleFromPhyInterface",
    "unbindRateLimitRuleFromSSID",
    "unbindRateLimitRuleFromVLAN",
    "unbindTagFromVirtualDevices",
    "unblockClientsInNetwork",
    "unblockClientsInSSID",
    "undeleteNetwork",
    "undoSwitchAutoConfigurationRun",
    "unexpireTrialNetwork",
    "unpinDeviceConfigsForNetwork",
    "unpinDeviceConfigsForNetworks",
    "unsetHardwareDeviceIsDev",
    "unverifyTopologyDesignVersion",
    "updateAccessPointPortProfile",
    "updateAlertCompanySubscription",
    "updateAlertFleetwideSubscription",
    "updateAlertReceiverWithTargets",
    "updateAlertSupportProviderSubscription",
    "updateAlertTargetSalesforce",
    "updateAlertTargetSlack",
    "updateAlertTargetWebhook",
    "updateApplicationDNSFirewallRule",
    "updateApplicationDNSFirewallRuleApplicationVisibilities",
    "updateApplicationDNSFirewallRules",
    "updateAutoVPNGroup",
    "updateAutoVPNHub",
    "updateAutoVPNHubs",
    "updateAutoVPNMember",
    "updateAutoVPNMemberHub",
    "updateAutoVPNRoute",
    "updateBGPNeighbor",
    "updateBGPRouter",
    "updateBGPRouterForEvent",
    "updateCaptivePortal",
    "updateClientVPNClient",
    "updateClientVPNServer",
    "updateCompany",
    "updateCompanyLocation",
    "updateCompanySIEMIntegration",
    "updateCompanyUser",
    "updateConnectStaticRate",
    "updateCountryDeviceCertifications",
    "updateCustomRole",
    "updateDDNSRecord",
    "updateDHCPOption",
    "updateDHCPProxy",
    "updateDHCPReservedRange",
    "updateDHCPRule",
    "updateDHCPStaticMapping",
    "updateDNSHostMapping",
    "updateDefaultRoleForUsers",
    "updateDeliverable",
    "updateDeploymentJob",
    "updateDeploymentTask",
    "updateDeploymentTaskException",
    "updateDeploymentTaskExceptionMessage",
    "updateDeploymentTaskNotification",
    "updateDeploymentTimeWindow",
    "updateDevHardwareDevice",
    "updateDeviceMACAllocation",
    "updateDeviceNotificationSnooze",
    "updateDocumentUpload",
    "updateEncryption8021X",
    "updateFirewallRule",
    "updateFirewallRules",
    "updateFleetwideNotificationSnooze",
    "updateFloorPlan",
    "updateForHighAvailabilityEvent",
    "updateGatewayProfile",
    "updateGatewayUplinkSettings",
    "updateHardwareDevice",
    "updateHardwareNosVersionRange",
    "updateHiddenCompanyOnboardingDocumentFields",
    "updateHiddenNetworkOnboardingDocumentFields",
    "updateHighAvailabilityControllersConfiguration",
    "updateHostMonitoringTarget",
    "updateIDSIPSConfig",
    "updateIDSIPSCustomRule",
    "updateIPForwardingRule",
    "updateIPSecTunnel",
    "updateInterVLANCommunicationPermittedPairs",
    "updateInternalNote",
    "updateInternetServicePlan",
    "updateInternetServicePlanDocument",
    "updateInternetServicePlanFulfillmentJob",
    "updateInternetServicePlanFulfillmentTask",
    "updateInternetServicePlanProvider",
    "updateInternetServicePlanProviderStaticRate",
    "updateInternetServicePlanProviderStaticRates",
    "updateLabReservation",
    "updateLabResource",
    "updateLocationProviderAvailability",
    "updateMaintenanceWindowForNetwork",
    "updateMarketingChangelogEntry",
    "updateMonitorGroup",
    "updateMonitorGroupMember",
    "updateMonitorProbe",
    "updateNACConfig",
    "updateNACCredential",
    "updateNACGroup",
    "updateNACIdPConfig",
    "updateNACIdPGroupMapping",
    "updateNACPolicy",
    "updateNOSUpgradeGroup",
    "updateNOSUpgradeGroups",
    "updateNetwork",
    "updateNetworkMetadata",
    "updateNetworkReservation",
    "updateNetworkThreatAllowlistEntry",
    "updateNetworkUnderlayPool",
    "updateNosFeature",
    "updateNosVersion",
    "updateOOBPhyInterface",
    "updateObserverTest",
    "updateOneToOneNATRule",
    "updateOpportunity",
    "updateOutletInterface",
    "updateOutletInterfaces",
    "updateOutletInterfacesIndependently",
    "updatePacketCaptureGroups",
    "updatePhyInterface",
    "updatePhyInterfaceDHCPRule",
    "updatePhyInterfaceForMultiWANEvent",
    "updatePhyInterfaces",
    "updatePhyInterfacesIndependently",
    "updatePolicyEnginePath",
    "updatePolicyEnginePolicies",
    "updatePolicyEnginePolicy",
    "updatePolicyEngineTrafficMatcher",
    "updatePolicyRoutingRule",
    "updatePortForwardingRule",
    "updateProactivePcapNetworkConfig",
    "updateProactivePcapSSIDConfig",
    "updateProviderConnectionTypeTerm",
    "updatePublicAPIKeyRateLimits",
    "updateQuote",
    "updateQuoteRequest",
    "updateRackElevation",
    "updateRackElevationDevice",
    "updateRadioProfile",
    "updateRateLimitRule",
    "updateRateLimitRulesIndependently",
    "updateRoleMapping",
    "updateSPANMirrorSession",
    "updateSSID",
    "updateSSIDs",
    "updateSSIDsIndependently",
    "updateSecurityApplianceProfile",
    "updateSecurityApplianceProfilesForNetwork",
    "updateSlackAccessToken",
    "updateSpeedtestRules",
    "updateStaticRoute",
    "updateSupportCases",
    "updateSupportProvider",
    "updateSupportProviderAlertReceiverWithTargets",
    "updateSwitchProfile",
    "updateSwitchProfiles",
    "updateTopologyDesignLink",
    "updateTopologyDesignNode",
    "updateTopologyDesignVersion",
    "updateUplinkPhyInterfaceExternalAddresses",
    "updateUserRoles",
    "updateVLAN",
    "updateVLANInterVLANCommunicationPermittedVLANs",
    "updateVLANs",
    "updateVLANsIndependently",
    "updateVirtualDevice",
    "updateVirtualDeviceTag",
    "updateVirtualDevices",
    "updateVirtualDevicesIndependently",
    "updateWifiIPSK",
    "uploadClientObserverTest",
    "upsertAlertDeprioritizationWindowsForNetworks",
    "upsertAllInboxMessageStates",
    "upsertCompanyOnboardingDocument",
    "upsertCompanyOnboardingDocumentMetadata",
    "upsertCompanyOnboardingFieldDelegation",
    "upsertDeviceConfigOverride",
    "upsertIDSIPSConfigCategoryBinding",
    "upsertIDSIPSConfigRuleBinding",
    "upsertInboxMessageState",
    "upsertInboxMessageStates",
    "upsertLocationProviderAvailability",
    "upsertMACAddressAlias",
    "upsertMACAddressAliases",
    "upsertNetworkCachedNOSVersions",
    "upsertNetworkOnboardingDocument",
    "upsertNetworkOnboardingDocumentMetadata",
    "upsertNetworkOnboardingFieldDelegation",
    "upsertRecurringAutoChannelSelectionJobs",
    "upsertSwitchAutoConfigMACAddressVLANBindingsForNetwork",
    "upsertTopologyDesign",
    "validateBearerSession",
    "verifyTopologyDesignVersion"
  ]
} as const;